export default function (editor: any, opt: any = {}) {
    const blockManager = editor.BlockManager;
    const category = opt.category;

    blockManager.add('careerum-club5-header', {
        label: 'Header 5',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club5-header main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="header-wrapper careerum-flex-sbc">
                        <div class="header-logo">
                            <a href="#">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1756457798717-IIDKV-logo.svg"
                                    class="hidden-tablet-mobile" alt="logo">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1756457805416-L3m4M-logo.svg"
                                    class="hidden-desc" alt="logo">
                            </a>
                        </div>
                        <nav class="careerum-flex-cc">
                            <a href="/ru-ru/promo/validator" target="_blank">Резюме-сканер</a>
                            <a href="/ru-ru/expert-consultations" target="_blank">Консультации</a>
                            <a href="/ru-ru/success-stories" target="_blank">Результаты клиентов</a>
                            <a href="/ru-ru/team" target="_blank">О нас</a>
                            <a href="https://learn.careerum.com" target="_blank" class="login-button">Войти</a>
                        </nav>
                        <div class="header-buttons">
                            <div class="login-button-wrapper hidden-mobile">
                                <a href="https://learn.careerum.com" target="_blank" class="login-button">Войти</a>
                            </div>
                            <div class="header-burger hidden-desc-tablet">
                                <span class="line line1"></span>
                                <span class="line line2"></span>
                                <span class="line line3"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-header-placeholder', {
        label: 'Header placeholder',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-header-placeholder"></div>
            `
    });

    blockManager.add('careerum-en-header', {
        label: 'Header',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `<div class="careerum-en-header veb30-header login-button">
        <div>
            <div class="header-en-top">
                <div class="header-en-logo">
                    <a onclick="" href="/ru-ru/club">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744110689090-f6HxF-logo.svg" alt="">
                    </a>
                </div>
                <div>
                    <nav>
                        <a onclick="" href="/ru-ru/club/gift-certificate" target="_blank">Сертификаты</a>
                        <a onclick="" href="/ru-ru/expert-consultations" target="_blank">Консультации</a>
                        <a onclick="" href="/ru-ru/success-stories" target="_blank">Результаты клиентов</a>
                        <a onclick="" href="/ru-ru/team" target="_blank">О нас</a>
                        <a onclick="" href="#login" class="login-button">Войти</a>
                    </nav>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-en-header-tablet', {
        label: 'Header (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `<div class="careerum-en-header-tablet veb30-header login-button">
        <div>
            <div class="header-en-top">
                <div class="header-en-logo">
                    <a onclick="" href="/ru-ru/club">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744110701230-gTgVM-logo.svg" alt="">
                    </a>
                </div>
                <div>
                    <nav>
                        <a onclick="" href="/ru-ru/club/gift-certificate" target="_blank">Сертификаты</a>
                        <a onclick="" href="/ru-ru/expert-consultations" target="_blank">Консультации</a>
                        <a onclick="" href="/ru-ru/success-stories" target="_blank">Результаты клиентов</a>
                        <a onclick="" href="/ru-ru/team" target="_blank">О нас</a>
                        <a onclick="" href="#login" class="login-button">Войти</a>
                    </nav>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-en-header-mobile', {
        label: 'Header (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `<div class="careerum-en-header-mobile veb30-header">
        <div>
            <div class="header-en-top">
                <div class="header-en-main">
                    <div class="header-en-logo">
                        <a onclick="" href="/ru-ru/club">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744110709561-T60ls-logo.svg" alt="">
                        </a>
                        </div>
                    <div class="header-en-burger"><span class="line line1"></span><span class="line line2"></span><span
                            class="line line3"></span></div>
                </div>
                <div class="header-en-menu">
                    <nav>
                    <a onclick="" href="/ru-ru/club/gift-certificate" target="_blank">Сертификаты</a>
                    <a onclick="" href="/ru-ru/expert-consultations" target="_blank">Консультации</a>
                    <a onclick="" href="/ru-ru/success-stories" target="_blank">Результаты клиентов</a>
                    <a onclick="" href="/ru-ru/team" target="_blank">О нас</a>
                    <a onclick="" href="#login" class="login-button">Войти</a>
                    </nav>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-club40-main', {
        label: 'Club 4 main',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-main">
            <div class="careerum-container-desc">
                <div class="club40-main-header">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723105236868-Y2Lsy-Vect.svg"
                        alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723105245948-FJlOP-Vect.svg"
                        alt="img">
                    <h1>Поможем построить карьеру<br> по любви в любой точке мира</h1>
                    <p>Careerum — платформа карьерного развития, с помощью которой тысячи<br> профессионалов из 30+ стран
                        уже построили карьеру мечты</p>
                </div>
                <div class="club40-main-tales">
                    <div class="club40-main-tales-wrapper careerum-flex-fsfs">
                        <div class="club40-main-tales-item-light">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723105590285-zZI0k-Unio.svg"
                                alt="" class="club40-main-tales-item-img-cross">
                            <p>Не получаю офферов</p>
                        </div>
                        <div class="club40-main-tales-item-blue">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723105590285-zZI0k-Unio.svg"
                                alt="" class="club40-main-tales-item-img-cross">
                            <p>Застрял на одной должности</p>
                        </div>
                        <div class="club40-main-tales-item-light">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723105590285-zZI0k-Unio.svg"
                                alt="" class="club40-main-tales-item-img-cross">
                            <p>Был большой перерыв в работе</p>
                        </div>
                    </div>
                    <div class="club40-main-tales-wrapper careerum-flex-fsfs">
                        <div class="club40-main-tales-item-dark">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723105635645-LsSKT-Fram.svg"
                                alt="" class="club40-main-tales-item-img-smile">
                            <p>Думаю о смене профессии</p>
                        </div>
                        <div class="club40-main-tales-item-dark">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723105635645-LsSKT-Fram.svg"
                                alt="" class="club40-main-tales-item-img-smile">
                            <p>Регулярно выгораю</p>
                        </div>
                        <div class="club40-main-tales-item-light">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723105590285-zZI0k-Unio.svg"
                                alt="" class="club40-main-tales-item-img-cross">
                            <p>Не могу найти работу за границей</p>
                        </div>
                    </div>
                    <div class="club40-main-tales-wrapper careerum-flex-fsfs">
                        <div class="club40-main-tales-item-blue">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723105635645-LsSKT-Fram.svg"
                                alt="" class="club40-main-tales-item-img-smile">
                            <p>Работаю без мотивации</p>
                        </div>
                        <div class="club40-main-tales-item-blue">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723105590285-zZI0k-Unio.svg"
                                alt="" class="club40-main-tales-item-img-cross">
                            <p>Не растет зарплата</p>
                        </div>
                    </div>
                    <div class="club40-main-tales-wrapper careerum-flex-fsfs">
                        <div class="club40-main-tales-item-dark">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723105635645-LsSKT-Fram.svg"
                                alt="" class="club40-main-tales-item-img-smile">
                            <p>Кажется, что я не на своем месте</p>
                        </div>
                        <div class="club40-main-tales-item-blue">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723105590285-zZI0k-Unio.svg"
                                alt="" class="club40-main-tales-item-img-cross">
                            <p>Не понимаю, туда ли движется моя карьера</p>
                        </div>
                    </div>
                </div>
                <div class="club40-main-link careerum-flex-cc">
                    <a href="#buy" class="btn-color-main-dark-orange">Изменить карьеру с Careerum</a>
                </div>
                <div class="club40-main-bottom">
                    <div class="careerum-flex-fsfs">
                        <div>
                            <p class="club40-main-bottom-header">12 000+</p>
                            <p class="club40-main-bottom-text">профессионалов построили карьеру мечты с нами</p>
                        </div>
                        <div>
                            <p class="club40-main-bottom-header">4 000+</p>
                            <p class="club40-main-bottom-text">офферов получили специалисты по всему миру с нашей помощью
                            </p>
                        </div>
                        <div>
                            <p class="club40-main-bottom-header">в 1,5 раза</p>
                            <p class="club40-main-bottom-text">средний рост<br> зарплаты клиентов<br> Careerum</p>
                        </div>
                        <div>
                            <p class="club40-main-bottom-header">6 лет</p>
                            <p class="club40-main-bottom-text">помогаем<br> превратить работу<br> в удовольствие</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-main-tablet', {
        label: 'Club 4 main (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-main-tablet">
            <div class="careerum-container-tablet">
                <div class="club40-main-header">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466319646-RNR9A-Vect.svg"
                        alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466319220-qzqJU-Vect.svg"
                        alt="img">
                    <h2>Поможем построить<br> карьеру по любви в любой<br> точке мира</h2>
                    <p>Careerum — платформа карьерного развития, с помощью которой<br> тысячи профессионалов из 30+ стран
                        уже построили карьеру мечты</p>
                </div>
                <div class="club40-main-tales">
                    <div class="club40-main-tales-wrapper careerum-flex-fsfs">
                        <div class="club40-main-tales-item-dark">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466510057-IeBl2-Unio.svg"
                                alt="" class="club40-main-tales-item-img-cross">
                            <p>Не могу найти работу</p>
                        </div>
                        <div class="club40-main-tales-item-blue">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466510057-IeBl2-Unio.svg"
                                alt="" class="club40-main-tales-item-img-cross">
                            <p>Застрял на одной должности</p>
                        </div>
                    </div>
                    <div class="club40-main-tales-wrapper careerum-flex-fsfs">
                        <div class="club40-main-tales-item-blue">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466509751-QKY45-Grou.svg"
                                alt="" class="club40-main-tales-item-img-smile">
                            <p>Кажется, что я не на своем месте</p>
                        </div>
                        <div class="club40-main-tales-item-light">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466510057-IeBl2-Unio.svg"
                                alt="" class="club40-main-tales-item-img-cross">
                            <p>Был большой перерыв в работе</p>
                        </div>
                    </div>
                    <div class="club40-main-tales-wrapper careerum-flex-fsfs">
                        <div class="club40-main-tales-item-blue">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466509751-QKY45-Grou.svg"
                                alt="" class="club40-main-tales-item-img-smile">
                            <p>Думаю о смене профессии</p>
                        </div>
                        <div class="club40-main-tales-item-dark">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466509751-QKY45-Grou.svg"
                                alt="" class="club40-main-tales-item-img-smile">
                            <p>Регулярно выгораю</p>
                        </div>
                        <div class="club40-main-tales-item-blue">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466509751-QKY45-Grou.svg"
                                alt="" class="club40-main-tales-item-img-smile">
                            <p>Работаю без мотивации</p>
                        </div>
                    </div>
                    <div class="club40-main-tales-wrapper careerum-flex-fsfs">
                        <div class="club40-main-tales-item-light">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466510057-IeBl2-Unio.svg"
                                alt="" class="club40-main-tales-item-img-cross">
                            <p>Не растет зарплата</p>
                        </div>
                        <div class="club40-main-tales-item-blue">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466510057-IeBl2-Unio.svg"
                                alt="" class="club40-main-tales-item-img-cross">
                            <p>Не понимаю, туда ли движется моя карьера</p>
                        </div>
                    </div>
                    <div class="club40-main-tales-wrapper careerum-flex-fsfs">
                        <div class="club40-main-tales-item-light">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466510057-IeBl2-Unio.svg"
                                alt="" class="club40-main-tales-item-img-cross">
                            <p>Не могу найти работу за границей</p>
                        </div>
                    </div>
                </div>
                <div class="club40-main-link careerum-flex-cc">
                    <a href="#buy" class="btn-color-main-dark-orange">Изменить карьеру с Careerum</a>
                </div>
                <div class="club40-main-bottom">
                    <div class="careerum-flex-fsfs">
                        <div>
                            <p class="club40-main-bottom-header">12 000+</p>
                            <p class="club40-main-bottom-text">профессионалов построили карьеру мечты с нами</p>
                        </div>
                        <div>
                            <p class="club40-main-bottom-header">4 000+</p>
                            <p class="club40-main-bottom-text">офферов получили специалисты по всему миру с нашей помощью
                            </p>
                        </div>
                        <div>
                            <p class="club40-main-bottom-header">в 1,5 раза</p>
                            <p class="club40-main-bottom-text">средний рост<br> зарплаты клиентов<br> Careerum</p>
                        </div>
                        <div>
                            <p class="club40-main-bottom-header">6 лет</p>
                            <p class="club40-main-bottom-text">помогаем<br> превратить работу<br> в удовольствие</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-main-mobile', {
        label: 'Club 4 main (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-main-mobile">
            <div class="careerum-container-mobile">
                <div class="club40-main-header">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723538992140-HqVEb-Vect.svg"
                        alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723538992001-jumGG-Vect.svg"
                        alt="img">
                    <h2>Поможем построить<br> карьеру по любви в любой точке мира</h2>
                    <p>Careerum — платформа карьерного развития, с помощью которой тысячи профессионалов из 30+ стран
                        уже<br> построили карьеру мечты</p>
                </div>
                <div class="club40-main-tales">
                    <div class="club40-main-tales-wrapper careerum-flex-fsfs">
                        <div class="club40-main-tales-item-dark">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466510057-IeBl2-Unio.svg"
                                alt="" class="club40-main-tales-item-img-cross">
                            <p>Не могу найти работу</p>
                        </div>
                        <div class="club40-main-tales-item-blue">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466510057-IeBl2-Unio.svg"
                                alt="" class="club40-main-tales-item-img-cross">
                            <p>Застрял на одной должности</p>
                        </div>
                    </div>
                    <div class="club40-main-tales-wrapper careerum-flex-fsfs">
                        <div class="club40-main-tales-item-light">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466510057-IeBl2-Unio.svg"
                                alt="" class="club40-main-tales-item-img-cross">
                            <p>Был большой перерыв в работе</p>
                        </div>
                        <div class="club40-main-tales-item-blue">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466509751-QKY45-Grou.svg"
                                alt="" class="club40-main-tales-item-img-smile">
                            <p>Кажется, что я не на своем месте</p>
                        </div>
                    </div>
                    <div class="club40-main-tales-wrapper careerum-flex-fsfs">
                        <div class="club40-main-tales-item-dark">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466509751-QKY45-Grou.svg"
                                alt="" class="club40-main-tales-item-img-smile">
                            <p>Регулярно выгораю</p>
                        </div>
                        <div class="club40-main-tales-item-blue">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466509751-QKY45-Grou.svg"
                                alt="" class="club40-main-tales-item-img-smile">
                            <p>Думаю о смене профессии</p>
                        </div>
                    </div>
                </div>
                <div class="club40-main-link careerum-flex-cc">
                    <a href="#buy" class="btn-color-main-dark-orange">Изменить карьеру с Careerum</a>
                </div>
                <div class="club40-main-bottom">
                    <div class="careerum-flex-fsfs">
                        <div>
                            <p class="club40-main-bottom-header">12 000+</p>
                            <p class="club40-main-bottom-text">профессионалов построили<br> карьеру мечты с нами</p>
                        </div>
                        <div>
                            <p class="club40-main-bottom-header">4 000+</p>
                            <p class="club40-main-bottom-text">офферов получили специалисты по всему миру с нашей помощью
                            </p>
                        </div>
                        <div>
                            <p class="club40-main-bottom-header">в 1,5 раза</p>
                            <p class="club40-main-bottom-text">средний рост зарплаты<br> клиентов Careerum</p>
                        </div>
                        <div>
                            <p class="club40-main-bottom-header">6 лет</p>
                            <p class="club40-main-bottom-text">помогаем превратить работу<br> в удовольствие</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-main2', {
        label: 'Club 4 main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-main2 main-wrapper" data-video-id="925287800">
            <div class="careerum-container-responsive careerum-flex-sbfs">
                <div class="club40-main2-left position-relative">
                    <h1>Платформа карьерного<br> развития Careerum</h1>
                    <p>Поможем построить карьеру по любви в любой точке мира: </p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733899360220-tPjRo-Grou.svg" alt=""
                        class="position-absolute hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733920456778-3k6OP-Grou.svg" alt=""
                        class="position-absolute hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733932964978-uPMKS-Grou.svg" alt=""
                        class="position-absolute hidden-desc-tablet">
                    <ul>
                        <li class="careerum-flex-fsfs">
                            <svg width="30" height="27" viewBox="0 0 30 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M2 12.2143C4.47211 14.3245 9.96632 19.2493 14.6035 24.0792C15.6451 25.1641 17.4711 24.8039 17.933 23.3726C20.5415 15.2898 22.532 6.00656 28 1.5"
                                    stroke="#0B70FE" stroke-width="3" stroke-linecap="round" />
                            </svg>
                            <p>Получить оффер мечты</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <svg width="30" height="27" viewBox="0 0 30 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M2 12.2143C4.47211 14.3245 9.96632 19.2493 14.6035 24.0792C15.6451 25.1641 17.4711 24.8039 17.933 23.3726C20.5415 15.2898 22.532 6.00656 28 1.5"
                                    stroke="#0B70FE" stroke-width="3" stroke-linecap="round" />
                            </svg>
                            <p>Найти работу за границей</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <svg width="30" height="27" viewBox="0 0 30 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M2 12.2143C4.47211 14.3245 9.96632 19.2493 14.6035 24.0792C15.6451 25.1641 17.4711 24.8039 17.933 23.3726C20.5415 15.2898 22.532 6.00656 28 1.5"
                                    stroke="#0B70FE" stroke-width="3" stroke-linecap="round" />
                            </svg>
                            <p>Вырасти в зарплате и должности</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <svg width="30" height="27" viewBox="0 0 30 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M2 12.2143C4.47211 14.3245 9.96632 19.2493 14.6035 24.0792C15.6451 25.1641 17.4711 24.8039 17.933 23.3726C20.5415 15.2898 22.532 6.00656 28 1.5"
                                    stroke="#0B70FE" stroke-width="3" stroke-linecap="round" />
                            </svg>
                            <p>Сменить сферу</p>
                        </li>
                    </ul>
                </div>
                <div class="club40-main2-right">
                    <div class="club40-main2-videowrapper position-relative">
                        <div class="club40-main2-videowrapper-frame position-absolute z-10"></div>
                        <svg width="70" height="63" viewBox="0 0 70 63" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="club40-main2-play position-absolute z-20">
                            <path
                                d="M68.2483 34.7204C67.2762 56.8698 46.1184 60.3881 35.4123 61.0219C29.7258 61.3586 5.18811 63.9441 2.13711 34.1026C-0.448426 8.81373 20.2043 4.35263 26.2295 2.98658C37.3753 0.459573 66.0873 0.626994 67.0274 28.5617"
                                stroke="white" stroke-width="2" stroke-linecap="round" />
                            <path
                                d="M27.4309 47.4754C27.8277 40.64 22.2067 26.9149 19.3467 20.9067C33.6166 22.2324 60.5889 25.4775 54.3183 27.8522C46.48 30.8206 26.935 56.0197 27.4309 47.4754Z"
                                stroke="white" stroke-width="2" />
                        </svg>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-achievements', {
        label: 'Club 4 achievements (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-achievements main-wrapper">
            <div class="careerum-container-responsive">
                <div class="club40-achievements-wrapper">
                    <div class="careerum-flex-sbfs">
                        <div>
                            <p class="club40-achievements-header">4 000+</p>
                            <p class="club40-achievements-text hidden-tablet-mobile"><span>офферов получили</span><br> наши
                                клиенты<br> по всему
                                миру </p>
                            <p class="club40-achievements-text hidden-desc">офферов получили наши
                                клиенты по всему
                                миру </p>
                        </div>
                        <div>
                            <p class="club40-achievements-header">на 50%</p>
                            <p class="club40-achievements-text hidden-tablet-mobile"><span>рост зарплаты</span><br> у наших
                                клиентов<br> в
                                среднем</p>
                            <p class="club40-achievements-text hidden-desc">рост зарплаты у наших
                                клиентов в
                                среднем</p>
                        </div>
                        <div>
                            <p class="club40-achievements-header">6 лет</p>
                            <p class="club40-achievements-text hidden-tablet-mobile"><span>выстраиваем</span><br> работающие
                                карьерные стратегии
                            </p>
                            <p class="club40-achievements-text hidden-desc">выстраиваем работающие
                                карьерные стратегии
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-about', {
        label: 'Club 4 about',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-about">
            <div class="careerum-container-desc">
                <h2 class="careerum-club40-header">Подписка Careerum — это</h2>
                <div class="club40-about-top careerum-flex-fsfs">
                    <div>
                        <div class="club40-about-label-blue">
                            <p>Careerum — это результаты</p>
                        </div>
                        <p class="club40-about-header-white">Команда сертифицированных карьерных коучей и экспертов</p>
                        <p class="club40-about-text-white">Проработайте свой кейс со специалистами <br>с международным
                            опытом
                            и достигните цели<br>в два раза быстрее</p>
                    </div>
                    <div>
                        <div class="careerum-flex-fsfs">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723109088799-unRFk-phot.png"
                                    alt="">
                            </div>
                            <div>
                                <p class="club40-about-coach-name">Софи Бессон</p>
                                <p class="club40-about-coach-position">Карьерный эксперт</p>
                                <p class="club40-about-coach-text">Добрый день! Оставила комментарии к резюме. Уже очень
                                    хорошо, но есть что исправить</p>
                            </div>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723109088402-yji01-phot.png"
                                    alt="">
                            </div>
                            <div>
                                <p class="club40-about-coach-name">Яна Хмельницкая</p>
                                <p class="club40-about-coach-position">Карьерный коуч</p>
                                <p class="club40-about-coach-text">Предлагаю сформулировать ваши сильные стороны и
                                    достижения, сможете опираться на них в разговоре о повышении</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="club40-about-center careerum-flex-sbst">
                    <div>
                        <div class="club40-about-label-blue">
                            <p>Careerum — это практика</p>
                        </div>
                        <p class="club40-about-header-dark">Интенсивы и Q&A-эфиры</p>
                        <p class="club40-about-text-dark">Разберетесь в самых актуальных карьерных<br> темах: от тенденций в
                            оформлении резюме<br> до развития нетворка в любой стране</p>
                    </div>
                    <div>
                        <div class="club40-about-label-white">
                            <p>Careerum — это поддержка</p>
                        </div>
                        <p class="club40-about-header-dark">Сильное сообщество</p>
                        <p class="club40-about-text-dark">Получите доступ к сообществу профессионалов<br> из 30+ стран, где
                            вы сможете завести полезные знакомства и найти рекомендации и поддержку<br> в достижении вашей
                            цели</p>
                    </div>
                </div>
                <div class="club40-about-bottom careerum-flex-fsfs">
                    <div>
                        <div class="club40-about-label-white">
                            <p>Careerum — это знания</p>
                        </div>
                        <p class="club40-about-header-white">80+ курсов от топовых экспертов для любой карьерной цели</p>
                        <p class="club40-about-text-white">Учитесь, когда и где удобно — материалы доступны<br> 24/7 на
                            любом
                            устройстве. Получайте целевые навыки, чтобы развивать карьеру так, как нужно вам</p>
    
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110551770-KJNwC-Grou.png"
                            alt="">
                    </div>
                </div>
                <div class="club40-about-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Выбрать тариф</a>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-about-tablet', {
        label: 'Club 4 about (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-about-tablet">
            <div class="careerum-container-tablet">
                <h2 class="careerum-club40-header-tablet">Подписка Careerum — это</h2>
                <div class="club40-about-top careerum-flex-fsfs">
                    <div>
                        <p class="club40-about-header-white">Команда сертифицированных карьерных коучей и экспертов</p>
                        <p class="club40-about-text-white">Проработайте свою ситуацию со специалистами с международным
                            опытом и достигните цели в два раза быстрее</p>
                    </div>
                    <div>
                        <div>
                            <div class="careerum-flex-fsc">
                                <div class="club40-about-coach-photo">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723468300463-EYtPX-phot.png"
                                        alt="">
                                </div>
                                <div>
                                    <p class="club40-about-coach-name">Софи Бессон</p>
                                    <p class="club40-about-coach-position">Карьерный эксперт</p>
                                </div>
                            </div>
                            <p class="club40-about-coach-text">Добрый день! Оставила комментарии к резюме. Уже очень
                                хорошо, но есть что исправить</p>
                        </div>
                        <div>
                            <div class="careerum-flex-fsc">
                                <div class="club40-about-coach-photo">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723468300132-DXXeM-phot.png"
                                        alt="">
                                </div>
                                <div>
                                    <p class="club40-about-coach-name">Яна Хмельницкая</p>
                                    <p class="club40-about-coach-position">Карьерный коуч</p>
                                </div>
                            </div>
                            <p class="club40-about-coach-text">Предлагаю сформулировать достижения, сможете опираться в
                                обсуждении повышения</p>
                        </div>
                    </div>
                </div>
                <div class="club40-about-center careerum-flex-sbst">
                    <div>
                        <p class="club40-about-header-white">Интенсивы и Q&A-эфиры</p>
                        <p class="club40-about-text-white">Разберетесь в самых актуальных карьерных темах: от тенденций
                            в оформлении резюме до развития нетворка в любой стране</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723468833142-XOfcz-Grou.svg"
                            alt="">
                    </div>
                    <div>
                        <p class="club40-about-header-dark">Сильное сообщество профессионалов<br> со всего мира</p>
                        <p class="club40-about-text-dark">Получите доступ к сообществу профессионалов из 30+ стран, где
                            вы сможете построить нетворк и найти поддержку в достижении вашей цели</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723468833762-HxGov-Play.svg"
                            alt="">
                    </div>
                </div>
                <div class="club40-about-bottom careerum-flex-fsfs">
                    <div>
                        <p class="club40-about-header-white">80+ курсов от топовых экспертов для любой цели</p>
                        <p class="club40-about-text-white">Учитесь, когда и где удобно — материалы доступны 24/7 на любом
                            устройстве. Получайте целевые навыки, чтобы развивать карьеру так, как нужно вам</p>
    
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723468833453-Ork8u-Grou.svg"
                            alt="">
                    </div>
                </div>
                <div class="club40-about-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Оформить подписку</a>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-about-mobile', {
        label: 'Club 4 about (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-about-mobile">
            <div class="careerum-container-mobile">
                <h2 class="careerum-club40-header-mobile">Подписка Careerum — это</h2>
                <div class="club40-about-top">
                    <div>
                        <p class="club40-about-header-white">Команда сертифицированных карьерных коучей и экспертов</p>
                        <p class="club40-about-text-white">Проработайте свою ситуацию со специалистами с международным
                            опытом и достигните цели в два раза быстрее</p>
                    </div>
                    <div>
                        <div>
                            <div class="careerum-flex-fsc">
                                <div class="club40-about-coach-photo">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723468300463-EYtPX-phot.png"
                                        alt="">
                                </div>
                                <div>
                                    <p class="club40-about-coach-name">Софи Бессон</p>
                                    <p class="club40-about-coach-position">Карьерный эксперт</p>
                                </div>
                            </div>
                            <p class="club40-about-coach-text">Добрый день! Оставила комментарии к резюме. Уже очень
                                хорошо, но есть что исправить</p>
                        </div>
                        <div>
                            <div class="careerum-flex-fsc">
                                <div class="club40-about-coach-photo">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723468300132-DXXeM-phot.png"
                                        alt="">
                                </div>
                                <div>
                                    <p class="club40-about-coach-name">Яна Хмельницкая</p>
                                    <p class="club40-about-coach-position">Карьерный коуч</p>
                                </div>
                            </div>
                            <p class="club40-about-coach-text">Предлагаю сформулировать достижения, сможете опираться в
                                обсуждении повышения</p>
                        </div>
                    </div>
                </div>
                <div class="club40-about-center">
                    <div>
                        <p class="club40-about-header-white">Интенсивы и Q&A-эфиры</p>
                        <p class="club40-about-text-white">Разберетесь в самых актуальных карьерных темах: от тенденций
                            в оформлении резюме до развития нетворка в любой стране</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723540946071-OF6ci-Grou.svg"
                            alt="">
                    </div>
                    <div>
                        <p class="club40-about-header-dark">Сильное сообщество профессионалов со всего мира</p>
                        <p class="club40-about-text-dark">Получите доступ к сообществу профессионалов из 30+ стран, где
                            вы сможете построить нетворк и найти поддержку в достижении вашей цели</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723541019685-hHvNE-Play.svg"
                            alt="">
                    </div>
                </div>
                <div class="club40-about-bottom">
                    <div>
                        <p class="club40-about-header-white">80+ курсов от топовых<br> экспертов для любой цели</p>
                        <p class="club40-about-text-white">Учитесь, когда и где удобно — материалы доступны 24/7 на любом
                            устройстве. Получайте целевые навыки, чтобы развивать карьеру так, как нужно вам</p>
    
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723541208766-qWvqi-Grou.svg"
                            alt="">
                    </div>
                </div>
                <div class="club40-about-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Выбрать тариф</a>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-goals', {
        label: 'Club 4 goals',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-goals">
            <div class="careerum-container-desc">
                <h2 class="careerum-club40-header">С Careerum любая карьерная задача<br> вам по плечу</h2>
                <div class="club40-goals-tales careerum-flex-fsfs">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                            alt="">
                        <p>Быстро найдете работу в компании, куда всегда хотелось</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                            alt="">
                        <p>Получите оффер на своих условиях, а не тот, который дают</p>
                    </div>
                    <div class="club40-goals-tale-rotate-right">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                            alt="">
                        <p>Подготовитесь к интервью, чтобы общаться с рекрутерами без паники и на равных </p>
                    </div>
                </div>
                <div class="club40-goals-tales careerum-flex-fsfs">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                            alt="">
                        <p>Устроитесь на работу<br> за границей и не упадете в грейде </p>
                    </div>
                    <div class="club40-goals-tale-rotate-left">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                            alt="">
                        <p>Начнете расти в профессии<br> и регулярно получать повышение </p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                            alt="">
                        <p>Перестанете выгорать,<br> начнете получать удовольствие от работы</p>
                    </div>
                </div>
                <div class="club40-goals-tales careerum-flex-fsfs">
                    <div class="club40-goals-tale-rotate-left">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                            alt="">
                        <p>Найдете свое место<br> в карьере, если запутались<br> и не знаете, как работать дальше </p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                            alt="">
                        <p>Укрепите профессиональную самооценку и начнете<br> строить карьеру вокруг себя,<br> а не наоборот
                        </p>
                    </div>
                    <div class="club40-goals-tale-rotate-right">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                            alt="">
                        <p>Повысите свою конкурентоспособность<br> даже после долгого<br> перерыва в работе</p>
                    </div>
                </div>
                <div class="club40-goals-form careerum-flex-sbfs">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723113134344-GuPXa-Vect.svg"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723113138463-WJviy-Unio.svg"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723113144846-xYKAa-Grou.svg"
                            alt="">
                        <p>У вас другая цель? Тоже поможем</p>
                        <div>
                            <p>Оставьте заявку,</p>
                            <p>а мы погрузимся в вашу ситуацию, подберем решение, и карьерные перемены начнутся уже в этом
                                месяце</p>
                        </div>
                    </div>
                    <div>
                        <div class="careerum-registration-form-club40">
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-club40-form-telegram">
                                    <input type="text" name="telegram" value="" required placeholder="Telegram">
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                                <div class="careerum-club40-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я даю согласие на обработку своих персональных данных<br> в соответствии с <a
                                            href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                                </div>
                                <a href="#" class="submit-btn btn-color-main-bright-orange button-sent" disabled>Оставить
                                    заявку</a>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-goals-tablet', {
        label: 'Club 4 goals (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-goals-tablet">
            <div class="careerum-container-tablet">
                <h2 class="careerum-club40-header-tablet">С Careerum любая карьерная задача<br> вам по плечу</h2>
                <div class="club40-goals-tales careerum-flex-fsst">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469156104-t334r-Vect.svg"
                            alt="">
                        <p>Быстро найдете работу в компании, куда всегда хотелось</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469156104-t334r-Vect.svg"
                            alt="">
                        <p>Получите оффер на своих условиях, а не тот, который дают</p>
                    </div>
                    <div class="club40-goals-tale-rotate-right">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469156104-t334r-Vect.svg"
                            alt="">
                        <p>Подготовитесь к интервью, чтобы общаться с рекрутерами без паники и на равных </p>
                    </div>
                </div>
                <div class="club40-goals-tales careerum-flex-fsst">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469156104-t334r-Vect.svg"
                            alt="">
                        <p>Устроитесь на работу<br> за границей и не упадете в грейде </p>
                    </div>
                    <div class="club40-goals-tale-rotate-left">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469156104-t334r-Vect.svg"
                            alt="">
                        <p>Начнете расти<br> в профессии и регулярно получать повышение </p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469156104-t334r-Vect.svg"
                            alt="">
                        <p>Перестанете выгорать,<br> начнете получать удовольствие от работы</p>
                    </div>
                </div>
                <div class="club40-goals-tales careerum-flex-fsst">
                    <div class="club40-goals-tale-rotate-left">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469156104-t334r-Vect.svg"
                            alt="">
                        <p>Найдете свое место<br> в карьере, если запутались и не знаете, как работать дальше </p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469156104-t334r-Vect.svg"
                            alt="">
                        <p>Укрепите профессиональную самооценку и начнете строить карьеру вокруг себя,<br> а не наоборот
                        </p>
                    </div>
                    <div class="club40-goals-tale-rotate-right">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469156104-t334r-Vect.svg"
                            alt="">
                        <p>Повысите свою конкуренто-способность<br> даже после долгого<br> перерыва в работе</p>
                    </div>
                </div>
                <div class="club40-goals-form careerum-flex-sbfs">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469779584-93ZWs-Vect.svg"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469779436-0tSV3-Unio.svg"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469778866-02ZRM-Grou.svg"
                            alt="">
                        <p>У вас другая цель? Тоже поможем</p>
                        <div>
                            <p>Оставьте заявку,</p>
                            <p>а мы погрузимся в вашу ситуацию, подберем решение, и карьерные перемены начнутся уже в этом
                                месяце</p>
                        </div>
                    </div>
                    <div>
                        <div class="careerum-registration-form-club40">
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-club40-form-telegram">
                                    <input type="text" name="telegram" value="" required placeholder="Telegram">
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                                <div class="careerum-club40-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я даю согласие на обработку своих персональных данных в соответствии с <a
                                            href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                                </div>
                                <a href="#" class="submit-btn btn-color-main-bright-orange button-sent" disabled>Оставить
                                    заявку</a>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-goals-mobile', {
        label: 'Club 4 goals (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-goals-mobile">
            <div class="careerum-container-mobile">
                <h2 class="careerum-club40-header-mobile">С Careerum любая карьерная задача вам по плечу</h2>
                <div class="club40-goals-tales club40-goals-tales-slider">
                    <div class="club40-goals-tale">
                        <p class="club40-goals-tale-header">Найти новую работу</p>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469156104-t334r-Vect.svg"
                                alt="">
                            <p>Подготовитесь к интервью, чтобы общаться с рекрутерами без паники</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469156104-t334r-Vect.svg"
                                alt="">
                            <p>Быстро найдете работу в компании, куда всегда хотелось, на своих условиях</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469156104-t334r-Vect.svg"
                                alt="">
                            <p>Устроитесь на работу за границей и не упадете в грейде</p>
                        </div>
                    </div>
                    <div class="club40-goals-tale">
                        <p class="club40-goals-tale-header">Вырасти в зарплате /<br> должности</p>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469156104-t334r-Vect.svg"
                                alt="">
                            <p>Укрепите профессиональную самооценку и начнете строить карьеру вокруг себя, а не наоборот</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469156104-t334r-Vect.svg"
                                alt="">
                            <p>Начнете расти и регулярно получать повышение</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469156104-t334r-Vect.svg"
                                alt="">
                            <p>Повысите конкуренто-способность даже после долгого перерыва в работе</p>
                        </div>
                    </div>
                    <div class="club40-goals-tale">
                        <p class="club40-goals-tale-header">Понять, чего хочется от карьеры</p>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469156104-t334r-Vect.svg"
                                alt="">
                            <p>Найдете свое место в карьере, если запутались и не знаете, как работать дальше </p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469156104-t334r-Vect.svg"
                                alt="">
                            <p>Перестанете выгорать, начнете получать удовольствие от работы</p>
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723542067084-cmkXg-Vect.svg"
                            alt="">
                    </div>
                </div>
                <div class="club40-goals-form">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723543242506-jHune-Vect.svg"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723543242175-LPPbu-Grou.svg"
                            alt="">
                        <p>У вас другая цель?<br> Тоже поможем</p>
                        <div>
                            <p>Оставьте заявку,</p>
                            <p>а мы погрузимся в вашу ситуацию, подберем решение, и карьерные перемены начнутся уже в этом
                                месяце</p>
                        </div>
                    </div>
                    <div>
                        <div class="careerum-registration-form-club40">
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-club40-form-telegram">
                                    <input type="text" name="telegram" value="" required placeholder="Telegram">
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                                <div class="careerum-club40-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я даю согласие на обработку своих персональных данных в соответствии с <a
                                            href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                                </div>
                                <a href="#" class="submit-btn btn-color-main-bright-orange button-sent" disabled>Оставить
                                    заявку</a>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-clients', {
        label: 'Club 4 clients',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-clients">
            <div class="careerum-container-desc">
                <h2 class="careerum-club40-header">Наши клиенты построили карьеру<br> в ведущих компаниях мира</h2>
                <div class="club40-clients-companies careerum-flex-fsfs">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115122363-xyHbj-Tesl.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115331031-myt4l-Amaz.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115330585-9MSlm-2560.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115333262-UAImR-Spot.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115332401-FkZ64-Micr.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115332749-mIfxs-Sky_.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115332515-khZye-Phil.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115332145-gqB7m-John.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115331911-hjvbp-Goog.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115333142-EdGAC-Sony.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115331641-UuXdl-Effe.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115331526-uL5Yd-Disn.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115332027-6Ren2-Inte.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115330911-6pK57-Airb.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115331174-9BWPm-Amer.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115332287-n7a8A-Lero.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115331415-4gsDs-Bost.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115517876-iF9c6-Toyo.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115333370-HJSp7-Yand.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115332622-sudY9-Puma.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115331287-VGekQ-Avit.svg"
                            alt="">
                    </div>
                    <div>
                        <p>4 000+ кейсов</p>
                    </div>
                </div>
                <div class="club40-clients-slider">
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422853-o2LIn-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Сергей Михайлов</p>
                                <p>Technical Transfer Lead, Австрия</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получил оффер c релокацией в Австрию, увеличил доход в 3 раза</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116421826-n9oaA-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Александра Пинчукова</p>
                                <p>менеджер бизнес-процессов, Германия</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получила оффер в штаб-квартиру Puma в начале 2023 года – после 3 месяцев поиска</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422118-nici9-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Сергей Бухаров</p>
                                <p>Supply Chain Forecast Analyst, Нидерланды</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получил оффер от Mars с релокацией в Нидерланды</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422236-vLdYI-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Карина Пысина</p>
                                <p>бизнес-аналитик, Россия</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получила оффер бизнес-аналитика, выросла в зарплате на 100%</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422371-2l7A2-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Тая Штоль</p>
                                <p>UX/UI-дизайнер, Испания</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получила оффер в немецкую компанию. Увеличила доход в 6 раз, получила соцпакет</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422492-aq4aa-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Евгения Вольхина</p>
                                <p>Project Manager, Германия</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получила оффер в Big4 в Москве и зарплату в 3,5 раза больше, потом – оффер в Германию
                                с ростом ещё на 40%</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422621-VPn05-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Олег Федоткин</p>
                                <p>Head of Department, Германия</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получил оффер на head-позицию с ростом зарплаты на 30%</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422737-07i7D-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Людмила Киселёва</p>
                                <p>Recruiter ll, США</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получила оффер ассистента в Microsoft, через год стала рекрутером в Transocean</p>
                        </div>
                    </div>
                </div>
                <div class="club40-clients-slider-nav careerum-flex-fec">
                    <div class="club40-clients-slider-nav-prev">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_7304_21282)">
                                <g filter="url(#filter0_b_7304_21282)">
                                    <rect y="40" width="40" height="40" transform="rotate(-90 0 40)" fill="#FF9F00" />
                                </g>
                                <path d="M13.1905 19.9993L26.8105 19.9993" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M19.4629 26.2453L13.1896 19.9986L19.4629 13.752" stroke="white"
                                    stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <filter id="filter0_b_7304_21282" x="-18.1166" y="-18.1166" width="76.2332" height="76.2332"
                                    filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                    <feComposite in2="SourceAlpha" operator="in"
                                        result="effect1_backgroundBlur_7304_21282" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_7304_21282"
                                        result="shape" />
                                </filter>
                                <clipPath id="clip0_7304_21282">
                                    <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                    <div class="club40-clients-slider-nav-next">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_7304_21286)">
                                <g filter="url(#filter0_b_7304_21286)">
                                    <rect x="40" width="40" height="40" transform="rotate(90 40 0)" fill="#FF9F00" />
                                </g>
                                <path d="M26.8095 20.0007L13.1895 20.0007" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M20.5371 13.7547L26.8104 20.0014L20.5371 26.248" stroke="white"
                                    stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <filter id="filter0_b_7304_21286" x="-18.1166" y="-18.1166" width="76.2332" height="76.2332"
                                    filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                    <feComposite in2="SourceAlpha" operator="in"
                                        result="effect1_backgroundBlur_7304_21286" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_7304_21286"
                                        result="shape" />
                                </filter>
                                <clipPath id="clip0_7304_21286">
                                    <rect x="40" width="40" height="40" rx="20" transform="rotate(90 40 0)" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-clients-tablet', {
        label: 'Club 4 clients (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-clients-tablet">
            <div class="careerum-container-tablet">
                <h2 class="careerum-club40-header-tablet">Наши клиенты построили карьеру<br> в ведущих компаниях мира</h2>
                <div class="club40-clients-companies careerum-flex-fsfs">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723471017456-aQU00-Effe.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723471019742-wiFVW-Toyo.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723471597031-41Sbz-Vect.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723471016854-KC0mT-Amaz.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723471018086-kFUjz-Micr.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723471019251-VE7GM-Spot.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723471017945-P9kjI-John.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723471746563-8Sd3H-Yand.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723472436347-BtDwx-Sky_L.webp"
                            width="52px" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723471017603-hfj9T-Goog.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723471019060-otJ5z-Sony.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723472605983-YIeVv-Mars.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723471018378-FPG9d-Puma.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723471017277-KsPCq-Disn.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723471017765-3Pia8-Inte.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723471018244-GkXf4-Phil.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723471017135-DO4xq-Bost.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723472803990-3lR8o-Avit.svg"
                            alt="">
                    </div>
                    <div>
                        <p>4 000+ кейсов</p>
                    </div>
                </div>
                <div class="club40-clients-slider">
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422853-o2LIn-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Сергей Михайлов</p>
                                <p>Technical Transfer Lead, Австрия</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получил оффер c релокацией в Австрию, увеличил доход в 3 раза</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116421826-n9oaA-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Александра Пинчукова</p>
                                <p>менеджер, Германия</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получила оффер в штаб-квартиру Puma в начале 2023 года – после 3 месяцев поиска</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422118-nici9-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Сергей Бухаров</p>
                                <p>Supply Chain Forecast Analyst, Нидерланды</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получил оффер от Mars с релокацией в Нидерланды</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422236-vLdYI-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Карина Пысина</p>
                                <p>бизнес-аналитик, Россия</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получила оффер бизнес-аналитика, выросла в зарплате на 100%</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422371-2l7A2-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Тая Штоль</p>
                                <p>UX/UI-дизайнер, Испания</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получила оффер в немецкую компанию. Увеличила доход в 6 раз, получила соцпакет</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422492-aq4aa-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Евгения Вольхина</p>
                                <p>Project Manager, Германия</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получила оффер в Big4 в Москве и зарплату в 3,5 раза больше, потом – оффер в Германию
                                с ростом ещё на 40%</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422621-VPn05-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Олег Федоткин</p>
                                <p>Head of Department, Германия</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получил оффер на head-позицию с ростом зарплаты на 30%</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422737-07i7D-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Людмила Киселёва</p>
                                <p>Recruiter ll, США</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получила оффер ассистента в Microsoft, через год стала рекрутером в Transocean</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-clients-mobile', {
        label: 'Club 4 clients (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-clients-mobile">
            <div class="careerum-container-mobile">
                <h2 class="careerum-club40-header-mobile">Наши клиенты построили карьеру в ведущих компаниях</h2>
                <div class="club40-clients-companies careerum-flex-fsfs">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544686294-cXWs4-Vect.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544685487-4vULq-Micr.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544684088-HJKiJ-Amaz.svg"
                            alt="" style="margin-top: 3px;">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544685276-ErtgD-John.svg"
                            alt="" style="margin-top: 1px;">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544684694-z20V7-g10..svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544686048-B1Bzn-Spot.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723472436347-BtDwx-Sky_L.webp"
                            width="46px" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544684875-Kh6BE-Goog.svg"
                            alt="" style="margin-top: 2px;">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544685014-IhhTc-Grou.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544685624-XDgU1-path.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544685896-mDyZM-Puma.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544684504-0d0Ri-Avit.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544686180-aw0aC-Vect.svg"
                            alt="" style="margin-top: 1px;">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544685145-EgMYR-Inte.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544685756-brX6G-Phil.svg"
                            alt="">
                    </div>
                    <div>
                        <p>4 000+ кейсов</p>
                    </div>
                </div>
                <div class="club40-clients-slider">
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422853-o2LIn-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Сергей Михайлов</p>
                                <p>Technical Transfer Lead, Австрия</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получил оффер c релокацией в Австрию, увеличил доход в 3 раза</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116421826-n9oaA-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Александра Пинчукова</p>
                                <p>менеджер, Германия</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получила оффер в штаб-квартиру Puma в начале 2023 года – после 3 месяцев поиска</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422118-nici9-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Сергей Бухаров</p>
                                <p>Supply Chain Forecast Analyst, Нидерланды</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получил оффер от Mars с релокацией в Нидерланды</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422236-vLdYI-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Карина Пысина</p>
                                <p>бизнес-аналитик, Россия</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получила оффер бизнес-аналитика, выросла в зарплате на 100%</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422371-2l7A2-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Тая Штоль</p>
                                <p>UX/UI-дизайнер, Испания</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получила оффер в немецкую компанию. Увеличила доход в 6 раз, получила соцпакет</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422492-aq4aa-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Евгения Вольхина</p>
                                <p>Project Manager, Германия</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получила оффер в Big4 в Москве и зарплату в 3,5 раза больше, потом – оффер в Германию
                                с ростом ещё на 40%</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422621-VPn05-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Олег Федоткин</p>
                                <p>Head of Department, Германия</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получил оффер на head-позицию с ростом зарплаты на 30%</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422737-07i7D-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Людмила Киселёва</p>
                                <p>Recruiter ll, США</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получила оффер ассистента в Microsoft, через год стала рекрутером в Transocean</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-mission', {
        label: 'Club 4 mission',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-mission">
            <div class="careerum-container-desc">
                <div class="club40-mission-top careerum-flex-fsfs">
                    <div class="club40-mission-top-left">
                        <div class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118383095-IJaUt-Circ.svg"
                                alt="">
                            <p>Преображаем карьеры с 2018 года</p>
                        </div>
                        <p>Точно знаем, как стать профессионалом<br>
                            с сильными карьерными навыками, который</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118383633-2vYzb-Vect.svg"
                            alt="">
                    </div>
                    <div class="club40-mission-top-right">
                        <div class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118383503-qQBVD-Unio.svg"
                                alt="">
                            <p>Знает, что востребовано на рынке</p>
                        </div>
                        <div class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118383365-pL8gq-Fram.svg"
                                alt="">
                            <p>Развивает навыки, за которые платят</p>
                        </div>
                        <div class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118383503-qQBVD-Unio.svg"
                                alt="">
                            <p>Заранее выстраивает стратегию повышения</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118383365-pL8gq-Fram.svg"
                                alt="">
                            <p>Умеет выгодно преподносить свой опыт<br> в разных рабочих контекстах</p>
                        </div>
                        <div>
                            <p>
                                <span>Наша миссия:</span> сделать так, чтобы специалистов, осознанно управляющих своей
                                карьерой, стало как можно бо-о-о-о-ольше
                            </p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118442385-bgk8K-Grou.svg"
                                alt="">
                        </div>
                    </div>
                </div>
                <div class="club40-mission-bottom">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118616351-b8BSw-Vect.svg" alt="">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118616229-fdPp2-Vect.svg" alt="">
                    <p>12 000+ профессионалов по всему миру<br> уже построили карьеру по своим правилам</p>
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118683984-d1y11-Grou.png"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118684271-AH5B0-Grou.png"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118684395-sR8Vx-Grou.png"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118684516-5Tr5C-Grou.png"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118684634-7DOXr-Grou.png"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118684760-uObOr-Grou.png"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118684896-6sxpG-Grou.png"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118685030-I5nvh-Grou.png"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118685170-r30Nz-Grou.png"
                            alt="">
                    </div>
                </div>
                <div class="club40-mission-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Оформить подписку</a>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-mission-tablet', {
        label: 'Club 4 mission (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-mission-tablet">
            <div class="careerum-container-tablet">
                <div class="club40-mission-top">
                    <div class="club40-mission-top-left">
                        <p>Знаем, как стать профессионалом с сильными карьерными навыками</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723473791743-ewVBv-Vect.svg"
                            alt="">
                    </div>
                    <div class="club40-mission-top-right">
                        <div class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118383503-qQBVD-Unio.svg"
                                alt="">
                            <p>Знает, что востребовано на рынке</p>
                        </div>
                        <div class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118383365-pL8gq-Fram.svg"
                                alt="">
                            <p>Развивает навыки, за которые платят</p>
                        </div>
                        <div class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118383503-qQBVD-Unio.svg"
                                alt="">
                            <p>Заранее выстраивает стратегию повышения</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118383365-pL8gq-Fram.svg"
                                alt="">
                            <p>Умеет выгодно преподносить свой опыт<br> в разных рабочих контекстах</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <p>Наша миссия:</p>
                            <p>сделать так, чтобы специалистов, осознанно управляющих своей карьерой, стало как можно больше
                            </p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723474308924-2J0Zv-Grou.svg"
                                alt="">
                        </div>
                    </div>
                </div>
                <div class="club40-mission-label careerum-flex-fsc">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723474401911-XhK0o-Circ.svg" alt="">
                    <p>Преображаем карьеры с 2018 года</p>
                </div>
                <div class="club40-mission-bottom">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118616351-b8BSw-Vect.svg" alt="">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723474635030-6fs3R-Vect.svg" alt="">
                    <p>12 000+ профессионалов по всему миру<br> уже построили карьеру по своим правилам</p>
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118683984-d1y11-Grou.png"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118684271-AH5B0-Grou.png"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118684395-sR8Vx-Grou.png"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118684516-5Tr5C-Grou.png"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118684634-7DOXr-Grou.png"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118684760-uObOr-Grou.png"
                            alt="">
                    </div>
                </div>
                <div class="club40-mission-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Оформить подписку</a>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-mission-mobile', {
        label: 'Club 4 mission (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-mission-mobile">
            <div class="careerum-container-mobile">
                <h2 class="careerum-club40-header-mobile">Точно знаем, как стать профессионалом с сильными карьерными
                    навыками</h2>
                <div class="club40-mission-top">
                    <div class="club40-mission-top-left">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723545520322-rmyPK-Vect.svg"
                            alt="">
                        <p>Специалист с такими навыками</p>
                        <div class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723545520992-Wp7M7-Vect.svg"
                                alt="">
                            <p>Осознанно управляет карьерой</p>
                        </div>
                        <div class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723545520992-Wp7M7-Vect.svg"
                                alt="">
                            <p>Получает лучшие офферы </p>
                        </div>
                        <div class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723545520992-Wp7M7-Vect.svg"
                                alt="">
                            <p>Быстро растет в должности и зарплате</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723545520992-Wp7M7-Vect.svg"
                                alt="">
                            <p>Знает, за какие скилы платят, и развивает их</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723545520992-Wp7M7-Vect.svg"
                                alt="">
                            <p>Заранее продумывает стратегию повышения</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723545520992-Wp7M7-Vect.svg"
                                alt="">
                            <p>Использует свой опыт как инструмент достижения целей</p>
                        </div>
                    </div>
                    <div class="club40-mission-top-right">
                        <div>
                            <p>Наша миссия:</p>
                            <p>сделать так, чтобы специалистов, осознанно управляющих своей карьерой, стало как можно
                                бо-о-о-о-ольше</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723545971958-ZuJE4-Grou.svg"
                                alt="">
                        </div>
                    </div>
                </div>
                <div class="club40-mission-label careerum-flex-fsc">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723474401911-XhK0o-Circ.svg" alt="">
                    <p>Преображаем карьеры с 2018 года</p>
                </div>
                <div class="club40-mission-bottom">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723546515249-YCFow-Vect.svg" alt="">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723546514877-ZE7qK-Vect.svg" alt="">
                    <p>12 000+ профессионалов по всему миру уже построили карьеру<br> по своим правилам</p>
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118683984-d1y11-Grou.png"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118684271-AH5B0-Grou.png"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118684395-sR8Vx-Grou.png"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118684516-5Tr5C-Grou.png"
                            alt="">
                    </div>
                </div>
                <div class="club40-mission-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Оформить подписку</a>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-author', {
        label: 'Club 4 author',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-author">
            <div class="careerum-container-desc">
                <h2 class="careerum-club40-header">Ольга Лермонтова, фаундер Careerum</h2>
                <div class="club40-author-top careerum-flex-fsc">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723121261660-K1WuM-Fram.png"
                            alt="">
                    </div>
                    <div>
                        <p>
                            «За 15 лет своей карьеры я прошла путь от репетитора английского языка до топ-менеджера в
                            Google,
                            Intel<br> и Microsoft.</p>
                        <p>
                            Я училась на своих ошибках, часто не знала, как правильно строить карьеру и сделать выбор,
                            который будет подходить именно мне, а не совпадать с навязанными шаблонами.</p>
                        <p>
                            Этот опыт я собрала в Careerum, чтобы другие профессионалы могли сэкономить время, избежать
                            фатальных карьерных ошибок, расти быстрее<br> и зарабатывать на том, что нравится именно им!»
                        </p>
                    </div>
                </div>
                <div class="club40-author-bottom">
                    <div class="careerum-flex-fsst">
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723121827701-lK3KT-User.svg"
                                alt="">
                            <p>Помогла 12 000+ клиентам из России, СНГ, Европы, Северной и Южной Америки построить карьеру
                            </p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723121827589-RDqmT-Grad.svg"
                                alt="">
                            <p>Сертифицированный карьерный коуч International Coaching Federation</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723121827589-RDqmT-Grad.svg"
                                alt="">
                            <p>Степень MBA от бизнес-школы INSEAD, учится в Гарварде</p>
                        </div>
                    </div>
                    <div class="careerum-flex-fsst">
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723121827344-JJ1IL-Brie.svg"
                                alt="">
                            <p>15+ лет успешной карьеры на руководящих позициях в 5 странах в tech-компаниях (Google,
                                Microsoft, Intel)</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723121827344-JJ1IL-Brie.svg"
                                alt="">
                            <p>Управляла бизнесом на 20+ рынках<br> Африки, Западной и Восточной Европы</p>
                        </div>
                    </div>
                    <div class="careerum-flex-fsst">
                        <div class="careerum-flex-sbfs">
                            <a class="careerum-flex-fsc" href="https://www.instagram.com/lermontova.career/"
                                target="_blank">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726038651331-fkpF5-Fram.svg"
                                    alt="">
                                <p>lermontova.career</p>
                            </a>
                            <a class="careerum-flex-fsc" href="https://www.linkedin.com/in/lermontova/" target="_blank">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726038856963-qRLBz-Fram.svg"
                                    alt="">
                                <p>lermontova</p>
                            </a>
                            <a class="careerum-flex-fsc" href="https://t.me/dreamcatchme" target="_blank">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726038866551-FX8WJ-Fram.svg"
                                    alt="">
                                <p>dreamcatchme</p>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="club40-author-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Оформить подписку</a>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-author-tablet', {
        label: 'Club 4 author (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-author-tablet">
            <div class="careerum-container-tablet">
                <h2 class="careerum-club40-header-tablet">Ольга Лермонтова, фаундер Careerum</h2>
                <div class="club40-author-top careerum-flex-fsc">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475008025-kxKl4-Fram.png"
                            alt="">
                    </div>
                    <div>
                        <p>
                            «За 15 лет своей карьеры я прошла путь<br> от репетитора английского языка до топ-<br>менеджера
                            в
                            Google,
                            Intel и Microsoft.</p>
                        <p>
                            Я училась на своих ошибках, часто не знала, как правильно строить карьеру и сделать выбор,
                            который будет подходить именно мне, а не совпадать с навязанными шаблонами.</p>
                        <p>
                            Этот опыт я собрала в Careerum, чтобы другие профессионалы могли сэкономить время, избежать
                            фатальных карьерных ошибок, расти быстрее и зарабатывать на том, что нравится именно им!»
                        </p>
                    </div>
                </div>
                <div class="club40-author-bottom">
                    <div class="careerum-flex-fsst">
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723121827701-lK3KT-User.svg"
                                alt="">
                            <p>Помогла 12 000+ клиентам из России, СНГ, Европы, Северной и Южной Америки построить карьеру
                            </p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723121827344-JJ1IL-Brie.svg"
                                alt="">
                            <p>15+ лет успешной карьеры на руководящих позициях в 5 странах в tech-компаниях (Google,
                                Microsoft, Intel)</p>
                        </div>
                    </div>
                    <div class="careerum-flex-fsst">
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723121827589-RDqmT-Grad.svg"
                                alt="">
                            <p>Сертифицированный карьерный коуч International Coaching Federation</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723121827589-RDqmT-Grad.svg"
                                alt="">
                            <p>Степень MBA от бизнес-школы INSEAD, учится в Гарварде</p>
                        </div>
                    </div>
                    <div class="careerum-flex-fsst">
                        <div class="careerum-flex-fsfs">
                            <a class="careerum-flex-fsc" href="https://www.instagram.com/lermontova.career/"
                                target="_blank">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726059782241-TGyZN-Fram.svg"
                                    alt="">
                                <p>lermontova.career</p>
                            </a>
                            <a class="careerum-flex-fsc" href="https://www.linkedin.com/in/lermontova/" target="_blank">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726059781876-BfLAq-Fram.svg"
                                    alt="">
                                <p>lermontova</p>
                            </a>
                            <a class="careerum-flex-fsc" href="https://t.me/dreamcatchme" target="_blank">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726059782128-2ixKy-Fram.svg"
                                    alt="">
                                <p>dreamcatchme</p>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="club40-author-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Оформить подписку</a>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-author-mobile', {
        label: 'Club 4 author (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-author-mobile">
            <div class="careerum-container-mobile">
                <h2 class="careerum-club40-header-mobile">Ольга Лермонтова, фаундер Careerum</h2>
                <div class="club40-author-top">
                    <div class="careerum-flex-cc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723546777111-Sr73P-Fram.png"
                            alt="">
                    </div>
                    <div>
                        <p>«За 15 лет карьеры я прошла путь от репетитора английского языка до топ-менеджера в Google, Intel
                            и Microsoft.</p>
                        <p>Я училась на своих ошибках, часто не знала, как правильно строить карьеру.</p>
                        <p>Весь опыт я собрала в Careerum, чтобы другие профессионалы могли сэкономить время, избежать
                            фатальных карьерных ошибок, расти быстрее и зарабатывать на том, что нравится именно им!»</p>
                    </div>
                </div>
                <div class="club40-author-bottom">
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723547194995-HHAge-User.svg"
                            alt="">
                        <p>Помогла 12 000+ клиентам из России, СНГ, Европы, Северной и Южной Америки построить карьеру </p>
                    </div>
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723547194808-hdZMf-Grad.svg"
                            alt="">
                        <p>Сертифицированный карьерный коуч ICF</p>
                    </div>
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723547194808-hdZMf-Grad.svg"
                            alt="">
                        <p>Степень MBA от бизнес-школы INSEAD, учится в Гарварде</p>
                    </div>
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723547194495-04rIA-Brie.svg"
                            alt="">
                        <p>15+ лет успешной карьеры на руководящих позициях в 5 странах в Google, Microsoft, Intel</p>
                    </div>
                </div>
                <div class="club40-author-bottom">
                    <a class="careerum-flex-fsc" href="https://www.instagram.com/lermontova.career/" target="_blank">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726059782241-TGyZN-Fram.svg"
                            alt="">
                        <p>lermontova.career</p>
                    </a>
                    <a class="careerum-flex-fsc" href="https://www.linkedin.com/in/lermontova/" target="_blank">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726059781876-BfLAq-Fram.svg"
                            alt="">
                        <p>lermontova</p>
                    </a>
                    <a class="careerum-flex-fsc" href="https://t.me/dreamcatchme" target="_blank">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726059782128-2ixKy-Fram.svg"
                            alt="">
                        <p>dreamcatchme</p>
                    </a>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-time', {
        label: 'Club 4 time',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-time">
            <div class="careerum-container-desc">
                <h2 class="careerum-club40-header">Сколько времени потребуется, чтобы</h2>
                <div class="club40-time-nav">
                    <ul class="club40-time-nav-wrapper careerum-flex-fsfs">
                    </ul>
                </div>
                <div class="club40-time-items">
                    <div class="club40-time-item active" data-name="Понять, чего хочется от карьеры">
                        <div class="club40-time-item-top">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123276318-o6rOi-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">В одиночку: иногда — всю жизнь</p>
                            <div class="club40-time-item-top-items careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Строите карьеру «как получится» и без плана</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Не понимаете свои сильные стороны, сомневаетесь в себе</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Чувствуете, что в работе нужно что-то менять, но не знаете, что</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Работа перестала радовать<br> и превратилась в рутину</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Не знаете, что делать дальше: с карьерой и жизнью</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Ощущаете себя на чужом месте</p>
                                </div>
                            </div>
                        </div>
                        <div class="club40-time-item-bottom">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123330340-wzGhN-Vect.svg"
                                alt="">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123330090-aI7Rw-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">С Careerum: от 4 месяцев</p>
                            <div class="club40-time-item-bottom-items careerum-flex-fsst">
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">1–2 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123375562-bETkB-Vect.svg"
                                            alt="">
                                        <p>Определите свои «Хочу» и «Могу»</p>
                                    </div>
                                    <ul>
                                        <li>Поймете, что мешает вам достичь карьерных целей
                                        <li>Выявите свои сильные стороны и таланты</li>
                                        <li>Определите свои ключевые ценности</li>
                                        <li>Поймете, что в работе радует, а что демотивирует</li>
                                        <li>Сформулируете свои профессиональные интересы</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">3 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123375562-bETkB-Vect.svg"
                                            alt="">
                                        <p>Поймете свои «Надо»</p>
                                    </div>
                                    <ul>
                                        <li>Соотнесете свои таланты с запросами рынка</li>
                                        <li>Подружите свои ценности с бизнес-задачами</li>
                                        <li>Научитесь выбирать работу осознанно, а не брать, «что дают»</li>
                                        <li>Поставите долгосрочную карьерную цель с опорой на свои ценности</li>
                                        <li>Определите пути развития под свою долгосрочную цель</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">4+ месяцa</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123375562-bETkB-Vect.svg"
                                            alt="">
                                        <p>В зависимости от целей:</p>
                                    </div>
                                    <ul>
                                        <li>Начнете осознанный поиск работы</li>
                                        <li>Составите план развития на текущем месте</li>
                                        <li>Наладите work-life balance</li>
                                        <li>Научитесь работать без выгорания</li>
                                        <li>Укрепите профессиональную самооценку</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item-photo careerum-flex-fsfs">
                                    <p class="club40-time-item-bottom-item-text">Распутать карьерный клубок не сложно, если
                                        рядом сертифицированные карьерные коучи и эксперты</p>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723125224907-7Ysdj-Unio.svg"
                                        alt="" class="club40-time-item-bottom-item-img-hover1">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723125004478-Uqcgc-ÑÐº.png"
                                        alt="" class="club40-time-item-bottom-item-img-coaches">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="club40-time-item" data-name="Найти работу в своей стране">
                        <div class="club40-time-item-top">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123276318-o6rOi-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">В одиночку: 9–12 месяцев</p>
                            <div class="club40-time-item-top-items careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Долго и безуспешно ищете работу</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Ваше резюме не читают или игнорируют</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Нервничаете на интервью и не знаете, как себя вести</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Не знаете, какую зарплату запросить — адекватно</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Боитесь откликаться на «крутые» вакансии</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Получаете отказы на разных этапах и не понимаете, почему</p>
                                </div>
                            </div>
                        </div>
                        <div class="club40-time-item-bottom">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123330340-wzGhN-Vect.svg"
                                alt="">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123330090-aI7Rw-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">С Careerum: 3–6 месяцев</p>
                            <div class="club40-time-item-bottom-items careerum-flex-fsst">
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">1 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123375562-bETkB-Vect.svg"
                                            alt="">
                                        <p>Создадите стратегию поиска</p>
                                    </div>
                                    <ul>
                                        <li>Определите цель поиска</li>
                                        <li>Составите стратегию и воронку поиска</li>
                                        <li>Подготовите продающее резюме</li>
                                        <li>Отправите первые отклики</li>
                                        <li>Напишете сильные сопроводительные письма</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">2-3 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123375562-bETkB-Vect.svg"
                                            alt="">
                                        <p>Выйдете на первые интервью</p>
                                    </div>
                                    <ul>
                                        <li>Проработаете LinkedIn-профиль</li>
                                        <li>Адаптируете резюме и письма под вакансии</li>
                                        <li>Подготовитесь к собеседованиям</li>
                                        <li>Получите первые приглашения на интервью</li>
                                        <li>Скорректируете стратегию поиска с экспертом</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">4–6 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123375562-bETkB-Vect.svg"
                                            alt="">
                                        <p>Начнете получать офферы</p>
                                    </div>
                                    <ul>
                                        <li>Начнете легко проходить интервью</li>
                                        <li>Научитесь вести переговоры об условиях работы</li>
                                        <li>Начнете получать первые офферы</li>
                                        <li>Будете выбирать офферы под свою цель и стратегию</li>
                                        <li>Построите нетворк и начнете получать больше приглашений</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">6+ месяцев</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123375562-bETkB-Vect.svg"
                                            alt="">
                                        <p>Освоитесь на новой работе</p>
                                    </div>
                                    <ul>
                                        <li>Поймете, как пройти испытательный срок</li>
                                        <li>Сформируете план развития на новом месте</li>
                                        <li>Узнаете, как вырасти в зарплате и должности</li>
                                        <li>Разовьете софтскилы для роста</li>
                                        <li>Адаптируетесь в новой команде</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item-photo-wide careerum-flex-sbfs">
                                    <p class="club40-time-item-bottom-item-text">Найти новую работу можно в 2 раза быстрее,
                                        когда рядом сертифицированные карьерные коучи и эксперты с международным опытом</p>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723126169139-JLbtf-Grou.svg"
                                        alt="" class="club40-time-item-bottom-item-img-hover3">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723126405309-EBRwq-ÑÐº.png"
                                        alt="" class="club40-time-item-bottom-item-img-coaches">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="club40-time-item" data-name="Найти работу в другой стране">
                        <div class="club40-time-item-top">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123276318-o6rOi-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">В одиночку: от 12 месяцев</p>
                            <div class="club40-time-item-top-items careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Не знаете, какую странувыбрать</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Не знакомы с форматом иностранных интервью</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Опасаетесь, что ваш доходстанет меньше</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Не понимаете, какие вакансии вам подойдут</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Боитесь конкуренции с местными кандидатами</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Получаете отказы и не понимаете, почему</p>
                                </div>
                            </div>
                        </div>
                        <div class="club40-time-item-bottom">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123330340-wzGhN-Vect.svg"
                                alt="">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123330090-aI7Rw-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">С Careerum: 3–6 месяцев</p>
                            <div class="club40-time-item-bottom-items careerum-flex-fsst">
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">1–2 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123375562-bETkB-Vect.svg"
                                            alt="">
                                        <p>Подготовитесь к поиску</p>
                                    </div>
                                    <ul>
                                        <li>Поймете, как устроен процесс найма за рубежом</li>
                                        <li>Определите географию, цель и стратегию поиска</li>
                                        <li>Составите резюме для выбранной страны</li>
                                        <li>Проработаете LinkedIn-профиль и сопроводительное письмо</li>
                                        <li>Начнете отправлять первые отклики</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">3-5 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123375562-bETkB-Vect.svg"
                                            alt="">
                                        <p>Выйдете на первые интервью</p>
                                    </div>
                                    <ul>
                                        <li>Научитесь проходить интервью на другом языке</li>
                                        <li>Поймете, как строить нетворк в нужной стране</li>
                                        <li>Сможете вести переговоры о зарплате и условиях</li>
                                        <li>Начнете получать первые приглашения на интервью</li>
                                        <li>Скорректируете стратегию поиска с экспертом</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">6–9 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123375562-bETkB-Vect.svg"
                                            alt="">
                                        <p>Начнете получать офферы</p>
                                    </div>
                                    <ul>
                                        <li>Начнете проходить собеседования без стресса</li>
                                        <li>Научитесь легко общаться с иностранными рекрутерами</li>
                                        <li>Получите первые офферы и выберете из них подходящие именно под вашу цель</li>
                                        <li>Разовьете нетворк и начнете получать больше приглашений</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">9+ месяцев</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123375562-bETkB-Vect.svg"
                                            alt="">
                                        <p>Освоитесь на новой работе</p>
                                    </div>
                                    <ul>
                                        <li>Узнаете, как успешно пройти испытательный срок</li>
                                        <li>Сформулируете план развития на новом месте</li>
                                        <li>Поймете, как вырасти в зарплате и должности</li>
                                        <li>Разовьете софтскилс для роста</li>
                                        <li>Адаптируетесь к иностранной команде</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item-photo-wide careerum-flex-sbfs">
                                    <p class="club40-time-item-bottom-item-text">Получить оффер за границе можно быстрее и
                                        без стресса, когда рядом сертифицированные карьерные эксперты с международным опытом
                                    </p>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723126555192-8CJQ6-Grou.svg"
                                        alt="" class="club40-time-item-bottom-item-img-hover4">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723126405309-EBRwq-ÑÐº.png"
                                        alt="" class="club40-time-item-bottom-item-img-coaches">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="club40-time-item" data-name="Вырасти в зарплате и должности">
                        <div class="club40-time-item-top">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123276318-o6rOi-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">В одиночку: до-о-о-о-олго</p>
                            <div class="club40-time-item-top-items careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Не знаете, как вырасти в зарплате и должности</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Не понимаете, как аргументировать повышение</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Не знаете, сколько должен получать специалист как вы</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Ждете, что вас повысят, но этого не происходит</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Не представляете, как может развиваться ваша карьера</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Не понимаете, зачем демонстрировать результаты</p>
                                </div>
                            </div>
                        </div>
                        <div class="club40-time-item-bottom">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123330340-wzGhN-Vect.svg"
                                alt="">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123330090-aI7Rw-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">С Careerum: от 3 месяцев</p>
                            <div class="club40-time-item-bottom-items careerum-flex-fsst">
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">1 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123375562-bETkB-Vect.svg"
                                            alt="">
                                        <p>Подготовите базу для роста</p>
                                    </div>
                                    <ul>
                                        <li>Определите, что мешает вам расти в карьере
                                        <li>Определите с руководителем цели, чтобы развиваться в профессии</li>
                                        <li>Составите стратегию роста с учетом ваших суперсил и задач бизнеса</li>
                                        <li>Поймете: сколько стоят ваши навыки на рынке</li>
                                        <li>Укрепите профессиональную самооценку</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">2 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123375562-bETkB-Vect.svg"
                                            alt="">
                                        <p>Вырастите в доходе / должности</p>
                                    </div>
                                    <ul>
                                        <li>Научитесь строить коммуникации и брать стратегически важные проекты</li>
                                        <li>Поймете, как запрашивать и принимать фидбек</li>
                                        <li>Сможете заявлять о себе и демонстрировать результаты</li>
                                        <li>Научитесь вести переговоры о повышении в свою пользу</li>
                                        <li>Получите повышение в зарплате / должности</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">3 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123375562-bETkB-Vect.svg"
                                            alt="">
                                        <p>Поставите новые рекорды</p>
                                    </div>
                                    <ul>
                                        <li>Определите дополнительные способы роста</li>
                                        <li>Составите стратегию дальнейшего повышения</li>
                                        <li>Наладите work-life balance</li>
                                        <li>Сможете работать без выгорания</li>
                                        <li>Разовьете софтскил, необходимые для роста</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item-photo careerum-flex-fsfs">
                                    <p class="club40-time-item-bottom-item-text">Расти в карьере можно регулярно, <br>если
                                        рядом сертифицированные карьерные коучи и эксперты с международным опытом</p>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723125950683-T4bEF-Unio.svg"
                                        alt="" class="club40-time-item-bottom-item-img-hover2">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723125004478-Uqcgc-ÑÐº.png"
                                        alt="" class="club40-time-item-bottom-item-img-coaches">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-time-tablet', {
        label: 'Club 4 time (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-time-tablet">
            <div class="careerum-container-tablet">
                <h2 class="careerum-club40-header-tablet">Сколько времени потребуется, чтобы</h2>
                <div class="club40-time-nav">
                    <ul class="club40-time-nav-wrapper careerum-flex-fsfs">
                    </ul>
                </div>
                <div class="club40-time-items">
                    <div class="club40-time-item active" data-name="Понять, чего хочется от карьеры">
                        <div class="club40-time-item-top">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475623488-GgpEV-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">В одиночку: иногда — всю жизнь</p>
                            <div class="club40-time-item-top-items careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Строите карьеру «как получится» и без плана</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не понимаете свои сильные стороны, сомневаетесь в себе</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Работа перестала радовать<br> и превратилась в рутину</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не знаете, что делать дальше: с карьерой и жизнью</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Чувствуете, что в работе нужно что-то менять, но не знаете, что</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Ощущаете себя на чужом месте</p>
                                </div>
                            </div>
                        </div>
                        <div class="club40-time-item-bottom">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475959505-4Gr3I-Vect.svg"
                                alt="">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475623753-JoaXH-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">С Careerum: от 4 месяцев</p>
                            <div class="club40-time-item-bottom-items careerum-flex-fsst">
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">1–2 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Определите свои «Хочу» и «Могу»</p>
                                    </div>
                                    <ul>
                                        <li>Поймете, что мешает вам достичь карьерных целей
                                        <li>Выявите свои сильные стороны и таланты</li>
                                        <li>Определите свои ключевые ценности</li>
                                        <li>Поймете, что в работе радует, а что демотивирует</li>
                                        <li>Сформулируете свои профессиональные интересы</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">3 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Поймете свои «Надо»</p>
                                    </div>
                                    <ul>
                                        <li>Соотнесете свои таланты с запросами рынка</li>
                                        <li>Подружите свои ценности с бизнес-задачами</li>
                                        <li>Научитесь выбирать работу осознанно, а не брать, «что дают»</li>
                                        <li>Поставите долгосрочную карьерную цель с опорой на свои ценности</li>
                                        <li>Определите пути развития под свою долгосрочную цель</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">4+ месяцa</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>В зависимости от целей:</p>
                                    </div>
                                    <ul>
                                        <li>Начнете осознанный поиск работы</li>
                                        <li>Составите план развития на текущем месте</li>
                                        <li>Наладите work-life balance</li>
                                        <li>Научитесь работать без выгорания</li>
                                        <li>Укрепите профессиональную самооценку</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item-photo careerum-flex-fsfs">
                                    <p class="club40-time-item-bottom-item-text">Распутать карьерный клубок<br> не сложно,
                                        если
                                        рядом карьерные коучи и эксперты</p>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476494104-dIToE-Unio.svg"
                                        alt="" class="club40-time-item-bottom-item-img-hover1">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476607650-AQUXg-ÑÐº.png"
                                        alt="" class="club40-time-item-bottom-item-img-coaches">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="club40-time-item" data-name="Найти работу в своей стране">
                        <div class="club40-time-item-top">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475623488-GgpEV-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">В одиночку: 9–12 месяцев</p>
                            <div class="club40-time-item-top-items careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Долго и безуспешно ищете работу</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Ваше резюме не читают или игнорируют</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Нервничаете на интервью и не знаете, как себя вести</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не знаете, какую зарплату запросить — адекватно</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Боитесь откликаться на «крутые» вакансии</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Получаете отказы на разных этапах и не понимаете, почему</p>
                                </div>
                            </div>
                        </div>
                        <div class="club40-time-item-bottom">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475959505-4Gr3I-Vect.svg"
                                alt="">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475623753-JoaXH-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">С Careerum: 3–6 месяцев</p>
                            <div class="club40-time-item-bottom-items careerum-flex-fsst">
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">1 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Создадите стратегию поиска</p>
                                    </div>
                                    <ul>
                                        <li>Определите цель поиска</li>
                                        <li>Составите стратегию и воронку поиска</li>
                                        <li>Подготовите продающее резюме</li>
                                        <li>Отправите первые отклики</li>
                                        <li>Напишете сильные сопроводительные письма</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">2-3 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Выйдете на первые интервью</p>
                                    </div>
                                    <ul>
                                        <li>Проработаете LinkedIn-профиль</li>
                                        <li>Адаптируете резюме и письма под вакансии</li>
                                        <li>Подготовитесь к собеседованиям</li>
                                        <li>Получите первые приглашения на интервью</li>
                                        <li>Скорректируете стратегию поиска с экспертом</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">4–6 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Начнете получать офферы</p>
                                    </div>
                                    <ul>
                                        <li>Начнете легко проходить интервью</li>
                                        <li>Научитесь вести переговоры об условиях работы</li>
                                        <li>Начнете получать первые офферы</li>
                                        <li>Будете выбирать офферы под свою цель и стратегию</li>
                                        <li>Построите нетворк и начнете получать больше приглашений</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">6+ месяцев</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Освоитесь на новой работе</p>
                                    </div>
                                    <ul>
                                        <li>Поймете, как пройти испытательный срок</li>
                                        <li>Сформируете план развития на новом месте</li>
                                        <li>Узнаете, как вырасти в зарплате и должности</li>
                                        <li>Разовьете софтскилы для роста</li>
                                        <li>Адаптируетесь в новой команде</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item-photo-wide">
                                    <p class="club40-time-item-bottom-item-text">Найти новую работу можно в 2 раза быстрее,
                                        когда рядом сертифицированные карьерные коучи и эксперты<br> с международным опытом
                                    </p>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723477015660-EqFgL-Grou.svg"
                                        alt="" class="club40-time-item-bottom-item-img-hover3">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476976190-qRyft-ÑÐº.png"
                                        alt="" class="club40-time-item-bottom-item-img-coaches">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="club40-time-item" data-name="Найти работу в другой стране">
                        <div class="club40-time-item-top">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475623488-GgpEV-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">В одиночку: от 12 месяцев</p>
                            <div class="club40-time-item-top-items careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не знаете, какую странувыбрать</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не знакомы с форматом иностранных интервью</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Опасаетесь, что ваш доходстанет меньше</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не понимаете, какие вакансии вам подойдут</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Боитесь конкуренции с местными кандидатами</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Получаете отказы и не понимаете, почему</p>
                                </div>
                            </div>
                        </div>
                        <div class="club40-time-item-bottom">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475959505-4Gr3I-Vect.svg"
                                alt="">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475623753-JoaXH-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">С Careerum: 3–6 месяцев</p>
                            <div class="club40-time-item-bottom-items careerum-flex-fsst">
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">1–2 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Подготовитесь к поиску</p>
                                    </div>
                                    <ul>
                                        <li>Поймете, как устроен процесс найма за рубежом</li>
                                        <li>Определите географию, цель и стратегию поиска</li>
                                        <li>Составите резюме для выбранной страны</li>
                                        <li>Проработаете LinkedIn-профиль и сопроводительное письмо</li>
                                        <li>Начнете отправлять первые отклики</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">3-5 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Выйдете на первые интервью</p>
                                    </div>
                                    <ul>
                                        <li>Научитесь проходить интервью на другом языке</li>
                                        <li>Поймете, как строить нетворк в нужной стране</li>
                                        <li>Сможете вести переговоры о зарплате и условиях</li>
                                        <li>Начнете получать первые приглашения на интервью</li>
                                        <li>Скорректируете стратегию поиска с экспертом</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">6–9 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Начнете получать офферы</p>
                                    </div>
                                    <ul>
                                        <li>Начнете проходить собеседования без стресса</li>
                                        <li>Научитесь легко общаться с иностранными рекрутерами</li>
                                        <li>Получите первые офферы и выберете из них подходящие именно под вашу цель</li>
                                        <li>Разовьете нетворк и начнете получать больше приглашений</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">9+ месяцев</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Освоитесь на новой работе</p>
                                    </div>
                                    <ul>
                                        <li>Узнаете, как успешно пройти испытательный срок</li>
                                        <li>Сформулируете план развития на новом месте</li>
                                        <li>Поймете, как вырасти в зарплате и должности</li>
                                        <li>Разовьете софтскилс для роста</li>
                                        <li>Адаптируетесь к иностранной команде</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item-photo-wide">
                                    <p class="club40-time-item-bottom-item-text">Получить оффер за границе можно быстрее и
                                        без стресса,<br> когда рядом сертифицированные карьерные эксперты<br> с
                                        международным опытом
                                    </p>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723477015660-EqFgL-Grou.svg"
                                        alt="" class="club40-time-item-bottom-item-img-hover4">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476976190-qRyft-ÑÐº.png"
                                        alt="" class="club40-time-item-bottom-item-img-coaches">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="club40-time-item" data-name="Вырасти в зарплате и должности">
                        <div class="club40-time-item-top">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475623488-GgpEV-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">В одиночку: до-о-о-о-олго</p>
                            <div class="club40-time-item-top-items careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не знаете, как вырасти в зарплате и должности</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не понимаете, как аргументировать повышение</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не знаете, сколько должен получать специалист как вы</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Ждете, что вас повысят, но этого не происходит</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не представляете, как может развиваться ваша карьера</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не понимаете, зачем демонстрировать результаты</p>
                                </div>
                            </div>
                        </div>
                        <div class="club40-time-item-bottom">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475959505-4Gr3I-Vect.svg"
                                alt="">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475623753-JoaXH-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">С Careerum: от 3 месяцев</p>
                            <div class="club40-time-item-bottom-items careerum-flex-fsst">
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">1 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Подготовите базу для роста</p>
                                    </div>
                                    <ul>
                                        <li>Определите, что мешает вам расти в карьере
                                        <li>Определите с руководителем цели, чтобы развиваться в профессии</li>
                                        <li>Составите стратегию роста с учетом ваших суперсил и задач бизнеса</li>
                                        <li>Поймете: сколько стоят ваши навыки на рынке</li>
                                        <li>Укрепите профессиональную самооценку</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">2 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Вырастите в доходе / должности</p>
                                    </div>
                                    <ul>
                                        <li>Научитесь строить коммуникации и брать стратегически важные проекты</li>
                                        <li>Поймете, как запрашивать и принимать фидбек</li>
                                        <li>Сможете заявлять о себе и демонстрировать результаты</li>
                                        <li>Научитесь вести переговоры о повышении в свою пользу</li>
                                        <li>Получите повышение в зарплате / должности</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">3 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Поставите новые рекорды</p>
                                    </div>
                                    <ul>
                                        <li>Определите дополнительные способы роста</li>
                                        <li>Составите стратегию дальнейшего повышения</li>
                                        <li>Наладите work-life balance</li>
                                        <li>Сможете работать без выгорания</li>
                                        <li>Разовьете софтскил, необходимые для роста</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item-photo careerum-flex-fsfs">
                                    <p class="club40-time-item-bottom-item-text">Расти в карьере можно регулярно, <br>если
                                        рядом сертифицированные карьерные коучи и эксперты с международным опытом</p>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476749956-7beZF-Unio.svg"
                                        alt="" class="club40-time-item-bottom-item-img-hover2">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476607650-AQUXg-ÑÐº.png"
                                        alt="" class="club40-time-item-bottom-item-img-coaches">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-time-mobile', {
        label: 'Club 4 time (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-time-mobile">
            <div class="careerum-container-mobile">
                <h2 class="careerum-club40-header-mobile">Сколько времени потребуется, чтобы</h2>
                <div class="club40-time-nav">
                    <ul class="club40-time-nav-wrapper careerum-flex-fsfs">
                    </ul>
                </div>
                <div class="club40-time-items">
                    <div class="club40-time-item active" data-name="Понять, чего хочется от карьеры">
                        <div class="club40-time-item-top">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723547678415-BM0qX-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">В одиночку:<br> иногда — всю жизнь</p>
                            <div class="club40-time-item-top-items careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Строите карьеру «как получится» и без плана</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Работа перестала радовать<br> и превратилась в рутину</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не понимаете свои сильные стороны, сомневаетесь в себе</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не знаете, что делать дальше: с карьерой и жизнью</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Чувствуете, что в работе нужно что-то менять, но не знаете, что</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Ощущаете себя на чужом месте</p>
                                </div>
                            </div>
                        </div>
                        <div class="club40-time-item-bottom">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723547709640-SXy9e-Vect.svg"
                                alt="">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723547678785-eQSTq-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">С Careerum:<br> от 4 месяцев</p>
                            <div class="club40-time-item-bottom-items">
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">1 – 2 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Определите свои «Хочу» и «Могу»</p>
                                    </div>
                                    <ul>
                                        <li>Поймете, что мешает вам достичь карьерных целей</li>
                                    </ul>
                                    <ul>
                                        <li>Выявите свои сильные стороны и таланты</li>
                                        <li>Определите свои ключевые ценности</li>
                                        <li>Поймете, что в работе радует, а что демотивирует</li>
                                        <li>Сформулируете свои профессиональные интересы</li>
                                    </ul>
                                    <div class="club40-time-item-bottom-item-switcher careerum-flex-fsc">
                                        <p>Показать больше</p>
                                        <p>Свернуть</p>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                                stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                            <path d="M15.375 10.875L12 14.625L8.625 10.875" stroke="black"
                                                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">3 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Поймете свои «Надо»</p>
                                    </div>
                                    <ul>
                                        <li>Соотнесете свои таланты с запросами рынка</li>
                                    </ul>
                                    <ul>
    
                                        <li>Подружите свои ценности с бизнес-задачами</li>
                                        <li>Научитесь выбирать работу осознанно, а не брать, «что дают»</li>
                                        <li>Поставите долгосрочную карьерную цель с опорой на свои ценности</li>
                                        <li>Определите пути развития под свою долгосрочную цель</li>
                                    </ul>
                                    <div class="club40-time-item-bottom-item-switcher careerum-flex-fsc">
                                        <p>Показать больше</p>
                                        <p>Свернуть</p>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                                stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                            <path d="M15.375 10.875L12 14.625L8.625 10.875" stroke="black"
                                                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">4+ месяцa</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>В зависимости от целей:</p>
                                    </div>
                                    <ul>
                                        <li>Начнете осознанный поиск работы</li>
                                    </ul>
                                    <ul>
    
                                        <li>Составите план развития на текущем месте</li>
                                        <li>Наладите work-life balance</li>
                                        <li>Научитесь работать без выгорания</li>
                                        <li>Укрепите профессиональную самооценку</li>
                                    </ul>
                                    <div class="club40-time-item-bottom-item-switcher careerum-flex-fsc">
                                        <p>Показать больше</p>
                                        <p>Свернуть</p>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                                stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                            <path d="M15.375 10.875L12 14.625L8.625 10.875" stroke="black"
                                                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="club40-time-item-bottom-item-photo careerum-flex-fsfs">
                                    <p class="club40-time-item-bottom-item-text">Распутать карьерный клубок<br> не сложно,
                                        если
                                        рядом карьерные коучи и эксперты</p>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723550900705-RSDHW-ÑÐº.png"
                                        alt="" class="club40-time-item-bottom-item-img-coaches">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="club40-time-item" data-name="Найти работу в своей стране">
                        <div class="club40-time-item-top">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723547678415-BM0qX-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">В одиночку:<br> 9–12 месяцев</p>
                            <div class="club40-time-item-top-items careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Долго и безуспешно ищете работу</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Ваше резюме не читают или игнорируют</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Нервничаете на интервью и не знаете, как себя вести</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не знаете, какую зарплату запросить — адекватно</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Боитесь откликаться на «крутые» вакансии</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Получаете отказы на разных этапах и не понимаете, почему</p>
                                </div>
                            </div>
                        </div>
                        <div class="club40-time-item-bottom">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723547709640-SXy9e-Vect.svg"
                                alt="">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723547678785-eQSTq-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">С Careerum:<br> 3–6 месяцев</p>
                            <div class="club40-time-item-bottom-items">
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">1 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Создадите стратегию поиска</p>
                                    </div>
                                    <ul>
                                        <li>Определите цель поиска</li>
                                    </ul>
                                    <ul>
    
                                        <li>Составите стратегию и воронку поиска</li>
                                        <li>Подготовите продающее резюме</li>
                                        <li>Отправите первые отклики</li>
                                        <li>Напишете сильные сопроводительные письма</li>
                                    </ul>
                                    <div class="club40-time-item-bottom-item-switcher careerum-flex-fsc">
                                        <p>Показать больше</p>
                                        <p>Свернуть</p>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                                stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                            <path d="M15.375 10.875L12 14.625L8.625 10.875" stroke="black"
                                                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">2-3 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Выйдете на первые интервью</p>
                                    </div>
                                    <ul>
                                        <li>Проработаете LinkedIn-профиль</li>
                                    </ul>
                                    <ul>
    
                                        <li>Адаптируете резюме и письма под вакансии</li>
                                        <li>Подготовитесь к собеседованиям</li>
                                        <li>Получите первые приглашения на интервью</li>
                                        <li>Скорректируете стратегию поиска с экспертом</li>
                                    </ul>
                                    <div class="club40-time-item-bottom-item-switcher careerum-flex-fsc">
                                        <p>Показать больше</p>
                                        <p>Свернуть</p>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                                stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                            <path d="M15.375 10.875L12 14.625L8.625 10.875" stroke="black"
                                                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">4–6 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Начнете получать офферы</p>
                                    </div>
                                    <ul>
                                        <li>Начнете легко проходить интервью</li>
                                    </ul>
                                    <ul>
    
                                        <li>Научитесь вести переговоры об условиях работы</li>
                                        <li>Начнете получать первые офферы</li>
                                        <li>Будете выбирать офферы под свою цель и стратегию</li>
                                        <li>Построите нетворк и начнете получать больше приглашений</li>
                                    </ul>
                                    <div class="club40-time-item-bottom-item-switcher careerum-flex-fsc">
                                        <p>Показать больше</p>
                                        <p>Свернуть</p>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                                stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                            <path d="M15.375 10.875L12 14.625L8.625 10.875" stroke="black"
                                                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">6+ месяцев</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Освоитесь на новой работе</p>
                                    </div>
                                    <ul>
                                        <li>Поймете, как пройти испытательный срок</li>
                                    </ul>
                                    <ul>
    
                                        <li>Сформируете план развития на новом месте</li>
                                        <li>Узнаете, как вырасти в зарплате и должности</li>
                                        <li>Разовьете софтскилы для роста</li>
                                        <li>Адаптируетесь в новой команде</li>
                                    </ul>
                                    <div class="club40-time-item-bottom-item-switcher careerum-flex-fsc">
                                        <p>Показать больше</p>
                                        <p>Свернуть</p>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                                stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                            <path d="M15.375 10.875L12 14.625L8.625 10.875" stroke="black"
                                                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="club40-time-item-bottom-item-photo-wide">
                                    <p class="club40-time-item-bottom-item-text">Найти новую работу можно в 2 раза быстрее,
                                        когда рядом карьерные коучи и эксперты с международным опытом</p>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723550900705-RSDHW-ÑÐº.png"
                                        alt="" class="club40-time-item-bottom-item-img-coaches">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="club40-time-item" data-name="Найти работу в другой стране">
                        <div class="club40-time-item-top">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723547678415-BM0qX-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">В одиночку:<br> от 12 месяцев</p>
                            <div class="club40-time-item-top-items careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не знаете, какую странувыбрать</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не знакомы с форматом иностранных интервью</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Опасаетесь, что ваш доходстанет меньше</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не понимаете, какие вакансии вам подойдут</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Боитесь конкуренции с местными кандидатами</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Получаете отказы и не понимаете, почему</p>
                                </div>
                            </div>
                        </div>
                        <div class="club40-time-item-bottom">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723547709640-SXy9e-Vect.svg"
                                alt="">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723547678785-eQSTq-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">С Careerum:<br> 3–6 месяцев</p>
                            <div class="club40-time-item-bottom-items">
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">1–2 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Подготовитесь к поиску</p>
                                    </div>
                                    <ul>
                                        <li>Поймете, как устроен процесс найма за рубежом</li>
                                    </ul>
                                    <ul>
    
                                        <li>Определите географию, цель и стратегию поиска</li>
                                        <li>Составите резюме для выбранной страны</li>
                                        <li>Проработаете LinkedIn-профиль и сопроводительное письмо</li>
                                        <li>Начнете отправлять первые отклики</li>
                                    </ul>
                                    <div class="club40-time-item-bottom-item-switcher careerum-flex-fsc">
                                        <p>Показать больше</p>
                                        <p>Свернуть</p>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                                stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                            <path d="M15.375 10.875L12 14.625L8.625 10.875" stroke="black"
                                                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">3-5 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Выйдете на первые интервью</p>
                                    </div>
                                    <ul>
                                        <li>Научитесь проходить интервью на другом языке</li>
                                    </ul>
                                    <ul>
    
                                        <li>Поймете, как строить нетворк в нужной стране</li>
                                        <li>Сможете вести переговоры о зарплате и условиях</li>
                                        <li>Начнете получать первые приглашения на интервью</li>
                                        <li>Скорректируете стратегию поиска с экспертом</li>
                                    </ul>
                                    <div class="club40-time-item-bottom-item-switcher careerum-flex-fsc">
                                        <p>Показать больше</p>
                                        <p>Свернуть</p>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                                stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                            <path d="M15.375 10.875L12 14.625L8.625 10.875" stroke="black"
                                                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">6–9 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Начнете получать офферы</p>
                                    </div>
                                    <ul>
                                        <li>Начнете проходить собеседования без стресса</li>
                                    </ul>
                                    <ul>
    
                                        <li>Научитесь легко общаться с иностранными рекрутерами</li>
                                        <li>Получите первые офферы и выберете из них подходящие именно под вашу цель</li>
                                        <li>Разовьете нетворк и начнете получать больше приглашений</li>
                                    </ul>
                                    <div class="club40-time-item-bottom-item-switcher careerum-flex-fsc">
                                        <p>Показать больше</p>
                                        <p>Свернуть</p>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                                stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                            <path d="M15.375 10.875L12 14.625L8.625 10.875" stroke="black"
                                                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">9+ месяцев</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Освоитесь на новой работе</p>
                                    </div>
                                    <ul>
                                        <li>Узнаете, как успешно пройти испытательный срок</li>
                                    </ul>
                                    <ul>
    
                                        <li>Сформулируете план развития на новом месте</li>
                                        <li>Поймете, как вырасти в зарплате и должности</li>
                                        <li>Разовьете софтскилс для роста</li>
                                        <li>Адаптируетесь к иностранной команде</li>
                                    </ul>
                                    <div class="club40-time-item-bottom-item-switcher careerum-flex-fsc">
                                        <p>Показать больше</p>
                                        <p>Свернуть</p>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                                stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                            <path d="M15.375 10.875L12 14.625L8.625 10.875" stroke="black"
                                                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="club40-time-item-bottom-item-photo-wide">
                                    <p class="club40-time-item-bottom-item-text">Получить оффер за границе можно быстрее и
                                        без стресса, когда рядом сертифицированные карьерные эксперты с международным опытом
                                    </p>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723550900705-RSDHW-ÑÐº.png"
                                        alt="" class="club40-time-item-bottom-item-img-coaches">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="club40-time-item" data-name="Вырасти в зарплате и должности">
                        <div class="club40-time-item-top">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723547678415-BM0qX-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">В одиночку:<br> до-о-о-о-олго</p>
                            <div class="club40-time-item-top-items careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не знаете, как вырасти в зарплате и должности</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не понимаете, как аргументировать повышение</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не знаете, сколько должен получать специалист как вы</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Ждете, что вас повысят, но этого не происходит</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не представляете, как может развиваться ваша карьера</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не понимаете, зачем демонстрировать результаты</p>
                                </div>
                            </div>
                        </div>
                        <div class="club40-time-item-bottom">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723547709640-SXy9e-Vect.svg"
                                alt="">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723547678785-eQSTq-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">С Careerum:<br> от 3 месяцев</p>
                            <div class="club40-time-item-bottom-items">
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">1 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Подготовите базу для роста</p>
                                    </div>
                                    <ul>
                                        <li>Определите, что мешает вам расти в карьере</li>
                                    </ul>
                                    <ul>
                                        <li>Определите с руководителем цели, чтобы развиваться в профессии</li>
                                        <li>Составите стратегию роста с учетом ваших суперсил и задач бизнеса</li>
                                        <li>Поймете: сколько стоят ваши навыки на рынке</li>
                                        <li>Укрепите профессиональную самооценку</li>
                                    </ul>
                                    <div class="club40-time-item-bottom-item-switcher careerum-flex-fsc">
                                        <p>Показать больше</p>
                                        <p>Свернуть</p>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                                stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                            <path d="M15.375 10.875L12 14.625L8.625 10.875" stroke="black"
                                                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">2 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Вырастите в доходе / должности</p>
                                    </div>
                                    <ul>
                                        <li>Научитесь строить коммуникации и брать стратегически важные проекты</li>
                                    </ul>
                                    <ul>
    
                                        <li>Поймете, как запрашивать и принимать фидбек</li>
                                        <li>Сможете заявлять о себе и демонстрировать результаты</li>
                                        <li>Научитесь вести переговоры о повышении в свою пользу</li>
                                        <li>Получите повышение в зарплате / должности</li>
                                    </ul>
                                    <div class="club40-time-item-bottom-item-switcher careerum-flex-fsc">
                                        <p>Показать больше</p>
                                        <p>Свернуть</p>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                                stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                            <path d="M15.375 10.875L12 14.625L8.625 10.875" stroke="black"
                                                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">3 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Поставите новые рекорды</p>
                                    </div>
                                    <ul>
                                        <li>Определите дополнительные способы роста</li>
                                    </ul>
                                    <ul>
    
                                        <li>Составите стратегию дальнейшего повышения</li>
                                        <li>Наладите work-life balance</li>
                                        <li>Сможете работать без выгорания</li>
                                        <li>Разовьете софтскил, необходимые для роста</li>
                                    </ul>
                                    <div class="club40-time-item-bottom-item-switcher careerum-flex-fsc">
                                        <p>Показать больше</p>
                                        <p>Свернуть</p>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                                stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                            <path d="M15.375 10.875L12 14.625L8.625 10.875" stroke="black"
                                                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="club40-time-item-bottom-item-photo careerum-flex-fsfs">
                                    <p class="club40-time-item-bottom-item-text">Расти в карьере можно регулярно, если рядом
                                        сертифицированные карьерные коучи и эксперты с международным опытом</p>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723550900705-RSDHW-ÑÐº.png"
                                        alt="" class="club40-time-item-bottom-item-img-coaches">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-tariffs', {
        label: 'Club 4 tariffs',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-tariffs">
            <div class="careerum-container-desc">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723278008892-Gajaw-Rect.png" alt="">
                <h2 class="careerum-club40-header">Оформите подписку Careerum </h2>
                <div class="club40-tariffs-nav careerum-flex-sbfs">
                    <div class="club40-tariffs-period">
                        <ul class="careerum-flex-fsfs">
                            <li data-period="12" class="active">12 месяцев</li>
                            <li data-period="6">6 месяцев</li>
                            <li data-period="3">3 месяца</li>
                            <li data-period="1">1 месяц</li>
                        </ul>
                    </div>
                    <div class="club40-tariffs-curr careerum-flex-fsst">
                        <ul class="careerum-flex-fsfs">
                            <li data-currency="eur" class="active">EUR</li>
                            <li data-currency="rub">RUB</li>
                        </ul>
                        <div class="club40-tariffs-notif careerum-flex-cc">
                            <div class="club40-tariffs-notif-icon">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                    alt="">
                            </div>
                            <div class="club40-tariffs-notif-content">
                                <p>Оплата в российских рублях возможна только картой российского банка. В евро — картой
                                    зарубежного банка</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="club40-tariffs-items careerum-flex-fsst">
                    <div class="club40-tariffs-item careerum-flex-fsfs" data-price-1m-rub="12 900 ₽"
                        data-price-3m-rub="9 967 ₽" data-fullprice-3m-rub="29 900 ₽" data-price-6m-rub="6 900 ₽"
                        data-fullprice-6m-rub="47 400 ₽" data-price-12m-rub="5 900 ₽" data-fullprice-12m-rub="77 880 ₽"
                        data-price-1m-eur="149 €" data-price-3m-eur="120 €" data-fullprice-3m-eur="360 €"
                        data-price-6m-eur="90 €" data-fullprice-6m-eur="540 €" data-price-12m-eur="80 €"
                        data-fullprice-12m-eur="960 €" data-offer-1m-rub="#1mr1" data-offer-3m-rub="#3mr1"
                        data-offer-6m-rub="#6mr1" data-offer-12m-rub="#12mr1" data-offer-1m-eur="#1me1"
                        data-offer-3m-eur="#3me1" data-offer-6m-eur="#6me1" data-offer-12m-eur="#12me1">
                        <p class="club40-tariffs-item-subheader">Тариф</p>
                        <p class="club40-tariffs-item-header">Самостоятельный</p>
                        <p class="club40-tariffs-item-description">Если есть время, чтобы самому проработать свой карьерный
                            запрос<br> с помощью наших программ</p>
                        <div class="club40-tariffs-item-divider"></div>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723135867345-NpjXQ-Play.svg"
                                    alt="">
                                <p>18 онлайн-программ,<br> закрывающих любой карьерный запрос</p>
                            </li>
                        </ul>
                        <div class="club40-tariffs-item-bottom">
                            <div class="careerum-flex-fsfs club40-tariffs-item-wrapper-price">
                                <div>
                                    <p class="club40-tariffs-item-price-pm">8 000 ₽</p>
                                    <p class="club40-tariffs-item-price-pmn1m">цена месяца в пакете</p>
                                    <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                </div>
                                <div>
                                    <p>/</p>
                                </div>
                                <div>
                                    <p class="club40-tariffs-item-price-f">96 000 ₽</p>
                                    <p>полная стоимость к оплате</p>
                                </div>
                            </div>
                            <a href="#thanks-no" class="btn-color-main-dark-orange">Выбрать тариф</a>
                            <p class="club40-tariffs-item-price-rassr-eur">Можно платить долями</p>
                            <p class="club40-tariffs-item-price-rassr-rub">Можно в рассрочку</p>
                        </div>
                    </div>
                    <div class="club40-tariffs-item careerum-flex-fsfs" data-price-1m-rub="14 900 ₽"
                        data-price-3m-rub="11 633 ₽" data-fullprice-3m-rub="34 900 ₽" data-price-6m-rub="9 817 ₽"
                        data-fullprice-6m-rub="58 900 ₽" data-price-12m-rub="8 000 ₽" data-fullprice-12m-rub="96 000 ₽"
                        data-price-1m-eur="199 €" data-price-3m-eur="170 €" data-fullprice-3m-eur="510 €"
                        data-price-6m-eur="130 €" data-fullprice-6m-eur="780 €" data-price-12m-eur="100 €"
                        data-fullprice-12m-eur="1 200 €" data-offer-1m-rub="#1mr" data-offer-3m-rub="#3mr"
                        data-offer-6m-rub="#6mr" data-offer-12m-rub="#12mr" data-offer-1m-eur="#1me"
                        data-offer-3m-eur="#3me" data-offer-6m-eur="#6me" data-offer-12m-eur="#12me">
                        <p class="club40-tariffs-item-label">Осталось: 25 мест</p>
                        <p class="club40-tariffs-item-subheader">Тариф</p>
                        <p class="club40-tariffs-item-header">С поддержкой</p>
                        <p class="club40-tariffs-item-description">Если важна обратная связь<br> от  экспертов и куратора.
                            Получите ее<br> в групповых чатах и на Q&A-эфирах</p>
                        <div class="club40-tariffs-item-divider"></div>
                        <p class="club40-tariffs-item-subheader">В тариф входят все опции тарифа «Самостоятельный», плюс:
                        </p>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                    alt="">
                                <p>Доступ к сообществу</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                    alt="">
                                <p>Доступ ко всем онлайн-ивентам и интенсивам</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                    alt="">
                                <p>2 Q&A-эфира в месяц с разбором ваших карьерных вопросов</p>
                            </li>
                        </ul>
                        <div class="club40-tariffs-item-bottom">
                            <div class="careerum-flex-fsfs club40-tariffs-item-wrapper-price">
                                <div>
                                    <p class="club40-tariffs-item-price-pm">8 000 ₽</p>
                                    <p class="club40-tariffs-item-price-pmn1m">цена месяца в пакете</p>
                                    <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                </div>
                                <div>
                                    <p>/</p>
                                </div>
                                <div>
                                    <p class="club40-tariffs-item-price-f">96 000 ₽</p>
                                    <p>полная стоимость к оплате</p>
                                </div>
                            </div>
                            <a href="#thanks-yes" class="btn-color-main-dark-orange">Выбрать тариф</a>
                            <p class="club40-tariffs-item-price-rassr-eur">Можно платить долями</p>
                            <p class="club40-tariffs-item-price-rassr-rub">Можно в рассрочку</p>
                        </div>
                    </div>
                    <div class="club40-tariffs-item careerum-flex-fsfs" data-price-1m-rub="27 900 ₽"
                        data-price-3m-rub="23 900 ₽" data-fullprice-3m-rub="71 700 ₽" data-price-6m-rub="18 317 ₽"
                        data-fullprice-6m-rub="109 900 ₽" data-price-12m-rub="16 583 ₽" data-fullprice-12m-rub="199 000 ₽"
                        data-price-1m-eur="360 €" data-price-3m-eur="310 €" data-fullprice-3m-eur="930 €"
                        data-price-6m-eur="250 €" data-fullprice-6m-eur="1 500 €" data-price-12m-eur="230 €"
                        data-fullprice-12m-eur="2 760 €" data-offer-1m-rub="#1mr" data-offer-3m-rub="#3mr"
                        data-offer-6m-rub="#6mr" data-offer-12m-rub="#12mr" data-offer-1m-eur="#1me"
                        data-offer-3m-eur="#3me" data-offer-6m-eur="#6me" data-offer-12m-eur="#12me">
                        <p class="club40-tariffs-item-label">Осталось: 25 мест</p>
                        <p class="club40-tariffs-item-subheader">Тариф</p>
                        <p class="club40-tariffs-item-header">Индивидуальный подход</p>
                        <p class="club40-tariffs-item-description">Когда надо прийти к цели быстро.<br> У вас будет
                            персональная поддержка наших карьерных экспертов</p>
                        <div class="club40-tariffs-item-divider"></div>
                        <p class="club40-tariffs-item-subheader">В тариф входят все преимущества тарифа «С поддержкой»,
                            плюс:</p>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                    alt="">
                                <p>Персональная поддержка карьерного эксперта<br> и карьерного коуча в чате</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                    alt="">
                                <p>2 видеоконсультации<br> в месяц с коучем или экспертом</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                    alt="">
                                <p>Персональный разбор вашего резюме и LinkedIn-профиля</p>
                            </li>
                        </ul>
                        <div class="club40-tariffs-item-bottom">
                            <div class="careerum-flex-fsfs club40-tariffs-item-wrapper-price">
                                <div>
                                    <p class="club40-tariffs-item-price-pm">8 000 ₽</p>
                                    <p class="club40-tariffs-item-price-pmn1m">цена месяца в пакете</p>
                                    <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                </div>
                                <div>
                                    <p>/</p>
                                </div>
                                <div>
                                    <p class="club40-tariffs-item-price-f">96 000 ₽</p>
                                    <p>полная стоимость к оплате</p>
                                </div>
                            </div>
                            <a href="#thanks" class="btn-color-main-dark-orange">Выбрать тариф</a>
                            <p class="club40-tariffs-item-price-rassr-eur">Можно платить долями</p>
                            <p class="club40-tariffs-item-price-rassr-rub">Можно в рассрочку</p>
                        </div>
                    </div>
                </div>
                <div class="club40-tariffs-bottom careerum-flex-sbfs">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723278649360-d3raW-Vect.svg"
                            alt="">
                        <p class="club40-tariffs-bottom-header">Не знаете, с чего начать?</p>
                        <p class="club40-tariffs-bottom-subheader">Напишите нам — мы ответим на все вопросы<br> и поможем
                            выбрать лучшее решение под вашу задачу</p>
                        <a href="#tg" class="btn-color-main-dark-orange careerum-flex-cc">
                            <svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M6.9104 12.5754L9.51374 19.781C9.51374 19.781 9.83922 20.4552 10.1877 20.4552C10.5363 20.4552 15.7201 15.0624 15.7201 15.0624L21.4847 3.92822L7.00329 10.7153L6.9104 12.5754Z"
                                    fill="#C8DAEA" />
                                <path
                                    d="M10.3623 14.4233L9.86251 19.7346C9.86251 19.7346 9.65332 21.362 11.2804 19.7346C12.9074 18.1072 14.4648 16.8522 14.4648 16.8522"
                                    fill="#A9C6D8" />
                                <path
                                    d="M6.9574 12.8324L1.60225 11.0876C1.60225 11.0876 0.962247 10.828 1.16833 10.2392C1.21075 10.1177 1.29633 10.0144 1.55233 9.83687C2.73889 9.00981 23.5146 1.54247 23.5146 1.54247C23.5146 1.54247 24.1012 1.3448 24.4471 1.47628C24.5327 1.50277 24.6097 1.55152 24.6703 1.61755C24.7309 1.68357 24.7728 1.7645 24.7918 1.85205C24.8292 2.00668 24.8448 2.16578 24.8383 2.32473C24.8366 2.46224 24.82 2.58969 24.8074 2.78956C24.6808 4.83116 20.8942 20.0683 20.8942 20.0683C20.8942 20.0683 20.6677 20.9599 19.856 20.9904C19.6565 20.9969 19.4578 20.9631 19.2716 20.8911C19.0855 20.8191 18.9157 20.7103 18.7725 20.5713C17.1797 19.2012 11.6742 15.5012 10.4577 14.6875C10.4302 14.6688 10.4071 14.6445 10.3899 14.6161C10.3727 14.5877 10.3617 14.5559 10.3578 14.523C10.3408 14.4372 10.4341 14.3309 10.4341 14.3309C10.4341 14.3309 20.0205 5.80981 20.2756 4.91527C20.2954 4.84597 20.2208 4.81177 20.1206 4.84213C19.4838 5.07637 8.44622 12.0467 7.22803 12.816C7.14034 12.8425 7.04766 12.8481 6.9574 12.8324Z"
                                    fill="white" />
                            </svg>
                            <p>Написать нам в Telegram</p>
                        </a>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723278685081-7nUnx-ÑÐ¾.svg"
                            alt="">
                        <div class="careerum-flex-fsfs club40-tariffs-bottom-care">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723278768285-Yeat8-phot.png"
                                    alt="">
                            </div>
                            <div>
                                <p class="club40-tariffs-bottom-care-name">Анна </p>
                                <p class="club40-tariffs-bottom-care-position">Команда заботы Careerum</p>
                                <p class="club40-tariffs-bottom-care-descr">Добрый день! Построить карьеру мечты в одиночку
                                    бывает непросто. Но мы рядом и приведем вас к заветной цели 💙</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-tariffs-tablet', {
        label: 'Club 4 tariffs (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-tariffs-tablet">
            <div class="careerum-container-tablet">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723485008387-JfPF7-Rect.png" alt="">
                <h2 class="careerum-club40-header-tablet">Оформите подписку Careerum </h2>
                <div class="club40-tariffs-nav careerum-flex-sbfs">
                    <div class="club40-tariffs-period">
                        <ul class="careerum-flex-fsfs">
                            <li data-period="12" class="active">12 месяцев</li>
                            <li data-period="6">6 месяцев</li>
                            <li data-period="3">3 месяца</li>
                            <li data-period="1">1 месяц</li>
                        </ul>
                    </div>
                </div>
                <div class="club40-tariffs-items">
                    <div class="careerum-flex-fsst">
                        <div class="club40-tariffs-item careerum-flex-fsfs" data-price-1m-rub="27 900 ₽"
                            data-price-3m-rub="23 900 ₽" data-fullprice-3m-rub="71 700 ₽" data-price-6m-rub="18 317 ₽"
                            data-fullprice-6m-rub="109 900 ₽" data-price-12m-rub="16 583 ₽"
                            data-fullprice-12m-rub="199 000 ₽" data-price-1m-eur="360 €" data-price-3m-eur="310 €"
                            data-fullprice-3m-eur="930 €" data-price-6m-eur="250 €" data-fullprice-6m-eur="1 500 €"
                            data-price-12m-eur="230 €" data-fullprice-12m-eur="2 760 €" data-offer-1m-rub="#1mr"
                            data-offer-3m-rub="#3mr" data-offer-6m-rub="#6mr" data-offer-12m-rub="#12mr"
                            data-offer-1m-eur="#1me" data-offer-3m-eur="#3me" data-offer-6m-eur="#6me"
                            data-offer-12m-eur="#12me">
                            <p class="club40-tariffs-item-label">Осталось: 25 мест</p>
                            <p class="club40-tariffs-item-subheader">Тариф</p>
                            <p class="club40-tariffs-item-header">Индивидуальный подход</p>
                            <p class="club40-tariffs-item-subheader">В тариф входят все преимущества тарифа «С поддержкой»,
                                плюс:</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723483406167-XJY0e-Fram.svg"
                                        alt="">
                                    <p>Персональная поддержка карьерного эксперта и карьерного коуча в чате</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723483406167-XJY0e-Fram.svg"
                                        alt="">
                                    <p>2 видеоконсультации<br> в месяц с коучем или экспертом</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723483406167-XJY0e-Fram.svg"
                                        alt="">
                                    <p>Персональный разбор вашего резюме и LinkedIn-профиля</p>
                                </li>
                            </ul>
                            <div class="club40-tariffs-item-bottom">
                                <div class="club40-tariffs-item-wrapper-price">
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-pm">8 000 ₽</p>
                                        <p class="club40-tariffs-item-price-pmn1m">цена месяца в пакете</p>
                                        <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                    </div>
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-f">96 000 ₽</p>
                                        <p>полная стоимость к оплате</p>
                                    </div>
                                </div>
                                <a href="#payform-single" class="btn-color-main-dark-orange">Выбрать тариф</a>
                                <p class="club40-tariffs-item-price-rassr-eur">Можно платить долями</p>
                                <p class="club40-tariffs-item-price-rassr-rub">Можно в рассрочку</p>
                            </div>
                        </div>
                        <div class="club40-tariffs-item careerum-flex-fsfs" data-price-1m-rub="14 900 ₽"
                            data-price-3m-rub="11 633 ₽" data-fullprice-3m-rub="34 900 ₽" data-price-6m-rub="9 817 ₽"
                            data-fullprice-6m-rub="58 900 ₽" data-price-12m-rub="8 000 ₽" data-fullprice-12m-rub="96 000 ₽"
                            data-price-1m-eur="199 €" data-price-3m-eur="170 €" data-fullprice-3m-eur="510 €"
                            data-price-6m-eur="130 €" data-fullprice-6m-eur="780 €" data-price-12m-eur="100 €"
                            data-fullprice-12m-eur="1 200 €" data-offer-1m-rub="#1mr" data-offer-3m-rub="#3mr"
                            data-offer-6m-rub="#6mr" data-offer-12m-rub="#12mr" data-offer-1m-eur="#1me"
                            data-offer-3m-eur="#3me" data-offer-6m-eur="#6me" data-offer-12m-eur="#12me">
                            <p class="club40-tariffs-item-label">Осталось: 25 мест</p>
                            <p class="club40-tariffs-item-subheader">Тариф</p>
                            <p class="club40-tariffs-item-header">С поддержкой</p>
                            <p class="club40-tariffs-item-subheader">В тариф входят все опции тарифа «Самостоятельный»,
                                плюс: </p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723483406167-XJY0e-Fram.svg"
                                        alt="">
                                    <p>Доступ к сообществу</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723483406167-XJY0e-Fram.svg"
                                        alt="">
                                    <p>Доступ ко всем онлайн-ивентам и интенсивам</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723483406167-XJY0e-Fram.svg"
                                        alt="">
                                    <p>2 Q&A-эфира в месяц с разбором ваших карьерных вопросов</p>
                                </li>
                            </ul>
                            <div class="club40-tariffs-item-bottom">
                                <div class="club40-tariffs-item-wrapper-price">
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-pm">8 000 ₽</p>
                                        <p class="club40-tariffs-item-price-pmn1m">цена месяца в пакете</p>
                                        <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                    </div>
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-f">96 000 ₽</p>
                                        <p>полная стоимость к оплате</p>
                                    </div>
                                </div>
                                <a href="#thanks-yes" class="btn-color-main-dark-orange">Выбрать тариф</a>
                                <p class="club40-tariffs-item-price-rassr-eur">Можно платить долями</p>
                                <p class="club40-tariffs-item-price-rassr-rub">Можно в рассрочку</p>
                            </div>
                        </div>
                        <div class="club40-tariffs-item careerum-flex-fsfs" data-price-1m-rub="12 900 ₽"
                            data-price-3m-rub="9 967 ₽" data-fullprice-3m-rub="29 900 ₽" data-price-6m-rub="6 900 ₽"
                            data-fullprice-6m-rub="47 400 ₽" data-price-12m-rub="5 900 ₽" data-fullprice-12m-rub="77 880 ₽"
                            data-price-1m-eur="149 €" data-price-3m-eur="120 €" data-fullprice-3m-eur="360 €"
                            data-price-6m-eur="90 €" data-fullprice-6m-eur="540 €" data-price-12m-eur="80 €"
                            data-fullprice-12m-eur="960 €" data-offer-1m-rub="#1mr1" data-offer-3m-rub="#3mr1"
                            data-offer-6m-rub="#6mr1" data-offer-12m-rub="#12mr1" data-offer-1m-eur="#1me1"
                            data-offer-3m-eur="#3me1" data-offer-6m-eur="#6me1" data-offer-12m-eur="#12me1">
                            <p class="club40-tariffs-item-subheader">Тариф</p>
                            <p class="club40-tariffs-item-header">Самостоятельный</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723552330061-yrrgy-Play.svg"
                                        alt="">
                                    <p>18 онлайн-программ,<br> закрывающих любой карьерный запрос</p>
                                </li>
                            </ul>
                            <div class="club40-tariffs-item-bottom">
                                <div class="club40-tariffs-item-wrapper-price">
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-pm">8 000 ₽</p>
                                        <p class="club40-tariffs-item-price-pmn1m">цена месяца в пакете</p>
                                        <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                    </div>
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-f">96 000 ₽</p>
                                        <p>полная стоимость к оплате</p>
                                    </div>
                                </div>
                                <a href="#thanks-no" class="btn-color-main-dark-orange">Выбрать тариф</a>
                                <p class="club40-tariffs-item-price-rassr-eur">Можно платить долями</p>
                                <p class="club40-tariffs-item-price-rassr-rub">Можно в рассрочку</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="club40-tariffs-curr">
                    <div class="club40-tariffs__swicher-block">
                        <div class="club40-tariffs__swicher-top">
                            <p class="club40-tariffs__swicher-header">Посмотреть цены в
                                <span>RUB</span>
                            </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" class="club40-tariffs__swicher-arrow">
                                <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black"></path>
                            </svg>
                        </div>
                        <div class="club40-tariffs__swicher-bottom">
                            <ul>
                                <li data-currency="rub">
                                    RUB
                                </li>
                                <li data-currency="eur" class="active">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских рублях
                                возможна только<br> с карты
                                российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
                <div class="club40-tariffs-bottom careerum-flex-sbfs">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723484897716-GBGcE-Vect.svg"
                            alt="">
                        <p class="club40-tariffs-bottom-header">Не знаете, с чего начать?</p>
                        <p class="club40-tariffs-bottom-subheader">Напишите нам — мы ответим на все вопросы и поможем
                            выбрать решение под вашу задачу</p>
                        <a href="#tg" class="btn-color-main-dark-orange careerum-flex-cc">
                            <svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M6.9104 12.5754L9.51374 19.781C9.51374 19.781 9.83922 20.4552 10.1877 20.4552C10.5363 20.4552 15.7201 15.0624 15.7201 15.0624L21.4847 3.92822L7.00329 10.7153L6.9104 12.5754Z"
                                    fill="#C8DAEA" />
                                <path
                                    d="M10.3623 14.4233L9.86251 19.7346C9.86251 19.7346 9.65332 21.362 11.2804 19.7346C12.9074 18.1072 14.4648 16.8522 14.4648 16.8522"
                                    fill="#A9C6D8" />
                                <path
                                    d="M6.9574 12.8324L1.60225 11.0876C1.60225 11.0876 0.962247 10.828 1.16833 10.2392C1.21075 10.1177 1.29633 10.0144 1.55233 9.83687C2.73889 9.00981 23.5146 1.54247 23.5146 1.54247C23.5146 1.54247 24.1012 1.3448 24.4471 1.47628C24.5327 1.50277 24.6097 1.55152 24.6703 1.61755C24.7309 1.68357 24.7728 1.7645 24.7918 1.85205C24.8292 2.00668 24.8448 2.16578 24.8383 2.32473C24.8366 2.46224 24.82 2.58969 24.8074 2.78956C24.6808 4.83116 20.8942 20.0683 20.8942 20.0683C20.8942 20.0683 20.6677 20.9599 19.856 20.9904C19.6565 20.9969 19.4578 20.9631 19.2716 20.8911C19.0855 20.8191 18.9157 20.7103 18.7725 20.5713C17.1797 19.2012 11.6742 15.5012 10.4577 14.6875C10.4302 14.6688 10.4071 14.6445 10.3899 14.6161C10.3727 14.5877 10.3617 14.5559 10.3578 14.523C10.3408 14.4372 10.4341 14.3309 10.4341 14.3309C10.4341 14.3309 20.0205 5.80981 20.2756 4.91527C20.2954 4.84597 20.2208 4.81177 20.1206 4.84213C19.4838 5.07637 8.44622 12.0467 7.22803 12.816C7.14034 12.8425 7.04766 12.8481 6.9574 12.8324Z"
                                    fill="white" />
                            </svg>
                            <p>Написать нам в Telegram</p>
                        </a>
                    </div>
                    <div>
                        <div class="club40-tariffs-bottom-care">
                            <div class="careerum-flex-fsc">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723278768285-Yeat8-phot.png"
                                        alt="">
                                </div>
                                <div>
                                    <p class="club40-tariffs-bottom-care-name">Анна </p>
                                    <p class="club40-tariffs-bottom-care-position">Команда заботы Careerum</p>
                                </div>
                            </div>
                            <p class="club40-tariffs-bottom-care-descr">Добрый день! Построить карьеру мечты в одиночку
                                бывает непросто. Но мы рядом и приведем вас к заветной цели 💙</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-tariffs-mobile', {
        label: 'Club 4 tariffs (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-tariffs-mobile">
            <div class="careerum-container-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723551361905-BYCit-Rect.png" alt="">
                <h2 class="careerum-club40-header-mobile">Оформите подписку<br> Careerum </h2>
                <div class="club40-tariffs-nav">
                    <div class="club40-tariffs-period">
                        <ul class="careerum-flex-fsfs">
                            <li data-period="12" class="active">Год</li>
                            <li data-period="6">Полгода</li>
                            <li data-period="3">3 месяца</li>
                            <li data-period="1">Месяц</li>
                        </ul>
                    </div>
                </div>
                <div class="club40-tariffs-curr">
                    <div class="club40-tariffs__swicher-block">
                        <div class="club40-tariffs__swicher-top">
                            <p class="club40-tariffs__swicher-header">Посмотреть цены в
                                <span>RUB</span>
                            </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" class="club40-tariffs__swicher-arrow">
                                <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black"></path>
                            </svg>
                        </div>
                        <div class="club40-tariffs__swicher-bottom">
                            <ul>
                                <li data-currency="rub">
                                    RUB
                                </li>
                                <li data-currency="eur" class="active">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских рублях
                                возможна только<br> с карты
                                российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
                <div class="club40-tariffs-items">
                    <div class="club40-tariffs-item careerum-flex-fsfs" data-price-1m-rub="12 900 ₽"
                        data-price-3m-rub="9 967 ₽" data-fullprice-3m-rub="29 900 ₽" data-price-6m-rub="6 900 ₽"
                        data-fullprice-6m-rub="47 400 ₽" data-price-12m-rub="5 900 ₽" data-fullprice-12m-rub="77 880 ₽"
                        data-price-1m-eur="149 €" data-price-3m-eur="120 €" data-fullprice-3m-eur="360 €"
                        data-price-6m-eur="90 €" data-fullprice-6m-eur="540 €" data-price-12m-eur="80 €"
                        data-fullprice-12m-eur="960 €" data-offer-1m-rub="#1mr1" data-offer-3m-rub="#3mr1"
                        data-offer-6m-rub="#6mr1" data-offer-12m-rub="#12mr1" data-offer-1m-eur="#1me1"
                        data-offer-3m-eur="#3me1" data-offer-6m-eur="#6me1" data-offer-12m-eur="#12me1">
                        <p class="club40-tariffs-item-subheader">Тариф</p>
                        <p class="club40-tariffs-item-header">Самостоятельный</p>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723552330061-yrrgy-Play.svg"
                                    alt="">
                                <p>18 онлайн-программ,<br> закрывающих любой карьерный запрос</p>
                            </li>
                        </ul>
                        <div class="club40-tariffs-item-bottom">
                            <div class="club40-tariffs-item-wrapper-price">
                                <div class="careerum-flex-fsfs">
                                    <p class="club40-tariffs-item-price-pm">8 000 ₽</p>
                                    <p class="club40-tariffs-item-price-pmn1m">цена месяца в пакете</p>
                                    <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <p class="club40-tariffs-item-price-f">96 000 ₽</p>
                                    <p>полная стоимость к оплате</p>
                                </div>
                            </div>
                            <a href="#thanks" class="btn-color-main-dark-orange">Выбрать тариф</a>
                            <p class="club40-tariffs-item-price-rassr-eur">Можно платить долями</p>
                            <p class="club40-tariffs-item-price-rassr-rub">Можно в рассрочку</p>
                        </div>
                    </div>
                    <div class="club40-tariffs-item careerum-flex-fsfs" data-price-1m-rub="14 900 ₽"
                        data-price-3m-rub="11 633 ₽" data-fullprice-3m-rub="34 900 ₽" data-price-6m-rub="9 817 ₽"
                        data-fullprice-6m-rub="58 900 ₽" data-price-12m-rub="8 000 ₽" data-fullprice-12m-rub="96 000 ₽"
                        data-price-1m-eur="199 €" data-price-3m-eur="170 €" data-fullprice-3m-eur="510 €"
                        data-price-6m-eur="130 €" data-fullprice-6m-eur="780 €" data-price-12m-eur="100 €"
                        data-fullprice-12m-eur="1 200 €" data-offer-1m-rub="#1mr" data-offer-3m-rub="#3mr"
                        data-offer-6m-rub="#6mr" data-offer-12m-rub="#12mr" data-offer-1m-eur="#1me"
                        data-offer-3m-eur="#3me" data-offer-6m-eur="#6me" data-offer-12m-eur="#12me">
                        <p class="club40-tariffs-item-label">Осталось: 25 мест</p>
                        <p class="club40-tariffs-item-subheader">Тариф</p>
                        <p class="club40-tariffs-item-header">С поддержкой</p>
                        <p class="club40-tariffs-item-subheader">Все преимущества тарифа «Самостоятельный», плюс:</p>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723483406167-XJY0e-Fram.svg"
                                    alt="">
                                <p>Доступ к сообществу</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723483406167-XJY0e-Fram.svg"
                                    alt="">
                                <p>Доступ ко всем онлайн-ивентам и интенсивам</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723483406167-XJY0e-Fram.svg"
                                    alt="">
                                <p>2 Q&A-эфира в месяц с разбором ваших карьерных вопросов</p>
                            </li>
                        </ul>
                        <div class="club40-tariffs-item-bottom">
                            <div class="club40-tariffs-item-wrapper-price">
                                <div class="careerum-flex-fsfs">
                                    <p class="club40-tariffs-item-price-pm">8 000 ₽</p>
                                    <p class="club40-tariffs-item-price-pmn1m">цена месяца в пакете</p>
                                    <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <p class="club40-tariffs-item-price-f">96 000 ₽</p>
                                    <p>полная стоимость к оплате</p>
                                </div>
                            </div>
                            <a href="#thanks-yes" class="btn-color-main-dark-orange">Выбрать тариф</a>
                            <p class="club40-tariffs-item-price-rassr-eur">Можно платить долями</p>
                            <p class="club40-tariffs-item-price-rassr-rub">Можно в рассрочку</p>
                        </div>
                    </div>
                    <div class="club40-tariffs-item careerum-flex-fsfs" data-price-1m-rub="27 900 ₽"
                        data-price-3m-rub="23 900 ₽" data-fullprice-3m-rub="71 700 ₽" data-price-6m-rub="18 317 ₽"
                        data-fullprice-6m-rub="109 900 ₽" data-price-12m-rub="16 583 ₽" data-fullprice-12m-rub="199 000 ₽"
                        data-price-1m-eur="360 €" data-price-3m-eur="310 €" data-fullprice-3m-eur="930 €"
                        data-price-6m-eur="250 €" data-fullprice-6m-eur="1 500 €" data-price-12m-eur="230 €"
                        data-fullprice-12m-eur="2 760 €" data-offer-1m-rub="#1mr" data-offer-3m-rub="#3mr"
                        data-offer-6m-rub="#6mr" data-offer-12m-rub="#12mr" data-offer-1m-eur="#1me"
                        data-offer-3m-eur="#3me" data-offer-6m-eur="#6me" data-offer-12m-eur="#12me">
                        <p class="club40-tariffs-item-label">Осталось: 25 мест</p>
                        <p class="club40-tariffs-item-subheader">Тариф</p>
                        <p class="club40-tariffs-item-header">Индивидуальный подход</p>
                        <p class="club40-tariffs-item-subheader">Все преимущества тарифа «С поддержкой», плюс:</p>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723483406167-XJY0e-Fram.svg"
                                    alt="">
                                <p>Персональная поддержка карьерного эксперта и карьерного коуча в чате</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723483406167-XJY0e-Fram.svg"
                                    alt="">
                                <p>2 видеоконсультации<br> в месяц с коучем или экспертом</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723483406167-XJY0e-Fram.svg"
                                    alt="">
                                <p>Персональный разбор вашего резюме и LinkedIn-профиля</p>
                            </li>
                        </ul>
                        <div class="club40-tariffs-item-bottom">
                            <div class="club40-tariffs-item-wrapper-price">
                                <div class="careerum-flex-fsfs">
                                    <p class="club40-tariffs-item-price-pm">8 000 ₽</p>
                                    <p class="club40-tariffs-item-price-pmn1m">цена месяца в пакете</p>
                                    <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <p class="club40-tariffs-item-price-f">96 000 ₽</p>
                                    <p>полная стоимость к оплате</p>
                                </div>
                            </div>
                            <a href="#payform-single" class="btn-color-main-dark-orange">Выбрать тариф</a>
                            <p class="club40-tariffs-item-price-rassr-eur">Можно платить долями</p>
                            <p class="club40-tariffs-item-price-rassr-rub">Можно в рассрочку</p>
                        </div>
                    </div>
                </div>
                <div class="club40-tariffs-bottom">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723484897716-GBGcE-Vect.svg"
                            alt="">
                        <p class="club40-tariffs-bottom-header">Не знаете, с чего начать?</p>
                        <p class="club40-tariffs-bottom-subheader">Напишите нам — мы ответим на все вопросы и поможем
                            выбрать решение под вашу задачу</p>
                    </div>
                    <div>
                        <div class="club40-tariffs-bottom-care">
                            <div class="careerum-flex-fsc">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723278768285-Yeat8-phot.png"
                                        alt="">
                                </div>
                                <div>
                                    <p class="club40-tariffs-bottom-care-name">Анна </p>
                                    <p class="club40-tariffs-bottom-care-position">Команда заботы Careerum</p>
                                </div>
                            </div>
                            <p class="club40-tariffs-bottom-care-descr">Добрый день! Построить карьеру мечты в одиночку
                                бывает непросто. Но мы рядом и приведем вас к заветной цели 💙</p>
                        </div>
                        <a href="#tg" class="btn-color-main-dark-orange careerum-flex-cc">
                            <svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M6.9104 12.5754L9.51374 19.781C9.51374 19.781 9.83922 20.4552 10.1877 20.4552C10.5363 20.4552 15.7201 15.0624 15.7201 15.0624L21.4847 3.92822L7.00329 10.7153L6.9104 12.5754Z"
                                    fill="#C8DAEA" />
                                <path
                                    d="M10.3623 14.4233L9.86251 19.7346C9.86251 19.7346 9.65332 21.362 11.2804 19.7346C12.9074 18.1072 14.4648 16.8522 14.4648 16.8522"
                                    fill="#A9C6D8" />
                                <path
                                    d="M6.9574 12.8324L1.60225 11.0876C1.60225 11.0876 0.962247 10.828 1.16833 10.2392C1.21075 10.1177 1.29633 10.0144 1.55233 9.83687C2.73889 9.00981 23.5146 1.54247 23.5146 1.54247C23.5146 1.54247 24.1012 1.3448 24.4471 1.47628C24.5327 1.50277 24.6097 1.55152 24.6703 1.61755C24.7309 1.68357 24.7728 1.7645 24.7918 1.85205C24.8292 2.00668 24.8448 2.16578 24.8383 2.32473C24.8366 2.46224 24.82 2.58969 24.8074 2.78956C24.6808 4.83116 20.8942 20.0683 20.8942 20.0683C20.8942 20.0683 20.6677 20.9599 19.856 20.9904C19.6565 20.9969 19.4578 20.9631 19.2716 20.8911C19.0855 20.8191 18.9157 20.7103 18.7725 20.5713C17.1797 19.2012 11.6742 15.5012 10.4577 14.6875C10.4302 14.6688 10.4071 14.6445 10.3899 14.6161C10.3727 14.5877 10.3617 14.5559 10.3578 14.523C10.3408 14.4372 10.4341 14.3309 10.4341 14.3309C10.4341 14.3309 20.0205 5.80981 20.2756 4.91527C20.2954 4.84597 20.2208 4.81177 20.1206 4.84213C19.4838 5.07637 8.44622 12.0467 7.22803 12.816C7.14034 12.8425 7.04766 12.8481 6.9574 12.8324Z"
                                    fill="white" />
                            </svg>
                            <p>Написать нам в Telegram</p>
                        </a>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-support', {
        label: 'Club 4 support',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-support">
            <div class="careerum-container-desc">
                <h2 class="careerum-club40-header">Еще немного про подписку Careerum</h2>
                <div class="club40-support-experts">
                    <div class="club40-support-experts-top">
                        <div class="club40-support-label careerum-flex-fsfs">
                            <p>Экспертная поддержка</p>
                        </div>
                        <p class="club40-support-header">Помощь карьерных коучей и экспертов:<br>
                            чтобы карьерные цели достигались легко и быстро</p>
                    </div>
                    <div class="club40-support-experts-slider">
                        <div class="club40-support-experts-slider-item-about">
                            <div>
                                <div>
                                    <p class="club40-support-experts-slider-item-header">9,3/10</p>
                                    <p class="club40-support-experts-slider-item-subheader">средняя оценка коучей от
                                        клиентов Careerum</p>
                                    <p class="club40-support-experts-slider-item-header">9,5/10</p>
                                    <p class="club40-support-experts-slider-item-subheader">средняя оценка карьерных
                                        экспертов</p>
                                </div>
                            </div>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280806527-AkUu1-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Елена Добринская</p>
                            <p class="club40-support-experts-slider-item-position">PCC ICF </p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>10+ лет в коучинге и финансах </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1700+ клиентам обрести уверенность и подготовиться к собеседованиям</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Sony, Ernst&Young, Deloitte</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>ОАЭ</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409766-cqwPu-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Софи Бессон</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>6+ в HR и карьерном консультировании</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 700+ клиентам составить резюме и найти работу в Европе, США и Канаде</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Disney, Intel, Microsoft</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Израиль</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409265-9vjpf-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Надежда Община</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>9+ лет в маркетинге и консультировании</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 550+ клиентам из США, Европы и СНГ найти работу и сменить карьеру</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Airbus, Hubspot, Google, Farfetch</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Португалия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410646-Tg23o-ÑÐ¼.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Яна Хмельницкая</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>15+ лет в HR, карьерном коучинге и закупках</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 800+ клиентам подготовиться к интервью на английском языке и релоцироваться
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Ford, Leroy Merlin, Unilever, Mars</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Турция</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410772-6unNS-ÑÐ¼.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Оксана Сыпченко</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>11+ лет в карьерном коучинге и гос.секторе</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 100+ клиентам найти карьерный вектор, стать увереннее в себе и получить
                                        повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками ERG, DevExpress, Роснефть</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Конго</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410266-0RLoj-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Елена Эльзенбах</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>11+ лет опыта в коучинге, НКО и EdTech</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1300+ клиентам из РФ, Европы и СНГ получить оффер через укрепление самооценки
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Lamoda, Яндекс, Mail, InDriver</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410383-HztZL-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Виктория Албаутова</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICU</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в коучинге и маркетинге</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 150+ клиентам построить выигрышные стратегии и бренды</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        компаниями Beiesdorf, Philips, Johnson&Johnson, Novartis</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Турция</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410508-UN5w7-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Светлана Шуйская</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в коучинге и закупках</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 300+ клиентам вырасти в доходе, составить стратегию, начать свое дело</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Metro Cash&Carry, Yandex, Avito</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409625-XnYoE-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Мария Пудалова</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>7+ лет в PR и стратегии выстраивания бренда</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 400+ клиентам улучшить CV и найти работу в Европе
                                        и США</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Deloitte, BBDO, Microsoft</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Германия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409884-sm2PF-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Астра Висаева</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>10+ лет в коучинге, финансах и инвестициях</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 2500+ клиентам определить карьерные вектора и найти работу в России, ЕС и США
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками OZON, EPAM, McKinsey, Nike</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410030-PrNQ2-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Марина Веденичева</p>
                            <p class="club40-support-experts-slider-item-position">Коуч PCC ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в HR и карьерном коучинге</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 2000+ клиентам усилить лидерские качества и получить повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Mars, Shell, Ernst & Young</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Великобритания</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410151-lWIq0-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Ирина Шутова</p>
                            <p class="club40-support-experts-slider-item-position">Коуч AFC</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>6+ лет в коучинге и коммуникациях</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1000+ клиентам получить офферы с релокацией и повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками PepsiCo, Amazon, VK, Pfizer</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="club40-support-slider-nav careerum-flex-fec">
                        <div class="club40-support-experts-slider-nav-prev">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_7304_21282)">
                                    <g filter="url(#filter0_b_7304_21282)">
                                        <rect y="40" width="40" height="40" transform="rotate(-90 0 40)" fill="#FF9F00" />
                                    </g>
                                    <path d="M13.1905 19.9993L26.8105 19.9993" stroke="white" stroke-width="2.64201"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M19.4629 26.2453L13.1896 19.9986L19.4629 13.752" stroke="white"
                                        stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <filter id="filter0_b_7304_21282" x="-18.1166" y="-18.1166" width="76.2332"
                                        height="76.2332" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                        <feComposite in2="SourceAlpha" operator="in"
                                            result="effect1_backgroundBlur_7304_21282" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_7304_21282"
                                            result="shape" />
                                    </filter>
                                    <clipPath id="clip0_7304_21282">
                                        <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)"
                                            fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="club40-support-experts-slider-nav-next">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_7304_21286)">
                                    <g filter="url(#filter0_b_7304_21286)">
                                        <rect x="40" width="40" height="40" transform="rotate(90 40 0)" fill="#FF9F00" />
                                    </g>
                                    <path d="M26.8095 20.0007L13.1895 20.0007" stroke="white" stroke-width="2.64201"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M20.5371 13.7547L26.8104 20.0014L20.5371 26.248" stroke="white"
                                        stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <filter id="filter0_b_7304_21286" x="-18.1166" y="-18.1166" width="76.2332"
                                        height="76.2332" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                        <feComposite in2="SourceAlpha" operator="in"
                                            result="effect1_backgroundBlur_7304_21286" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_7304_21286"
                                            result="shape" />
                                    </filter>
                                    <clipPath id="clip0_7304_21286">
                                        <rect x="40" width="40" height="40" rx="20" transform="rotate(90 40 0)"
                                            fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </div>
                    <div class="club40-support-experts-available careerum-flex-fsc">
                        <p>Доступно на тарифах:</p>
                        <div class="careerum-flex-cc not-avail">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723283080104-KyTpV-XCir.svg"
                                alt="">
                            <p>Самостоятельный</p>
                        </div>
                        <div class="careerum-flex-cc not-avail">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723283080104-KyTpV-XCir.svg"
                                alt="">
                            <p>С поддержкой</p>
                        </div>
                        <div class="careerum-flex-cc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723283079831-F19gL-Chec.svg"
                                alt="">
                            <p>Индивидуальный подход</p>
                        </div>
                    </div>
                </div>
                <div class="club40-support-info careerum-flex-sbst">
                    <div class="club40-support-mers">
                        <div class="club40-support-label careerum-flex-fsfs">
                            <p>Онлайн мероприятия</p>
                        </div>
                        <p class="club40-support-header">Интенсивы и Q&A-эфиры</p>
                        <p class="club40-support-content">На интенсивах глубоко погружаемся в ключевые карьерные темы и
                            помогаем каждому участнику быстро и эффективно достичь своей цели с поддержкой единомышленников
                            и экспертов.</p>
                        <p class="club40-support-content">На Q&A-эфирах вместе с карьерными экспертами и другими участниками
                            сообщества решаем актуальные карьерные вопросы.</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723283725047-fSheB-Fram.svg"
                            alt="">
                        <div class="club40-support-experts-available careerum-flex-fsc">
                            <p>Доступно на тарифах:</p>
                            <div class="careerum-flex-cc not-avail">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723283080104-KyTpV-XCir.svg"
                                    alt="">
                                <p>Самостоятельный</p>
                            </div>
                            <div class="careerum-flex-cc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723283079831-F19gL-Chec.svg"
                                    alt="">
                                <p>С поддержкой</p>
                            </div>
                            <div class="careerum-flex-cc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723283079831-F19gL-Chec.svg"
                                    alt="">
                                <p>Индивидуальный подход</p>
                            </div>
                        </div>
                    </div>
                    <div class="club40-support-netw">
                        <div class="club40-support-label careerum-flex-fsfs">
                            <p>Нетворкинг</p>
                        </div>
                        <p class="club40-support-header">Сильное сообщество профессионалов со всего мира</p>
                        <p class="club40-support-content">Доступ в сообщество из 1000+ профессионалов из 30+ стран, где вы
                            сможете научиться строить нетворк и завести полезные знакомства, найти поддержку среди
                            участников с похожими проблемами и целями и получить советы от тех, кто уже успешно прошел
                            аналогичный путь.</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723284054075-4V27u-Grou.svg"
                            alt="">
                        <div class="club40-support-experts-available careerum-flex-fsc">
                            <p>Доступно на тарифах:</p>
                            <div class="careerum-flex-cc not-avail">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723283080104-KyTpV-XCir.svg"
                                    alt="">
                                <p>Самостоятельный</p>
                            </div>
                            <div class="careerum-flex-cc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723283079831-F19gL-Chec.svg"
                                    alt="">
                                <p>С поддержкой</p>
                            </div>
                            <div class="careerum-flex-cc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723283079831-F19gL-Chec.svg"
                                    alt="">
                                <p>Индивидуальный подход</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="club40-support-mats">
                    <div class="club40-support-mats-top careerum-flex-sbfs">
                        <div>
                            <div class="club40-support-label careerum-flex-fsfs">
                                <p>Образовательные материалы</p>
                            </div>
                            <p class="club40-support-header">18 программ под любую карьерную задачу, и даже самую редкую</p>
                            <ul>
                                <li>Как построить карьеру за рубежом</li>
                                <li>Как адаптироваться на новом рабочем месте</li>
                                <li>Как регулярно расти в должности и доходе</li>
                                <li>Как укрепить профессиональную самооценку</li>
                                <li>Как построить life-work balance и не выгорать</li>
                                <li>И другие темы, чтобы карьера была по любви</li>
                            </ul>
                        </div>
                        <div>
                            <div>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723284844056-jWdN3-Note.svg"
                                            alt="">
                                        <p>В Сareerum больше 80 курсов под любой запрос</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723284843668-UVBRz-Book.svg"
                                            alt="">
                                        <p>Методисты Careerum разделили их по темам и упаковали в понятные образовательные
                                            траектории</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723284844268-BBlL8-Trop.svg"
                                            alt="">
                                        <p>Вам осталось выбрать подходящую и получить знания. А если возникнут вопросы, мы
                                            обязательно поможем!</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="club40-support-mats-divider"></div>
                    <div class="club40-support-mats-slider-wrapper">
                        <p class="club40-support-mats-slider-header">Учитесь по программам ведущих экспертов</p>
                        <div class="club40-support-mats-slider-items">
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285436842-nmhub-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Ольга Лермонтова</p>
                                <p class="club40-support-mats-slider-item-position">фаундер Careerum</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Занимала руководящие должности в Google и Microsoft</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Управляла бизнесом на 20+ рынках Африки и Европы</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>12 000+ клиентов из РФ, СНГ, Европы, Америки </p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Италия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437123-F7q7s-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Елена Резанова</p>
                                <p class="club40-support-mats-slider-item-position">карьерный стратег</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>9+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогает посмотреть на карьеру целостно и соотнести ее с целями бизнеса.</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Автор книг-бестселлеров «Никогда-нибудь» и «Это норм!»</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Монако </p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437246-oRSRS-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Sophie Vurpillot</p>
                                <p class="club40-support-mats-slider-item-position">рекрутер и коуч</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>10+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогла специалистам из 20+ стран раскрыть потенциал</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Сотрудничала с университетами Европы, США и Латинской Америки</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Испания</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437367-I19r8-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Анна Бабич</p>
                                <p class="club40-support-mats-slider-item-position">психолог</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Терапевт в сфере АСТ и эмоционально-фокусированной терапии</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Автор книги-бестселлера «Внутренняя опора»</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Спикер конференций: Psychologies, TeamLead, CodeFest</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Россия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437505-QfSia-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Montse Lorente</p>
                                <p class="club40-support-mats-slider-item-position">рекрутер и коуч</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>10+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогла специалистам из 20+ стран раскрыть потенциал</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Сотрудничала с университетами Европы, США и Латинской Америки.</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Перу</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437627-rUPvo-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Санжар Ибрагимов</p>
                                <p class="club40-support-mats-slider-item-position">ментор</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Опыт в консалтинге в McKinsey & Company, PwC, World Bank Group</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>MBA в швейцарской бизнес-школе IMD</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Ментор в IMD International и Aalto Business School</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Финляндия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437755-4zqkR-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Наталья Токарь</p>
                                <p class="club40-support-mats-slider-item-position">эксперт по коммуникации</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>CEO проекта по обучению команд маркетинга, продаж, проджект-менеджеров и
                                            руководителей</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Ментор в бизнес-акселераторе Чикаго</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>США</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="club40-support-slider-nav careerum-flex-fec">
                        <div class="club40-support-mats-slider-nav-prev">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_7304_21282)">
                                    <g filter="url(#filter0_b_7304_21282)">
                                        <rect y="40" width="40" height="40" transform="rotate(-90 0 40)" fill="#FF9F00" />
                                    </g>
                                    <path d="M13.1905 19.9993L26.8105 19.9993" stroke="white" stroke-width="2.64201"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M19.4629 26.2453L13.1896 19.9986L19.4629 13.752" stroke="white"
                                        stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <filter id="filter0_b_7304_21282" x="-18.1166" y="-18.1166" width="76.2332"
                                        height="76.2332" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                        <feComposite in2="SourceAlpha" operator="in"
                                            result="effect1_backgroundBlur_7304_21282" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_7304_21282"
                                            result="shape" />
                                    </filter>
                                    <clipPath id="clip0_7304_21282">
                                        <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)"
                                            fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="club40-support-mats-slider-nav-next">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_7304_21286)">
                                    <g filter="url(#filter0_b_7304_21286)">
                                        <rect x="40" width="40" height="40" transform="rotate(90 40 0)" fill="#FF9F00" />
                                    </g>
                                    <path d="M26.8095 20.0007L13.1895 20.0007" stroke="white" stroke-width="2.64201"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M20.5371 13.7547L26.8104 20.0014L20.5371 26.248" stroke="white"
                                        stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <filter id="filter0_b_7304_21286" x="-18.1166" y="-18.1166" width="76.2332"
                                        height="76.2332" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                        <feComposite in2="SourceAlpha" operator="in"
                                            result="effect1_backgroundBlur_7304_21286" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_7304_21286"
                                            result="shape" />
                                    </filter>
                                    <clipPath id="clip0_7304_21286">
                                        <rect x="40" width="40" height="40" rx="20" transform="rotate(90 40 0)"
                                            fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </div>
                    <div class="club40-support-experts-available careerum-flex-fsc">
                        <p>Доступно на тарифах:</p>
                        <div class="careerum-flex-cc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723283079831-F19gL-Chec.svg"
                                alt="">
                            <p>Самостоятельный</p>
                        </div>
                        <div class="careerum-flex-cc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723283079831-F19gL-Chec.svg"
                                alt="">
                            <p>С поддержкой</p>
                        </div>
                        <div class="careerum-flex-cc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723283079831-F19gL-Chec.svg"
                                alt="">
                            <p>Индивидуальный подход</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-support-tablet', {
        label: 'Club 4 support (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-support-tablet">
            <div class="careerum-container-tablet">
                <h2 class="careerum-club40-header-tablet">Еще немного про подписку</h2>
                <div class="club40-support-experts">
                    <div class="club40-support-experts-top careerum-flex-fsfs">
                        <div>
                            <div class="club40-support-label careerum-flex-fsfs">
                                <p>Экспертная поддержка</p>
                            </div>
                            <p class="club40-support-header">Помощь коучей и экспертов: чтобы карьерные цели достигались
                                легко и быстро</p>
                        </div>
                        <div>
                            <div>
                                <div class="careerum-flex-fsc">
                                    <p class="club40-support-experts-slider-item-header">9,3/10</p>
                                    <p class="club40-support-experts-slider-item-subheader">средняя оценка коучей от
                                        клиентов Careerum</p>
                                </div>
                                <div class="careerum-flex-fsc">
                                    <p class="club40-support-experts-slider-item-header">9,5/10</p>
                                    <p class="club40-support-experts-slider-item-subheader">средняя оценка карьерных
                                        экспертов</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="club40-support-experts-slider">
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280806527-AkUu1-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Елена Добринская</p>
                            <p class="club40-support-experts-slider-item-position">PCC ICF </p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>10+ лет в коучинге и финансах </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1700+ клиентам обрести уверенность и подготовиться к собеседованиям</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Sony, Ernst&Young, Deloitte</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>ОАЭ</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409766-cqwPu-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Софи Бессон</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>6+ в HR и карьерном консультировании</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 700+ клиентам составить резюме и найти работу в Европе, США и Канаде</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Disney, Intel, Microsoft</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Израиль</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409265-9vjpf-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Надежда Община</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>9+ лет в маркетинге и консультировании</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 550+ клиентам из США, Европы и СНГ найти работу и сменить карьеру</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Airbus, Hubspot, Google, Farfetch</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Португалия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410646-Tg23o-ÑÐ¼.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Яна Хмельницкая</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>15+ лет в HR, карьерном коучинге и закупках</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 800+ клиентам подготовиться к интервью на английском языке и релоцироваться
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Ford, Leroy Merlin, Unilever, Mars</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Турция</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410772-6unNS-ÑÐ¼.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Оксана Сыпченко</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>11+ лет в карьерном коучинге и гос.секторе</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 100+ клиентам найти карьерный вектор, стать увереннее в себе и получить
                                        повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками ERG, DevExpress, Роснефть</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Конго</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410266-0RLoj-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Елена Эльзенбах</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>11+ лет опыта в коучинге, НКО и EdTech</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1300+ клиентам из РФ, Европы и СНГ получить оффер через укрепление самооценки
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Lamoda, Яндекс, Mail, InDriver</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410383-HztZL-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Виктория Албаутова</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICU</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в коучинге и маркетинге</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 150+ клиентам построить выигрышные стратегии и бренды</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        компаниями Beiesdorf, Philips, Johnson&Johnson, Novartis</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Турция</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410508-UN5w7-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Светлана Шуйская</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в коучинге и закупках</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 300+ клиентам вырасти в доходе, составить стратегию, начать свое дело</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Metro Cash&Carry, Yandex, Avito</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409625-XnYoE-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Мария Пудалова</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>7+ лет в PR и стратегии выстраивания бренда</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 400+ клиентам улучшить CV и найти работу в Европе
                                        и США</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Deloitte, BBDO, Microsoft</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Германия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409884-sm2PF-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Астра Висаева</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>10+ лет в коучинге, финансах и инвестициях</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 2500+ клиентам определить карьерные вектора и найти работу в России, ЕС и США
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками OZON, EPAM, McKinsey, Nike</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410030-PrNQ2-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Марина Веденичева</p>
                            <p class="club40-support-experts-slider-item-position">Коуч PCC ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в HR и карьерном коучинге</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 2000+ клиентам усилить лидерские качества и получить повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Mars, Shell, Ernst & Young</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Великобритания</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410151-lWIq0-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Ирина Шутова</p>
                            <p class="club40-support-experts-slider-item-position">Коуч AFC</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>6+ лет в коучинге и коммуникациях</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1000+ клиентам получить офферы с релокацией и повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками PepsiCo, Amazon, VK, Pfizer</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="club40-support-info careerum-flex-sbst">
                    <div class="club40-support-mers">
                        <div class="club40-support-label careerum-flex-fsfs">
                            <p>Онлайн мероприятия</p>
                        </div>
                        <p class="club40-support-header">Интенсивы и Q&A-эфиры</p>
                        <p class="club40-support-content">На интенсивах глубоко погружаемся в ключевые карьерные темы и помогаем каждому участнику достичь своей цели с поддержкой единомышленников и экспертов.</p>
                        <p class="club40-support-content">На Q&A-эфирах вместе с карьерными экспертами и другими участниками
                            сообщества решаем актуальные карьерные вопросы.</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723487517601-J3a3P-Fram.svg"
                            alt="">
                    </div>
                    <div class="club40-support-netw">
                        <div class="club40-support-label careerum-flex-fsfs">
                            <p>Нетворкинг</p>
                        </div>
                        <p class="club40-support-header">Сильное сообщество профессионалов со всего мира</p>
                        <p class="club40-support-content">Доступ в сообщество из 1000+ профессионалов из 30+ стран, где вы сможете завести полезные знакомства, найти поддержку среди участников с похожими проблемами и целями и получить советы от тех, кто уже успешно прошел аналогичный путь.</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723487518161-WYb3k-Grou.svg"
                            alt="">
                    </div>
                </div>
                <div class="club40-support-mats">
                    <div class="club40-support-mats-top careerum-flex-sbfs">
                        <div>
                            <div class="club40-support-label careerum-flex-fsfs">
                                <p>Образовательные материалы</p>
                            </div>
                            <p class="club40-support-header">18 программ под любую карьерную задачу</p>
                            <ul>
                                <li>Построить карьеру за рубежом</li>
                                <li>Адаптироваться на новом рабочем месте</li>
                                <li>Регулярно расти в должности и доходе</li>
                                <li>Укрепить профессиональную самооценку</li>
                                <li>И другие темы, даже самые редкие</li>
                            </ul>
                        </div>
                        <div>
                            <div>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723488217563-Vnu5D-Note.svg"
                                            alt="">
                                        <p>В Сareerum больше 80 курсов<br> под любой запрос</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723488217283-YRFlS-Book.svg"
                                            alt="">
                                        <p>Методисты Careerum разделили<br> их по темам на программы и упаковали в понятные образовательные траектории</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723488217709-BpfbH-Trop.svg"
                                            alt="">
                                        <p>Вам осталось выбрать подходящую, а если возникнут вопросы — мы рядом</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="club40-support-mats-divider"></div>
                    <div class="club40-support-mats-slider-wrapper">
                        <p class="club40-support-mats-slider-header">Учитесь по программам ведущих экспертов</p>
                        <div class="club40-support-mats-slider-items">
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285436842-nmhub-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Ольга Лермонтова</p>
                                <p class="club40-support-mats-slider-item-position">фаундер Careerum</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Занимала руководящие должности в Google и Microsoft</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Управляла бизнесом на 20+ рынках Африки и Европы</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>12 000+ клиентов из РФ, СНГ, Европы, Америки </p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Италия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437123-F7q7s-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Елена Резанова</p>
                                <p class="club40-support-mats-slider-item-position">карьерный стратег</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>9+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогает посмотреть на карьеру целостно и соотнести ее с целями бизнеса.</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Автор книг-бестселлеров «Никогда-нибудь» и «Это норм!»</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Монако </p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437246-oRSRS-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Sophie Vurpillot</p>
                                <p class="club40-support-mats-slider-item-position">рекрутер и коуч</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>10+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогла специалистам из 20+ стран раскрыть потенциал</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Сотрудничала с университетами Европы, США и Латинской Америки</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Испания</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437367-I19r8-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Анна Бабич</p>
                                <p class="club40-support-mats-slider-item-position">психолог</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Терапевт в сфере АСТ и эмоционально-фокусированной терапии</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Автор книги-бестселлера «Внутренняя опора»</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Спикер конференций: Psychologies, TeamLead, CodeFest</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Россия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437505-QfSia-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Montse Lorente</p>
                                <p class="club40-support-mats-slider-item-position">рекрутер и коуч</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>10+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогла специалистам из 20+ стран раскрыть потенциал</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Сотрудничала с университетами Европы, США и Латинской Америки.</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Перу</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437627-rUPvo-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Санжар Ибрагимов</p>
                                <p class="club40-support-mats-slider-item-position">ментор</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Опыт в консалтинге в McKinsey & Company, PwC, World Bank Group</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>MBA в швейцарской бизнес-школе IMD</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Ментор в IMD International и Aalto Business School</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Финляндия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437755-4zqkR-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Наталья Токарь</p>
                                <p class="club40-support-mats-slider-item-position">эксперт по коммуникации</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>CEO проекта по обучению команд маркетинга, продаж, проджект-менеджеров и
                                            руководителей</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Ментор в бизнес-акселераторе Чикаго</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>США</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-support-mobile', {
        label: 'Club 4 support (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-support-mobile">
            <div class="careerum-container-mobile">
                <h2 class="careerum-club40-header-mobile">Еще немного про подписку</h2>
                <div class="club40-support-experts">
                    <div class="club40-support-experts-top">
                        <div>
                            <div class="club40-support-label careerum-flex-fsfs">
                                <p>Экспертная поддержка</p>
                            </div>
                            <p class="club40-support-header">Помощь коучей и экспертов: чтобы карьерные цели достигались
                                легко и быстро</p>
                        </div>
                        <div>
                            <div>
                                <div class="careerum-flex-fsc">
                                    <p class="club40-support-experts-slider-item-header">9,3/10</p>
                                    <p class="club40-support-experts-slider-item-subheader">средняя оценка коучей от
                                        клиентов Careerum</p>
                                </div>
                                <div class="careerum-flex-fsc">
                                    <p class="club40-support-experts-slider-item-header">9,5/10</p>
                                    <p class="club40-support-experts-slider-item-subheader">средняя оценка карьерных
                                        экспертов</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="club40-support-experts-slider">
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280806527-AkUu1-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Елена Добринская</p>
                            <p class="club40-support-experts-slider-item-position">PCC ICF </p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>10+ лет в коучинге и финансах </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1700+ клиентам обрести уверенность и подготовиться к собеседованиям</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Sony, Ernst&Young, Deloitte</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>ОАЭ</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409766-cqwPu-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Софи Бессон</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>6+ в HR и карьерном консультировании</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 700+ клиентам составить резюме и найти работу в Европе, США и Канаде</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Disney, Intel, Microsoft</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Израиль</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409265-9vjpf-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Надежда Община</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>9+ лет в маркетинге и консультировании</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 550+ клиентам из США, Европы и СНГ найти работу и сменить карьеру</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Airbus, Hubspot, Google, Farfetch</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Португалия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410646-Tg23o-ÑÐ¼.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Яна Хмельницкая</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>15+ лет в HR, карьерном коучинге и закупках</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 800+ клиентам подготовиться к интервью на английском языке и релоцироваться
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Ford, Leroy Merlin, Unilever, Mars</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Турция</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410772-6unNS-ÑÐ¼.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Оксана Сыпченко</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>11+ лет в карьерном коучинге и гос.секторе</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 100+ клиентам найти карьерный вектор, стать увереннее в себе и получить
                                        повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками ERG, DevExpress, Роснефть</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Конго</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410266-0RLoj-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Елена Эльзенбах</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>11+ лет опыта в коучинге, НКО и EdTech</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1300+ клиентам из РФ, Европы и СНГ получить оффер через укрепление самооценки
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Lamoda, Яндекс, Mail, InDriver</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410383-HztZL-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Виктория Албаутова</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICU</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в коучинге и маркетинге</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 150+ клиентам построить выигрышные стратегии и бренды</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        компаниями Beiesdorf, Philips, Johnson&Johnson, Novartis</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Турция</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410508-UN5w7-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Светлана Шуйская</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в коучинге и закупках</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 300+ клиентам вырасти в доходе, составить стратегию, начать свое дело</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Metro Cash&Carry, Yandex, Avito</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409625-XnYoE-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Мария Пудалова</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>7+ лет в PR и стратегии выстраивания бренда</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 400+ клиентам улучшить CV и найти работу в Европе
                                        и США</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Deloitte, BBDO, Microsoft</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Германия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409884-sm2PF-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Астра Висаева</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>10+ лет в коучинге, финансах и инвестициях</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 2500+ клиентам определить карьерные вектора и найти работу в России, ЕС и США
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками OZON, EPAM, McKinsey, Nike</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410030-PrNQ2-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Марина Веденичева</p>
                            <p class="club40-support-experts-slider-item-position">Коуч PCC ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в HR и карьерном коучинге</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 2000+ клиентам усилить лидерские качества и получить повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Mars, Shell, Ernst & Young</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Великобритания</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410151-lWIq0-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Ирина Шутова</p>
                            <p class="club40-support-experts-slider-item-position">Коуч AFC</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>6+ лет в коучинге и коммуникациях</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1000+ клиентам получить офферы с релокацией и повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками PepsiCo, Amazon, VK, Pfizer</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="club40-support-info">
                    <div class="club40-support-mers">
                        <div class="club40-support-label careerum-flex-fsfs">
                            <p>Онлайн мероприятия</p>
                        </div>
                        <p class="club40-support-header">Интенсивы и Q&A-эфиры</p>
                        <p class="club40-support-content">На интенсивах глубоко погружаемся в ключевые карьерные темы и
                            помогаем каждому участнику достичь своей цели с поддержкой единомышленников и экспертов.</p>
                        <p class="club40-support-content">На Q&A-эфирах вместе с карьерными экспертами и другими участниками
                            сообщества решаем актуальные карьерные вопросы.</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723487517601-J3a3P-Fram.svg"
                            alt="">
                    </div>
                    <div class="club40-support-netw">
                        <div class="club40-support-label careerum-flex-fsfs">
                            <p>Нетворкинг</p>
                        </div>
                        <p class="club40-support-header">Сильное сообщество профессионалов со всего мира</p>
                        <p class="club40-support-content">Доступ в сообщество из 1000+ профессионалов из 30+ стран, где вы
                            сможете завести полезные знакомства, найти поддержку среди участников с похожими проблемами и
                            целями и получить советы от тех, кто уже успешно прошел аналогичный путь.</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723554465492-akoKl-Grou.svg"
                            alt="">
                    </div>
                </div>
                <div class="club40-support-mats">
                    <div class="club40-support-mats-top">
                        <div>
                            <div class="club40-support-label careerum-flex-fsfs">
                                <p>Образовательные материалы</p>
                            </div>
                            <p class="club40-support-header">18 программ под любую карьерную задачу</p>
                            <ul>
                                <li>Построить карьеру за рубежом</li>
                                <li>Адаптироваться на новом рабочем месте</li>
                                <li>Регулярно расти в должности и доходе</li>
                                <li>Укрепить профессиональную самооценку</li>
                                <li>И другие темы, даже самые редкие</li>
                            </ul>
                        </div>
                        <div>
                            <div>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723488217563-Vnu5D-Note.svg"
                                            alt="">
                                        <p>В Сareerum больше 80 курсов<br> под любой запрос</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723488217283-YRFlS-Book.svg"
                                            alt="">
                                        <p>Методисты Careerum разделили<br> их по темам на программы и упаковали в понятные
                                            образовательные траектории</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723488217709-BpfbH-Trop.svg"
                                            alt="">
                                        <p>Вам осталось выбрать подходящую, а если возникнут вопросы — мы рядом</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="club40-support-mats-divider"></div>
                    <div class="club40-support-mats-slider-wrapper">
                        <p class="club40-support-mats-slider-header">Учитесь по программам<br> ведущих экспертов</p>
                        <div class="club40-support-mats-slider-items">
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285436842-nmhub-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Ольга Лермонтова</p>
                                <p class="club40-support-mats-slider-item-position">фаундер Careerum</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Занимала руководящие должности в Google и Microsoft</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Управляла бизнесом на 20+ рынках Африки и Европы</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>12 000+ клиентов из РФ, СНГ, Европы, Америки </p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Италия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437123-F7q7s-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Елена Резанова</p>
                                <p class="club40-support-mats-slider-item-position">карьерный стратег</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>9+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогает посмотреть на карьеру целостно и соотнести ее с целями бизнеса.</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Автор книг-бестселлеров «Никогда-нибудь» и «Это норм!»</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Монако </p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437246-oRSRS-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Sophie Vurpillot</p>
                                <p class="club40-support-mats-slider-item-position">рекрутер и коуч</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>10+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогла специалистам из 20+ стран раскрыть потенциал</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Сотрудничала с университетами Европы, США и Латинской Америки</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Испания</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437367-I19r8-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Анна Бабич</p>
                                <p class="club40-support-mats-slider-item-position">психолог</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Терапевт в сфере АСТ и эмоционально-фокусированной терапии</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Автор книги-бестселлера «Внутренняя опора»</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Спикер конференций: Psychologies, TeamLead, CodeFest</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Россия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437505-QfSia-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Montse Lorente</p>
                                <p class="club40-support-mats-slider-item-position">рекрутер и коуч</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>10+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогла специалистам из 20+ стран раскрыть потенциал</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Сотрудничала с университетами Европы, США и Латинской Америки.</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Перу</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437627-rUPvo-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Санжар Ибрагимов</p>
                                <p class="club40-support-mats-slider-item-position">ментор</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Опыт в консалтинге в McKinsey & Company, PwC, World Bank Group</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>MBA в швейцарской бизнес-школе IMD</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Ментор в IMD International и Aalto Business School</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Финляндия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437755-4zqkR-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Наталья Токарь</p>
                                <p class="club40-support-mats-slider-item-position">эксперт по коммуникации</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>CEO проекта по обучению команд маркетинга, продаж, проджект-менеджеров и
                                            руководителей</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Ментор в бизнес-акселераторе Чикаго</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>США</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('club40-support2', {
        label: 'Club 4 support2',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-support club40-support2">
            <div class="careerum-container-desc">
                <h2 class="careerum-club40-header">Careerum — это обучение карьерным навыкам, поддержка экспертов,
                    профессиональный нетворкинг</h2>
                <div class="club40-support-experts">
                    <div class="club40-support-experts-top">
                        <div class="club40-support-label careerum-flex-fsfs">
                            <p>01 Образовательная платформа</p>
                        </div>
                        <p class="club40-support-header">80 курсов под любую карьерную задачу</p>
                    </div>
                    <div class="club40-support-programms-slider-items">
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Звёздный кандидат</p>
                            <p class="programms-slider-text">Эта программа — must see для всех, кто хоть раз искал работу.
                            </p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733903195877-jxP4N-pic..svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Real Me: как найти себя </p>
                            <p class="programms-slider-text">Вы сможете лучше узнать себя настоящего и понять, чего вы
                                хотите для своей карьеры</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733903195760-k2i68-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Международная карьера и релокация</p>
                            <p class="programms-slider-text">Вы узнаете всё о поиске работы в новых для вас странах, освоите
                                LinkedIn и научитесь учитывать культурный контекст</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733903195611-i209G-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Карьерная ракета</p>
                            <p class="programms-slider-text">Вы освоите базу карьерного мышления, узнаете, как расти в
                                зарплате и роли и научитесь планировать и добиваться даже самых амбициозных целей.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733903195276-Tuk6J-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Работать не 24/7</p>
                            <p class="programms-slider-text">Вы повысите свою продуктивность и научитесь получать результаты
                                в проектах</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905207114-JpoWG-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Самооценка и Деньги: не мешайте себе зарабатывать</p>
                            <p class="programms-slider-text">Вы преодолеете эти барьеры, присвоите свои таланты и научитесь
                                опираться на себя и свою ценность</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206995-CzHss-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Публичные выступления</p>
                            <p class="programms-slider-text">Вы прокачаете навыки самопрезентации, научитесь бороться с
                                волнением и убедительно доносить свои мысли </p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206870-OTfik-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Жизнь после оффера</p>
                            <p class="programms-slider-text">Вы узнаете, как быстро освоиться на новой работе и найти
                                контакт с руководителем и коллегами. </p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206754-7evbK-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Антикризис</p>
                            <p class="programms-slider-text">Вы узнаете, как оставаться ценным сотрудником даже во времена
                                сокращений</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206605-BqNcB-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Карьера без стресса</p>
                            <p class="programms-slider-text">Вы освоите методы предотвращения стресса и выгорания,
                                прокачаете эмоциональный интеллект и настроите свой work-life balance.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206462-v4YrG-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Секреты нетворкинга</p>
                            <p class="programms-slider-text">Вы научитесь развивать и укреплять сеть контактов, освоите
                                small talk и elevator pitch и узнаете, как сформировать личный бренд.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206300-G4EiF-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Удалёнка</p>
                            <p class="programms-slider-text">Вы разберетесь, как организовать свою удаленную работу и
                                использовать все плюсы формата себе во благо</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206162-axyQs-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Коммуникация на работе</p>
                            <p class="programms-slider-text">Вы усилите навыки экологичного общения, научитесь достигать
                                своих целей в переговорах и разрешать конфликты</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206056-MnQUS-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Open Mindset</p>
                            <p class="programms-slider-text">Вы разовьете разные виды мышления и научитесь смотреть на
                                задачи, проекты и ситуации под новыми, порой непривычными, углами. </p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205937-ZsoJe-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Эффективный руководитель</p>
                            <p class="programms-slider-text">Вы освоите важные навыки руководителя, изучите лайфхаки по
                                взаимодействию в кросс-функциональных командах и лучше начнете понимать своего босса.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205773-omnR0-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Новые горизонты</p>
                            <p class="programms-slider-text">Вы узнаете, как сменить сферу и что делать, если вы прямо
                                сейчас оказались в точке выбора нового профессионального пути.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205629-EdGB4-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Карьера и финансы</p>
                            <p class="programms-slider-text">Вы узнаете, как добиться финансовой независимости и научитесь
                                грамотно распоряжаться своими деньгами.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205499-YmnJD-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Зарубежное образование</p>
                            <p class="programms-slider-text">Вы узнаете основные особенности обучения за рубежом и детально
                                рассмотрите поступление на MBA</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205377-zl9WX-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Выход из декрета</p>
                            <p class="programms-slider-text">Вы сможете преодолеть страхи и трудности, свойственные при
                                выходе из декрета, и узнаете, как вернуться к работе в бережном, но не менее эффективном
                                режиме.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205223-dT5vR-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Мышление Boost</p>
                            <p class="programms-slider-text">Узнайте, как построить стратегию поиска работы, пройти все
                                этапы и получить оффер мечты</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905204858-qg4Um-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                    </div>
                    <div class="club40-support-slider-nav careerum-flex-fec">
                        <div class="club40-support-programms-slider-nav-prev">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_9432_18847)">
                                    <g filter="url(#filter0_b_9432_18847)">
                                        <rect y="40" width="40" height="40" transform="rotate(-90 0 40)" fill="black" />
                                    </g>
                                    <path d="M13.1905 19.9993L26.8105 19.9993" stroke="white" stroke-width="2.64201"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M19.4629 26.2453L13.1896 19.9986L19.4629 13.752" stroke="white"
                                        stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <filter id="filter0_b_9432_18847" x="-18.1166" y="-18.1166" width="76.2332"
                                        height="76.2332" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                        <feComposite in2="SourceAlpha" operator="in"
                                            result="effect1_backgroundBlur_9432_18847" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_9432_18847"
                                            result="shape" />
                                    </filter>
                                    <clipPath id="clip0_9432_18847">
                                        <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)"
                                            fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="club40-support-programms-slider-nav-next">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_9432_18851)">
                                    <g filter="url(#filter0_b_9432_18851)">
                                        <rect x="40" width="40" height="40" transform="rotate(90 40 0)" fill="black" />
                                    </g>
                                    <path d="M26.8095 20.0007L13.1895 20.0007" stroke="white" stroke-width="2.64201"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M20.5371 13.7547L26.8104 20.0014L20.5371 26.248" stroke="white"
                                        stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <filter id="filter0_b_9432_18851" x="-18.1166" y="-18.1166" width="76.2332"
                                        height="76.2332" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                        <feComposite in2="SourceAlpha" operator="in"
                                            result="effect1_backgroundBlur_9432_18851" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_9432_18851"
                                            result="shape" />
                                    </filter>
                                    <clipPath id="clip0_9432_18851">
                                        <rect x="40" width="40" height="40" rx="20" transform="rotate(90 40 0)"
                                            fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </div>
                    <div class="club40-support-mats-slider-wrapper">
                        <p class="club40-support-mats-slider-header">Авторы курсов — ведущие карьерные эксперты и стратеги
                        </p>
                        <div class="club40-support-mats-slider-items">
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285436842-nmhub-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Ольга Лермонтова</p>
                                <p class="club40-support-mats-slider-item-position">фаундер Careerum</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Занимала руководящие должности в Google и Microsoft</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Управляла бизнесом на 20+ рынках Африки и Европы</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>12 000+ клиентов из РФ, СНГ, Европы, Америки </p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Италия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437123-F7q7s-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Елена Резанова</p>
                                <p class="club40-support-mats-slider-item-position">карьерный стратег</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>9+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогает посмотреть на карьеру целостно и соотнести ее с целями бизнеса.</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Автор книг-бестселлеров «Никогда-нибудь» и «Это норм!»</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Монако </p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437246-oRSRS-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Sophie Vurpillot</p>
                                <p class="club40-support-mats-slider-item-position">рекрутер и коуч</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>10+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогла специалистам из 20+ стран раскрыть потенциал</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Сотрудничала с университетами Европы, США и Латинской Америки</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Испания</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437367-I19r8-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Анна Бабич</p>
                                <p class="club40-support-mats-slider-item-position">психолог</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Терапевт в сфере АСТ и эмоционально-фокусированной терапии</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Автор книги-бестселлера «Внутренняя опора»</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Спикер конференций: Psychologies, TeamLead, CodeFest</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Россия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437505-QfSia-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Montse Lorente</p>
                                <p class="club40-support-mats-slider-item-position">рекрутер и коуч</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>10+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогла специалистам из 20+ стран раскрыть потенциал</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Сотрудничала с университетами Европы, США и Латинской Америки.</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Перу</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437627-rUPvo-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Санжар Ибрагимов</p>
                                <p class="club40-support-mats-slider-item-position">ментор</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Опыт в консалтинге в McKinsey & Company, PwC, World Bank Group</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>MBA в швейцарской бизнес-школе IMD</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Ментор в IMD International и Aalto Business School</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Финляндия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437755-4zqkR-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Наталья Токарь</p>
                                <p class="club40-support-mats-slider-item-position">эксперт по коммуникации</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>CEO проекта по обучению команд маркетинга, продаж, проджект-менеджеров и
                                            руководителей</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Ментор в бизнес-акселераторе Чикаго</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>США</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="club40-support-slider-nav careerum-flex-fec">
                        <div class="club40-support-mats-slider-nav-prev">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_9432_18847)">
                                    <g filter="url(#filter0_b_9432_18847)">
                                        <rect y="40" width="40" height="40" transform="rotate(-90 0 40)" fill="black" />
                                    </g>
                                    <path d="M13.1905 19.9993L26.8105 19.9993" stroke="white" stroke-width="2.64201"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M19.4629 26.2453L13.1896 19.9986L19.4629 13.752" stroke="white"
                                        stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <filter id="filter0_b_9432_18847" x="-18.1166" y="-18.1166" width="76.2332"
                                        height="76.2332" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                        <feComposite in2="SourceAlpha" operator="in"
                                            result="effect1_backgroundBlur_9432_18847" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_9432_18847"
                                            result="shape" />
                                    </filter>
                                    <clipPath id="clip0_9432_18847">
                                        <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)"
                                            fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="club40-support-mats-slider-nav-next">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_9432_18851)">
                                    <g filter="url(#filter0_b_9432_18851)">
                                        <rect x="40" width="40" height="40" transform="rotate(90 40 0)" fill="black" />
                                    </g>
                                    <path d="M26.8095 20.0007L13.1895 20.0007" stroke="white" stroke-width="2.64201"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M20.5371 13.7547L26.8104 20.0014L20.5371 26.248" stroke="white"
                                        stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <filter id="filter0_b_9432_18851" x="-18.1166" y="-18.1166" width="76.2332"
                                        height="76.2332" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                        <feComposite in2="SourceAlpha" operator="in"
                                            result="effect1_backgroundBlur_9432_18851" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_9432_18851"
                                            result="shape" />
                                    </filter>
                                    <clipPath id="clip0_9432_18851">
                                        <rect x="40" width="40" height="40" rx="20" transform="rotate(90 40 0)"
                                            fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </div>
                    <div class="club40-support-button">
                        <a href="#buy" class="btn-color-main-dark-orange">
                            Выбрать тариф
                        </a>
                    </div>
                </div>
                <div class="club40-support-mats">
                    <div class="club40-support-mats-top careerum-flex-sbfs">
                        <div>
                            <div class="club40-support-label careerum-flex-fsfs">
                                <p>02 Карьерные консультации</p>
                            </div>
                            <p class="club40-support-header">Команда карьерных коучей и экспертов с международной
                                сертификацией PCC ICF </p>
                        </div>
                        <div>
                            <div>
                                <p>3800+</p>
                                <p>часов проведенных сессий</p>
                                <p>9,5/10</p>
                                <p>средняя оценка карьерных экспертов</p>
                            </div>
                        </div>
                    </div>
                    <div class="club40-support-experts-slider">
                        <div class="club40-support-experts-slider-item-about">
                            <div>
                                <div>
                                    <p class="club40-support-experts-slider-item-text">Помогут достичь вашей цели: </p>
                                    <ul>
                                        <li class="position-relative">написать сильное резюме</li>
                                        <li class="position-relative">усилить профиль LinkedIn</li>
                                        <li class="position-relative">потренировать собеседование</li>
                                        <li class="position-relative">поставить карьерную цель</li>
                                        <li class="position-relative">усилить сопро-водительное</li>
                                        <li class="position-relative">подготовиться к переговорам по офферу</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280806527-AkUu1-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Елена Добринская</p>
                            <p class="club40-support-experts-slider-item-position">PCC ICF </p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>10+ лет в коучинге и финансах </p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1700+ клиентам обрести уверенность и подготовиться к собеседованиям</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Sony, Ernst&Young, Deloitte</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>ОАЭ</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409766-cqwPu-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Софи Бессон</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>6+ в HR и карьерном консультировании</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 700+ клиентам составить резюме и найти работу в Европе, США и Канаде</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Disney, Intel, Microsoft</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Израиль</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409265-9vjpf-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Надежда Община</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>9+ лет в маркетинге и консультировании</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 550+ клиентам из США, Европы и СНГ найти работу и сменить карьеру</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Airbus, Hubspot, Google, Farfetch</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Португалия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410646-Tg23o-ÑÐ¼.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Яна Хмельницкая</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>15+ лет в HR, карьерном коучинге и закупках</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 800+ клиентам подготовиться к интервью на английском языке и релоцироваться
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Ford, Leroy Merlin, Unilever, Mars</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Турция</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410772-6unNS-ÑÐ¼.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Оксана Сыпченко</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>11+ лет в карьерном коучинге и гос.секторе</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 100+ клиентам найти карьерный вектор, стать увереннее в себе и получить
                                        повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками ERG, DevExpress, Роснефть</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Конго</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410266-0RLoj-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Елена Эльзенбах</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>11+ лет опыта в коучинге, НКО и EdTech</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1300+ клиентам из РФ, Европы и СНГ получить оффер через укрепление самооценки
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Lamoda, Яндекс, Mail, InDriver</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410383-HztZL-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Виктория Албаутова</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICU</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в коучинге и маркетинге</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 150+ клиентам построить выигрышные стратегии и бренды</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с компаниями Beiesdorf, Philips, Johnson&Johnson, Novartis</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Турция</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410508-UN5w7-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Светлана Шуйская</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в коучинге и закупках</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 300+ клиентам вырасти в доходе, составить стратегию, начать свое дело</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Metro Cash&Carry, Yandex, Avito</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409625-XnYoE-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Мария Пудалова</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>7+ лет в PR и стратегии выстраивания бренда</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 400+ клиентам улучшить CV и найти работу в Европе и США</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Deloitte, BBDO, Microsoft</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Германия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409884-sm2PF-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Астра Висаева</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>10+ лет в коучинге, финансах и инвестициях</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 2500+ клиентам определить карьерные вектора и найти работу в России, ЕС и США
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками OZON, EPAM, McKinsey, Nike</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410030-PrNQ2-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Марина Веденичева</p>
                            <p class="club40-support-experts-slider-item-position">Коуч PCC ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в HR и карьерном коучинге</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 2000+ клиентам усилить лидерские качества и получить повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Mars, Shell, Ernst & Young</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Великобритания</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410151-lWIq0-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Ирина Шутова</p>
                            <p class="club40-support-experts-slider-item-position">Коуч AFC</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>6+ лет в коучинге и коммуникациях</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1000+ клиентам получить офферы с релокацией и повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками PepsiCo, Amazon, VK, Pfizer</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="club40-support-slider-nav careerum-flex-fec">
                        <div class="club40-support-experts-slider-nav-prev">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_9432_18847)">
                                    <g filter="url(#filter0_b_9432_18847)">
                                        <rect y="40" width="40" height="40" transform="rotate(-90 0 40)" fill="black" />
                                    </g>
                                    <path d="M13.1905 19.9993L26.8105 19.9993" stroke="white" stroke-width="2.64201"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M19.4629 26.2453L13.1896 19.9986L19.4629 13.752" stroke="white"
                                        stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <filter id="filter0_b_9432_18847" x="-18.1166" y="-18.1166" width="76.2332"
                                        height="76.2332" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                        <feComposite in2="SourceAlpha" operator="in"
                                            result="effect1_backgroundBlur_9432_18847" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_9432_18847"
                                            result="shape" />
                                    </filter>
                                    <clipPath id="clip0_9432_18847">
                                        <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)"
                                            fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="club40-support-experts-slider-nav-next">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_9432_18851)">
                                    <g filter="url(#filter0_b_9432_18851)">
                                        <rect x="40" width="40" height="40" transform="rotate(90 40 0)" fill="black" />
                                    </g>
                                    <path d="M26.8095 20.0007L13.1895 20.0007" stroke="white" stroke-width="2.64201"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M20.5371 13.7547L26.8104 20.0014L20.5371 26.248" stroke="white"
                                        stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <filter id="filter0_b_9432_18851" x="-18.1166" y="-18.1166" width="76.2332"
                                        height="76.2332" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                        <feComposite in2="SourceAlpha" operator="in"
                                            result="effect1_backgroundBlur_9432_18851" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_9432_18851"
                                            result="shape" />
                                    </filter>
                                    <clipPath id="clip0_9432_18851">
                                        <rect x="40" width="40" height="40" rx="20" transform="rotate(90 40 0)"
                                            fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="club40-support-info careerum-flex-sbst">
                    <div class="club40-support-mers">
                        <div class="club40-support-label careerum-flex-fsfs">
                            <p>03 Careerum.Club</p>
                        </div>
                        <p class="club40-support-header">Сообщество русскоговорящих профессионалов из 30+ стран</p>
                        <p class="club40-support-mers-text">C Careerum.Club вы сможете:</p>
                        <ul>
                            <li class="position-relative"> Собрать информацию из первых уст о компании, в которую хотите
                                попасть
                            </li>
                            <li class="position-relative">Найти рефералов и попросить рекомендовать вас в компанию на
                                выбранную позицию</li>
                            <li class="position-relative">Легче интегрироваться в новой стране и найти близких по духу людей
                            </li>
                            <li class="position-relative">Расширить нетворкинг — знакомства со специалистами разного уровня:
                                от junior до C-level. Найти партнеров и будущих сотрудников</li>
                        </ul>
                    </div>
                    <div class="club40-support-netw">
                        <div class="club40-support-label careerum-flex-fsfs">
                            <p>04 Живые онлайн-встречи</p>
                        </div>
                        <p class="club40-support-header">Практикумы и Q&A-эфиры</p>
                        <p class="club40-support-content"><span>Q&A-эфиры</span> — вместе с карьерными экспертами и другими
                            участниками прорабатываем карьерные вопросы от резюме до поиска себя в профессии.</p>
                        <p class="club40-support-content"><span>Практикумы</span> — практический группой формат, где
                            в группе решаются карьерные кейсы.</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733908074317-0OqMT-Fram.png"
                            alt="">
                    </div>
                </div>
            <div class="club40-support-about">
                <div class="club40-support-label careerum-flex-fsfs">
                    <p>03 Careerum.Club</p>
                </div>
                <p class="club40-support-header">Доступ к нетворк-сообществу русскоговорящих профессионалов из 30+ стран
                </p>
                <div class="careerum-flex-sbst">
                    <div class="club40-support-about-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737664719341-9oeGC-Edit.svg"
                            alt="">
                        <p>Соберете информацию из первых уст о компании, в которую хотите попасть</p>
                    </div>
                    <div class="club40-support-about-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737664719233-GNWR7-Prof.svg"
                            alt="">
                        <p>Найдете рефералов, чтобы получить рекомендации в компанию на выбранную позицию</p>
                    </div>
                    <div class="club40-support-about-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737664718978-8TCQz-Docu.svg"
                            alt="">
                        <p>Расширите нетворкинг со специалистами разного уровня: от junior до C-level</p>
                    </div>
                </div>
            </div>
            <div class="club40-support-banner">
                <div class="club40-support-label careerum-flex-fsfs">
                    <p>04 Интенсивы</p>
                </div>
                <p class="club40-support-header">Наш флагманский формат, который за короткое время поможет достичь
                    поставленной карьерной цели</p>
                <div class="club40-support-banner-item">
                    <div class="club40-support-banner-bg position-relative">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665441926-MVqRi-Vect.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665441820-YTSpe-Grou.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665441428-qYqGj-Grou.png"
                            alt="" class="position-absolute">
                    </div>
                    <div class="club40-support-banner-labels careerum-flex-fsfs">
                        <div class="careerum-flex-fsc img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                                alt="">
                            <p>Старт: 19 февраля</p>
                        </div>
                        <div>
                            <p>7 поток</p>
                        </div>
                    </div>
                    <p class="club40-support-banner-subheader">Набор на интенсив:</p>
                    <p class="club40-support-banner-header">Звездный кандидат</p>
                    <ul>
                        <li>
                            Составите продающее резюме
                        </li>
                        <li>
                            Усилите профиль LinkedIn
                        </li>
                        <li>
                            Определите стратегию вашего поиска
                        </li>
                        <li>
                            Научитесь откликаться на вакансии и проходить<br> интервью
                        </li>
                        <li>
                            Освоите переговоры по офферу на ваших условиях
                        </li>
                    </ul>
                    <a href="" class="btn-color-main-black">Узнать подробнее</a>
                </div>
                <div class="club40-support-banner-item2">
                    <div class="careerum-flex-fsfs">
                        <div class="club40-support-banner-item2-label-orange careerum-flex-cc">
                            <p>В подписке Careerum</p>
                        </div>
                        <div class="club40-support-banner-item2-label careerum-flex-cc">
                            <svg width="25" height="26" viewBox="0 0 25 26" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M20.4828 4.7431L5.48276 4.75692C5.06854 4.7573 4.73307 5.0934 4.73345 5.50761L4.74727 20.5076C4.74765 20.9218 5.08375 21.2573 5.49796 21.2569L20.498 21.2431C20.9122 21.2427 21.2476 20.9066 21.2473 20.4924L21.2334 5.49241C21.2331 5.0782 20.897 4.74272 20.4828 4.7431Z"
                                    stroke="#FF6A01" stroke-width="1.7825" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M17.4814 3.24586L17.4841 6.24586" stroke="#FF6A01" stroke-width="1.7825"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8.48138 3.25415L8.48415 6.25415" stroke="#FF6A01" stroke-width="1.7825"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M4.73691 9.25761L21.2369 9.2424" stroke="#FF6A01" stroke-width="1.7825"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M16.3654 12.9969L11.991 17.1259L9.61708 14.8781" stroke="#FF6A01"
                                    stroke-width="1.7825" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>

                            <p>Старт: 26 марта </p>
                        </div>
                        <div class="club40-support-banner-item2-label careerum-flex-cc">
                            <p>3 месяца</p>
                        </div>
                    </div>
                    <p class="club40-support-banner-item2-header">Power Talk</p>
                    <p class="club40-support-banner-item2-text">Курс по сильным коммуникациям<br>для прорыва <span>в карьере</span></p>
                    <a href="https://careerum.com/ru-ru/club/intensive/power-talk-2025" class="btn-color-main-black">Посмотреть программу</a>
                    <div class="position-relative">
                        <div>
                            <div class="position-absolute">реализация амбиций</div>
                            <div class="position-absolute">междyнародная карьера</div>
                            <div class="position-absolute">повышение</div>
                            <div class="position-absolute">лидерские позиции</div>
                            <div class="position-absolute">крутые проекты</div>
                            <div class="position-absolute">кайф от работы</div>
                            <div class="position-absolute">признание экспертизы</div>
                            <div class="position-absolute">рост дохода</div>
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741685782103-CmFT1-Grou.png" alt="" class="position-absolute">
                    </div>
                </div>
                <div class="club40-support-banner-item3 position-relative">
                    <div class="careerum-flex-fsfs">
                        <div class="club40-support-banner-item3-label careerum-flex-cc">
                            <svg width="25" height="26" viewBox="0 0 25 26" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M19.5035 4.74309L4.50346 4.75691C4.08925 4.75729 3.75377 5.09339 3.75415 5.5076L3.76797 20.5076C3.76836 20.9218 4.10445 21.2573 4.51867 21.2569L19.5187 21.2431C19.9329 21.2427 20.2684 20.9066 20.268 20.4924L20.2541 5.4924C20.2538 5.07818 19.9177 4.74271 19.5035 4.74309Z"
                                    stroke="#0B70FE" stroke-width="1.7825" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M16.5021 3.24585L16.5048 6.24585" stroke="#0B70FE" stroke-width="1.7825"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M7.50207 3.25415L7.50484 6.25415" stroke="#0B70FE" stroke-width="1.7825"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M3.75761 9.2576L20.2576 9.2424" stroke="#0B70FE" stroke-width="1.7825"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M15.3861 12.9969L11.0117 17.1259L8.63779 14.8781" stroke="#0B70FE"
                                    stroke-width="1.7825" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <p>26–27 апреля</p>
                        </div>
                        <div class="club40-support-banner-item3-label careerum-flex-cc">
                            <p>Практикум </p>
                        </div>
                    </div>
                    <p class="club40-support-banner-item3-header">Резюме<br> за выходные </p>
                    <p class="club40-support-banner-item3-text">Хватит терять вакансии и время!<br>Создайте резюме,
                        которое продаст вас</p>
                    <p class="club40-support-banner-item3-text-label position-absolute">с экспертом</p>
                    <a href="https://careerum.com/ru-ru/promo/weekend-resume?utm_source=web&utm_medium=ru-ru-club&utm_campaign=cv-weekend&utm_content=banner&utm_term=main"
                        class="btn-color-main-dark-orange">Посмотреть программу</a>
                </div>
            </div>
                <div class="club40-support-bottom-button">
                    <a href="#buy" class="btn-color-main-dark-orange">Выбрать тариф</a>
                </div>
            </div>
        </div>`
    });
    
    blockManager.add('club40-support2-tablet', {
        label: 'Club 4 support2 (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-support-tablet club40-support2-tablet">
            <div class="careerum-container-tablet">
                <h2 class="careerum-club40-header-tablet">Careerum — это обучение карьерным навыкам, поддержка экспертов,
                    профессиональный нетворкинг</h2>
                <div class="club40-support-experts">
                    <div class="club40-support-experts-top">
                        <div class="club40-support-label careerum-flex-fsfs">
                            <p>1. Образовательная платформа</p>
                        </div>
                        <p class="club40-support-header">80 курсов под любую карьерную задачу</p>
                    </div>
                    <div class="club40-support-programms-slider-items">
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Звёздный кандидат</p>
                            <p class="programms-slider-text">Эта программа — must see для всех, кто хоть раз искал работу.
                            </p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733903195877-jxP4N-pic..svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923137096-UO7U4-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Real Me: как найти себя </p>
                            <p class="programms-slider-text">Вы сможете лучше узнать себя настоящего и понять, чего вы
                                хотите для своей карьеры</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733903195760-k2i68-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136980-Rz3Af-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Международная карьера и релокация</p>
                            <p class="programms-slider-text">Вы узнаете всё о поиске работы в новых для вас странах, освоите
                                LinkedIn и научитесь учитывать культурный контекст</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733903195611-i209G-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136856-YVoxz-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Карьерная ракета</p>
                            <p class="programms-slider-text">Вы освоите базу карьерного мышления, узнаете, как расти в
                                зарплате и роли и научитесь планировать и добиваться даже самых амбициозных целей.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733903195276-Tuk6J-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136724-Jcd5H-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Работать не 24/7</p>
                            <p class="programms-slider-text">Вы повысите свою продуктивность и научитесь получать результаты
                                в проектах</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905207114-JpoWG-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136609-SntZn-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Самооценка и Деньги: не мешайте себе зарабатывать</p>
                            <p class="programms-slider-text">Вы преодолеете эти барьеры, присвоите свои таланты и научитесь
                                опираться на себя и свою ценность</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206995-CzHss-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136496-iK3of-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Публичные выступления</p>
                            <p class="programms-slider-text">Вы прокачаете навыки самопрезентации, научитесь бороться с
                                волнением и убедительно доносить свои мысли </p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206870-OTfik-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136368-XNklq-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Жизнь после оффера</p>
                            <p class="programms-slider-text">Вы узнаете, как быстро освоиться на новой работе и найти
                                контакт с руководителем и коллегами. </p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206754-7evbK-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136250-vxoGi-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Антикризис</p>
                            <p class="programms-slider-text">Вы узнаете, как оставаться ценным сотрудником даже во времена
                                сокращений</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206605-BqNcB-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136137-toVB5-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Карьера без стресса</p>
                            <p class="programms-slider-text">Вы освоите методы предотвращения стресса и выгорания,
                                прокачаете эмоциональный интеллект и настроите свой work-life balance.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206462-v4YrG-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136026-DlGgK-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Секреты нетворкинга</p>
                            <p class="programms-slider-text">Вы научитесь развивать и укреплять сеть контактов, освоите
                                small talk и elevator pitch и узнаете, как сформировать личный бренд.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206300-G4EiF-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135902-YaSxb-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Удалёнка</p>
                            <p class="programms-slider-text">Вы разберетесь, как организовать свою удаленную работу и
                                использовать все плюсы формата себе во благо</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206162-axyQs-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135782-HSOgY-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Коммуникация на работе</p>
                            <p class="programms-slider-text">Вы усилите навыки экологичного общения, научитесь достигать
                                своих целей в переговорах и разрешать конфликты</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206056-MnQUS-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135662-WTxmr-Fram.svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Open Mindset</p>
                            <p class="programms-slider-text">Вы разовьете разные виды мышления и научитесь смотреть на
                                задачи, проекты и ситуации под новыми, порой непривычными, углами. </p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205937-ZsoJe-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135534-kXWnQ-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Эффективный руководитель</p>
                            <p class="programms-slider-text">Вы освоите важные навыки руководителя, изучите лайфхаки по
                                взаимодействию в кросс-функциональных командах и лучше начнете понимать своего босса.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205773-omnR0-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135408-W8WQc-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Новые горизонты</p>
                            <p class="programms-slider-text">Вы узнаете, как сменить сферу и что делать, если вы прямо
                                сейчас оказались в точке выбора нового профессионального пути.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205629-EdGB4-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135278-gzlKn-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Карьера и финансы</p>
                            <p class="programms-slider-text">Вы узнаете, как добиться финансовой независимости и научитесь
                                грамотно распоряжаться своими деньгами.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205499-YmnJD-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135142-zfMz9-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Зарубежное образование</p>
                            <p class="programms-slider-text">Вы узнаете основные особенности обучения за рубежом и детально
                                рассмотрите поступление на MBA</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205377-zl9WX-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135022-KqJcY-Ð¸Ð».svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Выход из декрета</p>
                            <p class="programms-slider-text">Вы сможете преодолеть страхи и трудности, свойственные при
                                выходе из декрета, и узнаете, как вернуться к работе в бережном, но не менее эффективном
                                режиме.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205223-dT5vR-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923134903-TM6LM-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Мышление Boost</p>
                            <p class="programms-slider-text">Узнайте, как построить стратегию поиска работы, пройти все
                                этапы и получить оффер мечты</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905204858-qg4Um-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923134529-X2YUs-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                    </div>
                    <div class="club40-support-mats-slider-wrapper">
                        <p class="club40-support-mats-slider-header">Авторы курсов — ведущие карьерные эксперты и стратеги
                        </p>
                        <div class="club40-support-mats-slider-items">
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285436842-nmhub-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Ольга Лермонтова</p>
                                <p class="club40-support-mats-slider-item-position">фаундер Careerum</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Занимала руководящие должности в Google и Microsoft</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Управляла бизнесом на 20+ рынках Африки и Европы</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>12 000+ клиентов из РФ, СНГ, Европы, Америки </p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Италия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437123-F7q7s-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Елена Резанова</p>
                                <p class="club40-support-mats-slider-item-position">карьерный стратег</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>9+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогает посмотреть на карьеру целостно и соотнести ее с целями бизнеса.</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Автор книг-бестселлеров «Никогда-нибудь» и «Это норм!»</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Монако </p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437246-oRSRS-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Sophie Vurpillot</p>
                                <p class="club40-support-mats-slider-item-position">рекрутер и коуч</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>10+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогла специалистам из 20+ стран раскрыть потенциал</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Сотрудничала с университетами Европы, США и Латинской Америки</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Испания</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437367-I19r8-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Анна Бабич</p>
                                <p class="club40-support-mats-slider-item-position">психолог</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Терапевт в сфере АСТ и эмоционально-фокусированной терапии</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Автор книги-бестселлера «Внутренняя опора»</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Спикер конференций: Psychologies, TeamLead, CodeFest</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Россия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437505-QfSia-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Montse Lorente</p>
                                <p class="club40-support-mats-slider-item-position">рекрутер и коуч</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>10+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогла специалистам из 20+ стран раскрыть потенциал</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Сотрудничала с университетами Европы, США и Латинской Америки.</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Перу</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437627-rUPvo-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Санжар Ибрагимов</p>
                                <p class="club40-support-mats-slider-item-position">ментор</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Опыт в консалтинге в McKinsey & Company, PwC, World Bank Group</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>MBA в швейцарской бизнес-школе IMD</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Ментор в IMD International и Aalto Business School</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Финляндия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437755-4zqkR-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Наталья Токарь</p>
                                <p class="club40-support-mats-slider-item-position">эксперт по коммуникации</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>CEO проекта по обучению команд маркетинга, продаж, проджект-менеджеров и
                                            руководителей</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Ментор в бизнес-акселераторе Чикаго</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>США</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="club40-support-mats">
                    <div class="club40-support-mats-top careerum-flex-sbfs">
                        <div>
                            <div class="club40-support-label careerum-flex-fsfs">
                                <p>2. Карьерные консультации</p>
                            </div>
                            <p class="club40-support-header">Команда карьерных коучей и экспертов с международной
                                сертификацией PCC ICF </p>
                            <div class="careerum-flex-fsc">
                                <p>3800+</p>
                                <p>часов проведенных сессий</p>
                            </div>
                            <div class="careerum-flex-fsc">
                                <p>9,5/10</p>
                                <p>средняя оценка карьерных<br> экспертов</p>
                            </div>
                        </div>
                        <div>
                            <div>
                                <p>Помогут достичь вашей цели: </p>
                                <ul>
                                    <li class="position-relative">написать сильное резюме</li>
                                    <li class="position-relative">усилить профиль LinkedIn</li>
                                    <li class="position-relative">потренировать собеседование</li>
                                    <li class="position-relative">поставить карьерную цель</li>
                                    <li class="position-relative">усилить сопроводительное</li>
                                    <li class="position-relative">подготовиться к переговорам по офферу</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="club40-support-experts-slider">
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280806527-AkUu1-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Елена Добринская</p>
                            <p class="club40-support-experts-slider-item-position">PCC ICF </p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>10+ лет в коучинге и финансах </p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1700+ клиентам обрести уверенность и подготовиться к собеседованиям</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Sony, Ernst&Young, Deloitte</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>ОАЭ</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409766-cqwPu-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Софи Бессон</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>6+ в HR и карьерном консультировании</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 700+ клиентам составить резюме и найти работу в Европе, США и Канаде</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Disney, Intel, Microsoft</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Израиль</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409265-9vjpf-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Надежда Община</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>9+ лет в маркетинге и консультировании</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 550+ клиентам из США, Европы и СНГ найти работу и сменить карьеру</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Airbus, Hubspot, Google, Farfetch</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Португалия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410646-Tg23o-ÑÐ¼.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Яна Хмельницкая</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>15+ лет в HR, карьерном коучинге и закупках</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 800+ клиентам подготовиться к интервью на английском языке и релоцироваться
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Ford, Leroy Merlin, Unilever, Mars</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Турция</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410772-6unNS-ÑÐ¼.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Оксана Сыпченко</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>11+ лет в карьерном коучинге и гос.секторе</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 100+ клиентам найти карьерный вектор, стать увереннее в себе и получить
                                        повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками ERG, DevExpress, Роснефть</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Конго</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410266-0RLoj-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Елена Эльзенбах</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>11+ лет опыта в коучинге, НКО и EdTech</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1300+ клиентам из РФ, Европы и СНГ получить оффер через укрепление самооценки
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Lamoda, Яндекс, Mail, InDriver</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410383-HztZL-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Виктория Албаутова</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICU</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в коучинге и маркетинге</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 150+ клиентам построить выигрышные стратегии и бренды</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с компаниями Beiesdorf, Philips, Johnson&Johnson, Novartis</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Турция</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410508-UN5w7-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Светлана Шуйская</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в коучинге и закупках</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 300+ клиентам вырасти в доходе, составить стратегию, начать свое дело</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Metro Cash&Carry, Yandex, Avito</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409625-XnYoE-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Мария Пудалова</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>7+ лет в PR и стратегии выстраивания бренда</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 400+ клиентам улучшить CV и найти работу в Европе и США</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Deloitte, BBDO, Microsoft</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Германия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409884-sm2PF-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Астра Висаева</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>10+ лет в коучинге, финансах и инвестициях</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 2500+ клиентам определить карьерные вектора и найти работу в России, ЕС и США
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками OZON, EPAM, McKinsey, Nike</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410030-PrNQ2-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Марина Веденичева</p>
                            <p class="club40-support-experts-slider-item-position">Коуч PCC ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в HR и карьерном коучинге</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 2000+ клиентам усилить лидерские качества и получить повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Mars, Shell, Ernst & Young</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Великобритания</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410151-lWIq0-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Ирина Шутова</p>
                            <p class="club40-support-experts-slider-item-position">Коуч AFC</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>6+ лет в коучинге и коммуникациях</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1000+ клиентам получить офферы с релокацией и повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками PepsiCo, Amazon, VK, Pfizer</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="club40-support-info careerum-flex-sbst">
                    <div class="club40-support-mers">
                        <div class="club40-support-label careerum-flex-fsfs">
                            <p>3. Careerum.Club</p>
                        </div>
                        <p class="club40-support-header">Сообщество русскоговорящих профессионалов из 30+ стран</p>
                        <p class="club40-support-mers-text">C Careerum.Club вы сможете:</p>
                        <ul>
                            <li class="position-relative">Собрать информацию из первых уст<br> о компании, в которую хотите
                                попасть
                            </li>
                            <li class="position-relative">Найти рефералов и попросить рекомендовать вас в компанию<br> на
                                выбранную позицию</li>
                            <li class="position-relative">Легче интегрироваться в новой стране и найти близких по духу людей
                            </li>
                            <li class="position-relative">Расширить нетворкинг — знакомства со специалистами разного уровня:
                                от junior до C-level. Найти партнеров и будущих сотрудников</li>
                        </ul>
                    </div>
                    <div class="club40-support-netw">
                        <div class="club40-support-label careerum-flex-fsfs">
                            <p>4. Живые онлайн-встречи</p>
                        </div>
                        <p class="club40-support-header">Практикумы и Q&A-эфиры</p>
                        <p class="club40-support-content"><span>Q&A-эфиры</span> — вместе с карьерными экспертами и другими
                            участниками прорабатываем карьерные вопросы от резюме до поиска себя в профессии.</p>
                        <p class="club40-support-content"><span>Практикумы</span> — практический группой формат, где
                            в группе решаются карьерные кейсы.</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733925224291-duvri-Fram.png"
                            alt="">
                    </div>
                </div>
            <div class="club40-support-about">
                <div class="club40-support-label careerum-flex-fsfs">
                    <p>03 Careerum.Club</p>
                </div>
                <p class="club40-support-header">Доступ к нетворк-сообществу русскоговорящих профессионалов из 30+ стран
                </p>
                <div class="careerum-flex-sbst">
                    <div class="club40-support-about-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737664719341-9oeGC-Edit.svg"
                            alt="">
                        <p>Соберете информацию из первых уст о компании, в которую хотите попасть</p>
                    </div>
                    <div class="club40-support-about-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737664719233-GNWR7-Prof.svg"
                            alt="">
                        <p>Найдете рефералов, чтобы получить рекомендации в компанию на выбранную позицию</p>
                    </div>
                    <div class="club40-support-about-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737664718978-8TCQz-Docu.svg"
                            alt="">
                        <p>Расширите нетворкинг со специалистами разного уровня: от junior до C-level</p>
                    </div>
                </div>
            </div>
            <div class="club40-support-banner">
                <div class="club40-support-label careerum-flex-fsfs">
                    <p>04 Интенсивы</p>
                </div>
                <p class="club40-support-header">Наш флагманский формат, который за короткое время поможет достичь
                    поставленной карьерной цели</p>
                <div class="club40-support-banner-item">
                    <div class="club40-support-banner-bg position-relative">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737669158458-wxXKC-Vect.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737669158335-5Eip2-Grou.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737669157964-7CvXw-Grou.png"
                            alt="" class="position-absolute">
                    </div>
                    <div class="club40-support-banner-labels careerum-flex-fsfs">
                        <div class="careerum-flex-fsc img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                                alt="">
                            <p>Старт: 19 февраля</p>
                        </div>
                        <div>
                            <p>7 поток</p>
                        </div>
                    </div>
                    <p class="club40-support-banner-subheader">Набор на интенсив:</p>
                    <p class="club40-support-banner-header">Звездный кандидат</p>
                    <ul>
                        <li>
                            Составите продающее резюме
                        </li>
                        <li>
                            Усилите профиль LinkedIn
                        </li>
                        <li>
                            Определите стратегию вашего поиска
                        </li>
                        <li>
                            Научитесь откликаться на вакансии и<br> проходить интервью
                        </li>
                        <li>
                            Освоите переговоры по офферу на<br> ваших условиях
                        </li>
                    </ul>
                    <a href="" class="btn-color-main-black">Узнать подробнее</a>
                </div>
                <div class="club40-support-banner-item2">
                    <div class="careerum-flex-fsfs">
                        <div class="club40-support-banner-item2-label-orange careerum-flex-cc">
                            <p>В подписке Careerum</p>
                        </div>
                        <div class="club40-support-banner-item2-label careerum-flex-cc">
                            <svg width="25" height="26" viewBox="0 0 25 26" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M20.4828 4.7431L5.48276 4.75692C5.06854 4.7573 4.73307 5.0934 4.73345 5.50761L4.74727 20.5076C4.74765 20.9218 5.08375 21.2573 5.49796 21.2569L20.498 21.2431C20.9122 21.2427 21.2476 20.9066 21.2473 20.4924L21.2334 5.49241C21.2331 5.0782 20.897 4.74272 20.4828 4.7431Z"
                                    stroke="#FF6A01" stroke-width="1.7825" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M17.4814 3.24586L17.4841 6.24586" stroke="#FF6A01" stroke-width="1.7825"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8.48138 3.25415L8.48415 6.25415" stroke="#FF6A01" stroke-width="1.7825"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M4.73691 9.25761L21.2369 9.2424" stroke="#FF6A01" stroke-width="1.7825"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M16.3654 12.9969L11.991 17.1259L9.61708 14.8781" stroke="#FF6A01"
                                    stroke-width="1.7825" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>

                            <p>Старт: 26 марта </p>
                        </div>
                        <div class="club40-support-banner-item2-label careerum-flex-cc">
                            <p>3 месяца</p>
                        </div>
                    </div>
                    <p class="club40-support-banner-item2-header">Power Talk</p>
                    <p class="club40-support-banner-item2-text">Курс по сильным коммуникациям для прорыва<br> <span>в
                            карьере</span></p>
                    <a href="https://careerum.com/ru-ru/club/intensive/power-talk-2025"
                        class="btn-color-main-black">Посмотреть программу</a>
                    <div class="position-relative">
                        <div>
                            <div class="position-absolute">реализация амбиций</div>
                            <div class="position-absolute">междyнародная карьера</div>
                            <div class="position-absolute">повышение</div>
                            <div class="position-absolute">лидерские позиции</div>
                            <div class="position-absolute">крутые проекты</div>
                            <div class="position-absolute">кайф от работы</div>
                            <div class="position-absolute">признание экспертизы</div>
                            <div class="position-absolute">рост дохода</div>
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741686784070-bzFOY-Grou.png"
                            alt="" class="position-absolute">
                    </div>
                </div>
                <div class="club40-support-banner-item3 position-relative">
                    <div class="careerum-flex-fsfs">
                        <div class="club40-support-banner-item3-label careerum-flex-cc">
                            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.4845 4.24309L5.4845 4.25691C5.07028 4.25729 4.73481 4.59339 4.73519 5.0076L4.74901 20.0076C4.74939 20.4218 5.08548 20.7573 5.4997 20.7569L20.4997 20.7431C20.9139 20.7427 21.2494 20.4066 21.249 19.9924L21.2352 4.9924C21.2348 4.57818 20.8987 4.24271 20.4845 4.24309Z" stroke="#0B70FE" stroke-width="1.7825" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M17.4832 2.74586L17.4859 5.74586" stroke="#0B70FE" stroke-width="1.7825" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8.48315 2.75415L8.48592 5.75415" stroke="#0B70FE" stroke-width="1.7825" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M4.73865 8.7576L21.2386 8.7424" stroke="#0B70FE" stroke-width="1.7825" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M16.3672 12.4969L11.9929 16.6259L9.61891 14.3781" stroke="#0B70FE" stroke-width="1.7825" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>26–27 апреля</p>
                        </div>
                        <div class="club40-support-banner-item3-label careerum-flex-cc">
                            <p>Практикум </p>
                        </div>
                    </div>
                    <p class="club40-support-banner-item3-header">Резюме<br> за выходные </p>
                    <p class="club40-support-banner-item3-text">Хватит терять вакансии и время!<br>Создайте резюме,
                        которое продаст вас</p>
                    <p class="club40-support-banner-item3-text-label position-absolute">с экспертом</p>
                    <a href="https://careerum.com/ru-ru/promo/weekend-resume?utm_source=web&utm_medium=ru-ru-club&utm_campaign=cv-weekend&utm_content=banner&utm_term=main"
                        class="btn-color-main-dark-orange">Посмотреть программу</a>
                </div>
            </div>
                <div class="club40-support-bottom-button">
                    <a href="#buy" class="btn-color-main-dark-orange">Выбрать тариф</a>
                </div>
            </div>
        </div>`
    });
    
    blockManager.add('club40-support2-mobile', {
        label: 'Club 4 support2 (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-support-mobile club40-support2-mobile">
            <div class="careerum-container-mobile">
                <h2 class="careerum-club40-header-mobile">Careerum — это обучение карьерным навыкам, поддержка экспертов,
                    профессиональный нетворкинг</h2>
                <div class="club40-support-experts">
                    <div class="club40-support-experts-top">
                        <div class="club40-support-label careerum-flex-fsfs">
                            <p>01 Образовательная платформа</p>
                        </div>
                        <p class="club40-support-header">80 курсов под любую карьерную задачу</p>
                    </div>
                    <div class="club40-support-programms-slider-items">
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Звёздный кандидат</p>
                            <p class="programms-slider-text">Эта программа — must see для всех, кто хоть раз искал работу.
                            </p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733903195877-jxP4N-pic..svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923137096-UO7U4-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Real Me: как найти себя </p>
                            <p class="programms-slider-text">Вы сможете лучше узнать себя настоящего и понять, чего вы
                                хотите для своей карьеры</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733903195760-k2i68-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136980-Rz3Af-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Международная карьера и релокация</p>
                            <p class="programms-slider-text">Вы узнаете всё о поиске работы в новых для вас странах, освоите
                                LinkedIn и научитесь учитывать культурный контекст</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733903195611-i209G-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136856-YVoxz-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Карьерная ракета</p>
                            <p class="programms-slider-text">Вы освоите базу карьерного мышления, узнаете, как расти в
                                зарплате и роли и научитесь планировать и добиваться даже самых амбициозных целей.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733903195276-Tuk6J-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136724-Jcd5H-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Работать не 24/7</p>
                            <p class="programms-slider-text">Вы повысите свою продуктивность и научитесь получать результаты
                                в проектах</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905207114-JpoWG-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136609-SntZn-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Самооценка и Деньги: не мешайте себе зарабатывать</p>
                            <p class="programms-slider-text">Вы преодолеете эти барьеры, присвоите свои таланты и научитесь
                                опираться на себя и свою ценность</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206995-CzHss-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136496-iK3of-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Публичные выступления</p>
                            <p class="programms-slider-text">Вы прокачаете навыки самопрезентации, научитесь бороться с
                                волнением и убедительно доносить свои мысли </p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206870-OTfik-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136368-XNklq-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Жизнь после оффера</p>
                            <p class="programms-slider-text">Вы узнаете, как быстро освоиться на новой работе и найти
                                контакт с руководителем и коллегами. </p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206754-7evbK-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136250-vxoGi-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Антикризис</p>
                            <p class="programms-slider-text">Вы узнаете, как оставаться ценным сотрудником даже во времена
                                сокращений</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206605-BqNcB-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136137-toVB5-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Карьера без стресса</p>
                            <p class="programms-slider-text">Вы освоите методы предотвращения стресса и выгорания,
                                прокачаете эмоциональный интеллект и настроите свой work-life balance.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206462-v4YrG-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136026-DlGgK-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Секреты нетворкинга</p>
                            <p class="programms-slider-text">Вы научитесь развивать и укреплять сеть контактов, освоите
                                small talk и elevator pitch и узнаете, как сформировать личный бренд.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206300-G4EiF-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135902-YaSxb-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Удалёнка</p>
                            <p class="programms-slider-text">Вы разберетесь, как организовать свою удаленную работу и
                                использовать все плюсы формата себе во благо</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206162-axyQs-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135782-HSOgY-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Коммуникация на работе</p>
                            <p class="programms-slider-text">Вы усилите навыки экологичного общения, научитесь достигать
                                своих целей в переговорах и разрешать конфликты</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206056-MnQUS-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135662-WTxmr-Fram.svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Open Mindset</p>
                            <p class="programms-slider-text">Вы разовьете разные виды мышления и научитесь смотреть на
                                задачи, проекты и ситуации под новыми, порой непривычными, углами. </p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205937-ZsoJe-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135534-kXWnQ-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Эффективный руководитель</p>
                            <p class="programms-slider-text">Вы освоите важные навыки руководителя, изучите лайфхаки по
                                взаимодействию в кросс-функциональных командах и лучше начнете понимать своего босса.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205773-omnR0-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135408-W8WQc-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Новые горизонты</p>
                            <p class="programms-slider-text">Вы узнаете, как сменить сферу и что делать, если вы прямо
                                сейчас оказались в точке выбора нового профессионального пути.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205629-EdGB4-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135278-gzlKn-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Карьера и финансы</p>
                            <p class="programms-slider-text">Вы узнаете, как добиться финансовой независимости и научитесь
                                грамотно распоряжаться своими деньгами.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205499-YmnJD-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135142-zfMz9-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Зарубежное образование</p>
                            <p class="programms-slider-text">Вы узнаете основные особенности обучения за рубежом и детально
                                рассмотрите поступление на MBA</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205377-zl9WX-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135022-KqJcY-Ð¸Ð».svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Выход из декрета</p>
                            <p class="programms-slider-text">Вы сможете преодолеть страхи и трудности, свойственные при
                                выходе из декрета, и узнаете, как вернуться к работе в бережном, но не менее эффективном
                                режиме.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205223-dT5vR-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923134903-TM6LM-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Мышление Boost</p>
                            <p class="programms-slider-text">Узнайте, как построить стратегию поиска работы, пройти все
                                этапы и получить оффер мечты</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905204858-qg4Um-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923134529-X2YUs-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                    </div>
                    <div class="club40-support-mats-slider-wrapper">
                        <p class="club40-support-mats-slider-header">Авторы курсов — ведущие карьерные эксперты и стратеги
                        </p>
                        <div class="club40-support-mats-slider-items">
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285436842-nmhub-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Ольга Лермонтова</p>
                                <p class="club40-support-mats-slider-item-position">фаундер Careerum</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Занимала руководящие должности в Google и Microsoft</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Управляла бизнесом на 20+ рынках Африки и Европы</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>12 000+ клиентов из РФ, СНГ, Европы, Америки </p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Италия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437123-F7q7s-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Елена Резанова</p>
                                <p class="club40-support-mats-slider-item-position">карьерный стратег</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>9+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогает посмотреть на карьеру целостно и соотнести ее с целями бизнеса.</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Автор книг-бестселлеров «Никогда-нибудь» и «Это норм!»</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Монако </p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437246-oRSRS-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Sophie Vurpillot</p>
                                <p class="club40-support-mats-slider-item-position">рекрутер и коуч</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>10+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогла специалистам из 20+ стран раскрыть потенциал</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Сотрудничала с университетами Европы, США и Латинской Америки</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Испания</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437367-I19r8-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Анна Бабич</p>
                                <p class="club40-support-mats-slider-item-position">психолог</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Терапевт в сфере АСТ и эмоционально-фокусированной терапии</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Автор книги-бестселлера «Внутренняя опора»</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Спикер конференций: Psychologies, TeamLead, CodeFest</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Россия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437505-QfSia-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Montse Lorente</p>
                                <p class="club40-support-mats-slider-item-position">рекрутер и коуч</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>10+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогла специалистам из 20+ стран раскрыть потенциал</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Сотрудничала с университетами Европы, США и Латинской Америки.</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Перу</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437627-rUPvo-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Санжар Ибрагимов</p>
                                <p class="club40-support-mats-slider-item-position">ментор</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Опыт в консалтинге в McKinsey & Company, PwC, World Bank Group</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>MBA в швейцарской бизнес-школе IMD</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Ментор в IMD International и Aalto Business School</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Финляндия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437755-4zqkR-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Наталья Токарь</p>
                                <p class="club40-support-mats-slider-item-position">эксперт по коммуникации</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>CEO проекта по обучению команд маркетинга, продаж, проджект-менеджеров и
                                            руководителей</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Ментор в бизнес-акселераторе Чикаго</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>США</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="club40-support-button">
                        <a href="#buy" class="btn-color-main-dark-orange">
                            Выбрать тариф
                        </a>
                    </div>
                </div>
                <div class="club40-support-mats">
                    <div class="club40-support-mats-top careerum-flex-sbfs">
                        <div>
                            <div class="club40-support-label careerum-flex-fsfs">
                                <p>02 Карьерные консультации</p>
                            </div>
                            <p class="club40-support-header">Команда карьерных коучей и экспертов с международной
                                сертификацией PCC ICF </p>
                            <div class="careerum-flex-fsc">
                                <p>3800+</p>
                                <p>часов проведенных сессий</p>
                            </div>
                            <div class="careerum-flex-fsc">
                                <p>9,5/10</p>
                                <p>средняя оценка карьерных<br> экспертов</p>
                            </div>
                        </div>
                        <div>
                            <div>
                                <p>Помогут достичь вашей цели: </p>
                                <ul>
                                    <li class="position-relative">написать сильное резюме</li>
                                    <li class="position-relative">усилить профиль LinkedIn</li>
                                    <li class="position-relative">потренировать собеседование</li>
                                    <li class="position-relative">поставить карьерную цель</li>
                                    <li class="position-relative">усилить сопроводительное</li>
                                    <li class="position-relative">подготовиться к переговорам по офферу</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="club40-support-experts-slider">
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280806527-AkUu1-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Елена Добринская</p>
                            <p class="club40-support-experts-slider-item-position">PCC ICF </p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>10+ лет в коучинге и финансах </p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1700+ клиентам обрести уверенность и подготовиться к собеседованиям</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Sony, Ernst&Young, Deloitte</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>ОАЭ</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409766-cqwPu-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Софи Бессон</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>6+ в HR и карьерном консультировании</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 700+ клиентам составить резюме и найти работу в Европе, США и Канаде</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Disney, Intel, Microsoft</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Израиль</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409265-9vjpf-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Надежда Община</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>9+ лет в маркетинге и консультировании</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 550+ клиентам из США, Европы и СНГ найти работу и сменить карьеру</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Airbus, Hubspot, Google, Farfetch</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Португалия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410646-Tg23o-ÑÐ¼.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Яна Хмельницкая</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>15+ лет в HR, карьерном коучинге и закупках</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 800+ клиентам подготовиться к интервью на английском языке и релоцироваться
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Ford, Leroy Merlin, Unilever, Mars</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Турция</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410772-6unNS-ÑÐ¼.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Оксана Сыпченко</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>11+ лет в карьерном коучинге и гос.секторе</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 100+ клиентам найти карьерный вектор, стать увереннее в себе и получить
                                        повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками ERG, DevExpress, Роснефть</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Конго</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410266-0RLoj-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Елена Эльзенбах</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>11+ лет опыта в коучинге, НКО и EdTech</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1300+ клиентам из РФ, Европы и СНГ получить оффер через укрепление самооценки
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Lamoda, Яндекс, Mail, InDriver</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410383-HztZL-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Виктория Албаутова</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICU</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в коучинге и маркетинге</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 150+ клиентам построить выигрышные стратегии и бренды</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с компаниями Beiesdorf, Philips, Johnson&Johnson, Novartis</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Турция</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410508-UN5w7-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Светлана Шуйская</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в коучинге и закупках</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 300+ клиентам вырасти в доходе, составить стратегию, начать свое дело</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Metro Cash&Carry, Yandex, Avito</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409625-XnYoE-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Мария Пудалова</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>7+ лет в PR и стратегии выстраивания бренда</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 400+ клиентам улучшить CV и найти работу в Европе и США</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Deloitte, BBDO, Microsoft</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Германия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409884-sm2PF-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Астра Висаева</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>10+ лет в коучинге, финансах и инвестициях</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 2500+ клиентам определить карьерные вектора и найти работу в России, ЕС и США
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками OZON, EPAM, McKinsey, Nike</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410030-PrNQ2-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Марина Веденичева</p>
                            <p class="club40-support-experts-slider-item-position">Коуч PCC ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в HR и карьерном коучинге</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 2000+ клиентам усилить лидерские качества и получить повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Mars, Shell, Ernst & Young</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Великобритания</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410151-lWIq0-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Ирина Шутова</p>
                            <p class="club40-support-experts-slider-item-position">Коуч AFC</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>6+ лет в коучинге и коммуникациях</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1000+ клиентам получить офферы с релокацией и повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками PepsiCo, Amazon, VK, Pfizer</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="club40-support-info careerum-flex-sbst">
                    <div class="club40-support-mers">
                        <div class="club40-support-label careerum-flex-fsfs">
                            <p>3. Careerum.Club</p>
                        </div>
                        <p class="club40-support-header">Сообщество русскоговорящих профессионалов из 30+ стран</p>
                        <p class="club40-support-mers-text">C Careerum.Club вы сможете:</p>
                        <ul>
                            <li class="position-relative">Собрать информацию из первых уст<br> о компании, в которую хотите
                                попасть
                            </li>
                            <li class="position-relative">Найти рефералов и попросить рекомендовать вас в компанию<br> на
                                выбранную позицию</li>
                            <li class="position-relative">Легче интегрироваться в новой стране и найти близких по духу людей
                            </li>
                            <li class="position-relative">Расширить нетворкинг — знакомства со специалистами разного уровня:
                                от junior до C-level. Найти партнеров и будущих сотрудников</li>
                        </ul>
                    </div>
                    <div class="club40-support-netw">
                        <div class="club40-support-label careerum-flex-fsfs">
                            <p>4. Живые онлайн-встречи</p>
                        </div>
                        <p class="club40-support-header">Практикумы и Q&A-эфиры</p>
                        <p class="club40-support-content"><span>Q&A-эфиры</span> — вместе с карьерными экспертами и другими
                            участниками прорабатываем карьерные вопросы от резюме до поиска себя в профессии.</p>
                        <p class="club40-support-content"><span>Практикумы</span> — практический группой формат, где
                            в группе решаются карьерные кейсы.</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733925224291-duvri-Fram.png"
                            alt="">
                    </div>
                </div>
            <div class="club40-support-about">
                <div class="club40-support-label careerum-flex-fsfs">
                    <p>03 Careerum.Club</p>
                </div>
                <p class="club40-support-header">Доступ к нетворк-сообществу русскоговорящих профессионалов из 30+ стран
                </p>
                <div class="careerum-flex-sbst">
                    <div class="club40-support-about-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737664719341-9oeGC-Edit.svg"
                            alt="">
                        <p>Соберете информацию из первых уст о компании, в которую хотите попасть</p>
                    </div>
                    <div class="club40-support-about-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737664719233-GNWR7-Prof.svg"
                            alt="">
                        <p>Найдете рефералов, чтобы получить рекомендации в компанию на выбранную позицию</p>
                    </div>
                    <div class="club40-support-about-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737664718978-8TCQz-Docu.svg"
                            alt="">
                        <p>Расширите нетворкинг со специалистами разного уровня: от junior до C-level</p>
                    </div>
                </div>
            </div>
            <div class="club40-support-banner">
                <div class="club40-support-label careerum-flex-fsfs">
                    <p>04 Интенсивы</p>
                </div>
                <p class="club40-support-header">Наш флагманский формат, который за короткое время поможет достичь
                    поставленной карьерной цели</p>
                <div class="club40-support-banner-item">
                    <div class="club40-support-banner-bg position-relative">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737669158458-wxXKC-Vect.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737669158335-5Eip2-Grou.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737701847250-tYsQq-Grou.png"
                            alt="" class="position-absolute">
                    </div>
                    <div class="club40-support-banner-labels careerum-flex-fsfs">
                        <div class="careerum-flex-cc img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                                alt="">
                            <p>Старт: 19 февраля</p>
                        </div>
                        <div>
                            <p>7 поток</p>
                        </div>
                    </div>
                    <p class="club40-support-banner-subheader">Набор на интенсив:</p>
                    <p class="club40-support-banner-header">Звездный кандидат</p>
                    <ul>
                        <li>
                            Составите продающее резюме
                        </li>
                        <li>
                            Усилите профиль LinkedIn
                        </li>
                        <li>
                            Определите стратегию вашего поиска
                        </li>
                        <li>
                            Научитесь откликаться на вакансии и<br> проходить интервью
                        </li>
                        <li>
                            Освоите переговоры по офферу на<br> ваших условиях
                        </li>
                    </ul>
                    <a href="" class="btn-color-main-black">Узнать подробнее</a>
                </div>
                <div class="club40-support-banner-item2">
                    <div class="careerum-flex-fsfs">
                        <div class="club40-support-banner-item2-label-orange careerum-flex-cc">
                            <p>В подписке Careerum</p>
                        </div>
                        <div class="club40-support-banner-item2-label careerum-flex-cc">
                            <p>Старт: 26 марта </p>
                        </div>
                        <div class="club40-support-banner-item2-label careerum-flex-cc">
                            <p>3 месяца</p>
                        </div>
                    </div>
                    <p class="club40-support-banner-item2-header">Power Talk</p>
                    <p class="club40-support-banner-item2-text">Курс по сильным коммуникациям для прорыва <span>в
                            карьере</span></p>
                    <div class="position-relative club40-support-banner-imgs">
                        <div>
                            <div class="position-absolute">реализация амбиций</div>
                            <div class="position-absolute">междyнародная карьера</div>
                            <div class="position-absolute">повышение</div>
                            <div class="position-absolute">лидерские позиции</div>
                            <div class="position-absolute">крутые проекты</div>
                            <div class="position-absolute">кайф от работы</div>
                            <div class="position-absolute">признание экспертизы</div>
                            <div class="position-absolute">рост дохода</div>
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741687185091-7AUE8-Grou.png"
                            alt="" class="position-absolute">
                    </div>
                    <a href="https://careerum.com/ru-ru/club/intensive/power-talk-2025"
                        class="btn-color-main-black">Посмотреть программу</a>
                </div>
                <div class="club40-support-banner-item3 position-relative">
                    <div class="careerum-flex-fsfs">
                        <div class="club40-support-banner-item3-label careerum-flex-cc">
                            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.4845 4.24309L5.4845 4.25691C5.07028 4.25729 4.73481 4.59339 4.73519 5.0076L4.74901 20.0076C4.74939 20.4218 5.08548 20.7573 5.4997 20.7569L20.4997 20.7431C20.9139 20.7427 21.2494 20.4066 21.249 19.9924L21.2352 4.9924C21.2348 4.57818 20.8987 4.24271 20.4845 4.24309Z" stroke="#0B70FE" stroke-width="1.7825" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M17.4832 2.74586L17.4859 5.74586" stroke="#0B70FE" stroke-width="1.7825" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8.48315 2.75415L8.48592 5.75415" stroke="#0B70FE" stroke-width="1.7825" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M4.73865 8.7576L21.2386 8.7424" stroke="#0B70FE" stroke-width="1.7825" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M16.3672 12.4969L11.9929 16.6259L9.61891 14.3781" stroke="#0B70FE" stroke-width="1.7825" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>26–27 апреля</p>
                        </div>
                        <div class="club40-support-banner-item3-label careerum-flex-cc">
                            <p>Практикум </p>
                        </div>
                    </div>
                    <p class="club40-support-banner-item3-header">Резюме<br> за выходные </p>
                    <p class="club40-support-banner-item3-text">Хватит терять вакансии и время!<br>Создайте резюме,
                        которое продаст вас</p>
                    <p class="club40-support-banner-item3-text-label position-absolute">с экспертом</p>
                    <a href="https://careerum.com/ru-ru/promo/weekend-resume?utm_source=web&utm_medium=ru-ru-club&utm_campaign=cv-weekend&utm_content=banner&utm_term=main"
                        class="btn-color-main-dark-orange">Посмотреть программу</a>
                </div>
            </div>
                <div class="club40-support-bottom-button">
                    <a href="#buy" class="btn-color-main-dark-orange">Выбрать тариф</a>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-form', {
        label: 'Club 4 form',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-form">
            <div class="careerum-container-desc">
                <div class="careerum-flex-sbfs">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723287242177-1g7uZ-Vect.svg" alt="">
                        <h2>Начните знакомство <br>
                            с Careerum, это бесплатно!</h2>
                        <p>Заполните форму, а мы откроем вам доступ к образовательной платформе Careerum в демо-режиме. Увидите,
                            как работает платформа, и как мы поможем вам достичь целей</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723287284331-kmJYL-Grou.svg" alt="">
                    </div>
                    <div>
                        <div class="careerum-registration-form-club40">
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-club40-form-telegram">
                                    <input type="text" name="telegram" value="" required placeholder="Telegram">
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                                <div class="careerum-club40-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я даю согласие на обработку своих персональных данных<br> в соответствии с <a
                                            href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                                </div>
                                <a href="#" class="submit-btn btn-color-main-bright-orange button-sent" disabled>Получить
                                    доступ</a>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="careerum-container-desc">
                <div class="careerum-flex-sbst">
                    <div>
                        <h2><span>AI-валидатор</span> резюме</h2>
                        <p>Проверьте своё резюме и получите экспертные советы по улучшению</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744960070627-aR5Id-Group.webp"
                            alt="" class="position-absolute">
                    </div>
                    <div>
                        <div class="careerum-registration-form-club40">
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                    <p class="careerum-club40-form-warn">Неверное имя</p>
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-telegram">
                                    <input type="text" name="telegram" value="" required placeholder="Telegram">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я даю согласие на обработку своих персональных данных<br> в соответствии с <a
                                            href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                                </div> <a href="#" class="submit-btn btn-color-main-bright-orange button-sent"
                                    disabled>Проверить резюме</a>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-form-tablet', {
        label: 'Club 4 form (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-form-tablet">
            <div class="careerum-container-tablet">
                <div class="careerum-flex-sbst">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723489041657-m4vpb-Vect.svg" alt="">
                        <h2>Начните знакомство <br>
                            с Careerum, это бесплатно!</h2>
                        <p>Откроем вам доступ к образовательной платформе Careerum в демо-режиме. Увидите, как она работает, и как мы поможем вам достичь целей</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723489074938-2IeWJ-Grou.svg" alt="">
                    </div>
                    <div>
                        <div class="careerum-registration-form-club40">
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-club40-form-telegram">
                                    <input type="text" name="telegram" value="" required placeholder="Telegram">
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                                <div class="careerum-club40-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я даю согласие на обработку своих персональных данных в соответствии с <a
                                            href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                                </div>
                                <a href="#" class="submit-btn btn-color-main-bright-orange button-sent" disabled>Получить
                                    доступ</a>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="careerum-container-tablet">
                <div class="careerum-flex-sbst">
                    <div>
                        <h2><span>AI-валидатор</span> резюме</h2>
                        <p>Проверьте своё резюме и получите экспертные советы по улучшению</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744960835895-MkQ9m-Group.webp"
                            alt="" class="position-absolute">
                    </div>
                    <div>
                        <div class="careerum-registration-form-club40">
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                    <p class="careerum-club40-form-warn">Неверное имя</p>
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-telegram">
                                    <input type="text" name="telegram" value="" required placeholder="Telegram">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я даю согласие на обработку своих персональных данных в соответствии с <a
                                            href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                                </div> <a href="#" class="submit-btn btn-color-main-bright-orange button-sent"
                                    disabled>Проверить резюме</a>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-form-mobile', {
        label: 'Club 4 form (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-form-mobile">
            <div class="careerum-container-mobile">
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723489041657-m4vpb-Vect.svg"
                            alt="">
                        <h2>Начните знакомство <br>
                            с Careerum, это бесплатно!</h2>
                        <p>Откроем вам доступ к образовательной платформе Careerum в демо-режиме. Увидите, как она работает,
                            и как мы поможем вам достичь целей</p>
                    </div>
                    <div>
                        <div class="careerum-registration-form-club40">
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-club40-form-telegram">
                                    <input type="text" name="telegram" value="" required placeholder="Telegram">
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                                <div class="careerum-club40-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я даю согласие на обработку своих персональных данных в соответствии с <a
                                            href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                                </div>
                                <a href="#" class="submit-btn btn-color-main-bright-orange button-sent" disabled>Получить
                                    доступ</a>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="careerum-container-mobile">
                <div class="careerum-flex-sbst">
                    <div>
                        <h2><span>AI-валидатор</span> резюме</h2>
                        <p>Проверьте своё резюме и получите экспертные советы по улучшению</p>
                    </div>
                    <div>
                        <div class="careerum-registration-form-club40">
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                    <p class="careerum-club40-form-warn">Неверное имя</p>
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-telegram">
                                    <input type="text" name="telegram" value="" required placeholder="Telegram">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я даю согласие на обработку своих персональных данных в соответствии с <a
                                            href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                                </div> <a href="#" class="submit-btn btn-color-main-bright-orange button-sent"
                                    disabled>Проверить резюме</a>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-popup-pay', {
        label: 'Club 4 popup pay',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-popup careerum-club40-popup-pay" id="">
            <div class="popup__close-button-wrapper">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"
                    class="close-switch">
                    <rect width="32" height="32" rx="16" fill="#C2C2C2" />
                    <g clip-path="url(#clip0_7555_2802)">
                        <path d="M20.7979 20.6359L11.2059 11.083" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M11.1998 20.639L20.8018 11.0781" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_7555_2802">
                            <rect width="12" height="12" fill="white" transform="translate(10 10)" />
                        </clipPath>
                    </defs>
                </svg>
            </div>
            <div class="club40-popup-pay-content">
                <div class="careerum-flex-sbfs">
                    <div class="club40-popup-pay-content-left">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723457663947-ZJyDY-Unio.svg"
                            alt="">
                        <div class="club40-popup-pay-content-label m12 careerum-flex-fsfs">
                            <p>Подписка на 12 месяцев</p>
                        </div>
                        <div class="club40-popup-pay-content-label m6 careerum-flex-fsfs">
                            <p>Подписка на 6 месяцев</p>
                        </div>
                        <div class="club40-popup-pay-content-label m3 careerum-flex-fsfs">
                            <p>Подписка на 3 месяца</p>
                        </div>
                        <div class="club40-popup-pay-content-label m1 careerum-flex-fsfs">
                            <p>Подписка на 1 месяц</p>
                        </div>
                        <p>Тариф «Самостоятельный»</p>
                        <ul>
                            <li class="careerum-flex-fsfs club40-popup-pay-content-top-li rub">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723457666600-Zs2Dm-Fram.svg"
                                    class="popup-desctop-img" alt="">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723561372476-FqRod-Fram.svg"
                                    class="popup-mobile-img" alt="">
                                <p>Можно в рассрочку — первый платеж через 30 дней</p>
                            </li>
                            <li class="careerum-flex-fsfs club40-popup-pay-content-top-li eur">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723457666600-Zs2Dm-Fram.svg"
                                    class="popup-desctop-img" alt="">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723561372476-FqRod-Fram.svg"
                                    class="popup-mobile-img" alt="">
                                <p>Можно платить долями по персональному графику</p>
                            </li>
                            <li class="careerum-flex-fsfs club40-popup-pay-content-top-li single">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723457666600-Zs2Dm-Fram.svg"
                                    class="popup-desctop-img" alt="">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723561372476-FqRod-Fram.svg"
                                    class="popup-mobile-img" alt="">
                                <p>Подписка будет продлеваться автоматически за сутки до окончания</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723457666600-Zs2Dm-Fram.svg"
                                    class="popup-desctop-img" alt="">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723561372476-FqRod-Fram.svg"
                                    class="popup-mobile-img" alt="">
                                <p>После оплаты вы получите письмо с инструкцией</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723457666600-Zs2Dm-Fram.svg"
                                    class="popup-desctop-img" alt="">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723561372476-FqRod-Fram.svg"
                                    class="popup-mobile-img" alt="">
                                <p>Продление подписки можно отменить в любой момент</p>
                            </li>
                        </ul>
                    </div>
                    <div class="club40-popup-pay-content-right">
                        <div class="careerum-registration-form-club40">
                            <form class="deva-form" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-club40-form-telegram">
                                    <input type="text" name="telegram" value="" required placeholder="Telegram">
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                                <div class="careerum-club40-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я принимаю условия Оферты и даю согласие на обработку персональных данных
                                        в соответствии с Политикой конфиденциальности. Подписка будет автоматически
                                        продлеваться по аналогичным условиям за сутки до конца оплаченного периода</p>
                                </div>
                                <a href="#" class="submit-btn btn-color-main-bright-orange button-sent" disabled>К выбору способа оплаты</a>
                                <input type="hidden" hidden name="offerID" value="">
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-popup-pay2', {
        label: 'Club 4 popup pay 2',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-popup careerum-club40-popup-pay2" id="">
            <div class="popup__close-button-wrapper careerum-flex-cc">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                    class="close-switch hidden-tablet-mobile">
                    <path d="M21.5957 21.2718L2.41172 2.16602" stroke="#636463" stroke-width="4" stroke-linecap="round"
                        stroke-linejoin="round" />
                    <path d="M2.39951 21.278L21.6035 2.15625" stroke="#636463" stroke-width="4" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="close-switch hidden-desc">
                    <g clip-path="url(#clip0_10262_11319)">
                        <path d="M10.7979 10.6359L1.20586 1.08301" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M1.19976 10.639L10.8018 1.07812" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_10262_11319">
                            <rect width="12" height="12" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            </div>
            <div class="club40-popup-pay-content">
                <div class="careerum-flex-sbfs">
                    <div class="club40-popup-pay-content-left">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1738908255470-w31pl-Unio.svg"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1738908245146-uPi0X-Unio.svg"
                            alt="" class="hidden-desc-mobile">
                    </div>
                    <div class="club40-popup-pay-content-right">
                        <p class="club40-popup-pay-content-step">Шаг 1. Укажите свои данные</p>
                        <p class="club40-popup-pay-content-order-label">Ваш заказ:</p>
                        <p class="club40-popup-pay-content-order-header">Подписка Careerum</p>
                        <p class="club40-popup-pay-content-order-header">Тариф «Самостоятельный»</p>
                        <div class="club40-popup-pay-content-label m12 careerum-flex-fsfs">
                            <p>Длительность: 365 дней</p>
                        </div>
                        <div class="club40-popup-pay-content-label m6 careerum-flex-fsfs">
                            <p>Длительность: 180 дней</p>
                        </div>
                        <div class="club40-popup-pay-content-label m3 careerum-flex-fsfs">
                            <p>Длительность: 90 дней</p>
                        </div>
                        <div class="club40-popup-pay-content-label m1 careerum-flex-fsfs">
                            <p>Длительность: 30 дней</p>
                        </div>
                        <div class="careerum-registration-form-club40">
                            <form class="deva-form" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                        <p class="careerum-club40-form-warn">Неверное имя</p>
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-telegram">
                                    <input type="text" name="telegram" value="" required placeholder="Telegram">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я принимаю условия <a href="/ru-intl/legal/offer">Оферты</a> и даю согласие
                                        на обработку персональных данных
                                        в соответствии с <a href="/ru-ru/legal/privacy">Политикой конфиденциальности</a>.
                                        Подписка будет автоматически
                                        продлеваться по аналогичным условиям за сутки до конца оплаченного периода</p>
                                </div>
                                <a href="#" class="submit-btn btn-color-main-bright-orange careerum-flex-cc" disabled>
                                    Перейти к оплате
                                    <svg width="33" height="32" viewBox="0 0 33 32" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" class="hidden-mobile">
                                        <path d="M5.5 16H27.5" stroke="#ffffff" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M18.5 7L27.5 16L18.5 25" stroke="#ffffff" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </a>
                                <input type="hidden" hidden name="offerID" value="">
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-popup-subscribe', {
        label: 'Club 4 popup sunscribe',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-popup careerum-club40-popup-pay careerum-club40-popup-subscribe" id="">
            <div class="popup__close-button-wrapper">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"
                    class="close-switch">
                    <rect width="32" height="32" rx="16" fill="#C2C2C2" />
                    <g clip-path="url(#clip0_7555_2802)">
                        <path d="M20.7979 20.6359L11.2059 11.083" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M11.1998 20.639L20.8018 11.0781" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_7555_2802">
                            <rect width="12" height="12" fill="white" transform="translate(10 10)" />
                        </clipPath>
                    </defs>
                </svg>
            </div>
            <div class="club40-popup-pay-content">
                <div class="careerum-flex-sbfs">
                    <div class="club40-popup-pay-content-left">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723457663947-ZJyDY-Unio.svg"
                            alt="">
                        <div class="club40-popup-pay-content-label m12 careerum-flex-fsfs">
                            <p>Подписка на 12 месяцев</p>
                        </div>
                        <div class="club40-popup-pay-content-label m6 careerum-flex-fsfs">
                            <p>Подписка на 6 месяцев</p>
                        </div>
                        <div class="club40-popup-pay-content-label m3 careerum-flex-fsfs">
                            <p>Подписка на 3 месяца</p>
                        </div>
                        <div class="club40-popup-pay-content-label m1 careerum-flex-fsfs">
                            <p>Подписка на 1 месяц</p>
                        </div>
                        <p>Тариф «Самостоятельный»</p>
                        <ul>
                            <li class="careerum-flex-fsfs club40-popup-pay-content-top-li rub">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723457666600-Zs2Dm-Fram.svg"
                                    class="popup-desctop-img" alt="">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723561372476-FqRod-Fram.svg"
                                    class="popup-mobile-img" alt="">
                                <p>Можно в рассрочку — первый платеж через 30 дней</p>
                            </li>
                            <li class="careerum-flex-fsfs club40-popup-pay-content-top-li eur">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723457666600-Zs2Dm-Fram.svg"
                                    class="popup-desctop-img" alt="">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723561372476-FqRod-Fram.svg"
                                    class="popup-mobile-img" alt="">
                                <p>Можно платить долями по персональному графику</p>
                            </li>
                            <li class="careerum-flex-fsfs club40-popup-pay-content-top-li single">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723457666600-Zs2Dm-Fram.svg"
                                    class="popup-desctop-img" alt="">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723561372476-FqRod-Fram.svg"
                                    class="popup-mobile-img" alt="">
                                <p>Подписка будет продлеваться автоматически за сутки до окончания</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723457666600-Zs2Dm-Fram.svg"
                                    class="popup-desctop-img" alt="">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723561372476-FqRod-Fram.svg"
                                    class="popup-mobile-img" alt="">
                                <p>После оплаты вы получите письмо с инструкцией</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723457666600-Zs2Dm-Fram.svg"
                                    class="popup-desctop-img" alt="">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723561372476-FqRod-Fram.svg"
                                    class="popup-mobile-img" alt="">
                                <p>Продление подписки можно отменить в любой момент</p>
                            </li>
                        </ul>
                    </div>
                    <div class="club40-popup-pay-content-right">
                        <div class="careerum-registration-form-club40">
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-club40-form-telegram">
                                    <input type="text" name="telegram" value="" required placeholder="Telegram">
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                                <div class="careerum-club40-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я принимаю условия Оферты и даю согласие на обработку персональных данных
                                        в соответствии с Политикой конфиденциальности. Подписка будет автоматически
                                        продлеваться по аналогичным условиям за сутки до конца оплаченного периода</p>
                                </div>
                                <a href="#" class="submit-btn btn-color-main-bright-orange button-sent" disabled>К выбору способа оплаты</a>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-popup-subscribe2', {
        label: 'Club 4 popup sunscribe 2',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-popup careerum-club40-popup-pay2 careerum-club40-popup-subscribe2" id="">
                <div class="popup__close-button-wrapper careerum-flex-cc">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                        class="close-switch hidden-tablet-mobile">
                        <path d="M21.5957 21.2718L2.41172 2.16602" stroke="#636463" stroke-width="4" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M2.39951 21.278L21.6035 2.15625" stroke="#636463" stroke-width="4" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="close-switch hidden-desc">
                        <g clip-path="url(#clip0_10262_11319)">
                            <path d="M10.7979 10.6359L1.20586 1.08301" stroke="white" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M1.19976 10.639L10.8018 1.07812" stroke="white" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="clip0_10262_11319">
                                <rect width="12" height="12" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <div class="club40-popup-pay-content">
                    <div class="careerum-flex-sbfs">
                        <div class="club40-popup-pay-content-left position-relative ">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740733450214-Ioew5-Unio.svg"
                                alt="" class="hidden-tablet-mobile position-absolute z-10">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740733965773-4Cmuy-Unio.svg"
                                alt="" class="hidden-desc-mobile position-absolute z-10">
                            <p class="club40-popup-pay-content-header position-relative z-20">Тариф «С поддержкой»</p>
                            <div class="club40-popup-pay-content-label m12 careerum-flex-fsfs position-relative z-20">
                                <p>Подписка на 365 дней</p>
                            </div>
                            <div class="club40-popup-pay-content-label m6 careerum-flex-fsfs position-relative z-20">
                                <p>Подписка на 180 дней</p>
                            </div>
                            <div class="club40-popup-pay-content-label m3 careerum-flex-fsfs position-relative z-20">
                                <p>Подписка на 90 дней</p>
                            </div>
                            <div class="club40-popup-pay-content-label m1 careerum-flex-fsfs position-relative z-20">
                                <p>Подписка на 30 дней</p>
                            </div>
                            <p class="club40-popup-pay-content-text position-relative z-20">Оставьте заявку — наши менеджеры свяжутся с вами и подберут
                                решение, максимально подходящее для решения вашего карьерного запроса</p>
                        </div>
                        <div class="club40-popup-pay-content-right">
                            <div class="careerum-registration-form-club40">
                                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                    data-gjs-type="deva-registration-form">
                                    <div class="careerum-club40-form-name">
                                        <input type="text" name="name" value="" required placeholder="Имя">
                                        <p class="careerum-club40-form-warn">Неверное имя</p>
                                    </div>
                                    <div class="careerum-club40-form-email">
                                        <input type="text" name="email" value="" required placeholder="Почта">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                    </div>
                                    <div class="careerum-club40-form-phone">
                                        <input type="tel" value="" name="tel" required class="itl-input">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                    </div>
                                    <div class="careerum-club40-form-agree">
                                        <label>
                                            <input type="checkbox" name="agree">
                                            <div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                    fill="none">
                                                    <path
                                                        d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                        stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </label>
                                        <p>Я принимаю условия Оферты и даю согласие на обработку персональных данных
                                            в соответствии с Политикой конфиденциальности. Подписка будет автоматически
                                            продлеваться по аналогичным условиям за сутки до конца оплаченного периода</p>
                                    </div>
                                    <a href="#" class="submit-btn btn-color-main-bright-orange careerum-flex-cc" disabled>
                                        <p>Оставить заявку</p>
                                        <svg width="33" height="32" viewBox="0 0 33 32" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path d="M5.5 16H27.5" stroke="#ffffff" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                            <path d="M18.5 7L27.5 16L18.5 25" stroke="#ffffff" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </a>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });

    blockManager.add('careerum-club40-popup-lk', {
        label: 'Club 4 popup cabinet',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-popup careerum-club40-popup-pay careerum-club40-popup-subscribe careerum-club40-popup-lk" id="login" data-popup-open="thanks" getcourse-group="Вейтлист: личный кабинет">
            <div class="popup__close-button-wrapper">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"
                    class="close-switch">
                    <rect width="32" height="32" rx="16" fill="#C2C2C2" />
                    <g clip-path="url(#clip0_7555_2802)">
                        <path d="M20.7979 20.6359L11.2059 11.083" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M11.1998 20.639L20.8018 11.0781" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_7555_2802">
                            <rect width="12" height="12" fill="white" transform="translate(10 10)" />
                        </clipPath>
                    </defs>
                </svg>
            </div>
            <div class="club40-popup-pay-content">
                <div class="careerum-flex-sbfs">
                    <div class="club40-popup-pay-content-left">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723457663947-ZJyDY-Unio.svg"
                            alt="">
                        <p>Добро пожаловать в&nbsp;Careerum</p>
                        <div class="club40-popup-pay-content-text">
                            <p>Введите свои данные — после быстрой проверки мы перенаправим вас на страницу авторизации, если у вас уже есть активная подписка.<br><br>Если вы у нас впервые — создадим для вас личный кабинет и дадим демо-доступ к нашей платформе.
                            </p>
                        </div>
                    </div>
                    <div class="club40-popup-pay-content-right">
                        <div class="careerum-registration-form-club40">
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-club40-form-telegram">
                                    <input type="text" name="telegram" value="" required placeholder="Telegram">
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                                <div class="careerum-club40-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я даю согласие на обработку своих персональных данных в соответствии с <a href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                                </div>
                                <a href="#" class="submit-btn btn-color-main-bright-orange button-sent close-switch" disabled>Проверить доступ</a>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('no-cabinet', {
        label: 'Club 4 popup no cabinet',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div id="thanks-no" class="careerum-popup careerum-club40-popup-cabinet no-cabinet">
            <div class="popup__close-button-wrapper">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"
                    class="close-switch">
                    <rect width="32" height="32" rx="16" fill="#C2C2C2" />
                    <g clip-path="url(#clip0_7555_2802)">
                        <path d="M20.7979 20.6359L11.2059 11.083" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M11.1998 20.639L20.8018 11.0781" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_7555_2802">
                            <rect width="12" height="12" fill="white" transform="translate(10 10)" />
                        </clipPath>
                    </defs>
                </svg>
            </div>
            <div class="careerum-club40-popup-cabinet-wrapper">
                <div>
                    <div>
                        <p class="careerum-club40-popup-cabinet-header">Теперь у вас есть личный кабинет!</p>
                        <p class="careerum-club40-popup-cabinet-content">Чтобы попасть туда, нужно всего лишь подтвердить
                            свой email.</p>
                        <p class="careerum-club40-popup-cabinet-content">Для этого нажмите кнопку ниже и следуйте
                            инструкции.</p>
                        <a class="close-switch btn-color-main-dark-orange cabinet-activate" href="https://passport.careerum.com">Перейти в личный
                            кабинет</a>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('has-cabinet', {
        label: 'Club 4 popup has cabinet',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div id="thanks-has" class="careerum-popup careerum-club40-popup-cabinet has-cabinet">
            <div class="popup__close-button-wrapper">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"
                    class="close-switch">
                    <rect width="32" height="32" rx="16" fill="#C2C2C2" />
                    <g clip-path="url(#clip0_7555_2802)">
                        <path d="M20.7979 20.6359L11.2059 11.083" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M11.1998 20.639L20.8018 11.0781" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_7555_2802">
                            <rect width="12" height="12" fill="white" transform="translate(10 10)" />
                        </clipPath>
                    </defs>
                </svg>
            </div>
            <div class="careerum-club40-popup-cabinet-wrapper">
                <div>
                    <div>
                        <p class="careerum-club40-popup-cabinet-header">Welcome back! Рады видеть вас снова</p>
                        <p class="careerum-club40-popup-cabinet-content">Вы уже зарегестрированы в Careerum. Чтобы войти
                            в личный кабинет, нажмите на кнопку ниже.</p>
                        <a class="close-switch btn-color-main-dark-orange" href="https://passport.careerum.com" target="_blank">Войти в личный
                            кабинет</a>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-popup-thanks', {
        label: 'Club 4 popup thanks',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div id="thanks" class="careerum-popup careerum-club40-popup-thanks">
            <div class="popup__close-button-wrapper">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"
                    class="close-switch">
                    <rect width="32" height="32" rx="16" fill="#C2C2C2" />
                    <g clip-path="url(#clip0_7555_2802)">
                        <path d="M20.7979 20.6359L11.2059 11.083" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M11.1998 20.639L20.8018 11.0781" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_7555_2802">
                            <rect width="12" height="12" fill="white" transform="translate(10 10)" />
                        </clipPath>
                    </defs>
                </svg>
            </div>
            <div class="careerum-club40-popup-thanks-wrapper">
                <div>
                    <div>
                        <p class="careerum-club40-popup-thanks-header">Спасибо, что<br> оставили заявку!</p>
                        <p class="careerum-club40-popup-thanks-content">Наши специалисты свяжутся с вами<br> в течение 24
                            часов</p>
                        <!-- <a class="close-switch btn-color-main-dark-orange" href="#">Войти в личный кабинет</a> -->
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-popup-thanks2', {
        label: 'Club 4 popup thanks 2',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div id="thanks" class="careerum-popup careerum-club40-popup-thanks2">
                <div class="popup__close-button-wrapper">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"
                        class="close-switch">
                        <rect width="32" height="32" rx="16" fill="#C2C2C2" />
                        <g clip-path="url(#clip0_7555_2802)">
                            <path d="M20.7979 20.6359L11.2059 11.083" stroke="white" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M11.1998 20.639L20.8018 11.0781" stroke="white" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="clip0_7555_2802">
                                <rect width="12" height="12" fill="white" transform="translate(10 10)" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <div class="careerum-club40-popup-thanks-wrapper">
                    <div>
                        <div class="position-relative">
                            <p class="careerum-club40-popup-thanks-header">Спасибо! </p>
                            <p class="careerum-club40-popup-thanks-content">Наш специалист свяжется с вами</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744963731021-uO5uz-Grou.svg" alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744964366768-NbUK9-Grou.svg" alt="" class="position-absolute hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744964572618-1EEQR-Grou.svg" alt="" class="position-absolute hidden-desc-tablet">
                        </div>
                    </div>
                </div>
            </div>`
    });

    blockManager.add('careerum-club40-banner1', {
        label: 'Club 4 banner1',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-banner1">
            <div class="careerum-container-desc">
                <div class="club40-banner1-top">
                    <div class="club40-banner1-top-top">
                        <ul class="careerum-flex-fsfs">
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723721933804-EK5Pa-Soft.svg" alt="">
                                <p>Главный ивент сезона найма</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723721933804-EK5Pa-Soft.svg" alt="">
                                <p>Главный ивент сезона найма</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723721933804-EK5Pa-Soft.svg" alt="">
                                <p>Главный ивент сезона найма</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723721933804-EK5Pa-Soft.svg" alt="">
                                <p>Главный ивент сезона найма</p>
                            </li>
                        </ul>
                    </div>
                    <div class="club40-banner1-top-bottom">
                        <ul class="careerum-flex-fsfs">
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723721933804-EK5Pa-Soft.svg" alt="">
                                <p>Оффер — уже этой осенью!</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723721933804-EK5Pa-Soft.svg" alt="">
                                <p>Оффер — уже этой осенью!</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723721933804-EK5Pa-Soft.svg" alt="">
                                <p>Оффер — уже этой осенью!</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723721933804-EK5Pa-Soft.svg" alt="">
                                <p>Оффер — уже этой осенью!</p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="club40-banner1-header">
                    <div class="club40-banner1-labels careerum-flex-fsfs">
                        <div class="club40-banner1-label blue-label">
                            <p>Интенсив по поиску работы</p>
                        </div>
                        <div class="club40-banner1-label">
                            <p>26 августа – 27 октября 2024</p>
                        </div>
                    </div>
                    <h2>Fast Track: быстрый путь к офферу мечты</h2>
                </div>
                <div class="club40-banner1-center careerum-flex-fsfs">
                    <div class="club40-banner1-about careerum-flex-fsfs">
                        <div class="club40-banner1-about-item">
                            <p>8 живых эфиров</p>
                        </div>
                        <div class="club40-banner1-about-item">
                            <p>Много практики</p>
                        </div>
                        <div class="club40-banner1-about-item">
                            <p>Эксперты международного класса</p>
                        </div>
                        <div class="club40-banner1-about-item">
                            <p>Q&A-сессии</p>
                        </div>
                        <div class="club40-banner1-about-item">
                            <p>Полезный нетворк и поддержка сообщества</p>
                        </div>
                    </div>
                    <div class="club40-banner1-advantages">
                        <div>
                            <div class="club40-banner1-advantages-item careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723717427906-NTzju-Fram.svg" alt="">
                                <p>Идеально подойдет для поиска как в РФ, так и за рубежом</p>
                            </div>
                            <div class="club40-banner1-advantages-item careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723717427906-NTzju-Fram.svg" alt="">
                                <p>Лучшие  лайфхаки для каждого этапа поиска работы</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="club40-banner1-bottom">
                    <div class="club40-banner1-bottom-top">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723718895738-qiN8B-Grou.svg" alt="">
                        <p class="club40-banner1-bottom-header">Интенсив подойдет вам, если:</p>
                        <ul class="careerum-flex-fsfs">
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723717945036-7Fx3v-Unio.svg" alt="">
                                <p>Устали от долгого и безуспешного поиска работы</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723717945036-7Fx3v-Unio.svg" alt="">
                                <p>Ваше резюме не читают<br> или игнорируют</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723717945036-7Fx3v-Unio.svg" alt="">
                                <p>Нервничаете на интервью и не знаете, как себя вести</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723717945036-7Fx3v-Unio.svg" alt="">
                                <p>Боитесь откликаться на «крутые» вакансии</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723717945036-7Fx3v-Unio.svg" alt="">
                                <p>Получаете отказы на разных этапах и не понимаете, почему</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723717945036-7Fx3v-Unio.svg" alt="">
                                <p>Не знаете, какие<br> вакансии вам подойдут</p>
                            </li>
                        </ul>
                    </div>
                    <div class="club40-banner1-bottom-bottom">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723718896344-N4VBN-Grou.svg" alt="">
                        <p class="club40-banner1-bottom-header">Вы после интенсива:</p>
                        <ul class="careerum-flex-fsfs">
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723718016945-FGdYu-Vect.svg" alt="">
                                <p>Проанализируете рынок и поставите карьерные цели</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723718016945-FGdYu-Vect.svg" alt="">
                                <p>Построите стратегию поиска вакансий</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723718016945-FGdYu-Vect.svg" alt="">
                                <p>Напишете продающее резюме и сопроводительные письма</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723718016945-FGdYu-Vect.svg" alt="">
                                <p>Усилите ваш профиль в LinkedIn и научитесь использовать его в поиске</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723718016945-FGdYu-Vect.svg" alt="">
                                <p>Подготовитесь к собеседованиям и переговорам по офферу на русском или английском языках</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723718016945-FGdYu-Vect.svg" alt="">
                                <p>Сделаете свой поиск быстрым и эффективным</p>
                            </li>
                        </ul>
                    </div>
                    <div class="club40-banner1-bottom-label">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723721502311-LpuWO-Vect.svg" alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723721501990-ar0dE-Grou.svg" alt="">
                        <p>Получите оффер в компании мечты на лучших условиях</p>
                    </div>
                </div>
                <div class="club40-banner1-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Принять участие</a>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-banner1-tablet', {
        label: 'Club 4 banner1 (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-banner1-tablet">
            <div class="careerum-container-tablet">
                <div class="club40-banner1-top">
                    <div class="club40-banner1-top-top">
                        <ul class="careerum-flex-fsfs">
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723723436409-aaIHx-Soft.svg" alt="">
                                <p>Главный ивент сезона найма</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723723436409-aaIHx-Soft.svg" alt="">
                                <p>Главный ивент сезона найма</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723723436409-aaIHx-Soft.svg" alt="">
                                <p>Главный ивент сезона найма</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723723436409-aaIHx-Soft.svg" alt="">
                                <p>Главный ивент сезона найма</p>
                            </li>
                        </ul>
                    </div>
                    <div class="club40-banner1-top-bottom">
                        <ul class="careerum-flex-fsfs">
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723723436409-aaIHx-Soft.svg" alt="">
                                <p>Оффер — уже этой осенью!</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723723436409-aaIHx-Soft.svg" alt="">
                                <p>Оффер — уже этой осенью!</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723723436409-aaIHx-Soft.svg" alt="">
                                <p>Оффер — уже этой осенью!</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723723436409-aaIHx-Soft.svg" alt="">
                                <p>Оффер — уже этой осенью!</p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="club40-banner1-header">
                    <div class="club40-banner1-labels careerum-flex-fsfs">
                        <div class="club40-banner1-label blue-label">
                            <p>Интенсив по поиску работы</p>
                        </div>
                        <div class="club40-banner1-label">
                            <p>26 августа – 27 октября 2024</p>
                        </div>
                    </div>
                    <h2>Fast Track: быстрый путь к офферу<br> мечты</h2>
                </div>
                <div class="club40-banner1-center careerum-flex-fsfs">
                    <div class="club40-banner1-about careerum-flex-fsfs">
                        <div class="club40-banner1-about-item">
                            <p>8 живых эфиров</p>
                        </div>
                        <div class="club40-banner1-about-item">
                            <p>Много практики</p>
                        </div>
                        <div class="club40-banner1-about-item">
                            <p>Полезный нетворк</p>
                        </div>
                        <div class="club40-banner1-about-item">
                            <p>Q&A-сессии</p>
                        </div>
                        <div class="club40-banner1-about-item">
                            <p>Поддержка сообщества</p>
                        </div>
                        <div class="club40-banner1-about-item">
                            <p>Эксперты международного класса</p>
                        </div>
                    </div>
                    <div class="club40-banner1-advantages">
                        <div>
                            <div class="club40-banner1-advantages-item careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724010636-Galjh-Grou.svg" alt="">
                                <p>Идеально подойдет для поиска как в РФ, так и за рубежом</p>
                            </div>
                            <div class="club40-banner1-advantages-item careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724010636-Galjh-Grou.svg" alt="">
                                <p>Лучшие  лайфхаки для каждого этапа поиска работы</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="club40-banner1-bottom">
                    <div class="club40-banner1-bottom-top">
                        <p class="club40-banner1-bottom-header">Интенсив подойдет вам, если:</p>
                        <ul class="careerum-flex-fsfs">
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724247891-MUKp2-Unio.svg" alt="">
                                <p>Устали от долгого и безуспешного поиска работы</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724247891-MUKp2-Unio.svg" alt="">
                                <p>Ваше резюме не читают или игнорируют</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724247891-MUKp2-Unio.svg" alt="">
                                <p>Нервничаете на интервью и не знаете, как себя вести</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724247891-MUKp2-Unio.svg" alt="">
                                <p>Боитесь откликаться на «крутые» вакансии</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724247891-MUKp2-Unio.svg" alt="">
                                <p>Получаете отказы на разных этапах и не понимаете, почему</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724247891-MUKp2-Unio.svg" alt="">
                                <p>Не знаете, какие<br> вакансии вам подойдут</p>
                            </li>
                        </ul>
                    </div>
                    <div class="club40-banner1-bottom-bottom">
                        <p class="club40-banner1-bottom-header">Вы после интенсива:</p>
                        <ul class="careerum-flex-fsfs">
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724248356-hQhMB-Vect.svg" alt="">
                                <p>Проанализируете рынок и поставите карьерные цели</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724248356-hQhMB-Vect.svg" alt="">
                                <p>Построите стратегию поиска вакансий</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724248356-hQhMB-Vect.svg" alt="">
                                <p>Напишете продающее резюме и сопро-водительные письма</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724248356-hQhMB-Vect.svg" alt="">
                                <p>Усилите ваш профиль в LinkedIn и научитесь использовать его в поиске</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724248356-hQhMB-Vect.svg" alt="">
                                <p>Подготовитесь к собеседованиям на русском и английском</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724248356-hQhMB-Vect.svg" alt="">
                                <p>Сделаете свой поиск эффективным и быстрым</p>
                            </li>
                        </ul>
                    </div>
                    <div class="club40-banner1-bottom-label">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723721502311-LpuWO-Vect.svg" alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723725080238-kKiTY-Grou.svg" alt="">
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724888192-WsRoC-Vect.svg" alt="">
                            <p>Получите оффер в компании мечты на лучших условиях</p>
                        </div>
                    </div>
                </div>
                <div class="club40-banner1-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Принять участие</a>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-banner1-mobile', {
        label: 'Club 4 banner1 (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-banner1-mobile">
            <div class="careerum-container-mobile">
                <div class="club40-banner1-top">
                    <div class="club40-banner1-top-top">
                        <ul class="careerum-flex-fsfs">
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723723436409-aaIHx-Soft.svg" alt="">
                                <p>Главный ивент сезона найма</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723723436409-aaIHx-Soft.svg" alt="">
                                <p>Главный ивент сезона найма</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723723436409-aaIHx-Soft.svg" alt="">
                                <p>Главный ивент сезона найма</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723723436409-aaIHx-Soft.svg" alt="">
                                <p>Главный ивент сезона найма</p>
                            </li>
                        </ul>
                    </div>
                    <div class="club40-banner1-top-bottom">
                        <ul class="careerum-flex-fsfs">
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723723436409-aaIHx-Soft.svg" alt="">
                                <p>Оффер — уже этой осенью!</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723723436409-aaIHx-Soft.svg" alt="">
                                <p>Оффер — уже этой осенью!</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723723436409-aaIHx-Soft.svg" alt="">
                                <p>Оффер — уже этой осенью!</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723723436409-aaIHx-Soft.svg" alt="">
                                <p>Оффер — уже этой осенью!</p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="club40-banner1-header">
                    <div class="club40-banner1-labels">
                        <div class="club40-banner1-label blue-label">
                            <p>Интенсив по поиску работы</p>
                        </div>
                        <div class="club40-banner1-label">
                            <p>26 августа – 27 октября 2024</p>
                        </div>
                    </div>
                    <h2>Fast Track: быстрый путь к офферу мечты</h2>
                </div>
                <div class="club40-banner1-center">
                    <div class="club40-banner1-advantages">
                        <div>
                            <div class="club40-banner1-advantages-item careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724010636-Galjh-Grou.svg" alt="">
                                <p>Идеально подойдет для поиска как в РФ, так и за рубежом</p>
                            </div>
                            <div class="club40-banner1-advantages-item careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724010636-Galjh-Grou.svg" alt="">
                                <p>Лучшие  лайфхаки для каждого этапа поиска работы</p>
                            </div>
                        </div>
                    </div>
                    <div class="club40-banner1-about careerum-flex-fsfs">
                        <div class="club40-banner1-about-item">
                            <p>8 живых эфиров</p>
                        </div>
                        <div class="club40-banner1-about-item">
                            <p>Много практики</p>
                        </div>
                        <div class="club40-banner1-about-item">
                            <p>Полезный нетворк</p>
                        </div>
                        <div class="club40-banner1-about-item">
                            <p>Q&A-сессии</p>
                        </div>
                        <div class="club40-banner1-about-item">
                            <p>Поддержка сообщества</p>
                        </div>
                        <div class="club40-banner1-about-item">
                            <p>Эксперты международного класса</p>
                        </div>
                    </div>
                </div>
                <div class="club40-banner1-bottom">
                    <div class="club40-banner1-bottom-top">
                        <p class="club40-banner1-bottom-header">Интенсив подойдет<br> вам, если:</p>
                        <ul class="careerum-flex-fsfs">
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724247891-MUKp2-Unio.svg" alt="">
                                <p>Устали от долгого и безуспешного поиска работы</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724247891-MUKp2-Unio.svg" alt="">
                                <p>Ваше резюме не читают или игнорируют</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724247891-MUKp2-Unio.svg" alt="">
                                <p>Нервничаете на интервью и не знаете, как себя вести</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724247891-MUKp2-Unio.svg" alt="">
                                <p>Боитесь откликаться на «крутые» вакансии</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724247891-MUKp2-Unio.svg" alt="">
                                <p>Получаете отказы на разных этапах и не понимаете, почему</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724247891-MUKp2-Unio.svg" alt="">
                                <p>Не знаете, какие вакансии вам подойдут</p>
                            </li>
                        </ul>
                    </div>
                    <div class="club40-banner1-bottom-bottom">
                        <p class="club40-banner1-bottom-header">Вы после интенсива:</p>
                        <ul class="careerum-flex-fsfs">
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724248356-hQhMB-Vect.svg" alt="">
                                <p>Проанализируете рынок и поставите карьерные цели</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724248356-hQhMB-Vect.svg" alt="">
                                <p>Построите стратегию поиска вакансий</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724248356-hQhMB-Vect.svg" alt="">
                                <p>Напишете продающее резюме и сопроводительные письма</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724248356-hQhMB-Vect.svg" alt="">
                                <p>Усилите ваш профиль в LinkedIn и научитесь использовать его в поиске</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724248356-hQhMB-Vect.svg" alt="">
                                <p>Подготовитесь к собеседованиям<br>на русском или английском языках</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724248356-hQhMB-Vect.svg" alt="">
                                <p>Сделаете свой поиск быстрым и эффективным</p>
                            </li>
                        </ul>
                    </div>
                    <div class="club40-banner1-bottom-label">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723725080238-kKiTY-Grou.svg" alt="">
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724888192-WsRoC-Vect.svg" alt="">
                            <p>Получите оффер в компании мечты на лучших условиях</p>
                        </div>
                    </div>
                </div>
                <div class="club40-banner1-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Принять участие</a>
                </div>
            </div>
        </div>`
    });
    blockManager.add('careerum-club40-banner2', {
        label: 'Club 4 banner2 responsive',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club40-banner2 main-wrapper">
        <div class="careerum-container-responsive">
            <div class="club40-banner2-labels position-relative">
                <div class="club40-banner2-label-left">
                    <p class="text-white">Интенсив</p>
                </div>
                <div class="club40-banner2-label-center">
                    <p class="text-white">11 ноября – 10 февраля</p>
                </div>
            </div>
            <div class="club40-banner2-header careerum-flex-sbfs">
                <div>
                    <h2>Real Me: как найти<br> себя в работе и жизни</h2>
                    <p class="hidden-desc">Определитесь в каком направлении развивать карьеру и зарабатывать на том, что
                        любите</p>
                </div>
                <div class="careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1730623649747-c4j59-Mask.png"
                        alt="" class="hidden-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1730628211830-EU9A5-Mask.png"
                        alt="" class="hidden-desc-tablet">
                    <p class="hidden-tablet-mobile">Автор: Ольга Лермонтова,<br> карьерный стратег<br> и фаундер
                        Careerum
                    </p>
                    <p class="hidden-desc">Автор программы:
                        Ольга Лермонтова, карьерный стратег и фаундер Careerum
                    </p>
                </div>
            </div>
            <div class="club40-banner2-center hidden-tablet-mobile">
                <p>Определитесь в каком направлении развивать карьеру и зарабатывать на том, что любите</p>
            </div>
            <div class="club40-banner2-slider">
                <div class="club40-banner2-slider-items">
                    <div class="club40-banner2-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1730623883284-N90hT-Grad.svg"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1730626858021-GWm6d-Grad.svg"
                            alt="" class="hidden-desc">
                        <p>Откопаете свои таланты, сделаете их фундаментом карьеры</p>
                    </div>
                    <div class="club40-banner2-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1730623883171-gAtpm-Glob.svg"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1730626857905-eBGtx-Glob.svg"
                            alt="" class="hidden-desc">
                        <p>Найдете свое в работе, даже если все перепробовали</p>
                    </div>
                    <div class="club40-banner2-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1730623883048-VVsd0-Smil.svg"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1730626857771-NtVEh-Smil.svg"
                            alt="" class="hidden-desc">
                        <p>Справитесь с самозванцем, поверите в свои силы, выйдете из состояния постоянного напряжения
                        </p>
                    </div>
                    <div class="club40-banner2-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1730623882740-nubsC-Trop.svg"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1730626857412-X8Rr7-Trop.svg"
                            alt="" class="hidden-desc">
                        <p>Сможете сменить профессию без оглядки на возраст</p>
                    </div>
                </div>
                <div class="club40-banner2-slider-nav position-relative">
                    <div class="club40-banner2-slider-nav-prev">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="cursor-pointer">
                            <g clip-path="url(#clip0_177_2583)">
                                <g filter="url(#filter0_b_177_2583)">
                                    <rect y="40" width="40" height="40" transform="rotate(-90 0 40)" fill="#0B70FE" />
                                </g>
                                <path d="M13.1905 19.9993L26.8105 19.9993" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M19.4629 26.2453L13.1896 19.9986L19.4629 13.752" stroke="white"
                                    stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <filter id="filter0_b_177_2583" x="-18.1166" y="-18.1166" width="76.2332"
                                    height="76.2332" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                    <feComposite in2="SourceAlpha" operator="in"
                                        result="effect1_backgroundBlur_177_2583" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_177_2583"
                                        result="shape" />
                                </filter>
                                <clipPath id="clip0_177_2583">
                                    <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)"
                                        fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                    <div class="club40-banner2-slider-nav-next">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="cursor-pointer">
                            <g clip-path="url(#clip0_177_2587)">
                                <g filter="url(#filter0_b_177_2587)">
                                    <rect x="40" width="40" height="40" transform="rotate(90 40 0)" fill="#0B70FE" />
                                </g>
                                <path d="M26.8095 20.0007L13.1895 20.0007" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M20.5371 13.7547L26.8104 20.0014L20.5371 26.248" stroke="white"
                                    stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <filter id="filter0_b_177_2587" x="-18.1166" y="-18.1166" width="76.2332"
                                    height="76.2332" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                    <feComposite in2="SourceAlpha" operator="in"
                                        result="effect1_backgroundBlur_177_2587" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_177_2587"
                                        result="shape" />
                                </filter>
                                <clipPath id="clip0_177_2587">
                                    <rect x="40" width="40" height="40" rx="20" transform="rotate(90 40 0)"
                                        fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                </div>
            </div>
            <div class="club40-banner2-link">
                <a href="#buy" class="btn-color-main-dark-orange">Участвовать</a>
            </div>
        </div>
    </div>`
    });

    blockManager.add('club40-tariffs2', {
        label: 'Club 4 tariffs2',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-tariffs club40-tariffs2">
            <div class="careerum-container-desc">
                <div class="careerum-flex-fsc club40-tariffs-top-label">
                    <p>График повышения цен: </p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737370505194-JDWDp-Chec.svg" alt="" class="auto">
                    <p>15 февраля</p>
                    <p>17 февраля</p>
                    <p>19 февраля</p>
                    <p>22 февраля</p>
                </div>
                <h2 class="careerum-club40-header">Решите свою карьерную задачу с нами</h2>
                <div class="club40-tariffs-nav careerum-flex-sbfs">
                    <div class="club40-tariffs-period careerum-flex-fsst">
                        <ul class="careerum-flex-fsfs">
                            <li data-period="1" class="active">1 месяц</li>
                            <li data-period="3">3 месяца</li>
                            <li data-period="6">6 месяцев</li>
                            <li data-period="12">12 месяцев</li>
                        </ul>
                        <div class="club40-tariffs-notif careerum-flex-cc">
                            <div class="club40-tariffs-notif-icon"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                    alt=""></div>
                            <div class="club40-tariffs-notif-content">
                                <p>1 месяц подписки предоставляет 30 дней доступа к платформе</p>
                            </div>
                        </div>
                    </div>
                    <div class="club40-tariffs-curr careerum-flex-fsst">
                        <ul class="careerum-flex-fsfs">
                            <li data-currency="eur" class="active">EUR</li>
                            <li data-currency="rub">RUB</li>
                        </ul>
                        <div class="club40-tariffs-notif careerum-flex-cc">
                            <div class="club40-tariffs-notif-icon"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                    alt=""></div>
                            <div class="club40-tariffs-notif-content">
                                <p>Оплата в российских рублях возможна только картой российского банка. В&nbsp;евро — картой
                                    зарубежного банка</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="club40-tariffs-items careerum-flex-fsst">
                    <div data-price="" data-price-1m-rub="12 900 ₽" data-price-3m-rub="9&nbsp;967 ₽"
                        data-fullprice-3m-rub="29&nbsp;900 ₽" data-price-6m-rub="7 900 ₽"
                        data-fullprice-6m-rub="47&nbsp;400 ₽" data-price-12m-rub="6 490 ₽" data-fullprice-12m-rub="77 880 ₽"
                        data-price-1m-eur="149 €" data-price-3m-eur="120 €" data-fullprice-3m-eur="360 €"
                        data-price-6m-eur="90 €" data-fullprice-6m-eur="540 €" data-price-12m-eur="80 €"
                        data-fullprice-12m-eur="960 €" data-offer-1m-rub="27" data-offer-3m-rub="94" data-offer-6m-rub="95"
                        data-offer-12m-rub="96" data-offer-1m-eur="48" data-offer-3m-eur="97" data-offer-6m-eur="98"
                        data-offer-12m-eur="99" class="club40-tariffs-item careerum-flex-fsfs">
                        <p class="club40-tariffs-item-subheader2">Тариф «Самостоятельный»</p>
                        <p class="club40-tariffs-item-header">Доступ к карьерной платформе<br><br></p>
                        <p class="club40-tariffs-item-description">Неограниченное кол-во мест</p>
                        <div class="club40-tariffs-item-divider"></div>
                        <ul>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>80 карьерных курсов</p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Трекер заявок на вакансии, чтобы всегда знать, что и куда отправили</p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Шаблоны и примеры: резюме на русском и английском, сопроводительные письма, сообщения
                                    работодателям в LinkedIn, деловая email-переписка</p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Воркфлоу поиска достижений </p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Список платформ для поиска работы в 15 странах</p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Алгоритм, чтобы определить свою карьерную стадию </p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Скрипт обсуждения зарплаты и оффера </p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Формула расчета «Сколько я стою на рынке»
                                </p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Алгоритм постановки карьерных гипотез
                                    для смены сферы</p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Инструкция по созданию плана карьерного развития</p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Методы постановки карьерных целей
                                </p>
                            </li>
                        </ul>
                        <div class="club40-tariffs-item-bottom">
                            <div class="club40-tariffs-item-discount careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737368940097-5jGbI-Perc.svg" alt="">
                                <p>Цена со скидкой на 1-ый платеж</p>
                            </div>
                            <div class="careerum-flex-fsfs club40-tariffs-item-wrapper-price with-discount">
                                <div>
                                    <p class="club40-tariffs-item-price-f">8 900 ₽</p>
                                </div>
                                <div>
                                    <p class="club40-tariffs-item-price-old">12 900 ₽</p>
                                </div>
                            </div><a onclick="" href="#tariff-single" class="btn-color-main-dark-orange">Выбрать тариф</a>
                            <p class="club40-tariffs-item-price-rassr-eur" style="">Можно платить долями</p>
                            <p class="club40-tariffs-item-price-rassr-rub" style="display: none;">Можно в рассрочку</p>
                        </div>
                    </div>
                    <div data-price="" data-price-1m-rub="12 900 ₽" data-price-3m-rub="9&nbsp;967 ₽"
                        data-fullprice-3m-rub="29&nbsp;900 ₽" data-price-6m-rub="7 900 ₽"
                        data-fullprice-6m-rub="47&nbsp;400 ₽" data-price-12m-rub="6 490 ₽" data-fullprice-12m-rub="77 880 ₽"
                        data-price-1m-eur="149 €" data-price-3m-eur="120 €" data-fullprice-3m-eur="360 €"
                        data-price-6m-eur="90 €" data-fullprice-6m-eur="540 €" data-price-12m-eur="80 €"
                        data-fullprice-12m-eur="960 €" data-offer-1m-rub="27" data-offer-3m-rub="94" data-offer-6m-rub="95"
                        data-offer-12m-rub="96" data-offer-1m-eur="48" data-offer-3m-eur="97" data-offer-6m-eur="98"
                        data-offer-12m-eur="99" class="club40-tariffs-item careerum-flex-fsfs">
                        <p class="club40-tariffs-item-subheader2">Тариф «Самостоятельный»</p>
                        <p class="club40-tariffs-item-header">Доступ к карьерной платформе<br><br></p>
                        <p class="club40-tariffs-item-description">Неограниченное кол-во мест</p>
                        <div class="club40-tariffs-item-divider"></div>
                        <ul>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>80 карьерных курсов</p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Трекер заявок на вакансии, чтобы всегда знать, что и куда отправили</p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Шаблоны и примеры: резюме на русском и английском, сопроводительные письма, сообщения
                                    работодателям в LinkedIn, деловая email-переписка</p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Воркфлоу поиска достижений </p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Список платформ для поиска работы в 15 странах</p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Алгоритм, чтобы определить свою карьерную стадию </p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Скрипт обсуждения зарплаты и оффера </p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Формула расчета «Сколько я стою на рынке»
                                </p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Алгоритм постановки карьерных гипотез
                                    для смены сферы</p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Инструкция по созданию плана карьерного развития</p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Методы постановки карьерных целей
                                </p>
                            </li>
                        </ul>
                        <div class="club40-tariffs-item-bottom">
                            <div class="careerum-flex-fsfs club40-tariffs-item-wrapper-price">
                                <div>
                                    <p class="club40-tariffs-item-price-pm">120 €</p>
                                    <p class="club40-tariffs-item-price-pmn1m">цена месяца в&nbsp;пакете</p>
                                    <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                </div>
                                <div>
                                    <p>/</p>
                                </div>
                                <div>
                                    <p class="club40-tariffs-item-price-f">360 €</p>
                                    <p>полная стоимость к оплате</p>
                                </div>
                            </div><a onclick="" href="#tariff-single" class="btn-color-main-dark-orange">Выбрать тариф</a>
                            <p class="club40-tariffs-item-price-rassr-eur" style="">Можно платить долями</p>
                            <p class="club40-tariffs-item-price-rassr-rub" style="display: none;">Можно в рассрочку</p>
                        </div>
                    </div>
                    <div data-price="" data-price-1m-rub="14 900 ₽" data-price-3m-rub="11&nbsp;633 ₽"
                        data-fullprice-3m-rub="34&nbsp;900 ₽" data-price-6m-rub="9&nbsp;817 ₽"
                        data-fullprice-6m-rub="58&nbsp;900 ₽" data-price-12m-rub="8 000 ₽" data-fullprice-12m-rub="96 000 ₽"
                        data-price-1m-eur="199 €" data-price-3m-eur="170 €" data-fullprice-3m-eur="510 €"
                        data-price-6m-eur="130 €" data-fullprice-6m-eur="780 €" data-price-12m-eur="100 €"
                        data-fullprice-12m-eur="1 200 €" data-offer-1m-rub="28" data-offer-3m-rub="29"
                        data-offer-6m-rub="30" data-offer-12m-rub="31" data-offer-1m-eur="49" data-offer-3m-eur="50"
                        data-offer-6m-eur="51" data-offer-12m-eur="52" class="club40-tariffs-item careerum-flex-fsfs">
                        <p class="club40-tariffs-item-label">Популярный</p>
                        <p class="club40-tariffs-item-subheader2">Тариф «С поддержкой»</p>
                        <p class="club40-tariffs-item-header">Платформа +<br>поддержка<br> эксперта в группе</p>
                        <p class="club40-tariffs-item-description">Осталось: 25 мест</p>
                        <div class="club40-tariffs-item-divider"></div>
                        <p class="club40-tariffs-item-subheader">В тариф входят все опции тарифа «Самостоятельный», плюс:
                        </p>
                        <ul>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                    alt="">
                                <p>Групповой чат с экспертом и кураторами платформы</p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                    alt="">
                                <p>2 группые Q&A-встречи в месяц с экспертом для разбора вопросов</p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                    alt="">
                                <p>Доступ к Сareerum.Club и всем ивентам клуба</p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                    alt="">
                                <p>Доступ к сезонным Интенсивам </p>
                            </li>
                        </ul>
                        <div class="club40-tariffs-item-bottom">
                            <div class="careerum-flex-fsfs club40-tariffs-item-wrapper-price">
                                <div>
                                    <p class="club40-tariffs-item-price-pm">170 €</p>
                                    <p class="club40-tariffs-item-price-pmn1m">цена месяца в&nbsp;пакете</p>
                                    <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                </div>
                                <div>
                                    <p>/</p>
                                </div>
                                <div>
                                    <p class="club40-tariffs-item-price-f">510 €</p>
                                    <p>полная стоимость к оплате</p>
                                </div>
                            </div><a onclick="" href="#subscribe-support"
                                class="btn-color-main-dark-orange no-change">Оставить заявку</a>
                            <p class="club40-tariffs-item-price-rassr-eur" style="">Можно платить долями</p>
                            <p class="club40-tariffs-item-price-rassr-rub" style="display: none;">Можно в рассрочку</p>
                        </div>
                    </div>
                    <div data-price="" data-price-1m-rub="27 900 ₽" data-price-3m-rub="23&nbsp;900 ₽"
                        data-fullprice-3m-rub="71&nbsp;700 ₽" data-price-6m-rub="18&nbsp;317 ₽"
                        data-fullprice-6m-rub="109&nbsp;900 ₽" data-price-12m-rub="16&nbsp;583 ₽"
                        data-fullprice-12m-rub="199 000 ₽" data-price-1m-eur="360 €" data-price-3m-eur="310 €"
                        data-fullprice-3m-eur="930 €" data-price-6m-eur="250 €" data-fullprice-6m-eur="1 500 €"
                        data-price-12m-eur="230 €" data-fullprice-12m-eur="2 760 €" data-offer-1m-rub="32"
                        data-offer-3m-rub="100" data-offer-6m-rub="101" data-offer-12m-rub="102" data-offer-1m-eur="53"
                        data-offer-3m-eur="103" data-offer-6m-eur="104" data-offer-12m-eur="105"
                        class="club40-tariffs-item careerum-flex-fsfs">
                        <p class="club40-tariffs-item-subheader2">Тариф «Индивидуальный подход»</p>
                        <p class="club40-tariffs-item-header">Платформа +<br> личные консультации<br> с экспертом</p>
                        <p class="club40-tariffs-item-description">Осталось: 25 мест</p>
                        <div class="club40-tariffs-item-divider"></div>
                        <p class="club40-tariffs-item-subheader">В тариф входят все преимущества тарифа «С&nbsp;поддержкой»,
                            плюс:</p>
                        <ul>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                    alt="">
                                <p>Персональная поддержка карьерного эксперта и коуча<br> в чате</p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                    alt="">
                                <p>2 видеоконсультации<br> в месяц с экспертом под ваш карьерный запрос </p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                    alt="">
                                <p>Персональный разбор резюме<br> + 3 письменным фидбека по доработке</p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                    alt="">
                                <p>Персональный разбор LinkedIn<br>+3 письменным фидбека<br>по доработке</p>
                            </li>
                        </ul>
                        <div class="club40-tariffs-item-bottom">
                            <div class="careerum-flex-fsfs club40-tariffs-item-wrapper-price">
                                <div>
                                    <p class="club40-tariffs-item-price-pm">310 €</p>
                                    <p class="club40-tariffs-item-price-pmn1m">цена месяца в&nbsp;пакете</p>
                                    <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                </div>
                                <div>
                                    <p>/</p>
                                </div>
                                <div>
                                    <p class="club40-tariffs-item-price-f">930 €</p>
                                    <p>полная стоимость к оплате</p>
                                </div>
                            </div><a onclick="" href="#subscribe-individual"
                                class="btn-color-main-dark-orange no-change">Оставить заявку</a>
                            <p class="club40-tariffs-item-price-rassr-eur" style="">Можно платить долями</p>
                            <p class="club40-tariffs-item-price-rassr-rub" style="display: none;">Можно в рассрочку</p>
                        </div>
                    </div>
                </div>
                <div class="club40-tariffs-bottom careerum-flex-sbfs">
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733916035157-i9KVB-Vect.svg"
                            alt="">
                        <p class="club40-tariffs-bottom-header">Не знаете, с чего начать?</p>
                        <p class="club40-tariffs-bottom-subheader">Напишите нам — мы ответим на все вопросы<br> и поможем
                            выбрать лучшее решение под вашу задачу</p><a onclick=""
                            href="https://t.me/careerum_bot?roistat_visit=674480" target="_blank"
                            class="btn-color-main-dark-blue careerum-flex-cc"><svg width="28" height="24"
                                viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M6.9104 12.5754L9.51374 19.781C9.51374 19.781 9.83922 20.4552 10.1877 20.4552C10.5363 20.4552 15.7201 15.0624 15.7201 15.0624L21.4847 3.92822L7.00329 10.7153L6.9104 12.5754Z"
                                    fill="#C8DAEA"></path>
                                <path
                                    d="M10.3623 14.4233L9.86251 19.7346C9.86251 19.7346 9.65332 21.362 11.2804 19.7346C12.9074 18.1072 14.4648 16.8522 14.4648 16.8522"
                                    fill="#A9C6D8"></path>
                                <path
                                    d="M6.9574 12.8324L1.60225 11.0876C1.60225 11.0876 0.962247 10.828 1.16833 10.2392C1.21075 10.1177 1.29633 10.0144 1.55233 9.83687C2.73889 9.00981 23.5146 1.54247 23.5146 1.54247C23.5146 1.54247 24.1012 1.3448 24.4471 1.47628C24.5327 1.50277 24.6097 1.55152 24.6703 1.61755C24.7309 1.68357 24.7728 1.7645 24.7918 1.85205C24.8292 2.00668 24.8448 2.16578 24.8383 2.32473C24.8366 2.46224 24.82 2.58969 24.8074 2.78956C24.6808 4.83116 20.8942 20.0683 20.8942 20.0683C20.8942 20.0683 20.6677 20.9599 19.856 20.9904C19.6565 20.9969 19.4578 20.9631 19.2716 20.8911C19.0855 20.8191 18.9157 20.7103 18.7725 20.5713C17.1797 19.2012 11.6742 15.5012 10.4577 14.6875C10.4302 14.6688 10.4071 14.6445 10.3899 14.6161C10.3727 14.5877 10.3617 14.5559 10.3578 14.523C10.3408 14.4372 10.4341 14.3309 10.4341 14.3309C10.4341 14.3309 20.0205 5.80981 20.2756 4.91527C20.2954 4.84597 20.2208 4.81177 20.1206 4.84213C19.4838 5.07637 8.44622 12.0467 7.22803 12.816C7.14034 12.8425 7.04766 12.8481 6.9574 12.8324Z"
                                    fill="white"></path>
                            </svg>
                            <p>Написать в Telegram</p>
                        </a>
                    </div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723278685081-7nUnx-ÑÐ¾.svg"
                            alt="">
                        <div class="careerum-flex-fsfs club40-tariffs-bottom-care">
                            <div><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723278768285-Yeat8-phot.png"
                                    alt=""></div>
                            <div>
                                <p class="club40-tariffs-bottom-care-name">Анна </p>
                                <p class="club40-tariffs-bottom-care-position">Команда заботы Careerum</p>
                                <p class="club40-tariffs-bottom-care-descr">Добрый день! Построить карьеру мечты
                                    в&nbsp;одиночку бывает непросто. Но мы рядом и&nbsp;приведем вас к&nbsp;заветной цели 💙
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="club40-tariffs-bottom-pay position-relative">
                    <p class="club40-tariffs-bottom-pay-label position-absolute">20% скидка<br> для команд от 3 человек</p>
                    <p class="club40-tariffs-bottom-pay-title">Поможем оплатить<br>
                        подписку через работодателя</p>
                    <p class="club40-tariffs-bottom-pay-text">Мы подготовили шаблон письма для вашего руководителя, в
                        котором описали все плюшки подписки Сareerum и добавили специальные условия, если вы захотите
                        позвать коллег:)</p>
                    <div class="careerum-flex-fsfs">
                        <a href="#" class="btn-color-main-white">Забрать шаблон письма для руководителя </a>
                        <a href="#" class="btn-color-main-white">Оплатить сразу от юр.лица</a>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741088816737-v3uAC-Vect.svg" alt=""
                        class="position-absolute">
                </div>
            </div>
        </div>`
    });
    
    blockManager.add('club40-tariffs2-tablet', {
        label: 'Club 4 tariffs2 (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-tariffs-tablet club40-tariffs2-tablet">
            <div class="careerum-container-tablet">
                <div class="careerum-flex-fsc club40-tariffs-top-label">
                    <p>График<br> повышения цен: </p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737370505194-JDWDp-Chec.svg" alt="" class="auto">
                    <p>15 февраля</p>
                    <p>17 февраля</p>
                    <p>19 февраля</p>
                    <p>22 февраля</p>
                </div>
                <h2 class="careerum-club40-header-tablet">Решите свою карьерную задачу с нами</h2>
                <div class="club40-tariffs-nav careerum-flex-sbfs">
                    <div class="club40-tariffs-period">
                        <ul class="careerum-flex-fsfs">
                            <li data-period="1" class="active">30 дней</li>
                            <li data-period="3">90 дней</li>
                            <li data-period="6">180 дней</li>
                            <li data-period="12">365 дней</li>
                        </ul>
                    </div>
                </div>
                <div class="club40-tariffs-items careerum-flex-fsst">
                    <div class="careerum-flex-fsst">
                        <div data-price="" data-price-1m-rub="12 900 ₽" data-price-3m-rub="9&nbsp;967 ₽"
                            data-fullprice-3m-rub="29&nbsp;900 ₽" data-price-6m-rub="7 900 ₽"
                            data-fullprice-6m-rub="47&nbsp;400 ₽" data-price-12m-rub="6 490 ₽"
                            data-fullprice-12m-rub="77 880 ₽" data-price-1m-eur="149 €" data-price-3m-eur="120 €"
                            data-fullprice-3m-eur="360 €" data-price-6m-eur="90 €" data-fullprice-6m-eur="540 €"
                            data-price-12m-eur="80 €" data-fullprice-12m-eur="960 €" data-offer-1m-rub="27"
                            data-offer-3m-rub="94" data-offer-6m-rub="95" data-offer-12m-rub="96" data-offer-1m-eur="48"
                            data-offer-3m-eur="97" data-offer-6m-eur="98" data-offer-12m-eur="99"
                            class="club40-tariffs-item careerum-flex-fsfs">
                            <p class="club40-tariffs-item-subheader2">Тариф «Самостоятельный»</p>
                            <p class="club40-tariffs-item-header">Доступ к карьерной платформе</p>
                            <p class="club40-tariffs-item-description">Неограниченное кол-во мест</p>
                            <ul class="collapsed">
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>80 карьерных курсов</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Трекер заявок на вакансии, чтобы всегда знать, что и куда отправили</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Шаблоны и примеры: резюме на русском и английском, сопроводительные письма, сообщения
                                        работодателям в LinkedIn, деловая email-переписка</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Воркфлоу поиска достижений </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Список платформ для поиска работы в 15 странах</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Алгоритм, чтобы определить свою карьерную стадию </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Скрипт обсуждения зарплаты и оффера </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Формула расчета «Сколько я стою на рынке»
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Алгоритм постановки карьерных гипотез
                                        для смены сферы</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Инструкция по созданию плана карьерного развития</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Методы постановки карьерных целей
                                    </p>
                                </li>
                            </ul>
                            <div class="tariffs-item-switcher careerum-flex-fsc">
                                <p>Показать больше</p>
                                <p>Свернуть</p>
                                <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733929611928-Z084c-Care.svg"
                                alt="">
                            </div>
                            <div class="club40-tariffs-item-bottom">
                                <div class="club40-tariffs-item-discount careerum-flex-fsc">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737368940097-5jGbI-Perc.svg" alt="">
                                    <p>Цена со скидкой на 1ый платеж</p>
                                </div>
                                <div class="careerum-flex-fsfs club40-tariffs-item-wrapper-price with-discount">
                                    <div>
                                        <p class="club40-tariffs-item-price-f">8 900 ₽</p>
                                    </div>
                                    <div>
                                        <p class="club40-tariffs-item-price-old">12 900 ₽</p>
                                    </div>
                                </div><a onclick="" href="#tariff-single" class="btn-color-main-dark-orange">Выбрать тариф</a>
                                <p class="club40-tariffs-item-price-rassr-eur" style="">Можно платить долями</p>
                                <p class="club40-tariffs-item-price-rassr-rub" style="display: none;">Можно в рассрочку</p>
                            </div>
                        </div>
                        <div data-price="" data-price-1m-rub="12 900 ₽" data-price-3m-rub="9&nbsp;967 ₽"
                            data-fullprice-3m-rub="29&nbsp;900 ₽" data-price-6m-rub="7 900 ₽"
                            data-fullprice-6m-rub="47&nbsp;400 ₽" data-price-12m-rub="6 490 ₽"
                            data-fullprice-12m-rub="77 880 ₽" data-price-1m-eur="149 €" data-price-3m-eur="120 €"
                            data-fullprice-3m-eur="360 €" data-price-6m-eur="90 €" data-fullprice-6m-eur="540 €"
                            data-price-12m-eur="80 €" data-fullprice-12m-eur="960 €" data-offer-1m-rub="27"
                            data-offer-3m-rub="94" data-offer-6m-rub="95" data-offer-12m-rub="96" data-offer-1m-eur="48"
                            data-offer-3m-eur="97" data-offer-6m-eur="98" data-offer-12m-eur="99"
                            class="club40-tariffs-item careerum-flex-fsfs">
                            <p class="club40-tariffs-item-subheader2">Тариф «Самостоятельный»</p>
                            <p class="club40-tariffs-item-header">Доступ к карьерной платформе</p>
                            <p class="club40-tariffs-item-description">Неограниченное кол-во мест</p>
                            <ul class="collapsed">
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>80 карьерных курсов</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Трекер заявок на вакансии, чтобы всегда знать, что и куда отправили</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Шаблоны и примеры: резюме на русском и английском, сопроводительные письма, сообщения
                                        работодателям в LinkedIn, деловая email-переписка</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Воркфлоу поиска достижений </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Список платформ для поиска работы в 15 странах</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Алгоритм, чтобы определить свою карьерную стадию </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Скрипт обсуждения зарплаты и оффера </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Формула расчета «Сколько я стою на рынке»
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Алгоритм постановки карьерных гипотез
                                        для смены сферы</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Инструкция по созданию плана карьерного развития</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Методы постановки карьерных целей
                                    </p>
                                </li>
                            </ul>
                            <div class="tariffs-item-switcher careerum-flex-fsc">
                                <p>Показать больше</p>
                                <p>Свернуть</p>
                                <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733929611928-Z084c-Care.svg"
                                alt="">
                            </div>
                            <div class="club40-tariffs-item-bottom">
                                <div class="club40-tariffs-item-wrapper-price">
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-pm">310 €</p>
                                        <p class="club40-tariffs-item-price-pmn1m">цена месяца в&nbsp;пакете</p>
                                        <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                    </div>
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-f">930 €</p>
                                        <p>полная стоимость к оплате</p>
                                    </div>
                                </div>
                                <a onclick="" href="#tariff-single" class="btn-color-main-dark-orange">Выбрать
                                    тариф</a>
                                <p class="club40-tariffs-item-price-rassr-eur" style="">Можно платить долями</p>
                                <p class="club40-tariffs-item-price-rassr-rub" style="display: none;">Можно в рассрочку</p>
                            </div>
                        </div>
                        <div data-price="" data-price-1m-rub="14 900 ₽" data-price-3m-rub="11&nbsp;633 ₽"
                            data-fullprice-3m-rub="34&nbsp;900 ₽" data-price-6m-rub="9&nbsp;817 ₽"
                            data-fullprice-6m-rub="58&nbsp;900 ₽" data-price-12m-rub="8 000 ₽"
                            data-fullprice-12m-rub="96 000 ₽" data-price-1m-eur="199 €" data-price-3m-eur="170 €"
                            data-fullprice-3m-eur="510 €" data-price-6m-eur="130 €" data-fullprice-6m-eur="780 €"
                            data-price-12m-eur="100 €" data-fullprice-12m-eur="1 200 €" data-offer-1m-rub="28"
                            data-offer-3m-rub="29" data-offer-6m-rub="30" data-offer-12m-rub="31" data-offer-1m-eur="49"
                            data-offer-3m-eur="50" data-offer-6m-eur="51" data-offer-12m-eur="52"
                            class="club40-tariffs-item careerum-flex-fsfs">
                            <p class="club40-tariffs-item-label">Популярный</p>
                            <p class="club40-tariffs-item-subheader2">Тариф «С поддержкой»</p>
                            <p class="club40-tariffs-item-header">Платформа +<br>групповой чат с экспертом</p>
                            <p class="club40-tariffs-item-description">Осталось: 25 мест</p>
                            <div class="club40-tariffs-item-divider"></div>
                            <p class="club40-tariffs-item-subheader">В тариф входят все опции тарифа «Самостоятельный»,
                                плюс:
                            </p>
                            <ul>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927796778-lS80O-Fram.svg"
                                        alt="">
                                    <p>Групповой чат с экспертом и кураторами платформы</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927796778-lS80O-Fram.svg"
                                        alt="">
                                    <p>2 группые Q&A-встречи в месяц с экспертом для разбора вопросов</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927796778-lS80O-Fram.svg"
                                        alt="">
                                    <p>Доступ к Сareerum.Club и всем ивентам клуба</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927796778-lS80O-Fram.svg"
                                        alt="">
                                    <p>Доступ к сезонным Интенсивам </p>
                                </li>
                            </ul>
                            <div class="club40-tariffs-item-bottom">
                                <div class="club40-tariffs-item-wrapper-price">
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-pm">310 €</p>
                                        <p class="club40-tariffs-item-price-pmn1m">цена месяца в&nbsp;пакете</p>
                                        <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                    </div>
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-f">930 €</p>
                                        <p>полная стоимость к оплате</p>
                                    </div>
                                </div>
                                <a onclick="" href="#subscribe-support"
                                    class="btn-color-main-dark-orange no-change">Оставить заявку</a>
                                <p class="club40-tariffs-item-price-rassr-eur" style="">Можно платить долями</p>
                                <p class="club40-tariffs-item-price-rassr-rub" style="display: none;">Можно в рассрочку</p>
                            </div>
                        </div>
                        <div data-price="" data-price-1m-rub="27 900 ₽" data-price-3m-rub="23&nbsp;900 ₽"
                            data-fullprice-3m-rub="71&nbsp;700 ₽" data-price-6m-rub="18&nbsp;317 ₽"
                            data-fullprice-6m-rub="109&nbsp;900 ₽" data-price-12m-rub="16&nbsp;583 ₽"
                            data-fullprice-12m-rub="199 000 ₽" data-price-1m-eur="360 €" data-price-3m-eur="310 €"
                            data-fullprice-3m-eur="930 €" data-price-6m-eur="250 €" data-fullprice-6m-eur="1 500 €"
                            data-price-12m-eur="230 €" data-fullprice-12m-eur="2 760 €" data-offer-1m-rub="32"
                            data-offer-3m-rub="100" data-offer-6m-rub="101" data-offer-12m-rub="102" data-offer-1m-eur="53"
                            data-offer-3m-eur="103" data-offer-6m-eur="104" data-offer-12m-eur="105"
                            class="club40-tariffs-item careerum-flex-fsfs">
                            <p class="club40-tariffs-item-subheader2">Тариф «Индивидуальный подход»</p>
                            <p class="club40-tariffs-item-header">Платформа +<br>консультации с экспертом</p>
                            <p class="club40-tariffs-item-description">Осталось: 25 мест</p>
                            <div class="club40-tariffs-item-divider"></div>
                            <p class="club40-tariffs-item-subheader">В тариф входят все преимущества тарифа
                                «С&nbsp;поддержкой»,
                                плюс:</p>
                            <ul>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927796778-lS80O-Fram.svg"
                                        alt="">
                                    <p>Персональная поддержка карьерного эксперта и коуча в чате</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927796778-lS80O-Fram.svg"
                                        alt="">
                                    <p>2 видеоконсультации в месяц с экспертом под ваш карьерный запрос </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927796778-lS80O-Fram.svg"
                                        alt="">
                                    <p>Персональный разбор резюме<br> + 3 письменным фидбека по доработке</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927796778-lS80O-Fram.svg"
                                        alt="">
                                    <p>Персональный разбор LinkedIn<br>+3 письменным фидбека<br>по доработке</p>
                                </li>
                            </ul>
                            <div class="club40-tariffs-item-bottom">
                                <div class="club40-tariffs-item-wrapper-price">
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-pm">310 €</p>
                                        <p class="club40-tariffs-item-price-pmn1m">цена месяца в&nbsp;пакете</p>
                                        <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                    </div>
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-f">930 €</p>
                                        <p>полная стоимость к оплате</p>
                                    </div>
                                </div>
                                <a onclick="" href="#subscribe-individual"
                                    class="btn-color-main-dark-orange no-change">Оставить заявку</a>
                                <p class="club40-tariffs-item-price-rassr-eur" style="">Можно платить долями</p>
                                <p class="club40-tariffs-item-price-rassr-rub" style="display: none;">Можно в рассрочку</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="club40-tariffs-curr">
                    <div class="club40-tariffs__swicher-block">
                        <div class="club40-tariffs__swicher-top">
                            <p class="club40-tariffs__swicher-header">Посмотреть цены в
                                <span>RUB</span>
                            </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" class="club40-tariffs__swicher-arrow">
                                <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black"></path>
                            </svg>
                        </div>
                        <div class="club40-tariffs__swicher-bottom">
                            <ul>
                                <li data-currency="rub">
                                    RUB
                                </li>
                                <li data-currency="eur" class="active">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских рублях
                                возможна только<br> с карты
                                российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
                <div class="club40-tariffs-bottom careerum-flex-sbfs">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733931610233-Rgii4-Vect.svg"
                            alt="">
                        <p class="club40-tariffs-bottom-header">Не знаете, с чего начать?</p>
                        <p class="club40-tariffs-bottom-subheader">Напишите нам — мы ответим на все вопросы и поможем выбрать лучшее решение под вашу цель</p>
                        <a href="#tg" class="btn-color-main-dark-blue careerum-flex-cc">
                            <svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M6.9104 12.5754L9.51374 19.781C9.51374 19.781 9.83922 20.4552 10.1877 20.4552C10.5363 20.4552 15.7201 15.0624 15.7201 15.0624L21.4847 3.92822L7.00329 10.7153L6.9104 12.5754Z"
                                    fill="#C8DAEA" />
                                <path
                                    d="M10.3623 14.4233L9.86251 19.7346C9.86251 19.7346 9.65332 21.362 11.2804 19.7346C12.9074 18.1072 14.4648 16.8522 14.4648 16.8522"
                                    fill="#A9C6D8" />
                                <path
                                    d="M6.9574 12.8324L1.60225 11.0876C1.60225 11.0876 0.962247 10.828 1.16833 10.2392C1.21075 10.1177 1.29633 10.0144 1.55233 9.83687C2.73889 9.00981 23.5146 1.54247 23.5146 1.54247C23.5146 1.54247 24.1012 1.3448 24.4471 1.47628C24.5327 1.50277 24.6097 1.55152 24.6703 1.61755C24.7309 1.68357 24.7728 1.7645 24.7918 1.85205C24.8292 2.00668 24.8448 2.16578 24.8383 2.32473C24.8366 2.46224 24.82 2.58969 24.8074 2.78956C24.6808 4.83116 20.8942 20.0683 20.8942 20.0683C20.8942 20.0683 20.6677 20.9599 19.856 20.9904C19.6565 20.9969 19.4578 20.9631 19.2716 20.8911C19.0855 20.8191 18.9157 20.7103 18.7725 20.5713C17.1797 19.2012 11.6742 15.5012 10.4577 14.6875C10.4302 14.6688 10.4071 14.6445 10.3899 14.6161C10.3727 14.5877 10.3617 14.5559 10.3578 14.523C10.3408 14.4372 10.4341 14.3309 10.4341 14.3309C10.4341 14.3309 20.0205 5.80981 20.2756 4.91527C20.2954 4.84597 20.2208 4.81177 20.1206 4.84213C19.4838 5.07637 8.44622 12.0467 7.22803 12.816C7.14034 12.8425 7.04766 12.8481 6.9574 12.8324Z"
                                    fill="white" />
                            </svg>
                            <p>Написать в Telegram</p>
                        </a>
                    </div>
                    <div>
                        <div class="club40-tariffs-bottom-care">
                            <div class="careerum-flex-fsc">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723278768285-Yeat8-phot.png"
                                        alt="">
                                </div>
                                <div>
                                    <p class="club40-tariffs-bottom-care-name">Анна </p>
                                    <p class="club40-tariffs-bottom-care-position">Команда заботы Careerum</p>
                                </div>
                            </div>
                            <p class="club40-tariffs-bottom-care-descr">Добрый день! Построить карьеру мечты в одиночку
                                бывает непросто. Но мы рядом и приведем вас к заветной цели 💙</p>
                        </div>
                    </div>
                </div>
                <div class="club40-tariffs-bottom-pay position-relative">
                    <p class="club40-tariffs-bottom-pay-label position-absolute">20% скидка для<br> команд от 3 человек</p>
                    <p class="club40-tariffs-bottom-pay-title">Поможем оплатить<br>
                        подписку через работодателя</p>
                    <p class="club40-tariffs-bottom-pay-text">Мы подготовили шаблон письма для вашего руководителя, в
                        котором описали все плюшки подписки Сareerum и добавили специальные условия, если вы захотите
                        позвать коллег:)</p>
                    <div class="careerum-flex-fsfs">
                        <a href="#" class="btn-color-main-white">Забрать шаблон письма для руководителя </a>
                        <a href="#" class="btn-color-main-white">Оплатить сразу от юр.лица</a>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741088816737-v3uAC-Vect.svg" alt=""
                        class="position-absolute hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741091581709-j6Etn-Vect.svg" alt=""
                        class="position-absolute hidden-desc-mobile">
                </div>
            </div>
        </div>`
    });
    
    blockManager.add('club40-tariffs2-mobile', {
        label: 'Club 4 tariffs2 (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-tariffs-mobile club40-tariffs2-mobile">
            <div class="careerum-container-mobile">
                <div class="club40-tariffs-top-label">
                    <p>График повышения цен: </p><br>
                    <div class="careerum-flex-fsc ">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737379529099-NWB2Y-Chec.svg" alt="">
                        <p>15.02</p>
                        <p>17.02</p>
                        <p>19.02</p>
                        <p>22.02</p>
                    </div>
                </div>
                <h2 class="careerum-club40-header-mobile">Решите свою карьерную задачу с нами </h2>
                <div class="club40-tariffs-nav">
                    <div class="club40-tariffs-period">
                        <ul class="careerum-flex-fsfs">
                            <li data-period="1" class="active">30 дней</li>
                            <li data-period="3">90 дней</li>
                            <li data-period="6">180 дней</li>
                            <li data-period="12">365 дней</li>
                        </ul>
                    </div>
                </div>
                <div class="club40-tariffs-curr">
                    <div class="club40-tariffs__swicher-block">
                        <div class="club40-tariffs__swicher-top">
                            <p class="club40-tariffs__swicher-header">Посмотреть цены в
                                <span>RUB</span>
                            </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" class="club40-tariffs__swicher-arrow">
                                <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black"></path>
                            </svg>
                        </div>
                        <div class="club40-tariffs__swicher-bottom">
                            <ul>
                                <li data-currency="rub">
                                    RUB
                                </li>
                                <li data-currency="eur" class="active">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских рублях
                                возможна только<br> с карты
                                российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
                <div class="club40-tariffs-items">
                        <div data-price="" data-price-1m-rub="12 900 ₽" data-price-3m-rub="9&nbsp;967 ₽"
                            data-fullprice-3m-rub="29&nbsp;900 ₽" data-price-6m-rub="7 900 ₽"
                            data-fullprice-6m-rub="47&nbsp;400 ₽" data-price-12m-rub="6 490 ₽"
                            data-fullprice-12m-rub="77 880 ₽" data-price-1m-eur="149 €" data-price-3m-eur="120 €"
                            data-fullprice-3m-eur="360 €" data-price-6m-eur="90 €" data-fullprice-6m-eur="540 €"
                            data-price-12m-eur="80 €" data-fullprice-12m-eur="960 €" data-offer-1m-rub="27"
                            data-offer-3m-rub="94" data-offer-6m-rub="95" data-offer-12m-rub="96" data-offer-1m-eur="48"
                            data-offer-3m-eur="97" data-offer-6m-eur="98" data-offer-12m-eur="99"
                            class="club40-tariffs-item careerum-flex-fsfs">
                            <p class="club40-tariffs-item-subheader2">Тариф «Самостоятельный»</p>
                            <p class="club40-tariffs-item-header">Доступ к карьерной платформе</p>
                            <p class="club40-tariffs-item-description">Неограниченное кол-во мест</p>
                            <ul class="collapsed">
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>80 карьерных курсов</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Трекер заявок на вакансии, чтобы всегда знать, что и куда отправили</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Шаблоны и примеры: резюме на русском и английском, сопроводительные письма, сообщения
                                        работодателям в LinkedIn, деловая email-переписка</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Воркфлоу поиска достижений </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Список платформ для поиска работы в 15 странах</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Алгоритм, чтобы определить свою карьерную стадию </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Скрипт обсуждения зарплаты и оффера </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Формула расчета «Сколько я стою на рынке»
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Алгоритм постановки карьерных гипотез
                                        для смены сферы</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Инструкция по созданию плана карьерного развития</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Методы постановки карьерных целей
                                    </p>
                                </li>
                            </ul>
                            <div class="tariffs-item-switcher careerum-flex-fsc">
                                <p>Показать больше</p>
                                <p>Свернуть</p>
                                <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733929611928-Z084c-Care.svg"
                                alt="">
                            </div>
                            <div class="club40-tariffs-item-bottom">
                                <div class="club40-tariffs-item-discount careerum-flex-fsc">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737368940097-5jGbI-Perc.svg" alt="">
                                    <p>Цена со скидкой на 1-ый платеж</p>
                                </div>
                                <div class="careerum-flex-fsfs club40-tariffs-item-wrapper-price with-discount">
                                    <div>
                                        <p class="club40-tariffs-item-price-f">8 900 ₽</p>
                                    </div>
                                    <div>
                                        <p class="club40-tariffs-item-price-old">12 900 ₽</p>
                                    </div>
                                </div><a onclick="" href="#tariff-single" class="btn-color-main-dark-orange">Выбрать тариф</a>
                                <p class="club40-tariffs-item-price-rassr-eur" style="">Можно платить долями</p>
                                <p class="club40-tariffs-item-price-rassr-rub" style="display: none;">Можно в рассрочку</p>
                            </div>
                        </div>
                        <div data-price="" data-price-1m-rub="12 900 ₽" data-price-3m-rub="9&nbsp;967 ₽"
                            data-fullprice-3m-rub="29&nbsp;900 ₽" data-price-6m-rub="7 900 ₽"
                            data-fullprice-6m-rub="47&nbsp;400 ₽" data-price-12m-rub="6 490 ₽"
                            data-fullprice-12m-rub="77 880 ₽" data-price-1m-eur="149 €" data-price-3m-eur="120 €"
                            data-fullprice-3m-eur="360 €" data-price-6m-eur="90 €" data-fullprice-6m-eur="540 €"
                            data-price-12m-eur="80 €" data-fullprice-12m-eur="960 €" data-offer-1m-rub="27"
                            data-offer-3m-rub="94" data-offer-6m-rub="95" data-offer-12m-rub="96" data-offer-1m-eur="48"
                            data-offer-3m-eur="97" data-offer-6m-eur="98" data-offer-12m-eur="99"
                            class="club40-tariffs-item careerum-flex-fsfs">
                            <p class="club40-tariffs-item-subheader2">Тариф «Самостоятельный»</p>
                            <p class="club40-tariffs-item-header">Доступ к карьерной платформе</p>
                            <p class="club40-tariffs-item-description">Неограниченное кол-во мест</p>
                            <ul class="collapsed">
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>80 карьерных курсов</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Трекер заявок на вакансии, чтобы всегда знать, что и куда отправили</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Шаблоны и примеры: резюме на русском и английском, сопроводительные письма, сообщения
                                        работодателям в LinkedIn, деловая email-переписка</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Воркфлоу поиска достижений </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Список платформ для поиска работы в 15 странах</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Алгоритм, чтобы определить свою карьерную стадию </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Скрипт обсуждения зарплаты и оффера </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Формула расчета «Сколько я стою на рынке»
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Алгоритм постановки карьерных гипотез
                                        для смены сферы</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Инструкция по созданию плана карьерного развития</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Методы постановки карьерных целей
                                    </p>
                                </li>
                            </ul>
                            <div class="tariffs-item-switcher careerum-flex-fsc">
                                <p>Показать больше</p>
                                <p>Свернуть</p>
                                <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733929611928-Z084c-Care.svg"
                                alt="">
                            </div>
                            <div class="club40-tariffs-item-bottom">
                                <div class="club40-tariffs-item-wrapper-price">
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-pm">310 €</p>
                                        <p class="club40-tariffs-item-price-pmn1m">цена месяца в&nbsp;пакете</p>
                                        <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                    </div>
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-f">930 €</p>
                                        <p>полная стоимость к оплате</p>
                                    </div>
                                </div>
                                <a onclick="" href="#tariff-single" class="btn-color-main-dark-orange">Выбрать
                                    тариф</a>
                                <p class="club40-tariffs-item-price-rassr-eur" style="">Можно платить долями</p>
                                <p class="club40-tariffs-item-price-rassr-rub" style="display: none;">Можно в рассрочку</p>
                            </div>
                        </div>
                        <div data-price="" data-price-1m-rub="14 900 ₽" data-price-3m-rub="11&nbsp;633 ₽"
                            data-fullprice-3m-rub="34&nbsp;900 ₽" data-price-6m-rub="9&nbsp;817 ₽"
                            data-fullprice-6m-rub="58&nbsp;900 ₽" data-price-12m-rub="8 000 ₽"
                            data-fullprice-12m-rub="96 000 ₽" data-price-1m-eur="199 €" data-price-3m-eur="170 €"
                            data-fullprice-3m-eur="510 €" data-price-6m-eur="130 €" data-fullprice-6m-eur="780 €"
                            data-price-12m-eur="100 €" data-fullprice-12m-eur="1 200 €" data-offer-1m-rub="28"
                            data-offer-3m-rub="29" data-offer-6m-rub="30" data-offer-12m-rub="31" data-offer-1m-eur="49"
                            data-offer-3m-eur="50" data-offer-6m-eur="51" data-offer-12m-eur="52"
                            class="club40-tariffs-item careerum-flex-fsfs">
                            <p class="club40-tariffs-item-label">Популярный</p>
                            <p class="club40-tariffs-item-subheader2">Тариф «С поддержкой»</p>
                            <p class="club40-tariffs-item-header">Платформа +<br>групповой чат с экспертом</p>
                            <p class="club40-tariffs-item-description">Осталось: 25 мест</p>
                            <div class="club40-tariffs-item-divider"></div>
                            <p class="club40-tariffs-item-subheader">В тариф входят все опции тарифа «Самостоятельный»,
                                плюс:
                            </p>
                            <ul>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927796778-lS80O-Fram.svg"
                                        alt="">
                                    <p>Групповой чат с экспертом и кураторами платформы</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927796778-lS80O-Fram.svg"
                                        alt="">
                                    <p>2 группые Q&A-встречи в месяц с экспертом для разбора вопросов</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927796778-lS80O-Fram.svg"
                                        alt="">
                                    <p>Доступ к Сareerum.Club и всем ивентам клуба</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927796778-lS80O-Fram.svg"
                                        alt="">
                                    <p>Доступ к сезонным Интенсивам </p>
                                </li>
                            </ul>
                            <div class="club40-tariffs-item-bottom">
                                <div class="club40-tariffs-item-wrapper-price">
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-pm">310 €</p>
                                        <p class="club40-tariffs-item-price-pmn1m">цена месяца в&nbsp;пакете</p>
                                        <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                    </div>
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-f">930 €</p>
                                        <p>полная стоимость к оплате</p>
                                    </div>
                                </div>
                                <a onclick="" href="#subscribe-support"
                                    class="btn-color-main-dark-orange no-change">Оставить заявку</a>
                                <p class="club40-tariffs-item-price-rassr-eur" style="">Можно платить долями</p>
                                <p class="club40-tariffs-item-price-rassr-rub" style="display: none;">Можно в рассрочку</p>
                            </div>
                        </div>
                        <div data-price="" data-price-1m-rub="27 900 ₽" data-price-3m-rub="23&nbsp;900 ₽"
                            data-fullprice-3m-rub="71&nbsp;700 ₽" data-price-6m-rub="18&nbsp;317 ₽"
                            data-fullprice-6m-rub="109&nbsp;900 ₽" data-price-12m-rub="16&nbsp;583 ₽"
                            data-fullprice-12m-rub="199 000 ₽" data-price-1m-eur="360 €" data-price-3m-eur="310 €"
                            data-fullprice-3m-eur="930 €" data-price-6m-eur="250 €" data-fullprice-6m-eur="1 500 €"
                            data-price-12m-eur="230 €" data-fullprice-12m-eur="2 760 €" data-offer-1m-rub="32"
                            data-offer-3m-rub="100" data-offer-6m-rub="101" data-offer-12m-rub="102" data-offer-1m-eur="53"
                            data-offer-3m-eur="103" data-offer-6m-eur="104" data-offer-12m-eur="105"
                            class="club40-tariffs-item careerum-flex-fsfs">
                            <p class="club40-tariffs-item-subheader2">Тариф «Индивидуальный подход»</p>
                            <p class="club40-tariffs-item-header">Платформа +<br>консультации с экспертом</p>
                            <p class="club40-tariffs-item-description">Осталось: 25 мест</p>
                            <div class="club40-tariffs-item-divider"></div>
                            <p class="club40-tariffs-item-subheader">В тариф входят все преимущества тарифа
                                «С&nbsp;поддержкой»,
                                плюс:</p>
                            <ul>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927796778-lS80O-Fram.svg"
                                        alt="">
                                    <p>Персональная поддержка карьерного эксперта и коуча в чате</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927796778-lS80O-Fram.svg"
                                        alt="">
                                    <p>2 видеоконсультации в месяц с экспертом под ваш карьерный запрос </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927796778-lS80O-Fram.svg"
                                        alt="">
                                    <p>Персональный разбор резюме<br> + 3 письменным фидбека по доработке</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927796778-lS80O-Fram.svg"
                                        alt="">
                                    <p>Персональный разбор LinkedIn<br>+3 письменным фидбека<br>по доработке</p>
                                </li>
                            </ul>
                            <div class="club40-tariffs-item-bottom">
                                <div class="club40-tariffs-item-wrapper-price">
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-pm">310 €</p>
                                        <p class="club40-tariffs-item-price-pmn1m">цена месяца в&nbsp;пакете</p>
                                        <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                    </div>
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-f">930 €</p>
                                        <p>полная стоимость к оплате</p>
                                    </div>
                                </div>
                                <a onclick="" href="#subscribe-individual"
                                    class="btn-color-main-dark-orange no-change">Оставить заявку</a>
                                <p class="club40-tariffs-item-price-rassr-eur" style="">Можно платить долями</p>
                                <p class="club40-tariffs-item-price-rassr-rub" style="display: none;">Можно в рассрочку</p>
                            </div>
                        </div>
                </div>
                <div class="club40-tariffs-bottom">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733936419948-QhCyw-Vect.svg"
                            alt="">
                        <p class="club40-tariffs-bottom-header">Не знаете, с чего начать?</p>
                        <p class="club40-tariffs-bottom-subheader">Напишите нам — мы ответим на все вопросы и поможем
                            выбрать решение под вашу задачу</p>
                    </div>
                    <div>
                        <div class="club40-tariffs-bottom-care">
                            <div class="careerum-flex-fsc">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723278768285-Yeat8-phot.png"
                                        alt="">
                                </div>
                                <div>
                                    <p class="club40-tariffs-bottom-care-name">Анна </p>
                                    <p class="club40-tariffs-bottom-care-position">Команда заботы Careerum</p>
                                </div>
                            </div>
                            <p class="club40-tariffs-bottom-care-descr">Добрый день! Построить карьеру мечты в одиночку
                                бывает непросто. Но мы рядом и приведем вас к заветной цели 💙</p>
                        </div>
                        <a href="#tg" class="btn-color-main-dark-blue careerum-flex-cc">
                            <svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M6.9104 12.5754L9.51374 19.781C9.51374 19.781 9.83922 20.4552 10.1877 20.4552C10.5363 20.4552 15.7201 15.0624 15.7201 15.0624L21.4847 3.92822L7.00329 10.7153L6.9104 12.5754Z"
                                    fill="#C8DAEA" />
                                <path
                                    d="M10.3623 14.4233L9.86251 19.7346C9.86251 19.7346 9.65332 21.362 11.2804 19.7346C12.9074 18.1072 14.4648 16.8522 14.4648 16.8522"
                                    fill="#A9C6D8" />
                                <path
                                    d="M6.9574 12.8324L1.60225 11.0876C1.60225 11.0876 0.962247 10.828 1.16833 10.2392C1.21075 10.1177 1.29633 10.0144 1.55233 9.83687C2.73889 9.00981 23.5146 1.54247 23.5146 1.54247C23.5146 1.54247 24.1012 1.3448 24.4471 1.47628C24.5327 1.50277 24.6097 1.55152 24.6703 1.61755C24.7309 1.68357 24.7728 1.7645 24.7918 1.85205C24.8292 2.00668 24.8448 2.16578 24.8383 2.32473C24.8366 2.46224 24.82 2.58969 24.8074 2.78956C24.6808 4.83116 20.8942 20.0683 20.8942 20.0683C20.8942 20.0683 20.6677 20.9599 19.856 20.9904C19.6565 20.9969 19.4578 20.9631 19.2716 20.8911C19.0855 20.8191 18.9157 20.7103 18.7725 20.5713C17.1797 19.2012 11.6742 15.5012 10.4577 14.6875C10.4302 14.6688 10.4071 14.6445 10.3899 14.6161C10.3727 14.5877 10.3617 14.5559 10.3578 14.523C10.3408 14.4372 10.4341 14.3309 10.4341 14.3309C10.4341 14.3309 20.0205 5.80981 20.2756 4.91527C20.2954 4.84597 20.2208 4.81177 20.1206 4.84213C19.4838 5.07637 8.44622 12.0467 7.22803 12.816C7.14034 12.8425 7.04766 12.8481 6.9574 12.8324Z"
                                    fill="white" />
                            </svg>
                            <p>Написать нам в Telegram</p>
                        </a>
                    </div>
                </div>
                <div class="club40-tariffs-bottom-pay position-relative">
                    <p class="club40-tariffs-bottom-pay-title">Поможем оплатить
                        подписку через работодателя</p>
                    <p class="club40-tariffs-bottom-pay-text">Мы подготовили шаблон письма для вашего руководителя, в
                        котором описали все плюшки подписки Сareerum и добавили специальные условия, если вы захотите
                        позвать коллег:)</p>
                    <p class="club40-tariffs-bottom-pay-label position-relative">20% скидка для<br> команд от 3 человек</p>
                    <div class="careerum-flex-fsfs">
                        <a href="#" class="btn-color-main-white">Забрать шаблон письма для руководителя </a>
                        <a href="#" class="btn-color-main-white">Оплатить сразу от юр.лица</a>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741088816737-v3uAC-Vect.svg" alt=""
                        class="position-absolute hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741091581709-j6Etn-Vect.svg" alt=""
                        class="position-absolute hidden-desc-mobile">
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-results', {
        label: 'Club 4 results (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-results main-wrapper">
            <div class="careerum-container-responsive">
                <h2 >
                    Результаты, которые достигли наши клиенты
                </h2>
                <div class="club40-results-slider">
                    <div class="club40-results-slider-item">
                        <div class="careerum-flex-fsc">
                            <div class="position-relative">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422853-o2LIn-Grou.png"
                                    alt="">
                                <a href="#1" class="position-absolute">
                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <rect width="32" height="32" rx="16" fill="#00BAFF" />
                                        <path
                                            d="M17.227 13.3841C17.7811 12.6708 18.4708 12.2227 19.3492 12.1343C21.1472 11.9575 22.5443 12.7562 23.013 14.6338C23.125 15.0789 23.178 15.5505 23.1839 16.0103C23.2046 17.5902 23.1869 19.1701 23.1987 20.7529C23.2016 21.0241 23.1191 21.1037 22.8509 21.0978C22.0992 21.0801 21.3447 21.0919 20.593 21.0919C20.2069 21.0919 20.204 21.0919 20.204 20.7146C20.204 19.2821 20.2069 17.8525 20.201 16.42C20.201 16.1695 20.1863 15.919 20.1391 15.6743C20.036 15.1054 19.7648 14.6545 19.1605 14.5159C18.5003 14.3685 17.9521 14.5719 17.5453 15.1202C17.3007 15.4473 17.2299 15.8276 17.2299 16.2255C17.227 17.7228 17.2299 19.2202 17.2299 20.7146C17.2299 20.8236 17.2299 20.9357 17.2299 21.0624C17.1356 21.0742 17.0649 21.0919 16.9941 21.0919C16.1747 21.0948 15.3582 21.086 14.5388 21.0978C14.3207 21.1007 14.2765 21.0182 14.2794 20.8207C14.2853 18.0795 14.2853 15.3353 14.2794 12.5941C14.2794 12.3672 14.359 12.3023 14.5683 12.3053C15.3582 12.3112 16.1482 12.3141 16.9381 12.3053C17.1739 12.3023 17.2476 12.3908 17.2329 12.6148C17.2152 12.8653 17.227 13.1247 17.227 13.3841Z"
                                            fill="white" />
                                        <path
                                            d="M12.7564 16.7155C12.7564 18.0536 12.7505 19.3918 12.7623 20.7329C12.7653 21.01 12.6916 21.1043 12.4027 21.0955C11.6305 21.0749 10.8582 21.0808 10.0889 21.0925C9.85309 21.0955 9.76172 21.0395 9.76172 20.786C9.77056 18.0625 9.77056 15.339 9.76172 12.6125C9.76172 12.362 9.85604 12.2942 10.0889 12.2971C10.87 12.3059 11.6511 12.3089 12.4322 12.2971C12.6975 12.2912 12.7623 12.3973 12.7594 12.6449C12.7505 14.0008 12.7564 15.3596 12.7564 16.7155Z"
                                            fill="white" />
                                        <path
                                            d="M12.9303 9.67361C12.9303 10.552 12.2229 11.2034 11.2591 11.2093C10.3188 11.2152 9.59961 10.5431 9.59961 9.65887C9.59961 8.76871 10.3277 8.10257 11.2915 8.11142C12.2465 8.11731 12.9303 8.76871 12.9303 9.67361Z"
                                            fill="white" />
                                    </svg>
                                </a>
                            </div>
                            <div>
                                <p>Сергей Михайлов</p>
                                <p>Technical Transfer Lead, Австрия</p>
                            </div>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Хотел найти работу проджет-менеджера в международной компании и переехать в Западную Европу</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Прошел Real Me, «Звёздного кандидата», проработал резюме и составил стратегию</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Получил оффер c релокацией в Австрию весной 2022 года, увеличил доход в 3 раза</p>
                        </div>
                    </div>
                    <div class="club40-results-slider-item">
                        <div class="careerum-flex-fsc">
                            <div class="position-relative">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116421826-n9oaA-Grou.png"
                                    alt="">
                                    <a href="#1" class="position-absolute">
                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <rect width="32" height="32" rx="16" fill="#00BAFF" />
                                            <path
                                                d="M17.227 13.3841C17.7811 12.6708 18.4708 12.2227 19.3492 12.1343C21.1472 11.9575 22.5443 12.7562 23.013 14.6338C23.125 15.0789 23.178 15.5505 23.1839 16.0103C23.2046 17.5902 23.1869 19.1701 23.1987 20.7529C23.2016 21.0241 23.1191 21.1037 22.8509 21.0978C22.0992 21.0801 21.3447 21.0919 20.593 21.0919C20.2069 21.0919 20.204 21.0919 20.204 20.7146C20.204 19.2821 20.2069 17.8525 20.201 16.42C20.201 16.1695 20.1863 15.919 20.1391 15.6743C20.036 15.1054 19.7648 14.6545 19.1605 14.5159C18.5003 14.3685 17.9521 14.5719 17.5453 15.1202C17.3007 15.4473 17.2299 15.8276 17.2299 16.2255C17.227 17.7228 17.2299 19.2202 17.2299 20.7146C17.2299 20.8236 17.2299 20.9357 17.2299 21.0624C17.1356 21.0742 17.0649 21.0919 16.9941 21.0919C16.1747 21.0948 15.3582 21.086 14.5388 21.0978C14.3207 21.1007 14.2765 21.0182 14.2794 20.8207C14.2853 18.0795 14.2853 15.3353 14.2794 12.5941C14.2794 12.3672 14.359 12.3023 14.5683 12.3053C15.3582 12.3112 16.1482 12.3141 16.9381 12.3053C17.1739 12.3023 17.2476 12.3908 17.2329 12.6148C17.2152 12.8653 17.227 13.1247 17.227 13.3841Z"
                                                fill="white" />
                                            <path
                                                d="M12.7564 16.7155C12.7564 18.0536 12.7505 19.3918 12.7623 20.7329C12.7653 21.01 12.6916 21.1043 12.4027 21.0955C11.6305 21.0749 10.8582 21.0808 10.0889 21.0925C9.85309 21.0955 9.76172 21.0395 9.76172 20.786C9.77056 18.0625 9.77056 15.339 9.76172 12.6125C9.76172 12.362 9.85604 12.2942 10.0889 12.2971C10.87 12.3059 11.6511 12.3089 12.4322 12.2971C12.6975 12.2912 12.7623 12.3973 12.7594 12.6449C12.7505 14.0008 12.7564 15.3596 12.7564 16.7155Z"
                                                fill="white" />
                                            <path
                                                d="M12.9303 9.67361C12.9303 10.552 12.2229 11.2034 11.2591 11.2093C10.3188 11.2152 9.59961 10.5431 9.59961 9.65887C9.59961 8.76871 10.3277 8.10257 11.2915 8.11142C12.2465 8.11731 12.9303 8.76871 12.9303 9.67361Z"
                                                fill="white" />
                                        </svg>
                                    </a>
                            </div>
                            <div>
                                <p>Александра Пинчукова</p>
                                <p>менеджер бизнес-процессов, Германия</p>
                            </div>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Работала главным бухгалтером. Хотела найти работу в Германии и переехать</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Прошла «Звёздного кандидата», курсы по LinkedIn и самооценку, работала с коучем и CV-специалистом</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Получила оффер в штаб-квартиру Puma в начале 2023 года – после 3 месяцев поиска</p>
                        </div>
                    </div>
                    <div class="club40-results-slider-item">
                        <div class="careerum-flex-fsc">
                            <div class="position-relative">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422118-nici9-Grou.png"
                                    alt="">
                                    <a href="#1" class="position-absolute">
                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <rect width="32" height="32" rx="16" fill="#00BAFF" />
                                            <path
                                                d="M17.227 13.3841C17.7811 12.6708 18.4708 12.2227 19.3492 12.1343C21.1472 11.9575 22.5443 12.7562 23.013 14.6338C23.125 15.0789 23.178 15.5505 23.1839 16.0103C23.2046 17.5902 23.1869 19.1701 23.1987 20.7529C23.2016 21.0241 23.1191 21.1037 22.8509 21.0978C22.0992 21.0801 21.3447 21.0919 20.593 21.0919C20.2069 21.0919 20.204 21.0919 20.204 20.7146C20.204 19.2821 20.2069 17.8525 20.201 16.42C20.201 16.1695 20.1863 15.919 20.1391 15.6743C20.036 15.1054 19.7648 14.6545 19.1605 14.5159C18.5003 14.3685 17.9521 14.5719 17.5453 15.1202C17.3007 15.4473 17.2299 15.8276 17.2299 16.2255C17.227 17.7228 17.2299 19.2202 17.2299 20.7146C17.2299 20.8236 17.2299 20.9357 17.2299 21.0624C17.1356 21.0742 17.0649 21.0919 16.9941 21.0919C16.1747 21.0948 15.3582 21.086 14.5388 21.0978C14.3207 21.1007 14.2765 21.0182 14.2794 20.8207C14.2853 18.0795 14.2853 15.3353 14.2794 12.5941C14.2794 12.3672 14.359 12.3023 14.5683 12.3053C15.3582 12.3112 16.1482 12.3141 16.9381 12.3053C17.1739 12.3023 17.2476 12.3908 17.2329 12.6148C17.2152 12.8653 17.227 13.1247 17.227 13.3841Z"
                                                fill="white" />
                                            <path
                                                d="M12.7564 16.7155C12.7564 18.0536 12.7505 19.3918 12.7623 20.7329C12.7653 21.01 12.6916 21.1043 12.4027 21.0955C11.6305 21.0749 10.8582 21.0808 10.0889 21.0925C9.85309 21.0955 9.76172 21.0395 9.76172 20.786C9.77056 18.0625 9.77056 15.339 9.76172 12.6125C9.76172 12.362 9.85604 12.2942 10.0889 12.2971C10.87 12.3059 11.6511 12.3089 12.4322 12.2971C12.6975 12.2912 12.7623 12.3973 12.7594 12.6449C12.7505 14.0008 12.7564 15.3596 12.7564 16.7155Z"
                                                fill="white" />
                                            <path
                                                d="M12.9303 9.67361C12.9303 10.552 12.2229 11.2034 11.2591 11.2093C10.3188 11.2152 9.59961 10.5431 9.59961 9.65887C9.59961 8.76871 10.3277 8.10257 11.2915 8.11142C12.2465 8.11731 12.9303 8.76871 12.9303 9.67361Z"
                                                fill="white" />
                                        </svg>
                                    </a>
                            </div>
                            <div>
                                <p>Сергей Бухаров</p>
                                <p>Supply Chain Forecast Analyst, Нидерланды</p>
                            </div>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Уволился из Mars весной 2022 года, так как не смог договориться о релокации, переехал из России в Грузию</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Прошел курс Real Me, персонально работал с экспертом клуба, составил стратегию</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Получил оффер от Mars с релокацией в Нидерланды в середине 2022 года</p>
                        </div>
                    </div>
                    <div class="club40-results-slider-item">
                        <div class="careerum-flex-fsc">
                            <div class="position-relative">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422236-vLdYI-Grou.png"
                                    alt="">
                                    <a href="#1" class="position-absolute">
                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <rect width="32" height="32" rx="16" fill="#00BAFF" />
                                            <path
                                                d="M17.227 13.3841C17.7811 12.6708 18.4708 12.2227 19.3492 12.1343C21.1472 11.9575 22.5443 12.7562 23.013 14.6338C23.125 15.0789 23.178 15.5505 23.1839 16.0103C23.2046 17.5902 23.1869 19.1701 23.1987 20.7529C23.2016 21.0241 23.1191 21.1037 22.8509 21.0978C22.0992 21.0801 21.3447 21.0919 20.593 21.0919C20.2069 21.0919 20.204 21.0919 20.204 20.7146C20.204 19.2821 20.2069 17.8525 20.201 16.42C20.201 16.1695 20.1863 15.919 20.1391 15.6743C20.036 15.1054 19.7648 14.6545 19.1605 14.5159C18.5003 14.3685 17.9521 14.5719 17.5453 15.1202C17.3007 15.4473 17.2299 15.8276 17.2299 16.2255C17.227 17.7228 17.2299 19.2202 17.2299 20.7146C17.2299 20.8236 17.2299 20.9357 17.2299 21.0624C17.1356 21.0742 17.0649 21.0919 16.9941 21.0919C16.1747 21.0948 15.3582 21.086 14.5388 21.0978C14.3207 21.1007 14.2765 21.0182 14.2794 20.8207C14.2853 18.0795 14.2853 15.3353 14.2794 12.5941C14.2794 12.3672 14.359 12.3023 14.5683 12.3053C15.3582 12.3112 16.1482 12.3141 16.9381 12.3053C17.1739 12.3023 17.2476 12.3908 17.2329 12.6148C17.2152 12.8653 17.227 13.1247 17.227 13.3841Z"
                                                fill="white" />
                                            <path
                                                d="M12.7564 16.7155C12.7564 18.0536 12.7505 19.3918 12.7623 20.7329C12.7653 21.01 12.6916 21.1043 12.4027 21.0955C11.6305 21.0749 10.8582 21.0808 10.0889 21.0925C9.85309 21.0955 9.76172 21.0395 9.76172 20.786C9.77056 18.0625 9.77056 15.339 9.76172 12.6125C9.76172 12.362 9.85604 12.2942 10.0889 12.2971C10.87 12.3059 11.6511 12.3089 12.4322 12.2971C12.6975 12.2912 12.7623 12.3973 12.7594 12.6449C12.7505 14.0008 12.7564 15.3596 12.7564 16.7155Z"
                                                fill="white" />
                                            <path
                                                d="M12.9303 9.67361C12.9303 10.552 12.2229 11.2034 11.2591 11.2093C10.3188 11.2152 9.59961 10.5431 9.59961 9.65887C9.59961 8.76871 10.3277 8.10257 11.2915 8.11142C12.2465 8.11731 12.9303 8.76871 12.9303 9.67361Z"
                                                fill="white" />
                                        </svg>
                                    </a>
                            </div>
                            <div>
                                <p>Карина Пысина</p>
                                <p>бизнес-аналитик, Россия</p>
                            </div>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Пыталась перейти в бизнес-анализ из клиентского отдела, но не смогла и уволилась вникуда</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Прошла Real Me, «Звёздного кандидата», работала с коучем, составила продающее резюме</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Получила оффер бизнес-аналитика, зарплату на 100% выше в 2022 году</p>
                        </div>
                    </div>
                    <div class="club40-results-slider-item">
                        <div class="careerum-flex-fsc">
                            <div class="position-relative">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422371-2l7A2-Grou.png"
                                    alt="">
                                    <a href="#1" class="position-absolute">
                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <rect width="32" height="32" rx="16" fill="#00BAFF" />
                                            <path
                                                d="M17.227 13.3841C17.7811 12.6708 18.4708 12.2227 19.3492 12.1343C21.1472 11.9575 22.5443 12.7562 23.013 14.6338C23.125 15.0789 23.178 15.5505 23.1839 16.0103C23.2046 17.5902 23.1869 19.1701 23.1987 20.7529C23.2016 21.0241 23.1191 21.1037 22.8509 21.0978C22.0992 21.0801 21.3447 21.0919 20.593 21.0919C20.2069 21.0919 20.204 21.0919 20.204 20.7146C20.204 19.2821 20.2069 17.8525 20.201 16.42C20.201 16.1695 20.1863 15.919 20.1391 15.6743C20.036 15.1054 19.7648 14.6545 19.1605 14.5159C18.5003 14.3685 17.9521 14.5719 17.5453 15.1202C17.3007 15.4473 17.2299 15.8276 17.2299 16.2255C17.227 17.7228 17.2299 19.2202 17.2299 20.7146C17.2299 20.8236 17.2299 20.9357 17.2299 21.0624C17.1356 21.0742 17.0649 21.0919 16.9941 21.0919C16.1747 21.0948 15.3582 21.086 14.5388 21.0978C14.3207 21.1007 14.2765 21.0182 14.2794 20.8207C14.2853 18.0795 14.2853 15.3353 14.2794 12.5941C14.2794 12.3672 14.359 12.3023 14.5683 12.3053C15.3582 12.3112 16.1482 12.3141 16.9381 12.3053C17.1739 12.3023 17.2476 12.3908 17.2329 12.6148C17.2152 12.8653 17.227 13.1247 17.227 13.3841Z"
                                                fill="white" />
                                            <path
                                                d="M12.7564 16.7155C12.7564 18.0536 12.7505 19.3918 12.7623 20.7329C12.7653 21.01 12.6916 21.1043 12.4027 21.0955C11.6305 21.0749 10.8582 21.0808 10.0889 21.0925C9.85309 21.0955 9.76172 21.0395 9.76172 20.786C9.77056 18.0625 9.77056 15.339 9.76172 12.6125C9.76172 12.362 9.85604 12.2942 10.0889 12.2971C10.87 12.3059 11.6511 12.3089 12.4322 12.2971C12.6975 12.2912 12.7623 12.3973 12.7594 12.6449C12.7505 14.0008 12.7564 15.3596 12.7564 16.7155Z"
                                                fill="white" />
                                            <path
                                                d="M12.9303 9.67361C12.9303 10.552 12.2229 11.2034 11.2591 11.2093C10.3188 11.2152 9.59961 10.5431 9.59961 9.65887C9.59961 8.76871 10.3277 8.10257 11.2915 8.11142C12.2465 8.11731 12.9303 8.76871 12.9303 9.67361Z"
                                                fill="white" />
                                        </svg>
                                    </a>
                            </div>
                            <div>
                                <p>Тая Штоль</p>
                                <p>UX/UI-дизайнер, Испания</p>
                            </div>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Потеряла всех клиентов из России в феврале 2022 года. Хотела в найм, но опыт был только во фрилансе</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Прошла программы «Звёздный кандидат» и «Выход из декрета», работала с коучем</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Получила оффер в немецкую компанию. Увеличила доход в 6 раз, получила соцпакет</p>
                        </div>
                    </div>
                    <div class="club40-results-slider-item">
                        <div class="careerum-flex-fsc">
                            <div class="position-relative">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422492-aq4aa-Grou.png"
                                    alt="">
                                    <a href="#1" class="position-absolute">
                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <rect width="32" height="32" rx="16" fill="#00BAFF" />
                                            <path
                                                d="M17.227 13.3841C17.7811 12.6708 18.4708 12.2227 19.3492 12.1343C21.1472 11.9575 22.5443 12.7562 23.013 14.6338C23.125 15.0789 23.178 15.5505 23.1839 16.0103C23.2046 17.5902 23.1869 19.1701 23.1987 20.7529C23.2016 21.0241 23.1191 21.1037 22.8509 21.0978C22.0992 21.0801 21.3447 21.0919 20.593 21.0919C20.2069 21.0919 20.204 21.0919 20.204 20.7146C20.204 19.2821 20.2069 17.8525 20.201 16.42C20.201 16.1695 20.1863 15.919 20.1391 15.6743C20.036 15.1054 19.7648 14.6545 19.1605 14.5159C18.5003 14.3685 17.9521 14.5719 17.5453 15.1202C17.3007 15.4473 17.2299 15.8276 17.2299 16.2255C17.227 17.7228 17.2299 19.2202 17.2299 20.7146C17.2299 20.8236 17.2299 20.9357 17.2299 21.0624C17.1356 21.0742 17.0649 21.0919 16.9941 21.0919C16.1747 21.0948 15.3582 21.086 14.5388 21.0978C14.3207 21.1007 14.2765 21.0182 14.2794 20.8207C14.2853 18.0795 14.2853 15.3353 14.2794 12.5941C14.2794 12.3672 14.359 12.3023 14.5683 12.3053C15.3582 12.3112 16.1482 12.3141 16.9381 12.3053C17.1739 12.3023 17.2476 12.3908 17.2329 12.6148C17.2152 12.8653 17.227 13.1247 17.227 13.3841Z"
                                                fill="white" />
                                            <path
                                                d="M12.7564 16.7155C12.7564 18.0536 12.7505 19.3918 12.7623 20.7329C12.7653 21.01 12.6916 21.1043 12.4027 21.0955C11.6305 21.0749 10.8582 21.0808 10.0889 21.0925C9.85309 21.0955 9.76172 21.0395 9.76172 20.786C9.77056 18.0625 9.77056 15.339 9.76172 12.6125C9.76172 12.362 9.85604 12.2942 10.0889 12.2971C10.87 12.3059 11.6511 12.3089 12.4322 12.2971C12.6975 12.2912 12.7623 12.3973 12.7594 12.6449C12.7505 14.0008 12.7564 15.3596 12.7564 16.7155Z"
                                                fill="white" />
                                            <path
                                                d="M12.9303 9.67361C12.9303 10.552 12.2229 11.2034 11.2591 11.2093C10.3188 11.2152 9.59961 10.5431 9.59961 9.65887C9.59961 8.76871 10.3277 8.10257 11.2915 8.11142C12.2465 8.11731 12.9303 8.76871 12.9303 9.67361Z"
                                                fill="white" />
                                        </svg>
                                    </a>
                            </div>
                            <div>
                                <p>Евгения Вольхина</p>
                                <p>Project Manager, Германия</p>
                            </div>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Работала консультантом-методологом в Екатеринбурге. Хотела стать project manager в Германии</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Прошла «Звёздного кандидата», прокачала CV, выстроила нетворк</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Получила оффер в Big4 в Москве и зарплату в 3,5 раза больше, потом – оффер в Германию с ростом ещё на 40%</p>
                        </div>
                    </div>
                    <div class="club40-results-slider-item">
                        <div class="careerum-flex-fsc">
                            <div class="position-relative">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422621-VPn05-Grou.png"
                                    alt="">
                                    <a href="#1" class="position-absolute">
                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <rect width="32" height="32" rx="16" fill="#00BAFF" />
                                            <path
                                                d="M17.227 13.3841C17.7811 12.6708 18.4708 12.2227 19.3492 12.1343C21.1472 11.9575 22.5443 12.7562 23.013 14.6338C23.125 15.0789 23.178 15.5505 23.1839 16.0103C23.2046 17.5902 23.1869 19.1701 23.1987 20.7529C23.2016 21.0241 23.1191 21.1037 22.8509 21.0978C22.0992 21.0801 21.3447 21.0919 20.593 21.0919C20.2069 21.0919 20.204 21.0919 20.204 20.7146C20.204 19.2821 20.2069 17.8525 20.201 16.42C20.201 16.1695 20.1863 15.919 20.1391 15.6743C20.036 15.1054 19.7648 14.6545 19.1605 14.5159C18.5003 14.3685 17.9521 14.5719 17.5453 15.1202C17.3007 15.4473 17.2299 15.8276 17.2299 16.2255C17.227 17.7228 17.2299 19.2202 17.2299 20.7146C17.2299 20.8236 17.2299 20.9357 17.2299 21.0624C17.1356 21.0742 17.0649 21.0919 16.9941 21.0919C16.1747 21.0948 15.3582 21.086 14.5388 21.0978C14.3207 21.1007 14.2765 21.0182 14.2794 20.8207C14.2853 18.0795 14.2853 15.3353 14.2794 12.5941C14.2794 12.3672 14.359 12.3023 14.5683 12.3053C15.3582 12.3112 16.1482 12.3141 16.9381 12.3053C17.1739 12.3023 17.2476 12.3908 17.2329 12.6148C17.2152 12.8653 17.227 13.1247 17.227 13.3841Z"
                                                fill="white" />
                                            <path
                                                d="M12.7564 16.7155C12.7564 18.0536 12.7505 19.3918 12.7623 20.7329C12.7653 21.01 12.6916 21.1043 12.4027 21.0955C11.6305 21.0749 10.8582 21.0808 10.0889 21.0925C9.85309 21.0955 9.76172 21.0395 9.76172 20.786C9.77056 18.0625 9.77056 15.339 9.76172 12.6125C9.76172 12.362 9.85604 12.2942 10.0889 12.2971C10.87 12.3059 11.6511 12.3089 12.4322 12.2971C12.6975 12.2912 12.7623 12.3973 12.7594 12.6449C12.7505 14.0008 12.7564 15.3596 12.7564 16.7155Z"
                                                fill="white" />
                                            <path
                                                d="M12.9303 9.67361C12.9303 10.552 12.2229 11.2034 11.2591 11.2093C10.3188 11.2152 9.59961 10.5431 9.59961 9.65887C9.59961 8.76871 10.3277 8.10257 11.2915 8.11142C12.2465 8.11731 12.9303 8.76871 12.9303 9.67361Z"
                                                fill="white" />
                                        </svg>
                                    </a>
                            </div>
                            <div>
                                <p>Олег Федоткин</p>
                                <p>Head of Department, Германия</p>
                            </div>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Не мог найти работу в Германии, не хотел возвращаться в Москву после окончания контракта Henkel</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Прошел Real Me, составил стратегию, прорабатывал запрос в паре с участником клуба</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Получил оффер на head-позицию с ростом зарплаты на 30% в начале 2022 года</p>
                        </div>
                    </div>
                    <div class="club40-results-slider-item">
                        <div class="careerum-flex-fsc">
                            <div class="position-relative">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422737-07i7D-Grou.png"
                                    alt="">
                                    <a href="#1" class="position-absolute">
                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <rect width="32" height="32" rx="16" fill="#00BAFF" />
                                            <path
                                                d="M17.227 13.3841C17.7811 12.6708 18.4708 12.2227 19.3492 12.1343C21.1472 11.9575 22.5443 12.7562 23.013 14.6338C23.125 15.0789 23.178 15.5505 23.1839 16.0103C23.2046 17.5902 23.1869 19.1701 23.1987 20.7529C23.2016 21.0241 23.1191 21.1037 22.8509 21.0978C22.0992 21.0801 21.3447 21.0919 20.593 21.0919C20.2069 21.0919 20.204 21.0919 20.204 20.7146C20.204 19.2821 20.2069 17.8525 20.201 16.42C20.201 16.1695 20.1863 15.919 20.1391 15.6743C20.036 15.1054 19.7648 14.6545 19.1605 14.5159C18.5003 14.3685 17.9521 14.5719 17.5453 15.1202C17.3007 15.4473 17.2299 15.8276 17.2299 16.2255C17.227 17.7228 17.2299 19.2202 17.2299 20.7146C17.2299 20.8236 17.2299 20.9357 17.2299 21.0624C17.1356 21.0742 17.0649 21.0919 16.9941 21.0919C16.1747 21.0948 15.3582 21.086 14.5388 21.0978C14.3207 21.1007 14.2765 21.0182 14.2794 20.8207C14.2853 18.0795 14.2853 15.3353 14.2794 12.5941C14.2794 12.3672 14.359 12.3023 14.5683 12.3053C15.3582 12.3112 16.1482 12.3141 16.9381 12.3053C17.1739 12.3023 17.2476 12.3908 17.2329 12.6148C17.2152 12.8653 17.227 13.1247 17.227 13.3841Z"
                                                fill="white" />
                                            <path
                                                d="M12.7564 16.7155C12.7564 18.0536 12.7505 19.3918 12.7623 20.7329C12.7653 21.01 12.6916 21.1043 12.4027 21.0955C11.6305 21.0749 10.8582 21.0808 10.0889 21.0925C9.85309 21.0955 9.76172 21.0395 9.76172 20.786C9.77056 18.0625 9.77056 15.339 9.76172 12.6125C9.76172 12.362 9.85604 12.2942 10.0889 12.2971C10.87 12.3059 11.6511 12.3089 12.4322 12.2971C12.6975 12.2912 12.7623 12.3973 12.7594 12.6449C12.7505 14.0008 12.7564 15.3596 12.7564 16.7155Z"
                                                fill="white" />
                                            <path
                                                d="M12.9303 9.67361C12.9303 10.552 12.2229 11.2034 11.2591 11.2093C10.3188 11.2152 9.59961 10.5431 9.59961 9.65887C9.59961 8.76871 10.3277 8.10257 11.2915 8.11142C12.2465 8.11731 12.9303 8.76871 12.9303 9.67361Z"
                                                fill="white" />
                                        </svg>
                                    </a>
                            </div>
                            <div>
                                <p>Людмила Киселёва</p>
                                <p>Recruiter ll, США</p>
                            </div>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Приехала в США как турист, осталась там, работала ассистентом. Хотела начать карьеру в корпорации</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Прошла курсы «Продающее резюме»<br> и «Эффективное интервью».</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Получила оффер ассистента в Microsoft, через год стала рекрутером в Transocean</p>
                        </div>
                    </div>
                </div>
                <div class="club40-results-slider-nav careerum-flex-fec">
                    <div class="club40-results-slider-nav-prev">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_9432_18847)">
                                <g filter="url(#filter0_b_9432_18847)">
                                    <rect y="40" width="40" height="40" transform="rotate(-90 0 40)" fill="black" />
                                </g>
                                <path d="M13.1905 19.9993L26.8105 19.9993" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M19.4629 26.2453L13.1896 19.9986L19.4629 13.752" stroke="white"
                                    stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <filter id="filter0_b_9432_18847" x="-18.1166" y="-18.1166" width="76.2332"
                                    height="76.2332" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                    <feComposite in2="SourceAlpha" operator="in"
                                        result="effect1_backgroundBlur_9432_18847" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_9432_18847"
                                        result="shape" />
                                </filter>
                                <clipPath id="clip0_9432_18847">
                                    <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)"
                                        fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                    <div class="club40-results-slider-nav-next">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_9432_18851)">
                                <g filter="url(#filter0_b_9432_18851)">
                                    <rect x="40" width="40" height="40" transform="rotate(90 40 0)" fill="black" />
                                </g>
                                <path d="M26.8095 20.0007L13.1895 20.0007" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M20.5371 13.7547L26.8104 20.0014L20.5371 26.248" stroke="white"
                                    stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <filter id="filter0_b_9432_18851" x="-18.1166" y="-18.1166" width="76.2332"
                                    height="76.2332" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                    <feComposite in2="SourceAlpha" operator="in"
                                        result="effect1_backgroundBlur_9432_18851" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_9432_18851"
                                        result="shape" />
                                </filter>
                                <clipPath id="clip0_9432_18851">
                                    <rect x="40" width="40" height="40" rx="20" transform="rotate(90 40 0)"
                                        fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-schedule', {
        label: 'Club 4 schedule (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club40-schedule main-wrapper">
        <div class="careerum-container-responsive">
            <h2>Расписание Careerum 2025</h2>
            <div class="club40-schedule-items careerum-flex-sbst">
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 11 января </p>
                    </div>
                    <p class="club40-schedule-item-header">Карьерные цели на 2025 </p>
                    <p class="club40-schedule-item-subheader">Поставьте карьерные цели с учетом рыночных реалий и
                        синхронизируйте их с бизнес-целями компании</p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 19 февраля </p>
                    </div>
                    <p class="club40-schedule-item-header">Звёздный кандидат</p>
                    <p class="club40-schedule-item-subheader">Интенсив по поиску работы в СНГ и за рубежом. Быстрый путь
                        к офферу за 3 месяца с профессиональной поддержкой </p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 23 марта </p>
                    </div>
                    <p class="club40-schedule-item-header">Коммуникация на работе: управляй руководителем и коллегами
                    </p>
                    <p class="club40-schedule-item-subheader">Как строить личные границы, решать конфликты экологично и
                        достигать своих целей в переговорах</p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 17 апреля </p>
                    </div>
                    <p class="club40-schedule-item-header">Релокация и поиск работы за рубежом</p>
                    <p class="club40-schedule-item-subheader">Интенсив по поиску работы за границей, определите страну и
                        способ переезда — построите свою стратегию для получения оффера в новой географии</p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 20 мая </p>
                    </div>
                    <p class="club40-schedule-item-header">Самооценка и деньги</p>
                    <p class="club40-schedule-item-subheader">Научитесь опираться на себя и свою ценность, сможете
                        спокойно и уверенно называть стоимость своей работы</p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 17 июня </p>
                    </div>
                    <p class="club40-schedule-item-header">Карьерный кризис</p>
                    <p class="club40-schedule-item-subheader">Определите, чего вы хотите для своей карьеры, какие
                        суперсилы у вас есть и как всё это соотнести с потребностями рынка</p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 18 июля</p>
                    </div>
                    <p class="club40-schedule-item-header">Декрет и перерыв в работе</p>
                    <p class="club40-schedule-item-subheader">Как подготовиться на работе, как не потерять себя в
                        декрете, как преодолеете страхи при выходе на работу. Узнаете, как вернуться к работе в
                        бережном, но не менее эффективном режиме </p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 15 августа</p>
                    </div>
                    <p class="club40-schedule-item-header">Рефреш целей</p>
                    <p class="club40-schedule-item-subheader">Определите, чего вы хотите для своей карьеры, какие
                        суперсилы у вас есть и как всё это соотнести с потребностями рынка</p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 8 сентября</p>
                    </div>
                    <p class="club40-schedule-item-header">Звёздный кандидат</p>
                    <p class="club40-schedule-item-subheader">Интенсив по поиску работы в СНГ и за рубежом. Быстрый путь
                        к офферу за 3 месяца с профессиональной поддержкой </p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 16 октября </p>
                    </div>
                    <p class="club40-schedule-item-header">Хочу стать руководителем</p>
                    <p class="club40-schedule-item-subheader">Вы освоите самые важные навыки руководителя, изучите
                        лайфхаки по взаимодействию в кросс-функциональных командах</p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 10 ноября</p>
                    </div>
                    <p class="club40-schedule-item-header">Карьерная ракета</p>
                    <p class="club40-schedule-item-subheader">Узнаете, как расти в зарплате и роли и научитесь
                        планировать и добиваться даже самых амбициозных целей</p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 10 декабря </p>
                    </div>
                    <p class="club40-schedule-item-header">Подводим итоги года</p>
                    <p class="club40-schedule-item-subheader">Подведете итоги своего продуктивного года и успехов в
                        карьере</p>
                </div>
            </div>
            <div class="club40-schedule-items-slider careerum-flex-sbst">
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 11 января </p>
                    </div>
                    <p class="club40-schedule-item-header">Карьерные цели на 2025 </p>
                    <p class="club40-schedule-item-subheader">Поставьте карьерные цели с учетом рыночных реалий и
                        синхронизируйте их с бизнес-целями компании</p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 19 февраля </p>
                    </div>
                    <p class="club40-schedule-item-header">Звёздный кандидат</p>
                    <p class="club40-schedule-item-subheader">Интенсив по поиску работы в СНГ и за рубежом. Быстрый путь
                        к офферу за 3 месяца с профессиональной поддержкой </p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 23 марта </p>
                    </div>
                    <p class="club40-schedule-item-header">Коммуникация на работе: управляй руководителем и коллегами
                    </p>
                    <p class="club40-schedule-item-subheader">Как строить личные границы, решать конфликты экологично и
                        достигать своих целей в переговорах</p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 17 апреля </p>
                    </div>
                    <p class="club40-schedule-item-header">Релокация и поиск работы за рубежом</p>
                    <p class="club40-schedule-item-subheader">Интенсив по поиску работы за границей, определите страну и
                        способ переезда — построите свою стратегию для получения оффера в новой географии</p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 20 мая </p>
                    </div>
                    <p class="club40-schedule-item-header">Самооценка и деньги</p>
                    <p class="club40-schedule-item-subheader">Научитесь опираться на себя и свою ценность, сможете
                        спокойно и уверенно называть стоимость своей работы</p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 17 июня </p>
                    </div>
                    <p class="club40-schedule-item-header">Карьерный кризис</p>
                    <p class="club40-schedule-item-subheader">Определите, чего вы хотите для своей карьеры, какие
                        суперсилы у вас есть и как всё это соотнести с потребностями рынка</p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 18 июля</p>
                    </div>
                    <p class="club40-schedule-item-header">Декрет и перерыв в работе</p>
                    <p class="club40-schedule-item-subheader">Как подготовиться на работе, как не потерять себя в
                        декрете, как преодолеете страхи при выходе на работу. Узнаете, как вернуться к работе в
                        бережном, но не менее эффективном режиме </p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 15 августа</p>
                    </div>
                    <p class="club40-schedule-item-header">Рефреш целей</p>
                    <p class="club40-schedule-item-subheader">Определите, чего вы хотите для своей карьеры, какие
                        суперсилы у вас есть и как всё это соотнести с потребностями рынка</p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 8 сентября</p>
                    </div>
                    <p class="club40-schedule-item-header">Звёздный кандидат</p>
                    <p class="club40-schedule-item-subheader">Интенсив по поиску работы в СНГ и за рубежом. Быстрый путь
                        к офферу за 3 месяца с профессиональной поддержкой </p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 16 октября </p>
                    </div>
                    <p class="club40-schedule-item-header">Хочу стать руководителем</p>
                    <p class="club40-schedule-item-subheader">Вы освоите самые важные навыки руководителя, изучите
                        лайфхаки по взаимодействию в кросс-функциональных командах</p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 10 ноября</p>
                    </div>
                    <p class="club40-schedule-item-header">Карьерная ракета</p>
                    <p class="club40-schedule-item-subheader">Узнаете, как расти в зарплате и роли и научитесь
                        планировать и добиваться даже самых амбициозных целей</p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 10 декабря </p>
                    </div>
                    <p class="club40-schedule-item-header">Подводим итоги года</p>
                    <p class="club40-schedule-item-subheader">Подведете итоги своего продуктивного года и успехов в
                        карьере</p>
                </div>
            </div>
            <div class="club40-schedule-link">
                <a href="#buy" class="btn-color-main-dark-orange">Выбрать тариф</a>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-club40-banner-top', {
        label: 'Club 4 banner-top (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club40-banner-top position-absolute" data-href="#buy" data-timer="no" data-redirect="no"
        data-url="" data-static="yes" data-offset="" data-timer-end="02/24/2025 12:00 GMT+0300" data-theme="light">
        <div>
            <div class="club40-banner-bg position-relative">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737661896849-oSmQ4-bulb.png" alt=""
                    class="hidden-tablet-mobile position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737661913259-Qlmap-file.png" alt=""
                    class="hidden-tablet-mobile position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737661960821-rZb6v-Grou.png" alt=""
                    class="hidden-desc-mobile position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737661952376-pRpSK-Grou.png" alt=""
                    class="hidden-desc-tablet position-absolute">
            </div>
            <div class="club40-banner-top careerum-flex-fsc">
                <div class="club40-banner-top-left">
                    <p class="club40-banner-top-sunheader">Старт 19 февраля</p>
                    <p class="club40-banner-top-header">Идет набор на интенсив по поиску работы Получи оффер мечты уже
                        этой весной!</p>
                </div>
                <div class="club40-banner-top-center careerum-flex-fsc">
                    <div class="banner-top-timer careerum-flex-sbfs">
                        <div>
                            <p class="timer-day-number">00</p>
                            <p class="timer-day-text"></p>
                        </div>
                        <div>
                            <p class="timer-hour-number">00</p>
                            <p class="timer-hour-text"></p>
                        </div>
                        <div>
                            <p class="timer-min-number">00</p>
                            <p class="timer-min-text"></p>
                        </div>
                    </div>
                </div>
                <div class="club40-banner-top-right">
                    <a href="#buy" class="btn-color-main-dark-blue">Узнать подробнее</a>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-club40-goals-slider', {
        label: 'Club 4 goals-slider (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club40-goals-slider main-wrapper">
        <div class="careerum-container-responsive">
            <h2 class="careerum-club40-header">Careerum для вас, если:</h2>
            <div class="club40-goals-tales careerum-flex-fsfs">
                <div class="club40-goals-tale careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                        alt="" class="hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737668239851-P9zPK-Vect.svg"
                        alt="" class="hidden-desc">
                    <p>У вас высокая квалифицикация, но сомневаетесь в своих силах</p>
                </div>
                <div class="club40-goals-tale careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                        alt="" class="hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737668239851-P9zPK-Vect.svg"
                        alt="" class="hidden-desc">
                    <p>Более 3 месяцев ищете работу, но откликов мало, а вакансии не радуют</p>
                </div>
                <div class="club40-goals-tale careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                        alt="" class="hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737668239851-P9zPK-Vect.svg"
                        alt="" class="hidden-desc">
                    <p>Классно справляетесь с задачами, но обычно повышают не вас</p>
                </div>
                <div class="club40-goals-tale careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                        alt="" class="hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737668239851-P9zPK-Vect.svg"
                        alt="" class="hidden-desc">
                    <p>Впервые ищете работу или выходите на первую роль в новой стране</p>
                </div>
                <div class="club40-goals-tale careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                        alt="" class="hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737668239851-P9zPK-Vect.svg"
                        alt="" class="hidden-desc">
                    <p>Каждый год меняете компанию, надеясь, что на новом месте будет лучше</p>
                </div>
                <div class="club40-goals-tale careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                        alt="" class="hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737668239851-P9zPK-Vect.svg"
                        alt="" class="hidden-desc">
                    <p>Вам сложно обсуждать деньги, условия и предлагать свои условия в работе</p>
                </div>
                <div class="club40-goals-tale careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                        alt="" class="hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737668239851-P9zPK-Vect.svg"
                        alt="" class="hidden-desc">
                    <p>Наваливаете на себя кучу проектов и ждете, что руководитель сам заметит ваши результаты</p>
                </div>
                <div class="club40-goals-tale careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                        alt="" class="hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737668239851-P9zPK-Vect.svg"
                        alt="" class="hidden-desc">
                    <p>У вас нет четкого понимания своих сильных сторон и куда развиваться</p>
                </div>
                <div class="club40-goals-tale careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                        alt="" class="hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737668239851-P9zPK-Vect.svg"
                        alt="" class="hidden-desc">
                    <p>Регулярно выгораете, раз в год или чаще меняете работу или уходите в творческий отпуск</p>
                </div>
            </div>
            <div class="club40-goals-nav careerum-flex-fec">
                <div class="club40-goals-nav-prev careerum-flex-cc ">
                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="club40-goals-nav-next careerum-flex-cc">
                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-course40-main', {
        label: 'Course 4 main',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-course40-main">
            <div class="careerum-container-desc">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726050859214-4P2O8-Elli.png" alt="">
                <div class="course40-main-top careerum-flex-fsfs">
                    <div class="course40-main-label careerum-flex-fsc">
                        <p>Флагманский курс Careerum</p>
                    </div>
                    <div class="course40-main-label careerum-flex-fsc">
                        <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M19.5034 4.74306L4.50342 4.75688C4.0892 4.75726 3.75373 5.09335 3.75411 5.50757L3.76793 20.5076C3.76831 20.9218 4.10441 21.2573 4.51862 21.2569L19.5186 21.2431C19.9328 21.2427 20.2683 20.9066 20.2679 20.4924L20.2541 5.49237C20.2537 5.07815 19.9176 4.74268 19.5034 4.74306Z"
                                stroke="black" stroke-width="1.7825" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M16.502 3.24585L16.5047 6.24585" stroke="black" stroke-width="1.7825"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M7.50195 3.25415L7.50472 6.25415" stroke="black" stroke-width="1.7825"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M3.75732 9.25757L20.2573 9.24237" stroke="black" stroke-width="1.7825"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M15.3862 12.997L11.0119 17.126L8.63796 14.8782" stroke="black" stroke-width="1.7825"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <p>Старт: 8 октября</p>
                    </div>
                </div>
                <div class="course40-main-center careerum-flex-fsfs">
                    <div>
                        <h1>Наука счастья: как жить и работать по любви</h1>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726035652277-6HFSP-Grou.svg"
                            alt="">
                        <p>Курс о том, как найти и поддерживать мотивацию, чтобы никогда больше<br> не выгорать</p>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <svg width="37" height="44" viewBox="0 0 37 44" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g filter="url(#filter0_di_364_995)">
                                        <path
                                            d="M17.0126 5.69061C16.9094 5.16464 16.33 5.22554 16.3383 5.76148L16.409 10.2575C16.5003 16.063 13.5664 20.9562 9.31252 22.0933L6.01812 22.9739C5.62538 23.0789 5.70636 23.8494 6.11236 23.8705L9.51785 24.0469C13.9152 24.2747 17.8023 28.451 18.9201 34.1486L19.7857 38.561C19.8889 39.0871 20.4684 39.0262 20.46 38.4902L20.3893 33.9941C20.2981 28.1886 23.2319 23.2955 27.4859 22.1584L30.7803 21.2778C31.173 21.1727 31.092 20.4023 30.686 20.3812L27.2805 20.2048C22.8831 19.977 18.996 15.8007 17.8783 10.1031L17.0126 5.69061Z"
                                            fill="#F9F9F9" />
                                    </g>
                                    <defs>
                                        <filter id="filter0_di_364_995" x="0.713428" y="0.277515" width="35.3715"
                                            height="43.6967" filterUnits="userSpaceOnUse"
                                            color-interpolation-filters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                            <feOffset />
                                            <feGaussianBlur stdDeviation="2.52439" />
                                            <feComposite in2="hardAlpha" operator="out" />
                                            <feColorMatrix type="matrix"
                                                values="0 0 0 0 0.934668 0 0 0 0 0.74877 0 0 0 0 0.270771 0 0 0 1 0" />
                                            <feBlend mode="normal" in2="BackgroundImageFix"
                                                result="effect1_dropShadow_364_995" />
                                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_364_995"
                                                result="shape" />
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                            <feOffset />
                                            <feGaussianBlur stdDeviation="2.88502" />
                                            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                            <feColorMatrix type="matrix"
                                                values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                            <feBlend mode="normal" in2="shape" result="effect2_innerShadow_364_995" />
                                        </filter>
                                    </defs>
                                </svg>
                                <p>Личная работа с Ольгой Лермонтовой</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <svg width="37" height="44" viewBox="0 0 37 44" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g filter="url(#filter0_di_364_995)">
                                        <path
                                            d="M17.0126 5.69061C16.9094 5.16464 16.33 5.22554 16.3383 5.76148L16.409 10.2575C16.5003 16.063 13.5664 20.9562 9.31252 22.0933L6.01812 22.9739C5.62538 23.0789 5.70636 23.8494 6.11236 23.8705L9.51785 24.0469C13.9152 24.2747 17.8023 28.451 18.9201 34.1486L19.7857 38.561C19.8889 39.0871 20.4684 39.0262 20.46 38.4902L20.3893 33.9941C20.2981 28.1886 23.2319 23.2955 27.4859 22.1584L30.7803 21.2778C31.173 21.1727 31.092 20.4023 30.686 20.3812L27.2805 20.2048C22.8831 19.977 18.996 15.8007 17.8783 10.1031L17.0126 5.69061Z"
                                            fill="#F9F9F9" />
                                    </g>
                                    <defs>
                                        <filter id="filter0_di_364_995" x="0.713428" y="0.277515" width="35.3715"
                                            height="43.6967" filterUnits="userSpaceOnUse"
                                            color-interpolation-filters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                            <feOffset />
                                            <feGaussianBlur stdDeviation="2.52439" />
                                            <feComposite in2="hardAlpha" operator="out" />
                                            <feColorMatrix type="matrix"
                                                values="0 0 0 0 0.934668 0 0 0 0 0.74877 0 0 0 0 0.270771 0 0 0 1 0" />
                                            <feBlend mode="normal" in2="BackgroundImageFix"
                                                result="effect1_dropShadow_364_995" />
                                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_364_995"
                                                result="shape" />
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                            <feOffset />
                                            <feGaussianBlur stdDeviation="2.88502" />
                                            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                            <feColorMatrix type="matrix"
                                                values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                            <feBlend mode="normal" in2="shape" result="effect2_innerShadow_364_995" />
                                        </filter>
                                    </defs>
                                </svg>
                                <p>В основе: 200+ исследований и методики<br> Гарварда</p>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726047277007-RgvCH-Fram.png"
                            alt="" class="course40-main-photo">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726047243228-8QJbr-Grou.svg"
                            alt="" class="course40-main-decor">
                    </div>
                </div>
                <h2 class="careerum-club40-header">Кому подойдет этот курс</h2>
                <div class="course40-goals-tales careerum-flex-fsfs">
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                            alt="">
                        <p>Руководителям, CEO, <br>топ-менеджерам </p>
                    </div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                            alt="">
                        <p>Предпринимателям<br>Фаундерам стартапов</p>
                    </div>
                    <div class="course40-goals-tale-rotate-right"><img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                            alt="">
                        <p>Middle и Senior-специалистам,<br> тим-лидам</p>
                    </div>
                </div>
                <div class="course40-main-link">
                    <a href="#program" class="btn-color-main-black">Посмотреть программу</a>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-course40-main-tablet', {
        label: 'Course 4 main (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-course40-main-tablet">
            <div class="careerum-container-tablet">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064210085-v3zGQ-Elli.png" alt="">
                <div class="course40-main-top careerum-flex-fsfs">
                    <div class="course40-main-label careerum-flex-fsc">
                        <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M15.5215 2.8125H4.27148C3.96082 2.8125 3.70898 3.06434 3.70898 3.375V14.625C3.70898 14.9357 3.96082 15.1875 4.27148 15.1875H15.5215C15.8321 15.1875 16.084 14.9357 16.084 14.625V3.375C16.084 3.06434 15.8321 2.8125 15.5215 2.8125Z"
                                stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M13.2715 1.6875V3.9375" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M6.52148 1.6875V3.9375" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M3.70898 6.1875H16.084" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M12.4277 9L9.14414 12.0937L7.36523 10.4062" stroke="black" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <p><span>Старт: 8 октября</span></p>
                    </div>
                    <div class="course40-main-label careerum-flex-fsc">
                        <p>Флагманский курс Careerum</p>
                    </div>
                </div>
                <div class="course40-main-center careerum-flex-fsfs">
                    <div>
                        <h2>Наука счастья: как жить и работать по любви</h2>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726051137027-gfpcc-Grou.svg"
                            alt="">
                        <p>Курс о том, как найти и поддерживать мотивацию, чтобы никогда больше<br> не выгорать</p>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <svg width="21" height="26" viewBox="0 0 21 26" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g filter="url(#filter0_di_425_1111)">
                                        <path
                                            d="M9.4445 3.96717C9.38544 3.66627 9.05395 3.70111 9.05875 4.00772L9.09918 6.57981C9.15139 9.90108 7.47298 12.7004 5.03939 13.3509L3.15472 13.8547C2.93004 13.9148 2.97636 14.3555 3.20863 14.3676L5.15685 14.4685C7.67252 14.5988 9.89625 16.988 10.5357 20.2475L11.0309 22.7718C11.09 23.0727 11.4215 23.0379 11.4167 22.7313L11.3763 20.1592C11.324 16.8379 13.0025 14.0386 15.4361 13.3881L17.3207 12.8843C17.5454 12.8243 17.4991 12.3835 17.2668 12.3714L15.3186 12.2705C12.8029 12.1402 10.5792 9.75101 9.93972 6.49147L9.4445 3.96717Z"
                                            fill="#F9F9F9" />
                                    </g>
                                    <defs>
                                        <filter id="filter0_di_425_1111" x="0.119487" y="0.870464" width="20.2356"
                                            height="24.9981" filterUnits="userSpaceOnUse"
                                            color-interpolation-filters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                            <feOffset />
                                            <feGaussianBlur stdDeviation="1.44416" />
                                            <feComposite in2="hardAlpha" operator="out" />
                                            <feColorMatrix type="matrix"
                                                values="0 0 0 0 0.934668 0 0 0 0 0.74877 0 0 0 0 0.270771 0 0 0 1 0" />
                                            <feBlend mode="normal" in2="BackgroundImageFix"
                                                result="effect1_dropShadow_425_1111" />
                                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_425_1111"
                                                result="shape" />
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                            <feOffset />
                                            <feGaussianBlur stdDeviation="1.65047" />
                                            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                            <feColorMatrix type="matrix"
                                                values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                            <feBlend mode="normal" in2="shape" result="effect2_innerShadow_425_1111" />
                                        </filter>
                                    </defs>
                                </svg>
                                <p>Личная работа с Ольгой Лермонтовой</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <svg width="21" height="26" viewBox="0 0 21 26" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g filter="url(#filter0_di_425_1111)">
                                        <path
                                            d="M9.4445 3.96717C9.38544 3.66627 9.05395 3.70111 9.05875 4.00772L9.09918 6.57981C9.15139 9.90108 7.47298 12.7004 5.03939 13.3509L3.15472 13.8547C2.93004 13.9148 2.97636 14.3555 3.20863 14.3676L5.15685 14.4685C7.67252 14.5988 9.89625 16.988 10.5357 20.2475L11.0309 22.7718C11.09 23.0727 11.4215 23.0379 11.4167 22.7313L11.3763 20.1592C11.324 16.8379 13.0025 14.0386 15.4361 13.3881L17.3207 12.8843C17.5454 12.8243 17.4991 12.3835 17.2668 12.3714L15.3186 12.2705C12.8029 12.1402 10.5792 9.75101 9.93972 6.49147L9.4445 3.96717Z"
                                            fill="#F9F9F9" />
                                    </g>
                                    <defs>
                                        <filter id="filter0_di_425_1111" x="0.119487" y="0.870464" width="20.2356"
                                            height="24.9981" filterUnits="userSpaceOnUse"
                                            color-interpolation-filters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                            <feOffset />
                                            <feGaussianBlur stdDeviation="1.44416" />
                                            <feComposite in2="hardAlpha" operator="out" />
                                            <feColorMatrix type="matrix"
                                                values="0 0 0 0 0.934668 0 0 0 0 0.74877 0 0 0 0 0.270771 0 0 0 1 0" />
                                            <feBlend mode="normal" in2="BackgroundImageFix"
                                                result="effect1_dropShadow_425_1111" />
                                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_425_1111"
                                                result="shape" />
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                            <feOffset />
                                            <feGaussianBlur stdDeviation="1.65047" />
                                            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                            <feColorMatrix type="matrix"
                                                values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                            <feBlend mode="normal" in2="shape" result="effect2_innerShadow_425_1111" />
                                        </filter>
                                    </defs>
                                </svg>
                                <p>В основе: 200+ исследований<br> и методики Гарварда</p>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726050611332-czJMK-Fram.png"
                            alt="" class="course40-main-photo">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726051342566-R4UtQ-Grou.svg"
                            alt="" class="course40-main-decor">
                        <div>
                            <p>Автор: Ольга Лермонтова, фаундер Careerum, карьерный коуч, ex топ-менеджер Google, Microsoft,
                                Intel</p>
                        </div>
                    </div>
                </div>
                <h2>Кому подойдет этот курс</h2>
                <div class="course40-goals-tales careerum-flex-fsst">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726051495630-Z6SnH-Vect.svg"
                            alt="">
                        <p>Руководителям, CEO, <br>топ-менеджерам </p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726051495630-Z6SnH-Vect.svg"
                            alt="">
                        <p>Предпринимателям,<br>фаундерам стартапов</p>
                    </div>
                    <div class="course40-goals-tale-rotate-right">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726051495630-Z6SnH-Vect.svg"
                            alt="">
                        <p>Middle и Senior-специалистам, тим-лидам</p>
                    </div>
                </div>
                <div class="course40-main-link">
                    <a href="#program" class="btn-color-main-black">Посмотреть программу</a>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-course40-main-mobile', {
        label: 'Course 4 main (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-course40-main-mobile">
            <div class="careerum-container-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726069479663-wocTl-Elli.png" alt="">
                <div class="course40-main-top careerum-flex-fsfs">
                    <div class="course40-main-label careerum-flex-fsc">
                        <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M15.5215 2.8125H4.27148C3.96082 2.8125 3.70898 3.06434 3.70898 3.375V14.625C3.70898 14.9357 3.96082 15.1875 4.27148 15.1875H15.5215C15.8321 15.1875 16.084 14.9357 16.084 14.625V3.375C16.084 3.06434 15.8321 2.8125 15.5215 2.8125Z"
                                stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M13.2715 1.6875V3.9375" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M6.52148 1.6875V3.9375" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M3.70898 6.1875H16.084" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M12.4277 9L9.14414 12.0937L7.36523 10.4062" stroke="black" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <p><span>Старт: 8 октября</span></p>
                    </div>
                    <div class="course40-main-label careerum-flex-fsc">
                        <p>Флагманский курс Careerum</p>
                    </div>
                </div>
                <div class="course40-main-center">
                    <div>
                        <h2>Наука счастья: как жить и работать по любви</h2>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726069691779-GE4Xn-Grou.svg"
                            alt="">
                        <p>Курс о том, как найти и поддерживать мотивацию, чтобы никогда больше<br> не выгорать</p>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <svg width="21" height="26" viewBox="0 0 21 26" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g filter="url(#filter0_di_425_1111)">
                                        <path
                                            d="M9.4445 3.96717C9.38544 3.66627 9.05395 3.70111 9.05875 4.00772L9.09918 6.57981C9.15139 9.90108 7.47298 12.7004 5.03939 13.3509L3.15472 13.8547C2.93004 13.9148 2.97636 14.3555 3.20863 14.3676L5.15685 14.4685C7.67252 14.5988 9.89625 16.988 10.5357 20.2475L11.0309 22.7718C11.09 23.0727 11.4215 23.0379 11.4167 22.7313L11.3763 20.1592C11.324 16.8379 13.0025 14.0386 15.4361 13.3881L17.3207 12.8843C17.5454 12.8243 17.4991 12.3835 17.2668 12.3714L15.3186 12.2705C12.8029 12.1402 10.5792 9.75101 9.93972 6.49147L9.4445 3.96717Z"
                                            fill="#F9F9F9" />
                                    </g>
                                    <defs>
                                        <filter id="filter0_di_425_1111" x="0.119487" y="0.870464" width="20.2356"
                                            height="24.9981" filterUnits="userSpaceOnUse"
                                            color-interpolation-filters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                            <feOffset />
                                            <feGaussianBlur stdDeviation="1.44416" />
                                            <feComposite in2="hardAlpha" operator="out" />
                                            <feColorMatrix type="matrix"
                                                values="0 0 0 0 0.934668 0 0 0 0 0.74877 0 0 0 0 0.270771 0 0 0 1 0" />
                                            <feBlend mode="normal" in2="BackgroundImageFix"
                                                result="effect1_dropShadow_425_1111" />
                                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_425_1111"
                                                result="shape" />
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                            <feOffset />
                                            <feGaussianBlur stdDeviation="1.65047" />
                                            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                            <feColorMatrix type="matrix"
                                                values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                            <feBlend mode="normal" in2="shape" result="effect2_innerShadow_425_1111" />
                                        </filter>
                                    </defs>
                                </svg>
                                <p>Личная работа с Ольгой Лермонтовой</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <svg width="21" height="26" viewBox="0 0 21 26" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g filter="url(#filter0_di_425_1111)">
                                        <path
                                            d="M9.4445 3.96717C9.38544 3.66627 9.05395 3.70111 9.05875 4.00772L9.09918 6.57981C9.15139 9.90108 7.47298 12.7004 5.03939 13.3509L3.15472 13.8547C2.93004 13.9148 2.97636 14.3555 3.20863 14.3676L5.15685 14.4685C7.67252 14.5988 9.89625 16.988 10.5357 20.2475L11.0309 22.7718C11.09 23.0727 11.4215 23.0379 11.4167 22.7313L11.3763 20.1592C11.324 16.8379 13.0025 14.0386 15.4361 13.3881L17.3207 12.8843C17.5454 12.8243 17.4991 12.3835 17.2668 12.3714L15.3186 12.2705C12.8029 12.1402 10.5792 9.75101 9.93972 6.49147L9.4445 3.96717Z"
                                            fill="#F9F9F9" />
                                    </g>
                                    <defs>
                                        <filter id="filter0_di_425_1111" x="0.119487" y="0.870464" width="20.2356"
                                            height="24.9981" filterUnits="userSpaceOnUse"
                                            color-interpolation-filters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                            <feOffset />
                                            <feGaussianBlur stdDeviation="1.44416" />
                                            <feComposite in2="hardAlpha" operator="out" />
                                            <feColorMatrix type="matrix"
                                                values="0 0 0 0 0.934668 0 0 0 0 0.74877 0 0 0 0 0.270771 0 0 0 1 0" />
                                            <feBlend mode="normal" in2="BackgroundImageFix"
                                                result="effect1_dropShadow_425_1111" />
                                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_425_1111"
                                                result="shape" />
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                            <feOffset />
                                            <feGaussianBlur stdDeviation="1.65047" />
                                            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                            <feColorMatrix type="matrix"
                                                values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                            <feBlend mode="normal" in2="shape" result="effect2_innerShadow_425_1111" />
                                        </filter>
                                    </defs>
                                </svg>
                                <p>В основе: 200+ исследований<br> и методики Гарварда</p>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726069790705-Jy79a-Fram.png"
                            alt="" class="course40-main-photo">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726069832185-WM9bJ-Grou.svg"
                            alt="" class="course40-main-decor">
                        <div>
                            <p>Автор: Ольга Лермонтова, фаундер Careerum, карьерный коуч, ex топ-менеджер Google, Microsoft,
                                Intel</p>
                        </div>
                    </div>
                </div>
                <h2>Кому подойдет этот курс</h2>
                <div class="course40-goals-tales">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726051495630-Z6SnH-Vect.svg"
                            alt="">
                        <p>Руководителям, CEO, топ-менеджерам </p>
                    </div>
                    <div class="course40-goals-tale-rotate-right">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726051495630-Z6SnH-Vect.svg"
                            alt="">
                        <p>Предпринимателям, фаундерам стартапов</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726051495630-Z6SnH-Vect.svg"
                            alt="">
                        <p>Middle и Senior-специалистам, тим-лидам</p>
                    </div>
                </div>
                <div class="course40-main-link">
                    <a href="#program" class="btn-color-main-black">Посмотреть программу</a>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-course40-about', {
        label: 'Course 4 about',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-course40-about">
            <div class="careerum-container-desc">
                <h2 class="careerum-club40-header">Что будет на курсе</h2>
                <div class="course40-about-top careerum-flex-fsst">
                    <div>
                        <p class="course40-about-top-header">Живые эфиры с Ольгой</p>
                        <p class="course40-about-top-subheader">Интерактивные эфиры, где вы получите теорию и сразу же
                            попрактикуетесь ее применять</p>
                    </div>
                    <div>
                        <p class="course40-about-top-header">Работа в паре с buddy</p>
                        <p class="course40-about-top-subheader">Вы будете разбиты на пары, чтобы прорабатывать свои
                            результаты, поддерживать и мотивировать друг друга</p>
                    </div>
                    <div>
                        <p class="course40-about-top-header">Практические сессии </p>
                        <p class="course40-about-top-subheader">Встречи с экспертом, где разберем домашние задания,
                            упражнения и сложные вопросы</p>
                    </div>
                    <div>
                        <p class="course40-about-top-header">Групповой чат курса</p>
                        <p class="course40-about-top-subheader">Комьюнити курса, чтобы делиться опытом, обсуждать трудные
                            темы и находить новые решения</p>
                    </div>
                    <div>
                        <p class="course40-about-top-header">Мастер-майнды с Ольгой</p>
                        <p class="course40-about-top-subheader">Интенсивные сессии по обмену опытом и идеями, чтобы получать
                            инсайты для своего роста</p>
                    </div>
                    <div>
                        <p class="course40-about-top-header">Доступ к материалам курса</p>
                        <p class="course40-about-top-subheader">Когда закончатся сессии, доступ к курсу останется, сможете
                            пользоваться материалами еще месяц</p>
                    </div>
                </div>
                <div class="course40-about-bottom careerum-flex-fsst">
                    <div>
                        <p class="course40-about-bottom-label">Помогут закрепить новые привычки</p>
                        <p class="course40-about-bottom-header">Практические задания</p>
                        <p class="course40-about-bottom-subheader">Практика:</p>
                        <ul>
                            <li>Оценка уровня счастья</li>
                            <li>Рефрейминг: пересмотр прошлых ошибок и неудач как шагов к успеху</li>
                            <li>Планирование идеальной рабочей недели с акцентом на мотивацию и удовольствие</li>
                            <li>«Проявления доброты» и благодарности</li>
                            <li>Создание шаблонов карьерного плана и целей на ближайший год</li>
                        </ul>
                        <p class="course40-about-bottom-subheader">Ежедневные упражнения: </p>
                        <ul>
                            <li>Для укрепления самооценки и нахождения положительных аспектов в жизни</li>
                        </ul>
                    </div>
                    <div>
                        <p class="course40-about-bottom-label">Останутся с вами навсегда</p>
                        <p class="course40-about-bottom-header">Чеклисты, артефакты, гайды</p>
                        <p class="course40-about-bottom-subheader">Гайды и артефакты:</p>
                        <ul>
                            <li>Формула счастья «МОСТ»</li>
                            <li>Шкала мотивации Деси и Райана для регуляции собственной деятельности</li>
                            <li>Список привычек счастливых людей для ежедневной практики</li>
                        </ul>
                        <p class="course40-about-bottom-subheader">Чеклисты и трекеры:</p>
                        <ul>
                            <li>Ментальная гигиена</li>
                            <li>Качественный сон</li>
                            <li>Работа с критикой</li>
                            <li>Карьерное планирование</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-course40-about-tablet', {
        label: 'Course 4 about (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-course40-about-tablet">
            <div class="careerum-container-tablet">
                <h2 class="careerum-club40-header-tablet">Что будет на курсе</h2>
                <div class="course40-about-top careerum-flex-fsst">
                    <div>
                        <p class="course40-about-top-header">Живые эфиры с Ольгой</p>
                        <p class="course40-about-top-subheader">Интерактивные эфиры, где вы получите теорию и сразу же
                            попрактикуетесь ее применять</p>
                    </div>
                    <div>
                        <p class="course40-about-top-header">Работа в паре с buddy</p>
                        <p class="course40-about-top-subheader">Вы будете разбиты на пары, чтобы прорабатывать свои
                            результаты, поддерживать и мотивировать друг друга</p>
                    </div>
                    <div>
                        <p class="course40-about-top-header">Практические сессии </p>
                        <p class="course40-about-top-subheader">Встречи с экспертом, где разберем домашние задания,
                            упражнения и сложные вопросы</p>
                    </div>
                    <div>
                        <p class="course40-about-top-header">Групповой чат курса</p>
                        <p class="course40-about-top-subheader">Комьюнити курса, чтобы делиться опытом, обсуждать трудные
                            темы и находить новые решения</p>
                    </div>
                    <div>
                        <p class="course40-about-top-header">Мастер-майнды с Ольгой</p>
                        <p class="course40-about-top-subheader">Интенсивные сессии по обмену опытом и идеями, чтобы получать
                            инсайты для своего роста</p>
                    </div>
                    <div>
                        <p class="course40-about-top-header">Доступ к материалам курса</p>
                        <p class="course40-about-top-subheader">Когда закончатся сессии, доступ к курсу останется, сможете
                            пользоваться материалами еще месяц</p>
                    </div>
                </div>
                <div class="course40-about-bottom careerum-flex-fsst">
                    <div>
                        <p class="course40-about-bottom-label">Помогут закрепить новые привычки</p>
                        <p class="course40-about-bottom-header">Практические задания</p>
                        <p class="course40-about-bottom-subheader">Практика:</p>
                        <ul>
                            <li>Оценка уровня счастья</li>
                            <li>Рефрейминг: пересмотр прошлых ошибок и неудач как шагов к успеху</li>
                            <li>Планирование идеальной рабочей недели с акцентом на мотивацию и удовольствие</li>
                            <li>«Проявления доброты» и благодарности</li>
                            <li>Создание шаблонов карьерного плана и целей на ближайший год</li>
                        </ul>
                        <p class="course40-about-bottom-subheader">Ежедневные упражнения: </p>
                        <ul>
                            <li>Для укрепления самооценки и нахождения положительных аспектов в жизни</li>
                        </ul>
                    </div>
                    <div>
                        <p class="course40-about-bottom-label">Останутся с вами навсегда</p>
                        <p class="course40-about-bottom-header">Чеклисты, артефакты, гайды</p>
                        <p class="course40-about-bottom-subheader">Гайды и артефакты:</p>
                        <ul>
                            <li>Формула счастья «МОСТ»</li>
                            <li>Шкала мотивации Деси и Райана для регуляции собственной деятельности</li>
                            <li>Список привычек счастливых людей для ежедневной практики</li>
                        </ul>
                        <p class="course40-about-bottom-subheader">Чеклисты и трекеры:</p>
                        <ul>
                            <li>Ментальная гигиена</li>
                            <li>Качественный сон</li>
                            <li>Работа с критикой</li>
                            <li>Карьерное планирование</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-course40-about-mobile', {
        label: 'Course 4 about (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-course40-about-mobile">
            <div class="careerum-container-mobile">
                <h2 class="careerum-club40-header-mobile">Что еще будет на курсе</h2>
                <div class="course40-about-top about-top-slider">
                    <div class="course40-about-top-item">
                        <p class="course40-about-top-header">Живые эфиры с Ольгой</p>
                        <p class="course40-about-top-subheader">Интерактивные эфиры, где вы получите теорию и сразу же
                            попрактикуетесь ее применять</p>
                    </div>
                    <div class="course40-about-top-item">
                        <p class="course40-about-top-header">Работа в паре с buddy</p>
                        <p class="course40-about-top-subheader">Вы будете разбиты на пары, чтобы прорабатывать свои
                            результаты, поддерживать и мотивировать друг друга</p>
                    </div>
                    <div class="course40-about-top-item">
                        <p class="course40-about-top-header">Практические сессии </p>
                        <p class="course40-about-top-subheader">Встречи с экспертом, где разберем домашние задания,
                            упражнения и сложные вопросы</p>
                    </div>
                    <div class="course40-about-top-item">
                        <p class="course40-about-top-header">Групповой чат курса</p>
                        <p class="course40-about-top-subheader">Комьюнити курса, чтобы делиться опытом, обсуждать трудные
                            темы и находить новые решения</p>
                    </div>
                    <div class="course40-about-top-item">
                        <p class="course40-about-top-header">Мастер-майнды с Ольгой</p>
                        <p class="course40-about-top-subheader">Интенсивные сессии по обмену опытом и идеями, чтобы получать
                            инсайты для своего роста</p>
                    </div>
                    <div class="course40-about-top-item">
                        <p class="course40-about-top-header">Доступ к материалам курса</p>
                        <p class="course40-about-top-subheader">Когда закончатся сессии, доступ к курсу останется, сможете
                            пользоваться материалами еще месяц</p>
                    </div>
                </div>
                <div class="course40-about-bottom">
                    <div>
                        <p class="course40-about-bottom-label">Помогут закрепить новые привычки</p>
                        <p class="course40-about-bottom-header">Практические задания</p>
                        <p class="course40-about-bottom-subheader">Практика:</p>
                        <ul>
                            <li>Оценка уровня счастья</li>
                            <li>Рефрейминг: пересмотр прошлых ошибок и неудач как шагов к успеху</li>
                            <li>Планирование идеальной рабочей недели с акцентом на мотивацию и удовольствие</li>
                            <li>«Проявления доброты» и благодарности</li>
                            <li>Создание шаблонов карьерного плана и целей на ближайший год</li>
                        </ul>
                        <p class="course40-about-bottom-subheader">Ежедневные упражнения: </p>
                        <ul>
                            <li>Для укрепления самооценки и нахождения положительных аспектов в жизни</li>
                        </ul>
                    </div>
                    <div>
                        <p class="course40-about-bottom-label">Останутся с вами навсегда</p>
                        <p class="course40-about-bottom-header">Чеклисты, артефакты, гайды</p>
                        <p class="course40-about-bottom-subheader">Гайды и артефакты:</p>
                        <ul>
                            <li>Формула счастья «МОСТ»</li>
                            <li>Шкала мотивации Деси и Райана для регуляции собственной деятельности</li>
                            <li>Список привычек счастливых людей для ежедневной практики</li>
                        </ul>
                        <p class="course40-about-bottom-subheader">Чеклисты и трекеры:</p>
                        <ul>
                            <li>Ментальная гигиена</li>
                            <li>Качественный сон</li>
                            <li>Работа с критикой</li>
                            <li>Карьерное планирование</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-course40-results', {
        label: 'Course 4 results',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-course40-results">
            <div class="careerum-container-desc">
                <h2 class="careerum-club40-header">Результаты наших клиентов</h2>
                <div class="course40-results-items careerum-flex-fsst">
                    <div class="course40-results-item no-image-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726041211406-mZpvu-Mask.png"
                                    alt="">
                                <p>Елена Фролова</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="116" height="20" viewBox="0 0 116 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M10.3439 14.8985L14.2814 17.3985C14.7892 17.7188 15.4142 17.2422 15.2657 16.6563L14.1251 12.1719C14.0943 12.0476 14.0992 11.9171 14.1393 11.7955C14.1793 11.6738 14.253 11.566 14.3517 11.4844L17.8829 8.53908C18.3439 8.15627 18.1095 7.38283 17.5079 7.34377L12.8986 7.04689C12.7728 7.03958 12.6519 6.99578 12.5506 6.92086C12.4493 6.84594 12.372 6.74314 12.3282 6.62502L10.6095 2.29689C10.564 2.17182 10.4811 2.06377 10.3721 1.98742C10.2631 1.91107 10.1332 1.87012 10.0001 1.87012C9.86702 1.87012 9.73715 1.91107 9.62814 1.98742C9.51912 2.06377 9.43624 2.17182 9.39074 2.29689L7.67199 6.62502C7.62819 6.74314 7.55092 6.84594 7.44964 6.92086C7.34836 6.99578 7.22745 7.03958 7.10168 7.04689L2.49231 7.34377C1.89074 7.38283 1.65637 8.15627 2.11731 8.53908L5.64856 11.4844C5.74726 11.566 5.82089 11.6738 5.86097 11.7955C5.90106 11.9171 5.90596 12.0476 5.87512 12.1719L4.82043 16.3281C4.64074 17.0313 5.39074 17.6016 5.99231 17.2188L9.65637 14.8985C9.75912 14.8331 9.87836 14.7984 10.0001 14.7984C10.1219 14.7984 10.2411 14.8331 10.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M34.3439 14.8985L38.2814 17.3985C38.7892 17.7188 39.4142 17.2422 39.2657 16.6563L38.1251 12.1719C38.0943 12.0476 38.0992 11.9171 38.1393 11.7955C38.1793 11.6738 38.253 11.566 38.3517 11.4844L41.8829 8.53908C42.3439 8.15627 42.1095 7.38283 41.5079 7.34377L36.8986 7.04689C36.7728 7.03958 36.6519 6.99578 36.5506 6.92086C36.4493 6.84594 36.372 6.74314 36.3282 6.62502L34.6095 2.29689C34.564 2.17182 34.4811 2.06377 34.3721 1.98742C34.2631 1.91107 34.1332 1.87012 34.0001 1.87012C33.867 1.87012 33.7372 1.91107 33.6281 1.98742C33.5191 2.06377 33.4362 2.17182 33.3907 2.29689L31.672 6.62502C31.6282 6.74314 31.5509 6.84594 31.4496 6.92086C31.3484 6.99578 31.2274 7.03958 31.1017 7.04689L26.4923 7.34377C25.8907 7.38283 25.6564 8.15627 26.1173 8.53908L29.6486 11.4844C29.7473 11.566 29.8209 11.6738 29.861 11.7955C29.9011 11.9171 29.906 12.0476 29.8751 12.1719L28.8204 16.3281C28.6407 17.0313 29.3907 17.6016 29.9923 17.2188L33.6564 14.8985C33.7591 14.8331 33.8784 14.7984 34.0001 14.7984C34.1219 14.7984 34.2411 14.8331 34.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M58.3439 14.8985L62.2814 17.3985C62.7892 17.7188 63.4142 17.2422 63.2657 16.6563L62.1251 12.1719C62.0943 12.0476 62.0992 11.9171 62.1393 11.7955C62.1793 11.6738 62.253 11.566 62.3517 11.4844L65.8829 8.53908C66.3439 8.15627 66.1095 7.38283 65.5079 7.34377L60.8986 7.04689C60.7728 7.03958 60.6519 6.99578 60.5506 6.92086C60.4493 6.84594 60.372 6.74314 60.3282 6.62502L58.6095 2.29689C58.564 2.17182 58.4811 2.06377 58.3721 1.98742C58.2631 1.91107 58.1332 1.87012 58.0001 1.87012C57.867 1.87012 57.7372 1.91107 57.6281 1.98742C57.5191 2.06377 57.4362 2.17182 57.3907 2.29689L55.672 6.62502C55.6282 6.74314 55.5509 6.84594 55.4496 6.92086C55.3484 6.99578 55.2274 7.03958 55.1017 7.04689L50.4923 7.34377C49.8907 7.38283 49.6564 8.15627 50.1173 8.53908L53.6486 11.4844C53.7473 11.566 53.8209 11.6738 53.861 11.7955C53.9011 11.9171 53.906 12.0476 53.8751 12.1719L52.8204 16.3281C52.6407 17.0313 53.3907 17.6016 53.9923 17.2188L57.6564 14.8985C57.7591 14.8331 57.8784 14.7984 58.0001 14.7984C58.1219 14.7984 58.2411 14.8331 58.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M82.3439 14.8985L86.2814 17.3985C86.7892 17.7188 87.4142 17.2422 87.2657 16.6563L86.1251 12.1719C86.0943 12.0476 86.0992 11.9171 86.1393 11.7955C86.1793 11.6738 86.253 11.566 86.3517 11.4844L89.8829 8.53908C90.3439 8.15627 90.1095 7.38283 89.5079 7.34377L84.8986 7.04689C84.7728 7.03958 84.6519 6.99578 84.5506 6.92086C84.4493 6.84594 84.372 6.74314 84.3282 6.62502L82.6095 2.29689C82.564 2.17182 82.4811 2.06377 82.3721 1.98742C82.2631 1.91107 82.1332 1.87012 82.0001 1.87012C81.867 1.87012 81.7372 1.91107 81.6281 1.98742C81.5191 2.06377 81.4362 2.17182 81.3907 2.29689L79.672 6.62502C79.6282 6.74314 79.5509 6.84594 79.4496 6.92086C79.3484 6.99578 79.2274 7.03958 79.1017 7.04689L74.4923 7.34377C73.8907 7.38283 73.6564 8.15627 74.1173 8.53908L77.6486 11.4844C77.7473 11.566 77.8209 11.6738 77.861 11.7955C77.9011 11.9171 77.906 12.0476 77.8751 12.1719L76.8204 16.3281C76.6407 17.0313 77.3907 17.6016 77.9923 17.2188L81.6564 14.8985C81.7591 14.8331 81.8784 14.7984 82.0001 14.7984C82.1219 14.7984 82.2411 14.8331 82.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M106.344 14.8985L110.281 17.3985C110.789 17.7188 111.414 17.2422 111.266 16.6563L110.125 12.1719C110.094 12.0476 110.099 11.9171 110.139 11.7955C110.179 11.6738 110.253 11.566 110.352 11.4844L113.883 8.53908C114.344 8.15627 114.109 7.38283 113.508 7.34377L108.899 7.04689C108.773 7.03958 108.652 6.99578 108.551 6.92086C108.449 6.84594 108.372 6.74314 108.328 6.62502L106.609 2.29689C106.564 2.17182 106.481 2.06377 106.372 1.98742C106.263 1.91107 106.133 1.87012 106 1.87012C105.867 1.87012 105.737 1.91107 105.628 1.98742C105.519 2.06377 105.436 2.17182 105.391 2.29689L103.672 6.62502C103.628 6.74314 103.551 6.84594 103.45 6.92086C103.348 6.99578 103.227 7.03958 103.102 7.04689L98.4923 7.34377C97.8907 7.38283 97.6564 8.15627 98.1173 8.53908L101.649 11.4844C101.747 11.566 101.821 11.6738 101.861 11.7955C101.901 11.9171 101.906 12.0476 101.875 12.1719L100.82 16.3281C100.641 17.0313 101.391 17.6016 101.992 17.2188L105.656 14.8985C105.759 14.8331 105.878 14.7984 106 14.7984C106.122 14.7984 106.241 14.8331 106.344 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="course40-results-item-text">
                            <p>Добрый день! Я очень благодарна Ольге и Карьеруму за мега полезные материалы, позитивную
                                атмосферу, общение, поддержку коучей. Решила сделать перерыв и направить энергию на новый
                                рабочий функционал, который выбрала как раз в Карьерум. Большое спасибо!!!</p>
                        </div>
                    </div>
                    <div class="course40-results-item no-image-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726041211406-mZpvu-Mask.png"
                                    alt="">
                                <p>Анонимный отзыв</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="116" height="20" viewBox="0 0 116 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M10.3439 14.8985L14.2814 17.3985C14.7892 17.7188 15.4142 17.2422 15.2657 16.6563L14.1251 12.1719C14.0943 12.0476 14.0992 11.9171 14.1393 11.7955C14.1793 11.6738 14.253 11.566 14.3517 11.4844L17.8829 8.53908C18.3439 8.15627 18.1095 7.38283 17.5079 7.34377L12.8986 7.04689C12.7728 7.03958 12.6519 6.99578 12.5506 6.92086C12.4493 6.84594 12.372 6.74314 12.3282 6.62502L10.6095 2.29689C10.564 2.17182 10.4811 2.06377 10.3721 1.98742C10.2631 1.91107 10.1332 1.87012 10.0001 1.87012C9.86702 1.87012 9.73715 1.91107 9.62814 1.98742C9.51912 2.06377 9.43624 2.17182 9.39074 2.29689L7.67199 6.62502C7.62819 6.74314 7.55092 6.84594 7.44964 6.92086C7.34836 6.99578 7.22745 7.03958 7.10168 7.04689L2.49231 7.34377C1.89074 7.38283 1.65637 8.15627 2.11731 8.53908L5.64856 11.4844C5.74726 11.566 5.82089 11.6738 5.86097 11.7955C5.90106 11.9171 5.90596 12.0476 5.87512 12.1719L4.82043 16.3281C4.64074 17.0313 5.39074 17.6016 5.99231 17.2188L9.65637 14.8985C9.75912 14.8331 9.87836 14.7984 10.0001 14.7984C10.1219 14.7984 10.2411 14.8331 10.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M34.3439 14.8985L38.2814 17.3985C38.7892 17.7188 39.4142 17.2422 39.2657 16.6563L38.1251 12.1719C38.0943 12.0476 38.0992 11.9171 38.1393 11.7955C38.1793 11.6738 38.253 11.566 38.3517 11.4844L41.8829 8.53908C42.3439 8.15627 42.1095 7.38283 41.5079 7.34377L36.8986 7.04689C36.7728 7.03958 36.6519 6.99578 36.5506 6.92086C36.4493 6.84594 36.372 6.74314 36.3282 6.62502L34.6095 2.29689C34.564 2.17182 34.4811 2.06377 34.3721 1.98742C34.2631 1.91107 34.1332 1.87012 34.0001 1.87012C33.867 1.87012 33.7372 1.91107 33.6281 1.98742C33.5191 2.06377 33.4362 2.17182 33.3907 2.29689L31.672 6.62502C31.6282 6.74314 31.5509 6.84594 31.4496 6.92086C31.3484 6.99578 31.2274 7.03958 31.1017 7.04689L26.4923 7.34377C25.8907 7.38283 25.6564 8.15627 26.1173 8.53908L29.6486 11.4844C29.7473 11.566 29.8209 11.6738 29.861 11.7955C29.9011 11.9171 29.906 12.0476 29.8751 12.1719L28.8204 16.3281C28.6407 17.0313 29.3907 17.6016 29.9923 17.2188L33.6564 14.8985C33.7591 14.8331 33.8784 14.7984 34.0001 14.7984C34.1219 14.7984 34.2411 14.8331 34.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M58.3439 14.8985L62.2814 17.3985C62.7892 17.7188 63.4142 17.2422 63.2657 16.6563L62.1251 12.1719C62.0943 12.0476 62.0992 11.9171 62.1393 11.7955C62.1793 11.6738 62.253 11.566 62.3517 11.4844L65.8829 8.53908C66.3439 8.15627 66.1095 7.38283 65.5079 7.34377L60.8986 7.04689C60.7728 7.03958 60.6519 6.99578 60.5506 6.92086C60.4493 6.84594 60.372 6.74314 60.3282 6.62502L58.6095 2.29689C58.564 2.17182 58.4811 2.06377 58.3721 1.98742C58.2631 1.91107 58.1332 1.87012 58.0001 1.87012C57.867 1.87012 57.7372 1.91107 57.6281 1.98742C57.5191 2.06377 57.4362 2.17182 57.3907 2.29689L55.672 6.62502C55.6282 6.74314 55.5509 6.84594 55.4496 6.92086C55.3484 6.99578 55.2274 7.03958 55.1017 7.04689L50.4923 7.34377C49.8907 7.38283 49.6564 8.15627 50.1173 8.53908L53.6486 11.4844C53.7473 11.566 53.8209 11.6738 53.861 11.7955C53.9011 11.9171 53.906 12.0476 53.8751 12.1719L52.8204 16.3281C52.6407 17.0313 53.3907 17.6016 53.9923 17.2188L57.6564 14.8985C57.7591 14.8331 57.8784 14.7984 58.0001 14.7984C58.1219 14.7984 58.2411 14.8331 58.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M82.3439 14.8985L86.2814 17.3985C86.7892 17.7188 87.4142 17.2422 87.2657 16.6563L86.1251 12.1719C86.0943 12.0476 86.0992 11.9171 86.1393 11.7955C86.1793 11.6738 86.253 11.566 86.3517 11.4844L89.8829 8.53908C90.3439 8.15627 90.1095 7.38283 89.5079 7.34377L84.8986 7.04689C84.7728 7.03958 84.6519 6.99578 84.5506 6.92086C84.4493 6.84594 84.372 6.74314 84.3282 6.62502L82.6095 2.29689C82.564 2.17182 82.4811 2.06377 82.3721 1.98742C82.2631 1.91107 82.1332 1.87012 82.0001 1.87012C81.867 1.87012 81.7372 1.91107 81.6281 1.98742C81.5191 2.06377 81.4362 2.17182 81.3907 2.29689L79.672 6.62502C79.6282 6.74314 79.5509 6.84594 79.4496 6.92086C79.3484 6.99578 79.2274 7.03958 79.1017 7.04689L74.4923 7.34377C73.8907 7.38283 73.6564 8.15627 74.1173 8.53908L77.6486 11.4844C77.7473 11.566 77.8209 11.6738 77.861 11.7955C77.9011 11.9171 77.906 12.0476 77.8751 12.1719L76.8204 16.3281C76.6407 17.0313 77.3907 17.6016 77.9923 17.2188L81.6564 14.8985C81.7591 14.8331 81.8784 14.7984 82.0001 14.7984C82.1219 14.7984 82.2411 14.8331 82.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M106.344 14.8985L110.281 17.3985C110.789 17.7188 111.414 17.2422 111.266 16.6563L110.125 12.1719C110.094 12.0476 110.099 11.9171 110.139 11.7955C110.179 11.6738 110.253 11.566 110.352 11.4844L113.883 8.53908C114.344 8.15627 114.109 7.38283 113.508 7.34377L108.899 7.04689C108.773 7.03958 108.652 6.99578 108.551 6.92086C108.449 6.84594 108.372 6.74314 108.328 6.62502L106.609 2.29689C106.564 2.17182 106.481 2.06377 106.372 1.98742C106.263 1.91107 106.133 1.87012 106 1.87012C105.867 1.87012 105.737 1.91107 105.628 1.98742C105.519 2.06377 105.436 2.17182 105.391 2.29689L103.672 6.62502C103.628 6.74314 103.551 6.84594 103.45 6.92086C103.348 6.99578 103.227 7.03958 103.102 7.04689L98.4923 7.34377C97.8907 7.38283 97.6564 8.15627 98.1173 8.53908L101.649 11.4844C101.747 11.566 101.821 11.6738 101.861 11.7955C101.901 11.9171 101.906 12.0476 101.875 12.1719L100.82 16.3281C100.641 17.0313 101.391 17.6016 101.992 17.2188L105.656 14.8985C105.759 14.8331 105.878 14.7984 106 14.7984C106.122 14.7984 106.241 14.8331 106.344 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="course40-results-item-text">
                            <p>Мне очень понравилось участвовать в Мастермаинде, во встречах посредством Coffee Buddy.
                                Познакомилась с интересными людьми, посмотрела на себя со стороны, отметив свои сильные
                                стороны и над чем надо поработать, узнала мнение о себе других незнакомых ранее людей,
                                пообщалась с экспертом.</p>
                        </div>
                    </div>
                    <div class="course40-results-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726040618214-Dzugu-Mask.png"
                                    alt="">
                                <p>Наталья Макеева</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="116" height="20" viewBox="0 0 116 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M10.3439 14.8985L14.2814 17.3985C14.7892 17.7188 15.4142 17.2422 15.2657 16.6563L14.1251 12.1719C14.0943 12.0476 14.0992 11.9171 14.1393 11.7955C14.1793 11.6738 14.253 11.566 14.3517 11.4844L17.8829 8.53908C18.3439 8.15627 18.1095 7.38283 17.5079 7.34377L12.8986 7.04689C12.7728 7.03958 12.6519 6.99578 12.5506 6.92086C12.4493 6.84594 12.372 6.74314 12.3282 6.62502L10.6095 2.29689C10.564 2.17182 10.4811 2.06377 10.3721 1.98742C10.2631 1.91107 10.1332 1.87012 10.0001 1.87012C9.86702 1.87012 9.73715 1.91107 9.62814 1.98742C9.51912 2.06377 9.43624 2.17182 9.39074 2.29689L7.67199 6.62502C7.62819 6.74314 7.55092 6.84594 7.44964 6.92086C7.34836 6.99578 7.22745 7.03958 7.10168 7.04689L2.49231 7.34377C1.89074 7.38283 1.65637 8.15627 2.11731 8.53908L5.64856 11.4844C5.74726 11.566 5.82089 11.6738 5.86097 11.7955C5.90106 11.9171 5.90596 12.0476 5.87512 12.1719L4.82043 16.3281C4.64074 17.0313 5.39074 17.6016 5.99231 17.2188L9.65637 14.8985C9.75912 14.8331 9.87836 14.7984 10.0001 14.7984C10.1219 14.7984 10.2411 14.8331 10.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M34.3439 14.8985L38.2814 17.3985C38.7892 17.7188 39.4142 17.2422 39.2657 16.6563L38.1251 12.1719C38.0943 12.0476 38.0992 11.9171 38.1393 11.7955C38.1793 11.6738 38.253 11.566 38.3517 11.4844L41.8829 8.53908C42.3439 8.15627 42.1095 7.38283 41.5079 7.34377L36.8986 7.04689C36.7728 7.03958 36.6519 6.99578 36.5506 6.92086C36.4493 6.84594 36.372 6.74314 36.3282 6.62502L34.6095 2.29689C34.564 2.17182 34.4811 2.06377 34.3721 1.98742C34.2631 1.91107 34.1332 1.87012 34.0001 1.87012C33.867 1.87012 33.7372 1.91107 33.6281 1.98742C33.5191 2.06377 33.4362 2.17182 33.3907 2.29689L31.672 6.62502C31.6282 6.74314 31.5509 6.84594 31.4496 6.92086C31.3484 6.99578 31.2274 7.03958 31.1017 7.04689L26.4923 7.34377C25.8907 7.38283 25.6564 8.15627 26.1173 8.53908L29.6486 11.4844C29.7473 11.566 29.8209 11.6738 29.861 11.7955C29.9011 11.9171 29.906 12.0476 29.8751 12.1719L28.8204 16.3281C28.6407 17.0313 29.3907 17.6016 29.9923 17.2188L33.6564 14.8985C33.7591 14.8331 33.8784 14.7984 34.0001 14.7984C34.1219 14.7984 34.2411 14.8331 34.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M58.3439 14.8985L62.2814 17.3985C62.7892 17.7188 63.4142 17.2422 63.2657 16.6563L62.1251 12.1719C62.0943 12.0476 62.0992 11.9171 62.1393 11.7955C62.1793 11.6738 62.253 11.566 62.3517 11.4844L65.8829 8.53908C66.3439 8.15627 66.1095 7.38283 65.5079 7.34377L60.8986 7.04689C60.7728 7.03958 60.6519 6.99578 60.5506 6.92086C60.4493 6.84594 60.372 6.74314 60.3282 6.62502L58.6095 2.29689C58.564 2.17182 58.4811 2.06377 58.3721 1.98742C58.2631 1.91107 58.1332 1.87012 58.0001 1.87012C57.867 1.87012 57.7372 1.91107 57.6281 1.98742C57.5191 2.06377 57.4362 2.17182 57.3907 2.29689L55.672 6.62502C55.6282 6.74314 55.5509 6.84594 55.4496 6.92086C55.3484 6.99578 55.2274 7.03958 55.1017 7.04689L50.4923 7.34377C49.8907 7.38283 49.6564 8.15627 50.1173 8.53908L53.6486 11.4844C53.7473 11.566 53.8209 11.6738 53.861 11.7955C53.9011 11.9171 53.906 12.0476 53.8751 12.1719L52.8204 16.3281C52.6407 17.0313 53.3907 17.6016 53.9923 17.2188L57.6564 14.8985C57.7591 14.8331 57.8784 14.7984 58.0001 14.7984C58.1219 14.7984 58.2411 14.8331 58.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M82.3439 14.8985L86.2814 17.3985C86.7892 17.7188 87.4142 17.2422 87.2657 16.6563L86.1251 12.1719C86.0943 12.0476 86.0992 11.9171 86.1393 11.7955C86.1793 11.6738 86.253 11.566 86.3517 11.4844L89.8829 8.53908C90.3439 8.15627 90.1095 7.38283 89.5079 7.34377L84.8986 7.04689C84.7728 7.03958 84.6519 6.99578 84.5506 6.92086C84.4493 6.84594 84.372 6.74314 84.3282 6.62502L82.6095 2.29689C82.564 2.17182 82.4811 2.06377 82.3721 1.98742C82.2631 1.91107 82.1332 1.87012 82.0001 1.87012C81.867 1.87012 81.7372 1.91107 81.6281 1.98742C81.5191 2.06377 81.4362 2.17182 81.3907 2.29689L79.672 6.62502C79.6282 6.74314 79.5509 6.84594 79.4496 6.92086C79.3484 6.99578 79.2274 7.03958 79.1017 7.04689L74.4923 7.34377C73.8907 7.38283 73.6564 8.15627 74.1173 8.53908L77.6486 11.4844C77.7473 11.566 77.8209 11.6738 77.861 11.7955C77.9011 11.9171 77.906 12.0476 77.8751 12.1719L76.8204 16.3281C76.6407 17.0313 77.3907 17.6016 77.9923 17.2188L81.6564 14.8985C81.7591 14.8331 81.8784 14.7984 82.0001 14.7984C82.1219 14.7984 82.2411 14.8331 82.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M106.344 14.8985L110.281 17.3985C110.789 17.7188 111.414 17.2422 111.266 16.6563L110.125 12.1719C110.094 12.0476 110.099 11.9171 110.139 11.7955C110.179 11.6738 110.253 11.566 110.352 11.4844L113.883 8.53908C114.344 8.15627 114.109 7.38283 113.508 7.34377L108.899 7.04689C108.773 7.03958 108.652 6.99578 108.551 6.92086C108.449 6.84594 108.372 6.74314 108.328 6.62502L106.609 2.29689C106.564 2.17182 106.481 2.06377 106.372 1.98742C106.263 1.91107 106.133 1.87012 106 1.87012C105.867 1.87012 105.737 1.91107 105.628 1.98742C105.519 2.06377 105.436 2.17182 105.391 2.29689L103.672 6.62502C103.628 6.74314 103.551 6.84594 103.45 6.92086C103.348 6.99578 103.227 7.03958 103.102 7.04689L98.4923 7.34377C97.8907 7.38283 97.6564 8.15627 98.1173 8.53908L101.649 11.4844C101.747 11.566 101.821 11.6738 101.861 11.7955C101.901 11.9171 101.906 12.0476 101.875 12.1719L100.82 16.3281C100.641 17.0313 101.391 17.6016 101.992 17.2188L105.656 14.8985C105.759 14.8331 105.878 14.7984 106 14.7984C106.122 14.7984 106.241 14.8331 106.344 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="course40-results-item-text">
                            <p>Ольга, здравствуйте! Прохожу курс по самооценке в Карьеруме, наконец-то работаю в
                                тройке-очень интересный опыт! Спасибо, что вы с командой создали такую крутую платформу.</p>
                        </div>
                    </div>
                    <div class="course40-results-item no-image-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726041211406-mZpvu-Mask.png"
                                    alt="">
                                <p>Анонимный отзыв</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="116" height="20" viewBox="0 0 116 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M10.3439 14.8985L14.2814 17.3985C14.7892 17.7188 15.4142 17.2422 15.2657 16.6563L14.1251 12.1719C14.0943 12.0476 14.0992 11.9171 14.1393 11.7955C14.1793 11.6738 14.253 11.566 14.3517 11.4844L17.8829 8.53908C18.3439 8.15627 18.1095 7.38283 17.5079 7.34377L12.8986 7.04689C12.7728 7.03958 12.6519 6.99578 12.5506 6.92086C12.4493 6.84594 12.372 6.74314 12.3282 6.62502L10.6095 2.29689C10.564 2.17182 10.4811 2.06377 10.3721 1.98742C10.2631 1.91107 10.1332 1.87012 10.0001 1.87012C9.86702 1.87012 9.73715 1.91107 9.62814 1.98742C9.51912 2.06377 9.43624 2.17182 9.39074 2.29689L7.67199 6.62502C7.62819 6.74314 7.55092 6.84594 7.44964 6.92086C7.34836 6.99578 7.22745 7.03958 7.10168 7.04689L2.49231 7.34377C1.89074 7.38283 1.65637 8.15627 2.11731 8.53908L5.64856 11.4844C5.74726 11.566 5.82089 11.6738 5.86097 11.7955C5.90106 11.9171 5.90596 12.0476 5.87512 12.1719L4.82043 16.3281C4.64074 17.0313 5.39074 17.6016 5.99231 17.2188L9.65637 14.8985C9.75912 14.8331 9.87836 14.7984 10.0001 14.7984C10.1219 14.7984 10.2411 14.8331 10.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M34.3439 14.8985L38.2814 17.3985C38.7892 17.7188 39.4142 17.2422 39.2657 16.6563L38.1251 12.1719C38.0943 12.0476 38.0992 11.9171 38.1393 11.7955C38.1793 11.6738 38.253 11.566 38.3517 11.4844L41.8829 8.53908C42.3439 8.15627 42.1095 7.38283 41.5079 7.34377L36.8986 7.04689C36.7728 7.03958 36.6519 6.99578 36.5506 6.92086C36.4493 6.84594 36.372 6.74314 36.3282 6.62502L34.6095 2.29689C34.564 2.17182 34.4811 2.06377 34.3721 1.98742C34.2631 1.91107 34.1332 1.87012 34.0001 1.87012C33.867 1.87012 33.7372 1.91107 33.6281 1.98742C33.5191 2.06377 33.4362 2.17182 33.3907 2.29689L31.672 6.62502C31.6282 6.74314 31.5509 6.84594 31.4496 6.92086C31.3484 6.99578 31.2274 7.03958 31.1017 7.04689L26.4923 7.34377C25.8907 7.38283 25.6564 8.15627 26.1173 8.53908L29.6486 11.4844C29.7473 11.566 29.8209 11.6738 29.861 11.7955C29.9011 11.9171 29.906 12.0476 29.8751 12.1719L28.8204 16.3281C28.6407 17.0313 29.3907 17.6016 29.9923 17.2188L33.6564 14.8985C33.7591 14.8331 33.8784 14.7984 34.0001 14.7984C34.1219 14.7984 34.2411 14.8331 34.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M58.3439 14.8985L62.2814 17.3985C62.7892 17.7188 63.4142 17.2422 63.2657 16.6563L62.1251 12.1719C62.0943 12.0476 62.0992 11.9171 62.1393 11.7955C62.1793 11.6738 62.253 11.566 62.3517 11.4844L65.8829 8.53908C66.3439 8.15627 66.1095 7.38283 65.5079 7.34377L60.8986 7.04689C60.7728 7.03958 60.6519 6.99578 60.5506 6.92086C60.4493 6.84594 60.372 6.74314 60.3282 6.62502L58.6095 2.29689C58.564 2.17182 58.4811 2.06377 58.3721 1.98742C58.2631 1.91107 58.1332 1.87012 58.0001 1.87012C57.867 1.87012 57.7372 1.91107 57.6281 1.98742C57.5191 2.06377 57.4362 2.17182 57.3907 2.29689L55.672 6.62502C55.6282 6.74314 55.5509 6.84594 55.4496 6.92086C55.3484 6.99578 55.2274 7.03958 55.1017 7.04689L50.4923 7.34377C49.8907 7.38283 49.6564 8.15627 50.1173 8.53908L53.6486 11.4844C53.7473 11.566 53.8209 11.6738 53.861 11.7955C53.9011 11.9171 53.906 12.0476 53.8751 12.1719L52.8204 16.3281C52.6407 17.0313 53.3907 17.6016 53.9923 17.2188L57.6564 14.8985C57.7591 14.8331 57.8784 14.7984 58.0001 14.7984C58.1219 14.7984 58.2411 14.8331 58.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M82.3439 14.8985L86.2814 17.3985C86.7892 17.7188 87.4142 17.2422 87.2657 16.6563L86.1251 12.1719C86.0943 12.0476 86.0992 11.9171 86.1393 11.7955C86.1793 11.6738 86.253 11.566 86.3517 11.4844L89.8829 8.53908C90.3439 8.15627 90.1095 7.38283 89.5079 7.34377L84.8986 7.04689C84.7728 7.03958 84.6519 6.99578 84.5506 6.92086C84.4493 6.84594 84.372 6.74314 84.3282 6.62502L82.6095 2.29689C82.564 2.17182 82.4811 2.06377 82.3721 1.98742C82.2631 1.91107 82.1332 1.87012 82.0001 1.87012C81.867 1.87012 81.7372 1.91107 81.6281 1.98742C81.5191 2.06377 81.4362 2.17182 81.3907 2.29689L79.672 6.62502C79.6282 6.74314 79.5509 6.84594 79.4496 6.92086C79.3484 6.99578 79.2274 7.03958 79.1017 7.04689L74.4923 7.34377C73.8907 7.38283 73.6564 8.15627 74.1173 8.53908L77.6486 11.4844C77.7473 11.566 77.8209 11.6738 77.861 11.7955C77.9011 11.9171 77.906 12.0476 77.8751 12.1719L76.8204 16.3281C76.6407 17.0313 77.3907 17.6016 77.9923 17.2188L81.6564 14.8985C81.7591 14.8331 81.8784 14.7984 82.0001 14.7984C82.1219 14.7984 82.2411 14.8331 82.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M106.344 14.8985L110.281 17.3985C110.789 17.7188 111.414 17.2422 111.266 16.6563L110.125 12.1719C110.094 12.0476 110.099 11.9171 110.139 11.7955C110.179 11.6738 110.253 11.566 110.352 11.4844L113.883 8.53908C114.344 8.15627 114.109 7.38283 113.508 7.34377L108.899 7.04689C108.773 7.03958 108.652 6.99578 108.551 6.92086C108.449 6.84594 108.372 6.74314 108.328 6.62502L106.609 2.29689C106.564 2.17182 106.481 2.06377 106.372 1.98742C106.263 1.91107 106.133 1.87012 106 1.87012C105.867 1.87012 105.737 1.91107 105.628 1.98742C105.519 2.06377 105.436 2.17182 105.391 2.29689L103.672 6.62502C103.628 6.74314 103.551 6.84594 103.45 6.92086C103.348 6.99578 103.227 7.03958 103.102 7.04689L98.4923 7.34377C97.8907 7.38283 97.6564 8.15627 98.1173 8.53908L101.649 11.4844C101.747 11.566 101.821 11.6738 101.861 11.7955C101.901 11.9171 101.906 12.0476 101.875 12.1719L100.82 16.3281C100.641 17.0313 101.391 17.6016 101.992 17.2188L105.656 14.8985C105.759 14.8331 105.878 14.7984 106 14.7984C106.122 14.7984 106.241 14.8331 106.344 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="course40-results-item-text">
                            <p>С помощью Карьерума уже праздную годовщину на работе-вызове в хорошем смысле слова! Самое
                                крутое, что навык осознанности распространяется и на все остальные сферы жизни!</p>
                        </div>
                    </div>
                    <div class="course40-results-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726041134760-xloV5-Mask.png"
                                    alt="">
                                <p>Elvira Melentyeva</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="116" height="20" viewBox="0 0 116 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M10.3439 14.8985L14.2814 17.3985C14.7892 17.7188 15.4142 17.2422 15.2657 16.6563L14.1251 12.1719C14.0943 12.0476 14.0992 11.9171 14.1393 11.7955C14.1793 11.6738 14.253 11.566 14.3517 11.4844L17.8829 8.53908C18.3439 8.15627 18.1095 7.38283 17.5079 7.34377L12.8986 7.04689C12.7728 7.03958 12.6519 6.99578 12.5506 6.92086C12.4493 6.84594 12.372 6.74314 12.3282 6.62502L10.6095 2.29689C10.564 2.17182 10.4811 2.06377 10.3721 1.98742C10.2631 1.91107 10.1332 1.87012 10.0001 1.87012C9.86702 1.87012 9.73715 1.91107 9.62814 1.98742C9.51912 2.06377 9.43624 2.17182 9.39074 2.29689L7.67199 6.62502C7.62819 6.74314 7.55092 6.84594 7.44964 6.92086C7.34836 6.99578 7.22745 7.03958 7.10168 7.04689L2.49231 7.34377C1.89074 7.38283 1.65637 8.15627 2.11731 8.53908L5.64856 11.4844C5.74726 11.566 5.82089 11.6738 5.86097 11.7955C5.90106 11.9171 5.90596 12.0476 5.87512 12.1719L4.82043 16.3281C4.64074 17.0313 5.39074 17.6016 5.99231 17.2188L9.65637 14.8985C9.75912 14.8331 9.87836 14.7984 10.0001 14.7984C10.1219 14.7984 10.2411 14.8331 10.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M34.3439 14.8985L38.2814 17.3985C38.7892 17.7188 39.4142 17.2422 39.2657 16.6563L38.1251 12.1719C38.0943 12.0476 38.0992 11.9171 38.1393 11.7955C38.1793 11.6738 38.253 11.566 38.3517 11.4844L41.8829 8.53908C42.3439 8.15627 42.1095 7.38283 41.5079 7.34377L36.8986 7.04689C36.7728 7.03958 36.6519 6.99578 36.5506 6.92086C36.4493 6.84594 36.372 6.74314 36.3282 6.62502L34.6095 2.29689C34.564 2.17182 34.4811 2.06377 34.3721 1.98742C34.2631 1.91107 34.1332 1.87012 34.0001 1.87012C33.867 1.87012 33.7372 1.91107 33.6281 1.98742C33.5191 2.06377 33.4362 2.17182 33.3907 2.29689L31.672 6.62502C31.6282 6.74314 31.5509 6.84594 31.4496 6.92086C31.3484 6.99578 31.2274 7.03958 31.1017 7.04689L26.4923 7.34377C25.8907 7.38283 25.6564 8.15627 26.1173 8.53908L29.6486 11.4844C29.7473 11.566 29.8209 11.6738 29.861 11.7955C29.9011 11.9171 29.906 12.0476 29.8751 12.1719L28.8204 16.3281C28.6407 17.0313 29.3907 17.6016 29.9923 17.2188L33.6564 14.8985C33.7591 14.8331 33.8784 14.7984 34.0001 14.7984C34.1219 14.7984 34.2411 14.8331 34.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M58.3439 14.8985L62.2814 17.3985C62.7892 17.7188 63.4142 17.2422 63.2657 16.6563L62.1251 12.1719C62.0943 12.0476 62.0992 11.9171 62.1393 11.7955C62.1793 11.6738 62.253 11.566 62.3517 11.4844L65.8829 8.53908C66.3439 8.15627 66.1095 7.38283 65.5079 7.34377L60.8986 7.04689C60.7728 7.03958 60.6519 6.99578 60.5506 6.92086C60.4493 6.84594 60.372 6.74314 60.3282 6.62502L58.6095 2.29689C58.564 2.17182 58.4811 2.06377 58.3721 1.98742C58.2631 1.91107 58.1332 1.87012 58.0001 1.87012C57.867 1.87012 57.7372 1.91107 57.6281 1.98742C57.5191 2.06377 57.4362 2.17182 57.3907 2.29689L55.672 6.62502C55.6282 6.74314 55.5509 6.84594 55.4496 6.92086C55.3484 6.99578 55.2274 7.03958 55.1017 7.04689L50.4923 7.34377C49.8907 7.38283 49.6564 8.15627 50.1173 8.53908L53.6486 11.4844C53.7473 11.566 53.8209 11.6738 53.861 11.7955C53.9011 11.9171 53.906 12.0476 53.8751 12.1719L52.8204 16.3281C52.6407 17.0313 53.3907 17.6016 53.9923 17.2188L57.6564 14.8985C57.7591 14.8331 57.8784 14.7984 58.0001 14.7984C58.1219 14.7984 58.2411 14.8331 58.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M82.3439 14.8985L86.2814 17.3985C86.7892 17.7188 87.4142 17.2422 87.2657 16.6563L86.1251 12.1719C86.0943 12.0476 86.0992 11.9171 86.1393 11.7955C86.1793 11.6738 86.253 11.566 86.3517 11.4844L89.8829 8.53908C90.3439 8.15627 90.1095 7.38283 89.5079 7.34377L84.8986 7.04689C84.7728 7.03958 84.6519 6.99578 84.5506 6.92086C84.4493 6.84594 84.372 6.74314 84.3282 6.62502L82.6095 2.29689C82.564 2.17182 82.4811 2.06377 82.3721 1.98742C82.2631 1.91107 82.1332 1.87012 82.0001 1.87012C81.867 1.87012 81.7372 1.91107 81.6281 1.98742C81.5191 2.06377 81.4362 2.17182 81.3907 2.29689L79.672 6.62502C79.6282 6.74314 79.5509 6.84594 79.4496 6.92086C79.3484 6.99578 79.2274 7.03958 79.1017 7.04689L74.4923 7.34377C73.8907 7.38283 73.6564 8.15627 74.1173 8.53908L77.6486 11.4844C77.7473 11.566 77.8209 11.6738 77.861 11.7955C77.9011 11.9171 77.906 12.0476 77.8751 12.1719L76.8204 16.3281C76.6407 17.0313 77.3907 17.6016 77.9923 17.2188L81.6564 14.8985C81.7591 14.8331 81.8784 14.7984 82.0001 14.7984C82.1219 14.7984 82.2411 14.8331 82.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M106.344 14.8985L110.281 17.3985C110.789 17.7188 111.414 17.2422 111.266 16.6563L110.125 12.1719C110.094 12.0476 110.099 11.9171 110.139 11.7955C110.179 11.6738 110.253 11.566 110.352 11.4844L113.883 8.53908C114.344 8.15627 114.109 7.38283 113.508 7.34377L108.899 7.04689C108.773 7.03958 108.652 6.99578 108.551 6.92086C108.449 6.84594 108.372 6.74314 108.328 6.62502L106.609 2.29689C106.564 2.17182 106.481 2.06377 106.372 1.98742C106.263 1.91107 106.133 1.87012 106 1.87012C105.867 1.87012 105.737 1.91107 105.628 1.98742C105.519 2.06377 105.436 2.17182 105.391 2.29689L103.672 6.62502C103.628 6.74314 103.551 6.84594 103.45 6.92086C103.348 6.99578 103.227 7.03958 103.102 7.04689L98.4923 7.34377C97.8907 7.38283 97.6564 8.15627 98.1173 8.53908L101.649 11.4844C101.747 11.566 101.821 11.6738 101.861 11.7955C101.901 11.9171 101.906 12.0476 101.875 12.1719L100.82 16.3281C100.641 17.0313 101.391 17.6016 101.992 17.2188L105.656 14.8985C105.759 14.8331 105.878 14.7984 106 14.7984C106.122 14.7984 106.241 14.8331 106.344 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="course40-results-item-text">
                            <p>My last career crisis was solved with Careerum's help. Now I see career as something that is
                                forming and changing all the time. With good planning it is easier to avoid a crisis moment.
                                Forever grateful!
                            </p>
                        </div>
                    </div>
                    <div class="course40-results-item no-image-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726041211406-mZpvu-Mask.png"
                                    alt="">
                                <p>Милана Александрова</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="116" height="20" viewBox="0 0 116 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M10.3439 14.8985L14.2814 17.3985C14.7892 17.7188 15.4142 17.2422 15.2657 16.6563L14.1251 12.1719C14.0943 12.0476 14.0992 11.9171 14.1393 11.7955C14.1793 11.6738 14.253 11.566 14.3517 11.4844L17.8829 8.53908C18.3439 8.15627 18.1095 7.38283 17.5079 7.34377L12.8986 7.04689C12.7728 7.03958 12.6519 6.99578 12.5506 6.92086C12.4493 6.84594 12.372 6.74314 12.3282 6.62502L10.6095 2.29689C10.564 2.17182 10.4811 2.06377 10.3721 1.98742C10.2631 1.91107 10.1332 1.87012 10.0001 1.87012C9.86702 1.87012 9.73715 1.91107 9.62814 1.98742C9.51912 2.06377 9.43624 2.17182 9.39074 2.29689L7.67199 6.62502C7.62819 6.74314 7.55092 6.84594 7.44964 6.92086C7.34836 6.99578 7.22745 7.03958 7.10168 7.04689L2.49231 7.34377C1.89074 7.38283 1.65637 8.15627 2.11731 8.53908L5.64856 11.4844C5.74726 11.566 5.82089 11.6738 5.86097 11.7955C5.90106 11.9171 5.90596 12.0476 5.87512 12.1719L4.82043 16.3281C4.64074 17.0313 5.39074 17.6016 5.99231 17.2188L9.65637 14.8985C9.75912 14.8331 9.87836 14.7984 10.0001 14.7984C10.1219 14.7984 10.2411 14.8331 10.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M34.3439 14.8985L38.2814 17.3985C38.7892 17.7188 39.4142 17.2422 39.2657 16.6563L38.1251 12.1719C38.0943 12.0476 38.0992 11.9171 38.1393 11.7955C38.1793 11.6738 38.253 11.566 38.3517 11.4844L41.8829 8.53908C42.3439 8.15627 42.1095 7.38283 41.5079 7.34377L36.8986 7.04689C36.7728 7.03958 36.6519 6.99578 36.5506 6.92086C36.4493 6.84594 36.372 6.74314 36.3282 6.62502L34.6095 2.29689C34.564 2.17182 34.4811 2.06377 34.3721 1.98742C34.2631 1.91107 34.1332 1.87012 34.0001 1.87012C33.867 1.87012 33.7372 1.91107 33.6281 1.98742C33.5191 2.06377 33.4362 2.17182 33.3907 2.29689L31.672 6.62502C31.6282 6.74314 31.5509 6.84594 31.4496 6.92086C31.3484 6.99578 31.2274 7.03958 31.1017 7.04689L26.4923 7.34377C25.8907 7.38283 25.6564 8.15627 26.1173 8.53908L29.6486 11.4844C29.7473 11.566 29.8209 11.6738 29.861 11.7955C29.9011 11.9171 29.906 12.0476 29.8751 12.1719L28.8204 16.3281C28.6407 17.0313 29.3907 17.6016 29.9923 17.2188L33.6564 14.8985C33.7591 14.8331 33.8784 14.7984 34.0001 14.7984C34.1219 14.7984 34.2411 14.8331 34.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M58.3439 14.8985L62.2814 17.3985C62.7892 17.7188 63.4142 17.2422 63.2657 16.6563L62.1251 12.1719C62.0943 12.0476 62.0992 11.9171 62.1393 11.7955C62.1793 11.6738 62.253 11.566 62.3517 11.4844L65.8829 8.53908C66.3439 8.15627 66.1095 7.38283 65.5079 7.34377L60.8986 7.04689C60.7728 7.03958 60.6519 6.99578 60.5506 6.92086C60.4493 6.84594 60.372 6.74314 60.3282 6.62502L58.6095 2.29689C58.564 2.17182 58.4811 2.06377 58.3721 1.98742C58.2631 1.91107 58.1332 1.87012 58.0001 1.87012C57.867 1.87012 57.7372 1.91107 57.6281 1.98742C57.5191 2.06377 57.4362 2.17182 57.3907 2.29689L55.672 6.62502C55.6282 6.74314 55.5509 6.84594 55.4496 6.92086C55.3484 6.99578 55.2274 7.03958 55.1017 7.04689L50.4923 7.34377C49.8907 7.38283 49.6564 8.15627 50.1173 8.53908L53.6486 11.4844C53.7473 11.566 53.8209 11.6738 53.861 11.7955C53.9011 11.9171 53.906 12.0476 53.8751 12.1719L52.8204 16.3281C52.6407 17.0313 53.3907 17.6016 53.9923 17.2188L57.6564 14.8985C57.7591 14.8331 57.8784 14.7984 58.0001 14.7984C58.1219 14.7984 58.2411 14.8331 58.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M82.3439 14.8985L86.2814 17.3985C86.7892 17.7188 87.4142 17.2422 87.2657 16.6563L86.1251 12.1719C86.0943 12.0476 86.0992 11.9171 86.1393 11.7955C86.1793 11.6738 86.253 11.566 86.3517 11.4844L89.8829 8.53908C90.3439 8.15627 90.1095 7.38283 89.5079 7.34377L84.8986 7.04689C84.7728 7.03958 84.6519 6.99578 84.5506 6.92086C84.4493 6.84594 84.372 6.74314 84.3282 6.62502L82.6095 2.29689C82.564 2.17182 82.4811 2.06377 82.3721 1.98742C82.2631 1.91107 82.1332 1.87012 82.0001 1.87012C81.867 1.87012 81.7372 1.91107 81.6281 1.98742C81.5191 2.06377 81.4362 2.17182 81.3907 2.29689L79.672 6.62502C79.6282 6.74314 79.5509 6.84594 79.4496 6.92086C79.3484 6.99578 79.2274 7.03958 79.1017 7.04689L74.4923 7.34377C73.8907 7.38283 73.6564 8.15627 74.1173 8.53908L77.6486 11.4844C77.7473 11.566 77.8209 11.6738 77.861 11.7955C77.9011 11.9171 77.906 12.0476 77.8751 12.1719L76.8204 16.3281C76.6407 17.0313 77.3907 17.6016 77.9923 17.2188L81.6564 14.8985C81.7591 14.8331 81.8784 14.7984 82.0001 14.7984C82.1219 14.7984 82.2411 14.8331 82.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M106.344 14.8985L110.281 17.3985C110.789 17.7188 111.414 17.2422 111.266 16.6563L110.125 12.1719C110.094 12.0476 110.099 11.9171 110.139 11.7955C110.179 11.6738 110.253 11.566 110.352 11.4844L113.883 8.53908C114.344 8.15627 114.109 7.38283 113.508 7.34377L108.899 7.04689C108.773 7.03958 108.652 6.99578 108.551 6.92086C108.449 6.84594 108.372 6.74314 108.328 6.62502L106.609 2.29689C106.564 2.17182 106.481 2.06377 106.372 1.98742C106.263 1.91107 106.133 1.87012 106 1.87012C105.867 1.87012 105.737 1.91107 105.628 1.98742C105.519 2.06377 105.436 2.17182 105.391 2.29689L103.672 6.62502C103.628 6.74314 103.551 6.84594 103.45 6.92086C103.348 6.99578 103.227 7.03958 103.102 7.04689L98.4923 7.34377C97.8907 7.38283 97.6564 8.15627 98.1173 8.53908L101.649 11.4844C101.747 11.566 101.821 11.6738 101.861 11.7955C101.901 11.9171 101.906 12.0476 101.875 12.1719L100.82 16.3281C100.641 17.0313 101.391 17.6016 101.992 17.2188L105.656 14.8985C105.759 14.8331 105.878 14.7984 106 14.7984C106.122 14.7984 106.241 14.8331 106.344 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="course40-results-item-text">
                            <p>Вижу, как влияют наша с вами работа, спорт и корректные фокусировки влияют на нужный
                                результат. Поняла, что поработала 3 года практически без отпусков. Даже деньги не тратила,
                                потому что было некогда. Хочу потратить и вложиться в ремонт и свое продвижение.
                                Материальные изменения способствуют ментальным и душевным трансформациям. Большое вам
                                спасибо за терпение, внимание и поддержку!</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-course40-results-tablet', {
        label: 'Course 4 results (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-course40-results-tablet">
            <div class="careerum-container-tablet">
                <h2>Результаты наших клиентов</h2>
                <div class="course40-results-items results-items-slider">
                    <div class="course40-results-item no-image-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726041211406-mZpvu-Mask.png"
                                    alt="">
                                <p>Елена Фролова</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="97" height="17" viewBox="0 0 97 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.29302 12.8441L11.4498 14.8484C11.8569 15.1052 12.358 14.7231 12.239 14.2533L11.3245 10.6581C11.2998 10.5585 11.3037 10.4538 11.3359 10.3563C11.368 10.2588 11.427 10.1724 11.5062 10.1069L14.3373 7.7456C14.7068 7.43869 14.5189 6.8186 14.0366 6.78728L10.3412 6.54927C10.2403 6.54341 10.1434 6.50829 10.0622 6.44823C9.981 6.38816 9.91906 6.30575 9.88394 6.21105L8.50598 2.74108C8.4695 2.64081 8.40305 2.55418 8.31565 2.49297C8.22825 2.43176 8.12413 2.39893 8.01743 2.39893C7.91072 2.39893 7.8066 2.43176 7.7192 2.49297C7.6318 2.55418 7.56535 2.64081 7.52887 2.74108L6.15091 6.21105C6.11579 6.30575 6.05385 6.38816 5.97265 6.44823C5.89145 6.50829 5.79451 6.54341 5.69368 6.54927L1.99823 6.78728C1.51594 6.8186 1.32804 7.43869 1.69758 7.7456L4.52867 10.1069C4.6078 10.1724 4.66684 10.2588 4.69897 10.3563C4.73111 10.4538 4.73504 10.5585 4.71031 10.6581L3.86474 13.9903C3.72068 14.554 4.32198 15.0112 4.80426 14.7043L7.74183 12.8441C7.82421 12.7917 7.91981 12.7639 8.01743 12.7639C8.11504 12.7639 8.21064 12.7917 8.29302 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M28.3272 12.8441L31.484 14.8484C31.8911 15.1052 32.3922 14.7231 32.2732 14.2533L31.3587 10.6581C31.334 10.5585 31.3379 10.4538 31.3701 10.3563C31.4022 10.2588 31.4612 10.1724 31.5404 10.1069L34.3714 7.7456C34.741 7.43869 34.5531 6.8186 34.0708 6.78728L30.3754 6.54927C30.2745 6.54341 30.1776 6.50829 30.0964 6.44823C30.0152 6.38816 29.9532 6.30575 29.9181 6.21105L28.5402 2.74108C28.5037 2.64081 28.4372 2.55418 28.3498 2.49297C28.2624 2.43176 28.1583 2.39893 28.0516 2.39893C27.9449 2.39893 27.8408 2.43176 27.7534 2.49297C27.666 2.55418 27.5995 2.64081 27.5631 2.74108L26.1851 6.21105C26.15 6.30575 26.088 6.38816 26.0068 6.44823C25.9256 6.50829 25.8287 6.54341 25.7279 6.54927L22.0324 6.78728C21.5501 6.8186 21.3622 7.43869 21.7318 7.7456L24.5629 10.1069C24.642 10.1724 24.701 10.2588 24.7332 10.3563C24.7653 10.4538 24.7692 10.5585 24.7445 10.6581L23.8989 13.9903C23.7549 14.554 24.3562 15.0112 24.8384 14.7043L27.776 12.8441C27.8584 12.7917 27.954 12.7639 28.0516 12.7639C28.1492 12.7639 28.2448 12.7917 28.3272 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M48.3624 12.8441L51.5191 14.8484C51.9263 15.1052 52.4273 14.7231 52.3083 14.2533L51.3939 10.6581C51.3691 10.5585 51.3731 10.4538 51.4052 10.3563C51.4374 10.2588 51.4964 10.1724 51.5755 10.1069L54.4066 7.7456C54.7761 7.43869 54.5882 6.8186 54.106 6.78728L50.4105 6.54927C50.3097 6.54341 50.2127 6.50829 50.1315 6.44823C50.0503 6.38816 49.9884 6.30575 49.9533 6.21105L48.5753 2.74108C48.5388 2.64081 48.4724 2.55418 48.385 2.49297C48.2976 2.43176 48.1935 2.39893 48.0868 2.39893C47.9801 2.39893 47.8759 2.43176 47.7885 2.49297C47.7011 2.55418 47.6347 2.64081 47.5982 2.74108L46.2202 6.21105C46.1851 6.30575 46.1232 6.38816 46.042 6.44823C45.9608 6.50829 45.8638 6.54341 45.763 6.54927L42.0676 6.78728C41.5853 6.8186 41.3974 7.43869 41.7669 7.7456L44.598 10.1069C44.6771 10.1724 44.7362 10.2588 44.7683 10.3563C44.8004 10.4538 44.8044 10.5585 44.7796 10.6581L43.9341 13.9903C43.79 14.554 44.3913 15.0112 44.8736 14.7043L47.8112 12.8441C47.8935 12.7917 47.9891 12.7639 48.0868 12.7639C48.1844 12.7639 48.28 12.7917 48.3624 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M68.3965 12.8441L71.5533 14.8484C71.9604 15.1052 72.4615 14.7231 72.3425 14.2533L71.4281 10.6581C71.4033 10.5585 71.4073 10.4538 71.4394 10.3563C71.4715 10.2588 71.5306 10.1724 71.6097 10.1069L74.4408 7.7456C74.8103 7.43869 74.6224 6.8186 74.1401 6.78728L70.4447 6.54927C70.3439 6.54341 70.2469 6.50829 70.1657 6.44823C70.0845 6.38816 70.0226 6.30575 69.9875 6.21105L68.6095 2.74108C68.573 2.64081 68.5066 2.55418 68.4192 2.49297C68.3318 2.43176 68.2276 2.39893 68.1209 2.39893C68.0142 2.39893 67.9101 2.43176 67.8227 2.49297C67.7353 2.55418 67.6689 2.64081 67.6324 2.74108L66.2544 6.21105C66.2193 6.30575 66.1574 6.38816 66.0762 6.44823C65.995 6.50829 65.898 6.54341 65.7972 6.54927L62.1017 6.78728C61.6195 6.8186 61.4316 7.43869 61.8011 7.7456L64.6322 10.1069C64.7113 10.1724 64.7704 10.2588 64.8025 10.3563C64.8346 10.4538 64.8386 10.5585 64.8138 10.6581L63.9683 13.9903C63.8242 14.554 64.4255 15.0112 64.9078 14.7043L67.8453 12.8441C67.9277 12.7917 68.0233 12.7639 68.1209 12.7639C68.2186 12.7639 68.3142 12.7917 68.3965 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M88.4307 12.8441L91.5875 14.8484C91.9946 15.1052 92.4957 14.7231 92.3767 14.2533L91.4622 10.6581C91.4375 10.5585 91.4414 10.4538 91.4736 10.3563C91.5057 10.2588 91.5647 10.1724 91.6439 10.1069L94.475 7.7456C94.8445 7.43869 94.6566 6.8186 94.1743 6.78728L90.4789 6.54927C90.378 6.54341 90.2811 6.50829 90.1999 6.44823C90.1187 6.38816 90.0568 6.30575 90.0216 6.21105L88.6437 2.74108C88.6072 2.64081 88.5407 2.55418 88.4533 2.49297C88.3659 2.43176 88.2618 2.39893 88.1551 2.39893C88.0484 2.39893 87.9443 2.43176 87.8569 2.49297C87.7695 2.55418 87.703 2.64081 87.6666 2.74108L86.2886 6.21105C86.2535 6.30575 86.1915 6.38816 86.1103 6.44823C86.0291 6.50829 85.9322 6.54341 85.8314 6.54927L82.1359 6.78728C81.6536 6.8186 81.4657 7.43869 81.8353 7.7456L84.6664 10.1069C84.7455 10.1724 84.8045 10.2588 84.8367 10.3563C84.8688 10.4538 84.8727 10.5585 84.848 10.6581L84.0024 13.9903C83.8584 14.554 84.4597 15.0112 84.942 14.7043L87.8795 12.8441C87.9619 12.7917 88.0575 12.7639 88.1551 12.7639C88.2527 12.7639 88.3483 12.7917 88.4307 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
    
                        </div>
                        <div class="course40-results-item-text">
                            <p>Добрый день! Я очень благодарна Ольге и Карьеруму за мега полезные материалы, позитивную
                                атмосферу, общение, поддержку коучей. Решила сделать перерыв и направить энергию на новый
                                рабочий функционал, который выбрала как раз в Карьерум. Большое спасибо!!!</p>
                        </div>
                    </div>
                    <div class="course40-results-item no-image-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726041211406-mZpvu-Mask.png"
                                    alt="">
                                <p>Анонимный отзыв</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="97" height="17" viewBox="0 0 97 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.29302 12.8441L11.4498 14.8484C11.8569 15.1052 12.358 14.7231 12.239 14.2533L11.3245 10.6581C11.2998 10.5585 11.3037 10.4538 11.3359 10.3563C11.368 10.2588 11.427 10.1724 11.5062 10.1069L14.3373 7.7456C14.7068 7.43869 14.5189 6.8186 14.0366 6.78728L10.3412 6.54927C10.2403 6.54341 10.1434 6.50829 10.0622 6.44823C9.981 6.38816 9.91906 6.30575 9.88394 6.21105L8.50598 2.74108C8.4695 2.64081 8.40305 2.55418 8.31565 2.49297C8.22825 2.43176 8.12413 2.39893 8.01743 2.39893C7.91072 2.39893 7.8066 2.43176 7.7192 2.49297C7.6318 2.55418 7.56535 2.64081 7.52887 2.74108L6.15091 6.21105C6.11579 6.30575 6.05385 6.38816 5.97265 6.44823C5.89145 6.50829 5.79451 6.54341 5.69368 6.54927L1.99823 6.78728C1.51594 6.8186 1.32804 7.43869 1.69758 7.7456L4.52867 10.1069C4.6078 10.1724 4.66684 10.2588 4.69897 10.3563C4.73111 10.4538 4.73504 10.5585 4.71031 10.6581L3.86474 13.9903C3.72068 14.554 4.32198 15.0112 4.80426 14.7043L7.74183 12.8441C7.82421 12.7917 7.91981 12.7639 8.01743 12.7639C8.11504 12.7639 8.21064 12.7917 8.29302 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M28.3272 12.8441L31.484 14.8484C31.8911 15.1052 32.3922 14.7231 32.2732 14.2533L31.3587 10.6581C31.334 10.5585 31.3379 10.4538 31.3701 10.3563C31.4022 10.2588 31.4612 10.1724 31.5404 10.1069L34.3714 7.7456C34.741 7.43869 34.5531 6.8186 34.0708 6.78728L30.3754 6.54927C30.2745 6.54341 30.1776 6.50829 30.0964 6.44823C30.0152 6.38816 29.9532 6.30575 29.9181 6.21105L28.5402 2.74108C28.5037 2.64081 28.4372 2.55418 28.3498 2.49297C28.2624 2.43176 28.1583 2.39893 28.0516 2.39893C27.9449 2.39893 27.8408 2.43176 27.7534 2.49297C27.666 2.55418 27.5995 2.64081 27.5631 2.74108L26.1851 6.21105C26.15 6.30575 26.088 6.38816 26.0068 6.44823C25.9256 6.50829 25.8287 6.54341 25.7279 6.54927L22.0324 6.78728C21.5501 6.8186 21.3622 7.43869 21.7318 7.7456L24.5629 10.1069C24.642 10.1724 24.701 10.2588 24.7332 10.3563C24.7653 10.4538 24.7692 10.5585 24.7445 10.6581L23.8989 13.9903C23.7549 14.554 24.3562 15.0112 24.8384 14.7043L27.776 12.8441C27.8584 12.7917 27.954 12.7639 28.0516 12.7639C28.1492 12.7639 28.2448 12.7917 28.3272 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M48.3624 12.8441L51.5191 14.8484C51.9263 15.1052 52.4273 14.7231 52.3083 14.2533L51.3939 10.6581C51.3691 10.5585 51.3731 10.4538 51.4052 10.3563C51.4374 10.2588 51.4964 10.1724 51.5755 10.1069L54.4066 7.7456C54.7761 7.43869 54.5882 6.8186 54.106 6.78728L50.4105 6.54927C50.3097 6.54341 50.2127 6.50829 50.1315 6.44823C50.0503 6.38816 49.9884 6.30575 49.9533 6.21105L48.5753 2.74108C48.5388 2.64081 48.4724 2.55418 48.385 2.49297C48.2976 2.43176 48.1935 2.39893 48.0868 2.39893C47.9801 2.39893 47.8759 2.43176 47.7885 2.49297C47.7011 2.55418 47.6347 2.64081 47.5982 2.74108L46.2202 6.21105C46.1851 6.30575 46.1232 6.38816 46.042 6.44823C45.9608 6.50829 45.8638 6.54341 45.763 6.54927L42.0676 6.78728C41.5853 6.8186 41.3974 7.43869 41.7669 7.7456L44.598 10.1069C44.6771 10.1724 44.7362 10.2588 44.7683 10.3563C44.8004 10.4538 44.8044 10.5585 44.7796 10.6581L43.9341 13.9903C43.79 14.554 44.3913 15.0112 44.8736 14.7043L47.8112 12.8441C47.8935 12.7917 47.9891 12.7639 48.0868 12.7639C48.1844 12.7639 48.28 12.7917 48.3624 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M68.3965 12.8441L71.5533 14.8484C71.9604 15.1052 72.4615 14.7231 72.3425 14.2533L71.4281 10.6581C71.4033 10.5585 71.4073 10.4538 71.4394 10.3563C71.4715 10.2588 71.5306 10.1724 71.6097 10.1069L74.4408 7.7456C74.8103 7.43869 74.6224 6.8186 74.1401 6.78728L70.4447 6.54927C70.3439 6.54341 70.2469 6.50829 70.1657 6.44823C70.0845 6.38816 70.0226 6.30575 69.9875 6.21105L68.6095 2.74108C68.573 2.64081 68.5066 2.55418 68.4192 2.49297C68.3318 2.43176 68.2276 2.39893 68.1209 2.39893C68.0142 2.39893 67.9101 2.43176 67.8227 2.49297C67.7353 2.55418 67.6689 2.64081 67.6324 2.74108L66.2544 6.21105C66.2193 6.30575 66.1574 6.38816 66.0762 6.44823C65.995 6.50829 65.898 6.54341 65.7972 6.54927L62.1017 6.78728C61.6195 6.8186 61.4316 7.43869 61.8011 7.7456L64.6322 10.1069C64.7113 10.1724 64.7704 10.2588 64.8025 10.3563C64.8346 10.4538 64.8386 10.5585 64.8138 10.6581L63.9683 13.9903C63.8242 14.554 64.4255 15.0112 64.9078 14.7043L67.8453 12.8441C67.9277 12.7917 68.0233 12.7639 68.1209 12.7639C68.2186 12.7639 68.3142 12.7917 68.3965 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M88.4307 12.8441L91.5875 14.8484C91.9946 15.1052 92.4957 14.7231 92.3767 14.2533L91.4622 10.6581C91.4375 10.5585 91.4414 10.4538 91.4736 10.3563C91.5057 10.2588 91.5647 10.1724 91.6439 10.1069L94.475 7.7456C94.8445 7.43869 94.6566 6.8186 94.1743 6.78728L90.4789 6.54927C90.378 6.54341 90.2811 6.50829 90.1999 6.44823C90.1187 6.38816 90.0568 6.30575 90.0216 6.21105L88.6437 2.74108C88.6072 2.64081 88.5407 2.55418 88.4533 2.49297C88.3659 2.43176 88.2618 2.39893 88.1551 2.39893C88.0484 2.39893 87.9443 2.43176 87.8569 2.49297C87.7695 2.55418 87.703 2.64081 87.6666 2.74108L86.2886 6.21105C86.2535 6.30575 86.1915 6.38816 86.1103 6.44823C86.0291 6.50829 85.9322 6.54341 85.8314 6.54927L82.1359 6.78728C81.6536 6.8186 81.4657 7.43869 81.8353 7.7456L84.6664 10.1069C84.7455 10.1724 84.8045 10.2588 84.8367 10.3563C84.8688 10.4538 84.8727 10.5585 84.848 10.6581L84.0024 13.9903C83.8584 14.554 84.4597 15.0112 84.942 14.7043L87.8795 12.8441C87.9619 12.7917 88.0575 12.7639 88.1551 12.7639C88.2527 12.7639 88.3483 12.7917 88.4307 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
    
                        </div>
                        <div class="course40-results-item-text">
                            <p>Мне очень понравилось участвовать в Мастермаинде, во встречах посредством Coffee Buddy.
                                Познакомилась с интересными людьми, посмотрела на себя со стороны, отметив свои сильные
                                стороны и над чем надо поработать, узнала мнение о себе других незнакомых ранее людей,
                                пообщалась с экспертом.</p>
                        </div>
                    </div>
                    <div class="course40-results-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726040618214-Dzugu-Mask.png"
                                    alt="">
                                <p>Наталья Макеева</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="97" height="17" viewBox="0 0 97 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.29302 12.8441L11.4498 14.8484C11.8569 15.1052 12.358 14.7231 12.239 14.2533L11.3245 10.6581C11.2998 10.5585 11.3037 10.4538 11.3359 10.3563C11.368 10.2588 11.427 10.1724 11.5062 10.1069L14.3373 7.7456C14.7068 7.43869 14.5189 6.8186 14.0366 6.78728L10.3412 6.54927C10.2403 6.54341 10.1434 6.50829 10.0622 6.44823C9.981 6.38816 9.91906 6.30575 9.88394 6.21105L8.50598 2.74108C8.4695 2.64081 8.40305 2.55418 8.31565 2.49297C8.22825 2.43176 8.12413 2.39893 8.01743 2.39893C7.91072 2.39893 7.8066 2.43176 7.7192 2.49297C7.6318 2.55418 7.56535 2.64081 7.52887 2.74108L6.15091 6.21105C6.11579 6.30575 6.05385 6.38816 5.97265 6.44823C5.89145 6.50829 5.79451 6.54341 5.69368 6.54927L1.99823 6.78728C1.51594 6.8186 1.32804 7.43869 1.69758 7.7456L4.52867 10.1069C4.6078 10.1724 4.66684 10.2588 4.69897 10.3563C4.73111 10.4538 4.73504 10.5585 4.71031 10.6581L3.86474 13.9903C3.72068 14.554 4.32198 15.0112 4.80426 14.7043L7.74183 12.8441C7.82421 12.7917 7.91981 12.7639 8.01743 12.7639C8.11504 12.7639 8.21064 12.7917 8.29302 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M28.3272 12.8441L31.484 14.8484C31.8911 15.1052 32.3922 14.7231 32.2732 14.2533L31.3587 10.6581C31.334 10.5585 31.3379 10.4538 31.3701 10.3563C31.4022 10.2588 31.4612 10.1724 31.5404 10.1069L34.3714 7.7456C34.741 7.43869 34.5531 6.8186 34.0708 6.78728L30.3754 6.54927C30.2745 6.54341 30.1776 6.50829 30.0964 6.44823C30.0152 6.38816 29.9532 6.30575 29.9181 6.21105L28.5402 2.74108C28.5037 2.64081 28.4372 2.55418 28.3498 2.49297C28.2624 2.43176 28.1583 2.39893 28.0516 2.39893C27.9449 2.39893 27.8408 2.43176 27.7534 2.49297C27.666 2.55418 27.5995 2.64081 27.5631 2.74108L26.1851 6.21105C26.15 6.30575 26.088 6.38816 26.0068 6.44823C25.9256 6.50829 25.8287 6.54341 25.7279 6.54927L22.0324 6.78728C21.5501 6.8186 21.3622 7.43869 21.7318 7.7456L24.5629 10.1069C24.642 10.1724 24.701 10.2588 24.7332 10.3563C24.7653 10.4538 24.7692 10.5585 24.7445 10.6581L23.8989 13.9903C23.7549 14.554 24.3562 15.0112 24.8384 14.7043L27.776 12.8441C27.8584 12.7917 27.954 12.7639 28.0516 12.7639C28.1492 12.7639 28.2448 12.7917 28.3272 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M48.3624 12.8441L51.5191 14.8484C51.9263 15.1052 52.4273 14.7231 52.3083 14.2533L51.3939 10.6581C51.3691 10.5585 51.3731 10.4538 51.4052 10.3563C51.4374 10.2588 51.4964 10.1724 51.5755 10.1069L54.4066 7.7456C54.7761 7.43869 54.5882 6.8186 54.106 6.78728L50.4105 6.54927C50.3097 6.54341 50.2127 6.50829 50.1315 6.44823C50.0503 6.38816 49.9884 6.30575 49.9533 6.21105L48.5753 2.74108C48.5388 2.64081 48.4724 2.55418 48.385 2.49297C48.2976 2.43176 48.1935 2.39893 48.0868 2.39893C47.9801 2.39893 47.8759 2.43176 47.7885 2.49297C47.7011 2.55418 47.6347 2.64081 47.5982 2.74108L46.2202 6.21105C46.1851 6.30575 46.1232 6.38816 46.042 6.44823C45.9608 6.50829 45.8638 6.54341 45.763 6.54927L42.0676 6.78728C41.5853 6.8186 41.3974 7.43869 41.7669 7.7456L44.598 10.1069C44.6771 10.1724 44.7362 10.2588 44.7683 10.3563C44.8004 10.4538 44.8044 10.5585 44.7796 10.6581L43.9341 13.9903C43.79 14.554 44.3913 15.0112 44.8736 14.7043L47.8112 12.8441C47.8935 12.7917 47.9891 12.7639 48.0868 12.7639C48.1844 12.7639 48.28 12.7917 48.3624 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M68.3965 12.8441L71.5533 14.8484C71.9604 15.1052 72.4615 14.7231 72.3425 14.2533L71.4281 10.6581C71.4033 10.5585 71.4073 10.4538 71.4394 10.3563C71.4715 10.2588 71.5306 10.1724 71.6097 10.1069L74.4408 7.7456C74.8103 7.43869 74.6224 6.8186 74.1401 6.78728L70.4447 6.54927C70.3439 6.54341 70.2469 6.50829 70.1657 6.44823C70.0845 6.38816 70.0226 6.30575 69.9875 6.21105L68.6095 2.74108C68.573 2.64081 68.5066 2.55418 68.4192 2.49297C68.3318 2.43176 68.2276 2.39893 68.1209 2.39893C68.0142 2.39893 67.9101 2.43176 67.8227 2.49297C67.7353 2.55418 67.6689 2.64081 67.6324 2.74108L66.2544 6.21105C66.2193 6.30575 66.1574 6.38816 66.0762 6.44823C65.995 6.50829 65.898 6.54341 65.7972 6.54927L62.1017 6.78728C61.6195 6.8186 61.4316 7.43869 61.8011 7.7456L64.6322 10.1069C64.7113 10.1724 64.7704 10.2588 64.8025 10.3563C64.8346 10.4538 64.8386 10.5585 64.8138 10.6581L63.9683 13.9903C63.8242 14.554 64.4255 15.0112 64.9078 14.7043L67.8453 12.8441C67.9277 12.7917 68.0233 12.7639 68.1209 12.7639C68.2186 12.7639 68.3142 12.7917 68.3965 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M88.4307 12.8441L91.5875 14.8484C91.9946 15.1052 92.4957 14.7231 92.3767 14.2533L91.4622 10.6581C91.4375 10.5585 91.4414 10.4538 91.4736 10.3563C91.5057 10.2588 91.5647 10.1724 91.6439 10.1069L94.475 7.7456C94.8445 7.43869 94.6566 6.8186 94.1743 6.78728L90.4789 6.54927C90.378 6.54341 90.2811 6.50829 90.1999 6.44823C90.1187 6.38816 90.0568 6.30575 90.0216 6.21105L88.6437 2.74108C88.6072 2.64081 88.5407 2.55418 88.4533 2.49297C88.3659 2.43176 88.2618 2.39893 88.1551 2.39893C88.0484 2.39893 87.9443 2.43176 87.8569 2.49297C87.7695 2.55418 87.703 2.64081 87.6666 2.74108L86.2886 6.21105C86.2535 6.30575 86.1915 6.38816 86.1103 6.44823C86.0291 6.50829 85.9322 6.54341 85.8314 6.54927L82.1359 6.78728C81.6536 6.8186 81.4657 7.43869 81.8353 7.7456L84.6664 10.1069C84.7455 10.1724 84.8045 10.2588 84.8367 10.3563C84.8688 10.4538 84.8727 10.5585 84.848 10.6581L84.0024 13.9903C83.8584 14.554 84.4597 15.0112 84.942 14.7043L87.8795 12.8441C87.9619 12.7917 88.0575 12.7639 88.1551 12.7639C88.2527 12.7639 88.3483 12.7917 88.4307 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
    
                        </div>
                        <div class="course40-results-item-text">
                            <p>Ольга, здравствуйте! Прохожу курс по самооценке в Карьеруме, наконец-то работаю в
                                тройке-очень интересный опыт! Спасибо, что вы с командой создали такую крутую платформу.</p>
                        </div>
                    </div>
                    <div class="course40-results-item no-image-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726041211406-mZpvu-Mask.png"
                                    alt="">
                                <p>Анонимный отзыв</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="97" height="17" viewBox="0 0 97 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.29302 12.8441L11.4498 14.8484C11.8569 15.1052 12.358 14.7231 12.239 14.2533L11.3245 10.6581C11.2998 10.5585 11.3037 10.4538 11.3359 10.3563C11.368 10.2588 11.427 10.1724 11.5062 10.1069L14.3373 7.7456C14.7068 7.43869 14.5189 6.8186 14.0366 6.78728L10.3412 6.54927C10.2403 6.54341 10.1434 6.50829 10.0622 6.44823C9.981 6.38816 9.91906 6.30575 9.88394 6.21105L8.50598 2.74108C8.4695 2.64081 8.40305 2.55418 8.31565 2.49297C8.22825 2.43176 8.12413 2.39893 8.01743 2.39893C7.91072 2.39893 7.8066 2.43176 7.7192 2.49297C7.6318 2.55418 7.56535 2.64081 7.52887 2.74108L6.15091 6.21105C6.11579 6.30575 6.05385 6.38816 5.97265 6.44823C5.89145 6.50829 5.79451 6.54341 5.69368 6.54927L1.99823 6.78728C1.51594 6.8186 1.32804 7.43869 1.69758 7.7456L4.52867 10.1069C4.6078 10.1724 4.66684 10.2588 4.69897 10.3563C4.73111 10.4538 4.73504 10.5585 4.71031 10.6581L3.86474 13.9903C3.72068 14.554 4.32198 15.0112 4.80426 14.7043L7.74183 12.8441C7.82421 12.7917 7.91981 12.7639 8.01743 12.7639C8.11504 12.7639 8.21064 12.7917 8.29302 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M28.3272 12.8441L31.484 14.8484C31.8911 15.1052 32.3922 14.7231 32.2732 14.2533L31.3587 10.6581C31.334 10.5585 31.3379 10.4538 31.3701 10.3563C31.4022 10.2588 31.4612 10.1724 31.5404 10.1069L34.3714 7.7456C34.741 7.43869 34.5531 6.8186 34.0708 6.78728L30.3754 6.54927C30.2745 6.54341 30.1776 6.50829 30.0964 6.44823C30.0152 6.38816 29.9532 6.30575 29.9181 6.21105L28.5402 2.74108C28.5037 2.64081 28.4372 2.55418 28.3498 2.49297C28.2624 2.43176 28.1583 2.39893 28.0516 2.39893C27.9449 2.39893 27.8408 2.43176 27.7534 2.49297C27.666 2.55418 27.5995 2.64081 27.5631 2.74108L26.1851 6.21105C26.15 6.30575 26.088 6.38816 26.0068 6.44823C25.9256 6.50829 25.8287 6.54341 25.7279 6.54927L22.0324 6.78728C21.5501 6.8186 21.3622 7.43869 21.7318 7.7456L24.5629 10.1069C24.642 10.1724 24.701 10.2588 24.7332 10.3563C24.7653 10.4538 24.7692 10.5585 24.7445 10.6581L23.8989 13.9903C23.7549 14.554 24.3562 15.0112 24.8384 14.7043L27.776 12.8441C27.8584 12.7917 27.954 12.7639 28.0516 12.7639C28.1492 12.7639 28.2448 12.7917 28.3272 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M48.3624 12.8441L51.5191 14.8484C51.9263 15.1052 52.4273 14.7231 52.3083 14.2533L51.3939 10.6581C51.3691 10.5585 51.3731 10.4538 51.4052 10.3563C51.4374 10.2588 51.4964 10.1724 51.5755 10.1069L54.4066 7.7456C54.7761 7.43869 54.5882 6.8186 54.106 6.78728L50.4105 6.54927C50.3097 6.54341 50.2127 6.50829 50.1315 6.44823C50.0503 6.38816 49.9884 6.30575 49.9533 6.21105L48.5753 2.74108C48.5388 2.64081 48.4724 2.55418 48.385 2.49297C48.2976 2.43176 48.1935 2.39893 48.0868 2.39893C47.9801 2.39893 47.8759 2.43176 47.7885 2.49297C47.7011 2.55418 47.6347 2.64081 47.5982 2.74108L46.2202 6.21105C46.1851 6.30575 46.1232 6.38816 46.042 6.44823C45.9608 6.50829 45.8638 6.54341 45.763 6.54927L42.0676 6.78728C41.5853 6.8186 41.3974 7.43869 41.7669 7.7456L44.598 10.1069C44.6771 10.1724 44.7362 10.2588 44.7683 10.3563C44.8004 10.4538 44.8044 10.5585 44.7796 10.6581L43.9341 13.9903C43.79 14.554 44.3913 15.0112 44.8736 14.7043L47.8112 12.8441C47.8935 12.7917 47.9891 12.7639 48.0868 12.7639C48.1844 12.7639 48.28 12.7917 48.3624 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M68.3965 12.8441L71.5533 14.8484C71.9604 15.1052 72.4615 14.7231 72.3425 14.2533L71.4281 10.6581C71.4033 10.5585 71.4073 10.4538 71.4394 10.3563C71.4715 10.2588 71.5306 10.1724 71.6097 10.1069L74.4408 7.7456C74.8103 7.43869 74.6224 6.8186 74.1401 6.78728L70.4447 6.54927C70.3439 6.54341 70.2469 6.50829 70.1657 6.44823C70.0845 6.38816 70.0226 6.30575 69.9875 6.21105L68.6095 2.74108C68.573 2.64081 68.5066 2.55418 68.4192 2.49297C68.3318 2.43176 68.2276 2.39893 68.1209 2.39893C68.0142 2.39893 67.9101 2.43176 67.8227 2.49297C67.7353 2.55418 67.6689 2.64081 67.6324 2.74108L66.2544 6.21105C66.2193 6.30575 66.1574 6.38816 66.0762 6.44823C65.995 6.50829 65.898 6.54341 65.7972 6.54927L62.1017 6.78728C61.6195 6.8186 61.4316 7.43869 61.8011 7.7456L64.6322 10.1069C64.7113 10.1724 64.7704 10.2588 64.8025 10.3563C64.8346 10.4538 64.8386 10.5585 64.8138 10.6581L63.9683 13.9903C63.8242 14.554 64.4255 15.0112 64.9078 14.7043L67.8453 12.8441C67.9277 12.7917 68.0233 12.7639 68.1209 12.7639C68.2186 12.7639 68.3142 12.7917 68.3965 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M88.4307 12.8441L91.5875 14.8484C91.9946 15.1052 92.4957 14.7231 92.3767 14.2533L91.4622 10.6581C91.4375 10.5585 91.4414 10.4538 91.4736 10.3563C91.5057 10.2588 91.5647 10.1724 91.6439 10.1069L94.475 7.7456C94.8445 7.43869 94.6566 6.8186 94.1743 6.78728L90.4789 6.54927C90.378 6.54341 90.2811 6.50829 90.1999 6.44823C90.1187 6.38816 90.0568 6.30575 90.0216 6.21105L88.6437 2.74108C88.6072 2.64081 88.5407 2.55418 88.4533 2.49297C88.3659 2.43176 88.2618 2.39893 88.1551 2.39893C88.0484 2.39893 87.9443 2.43176 87.8569 2.49297C87.7695 2.55418 87.703 2.64081 87.6666 2.74108L86.2886 6.21105C86.2535 6.30575 86.1915 6.38816 86.1103 6.44823C86.0291 6.50829 85.9322 6.54341 85.8314 6.54927L82.1359 6.78728C81.6536 6.8186 81.4657 7.43869 81.8353 7.7456L84.6664 10.1069C84.7455 10.1724 84.8045 10.2588 84.8367 10.3563C84.8688 10.4538 84.8727 10.5585 84.848 10.6581L84.0024 13.9903C83.8584 14.554 84.4597 15.0112 84.942 14.7043L87.8795 12.8441C87.9619 12.7917 88.0575 12.7639 88.1551 12.7639C88.2527 12.7639 88.3483 12.7917 88.4307 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
    
                        </div>
                        <div class="course40-results-item-text">
                            <p>С помощью Карьерума уже праздную годовщину на работе-вызове в хорошем смысле слова! Самое
                                крутое, что навык осознанности распространяется и на все остальные сферы жизни!</p>
                        </div>
                    </div>
                    <div class="course40-results-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726041134760-xloV5-Mask.png"
                                    alt="">
                                <p>Elvira Melentyeva</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="97" height="17" viewBox="0 0 97 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.29302 12.8441L11.4498 14.8484C11.8569 15.1052 12.358 14.7231 12.239 14.2533L11.3245 10.6581C11.2998 10.5585 11.3037 10.4538 11.3359 10.3563C11.368 10.2588 11.427 10.1724 11.5062 10.1069L14.3373 7.7456C14.7068 7.43869 14.5189 6.8186 14.0366 6.78728L10.3412 6.54927C10.2403 6.54341 10.1434 6.50829 10.0622 6.44823C9.981 6.38816 9.91906 6.30575 9.88394 6.21105L8.50598 2.74108C8.4695 2.64081 8.40305 2.55418 8.31565 2.49297C8.22825 2.43176 8.12413 2.39893 8.01743 2.39893C7.91072 2.39893 7.8066 2.43176 7.7192 2.49297C7.6318 2.55418 7.56535 2.64081 7.52887 2.74108L6.15091 6.21105C6.11579 6.30575 6.05385 6.38816 5.97265 6.44823C5.89145 6.50829 5.79451 6.54341 5.69368 6.54927L1.99823 6.78728C1.51594 6.8186 1.32804 7.43869 1.69758 7.7456L4.52867 10.1069C4.6078 10.1724 4.66684 10.2588 4.69897 10.3563C4.73111 10.4538 4.73504 10.5585 4.71031 10.6581L3.86474 13.9903C3.72068 14.554 4.32198 15.0112 4.80426 14.7043L7.74183 12.8441C7.82421 12.7917 7.91981 12.7639 8.01743 12.7639C8.11504 12.7639 8.21064 12.7917 8.29302 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M28.3272 12.8441L31.484 14.8484C31.8911 15.1052 32.3922 14.7231 32.2732 14.2533L31.3587 10.6581C31.334 10.5585 31.3379 10.4538 31.3701 10.3563C31.4022 10.2588 31.4612 10.1724 31.5404 10.1069L34.3714 7.7456C34.741 7.43869 34.5531 6.8186 34.0708 6.78728L30.3754 6.54927C30.2745 6.54341 30.1776 6.50829 30.0964 6.44823C30.0152 6.38816 29.9532 6.30575 29.9181 6.21105L28.5402 2.74108C28.5037 2.64081 28.4372 2.55418 28.3498 2.49297C28.2624 2.43176 28.1583 2.39893 28.0516 2.39893C27.9449 2.39893 27.8408 2.43176 27.7534 2.49297C27.666 2.55418 27.5995 2.64081 27.5631 2.74108L26.1851 6.21105C26.15 6.30575 26.088 6.38816 26.0068 6.44823C25.9256 6.50829 25.8287 6.54341 25.7279 6.54927L22.0324 6.78728C21.5501 6.8186 21.3622 7.43869 21.7318 7.7456L24.5629 10.1069C24.642 10.1724 24.701 10.2588 24.7332 10.3563C24.7653 10.4538 24.7692 10.5585 24.7445 10.6581L23.8989 13.9903C23.7549 14.554 24.3562 15.0112 24.8384 14.7043L27.776 12.8441C27.8584 12.7917 27.954 12.7639 28.0516 12.7639C28.1492 12.7639 28.2448 12.7917 28.3272 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M48.3624 12.8441L51.5191 14.8484C51.9263 15.1052 52.4273 14.7231 52.3083 14.2533L51.3939 10.6581C51.3691 10.5585 51.3731 10.4538 51.4052 10.3563C51.4374 10.2588 51.4964 10.1724 51.5755 10.1069L54.4066 7.7456C54.7761 7.43869 54.5882 6.8186 54.106 6.78728L50.4105 6.54927C50.3097 6.54341 50.2127 6.50829 50.1315 6.44823C50.0503 6.38816 49.9884 6.30575 49.9533 6.21105L48.5753 2.74108C48.5388 2.64081 48.4724 2.55418 48.385 2.49297C48.2976 2.43176 48.1935 2.39893 48.0868 2.39893C47.9801 2.39893 47.8759 2.43176 47.7885 2.49297C47.7011 2.55418 47.6347 2.64081 47.5982 2.74108L46.2202 6.21105C46.1851 6.30575 46.1232 6.38816 46.042 6.44823C45.9608 6.50829 45.8638 6.54341 45.763 6.54927L42.0676 6.78728C41.5853 6.8186 41.3974 7.43869 41.7669 7.7456L44.598 10.1069C44.6771 10.1724 44.7362 10.2588 44.7683 10.3563C44.8004 10.4538 44.8044 10.5585 44.7796 10.6581L43.9341 13.9903C43.79 14.554 44.3913 15.0112 44.8736 14.7043L47.8112 12.8441C47.8935 12.7917 47.9891 12.7639 48.0868 12.7639C48.1844 12.7639 48.28 12.7917 48.3624 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M68.3965 12.8441L71.5533 14.8484C71.9604 15.1052 72.4615 14.7231 72.3425 14.2533L71.4281 10.6581C71.4033 10.5585 71.4073 10.4538 71.4394 10.3563C71.4715 10.2588 71.5306 10.1724 71.6097 10.1069L74.4408 7.7456C74.8103 7.43869 74.6224 6.8186 74.1401 6.78728L70.4447 6.54927C70.3439 6.54341 70.2469 6.50829 70.1657 6.44823C70.0845 6.38816 70.0226 6.30575 69.9875 6.21105L68.6095 2.74108C68.573 2.64081 68.5066 2.55418 68.4192 2.49297C68.3318 2.43176 68.2276 2.39893 68.1209 2.39893C68.0142 2.39893 67.9101 2.43176 67.8227 2.49297C67.7353 2.55418 67.6689 2.64081 67.6324 2.74108L66.2544 6.21105C66.2193 6.30575 66.1574 6.38816 66.0762 6.44823C65.995 6.50829 65.898 6.54341 65.7972 6.54927L62.1017 6.78728C61.6195 6.8186 61.4316 7.43869 61.8011 7.7456L64.6322 10.1069C64.7113 10.1724 64.7704 10.2588 64.8025 10.3563C64.8346 10.4538 64.8386 10.5585 64.8138 10.6581L63.9683 13.9903C63.8242 14.554 64.4255 15.0112 64.9078 14.7043L67.8453 12.8441C67.9277 12.7917 68.0233 12.7639 68.1209 12.7639C68.2186 12.7639 68.3142 12.7917 68.3965 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M88.4307 12.8441L91.5875 14.8484C91.9946 15.1052 92.4957 14.7231 92.3767 14.2533L91.4622 10.6581C91.4375 10.5585 91.4414 10.4538 91.4736 10.3563C91.5057 10.2588 91.5647 10.1724 91.6439 10.1069L94.475 7.7456C94.8445 7.43869 94.6566 6.8186 94.1743 6.78728L90.4789 6.54927C90.378 6.54341 90.2811 6.50829 90.1999 6.44823C90.1187 6.38816 90.0568 6.30575 90.0216 6.21105L88.6437 2.74108C88.6072 2.64081 88.5407 2.55418 88.4533 2.49297C88.3659 2.43176 88.2618 2.39893 88.1551 2.39893C88.0484 2.39893 87.9443 2.43176 87.8569 2.49297C87.7695 2.55418 87.703 2.64081 87.6666 2.74108L86.2886 6.21105C86.2535 6.30575 86.1915 6.38816 86.1103 6.44823C86.0291 6.50829 85.9322 6.54341 85.8314 6.54927L82.1359 6.78728C81.6536 6.8186 81.4657 7.43869 81.8353 7.7456L84.6664 10.1069C84.7455 10.1724 84.8045 10.2588 84.8367 10.3563C84.8688 10.4538 84.8727 10.5585 84.848 10.6581L84.0024 13.9903C83.8584 14.554 84.4597 15.0112 84.942 14.7043L87.8795 12.8441C87.9619 12.7917 88.0575 12.7639 88.1551 12.7639C88.2527 12.7639 88.3483 12.7917 88.4307 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
    
                        </div>
                        <div class="course40-results-item-text">
                            <p>My last career crisis was solved with Careerum's help. Now I see career as something that is
                                forming and changing all the time. With good planning it is easier to avoid a crisis moment.
                                Forever grateful!
                            </p>
                        </div>
                    </div>
                    <div class="course40-results-item no-image-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726041211406-mZpvu-Mask.png"
                                    alt="">
                                <p>Милана Александрова</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="97" height="17" viewBox="0 0 97 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.29302 12.8441L11.4498 14.8484C11.8569 15.1052 12.358 14.7231 12.239 14.2533L11.3245 10.6581C11.2998 10.5585 11.3037 10.4538 11.3359 10.3563C11.368 10.2588 11.427 10.1724 11.5062 10.1069L14.3373 7.7456C14.7068 7.43869 14.5189 6.8186 14.0366 6.78728L10.3412 6.54927C10.2403 6.54341 10.1434 6.50829 10.0622 6.44823C9.981 6.38816 9.91906 6.30575 9.88394 6.21105L8.50598 2.74108C8.4695 2.64081 8.40305 2.55418 8.31565 2.49297C8.22825 2.43176 8.12413 2.39893 8.01743 2.39893C7.91072 2.39893 7.8066 2.43176 7.7192 2.49297C7.6318 2.55418 7.56535 2.64081 7.52887 2.74108L6.15091 6.21105C6.11579 6.30575 6.05385 6.38816 5.97265 6.44823C5.89145 6.50829 5.79451 6.54341 5.69368 6.54927L1.99823 6.78728C1.51594 6.8186 1.32804 7.43869 1.69758 7.7456L4.52867 10.1069C4.6078 10.1724 4.66684 10.2588 4.69897 10.3563C4.73111 10.4538 4.73504 10.5585 4.71031 10.6581L3.86474 13.9903C3.72068 14.554 4.32198 15.0112 4.80426 14.7043L7.74183 12.8441C7.82421 12.7917 7.91981 12.7639 8.01743 12.7639C8.11504 12.7639 8.21064 12.7917 8.29302 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M28.3272 12.8441L31.484 14.8484C31.8911 15.1052 32.3922 14.7231 32.2732 14.2533L31.3587 10.6581C31.334 10.5585 31.3379 10.4538 31.3701 10.3563C31.4022 10.2588 31.4612 10.1724 31.5404 10.1069L34.3714 7.7456C34.741 7.43869 34.5531 6.8186 34.0708 6.78728L30.3754 6.54927C30.2745 6.54341 30.1776 6.50829 30.0964 6.44823C30.0152 6.38816 29.9532 6.30575 29.9181 6.21105L28.5402 2.74108C28.5037 2.64081 28.4372 2.55418 28.3498 2.49297C28.2624 2.43176 28.1583 2.39893 28.0516 2.39893C27.9449 2.39893 27.8408 2.43176 27.7534 2.49297C27.666 2.55418 27.5995 2.64081 27.5631 2.74108L26.1851 6.21105C26.15 6.30575 26.088 6.38816 26.0068 6.44823C25.9256 6.50829 25.8287 6.54341 25.7279 6.54927L22.0324 6.78728C21.5501 6.8186 21.3622 7.43869 21.7318 7.7456L24.5629 10.1069C24.642 10.1724 24.701 10.2588 24.7332 10.3563C24.7653 10.4538 24.7692 10.5585 24.7445 10.6581L23.8989 13.9903C23.7549 14.554 24.3562 15.0112 24.8384 14.7043L27.776 12.8441C27.8584 12.7917 27.954 12.7639 28.0516 12.7639C28.1492 12.7639 28.2448 12.7917 28.3272 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M48.3624 12.8441L51.5191 14.8484C51.9263 15.1052 52.4273 14.7231 52.3083 14.2533L51.3939 10.6581C51.3691 10.5585 51.3731 10.4538 51.4052 10.3563C51.4374 10.2588 51.4964 10.1724 51.5755 10.1069L54.4066 7.7456C54.7761 7.43869 54.5882 6.8186 54.106 6.78728L50.4105 6.54927C50.3097 6.54341 50.2127 6.50829 50.1315 6.44823C50.0503 6.38816 49.9884 6.30575 49.9533 6.21105L48.5753 2.74108C48.5388 2.64081 48.4724 2.55418 48.385 2.49297C48.2976 2.43176 48.1935 2.39893 48.0868 2.39893C47.9801 2.39893 47.8759 2.43176 47.7885 2.49297C47.7011 2.55418 47.6347 2.64081 47.5982 2.74108L46.2202 6.21105C46.1851 6.30575 46.1232 6.38816 46.042 6.44823C45.9608 6.50829 45.8638 6.54341 45.763 6.54927L42.0676 6.78728C41.5853 6.8186 41.3974 7.43869 41.7669 7.7456L44.598 10.1069C44.6771 10.1724 44.7362 10.2588 44.7683 10.3563C44.8004 10.4538 44.8044 10.5585 44.7796 10.6581L43.9341 13.9903C43.79 14.554 44.3913 15.0112 44.8736 14.7043L47.8112 12.8441C47.8935 12.7917 47.9891 12.7639 48.0868 12.7639C48.1844 12.7639 48.28 12.7917 48.3624 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M68.3965 12.8441L71.5533 14.8484C71.9604 15.1052 72.4615 14.7231 72.3425 14.2533L71.4281 10.6581C71.4033 10.5585 71.4073 10.4538 71.4394 10.3563C71.4715 10.2588 71.5306 10.1724 71.6097 10.1069L74.4408 7.7456C74.8103 7.43869 74.6224 6.8186 74.1401 6.78728L70.4447 6.54927C70.3439 6.54341 70.2469 6.50829 70.1657 6.44823C70.0845 6.38816 70.0226 6.30575 69.9875 6.21105L68.6095 2.74108C68.573 2.64081 68.5066 2.55418 68.4192 2.49297C68.3318 2.43176 68.2276 2.39893 68.1209 2.39893C68.0142 2.39893 67.9101 2.43176 67.8227 2.49297C67.7353 2.55418 67.6689 2.64081 67.6324 2.74108L66.2544 6.21105C66.2193 6.30575 66.1574 6.38816 66.0762 6.44823C65.995 6.50829 65.898 6.54341 65.7972 6.54927L62.1017 6.78728C61.6195 6.8186 61.4316 7.43869 61.8011 7.7456L64.6322 10.1069C64.7113 10.1724 64.7704 10.2588 64.8025 10.3563C64.8346 10.4538 64.8386 10.5585 64.8138 10.6581L63.9683 13.9903C63.8242 14.554 64.4255 15.0112 64.9078 14.7043L67.8453 12.8441C67.9277 12.7917 68.0233 12.7639 68.1209 12.7639C68.2186 12.7639 68.3142 12.7917 68.3965 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M88.4307 12.8441L91.5875 14.8484C91.9946 15.1052 92.4957 14.7231 92.3767 14.2533L91.4622 10.6581C91.4375 10.5585 91.4414 10.4538 91.4736 10.3563C91.5057 10.2588 91.5647 10.1724 91.6439 10.1069L94.475 7.7456C94.8445 7.43869 94.6566 6.8186 94.1743 6.78728L90.4789 6.54927C90.378 6.54341 90.2811 6.50829 90.1999 6.44823C90.1187 6.38816 90.0568 6.30575 90.0216 6.21105L88.6437 2.74108C88.6072 2.64081 88.5407 2.55418 88.4533 2.49297C88.3659 2.43176 88.2618 2.39893 88.1551 2.39893C88.0484 2.39893 87.9443 2.43176 87.8569 2.49297C87.7695 2.55418 87.703 2.64081 87.6666 2.74108L86.2886 6.21105C86.2535 6.30575 86.1915 6.38816 86.1103 6.44823C86.0291 6.50829 85.9322 6.54341 85.8314 6.54927L82.1359 6.78728C81.6536 6.8186 81.4657 7.43869 81.8353 7.7456L84.6664 10.1069C84.7455 10.1724 84.8045 10.2588 84.8367 10.3563C84.8688 10.4538 84.8727 10.5585 84.848 10.6581L84.0024 13.9903C83.8584 14.554 84.4597 15.0112 84.942 14.7043L87.8795 12.8441C87.9619 12.7917 88.0575 12.7639 88.1551 12.7639C88.2527 12.7639 88.3483 12.7917 88.4307 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
    
                        </div>
                        <div class="course40-results-item-text">
                            <p>Вижу, как влияют наша с вами работа, спорт и корректные фокусировки влияют на нужный
                                результат. Поняла, что поработала 3 года практически без отпусков. Даже деньги не тратила,
                                потому что было некогда. Хочу потратить и вложиться в ремонт и свое продвижение.
                                Материальные изменения способствуют ментальным и душевным трансформациям. Большое вам
                                спасибо за терпение, внимание и поддержку!</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-course40-results-mobile', {
        label: 'Course 4 results (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-course40-results-mobile">
            <div class="careerum-container-mobile">
                <h2>Результаты наших клиентов</h2>
                <div class="course40-results-items results-items-slider">
                    <div class="course40-results-item no-image-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726041211406-mZpvu-Mask.png"
                                    alt="">
                                <p>Елена Фролова</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="97" height="17" viewBox="0 0 97 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.29302 12.8441L11.4498 14.8484C11.8569 15.1052 12.358 14.7231 12.239 14.2533L11.3245 10.6581C11.2998 10.5585 11.3037 10.4538 11.3359 10.3563C11.368 10.2588 11.427 10.1724 11.5062 10.1069L14.3373 7.7456C14.7068 7.43869 14.5189 6.8186 14.0366 6.78728L10.3412 6.54927C10.2403 6.54341 10.1434 6.50829 10.0622 6.44823C9.981 6.38816 9.91906 6.30575 9.88394 6.21105L8.50598 2.74108C8.4695 2.64081 8.40305 2.55418 8.31565 2.49297C8.22825 2.43176 8.12413 2.39893 8.01743 2.39893C7.91072 2.39893 7.8066 2.43176 7.7192 2.49297C7.6318 2.55418 7.56535 2.64081 7.52887 2.74108L6.15091 6.21105C6.11579 6.30575 6.05385 6.38816 5.97265 6.44823C5.89145 6.50829 5.79451 6.54341 5.69368 6.54927L1.99823 6.78728C1.51594 6.8186 1.32804 7.43869 1.69758 7.7456L4.52867 10.1069C4.6078 10.1724 4.66684 10.2588 4.69897 10.3563C4.73111 10.4538 4.73504 10.5585 4.71031 10.6581L3.86474 13.9903C3.72068 14.554 4.32198 15.0112 4.80426 14.7043L7.74183 12.8441C7.82421 12.7917 7.91981 12.7639 8.01743 12.7639C8.11504 12.7639 8.21064 12.7917 8.29302 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M28.3272 12.8441L31.484 14.8484C31.8911 15.1052 32.3922 14.7231 32.2732 14.2533L31.3587 10.6581C31.334 10.5585 31.3379 10.4538 31.3701 10.3563C31.4022 10.2588 31.4612 10.1724 31.5404 10.1069L34.3714 7.7456C34.741 7.43869 34.5531 6.8186 34.0708 6.78728L30.3754 6.54927C30.2745 6.54341 30.1776 6.50829 30.0964 6.44823C30.0152 6.38816 29.9532 6.30575 29.9181 6.21105L28.5402 2.74108C28.5037 2.64081 28.4372 2.55418 28.3498 2.49297C28.2624 2.43176 28.1583 2.39893 28.0516 2.39893C27.9449 2.39893 27.8408 2.43176 27.7534 2.49297C27.666 2.55418 27.5995 2.64081 27.5631 2.74108L26.1851 6.21105C26.15 6.30575 26.088 6.38816 26.0068 6.44823C25.9256 6.50829 25.8287 6.54341 25.7279 6.54927L22.0324 6.78728C21.5501 6.8186 21.3622 7.43869 21.7318 7.7456L24.5629 10.1069C24.642 10.1724 24.701 10.2588 24.7332 10.3563C24.7653 10.4538 24.7692 10.5585 24.7445 10.6581L23.8989 13.9903C23.7549 14.554 24.3562 15.0112 24.8384 14.7043L27.776 12.8441C27.8584 12.7917 27.954 12.7639 28.0516 12.7639C28.1492 12.7639 28.2448 12.7917 28.3272 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M48.3624 12.8441L51.5191 14.8484C51.9263 15.1052 52.4273 14.7231 52.3083 14.2533L51.3939 10.6581C51.3691 10.5585 51.3731 10.4538 51.4052 10.3563C51.4374 10.2588 51.4964 10.1724 51.5755 10.1069L54.4066 7.7456C54.7761 7.43869 54.5882 6.8186 54.106 6.78728L50.4105 6.54927C50.3097 6.54341 50.2127 6.50829 50.1315 6.44823C50.0503 6.38816 49.9884 6.30575 49.9533 6.21105L48.5753 2.74108C48.5388 2.64081 48.4724 2.55418 48.385 2.49297C48.2976 2.43176 48.1935 2.39893 48.0868 2.39893C47.9801 2.39893 47.8759 2.43176 47.7885 2.49297C47.7011 2.55418 47.6347 2.64081 47.5982 2.74108L46.2202 6.21105C46.1851 6.30575 46.1232 6.38816 46.042 6.44823C45.9608 6.50829 45.8638 6.54341 45.763 6.54927L42.0676 6.78728C41.5853 6.8186 41.3974 7.43869 41.7669 7.7456L44.598 10.1069C44.6771 10.1724 44.7362 10.2588 44.7683 10.3563C44.8004 10.4538 44.8044 10.5585 44.7796 10.6581L43.9341 13.9903C43.79 14.554 44.3913 15.0112 44.8736 14.7043L47.8112 12.8441C47.8935 12.7917 47.9891 12.7639 48.0868 12.7639C48.1844 12.7639 48.28 12.7917 48.3624 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M68.3965 12.8441L71.5533 14.8484C71.9604 15.1052 72.4615 14.7231 72.3425 14.2533L71.4281 10.6581C71.4033 10.5585 71.4073 10.4538 71.4394 10.3563C71.4715 10.2588 71.5306 10.1724 71.6097 10.1069L74.4408 7.7456C74.8103 7.43869 74.6224 6.8186 74.1401 6.78728L70.4447 6.54927C70.3439 6.54341 70.2469 6.50829 70.1657 6.44823C70.0845 6.38816 70.0226 6.30575 69.9875 6.21105L68.6095 2.74108C68.573 2.64081 68.5066 2.55418 68.4192 2.49297C68.3318 2.43176 68.2276 2.39893 68.1209 2.39893C68.0142 2.39893 67.9101 2.43176 67.8227 2.49297C67.7353 2.55418 67.6689 2.64081 67.6324 2.74108L66.2544 6.21105C66.2193 6.30575 66.1574 6.38816 66.0762 6.44823C65.995 6.50829 65.898 6.54341 65.7972 6.54927L62.1017 6.78728C61.6195 6.8186 61.4316 7.43869 61.8011 7.7456L64.6322 10.1069C64.7113 10.1724 64.7704 10.2588 64.8025 10.3563C64.8346 10.4538 64.8386 10.5585 64.8138 10.6581L63.9683 13.9903C63.8242 14.554 64.4255 15.0112 64.9078 14.7043L67.8453 12.8441C67.9277 12.7917 68.0233 12.7639 68.1209 12.7639C68.2186 12.7639 68.3142 12.7917 68.3965 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M88.4307 12.8441L91.5875 14.8484C91.9946 15.1052 92.4957 14.7231 92.3767 14.2533L91.4622 10.6581C91.4375 10.5585 91.4414 10.4538 91.4736 10.3563C91.5057 10.2588 91.5647 10.1724 91.6439 10.1069L94.475 7.7456C94.8445 7.43869 94.6566 6.8186 94.1743 6.78728L90.4789 6.54927C90.378 6.54341 90.2811 6.50829 90.1999 6.44823C90.1187 6.38816 90.0568 6.30575 90.0216 6.21105L88.6437 2.74108C88.6072 2.64081 88.5407 2.55418 88.4533 2.49297C88.3659 2.43176 88.2618 2.39893 88.1551 2.39893C88.0484 2.39893 87.9443 2.43176 87.8569 2.49297C87.7695 2.55418 87.703 2.64081 87.6666 2.74108L86.2886 6.21105C86.2535 6.30575 86.1915 6.38816 86.1103 6.44823C86.0291 6.50829 85.9322 6.54341 85.8314 6.54927L82.1359 6.78728C81.6536 6.8186 81.4657 7.43869 81.8353 7.7456L84.6664 10.1069C84.7455 10.1724 84.8045 10.2588 84.8367 10.3563C84.8688 10.4538 84.8727 10.5585 84.848 10.6581L84.0024 13.9903C83.8584 14.554 84.4597 15.0112 84.942 14.7043L87.8795 12.8441C87.9619 12.7917 88.0575 12.7639 88.1551 12.7639C88.2527 12.7639 88.3483 12.7917 88.4307 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
    
                        </div>
                        <div class="course40-results-item-text">
                            <p>Добрый день! Я очень благодарна Ольге и Карьеруму за мега полезные материалы, позитивную
                                атмосферу, общение, поддержку коучей. Решила сделать перерыв и направить энергию на новый
                                рабочий функционал, который выбрала как раз в Карьерум. Большое спасибо!!!</p>
                        </div>
                    </div>
                    <div class="course40-results-item no-image-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726041211406-mZpvu-Mask.png"
                                    alt="">
                                <p>Анонимный отзыв</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="97" height="17" viewBox="0 0 97 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.29302 12.8441L11.4498 14.8484C11.8569 15.1052 12.358 14.7231 12.239 14.2533L11.3245 10.6581C11.2998 10.5585 11.3037 10.4538 11.3359 10.3563C11.368 10.2588 11.427 10.1724 11.5062 10.1069L14.3373 7.7456C14.7068 7.43869 14.5189 6.8186 14.0366 6.78728L10.3412 6.54927C10.2403 6.54341 10.1434 6.50829 10.0622 6.44823C9.981 6.38816 9.91906 6.30575 9.88394 6.21105L8.50598 2.74108C8.4695 2.64081 8.40305 2.55418 8.31565 2.49297C8.22825 2.43176 8.12413 2.39893 8.01743 2.39893C7.91072 2.39893 7.8066 2.43176 7.7192 2.49297C7.6318 2.55418 7.56535 2.64081 7.52887 2.74108L6.15091 6.21105C6.11579 6.30575 6.05385 6.38816 5.97265 6.44823C5.89145 6.50829 5.79451 6.54341 5.69368 6.54927L1.99823 6.78728C1.51594 6.8186 1.32804 7.43869 1.69758 7.7456L4.52867 10.1069C4.6078 10.1724 4.66684 10.2588 4.69897 10.3563C4.73111 10.4538 4.73504 10.5585 4.71031 10.6581L3.86474 13.9903C3.72068 14.554 4.32198 15.0112 4.80426 14.7043L7.74183 12.8441C7.82421 12.7917 7.91981 12.7639 8.01743 12.7639C8.11504 12.7639 8.21064 12.7917 8.29302 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M28.3272 12.8441L31.484 14.8484C31.8911 15.1052 32.3922 14.7231 32.2732 14.2533L31.3587 10.6581C31.334 10.5585 31.3379 10.4538 31.3701 10.3563C31.4022 10.2588 31.4612 10.1724 31.5404 10.1069L34.3714 7.7456C34.741 7.43869 34.5531 6.8186 34.0708 6.78728L30.3754 6.54927C30.2745 6.54341 30.1776 6.50829 30.0964 6.44823C30.0152 6.38816 29.9532 6.30575 29.9181 6.21105L28.5402 2.74108C28.5037 2.64081 28.4372 2.55418 28.3498 2.49297C28.2624 2.43176 28.1583 2.39893 28.0516 2.39893C27.9449 2.39893 27.8408 2.43176 27.7534 2.49297C27.666 2.55418 27.5995 2.64081 27.5631 2.74108L26.1851 6.21105C26.15 6.30575 26.088 6.38816 26.0068 6.44823C25.9256 6.50829 25.8287 6.54341 25.7279 6.54927L22.0324 6.78728C21.5501 6.8186 21.3622 7.43869 21.7318 7.7456L24.5629 10.1069C24.642 10.1724 24.701 10.2588 24.7332 10.3563C24.7653 10.4538 24.7692 10.5585 24.7445 10.6581L23.8989 13.9903C23.7549 14.554 24.3562 15.0112 24.8384 14.7043L27.776 12.8441C27.8584 12.7917 27.954 12.7639 28.0516 12.7639C28.1492 12.7639 28.2448 12.7917 28.3272 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M48.3624 12.8441L51.5191 14.8484C51.9263 15.1052 52.4273 14.7231 52.3083 14.2533L51.3939 10.6581C51.3691 10.5585 51.3731 10.4538 51.4052 10.3563C51.4374 10.2588 51.4964 10.1724 51.5755 10.1069L54.4066 7.7456C54.7761 7.43869 54.5882 6.8186 54.106 6.78728L50.4105 6.54927C50.3097 6.54341 50.2127 6.50829 50.1315 6.44823C50.0503 6.38816 49.9884 6.30575 49.9533 6.21105L48.5753 2.74108C48.5388 2.64081 48.4724 2.55418 48.385 2.49297C48.2976 2.43176 48.1935 2.39893 48.0868 2.39893C47.9801 2.39893 47.8759 2.43176 47.7885 2.49297C47.7011 2.55418 47.6347 2.64081 47.5982 2.74108L46.2202 6.21105C46.1851 6.30575 46.1232 6.38816 46.042 6.44823C45.9608 6.50829 45.8638 6.54341 45.763 6.54927L42.0676 6.78728C41.5853 6.8186 41.3974 7.43869 41.7669 7.7456L44.598 10.1069C44.6771 10.1724 44.7362 10.2588 44.7683 10.3563C44.8004 10.4538 44.8044 10.5585 44.7796 10.6581L43.9341 13.9903C43.79 14.554 44.3913 15.0112 44.8736 14.7043L47.8112 12.8441C47.8935 12.7917 47.9891 12.7639 48.0868 12.7639C48.1844 12.7639 48.28 12.7917 48.3624 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M68.3965 12.8441L71.5533 14.8484C71.9604 15.1052 72.4615 14.7231 72.3425 14.2533L71.4281 10.6581C71.4033 10.5585 71.4073 10.4538 71.4394 10.3563C71.4715 10.2588 71.5306 10.1724 71.6097 10.1069L74.4408 7.7456C74.8103 7.43869 74.6224 6.8186 74.1401 6.78728L70.4447 6.54927C70.3439 6.54341 70.2469 6.50829 70.1657 6.44823C70.0845 6.38816 70.0226 6.30575 69.9875 6.21105L68.6095 2.74108C68.573 2.64081 68.5066 2.55418 68.4192 2.49297C68.3318 2.43176 68.2276 2.39893 68.1209 2.39893C68.0142 2.39893 67.9101 2.43176 67.8227 2.49297C67.7353 2.55418 67.6689 2.64081 67.6324 2.74108L66.2544 6.21105C66.2193 6.30575 66.1574 6.38816 66.0762 6.44823C65.995 6.50829 65.898 6.54341 65.7972 6.54927L62.1017 6.78728C61.6195 6.8186 61.4316 7.43869 61.8011 7.7456L64.6322 10.1069C64.7113 10.1724 64.7704 10.2588 64.8025 10.3563C64.8346 10.4538 64.8386 10.5585 64.8138 10.6581L63.9683 13.9903C63.8242 14.554 64.4255 15.0112 64.9078 14.7043L67.8453 12.8441C67.9277 12.7917 68.0233 12.7639 68.1209 12.7639C68.2186 12.7639 68.3142 12.7917 68.3965 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M88.4307 12.8441L91.5875 14.8484C91.9946 15.1052 92.4957 14.7231 92.3767 14.2533L91.4622 10.6581C91.4375 10.5585 91.4414 10.4538 91.4736 10.3563C91.5057 10.2588 91.5647 10.1724 91.6439 10.1069L94.475 7.7456C94.8445 7.43869 94.6566 6.8186 94.1743 6.78728L90.4789 6.54927C90.378 6.54341 90.2811 6.50829 90.1999 6.44823C90.1187 6.38816 90.0568 6.30575 90.0216 6.21105L88.6437 2.74108C88.6072 2.64081 88.5407 2.55418 88.4533 2.49297C88.3659 2.43176 88.2618 2.39893 88.1551 2.39893C88.0484 2.39893 87.9443 2.43176 87.8569 2.49297C87.7695 2.55418 87.703 2.64081 87.6666 2.74108L86.2886 6.21105C86.2535 6.30575 86.1915 6.38816 86.1103 6.44823C86.0291 6.50829 85.9322 6.54341 85.8314 6.54927L82.1359 6.78728C81.6536 6.8186 81.4657 7.43869 81.8353 7.7456L84.6664 10.1069C84.7455 10.1724 84.8045 10.2588 84.8367 10.3563C84.8688 10.4538 84.8727 10.5585 84.848 10.6581L84.0024 13.9903C83.8584 14.554 84.4597 15.0112 84.942 14.7043L87.8795 12.8441C87.9619 12.7917 88.0575 12.7639 88.1551 12.7639C88.2527 12.7639 88.3483 12.7917 88.4307 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
    
                        </div>
                        <div class="course40-results-item-text">
                            <p>Мне очень понравилось участвовать в Мастермаинде, во встречах посредством Coffee Buddy.
                                Познакомилась с интересными людьми, посмотрела на себя со стороны, отметив свои сильные
                                стороны и над чем надо поработать, узнала мнение о себе других незнакомых ранее людей,
                                пообщалась с экспертом.</p>
                        </div>
                    </div>
                    <div class="course40-results-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726040618214-Dzugu-Mask.png"
                                    alt="">
                                <p>Наталья Макеева</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="97" height="17" viewBox="0 0 97 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.29302 12.8441L11.4498 14.8484C11.8569 15.1052 12.358 14.7231 12.239 14.2533L11.3245 10.6581C11.2998 10.5585 11.3037 10.4538 11.3359 10.3563C11.368 10.2588 11.427 10.1724 11.5062 10.1069L14.3373 7.7456C14.7068 7.43869 14.5189 6.8186 14.0366 6.78728L10.3412 6.54927C10.2403 6.54341 10.1434 6.50829 10.0622 6.44823C9.981 6.38816 9.91906 6.30575 9.88394 6.21105L8.50598 2.74108C8.4695 2.64081 8.40305 2.55418 8.31565 2.49297C8.22825 2.43176 8.12413 2.39893 8.01743 2.39893C7.91072 2.39893 7.8066 2.43176 7.7192 2.49297C7.6318 2.55418 7.56535 2.64081 7.52887 2.74108L6.15091 6.21105C6.11579 6.30575 6.05385 6.38816 5.97265 6.44823C5.89145 6.50829 5.79451 6.54341 5.69368 6.54927L1.99823 6.78728C1.51594 6.8186 1.32804 7.43869 1.69758 7.7456L4.52867 10.1069C4.6078 10.1724 4.66684 10.2588 4.69897 10.3563C4.73111 10.4538 4.73504 10.5585 4.71031 10.6581L3.86474 13.9903C3.72068 14.554 4.32198 15.0112 4.80426 14.7043L7.74183 12.8441C7.82421 12.7917 7.91981 12.7639 8.01743 12.7639C8.11504 12.7639 8.21064 12.7917 8.29302 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M28.3272 12.8441L31.484 14.8484C31.8911 15.1052 32.3922 14.7231 32.2732 14.2533L31.3587 10.6581C31.334 10.5585 31.3379 10.4538 31.3701 10.3563C31.4022 10.2588 31.4612 10.1724 31.5404 10.1069L34.3714 7.7456C34.741 7.43869 34.5531 6.8186 34.0708 6.78728L30.3754 6.54927C30.2745 6.54341 30.1776 6.50829 30.0964 6.44823C30.0152 6.38816 29.9532 6.30575 29.9181 6.21105L28.5402 2.74108C28.5037 2.64081 28.4372 2.55418 28.3498 2.49297C28.2624 2.43176 28.1583 2.39893 28.0516 2.39893C27.9449 2.39893 27.8408 2.43176 27.7534 2.49297C27.666 2.55418 27.5995 2.64081 27.5631 2.74108L26.1851 6.21105C26.15 6.30575 26.088 6.38816 26.0068 6.44823C25.9256 6.50829 25.8287 6.54341 25.7279 6.54927L22.0324 6.78728C21.5501 6.8186 21.3622 7.43869 21.7318 7.7456L24.5629 10.1069C24.642 10.1724 24.701 10.2588 24.7332 10.3563C24.7653 10.4538 24.7692 10.5585 24.7445 10.6581L23.8989 13.9903C23.7549 14.554 24.3562 15.0112 24.8384 14.7043L27.776 12.8441C27.8584 12.7917 27.954 12.7639 28.0516 12.7639C28.1492 12.7639 28.2448 12.7917 28.3272 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M48.3624 12.8441L51.5191 14.8484C51.9263 15.1052 52.4273 14.7231 52.3083 14.2533L51.3939 10.6581C51.3691 10.5585 51.3731 10.4538 51.4052 10.3563C51.4374 10.2588 51.4964 10.1724 51.5755 10.1069L54.4066 7.7456C54.7761 7.43869 54.5882 6.8186 54.106 6.78728L50.4105 6.54927C50.3097 6.54341 50.2127 6.50829 50.1315 6.44823C50.0503 6.38816 49.9884 6.30575 49.9533 6.21105L48.5753 2.74108C48.5388 2.64081 48.4724 2.55418 48.385 2.49297C48.2976 2.43176 48.1935 2.39893 48.0868 2.39893C47.9801 2.39893 47.8759 2.43176 47.7885 2.49297C47.7011 2.55418 47.6347 2.64081 47.5982 2.74108L46.2202 6.21105C46.1851 6.30575 46.1232 6.38816 46.042 6.44823C45.9608 6.50829 45.8638 6.54341 45.763 6.54927L42.0676 6.78728C41.5853 6.8186 41.3974 7.43869 41.7669 7.7456L44.598 10.1069C44.6771 10.1724 44.7362 10.2588 44.7683 10.3563C44.8004 10.4538 44.8044 10.5585 44.7796 10.6581L43.9341 13.9903C43.79 14.554 44.3913 15.0112 44.8736 14.7043L47.8112 12.8441C47.8935 12.7917 47.9891 12.7639 48.0868 12.7639C48.1844 12.7639 48.28 12.7917 48.3624 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M68.3965 12.8441L71.5533 14.8484C71.9604 15.1052 72.4615 14.7231 72.3425 14.2533L71.4281 10.6581C71.4033 10.5585 71.4073 10.4538 71.4394 10.3563C71.4715 10.2588 71.5306 10.1724 71.6097 10.1069L74.4408 7.7456C74.8103 7.43869 74.6224 6.8186 74.1401 6.78728L70.4447 6.54927C70.3439 6.54341 70.2469 6.50829 70.1657 6.44823C70.0845 6.38816 70.0226 6.30575 69.9875 6.21105L68.6095 2.74108C68.573 2.64081 68.5066 2.55418 68.4192 2.49297C68.3318 2.43176 68.2276 2.39893 68.1209 2.39893C68.0142 2.39893 67.9101 2.43176 67.8227 2.49297C67.7353 2.55418 67.6689 2.64081 67.6324 2.74108L66.2544 6.21105C66.2193 6.30575 66.1574 6.38816 66.0762 6.44823C65.995 6.50829 65.898 6.54341 65.7972 6.54927L62.1017 6.78728C61.6195 6.8186 61.4316 7.43869 61.8011 7.7456L64.6322 10.1069C64.7113 10.1724 64.7704 10.2588 64.8025 10.3563C64.8346 10.4538 64.8386 10.5585 64.8138 10.6581L63.9683 13.9903C63.8242 14.554 64.4255 15.0112 64.9078 14.7043L67.8453 12.8441C67.9277 12.7917 68.0233 12.7639 68.1209 12.7639C68.2186 12.7639 68.3142 12.7917 68.3965 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M88.4307 12.8441L91.5875 14.8484C91.9946 15.1052 92.4957 14.7231 92.3767 14.2533L91.4622 10.6581C91.4375 10.5585 91.4414 10.4538 91.4736 10.3563C91.5057 10.2588 91.5647 10.1724 91.6439 10.1069L94.475 7.7456C94.8445 7.43869 94.6566 6.8186 94.1743 6.78728L90.4789 6.54927C90.378 6.54341 90.2811 6.50829 90.1999 6.44823C90.1187 6.38816 90.0568 6.30575 90.0216 6.21105L88.6437 2.74108C88.6072 2.64081 88.5407 2.55418 88.4533 2.49297C88.3659 2.43176 88.2618 2.39893 88.1551 2.39893C88.0484 2.39893 87.9443 2.43176 87.8569 2.49297C87.7695 2.55418 87.703 2.64081 87.6666 2.74108L86.2886 6.21105C86.2535 6.30575 86.1915 6.38816 86.1103 6.44823C86.0291 6.50829 85.9322 6.54341 85.8314 6.54927L82.1359 6.78728C81.6536 6.8186 81.4657 7.43869 81.8353 7.7456L84.6664 10.1069C84.7455 10.1724 84.8045 10.2588 84.8367 10.3563C84.8688 10.4538 84.8727 10.5585 84.848 10.6581L84.0024 13.9903C83.8584 14.554 84.4597 15.0112 84.942 14.7043L87.8795 12.8441C87.9619 12.7917 88.0575 12.7639 88.1551 12.7639C88.2527 12.7639 88.3483 12.7917 88.4307 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
    
                        </div>
                        <div class="course40-results-item-text">
                            <p>Ольга, здравствуйте! Прохожу курс по самооценке в Карьеруме, наконец-то работаю в
                                тройке-очень интересный опыт! Спасибо, что вы с командой создали такую крутую платформу.</p>
                        </div>
                    </div>
                    <div class="course40-results-item no-image-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726041211406-mZpvu-Mask.png"
                                    alt="">
                                <p>Анонимный отзыв</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="97" height="17" viewBox="0 0 97 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.29302 12.8441L11.4498 14.8484C11.8569 15.1052 12.358 14.7231 12.239 14.2533L11.3245 10.6581C11.2998 10.5585 11.3037 10.4538 11.3359 10.3563C11.368 10.2588 11.427 10.1724 11.5062 10.1069L14.3373 7.7456C14.7068 7.43869 14.5189 6.8186 14.0366 6.78728L10.3412 6.54927C10.2403 6.54341 10.1434 6.50829 10.0622 6.44823C9.981 6.38816 9.91906 6.30575 9.88394 6.21105L8.50598 2.74108C8.4695 2.64081 8.40305 2.55418 8.31565 2.49297C8.22825 2.43176 8.12413 2.39893 8.01743 2.39893C7.91072 2.39893 7.8066 2.43176 7.7192 2.49297C7.6318 2.55418 7.56535 2.64081 7.52887 2.74108L6.15091 6.21105C6.11579 6.30575 6.05385 6.38816 5.97265 6.44823C5.89145 6.50829 5.79451 6.54341 5.69368 6.54927L1.99823 6.78728C1.51594 6.8186 1.32804 7.43869 1.69758 7.7456L4.52867 10.1069C4.6078 10.1724 4.66684 10.2588 4.69897 10.3563C4.73111 10.4538 4.73504 10.5585 4.71031 10.6581L3.86474 13.9903C3.72068 14.554 4.32198 15.0112 4.80426 14.7043L7.74183 12.8441C7.82421 12.7917 7.91981 12.7639 8.01743 12.7639C8.11504 12.7639 8.21064 12.7917 8.29302 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M28.3272 12.8441L31.484 14.8484C31.8911 15.1052 32.3922 14.7231 32.2732 14.2533L31.3587 10.6581C31.334 10.5585 31.3379 10.4538 31.3701 10.3563C31.4022 10.2588 31.4612 10.1724 31.5404 10.1069L34.3714 7.7456C34.741 7.43869 34.5531 6.8186 34.0708 6.78728L30.3754 6.54927C30.2745 6.54341 30.1776 6.50829 30.0964 6.44823C30.0152 6.38816 29.9532 6.30575 29.9181 6.21105L28.5402 2.74108C28.5037 2.64081 28.4372 2.55418 28.3498 2.49297C28.2624 2.43176 28.1583 2.39893 28.0516 2.39893C27.9449 2.39893 27.8408 2.43176 27.7534 2.49297C27.666 2.55418 27.5995 2.64081 27.5631 2.74108L26.1851 6.21105C26.15 6.30575 26.088 6.38816 26.0068 6.44823C25.9256 6.50829 25.8287 6.54341 25.7279 6.54927L22.0324 6.78728C21.5501 6.8186 21.3622 7.43869 21.7318 7.7456L24.5629 10.1069C24.642 10.1724 24.701 10.2588 24.7332 10.3563C24.7653 10.4538 24.7692 10.5585 24.7445 10.6581L23.8989 13.9903C23.7549 14.554 24.3562 15.0112 24.8384 14.7043L27.776 12.8441C27.8584 12.7917 27.954 12.7639 28.0516 12.7639C28.1492 12.7639 28.2448 12.7917 28.3272 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M48.3624 12.8441L51.5191 14.8484C51.9263 15.1052 52.4273 14.7231 52.3083 14.2533L51.3939 10.6581C51.3691 10.5585 51.3731 10.4538 51.4052 10.3563C51.4374 10.2588 51.4964 10.1724 51.5755 10.1069L54.4066 7.7456C54.7761 7.43869 54.5882 6.8186 54.106 6.78728L50.4105 6.54927C50.3097 6.54341 50.2127 6.50829 50.1315 6.44823C50.0503 6.38816 49.9884 6.30575 49.9533 6.21105L48.5753 2.74108C48.5388 2.64081 48.4724 2.55418 48.385 2.49297C48.2976 2.43176 48.1935 2.39893 48.0868 2.39893C47.9801 2.39893 47.8759 2.43176 47.7885 2.49297C47.7011 2.55418 47.6347 2.64081 47.5982 2.74108L46.2202 6.21105C46.1851 6.30575 46.1232 6.38816 46.042 6.44823C45.9608 6.50829 45.8638 6.54341 45.763 6.54927L42.0676 6.78728C41.5853 6.8186 41.3974 7.43869 41.7669 7.7456L44.598 10.1069C44.6771 10.1724 44.7362 10.2588 44.7683 10.3563C44.8004 10.4538 44.8044 10.5585 44.7796 10.6581L43.9341 13.9903C43.79 14.554 44.3913 15.0112 44.8736 14.7043L47.8112 12.8441C47.8935 12.7917 47.9891 12.7639 48.0868 12.7639C48.1844 12.7639 48.28 12.7917 48.3624 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M68.3965 12.8441L71.5533 14.8484C71.9604 15.1052 72.4615 14.7231 72.3425 14.2533L71.4281 10.6581C71.4033 10.5585 71.4073 10.4538 71.4394 10.3563C71.4715 10.2588 71.5306 10.1724 71.6097 10.1069L74.4408 7.7456C74.8103 7.43869 74.6224 6.8186 74.1401 6.78728L70.4447 6.54927C70.3439 6.54341 70.2469 6.50829 70.1657 6.44823C70.0845 6.38816 70.0226 6.30575 69.9875 6.21105L68.6095 2.74108C68.573 2.64081 68.5066 2.55418 68.4192 2.49297C68.3318 2.43176 68.2276 2.39893 68.1209 2.39893C68.0142 2.39893 67.9101 2.43176 67.8227 2.49297C67.7353 2.55418 67.6689 2.64081 67.6324 2.74108L66.2544 6.21105C66.2193 6.30575 66.1574 6.38816 66.0762 6.44823C65.995 6.50829 65.898 6.54341 65.7972 6.54927L62.1017 6.78728C61.6195 6.8186 61.4316 7.43869 61.8011 7.7456L64.6322 10.1069C64.7113 10.1724 64.7704 10.2588 64.8025 10.3563C64.8346 10.4538 64.8386 10.5585 64.8138 10.6581L63.9683 13.9903C63.8242 14.554 64.4255 15.0112 64.9078 14.7043L67.8453 12.8441C67.9277 12.7917 68.0233 12.7639 68.1209 12.7639C68.2186 12.7639 68.3142 12.7917 68.3965 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M88.4307 12.8441L91.5875 14.8484C91.9946 15.1052 92.4957 14.7231 92.3767 14.2533L91.4622 10.6581C91.4375 10.5585 91.4414 10.4538 91.4736 10.3563C91.5057 10.2588 91.5647 10.1724 91.6439 10.1069L94.475 7.7456C94.8445 7.43869 94.6566 6.8186 94.1743 6.78728L90.4789 6.54927C90.378 6.54341 90.2811 6.50829 90.1999 6.44823C90.1187 6.38816 90.0568 6.30575 90.0216 6.21105L88.6437 2.74108C88.6072 2.64081 88.5407 2.55418 88.4533 2.49297C88.3659 2.43176 88.2618 2.39893 88.1551 2.39893C88.0484 2.39893 87.9443 2.43176 87.8569 2.49297C87.7695 2.55418 87.703 2.64081 87.6666 2.74108L86.2886 6.21105C86.2535 6.30575 86.1915 6.38816 86.1103 6.44823C86.0291 6.50829 85.9322 6.54341 85.8314 6.54927L82.1359 6.78728C81.6536 6.8186 81.4657 7.43869 81.8353 7.7456L84.6664 10.1069C84.7455 10.1724 84.8045 10.2588 84.8367 10.3563C84.8688 10.4538 84.8727 10.5585 84.848 10.6581L84.0024 13.9903C83.8584 14.554 84.4597 15.0112 84.942 14.7043L87.8795 12.8441C87.9619 12.7917 88.0575 12.7639 88.1551 12.7639C88.2527 12.7639 88.3483 12.7917 88.4307 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
    
                        </div>
                        <div class="course40-results-item-text">
                            <p>С помощью Карьерума уже праздную годовщину на работе-вызове в хорошем смысле слова! Самое
                                крутое, что навык осознанности распространяется и на все остальные сферы жизни!</p>
                        </div>
                    </div>
                    <div class="course40-results-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726041134760-xloV5-Mask.png"
                                    alt="">
                                <p>Elvira Melentyeva</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="97" height="17" viewBox="0 0 97 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.29302 12.8441L11.4498 14.8484C11.8569 15.1052 12.358 14.7231 12.239 14.2533L11.3245 10.6581C11.2998 10.5585 11.3037 10.4538 11.3359 10.3563C11.368 10.2588 11.427 10.1724 11.5062 10.1069L14.3373 7.7456C14.7068 7.43869 14.5189 6.8186 14.0366 6.78728L10.3412 6.54927C10.2403 6.54341 10.1434 6.50829 10.0622 6.44823C9.981 6.38816 9.91906 6.30575 9.88394 6.21105L8.50598 2.74108C8.4695 2.64081 8.40305 2.55418 8.31565 2.49297C8.22825 2.43176 8.12413 2.39893 8.01743 2.39893C7.91072 2.39893 7.8066 2.43176 7.7192 2.49297C7.6318 2.55418 7.56535 2.64081 7.52887 2.74108L6.15091 6.21105C6.11579 6.30575 6.05385 6.38816 5.97265 6.44823C5.89145 6.50829 5.79451 6.54341 5.69368 6.54927L1.99823 6.78728C1.51594 6.8186 1.32804 7.43869 1.69758 7.7456L4.52867 10.1069C4.6078 10.1724 4.66684 10.2588 4.69897 10.3563C4.73111 10.4538 4.73504 10.5585 4.71031 10.6581L3.86474 13.9903C3.72068 14.554 4.32198 15.0112 4.80426 14.7043L7.74183 12.8441C7.82421 12.7917 7.91981 12.7639 8.01743 12.7639C8.11504 12.7639 8.21064 12.7917 8.29302 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M28.3272 12.8441L31.484 14.8484C31.8911 15.1052 32.3922 14.7231 32.2732 14.2533L31.3587 10.6581C31.334 10.5585 31.3379 10.4538 31.3701 10.3563C31.4022 10.2588 31.4612 10.1724 31.5404 10.1069L34.3714 7.7456C34.741 7.43869 34.5531 6.8186 34.0708 6.78728L30.3754 6.54927C30.2745 6.54341 30.1776 6.50829 30.0964 6.44823C30.0152 6.38816 29.9532 6.30575 29.9181 6.21105L28.5402 2.74108C28.5037 2.64081 28.4372 2.55418 28.3498 2.49297C28.2624 2.43176 28.1583 2.39893 28.0516 2.39893C27.9449 2.39893 27.8408 2.43176 27.7534 2.49297C27.666 2.55418 27.5995 2.64081 27.5631 2.74108L26.1851 6.21105C26.15 6.30575 26.088 6.38816 26.0068 6.44823C25.9256 6.50829 25.8287 6.54341 25.7279 6.54927L22.0324 6.78728C21.5501 6.8186 21.3622 7.43869 21.7318 7.7456L24.5629 10.1069C24.642 10.1724 24.701 10.2588 24.7332 10.3563C24.7653 10.4538 24.7692 10.5585 24.7445 10.6581L23.8989 13.9903C23.7549 14.554 24.3562 15.0112 24.8384 14.7043L27.776 12.8441C27.8584 12.7917 27.954 12.7639 28.0516 12.7639C28.1492 12.7639 28.2448 12.7917 28.3272 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M48.3624 12.8441L51.5191 14.8484C51.9263 15.1052 52.4273 14.7231 52.3083 14.2533L51.3939 10.6581C51.3691 10.5585 51.3731 10.4538 51.4052 10.3563C51.4374 10.2588 51.4964 10.1724 51.5755 10.1069L54.4066 7.7456C54.7761 7.43869 54.5882 6.8186 54.106 6.78728L50.4105 6.54927C50.3097 6.54341 50.2127 6.50829 50.1315 6.44823C50.0503 6.38816 49.9884 6.30575 49.9533 6.21105L48.5753 2.74108C48.5388 2.64081 48.4724 2.55418 48.385 2.49297C48.2976 2.43176 48.1935 2.39893 48.0868 2.39893C47.9801 2.39893 47.8759 2.43176 47.7885 2.49297C47.7011 2.55418 47.6347 2.64081 47.5982 2.74108L46.2202 6.21105C46.1851 6.30575 46.1232 6.38816 46.042 6.44823C45.9608 6.50829 45.8638 6.54341 45.763 6.54927L42.0676 6.78728C41.5853 6.8186 41.3974 7.43869 41.7669 7.7456L44.598 10.1069C44.6771 10.1724 44.7362 10.2588 44.7683 10.3563C44.8004 10.4538 44.8044 10.5585 44.7796 10.6581L43.9341 13.9903C43.79 14.554 44.3913 15.0112 44.8736 14.7043L47.8112 12.8441C47.8935 12.7917 47.9891 12.7639 48.0868 12.7639C48.1844 12.7639 48.28 12.7917 48.3624 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M68.3965 12.8441L71.5533 14.8484C71.9604 15.1052 72.4615 14.7231 72.3425 14.2533L71.4281 10.6581C71.4033 10.5585 71.4073 10.4538 71.4394 10.3563C71.4715 10.2588 71.5306 10.1724 71.6097 10.1069L74.4408 7.7456C74.8103 7.43869 74.6224 6.8186 74.1401 6.78728L70.4447 6.54927C70.3439 6.54341 70.2469 6.50829 70.1657 6.44823C70.0845 6.38816 70.0226 6.30575 69.9875 6.21105L68.6095 2.74108C68.573 2.64081 68.5066 2.55418 68.4192 2.49297C68.3318 2.43176 68.2276 2.39893 68.1209 2.39893C68.0142 2.39893 67.9101 2.43176 67.8227 2.49297C67.7353 2.55418 67.6689 2.64081 67.6324 2.74108L66.2544 6.21105C66.2193 6.30575 66.1574 6.38816 66.0762 6.44823C65.995 6.50829 65.898 6.54341 65.7972 6.54927L62.1017 6.78728C61.6195 6.8186 61.4316 7.43869 61.8011 7.7456L64.6322 10.1069C64.7113 10.1724 64.7704 10.2588 64.8025 10.3563C64.8346 10.4538 64.8386 10.5585 64.8138 10.6581L63.9683 13.9903C63.8242 14.554 64.4255 15.0112 64.9078 14.7043L67.8453 12.8441C67.9277 12.7917 68.0233 12.7639 68.1209 12.7639C68.2186 12.7639 68.3142 12.7917 68.3965 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M88.4307 12.8441L91.5875 14.8484C91.9946 15.1052 92.4957 14.7231 92.3767 14.2533L91.4622 10.6581C91.4375 10.5585 91.4414 10.4538 91.4736 10.3563C91.5057 10.2588 91.5647 10.1724 91.6439 10.1069L94.475 7.7456C94.8445 7.43869 94.6566 6.8186 94.1743 6.78728L90.4789 6.54927C90.378 6.54341 90.2811 6.50829 90.1999 6.44823C90.1187 6.38816 90.0568 6.30575 90.0216 6.21105L88.6437 2.74108C88.6072 2.64081 88.5407 2.55418 88.4533 2.49297C88.3659 2.43176 88.2618 2.39893 88.1551 2.39893C88.0484 2.39893 87.9443 2.43176 87.8569 2.49297C87.7695 2.55418 87.703 2.64081 87.6666 2.74108L86.2886 6.21105C86.2535 6.30575 86.1915 6.38816 86.1103 6.44823C86.0291 6.50829 85.9322 6.54341 85.8314 6.54927L82.1359 6.78728C81.6536 6.8186 81.4657 7.43869 81.8353 7.7456L84.6664 10.1069C84.7455 10.1724 84.8045 10.2588 84.8367 10.3563C84.8688 10.4538 84.8727 10.5585 84.848 10.6581L84.0024 13.9903C83.8584 14.554 84.4597 15.0112 84.942 14.7043L87.8795 12.8441C87.9619 12.7917 88.0575 12.7639 88.1551 12.7639C88.2527 12.7639 88.3483 12.7917 88.4307 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
    
                        </div>
                        <div class="course40-results-item-text">
                            <p>My last career crisis was solved with Careerum's help. Now I see career as something that is
                                forming and changing all the time. With good planning it is easier to avoid a crisis moment.
                                Forever grateful!
                            </p>
                        </div>
                    </div>
                    <div class="course40-results-item no-image-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726041211406-mZpvu-Mask.png"
                                    alt="">
                                <p>Милана Александрова</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="97" height="17" viewBox="0 0 97 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.29302 12.8441L11.4498 14.8484C11.8569 15.1052 12.358 14.7231 12.239 14.2533L11.3245 10.6581C11.2998 10.5585 11.3037 10.4538 11.3359 10.3563C11.368 10.2588 11.427 10.1724 11.5062 10.1069L14.3373 7.7456C14.7068 7.43869 14.5189 6.8186 14.0366 6.78728L10.3412 6.54927C10.2403 6.54341 10.1434 6.50829 10.0622 6.44823C9.981 6.38816 9.91906 6.30575 9.88394 6.21105L8.50598 2.74108C8.4695 2.64081 8.40305 2.55418 8.31565 2.49297C8.22825 2.43176 8.12413 2.39893 8.01743 2.39893C7.91072 2.39893 7.8066 2.43176 7.7192 2.49297C7.6318 2.55418 7.56535 2.64081 7.52887 2.74108L6.15091 6.21105C6.11579 6.30575 6.05385 6.38816 5.97265 6.44823C5.89145 6.50829 5.79451 6.54341 5.69368 6.54927L1.99823 6.78728C1.51594 6.8186 1.32804 7.43869 1.69758 7.7456L4.52867 10.1069C4.6078 10.1724 4.66684 10.2588 4.69897 10.3563C4.73111 10.4538 4.73504 10.5585 4.71031 10.6581L3.86474 13.9903C3.72068 14.554 4.32198 15.0112 4.80426 14.7043L7.74183 12.8441C7.82421 12.7917 7.91981 12.7639 8.01743 12.7639C8.11504 12.7639 8.21064 12.7917 8.29302 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M28.3272 12.8441L31.484 14.8484C31.8911 15.1052 32.3922 14.7231 32.2732 14.2533L31.3587 10.6581C31.334 10.5585 31.3379 10.4538 31.3701 10.3563C31.4022 10.2588 31.4612 10.1724 31.5404 10.1069L34.3714 7.7456C34.741 7.43869 34.5531 6.8186 34.0708 6.78728L30.3754 6.54927C30.2745 6.54341 30.1776 6.50829 30.0964 6.44823C30.0152 6.38816 29.9532 6.30575 29.9181 6.21105L28.5402 2.74108C28.5037 2.64081 28.4372 2.55418 28.3498 2.49297C28.2624 2.43176 28.1583 2.39893 28.0516 2.39893C27.9449 2.39893 27.8408 2.43176 27.7534 2.49297C27.666 2.55418 27.5995 2.64081 27.5631 2.74108L26.1851 6.21105C26.15 6.30575 26.088 6.38816 26.0068 6.44823C25.9256 6.50829 25.8287 6.54341 25.7279 6.54927L22.0324 6.78728C21.5501 6.8186 21.3622 7.43869 21.7318 7.7456L24.5629 10.1069C24.642 10.1724 24.701 10.2588 24.7332 10.3563C24.7653 10.4538 24.7692 10.5585 24.7445 10.6581L23.8989 13.9903C23.7549 14.554 24.3562 15.0112 24.8384 14.7043L27.776 12.8441C27.8584 12.7917 27.954 12.7639 28.0516 12.7639C28.1492 12.7639 28.2448 12.7917 28.3272 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M48.3624 12.8441L51.5191 14.8484C51.9263 15.1052 52.4273 14.7231 52.3083 14.2533L51.3939 10.6581C51.3691 10.5585 51.3731 10.4538 51.4052 10.3563C51.4374 10.2588 51.4964 10.1724 51.5755 10.1069L54.4066 7.7456C54.7761 7.43869 54.5882 6.8186 54.106 6.78728L50.4105 6.54927C50.3097 6.54341 50.2127 6.50829 50.1315 6.44823C50.0503 6.38816 49.9884 6.30575 49.9533 6.21105L48.5753 2.74108C48.5388 2.64081 48.4724 2.55418 48.385 2.49297C48.2976 2.43176 48.1935 2.39893 48.0868 2.39893C47.9801 2.39893 47.8759 2.43176 47.7885 2.49297C47.7011 2.55418 47.6347 2.64081 47.5982 2.74108L46.2202 6.21105C46.1851 6.30575 46.1232 6.38816 46.042 6.44823C45.9608 6.50829 45.8638 6.54341 45.763 6.54927L42.0676 6.78728C41.5853 6.8186 41.3974 7.43869 41.7669 7.7456L44.598 10.1069C44.6771 10.1724 44.7362 10.2588 44.7683 10.3563C44.8004 10.4538 44.8044 10.5585 44.7796 10.6581L43.9341 13.9903C43.79 14.554 44.3913 15.0112 44.8736 14.7043L47.8112 12.8441C47.8935 12.7917 47.9891 12.7639 48.0868 12.7639C48.1844 12.7639 48.28 12.7917 48.3624 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M68.3965 12.8441L71.5533 14.8484C71.9604 15.1052 72.4615 14.7231 72.3425 14.2533L71.4281 10.6581C71.4033 10.5585 71.4073 10.4538 71.4394 10.3563C71.4715 10.2588 71.5306 10.1724 71.6097 10.1069L74.4408 7.7456C74.8103 7.43869 74.6224 6.8186 74.1401 6.78728L70.4447 6.54927C70.3439 6.54341 70.2469 6.50829 70.1657 6.44823C70.0845 6.38816 70.0226 6.30575 69.9875 6.21105L68.6095 2.74108C68.573 2.64081 68.5066 2.55418 68.4192 2.49297C68.3318 2.43176 68.2276 2.39893 68.1209 2.39893C68.0142 2.39893 67.9101 2.43176 67.8227 2.49297C67.7353 2.55418 67.6689 2.64081 67.6324 2.74108L66.2544 6.21105C66.2193 6.30575 66.1574 6.38816 66.0762 6.44823C65.995 6.50829 65.898 6.54341 65.7972 6.54927L62.1017 6.78728C61.6195 6.8186 61.4316 7.43869 61.8011 7.7456L64.6322 10.1069C64.7113 10.1724 64.7704 10.2588 64.8025 10.3563C64.8346 10.4538 64.8386 10.5585 64.8138 10.6581L63.9683 13.9903C63.8242 14.554 64.4255 15.0112 64.9078 14.7043L67.8453 12.8441C67.9277 12.7917 68.0233 12.7639 68.1209 12.7639C68.2186 12.7639 68.3142 12.7917 68.3965 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M88.4307 12.8441L91.5875 14.8484C91.9946 15.1052 92.4957 14.7231 92.3767 14.2533L91.4622 10.6581C91.4375 10.5585 91.4414 10.4538 91.4736 10.3563C91.5057 10.2588 91.5647 10.1724 91.6439 10.1069L94.475 7.7456C94.8445 7.43869 94.6566 6.8186 94.1743 6.78728L90.4789 6.54927C90.378 6.54341 90.2811 6.50829 90.1999 6.44823C90.1187 6.38816 90.0568 6.30575 90.0216 6.21105L88.6437 2.74108C88.6072 2.64081 88.5407 2.55418 88.4533 2.49297C88.3659 2.43176 88.2618 2.39893 88.1551 2.39893C88.0484 2.39893 87.9443 2.43176 87.8569 2.49297C87.7695 2.55418 87.703 2.64081 87.6666 2.74108L86.2886 6.21105C86.2535 6.30575 86.1915 6.38816 86.1103 6.44823C86.0291 6.50829 85.9322 6.54341 85.8314 6.54927L82.1359 6.78728C81.6536 6.8186 81.4657 7.43869 81.8353 7.7456L84.6664 10.1069C84.7455 10.1724 84.8045 10.2588 84.8367 10.3563C84.8688 10.4538 84.8727 10.5585 84.848 10.6581L84.0024 13.9903C83.8584 14.554 84.4597 15.0112 84.942 14.7043L87.8795 12.8441C87.9619 12.7917 88.0575 12.7639 88.1551 12.7639C88.2527 12.7639 88.3483 12.7917 88.4307 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
    
                        </div>
                        <div class="course40-results-item-text">
                            <p>Вижу, как влияют наша с вами работа, спорт и корректные фокусировки влияют на нужный
                                результат. Поняла, что поработала 3 года практически без отпусков. Даже деньги не тратила,
                                потому что было некогда. Хочу потратить и вложиться в ремонт и свое продвижение.
                                Материальные изменения способствуют ментальным и душевным трансформациям. Большое вам
                                спасибо за терпение, внимание и поддержку!</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-course40-banner1', {
        label: 'Course 4 banner1',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-course40-banner1" data-redirect="no" data-url="" data-static="yes" data-offset=""
            data-timer-end="09/13/2024 23:59 GMT+0300">
            <div class="careerum-container-desc careerum-flex-cc">
                <div class="careerum-flex-cc">
                    <p>Курс стартует через</p>
                    <div>
                        <div class="course40-banner1-timer careerum-flex-cc">
                            <div>
                                <p class="timer-day-number">00</p>
                                <p class="timer-day-text">дней</p>
                            </div>
                            <div>
                                <p class="timer-hour-number">00</p>
                                <p class="timer-hour-text">часов</p>
                            </div>
                            <div>
                                <p class="timer-min-number">00</p>
                                <p class="timer-min-text">минут</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <a href="#buy" class="btn-color-main-black">Лист ожидания</a>
                </div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726063588942-SwGhf-ÑÐ¾.svg" alt="">
            </div>
        </div>`
    });

    blockManager.add('careerum-course40-results-banner1', {
        label: 'Course 4 banner1 (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-course40-banner1-tablet" data-redirect="no" data-url="" data-static="yes" data-offset=""
            data-timer-end="09/13/2024 23:59 GMT+0300">
            <div class="careerum-container-tablet careerum-flex-sbc">
                <div class="careerum-flex-sbc">
                    <p>Курс стартует через</p>
                    <div>
                        <div class="course40-banner1-timer careerum-flex-cc">
                            <div>
                                <p class="timer-day-number">00</p>
                                <p class="timer-day-text">дней</p>
                            </div>
                            <div>
                                <p class="timer-hour-number">00</p>
                                <p class="timer-hour-text">часов</p>
                            </div>
                            <div>
                                <p class="timer-min-number">00</p>
                                <p class="timer-min-text">минут</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <a href="#buy" class="btn-color-main-black">Лист ожидания</a>
                </div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726063310723-kdnwW-ÑÐ¾.svg" alt="">
            </div>
        </div>`
    });

    blockManager.add('careerum-course40-banner1-mobile', {
        label: 'Course 4 banner1 (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-course40-banner1-mobile" data-redirect="no" data-url="" data-static="yes" data-offset=""
            data-timer-end="09/13/2024 23:59 GMT+0300">
            <div class="careerum-container-mobile">
                <div class="careerum-flex-sbc">
                    <p>Курс стартует через</p>
                    <div>
                        <div class="course40-banner1-timer careerum-flex-cc">
                            <div>
                                <p class="timer-day-number">00</p>
                                <p class="timer-day-text">дней</p>
                            </div>
                            <div>
                                <p class="timer-hour-number">00</p>
                                <p class="timer-hour-text">часов</p>
                            </div>
                            <div>
                                <p class="timer-min-number">00</p>
                                <p class="timer-min-text">минут</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <a href="#buy" class="btn-color-main-black">Лист ожидания</a>
                </div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726063310723-kdnwW-ÑÐ¾.svg" alt="">
            </div>
        </div>`
    });

    blockManager.add('careerum-course40-tariffs', {
        label: 'Course 4 tariffs',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-course40-tariffs">
            <div class="careerum-container-desc">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726043257012-W5UXY-Rect.png" alt="">
                <h2 class="careerum-club40-header">Условия участия</h2>
                <p>У курса не будет открытых продаж. Добавляйтесь в лист ожидания,<br> чтобы попасть на него и получить
                    доступ по лучшей цене</p>
                <div class="careerum-flex-cc course40-tariffs-curr-wrapper">
                    <div class="course40-tariffs-curr careerum-flex-fsst">
                        <ul class="careerum-flex-fsfs">
                            <li data-currency="eur" class="">EUR</li>
                            <li data-currency="rub" class="active">RUB</li>
                        </ul>
                        <div class="course40-tariffs-notif careerum-flex-cc">
                            <div class="course40-tariffs-notif-icon"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                    alt=""></div>
                            <div class="course40-tariffs-notif-content">
                                <p>Оплата в российских рублях возможна только картой российского банка. В&nbsp;евро — картой
                                    зарубежного банка</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="course40-tariffs-items careerum-flex-cst" data-price-rub="">
                    <div class="course40-tariffs-item careerum-flex-fsfs" data-price-rub="65 000 ₽" data-price-eur="650 €">
                        <p class="course40-tariffs-item-header">Базовый</p>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726043794907-HbEAM-Chec.svg"
                                    alt="">
                                <p>Доступ к живым эфирам с Ольгой Лермонтовой</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726043794907-HbEAM-Chec.svg"
                                    alt="">
                                <p>Работа в чате с куратором</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726043794907-HbEAM-Chec.svg"
                                    alt="">
                                <p>Работа в паре с buddy, с которым вы будете прорабатывать свои результаты</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726043794907-HbEAM-Chec.svg"
                                    alt="">
                                <p>2 практические сессии, чтобы глубже разобрать важные для вас вопросы</p>
                            </li>
                        </ul>
                        <div>
                            <p class="course40-tariffs-item-price">65 000 ₽</p>
                            <a href="#" class="btn-color-main-black">Лист ожидания </a>
                        </div>
                    </div>
                    <div class="course40-tariffs-item careerum-flex-fsfs" data-price-rub="150 000 ₽"
                        data-price-eur="1 500 €">
                        <p class="course40-tariffs-item-label">Всего: 20 мест</p>
                        <p class="course40-tariffs-item-header">Индивидуальная работа с Ольгой Лермонтовой</p>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726043818982-MWYlb-Fram.svg"
                                    alt="">
                                <p><span>2 мастермайнда в группе из 10 человек с Ольгой Лермонтовой, на которых будут
                                        проработаны лично ваши кейсы</span></p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726043794907-HbEAM-Chec.svg"
                                    alt="">
                                <p>Доступ к живым эфирам с Ольгой Лермонтовой</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726043794907-HbEAM-Chec.svg"
                                    alt="">
                                <p>Работа в чате с куратором</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726043794907-HbEAM-Chec.svg"
                                    alt="">
                                <p>Работа в паре с buddy, с которым вы будете прорабатывать свои результаты</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726043794907-HbEAM-Chec.svg"
                                    alt="">
                                <p>2 практические сессии, чтобы глубже разобрать важные для вас вопросы</p>
                            </li>
                        </ul>
                        <div>
                            <p class="course40-tariffs-item-price">150 000 ₽</p>
                            <a href="#" class="btn-color-main-black">Лист ожидания </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-course40-tariffs-tablet', {
        label: 'Course 4 tariffs (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-course40-tariffs-tablet">
            <div class="careerum-container-tablet">
                <!-- <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064307622-aQIq7-Rect.png" alt=""> -->
                <h2>Условия участия</h2>
                <p>У курса не будет открытых продаж. Добавляйтесь в лист ожидания,<br> чтобы попасть на него и получить
                    доступ по лучшей цене</p>
                <div class="course40-tariffs-items careerum-flex-fsst" data-price-rub="">
                    <div class="course40-tariffs-item careerum-flex-fsfs" data-price-rub="65 000 ₽" data-price-eur="650 €">
                        <p class="course40-tariffs-item-header">Базовый</p>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570404-Jm6Zo-Chec.svg"
                                    alt="">
                                <p>Доступ к живым эфирам с Ольгой Лермонтовой</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570404-Jm6Zo-Chec.svg"
                                    alt="">
                                <p>Работа в чате с куратором</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570404-Jm6Zo-Chec.svg"
                                    alt="">
                                <p>Работа в паре с buddy, с которым вы будете прорабатывать свои результаты</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570404-Jm6Zo-Chec.svg"
                                    alt="">
                                <p>2 практические сессии, чтобы глубже разобрать важные для вас вопросы</p>
                            </li>
                        </ul>
                        <div>
                            <p class="course40-tariffs-item-price">65 000 ₽</p>
                            <a href="#" class="btn-color-main-black">Лист ожидания </a>
                        </div>
                    </div>
                    <div class="course40-tariffs-item careerum-flex-fsfs" data-price-rub="150 000 ₽"
                        data-price-eur="1 500 €">
                        <p class="course40-tariffs-item-label">Осталось: 20 мест</p>
                        <p class="course40-tariffs-item-header">Индивидуальная работа с Ольгой Лермонтовой</p>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570641-3n9ce-Fram.svg"
                                    alt="">
                                <p><span>2 мастермайнда в группе из 10 человек с Ольгой Лермонтовой, на которых будут
                                        проработаны лично ваши кейсы</span></p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570404-Jm6Zo-Chec.svg"
                                    alt="">
                                <p>Доступ к живым эфирам с Ольгой Лермонтовой</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570404-Jm6Zo-Chec.svg"
                                    alt="">
                                <p>Работа в чате с куратором</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570404-Jm6Zo-Chec.svg"
                                    alt="">
                                <p>Работа в паре с buddy, с которым вы будете прорабатывать свои результаты</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570404-Jm6Zo-Chec.svg"
                                    alt="">
                                <p>2 практические сессии, чтобы глубже разобрать важные для вас вопросы</p>
                            </li>
                        </ul>
                        <div>
                            <p class="course40-tariffs-item-price">150 000 ₽</p>
                            <a href="#" class="btn-color-main-black">Лист ожидания </a>
                        </div>
                    </div>
                </div>
                <div class="course40-tariffs-curr">
                    <div class="club40-tariffs__swicher-block">
                        <div class="club40-tariffs__swicher-top">
                            <p class="club40-tariffs__swicher-header">Посмотреть цены
                                в
                                <span>EUR</span>
                            </p><svg xmlns="http://www.w3.org/2000/svg" width="24"
                                height="24" viewBox="0 0 24 24" fill="none" class="club40-tariffs__swicher-arrow">
                                <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black">
                                </path>
                            </svg>
                        </div>
                        <div class="club40-tariffs__swicher-bottom">
                            <ul>
                                <li data-currency="rub" class="active">
                                    RUB
                                </li>
                                <li data-currency="eur" class="">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских рублях
                                возможна только<br> с карты
                                российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-course40-tariffs-mobile', {
        label: 'Course 4 tariffs (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-course40-tariffs-mobile">
            <div class="careerum-container-mobile">
                <h2>Условия участия</h2>
                <p>У курса не будет открытых продаж. Добавляйтесь в лист ожидания, чтобы <br>попасть на него и получить
                    доступ по лучшей цене</p>
                <div class="course40-tariffs-curr">
                    <div class="club40-tariffs__swicher-block">
                        <div class="club40-tariffs__swicher-top">
                            <p class="club40-tariffs__swicher-header">Посмотреть цены
                                в
                                <span>EUR</span>
                            </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" class="club40-tariffs__swicher-arrow">
                                <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black">
                                </path>
                            </svg>
                        </div>
                        <div class="club40-tariffs__swicher-bottom">
                            <ul>
                                <li data-currency="rub" class="active">
                                    RUB
                                </li>
                                <li data-currency="eur" class="">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских рублях
                                возможна только<br> с карты
                                российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
                <div class="course40-tariffs-items">
                    <div class="course40-tariffs-item careerum-flex-fsfs" data-price-rub="65 000 ₽" data-price-eur="650 €">
                        <p class="course40-tariffs-item-header">Базовый</p>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570404-Jm6Zo-Chec.svg"
                                    alt="">
                                <p>Доступ к живым эфирам с Ольгой Лермонтовой</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570404-Jm6Zo-Chec.svg"
                                    alt="">
                                <p>Работа в чате с куратором</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570404-Jm6Zo-Chec.svg"
                                    alt="">
                                <p>Работа в паре с buddy, с которым вы будете прорабатывать свои результаты</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570404-Jm6Zo-Chec.svg"
                                    alt="">
                                <p>2 практические сессии, чтобы глубже разобрать важные для вас вопросы</p>
                            </li>
                        </ul>
                        <div>
                            <p class="course40-tariffs-item-price">65 000 ₽</p>
                            <a href="#" class="btn-color-main-black">Лист ожидания </a>
                        </div>
                    </div>
                    <div class="course40-tariffs-item careerum-flex-fsfs" data-price-rub="150 000 ₽"
                        data-price-eur="1 500 €">
                        <p class="course40-tariffs-item-label">Осталось: 20 мест</p>
                        <p class="course40-tariffs-item-header">Индивидуальная работа с Ольгой Лермонтовой</p>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570641-3n9ce-Fram.svg"
                                    alt="">
                                <p><span>2 мастермайнда в группе из 10 человек с Ольгой Лермонтовой, на которых будут
                                        проработаны лично ваши кейсы</span></p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570404-Jm6Zo-Chec.svg"
                                    alt="">
                                <p>Доступ к живым эфирам с Ольгой Лермонтовой</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570404-Jm6Zo-Chec.svg"
                                    alt="">
                                <p>Работа в чате с куратором</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570404-Jm6Zo-Chec.svg"
                                    alt="">
                                <p>Работа в паре с buddy, с которым вы будете прорабатывать свои результаты</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570404-Jm6Zo-Chec.svg"
                                    alt="">
                                <p>2 практические сессии, чтобы глубже разобрать важные для вас вопросы</p>
                            </li>
                        </ul>
                        <div>
                            <p class="course40-tariffs-item-price">150 000 ₽</p>
                            <a href="#" class="btn-color-main-black">Лист ожидания </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-blackfriday-main', {
        label: 'Black friday main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-blackfriday-main main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1731910870671-8wMca-Elli.png" alt=""
                class="position-absolute z-10">
            <div class="careerum-flex-fsfs position-relative z-20 blackfriday-main__top">
                <div class="position-relative">
                    <h1 class="position-relative z-10">BLACK FRIDAY</h1>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732702169493-AB4tY-Grou.png"
                            alt="" class="position-absolute z-20 hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732710712112-sKn3B-Grou.png"
                            alt="" class="position-absolute z-20 hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732715793717-CSjIx-Grou.png"
                            alt="" class="position-absolute z-20 hidden-desc-tablet">
                    </div>
                </div>
                <div class="position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1731911478189-S2vLD-Vect.svg"
                        alt="" class="position-absolute z-20 hidden-tablet-mobile">
                    <p class="blackfriday-main__subheader position-relative z-10 hidden-tablet-mobile">Лучшие курсы и мастер-классы Careerum <span>14 900 ₽</span> 5 690 ₽ </p>
                    <p class="blackfriday-main__subheader position-relative z-10 hidden-desc">Лучшие курсы и мастер-классы Careerum за <span>14 900 ₽</span><span class="position-relative"><img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732008867256-0zvS7-Vect.svg"
                                alt="" class="position-absolute z-20"></span> 5 690 ₽ </p>
                    <p class="blackfriday-main__text position-relative z-10">И никаких страданий по понедельникам</p>
                </div>
            </div>
            <div class="position-relative z-20 blackfriday-main__center">
                <div class="position-absolute blackfriday-main__center-top careerum-flex-fsc">
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                </div>
                <div class="position-absolute blackfriday-main__center-bottom careerum-flex-fsc">
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                </div>
            </div>
            <div class="blackfriday-main__bottom position-relative">
                <p class="hidden-tablet-mobile">🎁 В подарок — месяц подписки на Careerum.Tips</p>
                <p class="hidden-desc">🎁 В подарок к покупке: месяц подписки на Careerum.Tips </p>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1731918326211-H07JU-Vect.svg" alt=""
                    class="blackfriday-main__bottom-left position-absolute hidden-mobile">
                <p>70 писем-уроков, которые помогут решить любую карьерную задачу</p>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1731919048635-oK82s-Grou.png" alt=""
                    class="blackfriday-main__bottom-right position-absolute hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1731933425253-xoE6s-Grou.png" alt=""
                    class="blackfriday-main__bottom-right position-absolute hidden-desc-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732017887120-6DVsn-Grou.png" alt=""
                    class="blackfriday-main__bottom-right hidden-desc-tablet">
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-blackfriday-tales', {
        label: 'Black friday tales (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-blackfriday-tales main-wrapper">
        <div class="careerum-container-responsive">
            <div class="blackfriday-tales-header position-relative">
                <h2>Лучшие курсы из подписки</h2>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732709671524-3GKLk-Grou.png" alt=""
                    class="position-absolute hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732712919539-f1RyJ-Grou.png" alt=""
                    class="position-absolute hidden-desc-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732717279175-edjte-Grou.png" alt=""
                    class="position-absolute hidden-desc-tablet">
            </div>
            <div class="blackfriday-tales-currency position-relative z-20">
                <div class="hidden-tablet-mobile">
                    <div class="blackfriday-tales-currency-desctop careerum-flex-fsst">
                        <ul class="careerum-flex-fsfs">
                            <li data-currency="eur">EUR</li>
                            <li data-currency="rub" class="active">RUB</li>
                        </ul>
                        <div class="blackfriday-tales-notif careerum-flex-cc">
                            <div class="blackfriday-tales-notif-icon">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                    alt="">
                            </div>
                            <div class="blackfriday-tales-notif-content">
                                <p>Оплата в российских рублях возможна только картой
                                    российского банка. В&nbsp;евро — картой
                                    зарубежного банка</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="hidden-desc position-relative">
                    <div class="blackfriday-tales__swicher-block position-absolute">
                        <div class="blackfriday-tales__swicher-top">
                            <p class="blackfriday-tales__swicher-header">Посмотреть
                                цены в
                                <span>RUB</span>
                            </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" class="blackfriday-tales__swicher-arrow">
                                <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black">
                                </path>
                            </svg>
                        </div>
                        <div class="blackfriday-tales__swicher-bottom">
                            <ul>
                                <li data-currency="rub">
                                    RUB
                                </li>
                                <li data-currency="eur" class="active">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских
                                рублях
                                возможна только<br> с карты
                                российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="blackfriday-tales careerum-flex-fsfs position-relative z-10">
                <div class="blackfriday-tale careerum-flex-fsfs position-relative blackfriday-tale-change-currency"
                    price-current-eur="56 €" price-current-rub="5 690 ₽" price-old-eur="149 €" price-old-rub="14900 ₽"
                    link-eur="#eur" link-rub="#rub">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1731920558380-LZI1S-Fram.png"
                        alt="" class="hidden-tablet">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732005724556-ACS5J-Fram.png"
                        alt="" class="hidden-desc-mobile">
                    <div class="blackfriday-tale__label position-absolute">
                        <p>поиск работы</p>
                    </div>
                    <div class="blackfriday-tale__header">
                        <h3>Продающее резюме</h3>
                        <p>Пошаговая инструкция для создания идеального резюме.</p>
                    </div>
                    <div class="blackfriday-tale__content">
                        <div class="careerum-flex-fsc blackfriday-tale__switcher">
                            <p>Программа курса</p>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="hidden-mobile">
                                <path
                                    d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                                    stroke="white" stroke-width="2" stroke-miterlimit="10" />
                                <path d="M20.5 14.5L16 19.5L11.5 14.5" stroke="white" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="hidden-desc-tablet">
                                <path
                                    d="M12 21.6147C16.9706 21.6147 21 17.5853 21 12.6147C21 7.64418 16.9706 3.61475 12 3.61475C7.02944 3.61475 3 7.64418 3 12.6147C3 17.5853 7.02944 21.6147 12 21.6147Z"
                                    stroke="white" stroke-width="1.5" stroke-miterlimit="10" />
                                <path d="M15.375 11.4897L12 15.2397L8.625 11.4897" stroke="white" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <ol>
                            <li>Эффективная основа любого резюме: принципы написания, формат</li>
                            <li>Достижения: как найти и упаковать </li>
                            <li>Как «докрутить» резюме до уровня топ-компаний рынка</li>
                            <li>Как получать максимум откликов: лайфхаки кастомизации резюме под вакансии</li>
                        </ol>
                    </div>
                    <div class="careerum-flex-fsc blackfriday-tale__descr">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <p>Доступ на 90 дней</p>
                    </div>
                    <div class="careerum-flex-fsc blackfriday-tale__price">
                        <p class="price-current">5 690 ₽</p>
                        <p class="price-old">14900 ₽</p>
                        <p>— 60%</p>
                    </div>
                    <a href="#buy" class="btn-color-main-dark-blue">Выбрать</a>
                </div>
                <div class="blackfriday-tale careerum-flex-fsfs position-relative blackfriday-tale-change-currency"
                    price-current-eur="56 €" price-current-rub="5 690 ₽" price-old-eur="149 €" price-old-rub="14900 ₽"
                    link-eur="#eur2" link-rub="#rub2">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1731920571409-iJ8hG-Fram.png"
                        alt="" class="hidden-tablet">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732005724428-RwfiV-Fram.png"
                        alt="" class="hidden-desc-mobile">
                    <div class="blackfriday-tale__label position-absolute">
                        <p>релокация</p>
                    </div>
                    <div class="blackfriday-tale__header">
                        <h3>Международная карьера и релокация</h3>
                        <p>Стратегия для получения оффера в новой географии. </p>
                    </div>
                    <div class="blackfriday-tale__content">
                        <div class="careerum-flex-fsc blackfriday-tale__switcher">
                            <p>Программа курса</p>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="hidden-mobile">
                                <path
                                    d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                                    stroke="white" stroke-width="2" stroke-miterlimit="10" />
                                <path d="M20.5 14.5L16 19.5L11.5 14.5" stroke="white" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="hidden-desc-tablet">
                                <path
                                    d="M12 21.6147C16.9706 21.6147 21 17.5853 21 12.6147C21 7.64418 16.9706 3.61475 12 3.61475C7.02944 3.61475 3 7.64418 3 12.6147C3 17.5853 7.02944 21.6147 12 21.6147Z"
                                    stroke="white" stroke-width="1.5" stroke-miterlimit="10" />
                                <path d="M15.375 11.4897L12 15.2397L8.625 11.4897" stroke="white" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <ol>
                            <li>Алгоритм поиска работы за границей</li>
                            <li>Выбор страны, способы переезда</li>
                            <li>Отличия рынка СНГ, Азии и Европы</li>
                            <li>Упаковка своего опыта на новом рынке</li>
                            <li>Постановка целей</li>
                            <li>Составление и адаптация резюме</li>
                            <li>LinkedIn для развития карьеры</li>
                            <li>Прохождение интервью</li>
                            <li>Коммуникация с иностранными коллегами</li>
                            <li>Обсуждение оффера</li>
                        </ol>
                    </div>
                    <div class="careerum-flex-fsc blackfriday-tale__descr">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <p>Доступ на 90 дней</p>
                    </div>
                    <div class="careerum-flex-fsc blackfriday-tale__price">
                        <p class="price-current">5 690 ₽</p>
                        <p class="price-old">14900 ₽</p>
                        <p>— 60%</p>
                    </div>
                    <a href="#buy" class="btn-color-main-dark-blue">Выбрать</a>
                </div>
                <div class="blackfriday-tale careerum-flex-fsfs position-relative blackfriday-tale-change-currency"
                    price-current-eur="56 €" price-current-rub="5 690 ₽" price-old-eur="149 €" price-old-rub="14900 ₽"
                    link-eur="#eur2" link-rub="#rub2">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1731920582141-pZszF-Fram.png"
                        alt="" class="hidden-tablet">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732005724312-5MiTW-Fram.png"
                        alt="" class="hidden-desc-mobile">
                    <div class="blackfriday-tale__label position-absolute hidden">
                        <p>поиск работы</p>
                    </div>
                    <div class="blackfriday-tale__header">
                        <h3>Карьера в кризис: как найти и не потерять работу</h3>
                        <p>Чтобы расти в компании и получать офферы вопреки сокращениям и изменениям на рынке.</p>
                    </div>
                    <div class="blackfriday-tale__content">
                        <div class="careerum-flex-fsc blackfriday-tale__switcher">
                            <p>Программа курса</p>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="hidden-mobile">
                                <path
                                    d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                                    stroke="white" stroke-width="2" stroke-miterlimit="10" />
                                <path d="M20.5 14.5L16 19.5L11.5 14.5" stroke="white" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="hidden-desc-tablet">
                                <path
                                    d="M12 21.6147C16.9706 21.6147 21 17.5853 21 12.6147C21 7.64418 16.9706 3.61475 12 3.61475C7.02944 3.61475 3 7.64418 3 12.6147C3 17.5853 7.02944 21.6147 12 21.6147Z"
                                    stroke="white" stroke-width="1.5" stroke-miterlimit="10" />
                                <path d="M15.375 11.4897L12 15.2397L8.625 11.4897" stroke="white" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <ol>
                            <li>Типы кризисов: панарама рынка</li>
                            <li>Алгоритм анализа кризисов</li>
                            <li>Боли компаний в кризис</li>
                            <li>ЛПР: кто и как нанимает в кризис</li>
                            <li>Позиционирование себя на рынке труда</li>
                            <li>Лайфхаки поиск работы в кризис</li>
                            <li>Ценный сотрудник: как закрепиться в текущей компании в кризис</li>
                        </ol>
                    </div>
                    <div class="careerum-flex-fsc blackfriday-tale__descr">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <p>Доступ на 90 дней</p>
                    </div>
                    <div class="careerum-flex-fsc blackfriday-tale__price">
                        <p class="price-current">5 690 ₽</p>
                        <p class="price-old">14900 ₽</p>
                        <p>— 60%</p>
                    </div>
                    <a href="#buy" class="btn-color-main-dark-blue">Выбрать</a>
                </div>
                <div class="blackfriday-tale careerum-flex-fsfs position-relative blackfriday-tale-change-currency"
                    price-current-eur="56 €" price-current-rub="5 690 ₽" price-old-eur="149 €" price-old-rub="14900 ₽"
                    link-eur="#eur2" link-rub="#rub2">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1731920591736-3vsCV-Fram.png"
                        alt="" class="hidden-tablet">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732005724175-jhZhx-Fram.png"
                        alt="" class="hidden-desc-mobile">
                    <div class="blackfriday-tale__label position-absolute hidden">
                        <p>поиск работы</p>
                    </div>
                    <div class="blackfriday-tale__header">
                        <h3>Нетворкинг для карьеры и жизни</h3>
                        <p>Измените отношение к нетворкингу — избавитесь от барьеров и начнете строить нетворк во время
                            обучения.</p>
                    </div>
                    <div class="blackfriday-tale__content">
                        <div class="careerum-flex-fsc blackfriday-tale__switcher">
                            <p>Программа курса</p>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="hidden-mobile">
                                <path
                                    d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                                    stroke="white" stroke-width="2" stroke-miterlimit="10" />
                                <path d="M20.5 14.5L16 19.5L11.5 14.5" stroke="white" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="hidden-desc-tablet">
                                <path
                                    d="M12 21.6147C16.9706 21.6147 21 17.5853 21 12.6147C21 7.64418 16.9706 3.61475 12 3.61475C7.02944 3.61475 3 7.64418 3 12.6147C3 17.5853 7.02944 21.6147 12 21.6147Z"
                                    stroke="white" stroke-width="1.5" stroke-miterlimit="10" />
                                <path d="M15.375 11.4897L12 15.2397L8.625 11.4897" stroke="white" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <ol>
                            <li>Цели и ценности нетворкинга</li>
                            <li>Мышление и навыки продвинутого нетворкера</li>
                            <li>Где и с кем? Портрет окружения</li>
                            <li>Эффективные каналы поиска</li>
                            <li>Как строить отношения</li>
                            <li>Бонус: уроки по построению личного бренда</li>
                        </ol>
                    </div>
                    <div class="careerum-flex-fsc blackfriday-tale__descr">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <p>Доступ на 90 дней</p>
                    </div>
                    <div class="careerum-flex-fsc blackfriday-tale__price">
                        <p class="price-current">5 690 ₽</p>
                        <p class="price-old">14900 ₽</p>
                        <p>— 60%</p>
                    </div>
                    <a href="#buy" class="btn-color-main-dark-blue">Выбрать</a>
                </div>
                <div class="blackfriday-tale careerum-flex-fsfs position-relative blackfriday-tale-change-currency"
                    price-current-eur="56 €" price-current-rub="5 690 ₽" price-old-eur="149 €" price-old-rub="14900 ₽"
                    link-eur="#eur2" link-rub="#rub2">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1731920601523-8qdN5-Fram.png"
                        alt="" class="hidden-tablet">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732005724053-MnuIv-Fram.png"
                        alt="" class="hidden-desc-mobile">
                    <div class="blackfriday-tale__label position-absolute hidden">
                        <p>поиск работы</p>
                    </div>
                    <div class="blackfriday-tale__header">
                        <h3>Great Deal: как получить оффер мечты</h3>
                        <p>Научитесь презентовать свой опыт и договариваться о желаемой зарплате, выгодном соцпакете и
                            других бонусах.</p>
                    </div>
                    <div class="blackfriday-tale__content">
                        <div class="careerum-flex-fsc blackfriday-tale__switcher">
                            <p>Программа курса</p>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="hidden-mobile">
                                <path
                                    d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                                    stroke="white" stroke-width="2" stroke-miterlimit="10" />
                                <path d="M20.5 14.5L16 19.5L11.5 14.5" stroke="white" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="hidden-desc-tablet">
                                <path
                                    d="M12 21.6147C16.9706 21.6147 21 17.5853 21 12.6147C21 7.64418 16.9706 3.61475 12 3.61475C7.02944 3.61475 3 7.64418 3 12.6147C3 17.5853 7.02944 21.6147 12 21.6147Z"
                                    stroke="white" stroke-width="1.5" stroke-miterlimit="10" />
                                <path d="M15.375 11.4897L12 15.2397L8.625 11.4897" stroke="white" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <ol>
                            <ol>
                                <li>Менталитет продавца</li>
                                <li>Предмет переговоров — не только зарплата</li>
                                <li>BATNA: ваша и компании</li>
                                <li>Как вести переговоры о зарплате</li>
                                <li>Процесс предоставления и принятия оффера</li>
                                <li>Установок, которые мешают продаже навыков</li>
                            </ol>
                        </ol>
                    </div>
                    <div class="careerum-flex-fsc blackfriday-tale__descr">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <p>Доступ на 90 дней</p>
                    </div>
                    <div class="careerum-flex-fsc blackfriday-tale__price">
                        <p class="price-current">5 690 ₽</p>
                        <p class="price-old">14900 ₽</p>
                        <p>— 60%</p>
                    </div>
                    <a href="#buy" class="btn-color-main-dark-blue">Выбрать</a>
                </div>
                <div class="blackfriday-tale careerum-flex-fsfs position-relative blackfriday-tale-change-currency"
                    price-current-eur="56 €" price-current-rub="5 690 ₽" price-old-eur="149 €" price-old-rub="14900 ₽"
                    link-eur="#eur2" link-rub="#rub2">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1731920609714-yudWd-Fram.png"
                        alt="" class="hidden-tablet">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732005723774-LfVSR-Fram.png"
                        alt="" class="hidden-desc-mobile">
                    <div class="blackfriday-tale__label position-absolute hidden">
                        <p>поиск работы</p>
                    </div>
                    <div class="blackfriday-tale__header">
                        <h3>Пробейте карьерный потолок</h3>
                        <p>Достигните целей как в Googlе, результатов как в Forbеs. Освойте базу карьерного мышления для
                            быстрого роста</p>
                    </div>
                    <div class="blackfriday-tale__content">
                        <div class="careerum-flex-fsc blackfriday-tale__switcher">
                            <p>Программа курса</p>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="hidden-mobile">
                                <path
                                    d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                                    stroke="white" stroke-width="2" stroke-miterlimit="10" />
                                <path d="M20.5 14.5L16 19.5L11.5 14.5" stroke="white" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="hidden-desc-tablet">
                                <path
                                    d="M12 21.6147C16.9706 21.6147 21 17.5853 21 12.6147C21 7.64418 16.9706 3.61475 12 3.61475C7.02944 3.61475 3 7.64418 3 12.6147C3 17.5853 7.02944 21.6147 12 21.6147Z"
                                    stroke="white" stroke-width="1.5" stroke-miterlimit="10" />
                                <path d="M15.375 11.4897L12 15.2397L8.625 11.4897" stroke="white" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <ol>
                            <li>Основные стопперы на пути к целям</li>
                            <li>Первые шаги постановки целей</li>
                            <li>Синхронизация ваших целей с целями компании</li>
                            <li>OKR — метод постановки амбициозных целей</li>
                            <li>План на день и неделю</li>
                            <li>Актуализация целей</li>
                            <li>Проводники к вашим карьерным целям</li>
                            <li>Как стать ценным специалистом и стоить дороже</li>
                            <li>Как обсуждать повышение зарплаты</li>
                            <li>Как добиться повышения</li>
                        </ol>
                    </div>
                    <div class="careerum-flex-fsc blackfriday-tale__descr">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <p>Доступ на 90 дней</p>
                    </div>
                    <div class="careerum-flex-fsc blackfriday-tale__price">
                        <p class="price-current">5 690 ₽</p>
                        <p class="price-old">14900 ₽</p>
                        <p>— 60%</p>
                    </div>
                    <a href="#buy" class="btn-color-main-dark-blue">Выбрать</a>
                </div>
            </div>
            <div class="blackfriday-tales-single careerum-flex-sbfs  blackfriday-tale-change-currency"
                price-current-eur="149 €" price-current-rub="14 900 ₽" price-old-eur="894 €" price-old-rub="89 480 ₽"
                link-eur="#eur2" link-rub="#buy">
                <div class="position-relative z-20">
                    <div class="blackfriday-tales-currency position-relative z-20 hidden-mobile">
                        <div class="hidden-tablet-mobile">
                            <div class="blackfriday-tales-currency-desctop careerum-flex-fsst">
                                <ul class="careerum-flex-fsfs">
                                    <li data-currency="eur">EUR</li>
                                    <li data-currency="rub" class="active">RUB</li>
                                </ul>
                                <div class="blackfriday-tales-notif careerum-flex-cc">
                                    <div class="blackfriday-tales-notif-icon">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                            alt="">
                                    </div>
                                    <div class="blackfriday-tales-notif-content">
                                        <p>Оплата в российских рублях возможна только картой
                                            российского банка. В&nbsp;евро — картой
                                            зарубежного банка</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="hidden-desc">
                            <div class="blackfriday-tales__swicher-block">
                                <div class="blackfriday-tales__swicher-top">
                                    <p class="blackfriday-tales__swicher-header">Посмотреть
                                        цены в
                                        <span>RUB</span>
                                    </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                        viewBox="0 0 24 24" fill="none" class="blackfriday-tales__swicher-arrow">
                                        <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black">
                                        </path>
                                    </svg>
                                </div>
                                <div class="blackfriday-tales__swicher-bottom">
                                    <ul>
                                        <li data-currency="rub">
                                            RUB
                                        </li>
                                        <li data-currency="eur" class="active">
                                            EUR
                                        </li>
                                    </ul>
                                    <p>
                                        Обратите внимание,<br> что оплата в российских
                                        рублях
                                        возможна только<br> с карты
                                        российского банка. Оплата в евро — с карты зарубежного банка
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <h3>Забирайте все курсы черной пятницы</h3>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732709046280-YP2xU-ÑÐº.png"
                        alt="" class="position-absolute hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732714223868-K96cn-ÑÐº.png"
                        alt="" class="position-absolute hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732716930506-nvEZa-Grou.png"
                        alt="" class="position-relative hidden-desc-tablet">
                    <div class="hidden-desc">
                        <div class="careerum-flex-fsc blackfriday-tale__descr">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <p>Доступ на 90 дней</p>
                        </div>
                    </div>
                    <div class="careerum-flex-fsc blackfriday-tale__price">
                        <p class="price-current">5 690 ₽</p>
                        <p class="price-old">14900 ₽</p>
                        <p>— 80%</p>
                    </div>
                    <div class="hidden-tablet-mobile">
                        <div class="careerum-flex-fsc blackfriday-tale__descr">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <p>Доступ на 90 дней</p>
                        </div>
                    </div>
                    <a href="#buy" class="btn-color-main-black hidden-tablet-mobile">Выбрать</a>
                    <a href="#buy" class="btn-color-main-dark-orange hidden-desc">Выбрать</a>
                </div>
                <div class="position-relative z-10 hidden-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732709002700-hfne0-Grou.svg"
                        alt="" class="position-relative hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732714316732-7gUuE-ÐÐ.svg"
                        alt="" class="position-relative hidden-desc">
                </div>
            </div>
            <div class="blackfriday-tales-header position-relative">
                <h2>Карьерные бустеры — 1 курс + 1 курс </h2>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732709690402-x5fnJ-Grou.png" alt=""
                    class="position-absolute hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732713012357-QBeQq-Grou.png" alt=""
                    class="position-absolute hidden-desc-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732717403143-VMYUl-Grou.png" alt=""
                    class="position-absolute hidden-desc-tablet">
            </div>
            <div class="blackfriday-tales-currency position-relative z-20 hidden-mobile">
                <div class="hidden-tablet-mobile">
                    <div class="blackfriday-tales-currency-desctop careerum-flex-fsst">
                        <ul class="careerum-flex-fsfs">
                            <li data-currency="eur">EUR</li>
                            <li data-currency="rub" class="active">RUB</li>
                        </ul>
                        <div class="blackfriday-tales-notif careerum-flex-cc">
                            <div class="blackfriday-tales-notif-icon">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                    alt="">
                            </div>
                            <div class="blackfriday-tales-notif-content">
                                <p>Оплата в российских рублях возможна только картой
                                    российского банка. В&nbsp;евро — картой
                                    зарубежного банка</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="hidden-desc position-relative">
                    <div class="blackfriday-tales__swicher-block position-absolute">
                        <div class="blackfriday-tales__swicher-top">
                            <p class="blackfriday-tales__swicher-header">Посмотреть
                                цены в
                                <span>RUB</span>
                            </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" class="blackfriday-tales__swicher-arrow">
                                <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black">
                                </path>
                            </svg>
                        </div>
                        <div class="blackfriday-tales__swicher-bottom">
                            <ul>
                                <li data-currency="rub">
                                    RUB
                                </li>
                                <li data-currency="eur" class="active">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских
                                рублях
                                возможна только<br> с карты
                                российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="blackfriday-tales-center position-relative z-10">
                <div class="blackfriday-tale-center careerum-flex-fsfs blackfriday-tale-change-currency"
                    price-current-eur="88 €" price-current-rub="8 880 ₽" price-old-eur="298 €" price-old-rub="29 800 ₽"
                    link-eur="#eur2" link-rub="#rub2">
                    <div>
                        <h3>Бустер «Поиск работы»</h3>
                        <div class="hidden-desc-tablet">
                            <h4>Что входит:</h4>
                            <p class="blackfriday-tale-center__label">курс</p>
                            <h5>Продающее резюме</h5>
                            <p class="blackfriday-tale-center__label">курс</p>
                            <h5>Great Deal: как получить оффер мечты</h5>
                        </div>
                        <div class="hidden-desc">
                            <div class="careerum-flex-fsc blackfriday-tale__descr">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                <p>Доступ на 90 дней</p>
                            </div>
                        </div>
                        <div class="careerum-flex-fsc blackfriday-tale__price">
                            <p class="price-current">5 690 ₽</p>
                            <p class="price-old">14900 ₽</p>
                            <p>— 70%</p>
                        </div>
                        <div class="hidden-tablet-mobile">
                            <div class="careerum-flex-fsc blackfriday-tale__descr">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                <p>Доступ на 90 дней</p>
                            </div>
                        </div>
                        <a href="#buy" class="btn-color-main-dark-blue">Выбрать</a>
                    </div>
                    <div class="hidden-mobile">
                        <h4>Что входит:</h4>
                        <p class="blackfriday-tale-center__label">курс</p>
                        <h5>Продающее резюме</h5>
                        <p class="blackfriday-tale-center__label">курс</p>
                        <h5>Great Deal: как получить оффер мечты</h5>
                    </div>
                    <div class="position-relative">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732707637954-tUakT-Fram.svg"
                            alt="" class="position-relative hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732715226614-uuG0K-Fram.svg"
                            alt="" class="position-relative hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732717727845-lOzCy-Fram.svg"
                            alt="" class="position-relative hidden-desc-tablet">
                    </div>
                </div>
                <div class="blackfriday-tale-center careerum-flex-fsfs blackfriday-tale-change-currency"
                    price-current-eur="88 €" price-current-rub="8 880 ₽" price-old-eur="298 €" price-old-rub="29 800 ₽"
                    link-eur="#eur2" link-rub="#rub2">
                    <div>
                        <h3>Бустер<br> «Работа в кризис»</h3>
                        <div class="hidden-desc-tablet">
                            <h4>Что входит:</h4>
                            <p class="blackfriday-tale-center__label">курс</p>
                            <h5>Карьера в кризис: как найти и не потерять работу</h5>
                            <p class="blackfriday-tale-center__label">курс</p>
                            <h5>Нетворкинг для карьеры и жизни</h5>
                        </div>
                        <div class="hidden-desc">
                            <div class="careerum-flex-fsc blackfriday-tale__descr">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                <p>Доступ на 90 дней</p>
                            </div>
                        </div>
                        <div class="careerum-flex-fsc blackfriday-tale__price">
                            <p class="price-current">5 690 ₽</p>
                            <p class="price-old">14900 ₽</p>
                            <p>— 70%</p>
                        </div>
                        <div class="hidden-tablet-mobile">
                            <div class="careerum-flex-fsc blackfriday-tale__descr">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                <p>Доступ на 90 дней</p>
                            </div>
                        </div>
                        <a href="#buy" class="btn-color-main-dark-blue">Выбрать</a>
                    </div>
                    <div class="hidden-mobile">
                        <h4>Что входит:</h4>
                        <p class="blackfriday-tale-center__label">курс</p>
                        <h5>Карьера в кризис: как найти и не потерять работу</h5>
                        <p class="blackfriday-tale-center__label">курс</p>
                        <h5>Нетворкинг для карьеры и жизни</h5>
                    </div>
                    <div class="position-relative">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732710015441-QP8Cg-Fram.svg"
                            alt="" class="position-relative hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732715328692-MNzQ3-Fram.svg"
                            alt="" class="position-relative hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732718073661-RFtuV-Fram.svg"
                            alt="" class="position-relative hidden-desc-tablet">
                    </div>
                </div>
                <div class="blackfriday-tale-center careerum-flex-fsfs blackfriday-tale-change-currency"
                    price-current-eur="88 €" price-current-rub="8 880 ₽" price-old-eur="298 €" price-old-rub="29 800 ₽"
                    link-eur="#eur2" link-rub="#rub2">
                    <div>
                        <h3 class="hidden-tablet">Бустер «Релокация»</h3>
                        <h3 class="hidden-desc-mobile">Бустер<br> «Релокация»</h3>
                        <div class="hidden-desc-tablet">
                            <h4>Что входит:</h4>
                            <p class="blackfriday-tale-center__label">курс</p>
                            <h5>Международная карьера и релокация</h5>
                            <p class="blackfriday-tale-center__label">курс</p>
                            <h5>Great Deal: как получить оффер мечты</h5>
                        </div>
                        <div class="hidden-desc">
                            <div class="careerum-flex-fsc blackfriday-tale__descr">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                <p>Доступ на 90 дней</p>
                            </div>
                        </div>
                        <div class="careerum-flex-fsc blackfriday-tale__price">
                            <p class="price-current">5 690 ₽</p>
                            <p class="price-old">14900 ₽</p>
                            <p>— 70%</p>
                        </div>
                        <div class="hidden-tablet-mobile">
                            <div class="careerum-flex-fsc blackfriday-tale__descr">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                <p>Доступ на 90 дней</p>
                            </div>
                        </div>
                        <a href="#buy" class="btn-color-main-dark-blue">Выбрать</a>

                    </div>
                    <div class="hidden-mobile">
                        <h4>Что входит:</h4>
                        <p class="blackfriday-tale-center__label">курс</p>
                        <h5>Международная карьера и релокация</h5>
                        <p class="blackfriday-tale-center__label">курс</p>
                        <h5>Great Deal: как получить оффер мечты</h5>
                    </div>
                    <div class="position-relative">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732710111629-uhGbR-Fram.svg"
                            alt="" class="position-relative hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732715357072-oUZ1q-Fram.svg"
                            alt="" class="position-relative hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732718227868-Lwojy-Fram.svg"
                            alt="" class="position-relative hidden-desc-tablet">
                    </div>
                </div>
                <div class="blackfriday-tale-center careerum-flex-fsfs blackfriday-tale-change-currency"
                    price-current-eur="88 €" price-current-rub="8 880 ₽" price-old-eur="298 €" price-old-rub="29 800 ₽"
                    link-eur="#eur2" link-rub="#rub2">
                    <div>
                        <h3>Бустер<br>«Рост в карьере»</h3>
                        <div class="hidden-desc-tablet">
                            <h4>Что входит:</h4>
                            <p class="blackfriday-tale-center__label">курс</p>
                            <h5>Продающее резюме</h5>
                            <p class="blackfriday-tale-center__label">курс</p>
                            <h5>Пробейте карьерный потолок</h5>
                        </div>
                        <div class="hidden-desc">
                            <div class="careerum-flex-fsc blackfriday-tale__descr">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                <p>Доступ на 90 дней</p>
                            </div>
                        </div>
                        <div class="careerum-flex-fsc blackfriday-tale__price">
                            <p class="price-current">5 690 ₽</p>
                            <p class="price-old">14900 ₽</p>
                            <p>— 70%</p>
                        </div>
                        <div class="hidden-tablet-mobile">
                            <div class="careerum-flex-fsc blackfriday-tale__descr">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                <p>Доступ на 90 дней</p>
                            </div>
                        </div>
                        <a href="#buy" class="btn-color-main-dark-blue">Выбрать</a>

                    </div>
                    <div class="hidden-mobile">
                        <h4>Что входит:</h4>
                        <p class="blackfriday-tale-center__label">курс</p>
                        <h5>Продающее резюме</h5>
                        <p class="blackfriday-tale-center__label">курс</p>
                        <h5>Пробейте карьерный потолок</h5>
                    </div>
                    <div class="position-relative">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732710188294-AV1Xu-Fram.svg"
                            alt="" class="position-relative hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732715390858-QYyaS-Fram.svg"
                            alt="" class="position-relative hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732718297575-lLVd0-Fram.svg"
                            alt="" class="position-relative hidden-desc-tablet">
                    </div>
                </div>
            </div>
            <div class="blackfriday-tales-bottom careerum-flex-sbfs">
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723278649360-d3raW-Vect.svg"
                        alt="" class="hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732006365323-z7bdR-Vect.svg"
                        alt="" class="hidden-desc">
                    <p class="blackfriday-tales-bottom-header">Не знаете, какой курс выбрать?</p>
                    <p class="blackfriday-tales-bottom-subheader">Напишите нам — мы поможем выбрать лучшее решение под
                        вашу задачу</p>
                    <a href="https://t.me/careerum_support?roistat_visit=660124" target="_blank"
                        class="btn-color-main-dark-orange careerum-flex-cc hidden-mobile">
                        <svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M6.9104 12.5754L9.51374 19.781C9.51374 19.781 9.83922 20.4552 10.1877 20.4552C10.5363 20.4552 15.7201 15.0624 15.7201 15.0624L21.4847 3.92822L7.00329 10.7153L6.9104 12.5754Z"
                                fill="#C8DAEA"></path>
                            <path
                                d="M10.3623 14.4233L9.86251 19.7346C9.86251 19.7346 9.65332 21.362 11.2804 19.7346C12.9074 18.1072 14.4648 16.8522 14.4648 16.8522"
                                fill="#A9C6D8"></path>
                            <path
                                d="M6.9574 12.8324L1.60225 11.0876C1.60225 11.0876 0.962247 10.828 1.16833 10.2392C1.21075 10.1177 1.29633 10.0144 1.55233 9.83687C2.73889 9.00981 23.5146 1.54247 23.5146 1.54247C23.5146 1.54247 24.1012 1.3448 24.4471 1.47628C24.5327 1.50277 24.6097 1.55152 24.6703 1.61755C24.7309 1.68357 24.7728 1.7645 24.7918 1.85205C24.8292 2.00668 24.8448 2.16578 24.8383 2.32473C24.8366 2.46224 24.82 2.58969 24.8074 2.78956C24.6808 4.83116 20.8942 20.0683 20.8942 20.0683C20.8942 20.0683 20.6677 20.9599 19.856 20.9904C19.6565 20.9969 19.4578 20.9631 19.2716 20.8911C19.0855 20.8191 18.9157 20.7103 18.7725 20.5713C17.1797 19.2012 11.6742 15.5012 10.4577 14.6875C10.4302 14.6688 10.4071 14.6445 10.3899 14.6161C10.3727 14.5877 10.3617 14.5559 10.3578 14.523C10.3408 14.4372 10.4341 14.3309 10.4341 14.3309C10.4341 14.3309 20.0205 5.80981 20.2756 4.91527C20.2954 4.84597 20.2208 4.81177 20.1206 4.84213C19.4838 5.07637 8.44622 12.0467 7.22803 12.816C7.14034 12.8425 7.04766 12.8481 6.9574 12.8324Z"
                                fill="white"></path>
                        </svg>
                        <p id="i03ubjg">Написать нам в Telegram</p>
                    </a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723278685081-7nUnx-ÑÐ¾.svg"
                        alt="" class="hidden-tablet-mobile">
                    <div class="careerum-flex-fsfs blackfriday-tales-bottom-care">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723278768285-Yeat8-phot.png"
                                alt="">
                        </div>
                        <div>
                            <p class="blackfriday-tales-bottom-care-name">Анна </p>
                            <p class="blackfriday-tales-bottom-care-position">Команда
                                заботы Careerum</p>
                            <p class="blackfriday-tales-bottom-care-descr hidden-tablet-mobile">Добрый
                                день! Построить карьеру мечты в&nbsp;одиночку
                                бывает непросто. Но мы рядом и&nbsp;приведем вас к&nbsp;заветной цели 💙</p>
                        </div>

                        <p class="blackfriday-tales-bottom-care-descr hidden-desc">Добрый
                            день! Построить карьеру мечты в&nbsp;одиночку
                            бывает непросто. Но мы рядом и&nbsp;приведем вас к&nbsp;заветной цели 💙</p>
                    </div>
                </div>
                <a href="https://t.me/careerum_support?roistat_visit=660124" target="_blank"
                    class="btn-color-main-dark-orange careerum-flex-cc hidden-desc-tablet">
                    <svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M6.9104 12.5754L9.51374 19.781C9.51374 19.781 9.83922 20.4552 10.1877 20.4552C10.5363 20.4552 15.7201 15.0624 15.7201 15.0624L21.4847 3.92822L7.00329 10.7153L6.9104 12.5754Z"
                            fill="#C8DAEA"></path>
                        <path
                            d="M10.3623 14.4233L9.86251 19.7346C9.86251 19.7346 9.65332 21.362 11.2804 19.7346C12.9074 18.1072 14.4648 16.8522 14.4648 16.8522"
                            fill="#A9C6D8"></path>
                        <path
                            d="M6.9574 12.8324L1.60225 11.0876C1.60225 11.0876 0.962247 10.828 1.16833 10.2392C1.21075 10.1177 1.29633 10.0144 1.55233 9.83687C2.73889 9.00981 23.5146 1.54247 23.5146 1.54247C23.5146 1.54247 24.1012 1.3448 24.4471 1.47628C24.5327 1.50277 24.6097 1.55152 24.6703 1.61755C24.7309 1.68357 24.7728 1.7645 24.7918 1.85205C24.8292 2.00668 24.8448 2.16578 24.8383 2.32473C24.8366 2.46224 24.82 2.58969 24.8074 2.78956C24.6808 4.83116 20.8942 20.0683 20.8942 20.0683C20.8942 20.0683 20.6677 20.9599 19.856 20.9904C19.6565 20.9969 19.4578 20.9631 19.2716 20.8911C19.0855 20.8191 18.9157 20.7103 18.7725 20.5713C17.1797 19.2012 11.6742 15.5012 10.4577 14.6875C10.4302 14.6688 10.4071 14.6445 10.3899 14.6161C10.3727 14.5877 10.3617 14.5559 10.3578 14.523C10.3408 14.4372 10.4341 14.3309 10.4341 14.3309C10.4341 14.3309 20.0205 5.80981 20.2756 4.91527C20.2954 4.84597 20.2208 4.81177 20.1206 4.84213C19.4838 5.07637 8.44622 12.0467 7.22803 12.816C7.14034 12.8425 7.04766 12.8481 6.9574 12.8324Z"
                            fill="white"></path>
                    </svg>
                    <p id="i03ubjg">Написать нам в Telegram</p>
                </a>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-blackfriday-mini', {
        label: 'Black friday main mini (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-blackfriday-mini main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1731910870671-8wMca-Elli.png" alt=""
                class="position-absolute z-10">
            <div class="careerum-flex-fsfs position-relative z-20 blackfriday-mini__top">
                <div class="position-relative">
                    <h1 class="position-relative z-10">BLACK FRIDAY</h1>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732087441952-QhniV-Soft.svg"
                        alt="" class="position-absolute z-20 hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732095446798-lWx8b-Grou.png"
                        alt="" class="position-absolute z-20 hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732102990307-sJjMO-Grou.png"
                        alt="" class="position-absolute z-20 hidden-desc-tablet">
                </div>
                <div class="position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732088491366-QHtRr-Grou.png"
                        alt="" class="position-absolute z-10 hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732095699205-5ASbQ-Soft.png"
                        alt="" class="position-absolute z-10 hidden-desc-mobile">
                    <p class="blackfriday-mini__subheader position-relative z-20">Больше никаких «черных понедельников»
                        на работе</p>
                    <p class="blackfriday-mini__text position-relative z-20">Лучшие инструменты Careerum для запуска
                        вашей карьеры в космос!</p>
                </div>
                <div>
                    <a href="#form" class="btn-color-main-dark-orange">Зарегистрироваться бесплатно</a>
                </div>
            </div>
            <div class="blackfriday-mini__center position-relative z-20">
                <div class="blackfriday-mini__center-header position-relative">
                    <h2>После регистрации вы получите</h2>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732088625516-cMx0r-Unio.svg"
                        alt="" class="position-absolute hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732096105492-yDQ18-Grou.png"
                        alt="" class="position-absolute hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732101266490-BKgHM-Grou.png"
                        alt="" class="position-absolute hidden-desc-tablet">
                </div>
                <div class="blackfriday-mini__center-row1 position-relative careerum-flex-sbfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732090285714-w52Ap-Soft.png"
                        alt="" class="position-absolute hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732101558827-ymFft-Grou.png"
                        alt="" class="position-absolute hidden-desc-tablet">
                    <div class="blackfriday-mini__center-row-header careerum-flex-fsfs">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732090324312-2vgc7-Gift.svg"
                                alt="" class="hidden-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732101429959-yvPO3-Gift.svg"
                                alt="" class="hidden-desc-tablet">
                        </div>
                        <div>
                            <p>Подарки</p>
                            <p>самые важные шаблоны для поиска работы</p>
                        </div>
                    </div>
                    <div class="blackfriday-mini__center-row-content careerum-flex-fsfs position-relative">
                        <div>
                            <p>Шаблоны резюме</p>
                            <p>На русском и английском </p>
                        </div>
                        <div>
                            <p>Шаблоны сопроводительного</p>
                            <p>На русском и английском </p>
                        </div>
                        <div>
                            <p>Шаблон воронки поиска работы</p>
                        </div>
                        <div>
                            <p>Шаблон для поиска достижений в резюме</p>
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732090350618-adOk5-Soft.png"
                            alt="" class="position-absolute hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732096736844-YwyHh-Grou.png"
                            alt="" class="position-absolute hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732102083433-J0cbz-Soft.png"
                            alt="" class="position-absolute hidden-desc-tablet">
                    </div>
                </div>
                <div class="blackfriday-mini__center-row2 position-relative careerum-flex-sbfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732090395032-s4smc-Grou.png"
                        alt="" class="position-absolute hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732102204590-auOAE-Soft.png"
                        alt="" class="position-absolute hidden-desc-tablet">
                    <div class="blackfriday-mini__center-row-header careerum-flex-fsc">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732090369169-WzyHp-Alar.svg"
                                alt="" class="hidden-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732102257014-1x5Pu-Alar.svg"
                                alt="" class="hidden-desc-tablet">
                        </div>
                        <div>
                            <p>Будете первым</p>
                        </div>
                    </div>
                    <div class="blackfriday-mini__center-row-content careerum-flex-fsfs">
                        <div>
                            <p>Раньше всех узнаете о старте распродажи</p>
                        </div>
                        <div>
                            <p>Получите доступ к секретным предложениям</p>
                        </div>
                    </div>
                </div>
                <div class="blackfriday-mini__center-row3 position-relative careerum-flex-sbfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732090473251-R73mQ-Soft.png"
                        alt="" class="position-absolute hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732097471151-HoZKj-Soft.png"
                        alt="" class="position-absolute hidden-desc-mobile ">
                    <div class="blackfriday-mini__center-row-header careerum-flex-fsfs">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732090496439-i14ac-Spar.svg"
                                alt="" class="hidden-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732102715673-EauTU-Spar.svg"
                                alt="" class="hidden-desc-tablet">
                        </div>
                        <div>
                            <p>Лучшие курсы из подписки Сareerum </p>
                        </div>
                    </div>
                    <div class="blackfriday-mini__center-row-content position-relative">
                        <div>
                            <p>Купить курсы по отдельности можно только в дни Черной пятницы</p>
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732090525217-mNNEf-Grou.png"
                            alt="" class="position-absolute hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732097607850-0WAtP-Grou.png"
                            alt="" class="position-absolute hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732102814481-Ey9Dj-Grou.png"
                            alt="" class="position-absolute hidden-desc-tablet">
                    </div>
                </div>
                <div class="blackfriday-mini__center-link">
                    <a href="#form" class="btn-color-main-dark-orange">Зарегистрироваться бесплатно</a>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-blackfriday-form', {
        label: 'Black friday form (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-blackfriday-form main-wrapper">
        <div class="careerum-container-responsive">
            <div class="position-relative z-20 blackfriday-main__center">
                <div class="position-absolute blackfriday-main__center-top careerum-flex-fsc">
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                </div>
                <div class="position-absolute blackfriday-main__center-bottom careerum-flex-fsc">
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                </div>
            </div>
            <div class="position-relative z-10 blackfriday-form__wrapper careerum-flex-sbfs">
                <div class="position-relative">
                    <div class="blackfriday-form__wrapper-label">
                        <p>29.11 — 2.12</p>
                    </div>
                    <h2>BLACK FRIDAY</h2>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732093891499-OGwP4-Soft.png"
                        alt="" class="position-absolute hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732103370450-YA9sb-Grou.png"
                        alt="" class="position-absolute hidden-desc-tablet">
                </div>
                <div>
                    <div class="careerum-registration-form-club40">
                        <form class="deva-form" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                            <div class="careerum-club40-form-name">
                                <input type="text" name="name" value="" required placeholder="Имя">
                            </div>
                            <div class="careerum-club40-form-email">
                                <input type="text" name="email" value="" required placeholder="Почта">
                            </div>
                            <div class="careerum-club40-form-phone">
                                <input type="tel" value="" name="tel" required class="itl-input">
                            </div>
                            <div class="careerum-club40-form-agree">
                                <label>
                                    <input type="checkbox" name="agree">
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                            fill="none">
                                            <path
                                                d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                        </svg>
                                    </div>
                                </label>
                                <p>Я даю согласие на обработку своих персональных данных в соответствии с <a
                                        href="#">Политикой конфиденциальности</a></p>
                            </div>
                            <a href="#" class="submit-btn btn-color-main-bright-orange button-sent"
                                disabled>Зарегистрироваться бесплатно</a>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-blackfriday-banner', {
        label: 'Black friday banner (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-blackfriday-banner z-50" data-redirect="no" data-url="" data-static="yes" data-offset=""
        data-timer-end="12/02/2024 23:59 GMT+0300">
        <div class="careerum-container-responsive careerum-flex-sbc">
            <div>
                <p class="hidden-mobile">29.11 — 2.12</p>
                <p>Распродажа закончится через</p>
            </div>
            <div class="blackfriday-banner-timer careerum-flex-cc">
                <div>
                    <p class="timer-day-number">00</p>
                    <p class="timer-day-text">дней</p>
                </div>
                <div>
                    <p class="timer-hour-number">00</p>
                    <p class="timer-hour-text">часов</p>
                </div>
                <div>
                    <p class="timer-min-number">00</p>
                    <p class="timer-min-text">минут</p>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-blackfriday-popup', {
        label: 'Black friday popup 2 предложения (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-popup careerum-blackfriday-popup" id="rub2">
            <div class="popup__close-button-wrapper">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"
                    class="close-switch">
                    <rect width="32" height="32" rx="16" fill="#C2C2C2" />
                    <g clip-path="url(#clip0_7555_2802)">
                        <path d="M20.7979 20.6359L11.2059 11.083" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M11.1998 20.639L20.8018 11.0781" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_7555_2802">
                            <rect width="12" height="12" fill="white" transform="translate(10 10)" />
                        </clipPath>
                    </defs>
                </svg>
            </div>
            <div class="blackfriday-popup-content">
                <div class="careerum-flex-sbst">
                    <div class="blackfriday-popup-content-left careerum-flex-fsfs">
                        <h3>Курс «Продающее резюме»</h3>
                        <div>
                            <div class="careerum-flex-fsc blackfriday-tale__descr">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <p>Доступ на 90 дней</p>
                            </div>
                            <div class="careerum-flex-fsc blackfriday-tale__price">
                                <p class="price-current">5 690 ₽</p>
                                <p class="price-old">14900 ₽</p>
                                <p>— 60%</p>
                            </div>
                        </div>
                        <a href="#buy" class="btn-color-main-dark-blue close-switch popup-open-next">Купить только этот курс</a>
                    </div>
                    <div class="blackfriday-popup-content-right">
                        <h3>Набор из 2 курсов</h3>
                        <p class="blackfriday-popup__label">курс</p>
                        <h5>Продающее резюме</h5>
                        <p class="blackfriday-popup__label">курс</p>
                        <h5>Пробейте карьерный потолок</h5>
                        <div>
                            <div class="careerum-flex-fsc blackfriday-tale__descr">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <p>Доступ на 90 дней</p>
                            </div>
                            <div class="careerum-flex-fsc blackfriday-tale__price">
                                <p class="price-current">8 880 ₽</p>
                                <p class="price-old">29800 ₽</p>
                                <p>— 70%</p>
                            </div>
                        </div>
                        <a href="#buy" class="btn-color-main-dark-orange close-switch popup-open-next">Купить 2 курса</a>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-gift', {
        label: 'Gift (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-gift main-wrapper">
        <div class="careerum-container-responsive">
            <div class="position-relative z-10 gift-backgrounds">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734950889834-rHAQw-Grou.png" class="position-absolute hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734951099806-gRn0x-Elli.png" class="position-absolute hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734951100141-3NBB6-Grou.png" class="position-absolute hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734971344861-JsQEk-Grou.png" class="position-absolute hidden-desc-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734971345352-LczH3-Elli.png" class="position-absolute hidden-desc-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734971345510-AI8mC-Grou.png" class="position-absolute hidden-desc-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734973591828-HO3KP-Grou.png" class="position-absolute hidden-desc-tablet">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734973592436-WenHI-Elli.png" class="position-absolute hidden-desc-tablet">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734973592323-IrWRN-Grou.png" class="position-absolute hidden-desc-tablet">
            </div>
            <div class="position-relative z-20 gift-top-logo">
                <a href="#">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734936850728-lmFrT-logo.svg"
                        alt="logo">
                </a>
            </div>
            <div class="position-relative z-20 careerum-flex-sbfs gift-form-top">
                <div>
                    <h1>Подарок для коллег, который выделит вас из череды поздравлений от GPT-чата</h1>
                    <div class="careerum-flex-fsfs gift-form-top-imgs">
                        <div class="gift-form-top-img-left">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734947838017-MnYVP-Fram.png" alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734962914067-eV7bV-Fram.png" alt="" class="hidden-desc">
                        </div>
                        <div class="gift-form-top-img-right">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734947839757-1Rh3U-Fram.png" alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734962914187-LkN79-Fram.png" alt="" class="hidden-desc">
                        </div>
                    </div>
                </div>
                <div class="gift-form-wrapper">
                    <div class="careerum-registration-form-club40">
                        <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                            <div class="careerum-club40-form-name">
                                <input type="text" name="name" value="" required placeholder="Имя">
                            </div>
                            <div class="careerum-club40-form-email">
                                <input type="text" name="email" value="" required placeholder="Почта">
                            </div>
                            <div class="careerum-club40-form-phone">
                                <input type="tel" value="" name="tel" required class="itl-input">
                            </div>
                            <div class="careerum-club40-form-agree">
                                <label>
                                    <input type="checkbox" name="agree">
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                            fill="none">
                                            <path
                                                d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                        </svg>
                                    </div>
                                </label>
                                <p>Я даю согласие на обработку своих персональных данных в соответствии с <a href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                            </div>
                            <a href="#" class="submit-btn btn-color-main-bright-orange button-sent" disabled>Забрать подарки для коллег</a>
                        </form>
                    </div>
                </div>
            </div>
            <div class="position-relative z-20 careerum-flex-fsfs gift-cards">
                <div class="position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734948657417-ExXly-Grou.svg" alt="" class="position-absolute hidden-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734972396090-LsxxB-Grou.svg" alt="" class="position-absolute hidden-desc-tablet">
                    <h2>Набор из 20 открыток</h2>
                    <p class="gift-cards-text">С классной графикой и веселым пожеланием. Хватит на всех коллег!</p>
                    <p class="gift-cards-text">В формате PDF: можно отправить коллеге онлайн или распечатать</p>
                </div>
                <div class="careerum-flex-fsfs position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734948792866-5Nqot-Fram.png" alt="" class="position-relative hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734948792988-MIAsP-Fram.png" alt="" class="position-relative hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734948792456-Betc7-Fram.png" alt="" class="position-relative hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734963359415-6O2Jv-Grou.png" alt="" class="position-relative hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734972523654-JjGcE-Ð¾Ñ.png" alt="" class="position-relative hidden-desc-tablet">
                </div>
            </div>
            <div class="position-relative z-20 careerum-flex-fsfs gift-bot">
                <div class="position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734949510687-SizIJ-Grou.svg" alt="" class="position-absolute hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734963767444-xaGrI-Grou.svg" alt="" class="position-relative hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734972949222-FB5UL-Grou.svg" alt="" class="position-relative hidden-desc-tablet">
                    <h2>Бот с карьерными аффирмациями</h2>
                    <p class="gift-bot-text">Бот будет слать аффирмации с нотками карьерного роста вашему коллеге:</p>
                    <ul>
                        <li>Чтобы понедельники радовали</li>
                        <li>Чтобы не проваливаться в синдром самозванца</li>
                        <li>Чтобы замечать свои успехи</li>
                        <li>Чтобы расти в профессии</li>
                    </ul>
                </div>
                <div class="position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734949709865-j8Whk-Fram.png" alt="" class="position-relative hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734963605425-dX3jj-Fram.png" alt="" class="position-relative hidden-desc">
                    <div class="position-absolute gift-bot-chats">
                        <div class="position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734949710219-70WlA-chat.png" alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734963606070-S8qeR-chat.png" alt="" class="hidden-desc">
                            <p class="position-absolute">Я всегда стремлюсь к профессиональному и личному росту.</p>
                        </div>
                        <div class="position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734949710434-OrP4s-chat.png" alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734963605945-2VCQj-chat.png" alt="" class="hidden-desc">
                            <p class="position-absolute">Я открыто говорю о своих успехах и достижениях.</p>
                        </div>
                        <div class="position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734949710326-x8od6-chat.png" alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734963605795-izSHZ-chat.png" alt="" class="hidden-desc">
                            <p class="position-absolute">Я не боюсь совершать ошибки</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="position-relative z-20 careerum-flex-sbfs gift-form-bottom">
                <div>
                    <p class="gift-form-bottom-header">Нетворкинг — двигатель карьеры,  а Новый год — прекрасный повод, чтобы поддерживать связи</p>
                </div>
                <div class="gift-form-wrapper">
                    <div class="careerum-registration-form-club40">
                        <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                            <div class="careerum-club40-form-name">
                                <input type="text" name="name" value="" required placeholder="Имя">
                            </div>
                            <div class="careerum-club40-form-email">
                                <input type="text" name="email" value="" required placeholder="Почта">
                            </div>
                            <div class="careerum-club40-form-phone">
                                <input type="tel" value="" name="tel" required class="itl-input">
                            </div>
                            <div class="careerum-club40-form-agree">
                                <label>
                                    <input type="checkbox" name="agree">
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                            fill="none">
                                            <path
                                                d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                        </svg>
                                    </div>
                                </label>
                                <p>Я даю согласие на обработку своих персональных данных в соответствии с <a href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                            </div>
                            <a href="#" class="submit-btn btn-color-main-bright-orange button-sent" disabled>Забрать подарки для коллег</a>
                        </form>
                    </div>
                </div>
            </div>
            <div class="position-relative z-20 gift-bottom-logo careerum-flex-fsc">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734950717967-BtVec-Unio.svg" alt="">
                <p>© Careerum 2024<br>
                    Все права защищены</p>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-veb4-main', {
        label: 'Veb 4 main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-veb4-main main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736950651807-6b5Dy-Elli.png" alt=""
                        class="hidden-desc-tablet position-absolute z-10">
                    <div class="veb4-main-top position-relative z-20">
                        <div class="veb4-main-logo careerum-flex-cc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736925596516-FtEaP-logo.svg"
                                alt="" class="hidden-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736950477033-PxsRw-Grou.svg"
                                alt="" class="hidden-desc-tablet">
                            <p>платформа карьерного развития</p>
                        </div>
                        <div class="veb4-main-date careerum-flex-cc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736949235494-I9oAA-Cale.svg"
                                alt="" class="hidden-desc-tablet">
                            <p>18 февраля, 19:00 мск</p>
                        </div>
                        <div class="veb4-main-subheader">
                            <p>Бесплатный мастер-класс</p>
                        </div>
                        <div class="veb4-main-header position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736926183347-QUGUJ-Grou.svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736926182956-AtQV0-Grou.svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736942909360-jfBcT-Grou.svg"
                                alt="" class="position-absolute hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736942909087-IIaw0-Grou.svg"
                                alt="" class="position-absolute hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736951304683-0xD9G-Grou.svg"
                                alt="" class="position-absolute hidden-desc-tablet">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736951304411-EmDAQ-Grou.svg"
                                alt="" class="position-absolute hidden-desc-tablet">
                            <h1>Разбор ошибок поиска работы</h1>
                        </div>
                        <div class="veb4-main-speakers careerum-flex-cst">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736926498127-1Moo4-Mask.png"
                                    alt="">
                                <p>Ольга Лермонтова, карьерный стратег,<br> Италия</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736926498393-FvGzg-Mask.png"
                                    alt="">
                                <p>Софи Бессон, карьерный эксперт,<br> Израиль</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736926498602-xyDdb-Mask.png"
                                    alt="">
                                <p>Майя Бурякина, карьерный эксперт,<br> США</p>
                            </div>
                        </div>
                        <div class="veb4-main-button">
                            <div class="careerum-flex-cfs">
                                <p>0₽</p>
                                <p>4990₽</p>
                            </div>
                            <a href="#form-top" class="btn-color-main-dark-orange">Зарегистрироваться бесплатно</a>
                        </div>
                        <div class="veb4-main-label position-absolute careerum-flex-cc">
                            <p><span>всего<br> 3 000 </span> бесплатных<br> мест</p>
                        </div>
                        <div class="veb4-main-speakers-label position-absolute">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736926183240-iiRlr-Grou.svg"
                                alt="" class="position-relative hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736945259231-5jkx2-Grou.svg"
                                alt="" class="position-relative hidden-desc">
                            <p>Спикеры</p>
                        </div>
                    </div>
                    <div class="veb4-main-bottom careerum-flex-sbfs position-relative z-20">
                        <div>
                            <p>Узнайте, как получить job offer уже этой весной:</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736928652870-1TAFs-Chec.svg"
                                        alt="">
                                    <p>Обсудим тренды найма в РФ и за рубежом в 2025 году</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736928652764-dc0XW-Targ.svg"
                                        alt="">
                                    <p>Топ-10 главных ошибок поиска работы</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736928652497-K8yBL-Note.svg"
                                        alt="">
                                    <p>Найдем слабые места в вашем резюме и усилим его</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736928652497-K8yBL-Note.svg"
                                        alt="">
                                    <p>Разберем кейсы кандидатов, которые привели к офферам</p>
                                </li>
                            </ul>
                        </div>
                        <div class="veb4-main-bottom-right-wrapper">
                            <div class="veb4-main-bottom-right">
                                <div class="careerum-flex-fsfs">
                                    <p>4990₽</p>
                                    <div class="careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740388082908-oiKTq-Lock.svg"
                                            alt="">
                                        <p>Доступ на 30 дней</p>
                                    </div>
                                </div>
                                <a href="#" class="btn-color-main-dark-orange">Купить запись мастер-класса</a>
                            </div>
                        </div>
                        <div>
                            <div class="careerum-registration-form-club40">
                                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                    data-gjs-type="deva-registration-form">
                                    <div class="careerum-club40-form-name">
                                        <input type="text" name="name" value="" required placeholder="Имя">
                                    </div>
                                    <div class="careerum-club40-form-telegram">
                                        <input type="text" name="telegram" value="" required placeholder="Telegram">
                                    </div>
                                    <div class="careerum-club40-form-email">
                                        <input type="text" name="email" value="" required placeholder="Почта">
                                    </div>
                                    <div class="careerum-club40-form-phone">
                                        <input type="tel" value="" name="tel" required class="itl-input">
                                    </div>
                                    <div class="careerum-club40-form-agree">
                                        <label>
                                            <input type="checkbox" name="agree">
                                            <div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                    fill="none">
                                                    <path
                                                        d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                        stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </label>
                                        <p>Я даю согласие на обработку своих персональных данных в соответствии с <a
                                                href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                                    </div>
                                    <a href="#" class="submit-btn btn-color-main-bright-orange button-sent"
                                        disabled>Зарегистрироваться бесплатно</a>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });

    blockManager.add('careerum-veb4-problems', {
        label: 'Veb 4 problems (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-veb4-problems main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Прожарки — в прямом эфире эксперты разберут вашу проблему и дадут решение </h2>
                    <div class="veb4-problems-items careerum-flex-fsst">
                        <div class="veb4-problems-item position-relative">
                            <p class="veb4-problems-item-header position-relative z-20">Прожарка резюме и LinkedIn</p>
                            <p class="veb4-problems-item-text position-relative z-20">Подготовьте свое CV и ссылку на LinkedIn.
                                Будь готовы скинуть
                                в чат во время эфира</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736935871039-eT2ri-3d-i.png"
                                alt="" class="position-absolute hidden-tablet-mobile z-10">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736947607375-C9g83-3d-i.png"
                                alt="" class="position-absolute hidden-desc-mobile z-10">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736952574883-izTjR-3d-i.png"
                                alt="" class="position-absolute hidden-desc-tablet z-10">
                        </div>
                        <div class="veb4-problems-item position-relative">
                            <p class="veb4-problems-item-header position-relative z-20">Прожарка ваших ошибок поиска</p>
                            <p class="veb4-problems-item-text position-relative z-20">После регистрации заполните анкету и
                                опишите вашу проблему поиска
                                работы. Эксперты сделают разбор в прямом эфире</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736935363047-yk19N-3dic.png"
                                alt="" class="position-absolute hidden-tablet-mobile z-10">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736947607646-8iqUJ-3dic.png"
                                alt="" class="position-absolute hidden-desc-mobile z-10">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736952575157-tzjbK-3dic.png"
                                alt="" class="position-absolute hidden-desc-tablet z-10">
                        </div>
                        <div class="veb4-problems-item position-relative">
                            <p class="veb4-problems-item-header white position-relative z-20">Разбор успешных кейсов кандидатов
                            </p>
                            <p class="veb4-problems-item-text white position-relative z-20">Поделимся кейсами клиентов, которые
                                уже работают в крупных
                                компаниях по всему миру</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736935781880-SVcag-3dic.png"
                                alt="" class="position-absolute hidden-tablet-mobile z-10">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736947607771-NbToc-3dic.png"
                                alt="" class="position-absolute hidden-desc-mobile z-10">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736952575277-DiESd-3dic.png"
                                alt="" class="position-absolute hidden-desc-tablet z-10">
                        </div>
                    </div>
                </div>
            </div>`
    });

    blockManager.add('careerum-veb4-form', {
        label: 'Veb 4 form (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-veb4-form main-wrapper">
                <div class="careerum-container-responsive careerum-flex-sbfs position-relative">
                    <div>
                        <div class="veb4-form-label careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736949235494-I9oAA-Cale.svg"
                                alt="" class="hidden-desc">
                            <p>18 февраля, 19:00 мск</p>
                        </div>
                        <div class="veb4-form-subheader">
                            <p>Бесплатный мастер-класс</p>
                        </div>
                        <div class="veb4-form-header position-relative">
                            <h2>Разбор ошибок поиска работы</h2>
                            <div class="position-absolute">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736939895228-zeoHb-Grou.svg"
                                    alt="" class="position-absolute hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736939894354-KVhTB-Grou.svg"
                                    alt="" class="position-absolute hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736949623688-Kr4Em-Grou.svg"
                                    alt="" class="position-absolute hidden-desc-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736949623420-8fdGM-Grou.svg"
                                    alt="" class="position-absolute hidden-desc-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736953912661-mWEsK-Grou.svg"
                                    alt="" class="position-absolute hidden-desc-tablet">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736953912392-nkgHk-Grou.svg"
                                    alt="" class="position-absolute hidden-desc-tablet">
                            </div>
                        </div>
                        <ul class="hidden-tablet-mobile">
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736928652764-dc0XW-Targ.svg"
                                    alt="">
                                <p>Рассмотрим топ-10 главных ошибок</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736928652870-1TAFs-Chec.svg"
                                    alt="">
                                <p>Обсудим тренды найма в РФ и за рубежом в 2025 году</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736928652497-K8yBL-Note.svg"
                                    alt="">
                                <p>Найдем слабые места в вашем резюме и усилим его</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736928652497-K8yBL-Note.svg"
                                    alt="">
                                <p>Разберем кейсы кандидатов, которые привели к офферам</p>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <div class="careerum-registration-form-club40">
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                                <div class="careerum-club40-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я даю согласие на обработку своих персональных данных в соответствии с <a
                                            href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                                </div>
                                <div class="careerum-club40-form-price careerum-flex-fsfs hidden-tablet-mobile">
                                    <p>0₽</p>
                                    <p>4990₽</p>
                                </div>
                                <a href="#" class="submit-btn btn-color-main-bright-orange button-sent"
                                    disabled>Зарегистрироваться бесплатно</a>
                            </form>
                        </div>
                    </div>
                    <div class="veb4-form-label-absolute position-absolute careerum-flex-cc">
                        <p><span>всего<br> 3 000 </span> бесплатных<br> мест</p>
                    </div>
                </div>
            </div>`
    });

    blockManager.add('careerum-veb4-reviews', {
        label: 'Veb 4 reviews',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-veb4-reviews main-wrapper">
        <div class="careerum-container-responsive">
            <h2>
                Отзывы о мастер-классе
            </h2>
            <div class="veb4-reviews-slider-wrapper">
                <div class="veb4-reviews-slider">
                    <div class="veb4-reviews-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740389145330-LPZI9-Grou.png"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740395529224-SL34w-Grou.png"
                            alt="" class="hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740399621516-UqvkB-Grou.png"
                            alt="" class="hidden-desc-tablet">
                    </div>
                    <div class="veb4-reviews-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740389145101-GHBFB-Grou.png"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740395529017-VIaLI-Grou.png"
                            alt="" class="hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740399621294-CmmKG-Grou.png"
                            alt="" class="hidden-desc-tablet">
                    </div>
                    <div class="veb4-reviews-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740389144866-eBX5n-Grou.png"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740395528854-u7dHD-Grou.png"
                            alt="" class="hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740399621107-W2FxV-Grou.png"
                            alt="" class="hidden-desc-tablet">
                    </div>
                    <div class="veb4-reviews-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740389144459-RdEXL-Fram.png"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740395528492-snR9w-Fram.png"
                            alt="" class="hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740399620770-w4hSc-Fram.png"
                            alt="" class="hidden-desc-tablet">
                    </div>
                </div>
            </div>
            <div class="veb4-reviews-nav careerum-flex-fec">
                <div class="veb4-reviews-nav-prev">
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_1227_3497)">
                            <foreignObject x="-18.1166" y="-18.1167" width="76.2332" height="76.2332">
                                <div xmlns="http://www.w3.org/1999/xhtml"
                                    style="backdrop-filter:blur(9.06px);clip-path:url(#bgblur_1_1227_3497_clip_path);height:100%;width:100%">
                                </div>
                            </foreignObject>
                            <rect data-figma-bg-blur-radius="18.1166" y="39.9999" width="40" height="40"
                                transform="rotate(-90 0 39.9999)" fill="black" />
                            <path d="M13.1905 19.9993L26.8105 19.9993" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M19.4629 26.2453L13.1896 19.9986L19.4629 13.752" stroke="white"
                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="bgblur_1_1227_3497_clip_path">
                                <rect transform="translate(18.1166 18.1167)" y="39.9999" width="40" height="40"
                                    transform="rotate(-90 0 39.9999)" />
                            </clipPath>
                            <clipPath id="clip0_1227_3497">
                                <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <div class="veb4-reviews-nav-next">
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_1227_3501)">
                            <foreignObject x="-18.1166" y="-18.1165" width="76.2332" height="76.2332">
                                <div xmlns="http://www.w3.org/1999/xhtml"
                                    style="backdrop-filter:blur(9.06px);clip-path:url(#bgblur_1_1227_3501_clip_path);height:100%;width:100%">
                                </div>
                            </foreignObject>
                            <rect data-figma-bg-blur-radius="18.1166" x="40" y="0.00012207" width="40" height="40"
                                transform="rotate(90 40 0.00012207)" fill="black" />
                            <path d="M26.8095 20.0007L13.1895 20.0007" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M20.5371 13.7547L26.8104 20.0014L20.5371 26.248" stroke="white"
                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="bgblur_1_1227_3501_clip_path">
                                <rect transform="translate(18.1166 18.1165)" x="40" y="0.00012207" width="40"
                                    height="40" transform="rotate(90 40 0.00012207)" />
                            </clipPath>
                            <clipPath id="clip0_1227_3501">
                                <rect x="40" width="40" height="40" rx="20" transform="rotate(90 40 0)" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-veb4-static-reviews', {
        label: 'Veb 4 reviews static',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-course41-static-reviews main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Отзывы</h2>
                    <div class="course41-reviews-items">
                        <div class="careerum-flex-sbst course41-reviews-items-wrapper">
                            <div>
                                <div class="course41-reviews-item">
                                    <p class="course41-reviews-item__name">Александра</p>
                                    <p class="course41-reviews-item__position">Finance manager | Finance analytics</p>
                                    <p class="course41-reviews-item__text">Синдром самозванца подтолкнул к решению вступить в клуб.
                                        Я поняла, что уверенность в себе нужно взрастить, а для этого — двигаться поэтапно.<br><br>
                                        В самоопределении очень помог нетворк, выстроенный в клубе. Я встретила несколько человек,
                                        которые были на финальных этапах или уже сдали профессиональную квалификацию
                                        для специалистов в сфере финансов CIMA, которую я начинала. <br><br>Я считала серьёзным
                                        препятствием для карьеры присущие мне сложности в коммуникациях с новыми людьми. Клуб
                                        позволил посмотреть на это без страха и усилить навык.<br><br>
                                        Очень важным оказалось осознать факт, что когда ты переходишь в новую компанию, нормально
                                        задавать вопросы.<br><br>
                                        Моё сознание после курса перевернулось, когда я поняла, что не надо в первые же дни пытаться
                                        показать, какой ты профессиональный и классный. Больше уважения вызывает человек, который
                                        интересуется ситуацией и готов принимать помощь.</p>
                                </div>
                                <div class="course41-reviews-item">
                                    <p class="course41-reviews-item__name">Мари</p>
                                    <p class="course41-reviews-item__position">Scientist/Researcher in ultrafast optics</p>
                                    <p class="course41-reviews-item__text">Курс по самооценке помог укрепить веру в себя и мои цели.
                                        Ценные замечания клубовцев, их личные истории помогли моей самооценке взлететь ещё выше.
                                        Общение в клубе очень экологичное, никто никогда не скажет: „куда это ты собралась вообще,
                                        придумала тоже!</p>
                                </div>
                            </div>
                            <div>
                                <div class="course41-reviews-item">
                                    <p class="course41-reviews-item__name">Илона</p>
                                    <p class="course41-reviews-item__position">Chief Executive Officer</p>
                                    <p class="course41-reviews-item__text">У меня были сильные сомнения в себе. Команда мне не доверяла, руководителю казалось, что мои результаты не вау. Я пришла в Careerum онять, есть ли у меня сильные стороны и могу ли я рассчитывать на то, что хочу<br><br>
            
                                        Я начала работать с карьерным консультантом и проходить курсы по самооценке.<br><br>
                                        
                                        Когда мы общались в тройках, я видела стратегические ошибки управленцев в компаниях девочек из нашей тройки. Я подмечала такие вещи, про которые они говорили, что никогда бы не заметили их. Это очень сильно придало мне уверенности</p>
                                </div>
                                <div class="course41-reviews-item">
                                    <p class="course41-reviews-item__name">Анна</p>
                                    <p class="course41-reviews-item__position">LX Designer</p>
                                    <p class="course41-reviews-item__text">В клуб я пришла в свой первый личный кризис 25 лет. И сейчас я чувствую, что прошла через трансформацию себя. Я осознала свои ценности и свою ценность. Почти год у меня ушёл на курсы RealMe и «Сколько я стою», но оно того стоило. Я благодарна себе за то, что не торопилась и прошла этот путь основательно.<br><br>
                                        Хочу сказать спасибо команде Careerum за развитие поддерживающего сообщества. Не знаю ни одного другого места, где я бы не боялась раскрываться и получать обратную связь: столь бережную, но, одновременно с этим, развивающую. Я точно ещё не раз вернусь в Careerum — как минимум в роли участника, а может быть и в роли амбассадора или даже сотрудника.</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-flex-sbst course41-reviews-items-wrapper items-wrapper-bottom">
                            <div>
                                <div class="course41-reviews-item">
                                    <p class="course41-reviews-item__name">Татьяна</p>
                                    <p class="course41-reviews-item__text">Итак, клуб повысил самооценку — привет Анне Бабич, объяснил, как выгорать меньше — стала планировать отдых, научил формулировать достижения, разговаривать с коллегами. Ну а ещё я написала классное резюме, которое не использовала на внешнем рынке, но при релокации и переходе из DT в Accenture Hungary (продажа подразделения) постоянно на него ссылалась — и самой его приятно перечитывать иногда, чтобы вспомнить, что я ого-го))<br>Спасибо!</p>
                                </div>
                                <div class="course41-reviews-item">
                                    <p class="course41-reviews-item__name">Юлия</p>
                                    <p class="course41-reviews-item__text">Ещё, вдохновлённая работой с коучем, решила и сама научиться коучингу. В итоге сейчас имею 7 месяцев обучения коучинг, уже обучаюсь на уровень PCC, но ещё недостаточно часов практики для сертификации, имею план развития себя как специалиста в своей профессии на след. год. С Карьерумом сделала самое страшное для себя — поговорила с менеджментом, что хочу поменять — и о! чудо! меня полностью поддержали 😃 Конкретного плана ещё нет, поэтому до Нового Года хочу составить план, что необходимо выучить и какие курсы пройти, так как решила менять свою специализацию, и обучение необходимо для хард скиллов.</p>
                                </div>
                                <div class="course41-reviews-item">
                                    <p class="course41-reviews-item__name">Александра</p>
                                    <p class="course41-reviews-item__text">Оксана, добрый день! Прошла на платформе курс по самооценке, всё получилось отлично — подобралась прекрасная тройка, так что мы всё сделали в хорошем темпе и с прекрасной обратной связью друг от друга. Параллельно я искала работу и, собственно, сегодня вышла на новую должность в новой стране. Темы, которые обсуждали с девочками в рамках курса, очень помогли чувствовать себя увереннее на интервью.</p>
                                </div>
                            </div>
                            <div>
                                <div class="course41-reviews-item">
                                    <p class="course41-reviews-item__name">Елена</p>
                                    <p class="course41-reviews-item__position">Первый заместитель генерального директора</p>
                                    <p class="course41-reviews-item__text">Начала с программы «Самооценка и деньги» и практикумов с Анной Бабич — смогла почувствовать себя сильным профессионалом и снизить уровень перфекционизма. А чек-лист переговоров стал главным инструментом общения в профессиональной сфере и теперь стабильно помогает достигать поставленных целей.</p>
                                </div>
                                <div class="course41-reviews-item">
                                    <p class="course41-reviews-item__name">Юлия</p>
                                    <p class="course41-reviews-item__position">3D-дизайнер</p>
                                    <p class="course41-reviews-item__text">Начала с курса по самооценке Анны Бабич. Курс настолько понравился, что до сих пор просматриваю свои конспекты. Они наполнены большой любовью, уверенностью, устойчивостью и внутренней силой. Этот курс стал мощной базой. Я поняла, что это было крайне необходимо перед тем, как перейти к непосредственно поиску и всему, что связано с новой работой.
                                    </p>
                                </div>
                                <div class="course41-reviews-item">
                                    <p class="course41-reviews-item__name">Мария</p>
                                    <p class="course41-reviews-item__position">Коуч</p>
                                    <p class="course41-reviews-item__text">Вот прям вчера у меня был пример на собеседовании. После вопроса об ожидаемом уровне зарплаты и моего ответа, директор департамента hr спросила: «И что, вам разве на текущем месте столько платят?». Но я чётко ответила: «Я не готова с вами обсуждать свою зарплату на текущем месте».<br>
                                        А ещё лет 5 назад я бы засомневалась в себе, начала бы перебирать варианты. А сейчас точно знаю — да, я классный специалист, и я точно знаю, сколько стою.<br><br>
                                        Спасибо, в том числе, курсу Анны Бабич в Карьеруме, который я проходила несколько лет назад ❤️</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <button>
                            <p>Показать больше отзывов</p>
                            <p>Скрыть отзывы</p>
                        </button>
                    </div>
                </div>
            </div>`
    });

    blockManager.add('careerum-veb4-buy', {
        label: 'Veb 4 buy',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-veb4-buy main-wrapper" data-amount-rub="4990₽" data-amount-eur="50€" data-link-rub="#popup1"
        data-link-eur="#popup2">
        <div class="careerum-container-responsive">
            <div class="veb4-buy-curr-wrapper careerum-flex-fec position-relative z-20">
                <div class="veb4-buy-curr hidden-tablet-mobile">
                    <ul class="careerum-flex-fsfs">
                        <li data-currency="eur">EUR</li>
                        <li data-currency="rub" class="active">RUB</li>
                    </ul>
                </div>
                <div class="club40-tariffs__swicher-block position-absolute">
                    <div class="club40-tariffs__swicher-top">
                        <p class="club40-tariffs__swicher-header">Посмотреть цены в
                            <span>EUR</span>
                        </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                            fill="none" class="club40-tariffs__swicher-arrow">
                            <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black"></path>
                        </svg>
                    </div>
                    <div class="club40-tariffs__swicher-bottom">
                        <ul>
                            <li data-currency="rub" class="active">
                                RUB
                            </li>
                            <li data-currency="eur">
                                EUR
                            </li>
                        </ul>
                        <p>
                            Обратите внимание,<br> что оплата в российских рублях
                            возможна только<br> с карты
                            российского банка. Оплата в евро — с карты зарубежного банка
                        </p>
                    </div>
                </div>
            </div>
            <div class="veb4-buy-tale position-relative z-10">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740391593737-Ni2HV-Vect.svg" alt=""
                    class="position-absolute z-10 hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740397264383-dSx1B-Vect.svg" alt=""
                    class="position-absolute z-10 hidden-desc-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740400299379-ar9lM-Vect.svg" alt=""
                    class="position-absolute z-10 hidden-desc-tablet">
                <div class="position-relative z-20 veb4-buy-tale-top">
                    <div>
                        <p>Запись мастер-класса</p>
                    </div>
                    <h2>Тренды найма 2025 и разбор ошибок поиска работы</h2>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740391623575-hiJq5-Grou.svg"
                        alt="" class="position-absolute veb4-buy-tale-header-line1 hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740391623718-d2BY9-Vect.svg"
                        alt="" class="position-absolute veb4-buy-tale-header-line2 hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740397263782-qgpr2-Grou.svg"
                        alt="" class="position-absolute veb4-buy-tale-header-line1 hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740397264221-MO2cN-Vect.svg"
                        alt="" class="position-absolute veb4-buy-tale-header-line2 hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740400299151-gyoD7-Grou.svg"
                        alt="" class="position-absolute veb4-buy-tale-header-line1 hidden-desc-tablet">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740400298857-7i4Tq-Vect.svg"
                        alt="" class="position-absolute veb4-buy-tale-header-line2 hidden-desc-tablet">
                </div>
                <div class="careerum-flex-sbfs z-20 position-relative veb4-buy-tale-bottom">
                    <div class="veb4-buy-bottom-left">
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740391717586-E46Ev-Targ.svg"
                                    alt="">
                                <p>Рассмотрим топ-10 главных ошибок</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740391717467-T15aS-Chec.svg"
                                    alt="">
                                <p>Обсудим тренды найма в РФ и за рубежом в 2025 году</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740391717198-HnIaj-Note.svg"
                                    alt="">
                                <p>Найдем слабые места в вашем резюме и усилим его</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740391717198-HnIaj-Note.svg"
                                    alt="">
                                <p>Разберем кейсы кандидатов, которые привели к офферам</p>
                            </li>
                        </ul>
                    </div>
                    <div class="veb4-buy-bottom-right">
                        <div class="careerum-flex-fsfs">
                            <p class="veb4-buy-amount">4990₽</p>
                            <div class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740388082908-oiKTq-Lock.svg"
                                    alt="">
                                <p>Доступ на 30 дней</p>
                            </div>
                        </div>
                        <a href="#" class="btn-color-main-dark-orange">Купить</a>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-product-main', {
        label: 'Product 4 main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-product-main main-wrapper">
        <div class="careerum-container-responsive careerum-flex-sbfs position-relative">
            <div class="position-relative z-20">
                <p class="product-main-subheader hidden-desc-mobile">Интенсив по поиску работы</p>
                <div class="product-main-labels careerum-flex-fsfs">
                    <div class="product-main-label careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737042994011-gJfkx-Cale.svg"
                            alt="">
                        <p>Старт: 19 февраля</p>
                    </div>
                    <div class="product-main-label careerum-flex-fsc">
                        <p>7 поток</p>
                    </div>
                </div>
                <p class="product-main-subheader hidden-tablet">Интенсив по поиску работы</p>
                <h1>Звездный кандидат</h1>
                <p class="product-main-text">Дадим рецепт сильного кандидата и доведем за руку до оффера</p>
                <a href="#buy" class="btn-color-main-dark-orange hidden-tablet-mobile">Записаться в лист ожидания</a>
            </div>
            <div class="position-relative z-20">
                <ul class="position-relative z-20">
                    <li class="careerum-flex-fsfs single-line">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737043560355-D29fs-Soft.svg"
                            alt="">
                        <p>Покажем рынок найма изнутри</p>
                    </li>
                    <li class="careerum-flex-fsfs single-line">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737043560355-D29fs-Soft.svg"
                            alt="">
                        <p>Инсайты от лучших рекрутеров</p>
                    </li>
                    <li class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737043560355-D29fs-Soft.svg"
                            alt="">
                        <p>CV — ваше первое свидание с рекрутером, сделаем его идеальным</p>
                    </li>
                    <li class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737043560355-D29fs-Soft.svg"
                            alt="">
                        <p>Практикумы с нанимающими менеджерами из разных индустрий</p>
                    </li>
                    <li class="careerum-flex-fsfs single-line">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737043560355-D29fs-Soft.svg"
                            alt="">
                        <p>Самые свежие лернинги для сильного профиля Linkedin</p>
                    </li>
                    <li class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737043560355-D29fs-Soft.svg"
                            alt="">
                        <p>Научитесь откликаться на вакансии и проходить интервью</p>
                    </li>
                </ul>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737121332146-y4ULC-ÑÐ¾.svg" alt=""
                    class="position-absolute z-10 hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737122441597-DBVrD-ÑÐ¾.svg" alt=""
                    class="position-absolute z-10 hidden-desc">
            </div>
            <div class="product-main-bg position-absolute z-10">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737118447411-8GuBV-Grou.svg" alt=""
                    class="position-absolute hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737043095328-vmmHO-Grou.svg" alt=""
                    class="position-absolute hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737043154452-Eaan2-Elli.png" alt=""
                    class="position-absolute hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737122309330-EtJCB-Grou.svg" alt=""
                    class="position-absolute hidden-desc-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737141459264-XAMtv-Grou.svg" alt=""
                    class="position-absolute hidden-desc-tablet">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737141478189-WnDGz-Elli.png" alt=""
                    class="position-absolute hidden-desc-tablet">
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-product-for', {
        label: 'Product 4 for (desktop only)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-product-for main-wrapper hidden-tablet-mobile">
        <div class="careerum-container-responsive position-relative ">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737044315136-AS5It-Vect.svg" alt=""
                class="position-absolute ">
            <h2 class="careerum-club40-header">Кому подойдет интенсив</h2>
            <div class="product-for-items">
                <div class="product-for-item dark careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737044753241-RT3IJ-Smil.svg"
                        alt="">
                    <p>Боитесь, что не найдете работу и от стресса даже не можете начать ее искать</p>
                </div>
                <div class="product-for-item medium careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737044753112-ViVhQ-XCir.svg"
                        alt="">
                    <p>Не знаете, как правильно откликаться на вакансии, чтобы вас заметил рекрутер</p>
                </div>
                <div class="product-for-item dark careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737044753004-6Zjqe-Thum.svg"
                        alt="">
                    <p>Не понимаете, как выгодно презентовать ваш уникальный опыт через цифры и достижения </p>
                </div>
                <div class="product-for-item light careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737044816664-0Vh5s-Smil.svg"
                        alt="">
                    <p>Более 3 месяцев ищете работу, но откликов мало, а вакансии не радуют</p>
                </div>
                <div class="product-for-item medium careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737044753112-ViVhQ-XCir.svg"
                        alt="">
                    <p>Есть пробелы в карьере: декрет / релокация / выгорание. Уверены, что с таким «багажом» никуда не
                        примут!</p>
                </div>
                <div class="product-for-item light careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737044752752-cykoA-Warn.svg"
                        alt="">
                    <p>Хотите, чтобы кто-то дал вам конкретную инструкцию, как получить оффер</p>
                </div>
            </div>
            <div class="product-for-nav careerum-flex-fec">
                <div class="product-for-nav-prev careerum-flex-cc ">
                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="product-for-nav-next careerum-flex-cc">
                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-product-about', {
        label: 'Product 4 about (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-product-about main-wrapper">
        <div class="careerum-container-responsive">
            <h2 class="careerum-club40-header">90% резюме отклоняются за 10 секунд!</h2>
            <p class="product-about-subheader">Покажем закулисье найма и научим, как стать самым желанным кандидатом на
                высококонкурентном рынке </p>
            <div class="product-about-items-3text careerum-flex-sbfs">
                <div class="careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737045888405-XKmnZ-Warn.svg"
                        alt="">
                    <div>
                        <p>≈250 резюме</p>
                        <p>на одну вакансию</p>
                    </div>
                </div>
                <div class="careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737045888405-XKmnZ-Warn.svg"
                        alt="">
                    <div>
                        <p>6–8 секунд</p>
                        <p>тратят рекрутеры на просмотр резюме</p>
                    </div>
                </div>
                <div class="careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737045888405-XKmnZ-Warn.svg"
                        alt="">
                    <div>
                        <p>только 4% претендентов</p>
                        <p>получают приглашение на интервью</p>
                    </div>
                </div>
            </div>
            <div class="product-about-items-1img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737046412326-Hz8cK-Grou.png" alt=""
                    class="hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737123915246-vWZnp-Grou.png" alt=""
                    class="hidden-desc-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737135286861-84qi5-Grou.png" alt=""
                    class="hidden-desc-tablet">
            </div>
            <div class="product-about-items-1text careerum-flex-fsfs">
                <div class="careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737045888405-XKmnZ-Warn.svg"
                        alt="">
                    <div>
                        <p>Больше раундов отбора с разными стейкхолдерами</p>
                    </div>
                </div>
                <div class="careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737046439272-rQNVl-Grou.png"
                        alt="" class="hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737124058064-64NMC-Grou.png"
                        alt="" class="hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737135501503-ygNg5-Grou.png"
                        alt="" class="hidden-desc-tablet">
                </div>
            </div>
            <div class="product-about-items-3text careerum-flex-sbfs">
                <div class="careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737045888405-XKmnZ-Warn.svg"
                        alt="">
                    <div>
                        <p>Сокращения</p>
                        <p>массовые сокращения, которые продолжаться в 2025 году</p>
                    </div>
                </div>
                <div class="careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737045888405-XKmnZ-Warn.svg"
                        alt="">
                    <div>
                        <p>Минимум в 13 компаниях </p>
                        <p>в среднем нужно пройти собеседование, чтобы получить оффер </p>
                    </div>
                </div>
                <div class="careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737045888405-XKmnZ-Warn.svg"
                        alt="">
                    <div>
                        <p>Минимум 200 откликов </p>
                        <p>в среднем нужно для оффера за рубежом </p>
                    </div>
                </div>
            </div>
            <div class="product-about-items-3text careerum-flex-sbfs">
                <div class="careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737045888405-XKmnZ-Warn.svg"
                        alt="">
                    <div>
                        <p>Вcе сложнее пройти ATS</p>
                        <p>резюме на первом этапе перестал оценивать человек. Все делается автоматически</p>
                    </div>
                </div>
                <div class="careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737045888405-XKmnZ-Warn.svg"
                        alt="">
                    <div>
                        <p>76% кандидатов имеют навыки работы с ИИ</p>
                        <p>активно повышают навыки работы с ИИ, чтобы оставаться конкурентоспособными на рынке </p>
                    </div>
                </div>
                <div class="careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737045888405-XKmnZ-Warn.svg"
                        alt="">
                    <div>
                        <p>6-8 месяцев</p>
                        <p>средний срок поиска в России и за рубежом в 2025 году</p>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-product-form', {
        label: 'Product 4 form (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-product-form main-wrapper">
        <div class="careerum-container-responsive">
            <div class="product-form-wrapper careerum-flex-sbfs">
                <div class="product-form-left position-relative">
                    <h2>Запишитесь в лист ожидания</h2>
                    <div class="position-relative z-10">
                        <p>Только участники листа ожидания получат самую низкую цену и 2 урока по резюме до старта
                            интенсива</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737047236076-zFGEE-Grou.svg"
                            alt="" class="position-absolute hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737124607208-FicsP-Grou.svg"
                            alt="" class="position-absolute hidden-desc-mobile">
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737047235806-Wgc2S-Unio.svg"
                        alt="" class="position-absolute z-20 hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737125439121-qU02p-Unio.svg"
                        alt="" class="position-absolute z-20 hidden-desc-mobile">
                </div>
                <div class="product-form-right">

                    <div class="careerum-registration-form-club40">
                        <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                            data-gjs-type="deva-registration-form">
                            <div class="careerum-club40-form-name">
                                <input type="text" name="name" value="" required placeholder="Имя">
                            </div>
                            <div class="careerum-club40-form-email">
                                <input type="text" name="email" value="" required placeholder="Почта">
                            </div>
                            <div class="careerum-club40-form-phone">
                                <input type="tel" value="" name="tel" required class="itl-input">
                            </div>
                            <div class="careerum-club40-form-agree">
                                <label>
                                    <input type="checkbox" name="agree">
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                            fill="none">
                                            <path
                                                d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                        </svg>
                                    </div>
                                </label>
                                <p>Я даю согласие на обработку своих персональных данных в соответствии с <a
                                        href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                            </div>
                            <a href="#" class="submit-btn btn-color-main-bright-orange button-sent" disabled>Записаться
                                в лист ожидания</a>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-product-how', {
        label: 'Product 4 how (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-product-how main-wrapper">
        <div class="careerum-container-responsive careerum-flex-fsfs">
            <div class="product-how-left">
                <h2 class="careerum-club40-header">Как устроен интенсив</h2>
                <div class="hidden-tablet-mobile">
                    <p class="product-how-left-header">Часть заданий вы будете выполнять в командах</p>
                    <p class="product-how-left-text">Работа в команде поможет:</p>
                    <ul>
                        <li class="position-relative">Увидеть свои сильные качества со стороны</li>
                        <li class="position-relative">Получить обратную связь от профессионалов в вашей сфере и
                            объективно упаковать свой опыт</li>
                        <li class="position-relative">Не потерять мотивацию и дойти до конца</li>
                    </ul>
                </div>
            </div>
            <div class="product-how-right careerum-flex-fsfs">
                <div class="product-how-right-item hidden-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737048702981-9uB8J-Vide.svg"
                        alt="">
                    <p>Уроки в записи</p>
                    <p>5 блоков и 34 урока. Каждый урок по 10–15 минут
                    </p>
                </div>
                <div class="product-how-right-item hidden-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737048702882-4UrQQ-Book.svg"
                        alt="">
                    <p>Практикумы с рекрутерами</p>
                    <p>Практические эфиры с рекрутерами с экспертизой найма в ведущие компании РФ и мира</p>
                </div>
                <div class="product-how-right-item hidden-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737048702776-o8qTO-Ligh.svg"
                        alt="">
                    <p>Чат интенсива</p>
                    <p>Обратная связь от кураторов и экспертов в ежедневном формате</p>
                </div>
                <div class="product-how-right-item hidden-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737048702524-0JafV-Note.svg"
                        alt="">
                    <p>Домашние задания</p>
                    <p>Упакуете свой опыт в резюме, усилите профессиональные соцсети и научитесь проходить интервью</p>
                </div>
                <div class="product-how-right-items-wrapper hidden-desc-tablet">
                    <div class="product-how-right-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737048702981-9uB8J-Vide.svg"
                            alt="">
                        <p>Уроки в записи</p>
                        <p>5 блоков и 34 урока. Каждый урок по 10–15 минут
                        </p>
                    </div>
                    <div class="product-how-right-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737048702882-4UrQQ-Book.svg"
                            alt="">
                        <p>Практикумы с рекрутерами</p>
                        <p>Практические эфиры с рекрутерами с экспертизой найма в ведущие компании РФ и мира</p>
                    </div>
                    <div class="product-how-right-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737048702776-o8qTO-Ligh.svg"
                            alt="">
                        <p>Чат интенсива</p>
                        <p>Обратная связь от кураторов и экспертов в ежедневном формате</p>
                    </div>
                    <div class="product-how-right-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737048702524-0JafV-Note.svg"
                            alt="">
                        <p>Домашние задания</p>
                        <p>Упакуете свой опыт в резюме, усилите профессиональные соцсети и научитесь проходить интервью
                        </p>
                    </div>
                </div>
                <div class="product-how-right-list hidden-desc">
                    <p class="product-how-left-header">Часть заданий вы будете выполнять в командах</p>
                    <p class="product-how-left-text">Работа в команде поможет:</p>
                    <ul>
                        <li class="position-relative">Увидеть свои сильные качества со стороны</li>
                        <li class="position-relative">Получить обратную связь от профессионалов в вашей сфере и
                            объективно упаковать свой опыт</li>
                        <li class="position-relative">Не потерять мотивацию и дойти до конца</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-product-results', {
        label: 'Product 4 results (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-product-results main-wrapper">
        <div class="careerum-container-responsive">
            <h2 class="careerum-club40-header">Ваши результаты интенсива</h2>
            <p class="product-results-subheader">Поможем получить оффер на ваших условиях, а не брать любой, который
                дают</p>
            <div class="product-results-items careerum-flex-sbst">
                <div class="product-results-item">
                    <p>1 месяц</p>
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737049255820-nCPaN-Vect.svg"
                            alt="">
                        <p>Упаковка опыта и первые интервью</p>
                    </div>
                    <ul>
                        <li class="position-relative">Резюме</li>
                        <li class="position-relative">Linkedin</li>
                        <li class="position-relative">Сопроводительные</li>
                        <li class="position-relative">Анализ рынка и вакансий</li>
                        <li class="position-relative">Первые интервью</li>
                    </ul>
                </div>
                <div class="product-results-item">
                    <p>2 месяц</p>
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737049255820-nCPaN-Vect.svg"
                            alt="">
                        <p>Активные собеседования</p>
                    </div>
                    <ul>
                        <li class="position-relative">Актуализация стратегии поиска после первых интервью</li>
                        <li class="position-relative">Подготовка к собеседованиям</li>
                        <li class="position-relative">Активные собеседования </li>
                    </ul>
                </div>
                <div class="product-results-item">
                    <p>3 месяц</p>
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737049255820-nCPaN-Vect.svg"
                            alt="">
                        <p>Финалы интервью и первые офферы</p>
                    </div>
                    <ul>
                        <li class="position-relative">Подготовка к финальным собеседованиям с руководителем</li>
                        <li class="position-relative">Подготовка в переговорам по офферу</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-product-news', {
        label: 'Product 4 news (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-product-news main-wrapper">
        <div class="careerum-container-responsive">
            <h2 class="careerum-club40-header">Мы постоянно обновляем программу, вот последние новинки интенсива</h2>
            <div class="product-news-top">
                <div class="careerum-flex-fsfs">
                    <div class="product-news-top-left">
                        <p>Практикумы с рекрутерами и нанимающими менеджерами</p>
                    </div>
                    <div class="product-news-top-right">
                        <p>Вы получите самую актуальную информацию о специфике найма, требованиях к кандидатам и этапах
                            найма в ведущих компаниях РФ и мира из первых уст нанимающих менеджеров</p>
                    </div>
                </div>
                <div class="product-news-slider-wrapper">
                    <div class="product-news-items">
                        <div class="product-news-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737120156550-FcOKG-trav.png"
                                    alt="">
                            </div>
                            <p class="product-news-slider-item-name">Найм в крупные компании и корпорации в РФ</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Как искать рефералов и получать рекомендации</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Работа с внутренними рекрутерами и прохождение оценочных центров</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Важность нетворкинга</p>
                                </li>
                            </ul>
                        </div>
                        <div class="product-news-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737120156433-CXAVW-noti.png"
                                    alt="">
                            </div>
                            <p class="product-news-slider-item-name">Найм в FAANG (Facebook, Amazon, Apple, Netflix,
                                Google)</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Специфика найма в крупнейшие технологические компании</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Особенности многоэтапных интервью</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Внутренняя культура</p>
                                </li>
                            </ul>
                        </div>
                        <div class="product-news-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737120156322-ok7Cz-rock.png"
                                    alt="">
                            </div>
                            <p class="product-news-slider-item-name">Хочу работать в стартапах</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Как оценить риски и возможности работы в стартапах и скейлапах на собеседовании?
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Как искать такие компании, и как подавать свой опыт в резюме, чтобы вас заметили?
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Как договариваться об опционах?</p>
                                </li>
                            </ul>
                        </div>
                        <div class="product-news-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737120156220-oY0c4-zoom.png"
                                    alt="">
                            </div>
                            <p class="product-news-slider-item-name">Поиск работы через рекрутинговые агентства</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Эффективное взаимодействие с рекрутерами и хедхантерами</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Практические кейсы</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Как выбирать агентства </p>
                                </li>
                            </ul>
                        </div>
                        <div class="product-news-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737120156107-86fx7-comp.png"
                                    alt="">
                            </div>
                            <p class="product-news-slider-item-name">Особенности найма в технологические компании</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Каких кандидатов ищут</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Этапы отборов</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>На что смотрят в резюме </p>
                                </li>
                            </ul>
                        </div>
                        <div class="product-news-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737120156003-9swnz-eth-.png"
                                    alt="">
                            </div>
                            <p class="product-news-slider-item-name">Найм в Web3 и криптокомпании</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Специфика трудоустройства в блокчейн-проекты</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Особенности компенсации в токенах и работу с DAO</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Риски и возможности</p>
                                </li>
                            </ul>
                        </div>
                        <div class="product-news-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737120155897-8ywcu-thum.png"
                                    alt="">
                            </div>
                            <p class="product-news-slider-item-name">Управление онлайн-репутацией при поиске работы</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Управление репутационными рисками</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Работе с цифровым следом</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Профессиональные соцсети</p>
                                </li>
                            </ul>
                        </div>
                        <div class="product-news-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737120155790-9Gs3L-hear.png"
                                    alt="">
                            </div>
                            <p class="product-news-slider-item-name">Найм в некоммерческий сектор</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Особенности трудоустройства в НКО и социальные предприятия</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Специфика мотивации</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Компенсации</p>
                                </li>
                            </ul>
                        </div>
                        <div class="product-news-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737120155673-RnHp8-lock.png"
                                    alt="">
                            </div>
                            <p class="product-news-slider-item-name">Поиск работы в регулируемых индустриях</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Специфика найма в финансовый сектор, здравоохранение и другие области с жёстким
                                        регулированием</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Зарплатные вилки</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Возможности для роста</p>
                                </li>
                            </ul>
                        </div>
                        <div class="product-news-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737120155556-mliey-boy-.png"
                                    alt="">
                            </div>
                            <p class="product-news-slider-item-name">Возрастные стереотипы при поиске работы</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Стратегии позиционирования опыта как преимущества</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Преодоление возрастных стереотипов </p>
                                </li>
                            </ul>
                        </div>
                        <div class="product-news-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737120155451-vSVTC-pain.png"
                                    alt="">
                            </div>
                            <p class="product-news-slider-item-name">Найм на креативные позиции: портфолио и тестовые
                            </p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Особенности поиска работы в творческих индустриях</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Как создавать портфолио, и на что делать акценты</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Как управлять потоком тестовых заданий</p>
                                </li>
                            </ul>
                        </div>
                        <div class="product-news-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737120155334-jzFVs-penc.png"
                                    alt="">
                            </div>
                            <p class="product-news-slider-item-name">Сами делайте свои тестовые</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Оценка серьезности намерений работодателя, анализ объема работы, защита
                                        интеллектуальной собственности</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Red flags в тестовых заданиях</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Убедительная презентация тестового задания</p>
                                </li>
                            </ul>
                        </div>
                        <div class="product-news-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737120155221-Qpf3B-targ.png"
                                    alt="">
                            </div>
                            <p class="product-news-slider-item-name">Смена профессии и поиска работы в новой сфере</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Как упаковать свой прошлый опыт</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>На что делать акцент на собеседовании</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Бенчмарки воронки поиска при смене сферы</p>
                                </li>
                            </ul>
                        </div>
                        <div class="product-news-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737120155109-jQMVy-forw.png"
                                    alt="">
                            </div>
                            <p class="product-news-slider-item-name">Переход между ролями внутри корпорации</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Как организовать личное развитие для успешного перехода</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Роль HR и руководителя в осуществлении перехода</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Когда нет смысла переходить внутри компании, а пора уходить</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="product-news-slider-nav careerum-flex-fec">
                        <div class="product-news-slider-nav-prev careerum-flex-cc ">
                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white"
                                    stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="product-news-slider-nav-next careerum-flex-cc">
                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white"
                                    stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <div class="product-news-bottom careerum-flex-fsfs position-relative">
                <div class="product-news-bottom-left">
                    <p>Добавили уроки по LinkedIn с самыми свежими обновлениями соцсети</p>
                </div>
                <div class="product-news-bottom-right">
                    <p>Прокачаете свой профиль, так чтобы рекрутеры сами писали вам каждый день</p>
                </div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737051095754-28pQk-3d-i.png" alt=""
                    class="position-absolute hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737129155951-RtQdT-3d-i.png" alt=""
                    class="position-absolute hidden-desc-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737137757750-IUCSZ-3d-i.png" alt=""
                    class="position-absolute hidden-desc-tablet">
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-product-additional', {
        label: 'Product 4 additional (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-product-additional main-wrapper">
        <div class="careerum-container-responsive">
            <h2 class="careerum-club40-header">Что еще будет на интенсиве?</h2>
            <div class="product-additional-top">
                <p class="product-additional-header">Доступ к нетворк-сообществу русскоговорящих профессионалов из 30+
                    стран</p>
                <div class="product-additional-top-items careerum-flex-sbst">
                    <div class="product-additional-top-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737051816284-lh227-Edit.svg"
                            alt="">
                        <p>Соберете информацию из первых уст о компании, в которую хотите попасть</p>
                    </div>
                    <div class="product-additional-top-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737051816177-SAaQ4-Prof.svg"
                            alt="">
                        <p>Найдете рефералов, чтобы получить рекомендации в компанию на выбранную позицию</p>
                    </div>
                    <div class="product-additional-top-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737051815933-aZMPt-Docu.svg"
                            alt="">
                        <p>Расширите нетворкинг со специалистами разного уровня: от junior до C-level</p>
                    </div>
                </div>
            </div>
            <div class="product-additional-bottom">
                <p class="product-additional-header">Доступ к карьерной платформе Careerum</p>
                <p class="product-additional-subheader">На время интенсива вы получите полный доступ ко всей платформе и
                    80 курсам в записи под любую карьерную задачу</p>
                <div class="product-additional-slider">
                    <div class="product-additional-slider-items">
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Освоиться на новой работе и быстро начать
                                приносить пользу</p>
                            <p class="product-additional-slider-text">Курс «Жизнь после оффера»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206754-7evbK-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136250-vxoGi-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Выстроить границы с руководителем и коллегами
                            </p>
                            <p class="product-additional-slider-text">Курс «Коммуникация на работе»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206056-MnQUS-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135782-HSOgY-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Получить повышение через полгода</p>
                            <p class="product-additional-slider-text">Курс «Карьерная ракета»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733903195276-Tuk6J-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136724-Jcd5H-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Найти работу за границей быстро и без проблем
                            </p>
                            <p class="product-additional-slider-text">Курс «Международная карьера и релокация»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733903195611-i209G-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136856-YVoxz-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Достигать результатов в разы быстрее</p>
                            <p class="product-additional-slider-text">Курс «Работать не 24/7»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905207114-JpoWG-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136609-SntZn-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Работать без выгораний и демотивации</p>
                            <p class="product-additional-slider-text">Курс «Карьера без стресса»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206462-v4YrG-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136026-DlGgK-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Сформировать здоровую самооценку и расти в
                                доходе</p>
                            <p class="product-additional-slider-text">Курс «Самооценка и Деньги: не мешайте себе
                                зарабатывать»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206995-CzHss-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136496-iK3of-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Развивать сеть контактов, формировать личный
                                бренд</p>
                            <p class="product-additional-slider-text">Курс «Секреты нетворкинга»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206300-G4EiF-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135902-YaSxb-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Работать из дома эффективно и без прокрастинации
                            </p>
                            <p class="product-additional-slider-text">Курс «Удаленка»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206162-axyQs-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135408-W8WQc-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Добиться финансовой самостоятельность</p>
                            <p class="product-additional-slider-text">Курс «Карьера и финансы»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206995-CzHss-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135142-zfMz9-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Разобраться в себе и понять, чего хочется от
                                карьеры</p>
                            <p class="product-additional-slider-text">Курс «Real Me: как найти себя»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733903195760-k2i68-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136980-Rz3Af-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Смело вести переговоры, презентации и смол-токи
                            </p>
                            <p class="product-additional-slider-text">Курс «Публичные выступления»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206870-OTfik-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136368-XNklq-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Сохранять свою ценность даже во времена
                                сокращений</p>
                            <p class="product-additional-slider-text">Курс «Антикризис»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206605-BqNcB-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136137-toVB5-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Видеть задачи и проекты с новых сторон</p>
                            <p class="product-additional-slider-text">Курс «Open Mindset»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205937-ZsoJe-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135662-WTxmr-Fram.svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Стать руководителем, который ведет команды и
                                растит KPI</p>
                            <p class="product-additional-slider-text">Курс «Эффективный руководитель»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205773-omnR0-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135534-kXWnQ-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Перейти в новую сферу быстро и без потери в
                                доходе</p>
                            <p class="product-additional-slider-text">Курс «Новые горизонты»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205629-EdGB4-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135278-gzlKn-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Понять, в чем особенности обучения за рубежом
                            </p>
                            <p class="product-additional-slider-text">Курс «Зарубежное образование»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205377-zl9WX-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135022-KqJcY-Ð¸Ð».svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Преодолеете трудности при выходе из декрета</p>
                            <p class="product-additional-slider-text">Курс «Выход из декрета»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205223-dT5vR-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923134903-TM6LM-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Построите стратегию поиска работы и получите
                                оффер</p>
                            <p class="product-additional-slider-text">Курс «Карьерная ракета»
                            </p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905204858-qg4Um-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923134529-X2YUs-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                    </div>
                    <div class="product-additional-nav careerum-flex-fec">
                        <div class="product-additional-nav-prev careerum-flex-cc ">
                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white"
                                    stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="product-additional-nav-next careerum-flex-cc">
                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white"
                                    stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-product-reviews', {
        label: 'Product 4 reviews (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-product-reviews main-wrapper">
        <div class="careerum-container-responsive">
            <div class="product-reviews-top careerum-flex-fsfs">
                <div class="product-reviews-top-left">
                    <h2>За 5 лет существования проекта программа «Звездный кандидат» была проверена на 7 000+
                        участниках, вот их отзывы</h2>
                </div>
                <div class="product-reviews-top-right">
                    <div class="position-relative z-20">
                        <p>5 лет</p>
                    </div>
                    <div class="position-relative z-10">
                        <p>7 000+ участников</p>
                    </div>
                </div>
            </div>
            <div class="product-reviews-bottom">
                <div class="product-reviews-items careerum-flex-fsst">
                    <div class="product-reviews-item">
                        <div class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737054548224-3DIfB-Mask.png"
                                alt="">
                            <p>Марина Мухаметшина</p>
                        </div>
                        <p>Проходила курс «Звёздный кандидат», пошагово применяя все практики. В одну из компаний, где
                            предложили оффер, собеседовалась до вступления в клуб и мне предложили доход всего на 10%
                            больше и должность аналогичную моей. При этом разница между собеседованиями была в месяц и
                            фактически мои скиллы не изменились, я просто научилась расставлять акценты, благодаря
                            кyрсy.</p>
                        <p>По результатам получены 2 оффера. Один с разницей в +35% к заработной плате и предложением
                            управленческой должности, второй с разницей +52% к заработной плате и расширением
                            компетенций.</p>
                    </div>
                    <div class="product-reviews-item">
                        <div class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737055570722-z5Ztf-imag.png"
                                alt="">
                            <p>Александра Анцyпова</p>
                        </div>
                        <p>Я прошла курс «Звездный кандидат», который не только помог проработать свое резюме, но и
                            получить оффер в компанию, где сейчас работаю. Я в целом поняла, как правильно составлять
                            резюме, что туда включать, как формулировать свои достижения.</p>
                    </div>
                    <div class="product-reviews-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737055829051-CftUX-01 7.png"
                            alt="">
                    </div>
                    <div class="product-reviews-item">
                        <div class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737055571025-S7iiv-imag.png"
                                alt="">
                            <p>Юлия Новикова</p>
                        </div>
                        <p>«Звездный кандидат» помог составить воронку поиска работы, проработать резюме и
                            сопроводительное письмо, а также проходить интервью. Через 3 месяца активной работы, я
                            смогла получить оффер в компанию по новой профессии. На такой результат повлияли навыки
                            презентации и хорошее позиционирование, а также знания, которые я получила на курсе
                            «Звездный кандидат».</p>
                    </div>
                    <div class="product-reviews-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737055829517-HIv3L-03 2.png"
                            alt="">
                    </div>
                    <div class="product-reviews-item">
                        <div class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737055571141-clyAM-imag.png"
                                alt="">
                            <p>Арина Кyнашко</p>
                        </div>
                        <p>Мне нужно было за короткий срок овладеть инструментами поиска вакансий и найти применение
                            своим навыкам на рынке. Программа «Звездный кандидат» с этим помогла: я построила стратегию
                            поиска работы, научилась составлять продающее резюме и правильно преподносить себя на
                            интервью.</p>
                    </div>
                    <div class="product-reviews-item">
                        <div class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737055571242-5S4jz-imag.png"
                                alt="">
                            <div>
                                <p>Мария Кyзнецова</p>
                                <div class="careerum-flex-fsc">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737056294053-Xa5hV-ocat.svg"
                                        alt="">
                                    <p>Франция</p>
                                </div>
                            </div>
                        </div>
                        <p>Благодаря курсам «Звездного кандидата» я поняла, что нужно откликаться на вакансии, даже если
                            описание подходит не на 100%. Также я смогла фокусироваться не на отсутствии каких-то
                            навыков, а на том, как имеющийся опыт и скиллы помогут решать рабочие задачи.</p>
                    </div>
                    <div class="product-reviews-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737056212828-SQ92g-Fram.png"
                            alt="">
                    </div>
                </div>
                <div class="product-reviews-nav careerum-flex-fec">
                    <div class="product-reviews-nav-prev careerum-flex-cc ">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white"
                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="product-reviews-nav-next careerum-flex-cc">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white"
                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-product-tariffs', {
        label: 'Product 4 tariffs (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-product-tariffs main-wrapper">
        <div class="careerum-container-responsive">
            <div class="product-tariffs-label">
                <p>Открытие продаж 15.02</p>
            </div>
            <h2 class="careerum-club40-header">Выберите удобный вариант участия — подписку помесячно или на 3 месяца
            </h2>
            <div class="product-tariffs-items-wrapper">
                <div class="product-tariffs-items careerum-flex-fsst">
                    <div class="product-tariffs-item careerum-flex-fsfs">
                        <div class="product-tariffs-item-top">
                            <p>Тариф «Самостоятельный»</p>
                        </div>
                        <div class="product-tariffs-item-content position-relative">
                            <p class="product-tariffs-item-header hidden-tablet-mobile">Доступ к интенсиву в записи без
                                обратной связи<br><br>
                            </p>
                            <p class="product-tariffs-item-header hidden-desc">Доступ к интенсиву в записи без обратной
                                связи</p>
                            <p class="product-tariffs-item-places hidden-tablet-mobile opacity-0">Всего: 30 мест</p>
                            <div class="product-tariffs-item-divider hidden-tablet-mobile"></div>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737057207301-OhLpp-Chec.svg"
                                        alt="">
                                    <p><span>Доступ к интенсиву Звёздный кандидат В ЗАПИСИ</span></p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737057207301-OhLpp-Chec.svg"
                                        alt="">
                                    <p>Шаблоны и примеры: резюме на русском и английском, сопроводительные письма,
                                        сообщения
                                        работодателямв LinkedIn, деловая email-переписка</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737057207301-OhLpp-Chec.svg"
                                        alt="">
                                    <p>Воркфлоу поиска достижений </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737057207301-OhLpp-Chec.svg"
                                        alt="">
                                    <p>Список платформ для поиска работы в 15 странах</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737057207301-OhLpp-Chec.svg"
                                        alt="">
                                    <p>Трекер заявок на вакансии, чтобы всегда знать, что и куда отправили</p>
                                </li>
                            </ul>
                        </div>
                        <div class="product-tariffs-item-link">
                            <a href="#" class="btn-color-main-dark-orange">Записаться в лист ожидания</a>
                        </div>
                    </div>
                    <div class="product-tariffs-item careerum-flex-fsfs">
                        <div class="product-tariffs-item-top">
                            <p>Тариф «С поддержкой»</p>
                        </div>
                        <div class="product-tariffs-item-content position-relative">
                            <div class="product-tariffs-item-label careerum-flex-fsc position-absolute ">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737121018148-1grJT-Fire.svg"
                                    alt="">
                                <p>Оптимальный</p>
                            </div>
                            <p class="product-tariffs-item-header hidden-tablet-mobile">Интенсив с практикой и обратной
                                связью<br><br><br>
                            </p>
                            <p class="product-tariffs-item-header hidden-desc">Интенсив с практикой и обратной связью
                            </p>
                            <p class="product-tariffs-item-places hidden-tablet-mobile opacity-0">Всего: 30 мест</p>
                            <div class="product-tariffs-item-divider hidden-tablet-mobile"></div>
                            <p class="product-tariffs-item-description">В тариф входят все опции тарифа
                                «Самостоятельный»,
                                плюс:</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                        alt="">
                                    <p>Групповой чат с экспертом и кураторами платформы</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                        alt="">
                                    <p>10 практикумов<br>- Резюме<br>- Linkedin<br>- Стратегия поиска<br>- Интервью
                                        RU<br>-
                                        Интервью EN<br>- Эфиры с нанимающими менеджерами и рекрутерами</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                        alt="">
                                    <p>2 групповые Q&A-встречи в месяц с экспертом для разбора вопросов</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                        alt="">
                                    <p>Доступ к нетворк-сообществу</p>
                                </li>
                            </ul>
                        </div>
                        <div class="product-tariffs-item-link">
                            <a href="#" class="btn-color-main-dark-orange">Записаться в лист ожидания</a>
                        </div>
                    </div>
                    <div class="product-tariffs-item careerum-flex-fsfs">
                        <div class="product-tariffs-item-top">
                            <p>Тариф «Индивидуальный подход»</p>
                        </div>
                        <div class="product-tariffs-item-content position-relative">
                            <p class="product-tariffs-item-header hidden-tablet-mobile">Интенсив с практикой и обратной
                                связью + личные консультации с экспертом</p>
                            <p class="product-tariffs-item-header hidden-desc">Интенсив с практикой и обратной связью +
                                личные консультации с экспертом</p>
                            <p class="product-tariffs-item-places">Всего: 30 мест</p>
                            <div class="product-tariffs-item-divider hidden-tablet-mobile"></div>
                            <p class="product-tariffs-item-description">В тариф входят все преимущества тарифа
                                «С поддержкой», плюс:</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                        alt="">
                                    <p>4 личные карьерные консультации с экспертом:<br>- разбор резюме<br>- разбор
                                        Linkedin<br>-
                                        стратегия поиска <br>- подготовка интервью или ваша карьерная задача</p>
                                </li>
                            </ul>
                        </div>
                        <div class="product-tariffs-item-link">
                            <a href="#" class="btn-color-main-dark-orange">Записаться в лист ожидания</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-quiz-main', {
        label: 'Quiz main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-quiz-main main-wrapper">
        <div class="careerum-container-responsive">
            <div class="quiz-main__logo careerum-flex-fsfs">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740463548843-nZTDm-logo.svg" alt="" class="hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740464735927-6BiS8-logo.svg" alt="" class="hidden-desc-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740464735927-6BiS8-logo.svg" alt="" class="hidden-desc-tablet">
                <p>— платформа карьерного развития</p>
            </div>
            <div class="quiz-main__header position-relative">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740463548351-moA8R-line.svg" alt="" class="hidden-tablet-mobile position-absolute z-10">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740464735767-YykH4-line.svg" alt="" class="hidden-desc-mobile position-absolute z-10">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740465429607-y6lU4-line.svg" alt="" class="hidden-desc-tablet position-absolute z-10">
                <p class="position-relative z-20">Тест</p>
                <h1>«Как вас воспринимают <span>коллеги</span>?» </h1>
            </div>
            <div class="quiz-main__content careerum-flex-sbst">
                <div class="quiz-main__content-left">
                    <div>
                        <p class="quiz-main__content-number">1</p>
                        <p class="quiz-main__content-text">Определите ваш текущий стиль профессиональной коммуникации</p>
                    </div>
                    <div>
                        <p class="quiz-main__content-number">2</p>
                        <p class="quiz-main__content-text">Выявите ключевые области для роста вашего влияния в команде</p>
                    </div>
                    <div>
                        <p class="quiz-main__content-number">3</p>
                        <p class="quiz-main__content-text">Получите персональные рекомендации по усилению вашей позиции</p>
                    </div>
                </div>
                <div class="quiz-main__content-right position-relative careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740463548716-h6SsP-Img..svg" alt="" class="position-absolute hidden-tablet-mobile z-10">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740464735426-txtKO-Img .svg" alt="" class="position-absolute hidden-desc-mobile z-10">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740465429319-DLv87-Img .svg" alt="" class="position-absolute hidden-desc-tablet z-10">
                    <a href="#" class="btn-color-main-dark-orange position-relative z-20">Пройти тест</a>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-consultations4-main', {
        label: 'Consultations main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-consultations4-main main-wrapper">
                <div class="careerum-container-responsive80 careerum-flex-fsfs">
                    <div class="consultations4-main-left">
                        <p class="consultations4-main__subheader">Поможем с любым карьерным вопросом</p>
                        <h1 class="consultations4-main__header">Консультации с карьерными экспертами</h1>
                        <div class="consultations4-main__bottom careerum-flex-fsfs">
                            <div>
                                <p class="consultations4-main__tale-header">9.7</p>
                                <p class="consultations4-main__tale-text">средняя оценка специалистов Careerum</p>
                            </div>
                            <div>
                                <p class="consultations4-main__tale-header">3800+</p>
                                <p class="consultations4-main__tale-text">часов проведенных сессий</p>
                            </div>
                        </div>
                        <a href="#buy" class="btn-color-main-dark-orange hidden-mobile">Купить консультацию</a>
                    </div>
                    <div class="consultations4-main-right position-relative">
                        <div class="position-relative z-20">
                            <p>Получить персональную<br> поддержку</p>
                        </div>
                        <div class="position-relative z-30">
                            <p>Составить стратегию<br> достижения результата</p>
                        </div>
                        <div class="position-relative z-50">
                            <p>Команда экспертов
                                с международным опытом</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739972912741-97II1-Grou.png"
                                alt="">
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739972599324-IHwFD-Grou.png" alt=""
                            class="position-absolute z-10 consultations4-main__img-1 hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739972842938-WYqeP-Grou.png" alt=""
                            class="position-absolute z-60 consultations4-main__img-2 hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739992321722-6C9cG-Grou.png" alt=""
                            class="position-absolute z-10 consultations4-main__img-1 hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739992322044-r8LDT-Grou.png" alt=""
                            class="position-absolute z-60 consultations4-main__img-2 hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739996780487-GKAfe-Grou.png" alt=""
                            class="position-absolute z-0 consultations4-main__img-1 hidden-desc-tablet">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739996780337-pyKgA-Grou.png" alt=""
                            class="position-absolute z-20 consultations4-main__img-2 hidden-desc-tablet">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739996780092-LT9HL-Grou.png" alt=""
                            class="position-absolute z-60 consultations4-main__img-3 hidden-desc-tablet">
                    </div>
                    <a href="#buy" class="btn-color-main-dark-orange hidden-desc-tablet">Купить консультацию</a>
                    <div class="club0526-couches-bottom">
                        <ul class="careerum-flex-sbfs">
                            <li class="careerum-flex-fsfs">
                                <img loading="lazy" src="https://cdn.careerum.com/1780392344972-5H0Pn-Chec.svg" alt="img"
                                    class="hidden-mobile">
                                <img loading="lazy" src="https://cdn.careerum.com/1780393930766-1U38L-Chec.svg" alt="img"
                                    class="hidden-desc-tablet">
                                <p>Знают, что реально работает, а что — нет. 4500+
                                    проведенных сессий</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img loading="lazy" src="https://cdn.careerum.com/1780392345000-jMVkD-Eye..svg" alt="img"
                                    class="hidden-mobile">
                                <img loading="lazy" src="https://cdn.careerum.com/1780393930801-raPI6-Eye..svg" alt="img"
                                    class="hidden-desc-tablet">
                                <p>Видят сотни кейсов переходов, увольнений и офферов </p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img loading="lazy" src="https://cdn.careerum.com/1780392344898-uZu3P-Chat.svg" alt="img"
                                    class="hidden-mobile">
                                <img loading="lazy" src="https://cdn.careerum.com/1780393930643-E4jay-Chat.svg" alt="img"
                                    class="hidden-desc-tablet">
                                <p>Могут сказать правду, даже если она неудобная</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img loading="lazy" src="https://cdn.careerum.com/1780392345024-Gv3jN-Gear.svg" alt="img"
                                    class="hidden-mobile">
                                <img loading="lazy" src="https://cdn.careerum.com/1780393930832-OlLq4-Gear.svg" alt="img"
                                    class="hidden-desc-tablet">
                                <p>Понимают рынок изнутри</p>
                            </li>
                        </ul>
                    </div>
                    <p class="club0326-main-text">Рынки, с которыми мы работаем:</p>
                    <div class="careerum-flex-fsc club0326-main-regions">
                        <p>РФ</p>
                        <p>СНГ</p>
                        <p>ЕС</p>
                        <p>DACH</p>
                        <p>США</p>
                        <p>ОАЭ</p>
                        <p>JАРАС</p>
                        <p>MENA</p>
                        <p>LATAM</p>
                        <p>UK&amp;I</p>
                        <p>BALTICS</p>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-consultations4-couch', {
        label: 'Consultations couch (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-consultations4-couch main-wrapper">
                <div class="careerum-container-responsive80">
                    <h2>Карьерный коуч vs эксперт</h2>
                    <div class="consultations4-couch-wrapper careerum-flex-sbst">
                        <div class="consultations4-couch-item blue">
                            <div class="consultations4-couch-item-top">
                                <p>Карьерный коуч</p>
                                <img src="https://cdn.careerum.com/1790850509662-GorlR-Fram.png" alt="img" loading="lazy">
                            </div>
                            <div class="consultations4-couch-item-bottom">
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1790850509569-sgZ0V-Soft.svg" alt="">
                                        <p>Помогает прояснить карьерные цели и ценности</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1790850509569-sgZ0V-Soft.svg" alt="">
                                        <p>Выводит из выгорания 1–2 стадии</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1790850509569-sgZ0V-Soft.svg" alt="">
                                        <p>Переводит «хочу» в работе в достижимый план</p>
                                    </li>
                                </ul>
                                <div class="consultations4-couch-item-divider"></div>
                                <p class="consultations4-couch-item-header">Инструменты: </p>
                                <p class="consultations4-couch-item-text">Коучинговые модели, вопросы, рефлексия, упражнения</p>
                                <p class="consultations4-couch-item-header">Результат:</p>
                                <p class="consultations4-couch-item-text">Ясность направления, устойчивые изменения</p>
                            </div>
                        </div>
                        <div class="consultations4-couch-item orange">
                            <div class="consultations4-couch-item-top">
                                <p>Карьерный эксперт</p>
                                <img src="https://cdn.careerum.com/1790850509601-sxPE6-Grou.png" alt="img" loading="lazy">
                            </div>
                            <div class="consultations4-couch-item-bottom">
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1790850509490-k8OqY-Soft.svg" alt="">
                                        <p>Помогает выстроить тактику поиска под ваши цели</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1790850509490-k8OqY-Soft.svg" alt="">
                                        <p>Аудит резюме с акцентом на ваши сильные стороны</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1790850509490-k8OqY-Soft.svg" alt="">
                                        <p>Техники интервью и переговоров под вас</p>
                                    </li>
                                </ul>
                                <div class="consultations4-couch-item-divider"></div>
                                <p class="consultations4-couch-item-header">Инструменты: </p>
                                <p class="consultations4-couch-item-text">ATS, hiring POV, матрица достижений, карта компаний</p>
                                <p class="consultations4-couch-item-header">Результат:</p>
                                <p class="consultations4-couch-item-text">Уверенность, эффективные отклики, оффер</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-consultations4-experts', {
        label: 'Consultations experts (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-consultations4-experts main-wrapper">
                <div class="careerum-container-responsive80">
                    <h2>Команда карьерных коучей
                        и экспертов с международной сертификацией</h2>
                    <div class="consultations4-experts-slider-item-about">
                        <p class="slider-item-about__header">Помогут достичь
                            вашей цели: </p>
                        <p class="slider-item-about__text">написать сильное резюме</p>
                        <p class="slider-item-about__text">усилить профиль LinkedIn</p>
                        <p class="slider-item-about__text">потренировать собеседование</p>
                        <p class="slider-item-about__text">поставить карьерную цель</p>
                        <p class="slider-item-about__text">усилить сопроводительное</p>
                        <p class="slider-item-about__text hidden-mobile">подготовиться к переговорам<br> по офферу</p>
                        <p class="slider-item-about__text hidden-desc-tablet">подготовиться<br> к переговорам по офферу</p>
                    </div>
                    <div class="consultations4-experts-slider">
                        <div class="consultations4-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739974820355-Yiojz-phot.png"
                                    alt="">
                            </div>
                            <p class="consultations4-experts-slider-item-name">Софи Бессон</p>
                            <p class="consultations4-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310928-GL8NO-Sjie.svg"
                                        alt="">
                                    <p>6+ в HR и карьерном консультировании</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310822-h04vz-User.svg"
                                        alt="">
                                    <p>Помогла 700+ клиентам составить резюме<br> и найти работу в Европе, США и Канаде</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310710-qRFZA-Work.svg"
                                        alt="">
                                    <p>Работала с<br>
                                        сотрудниками Disney, Intel, Microsoft</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310370-49q4A-Loca.svg"
                                        alt="">
                                    <p>Израиль</p>
                                </li>
                            </ul>
                        </div>
                        <div class="consultations4-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739974820231-kcH25-phot.png"
                                    alt="">
                            </div>
                            <p class="consultations4-experts-slider-item-name">Мария Пудалова</p>
                            <p class="consultations4-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310928-GL8NO-Sjie.svg"
                                        alt="">
                                    <p>7+ лет в PR и стратегии выстраивания бренда</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310822-h04vz-User.svg"
                                        alt="">
                                    <p>Помогла 400+ клиентам улучшить CV и найти работу в Европе<br>
                                        и США</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310710-qRFZA-Work.svg"
                                        alt="">
                                    <p>Работала с<br>
                                        сотрудниками Deloitte, BBDO, Microsoft</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310370-49q4A-Loca.svg"
                                        alt="">
                                    <p>Германия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="consultations4-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739974820121-GoyEh-phot.png"
                                    alt="">
                            </div>
                            <p class="consultations4-experts-slider-item-name">Виктория Албаутова</p>
                            <p class="consultations4-experts-slider-item-position">Коуч ICU</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310928-GL8NO-Sjie.svg"
                                        alt="">
                                    <p>18+ лет в коучинге и маркетинге</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310822-h04vz-User.svg"
                                        alt="">
                                    <p>Помогла 150+ клиентам построить выигрышные стратегии и бренды</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310710-qRFZA-Work.svg"
                                        alt="">
                                    <p>Работала с<br>
                                        компаниями Beiesdorf, Philips, Johnson&Johnson, Novartis</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310370-49q4A-Loca.svg"
                                        alt="">
                                    <p>Турция</p>
                                </li>
                            </ul>
                        </div>
                        <div class="consultations4-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739974819890-ow3jn-phot.png"
                                    alt="">
                            </div>
                            <p class="consultations4-experts-slider-item-name">Елена Добринская</p>
                            <p class="consultations4-experts-slider-item-position">PCC ICF </p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310928-GL8NO-Sjie.svg"
                                        alt="">
                                    <p>10+ лет в коучинге и финансах </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310822-h04vz-User.svg"
                                        alt="">
                                    <p>Помогла 1700+ клиентам обрести уверенность и подготовиться к собеседованиям</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310710-qRFZA-Work.svg"
                                        alt="">
                                    <p>Работала с<br>
                                        сотрудниками Sony, Ernst&Young, Deloitte</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310370-49q4A-Loca.svg"
                                        alt="">
                                    <p>ОАЭ</p>
                                </li>
                            </ul>
                        </div>
                        <div class="consultations4-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739974820009-ZZk0F-phot.png"
                                    alt="">
                            </div>
                            <p class="consultations4-experts-slider-item-name">Яна Хмельницкая</p>
                            <p class="consultations4-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310928-GL8NO-Sjie.svg"
                                        alt="">
                                    <p>15+ лет в HR, карьерном коучинге и закупках</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310822-h04vz-User.svg"
                                        alt="">
                                    <p>Помогла 800+ клиентам подготовиться к интервью на английском языке и релоцироваться
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310710-qRFZA-Work.svg"
                                        alt="">
                                    <p>Работала с<br>
                                        сотрудниками Ford, Leroy Merlin, Unilever, Mars</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310370-49q4A-Loca.svg"
                                        alt="">
                                    <p>Турция</p>
                                </li>
                            </ul>
                        </div>
                        <div class="consultations4-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739974819773-6nNdM-phot.png"
                                    alt="">
                            </div>
                            <p class="consultations4-experts-slider-item-name">Елена Эльзенбах</p>
                            <p class="consultations4-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310928-GL8NO-Sjie.svg"
                                        alt="">
                                    <p>11+ лет опыта в коучинге, НКО и EdTech</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310822-h04vz-User.svg"
                                        alt="">
                                    <p>Помогла 1300+ клиентам из РФ, Европы и СНГ получить оффер через укрепление самооценки
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310710-qRFZA-Work.svg"
                                        alt="">
                                    <p>Работала с<br>
                                        сотрудниками Lamoda, Яндекс, Mail, InDriver</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310370-49q4A-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="consultations4-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739974819542-PjU8d-phot.png"
                                    alt="">
                            </div>
                            <p class="consultations4-experts-slider-item-name">Светлана Шуйская</p>
                            <p class="consultations4-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310928-GL8NO-Sjie.svg"
                                        alt="">
                                    <p>18+ лет в коучинге и закупках</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310822-h04vz-User.svg"
                                        alt="">
                                    <p>Помогла 300+ клиентам вырасти в доходе, составить стратегию, начать свое дело</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310710-qRFZA-Work.svg"
                                        alt="">
                                    <p>Работала с<br>
                                        сотрудниками Metro Cash&Carry, Yandex, Avito</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310370-49q4A-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="consultations4-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739974819342-HAYLL-phot.png"
                                    alt="">
                            </div>
                            <p class="consultations4-experts-slider-item-name">Марина Веденичева</p>
                            <p class="consultations4-experts-slider-item-position">Коуч PCC ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310928-GL8NO-Sjie.svg"
                                        alt="">
                                    <p>18+ лет в HR и карьерном коучинге</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310822-h04vz-User.svg"
                                        alt="">
                                    <p>Помогла 2000+ клиентам усилить лидерские качества и получить повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310710-qRFZA-Work.svg"
                                        alt="">
                                    <p>Работала с<br>
                                        сотрудниками Mars, Shell, Ernst & Young</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310370-49q4A-Loca.svg"
                                        alt="">
                                    <p>Великобритания</p>
                                </li>
                            </ul>
                        </div>
                        <div class="consultations4-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739974818773-lLZ2m-phot.png"
                                    alt="">
                            </div>
                            <p class="consultations4-experts-slider-item-name">Майя Бурякина</p>
                            <p class="consultations4-experts-slider-item-position">Коуч ACC ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310928-GL8NO-Sjie.svg"
                                        alt="">
                                    <p>10 лет в подборе, адаптации и развитии персонала</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310822-h04vz-User.svg"
                                        alt="">
                                    <p>150+ консультаций на тему поиска работы и построения карьеры</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310710-qRFZA-Work.svg"
                                        alt="">
                                    <p>Организатор семинаров «Поиск работы в США» в Кремниевой долине</p>
                                </li>
                                <li class="careerum-flex-fsc">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310370-49q4A-Loca.svg"
                                        alt="">
                                    <p>США, Россия</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="consultations4-experts-nav careerum-flex-fec">
                        <div class="consultations4-experts-nav-prev hidden-tablet-mobile">
                            <svg width="55" height="54" viewBox="0 0 55 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="55" height="54" rx="27" transform="matrix(-1 0 0 1 55 0)" fill="black" />
                                <path
                                    d="M40 25.5C40.8284 25.5 41.5 26.1716 41.5 27C41.5 27.8284 40.8284 28.5 40 28.5V25.5ZM13.9393 28.0607C13.3536 27.4749 13.3536 26.5251 13.9393 25.9393L23.4853 16.3934C24.0711 15.8076 25.0208 15.8076 25.6066 16.3934C26.1924 16.9792 26.1924 17.9289 25.6066 18.5147L17.1213 27L25.6066 35.4853C26.1924 36.0711 26.1924 37.0208 25.6066 37.6066C25.0208 38.1924 24.0711 38.1924 23.4853 37.6066L13.9393 28.0607ZM40 28.5H15V25.5H40V28.5Z"
                                    fill="white" />
                            </svg>
                        </div>
                        <div class="consultations4-experts-nav-next">
                            <svg width="55" height="54" viewBox="0 0 55 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="55" height="54" rx="27" fill="black" />
                                <path
                                    d="M15 25.5C14.1716 25.5 13.5 26.1716 13.5 27C13.5 27.8284 14.1716 28.5 15 28.5V25.5ZM41.0607 28.0607C41.6464 27.4749 41.6464 26.5251 41.0607 25.9393L31.5147 16.3934C30.9289 15.8076 29.9792 15.8076 29.3934 16.3934C28.8076 16.9792 28.8076 17.9289 29.3934 18.5147L37.8787 27L29.3934 35.4853C28.8076 36.0711 28.8076 37.0208 29.3934 37.6066C29.9792 38.1924 30.9289 38.1924 31.5147 37.6066L41.0607 28.0607ZM15 28.5H40V25.5H15V28.5Z"
                                    fill="white" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-consultations4-tariffs', {
        label: 'Consultations tariffs (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-consultations4-tariffs main-wrapper">
                <div class="careerum-container-responsive80">
                    <h2>Задачи, которые вы сможете решить на консультации</h2>
                    <div class="consultations4-tariffs-currency position-relative z-20">
                        <div class="hidden-tablet-mobile">
                            <div class="consultations4-tariffs-currency-desctop careerum-flex-fsst">
                                <ul class="careerum-flex-fsfs">
                                    <li data-currency="eur" class="active">EUR</li>
                                    <li data-currency="rub">RUB</li>
                                </ul>
                                <div class="consultations4-tariffs-notif careerum-flex-cc">
                                    <div class="consultations4-tariffs-notif-icon">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                            alt="">
                                    </div>
                                    <div class="consultations4-tariffs-notif-content">
                                        <p>Оплата в российских рублях возможна только картой
                                            российского банка. В&nbsp;евро — картой
                                            зарубежного банка</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="hidden-desc position-relative">
                            <div class="consultations4-tariffs__swicher-block position-absolute">
                                <div class="consultations4-tariffs__swicher-top">
                                    <p class="consultations4-tariffs__swicher-header">Посмотреть
                                        цены в
                                        <span>RUB</span>
                                    </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" class="consultations4-tariffs__swicher-arrow">
                                        <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black">
                                        </path>
                                    </svg>
                                </div>
                                <div class="consultations4-tariffs__swicher-bottom">
                                    <ul>
                                        <li data-currency="rub">
                                            RUB
                                        </li>
                                        <li data-currency="eur" class="active">
                                            EUR
                                        </li>
                                    </ul>
                                    <p>
                                        Обратите внимание,<br> что оплата в российских
                                        рублях
                                        возможна только<br> с карты
                                        российского банка. Оплата в евро — с карты зарубежного банка
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="consultations4-tariffs-items careerum-flex-sbst position-relative z-10">
                        <div class="consultations4-tariffs-item"  data-price-rub="15 000 ₽" data-price-eur="150 €" data-link-rub="#r" data-link-eur="#e">
                            <div class="consultations4-tariffs-item__top careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982403554-1E3A5-File.svg"
                                        alt="">
                                    <p>Резюме + сопроводительное письмо</p>
                                </div>
                                <p>15 000 ₽</p>
                            </div>
                            <a href="#" class="btn-color-main-dark-orange">Купить</a>
                            <div class="consultations4-tariffs-item__bottom">
                                <p class="consultations4-tariffs-item__header-bottom">Что входит:</p>
                                <ul>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Онлайн-встреча 50 минут</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Разбор резюме</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Разбор сопроводительного письма</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Упаковка опыта под выбранную вами вакансию</p>
                                    </li>
                                </ul>
                                <p class="consultations4-tariffs-item__header-bottom">По итогам встречи вы получите:</p>
                                <ul>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214025-QSJ5W-1733.svg"
                                            alt="">
                                        <p>Запись встречи, чтобы можно было пересмотреть</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214025-QSJ5W-1733.svg"
                                            alt="">
                                        <p>Шаблоны: резюме на русском или английском</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214025-QSJ5W-1733.svg"
                                            alt="">
                                        <p>Примеры цепляющих сопроводительных писем</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="consultations4-tariffs-item">
                            <div class="consultations4-tariffs-item__top careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982403443-Fw2Ex-basi.svg"
                                        alt="">
                                    <p>LinkedIn + сопроводительное письмо для отклика
                                        в соцсети</p>
                                </div>
                                <p>15 000 ₽</p>
                            </div>
                            <a href="#" class="btn-color-main-dark-orange">Купить</a>
                            <div class="consultations4-tariffs-item__bottom">
                                <p class="consultations4-tariffs-item__header-bottom">Что входит:</p>
                                <ul>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Онлайн-встреча 50 минут</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Разбор профиля LinkedIn</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Разбор сопроводительного письма</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Упаковка саммари для профиля</p>
                                    </li>
                                </ul>
                                <p class="consultations4-tariffs-item__header-bottom">По итогам встречи вы получите:</p>
                                <ul>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214025-QSJ5W-1733.svg"
                                            alt="">
                                        <p>Запись встречи, чтобы можно было пересмотреть</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214025-QSJ5W-1733.svg"
                                            alt="">
                                        <p>Чек-лист сильного профиля</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214025-QSJ5W-1733.svg"
                                            alt="">
                                        <p>Примеры сильных профилей</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214025-QSJ5W-1733.svg"
                                            alt="">
                                        <p>Примеры цепляющих сопроводительных писем</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="consultations4-tariffs-item">
                            <div class="consultations4-tariffs-item__top careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982403318-tYifd-sola.svg"
                                        alt="">
                                    <p>Потренироваться проходить интервью</p>
                                    <span>на русском или английском</span>
                                </div>
                                <p>12 500 ₽</p>
                            </div>
                            <a href="#" class="btn-color-main-dark-orange">Купить</a>
                            <div class="consultations4-tariffs-item__bottom">
                                <p class="consultations4-tariffs-item__header-bottom">Что входит:</p>
                                <ul>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Онлайн-встреча 50 минут</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Интервью</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Разбор интервью: обратная связь, что улучшить</p>
                                    </li>
                                </ul>
                                <p class="consultations4-tariffs-item__header-bottom">По итогам встречи вы получите:</p>
                                <ul>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214025-QSJ5W-1733.svg"
                                            alt="">
                                        <p>Запись встречи, чтобы можно было пересмотреть</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214025-QSJ5W-1733.svg"
                                            alt="">
                                        <p>Чек-лист самых популярных вопросов на интервью</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214025-QSJ5W-1733.svg"
                                            alt="">
                                        <p>Алгоритм ответов на вопросы</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="consultations4-tariffs-item">
                            <div class="consultations4-tariffs-item__top careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982403200-0LPkd-file.svg"
                                        alt="">
                                    <p>Откликаюсь,<br> но не приглашают на интервью</p>
                                </div>
                                <p>15 000 ₽</p>
                            </div>
                            <a href="#" class="btn-color-main-dark-orange">Купить</a>
                            <div class="consultations4-tariffs-item__bottom">
                                <p class="consultations4-tariffs-item__header-bottom">Что входит:</p>
                                <ul>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Онлайн-встреча 50 минут</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Анализ резюме/LinkedIn относительно вакансий, на которые откликаетесь</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Анализ сопроводительного письма</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Анализ количества откликов
                                            и приглашений на интервью</p>
                                    </li>
                                </ul>
                                <p class="consultations4-tariffs-item__header-bottom">По итогам встречи вы получите:</p>
                                <ul>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214025-QSJ5W-1733.svg"
                                            alt="">
                                        <p>Запись встречи, чтобы можно было пересмотреть</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214025-QSJ5W-1733.svg"
                                            alt="">
                                        <p>Чек-лист ошибок вашего поиска работы и рекомендации
                                            по улучшению</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="consultations4-tariffs-item">
                            <div class="consultations4-tariffs-item__top careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982403091-kqFeq-file.svg"
                                        alt="">
                                    <p>Карьерная консультация</p>
                                </div>
                                <div class="careerum-flex-fsc">
                                    <p>Примеры запросов:</p>
                                    <p class="hidden-desc-mobile">не умею себя продавать</p>
                                    <p>боюсь проходить собеседования</p>
                                    <p>личные границы на работе</p>
                                    <p>work-life-balance</p>
                                    <p class="hidden-desc">не знаю, что делать дальше в карьере</p>
                                    <p>синдром самозванца</p>
                                    <p class="hidden-tablet">не умею себя продавать</p>
                                    <p class="hidden-tablet-mobile">не знаю, что делать дальше в карьере</p>
                                    <p>адаптация на новой работе</p>
                                </div>
                                <p>10 000 ₽</p>
                            </div>
                            <a href="#" class="btn-color-main-dark-orange">Купить</a>
                            <div class="consultations4-tariffs-item__bottom">
                                <p class="consultations4-tariffs-item__header-bottom">Что входит:</p>
                                <ul>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Онлайн-встреча 50 минут</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Разбор вашего запроса</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Составление плана действий по выходу из ситуации</p>
                                    </li>
                                </ul>
                                <p class="consultations4-tariffs-item__header-bottom">По итогам встречи вы получите:</p>
                                <ul>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214025-QSJ5W-1733.svg"
                                            alt="">
                                        <p>Запись встречи, чтобы можно было пересмотреть</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214025-QSJ5W-1733.svg"
                                            alt="">
                                        <p>Список рекомендаций</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="consultations4-tariffs-item">
                            <div class="consultations4-tariffs-item__top careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982402845-RA0pi-file.svg"
                                        alt="">
                                    <p>Индивидуальная стратегическая сессия</p>
                                </div>
                                <p>20 500 ₽</p>
                            </div>
                            <a href="#" class="btn-color-main-dark-orange">Купить</a>
                            <div class="consultations4-tariffs-item__bottom">
                                <p class="consultations4-tariffs-item__header-bottom">Что входит:</p>
                                <ul>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Онлайн-встреча 2 часа</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Ретроспектива, в какой точке вы сейчас</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Постановка целей, куда хотите прийти</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Пошаговый план</p>
                                    </li>
                                </ul>
                                <p class="consultations4-tariffs-item__header-bottom">По итогам встречи вы получите:</p>
                                <ul>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214025-QSJ5W-1733.svg"
                                            alt="">
                                        <p>Запись встречи, чтобы можно было пересмотреть</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214025-QSJ5W-1733.svg"
                                            alt="">
                                        <p>Пошаговый план и как по нему идти</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-consultations4-contacts', {
        label: 'Consultations contacts (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-consultations4-contacts main-wrapper">
                <div class="careerum-container-responsive80 position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1747756640106-jyCUc-Vect.svg" alt="" class="hidden-tablet-mobile position-absolute">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1747756650406-JBF2J-Vect.svg" alt="" class="hidden-desc-mobile position-absolute">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1747756658526-9geim-Vect.svg" alt="" class="hidden-desc-tablet position-absolute">
                    <h2>Если перед вами стоит несколько задач, которые не получится решить за одну консультацию, напишите нам об этом.</h2>
                    <p>Мы подготовим для вас персонализированный пакет из нескольких консультаций на самых выгодных условиях</p>
                    <div class="consultations4-contacts-bottom">
                        <a href="#" target="_blank">Связаться с нами в Telegram</a>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-consultations4-about', {
        label: 'Consultations about (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-consultations4-about main-wrapper">
                <div class="careerum-container-responsive80">
                    <h2>Научитесь проходить собеседования</h2>
                    <div class="consultations4-about__wrapper careerum-flex-fsfs position-relative">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739987071263-xStpm-Line.svg" alt=""
                            class="position-absolute hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739995412211-lmOpp-Line.svg" alt=""
                            class="position-absolute hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739999369620-KRWKK-Line.svg" alt=""
                            class="position-absolute hidden-desc-tablet">
                        <div class="consultations4-about__left position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739987103601-zwt1r-Grou.svg"
                                alt="" class="position-absolute hidden-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739999536017-AZg0B-Grou.svg"
                                alt="" class="position-absolute hidden-desc-tablet">
                            <div class="careerum-flex-fsfs">
                                <p class="consultations4-about__label-fill position-relative z-20">Старт 4 февраля</p>
                                <p class="consultations4-about__label-line position-relative z-10">4 zoom-встречи</p>
                            </div>
                            <p class="consultations4-about__subheader">Набор в на групповые консультации</p>
                            <p class="consultations4-about__header">Тренируемся проходить собеседования </p>
                            <p class="consultations4-about__text">Что входит:</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739987150703-BujMK-Trop.svg"
                                        alt="">
                                    <p>Решите топ-7 главных проблем поиска работы</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739987150600-5b1tK-Fram.svg"
                                        alt="">
                                    <p>Определите слабые места именно в вашем резюме и узнаете, как их исправить</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739987150490-UEG9Q-File.svg"
                                        alt="">
                                    <p>Разберёте резюме кандидатов, которые привели к офферам</p>
                                </li>
                            </ul>
                            <a href="#" class="btn-color-main-black-blue hidden-tablet-mobile ">Записаться</a>
                        </div>
                        <div class="consultations4-about__right position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739987189660-29MMf-Grou.png"
                                alt="" class="consultations4-about__expert position-absolute z-10 hidden-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739987189550-45mLh-Vect.svg"
                                alt="" class="consultations4-about__arrow position-absolute hidden-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739999970088-jtIgm-Grou.png"
                                alt="" class="consultations4-about__expert position-absolute z-10 hidden-desc-tablet">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739999969821-nHzCM-Vect.svg"
                                alt="" class="consultations4-about__arrow position-absolute hidden-desc-tablet z-30">
                            <p class="position-absolute z-20">Cофи Бессон, СV-экспертка, помогла 400+ клиентам найти работу
                                в США, Европе и Канаде</p>
                        </div>
                        <a href="#" class="btn-color-main-black-blue hidden-desc">Записаться</a>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-consultations4-how', {
        label: 'Consultations how (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-consultations4-how main-wrapper">
                <div class="careerum-container-responsive80">
                    <h2>Как работают консультации</h2>
                    <div class="consultations4-how-items careerum-flex-sbst">
                        <div class="consultations4-how-item">
                            <div class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739988511541-LxX8p-file.svg"
                                    alt="">
                                <p>Шаг 1</p>
                            </div>
                            <p>После оплаты вам приходит письмо
                                с анкетой, которую нужно заполнить под ваш карьерный запрос</p>
                        </div>
                        <div class="consultations4-how-item">
                            <div class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739988511429-SiYKS-file.svg"
                                    alt="">
                                <p>Шаг 2</p>
                            </div>
                            <p>Подбираем специалиста в течение
                                48 часов. <br>
                                Чем подробнее вы ее заполните, тем точнее мы сможем подобрать для вас специалиста с опытом
                                именно
                                в вашей теме</p>
                        </div>
                        <div class="consultations4-how-item">
                            <div class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739988511315-LXuvT-file.svg"
                                    alt="">
                                <p>Шаг 3</p>
                            </div>
                            <p>С вами связывается эксперт
                                и согласовывает дату и время консультации</p>
                        </div>
                        <div class="consultations4-how-item">
                            <div class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739988511200-7SFGg-file.svg"
                                    alt="">
                                <p>Шаг 4</p>
                            </div>
                            <p>Консультации проходят онлайн
                                в удобное для вас время.<br>
                                Каждая консультация длится 50 минут</p>
                        </div>
                        <div class="consultations4-how-item">
                            <div class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739988510967-XhEOY-1737.svg"
                                    alt="">
                                <p>Шаг 5</p>
                            </div>
                            <p>После консультации мы высылаем
                                вам на почту запись консультации
                                и дополнительные материалы</p>
                        </div>
                        <div class="consultations4-how-item blue">
                            <div>
                                <div class="careerum-flex-fsc">
                                    <p>Важно!</p>
                                </div>
                                <p>Приобретенную услугу необходимо использовать в течение одного месяца.</p>
                                <p>Вы можете перенести или отменить консультацию максимум за 24 часа до назначенного времени</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-consultations4-results', {
        label: 'Consultations results (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-consultations4-results main-wrapper">
                <div class="careerum-container-responsive80 position-relative">
                    <h2>Результаты, которые достигли наши клиенты</h2>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739989926087-ZmEP0-Vect.svg" alt=""
                        class="position-absolute hidden-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740000555748-yHq8l-Vect.svg" alt=""
                        class="position-absolute hidden-desc-tablet">
                    <div class="consultations4-results-slider">
                        <div>
                            <div class="consultations4-results-item">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739989577711-UJIIY-feed.png"
                                    alt="" class="hidden-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740000800246-DijJg-feed.png"
                                    alt="" class="hidden-desc-tablet">
                            </div>
                            <div class="consultations4-results-item">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739989577577-FoFng-feed.png"
                                    alt="" class="hidden-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740000800141-IjFjR-feed.png"
                                    alt="" class="hidden-desc-tablet">
                            </div>
                            <div class="consultations4-results-item">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739989577434-ZEKRs-Grou.png"
                                    alt="" class="hidden-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740000800036-ez15y-Grou.png"
                                    alt="" class="hidden-desc-tablet">
                            </div>
                            <div class="consultations4-results-item">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739989577315-5Y3u9-feed.png"
                                    alt="" class="hidden-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740000799933-nICc8-feed.png"
                                    alt="" class="hidden-desc-tablet">
                            </div>
                            <div class="consultations4-results-item">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739989577186-rBQdA-feed.png"
                                    alt="" class="hidden-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740000799830-8LGtj-feed.png"
                                    alt="" class="hidden-desc-tablet">
                            </div>
                            <div class="consultations4-results-item">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739989577040-7jz0j-Grou.png"
                                    alt="" class="hidden-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740000799725-HyHLH-Grou.png"
                                    alt="" class="hidden-desc-tablet">
                            </div>
                            <div class="consultations4-results-item">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739989576903-pErZw-feed.png"
                                    alt="" class="hidden-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740000799609-1tVto-feed.png"
                                    alt="" class="hidden-desc-tablet">
                            </div>
                            <div class="consultations4-results-item">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739989576656-UP3Uo-feed.png"
                                    alt="" class="hidden-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740000799444-mIm3T-feed.png"
                                    alt="" class="hidden-desc-tablet">
                            </div>
                            <div class="consultations4-results-item">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739989576270-9JAOX-feed.png"
                                    alt="" class="hidden-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740000799137-1UZoT-feed.png"
                                    alt="" class="hidden-desc-tablet">
                            </div>
                        </div>
                    </div>
                    <div class="consultations4-results-nav careerum-flex-fec">
                        <div class="consultations4-results-nav-prev hidden-tablet-mobile">
                            <svg width="55" height="54" viewBox="0 0 55 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="55" height="54" rx="27" transform="matrix(-1 0 0 1 55 0)" fill="black" />
                                <path
                                    d="M40 25.5C40.8284 25.5 41.5 26.1716 41.5 27C41.5 27.8284 40.8284 28.5 40 28.5V25.5ZM13.9393 28.0607C13.3536 27.4749 13.3536 26.5251 13.9393 25.9393L23.4853 16.3934C24.0711 15.8076 25.0208 15.8076 25.6066 16.3934C26.1924 16.9792 26.1924 17.9289 25.6066 18.5147L17.1213 27L25.6066 35.4853C26.1924 36.0711 26.1924 37.0208 25.6066 37.6066C25.0208 38.1924 24.0711 38.1924 23.4853 37.6066L13.9393 28.0607ZM40 28.5H15V25.5H40V28.5Z"
                                    fill="white" />
                            </svg>
                        </div>
                        <div class="consultations4-results-nav-next">
                            <svg width="55" height="54" viewBox="0 0 55 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="55" height="54" rx="27" fill="black" />
                                <path
                                    d="M15 25.5C14.1716 25.5 13.5 26.1716 13.5 27C13.5 27.8284 14.1716 28.5 15 28.5V25.5ZM41.0607 28.0607C41.6464 27.4749 41.6464 26.5251 41.0607 25.9393L31.5147 16.3934C30.9289 15.8076 29.9792 15.8076 29.3934 16.3934C28.8076 16.9792 28.8076 17.9289 29.3934 18.5147L37.8787 27L29.3934 35.4853C28.8076 36.0711 28.8076 37.0208 29.3934 37.6066C29.9792 38.1924 30.9289 38.1924 31.5147 37.6066L41.0607 28.0607ZM15 28.5H40V25.5H15V28.5Z"
                                    fill="white" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-intens4-main', {
        label: 'Intensive main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-intens4-main main-wrapper">
        <div class="careerum-container-responsive">
            <div class="careerum-flex-sbfs">
                <div class="intens4-main__left position-relative z-10">
                    <div class="careerum-flex-fsfs intens4-main__labels">
                        <div class="intens4-main__label-orange careerum-flex-cc">
                            <p>В подписке Careerum</p>
                        </div>
                        <div class="intens4-main__label-white careerum-flex-cc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740999546789-0SCnq-Cale.svg"
                                alt="" class="hidden-mobile">
                            <p>Старт: 26 марта</p>
                        </div>
                        <div class="intens4-main__label-white careerum-flex-cc">
                            <p>3 месяца</p>
                        </div>
                    </div>
                    <h1>Power Talk</h1>
                    <p>Курс по сильным коммуникациям для прорыва <span>в карьере</span></p>
                    <a href="#" class="btn-color-main-dark-orange">Посмотреть программу</a>
                </div>
                <div class="intens4-main__right position-relative z-20">
                    <div class="position-absolute">
                        <div class="position-absolute">реализация амбиций</div>
                        <div class="position-absolute">повышение</div>
                        <div class="position-absolute">лидерские позиции</div>
                        <div class="position-absolute">крутые проекты</div>
                        <div class="position-absolute">кайф от работы</div>
                        <div class="position-absolute">признание экспертизы</div>
                        <div class="position-absolute">рост дохода</div>
                        <div class="position-absolute">междyнародная карьера</div>
                    </div>
                    <div class="position-absolute hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741078378188-45W7p-Grou.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741078378071-r4bpQ-Grou.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741680347838-xi93E-Star.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741078377850-1z6D8-Grou.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741078377729-Ksjx0-Star.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741078377624-yfuX6-Star.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741078377517-omO51-Elli.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741078377238-nhRrP-Grou.svg"
                            alt="" class="position-absolute">
                    </div>
                    <div class="position-absolute hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741681330796-OI5ej-Grou.png"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741681330513-9vlXf-Grou.png"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741085385517-jn4GJ-Star.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741078377850-1z6D8-Grou.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741078377729-Ksjx0-Star.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741078377624-yfuX6-Star.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741078377517-omO51-Elli.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741078377238-nhRrP-Grou.svg"
                            alt="" class="position-absolute">
                    </div>
                    <div class="position-absolute hidden-desc-tablet">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741681778188-6j3Uk-Grou.png"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741681777917-Bixv2-Grou.png"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741158067504-ocGNc-Star.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741681661110-iIxUw-Grou.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741158067391-XQGXF-Star.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741158067828-cJvcD-Star.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741158067613-wKSp4-Elli.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741158067276-fhnWa-Grou.svg"
                            alt="" class="position-absolute">
                    </div>
                </div>
            </div>
            <a href="#" class="btn-color-main-dark-orange">Посмотреть программу</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-intens4-for', {
        label: 'Intensive for (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-intens4-for main-wrapper">
        <div class="careerum-container-responsive">
            <div class="intens4-for__top position-relative">
                <h2>Курс подойдет</h2>
                <p>Если ваша карьера зависит от умения эффективно общаться, продавать идеи и влиять на людей, и вы:</p>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740999614418-9fsgy-Vect.svg" alt=""
                    class="position-absolute hidden-tablet-mobile">
            </div>
            <div class="intens4-for__bottom">
                <div class="careerum-flex-cfs item-wide">
                    <div class="intens4-for__bottom-item careerum-flex-fsfs">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740999943541-vDISS-img..png"
                                alt="">
                        </div>
                        <div>
                            <p>Middle/Senior, хочу получить повышение и научиться обосновывать свои карьерные запросы
                            </p>
                        </div>
                    </div>
                    <div class="intens4-for__bottom-item careerum-flex-fsfs">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740999943242-7DCtW-img .png"
                                alt="">
                        </div>
                        <div>
                            <p>Управляю отношениями с партнерами и клиентами, хочу научиться мастерству сильных
                                переговоров</p>
                        </div>
                    </div>
                </div>
                <div class="careerum-flex-cfs">
                    <div class="intens4-for__bottom-item careerum-flex-fsfs">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740999943650-AICbC-img .png"
                                alt="">
                        </div>
                        <div>
                            <p>Head of, хочу начать делегировать задачи и не тянуть все на себе</p>
                        </div>
                    </div>
                    <div class="intens4-for__bottom-item careerum-flex-fsfs">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740999943761-UXHzp-img .png"
                                alt="">
                        </div>
                        <div>
                            <p>Свежий тимлид без опыта управления, хочу стать настоящим лидером </p>
                        </div>
                    </div>
                    <div class="intens4-for__bottom-item careerum-flex-fsfs">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740999943879-6LskC-img .png"
                                alt="">
                        </div>
                        <div>
                            <p>Удаленщица, хочу проще и быстрее договариваться с коллегами </p>
                        </div>
                    </div>
                </div>
                <div class="careerum-flex-cfs item-wide">
                    <div class="intens4-for__bottom-item careerum-flex-fsfs">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740999944001-15ZxY-img .png"
                                alt="">
                        </div>
                        <div>
                            <p>Продакт-менеджер на стыке нескольких отделов и хочу научиться эффективно общаться со
                                специалистами с разным бэкграундом </p>
                        </div>
                    </div>
                    <div class="intens4-for__bottom-item careerum-flex-fsfs">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740999944106-Z8jKx-img .png"
                                alt="">
                        </div>
                        <div>
                            <p>Менеджер проектов с несколькими стейкхолдерами, хочу научиться защищать свои идеи
                                аргументировано и без стресса</p>
                        </div>
                    </div>
                </div>
                <div class="careerum-flex-cfs">
                    <div class="intens4-for__bottom-item careerum-flex-fsfs">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740999944376-lHBfM-img .png"
                                alt="">
                        </div>
                        <div>
                            <p>Специалистка, хочу выстроить здоровые отношения с командой без токсика и манипуляций </p>
                        </div>
                    </div>
                    <div class="intens4-for__bottom-item careerum-flex-fsfs">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740999944501-Xl2zq-img .png"
                                alt="">
                        </div>
                        <div>
                            <p>Незаметный профи, хочу повысить свою экспертность в глазах коллег </p>
                        </div>
                    </div>
                    <div class="intens4-for__bottom-item careerum-flex-fsfs">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740999944621-c5JVv-img .png"
                                alt="">
                        </div>
                        <div>
                            <p>Руководительница, хочу научиться “продавать” идеи команде и давать экологичную обратную
                                связь </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-intens4-how', {
        label: 'Intensive how (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-intens4-how main-wrapper">
        <div class="careerum-container-responsive">
            <h2>Как слабые коммуникации тормозят ваш рост?</h2>
            <p>*По данным исследований McKinsey, Harvard Business Review и Project Management Institute </p>
            <div class="intens4-how__item yellow careerum-flex-fsst">
                <div class="position-relative">
                    <div class="careerum-flex-fsfs">
                        <p class="intens4-how__item-header">67%</p>
                        <p class="intens4-how__item-label right">специалистов</p>
                    </div>
                    <p class="intens4-how__item-text">Испытывают трудности при продвижении своих идей руководству</p>
                </div>
                <div class="position-relative">
                    <div class="careerum-flex-fsfs">
                        <p class="intens4-how__item-header">83%</p>
                        <p class="intens4-how__item-label left">профессионалов</p>
                    </div>
                    <p class="intens4-how__item-text">Признают, что испытывают стресс при публичной защите проектов
                        и важных переговорах</p>
                </div>
                <div class="position-relative">
                    <div class="careerum-flex-fsfs">
                        <p class="intens4-how__item-header">91%</p>
                        <p class="intens4-how__item-label left">удалёнщиков</p>
                    </div>
                    <p class="intens4-how__item-text">Отмечают, что качество коммуникации напрямую влияет
                        на их эффективность</p>
                </div>
            </div>
            <div class="intens4-how__item violet careerum-flex-fsst">
                <div class="position-relative">
                    <div class="careerum-flex-fsfs">
                        <p class="intens4-how__item-header">72%</p>
                        <p class="intens4-how__item-label right">специалистов</p>
                    </div>
                    <p class="intens4-how__item-text">Чувствуют, что недостаток soft навыков мешает карьерному росту</p>
                </div>
                <div class="position-relative">
                    <div class="careerum-flex-fsfs">
                        <p class="intens4-how__item-header">64%</p>
                        <p class="intens4-how__item-label left">руководителей</p>
                    </div>
                    <p class="intens4-how__item-text">Считают слабые коммуникативные навыки главным препятствием
                        для повышения сотрудников</p>
                </div>
                <div class="position-relative">
                    <div class="careerum-flex-fsfs">
                        <p class="intens4-how__item-header">58%</p>
                        <p class="intens4-how__item-label left">проектов</p>
                    </div>
                    <p class="intens4-how__item-text">Терпят неудачу из-за неэффективного общения внутри команды</p>
                </div>
            </div>
            <div class="intens4-how__item white careerum-flex-sbst">
                <div class="careerum-flex-sbst">
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000145239-hlKmG-Smil.svg"
                            alt="">
                        <p>Не знаете, как продвигать себя, чтобы расти в зарплате и должности</p>
                    </div>
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000145118-lKveO-Thum.svg"
                            alt="">
                        <p>Постоянно сомневаетесь в своей экспертизе при общении с коллегами</p>
                    </div>
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000144797-MIJQl-XCir.svg"
                            alt="">
                        <p>Не умеете давать обратную связь коллегам, тем более негативную</p>
                    </div>
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000145118-lKveO-Thum.svg"
                            alt="">
                        <p>Не умеете устанавливать и поддерживать профессиональные границы</p>
                    </div>
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000144797-MIJQl-XCir.svg"
                            alt="">
                        <p>Не умеете конструктивно решать конфликты на работе. Злитесь и токсичите</p>
                    </div>
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000145239-hlKmG-Smil.svg"
                            alt="">
                        <p>Сталкиваетесь с манипуляциями и токсичностью со стороны команды</p>
                    </div>
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000144797-MIJQl-XCir.svg"
                            alt="">
                        <p>Не умеете «продать» свои идеи и инициативы руководителю</p>
                    </div>
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000145239-hlKmG-Smil.svg"
                            alt="">
                        <p>Не умеете аргументировать свою позицию коллегам</p>
                    </div>
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000145118-lKveO-Thum.svg"
                            alt="">
                        <p>Не умеете получать результат от планёрок</p>
                    </div>
                </div>
            </div>
            <a href="#programm" class="btn-color-main-dark-orange">Посмотреть программу</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-intens4-banner', {
        label: 'Intensive banner (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-intens4-banner main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <div class="position-absolute z-10 hidden-tablet-mobile ">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000264057-oLGsP-Elli.svg" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000263944-1q4AV-Vect.svg" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000263826-JADnC-Star.svg" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000263593-cQxcP-Vect.svg" alt=""
                    class="position-absolute">
            </div>
            <div class="position-absolute z-10 hidden-desc-mobile ">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741070661907-njDCw-Elli.svg" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741070661665-V3Plv-Vect.svg" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741070661783-3nkze-Star.svg" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741070661365-U1Ypy-Vect.svg" alt=""
                    class="position-absolute">
            </div>
            <div class="position-absolute z-10 hidden-desc-tablet ">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741103664140-kL2jK-Elli.svg" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741103664007-iX1Fu-Vect.svg" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741103663900-gUrbl-Star.svg" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741103663637-li3HL-Vect.svg" alt=""
                    class="position-absolute">
            </div>
            <p class="intens4-banner-subheader position-relative z-20">Big Idea </p>
            <h2 class="position-relative z-20">Power Talk</h2>
            <p class="intens4-banner-header position-relative z-20 hidden-mobile">Is The New Sexy</p>
            <p class="intens4-banner-header position-relative z-20 hidden-desc-tablet">Is The</p>
            <p class="intens4-banner-header position-relative z-20 hidden-desc-tablet">New Sexy</p>
            <p class="intens4-banner-text position-relative z-20">Сделаем деловое общение человечным, а ваш карьерный
                рост — неизбежным</p>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-intens4-study', {
        label: 'Intensive study (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-intens4-study main-wrapper">
        <div class="careerum-container-responsive">
            <div class="intens4-study__top position-relative">
                <p class="intens4-study__label position-relative">В подписке Careerum</p>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000320579-rrgjn-Line.svg" alt=""
                    class="position-absolute z-10 hidden-tablet-mobile">
                <h2>Как проходит обучение </h2>
                <p class="hidden-mobile">В течение месяца мы будем превращать вас из застенчивых профи в харизматичных
                    коммуникаторов </p>
            </div>
            <div class="intens4-study__bottom careerum-flex-sbst">
                <div class="intens4-study__item gray hidden-desc-tablet">
                    <p class="intens4-study__item-text2">В течение месяца мы будем превращать вас из застенчивых профи в
                        харизматичных коммуникаторов </p>
                </div>
                <div class="intens4-study__item position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000319498-YCtvg-Arro.svg"
                        alt="" class="position-absolute hidden-tablet-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741071192302-1FB9B-Arro.svg"
                        alt="" class="position-absolute hidden-desc-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741104474141-vpvrr-Arro.svg"
                        alt="" class="position-absolute hidden-desc-tablet ">
                    <p class="intens4-study__item-title">Формат</p>
                    <p class="intens4-study__item-text">Формат интенсива — 3 месяца </p>
                </div>
                <div class="intens4-study__item position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000319498-YCtvg-Arro.svg"
                        alt="" class="position-absolute hidden-tablet-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741071192302-1FB9B-Arro.svg"
                        alt="" class="position-absolute hidden-desc-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741104474141-vpvrr-Arro.svg"
                        alt="" class="position-absolute hidden-desc-tablet ">
                    <p class="intens4-study__item-title">Видеоуроки</p>
                    <p class="intens4-study__item-text">20 емких видеолекций</p>
                </div>
                <div class="intens4-study__item position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000319498-YCtvg-Arro.svg"
                        alt="" class="position-absolute hidden-tablet-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741071192302-1FB9B-Arro.svg"
                        alt="" class="position-absolute hidden-desc-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741104474141-vpvrr-Arro.svg"
                        alt="" class="position-absolute hidden-desc-tablet ">
                    <p class="intens4-study__item-title hidden-tablet-mobile">Практики с экспертами</p>
                    <p class="intens4-study__item-title hidden-desc">Практики</p>
                    <p class="intens4-study__item-text">5 онлайн-практик и живой разбор кейсов</p>
                </div>
                <div class="intens4-study__item position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000319498-YCtvg-Arro.svg"
                        alt="" class="position-absolute hidden-tablet-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741071192302-1FB9B-Arro.svg"
                        alt="" class="position-absolute hidden-desc-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741104474141-vpvrr-Arro.svg"
                        alt="" class="position-absolute hidden-desc-tablet ">
                    <p class="intens4-study__item-title">Тренировка soft skills</p>
                    <p class="intens4-study__item-text">Домашние задания на тренировку soft навыков</p>
                </div>
                <div class="intens4-study__item position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000319498-YCtvg-Arro.svg"
                        alt="" class="position-absolute hidden-tablet-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741071192302-1FB9B-Arro.svg"
                        alt="" class="position-absolute hidden-desc-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741104474141-vpvrr-Arro.svg"
                        alt="" class="position-absolute hidden-desc-tablet ">
                    <p class="intens4-study__item-title">Нетворкинг</p>
                    <p class="intens4-study__item-text">Лидерский нетворкинг — 4 встречи</p>
                </div>
                <div class="intens4-study__item position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000319498-YCtvg-Arro.svg"
                        alt="" class="position-absolute hidden-tablet-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741071192302-1FB9B-Arro.svg"
                        alt="" class="position-absolute hidden-desc-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741104474141-vpvrr-Arro.svg"
                        alt="" class="position-absolute hidden-desc-tablet ">
                    <p class="intens4-study__item-title">Coffee buddy</p>
                    <p class="intens4-study__item-text">Еженедельные Coffeе Buddy</p>
                </div>
                <div class="intens4-study__item position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000319498-YCtvg-Arro.svg"
                        alt="" class="position-absolute hidden-tablet-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741071192302-1FB9B-Arro.svg"
                        alt="" class="position-absolute hidden-desc-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741104474141-vpvrr-Arro.svg"
                        alt="" class="position-absolute hidden-desc-tablet ">
                    <p class="intens4-study__item-title">Q&A-сессии</p>
                    <p class="intens4-study__item-text">6 Q&A-сессий с коучами из команды Careerum</p>
                </div>
                <div class="intens4-study__item position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000319498-YCtvg-Arro.svg"
                        alt="" class="position-absolute hidden-tablet-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741071192302-1FB9B-Arro.svg"
                        alt="" class="position-absolute hidden-desc-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741104474141-vpvrr-Arro.svg"
                        alt="" class="position-absolute hidden-desc-tablet ">
                    <p class="intens4-study__item-title">Buddy-поддержка</p>
                    <p class="intens4-study__item-text">Buddy-поддержка: мотивация и менторство в тройках с другими
                        участниками по принципу “равный равному”</p>
                </div>
                <div class="intens4-study__item position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000319498-YCtvg-Arro.svg"
                        alt="" class="position-absolute hidden-tablet-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741071192302-1FB9B-Arro.svg"
                        alt="" class="position-absolute hidden-desc-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741104474141-vpvrr-Arro.svg"
                        alt="" class="position-absolute hidden-desc-tablet ">
                    <p class="intens4-study__item-title">Комьюнити</p>
                    <p class="intens4-study__item-text">Чат нетворк-комьюнити с поддержкой кураторов</p>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-intens4-programm', {
        label: 'Intensive programm (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-intens4-programm main-wrapper">
        <div class="careerum-container-responsive">
            <h2>Программа</h2>
            <div class="intens4-programm__item">
                <div class="intens4-programm__item-top">
                    <p class="intens4-programm__item-label">Модуль 1 </p>
                    <p class="intens4-programm__item-header">EcoTalk. Здоровое общение и личные границы на работе</p>
                    <div class="intens4-programm__item-top-list">
                        <div class="careerum-flex-sbc">
                            <p>Как корректно формулировать свои мысли. Разбор типичных ошибок</p>
                            <p>Видеолекция</p>
                        </div>
                        <div class="careerum-flex-sbc">
                            <p>Как реагировать на агрессию пассивную и явную</p>
                            <p>Видеолекция</p>
                        </div>
                        <div class="careerum-flex-sbc">
                            <p>Личные границы на работе: как корректно отказать в просьбе, как отказаться от «неважной»
                                работы</p>
                            <p>Видеолекция</p>
                        </div>
                        <div class="careerum-flex-sbc">
                            <p>Экологичная обратная связь</p>
                            <p>Видеолекция</p>
                        </div>
                    </div>
                </div>
                <div class="intens4-programm__item-bottom careerum-flex-sbst">
                    <div class="intens4-programm__item-expert pink careerum-flex-sbfs">
                        <div>
                            <p class="hidden-desc-tablet intens4-programm__item-expert-title">Практика с экспертом</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000437656-i7KD7-Phot.png"
                                alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741072738899-O092O-Phot.png"
                                alt="" class="hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741105374395-6lC7h-Phot.png"
                                alt="" class="hidden-desc-tablet">
                        </div>
                        <div>
                            <p class="hidden-mobile intens4-programm__item-expert-title">Практика с экспертом</p>
                            <p class="intens4-programm__item-expert-name">Ольга Лермонтова</p>
                            <p class="intens4-programm__item-expert-text">Карьерный стратег и сертифированный коуч</p>
                            <p class="intens4-programm__item-expert-text">Основательница Careerum</p>
                            <p class="intens4-programm__item-expert-text">15+ лет на руководящих позициях в
                                tech-компаниях: Google, Microsoft, Intel, управляла бизнесом на 20+ рынках Африки,
                                Западной и Восточной Европы</p>
                            <div class="careerum-flex-fsc intens4-programm__item-expert-img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000778483-nTpGq-Goog.svg"
                                    alt="" class="hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000778386-bVEtA-Micr.svg"
                                    alt="" class="hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000778104-k5S1h-Inte.svg"
                                    alt="" class="hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741072962354-cibm0-Logo.png"
                                    alt="" class="hidden-desc">
                            </div>
                        </div>
                        <div class="careerum-flex-fsc">
                            <p>’’</p>
                            <p class="intens4-programm__item-expert-quote">Коммуникации — это не дар, а «мышца», которую
                                нужно регулярно качать</p>
                        </div>
                    </div>
                    <div>
                        <p>Экологичное лидерство</p>
                        <div class="intens4-programm__item-bottom-list">
                            <p>Эмпатичная коммуникация: как слышать и быть услышанным</p>
                            <p>Конструктивная обратная связь: как давать и принимать</p>
                            <p>Ассертивность в действии: уверенное общение без агрессии</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="intens4-programm__item">
                <div class="intens4-programm__item-top">
                    <p class="intens4-programm__item-label">Модуль 2 </p>
                    <p class="intens4-programm__item-header">Эффективное управление конфликтами и переговоры</p>
                    <div class="intens4-programm__item-top-list">
                        <div class="careerum-flex-sbc">
                            <p>Тренируем навык переговоров</p>
                            <p>Видеолекция</p>
                        </div>
                        <div class="careerum-flex-sbc">
                            <p>Сильные вопросы и виды слушания</p>
                            <p>Видеолекция</p>
                        </div>
                        <div class="careerum-flex-sbc">
                            <p>Медиация конфликтов, тактики влияния и ваш стиль переговоров</p>
                            <p>Видеолекция</p>
                        </div>
                    </div>
                </div>
                <div class="intens4-programm__item-bottom careerum-flex-sbst">
                    <div class="intens4-programm__item-expert yellow careerum-flex-sbfs">
                        <div>
                            <p class="hidden-desc-tablet intens4-programm__item-expert-title">Практика с экспертом</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000438199-3PnZ6-Phot.png"
                                alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741072738752-21Q01-Phot.png"
                                alt="" class="hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741105374864-icUYb-Phot.png"
                                alt="" class="hidden-desc-tablet">
                        </div>
                        <div>
                            <p class="hidden-mobile intens4-programm__item-expert-title">Практика с экспертом</p>
                            <p class="intens4-programm__item-expert-name">Михаил Ромашов</p>
                            <p class="intens4-programm__item-expert-text">Product Owner SberCIB</p>
                            <p class="intens4-programm__item-expert-text">Старший преподаватель в Soft Skills Lab</p>
                            <p class="intens4-programm__item-expert-text">Преподаватель в НИУ ВШЭ</p>
                            <div class="careerum-flex-fsc intens4-programm__item-expert-img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000885542-qmH5d-_.sv.svg"
                                    alt="" class="hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000885234-qbXlw-ÐÐ¾.svg"
                                    alt="" class="hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000884880-DRWyh-Sber.svg"
                                    alt="" class="hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741073525674-lNp6U-logo.png"
                                    alt="" class="hidden-desc">
                            </div>
                        </div>
                        <div class="careerum-flex-fsc">
                            <p>’’</p>
                            <p class="intens4-programm__item-expert-quote">Коммуникация — это валюта карьерного роста,
                                которая никогда не обесценивается</p>
                        </div>
                    </div>
                    <div>
                        <p>Как работать с теми, кто бесит</p>
                        <div class="intens4-programm__item-bottom-list">
                            <p>Как справляться с манипуляциями на работе и в жизни?</p>
                            <p>Как работать с эмоциональными людьми?</p>
                            <p>Как работать с теми, кто бесит?</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="intens4-programm__item">
                <div class="intens4-programm__item-top">
                    <p class="intens4-programm__item-label">Модуль 3 </p>
                    <p class="intens4-programm__item-header">Как «продавать» свои идеи руководителю и команде</p>
                    <div class="intens4-programm__item-top-list">
                        <div class="careerum-flex-sbc">
                            <p>Как находить общую цель с собеседником и учитывать контекст коммуникации</p>
                            <p>Видеолекция</p>
                        </div>
                        <div class="careerum-flex-sbc">
                            <p>Как «продать» идею своему руководителю или стейкхолдерам</p>
                            <p>Видеолекция</p>
                        </div>
                        <div class="careerum-flex-sbc">
                            <p>Отработка возражений после презентации идей. Разбор инструментов и кейсов</p>
                            <p>Видеолекция</p>
                        </div>
                        <div class="careerum-flex-sbc">
                            <p>Как «продать» идею команде. Коучинговые приемы работы с командой для руководителей</p>
                            <p>Видеолекция</p>
                        </div>
                    </div>
                </div>
                <div class="intens4-programm__item-bottom careerum-flex-sbst">
                    <div class="intens4-programm__item-expert violet careerum-flex-sbfs">
                        <div>
                            <p class="hidden-desc-tablet intens4-programm__item-expert-title">Практика с экспертом</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000438199-3PnZ6-Phot.png"
                                alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741072738752-21Q01-Phot.png"
                                alt="" class="hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741105374864-icUYb-Phot.png"
                                alt="" class="hidden-desc-tablet">
                        </div>
                        <div>
                            <p class="hidden-mobile intens4-programm__item-expert-title">Практика с экспертом</p>
                            <p class="intens4-programm__item-expert-name">Михаил Ромашов</p>
                            <p class="intens4-programm__item-expert-text">Product Owner SberCIB</p>
                            <p class="intens4-programm__item-expert-text">Старший преподаватель в Soft Skills Lab</p>
                            <p class="intens4-programm__item-expert-text">Преподаватель в НИУ ВШЭ</p>
                            <div class="careerum-flex-fsc intens4-programm__item-expert-img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000885542-qmH5d-_.sv.svg"
                                    alt="" class="hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000885234-qbXlw-ÐÐ¾.svg"
                                    alt="" class="hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000884880-DRWyh-Sber.svg"
                                    alt="" class="hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741073525674-lNp6U-logo.png"
                                    alt="" class="hidden-desc">
                            </div>
                        </div>
                        <div class="careerum-flex-fsc">
                            <p>’’</p>
                            <p class="intens4-programm__item-expert-quote">Эффективная коммуникация — это мост между
                                вашим потенциалом и его признанием </p>
                        </div>
                    </div>
                    <div>
                        <p>Как влюбить в вашу идею</p>
                        <div class="intens4-programm__item-bottom-list">
                            <p>Как превратить любую идею в проект, который невозможно отклонить</p>
                            <p>Техники влияния на коллег, которые работают даже в самых сложных ситуациях</p>
                            <p>Методы построения доверия в переговорах</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="intens4-programm__item">
                <div class="intens4-programm__item-top">
                    <p class="intens4-programm__item-label">Модуль 4 </p>
                    <p class="intens4-programm__item-header">Формула повышения в зарплате и должности</p>
                    <div class="intens4-programm__item-top-list">
                        <div class="careerum-flex-sbc">
                            <p>Как отчитываться по результатам, чтобы стать ценным сотрудником и вас заметили</p>
                            <p>Видеолекция</p>
                        </div>
                        <div class="careerum-flex-sbc">
                            <p>Как реагировать на критику руководителя, повышая свой авторитет</p>
                            <p>Видеолекция</p>
                        </div>
                        <div class="careerum-flex-sbc">
                            <p>Формула повышения в должности: как определить стратегически важную работу и расширить
                                свои полномочия</p>
                            <p>Видеолекция</p>
                        </div>
                    </div>
                </div>
                <div class="intens4-programm__item-bottom careerum-flex-sbst">
                    <div class="intens4-programm__item-expert blue careerum-flex-sbfs">
                        <div>
                            <p class="hidden-desc-tablet intens4-programm__item-expert-title">Практика с экспертом</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000438039-uy43G-Phot.png"
                                alt="" class="hidden-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/" alt=""
                                class="hidden-desc-tablet">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741105374748-wK44D-Phot.png"
                                alt="" class="hidden-desc-tablet">
                        </div>
                        <div>
                            <p class="hidden-mobile intens4-programm__item-expert-title">Практика с экспертом</p>
                            <p class="intens4-programm__item-expert-name">Мила Плющ</p>
                            <p class="intens4-programm__item-expert-text">CMO International Ads Яндекс</p>
                            <div class="careerum-flex-fsc intens4-programm__item-expert-img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741001287772-2kJN1-logo.svg"
                                    alt="">
                            </div>
                        </div>
                        <div class="careerum-flex-fsc">
                            <p>’’</p>
                            <p class="intens4-programm__item-expert-quote">Ваши идеи заслуживают быть услышанными.
                                Научитесь говорить так, чтобы к вам прислушивались</p>
                        </div>
                    </div>
                    <div>
                        <p>Как управлять руководителем</p>
                        <div class="intens4-programm__item-bottom-list">
                            <p>Понимание целей и приоритетов руководителя</p>
                            <p>Развитие проактивного подхода к коммуникации</p>
                            <p>Управление ожиданиями и установление границ</p>
                        </div>
                    </div>
                </div>
            </div>
            <a href="#buy" class="btn-color-main-dark-orange">Выбрать тариф</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-intens4-results', {
        label: 'Intensive results (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-intens4-results main-wrapper">
        <div class="careerum-container-responsive">
            <h2>Результаты курса</h2>
            <div class="intens4-results-slider">
                <div class="intens4-results-slider-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740997682340-MYXc9-Chec.svg"
                        alt="">
                    <p>Научитесь уверенно презентовать свои идеи руководству и согласовывать проекты</p>
                </div>
                <div class="intens4-results-slider-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740997682340-MYXc9-Chec.svg"
                        alt="">
                    <p>Освоите техники влияния
                        для эффективной работы с командой</p>
                </div>
                <div class="intens4-results-slider-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740997682340-MYXc9-Chec.svg"
                        alt="">
                    <p>Разовьете навыки стратегической коммуникации для перехода на следующий карьерный уровень</p>
                </div>
                <div class="intens4-results-slider-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740997682340-MYXc9-Chec.svg"
                        alt="">
                    <p>Сможете эффективно управлять конфликтами и сложными ситуациями на работе</p>
                </div>
                <div class="intens4-results-slider-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740997682340-MYXc9-Chec.svg"
                        alt="">
                    <p>Установите профессиональные границы и научитесь их поддерживать </p>
                </div>
                <div class="intens4-results-slider-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740997682340-MYXc9-Chec.svg"
                        alt="">
                    <p>Научитесь позиционировать свою экспертизу для получения более значимых проектов</p>
                </div>
                <div class="intens4-results-slider-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740997682340-MYXc9-Chec.svg"
                        alt="">
                    <p>Научитесь управлять стрессом и повышенной ответственностью</p>
                </div>
                <div class="intens4-results-slider-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740997682340-MYXc9-Chec.svg"
                        alt="">
                    <p>Выстроите продуктивные отношений с коллегами из других отделов</p>
                </div>
                <div class="intens4-results-slider-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740997682340-MYXc9-Chec.svg"
                        alt="">
                    <p>Сможете уверенно лидировать проекты и команды </p>
                </div>
            </div>
            <div class="intens4-results-slider-nav careerum-flex-fec">
                <div class="intens4-results-slider-prev">
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_387_1573)">
                            <foreignObject x="-18.1166" y="-18.1166" width="76.2332" height="76.2332">
                                <div xmlns="http://www.w3.org/1999/xhtml"
                                    style="backdrop-filter:blur(9.06px);clip-path:url(#bgblur_1_387_1573_clip_path);height:100%;width:100%">
                                </div>
                            </foreignObject>
                            <rect data-figma-bg-blur-radius="18.1166" y="40" width="40" height="40"
                                transform="rotate(-90 0 40)" fill="black" />
                            <path d="M13.1905 19.9993L26.8105 19.9993" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M19.4629 26.2453L13.1896 19.9986L19.4629 13.752" stroke="white"
                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="bgblur_1_387_1573_clip_path" transform="translate(18.1166 18.1166)">
                                <rect y="40" width="40" height="40" transform="rotate(-90 0 40)" />
                            </clipPath>
                            <clipPath id="clip0_387_1573">
                                <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <div class="intens4-results-slider-next">
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_387_1577)">
                            <foreignObject x="-18.1166" y="-18.1166" width="76.2332" height="76.2332">
                                <div xmlns="http://www.w3.org/1999/xhtml"
                                    style="backdrop-filter:blur(9.06px);clip-path:url(#bgblur_1_387_1577_clip_path);height:100%;width:100%">
                                </div>
                            </foreignObject>
                            <rect data-figma-bg-blur-radius="18.1166" x="40" width="40" height="40"
                                transform="rotate(90 40 0)" fill="black" />
                            <path d="M26.8095 20.0007L13.1895 20.0007" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M20.5371 13.7547L26.8104 20.0014L20.5371 26.248" stroke="white"
                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="bgblur_1_387_1577_clip_path" transform="translate(18.1166 18.1166)">
                                <rect x="40" width="40" height="40" transform="rotate(90 40 0)" />
                            </clipPath>
                            <clipPath id="clip0_387_1577">
                                <rect x="40" width="40" height="40" rx="20" transform="rotate(90 40 0)" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-intens4-cases', {
        label: 'Intensive cases (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-intens4-cases main-wrapper">
        <div class="careerum-container-responsive">
            <h2>Кейсы наших выпускников — повышение в зарплате и должности</h2>
            <div class="intens4-cases-slider">
                <div class="intens4-cases__item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741001590923-CSFGg-Fram.png"
                        alt="">
                    <div>
                        <p class="intens4-cases__item-name">Юлия Кормановская</p>
                        <p class="intens4-cases__item-position">Account Manager,
                            Германия</p>
                        <p class="intens4-cases__item-description">Мечта о международной карьере, непонимание, как
                            достичь этой цели</p>
                        <div class="intens4-cases__item-result-header careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740998228805-IPuQO-Chec.svg"
                                alt="">
                            <p>Результат с Careerum:</p>
                        </div>
                        <p class="intens4-cases__item-result-item">Выросла в должности и доходе на 13%, получила новый
                            контракт в Германии на 4 года</p>
                        <p class="intens4-cases__item-result-item">Научилась позиционировать свою экспертизу</p>
                        <p class="intens4-cases__item-result-item">Прокачала навык переговоров по офферу</p>
                    </div>
                </div>
                <div class="intens4-cases__item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741001590803-hjrc0-Fram.png"
                        alt="">
                    <div>
                        <p class="intens4-cases__item-name">Александра Воробьева</p>
                        <p class="intens4-cases__item-position">Finance manager, Турция</p>
                        <p class="intens4-cases__item-description">Переживала из-за синдрома самозванца и неуверенности
                            в себе</p>
                        <div class="intens4-cases__item-result-header careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740998228805-IPuQO-Chec.svg"
                                alt="">
                            <p>Результат с Careerum:</p>
                        </div>
                        <p class="intens4-cases__item-result-item">Получила работу в компании мечты, увеличила доход на
                            40%</p>
                        <p class="intens4-cases__item-result-item">Научилась позиционировать свою экспертизу</p>
                        <p class="intens4-cases__item-result-item">Научилась в свою пользу защищать идеи и задачи</p>
                    </div>
                </div>
                <div class="intens4-cases__item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741001590572-zNhsB-Fram.png"
                        alt="">
                    <div>
                        <p class="intens4-cases__item-name">Виктория Сагина</p>
                        <p class="intens4-cases__item-position">Planning Specialist, Россия</p>
                        <p class="intens4-cases__item-description">Хотела сменить работу, сомневалась в своих силах, не
                            знала, как найти компанию с подходящими ценностями</p>
                        <div class="intens4-cases__item-result-header careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740998228805-IPuQO-Chec.svg"
                                alt="">
                            <p>Результат с Careerum:</p>
                        </div>
                        <p class="intens4-cases__item-result-item">Оффер и рост зарплаты на 50%</p>
                        <p class="intens4-cases__item-result-item">Научилась позиционировать свою экспертизу</p>
                        <p class="intens4-cases__item-result-item">Научилась вести переговоры по офферу</p>
                    </div>
                </div>
                <div class="intens4-cases__item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741001590696-Nge11-Fram.png"
                        alt="">
                    <div>
                        <p class="intens4-cases__item-name">Екатерина Козлова</p>
                        <p class="intens4-cases__item-position">Head of Customer Service & Account Management, Россия
                        </p>
                        <p class="intens4-cases__item-description">Декрет, была в состоянии выгорания, не понимала, чего
                            хочет в работе</p>
                        <div class="intens4-cases__item-result-header careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740998228805-IPuQO-Chec.svg"
                                alt="">
                            <p>Результат с Careerum:</p>
                        </div>
                        <p class="intens4-cases__item-result-item">Вышла из декрета с минимальным стрессом, вернулась к
                            работе с ростом зарплаты на 7%</p>
                        <p class="intens4-cases__item-result-item">Научилась аргументировать свою позицию перед
                            руководителем</p>
                        <p class="intens4-cases__item-result-item">Прокачала навык переговоров</p>
                    </div>
                </div>
                <div class="intens4-cases__item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741001590451-7fblz-Imag.png"
                        alt="">
                    <div>
                        <p class="intens4-cases__item-name">Анна Лисина</p>
                        <p class="intens4-cases__item-position">Сontent & Marketing Director, Колумбия</p>
                        <p class="intens4-cases__item-description">Желание развивать карьеру в маркетинге и вырасти в
                            должности</p>
                        <div class="intens4-cases__item-result-header careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740998228805-IPuQO-Chec.svg"
                                alt="">
                            <p>Результат с Careerum:</p>
                        </div>
                        <p class="intens4-cases__item-result-item">Повышение внутри компании до Creative & Brand
                            Marketing Lead</p>
                        <p class="intens4-cases__item-result-item">Улучшила навыки публичных выступлений и защиты
                            проектов</p>
                        <p class="intens4-cases__item-result-item">Прокачала навык переговоров</p>
                    </div>
                </div>
                <div class="intens4-cases__item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741001590337-6yW9u-Imag.png"
                        alt="">
                    <div>
                        <p class="intens4-cases__item-name">Екатерина Савченко</p>
                        <p class="intens4-cases__item-position">PhD студентка, Университет Мангейма, Германия</p>
                        <p class="intens4-cases__item-description">Неуверенность, выгорание, страх конкуренции в
                            Германии</p>
                        <div class="intens4-cases__item-result-header careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740998228805-IPuQO-Chec.svg"
                                alt="">
                            <p>Результат с Careerum:</p>
                        </div>
                        <p class="intens4-cases__item-result-item">Выросла до PhD студента,
                            yвеличила доход на 38%
                        </p>
                        <p class="intens4-cases__item-result-item">Научилась перезентовать свои достижения и результаты
                            руководителю</p>
                    </div>
                </div>
                <div class="intens4-cases__item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741001590181-V5L67-Imag.png"
                        alt="">
                    <div>
                        <p class="intens4-cases__item-name">Анастасия Сергиенко</p>
                        <p class="intens4-cases__item-position">Senior Consultant, Camelot IT lab, Германия
                        </p>
                        <p class="intens4-cases__item-description">Стремилась построить международную карьеру и вырасти
                            в доходе</p>
                        <div class="intens4-cases__item-result-header careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740998228805-IPuQO-Chec.svg"
                                alt="">
                            <p>Результат с Careerum:</p>
                        </div>
                        <p class="intens4-cases__item-result-item">Релоцировалась в Германию, выросла в доходе в 2 раза
                        </p>
                        <p class="intens4-cases__item-result-item">Научилась презентовать свои достижения и экспертизу
                        </p>
                    </div>
                </div>
                <div class="intens4-cases__item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741001589848-49mwc-Imag.png"
                        alt="">
                    <div>
                        <p class="intens4-cases__item-name">Анастасия Вербицкая</p>
                        <p class="intens4-cases__item-position">Зам. гендиректора по стратегии и развитию, Россия

                        </p>
                        <p class="intens4-cases__item-description">Стабильная работа, но не было радости от карьеры</p>
                        <div class="intens4-cases__item-result-header careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740998228805-IPuQO-Chec.svg"
                                alt="">
                            <p>Результат с Careerum:</p>
                        </div>
                        <p class="intens4-cases__item-result-item">Получила оффер в желаемую компанию и повышение на
                            новой месте через 2 месяца</p>
                        <p class="intens4-cases__item-result-item">Вести диалог с руководством и обосновывать карьерные
                            запросы</p>
                    </div>
                </div>
            </div>
            <div class="intens4-cases-slider-nav careerum-flex-fec">
                <div class="intens4-cases-slider-prev">
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_387_1573)">
                            <foreignObject x="-18.1166" y="-18.1166" width="76.2332" height="76.2332">
                                <div xmlns="http://www.w3.org/1999/xhtml"
                                    style="backdrop-filter:blur(9.06px);clip-path:url(#bgblur_1_387_1573_clip_path);height:100%;width:100%">
                                </div>
                            </foreignObject>
                            <rect data-figma-bg-blur-radius="18.1166" y="40" width="40" height="40"
                                transform="rotate(-90 0 40)" fill="black" />
                            <path d="M13.1905 19.9993L26.8105 19.9993" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M19.4629 26.2453L13.1896 19.9986L19.4629 13.752" stroke="white"
                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="bgblur_1_387_1573_clip_path" transform="translate(18.1166 18.1166)">
                                <rect y="40" width="40" height="40" transform="rotate(-90 0 40)" />
                            </clipPath>
                            <clipPath id="clip0_387_1573">
                                <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <div class="intens4-cases-slider-next">
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_387_1577)">
                            <foreignObject x="-18.1166" y="-18.1166" width="76.2332" height="76.2332">
                                <div xmlns="http://www.w3.org/1999/xhtml"
                                    style="backdrop-filter:blur(9.06px);clip-path:url(#bgblur_1_387_1577_clip_path);height:100%;width:100%">
                                </div>
                            </foreignObject>
                            <rect data-figma-bg-blur-radius="18.1166" x="40" width="40" height="40"
                                transform="rotate(90 40 0)" fill="black" />
                            <path d="M26.8095 20.0007L13.1895 20.0007" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M20.5371 13.7547L26.8104 20.0014L20.5371 26.248" stroke="white"
                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="bgblur_1_387_1577_clip_path" transform="translate(18.1166 18.1166)">
                                <rect x="40" width="40" height="40" transform="rotate(90 40 0)" />
                            </clipPath>
                            <clipPath id="clip0_387_1577">
                                <rect x="40" width="40" height="40" rx="20" transform="rotate(90 40 0)" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
            </div>
            <a href="#buy" class="btn-color-main-dark-orange">Выбрать тариф</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-intens4-subscribe', {
        label: 'Intensive subscribe (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-intens4-subscribe main-wrapper">
        <div class="careerum-container-responsive">
            <h2>Что такое подписка Careerum</h2>
            <div class="intens4-subscribe-top careerum-flex-sbfs">
                <div class="intens4-subscribe-yellow">
                    <div class="careerum-flex-fsfs">
                        <p class="intens4-subscribe-white-header">80</p>
                        <p class="intens4-subscribe-white-label">курсов в подписке</p>
                    </div>
                    <p class="intens4-subscribe-white-subheader">Решите вашу карьерную задачу</p>
                    <ul>
                        <li class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741012112094-hQvrJ-Chec.svg"
                                alt="">
                            <p>Написать резюме и найти работу </p>
                        </li>
                        <li class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741012112094-hQvrJ-Chec.svg"
                                alt="">
                            <p>Получить повышение</p>
                        </li>
                        <li class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741012112094-hQvrJ-Chec.svg"
                                alt="">
                            <p>Выйти из декрета на крутую работу</p>
                        </li>
                        <li class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741012112094-hQvrJ-Chec.svg"
                                alt="">
                            <p>Перерыв в работе</p>
                        </li>
                        <li class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741012112094-hQvrJ-Chec.svg"
                                alt="">
                            <p>Релоцироваться</p>
                        </li>
                        <li class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741012112094-hQvrJ-Chec.svg"
                                alt="">
                            <p>Понять следующий шаг в карьере</p>
                        </li>
                    </ul>
                    <div class="position-relative">
                        <p class="position-absolute z-20">удобная платформа</p>
                        <p class="position-absolute z-10">постоянные обновления</p>
                    </div>
                </div>
                <div>
                    <div class="intens4-subscribe-white">
                        <div class="careerum-flex-fsfs">
                            <p class="intens4-subscribe-white-header">AI</p>
                            <p class="intens4-subscribe-white-label">помощники</p>
                        </div>
                        <p class="intens4-subscribe-white-text">Резюме-ассистент, тренер по интервью, карьерный аналитик
                        </p>
                    </div>
                    <div class="intens4-subscribe-white">
                        <div class="careerum-flex-fsfs">
                            <p class="intens4-subscribe-white-header">Meetup</p>
                            <p class="intens4-subscribe-white-label">days</p>
                        </div>
                        <p class="intens4-subscribe-white-text">Тематические онлайн-ивенты каждый месяц</p>
                    </div>
                </div>
            </div>
            <div class="intens4-subscribe-bottom careerum-flex-sbst">
                <div class="intens4-subscribe-white">
                    <div class="careerum-flex-fsfs">
                        <p class="intens4-subscribe-white-header">9.5</p>
                        <p class="intens4-subscribe-white-label">средняя оценка</p>
                    </div>
                    <p class="intens4-subscribe-white-text">Карьерных экспертов и коучей Careerum</p>
                </div>
                <div class="intens4-subscribe-white">
                    <div class="careerum-flex-fsfs">
                        <p class="intens4-subscribe-white-header">10</p>
                        <p class="intens4-subscribe-white-label">интенсивов в год</p>
                    </div>
                    <p class="intens4-subscribe-white-text">Онлайн-интенсивы, где много практики и обучения у топовых
                        экспертов рынка</p>
                </div>
                <div class="intens4-subscribe-white">
                    <div class="careerum-flex-fsfs">
                        <p class="intens4-subscribe-white-header">Q&A</p>
                        <p class="intens4-subscribe-white-label">сессии</p>
                    </div>
                    <p class="intens4-subscribe-white-text">Онлайн-разбор ваших кейсов с экспертами и коучами Careerum
                    </p>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-intens4-boost', {
        label: 'Intensive boost (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-intens4-boost main-wrapper">
        <div class="careerum-container-responsive">
            <div class="intens4-boost__wrapper">
                <div class="intens4-boost__top position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741013741278-6Rzkn-Arro.svg"
                        alt="" class="position-absolute hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741083914483-OSc1Z-Arro.svg"
                        alt="" class="position-absolute hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741108583006-LwxXN-Arro.svg"
                        alt="" class="position-absolute hidden-desc-tablet">
                    <h2>Годовая программа буста карьеры на <span>2025</span> </h2>
                    <p>В рамках подписки вы сможете участвовать в интенсивах и прокачивать один из карьерных навыков</p>
                    <div class="intens4-boost__item-last careerum-flex-fsst">
                        <div class="careerum-flex-cc">Январь</div>
                        <div>Карьерные цели на 2025</div>
                    </div>
                    <div class="intens4-boost__item-last careerum-flex-fsst">
                        <div class="careerum-flex-cc">Февраль</div>
                        <div>Звездный кандидат</div>
                    </div>
                    <div class="intens4-boost__item-current row-2 careerum-flex-fsst">
                        <div class="careerum-flex-cc">Март</div>
                        <div>Коммуникация на работе: управляй руководителем и коллегами</div>
                    </div>
                    <div class="intens4-boost__item-future careerum-flex-fsst">
                        <div class="careerum-flex-cc">Апрель</div>
                        <div>Релокация и поиск работы за рубежом</div>
                    </div>
                    <div class="intens4-boost__item-future careerum-flex-fsst">
                        <div class="careerum-flex-cc">Май</div>
                        <div>Самооценка и деньги</div>
                    </div>
                    <div class="intens4-boost__item-future careerum-flex-fsst">
                        <div class="careerum-flex-cc">Июнь</div>
                        <div>Карьерный кризис</div>
                    </div>
                    <div class="intens4-boost__item-future careerum-flex-fsst">
                        <div class="careerum-flex-cc">Июль</div>
                        <div>Декрет и перерыв в работе</div>
                    </div>
                    <div class="intens4-boost__item-future careerum-flex-fsst">
                        <div class="careerum-flex-cc">Август</div>
                        <div>Рефреш целей</div>
                    </div>
                    <div class="intens4-boost__item-future careerum-flex-fsst">
                        <div class="careerum-flex-cc">Сентябрь</div>
                        <div>Звездный кандидат</div>
                    </div>
                    <div class="intens4-boost__item-future careerum-flex-fsst">
                        <div class="careerum-flex-cc">Октябрь</div>
                        <div>Хочу стать руководителем</div>
                    </div>
                    <div class="intens4-boost__item-future careerum-flex-fsst">
                        <div class="careerum-flex-cc">Ноябрь</div>
                        <div>Карьерная ракета</div>
                    </div>
                    <div class="intens4-boost__item-future careerum-flex-fsst">
                        <div class="careerum-flex-cc">Декабрь</div>
                        <div>Подводим итоги года</div>
                    </div>
                    <div class="intens4-boost__item-gradient position-absolute">
                    </div>
                </div>
                <div class="intens4-boost__bottom">
                    <div class="intens4-boost__bottom-top careerum-flex-sbst">
                        <div class="intens4-boost__bottom-top-left careerum-flex-fsfs">
                            <div class="careerum-flex-fsfs">
                                <p class="intens4-boost__bottom-top-header">600+</p>
                                <p class="intens4-boost__bottom-top-label">профессионалов</p>
                            </div>
                            <div class="careerum-flex-fsfs">
                                <p class="intens4-boost__bottom-top-header"><span>из</span> 50</p>
                                <p class="intens4-boost__bottom-top-label">стран</p>
                            </div>
                            <div>
                                <p class="intens4-boost__bottom-subheader">Сильное профессиональное комьюнити по всему
                                    миру
                                </p>
                            </div>
                        </div>
                        <div class="intens4-boost__bottom-top-right hidden-mobile">
                            <p class="intens4-boost__bottom-header">Нетворкинг</p>
                            <p class="intens4-boost__bottom-text">Регулярные онлайн-встречи, а еще наши подписчики
                                дружат
                                оффлайн в разных странах :)</p>
                        </div>
                    </div>
                    <div class="intens4-boost__bottom-center careerum-flex-sbst">
                        <div class="intens4-boost__bottom-top-right hidden-desc-tablet">
                            <p class="intens4-boost__bottom-header">Нетворкинг</p>
                            <p class="intens4-boost__bottom-text">Регулярные онлайн-встречи, а еще наши подписчики
                                дружат
                                оффлайн в разных странах :)</p>
                        </div>
                        <div class="intens4-boost__bottom-center-left">
                            <p class="intens4-boost__bottom-header">Сoffee Buddy</p>
                            <p class="intens4-boost__bottom-text">Еженедельные встречи-знакомства</p>
                        </div>
                        <div class="intens4-boost__bottom-center-right">
                            <p class="intens4-boost__bottom-header">Клубы по интересам</p>
                            <p class="intens4-boost__bottom-text">English Speaking club, Mindfullness Club и другие</p>
                        </div>
                    </div>
                    <div class="intens4-boost__bottom-bottom careerum-flex-sbst">
                        <div class="intens4-boost__bottom-bottom-left">
                            <p class="intens4-boost__bottom-subheader2">Участники из топовых компаний</p>
                        </div>
                        <div class="intens4-boost__bottom-bottom-right">
                            <div class="intens4-boost__bottom-row">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002650039-SQyje-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110315357-MY1aU-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002649933-DtsCA-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110315794-h61cj-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002649826-4aoDW-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110315668-P7k3X-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002649711-m8OgA-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110316019-UNfD5-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002649592-aXz33-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110399429-at1lG-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002649479-s4z06-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110399180-89vwx-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002649370-yDZve-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110399664-pS6Hf-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741016349221-Awmag-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110399545-RLua7-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002733313-ktpGf-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110470822-5z99s-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002984724-YlMGO-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110470506-VFcKd-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741016494247-3yo1H-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110470930-lT5z0-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002984839-bFXtJ-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110470717-HIkW2-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002933541-5gOd1-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110548043-wQrvm-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002933885-4BI8d-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110548155-kDSqp-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002818574-dGqyI-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110547785-8WYpT-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002934419-pEXW9-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110548258-MHnFa-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002881390-DglVk-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110598663-YpoKv-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002881636-20M0F-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110598772-LG6Ef-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002881738-rUd6v-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110599016-SE5h2-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002881956-L789O-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110599118-AtfH1-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002882055-3b09F-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110640429-fXoCK-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002882163-Lw4QS-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110640546-nR1J3-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002984373-ayHsi-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110640213-tSnwe-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002984949-h5LFK-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110640320-fkKpP-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002933643-dQy0X-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110702958-RypfK-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741017148231-8jY8W-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110703062-5xDjx-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002881859-DSLjv-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110703172-6NNwk-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002984125-xDA0R-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110702710-ntrl6-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741017241617-RU7Ld-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110745838-gbHLt-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002984620-EBqMl-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110745729-bIMj4-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002934207-bBbrx-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110745943-K5DSJ-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002984492-TPXBo-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110745623-ZhTri-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002984002-3uqrI-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110813685-4jbRz-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002818354-Lz8Bw-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110813923-zN9F3-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002818473-iYUqq-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110814033-CzX2l-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002984249-hq9ir-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110814158-A8z6g-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002818688-8z8Ix-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110859226-T4D6H-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741017415896-Ohh9Z-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110859333-Js4if-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741017454811-IWYRT-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110859445-OVyc6-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002732772-LJCNs-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110859572-f3y3a-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002732883-WfFwO-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110892202-9jgYD-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002732986-Qrhko-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110892306-tUMo1-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002882266-wXBDm-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110891967-lzfkk-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002817778-MEPzC-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110892074-tAInC-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002818031-drfq7-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110938064-2BMvc-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741017659715-utdrz-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110938184-2kBCQ-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002818253-ujk4l-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110938294-f2xZ0-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002733102-9fFZM-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110938399-Zqi1v-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002733211-vvpOy-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110938515-IFvht-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002650039-SQyje-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110315357-MY1aU-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002649933-DtsCA-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110315794-h61cj-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002649826-4aoDW-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110315668-P7k3X-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002649711-m8OgA-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110316019-UNfD5-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002649592-aXz33-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110399429-at1lG-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-intens4-photos', {
        label: 'Intensive photos (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-intens4-photos main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <h2 class="position-relative z-10">Поможем построить карьеру по любви в любой точке мира</h2>
            <div class="position-relative hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741003206277-S1wKF-Hear.svg" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741003206168-T4Mmm-line.svg" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741003221899-v3lM0-Phot.png" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741003205913-eE2xd-Vect.svg" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741003222218-XshNs-Phot.png" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741003222394-TKcxr-Phot.png" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741003222581-9Ya5X-Phot.png" alt=""
                    class="position-absolute">
            </div>
            <div class="position-relative hidden-desc-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741076944516-Wiis9-Hear.svg" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741076944405-vCLgu-line.svg" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741003221899-v3lM0-Phot.png" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741076944142-eCtSb-Vect.svg" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741003222218-XshNs-Phot.png" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741003222394-TKcxr-Phot.png" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741003222581-9Ya5X-Phot.png" alt=""
                    class="position-absolute">
            </div>
            <div class="position-relative hidden-desc-tablet">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741111375383-imt4p-Hear.svg" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741111375275-odKSx-line.svg" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741111369236-qjNjq-Phot.png" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741076944142-eCtSb-Vect.svg" alt=""
                    class="position-absolute hidden-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741111368896-fhiLO-Phot.png" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741111369379-crjTF-Phot.png" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741111369496-11Pxm-Phot.png" alt=""
                    class="position-absolute">
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-intens4-quiz', {
        label: 'Intensive quiz (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-intens4-quiz main-wrapper">
        <div class="careerum-container-responsive">
            <p class="intens4-quiz-label position-relative">Пройдите тест</p>
            <h2>«Как вас воспринимают <span>коллеги</span>?» </h2>
            <div class="intens4-quiz__content careerum-flex-sbst">
                <div class="intens4-quiz__content-left">
                    <div>
                        <p class="intens4-quiz__content-number">1</p>
                        <p class="intens4-quiz__content-text">Определите ваш текущий стиль профессиональной коммуникации
                        </p>
                    </div>
                    <div>
                        <p class="intens4-quiz__content-number">2</p>
                        <p class="intens4-quiz__content-text">Выявите ключевые области для роста вашего влияния
                            в команде
                        </p>
                    </div>
                    <div>
                        <p class="intens4-quiz__content-number">3</p>
                        <p class="intens4-quiz__content-text">Получите персональные рекомендации по усилению вашей
                            позиции
                        </p>
                    </div>
                </div>
                <div class="intens4-quiz__content-right position-relative careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741089855693-Gz8qs-Img..svg"
                        alt="" class="position-absolute hidden-tablet-mobile z-10">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741099055168-ILd7Q-Img .svg"
                        alt="" class="position-absolute hidden-desc-mobile z-10">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741112779275-OJxa1-Img .svg"
                        alt="" class="position-absolute hidden-desc-tablet z-10">
                    <a href="#" class="btn-color-main-white position-relative z-20">Пройти тест</a>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-trip-main', {
        label: 'Trip main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-trip-main main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <div class="position-relative">
                <h1 class="position-relative z-30">Работающие шаблоны резюме</h1>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741591489273-NRdw5-Grou.png" alt=""
                    class="position-absolute z-20 hidden-tablet-mobile trip-main-img-label">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741599409660-IVYrq-Grou.png" alt=""
                    class="position-absolute z-20 hidden-desc-mobile trip-main-img-label">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741613978147-RwdRK-Grou.png" alt=""
                    class="position-absolute z-20 hidden-desc-tablet trip-main-img-label">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1731910870671-8wMca-Elli.png" alt=""
                    class="position-absolute z-10 trip-main-img-bg">
            </div>
            <div class="trip-tales-currency position-relative z-20">
                <div class="hidden-tablet-mobile">
                    <div class="trip-tales-currency-desctop careerum-flex-fsst">
                        <ul class="careerum-flex-fsfs">
                            <li data-currency="eur" class="active">EUR</li>
                            <li data-currency="rub">RUB</li>
                        </ul>
                        <div class="trip-tales-notif careerum-flex-cc">
                            <div class="trip-tales-notif-icon">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                    alt="">
                            </div>
                            <div class="trip-tales-notif-content">
                                <p>Оплата в российских рублях возможна только картой
                                    российского банка. В&nbsp;евро — картой
                                    зарубежного банка</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="hidden-desc position-relative">
                    <div class="trip-tales__swicher-block position-absolute">
                        <div class="trip-tales__swicher-top">
                            <p class="trip-tales__swicher-header">Посмотреть
                                цены в
                                <span>RUB</span>
                            </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" class="trip-tales__swicher-arrow">
                                <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black">
                                </path>
                            </svg>
                        </div>
                        <div class="trip-tales__swicher-bottom">
                            <ul>
                                <li data-currency="rub">
                                    RUB
                                </li>
                                <li data-currency="eur" class="active">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских
                                рублях
                                возможна только<br> с карты
                                российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="trip-tales position-relative z-10">
                <div class="careerum-flex-fsfs">
                    <div class="trip-tale careerum-flex-fsfs position-relative trip-tale-change-currency"
                        data-price-new-eur="56 €" data-price-new-rub="5 690 ₽" data-price-eur="149 €"
                        data-price-rub="14900 ₽" data-href-eur="#eur" data-href-rub="#rub">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741593134110-Q0Klr-Fram.png"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741601382277-ujMSF-Fram.png"
                            alt="" class="hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741614219401-OYUPg-Fram.png"
                            alt="" class="hidden-desc-tablet">
                        <div class="trip-tale__header">
                            <h3>Шаблон хронологического резюме RU и EN</h3>
                            <p>Чтобы показать стабильный карьерный рост</p>
                            <p>Формат четко покажет ваш профессиональный путь, начиная с текущего места работы</p>
                        </div>
                        <div class="trip-tale__content">
                            <div class="careerum-flex-fsc trip-tale__switcher">
                                <p>Кому подойдет</p>
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                    xmlns="http://www.w3.org/2000/svg" class="hidden-mobile">
                                    <path
                                        d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                                        stroke="white" stroke-width="2" stroke-miterlimit="10" />
                                    <path d="M20.5 14.5L16 19.5L11.5 14.5" stroke="white" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                    xmlns="http://www.w3.org/2000/svg" class="hidden-desc-tablet">
                                    <path
                                        d="M12 21.6147C16.9706 21.6147 21 17.5853 21 12.6147C21 7.64418 16.9706 3.61475 12 3.61475C7.02944 3.61475 3 7.64418 3 12.6147C3 17.5853 7.02944 21.6147 12 21.6147Z"
                                        stroke="white" stroke-width="1.5" stroke-miterlimit="10" />
                                    <path d="M15.375 11.4897L12 15.2397L8.625 11.4897" stroke="white" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <ol>
                                <li>Эффективная основа любого резюме: принципы написания, формат</li>
                                <li>Достижения: как найти и упаковать </li>
                                <li>Как «докрутить» резюме до уровня топ-компаний рынка</li>
                                <li>Как получать максимум откликов: лайфхаки кастомизации резюме под вакансии</li>
                            </ol>
                        </div>
                        <div class="careerum-flex-fsc trip-tale__descr">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <p>Доступ навсегда</p>
                        </div>
                        <div class="careerum-flex-fsc trip-tale__price">
                            <p class="price-current">490 ₽</p>
                            <p class="price-old">1490 ₽</p>
                            <p>— 70%</p>
                        </div>
                        <a href="#buy" class="btn-color-main-dark-blue">Купить</a>
                    </div>
                    <div class="trip-tale careerum-flex-fsfs position-relative trip-tale-change-currency"
                        data-price-new-eur="56 €" data-price-new-rub="5 690 ₽" data-price-eur="149 €"
                        data-price-rub="14900 ₽" data-href-eur="#eur" data-href-rub="#rub">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741593133973-h55Uf-Fram.png"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741601382125-B6SRt-Fram.png"
                            alt="" class="hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741614219271-0ORV0-Fram.png"
                            alt="" class="hidden-desc-tablet">
                        <div class="trip-tale__header">
                            <h3>Шаблон функционального резюме RU и EN</h3>
                            <p>Акцент на навыках, а не на датах</p>
                            <p>Формат подсветит умения и достижения, даже если были перерывы в карьере
                            </p>
                        </div>
                        <div class="trip-tale__content">
                            <div class="careerum-flex-fsc trip-tale__switcher">
                                <p>Кому подойдет</p>
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                    xmlns="http://www.w3.org/2000/svg" class="hidden-mobile">
                                    <path
                                        d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                                        stroke="white" stroke-width="2" stroke-miterlimit="10" />
                                    <path d="M20.5 14.5L16 19.5L11.5 14.5" stroke="white" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                    xmlns="http://www.w3.org/2000/svg" class="hidden-desc-tablet">
                                    <path
                                        d="M12 21.6147C16.9706 21.6147 21 17.5853 21 12.6147C21 7.64418 16.9706 3.61475 12 3.61475C7.02944 3.61475 3 7.64418 3 12.6147C3 17.5853 7.02944 21.6147 12 21.6147Z"
                                        stroke="white" stroke-width="1.5" stroke-miterlimit="10" />
                                    <path d="M15.375 11.4897L12 15.2397L8.625 11.4897" stroke="white" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <ol>
                                <li>Есть длительный перерыв в работе</li>
                                <li>Меняете сферу деятельности </li>
                                <li>Хотите подчеркнуть transferable skills</li>
                                <li>Работали на нескольких проектах одновременно</li>
                                <li>Опыт работы не связан напрямую с желаемой должностью</li>
                            </ol>
                        </div>
                        <div class="careerum-flex-fsc trip-tale__descr">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <p>Доступ навсегда</p>
                        </div>
                        <div class="careerum-flex-fsc trip-tale__price">
                            <p class="price-current">490 ₽</p>
                            <p class="price-old">1490 ₽</p>
                            <p>— 70%</p>
                        </div>
                        <a href="#buy" class="btn-color-main-dark-blue">Купить</a>
                    </div>
                    <div class="trip-tale careerum-flex-fsfs position-relative trip-tale-change-currency"
                        data-price-new-eur="56 €" data-price-new-rub="5 690 ₽" data-price-eur="149 €"
                        data-price-rub="14900 ₽" data-href-eur="#eur" data-href-rub="#rub">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741593133604-wBokn-Fram.png"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741601396190-SlO5L-Fram.png"
                            alt="" class="hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741614218994-NPfCK-Fram.png"
                            alt="" class="hidden-desc-tablet">
                        <div class="trip-tale__header">
                            <h3>Шаблон комбинированного резюме RU и EN</h3>
                            <p>Показать опыт и навыки одновременно</p>
                            <p>Объединяет оба формата, чтобы эффектно представить себя работодателю
                            </p>
                        </div>
                        <div class="trip-tale__content">
                            <div class="careerum-flex-fsc trip-tale__switcher">
                                <p>Кому подойдет</p>
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                    xmlns="http://www.w3.org/2000/svg" class="hidden-mobile">
                                    <path
                                        d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                                        stroke="white" stroke-width="2" stroke-miterlimit="10" />
                                    <path d="M20.5 14.5L16 19.5L11.5 14.5" stroke="white" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                    xmlns="http://www.w3.org/2000/svg" class="hidden-desc-tablet">
                                    <path
                                        d="M12 21.6147C16.9706 21.6147 21 17.5853 21 12.6147C21 7.64418 16.9706 3.61475 12 3.61475C7.02944 3.61475 3 7.64418 3 12.6147C3 17.5853 7.02944 21.6147 12 21.6147Z"
                                        stroke="white" stroke-width="1.5" stroke-miterlimit="10" />
                                    <path d="M15.375 11.4897L12 15.2397L8.625 11.4897" stroke="white" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <ol>
                                <li>Хотите подчеркнуть навыки и опыт работы</li>
                                <li>Есть значимые достижения, которые важно подсветить</li>
                                <li>Претендуете на позицию, где важны опыт и конкретные умения</li>
                                <li>Хотите сделать резюме адаптивным под разные вакансии</li>
                            </ol>
                        </div>
                        <div class="careerum-flex-fsc trip-tale__descr">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <p>Доступ навсегда</p>
                        </div>
                        <div class="careerum-flex-fsc trip-tale__price">
                            <p class="price-current">490 ₽</p>
                            <p class="price-old">1490 ₽</p>
                            <p>— 70%</p>
                        </div>
                        <a href="#buy" class="btn-color-main-dark-blue">Купить</a>
                    </div>
                </div>
            </div>
            <div class="trip-tales-currency position-relative z-20 hidden-desc">
                <div class="hidden-tablet-mobile">
                    <div class="trip-tales-currency-desctop careerum-flex-fsst">
                        <ul class="careerum-flex-fsfs">
                            <li data-currency="eur" class="active">EUR</li>
                            <li data-currency="rub">RUB</li>
                        </ul>
                        <div class="trip-tales-notif careerum-flex-cc">
                            <div class="trip-tales-notif-icon">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                    alt="">
                            </div>
                            <div class="trip-tales-notif-content">
                                <p>Оплата в российских рублях возможна только картой
                                    российского банка. В&nbsp;евро — картой
                                    зарубежного банка</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="hidden-desc position-relative">
                    <div class="trip-tales__swicher-block position-absolute">
                        <div class="trip-tales__swicher-top">
                            <p class="trip-tales__swicher-header">Посмотреть
                                цены в
                                <span>RUB</span>
                            </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" class="trip-tales__swicher-arrow">
                                <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black">
                                </path>
                            </svg>
                        </div>
                        <div class="trip-tales__swicher-bottom">
                            <ul>
                                <li data-currency="rub">
                                    RUB
                                </li>
                                <li data-currency="eur" class="active">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских
                                рублях
                                возможна только<br> с карты
                                российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="trip-tales-single careerum-flex-sbfs trip-tale-change-currency" data-price-new-eur="149 €"
                data-price-new-rub="14 900 ₽" data-price-eur="894 €" data-price-rub="89 480 ₽" data-href-eur="#eur2"
                data-href-rub="#buy">
                <div class="position-relative">
                    <div class="trip-tales-currency position-relative z-20 hidden-tablet-mobile">
                        <div class="hidden-tablet-mobile">
                            <div class="trip-tales-currency-desctop careerum-flex-fsst">
                                <ul class="careerum-flex-fsfs">
                                    <li data-currency="eur" class="active">EUR</li>
                                    <li data-currency="rub">RUB</li>
                                </ul>
                                <div class="trip-tales-notif careerum-flex-cc">
                                    <div class="trip-tales-notif-icon">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                            alt="">
                                    </div>
                                    <div class="trip-tales-notif-content">
                                        <p>Оплата в российских рублях возможна только картой
                                            российского банка. В&nbsp;евро — картой
                                            зарубежного банка</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="hidden-desc">
                            <div class="trip-tales__swicher-block">
                                <div class="trip-tales__swicher-top">
                                    <p class="trip-tales__swicher-header">Посмотреть
                                        цены в
                                        <span>RUB</span>
                                    </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                        viewBox="0 0 24 24" fill="none" class="trip-tales__swicher-arrow">
                                        <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black">
                                        </path>
                                    </svg>
                                </div>
                                <div class="trip-tales__swicher-bottom">
                                    <ul>
                                        <li data-currency="rub">
                                            RUB
                                        </li>
                                        <li data-currency="eur" class="active">
                                            EUR
                                        </li>
                                    </ul>
                                    <p>
                                        Обратите внимание,<br> что оплата в российских
                                        рублях
                                        возможна только<br> с карты
                                        российского банка. Оплата в евро — с карты зарубежного банка
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <h3>🎁 Забирайте пак из 6 шаблонов резюме </h3>
                    <div class="trip-tales-single-bottom">
                        <div class="careerum-flex-fsc trip-tale__descr">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <p>Доступ навсегда</p>
                        </div>
                        <div class="careerum-flex-fsc trip-tale__price">
                            <p class="price-current">990 ₽</p>
                            <p class="price-old">4 470 ₽</p>
                        </div>
                        <a href="#buy" class="btn-color-main-dark-orange hidden-mobile">Купить</a>
                        <a href="#buy" class="btn-color-main-dark-blue hidden-desc-tablet">Купить</a>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741596108887-VuMM6-ÑÐº.png"
                        alt="" class="trip-tales-single-img-sale position-absolute hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741596109039-feyv6-Grou.png"
                        alt="" class="trip-tales-single-img-bg position-absolute hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741601948203-VCkr0-ÑÐº.png"
                        alt="" class="trip-tales-single-img-sale position-absolute hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741601947887-6yQZT-Grou.png"
                        alt="" class="trip-tales-single-img-bg position-absolute hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741614810631-Sjt89-ÑÐº.png"
                        alt="" class="trip-tales-single-img-sale position-absolute hidden-desc-tablet">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741614810324-tFzCx-Grou.png"
                        alt="" class="trip-tales-single-img-bg position-absolute hidden-desc-tablet">
                </div>
            </div>
            <h2><span>🔥</span>Прокачайте резюме</h2>
            <div class="trip-tales careerum-flex-fsfs position-relative z-10">
                <div class=" careerum-flex-fsfs">
                    <div class="trip-tale trip-tale-no-button careerum-flex-fsfs position-relative trip-tale-change-currency"
                        data-price-new-eur="56 €" data-price-new-rub="5 690 ₽" data-price-eur="149 €"
                        data-price-rub="14900 ₽" data-href-eur="#eur" data-href-rub="#rub">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1731920558380-LZI1S-Fram.png"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741611831676-XaOWs-Fram.png"
                            alt="" class="hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741615342381-3yVNk-Fram.png"
                            alt="" class="hidden-desc-tablet">
                        <div class="trip-tale__label position-absolute">
                            <p>поиск работы</p>
                        </div>
                        <div class="trip-tale__header">
                            <h3>Продающее резюме</h3>
                            <p>Пошаговая инструкция для создания идеального резюме.</p>
                        </div>
                        <div class="trip-tale__content">
                            <div class="careerum-flex-fsc trip-tale__switcher">
                                <p>Программа курса</p>
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                    xmlns="http://www.w3.org/2000/svg" class="hidden-mobile">
                                    <path
                                        d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                                        stroke="white" stroke-width="2" stroke-miterlimit="10" />
                                    <path d="M20.5 14.5L16 19.5L11.5 14.5" stroke="white" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                    xmlns="http://www.w3.org/2000/svg" class="hidden-desc-tablet">
                                    <path
                                        d="M12 21.6147C16.9706 21.6147 21 17.5853 21 12.6147C21 7.64418 16.9706 3.61475 12 3.61475C7.02944 3.61475 3 7.64418 3 12.6147C3 17.5853 7.02944 21.6147 12 21.6147Z"
                                        stroke="white" stroke-width="1.5" stroke-miterlimit="10" />
                                    <path d="M15.375 11.4897L12 15.2397L8.625 11.4897" stroke="white" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <ol>
                                <li>Эффективная основа любого резюме: принципы написания, формат</li>
                                <li>Достижения: как найти и упаковать </li>
                                <li>Как «докрутить» резюме до уровня топ-компаний рынка</li>
                                <li>Как получать максимум откликов: лайфхаки кастомизации резюме под вакансии</li>
                            </ol>
                        </div>
                        <div class="careerum-flex-fsc trip-tale__descr">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <p>Доступ на 30 дней</p>
                        </div>
                        <div class="careerum-flex-fsc trip-tale__price">
                            <p class="price-current">14 900 ₽</p>
                            <p class="price-name">обычная цена</p>
                        </div>
                    </div>
                    <div class="trip-tale trip-tale-no-button careerum-flex-fsfs position-relative trip-tale-change-currency"
                        data-price-new-eur="56 €" data-price-new-rub="5 690 ₽" data-price-eur="149 €"
                        data-price-rub="14900 ₽" data-href-eur="#eur2" data-href-rub="#rub2">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1731920571409-iJ8hG-Fram.png"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741611831507-xh19w-Fram.png"
                            alt="" class="hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741615342229-EUxH0-Fram.png"
                            alt="" class="hidden-desc-tablet">
                        <div class="trip-tale__header">
                            <h3>Пак из 6 шаблонов резюме</h3>
                            <p>Универсальное решение для поиска работы в любой сфере и любой точке мира
                            </p>
                        </div>
                        <div class="trip-tale__content">
                            <div class="careerum-flex-fsc trip-tale__switcher">
                                <p>Кому подойдет</p>
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                    xmlns="http://www.w3.org/2000/svg" class="hidden-mobile">
                                    <path
                                        d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                                        stroke="white" stroke-width="2" stroke-miterlimit="10" />
                                    <path d="M20.5 14.5L16 19.5L11.5 14.5" stroke="white" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                    xmlns="http://www.w3.org/2000/svg" class="hidden-desc-tablet">
                                    <path
                                        d="M12 21.6147C16.9706 21.6147 21 17.5853 21 12.6147C21 7.64418 16.9706 3.61475 12 3.61475C7.02944 3.61475 3 7.64418 3 12.6147C3 17.5853 7.02944 21.6147 12 21.6147Z"
                                        stroke="white" stroke-width="1.5" stroke-miterlimit="10" />
                                    <path d="M15.375 11.4897L12 15.2397L8.625 11.4897" stroke="white" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <ol>
                                <li>Шлете резюме сотнями, а работодатели их игнорят</li>
                                <li>Сменили несколько мест работы, не знаете, как это подать</li>
                                <li>Были перерывы в карьере, страшно, что никуда не примут</li>
                                <li>Есть классный опыт, но непонятно, как его упаковать</li>
                                <li>Чувствуете, что резюме отстало от рынка</li>
                                <li>Хотите, чтобы рекрутеры сразу понимали вашу ценность</li>
                                <li>Боитесь, что ваш опыт выглядит хаотично</li>
                                <li>Не знаете, как адаптировать резюме под зарубежный рынок</li>
                            </ol>
                        </div>
                        <div class="careerum-flex-fsc trip-tale__descr">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <p>Доступ навсегда</p>
                        </div>
                        <div class="careerum-flex-fsc trip-tale__price">
                            <p class="price-current">990 ₽</p>
                            <p class="price-old">4 470 ₽</p>
                        </div>
                    </div>
                    <div class="trip-tale trip-tale-no-button careerum-flex-fsfs position-relative trip-tale-change-currency"
                        data-price-new-eur="56 €" data-price-new-rub="5 690 ₽" data-price-eur="149 €"
                        data-price-rub="14900 ₽" data-href-eur="#eur2" data-href-rub="#rub2">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1731920582141-pZszF-Fram.png"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741611831244-XH62k-Fram.png"
                            alt="" class="hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741615341945-Z5sIT-Fram.png"
                            alt="" class="hidden-desc-tablet">
                        <div class="trip-tale__header">
                            <h3>Доступ к карьерной платформе</h3>
                            <p>Буст вашего поиска работы: уроки по Linkedin, сопроводительным письмам, собеседованиям
                            </p>
                        </div>
                        <div class="trip-tale__content">
                            <div class="careerum-flex-fsc trip-tale__switcher">
                                <p>Что еще входит</p>
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                    xmlns="http://www.w3.org/2000/svg" class="hidden-mobile">
                                    <path
                                        d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                                        stroke="white" stroke-width="2" stroke-miterlimit="10" />
                                    <path d="M20.5 14.5L16 19.5L11.5 14.5" stroke="white" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                    xmlns="http://www.w3.org/2000/svg" class="hidden-desc-tablet">
                                    <path
                                        d="M12 21.6147C16.9706 21.6147 21 17.5853 21 12.6147C21 7.64418 16.9706 3.61475 12 3.61475C7.02944 3.61475 3 7.64418 3 12.6147C3 17.5853 7.02944 21.6147 12 21.6147Z"
                                        stroke="white" stroke-width="1.5" stroke-miterlimit="10" />
                                    <path d="M15.375 11.4897L12 15.2397L8.625 11.4897" stroke="white" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <ol>
                                <li>Шаблоны и примеры:<br>
                                    ·  резюме на русском и английском<br>
                                    ·  спроводительные письма<br>
                                    ·  сообщения работодателям в LinkedIn<br>
                                    ·  деловая email-переписка<br>
                                    ·  Алгоритм анализа кризисов</li>
                                <li>Шаблон поиска достижений</li>
                                <li>Список платформ для поиска работы в 15 странах</li>
                                <li>Трекер откликов на вакансии, чтобы всегда знать, что и куда отправили</li>
                            </ol>
                        </div>
                        <div class="careerum-flex-fsc trip-tale__descr">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <p>Доступ на 30 дней</p>
                        </div>
                        <div class="careerum-flex-fsc trip-tale__price">
                            <p class="price-current">12 900 ₽</p>
                            <p class="price-name">обычная цена</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="trip-tales-currency position-relative z-20 hidden-desc">
                <div class="hidden-tablet-mobile">
                    <div class="trip-tales-currency-desctop careerum-flex-fsst">
                        <ul class="careerum-flex-fsfs">
                            <li data-currency="eur" class="active">EUR</li>
                            <li data-currency="rub">RUB</li>
                        </ul>
                        <div class="trip-tales-notif careerum-flex-cc">
                            <div class="trip-tales-notif-icon">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                    alt="">
                            </div>
                            <div class="trip-tales-notif-content">
                                <p>Оплата в российских рублях возможна только картой
                                    российского банка. В&nbsp;евро — картой
                                    зарубежного банка</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="hidden-desc position-relative">
                    <div class="trip-tales__swicher-block position-absolute">
                        <div class="trip-tales__swicher-top">
                            <p class="trip-tales__swicher-header">Посмотреть
                                цены в
                                <span>RUB</span>
                            </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" class="trip-tales__swicher-arrow">
                                <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black">
                                </path>
                            </svg>
                        </div>
                        <div class="trip-tales__swicher-bottom">
                            <ul>
                                <li data-currency="rub">
                                    RUB
                                </li>
                                <li data-currency="eur" class="active">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских
                                рублях
                                возможна только<br> с карты
                                российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="trip-tales-single trip-single-dark careerum-flex-sbfs trip-tale-change-currency"
                data-price-new-eur="149 €" data-price-new-rub="14 900 ₽" data-price-eur="894 €" data-price-rub="89 480 ₽"
                data-href-eur="#eur2" data-href-rub="#buy">
                <div class="position-relative">
                    <div class="trip-tales-currency position-relative z-20 hidden-tablet-mobile">
                        <div class="hidden-tablet-mobile">
                            <div class="trip-tales-currency-desctop careerum-flex-fsst">
                                <ul class="careerum-flex-fsfs">
                                    <li data-currency="eur" class="active">EUR</li>
                                    <li data-currency="rub">RUB</li>
                                </ul>
                                <div class="trip-tales-notif careerum-flex-cc">
                                    <div class="trip-tales-notif-icon">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                            alt="">
                                    </div>
                                    <div class="trip-tales-notif-content">
                                        <p>Оплата в российских рублях возможна только картой
                                            российского банка. В&nbsp;евро — картой
                                            зарубежного банка</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="hidden-desc">
                            <div class="trip-tales__swicher-block">
                                <div class="trip-tales__swicher-top">
                                    <p class="trip-tales__swicher-header">Посмотреть
                                        цены в
                                        <span>RUB</span>
                                    </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                        viewBox="0 0 24 24" fill="none" class="trip-tales__swicher-arrow">
                                        <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black">
                                        </path>
                                    </svg>
                                </div>
                                <div class="trip-tales__swicher-bottom">
                                    <ul>
                                        <li data-currency="rub">
                                            RUB
                                        </li>
                                        <li data-currency="eur" class="active">
                                            EUR
                                        </li>
                                    </ul>
                                    <p>
                                        Обратите внимание,<br> что оплата в российских
                                        рублях
                                        возможна только<br> с карты
                                        российского банка. Оплата в евро — с карты зарубежного банка
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <h3>Суперцена на прокачку резюме</h3>
                    <ul>
                        <li>курс Продающее резюме</li>
                        <li>пак из 6 шаблонов резюме</li>
                        <li>доступ к карьерной платформе</li>
                    </ul>
                    <div class="trip-tales-single-bottom careerum-flex-fsfs">
                        <div class="careerum-flex-fsc trip-tale__price">
                            <p class="price-current">8 900 ₽</p>
                            <p class="price-old">30 770 ₽</p>
                        </div>
                        <a href="#buy" class="btn-color-main-dark-blue">Купить</a>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741597972335-NAiyj-ÑÐº.png"
                        alt="" class="trip-tales-single-img-sale2 position-absolute hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741612309356-NZpOb-ÑÐº.png"
                        alt="" class="trip-tales-single-img-sale2 position-absolute hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741615602137-2TUss-ÑÐº.png"
                        alt="" class="trip-tales-single-img-sale2 position-absolute hidden-desc-tablet">
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-thanks4-main', {
        label: 'Thanks 4 main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-thanks4-main main-wrapper">
                <div class="careerum-container-responsive">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742311866232-kETb7-Elli.png" alt="" class="hidden-tablet-mobile position-absolute z-10">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742311875120-7wh1S-Elli.png" alt="" class="hidden-desc-mobile position-absolute z-10">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742311882813-ei3Sp-Elli.png" alt="" class="hidden-desc-tablet position-absolute z-10">
                    <h1 class="position-relative z-20">Поздравляем! </h1>
                    <p class="thanks4-subheader position-relative z-20">Скоро вы направите свою карьерную ракету к звездам</p>
                    <div class="thanks4-imgs position-relative z-30">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742311781107-riejF-arro.svg" alt=""
                            class="hidden-tablet-mobile position-absolute z-10">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742311822768-srMVZ-arro.svg" alt="" class="hidden-desc-mobile position-absolute z-10">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742311831156-Qfio1-arro.svg" alt="" class="hidden-desc-tablet position-absolute z-10">
                    </div>
                    <div class="thanks4-block-blue position-relative z-20">
                        <p>Оплата прошла успешно. В ближайшее время<br> вам на почту придет письмо с инструкцией и анкетой</p>
                        <p>Пожалуйста, прочитайте письмо и заполните анкету, только после этого мы сможем подобрать эксперта для
                            вас</p>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-cv-main', {
        label: 'CV main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-cv-main main-wrapper">
        <div class="careerum-container-responsive position-relative careerum-flex-sbst">
            <div class="careerum-flex-fsfs position-relative">
                <div class="cv-main-labels careerum-flex-fsfs">
                    <div class="careerum-flex-cc cv-main-label">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742975857217-KWAd1-Cale.svg"
                            alt="" class="hidden-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743002908774-rOptU-Cale.svg"
                            alt="" class="hidden-desc-tablet">
                        <p>26-27 апреля</p>
                    </div>
                    <div class="careerum-flex-cc cv-main-label">
                        <p>Практикум</p>
                    </div>
                </div>
                <div class="cv-main-float-header position-absolute">с экспертом</div>
                <h1>Резюме<br> за выходные</h1>
                <p>Хватит терять вакансии и время!<br> Создайте резюме, которое продаст вас</p>
                <a href="#program" class="btn-color-main-dark-orange">Посмотреть программу</a>
            </div>
            <div class="careerum-flex-fsfs">
                <div class="careerum-flex-fsfs cv-main-right pink">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742976497912-ac2Vk-Star.svg"
                        alt="">
                    <p>Дадим рабочий алгоритм, чтобы усилить резюме. Проверен на 5 000+ клиентов, которые получили
                        офферы</p>
                </div>
                <div class="careerum-flex-fsfs cv-main-right orange">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742976497797-8p28K-Edit.svg"
                        alt="">
                    <p>Готовое мощное резюме за 2 дня интенсивной работы</p>
                </div>
                <div class="careerum-flex-fsfs cv-main-right violet">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742976497389-FK9N0-Pape.svg"
                        alt="">
                    <p>3 индивидуальных разбора
                        вашего резюме карьерным экспертом</p>
                </div>
                <div class="careerum-flex-fsfs cv-main-right blue">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742976497673-YkVOO-Pape.svg"
                        alt="">
                    <p>Количество мест ограничено, чтобы обеспечить качественную обратную связь каждому участнику
                    </p>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-cv-who', {
        label: 'CV who (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-cv-who main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <h2>Кому подойдет?</h2>
            <div class="cv-who-cards careerum-flex-sbst">
                <div class="cv-who-card single careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742976695926-yjMSH-Icon.svg"
                        alt="">
                    <p>Нужно быстрее найти работу</p>
                </div>
                <div class="cv-who-card careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742976695926-yjMSH-Icon.svg"
                        alt="">
                    <p>Необходимо срочно создать профессиональное резюме с нуля</p>
                </div>
                <div class="cv-who-card careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742976695926-yjMSH-Icon.svg"
                        alt="">
                    <p>Отправляете отклики, но не получаете приглашения на собеседования </p>
                </div>
                <div class="cv-who-card careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742976695926-yjMSH-Icon.svg"
                        alt="">
                    <p>Сделали резюме по шаблону hh или брали консультации по резюме, но не помогло</p>
                </div>
                <div class="cv-who-card careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742976695926-yjMSH-Icon.svg"
                        alt="">
                    <p>Требуется экспертная оценка и конкретные рекомендации по улучшению резюме</p>
                </div>
                <div class="cv-who-card careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742976695926-yjMSH-Icon.svg"
                        alt="">
                    <p>Стремитесь получить более высокую позицию и зарплату, но резюме не отражает ваш потенциал</p>
                </div>
                <div class="cv-who-card careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742976695926-yjMSH-Icon.svg"
                        alt="">
                    <p>Давно не искали работу и не понимаете требования работодателей</p>
                </div>
                <div class="cv-who-card careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742976695926-yjMSH-Icon.svg"
                        alt="">
                    <p>Не знаете, как показать свой опыт емко через цифры, кейсы и выгоду для бизнеса</p>
                </div>
                <div class="cv-who-card careerum-flex-fsfs full">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742976695926-yjMSH-Icon.svg"
                        alt="">
                    <p>Вы не ищете работу, но хотите оформить свой опыт и научиться обновлять резюме на регулярной
                        основе, чтобы всегда быть готовым</p>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-cv-why', {
        label: 'CV why (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-cv-why main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <h2>Почему действовать нужно именно сейчас?</h2>
            <div class="cv-why-cards careerum-flex-sbst">
                <div class="cv-why-card">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742977181183-l0pV4-Icon.svg"
                        alt="">
                    <p class="cv-why-card-header">Сезон активного найма закончится в июне</p>
                    <p class="cv-why-card-text">Компании закрывают вакансии до конца мая по ключевым проектам</p>
                </div>
                <div class="cv-why-card">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742977181066-SpdRR-Icon.svg"
                        alt="">
                    <p class="cv-why-card-header">Лучшие вакансии будут заняты </p>
                    <p class="cv-why-card-text">Придется ждать следующего активного сезона найма в начале осени</p>
                </div>
                <div class="cv-why-card">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742977180762-XuLxY-Icon.svg"
                        alt="">
                    <p class="cv-why-card-header hidden-tablet">Времени на метод проб и ошибок нет</p>
                    <p class="cv-why-card-header hidden-desc-mobile">Времени<br> на метод проб<br>и ошибок нет</p>
                    <p class="cv-why-card-text">Каждая неудачная попытка отдаляет вас от желаемой работы</p>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-cv-power', {
        label: 'CV power (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-cv-power main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <h2>Сила резюме в поиске работы</h2>
            <div class="cv-power-cards careerum-flex-sbst">
                <div class="cv-power-card top blue">
                    <p>Резюме — это не просто документ, а мощный инструмент самоанализа и профессионального
                        позиционирования, который открывает двери к новым карьерным возможностям!</p>
                </div>
                <div class="cv-power-card pink">
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742977784191-zA9oM-Tick.svg"
                            alt="">
                        <p>Фундамент карьеры</p>
                    </div>
                    <ul>
                        <li>Глубокая проработка профессионального опыта</li>
                        <li>Чёткое понимание своих сильных сторон</li>
                        <li>Структурированный анализ достижений </li>
                    </ul>
                </div>
                <div class="cv-power-card yellow">
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742977784191-zA9oM-Tick.svg"
                            alt="">
                        <p>Карьерный компас</p>
                    </div>
                    <ul>
                        <li>Определение желаемого направления развития</li>
                        <li>Осознание своей профессиональной ценности</li>
                        <li>Фокус на релевантном опыте</li>
                    </ul>
                </div>
                <div class="cv-power-card violet">
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742977784191-zA9oM-Tick.svg"
                            alt="">
                        <p>Инструмент самопрезентации</p>
                    </div>
                    <ul>
                        <li>Ваша профессиональная визитная карточка </li>
                        <li>Первое впечатление о вас как специалисте</li>
                        <li>Демонстрация вашей экспертизы</li>
                    </ul>
                </div>
                <div class="cv-power-card light-blue">
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742977784191-zA9oM-Tick.svg"
                            alt="">
                        <p>Инвестиция в будущее</p>
                    </div>
                    <ul>
                        <li>База для карьерного роста</li>
                        <li>Артефакт вашего профессионального пути </li>
                        <li>Платформа для повышения дохода</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-cv-format', {
        label: 'CV format (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-cv-format main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <h2>Формат — практика и много обратной связи </h2>
            <div class="cv-format-cards careerum-flex-sbst">
                <div class="cv-format-card position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742983113104-pN9Wl-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742996318664-tgFTh-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743004329512-SUdDr-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-desc-tablet">
                    <p>01.</p>
                    <p class="position-relative z-20">2 дня интенсивной практической работы над резюме</p>
                </div>
                <div class="cv-format-card position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742983112996-PUj4B-Star.svg"
                        alt="" class="position-absolute z-10 hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742996318558-2RkzY-Star.svg"
                        alt="" class="position-absolute z-10 hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743004329398-7Aa7y-Star.svg"
                        alt="" class="position-absolute z-10 hidden-desc-tablet">
                    <p>02.</p>
                    <p class="position-relative z-20">Мини-группы до 15 человек, чтобы yделить максимyм внимания каждому
                    </p>
                </div>
                <div class="cv-format-card position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742983112882-Htfe5-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742996318437-P6tQD-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743004329285-8FmKM-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-desc-tablet">
                    <p>03.</p>
                    <p class="position-relative z-20">Разбор сложных вопросов экспертами в формате<br> Q&A-сессии</p>
                </div>
                <div class="cv-format-card position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742983112758-Vv6cj-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742996318032-ByTHn-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743004329025-z5FJD-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-desc-tablet">
                    <p>04.</p>
                    <p class="position-relative z-20">3 раунда персонального фидбека от экспертов </p>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-cv-schedule', {
        label: 'CV schedule (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-cv-schedule main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <div class="position-absolute cv-schedule-label">Скорая помощь для резюме</div>
            <h2>Расписание практикума</h2>
            <div class="cv-schedule-cards careerum-flex-sbst">
                <div class="cv-schedule-card card-day">
                    <div class="careerum-flex-fsc cv-schedule-card-date">
                        <p class="cv-schedule-card-label">1 день</p>
                        <p>26 апреля, сб</p>
                    </div>
                    <div class="cv-schedule-card-time blue careerum-flex-fsfs">
                        <div>
                            <p>11:00–11:45</p>
                            <p>45 мин</p>
                        </div>
                        <div>
                            <p>Структура резюме: </p>
                            <ul>
                                <li>Первый разбор с примерами резюме участников</li>
                                <li>Функциональное и хронологическое резюме — когда какое использовать</li>
                                <li>Вопросы по структуре резюме</li>
                            </ul>
                        </div>
                    </div>
                    <div class="cv-schedule-card-time yellow careerum-flex-fsfs">
                        <div>
                            <p>11:45–12:00</p>
                            <p>1 час 15 мин</p>
                        </div>
                        <div>
                            <p>Самостоятельная работа: </p>
                            <p> Исправляем свои резюме,
                                исходя из рекомендаций экспертов</p>
                        </div>
                    </div>
                    <div class="cv-schedule-card-time blue careerum-flex-fsfs">
                        <div>
                            <p>12:00–13:30</p>
                            <p>1,5 часа</p>
                        </div>
                        <div>
                            <p>Summary резюме:</p>
                            <ul>
                                <li>Что должно содержать, какого размера, и тд</li>
                                <li>Разборы summary резюме участников со скринами их резюме</li>
                            </ul>
                        </div>
                    </div>
                    <div class="cv-schedule-card-time pink careerum-flex-fsfs">
                        <div>
                            <p>13:30–14:00</p>
                            <p>30 мин</p>
                        </div>
                        <div>
                            <p>Перерыв</p>
                        </div>
                    </div>
                    <div class="cv-schedule-card-time blue careerum-flex-fsfs">
                        <div>
                            <p>14:00–15:30</p>
                            <p>1,5 часа</p>
                        </div>
                        <div>
                            <p>Работающие промты для сильного summary:</p>
                            <ul>
                                <li>Вопросы по summary</li>
                                <li>Разбор резюме участников. Примеры, как промты могут улучшить summary </li>
                            </ul>
                        </div>
                    </div>
                    <div class="cv-schedule-card-time yellow careerum-flex-fsfs">
                        <div>
                            <p>15:30–17:00</p>
                            <p>1,5 часа</p>
                        </div>
                        <div>
                            <p>Самостоятельная работа: </p>
                            <p> Исправляем свои резюме,
                                исходя из рекомендаций экспертов</p>
                        </div>
                    </div>
                </div>
                <div class="cv-schedule-card card-day">
                    <div class="careerum-flex-fsc cv-schedule-card-date">
                        <p class="cv-schedule-card-label">2 день</p>
                        <p>27 апреля, вс</p>
                    </div>
                    <div class="cv-schedule-card-time blue careerum-flex-fsfs">
                        <div>
                            <p>11:00–13:30</p>
                            <p>2,5 часа </p>
                        </div>
                        <div>
                            <p>Достижения в резюме:</p>
                            <ul>
                                <li>Вопросы по достижениям в резюме</li>
                                <li>Как должны быть описаны, как формулировать</li>
                                <li>Разборы достижений в резюме участников</li>
                            </ul>
                        </div>
                    </div>
                    <div class="cv-schedule-card-time violet careerum-flex-fsfs">
                        <div>
                            <p>13:30–14:00</p>
                            <p>1 час</p>
                        </div>
                        <div>
                            <p>Перерыв</p>
                        </div>
                    </div>
                    <div class="cv-schedule-card-time blue careerum-flex-fsfs">
                        <div>
                            <p>14:00–14:30</p>
                            <p>30 мин</p>
                        </div>
                        <div>
                            <p>Работающие промты для написания сильных достиений</p>
                        </div>
                    </div>
                    <div class="cv-schedule-card-time yellow careerum-flex-fsfs">
                        <div>
                            <p>14:30–15:30</p>
                            <p>1 час</p>
                        </div>
                        <div>
                            <p>Самостоятельная работа: </p>
                            <p> Исправляем свои резюме,
                                исходя из рекомендаций экспертов</p>
                        </div>
                    </div>
                    <div class="cv-schedule-card-time blue careerum-flex-fsfs">
                        <div>
                            <p>15:30–16:30</p>
                            <p>1 час</p>
                        </div>
                        <div>
                            <p>Разбор ошибок поиска работы </p>
                        </div>
                    </div>
                    <div class="cv-schedule-card-time blue careerum-flex-fsfs">
                        <div>
                            <p>16:30–17:30</p>
                            <p>1 час</p>
                        </div>
                        <div>
                            <p>Q&A-сессия с экспертами:</p>
                            <ul>
                                <li>Заключительная сессия вопросов по написанию резюме</li>
                                <li>Нетворкинг с участниками практикума</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="cv-schedule-card card-text">
                    <div class="careerum-flex-fsfs cv-schedule-card-header">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742984837323-nAEMm-Tick.svg"
                            alt="">
                        <p>Уроки и шаблоны по резюме</p>
                    </div>
                    <ul>
                        <li>5 видеоуроков-инструкций по созданию резюме. Откроем за 2 недели до старта </li>
                        <li>Шаблоны резюме под разные кейсы</li>
                        <li>Гайд по поиску достижений и упаковке своего опыта</li>
                    </ul>
                </div>
                <div class="cv-schedule-card card-text">
                    <div class="careerum-flex-fsfs cv-schedule-card-header">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742984837323-nAEMm-Tick.svg"
                            alt="">
                        <p>Чат с экспертами</p>
                    </div>
                    <ul>
                        <li>Чат на 1 неделю с экспертами для получения фидбэка от эксперта на формулировки саммари
                            и достижений</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-cv-experts-why', {
        label: 'CV experts-why (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-cv-experts-why main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <h2>Почему стоит доверить резюме карьерному эксперту?</h2>
            <div class="cv-experts-why-cards careerum-flex-sbst">
                <div class="cv-experts-why-card blue">
                    <p>Знает требования работодателей и помогает пройти отбор </p>
                </div>
                <div class="cv-experts-why-card">
                    <p>Имеет опыт в вашем рынке, сфере и грейде: ежедневно помогает составлять резюме сотням кандидатов
                    </p>
                </div>
                <div class="cv-experts-why-card">
                    <p>Знает, как исправить ошибки резюме и зацепить рекрутера</p>
                </div>
                <div class="cv-experts-why-card">
                    <p>Знает, как сделать резюме идеальным: использует практики отработанные на тысячах кандидатов</p>
                </div>
                <div class="cv-experts-why-card">
                    <p>Помогает скрыть недостатки: долгий перерыв в работе, мало опыта, возраст 40+</p>
                </div>
                <div class="cv-experts-why-card">
                    <p>Помогает упаковывать опыт через достижения, цифры, факты и пользу для компании</p>
                </div>
                <div class="cv-experts-why-card">
                    <p>Понимает, как пройти ATS-системы</p>
                </div>
                <div class="cv-experts-why-card">
                    <p>Помогает кастомизировать резюме под разные вакансии</p>
                </div>
                <div class="cv-experts-why-card">
                    <p>Знает тренды найма в РФ и 50+ странах. Помогает внедрить их в резюме</p>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-cv-feedback', {
        label: 'CV feedback (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-cv-feedback main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <h2>Сила экспертного фидбека для резюме</h2>
            <div class="cv-feedback-cards careerum-flex-sbst">
                <div class="cv-feedback-card">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742986005482-thtwx-Icon.svg"
                        alt="">
                    <p>Профессиональная оценка карьерных экспертов с международным опытом
                        покажет, как ваше резюме видит рекрyтер или нанимающий менеджер</p>
                </div>
                <div class="cv-feedback-card">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742986005346-YP1jd-Vect.svg"
                        alt="">
                    <p>Каждый новый раунд обратной связи позволяет улучшить резюме и
                        формулировки достижений, опираясь на предыдущие рекомендации</p>
                </div>
                <div class="cv-feedback-card">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742986005237-JFGH5-Star.svg"
                        alt="">
                    <p>За 2 раунда исправите все недочеты и доведете резюме до рабочего
                        результата</p>
                </div>
                <div class="cv-feedback-card">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742986005125-6bv7a-Vect.svg"
                        alt="">
                    <p>Разбор ваших реальных кейсов </p>
                </div>
                <div class="cv-feedback-card blue position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742985964024-LL1Hr-Vect.svg"
                        alt="" class="position-absolute z-10">
                    <p class="cv-schedule-card-header position-relative z-20">Разбор резюме происходит онлайн</p>
                    <p class="cv-schedule-card-text position-relative z-20 hidden-tablet-mobile">Эксперт персонально
                        знакомится с вашим
                        резюме, разбирает ошибки и
                        дает рекомендации</p>
                    <p class="cv-schedule-card-text position-relative z-20 hidden-desc">Эксперт персонально знакомится с
                        вашим резюме и дает рекомендации</p>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-cv-results', {
        label: 'CV results (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-cv-results main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <h2>Результат, который вы получите </h2>
            <p>Каждая составляющая резюме будет качественно проработана благодаря персональной обратной связи от
                экспертов</p>
            <div class="cv-results-cards">
                <div class="cv-results-cards-wrapper careerum-flex-sbst">
                    <div class="cv-results-card">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742986507920-Huo7M-Chec.svg"
                            alt="" class="hidden-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743053795656-PgX4q-Chec.svg"
                            alt="" class="hidden-desc-tablet">
                        <p>Резюме, которое увеличит количество откликов минимум в 2 раза</p>
                    </div>
                    <div class="cv-results-card">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742986507920-Huo7M-Chec.svg"
                            alt="" class="hidden-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743053795656-PgX4q-Chec.svg"
                            alt="" class="hidden-desc-tablet">
                        <p>Сильное резюме, соответствующее современным требованиям рынка</p>
                    </div>
                    <div class="cv-results-card">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742986507920-Huo7M-Chec.svg"
                            alt="" class="hidden-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743053795656-PgX4q-Chec.svg"
                            alt="" class="hidden-desc-tablet">
                        <p>Четкое описание ключевых компетенций и навыков для желаемой позиции</p>
                    </div>
                    <div class="cv-results-card">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742986507920-Huo7M-Chec.svg"
                            alt="" class="hidden-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743053795656-PgX4q-Chec.svg"
                            alt="" class="hidden-desc-tablet">
                        <p>Грамотно сформулированные достижения с измеримыми результатами</p>
                    </div>
                    <div class="cv-results-card">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742986507920-Huo7M-Chec.svg"
                            alt="" class="hidden-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743053795656-PgX4q-Chec.svg"
                            alt="" class="hidden-desc-tablet">
                        <p>Структурированная информация для быстрого сканирования рекрутером</p>
                    </div>
                    <div class="cv-results-card">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742986507920-Huo7M-Chec.svg"
                            alt="" class="hidden-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743053795656-PgX4q-Chec.svg"
                            alt="" class="hidden-desc-tablet">
                        <p>Ключевые слова, оптимизированные под ATS-системы </p>
                    </div>
                    <div class="cv-results-card">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742986507920-Huo7M-Chec.svg"
                            alt="" class="hidden-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743053795656-PgX4q-Chec.svg"
                            alt="" class="hidden-desc-tablet">
                        <p>Убедительное описание мягких навыков с конкретными примерами их применения</p>
                    </div>
                    <div class="cv-results-card">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742986507920-Huo7M-Chec.svg"
                            alt="" class="hidden-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743053795656-PgX4q-Chec.svg"
                            alt="" class="hidden-desc-tablet">
                        <p>Правильно оформленный опыт работы с акцентом на ваши сильные стороны</p>
                    </div>
                    <div class="cv-results-card">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742986507920-Huo7M-Chec.svg"
                            alt="" class="hidden-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743053795656-PgX4q-Chec.svg"
                            alt="" class="hidden-desc-tablet">
                        <p>Продающее саммари, которое позволит делать эффективную самопрезентацию на интервью</p>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-cv-experts', {
        label: 'CV experts (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-cv-experts main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <h2>Карьерные эксперты</h2>
            <div class="cv-experts-cards">
                <div class="cv-experts-card careerum-flex-sbfs">
                    <div class="cv-experts-card-img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742986783731-8g4ov-Image.webp"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742998299339-UuZVK-Image.webp"
                            alt="" class="hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743054863881-agfGl-Image.webp"
                            alt="" class="hidden-desc-tablet">
                        <p>Софи Бессон</p>
                    </div>
                    <div class="cv-experts-card-description careerum-flex-sbst">
                        <div class="cv-experts-card-description-about careerum-flex-fsfs">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742987270237-1CYme-Work.svg"
                                    alt="">
                            </div>
                            <div>
                                <p>Карьерный консультант с международным опытом, специализирующийся на поиске работы</p>
                                <p>Консультирует на русском и английском</p>
                            </div>
                        </div>
                        <div class="cv-experts-card-description-number">
                            <div>
                                <p class="cv-experts-card-description-number-top">4,5</p>
                                <p class="cv-experts-card-description-number-label position-relative">года</p>
                            </div>
                            <p class="cv-experts-card-description-number-bottom">в карьерном консалтинге. С 2015 года —
                                в HR</p>
                        </div>
                        <div class="cv-experts-card-description-number">
                            <div>
                                <p class="cv-experts-card-description-number-top">9.7</p>
                                <p class="cv-experts-card-description-number-label position-relative">баллов</p>
                            </div>
                            <p class="cv-experts-card-description-number-bottom">из 10: средняя оценка качества работы
                                от клиентов</p>
                        </div>
                        <div class="cv-experts-card-description-number-full pink">
                            <div>
                                <p class="cv-experts-card-description-number-top">600+</p>
                                <p class="cv-experts-card-description-number-label position-relative">успешных клиентов
                                </p>
                            </div>
                            <p class="cv-experts-card-description-number-bottom">из локальных и международных компаний:
                                IBM, World Bank, Microsoft, Disney, Mastercard и др.</p>
                        </div>
                    </div>
                </div>
                <div class="cv-experts-card careerum-flex-sbfs">
                    <div class="cv-experts-card-img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742986784267-VqvAQ-Image.webp"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742998299666-z3qUH-Image.webp"
                            alt="" class="hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743054863549-81r00-Image.webp"
                            alt="" class="hidden-desc-tablet">
                        <p>Мария Пудалова</p>
                    </div>
                    <div class="cv-experts-card-description careerum-flex-sbst">
                        <div class="cv-experts-card-description-about careerum-flex-fsfs">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742987270237-1CYme-Work.svg"
                                    alt="">
                            </div>
                            <div>
                                <p>Карьерный эксперт с международной практикой, специализирующийся на развитии личного
                                    бренда</p>
                                <p>Консультирует на русском, английском, французском</p>
                            </div>
                        </div>
                        <div class="cv-experts-card-description-number">
                            <div>
                                <p class="cv-experts-card-description-number-top">7+</p>
                                <p class="cv-experts-card-description-number-label position-relative">лет</p>
                            </div>
                            <p class="cv-experts-card-description-number-bottom">международного опыта работы: Франция,
                                Израиль, Германия</p>
                        </div>
                        <div class="cv-experts-card-description-number">
                            <div>
                                <p class="cv-experts-card-description-number-top">х2</p>
                                <p class="cv-experts-card-description-number-label position-relative">чаще</p>
                            </div>
                            <p class="cv-experts-card-description-number-bottom">полyчают офферы клиенты Марии, чем при
                                самостоятельно поиске</p>
                        </div>
                        <div class="cv-experts-card-description-number-full blue">
                            <div>
                                <p class="cv-experts-card-description-number-top">350+</p>
                                <p class="cv-experts-card-description-number-label position-relative">счастливых
                                    клиентов
                                </p>
                            </div>
                            <p class="cv-experts-card-description-number-bottom">оптимизировали стратегию поиска
                                и работают в Meta, BBDO, Microsoft и других международных компаниях</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-cv-header', {
        label: 'CV header (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-cv-header main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <h2 class="position-relative z-20">Сделайте<span>резюме</span>, которое открывает двери в лучшие компании
                в вашей сфере</h2>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742988514104-ZcQ4G-Vect.svg" alt=""
                class="position-absolute cv-header-img-1 hidden-tablet-mobile z-10">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742988513822-XcUTD-Vect.svg" alt=""
                class="position-absolute cv-header-img-2 hidden-tablet-mobile z-10">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742999138926-wCgZl-Vect.svg" alt=""
                class="position-absolute cv-header-img-1 hidden-desc-mobile z-10">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742999138658-9ivQi-Vect.svg" alt=""
                class="position-absolute cv-header-img-2 hidden-desc-mobile z-10">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743055179464-bnVLG-Vect.svg" alt=""
                class="position-absolute cv-header-img-1 hidden-desc-tablet z-10">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743055179188-b9uRw-Vect.svg" alt=""
                class="position-absolute cv-header-img-2 hidden-desc-tablet z-10">
        </div>
    </div>`
    });
    
    blockManager.add('careerum-cv-clients', {
        label: 'CV clients (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-cv-clients main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <h2>Клиенты Carееrum получают офферы в ведущие компании России и мира</h2>
            <div class="cv-clients-logos position-relative z-10">
                <div class="cv-clients-logo">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742988884752-nBSBa-Ð»Ð¾Ð.webp"
                        alt="" class="hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742999298225-1sAwU-Ð»Ð¾Ð.webp"
                        alt="" class="hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743055491170-BEgvm-Logos.webp"
                        alt="" class="hidden-desc-tablet">
                </div>
            </div>
            <div class="cv-clients-label position-absolute z-20">
                <p>5 000+ офферов</p>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-cv-reviews', {
        label: 'CV reviews (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-cv-reviews main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <h2>Отзывы о работе экспертов Careerum</h2>
            <div class="cv-reviews-img-container hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742990536335-nnmgA-Conte.webp" alt=""
                    class="position-relative">
            </div>
            <div class="cv-reviews-img-container hidden-desc-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742999549183-fvvMI-Conte.webp" alt=""
                    class="position-relative">
            </div>
            <div class="cv-reviews-img-container hidden-desc-tablet">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743055542407-8QmbJ-Group.webp" alt=""
                    class="position-relative">
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-cv-tariffs', {
        label: 'CV tariffs (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club40-tariffs careerum-cv-tariffs main-wrapper">
                <div class="careerum-container-responsive">
                    <h2 class="careerum-club40-header">Выберите вариант участия </h2>
                    <div class="club40-tariffs-nav careerum-flex-fec">
                        <div class="club40-tariffs-period careerum-flex-fsst hidden">
                            <ul class="careerum-flex-fsfs">
                                <li data-period="1" class="active">1 месяц</li>
                                <li data-period="3">3 месяца</li>
                                <li data-period="6">6 месяцев</li>
                                <li data-period="12">12 месяцев</li>
                            </ul>
                            <div class="club40-tariffs-notif careerum-flex-cc">
                                <div class="club40-tariffs-notif-icon"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                        alt=""></div>
                                <div class="club40-tariffs-notif-content">
                                    <p>1 месяц подписки предоставляет 30 дней доступа к платформе</p>
                                </div>
                            </div>
                        </div>
                        <div class="club40-tariffs-curr careerum-flex-fsst">
                            <ul class="careerum-flex-fsfs">
                                <li data-currency="eur" class="active">EUR</li>
                                <li data-currency="rub">RUB</li>
                            </ul>
                            <div class="club40-tariffs-notif careerum-flex-cc">
                                <div class="club40-tariffs-notif-icon"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                        alt=""></div>
                                <div class="club40-tariffs-notif-content">
                                    <p>Оплата в российских рублях возможна только картой российского банка. В&nbsp;евро — картой
                                        зарубежного банка</p>
                                </div>
                            </div>
                        </div>
                        <div class="club40-tariffs__swicher-block">
                            <div class="club40-tariffs__swicher-top">
                                <p class="club40-tariffs__swicher-header">Посмотреть цены в
                                    <span>RUB</span>
                                </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" class="club40-tariffs__swicher-arrow">
                                    <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black"></path>
                                </svg>
                            </div>
                            <div class="club40-tariffs__swicher-bottom">
                                <ul>
                                    <li data-currency="rub">
                                        RUB
                                    </li>
                                    <li data-currency="eur" class="active">
                                        EUR
                                    </li>
                                </ul>
                                <p>
                                    Обратите внимание,<br> что оплата в российских рублях
                                    возможна только<br> с карты
                                    российского банка. Оплата в евро — с карты зарубежного банка
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="club40-tariffs-items careerum-flex-cst">
                        <div data-price="" data-price-1m-rub="12 900 ₽" data-price-3m-rub="9&nbsp;967 ₽"
                            data-fullprice-3m-rub="29&nbsp;900 ₽" data-price-6m-rub="7 900 ₽"
                            data-fullprice-6m-rub="47&nbsp;400 ₽" data-price-12m-rub="6 490 ₽" data-fullprice-12m-rub="77 880 ₽"
                            data-price-1m-eur="149 €" data-price-3m-eur="120 €" data-fullprice-3m-eur="360 €"
                            data-price-6m-eur="90 €" data-fullprice-6m-eur="540 €" data-price-12m-eur="80 €"
                            data-fullprice-12m-eur="960 €" data-offer-1m-rub="27" data-offer-3m-rub="94" data-offer-6m-rub="95"
                            data-offer-12m-rub="96" data-offer-1m-eur="48" data-offer-3m-eur="97" data-offer-6m-eur="98"
                            data-offer-12m-eur="99" class="club40-tariffs-item careerum-flex-fsfs">
                            <p class="club40-tariffs-item-subheader2">Тариф «С поддержкой»</p>
                            <p class="club40-tariffs-item-header hidden-tablet-mobile">Резюме<br> с поддержкой<br><br><br></p>
                            <p class="club40-tariffs-item-header hidden-desc-mobile">Резюме<br> с поддержкой</p>
                            <p class="club40-tariffs-item-header hidden-desc-tablet">Резюме с поддержкой</p>
                            <p class="club40-tariffs-item-description">Всего: 50 мест</p>
                            <div class="club40-tariffs-item-divider"></div>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742991894076-U2VdV-Feat.svg"
                                        alt="">
                                    <p>1 эфир разбор summary резюме + промты</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742991894076-U2VdV-Feat.svg"
                                        alt="">
                                    <p>1 эфир разбор достижения в резюме + промты</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742991894076-U2VdV-Feat.svg"
                                        alt="">
                                    <p>1 Q&A-сессии с экспертами в формате вопрос-ответ</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742991894076-U2VdV-Feat.svg"
                                        alt="">
                                    <p>Чат на 1 неделю для получения фидбэка от эксперта на формулировки саммари и достижений
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742991894076-U2VdV-Feat.svg"
                                        alt="">
                                    <p>5 видеоуроков, шаблоны резюме, гайд по достижениям</p>
                                </li>
                                <li class="careerum-flex-fsfs disabled">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742992250466-jL6F4-Feat.svg"
                                        alt="">
                                    <p>1 личная консультация c карьерным экспертом для проработки резюме / LinkedIn
                                        в индивидуальном формате</p>
                                </li>
                            </ul>
                            <div class="club40-tariffs-item-bottom">
                                <div class="club40-tariffs-item-discount careerum-flex-fsc">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742992296643-Uht7v-Lock.svg"
                                        alt="" class="hidden-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743056624755-0AZOL-Lock.svg"
                                        alt="" class="hidden-desc-tablet">
                                    <p>Доступ на 30 дней</p>
                                </div>
                                <div class="careerum-flex-fsfs club40-tariffs-item-wrapper-price with-discount">
                                    <div>
                                        <p class="club40-tariffs-item-price-pm">14 900 ₽</p>
                                    </div>
                                </div>
                                <a onclick="" href="#tariff-single" class="btn-color-main-dark-orange">Купить</a>
                            </div>
                        </div>
                        <div data-price="" data-price-1m-rub="12 900 ₽" data-price-3m-rub="9&nbsp;967 ₽"
                            data-fullprice-3m-rub="29&nbsp;900 ₽" data-price-6m-rub="7 900 ₽"
                            data-fullprice-6m-rub="47&nbsp;400 ₽" data-price-12m-rub="6 490 ₽" data-fullprice-12m-rub="77 880 ₽"
                            data-price-1m-eur="149 €" data-price-3m-eur="120 €" data-fullprice-3m-eur="360 €"
                            data-price-6m-eur="90 €" data-fullprice-6m-eur="540 €" data-price-12m-eur="80 €"
                            data-fullprice-12m-eur="960 €" data-offer-1m-rub="27" data-offer-3m-rub="94" data-offer-6m-rub="95"
                            data-offer-12m-rub="96" data-offer-1m-eur="48" data-offer-3m-eur="97" data-offer-6m-eur="98"
                            data-offer-12m-eur="99" class="club40-tariffs-item careerum-flex-fsfs">
                            <p class="club40-tariffs-item-subheader2">Тариф «Индивидуальный подход»</p>
                            <p class="club40-tariffs-item-header">Резюме с поддержкой + индивидуальная консультация с карьерным
                                экспертом</p>
                            <p class="club40-tariffs-item-description">Всего: 10 мест</p>
                            <div class="club40-tariffs-item-divider"></div>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742991894076-U2VdV-Feat.svg"
                                        alt="">
                                    <p>1 эфир разбор summary резюме + промты</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742991894076-U2VdV-Feat.svg"
                                        alt="">
                                    <p>1 эфир разбор достижения в резюме + промты</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742991894076-U2VdV-Feat.svg"
                                        alt="">
                                    <p>1 Q&A-сессии с экспертами в формате вопрос-ответ</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742991894076-U2VdV-Feat.svg"
                                        alt="">
                                    <p>Чат на 1 неделю для получения фидбэка от эксперта на формулировки саммари и достижений
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742991894076-U2VdV-Feat.svg"
                                        alt="">
                                    <p>5 видеоуроков, шаблоны резюме, гайд по достижениям</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742991894076-U2VdV-Feat.svg"
                                        alt="">
                                    <p>1 личная консультация c карьерным экспертом для проработки резюме / LinkedIn
                                        в индивидуальном формате</p>
                                </li>
                            </ul>
                            <div class="club40-tariffs-item-bottom">
                                <div class="club40-tariffs-item-discount careerum-flex-fsc">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742992296643-Uht7v-Lock.svg"
                                        alt="" class="hidden-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743056624755-0AZOL-Lock.svg"
                                        alt="" class="hidden-desc-tablet">
                                    <p>Доступ на 30 дней</p>
                                </div>
                                <div class="careerum-flex-fsfs club40-tariffs-item-wrapper-price with-discount">
                                    <div>
                                        <p class="club40-tariffs-item-price-pm">14 900 ₽</p>
                                    </div>
                                </div>
                                <a onclick="" href="#tariff-single" class="btn-color-main-dark-orange">Купить</a>
                            </div>
                        </div>
                    </div>
                    <div class="club40-tariffs-curr">
                        <div class="club40-tariffs__swicher-block">
                            <div class="club40-tariffs__swicher-top">
                                <p class="club40-tariffs__swicher-header">Посмотреть цены в
                                    <span>RUB</span>
                                </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" class="club40-tariffs__swicher-arrow">
                                    <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black"></path>
                                </svg>
                            </div>
                            <div class="club40-tariffs__swicher-bottom">
                                <ul>
                                    <li data-currency="rub">
                                        RUB
                                    </li>
                                    <li data-currency="eur" class="active">
                                        EUR
                                    </li>
                                </ul>
                                <p>
                                    Обратите внимание,<br> что оплата в российских рублях
                                    возможна только<br> с карты
                                    российского банка. Оплата в евро — с карты зарубежного банка
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-cv-pay', {
        label: 'CV pay (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-cv-pay main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <h2>Поможем оплатить подписку через работодателя</h2>
                    <div class="cv-pay-bottom position-relative">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742992946020-8Dy9W-Vect.svg" alt=""
                            class="position-absolute p-10">
                        <p class="position-relative p-20">Если компания вас недавно сократила и готова оплатить вам поиск новой работы, свяжитесь с нами и
                            оплатите через нее</p>
                        <div class="position-relative p-20">
                            <a href="#" class="btn-color-main-white">Связаться</a>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-cv-start', {
        label: 'CV start (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-cv-start main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <h2 class="position-relative z-20">Начните получать много откликов в лучшие компании в вашей сфере.</h2>
                    <p class="position-relative z-20">За 2 дня под руководством экспертов создайте сильное резюме, которое поможет вам быстро найти желаемую работу.</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743590517909-g2Zun-Vect.svg" alt="" class="hidden-tablet-mobile cv-start-img-hover position-absolute z-10">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743590517657-vToab-t.sv.svg" alt="" class="hidden-desc-mobile cv-start-img-hover position-absolute z-10">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743590517534-JUKRZ-m.sv.svg" alt="" class="hidden-desc-tablet cv-start-img-hover position-absolute z-10">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743590597831-N7hvf-Vect.svg" alt="" class="cv-start-img-bg position-absolute z-10">
                </div>
            </div>`
    });
    
    blockManager.add('careerum-affirm-main', {
        label: 'Affirmation main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-affirm-main main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <div class="affirm-main-header careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743414526635-nEY0l-logo.svg" alt=""
                            class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743415839053-u7JZ8-logo.svg" alt=""
                            class="hidden-desc">
                        <p>— платформа карьерного развития</p>
                    </div>
                    <h1 class="position-relative z-20">Бот с карьерными аффирмациями</h1>
                    <div class="affirm-main-text-block position-relative z-20">
                        <p>365 дней вдохновляющей поддержки в коротких мотивирующих фразах для вас:</p>
                        <ul>
                            <li>Чтобы понедельники радовали</li>
                            <li>Чтобы не проваливаться в синдром самозванца</li>
                            <li>Чтобы замечать свои успехи</li>
                            <li>Чтобы расти в профессии</li>
                        </ul>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743414526279-K3it3-Grou.svg" alt=""
                        class="position-absolute affirm-main-bg hidden-tablet-mobile z-10">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743414525920-XG0zx-Group.webp" alt=""
                        class="position-absolute affirm-main-phone hidden-tablet-mobile z-10">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743415581817-TkobR-Grou.svg" alt=""
                        class="position-absolute affirm-main-bg hidden-desc-mobile z-10">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743415622906-NGEZZ-Group.webp" alt=""
                        class="position-absolute affirm-main-phone hidden-desc-mobile z-10">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743416230516-oBkQC-Grou.svg" alt=""
                        class="position-absolute affirm-main-bg hidden-desc-tablet z-10">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743416197071-ijO6L-Group.webp" alt=""
                        class="affirm-main-phone hidden-desc-tablet">
                    <a href="#popup" class="btn-color-main-dark-orange">Забрать подарок</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-diagnostics-main', {
        label: 'Diagnostics main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-diagnostics-main main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <div class="diagnostics-main-header careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743431141861-x9NS1-Grou.svg" alt=""
                            class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743431152141-J2lCN-Head.svg" alt=""
                            class="hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743431162612-Cw8O8-Grou.svg" alt=""
                            class="hidden-desc-tablet">
                    </div>
                    <h1 class="position-relative z-20">Бесплатная<br><span>экспресс-диагностика</span><br><span>резюме</span>
                    </h1>
                    <p class="position-absolute">НЕ ИМЕЕТ ПРОТИВОПОКАЗАНИЙ.
                        НЕ НУЖНА КОНСУЛЬТАЦИЯ ВРАЧА</p>
                    <p class="position-absolute">Результаты анализа за 10 минут</p>
                    <div class="diagnostics-main-cards position-relative z-20 careerum-flex-sbst">
                        <div class="diagnostics-main-card position-relative">
                            <p class="diagnostics-main-card-header">Показания</p>
                            <p class="diagnostics-main-card-text">Ваше резюме не просматривают и не приглашают на собеседования
                            </p>
                        </div>
                        <div class="diagnostics-main-card position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743431962020-8GLCk-Icon.svg"
                                alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743434598120-1MYca-Icon.svg"
                                alt="" class="hidden-desc">
                            <p class="diagnostics-main-card-header">Анализ состояния</p>
                            <p class="diagnostics-main-card-text">Выявим слабые места в резюме</p>
                        </div>
                        <div class="diagnostics-main-card position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743431961751-egSVF-Icon.svg"
                                alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743434597856-OHjSd-Icon.svg"
                                alt="" class="hidden-desc">
                            <p class="diagnostics-main-card-header">Расшифровка результатов</p>
                            <p class="diagnostics-main-card-text">В чём причина недомогания</p>
                        </div>
                    </div>
                    <div class="diagnostics-main-form position-relative z-20">
                        <div class="careerum-registration-form-club40 no-checkbox">
                            <form class="deva-form getcourse-email-signup careerum-flex-sbfs" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                                <div class="careerum-club40-form-button-agree">
                                    <a href="#" class="submit-btn btn-color-main-bright-orange" disabled>Пройти диагностику</a>
                                    <div class="careerum-club40-form-agree">
                                        <label>
                                            <input type="checkbox" name="agree" checked="checked">
                                            <div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                    fill="none">
                                                    <path
                                                        d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                        stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </label>
                                        <p>Нажимая на кнопку, я даю согласие на обработку своих персональных данных
                                            в соответствии с <a href="https://careerum.com/ru-ru/legal/privacy"
                                                target="_blank">Политикой конфиденциальности</a></p>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743432067704-tpMln-Grou.svg" alt=""
                        class="position-absolute diagnostics-main-bg hidden-tablet-mobile z-10">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743434379452-2js3v-Grou.svg" alt=""
                        class="position-absolute diagnostics-main-bg hidden-desc-mobile z-10">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743435839820-AFBD0-Grou.svg" alt=""
                        class="position-absolute diagnostics-main-bg hidden-desc-tablet z-10">
                </div>
            </div>`
    });
    
    blockManager.add('careerum-validator-main', {
        label: 'Validator main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `            
            <div class="careerum-validator-main main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <div class="validator-main-header careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743431141861-x9NS1-Grou.svg" alt=""
                            class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743431152141-J2lCN-Head.svg" alt=""
                            class="hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743431162612-Cw8O8-Grou.svg" alt=""
                            class="hidden-desc-tablet">
                    </div>
                    <h1 class="position-relative z-10">AI-валидатор</h1>
                    <p class="position-relative z-10">резюме</p>
                    <p class="position-relative z-10">Проверьте своё резюме и получите экспертные советы по улучшению</p>
                    <div class="validator-main-form position-relative z-20">
                        <div class="careerum-registration-form-club40 no-checkbox">
                            <form class="deva-form getcourse-email-signup careerum-flex-sbfs" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                                <div class="careerum-club40-form-button-agree">
                                    <a href="#" class="submit-btn btn-color-main-bright-orange" disabled>Проверить резюме</a>
                                    <div class="careerum-club40-form-agree">
                                        <label>
                                            <input type="checkbox" name="agree" checked="checked">
                                            <div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                    fill="none">
                                                    <path
                                                        d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                        stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </label>
                                        <p>Нажимая на кнопку, я даю согласие на обработку своих персональных данных
                                            в соответствии с <a href="https://careerum.com/ru-ru/legal/privacy"
                                                target="_blank">Политикой конфиденциальности</a></p>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="validator-main-cards position-relative z-20 careerum-flex-sbst">
                        <div class="validator-main-card-left position-relative">
                            <p>Обучен на основе:</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744099557354-drFph-Docu.svg" alt="">
                                    <p><span class="orange">5000+ резюме</span> которые привели к офферам</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744099556541-s4Tvs-Prof.svg" alt="">
                                    <p><span class="pink">Базы знаний</span> экспертов Careerum</p>
                                </li>
                            </ul>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744100236160-ZH6ib-ÑÐ¾.svg" alt="" class="position-absolute z-10 hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744101173292-GsXr2-ÑÐ¾.svg" alt="" class="position-absolute z-10 hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744103317799-wi4zP-ÑÐ¾.svg" alt="" class="position-absolute z-10 hidden-desc-tablet">
                        </div>
                        <div class="validator-main-card-right position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744100149498-rWY7E-Cont.png" alt="" class="position-absolute z-10 hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744101172995-SEAhS-Grou.svg" alt="" class="position-absolute z-10 hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744103381953-2gAoz-Imag.svg" alt="" class="position-absolute hidden-desc-tablet">
                        </div>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744097566446-0Pd2Q-Star.svg" alt=""
                        class="position-absolute validator-img-label hidden-tablet-mobile z-20">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744113262961-su8tk-Star.svg" alt=""
                        class="position-absolute validator-img-label hidden-desc-mobile z-20">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744113280592-Ep3cl-Star.svg" alt=""
                        class="position-absolute validator-img-label hidden-desc-tablet z-20">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744097566339-cktm9-Vect.svg" alt=""
                        class="position-absolute validator-img-arr hidden-tablet-mobile z-20">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744100437169-P4Osp-Vect.png" alt=""
                        class="position-absolute validator-img-arr hidden-desc-mobile z-20">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744102862655-sPv1w-Vect.svg" alt=""
                        class="position-absolute validator-img-arr hidden-desc-tablet z-20">
                </div>
            </div>`
    });
    
    blockManager.add('careerum-validator-items', {
        label: 'Validator items (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-validator-items main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <div class="validator-item img-left careerum-flex-sbst">
                        <div class="validator-item-img position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1750665459173-edR9E-Fram.png"
                                class="hidden-tablet-mobile position-absolute" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1750673070056-iMfAK-Fram.png"
                                class="hidden-desc-mobile position-absolute" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1750675352838-PHFEJ-Fram.png"
                                class="hidden-desc-tablet" alt="img">
                        </div>
                        <div class="validator-item-text">
                            <div class="validator-item-label">
                                <p>01</p>
                            </div>
                            <p class="validator-item-header">Проанализирует резюме и поможет исправить ошибки</p>
                            <ul>
                                <li>Структура, формулировки, грамотность</li>
                                <li>Активные глаголы, стиль изложения</li>
                                <li>Оцифрованные результаты</li>
                                <li>Качество презентации вашего опыта</li>
                            </ul>
                        </div>
                    </div>
                    <div class="validator-item img-right careerum-flex-sbst">
                        <div class="validator-item-text">
                            <div class="validator-item-label">
                                <p>02</p>
                            </div>
                            <p class="validator-item-header">Проведёт скрининг резюме под вакансии</p>
                            <ul>
                                <li>Загружайте описание выбранной вакансии и узнайте % соответствия резюме</li>
                                <li>Посмотрите альтернативные варианты профессий для вашего резюме</li>
                                <li>Узнайте возможные вопросы рекрутера на собеседовании</li>
                                <li>Получите шаблон сопроводительного письма для конкретной вакансии</li>
                            </ul>
                        </div>
                        <div class="validator-item-img position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1750665461825-SuP0j-Fram.png"
                                class="hidden-tablet-mobile position-absolute" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1750673067598-aDzmz-Fram.png"
                                class="hidden-desc-mobile position-absolute" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1750675353422-0zlbQ-Fram.png"
                                class="hidden-desc-tablet" alt="img">
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-career-main', {
        label: 'Career main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-career-main main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <div class="validator-main-header careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743431141861-x9NS1-Grou.svg" alt=""
                            class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743431152141-J2lCN-Head.svg" alt=""
                            class="hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743431162612-Cw8O8-Grou.svg" alt=""
                            class="hidden-desc-tablet">
                    </div>
                    <h1 class="position-relative z-10">Вы застряли в карьере<br> и <span class="left-before">не знаете,</span><span class="right-before">что дальше?</span></h1>
                    <p>Пройдите тест и узнайте:</p>
                    <div class="position-relative career-main-cards">
                        <div class="position-absolute z-20">Почему вы топчетесь на месте?</div>
                        <div class="position-absolute z-20">На какой стадии карьерного развития вы находитесь прямо сейчас?</div>
                        <div class="position-absolute z-20">Что делать, чтобы двигаться дальше без выгорания и хаоса?</div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744368150786-bPWPM-Vect.svg" alt="" class="position-relative z-10 hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744368736468-kJSRX-Vect.svg" alt="" class="position-relative z-10 hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744369159876-8mUn1-Vect.svg" alt="" class="position-relative z-10 hidden-desc-tablet">
                    </div>
                    <div class="career-main-form position-relative z-30">
                        <div class="careerum-registration-form-club40 no-checkbox">
                            <form class="deva-form getcourse-email-signup careerum-flex-sbfs" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                                <div class="careerum-club40-form-button-agree">
                                    <a href="#" class="submit-btn btn-color-main-bright-orange" disabled>Пройти тест</a>
                                    <div class="careerum-club40-form-agree">
                                        <label>
                                            <input type="checkbox" name="agree" checked="checked">
                                            <div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                    fill="none">
                                                    <path
                                                        d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                        stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </label>
                                        <p>Нажимая на кнопку, я даю согласие на обработку своих персональных данных
                                            в соответствии с <a href="https://careerum.com/ru-ru/legal/privacy"
                                                target="_blank">Политикой конфиденциальности</a></p>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="career-main-bottom position-relative z-20">
                        <p class="career-main-bottom-header">Результат теста</p>
                        <p class="career-main-bottom-text hidden-tablet-mobile">Видеоразбор <span>Ольги Лермонтовой</span><br> с интерпретацией вашего результата</p>
                        <p class="career-main-bottom-text hidden-desc">Видеоразбор от <span>Ольги Лермонтовой</span><br> с интерпретацией вашего результата</p>
                        <p class="career-main-bottom-author">Карьерный стратег<br> и основательница Careerum</p>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-veb41-main', {
        label: 'Veb41 main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-veb41-main veb41-switch-currency main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="position-relative">
                        <div class="veb41-main-label">
                            <p>Курс</p>
                        </div>
                        <div class="veb41-main-bg position-relative z-10">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745238712400-Xc9Sp-Grou.svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745247226100-0QCs3-Grou.svg"
                                alt="" class="position-absolute hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745250075182-yG5G4-Vect.svg"
                                alt="" class="position-absolute hidden-desc-tablet">
                        </div>
                        <h1 class="position-relative z-20">Продающее резюме</h1>
                        <p class="veb41-main-subheader position-relative z-20">Напишите резюме, которое привлечет рекрутеров</p>
                        <div class="veb41-main-banner careerum-flex-sbc">
                            <div class="veb41-price-wrapper careerum-flex-sbc" data-price-rub="4 900 ₽" data-price-eur="49 €"
                                data-price-rub-old="4 900 ₽" data-price-eur-old="149 €₽" data-link-rub="#popup-rub"
                                data-link-eur="#popup-eur">
                                <div class="careerum-flex-fsc">
                                    <p class="veb41-price-text-full">Специальное предложение от Careerum </p>
                                    <p class="veb41-price-new hidden-desc-tablet">4 900 ₽</p>
                                    <p class="veb41-price-old">14900 ₽</p>
                                    <p class="veb41-price-new hidden-mobile">4 900 ₽</p>
                                    <p class="veb41-price-percent">— 70%</p>
                                </div>
                                <a href="#popup" class="btn-color-main-dark-orange veb41-price-link">Купить курс</a>
                            </div>
                        </div>
                    </div>
                    <div class="veb41-main-tales">
                        <h3>Программа курса</h3>
                        <div class="veb41-main-tale">
                            <div class="veb41-main-tale-label careerum-flex-fsc">
                                <p>Блок 1</p>
                                <p>1 урок</p>
                            </div>
                            <div class="careerum-flex-fsfs">
                                <h4>Эффективная основа любого резюме</h4>
                                <p>Изучите главные принципы написания резюме, выберете подходящий для своей цели формат и
                                    сделаете рабочую заготовку для своего резюме</p>
                            </div>
                        </div>
                        <div class="veb41-main-tale">
                            <div class="veb41-main-tale-label careerum-flex-fsc">
                                <p>Блок 2</p>
                                <p>3 урока</p>
                            </div>
                            <div class="careerum-flex-fsfs">
                                <h4>«Почему мы должны взять именно вас?»</h4>
                                <p>Найдете достижения в своем рабочем опыте, даже если вам кажется, что их нет, и научитесь
                                    грамотно преподносить их работодателю</p>
                            </div>
                        </div>
                        <div class="veb41-main-tale">
                            <div class="veb41-main-tale-label careerum-flex-fsc">
                                <p>Блок 3</p>
                                <p>3 урока</p>
                            </div>
                            <div class="careerum-flex-fsfs">
                                <h4>Как «докрутить» резюме до уровня топ-компаний</h4>
                                <p>Добавите в резюме ключевые элементы, на которые смотрят рекрутеры и нанимающие менеджеры
                                    международных топ-компаний </p>
                            </div>
                        </div>
                        <div class="veb41-main-tale">
                            <div class="veb41-main-tale-label careerum-flex-fsc">
                                <p>Блок 4</p>
                                <p>1 урок</p>
                            </div>
                            <div class="careerum-flex-fsfs">
                                <h4>Главный лайфхак для получения откликов</h4>
                                <p>Научитесь адаптировать резюме под разные вакансии, чтобы привлекать внимание конкретных
                                    работодателей на международном рынке</p>
                            </div>
                        </div>
                        <div class="veb41-price-wrapper" data-price-rub="4 900 ₽" data-price-eur="49 €"
                            data-price-rub-old="4 900 ₽" data-price-eur-old="149 €₽" data-link-rub="#popup-rub"
                            data-link-eur="#popup-eur">
                            <div class="veb41-tariffs-curr-wrapper position-relative z-20">
                                <div class="veb41-tariffs-curr careerum-flex-fsst">
                                    <ul class="careerum-flex-fsfs">
                                        <li data-currency="eur">EUR</li>
                                        <li data-currency="rub" class="active">RUB</li>
                                    </ul>
                                    <div class="veb41-tariffs-notif careerum-flex-cc">
                                        <div class="veb41-tariffs-notif-icon">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                                alt="">
                                        </div>
                                        <div class="veb41-tariffs-notif-content">
                                            <p>Оплата в российских рублях возможна только
                                                картой российского банка. В&nbsp;евро — картой
                                                зарубежного банка</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="veb41-tariffs__swicher-block">
                                    <div class="veb41-tariffs__swicher-top">
                                        <p class="veb41-tariffs__swicher-header">
                                            Посмотреть цены в
                                            <span>EUR</span>
                                        </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                            fill="none" class="veb41-tariffs__swicher-arrow">
                                            <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black"></path>
                                        </svg>
                                    </div>
                                    <div class="veb41-tariffs__swicher-bottom">
                                        <ul>
                                            <li data-currency="rub" class="active">
                                                RUB
                                            </li>
                                            <li data-currency="eur">
                                                EUR
                                            </li>
                                        </ul>
                                        <p>
                                            Обратите внимание,<br> что оплата в российских
                                            рублях
                                            возможна только<br> с карты
                                            российского банка. Оплата в евро — с карты зарубежного банка
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="careerum-flex-fsc position-relative z-10">
                                <p class="veb41-price-new">4 900 ₽</p>
                                <p class="veb41-price-old">14900 ₽</p>
                                <p class="veb41-price-percent">— 70%</p>
                            </div>
                            <a href="#popup" class="veb41-price-link btn-color-main-dark-orange">Купить курс</a>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-veb41-tariff', {
        label: 'Veb41 tariff (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-veb41-tariff veb41-switch-currency main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="veb41-tariff-bg position-relative z-10">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745244826752-BwANH-Vect.svg" alt="" class="position-absolute hidden-tablet-mobile veb41-tariff-bg-1">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745244835999-Wwfan-Vect.svg" alt="" class="position-absolute hidden-tablet-mobile veb41-tariff-bg-2">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745249275880-3iuL4-Vect.svg" alt="" class="position-absolute hidden-desc-mobile veb41-tariff-bg-1">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745249275633-hzIgF-Vect.svg" alt="" class="position-absolute hidden-desc-mobile veb41-tariff-bg-2">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745252825715-LfJxB-Vect.svg" alt="" class="position-absolute hidden-desc-tablet veb41-tariff-bg-1">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745252786776-vFRqt-Vect.svg" alt="" class="position-absolute hidden-desc-tablet veb41-tariff-bg-2">
                    </div>
                    <h2 class="position-relative z-20">Сделайте продающее резюме и начните получать офферы</h2>
                    <div class="veb41-price-wrapper position-relative z-20" data-price-rub="4 900 ₽" data-price-eur="49 €"
                        data-price-rub-old="4 900 ₽" data-price-eur-old="149 €₽" data-link-rub="#popup-rub"
                        data-link-eur="#popup-eur">
                        <div class="veb41-tariffs-curr-wrapper">
                            <div class="veb41-tariffs-curr careerum-flex-fsst">
                                <ul class="careerum-flex-fsfs">
                                    <li data-currency="eur">EUR</li>
                                    <li data-currency="rub" class="active">RUB</li>
                                </ul>
                                <div class="veb41-tariffs-notif careerum-flex-cc">
                                    <div class="veb41-tariffs-notif-icon">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                            alt="">
                                    </div>
                                    <div class="veb41-tariffs-notif-content">
                                        <p>Оплата в российских рублях возможна только
                                            картой российского банка. В&nbsp;евро — картой
                                            зарубежного банка</p>
                                    </div>
                                </div>
                            </div>
                            <div class="veb41-tariffs__swicher-block">
                                <div class="veb41-tariffs__swicher-top">
                                    <p class="veb41-tariffs__swicher-header">
                                        Посмотреть цены в
                                        <span>EUR</span>
                                    </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" class="veb41-tariffs__swicher-arrow">
                                        <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black"></path>
                                    </svg>
                                </div>
                                <div class="veb41-tariffs__swicher-bottom">
                                    <ul>
                                        <li data-currency="rub" class="active">
                                            RUB
                                        </li>
                                        <li data-currency="eur">
                                            EUR
                                        </li>
                                    </ul>
                                    <p>
                                        Обратите внимание,<br> что оплата в российских
                                        рублях
                                        возможна только<br> с карты
                                        российского банка. Оплата в евро — с карты зарубежного банка
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="veb41-tariff-item position-relative z-10">
                        <p class="veb41-tariff-item-label">Курс</p>
                        <p class="veb41-tariff-item-header">Продающее резюме</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745245592688-dvHL4-1231.png" alt="" class="position-absolute hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745249210676-VQZLO-1312.png" alt="" class="position-absolute hidden-desc-mobile">
                        <div class="veb41-price-wrapper" data-price-rub="4 900 ₽" data-price-eur="49 €"
                            data-price-rub-old="4 900 ₽" data-price-eur-old="149 €₽" data-link-rub="#popup-rub"
                            data-link-eur="#popup-eur">
                            <div class="careerum-flex-fsc">
                                <p class="veb41-price-old">14900 ₽</p>
                                <p class="veb41-price-new">4 900 ₽</p>
                                <p class="veb41-price-percent">— 70%</p>
                            </div>
                            <a href="#popup" class="veb41-price-link btn-color-main-dark-orange">Купить курс</a>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('veb41-clients', {
        label: 'Veb41 clients (desk)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club40-clients club40-clients2 veb41-clients">
            <div class="careerum-container-desc">
                <h2 class="careerum-club40-header">Наши клиенты построили карьеру<br>в ведущих компаниях России и мира</h2>
                <div class="club40-clients-companies careerum-flex-fsfs">
                <div id="iflg1sq"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733997935945-pRsk5-Gazp.png" alt="" id="igom653">
                </div>
                <div id="i7t2yop"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734000524286-GhvMA-imag.png" alt="" id="icsxnl1">
                </div>
                <div id="izofubr"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998010983-4H13U-imag.png" alt="" id="i6sra6m">
                </div>
                <div id="iubfwrm"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998010852-FZDYu-VK_C.png" alt="" id="i3ws6q5">
                </div>
                <div id="ilp2w8l"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998010724-DRrf8-Lamo.png" alt="" id="i50pc0b">
                </div>
                <div id="isw37ap"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998191715-03aQG-Alfa.png" alt="" id="i1x4iby">
                </div>
                <div id="ij8f701"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998010482-1zKS3-Sber.png" alt="" id="ihrfbot">
                </div>
                <div id="ie7l51i"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998010356-oipyy-X5Gr.png" alt="" id="i5tqdvn">
                </div>
                <div id="igzu3gl"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998150711-gEF3e-logo.png" alt="" id="ipm64qc">
                </div>
                <div id="i1zjsnf"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998010109-DvTGc-Neto.png" alt="" id="i6k4oca">
                </div>
                <div id="irevgtg"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115331287-VGekQ-Avit.svg" alt="" id="i2vx3tg">
                </div>
                <div id="i02d061"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734000570618-3sjNX-imag.png" alt="" id="i2ahii2">
                </div>
                <div id="i0tg9c2"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998087474-jkGQ9-DBYi.png" alt="" id="iv6mr9h">
                </div>
                <div id="i10nazi"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998009603-ShNAu-bbdo.png" alt="" id="ifngeem">
                </div>
                <div id="ic3id8w"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115332287-n7a8A-Lero.svg" alt=""></div>
                <div id="izt4f1u"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998219423-4GYRw-RZD..png" alt="" id="ix82v0u">
                </div>
                <div id="i8jlrvc"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998318184-XhnMf-logo.png" alt="" id="iukwkm1">
                </div>
                <div id="igws8yr"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998318410-yVrIo-Shel.png" alt="" id="icsvnay">
                </div>
                <div id="irmi2u2"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998316931-o8CvP-DANO.png" alt="" id="ikp4qyk">
                </div>
                <div id="i12tkbr"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998318515-wik2H-Vect.png" alt="" id="iewqpzw">
                </div>
                <div id="isl8uxk"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998316810-7mi3l-6376.png" alt="" id="ix5r4kl">
                </div>
                <div id="ioeoa8f"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998317480-u6vHu-imag.png" alt="" id="idq0xoj">
                </div>
                <div id="iw31o9m"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998316506-WhkWJ-178-.png" alt="" id="itswtoz">
                </div>
                <div id="ifuml37"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998317274-CCA2J-Ikea.png" alt="" id="iukc5f7">
                </div>
                <div id="i2qh7uq"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998317589-jlP68-imag.png" alt="" id="ia7604b">
                </div>
                <div id="ijcf1ic"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998317044-f3Tq2-Delo.png" alt="" id="ioiru5h">
                </div>
                <div><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115122363-xyHbj-Tesl.svg" alt=""></div>
                <div><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115331031-myt4l-Amaz.svg" alt=""></div>
                <div><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115330585-9MSlm-2560.svg" alt=""></div>
                <div><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115333262-UAImR-Spot.svg" alt=""></div>
                <div><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115332401-FkZ64-Micr.svg" alt=""></div>
                <div id="ibe4ah5"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115333370-HJSp7-Yand.svg" alt=""></div>
                <div id="i6071pf"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115331911-hjvbp-Goog.svg" alt=""></div>
                <div id="iru583i"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115333142-EdGAC-Sony.svg" alt=""></div>
                <div id="iq1yp8g"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723472436347-BtDwx-Sky_L.webp" alt=""
                    id="i00r9l4"></div>
                <div id="i4tu0r5"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115331526-uL5Yd-Disn.svg" alt=""></div>
                <div id="inli5qg"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115332027-6Ren2-Inte.svg" alt=""></div>
                <div id="iyhp4q9"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115330911-6pK57-Airb.svg" alt=""></div>
                <div id="irmxszr"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998317379-5tPTc-imag.png" alt="" id="inafnei">
                </div>
                <div id="if12k2m"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998318296-Wv7Be-Sams.png" alt="" id="irizsik">
                </div>
                <div id="ihwjpgk"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998317695-YYb38-imag.png" alt="" id="is6t0bo">
                </div>
                <div id="ir851as"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998317815-jPM0S-imag.png" alt="" id="im010ph">
                </div>
                <div id="i2zuawp"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998321549-g85s9-logo.png" alt="" id="i5nqdlm">
                </div>
                <div id="iwolu0q"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998317156-axFBH-HubS.png" alt="" id="ioh9rgp">
                </div>
                <div id="itamg6b"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998317952-Ie5JQ-imag.png" alt="" id="i1jguqm">
                </div>
                <div><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115332515-khZye-Phil.svg" alt=""></div>
                <div><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115332145-gqB7m-John.svg" alt=""></div>
                <div id="iawbug3"><img
                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998318068-ytLpg-KPMG.png" alt="" id="i4rcqm5">
                </div>
                <div id="in1rtkg">
                    <p id="in1gzij">5 000+ кейсов</p>
                </div>
                </div>
            </div>
            </div>`
    });
    
    blockManager.add('veb41-clients-tablet', {
        label: 'Veb41 clients (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club40-clients-tablet club40-clients2 veb41-clients-tablet">
            <div class="careerum-container-tablet">
                <h2 class="careerum-club40-header-tablet">Наши клиенты построили карьеру<br>в ведущих компаниях России и мира</h2>
                <div class="club40-clients-companies careerum-flex-fsfs">
                <div id="ihmhwpl"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734000524286-GhvMA-imag.png"
                    alt="" id="ikzfkui">
                </div>
                <div id="iy3itv6"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998010983-4H13U-imag.png"
                    alt="" id="i9v950l">
                </div>
                <div id="iwzw51c"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998010724-DRrf8-Lamo.png"
                    alt="" id="iazhmot">
                </div>
                <div id="iqy23n5"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998191715-03aQG-Alfa.png"
                    alt="" id="ihjvb69">
                </div>
                <div id="ibnu4fo"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998010482-1zKS3-Sber.png"
                    alt="" id="iugpf1b">
                </div>
                <div id="ilkqlsf"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998010356-oipyy-X5Gr.png"
                    alt="" id="iitl62p">
                </div>
                <div id="ikl9kyn"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998150711-gEF3e-logo.png"
                    alt="" id="ipos2bj">
                </div>
                <div id="ifczbzl"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998010109-DvTGc-Neto.png"
                    alt="" id="i1dry22">
                </div>
                <div id="ipfqi3i"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115331287-VGekQ-Avit.svg"
                    alt="" id="i5ktb4l">
                </div>
                <div id="i9p1iqg"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734000570618-3sjNX-imag.png"
                    alt="" id="idqbmq4">
                </div>
                <div id="iv4lkxi"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998087474-jkGQ9-DBYi.png"
                    alt="" id="ik713jw">
                </div>
                <div id="itopw7j"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998009603-ShNAu-bbdo.png"
                    alt="" id="i12sh74">
                </div>
                <div id="ijhwap4"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115332287-n7a8A-Lero.svg"
                    alt="" id="in0y85i">
                </div>
                <div id="ihsnazu"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998219423-4GYRw-RZD..png"
                    alt="" id="iwazkv5">
                </div>
                <div id="ilw5f01"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998318184-XhnMf-logo.png"
                    alt="" id="i0wre4l">
                </div>
                <div id="iadpat2"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998318410-yVrIo-Shel.png"
                    alt="" id="ioaivas">
                </div>
                <div id="iblu9hd"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998316931-o8CvP-DANO.png"
                    alt="" id="ic16tvr">
                </div>
                <div id="ibiip4m"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998318515-wik2H-Vect.png"
                    alt="" id="iotj288">
                </div>
                <div id="ir88tox"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998316810-7mi3l-6376.png"
                    alt="" id="i2alk0w">
                </div>
                <div id="ijl0apf"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998317480-u6vHu-imag.png"
                    alt="" id="iyd5rqn">
                </div>
                <div id="imxhw7m"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998317274-CCA2J-Ikea.png"
                    alt="" id="iw8sc18">
                </div>
                <div id="ijpzwsi"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998317589-jlP68-imag.png"
                    alt="" id="itxb8eh">
                </div>
                <div id="i70vg7k"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998317044-f3Tq2-Delo.png"
                    alt="" id="i9w2sw3">
                </div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115122363-xyHbj-Tesl.svg" alt=""
                    id="ifkocfz">
                </div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115331031-myt4l-Amaz.svg" alt=""
                    id="iscglxj">
                </div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115330585-9MSlm-2560.svg" alt=""
                    id="ier1pgq">
                </div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115333262-UAImR-Spot.svg" alt=""
                    id="i7xf41b">
                </div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115332401-FkZ64-Micr.svg" alt=""
                    id="iibilo7">
                </div>
                <div id="ikep00r"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115333370-HJSp7-Yand.svg"
                    alt="" id="i4h3yhr">
                </div>
                <div id="ijtvt24"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115331911-hjvbp-Goog.svg"
                    alt="" id="imfd1yi">
                </div>
                <div id="i5cv0ej"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115333142-EdGAC-Sony.svg"
                    alt="" id="i90i27o">
                </div>
                <div id="ice4n86"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723472436347-BtDwx-Sky_L.webp"
                    alt="" id="ic47797"></div>
                <div id="ivw2fkl"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115331526-uL5Yd-Disn.svg"
                    alt="" id="imab6cx">
                </div>
                <div id="ibk4kvg"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115332027-6Ren2-Inte.svg"
                    alt="" id="ih3ovrq">
                </div>
                <div id="ioxnywj"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115330911-6pK57-Airb.svg"
                    alt="" id="ivokb8z">
                </div>
                <div id="imieisi"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998317379-5tPTc-imag.png"
                    alt="" id="icv00uy">
                </div>
                <div id="ior6nu3"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998318296-Wv7Be-Sams.png"
                    alt="" id="i7xxdtv">
                </div>
                <div id="icejm5q"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998317695-YYb38-imag.png"
                    alt="" id="idsa5ki">
                </div>
                <div id="irhvjpu"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998317815-jPM0S-imag.png"
                    alt="" id="i4mx2zx">
                </div>
                <div id="iwgsqii"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998321549-g85s9-logo.png"
                    alt="" id="i6zrl1l">
                </div>
                <div id="izrc2el"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998317156-axFBH-HubS.png"
                    alt="" id="i64rpyp">
                </div>
                <div id="ivcojcj"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998317952-Ie5JQ-imag.png"
                    alt="" id="i2edur2">
                </div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115332515-khZye-Phil.svg" alt=""
                    id="ikhjp5w">
                </div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115332145-gqB7m-John.svg" alt=""
                    id="iwdqdni">
                </div>
                <div id="ids35of"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733998318068-ytLpg-KPMG.png"
                    alt="" id="ioni6el">
                </div>
                <div id="ij27ifz">
                    <p id="igvtyai">5 000+ кейсов</p>
                </div>
                </div>
            </div>
            </div>`
    });

    
    blockManager.add('veb41-clients-mobile', {
        label: 'Veb41 clients (mob)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club40-clients-mobile club40-clients2 veb41-clients-mobile">
                <div class="careerum-container-mobile">
                <h2 class="careerum-club40-header-mobile">Наши клиенты построили карьеру в
                    ведущих компаниях России и мира</h2>
                <div class="club40-clients-companies careerum-flex-fsfs">
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544686294-cXWs4-Vect.svg" alt="">
                    </div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544685487-4vULq-Micr.svg" alt="">
                    </div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544684088-HJKiJ-Amaz.svg" alt=""
                        id="ijc6tq8"></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544685276-ErtgD-John.svg" alt=""
                        id="iitwncy"></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544684694-z20V7-g10..svg" alt="">
                    </div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544686048-B1Bzn-Spot.svg" alt="">
                    </div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723472436347-BtDwx-Sky_L.webp"
                        width="46px" alt=""></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544684875-Kh6BE-Goog.svg" alt=""
                        id="iqcx5rq"></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544685014-IhhTc-Grou.svg" alt="">
                    </div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544685624-XDgU1-path.svg" alt="">
                    </div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544685896-mDyZM-Puma.svg" alt="">
                    </div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544684504-0d0Ri-Avit.svg" alt="">
                    </div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544686180-aw0aC-Vect.svg" alt=""
                        id="ihgrleg"></div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544685145-EgMYR-Inte.svg" alt="">
                    </div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544685756-brX6G-Phil.svg" alt="">
                    </div>
                    <div>
                    <p id="if3pcrj">5 000+ кейсов</p>
                    </div>
                </div>
                </div>
            </div>`
    });

    blockManager.add('careerum-club40-popup-pay-tales', {
        label: 'Veb popup 2 col (mob)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-popup careerum-club40-popup-pay-tales" id="">
                <div class="popup__close-button-wrapper careerum-flex-cc close-switch">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"
                        class="close-switch">
                        <g clip-path="url(#clip0_10262_11319)">
                            <path d="M10.7979 10.6359L1.20586 1.08301" stroke="white" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M1.19976 10.639L10.8018 1.07812" stroke="white" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="clip0_10262_11319">
                                <rect width="12" height="12" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <div class="club40-popup-pay-content">
                    <div class="careerum-flex-sbst">
                        <div class="club40-popup-pay-content-left position-relative">
                            <div class="popup-tales-top position-relative z-20">
                                <p class="popup-tales-header">Только этот курс:
                                    Продающее резюме</p>
                                <div class="careerum-flex-fsc popup-tales-access">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745258248121-v4nS1-Lock.svg"
                                        alt="" class="hidden-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745258259579-YhYWm-Lock.svg"
                                        alt="" class="hidden-desc-tablet">
                                    <p>Доступ на 30 дней</p>
                                </div>
                                <div class="careerum-flex-fsc popup-tales-pay">
                                    <p class="popup-tales-pay-price">4 900 ₽</p>
                                    <p class="popup-tales-pay-old-price">14 900₽</p>
                                    <p class="popup-tales-pay-percent">— 70%</p>
                                    <a href="#popup1" class="btn-color-main-dark-orange close-switch">Купить</a>
                                </div>
                            </div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745258474590-L0eVK-Grou.svg"
                                alt="" class="hidden-tablet-mobile position-absolute z-10">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745258510640-H5516-Grou.svg"
                                alt="" class="hidden-desc-mobile position-absolute z-10">
                        </div>
                        <div class="club40-popup-pay-content-right">
                            <div class="popup-tales-top">
                                <p class="popup-tales-header">Подписка Careerum
                                    на 80 курсов</p>
                                <div class="careerum-flex-fsc popup-tales-access">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745258248121-v4nS1-Lock.svg"
                                        alt="" class="hidden-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745258259579-YhYWm-Lock.svg"
                                        alt="" class="hidden-desc-tablet">
                                    <p>Доступ на 30 дней</p>
                                </div>
                                <div class="careerum-flex-fsc popup-tales-pay">
                                    <p class="popup-tales-pay-price">8 900 ₽</p>
                                    <p class="popup-tales-pay-old-price">12 900₽</p>
                                    <p class="popup-tales-pay-percent">— 30%</p>
                                    <a href="#popup2" class="btn-color-main-dark-orange close-switch">Купить</a>
                                </div>
                            </div>
                            <div class="popup-tales-bottom">
                                <p class="popup-tales-bottom-header">Вот, что вы получите
                                    по поиску работы:</p>
                                <ul>
                                    <li>Курс: Продающее резюме</li>
                                    <li>Курс: Умная стратегия поиска работы</li>
                                    <li>Курс: Как продавать себя</li>
                                    <li>Курс: Как написать цепляющее сопроводительное письмо</li>
                                    <li>Курс: LinkedIn Pro: как стать звездой для рекрутеров</li>
                                    <li>Курс: Эффективное интервью</li>
                                    <li>Курс: Как получить оффер мечты</li>
                                    <li>Курс: Международная карьера и релокация</li>
                                    <li>150 платформ для поиска работы в 15 странах</li>
                                    <li>Трекер откликов на вакансии, чтобы всегда знать, что куда отправили</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-course41-main', {
        label: 'Self-esteem main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-course41-main main-wrapper">
                <div class="careerum-container-responsive careerum-flex-sbst">
                    <div class="course41-main-left">
                        <div class="course41-main-label careerum-flex-fsfs">
                            <div class="course41-main-label__item_pink careerum-flex-fsc">В подписке Careerum</div>
                            <div class="careerum-flex-fsc course41-main-label__item">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745952459306-dyXjH-Cale.svg"
                                    alt="" class="hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746028100443-9Mp5j-Cale.svg"
                                    alt="" class="hidden-desc-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746096673546-AU0nG-Cale.svg"
                                    alt="" class="hidden-desc-tablet">
                                <p>27 мая – 5 августа</p>
                            </div>
                        </div>
                        <h1>Само<span>О</span>ценка</h1>
                        <p>Готовы больше не сомневаться в себе и зарабатывать на уровень выше?</p>
                        <div class="course41-main-text-block">
                            <p>Курс для профессионалок, которые ощущают себя неуверенно в карьере, несмотря на весь опыт и
                                предыдущие результаты</p>
                        </div>
                        <a href="#program" class="btn-color-main-dark-orange">Посмотреть программу</a>
                    </div>
                    <div class="course41-main-right">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745952173477-2A1cN-Image.webp" alt=""
                            class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746028410657-o3WGc-Image.webp" alt=""
                            class="hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746096825780-YaCap-Group.webp" alt=""
                            class="hidden-desc-tablet">
                        <a href="#program" class="btn-color-main-dark-orange">Посмотреть программу</a>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-course41-about-you', {
        label: 'Self-esteem about-you (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-course41-about-you main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <h2 class="position-relative z-20">Это признак слабой профессиональной самооценки, если ты себя чувствуешь
                        вот так</h2>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745952609757-C4S98-Grou.svg" alt=""
                        class="position-absolute z-10 hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746028560459-Ig6nC-Grou.svg" alt=""
                        class="position-absolute z-10 hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746097034206-rxWpy-Grou.svg" alt=""
                        class="position-absolute z-10 hidden-desc-tablet">
                    <div class="course41-about-you-items">
                        <div class="course41-about-you-item_left careerum-flex-fsfs">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745954109424-wsEqv-Group.webp"
                                    alt="" class="hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746028852723-c11mH-Group.webp"
                                    alt="" class="hidden-desc-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746097311507-NUxpI-Group.webp"
                                    alt="" class="hidden-desc-tablet">
                            </div>
                            <div>
                                <p>Обычно я спокойно говорю о деньгах. Но как только начинается давление — я сдаюсь. Сомневаюсь,
                                    теряю голос, позволяю продавить себя.</p>
                            </div>
                        </div>
                        <div class="course41-about-you-item_right careerum-flex-fefs">
                            <div>
                                <p>А вдруг я просто случайно оказалась здесь и мне повезло? У других всё серьёзнее, масштабнее.
                                    А мне, наверное, рано говорить о себе всерьёз, даже если у меня крутой опыт.</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745954352128-6tv9o-Group.webp"
                                    alt="" class="hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746028852267-PCroQ-Group.webp"
                                    alt="" class="hidden-desc-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746097309512-Ex1hi-Group.webp"
                                    alt="" class="hidden-desc-tablet">
                            </div>
                        </div>
                        <div class="course41-about-you-item_left careerum-flex-fsfs">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745954353899-oQ4Gi-Group.webp"
                                    alt="" class="hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746028853466-WIqqr-Group.webp"
                                    alt="" class="hidden-desc-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746097309792-EAqRH-Group.webp"
                                    alt="" class="hidden-desc-tablet">
                            </div>
                            <div>
                                <p>Как только я думаю озвучить цену выше — мне сразу становится страшно: «А вдруг подумают, что
                                    я наглая или хочу слишком много?»</p>
                            </div>
                        </div>
                        <div class="course41-about-you-item_right careerum-flex-fefs">
                            <div>
                                <p>Мне сложно выносить критику руководителя. Мне обидно, и я не могу с этим справиться сама.</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745954352325-iXpf1-Group.webp"
                                    alt="" class="hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746028853109-WxrSK-Group.webp"
                                    alt="" class="hidden-desc-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746097310815-9qfBb-Group.webp"
                                    alt="" class="hidden-desc-tablet">
                            </div>
                        </div>
                        <div class="course41-about-you-item_left careerum-flex-fsfs">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745954351843-hVat9-Group.webp"
                                    alt="" class="hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746028852987-2vLma-Group.webp"
                                    alt="" class="hidden-desc-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746097310057-25dd7-Group.webp"
                                    alt="" class="hidden-desc-tablet">
                            </div>
                            <div>
                                <p>Ставлю себе нереалистичные цели, а потом ругаю себя за то, что не справилась. Чувствую, что
                                    делаю недостаточно</p>
                            </div>
                        </div>
                        <div class="course41-about-you-item_right careerum-flex-fefs">
                            <div>
                                <p>Когда меня не хвалят и не отмечают мою работу,я начинаю думать:<br> Может, я вообще ничего не
                                    стою?</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745954353220-AbWFt-Group.webp"
                                    alt="" class="hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746028852862-ThUHz-Group.webp"
                                    alt="" class="hidden-desc-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746097309312-fUMrh-Group.webp"
                                    alt="" class="hidden-desc-tablet">
                            </div>
                        </div>
                        <div class="course41-about-you-item_left careerum-flex-fsfs">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745954352969-IlnNt-Group.webp"
                                    alt="" class="hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746028853342-WQQny-Group.webp"
                                    alt="" class="hidden-desc-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746097308969-ZS13g-Group.webp"
                                    alt="" class="hidden-desc-tablet">
                            </div>
                            <div>
                                <p>Мне больно обесценивать свой труд.Но я так не уверена в себе, что убеждаю сама себя, что
                                    деньги не главное</p>
                            </div>
                        </div>
                        <div class="course41-about-you-item_right careerum-flex-fefs">
                            <div>
                                <p>Мне важнее услышать «ты молодец» от кого-то другого, чем сказать это себе самой. Себе я не
                                    верю.</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745954353466-UaWaK-Group.webp"
                                    alt="" class="hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746028853720-AiehJ-Group.webp"
                                    alt="" class="hidden-desc-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746097309927-NduGE-Group.webp"
                                    alt="" class="hidden-desc-tablet">
                            </div>
                        </div>
                        <div class="course41-about-you-item_left careerum-flex-fsfs">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745954352559-3auVb-Group.webp"
                                    alt="" class="hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746028853217-SB7YT-Group.webp"
                                    alt="" class="hidden-desc-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746097311336-xFE2d-Group.webp"
                                    alt="" class="hidden-desc-tablet">
                            </div>
                            <div>
                                <p>Когда мне отказывают, я не думаю, что это про проект или цену. Я сразу думаю: «Со мной что-то
                                    не так», это я «плохая»</p>
                            </div>
                        </div>
                        <div class="course41-about-you-item_right careerum-flex-fefs">
                            <div>
                                <p>Если мне что-то даётся легко и в кайф, мне почему-то кажется, что это не имеет ценности. Как
                                    будто деньги можно просить только за трудные задачи.</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745954352451-A7fT5-Group.webp"
                                    alt="" class="hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746028853592-HlhcH-Group.webp"
                                    alt="" class="hidden-desc-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746097310549-yNa83-Group.webp"
                                    alt="" class="hidden-desc-tablet">
                            </div>
                        </div>
                        <div class="course41-about-you-item_left careerum-flex-fsfs">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745954353703-AhetJ-Group.webp"
                                    alt="" class="hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746028852593-f9cWx-Group.webp"
                                    alt="" class="hidden-desc-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746097309669-EvwkL-Group.webp"
                                    alt="" class="hidden-desc-tablet">
                            </div>
                            <div>
                                <p>Вроде всё хорошо — опыт, доход, стабильность. Но внутри всё равно сидит страх: «А вдруг всё
                                    закончится в один момент?» Мне очень страшно всё потерять.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-course41-statistic', {
        label: 'Self-esteem statistic (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-course41-statistic main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <p class="course41-statistic__header position-relative z-20">Женщинам по статистике <span
                    class="orange">сложнее</span> говорить
                о стоимости своих услуг из-за
                страха осуждения. Так что твоя проблема распространена, и <span class="pink">мы знаем, как с ней
                    быть</span></p>
            <p class="course41-statistic__text position-relative z-20">Источник: Harvard Business Review</p>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745991859599-2mbvJ-Grou.svg" alt=""
                class="position-absolute hidden-tablet-mobile z-10">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746030138561-FOBDR-Grou.svg" alt=""
                class="position-absolute hidden-desc-mobile z-10">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746098076647-DM9KA-Grou.svg" alt=""
                class="position-absolute hidden-desc-tablet z-10">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746098222873-lfPaw-Fram.svg" alt=""
                class="hidden-desc-tablet z-10 static">
            <a href="#program" class="btn-color-main-dark-orange position-relative z-20">Посмотреть программу</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-course41-money', {
        label: 'Self-esteem money (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-course41-money main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Тема денег сложная и табуированная</h2>
                    <p>Нас этому с детства не учили, а наоборот, внушали что:</p>
                    <div class="course41-money-wrapper position-relative careerum-flex-fsfs">
                        <p class="position-relative z-20">Деньги не главное</p>
                        <p class="position-relative z-20">Нужно быть доброй и удобной,<br> а не жадной и наглой</p>
                        <p class="position-relative z-20">У нас в семье никогда не было денег</p>
                        <p class="position-relative z-20">Я не такая уж амбициозная</p>
                        <p class="position-relative z-20">Умные женщины не ради денег работают</p>
                        <p class="position-relative z-20"> И это все саботирует карьерный и финансовый рост</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745955358039-AsTmX-Grou.svg" alt=""
                            class="position-absolute hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746084128319-TBWoA-Grou.svg" alt=""
                            class="position-absolute hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746098546536-hAsUL-Grou.svg" alt=""
                            class="position-absolute hidden-desc-tablet z-10">
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-course41-why', {
        label: 'Self-esteem why (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-course41-why main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745955452883-o4fIs-Vect.svg" alt=""
                class="position-absolute hidden-tablet-mobile">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746084462172-UIMpA-Vect.svg" alt=""
                class="position-absolute hidden-desc-mobile">
            <h2>Ты давно в профессии. У тебя за плечами опыт, знания, тысячи решённых задач, но ты все равно:</h2>
            <div class="course41-why-items careerum-flex-sbst">
                <div class="course41-why-item position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745955662340-LXTNb-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746084775956-he8fn-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746099065030-kGUxQ-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-desc-tablet">
                    <div class="position-relative z-20">
                        <p>При каждом новом проекте сомневаешься — «а вдруг не справлюсь?»</p>
                    </div>
                </div>
                <div class="course41-why-item position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745955689164-Ho8Zv-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746084775645-itfdQ-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746099064816-q7fJa-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-desc-tablet">
                    <div class="position-relative z-20">
                        <p>Назначаешь цену — и потом внутренне с ней торгуешься</p>
                    </div>
                </div>
                <div class="course41-why-item position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745955662340-LXTNb-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746084775956-he8fn-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746099064816-q7fJa-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-desc-tablet">
                    <div class="position-relative z-20">
                        <p>Получаешь меньше, чем коллеги-мужчины, часто менее опытные, и знаешь об этом</p>
                    </div>
                </div>
                <div class="course41-why-item position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745955689164-Ho8Zv-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746084775645-itfdQ-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746099065030-kGUxQ-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-desc-tablet">
                    <div class="position-relative z-20">
                        <p>Теряешь голос в переговорах — боишься показаться «наглой»</p>
                    </div>
                </div>
                <div class="course41-why-item position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745955662340-LXTNb-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746084775956-he8fn-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746099065030-kGUxQ-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-desc-tablet">
                    <div class="position-relative z-20">
                        <p>Вкладываешься в других (муж, дети, коллеги, начальник), но не позволяешь себе вкладываться
                            в себя
                        </p>
                    </div>
                </div>
                <div class="course41-why-item position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745955689164-Ho8Zv-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746084775645-itfdQ-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746099064816-q7fJa-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-desc-tablet">
                    <div class="position-relative z-20">
                        <p>Уже почти решила сменить работу, но постоянно тормозишь</p>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-course41-cta', {
        label: 'Self-esteem cta (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-course41-cta main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745992452336-4DBsQ-Grou.svg" alt=""
                class="position-absolute hidden-tablet-mobile z-10">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746085119229-zN9gq-Grou.svg" alt=""
                class="position-absolute hidden-desc-mobile z-10">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746099251037-e8QNr-Grou.svg" alt=""
                class="position-absolute hidden-desc-tablet z-10">
            <p class="position-relative z-20">Давай честно? В глубине — это не про деньги. Это про самооценку.
                Про «а можно ли мне». Пришло время
                <span>РАЗРЕШИТЬ</span> себе выйти на следующий уровень
            </p>
            <a href="#program" class="btn-color-main-dark-orange position-relative z-20">Посмотреть программу</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-course41-after', {
        label: 'Self-esteem after (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-course41-after main-wrapper">
        <div class="careerum-container-responsive">
            <h2>Как может быть у тебя после курса</h2>
            <div class="course41-after-blocks careerum-flex-sbst">
                <div class="course41-after-block wide position-relative">
                    <p>Готовность озвучивать цену</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745956579931-drYYh-Group.webp"
                        alt="" class="position-absolute hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746085641420-gU3pU-Grou.svg"
                        alt="" class="position-absolute hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746099576416-NtDGU-Fram.svg"
                        alt="" class="position-absolute hidden-desc-tablet">
                </div>
                <div class="course41-after-block pink">
                    <p>Способность вести переговоры</p>
                </div>
                <div class="course41-after-block orange">
                    <p>Качество твоих карьерных решений</p>
                </div>
                <div class="course41-after-block pink">
                    <p>Масштаб целей, которые ты ставишь</p>
                </div>
                <div class="course41-after-block orange">
                    <p>Доступ к новым проектам и возможностям</p>
                </div>
                <div class="course41-after-block pink">
                    <p>Высокий уровень внутренней энергии и мотивации</p>
                </div>
                <div class="course41-after-block orange">
                    <p>Прочная опора на собственные силы, навыки и опыт</p>
                </div>
                <div class="course41-after-block pink">
                    <p>Умение справляться с неудачами и адаптироваться к изменениям</p>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-course41-author', {
        label: 'Self-esteem author (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-course41-author main-wrapper">
        <div class="careerum-container-responsive">
            <h2>Автор программы</h2>
            <div class="careerum-flex-fsst course41-author-wrapper">
                <div class="course41-author-photo">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745993431676-vrxoC-Frame.webp"
                        alt="" class="hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746085863318-NfkhC-Frame.webp"
                        alt="" class="hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746099716679-PJtFM-Frame.webp"
                        alt="" class="hidden-desc-tablet">
                </div>
                <div class="course41-author-description position-relative">
                    <p>Анна Бабич</p>
                    <ul>
                        <li class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745993546443-X2wPQ-Soft.svg"
                                alt="">
                            <p>Дипломированный психолог и эксперт по самооценке и самореализации</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745993546443-X2wPQ-Soft.svg"
                                alt="">
                            <p>Автор психологических курсов и подкаста «Точки опоры»</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745993546443-X2wPQ-Soft.svg"
                                alt="">
                            <p>Основательница онлайн-школы по самооценке с более чем 35000+ учеников</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745993546443-X2wPQ-Soft.svg"
                                alt="">
                            <p>Автор книг-бестселлеров «Внутренняя опора», ”Я — ОК». «Карты внутренней
                                опоры», ”Книга-сериал по самооценке», ”Жизнь с опорой на ценности», ”Мама, отпусти»</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745993546443-X2wPQ-Soft.svg"
                                alt="">
                            <p>Автор статей для журналов Psychologies, Marie Claire, спикер на радио Buisness FM. Тренер
                                компаний СберБанк, Мегафон, 2Gis, Movavi</p>
                        </li>
                    </ul>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745993873282-BhHSZ-Grou.svg"
                        alt="" class="position-absolute hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746086124479-6YIjd-Grou.svg"
                        alt="" class="position-absolute hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746099859425-F9iPJ-Grou.svg"
                        alt="" class="position-absolute hidden-desc-tablet">
                </div>
            </div>
            <a href="#program" class="btn-color-main-dark-orange">Посмотреть программу</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-course41-program', {
        label: 'Self-esteem program (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-course41-program main-wrapper">
        <div class="careerum-container-responsive">
            <h2>Программа</h2>
            <div class="course41-program-cards">
                <div class="course41-program-card">
                    <div class="course41-program-card__top careerum-flex-fsc">
                        <p class="course41-program-card__label">Модуль 1 </p>
                        <p>Самооценка изнутри: работа с собой</p>
                    </div>
                    <div class="careerum-flex-fsfs course41-program-card__block">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745995511800-kwp8k-Book.svg"
                                alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087210367-XTbPT-Book.svg"
                                alt="" class="hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087236853-xfK19-Book.svg"
                                alt="" class="hidden-desc-tablet">
                        </div>
                        <div>
                            <p>Связь самооценки и денег</p>
                            <p>Вы разберётесь, как связаны профессиональное самоощущение и деньги, и определите
                                ваш тип самооценки. А также поставите финансовую цель на программу, чтобы отслеживать
                                внутренние изменения в самооценке и ощущении стоимости своей работы</p>
                        </div>
                    </div>
                    <div class="careerum-flex-fsfs course41-program-card__block">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745995511800-kwp8k-Book.svg"
                                alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087210367-XTbPT-Book.svg"
                                alt="" class="hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087236853-xfK19-Book.svg"
                                alt="" class="hidden-desc-tablet">
                        </div>
                        <div>
                            <p>Профессионал VS Критик</p>
                            <p>Вы узнаете, как формируются внутренние Критик и Профессионал и как их распознать
                                на уровне эмоций и действий. А также освоите приёмы, которые помогут вам ослабить голос
                                Критика и чаще обращаться к своему Профессионалу</p>
                        </div>
                    </div>
                    <div class="careerum-flex-fsfs course41-program-card__block">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745995511800-kwp8k-Book.svg"
                                alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087210367-XTbPT-Book.svg"
                                alt="" class="hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087236853-xfK19-Book.svg"
                                alt="" class="hidden-desc-tablet">
                        </div>
                        <div>
                            <p>Ваша опора: смыслы</p>
                            <p>Вы узнаете, что такое уникальный код профессионала, из каких внутренних опор он состоит,
                                и разберёте первую из них — смыслы</p>
                        </div>
                    </div>
                    <div class="careerum-flex-fsfs course41-program-card__block">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745995511800-kwp8k-Book.svg"
                                alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087210367-XTbPT-Book.svg"
                                alt="" class="hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087236853-xfK19-Book.svg"
                                alt="" class="hidden-desc-tablet">
                        </div>
                        <div>
                            <p>Ваша опора: ресурсы и активы</p>
                            <p>Вы разберёте вторую опору вашего кода профессионала — активы и ресурсы, научитесь
                                их выявлять и присваивать с помощью специального алгоритма</p>
                        </div>
                    </div>
                    <div class="careerum-flex-fsfs course41-program-card__block">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745995511800-kwp8k-Book.svg"
                                alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087210367-XTbPT-Book.svg"
                                alt="" class="hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087236853-xfK19-Book.svg"
                                alt="" class="hidden-desc-tablet">
                        </div>
                        <div>
                            <p>Перфекционизм и синдром самозванца</p>
                            <p>Вы узнаете, как выражается синдром самозванца и как присвоить свои достижения с помощью
                                алгоритма. А также разберётесь, чем так вреден перфекционизм и как с ним бороться</p>
                        </div>
                    </div>
                    <div class="careerum-flex-fsfs course41-program-card__block">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745995511800-kwp8k-Book.svg"
                                alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087210367-XTbPT-Book.svg"
                                alt="" class="hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087236853-xfK19-Book.svg"
                                alt="" class="hidden-desc-tablet">
                        </div>
                        <div>
                            <p>Формула «Сколько я стою?»</p>
                            <p>Вы узнаете, как определять стоимость своей работы по специальной формуле. А также
                                определите, как изменилась ваша финансовая цель после первого блока программы</p>
                        </div>
                    </div>
                </div>
                <div class="course41-program-card">
                    <div class="course41-program-card__top careerum-flex-fsc">
                        <p class="course41-program-card__label">Модуль 2 </p>
                        <p>Обесценивающие установки талантливых женщин</p>
                    </div>
                    <p class="course41-program-card-header">Большинство талантливых, чувствительных, умных женщин
                        не тормозят из-за недостатка способностей. Они тормозят, потому что внутри живут старые «ловушки
                        восприятия себя». Этот блок — про то, чтобы переписать их. Чтобы перестать доказывать свою
                        ценность — и начать жить из внутренней уверенности.</p>
                    <div class="careerum-flex-fsfs course41-program-card__block">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745995511800-kwp8k-Book.svg"
                                alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087210367-XTbPT-Book.svg"
                                alt="" class="hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087236853-xfK19-Book.svg"
                                alt="" class="hidden-desc-tablet">
                        </div>
                        <div>
                            <p>Архетипы самооценки: где ты сейчас и что тебя держит</p>
                            <p>Разберём, какие невидимые сценарии управляют твоими действиями: <br>
                                • Невидимая <br>
                                • Лёгкость = неценность <br>
                                • Успешная, но в напряжении <br>
                                • Хорошая, но недорогая <br>
                                Ты увидишь свою стратегию — и поймёшь, что именно мешает сделать следующий шаг вперёд.
                            </p>
                        </div>
                    </div>
                    <div class="careerum-flex-fsfs course41-program-card__block">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745995511800-kwp8k-Book.svg"
                                alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087210367-XTbPT-Book.svg"
                                alt="" class="hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087236853-xfK19-Book.svg"
                                alt="" class="hidden-desc-tablet">
                        </div>
                        <div>
                            <p>От «хорошей девочки» к зрелой самоценности</p>
                            <p>Как выйти из роли удобной и сверхответственной «спасательницы», которая считает,
                                что «помочь важнее, чем зарабатывать». Начинаем строить самоценность не на ожиданиях
                                других, а на осознанном праве быть собой.</p>
                        </div>
                    </div>
                    <div class="careerum-flex-fsfs course41-program-card__block">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745995511800-kwp8k-Book.svg"
                                alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087210367-XTbPT-Book.svg"
                                alt="" class="hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087236853-xfK19-Book.svg"
                                alt="" class="hidden-desc-tablet">
                        </div>
                        <div>
                            <p>Самооценка, внутренние запреты на амбиции и страх успеха</p>
                            <p>Почему иногда страшно «хотеть большего» — и кажется, что успех небезопасен? Как разрешить
                                себе расти без стыда, удерживать опору в новых результатах и не ждать подвоха.</p>
                        </div>
                    </div>
                    <div class="careerum-flex-fsfs course41-program-card__block">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745995511800-kwp8k-Book.svg"
                                alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087210367-XTbPT-Book.svg"
                                alt="" class="hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087236853-xfK19-Book.svg"
                                alt="" class="hidden-desc-tablet">
                        </div>
                        <div>
                            <p>Всё нормально, но боюсь остаться под мостом»: страх финансового краха</p>
                            <p>Разбираем катастрофизацию: откуда появляется скрытый ужас «всё потеряю»,
                                даже при стабильной жизни. Почему планка всегда ползёт вверх — и как перестроить
                                внутреннюю динамику.</p>
                        </div>
                    </div>
                    <div class="careerum-flex-fsfs course41-program-card__block">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745995511800-kwp8k-Book.svg"
                                alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087210367-XTbPT-Book.svg"
                                alt="" class="hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087236853-xfK19-Book.svg"
                                alt="" class="hidden-desc-tablet">
                        </div>
                        <div>
                            <p>Навык поддержки себя: перестаём быть героем-одиночкой</p>
                            <p>Как уйти от установки «Должна справляться сама». Как строить внутреннюю и внешнюю
                                экосистему поддержки — без вины и ощущения долга.</p>
                        </div>
                    </div>
                    <div class="careerum-flex-fsfs course41-program-card__block">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745995511800-kwp8k-Book.svg"
                                alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087210367-XTbPT-Book.svg"
                                alt="" class="hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087236853-xfK19-Book.svg"
                                alt="" class="hidden-desc-tablet">
                        </div>
                        <div>
                            <p>Оценка от других: как отделить свою ценность от результата</p>
                            <p>Почему одно негативное замечание способно обрушить самооценку. Учимся разделять себя
                                и результаты своей работы — и строить зрелую устойчивость в моменты критики.</p>
                        </div>
                    </div>
                </div>
                <div class="course41-program-card">
                    <div class="course41-program-card__top careerum-flex-fsc">
                        <p class="course41-program-card__label">Модуль 3 </p>
                        <p>Самооценка вовне: контакт с миром</p>
                    </div>
                    <div class="careerum-flex-fsfs course41-program-card__block">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745995511800-kwp8k-Book.svg"
                                alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087210367-XTbPT-Book.svg"
                                alt="" class="hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087236853-xfK19-Book.svg"
                                alt="" class="hidden-desc-tablet">
                        </div>
                        <div>
                            <p>Право быть заметным</p>
                            <p>Вы начнёте работу над внешним кругом самооценки и узнаете, что такое право быть, почему
                                так важно проявляться и как побороть страх и стыд заявлять о себе. А также
                                потренируетесь заменять стопперы самопроявления на активаторы</p>
                        </div>
                    </div>
                    <div class="careerum-flex-fsfs course41-program-card__block">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745995511800-kwp8k-Book.svg"
                                alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087210367-XTbPT-Book.svg"
                                alt="" class="hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087236853-xfK19-Book.svg"
                                alt="" class="hidden-desc-tablet">
                        </div>
                        <div>
                            <p>Сравнение без самоедства</p>
                            <p>Вы узнаете, как работает механизм сравнения и почему его не стоит избегать. А также
                                освоите алгоритм, который поможет вам извлекать пользу из сравнения и делать
                                это без самоедства</p>
                        </div>
                    </div>
                    <div class="careerum-flex-fsfs course41-program-card__block">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745995511800-kwp8k-Book.svg"
                                alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087210367-XTbPT-Book.svg"
                                alt="" class="hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087236853-xfK19-Book.svg"
                                alt="" class="hidden-desc-tablet">
                        </div>
                        <div>
                            <p>Устойчивость к критике</p>
                            <p>Вы узнаете, как реагировать на критику из позиции Профессионала и различить адекватную
                                и неадекватную критику, А Также разберётесь, как защитить и сохранить самооценку
                                в моменты, когда вас критикуют</p>
                        </div>
                    </div>
                    <div class="careerum-flex-fsfs course41-program-card__block">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745995511800-kwp8k-Book.svg"
                                alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087210367-XTbPT-Book.svg"
                                alt="" class="hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087236853-xfK19-Book.svg"
                                alt="" class="hidden-desc-tablet">
                        </div>
                        <div>
                            <p>Иммунитет к отказам</p>
                            <p>Вы узнаете, как отказы влияют на самооценку, будь это отказ вам или, наоборот, ваш отказ
                                кому‑либо. А также разберётесь, как выработать иммунитет, чтобы не бояться принимать
                                отказы и отказывать самому</p>
                        </div>
                    </div>
                    <div class="careerum-flex-fsfs course41-program-card__block">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745995511800-kwp8k-Book.svg"
                                alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087210367-XTbPT-Book.svg"
                                alt="" class="hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087236853-xfK19-Book.svg"
                                alt="" class="hidden-desc-tablet">
                        </div>
                        <div>
                            <p>Равноправные переговоры о деньгах</p>
                            <p>Вы узнаете, как уверенно вести переговоры про деньги с помощью специального алгоритма.
                                А также сверитесь с типом вашей профессиональной самооценки и целью на курс</p>
                        </div>
                    </div>
                    <div class="careerum-flex-fsfs course41-program-card__block">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745995511800-kwp8k-Book.svg"
                                alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087210367-XTbPT-Book.svg"
                                alt="" class="hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087236853-xfK19-Book.svg"
                                alt="" class="hidden-desc-tablet">
                        </div>
                        <div>
                            <p>Самооценка — ваш вечный двигатель</p>
                            <p>Этот урок — ваше напутствие. Вы узнаете, как адаптироваться к внешним изменениям,
                                что делать, если вы достигли всех вершин, и как понять, что пора двигаться дальше</p>
                        </div>
                    </div>
                </div>
            </div>
            <a href="#form" class="btn-color-main-dark-orange">Записаться на бесплатную неделю</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-course41-instruments', {
        label: 'Self-esteem instruments (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-course41-instruments main-wrapper">
                <div class="careerum-container-responsive careerum-flex-sbst">
                    <div class="course41-instruments-item black position-relative">
                        <h2>Инструменты курса</h2>
                        <ul>
                            <li>Будешь использовать эти инструменты ежедневно: для решений, переговоров, yстановки цен, самооценки и обратной связи</li>
                            <li>Практичные форматы с пошаговыми инструкциями и готовыми шаблонами</li>
                        </ul>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1747293550658-SkxcC-Grou.png" alt="" class="position-absolute hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1747294397418-K0BB3-Grou.png" alt="" class="position-absolute hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1747295103492-436m5-Grou.png" alt="" class="position-absolute hidden-desc-tablet">
                    </div>
                    <div class="course41-instruments-item orange">
                        <div class="course41-instruments-item__number careerum-flex-cc">
                            <span>1</span>
                        </div>
                        <p class="course41-instruments-item__header">Диагностика внyтреннего диалога: «Кто сейчас говорит?»</p>
                        <ul>
                            <li>Отличишь Критика от Профессионала и переключишься на конструктивный диалог</li>
                        </ul>
                    </div>
                    <div class="course41-instruments-item pink">
                        <div class="course41-instruments-item__number careerum-flex-cc">
                            <span>2</span>
                        </div>
                        <p class="course41-instruments-item__header">Формула: «Сколько ты стоишь на рынке»</p>
                        <ul>
                            <li>Разберешь навыки, опыт и вклад в результат, чтобы понять свою рыночную и внутреннюю цену</li>
                        </ul>
                    </div>
                    <div class="course41-instruments-item pink">
                        <div class="course41-instruments-item__number careerum-flex-cc">
                            <span>3</span>
                        </div>
                        <p class="course41-instruments-item__header">Чек-лист ресурсов и активов</p>
                        <ul>
                            <li>Шаблон для определения твоих сильных сторон, навыков и ресурсов поддержки</li>
                        </ul>
                    </div>
                    <div class="course41-instruments-item orange">
                        <div class="course41-instruments-item__number careerum-flex-cc">
                            <span>4</span>
                        </div>
                        <p class="course41-instruments-item__header">Шаблон «Как озвучить свою цену»</p>
                        <ul>
                            <li>Фразы для уверенного разговора о деньгах — без оправданий и самоуничижения</li>
                        </ul>
                    </div>
                    <div class="course41-instruments-item orange">
                        <div class="course41-instruments-item__number careerum-flex-cc">
                            <span>5</span>
                        </div>
                        <p class="course41-instruments-item__header">Метод: «Осознанное<br> сравнение»</p>
                        <ul>
                            <li>Алгоритм, чтобы перестать обесценивать себя и превратить чужие успехи в план роста</li>
                        </ul>
                    </div>
                    <div class="course41-instruments-item pink">
                        <div class="course41-instruments-item__number careerum-flex-cc">
                            <span>6</span>
                        </div>
                        <p class="course41-instruments-item__header">Сценарии поведения при критике</p>
                        <ul>
                            <li>Фразы и шаги, чтобы спокойно реагировать на внешнюю и внутреннюю критику</li>
                        </ul>
                    </div>
                    <div class="course41-instruments-item pink">
                        <div class="course41-instruments-item__number careerum-flex-cc">
                            <span>7</span>
                        </div>
                        <p class="course41-instruments-item__header">Анти-самосаботаж: обнаружение и выключение триггеров</p>
                        <ul>
                            <li>Пошаговая схема, чтобы перестать молчать и терпеть, и действовать конструктивно</li>
                        </ul>
                    </div>
                    <div class="course41-instruments-item orange">
                        <div class="course41-instruments-item__number careerum-flex-cc">
                            <span>8</span>
                        </div>
                        <p class="course41-instruments-item__header">Инструмент «Это не вся я»</p>
                        <ul>
                            <li>Перестанешь оценивать себя через ошибки, сможешь поддерживать работоспособность после «неудач»</li>
                        </ul>
                    </div>
                    <div class="course41-instruments-item orange">
                        <div class="course41-instruments-item__number careerum-flex-cc">
                            <span>9</span>
                        </div>
                        <p class="course41-instruments-item__header">Система самостоятельной поддержки: мини чек-листы</p>
                        <ul>
                            <li>Упражнения для быстрого восстановления уверенности без внешнего одобрения</li>
                        </ul>
                    </div>
                    <div class="course41-instruments-item pink">
                        <div class="course41-instruments-item__number careerum-flex-cc ">
                            <span>10</span>
                        </div>
                        <p class="course41-instruments-item__header">Реестр достижений</p>
                        <ul>
                            <li>Таблица для фиксации успехов, чтобы поддерживать уверенность фактами</li>
                        </ul>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-course41-live', {
        label: 'Self-esteem live (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-course41-live main-wrapper">
        <div class="careerum-container-responsive">
            <h2>Живые онлайн-практикумы</h2>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745995804643-APMTA-Main .webp" alt=""
                class="position-relative hidden-tablet-mobile">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087648279-2Xyrh-Group.webp" alt=""
                class="position-relative hidden-desc-mobile">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746100367094-73UsG-Main .webp" alt=""
                class="position-relative hidden-desc-tablet">
            <div class="careerum-flex-cc course41-live-names position-relative">
                <p>Анна Бабич</p>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745995830827-nUquz-Vect.svg" alt=""
                    class="hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087835640-ecLCm-Vect.svg" alt=""
                    class="hidden-desc-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746087855434-jEzhT-Vect.svg" alt=""
                    class="hidden-desc-tablet">
                <p>Ольга Лермонтова</p>
            </div>
            <div class="course41-live-cards careerum-flex-sbst">
                <div class="course41-live-card careerum-flex-fsst">
                    <p>Анна Бабич</p>
                    <div class="course41-live-card__wrapper">
                        <div class="course41-live-card__schedule careerum-flex-fsc">
                            <div class="course41-live-card__date">
                                <p>17<br>
                                    <span>Июня</span>
                                </p>
                            </div>
                            <div class="course41-live-card__header">
                                <p>Как присваивать активы и ресурсы через благодарность?</p>
                            </div>
                        </div>
                        <div class="course41-live-card__schedule careerum-flex-fsc">
                            <div class="course41-live-card__date">
                                <p>8<br>
                                    <span>Июля</span>
                                </p>
                            </div>
                            <div class="course41-live-card__header">
                                <p>Как заявлять о себе без стыда?</p>
                            </div>
                        </div>
                        <div class="course41-live-card__schedule careerum-flex-fsc">
                            <div class="course41-live-card__date">
                                <p>29<br>
                                    <span>Июля</span>
                                </p>
                            </div>
                            <div class="course41-live-card__header">
                                <p>Как вести переговоры про деньги?</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="course41-live-card careerum-flex-fsst">
                    <p>Ольга Лермонтова</p>
                    <div class="course41-live-card__wrapper position-relative">
                        <div class="course41-live-card__schedule careerum-flex-fsc position-relative z-20">
                            <div class="course41-live-card__date">
                                <p>3<br>
                                    <span>Июня</span>
                                </p>
                            </div>
                            <div class="course41-live-card__header">
                                <p>Тихое соглашение на меньшее: как незаметно мы сдаём свои цели</p>
                            </div>
                        </div>
                        <div class="course41-live-card__schedule careerum-flex-fsc position-relative z-20">
                            <div class="course41-live-card__date">
                                <p>1<br>
                                    <span>Июля</span>
                                </p>
                            </div>
                            <div class="course41-live-card__header">
                                <p>Почему талантливые женщины обесценивают сами себя?</p>
                            </div>
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746088375100-WbzNN-Grou.svg"
                            alt="" class="hidden-desc-mobile position-absolute z-10">
                    </div>
                </div>
            </div>
            <a href="#form" class="btn-color-main-dark-orange">Записаться на бесплатную неделю</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-course41-form', {
        label: 'Self-esteem form (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-course41-form main-wrapper">
        <div class="careerum-container-responsive careerum-flex-sbfs position-relative">
            <div class="course41-form-left position-relative z-20">
                <div class="course41-form-labels careerum-flex-fsfs">
                    <div class="course41-form-label_pink careerum-flex-fsc">
                        <p>Бесплатная неделя</p>
                    </div>
                    <div class="course41-form-label careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745952459306-dyXjH-Cale.svg"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746028100443-9Mp5j-Cale.svg"
                            alt="" class="hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746096673546-AU0nG-Cale.svg"
                            alt="" class="hidden-desc-tablet">
                        <p>19 мая – 22 мая</p>
                    </div>
                </div>
                <p>Присоединяйся к бесплатной неделе курса</p>
                <h2>Само<span>О</span>ценка</h2>
                <p>Программа:</p>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745997627950-FEf1J-Vect.svg" alt=""
                    class="position-absolute hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746089438270-NkvxF-Vect.svg" alt=""
                    class="position-absolute hidden-desc-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746100776305-5lQDy-Vect.svg" alt=""
                    class="position-absolute hidden-desc-tablet">
                <ul>
                    <li class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745997483578-sVR97-Soft.svg"
                            alt="">
                        <p>4 дня практик с Анной Бабич и Ольгой Лермонтовой</p>
                    </li>
                    <li class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745997483578-sVR97-Soft.svg"
                            alt="">
                        <p>1 чекап-диагностика</p>
                    </li>
                    <li class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745997483578-sVR97-Soft.svg"
                            alt="">
                        <p>2 урока + домашние задания</p>
                    </li>
                    <li class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745997483578-sVR97-Soft.svg"
                            alt="">
                        <p>1 живой онлайн-практикум с Анной и Ольгой</p>
                    </li>
                    <li class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745997483578-sVR97-Soft.svg"
                            alt="">
                        <p>Q&A Day с Анной и Ольгой</p>
                    </li>
                </ul>
            </div>
            <div class="course41-form-right position-relative z-20">
                <div class="careerum-registration-form-club40">
                    <form class="deva-form" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                        <div class="careerum-club40-form-name">
                            <input type="text" name="name" value="" required placeholder="Имя">
                            <p class="careerum-club40-form-warn">Неверное имя</p>
                        </div>
                        <div class="careerum-club40-form-email">
                            <input type="text" name="email" value="" required placeholder="Почта">
                            <p class="careerum-club40-form-warn">Поле не заполнено</p>
                        </div>
                        <div class="careerum-club40-form-telegram">
                            <input type="text" name="telegram" value="" required placeholder="Telegram">
                            <p class="careerum-club40-form-warn">Поле не заполнено</p>
                        </div>
                        <div class="careerum-club40-form-phone">
                            <input type="tel" value="" name="tel" required class="itl-input">
                            <p class="careerum-club40-form-warn">Поле не заполнено</p>
                        </div>
                        <div class="careerum-club40-form-agree">
                            <label>
                                <input type="checkbox" name="agree">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                        fill="none">
                                        <path
                                            d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                            stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                    </svg>
                                </div>
                            </label>
                            <p>Я принимаю условия <a href="/ru-intl/legal/offer">Оферты</a> и даю согласие
                                на обработку персональных данных
                                в соответствии с <a href="/ru-ru/legal/privacy">Политикой конфиденциальности</a>.
                                Подписка будет автоматически
                                продлеваться по аналогичным условиям за сутки до конца оплаченного периода</p>
                        </div>
                        <a href="#" class="submit-btn btn-color-main-bright-orange careerum-flex-cc" disabled>
                            Записаться
                        </a>
                    </form>
                </div>
            </div>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745997793971-aq2DK-Grou.svg" alt=""
                class="position-absolute z-10 hidden-tablet-mobile">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746088819335-YMRNE-Grou.svg" alt=""
                class="position-absolute z-10 hidden-desc-mobile">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746100980805-A8w3b-Star.svg" alt=""
                class="position-absolute z-10 hidden-desc-tablet">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746100981310-KqEcc-Fram.svg" alt=""
                class="position-absolute z-10 hidden-desc-tablet">
        </div>
    </div>`
    });
    
    blockManager.add('careerum-course41-reviews', {
        label: 'Self-esteem reviews (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-course41-reviews main-wrapper">
        <div class="careerum-container-responsive">
            <h2>Отзывы</h2>
            <div class="course41-reviews-slider">
                <div class="course41-reviews-slider__item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745998780295-wvpSG-image.webp"
                        alt="" class="hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746089971178-sahiv-image.webp"
                        alt="" class="hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746101294892-iUULT-image.webp"
                        alt="" class="hidden-desc-tablet">
                </div>
                <div class="course41-reviews-slider__item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745998780496-cPIvg-Group.webp"
                        alt="" class="hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746089971885-fDCRc-Group.webp"
                        alt="" class="hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746101295073-wC2nx-Group.webp"
                        alt="" class="hidden-desc-tablet">
                </div>
                <div class="course41-reviews-slider__item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745998779895-ZDRCa-Frame.webp"
                        alt="" class="hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746089971778-sUCuk-Frame.webp"
                        alt="" class="hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746101294310-L4rKO-Frame.webp"
                        alt="" class="hidden-desc-tablet">
                </div>
                <div class="course41-reviews-slider__item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745998780833-GKkFb-Frame.webp"
                        alt="" class="hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746089971554-jZesh-Frame.webp"
                        alt="" class="hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746101294772-suCnk-Frame.webp"
                        alt="" class="hidden-desc-tablet">
                </div>
                <div class="course41-reviews-slider__item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1745998780684-iOrHJ-image.webp"
                        alt="" class="hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746089971666-qjhj8-image.webp"
                        alt="" class="hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746101294576-pUPkp-image.webp"
                        alt="" class="hidden-desc-tablet">
                </div>
            </div>
            <div class="course41-reviews-slider__nav careerum-flex-fec">
                <div class="course41-reviews-slider__nav_left">
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_323_5564)">
                            <foreignObject x="-18.1166" y="-18.1166" width="76.2332" height="76.2332">
                                <div xmlns="http://www.w3.org/1999/xhtml"
                                    style="backdrop-filter:blur(9.06px);clip-path:url(#bgblur_1_323_5564_clip_path);height:100%;width:100%">
                                </div>
                            </foreignObject>
                            <rect data-figma-bg-blur-radius="18.1166" y="40" width="40" height="40"
                                transform="rotate(-90 0 40)" fill="black" />
                            <path d="M13 20L27 20" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M19 26L13 20L19 14" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="bgblur_1_323_5564_clip_path" transform="translate(18.1166 18.1166)">
                                <rect y="40" width="40" height="40" transform="rotate(-90 0 40)" />
                            </clipPath>
                            <clipPath id="clip0_323_5564">
                                <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <div class="course41-reviews-slider__nav_right">
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_323_5568)">
                            <foreignObject x="-18.1166" y="-18.1166" width="76.2332" height="76.2332">
                                <div xmlns="http://www.w3.org/1999/xhtml"
                                    style="backdrop-filter:blur(9.06px);clip-path:url(#bgblur_1_323_5568_clip_path);height:100%;width:100%">
                                </div>
                            </foreignObject>
                            <rect data-figma-bg-blur-radius="18.1166" x="40" width="40" height="40"
                                transform="rotate(90 40 0)" fill="black" />
                            <path d="M27 20L13 20" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M21 14L27 20L21 26" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="bgblur_1_323_5568_clip_path" transform="translate(18.1166 18.1166)">
                                <rect x="40" width="40" height="40" transform="rotate(90 40 0)" />
                            </clipPath>
                            <clipPath id="clip0_323_5568">
                                <rect x="40" width="40" height="40" rx="20" transform="rotate(90 40 0)" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-course41-about', {
        label: 'Self-esteem about (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-course41-about main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <h2 class="position-relative z-20">С нами вы решите проблему в 9 раз дешевле и быстрее</h2>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746090386279-GlE33-Vect.svg" alt=""
                class="position-absolute hidden-tablet-mobile z-10">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746090395970-bGJTl-Vect.svg" alt=""
                class="position-absolute hidden-desc-mobile z-10">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746090403053-SGSIg-Vect.svg" alt=""
                class="position-absolute hidden-desc-tablet z-10">
            <div class="course41-about-items careerum-flex-sbst">
                <div class="course41-about__item_left position-relative">
                    <p class="course41-about__item-label">С психологом</p>
                    <p class="course41-about__item-header position-relative z-30 hidden-tablet-mobile">Выкапывать
                        проблему минимум 1 год!</p>
                    <p class="course41-about__item-header position-relative z-30 hidden-desc">Выкапывать проблему
                        минимум 1 год!</p>
                    <p class="course41-about__item-price">1 год <span></span> 52 сессии <span></span> 5000 руб</p>
                    <p class="course41-about__item-equal">=</p>
                    <p class="course41-about__item-total position-relative z-10">260 000 ₽</p>
                    <div class="position-relative z-20">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746000124179-swjpO-Psyc.svg"
                            alt="" class="position-absolute bg hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746000123876-ksfHA-Vect.svg"
                            alt="" class="position-absolute price hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746090704537-ugDhD-Psyc.svg"
                            alt="" class="position-absolute bg hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746090715873-OhkZv-Vect.svg"
                            alt="" class="position-absolute price hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746101666083-p2IP7-Psyc.svg"
                            alt="" class="position-absolute bg hidden-desc-tablet">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746101665805-WtWPO-Vect.svg"
                            alt="" class="position-absolute price hidden-desc-tablet">
                    </div>
                </div>
                <div class="course41-about__item_right position-relative">
                    <p class="course41-about__item-label">С Сareerum</p>
                    <p class="course41-about__item-header position-relative z-30">Прицельная работа на рост самооценки 3
                        месяца</p>
                    <p class="course41-about__item-price">3 месяца</p>
                    <p class="course41-about__item-equal">=</p>
                    <p class="course41-about__item-total position-relative z-10">29 000 ₽</p>
                    <div class="position-relative z-20">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746000319483-oNISF-Grou.svg"
                            alt="" class="position-absolute bg hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746000319246-6WnIG-Grou.svg"
                            alt="" class="position-absolute price hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746090994155-pnvpQ-Grou.svg"
                            alt="" class="position-absolute bg hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746090993931-yrfE4-Grou.svg"
                            alt="" class="position-absolute price hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746101711734-cQvt8-Grou.svg"
                            alt="" class="position-absolute bg hidden-desc-tablet">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746101711611-Dqtp6-Grou.svg"
                            alt="" class="position-absolute price hidden-desc-tablet">
                    </div>
                </div>
            </div>
            <a href="#form" class="btn-color-main-dark-orange">Записаться на бесплатную неделю</a>
        </div>
    </div>`
    });
    
    blockManager.add('course41-tariffs', {
        label: 'Self-esteem about (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club40-tariffs course41-tariffs main-wrapper disabled">
                <div class="careerum-container-responsive">
                    <h2 class="careerum-club40-header">Выберите тариф подписки в Careerum</h2>
                    <p>Чтобы попасть на курс, нужно оформить подписку на платформу </p>
                    <div class="club40-tariffs-top hidden-mobile">
                        <p class="club40-tariffs-top-header">Как выбрать длительность подписки:</p>
                        <div class="careerum-flex-sbst club40-tariffs-top-items">
                            <div class="club40-tariffs-top-item">
                                <p class="club40-tariffs-top-label">Подписка на 30 дней </p>
                                <p class="club40-tariffs-top-text">Вы получаете доступ только к одному месяцу курса по самооценке. Чтобы пройти курс полностью, вы можете продлевать подписку каждый месяц.</p>
                            </div>
                            <div class="club40-tariffs-top-item">
                                <p class="club40-tariffs-top-label">Подписка на 90 дней </p>
                                <p class="club40-tariffs-top-text">Вы получаете доступ ко всем активностям курса.</p>
                            </div>
                            <div class="club40-tariffs-top-item">
                                <p class="club40-tariffs-top-label">Подписка на 180 дней </p>
                                <p class="club40-tariffs-top-text">Вы получаете доступ ко всем материалам курса по самооценке и всем активностям нашей карьерной платформы в течение полугода.</p>
                            </div>
                            <div class="club40-tariffs-top-item">
                                <p class="club40-tariffs-top-label">Подписка на 365 дней </p>
                                <p class="club40-tariffs-top-text">Вы получаете доступ ко всем материалам курса по самооценке и всем активностям нашей платформы в течение года</p>
                            </div>
                            <div class="position-relative club40-tariffs-top-item orange">
                                <p class="club40-tariffs-top-label position-relative z-10">Промокод</p>
                                <p class="club40-tariffs-top-text position-relative z-10">Если у вас есть промокод, он действует на пакеты от 90 дней. Подписку на 30 дней можно приобрести только по полной стоимости.<br> Вводите его на странице оплаты после выбора своего тарифа.</p>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1747754531668-XGFJY-Soft.svg" alt="" class="position-absolute z-20 hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1747754372674-gRkiI-Soft.svg" alt="" class="position-absolute z-20 hidden-desc-mobile">
                            </div>
                        </div>
                    </div>
                    <div class="club40-tariffs-nav careerum-flex-sbc">
                        <div class="club40-tariffs-period careerum-flex-sbst">
                            <ul class="careerum-flex-fsfs">
                                <li data-period="1" class="active">1 месяц</li>
                                <li data-period="3">3 месяца</li>
                                <li data-period="6">6 месяцев</li>
                                <li data-period="12">12 месяцев</li>
                            </ul>
                            <div class="club40-tariffs-notif careerum-flex-cc">
                                <div class="club40-tariffs-notif-icon">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                        alt="">
                                </div>
                                <div class="club40-tariffs-notif-content">
                                    <p>1 месяц подписки предоставляет 30 дней доступа к платформе</p>
                                </div>
                            </div>
                        </div>
                        <div class="club40-tariffs-curr careerum-flex-fsst">
                            <ul class="careerum-flex-fsfs">
                                <li data-currency="eur" class="active">EUR</li>
                                <li data-currency="rub">RUB</li>
                            </ul>
                            <div class="club40-tariffs-notif careerum-flex-cc">
                                <div class="club40-tariffs-notif-icon">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                        alt="">
                                </div>
                                <div class="club40-tariffs-notif-content">
                                    <p>Оплата в российских рублях возможна только картой российского банка. В&nbsp;евро — картой
                                        зарубежного банка</p>
                                </div>
                            </div>
                        </div>
                        <div class="club40-tariffs-top hidden-desc-tablet">
                            <p class="club40-tariffs-top-header">Как выбрать длительность подписки:</p>
                            <div class="careerum-flex-sbst club40-tariffs-top-items">
                                <div class="club40-tariffs-top-item">
                                    <p class="club40-tariffs-top-label">Подписка на 30 дней </p>
                                    <p class="club40-tariffs-top-text">Вы получаете доступ только к одному месяцу курса по самооценке. Чтобы пройти курс полностью, вы можете продлевать подписку каждый месяц.</p>
                                </div>
                                <div class="club40-tariffs-top-item">
                                    <p class="club40-tariffs-top-label">Подписка на 90 дней </p>
                                    <p class="club40-tariffs-top-text">Вы получаете доступ ко всем активностям курса.</p>
                                </div>
                                <div class="club40-tariffs-top-item">
                                    <p class="club40-tariffs-top-label">Подписка на 180 дней </p>
                                    <p class="club40-tariffs-top-text">Вы получаете доступ ко всем материалам курса по самооценке и всем активностям нашей карьерной платформы в течение полугода.</p>
                                </div>
                                <div class="club40-tariffs-top-item">
                                    <p class="club40-tariffs-top-label">Подписка на 365 дней </p>
                                    <p class="club40-tariffs-top-text">Вы получаете доступ ко всем материалам курса по самооценке и всем активностям нашей платформы в течение года</p>
                                </div>
                                <div class="position-relative club40-tariffs-top-item orange">
                                    <p class="club40-tariffs-top-label position-relative z-10">Промокод</p>
                                    <p class="club40-tariffs-top-text position-relative z-10">Если у вас есть промокод, он действует на пакеты от 90 дней. Подписку на 30 дней можно приобрести только по полной стоимости.<br> Вводите его на странице оплаты после выбора своего тарифа.</p>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1747754531668-XGFJY-Soft.svg" alt="" class="position-absolute z-20 hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1747754372674-gRkiI-Soft.svg" alt="" class="position-absolute z-20 hidden-desc-mobile">
                                </div>
                            </div>
                        </div>
                        <div class="club40-tariffs__swicher-block-wrapper">
                            <div class="club40-tariffs__swicher-block">
                                <div class="club40-tariffs__swicher-top">
                                    <p class="club40-tariffs__swicher-header">Посмотреть цены в
                                        <span>RUB</span>
                                    </p>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                        class="club40-tariffs__swicher-arrow">
                                        <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black"></path>
                                    </svg>
                                </div>
                                <div class="club40-tariffs__swicher-bottom">
                                    <ul>
                                        <li data-currency="rub">
                                            RUB
                                        </li>
                                        <li data-currency="eur" class="active">
                                            EUR
                                        </li>
                                    </ul>
                                    <p>Обратите внимание,<br> что оплата в российских рублях возможна только<br> с карты российского
                                        банка. Оплата в евро — с карты зарубежного банка </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="club40-tariffs-items">
                        <div class="careerum-flex-cst">
                            <div data-price="" data-price-1m-rub="12 900 ₽" data-price-3m-rub="9&nbsp;967 ₽"
                                data-fullprice-3m-rub="29&nbsp;900 ₽" data-price-6m-rub="" data-fullprice-6m-rub=""
                                data-price-12m-rub="" data-fullprice-12m-rub="" data-price-1m-eur="149 €"
                                data-price-3m-eur="120 €" data-fullprice-3m-eur="360 €" data-price-6m-eur=""
                                data-fullprice-6m-eur="" data-price-12m-eur="" data-fullprice-12m-eur="" data-offer-1m-rub="27"
                                data-offer-3m-rub="94" data-offer-6m-rub="" data-offer-12m-rub="" data-offer-1m-eur="48"
                                data-offer-3m-eur="97" data-offer-6m-eur="" data-offer-12m-eur=""
                                class="club40-tariffs-item careerum-flex-fsfs hidden-9-12">
                                <p class="club40-tariffs-item-subheader2">Тариф «Самостоятельный»</p>
                                <p class="club40-tariffs-item-header">Доступ к курсу в записи без обратной связи</p>
                                <div class="club40-tariffs-item-divider"></div>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746022497181-lXdM7-Chec.svg"
                                            alt="">
                                        <p><span>Доступ к интенсиву в записи:<br>
                                                ·  видеолекции в записи<br>
                                                ·  5 онлайн-практик в записи</span></p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746022497181-lXdM7-Chec.svg"
                                            alt="">
                                        <p>Доступ ко всем материалам курса на 3 месяца</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746022497181-lXdM7-Chec.svg"
                                            alt="">
                                        <p>Доступ к обучающей платформе и 80 курсам на время действия подписки</p>
                                    </li>
                                </ul>
                                <div class="club40-tariffs-item-bottom">
                                    <div class="club40-tariffs-item-discount m3 careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746023192218-uqrT8-Disc.svg"
                                            alt="" class="hidden-mobile">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743056624755-0AZOL-Lock.svg"
                                            alt="" class="hidden-desc-tablet">
                                        <p>Доступ на 90 дней</p>
                                    </div>
                                    <div class="club40-tariffs-item-discount m6 careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746023192218-uqrT8-Disc.svg"
                                            alt="" class="hidden-mobile">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743056624755-0AZOL-Lock.svg"
                                            alt="" class="hidden-desc-tablet">
                                        <p>Доступ на 180 дней</p>
                                    </div>
                                    <div class="club40-tariffs-item-discount m12 careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746023192218-uqrT8-Disc.svg"
                                            alt="" class="hidden-mobile">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743056624755-0AZOL-Lock.svg"
                                            alt="" class="hidden-desc-tablet">
                                        <p>Доступ на 365 дней</p>
                                    </div>
                                    <div class="careerum-flex-fsfs club40-tariffs-item-wrapper-price with-discount">
                                        <div>
                                            <p class="club40-tariffs-item-price-f">14 900 ₽</p>
                                        </div>
                                    </div>
                                    <a onclick="" href="#tariff-single" class="btn-color-main-dark-orange">
                                        <svg width="33" height="32" viewBox="0 0 33 32" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M26.5 11H6.5C5.94772 11 5.5 11.4477 5.5 12V26C5.5 26.5523 5.94772 27 6.5 27H26.5C27.0523 27 27.5 26.5523 27.5 26V12C27.5 11.4477 27.0523 11 26.5 11Z"
                                                stroke="white" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                            <path
                                                d="M12 11V6.5C12 5.30653 12.4741 4.16193 13.318 3.31802C14.1619 2.47411 15.3065 2 16.5 2C17.6935 2 18.8381 2.47411 19.682 3.31802C20.5259 4.16193 21 5.30653 21 6.5"
                                                stroke="white" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                            <path
                                                d="M16.5 20.5C17.3284 20.5 18 19.8284 18 19C18 18.1716 17.3284 17.5 16.5 17.5C15.6716 17.5 15 18.1716 15 19C15 19.8284 15.6716 20.5 16.5 20.5Z"
                                                fill="white" />
                                        </svg>
                                        Доступно с 21 мая</a>
                                </div>
                            </div>
                            <div data-price="" data-price-1m-rub="14 900 ₽" data-price-3m-rub="13&nbsp;300 ₽"
                                data-fullprice-3m-rub="39&nbsp;900 ₽" data-price-6m-rub="11&nbsp;650 ₽"
                                data-fullprice-6m-rub="69&nbsp;900 ₽" data-price-12m-rub="9&nbsp;075 ₽"
                                data-fullprice-12m-rub="108&nbsp;900 ₽" data-price-1m-eur="199 €" data-price-3m-eur="170 €"
                                data-fullprice-3m-eur="510 €" data-price-6m-eur="130 €" data-fullprice-6m-eur="780 €"
                                data-price-12m-eur="100 €" data-fullprice-12m-eur="1 200 €" data-offer-1m-rub="28"
                                data-offer-3m-rub="29" data-offer-6m-rub="30" data-offer-12m-rub="31" data-offer-1m-eur="49"
                                data-offer-3m-eur="50" data-offer-6m-eur="51" data-offer-12m-eur="52"
                                class="club40-tariffs-item careerum-flex-fsfs">
                                <p class="club40-tariffs-item-subheader2">Тариф «С поддержкой»</p>
                                <p class="club40-tariffs-item-header">Курс с практикой и обратной связью</p>
                                <div class="club40-tariffs-item-divider"></div>
                                <p class="club40-tariffs-item-subheader">Входят все опции
                                    тарифа «Самостоятельный», плюс:
                                </p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746022496945-k6KTg-Chec.svg"
                                            alt="">
                                        <p>Групповой чат с кураторами </p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746022496945-k6KTg-Chec.svg"
                                            alt="">
                                        <p>4 онлайн-практики и живой разбор кейсов</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746022496945-k6KTg-Chec.svg"
                                            alt="">
                                        <p>2 групповые Q&A-встречи в месяц с коучем из команды Careerum для разбора вопросов
                                        </p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746022496945-k6KTg-Chec.svg"
                                            alt="">
                                        <p>Домашние задания </p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746022496945-k6KTg-Chec.svg"
                                            alt="">
                                        <p>Доступ к нетворк-сообществу Сareerum.Club:<br>
                                            ·  4 нетворк-встречи<br>
                                            ·  Еженедельные Coffeе Buddy</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746022496945-k6KTg-Chec.svg"
                                            alt="">
                                        <p>Buddy-поддержка: мотивация и менторство в тройках с другим участником по принципу
                                            “равный
                                            равному”</p>
                                    </li>
                                </ul>
                                <div class="club40-tariffs-item-bottom">
                                    <div class="club40-tariffs-item-discount m3 careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746023192218-uqrT8-Disc.svg"
                                            alt="" class="hidden-mobile">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743056624755-0AZOL-Lock.svg"
                                            alt="" class="hidden-desc-tablet">
                                        <p>Доступ на 90 дней</p>
                                    </div>
                                    <div class="club40-tariffs-item-discount m6 careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746023192218-uqrT8-Disc.svg"
                                            alt="" class="hidden-mobile">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743056624755-0AZOL-Lock.svg"
                                            alt="" class="hidden-desc-tablet">
                                        <p>Доступ на 180 дней</p>
                                    </div>
                                    <div class="club40-tariffs-item-discount m12 careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746023192218-uqrT8-Disc.svg"
                                            alt="" class="hidden-mobile">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743056624755-0AZOL-Lock.svg"
                                            alt="" class="hidden-desc-tablet">
                                        <p>Доступ на 365 дней</p>
                                    </div>
                                    <div class="careerum-flex-fsfs club40-tariffs-item-wrapper-price with-discount">
                                        <div>
                                            <p class="club40-tariffs-item-price-f">14 900 ₽</p>
                                        </div>
                                    </div>
                                    <a onclick="" href="#tariff-single" class="btn-color-main-dark-orange">
                                        <svg width="33" height="32" viewBox="0 0 33 32" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M26.5 11H6.5C5.94772 11 5.5 11.4477 5.5 12V26C5.5 26.5523 5.94772 27 6.5 27H26.5C27.0523 27 27.5 26.5523 27.5 26V12C27.5 11.4477 27.0523 11 26.5 11Z"
                                                stroke="white" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                            <path
                                                d="M12 11V6.5C12 5.30653 12.4741 4.16193 13.318 3.31802C14.1619 2.47411 15.3065 2 16.5 2C17.6935 2 18.8381 2.47411 19.682 3.31802C20.5259 4.16193 21 5.30653 21 6.5"
                                                stroke="white" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                            <path
                                                d="M16.5 20.5C17.3284 20.5 18 19.8284 18 19C18 18.1716 17.3284 17.5 16.5 17.5C15.6716 17.5 15 18.1716 15 19C15 19.8284 15.6716 20.5 16.5 20.5Z"
                                                fill="white" />
                                        </svg>
                                        Доступно с 21 мая</a>
                                </div>
                            </div>
                            <div data-price="" data-price-1m-rub="33&nbsp;900 ₽" data-price-3m-rub="29&nbsp;967 ₽"
                                data-fullprice-3m-rub="89&nbsp;900 ₽" data-price-6m-rub="26&nbsp;650 ₽"
                                data-fullprice-6m-rub="159&nbsp;900 ₽" data-price-12m-rub="20&nbsp;908 ₽"
                                data-fullprice-12m-rub="250&nbsp;900 ₽" data-price-1m-eur="360 €" data-price-3m-eur="310 €"
                                data-fullprice-3m-eur="930 €" data-price-6m-eur="250 €" data-fullprice-6m-eur="1 500 €"
                                data-price-12m-eur="230 €" data-fullprice-12m-eur="2 760 €" data-offer-1m-rub="32"
                                data-offer-3m-rub="100" data-offer-6m-rub="101" data-offer-12m-rub="102" data-offer-1m-eur="53"
                                data-offer-3m-eur="103" data-offer-6m-eur="104" data-offer-12m-eur="105"
                                class="club40-tariffs-item careerum-flex-fsfs">
                                <p class="club40-tariffs-item-subheader2">Тариф «Индивидуальный подход»</p>
                                <p class="club40-tariffs-item-header">Курс с практикой и обратной связью + личные консультации
                                    с экспертом</p>
                                <p class="club40-tariffs-item-description">Всего: 30 мест</p>
                                <div class="club40-tariffs-item-divider"></div>
                                <p class="club40-tariffs-item-subheader">Входят все опции тарифа «С поддержкой», плюс: </p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746022496945-k6KTg-Chec.svg"
                                            alt="">
                                        <p>2 личные консультации в месяц с сертифицированным коучем из команды Careerum для
                                            глубокой
                                            проработки вашего запроса:<br>
                                            ·  онлайн-встреча<br>
                                            ·  50 минут<br>
                                            ·  разбор вашего запроса<br>
                                            ·  запись встречи, чтобы можно было пересмотреть<br>
                                            ·  список рекомендаций</p>
                                    </li>
                                </ul>
                                <div class="club40-tariffs-item-bottom">
                                    <div class="club40-tariffs-item-discount m3 careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746023192218-uqrT8-Disc.svg"
                                            alt="" class="hidden-mobile">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743056624755-0AZOL-Lock.svg"
                                            alt="" class="hidden-desc-tablet">
                                        <p>Доступ на 90 дней</p>
                                    </div>
                                    <div class="club40-tariffs-item-discount m6 careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746023192218-uqrT8-Disc.svg"
                                            alt="" class="hidden-mobile">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743056624755-0AZOL-Lock.svg"
                                            alt="" class="hidden-desc-tablet">
                                        <p>Доступ на 180 дней</p>
                                    </div>
                                    <div class="club40-tariffs-item-discount m12 careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746023192218-uqrT8-Disc.svg"
                                            alt="" class="hidden-mobile">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743056624755-0AZOL-Lock.svg"
                                            alt="" class="hidden-desc-tablet">
                                        <p>Доступ на 365 дней</p>
                                    </div>
                                    <div class="careerum-flex-fsfs club40-tariffs-item-wrapper-price with-discount">
                                        <div>
                                            <p class="club40-tariffs-item-price-f">14 900 ₽</p>
                                        </div>
                                    </div>
                                    <a onclick="" href="#tariff-single" class="btn-color-main-dark-orange">
                                        <svg width="33" height="32" viewBox="0 0 33 32" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M26.5 11H6.5C5.94772 11 5.5 11.4477 5.5 12V26C5.5 26.5523 5.94772 27 6.5 27H26.5C27.0523 27 27.5 26.5523 27.5 26V12C27.5 11.4477 27.0523 11 26.5 11Z"
                                                stroke="white" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                            <path
                                                d="M12 11V6.5C12 5.30653 12.4741 4.16193 13.318 3.31802C14.1619 2.47411 15.3065 2 16.5 2C17.6935 2 18.8381 2.47411 19.682 3.31802C20.5259 4.16193 21 5.30653 21 6.5"
                                                stroke="white" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                            <path
                                                d="M16.5 20.5C17.3284 20.5 18 19.8284 18 19C18 18.1716 17.3284 17.5 16.5 17.5C15.6716 17.5 15 18.1716 15 19C15 19.8284 15.6716 20.5 16.5 20.5Z"
                                                fill="white" />
                                        </svg>
                                        Доступно с 21 мая</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="club40-tariffs-curr  position-relative z-20">
                        <div class="club40-tariffs__swicher-block">
                            <div class="club40-tariffs__swicher-top">
                                <p class="club40-tariffs__swicher-header">Посмотреть цены в
                                    <span>RUB</span>
                                </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" class="club40-tariffs__swicher-arrow">
                                    <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black"></path>
                                </svg>
                            </div>
                            <div class="club40-tariffs__swicher-bottom">
                                <ul>
                                    <li data-currency="rub">
                                        RUB
                                    </li>
                                    <li data-currency="eur" class="active">
                                        EUR
                                    </li>
                                </ul>
                                <p>
                                    Обратите внимание,<br> что оплата в российских рублях
                                    возможна только<br> с карты
                                    российского банка. Оплата в евро — с карты зарубежного банка
                                </p>
                            </div>
                        </div>
                    </div>
                    <a href="#form"
                        class="btn-color-main-dark-orange course41-tariffs-bottom-link position-relative z-10">Записаться на
                        бесплатную
                        неделю</a>
                </div>
            </div>`
    });
    
    blockManager.add('club40-banner-self-esteem', {
        label: 'Self-esteem banner (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club40-banner-top club40-banner-self-esteem position-absolute closed" data-href="#form"
        data-timer="no" data-redirect="no" data-url="" data-static="yes" data-offset=""
        data-timer-end="02/24/2025 12:00 GMT+0300" data-theme="light">
        <div>
            <div class="club40-banner-bg position-relative z-10">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746611745809-EPiAk-Vect.svg" alt=""
                    class="hidden-tablet-mobile position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746611912008-PwE9h-Grou.svg" alt=""
                    class="hidden-tablet-mobile position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746612352062-pC5mE-Icon.svg" alt=""
                    class="hidden-desc-mobile position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1746612427423-qAHRH-Icon.svg" alt=""
                    class="hidden-desc-tablet position-absolute">
            </div>
            <div class="club40-banner-top careerum-flex-fsc position-relative z-20">
                <div class="club40-banner-top-left">
                    <p class="club40-banner-top-header">Приглашаем на пробную неделю курса</p>
                </div>
                <div class="club40-banner-top-right">
                    <a href="#form" class="btn-color-main-dark-orange">Узнать подробнее</a>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club5-main', {
        label: 'Club 5 main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club5-main main-wrapper">
        <div class="careerum-container-responsive-wide">
            <div class="club5-main-top position-relative">
                <h1 class="position-relative z-20">Careerum. Club</h1>
                <p class="position-relative z-20">Мы помогаем перезапустить карьеру в 30+</p>
            </div>
            <div class="club5-main-center tablet careerum-flex-sbst">
                <div>
                    <div>
                        <p>Обучение</p>
                        <p>Комьюнити</p>
                        <p>Эксперты</p>
                    </div>
                    <div> <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748441652507-06zqV-Imag.svg"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748442697440-T0SD9-Back.svg"
                            class="hidden-desc-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748443387612-fL6AK-Back.svg"
                            class="hidden-desc-tablet" alt="img">
                    </div>
                </div>
                <div class="position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748682423957-Oabhu-Fram.png"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748682426418-Ulut0-Imag.png"
                        class="hidden-desc-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748682428367-u6uX3-Imag.png"
                        class="hidden-desc-tablet position-absolute" alt="img">
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748682527311-mRCrQ-Fram.png"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748682526937-yc3TH-Righ.png"
                        class="hidden-desc" alt="img">
                </div>
                <div class="position-relative">
                    <p>Образовательная платформа <span>карьерного развития </span></p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748441650888-LWszr-Vect.svg"
                        class="hidden-tablet-mobile position-absolute" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748442696276-IWQnT-Vect.svg"
                        class="hidden-desc-mobile position-absolute" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748443587600-2LiVN-Vect.svg"
                        class="hidden-desc-tablet position-absolute" alt="img">
                </div>
            </div>
            <div class="club5-main-bottom careerum-flex-sbst">
                <div class="club5-main-bottom-left position-relative">
                    <p>Не сжигать мосты, а <span>пересобрать</span> весь твой опыт в новое и классное. <br>В то, что
                        будет тебя зажигать</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748248591439-8zsm2-Grou.svg"
                        alt="" class="hidden-tablet-mobile position-absolute z-10">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748248615887-Iaa4b-Grou.svg"
                        alt="" class="hidden-desc-mobile position-absolute z-10">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748443841460-ZTMdC-Grou.svg"
                        alt="" class="hidden-desc-tablet position-absolute z-10">
                </div>
                <div class="club5-main-bottom-right">
                    <ul>
                        <li class="careerum-flex-fsc"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748250864495-UECCl-Soft.svg"
                                alt="">
                            <p>Не просто найти работу, а свое «место силы»</p>
                        </li>
                        <li class="careerum-flex-fsc"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748250864495-UECCl-Soft.svg"
                                alt="">
                            <p>Перестать сомневаться в себе и присвоить свой опыт</p>
                        </li>
                        <li class="careerum-flex-fsc"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748250864495-UECCl-Soft.svg"
                                alt="">
                            <p>Перепридумать себя в профессии, не обнуляя пройденный путь</p>
                        </li>
                        <li class="careerum-flex-fsc"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748250864495-UECCl-Soft.svg"
                                alt="">
                            <p>Выйти на новый уровень в доходе без гонки</p>
                        </li>
                        <li class="careerum-flex-fsc"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748250864495-UECCl-Soft.svg"
                                alt="">
                            <p>Перестать тревожно пахать и начать жить с чувством опоры</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="club5-main-center careerum-flex-sbst">
                <div>
                    <div>
                        <p>Обучение</p>
                        <p>Комьюнити</p>
                        <p>Эксперты</p>
                    </div>
                    <div> <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748441652507-06zqV-Imag.svg"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748442697440-T0SD9-Back.svg"
                            class="hidden-desc-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748443387612-fL6AK-Back.svg"
                            class="hidden-desc-tablet" alt="img">
                    </div>
                </div>
                <div class="position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748682423957-Oabhu-Fram.png"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748682426418-Ulut0-Imag.png"
                        class="hidden-desc-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748682428367-u6uX3-Imag.png"
                        class="hidden-desc-tablet position-absolute" alt="img">
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748682527311-mRCrQ-Fram.png"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748682526937-yc3TH-Righ.png"
                        class="hidden-desc" alt="img">
                </div>
                <div class="position-relative">
                    <p>Образовательная платформа <span>карьерного развития </span></p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748441650888-LWszr-Vect.svg"
                        class="hidden-tablet-mobile position-absolute" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748442696276-IWQnT-Vect.svg"
                        class="hidden-desc-mobile position-absolute" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748443587600-2LiVN-Vect.svg"
                        class="hidden-desc-tablet position-absolute" alt="img">
                </div>
            </div>
            <div class="club5-main-link">
                <a href="#buy" class="btn-color-main-bright-orange">Записаться в лист ожидания</a>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club5-experience', {
        label: 'Club 5 experience (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club5-experience main-wrapper">
        <div class="careerum-container-responsive-wide position-relative">
            <p class="club5-experience-top">У тебя за плечами реальный опыт, пройденные взлёты и падения. Карьера
                <span>вроде бы</span> есть. Но ты стоишь на распутье:
            </p>
            <div class="club5-experience-center careerum-flex-fsfs position-relative z-10">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748346679278-MqNbI-Prof.png" alt="">
                <p>Хочется нового этапа, но какого - непонятно. Понятно только
                    то, что по-старому уже не хочется? </p>
            </div>
            <p class="club5-experience-bottom position-relative z-30">Страшно ошибиться и снова выбрать не то</p>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748682716512-dLFn4-Vect.svg" alt=""
                class="bottom-text-bg position-absolute z-20 hidden-tablet-mobile">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748344298205-39krS-Grou.svg" alt=""
                class="center-text-bg position-absolute z-20 hidden-tablet-mobile">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748682719284-wUk4D-Vect.svg" alt=""
                class="bottom-text-bg position-absolute z-20 hidden-desc-mobile">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748424344394-eYFnz-Grou.svg" alt=""
                class="center-text-bg position-absolute z-20 hidden-desc-mobile">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748444278180-9anKn-Grou.svg" alt=""
                class="center-text-bg position-absolute z-20 hidden-desc-tablet">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748682722821-I3QAd-Vect.svg" alt=""
                class="bottom-text-bg position-absolute z-20 hidden-desc-tablet">
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club5-myths', {
        label: 'Club 5 myths (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club5-myths main-wrapper">
        <div class="careerum-container-responsive-wide">
            <div class="club5-myths-header-container position-relative">
                <h2>Просто старая модель карьеры и тебя самой больше не работает</h2>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748683018174-dfZnd-Vect.svg" alt=""
                    class="position-absolute hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748683019747-3wfk2-Vect.svg" alt=""
                    class="position-absolute hidden-desc-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748683021557-FVrP9-Vect.svg" alt=""
                    class="position-absolute hidden-desc-tablet">
            </div>
            <div class="club5-myths-items">
                <div class="club5-myths-item careerum-flex-fsst">
                    <div class="club5-myths-item-content">
                        <p class="club5-myths-item-label">Миф #1</p>
                        <p class="club5-myths-item-header">Карьера для сильных, жестких, энергичных</p>
                        <p class="club5-myths-item-subheader">Как на самом деле?</p>
                        <p class="club5-myths-item-text">Мы помогаем найти и распознать компании, где ценится
                            кооперация, доверие и синергия. И научим тебя отстаивать себя в любых обстоятельствах.</p>
                    </div>
                    <div class="club5-myths-item-img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748683442863-YLBTt-Fram.png"
                            alt="" class="hidden-tablet-mobile"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748776374698-msuZz-Imag.png"
                            alt="" class="hidden-desc-mobile"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748780981400-TIPGC-Imag.png"
                            alt="" class="hidden-desc-tablet">
                    </div>
                </div>
                <div class="club5-myths-item careerum-flex-fsst">
                    <div class="club5-myths-item-img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748683625806-hI1CT-Fram.png"
                            alt="" class="hidden-tablet-mobile"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748776375040-AwQfl-Imag.png"
                            alt="" class="hidden-desc-mobile"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748780982178-gpc0m-Imag.png"
                            alt="" class="hidden-desc-tablet">
                    </div>
                    <div class="club5-myths-item-content">
                        <p class="club5-myths-item-label">Миф #2</p>
                        <p class="club5-myths-item-header">Надо собирать в резюме престижные компании, даже если глаз не
                            горит</p>
                        <p class="club5-myths-item-subheader">Как на самом деле?</p>
                        <p class="club5-myths-item-text">Бренд на визитке может приносить уважение со стороны чужих
                            людей, но истинная самореализация происходит через смыслы в работе, опору на таланты,
                            мотиваторы и признание</p>
                    </div>
                </div>
                <div class="club5-myths-item careerum-flex-fsst">
                    <div class="club5-myths-item-content">
                        <p class="club5-myths-item-label">Миф #3</p>
                        <p class="club5-myths-item-header">Если я не расту вертикально, значит я стою на месте </p>
                        <p class="club5-myths-item-subheader">Как на самом деле?</p>
                        <p class="club5-myths-item-text">Горизонтальные переходы и портфолийная карьера — тренды
                            будущего, и один из самых сильных качественных скачков. </p>
                    </div>
                    <div class="club5-myths-item-img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748683624534-blpI3-Fram.png"
                            alt="" class="hidden-tablet-mobile"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748776375622-A29Wu-Imag.png"
                            alt="" class="hidden-desc-mobile"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748780983902-ccF1j-Imag.png"
                            alt="" class="hidden-desc-tablet">
                    </div>
                </div>
                <div class="club5-myths-item careerum-flex-fsst">
                    <div class="club5-myths-item-img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748683622383-yS12Q-Fram.png"
                            alt="" class="hidden-tablet-mobile"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748776376521-mh5LI-Imag.png"
                            alt="" class="hidden-desc-mobile"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748780985691-qoliw-Imag.png"
                            alt="" class="hidden-desc-tablet">
                    </div>
                    <div class="club5-myths-item-content">
                        <p class="club5-myths-item-label">Миф #4</p>
                        <p class="club5-myths-item-header">смена работы каждые два года завела в тупик</p>
                        <p class="club5-myths-item-subheader">Как на самом деле?</p>
                        <p class="club5-myths-item-text">Долгосрочное удовлетворение складывается из трёх элементов —
                            адекватной оплаты, вдохновляющих задач и чувства, что ты действительно вносишь вклад</p>
                    </div>
                </div>
                <div class="club5-myths-item careerum-flex-fsst">
                    <div class="club5-myths-item-content">
                        <p class="club5-myths-item-label">Миф #5</p>
                        <p class="club5-myths-item-header">Чтобы построить карьеру, нужно работать без передышки</p>
                        <p class="club5-myths-item-subheader">Как на самом деле?</p>
                        <p class="club5-myths-item-text">Отдых – полноценная часть работы. Мы помогаем уставшим
                            карьеристкам вернуть без стыда и чувства вины себе эту важную часть жизни</p>
                    </div>
                    <div class="club5-myths-item-img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748683620608-bJWZ4-Fram.png"
                            alt="" class="hidden-tablet-mobile"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748776377501-04YLg-Imag.png"
                            alt="" class="hidden-desc-mobile"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748780988333-9DDJ6-Imag.png"
                            alt="" class="hidden-desc-tablet">
                    </div>
                </div>
                <div class="club5-myths-item careerum-flex-fsst">
                    <div class="club5-myths-item-img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748683616500-56OT2-Fram.png"
                            alt="" class="hidden-tablet-mobile"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748776378631-f7hCM-Imag.png"
                            alt="" class="hidden-desc-mobile"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748780993822-7y01i-Imag.png"
                            alt="" class="hidden-desc-tablet">
                    </div>
                    <div class="club5-myths-item-content">
                        <p class="club5-myths-item-label">Миф #6</p>
                        <p class="club5-myths-item-header">Если я не стала руководителем до 40/50 лет, можно ставить
                            крест </p>
                        <p class="club5-myths-item-subheader">Как на самом деле?</p>
                        <p class="club5-myths-item-text">Каждая карьера развивается в своём ритме. Ты можешь выйти
                            на топ-уровень и в 45, и в 50 лет. Или не выйти, если поймешь, что это не твое</p>
                    </div>
                </div>
                <div class="club5-myths-item careerum-flex-fsst">
                    <div class="club5-myths-item-content">
                        <p class="club5-myths-item-label">Миф #7</p>
                        <p class="club5-myths-item-header">Менять сферу и направление в моем возрасте поздно
                            и небезопасно </p>
                        <p class="club5-myths-item-subheader">Как на самом деле?</p>
                        <p class="club5-myths-item-text">В Careerum ты увидишь варианты развития и выстроишь карьерную
                            стратегию. Целостно, на чистовик без лишних метаний по рынку</p>
                    </div>
                    <div class="club5-myths-item-img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748683618372-5MV0j-Fram.png"
                            alt="" class="hidden-tablet-mobile"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748776377972-wn62n-Imag.png"
                            alt="" class="hidden-desc-mobile"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748780990482-O2DKh-Imag.png"
                            alt="" class="hidden-desc-tablet">
                    </div>
                </div>
                <div class="club5-myths-item careerum-flex-fsst">
                    <div class="club5-myths-item-img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748683615346-9mzkW-Fram.png"
                            alt="" class="hidden-tablet-mobile"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748776378991-66HFY-Imag.png"
                            alt="" class="hidden-desc-mobile"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748780995370-Umy98-Imag.png"
                            alt="" class="hidden-desc-tablet">
                    </div>
                    <div class="club5-myths-item-content">
                        <p class="club5-myths-item-label">Миф #8</p>
                        <p class="club5-myths-item-header">После неудачи и увольнения меня не возьмут никогда и никуда
                        </p>
                        <p class="club5-myths-item-subheader">Как на самом деле?</p>
                        <p class="club5-myths-item-text">Каждый провал — это урок. Умение рассказывать на интервью,
                            как ты справилась с кризисом и что из этого вынесла, ценится даже больше, чем «гладкие»
                            биографии.</p>
                    </div>
                </div>
                <div class="club5-myths-item careerum-flex-fsst">
                    <div class="club5-myths-item-content">
                        <p class="club5-myths-item-label">Миф #9</p>
                        <p class="club5-myths-item-header">пРО ПРИЗНАНИЕ</p>
                        <p class="club5-myths-item-subheader">Как на самом деле?</p>
                        <p class="club5-myths-item-text">Общение с близкими, хобби и забота о себе — не роскошь
                            работающей женщины, а твое единственное качественное топливо для креативности, устойчивости
                            и профессионального развития.</p>
                    </div>
                    <div class="club5-myths-item-img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748683614548-wb7jc-Fram.png"
                            alt="" class="hidden-tablet-mobile"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748776379498-HyjFz-Imag.png"
                            alt="" class="hidden-desc-mobile"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748780997631-9l3Af-Imag.png"
                            alt="" class="hidden-desc-tablet">
                    </div>
                </div>
            </div>
            <div class="club5-myths-link">
                <a href="#buy" class="btn-color-main-bright-orange">Записаться в лист ожидания</a>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club5-career', {
        label: 'Club 5 career (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club5-career main-wrapper">
        <div class="careerum-container-responsive-wide">
            <h2>Твоя карьера:</h2>
            <div class="club5-career-top position-relative">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748347401887-dyomU-Grou.svg" alt=""
                    class="hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748426057709-9INSl-Grou.svg" alt=""
                    class="hidden-desc-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748512306858-PcJEF-Grou.svg" alt=""
                    class="hidden-desc-tablet">
                <div class="position-relative">
                    <div class="club5-career-top-item position-absolute careerum-flex-cc"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748684276278-qm2gQ-Fram.svg"
                            alt="" class="hidden-tablet-mobile"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748684327525-XYLyt-Icon.svg"
                            alt="" class="hidden-desc-mobile"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748684329032-yRaKe-Icon.svg"
                            alt="" class="hidden-desc-tablet">
                        <p>Не гонка</p>
                    </div>
                    <div class="club5-career-top-item position-absolute careerum-flex-cc"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748347853508-d65FU-Icon.svg"
                            alt="" class="hidden-tablet-mobile"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748426232672-9NUWV-Icon.svg"
                            alt="" class="hidden-desc-mobile"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748512407514-IRlBP-Icon.svg"
                            alt="" class="hidden-desc-tablet">
                        <p>Не чужие ожидания</p>
                    </div>
                    <div class="club5-career-top-item position-absolute careerum-flex-cc"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748347853272-6J7k6-Icon.svg"
                            alt="" class="hidden-tablet-mobile"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748426232464-Vc2A6-Icon.svg"
                            alt="" class="hidden-desc-mobile"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748512407265-JlKOK-Icon.svg"
                            alt="" class="hidden-desc-tablet">
                        <p>Не лестница</p>
                    </div>
                </div>
            </div>
            <div class="club5-career-center position-relative">
                <p>Ты можешь <span class="orange">быть любой</span> и реализовывать себя так, как хочешь<br
                        class="hidden-mobile"> и видишь
                    ты! В Careerum мы учим строить карьеру на <span class="violet">внутренней опоре</span>, с уважением
                    к своим ценностям, <span class="yellow">целям</span>, в своем ритме и балансе</p>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748348107280-8wKPq-Vect.svg"
                    class="hidden-tablet-mobile position-absolute" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748426380317-JFLQE-Vect.svg"
                    class="hidden-desc-mobile position-absolute" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748512438946-Gc8J7-Vect.svg"
                    class="hidden-desc-tablet position-absolute" alt="img">
            </div>
            <h3>Почему ты хочешь найти новую работу?</h3>
            <div class="club5-career-bottom careerum-flex-sbst">
                <div class="club5-career-bottom-left position-relative">
                    <p class="club5-career-bottom-item-header">Ты думаешь, что хочешь:</p>
                    <div class="position-absolute">
                        <p class="club5-career-bottom-item-text position-absolute">Бренд</p>
                        <p class="club5-career-bottom-item-text position-absolute">Статус</p>
                        <p class="club5-career-bottom-item-text position-absolute">Престиж</p>
                        <p class="club5-career-bottom-item-text position-absolute">Деньги</p>
                        <p class="club5-career-bottom-item-text position-absolute">Крутую роль</p>
                        <p class="club5-career-bottom-item-text position-absolute">Выше, быстрее, сильнее</p>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748684479621-ziiC8-Grou.svg"
                        alt="" class="hidden-tablet-mobile  position-absolute">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748777204700-QKHUK-Grou.svg"
                        alt="" class="hidden-desc-mobile position-absolute">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748781506656-iDg9v-Grou.svg"
                        alt="" class="hidden-desc-tablet position-absolute z-10">
                </div>
                <div class="club5-career-bottom-right position-relative z-20">
                    <p class="club5-career-bottom-item-header">А на самом деле ищешь:</p>
                    <div class="position-absolute">
                        <p class="club5-career-bottom-item-text position-absolute">Баланс</p>
                        <p class="club5-career-bottom-item-text position-absolute">Цели</p>
                        <p class="club5-career-bottom-item-text position-absolute">Огонек</p>
                        <p class="club5-career-bottom-item-text position-absolute">Легкость</p>
                        <p class="club5-career-bottom-item-text position-absolute">Интерес</p>
                        <p class="club5-career-bottom-item-text position-absolute">Смыслы</p>
                        <p class="club5-career-bottom-item-text position-absolute">Деньги</p>
                        <p class="club5-career-bottom-item-text position-absolute">Признание</p>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748684479167-3EDkn-Grou.svg"
                        alt="" class="hidden-tablet-mobile position-absolute">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748777338540-yl9Uq-Grou.svg"
                        alt="" class="hidden-desc-mobile position-absolute">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748781505603-F7VZl-Grou.svg"
                        alt="" class="hidden-desc-tablet position-absolute">
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club5-founder', {
        label: 'Club 5 founder (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club5-founder main-wrapper">
        <div class="careerum-container-responsive-wide">
            <h2>Основательница Careerum. Club</h2>
            <div class="club5-founder-wrapper careerum-flex-fsst">
                <div class="club5-founder-left">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748349908457-22htl-Imag.png"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748777904469-OwOG9-Imag.png"
                        class="hidden-desc-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748512994540-AQoMo-Imag.png"
                        class="hidden-desc-tablet" alt="img">
                </div>
                <div class="club5-founder-right">
                    <p class="club5-founder-right-header">Ольга Лермонтова</p>
                    <ul>
                        <li class="careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748685259125-cKvr6-Soft.svg"
                                alt="">
                            <p>Автор обучающих программ</p>
                        </li>
                        <li class="careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748685259125-cKvr6-Soft.svg"
                                alt="">
                            <p>Карьерный коуч и стратег с 13-летним опытом работы в пяти странах</p>
                        </li>
                        <li class="careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748685259125-cKvr6-Soft.svg"
                                alt="">
                            <p>Получает 4ое образование в сфере психологии в Гарварде</p>
                        </li>
                        <li class="careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748685259125-cKvr6-Soft.svg"
                                alt="">
                            <p>Работала в компаниях Google и Microsoft</p>
                        </li>
                        <li class="careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748685259125-cKvr6-Soft.svg"
                                alt="">
                            <p>Имеет степень MBA от бизнес-школы Insead</p>
                        </li>
                    </ul>
                    <div class="club5-founder-right-wrapper careerum-flex-fsfs">
                        <p class="club5-founder-right-quote">“</p>
                        <div>
                            <p>Для меня важно, чтобы каждая женщина, независимо от стартовых условий имела возможность
                                быть профессионально реализованной.</p>
                            <p>Именно поэтому я создала Careerum.Club — место, где с помощью точных алгоритмов, схем из
                                практики международных компаний и программ МВА, поддержки сильного профессионального
                                сообщества каждая может осознать карьеру своей мечты.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club5-form', {
        label: 'Club 5 form (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club5-form main-wrapper" data-offer-rub="11" data-offer-eur="22" data-link-rub="Оплатить участие 1000 ₽" data-link-eur="Оплатить участие 100 €">
        <div class="careerum-container-responsive-wide">
            <div class="club5-form-switcher careerum-flex-fec">
                <div class="club5-form-curr careerum-flex-fsst">
                    <ul class="careerum-flex-fsfs">
                        <li data-currency="eur">EUR</li>
                        <li data-currency="rub" class="active">RUB</li>
                    </ul>
                    <div class="club5-form-notif careerum-flex-cc">
                        <div class="club5-form-notif-icon"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                alt=""> </div>
                        <div class="club5-form-notif-content">
                            <p>Оплата в российских рублях возможна только картой российского банка. В&nbsp;евро — картой
                                зарубежного банка</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="club5-form-top careerum-flex-sbfs">
                <div class="club5-form-top-left position-relative">
                    <div class="club5-form-title">
                        <p>Мастер-класс Ольги Лермонтовой</p>
                    </div>
                    <div class="club5-form-date careerum-flex-fsfs">
                        <p>21 июня, суббота</p>
                        <p>12:00 по мск</p>
                    </div>
                    <h2>Карьерная перезагрузка 2026:</h2>
                    <p>Тренды, сценарии развития и навыки будущего</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748686508772-r2lwt-Vect.svg"
                        class="hidden-tablet-mobile position-absolute" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748778691159-Bijn9-Vect.svg"
                        class="hidden-desc-mobile position-absolute" alt="img">
                </div>
                <div class="club5-form-top-right">
                    <div class="careerum-registration-form-club40">
                        <form class="deva-form" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                            <div class="careerum-club40-form-name"> <input type="text" name="name" value="" required
                                    placeholder="Имя">
                                <p class="careerum-club40-form-warn">Поле не заполнено</p>
                            </div>
                            <div class="careerum-club40-form-email"> <input type="text" name="email" value="" required
                                    placeholder="Почта">
                                <p class="careerum-club40-form-warn">Поле не заполнено</p>
                            </div>
                            <div class="careerum-club40-form-telegram"> <input type="text" name="telegram" value=""
                                    required placeholder="Telegram">
                                <p class="careerum-club40-form-warn">Поле не заполнено</p>
                            </div>
                            <div class="careerum-club40-form-phone"> <input type="tel" value="" name="tel" required
                                    class="itl-input">
                                <p class="careerum-club40-form-warn">Поле не заполнено</p>
                            </div>
                            <div class="careerum-club40-form-agree"> <label> <input type="checkbox" name="agree">
                                    <div> <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                            fill="none">
                                            <path
                                                d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                        </svg> </div>
                                </label>
                                <p>Я принимаю условия <a href="/ru-intl/legal/offer">Оферты</a> и даю согласие
                                    на обработку персональных данных в соответствии с <a
                                        href="/ru-ru/legal/privacy">Политикой конфиденциальности</a>. </p>
                            </div> 
                            <a href="#" class="submit-btn btn-color-main-bright-orange careerum-flex-cc"
                                disabled> Оплатить участие 1000 ₽ </a>
                            <p class="careerum-club40-form-underbutton">Нажимая на кнопку, я даю согласие на обработку своих персональных данных в соответствии с <a
                                    href="/ru-ru/legal/privacy">Политикой конфиденциальности</a></p>
                            <input type="hidden" hidden name="offerID" value="" autocomplete="off">
                        </form>
                    </div>
                </div>
            </div>
            <div class="club5-form-bottom">
                <h3>Программа мастер-класса 2 часа</h3>
                <p>1. Мега-тренды рынка труда-2026</p>
                <p>2. Четыре сценария карьерного развития</p>
                <p>3. Навыки будущего: hard + soft + мета + цифровые</p>
                <p>4. Как создать свой план перезагрузки карьеры</p>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club5-what', {
        label: 'Club 5 what (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club5-what main-wrapper">
        <div class="careerum-container-responsive-wide position-relative">
            <h2>Что такое <span>Careerum. Club</span></h2>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748353696730-Kjz7l-Grou.svg"
                class="hidden-tablet-mobile" alt="img">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748428891403-63n6M-Grou.svg"
                class="hidden-desc-mobile" alt="img">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748513537253-6eQ2c-Grou.svg"
                class="hidden-desc-tablet" alt="img">
            <div class="club5-what-items position-absolute">
                <p class="position-absolute">Комьюнити</p>
                <p class="position-absolute">Сильный нетворкинг</p>
                <p class="position-absolute">Образовательный контент</p>
                <p class="position-absolute">Экспертная поддержка</p>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club5-space', {
        label: 'Club 5 space (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club5-space main-wrapper">
        <div class="careerum-container-responsive-wide">
            <h2>Careerum. Club — это пространство, где:</h2>
            <div class="careerum-flex-sbst club5-space-wrapper">
                <div class="club5-space-text">
                    <p>Карьера становится <span>личной опорой</span>, а не источником тревоги</p>
                </div>
                <div class="club5-space-img orange careerum-flex-cc">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748350583999-O3C7w-Top .svg"
                        alt="">
                </div>
                <div class="club5-space-text">
                    <p>Здесь ты найдёшь не только знания, но и <span>поддержку</span>, которая лечит и расправляет
                        крылья</p>
                </div>
                <div class="club5-space-img violet careerum-flex-cc">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748350584368-Yk5F9-Bott.svg"
                        alt="">
                </div>
                <div class="club5-space-text">
                    <p>Ты перестанешь доказывать всем и <span>начнешь выбирать себя</span></p>
                </div>
                <div class="club5-space-text">
                    <p><span>10 000+</span> профессионалок уже построили карьеру по любви</p>
                </div>
                <div class="club5-space-img violet careerum-flex-cc">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748350584259-Dyd25-Bott.svg"
                        alt="">
                </div>
            </div>
            <div class="club5-space-link">
                <a href="#buy" class="btn-color-main-bright-orange">Записаться в лист ожидания</a>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club5-start', {
        label: 'Club 5 start (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club5-start main-wrapper">
        <div class="careerum-container-responsive-wide">
            <h2>Это точка старта твоих <span>больших изменений</span>, где исчезают границы: покоряй любые компании,
                индустрии и страны</h2>
            <div class="club5-start-items careerum-flex-sbst">
                <div class="club5-start-item careerum-flex-fsfs">
                    <div class="club5-start-item-top">
                        <p>Обучение</p>
                    </div>
                    <div class="position-relative club5-start-item-bottom">
                        <p>Курсы от международных экспертов</p> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748354851465-ZaILH-Vect.svg"
                            class="hidden-tablet-mobile position-absolute" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748429324742-LajYG-Vect.svg"
                            class="hidden-desc-mobile position-absolute" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748513831755-g6M0t-Vect.svg"
                            class="hidden-desc-tablet position-absolute" alt="img">
                    </div>
                </div>
                <div class="club5-start-item careerum-flex-fsfs">
                    <div class="club5-start-item-top">
                        <p>Нетворкинг</p>
                    </div>
                    <div class="club5-start-item-bottom">
                        <p>Открытые к общению участницы из 60 стран, которые готовы делиться своим личным опытом</p>
                    </div>
                </div>
                <div class="club5-start-item careerum-flex-fsfs">
                    <div class="club5-start-item-top">
                        <p>Экспертная поддержка</p>
                    </div>
                    <div class="club5-start-item-bottom">
                        <p>Быстрое достижение целей с поддержкой практиков, которые вместо с тобой собирают твою личную
                            стратегию</p> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748354488382-kypD9-Card.png"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748429359689-99G2Y-Card.png"
                            class="hidden-desc-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748513861933-CniB9-Card.png"
                            class="hidden-desc-tablet" alt="img">
                    </div>
                </div>
            </div>
            <div class="club5-start-link">
                <a href="#buy" class="btn-color-main-bright-orange">Записаться в лист ожидания</a>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club5-we-learn', {
        label: 'Club 5 we-learn (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club5-we-learn main-wrapper">
        <div class="careerum-container-responsive-wide">
            <h2>Мы учим:</h2>
            <div class="club5-we-learn-items-top careerum-flex-fsst">
                <div class="club5-we-learn-item-top">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748355339737-pQTB3-Vect.svg"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748429621190-T8B8R-Vect.svg"
                        class="hidden-desc" alt="img">
                    <p>Опираться на свои ценности и сильные стороны </p>
                </div>
                <div class="club5-we-learn-item-top">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748355339160-gvbtf-Vect.svg"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748429620592-WCkaj-Vect.svg"
                        class="hidden-desc" alt="img">
                    <p>Найти работу мечты </p>
                </div>
                <div class="club5-we-learn-item-top position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748355339506-DLc9A-Vect.svg"
                        class="hidden-tablet-mobile position-absolute" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748429620956-yfh0r-Vect.svg"
                        class="hidden-desc position-absolute" alt="img">
                    <p>Строить карьеру без выгорания или личную практику</p>
                </div>
                <div class="club5-we-learn-item-top">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748355339396-3BOgD-Vect.svg"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748429620821-COxYp-Vect.svg"
                        class="hidden-desc" alt="img">
                    <p>Работать не 24/7, а меньше и эффективнее</p>
                </div>
                <div class="club5-we-learn-item-top">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748355339281-vbWLt-Soft.svg"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748429620704-PV2I7-Soft.svg"
                        class="hidden-desc" alt="img">
                    <p>Управлять карьерой в удовольствие</p>
                </div>
                <div class="club5-we-learn-item-top">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748687440772-F7UC9-Imag.svg"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748687467450-0uOsS-Imag.svg"
                        class="hidden-desc" alt="img">
                    <p>Расти в должности и зарплате</p>
                </div>
                <div class="club5-we-learn-item-top wide position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748687514270-jlssX-Vect.svg"
                        class="hidden-tablet-mobile position-absolute" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748779250481-z9wSp-Vect.svg"
                        class="hidden-desc-mobile position-absolute" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748782561184-0ttqk-Vect.svg"
                            class="hidden-desc-tablet position-absolute" alt="img">
                    <p>Достигать любых целей: от оффера в найме до выхода в экспертный фриланс, поиска клиентов и
                        гибкому построению карьеры</p>
                </div>
            </div>
            <div class="club5-we-learn-items-bottom hidden">
                <div class="club5-we-learn-item-bottom-wrapper careerum-flex-sbst">
                    <div class="club5-we-learn-item-bottom">
                        <div class="club5-we-learn-item-bottom-top careerum-flex-fsfs">
                            <p>5000+</p>
                            <p>офферов</p>
                        </div>
                        <p>Уже получили с помощью клуба</p>
                    </div>
                    <div class="club5-we-learn-item-bottom">
                        <div class="club5-we-learn-item-bottom-top careerum-flex-fsfs">
                            <p>70%</p>
                            <p>средний рост</p>
                        </div>
                        <p>Дохода участников</p>
                    </div>
                    <div class="club5-we-learn-item-bottom">
                        <div class="club5-we-learn-item-bottom-top careerum-flex-fsfs">
                            <p>300%</p>
                            <p>рекордное</p>
                        </div>
                        <p>Увеличение зарплаты наших участников</p>
                    </div>
                    <div class="club5-we-learn-item-bottom wide">
                        <div class="club5-we-learn-item-bottom-top careerum-flex-fsfs">
                            <p>500+</p>
                            <p>релокаций</p>
                        </div>
                        <p>В страну мечты — даже в пандемию</p>
                    </div>
                    <div class="club5-we-learn-item-bottom wide">
                        <div class="club5-we-learn-item-bottom-top careerum-flex-fsfs">
                            <p>55%</p>
                            <p>участников</p>
                        </div>
                        <p>Укрепили самооценку уже в первый месяц </p>
                    </div>
                </div>
            </div>
            <div class="club5-we-learn-link">
                <a href="#buy" class="btn-color-main-bright-orange">Записаться в лист ожидания</a>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club5-got', {
        label: 'Club 5 got (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club5-got main-wrapper">
        <div class="careerum-container-responsive-wide">
            <h2>В Careerum.Club ты получишь:</h2>
            <div class="club5-got-items-top careerum-flex-fsst">
                <div class="club5-got-item">
                    <div class="club5-got-item-top careerum-flex-fsc orange"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748356318443-qwv1y-Fram.svg"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748431048563-GOolE-Fram.svg"
                            class="hidden-desc-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748515119781-bPf5U-Fram.svg"
                            class="hidden-desc-tablet" alt="img">
                        <p>6 флагманских программ</p>
                    </div>
                    <div class="club5-got-item-bottom">
                        <p>6 флагманских программ, ежемесячные интенсивы и годовая программа развития карьеры</p>
                    </div>
                </div>
                <div class="club5-got-item">
                    <div class="club5-got-item-top careerum-flex-fsc violet"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748356318322-FEbrM-Fram.svg"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748431048445-QdBgq-Fram.svg"
                            class="hidden-desc-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748515119680-e1cW5-Fram.svg"
                            class="hidden-desc-tablet" alt="img">
                        <p>Онлайн-эфиры</p>
                    </div>
                    <div class="club5-got-item-bottom">
                        <p>Живые эфиры, онлайн-практикумы, Meet UP дни </p>
                    </div>
                </div>
                <div class="club5-got-item ">
                    <div class="club5-got-item-top careerum-flex-fsc orange"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748356318200-oOJ11-Fram.svg"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748431048337-4bTSu-Fram.svg"
                            class="hidden-desc-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748515119309-CffQw-Fram.svg"
                            class="hidden-desc-tablet" alt="img">
                        <p>Консультации</p>
                    </div>
                    <div class="club5-got-item-bottom">
                        <p>Индивидуальные карьерные консультации и экспертное сопровождение </p>
                    </div>
                </div>
                <div class="club5-got-item ">
                    <div class="club5-got-item-top careerum-flex-fsc violet"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748356318083-6IPaj-Fram.svg"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748431048232-DU8Tv-Fram.svg"
                            class="hidden-desc-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748515119200-gmcvH-Fram.svg"
                            class="hidden-desc-tablet" alt="img">
                        <p>AI-помощники</p>
                    </div>
                    <div class="club5-got-item-bottom">
                        <p>Резюме-валидатор, тренер по интервью, промпты для сильного резюме</p>
                    </div>
                </div>
                <div class="club5-got-item ">
                    <div class="club5-got-item-top careerum-flex-fsc orange"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748356317960-yNmw2-Fram.svg"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748431048117-xGY8F-Fram.svg"
                            class="hidden-desc-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748515119091-IpOlx-Fram.svg"
                            class="hidden-desc-tablet" alt="img">
                        <p>Платформа</p>
                    </div>
                    <div class="club5-got-item-bottom">
                        <p>Удобная обучающая платформа: постоянные обновления и мобильное приложение</p>
                    </div>
                </div>
                <div class="club5-got-item ">
                    <div class="club5-got-item-top careerum-flex-fsc violet"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748356317726-Wz3fC-Fram.svg"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748431047876-iXz3u-Fram.svg"
                            class="hidden-desc-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748515118977-AnfUY-Fram.svg"
                            class="hidden-desc-tablet" alt="img">
                        <p>Комьюнити</p>
                    </div>
                    <div class="club5-got-item-bottom">
                        <p>Мощное комьюнити: онлайн-нетворкинг и оффлайн в разных странах, Coffee Buddy, английский
                            разговорный клуб</p>
                    </div>
                </div>
            </div>
            <div class="club5-got-link">
                <a href="#buy" class="btn-color-main-bright-orange">Записаться в лист ожидания</a>
            </div>
            <div class="club5-got-items-bottom careerum-flex-fsst">
                <div class="club5-got-item-bottom-left position-relative">
                    <p><span>НЕ ОБЯЗАТЕЛЬНО</span> СТРОИТЬ КАРЬЕРУ В ОДИНОЧКУ</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748356444379-sHLNj-Illu.svg"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748431629166-NWY59-Imag.svg"
                        class="hidden-desc" alt="img">
                </div>
                <div class="club5-got-item-bottom-right">
                    <p>В сообществе Careerum.Club умные и открытые к общению специалисты готовы делиться своим личным
                        и профессиональным опытом </p>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club5-places', {
        label: 'Club 5 places (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club5-places main-wrapper hidden-mobile">
        <div class="careerum-container-responsive-wide">
            <h2>А еще наши участники дружат оффлайн в разных странах и проводят живые встречи и бизнес-завтраки в своих
                городах</h2>
            <div class="club5-places-wrapper position-relative">
                <p class="position-absolute">600+ участников</p>
                <p class="position-absolute">60+ стран</p>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748357408864-wrZfh-Fram.png"
                    class="hidden-tablet-mobile" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748432431733-I03uq-Fram.png"
                    class="hidden-desc-mobile" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/" class="hidden-desc-tablet" alt="img">
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club5-professions', {
        label: 'Club 5 professions (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club5-professions main-wrapper">
        <div class="careerum-container-responsive-wide">
            <h2>Мы не гонимся за красивыми брендами и всегда на твоей стороне, чтобы любая работа — в Apple или в
                собственной мастерской — <span>была тебе в кайф</span></h2>
            <div class="club5-professions-items careerum-flex-sbst">
                <div class="club5-professions-item careerum-flex-fsfs">
                    <div class="club5-professions-item-top">
                        <p>Отрасли</p>
                    </div>
                    <div class="club5-professions-item-bottom hidden-tablet-mobile">
                        <div class="careerum-flex-fsfs">
                            <p>Банки</p>
                            <p>Недвижимость</p>
                            <p>Информационные технологии</p>
                            <p>Телекоммуникация</p>
                            <p>Реклама</p>
                            <p>Консалтинг</p>
                            <p>Сырьевые рынки</p>
                            <p>Фармацевтика и биотехнологии</p>
                            <p>Пищевое производство</p>
                            <p>ТВ</p>
                            <p>Автобизнес</p>
                            <p>Образование</p>
                            <p>Энергетика</p>
                            <p>Металлургия</p>
                            <p>Строительство</p>
                            <p>Мода</p>
                            <p>Реклама</p>
                        </div>
                    </div>
                    <div class="club5-professions-item-bottom hidden-desc">
                        <div class="careerum-flex-fsfs">
                            <p>Банки</p>
                            <p>Энергетика</p>
                            <p>Недвижимость</p>
                            <p>Мода</p>
                            <p>Информационные технологии</p>
                            <p>Фармацевтика и биотехнологии</p>
                            <p>ТВ</p>
                            <p>Телекоммуникация</p>
                            <p>Реклама</p>
                            <p>Консалтинг</p>
                            <p>Сырьевые рынки</p>
                            <p>Пищевое производство</p>
                            <p>Автобизнес</p>
                            <p>Образование</p>
                            <p>Металлургия</p>
                            <p>Строительство</p>
                            <p>Реклама</p>
                        </div>
                    </div>
                </div>
                <div class="club5-professions-item careerum-flex-fsfs">
                    <div class="club5-professions-item-top">
                        <p>Профессии</p>
                    </div>
                    <div class="club5-professions-item-bottom careerum-flex-fsfs">
                        <div class="careerum-flex-fsfs">
                            <p>Маркетолог</p>
                            <p>СММ</p>
                            <p>Юрист</p>
                            <p>Микробиолог</p>
                            <p>Экономист</p>
                            <p>Программист</p>
                            <p>Бухгалтер</p>
                            <p>Офис-менеджер</p>
                            <p>Инженер</p>
                            <p>Горный инженер</p>
                            <p>Проджект менеджер</p>
                            <p>Финансовый директор</p>
                            <p>Финансовый специалист</p>
                            <p>Менеджер по продажам</p>
                            <p>Кредитный специалист</p>
                            <p>Генеральный директор</p>
                            <p>Менеджер по закупкам</p>
                        </div>
                    </div>
                </div>
                <div class="club5-professions-item careerum-flex-fsfs">
                    <div class="club5-professions-item-top">
                        <p>Компании</p>
                    </div>
                    <div class="club5-professions-item-bottom"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748358953330-SEkY5-Comp.png"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748433513400-KMQKG-Comp.png"
                            class="hidden-desc-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748515980291-578QQ-Comp.png"
                            class="hidden-desc-tablet" alt="img">
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club5-results', {
        label: 'Club 5 results (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club5-results main-wrapper">
        <div class="careerum-container-responsive-wide">
            <h2>Результаты наших участников</h2>
            <div class="club5-results-items-wrapper">
                <div class="club5-results-items">
                    <div class="club5-results-item"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748359429552-sLR6z-phot.png"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748433883480-GGpVd-Fram.png"
                            class="hidden-desc-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748516920462-p1UVp-Fram.png"
                            class="hidden-desc-tablet" alt="img">
                        <p class="club5-results-item-name">Юлия Кормановская</p>
                        <p class="club5-results-item-position">Account Manager, Германия</p>
                        <div class="club5-results-item-line"></div>
                        <p class="club5-results-item-about">Мечта о международной карьере, непонимание, как достичь этой
                            цели</p>
                        <div class="club5-results-item-result careerum-flex-fsc"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748360189833-ODnQI-Chec.svg"
                                alt="">
                            <p>Результат с Careerum: </p>
                        </div>
                        <ul>
                            <li>Выросла в должности и доходе на 13%, получила новый контракт в Германии на 4 года</li>
                            <li>Научилась позиционировать свою экспертизу</li>
                            <li>Прокачала навык переговоров по офферу</li>
                        </ul>
                    </div>
                    <div class="club5-results-item"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748359429964-NpZI3-phot.png"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748433883925-rKZiq-Fram.png"
                            class="hidden-desc-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748516921577-P3QQM-Fram.png"
                            class="hidden-desc-tablet" alt="img">
                        <p class="club5-results-item-name">Александра Воробьева</p>
                        <p class="club5-results-item-position">Finance manager, Турция</p>
                        <div class="club5-results-item-line"></div>
                        <p class="club5-results-item-about">Переживала из-за синдрома самозванца и неуверенности в себе
                        </p>
                        <div class="club5-results-item-result careerum-flex-fsc"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748360189833-ODnQI-Chec.svg"
                                alt="">
                            <p>Результат с Careerum: </p>
                        </div>
                        <ul>
                            <li>Получила работу в компании мечты, увеличила доход на 40%</li>
                            <li>Научилась позиционировать свою экспертизу</li>
                            <li>Научилась в свою пользу защищать идеи и задачи</li>
                        </ul>
                    </div>
                    <div class="club5-results-item"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748688145464-0oZo8-phot.png"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748688156632-cu60A-Fram.png"
                            class="hidden-desc-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748688165286-dYvpk-Fram.png"
                            class="hidden-desc-tablet" alt="img">
                        <p class="club5-results-item-name">Олег Федоткин</p>
                        <p class="club5-results-item-position">Head of Department, Германия</p>
                        <div class="club5-results-item-line"></div>
                        <p class="club5-results-item-about">Не мог найти работу в Германии, не хотел возвращаться в
                            Москву после окончания контракта Henkel</p>
                        <div class="club5-results-item-result careerum-flex-fsc"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748360189833-ODnQI-Chec.svg"
                                alt="">
                            <p>Результат с Careerum: </p>
                        </div>
                        <ul>
                            <li>Получил оффер на head-позицию с ростом зарплаты на 30% в начале 2022 года</li>
                            <li>Прорабатывал запрос в паре с участником клуба</li>
                        </ul>
                    </div>
                    <div class="club5-results-item"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748359430827-13HD7-phot.png"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748433884178-kENfj-Fram.png"
                            class="hidden-desc-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748516923152-hJZ1e-Fram.png"
                            class="hidden-desc-tablet" alt="img">
                        <p class="club5-results-item-name">Виктория Сагина</p>
                        <p class="club5-results-item-position">Planning Specialist, Россия</p>
                        <div class="club5-results-item-line"></div>
                        <p class="club5-results-item-about">Хотела сменить работу, сомневалась в своих силах, не знала,
                            как найти компанию с подходящими ценностями</p>
                        <div class="club5-results-item-result careerum-flex-fsc"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748360189833-ODnQI-Chec.svg"
                                alt="">
                            <p>Результат с Careerum: </p>
                        </div>
                        <ul>
                            <li>Оффер и рост зарплаты на 50%</li>
                            <li>Научилась позиционировать свою экспертизу</li>
                            <li>Научилась вести переговоры по офферу</li>
                        </ul>
                    </div>
                    <div class="club5-results-item"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748359430221-XnMTY-phot.png"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748433884805-MGLef-Fram.png"
                            class="hidden-desc-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748516924282-iNUJ7-Fram.png"
                            class="hidden-desc-tablet" alt="img">
                        <p class="club5-results-item-name">Екатерина Козлова</p>
                        <p class="club5-results-item-position">Head of Customer Service & Account Management, Россия
                        </p>
                        <div class="club5-results-item-line"></div>
                        <p class="club5-results-item-about">Декрет, была в состоянии выгорания, не понимала, чего хочет
                            в работе</p>
                        <div class="club5-results-item-result careerum-flex-fsc"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748360189833-ODnQI-Chec.svg"
                                alt="">
                            <p>Результат с Careerum: </p>
                        </div>
                        <ul>
                            <li>Вышла из декрета с минимальным стрессом, вернулась к работе с ростом зарплаты на 7%</li>
                            <li>Научилась аргументировать свою позицию перед руководителем</li>
                            <li>Прокачала навык переговоров</li>
                        </ul>
                    </div>
                    <div class="club5-results-item"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748688446271-aSGFH-phot.png"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748688445767-kfqSt-Fram.png"
                            class="hidden-desc-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748688463993-m8Ra4-Fram.png"
                            class="hidden-desc-tablet" alt="img">
                        <p class="club5-results-item-name">Сергей Бухаров</p>
                        <p class="club5-results-item-position">Supply Chain Forecast Analyst, Нидерланды </p>
                        <div class="club5-results-item-line"></div>
                        <p class="club5-results-item-about">Уволился из Mars весной 2022 года, так как не смог
                            договориться о релокации, переехал из России в Грузию</p>
                        <div class="club5-results-item-result careerum-flex-fsc"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748360189833-ODnQI-Chec.svg"
                                alt="">
                            <p>Результат с Careerum: </p>
                        </div>
                        <ul>
                            <li>Прошел курс Real Me, персонально работал c экспертом клуба, составил стратегию</li>
                            <li>Получил оффер от Mars с релокацией в Нидерланды в середине 2022 года</li>
                        </ul>
                    </div>
                    <div class="club5-results-item"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748359431262-jP8yP-phot.png"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748433884432-Kxf56-Fram.png"
                            class="hidden-desc-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748516926005-178Fp-Fram.png"
                            class="hidden-desc-tablet" alt="img">
                        <p class="club5-results-item-name">Анна Лисина</p>
                        <p class="club5-results-item-position">Сontent & Marketing Director, Колумбия</p>
                        <div class="club5-results-item-line"></div>
                        <p class="club5-results-item-about">Желание развивать карьеру в маркетинге и вырасти в должности
                        </p>
                        <div class="club5-results-item-result careerum-flex-fsc"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748360189833-ODnQI-Chec.svg"
                                alt="">
                            <p>Результат с Careerum: </p>
                        </div>
                        <ul>
                            <li>Повышение внутри компании до Creative & Brand Marketing Lead</li>
                            <li>Улучшила навыки публичных выступлений и защиты проектов</li>
                            <li>Прокачала навык переговоров</li>
                        </ul>
                    </div>
                    <div class="club5-results-item"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748359432132-XOY9i-phot.png"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748433885209-CAeOj-Fram.png"
                            class="hidden-desc-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748516927764-Rrp33-Fram.png"
                            class="hidden-desc-tablet" alt="img">
                        <p class="club5-results-item-name">Екатерина Савченко</p>
                        <p class="club5-results-item-position">PhD студентка, Университет Мангейма, Германия</p>
                        <div class="club5-results-item-line"></div>
                        <p class="club5-results-item-about">Неуверенность, выгорание, страх конкуренции в Германии</p>
                        <div class="club5-results-item-result careerum-flex-fsc"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748360189833-ODnQI-Chec.svg"
                                alt="">
                            <p>Результат с Careerum: </p>
                        </div>
                        <ul>
                            <li>Выросла до PhD студента, yвеличила доход на 38% </li>
                            <li>Научилась перезентовать свои достижения и результаты руководителю</li>
                        </ul>
                    </div>
                    <div class="club5-results-item"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748359432132-XOY9i-phot.png"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748433885632-iKHcg-Fram.png"
                            class="hidden-desc-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748516928495-HW2Kn-Fram.png"
                            class="hidden-desc-tablet" alt="img">
                        <p class="club5-results-item-name">Анастасия Сергиенко</p>
                        <p class="club5-results-item-position">Senior Consultant, Camelot IT lab, Германия </p>
                        <div class="club5-results-item-line"></div>
                        <p class="club5-results-item-about">Стремилась построитьмеждународную карьеру и вырасти в доходе
                        </p>
                        <div class="club5-results-item-result careerum-flex-fsc"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748360189833-ODnQI-Chec.svg"
                                alt="">
                            <p>Результат с Careerum: </p>
                        </div>
                        <ul>
                            <li>Релоцировалась в Германию, выросла в доходе в 2 раза </li>
                            <li>Научилась перезентовать свои достижения и экспертизу</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="club5-results-link">
                <a href="#buy" class="btn-color-main-bright-orange">Записаться в лист ожидания</a>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club5-how', {
        label: 'Club 5 how (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club5-how main-wrapper">
        <div class="careerum-container-responsive-wide">
            <h2>Как проходит обучение в Careerum.Club</h2>
            <div class="club5-how-wrapper">
                <ul>
                    <li class="careerum-flex-fsfs"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748360566269-LDIjf-Soft.svg"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748434320249-OjfSt-Soft.svg"
                            class="hidden-desc" alt="img">
                        <p>У нас продуманные карьерные программы для тех, кто не боится менять свою траекторию на 180°
                        </p>
                    </li>
                    <li class="careerum-flex-fsfs"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748360566269-LDIjf-Soft.svg"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748434320249-OjfSt-Soft.svg"
                            class="hidden-desc" alt="img">
                        <p>Каждый трек — живой, рабочий и под твои реальные цели: хочешь — идёшь по готовому маршруту
                            Хочешь — собираешь свой кастомный микс</p>
                    </li>
                    <li class="careerum-flex-fsfs"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748360566269-LDIjf-Soft.svg"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748434320249-OjfSt-Soft.svg"
                            class="hidden-desc" alt="img">
                        <p>Годовая программа, поддержка комьюнити и экспертов, которые помогут вытащить из любой
                            программы максимум</p>
                    </li>
                    <li class="careerum-flex-fsfs"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748360566269-LDIjf-Soft.svg"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748434320249-OjfSt-Soft.svg"
                            class="hidden-desc" alt="img">
                        <p>Ты не просто учишься, а строишь свою новую карьерную реальность</p>
                    </li>
                </ul>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club5-track', {
        label: 'Club 5 track (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club5-track main-wrapper">
        <div class="careerum-container-responsive-wide">
            <h2>Выбери свой карьерный трек</h2>
            <div class="club5-track-items careerum-flex-sbst">
                <div class="club5-track-item">
                    <p class="club5-track-item-header">Real Me 2.0. </p>
                    <p class="club5-track-item-text">Твоя карьерная перезагрузка. Найди своё дело по любви и пойми, в
                        чём твоя настоящая сила</p>
                    <ul>
                        <li class="careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676075-L3TYK-Care.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676379-ebXR9-Care.svg"
                                class="hidden-desc" alt="img">
                            <p>Выйдешь из карьерного кризиса и тупика</p>
                        </li>
                        <li class="careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676075-L3TYK-Care.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676379-ebXR9-Care.svg"
                                class="hidden-desc" alt="img">
                            <p>Найдёшь свои таланты, ценности и истинную мотивацию</p>
                        </li>
                        <li class="careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676075-L3TYK-Care.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676379-ebXR9-Care.svg"
                                class="hidden-desc" alt="img">
                            <p>Изучишь рынок и найдёшь работу без стресса с опорой на ценности и смыслы</p>
                        </li>
                    </ul>
                </div>
                <div class="club5-track-item">
                    <p class="club5-track-item-header">Звёздный кандидат</p>
                    <p class="club5-track-item-text">Твой профиль сильного игрока. Навыки и стратегии, чтобы стать
                        заметным для топ-работодателей</p>
                    <ul>
                        <li class="careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676075-L3TYK-Care.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676379-ebXR9-Care.svg"
                                class="hidden-desc" alt="img">
                            <p>Создашь сильное портфолио, резюме, профиль в Linkedin</p>
                        </li>
                        <li class="careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676075-L3TYK-Care.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676379-ebXR9-Care.svg"
                                class="hidden-desc" alt="img">
                            <p>Научишься проходить любые собеседования</p>
                        </li>
                        <li class="careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676075-L3TYK-Care.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676379-ebXR9-Care.svg"
                                class="hidden-desc" alt="img">
                            <p>Сможешь договаривать об оффере на своих условиях</p>
                        </li>
                    </ul>
                </div>
                <div class="club5-track-item">
                    <p class="club5-track-item-header">Portfolio Career</p>
                    <p class="club5-track-item-text">Гибкая карьера вне найма по твоим правилам. Станешь независимой
                        от одного работодателя</p>
                    <ul>
                        <li class="careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676075-L3TYK-Care.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676379-ebXR9-Care.svg"
                                class="hidden-desc" alt="img">
                            <p>Станешь свободнее и увереннее, без привязки к одному работодателю</p>
                        </li>
                        <li class="careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676075-L3TYK-Care.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676379-ebXR9-Care.svg"
                                class="hidden-desc" alt="img">
                            <p>Соберёшь уникальный микс из разнопрофильных проектов под свои цели</p>
                        </li>
                        <li class="careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676075-L3TYK-Care.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676379-ebXR9-Care.svg"
                                class="hidden-desc" alt="img">
                            <p>Выберешь что тебе ближе: экспертный фриланс, портфельная карьера, предпринимательство</p>
                        </li>
                    </ul>
                </div>
                <div class="club5-track-item">
                    <p class="club5-track-item-header">Go Global</p>
                    <p class="club5-track-item-text">Работай там, где хочешь жить. Релокация и международная карьера для
                        всех профессий</p>
                    <ul>
                        <li class="careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676075-L3TYK-Care.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676379-ebXR9-Care.svg"
                                class="hidden-desc" alt="img">
                            <p>Выберешь страну для своих карьерных целей и амбиций</p>
                        </li>
                        <li class="careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676075-L3TYK-Care.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676379-ebXR9-Care.svg"
                                class="hidden-desc" alt="img">
                            <p>Адаптируешь резюме и опыт под разные культуры и глобальные компании</p>
                        </li>
                        <li class="careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676075-L3TYK-Care.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676379-ebXR9-Care.svg"
                                class="hidden-desc" alt="img">
                            <p>Изучишь нюансы найма на международных рынках труда, научишься их применять в свою пользу
                            </p>
                        </li>
                    </ul>
                </div>
                <div class="club5-track-item top">
                    <p class="club5-track-item-header">Карьерная ракета</p>
                    <p class="club5-track-item-text">Лаборатория софт-скиллов будущего для развития и управления
                        карьерой</p>
                    <ul>
                        <li class="careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748779743270-Dr0Fq-Soft.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748779743270-Dr0Fq-Soft.svg"
                                class="hidden-desc" alt="img">
                            <p>Как эффективно проходить отборы в компании</p>
                        </li>
                        <li class="careerum-flex-fsfs"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748779743270-Dr0Fq-Soft.svg"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748779743270-Dr0Fq-Soft.svg"
                            class="hidden-desc" alt="img">
                            <p>Управлять карьерой как проектом, составлять план развития, расти через цели</p>
                        </li>
                        <li class="careerum-flex-fsfs"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748779743270-Dr0Fq-Soft.svg"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748779743270-Dr0Fq-Soft.svg"
                            class="hidden-desc" alt="img">
                            <p>Пробиваем ЗП потолок</p>
                        </li>
                        <li class="careerum-flex-fsfs"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748779743270-Dr0Fq-Soft.svg"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748779743270-Dr0Fq-Soft.svg"
                            class="hidden-desc" alt="img">
                            <p>Карьерные навыки будущего</p>
                        </li>
                        <li class="careerum-flex-fsfs"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748779743270-Dr0Fq-Soft.svg"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748779743270-Dr0Fq-Soft.svg"
                            class="hidden-desc" alt="img">
                            <p>Коммуникации и эмоциональный интеллект</p>
                        </li>
                    </ul>
                </div>
                <div class="club5-track-item">
                    <p class="club5-track-item-header">Power Talk </p>
                    <p class="club5-track-item-text">Прорыв в карьере через коммуникации : управляй переговорами,
                        конфликтами и своим статусом в команде</p>
                    <ul>
                        <li class="careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676075-L3TYK-Care.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676379-ebXR9-Care.svg"
                                class="hidden-desc" alt="img">
                            <p>Научишься уверенно доносить свои идеи без неловкости</p>
                        </li>
                        <li class="careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676075-L3TYK-Care.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676379-ebXR9-Care.svg"
                                class="hidden-desc" alt="img">
                            <p>Укрепишь профессиональные границы и сможешь противостоять токсичным собеседникам на всех
                                уровнях</p>
                        </li>
                        <li class="careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676075-L3TYK-Care.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676379-ebXR9-Care.svg"
                                class="hidden-desc" alt="img">
                            <p>Станешь мастером переговоров: от линейных сотрудников внутри отдела до внешних партнёров
                                и топ-руководителей</p>
                        </li>
                    </ul>
                </div>
                <div class="club5-track-item">
                    <p class="club5-track-item-header">Boss girl</p>
                    <p class="club5-track-item-text">Станешь уверенным лидером, руководителем и сможешь вести за собой
                        людей</p>
                    <ul>
                        <li class="careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676075-L3TYK-Care.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676379-ebXR9-Care.svg"
                                class="hidden-desc" alt="img">
                            <p>Прокачаешь лидерские навыки, стратегию и управление командой</p>
                        </li>
                        <li class="careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676075-L3TYK-Care.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676379-ebXR9-Care.svg"
                                class="hidden-desc" alt="img">
                            <p>Научишься выстраивать среду доверия и вдохновлять людей на результат</p>
                        </li>
                        <li class="careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676075-L3TYK-Care.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676379-ebXR9-Care.svg"
                                class="hidden-desc" alt="img">
                            <p>Овладеешь инструментами для управления сложными рабочими ситуациями</p>
                        </li>
                    </ul>
                </div>
                <div class="club5-track-item">
                    <p class="club5-track-item-header">Money Map</p>
                    <p class="club5-track-item-text">Управляй своими деньгами в любом формате карьеры: от найма до
                        фриланса</p>
                    <ul>
                        <li class="careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676075-L3TYK-Care.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676379-ebXR9-Care.svg"
                                class="hidden-desc" alt="img">
                            <p>Научишься создавать капитал на будущее и не бояться перемен в доходе</p>
                        </li>
                        <li class="careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676075-L3TYK-Care.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676379-ebXR9-Care.svg"
                                class="hidden-desc" alt="img">
                            <p>Деньги для фрилансеров и стратегии на случай нестабильного дохода</p>
                        </li>
                        <li class="careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676075-L3TYK-Care.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676379-ebXR9-Care.svg"
                                class="hidden-desc" alt="img">
                            <p>Научишься повышать прайс без стеснения и неловкости</p>
                        </li>
                    </ul>
                </div>
                <div class="club5-track-item">
                    <p class="club5-track-item-header">PULSE & PAUSE</p>
                    <p class="club5-track-item-text">Wellness-практики для тех, кто очень много работает и совсем не
                        даёт себе качественно отдыхать</p>
                    <ul>
                        <li class="careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676075-L3TYK-Care.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676379-ebXR9-Care.svg"
                                class="hidden-desc" alt="img">
                            <p>Поставишь отдых в приоритет без чувства вины</p>
                        </li>
                        <li class="careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676075-L3TYK-Care.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676379-ebXR9-Care.svg"
                                class="hidden-desc" alt="img">
                            <p>Станешь меньше работать без потери в доходе </p>
                        </li>
                        <li class="careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676075-L3TYK-Care.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676379-ebXR9-Care.svg"
                                class="hidden-desc" alt="img">
                            <p>Проработаешь границы и стресс-менеджмент</p>
                        </li>
                    </ul>
                </div>
                <div class="club5-track-item">
                    <p class="club5-track-item-header">POWER & MONEY</p>
                    <p class="club5-track-item-text">Укрепишь профессиональную самооценку, чтобы расти в доходе без
                        внутреннего критика</p>
                    <ul>
                        <li class="careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676075-L3TYK-Care.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676379-ebXR9-Care.svg"
                                class="hidden-desc" alt="img">
                            <p>Вырастишь внутреннюю устойчивость и сможешь продавать свои услуги дорого</p>
                        </li>
                        <li class="careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676075-L3TYK-Care.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676379-ebXR9-Care.svg"
                                class="hidden-desc" alt="img">
                            <p>Научишься выигрывать в переговорах о деньгах </p>
                        </li>
                        <li class="careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676075-L3TYK-Care.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748689676379-ebXR9-Care.svg"
                                class="hidden-desc" alt="img">
                            <p>Перестанешь сомневаться в своей экспертизе и начнёшь быстро расти в роли/финансах/карьере
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="club5-track-link">
                <a href="#buy" class="btn-color-main-bright-orange">Записаться в лист ожидания</a>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club5-calendar', {
        label: 'Club 5 calendar (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club5-calendar main-wrapper">
        <div class="careerum-container-responsive-wide">
            <h2>Ближайшие мероприятия</h2>
            <div class="club5-calendar-intensive position-relative">
                <div class="club5-calendar-intensive-top careerum-flex-fsc">
                    <p class="club5-calendar-intensive-type">Интенсив</p>
                    <p class="club5-calendar-intensive-date">Старт 24 июня</p>
                </div>
                <p class="club5-calendar-intensive-header">Real Me 2.0 / Второе дыхание</p>
                <p class="club5-calendar-intensive-text">После 35+ всё меняется. Это интенсив-переосмысление. Как
                    перепридумать себя в работе, выйти из «переломного» и найти новую роль или донасытить текущую</p>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748362373343-3oted-Upco.svg"
                    class="hidden-tablet-mobile position-absolute" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748435107385-YZTsX-Puzz.svg"
                    class="hidden-desc-mobile position-absolute" alt="img">
            </div>
            <div class="club5-calendar-items">
                <div class="club5-calendar-item">
                    <div class="club5-calendar-item-header careerum-flex-fsc">
                        <p>Блок 1 </p>
                        <p>Сонастройка перед путешествием</p>
                    </div>
                    <div class="club5-calendar-item-row  careerum-flex-sbst">
                        <div>
                            <p class="club5-calendar-item-row-header">1.1 Ваша отправная точка</p>
                        </div>
                        <div>
                            <p class="club5-calendar-item-row-text">Видеолекция</p>
                        </div>
                    </div>
                    <div class="club5-calendar-item-row  careerum-flex-sbst">
                        <div>
                            <p class="club5-calendar-item-row-header">Карьерные стадии и запрос на программу</p>
                        </div>
                        <div>
                            <p class="club5-calendar-item-row-text">Тест</p>
                        </div>
                    </div>
                    <div class="club5-calendar-item-row  careerum-flex-sbst">
                        <div>
                            <p class="club5-calendar-item-row-header">1.2 Стопперы самоопределения</p>
                        </div>
                        <div>
                            <p class="club5-calendar-item-row-text">Видеолекция</p>
                        </div>
                    </div>
                    <div class="club5-calendar-item-row  careerum-flex-sbst">
                        <div>
                            <p class="club5-calendar-item-row-header">Все об установках</p>
                        </div>
                        <div>
                            <p class="club5-calendar-item-row-text">Тест</p>
                        </div>
                    </div>
                </div>
                <div class="club5-calendar-item">
                    <div class="club5-calendar-item-header careerum-flex-fsc">
                        <p>Блок 2</p>
                        <p>Блок «Могу»</p>
                    </div>
                    <div class="club5-calendar-item-row  careerum-flex-sbst">
                        <div>
                            <p class="club5-calendar-item-row-header">2.1 Что блокирует ваше «Могу»</p>
                        </div>
                        <div>
                            <p class="club5-calendar-item-row-text">Лекция</p>
                        </div>
                    </div>
                    <div class="club5-calendar-item-row  careerum-flex-sbst">
                        <div>
                            <p class="club5-calendar-item-row-header">2.2 Навыки и опыт</p>
                        </div>
                        <div>
                            <p class="club5-calendar-item-row-text">Видеолекция</p>
                        </div>
                    </div>
                    <div class="club5-calendar-item-row  careerum-flex-sbst">
                        <div>
                            <p class="club5-calendar-item-row-header">Навыки и опыт</p>
                        </div>
                        <div>
                            <p class="club5-calendar-item-row-text">Тест</p>
                        </div>
                    </div>
                    <div class="club5-calendar-item-row  careerum-flex-sbst">
                        <div>
                            <p class="club5-calendar-item-row-header">2.3 Знания</p>
                        </div>
                        <div>
                            <p class="club5-calendar-item-row-text">Видеолекция</p>
                        </div>
                    </div>
                    <div class="club5-calendar-item-row  careerum-flex-sbst">
                        <div>
                            <p class="club5-calendar-item-row-header">Типы знаний</p>
                        </div>
                        <div>
                            <p class="club5-calendar-item-row-text">Тест</p>
                        </div>
                    </div>
                    <div class="club5-calendar-item-row  careerum-flex-sbst">
                        <div>
                            <p class="club5-calendar-item-row-header">2.4 Таланты</p>
                        </div>
                        <div>
                            <p class="club5-calendar-item-row-text">Видеолекция</p>
                        </div>
                    </div>
                    <div class="club5-calendar-item-row  careerum-flex-sbst">
                        <div>
                            <p class="club5-calendar-item-row-header">Таланты и их признаки</p>
                        </div>
                        <div>
                            <p class="club5-calendar-item-row-text">Тест</p>
                        </div>
                    </div>
                    <div class="club5-calendar-item-row  careerum-flex-sbst">
                        <div>
                            <p class="club5-calendar-item-row-header">2.5 Ваши «Могу» – это суперсилы!</p>
                        </div>
                        <div>
                            <p class="club5-calendar-item-row-text">Видеолекция</p>
                        </div>
                    </div>
                </div>
                <div class="club5-calendar-item">
                    <div class="club5-calendar-item-header careerum-flex-fsc">
                        <p>Блок 3</p>
                        <p>Блок «Хочу»</p>
                    </div>
                    <div class="club5-calendar-item-row  careerum-flex-sbst">
                        <div>
                            <p class="club5-calendar-item-row-header">3.1 Что блокирует ваше «Хочу»</p>
                        </div>
                        <div>
                            <p class="club5-calendar-item-row-text">Лекция</p>
                        </div>
                    </div>
                    <div class="club5-calendar-item-row  careerum-flex-sbst">
                        <div>
                            <p class="club5-calendar-item-row-header">3.2 Мотиваторы</p>
                        </div>
                        <div>
                            <p class="club5-calendar-item-row-text">Видеолекция</p>
                        </div>
                    </div>
                    <div class="club5-calendar-item-row  careerum-flex-sbst">
                        <div>
                            <p class="club5-calendar-item-row-header">[Де]мотиваторы и круги влияния</p>
                        </div>
                        <div>
                            <p class="club5-calendar-item-row-text">Тест</p>
                        </div>
                    </div>
                    <div class="club5-calendar-item-row  careerum-flex-sbst">
                        <div>
                            <p class="club5-calendar-item-row-header">3.3 Интересы</p>
                        </div>
                        <div>
                            <p class="club5-calendar-item-row-text">Видеолекция</p>
                        </div>
                    </div>
                    <div class="club5-calendar-item-row  careerum-flex-sbst">
                        <div>
                            <p class="club5-calendar-item-row-header">Мотиваторы vs Интересы</p>
                        </div>
                        <div>
                            <p class="club5-calendar-item-row-text">Тест</p>
                        </div>
                    </div>
                    <div class="club5-calendar-item-row  careerum-flex-sbst">
                        <div>
                            <p class="club5-calendar-item-row-header">3.4 Ценности</p>
                        </div>
                        <div>
                            <p class="club5-calendar-item-row-text">Видеолекция</p>
                        </div>
                    </div>
                    <div class="club5-calendar-item-row  careerum-flex-sbst">
                        <div>
                            <p class="club5-calendar-item-row-header">Потренируйтесь определять ценности</p>
                        </div>
                        <div>
                            <p class="club5-calendar-item-row-text">Тест</p>
                        </div>
                    </div>
                    <div class="club5-calendar-item-row  careerum-flex-sbst">
                        <div>
                            <p class="club5-calendar-item-row-header">3.5 Факторы рабочей среды</p>
                        </div>
                        <div>
                            <p class="club5-calendar-item-row-text">Видеолекция</p>
                        </div>
                    </div>
                    <div class="club5-calendar-item-row  careerum-flex-sbst">
                        <div>
                            <p class="club5-calendar-item-row-header">3.6 Ваши «Хочу» – маршрутная карта к карьере по
                                любви</p>
                        </div>
                        <div>
                            <p class="club5-calendar-item-row-text">Видеолекция</p>
                        </div>
                    </div>
                </div>
                <div class="club5-calendar-item">
                    <div class="club5-calendar-item-header careerum-flex-fsc">
                        <p>Блок 4</p>
                        <p>Блок «Надо»</p>
                    </div>
                    <div class="club5-calendar-item-row  careerum-flex-sbst">
                        <div>
                            <p class="club5-calendar-item-row-header">4.1 Что блокирует ваше «Надо»</p>
                        </div>
                        <div>
                            <p class="club5-calendar-item-row-text">Лекция</p>
                        </div>
                    </div>
                    <div class="club5-calendar-item-row  careerum-flex-sbst">
                        <div>
                            <p class="club5-calendar-item-row-header">4.2 Навигатор по блоку «Надо»</p>
                        </div>
                        <div>
                            <p class="club5-calendar-item-row-text">Видеолекция</p>
                        </div>
                    </div>
                    <div class="club5-calendar-item-row  careerum-flex-sbst">
                        <div>
                            <p class="club5-calendar-item-row-header">4.3 Базовый обзор отраслей</p>
                        </div>
                        <div>
                            <p class="club5-calendar-item-row-text">Видеолекция</p>
                        </div>
                    </div>
                    <div class="club5-calendar-item-row  careerum-flex-sbst">
                        <div>
                            <p class="club5-calendar-item-row-header">4.4 Исследование направлений отраслей</p>
                        </div>
                        <div>
                            <p class="club5-calendar-item-row-text">Видеолекция</p>
                        </div>
                    </div>
                    <div class="club5-calendar-item-row  careerum-flex-sbst">
                        <div>
                            <p class="club5-calendar-item-row-header">4.5 Анализ компаний и профессий</p>
                        </div>
                        <div>
                            <p class="club5-calendar-item-row-text">Видеолекция</p>
                        </div>
                    </div>
                    <div class="club5-calendar-item-row  careerum-flex-sbst">
                        <div>
                            <p class="club5-calendar-item-row-header">4.6 Валидация карьерных гипотез </p>
                        </div>
                        <div>
                            <p class="club5-calendar-item-row-text">Видеолекция</p>
                        </div>
                    </div>
                    <div class="club5-calendar-item-row  careerum-flex-sbst">
                        <div>
                            <p class="club5-calendar-item-row-header">4.7 Разбор упражнения «Алгоритм карьерного выбора»
                                на примере участника клуба</p>
                        </div>
                        <div>
                            <p class="club5-calendar-item-row-text">Видеолекция</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="club5-calendar-button">
                <div>
                    <p>Развернуть программу</p>
                    <p>Свернуть программу</p>
                </div>
            </div>
            <p class="club5-calendar-header">Эфиры и практикумы в июне</p>
            <div class="club5-calendar-bottom careerum-flex-fsst">
                <div class="club5-calendar-bottom-items">
                    <div class="club5-calendar-bottom-item">
                        <div class="club5-calendar-bottom-item-top purple careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748691238820-5HqLG-Icon.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748780059256-qvVgm-Icon.svg" class="hidden-desc"
                                alt="img">
                            <p>Встреча Careerum.Club</p>
                        </div>
                        <div class="club5-calendar-bottom-item-bottom">
                            <div class="careerum-flex-fsfs">
                                <p>25 мая</p>
                                <p>11:00–12:30 мск</p>
                            </div>
                            <p>Встреча английского клуба</p>
                        </div>
                    </div>
                    <div class="club5-calendar-bottom-item">
                        <div class="club5-calendar-bottom-item-top orange careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748691238707-dHsJU-Icon.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748780059115-LXPOu-Icon.svg" class="hidden-desc"
                                alt="img">
                            <p>Интенсив «СамоОценка»</p>
                        </div>
                        <div class="club5-calendar-bottom-item-bottom">
                            <div class="careerum-flex-fsfs">
                                <p>27 мая</p>
                                <p>18:00–19:30 мск</p>
                            </div>
                            <p>Вводный урок, где участники узнают как будет проходить интенсив</p>
                        </div>
                    </div>
                    <div class="club5-calendar-bottom-item">
                        <div class="club5-calendar-bottom-item-top pink careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748691238586-2Rvty-Icon.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748780058988-ndcLw-Icon.svg" class="hidden-desc"
                                alt="img">
                            <p>Интенсив «Power talk»</p>
                        </div>
                        <div class="club5-calendar-bottom-item-bottom">
                            <div class="careerum-flex-fsfs">
                                <p>28 мая</p>
                                <p>19:00–20:30 мск</p>
                            </div>
                            <p>Практикум «как управлят руководителем»</p>
                        </div>
                    </div>
                    <div class="club5-calendar-bottom-item">
                        <div class="club5-calendar-bottom-item-top purple careerum-flex-fsfs"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748691238820-5HqLG-Icon.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748780059256-qvVgm-Icon.svg" class="hidden-desc"
                                alt="img">
                            <p>Встреча Careerum.Club</p>
                        </div>
                        <div class="club5-calendar-bottom-item-bottom">
                            <div class="careerum-flex-fsfs">
                                <p>29 мая</p>
                                <p>11:00–12:30 мск</p>
                            </div>
                            <p>Встреча английского клуба</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="club5-calendar-link">
                <a href="#buy" class="btn-color-main-bright-orange">Записаться в лист ожидания</a>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club5-team', {
        label: 'Club 5 team (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club5-team main-wrapper">
        <div class="careerum-container-responsive-wide">
            <div class="club5-team-top">
                <h2>Твой буст в обучении — наша команда экспертов</h2>
                <p>Быстрое достижение целей с поддержкой практиков с международной экспертизой, которые вместе с тобой
                    собирают твою личную стратегию</p>
            </div>
            <div class="club5-team-center careerum-flex-sbst">
                <div class="club5-team-center-left">
                    <p class="club5-team-center-left-header">Эксперты помогут: </p>
                    <ul>
                        <li class="careerum-flex-fsc"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748360566269-LDIjf-Soft.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748434320249-OjfSt-Soft.svg"
                                class="hidden-desc" alt="img">
                            <p>Написать сильное резюме</p>
                        </li>
                        <li class="careerum-flex-fsc"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748360566269-LDIjf-Soft.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748434320249-OjfSt-Soft.svg"
                                class="hidden-desc" alt="img">
                            <p>Усилить профиль LinkedIn</p>
                        </li>
                        <li class="careerum-flex-fsc"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748360566269-LDIjf-Soft.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748434320249-OjfSt-Soft.svg"
                                class="hidden-desc" alt="img">
                            <p>Потренировать собеседование</p>
                        </li>
                        <li class="careerum-flex-fsc"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748360566269-LDIjf-Soft.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748434320249-OjfSt-Soft.svg"
                                class="hidden-desc" alt="img">
                            <p>Поставить карьерную цель</p>
                        </li>
                        <li class="careerum-flex-fsc"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748360566269-LDIjf-Soft.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748434320249-OjfSt-Soft.svg"
                                class="hidden-desc" alt="img">
                            <p>Усилить сопроводительное письмо</p>
                        </li>
                        <li class="careerum-flex-fsc"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748360566269-LDIjf-Soft.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748434320249-OjfSt-Soft.svg"
                                class="hidden-desc" alt="img">
                            <p>Подготовиться к переговорам по офферу</p>
                        </li>
                        <li class="careerum-flex-fsc"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748360566269-LDIjf-Soft.svg"
                                class="hidden-tablet-mobile" alt="img"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748434320249-OjfSt-Soft.svg"
                                class="hidden-desc" alt="img">
                            <p>Разработать карьерную стратегию</p>
                        </li>
                    </ul>
                </div>
                <div class="club5-team-center-right">
                    <div class="club5-team-center-right-item black">
                        <div class="careerum-flex-fsfs">
                            <p>3800+</p>
                            <p>часов</p>
                        </div>
                        <p>Проведенных сессий</p>
                    </div>
                    <div class="club5-team-center-right-item black">
                        <div class="careerum-flex-fsfs">
                            <p>9,5/10</p>
                            <p>средняя оценка</p>
                        </div>
                        <p>Карьерных экспертов и коучей Careerum</p>
                    </div>
                </div>
            </div>
            <div class="club5-team-bottom">
                <div class="club5-team-items careerum-flex-fsst">
                    <div class="club5-team-item"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748411185924-Uv71e-Fram.png"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748437082029-dZP6f-Spea.png"
                            class="hidden-desc-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748519546211-MgMAr-Spea.png"
                            class="hidden-desc-tablet" alt="img">
                        <p class="club5-team-item-name">Софи Бессон</p>
                        <p class="club5-team-item-position">Карьерный эксперт, Израиль</p>
                        <ul>
                            <li>6+ в HR и карьерном консультировании</li>
                            <li>Помогла 700+ клиентам составить резюме и найти работу в Европе, США и Канаде</li>
                            <li>Работала с сотрудниками Disney, Intel, Microsoft</li>
                        </ul>
                    </div>
                    <div class="club5-team-item"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748411186799-7fTsk-Fram.png"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748437083205-aeiu5-Spea.png"
                            class="hidden-desc-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748519547258-EfhTN-Spea.png"
                            class="hidden-desc-tablet" alt="img">
                        <p class="club5-team-item-name">Олеся Спиридонова</p>
                        <p class="club5-team-item-position">Коуч практик ФПКиН, психолог-консультант, Россия</p>
                        <ul>
                            <li>16+ лет в коучинге и инженерной отрасли</li>
                            <li>Помогла 100+ клиентам найти свой путь в жизни и карьере</li>
                            <li>Работала с сотрудниками компаний различных отраслей, включая IT, финансы, маркетинг,
                                EdTech и др.</li>
                        </ul>
                    </div>
                    <div class="club5-team-item"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748693004666-opLYt-Fram.png"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748693033893-ype7D-Spea.png"
                            class="hidden-desc-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748693036006-B4rRG-Spea.png"
                            class="hidden-desc-tablet" alt="img">
                        <p class="club5-team-item-name">Михаил Ромашов</p>
                        <p class="club5-team-item-position">Product Owner SberCIB, Россия</p>
                        <ul>
                            <li>16+ лет в коучинге и инженерной отрасли</li>
                            <li>Помогла 100+ клиентам найти свой путь в жизни и карьере</li>
                            <li>Работала с сотрудниками компаний различных отраслей, включая IT, финансы, маркетинг,
                                EdTech и др.</li>
                        </ul>
                    </div>
                    <div class="club5-team-item"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748693006072-g1Llf-Fram.png"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748437082556-O18fI-Spea.png"
                            class="hidden-desc-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748519548821-PXlwT-Spea.png"
                            class="hidden-desc-tablet" alt="img">
                        <p class="club5-team-item-name">Майя Бурякина</p>
                        <p class="club5-team-item-position">Коуч ACC ICF, США/Россия</p>
                        <ul>
                            <li>10+ лет в подборе, адаптации и развитии персонала</li>
                            <li>Провела 150+ консультаций на тему поиска работы и построения карьеры</li>
                            <li>Ex-руководитель HR-направления в международной FMCG-компании с 2 500+ сотрудников</li>
                        </ul>
                    </div>
                    <div class="club5-team-item"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748411189256-BG9fe-Fram.png"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748437084266-cw19I-Spea.png"
                            class="hidden-desc-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748519551873-8dHDK-Spea.png"
                            class="hidden-desc-tablet" alt="img">
                        <p class="club5-team-item-name">Мария Пудалова</p>
                        <p class="club5-team-item-position">Карьерный эксперт, Германия</p>
                        <ul>
                            <li>7+ лет в PR и стратегии выстраивания бренда</li>
                            <li>Помогла 400+ клиентам улучшить CV и найти работу в Европе и США</li>
                            <li>Работала с сотрудниками Deloitte, BBDO, Microsoft</li>
                        </ul>
                    </div>
                    <div class="club5-team-item"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748411190231-lXtrh-Fram.png"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748437083781-lLLJd-Spea.png"
                            class="hidden-desc-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748519554234-L9ntE-Spea.png"
                            class="hidden-desc-tablet" alt="img">
                        <p class="club5-team-item-name">Виктория Албаутова</p>
                        <p class="club5-team-item-position">Коуч ICU, Турция</p>
                        <ul>
                            <li>8+ лет в коучинге и маркетинге</li>
                            <li>Помогла 150+ клиентам построить выигрышные стратегии и бренды</li>
                            <li>Работала с компаниями Beiesdorf, Philips, Johnson&Johnson, Novartis</li>
                        </ul>
                    </div>
                    <div class="club5-team-item"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748411191417-3wNnJ-Fram.png"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748437084837-GMfj6-Spea.png"
                            class="hidden-desc-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748519557431-guMNa-Spea.png"
                            class="hidden-desc-tablet" alt="img">
                        <p class="club5-team-item-name">Елена Добринская</p>
                        <p class="club5-team-item-position">PCC ICF, ОАЭ</p>
                        <ul>
                            <li>10+ лет в коучинге и финансах </li>
                            <li>Помогла 1700+ клиентам обрести уверенность и подготовиться к собеседованиям</li>
                            <li>Работала с сотрудниками Sony, Ernst&Young, Deloitte</li>
                        </ul>
                    </div>
                    <div class="club5-team-item"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748411192057-sMcmF-Fram.png"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748437085188-G3a5X-Spea.png"
                            class="hidden-desc-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748519558512-l4WSX-Spea.png"
                            class="hidden-desc-tablet" alt="img">
                        <p class="club5-team-item-name">Елена Эльзенбах</p>
                        <p class="club5-team-item-position">Коуч ICF, Россия</p>
                        <ul>
                            <li>11+ лет опыта в коучинге, НКО и EdTech</li>
                            <li>Помогла 1300+ клиентам из РФ, Европы и СНГ получить оффер через укрепление самооценки
                            </li>
                            <li>Работала с сотрудниками Lamoda, Яндекс, Mail, InDriver</li>
                        </ul>
                    </div>
                    <div class="club5-team-item"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748411193620-NfQQG-Fram.png"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748437086488-3vtuU-Spea.png"
                            class="hidden-desc-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748519560765-ifx6F-Spea.png"
                            class="hidden-desc-tablet" alt="img">
                        <p class="club5-team-item-name">Светлана Шуйская</p>
                        <p class="club5-team-item-position">Коуч ICF, Россия</p>
                        <ul>
                            <li>18+ лет в коучинге и закупках</li>
                            <li>Помогла 300+ клиентам вырасти в доходе, составить стратегию, начать свое дело</li>
                            <li>Работала с сотрудниками Metro Cash&Carry, Yandex, Avito</li>
                        </ul>
                    </div>
                    <div class="club5-team-item"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748411192648-gibJe-Fram.png"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748437085718-3dynw-Spea.png"
                            class="hidden-desc-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748519563033-UY2Y5-Spea.png"
                            class="hidden-desc-tablet" alt="img">
                        <p class="club5-team-item-name">Марина Веденичева</p>
                        <p class="club5-team-item-position">Коуч PCC ICF, Великобритания</p>
                        <ul>
                            <li>18+ лет в HR и карьерном коучинге</li>
                            <li>Помогла 2000+ клиентам усилить лидерские качества и получить повышение</li>
                            <li>Работала с сотрудниками Mars, Shell, Ernst & Young</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="club5-team-link">
                <a href="#buy" class="btn-color-main-bright-orange">Записаться в лист ожидания</a>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club5-tariffs', {
        label: 'Club 5 tariffs (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club5-tariffs main-wrapper">
        <div class="careerum-container-responsive-wide">
            <h2>Возможности Careerum.Club доступны по подписке. Наши участники <span>не доплачивают</span> за новые
                мероприятия и курсы </h2>
            <div class="club5-tariffs-top">
                <div class="club5-tariffs-about">
                    <p class="club5-tariffs-top-header">На какой срок оформить подписку?</p>
                    <p class="club5-tariffs-top-text">Мы рекомендуем подписку <span>на 3 месяца</span>. Это самый
                        эффективный период, за который ты можешь решить любую карьерную задачу</p>
                </div>
                <div class="club5-tariffs-top-items careerum-flex-sbst">
                    <div class="club5-tariffs-top-item">
                        <p class="club5-tariffs-top-item-label">Новая программа каждый месяц внутри твоего тарифа</p>
                        <p class="club5-tariffs-top-item-header"><span>Тематические интенсивы 12 раз в год с
                                онлайн-встречами и поддержкой кураторов и комьюнити.</span> Только для тарифов «С
                            поддержкой» и «Индивидуальный подход».</p>
                    </div>
                    <div class="club5-tariffs-top-item">
                        <p class="club5-tariffs-top-item-label">Чем больше срок подписки, тем ниже цена каждого месяца
                        </p>
                        <p class="club5-tariffs-top-item-header"><span>Выгода 20%</span> при покупке от 3-х месяцев.
                            <span>При оплате годовой подписки ты сразу сэкономишь больше 35%</span> на тарифах «С
                            поддержкой» и «Индивидуальный подход»</p>
                    </div>
                    <div class="club5-tariffs-top-item">
                        <p class="club5-tariffs-top-item-label">Выгода 35% на персональные карьерные консультации в подписке</p>
                        <p class="club5-tariffs-top-item-header">Разбери свой кейс с топовыми карьерными экспертами и
                            коучами из РФ, СНГ, Европы и США на персональной видеосессии. <span>Спецтариф для клиентов
                                Careerum.Club и приоритетная очередь на консультацию.</span></p>
                    </div>
                    <div class="club5-tariffs-top-item">
                        <p class="club5-tariffs-top-item-label">AI-валидатор: умный сервис для проверки твоего резюме
                        </p>
                        <p class="club5-tariffs-top-item-header">Сделай своё резюме заметным для рекрутеров и
                            ATS-систем, получай рекомендации от ИИ, обученного нашими экспертами. <span>Неограниченный
                                доступ к сервису для клиентов Careerum.Club</span></p>
                    </div>
                </div>
                <div class="club5-tariffs-promo position-relative">
                    <p class="club5-tariffs-promo-label">Промокод</p>
                    <p class="club5-tariffs-promo-text position-relative z-20">Если у тебя есть промокод, он действует
                        на подписку от 3 месяцев. Подписку на 1 месяц можно приобрести только по полной стоимости. <br
                            class="hidden-mobile">Промокод не действует на продления подписки. <br> Введи промокод на
                        странице оплаты после выбора тарифа</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748412095013-4LNAj-Vect.svg"
                        class="hidden-tablet-mobile position-absolute z-10" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748437725171-8OKim-Vect.svg"
                        class="hidden-desc-mobile position-absolute z-10" alt="img">
                </div>
            </div>
            <div class="club5-tariffs-switchers careerum-flex-sbfs">
                <div class="club5-tariffs-period-wrapper">
                    <div class="club5-tariffs-period careerum-flex-fsst">
                        <ul class="careerum-flex-fsfs">
                            <li data-period="1" class="active">1 месяц</li>
                            <li data-period="3">3 месяца</li>
                            <li data-period="6">6 месяцев</li>
                            <li data-period="12">12 месяцев</li>
                        </ul>
                        <div class="club5-tariffs-notif careerum-flex-cc">
                            <div class="club5-tariffs-notif-icon"> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                    alt=""> </div>
                            <div class="club5-tariffs-notif-content">
                                <p>1 месяц подписки предоставляет 30 дней доступа к платформе</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="club5-tariffs-curr careerum-flex-fsst">
                    <ul class="careerum-flex-fsfs">
                        <li data-currency="eur">EUR</li>
                        <li data-currency="rub" class="active">RUB</li>
                    </ul>
                    <div class="club5-tariffs-notif careerum-flex-cc">
                        <div class="club5-tariffs-notif-icon"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                alt=""> </div>
                        <div class="club5-tariffs-notif-content">
                            <p>Оплата в российских рублях возможна только картой российского банка. В&nbsp;евро — картой
                                зарубежного банка</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="club5-tariffs-items-wpapper">
                <div class="club5-tariffs-items careerum-flex-sbst">
                    <div class="club5-tariffs-item careerum-flex-fsfs" data-price-1m-rub="12 900 ₽"
                        data-price-3m-rub="9&nbsp;967 ₽" data-fullprice-3m-rub="29&nbsp;900 ₽" data-price-6m-rub=""
                        data-fullprice-6m-rub="" data-price-12m-rub="" data-fullprice-12m-rub=""
                        data-price-1m-eur="149 €" data-price-3m-eur="120 €" data-fullprice-3m-eur="360 €"
                        data-price-6m-eur="" data-fullprice-6m-eur="" data-price-12m-eur="" data-fullprice-12m-eur=""
                        data-offer-1m-rub="27" data-offer-3m-rub="94" data-offer-6m-rub="" data-offer-12m-rub=""
                        data-offer-1m-eur="48" data-offer-3m-eur="97" data-offer-6m-eur="" data-offer-12m-eur="">
                        <div class="club5-tariffs-item-header">
                            <p>Тариф «Самостоятельный»</p>
                        </div>
                        <div class="club5-tariffs-item-content">
                            <p class="club5-tariffs-item-places">Доступно мест: неограниченно</p>
                            <div class="club5-tariffs-item-line"></div>
                            <p class="club5-tariffs-item-text">Доступ к образовательной платформе:</p>
                            <ul>
                                <li class="dot">10 флагманских курсов</li>
                                <li class="dot">Видеотека карьерных материалов</li>
                                <li class="dot">Доступ к Интенсивам в записи</li>
                                <li class="dot">AI-валидатор</li>
                                <li class="dot">Скидка на карьерные консультации 35%</li>
                            </ul>
                        </div>
                        <div class="club5-tariffs-item-footer">
                            <div class="club5-tariffs-item-price careerum-flex-fsfs">
                                <p class="club5-tariffs-item-price-amount">12 900 ₽</p>
                                <p class="club5-tariffs-item-price-text">в месяц</p>
                            </div>
                            <div class="club5-tariffs-item-link"> <a href="#single"
                                    class="btn-color-main-bright-orange">Купить</a> </div>
                        </div>
                    </div>
                    <div class="club5-tariffs-item careerum-flex-fsfs" data-price-1m-rub="14 900 ₽"
                        data-price-3m-rub="13&nbsp;300 ₽" data-fullprice-3m-rub="39&nbsp;900 ₽"
                        data-price-6m-rub="11&nbsp;650 ₽" data-fullprice-6m-rub="69&nbsp;900 ₽"
                        data-price-12m-rub="9&nbsp;075 ₽" data-fullprice-12m-rub="108&nbsp;900 ₽"
                        data-price-1m-eur="199 €" data-price-3m-eur="170 €" data-fullprice-3m-eur="510 €"
                        data-price-6m-eur="130 €" data-fullprice-6m-eur="780 €" data-price-12m-eur="100 €"
                        data-fullprice-12m-eur="1 200 €" data-offer-1m-rub="28" data-offer-3m-rub="29"
                        data-offer-6m-rub="30" data-offer-12m-rub="31" data-offer-1m-eur="49" data-offer-3m-eur="50"
                        data-offer-6m-eur="51" data-offer-12m-eur="52">
                        <div class="club5-tariffs-item-header">
                            <p>Тариф «С поддержкой»</p>
                        </div>
                        <div class="club5-tariffs-item-content">
                            <p class="club5-tariffs-item-places">Доступно мест: 250</p>
                            <div class="club5-tariffs-item-line"></div>
                            <p class="club5-tariffs-item-text">Входят все опции тарифа «Самостоятельный», плюс:</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748415502734-IRcHL-Fram.svg"
                                        alt="">
                                    <p>Групповой чат с экспертами и кураторами платформы</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748415502734-IRcHL-Fram.svg"
                                        alt="">
                                    <p>2 групповые встречи в месяц с разбором ваших кейсов</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748415502734-IRcHL-Fram.svg"
                                        alt="">
                                    <p>Онлайн-практикумы </p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748415502734-IRcHL-Fram.svg"
                                        alt="">
                                    <p>Доступ к комьюнити</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748415502734-IRcHL-Fram.svg"
                                        alt="">
                                    <p>Доступ ко всем мероприятиям Careerum</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748415502734-IRcHL-Fram.svg"
                                        alt="">
                                    <p>Доступ к Интенсивам в живом формате</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club5-tariffs-item-footer">
                            <div class="club5-tariffs-item-price careerum-flex-fsfs">
                                <p class="club5-tariffs-item-price-amount">12 900 ₽</p>
                                <p class="club5-tariffs-item-price-text">в месяц</p>
                            </div>
                            <div class="club5-tariffs-item-link"> <a href="#support"
                                    class="btn-color-main-bright-orange">Купить</a> </div>
                        </div>
                    </div>
                    <div class="club5-tariffs-item careerum-flex-fsfs" data-price-1m-rub="33&nbsp;900 ₽"
                        data-price-3m-rub="29&nbsp;967 ₽" data-fullprice-3m-rub="89&nbsp;900 ₽"
                        data-price-6m-rub="26&nbsp;650 ₽" data-fullprice-6m-rub="159&nbsp;900 ₽"
                        data-price-12m-rub="20&nbsp;908 ₽" data-fullprice-12m-rub="250&nbsp;900 ₽"
                        data-price-1m-eur="360 €" data-price-3m-eur="310 €" data-fullprice-3m-eur="930 €"
                        data-price-6m-eur="250 €" data-fullprice-6m-eur="1 500 €" data-price-12m-eur="230 €"
                        data-fullprice-12m-eur="2 760 €" data-offer-1m-rub="32" data-offer-3m-rub="100"
                        data-offer-6m-rub="101" data-offer-12m-rub="102" data-offer-1m-eur="53" data-offer-3m-eur="103"
                        data-offer-6m-eur="104" data-offer-12m-eur="105">
                        <div class="club5-tariffs-item-header">
                            <p class="club5-tariffs-item-header">Тариф «Индивидуальный подход»</p>
                        </div>
                        <div class="club5-tariffs-item-content">
                            <p class="club5-tariffs-item-places">Доступно мест: 50</p>
                            <div class="club5-tariffs-item-line"></div>
                            <p class="club5-tariffs-item-text">Входят все опции тарифа «С поддержкой», плюс:</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748415502734-IRcHL-Fram.svg"
                                        alt="">
                                    <p>Установочная сессия:</p>
                                </li>
                                <li class="dot">Онлайн-встреча 30 минут</li>
                                <li class="dot">Пошаговый план по достижению вашей цели</li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748415502734-IRcHL-Fram.svg"
                                        alt="">
                                    <p>2 карьерные консультации в месяц:</p>
                                </li>
                                <li class="dot">Онлайн-встреча 50 минут</li>
                                <li class="dot">Разбор вашего запроса</li>
                                <li class="dot">Запись встречи, чтобы можно было пересмотреть</li>
                                <li class="dot">Список рекомендаций</li>
                            </ul>
                        </div>
                        <div class="club5-tariffs-item-footer">
                            <div class="club5-tariffs-item-price careerum-flex-fsfs">
                                <p class="club5-tariffs-item-price-amount">12 900 ₽</p>
                                <p class="club5-tariffs-item-price-text">в месяц</p>
                            </div>
                            <div class="club5-tariffs-item-link"> <a href="#individual"
                                    class="btn-color-main-bright-orange">Купить</a> </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="club5-tariffs-switchers-tablet hidden-desc-mobile">
                <div class="club5-tariffs__swicher-block">
                    <div class="club5-tariffs__swicher-top">
                        <p class="club5-tariffs__swicher-header">Посмотреть цены в <span>RUB</span> </p> <svg
                            xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            class="club5-tariffs__swicher-arrow">
                            <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black"> </path>
                        </svg>
                    </div>
                    <div class="club5-tariffs__swicher-bottom">
                        <ul>
                            <li data-currency="rub" class="active"> RUB </li>
                            <li data-currency="eur"> EUR </li>
                        </ul>
                        <p> Обратите внимание,<br> что оплата в российских рублях возможна только<br> с карты
                            российского банка. Оплата в евро — с карты зарубежного банка </p>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club5-closed', {
        label: 'Club 5 closed (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club5-closed main-wrapper">
        <div class="careerum-container-responsive-wide">
            <h2>Сейчас вход в Careerum закрыт: оформить подписку можно только раз в месяц. Почему?</h2>
            <div class="club5-closed-items careerum-flex-sbst">
                <div class="club5-closed-item careerum-flex-fsfs">
                    <div class="club5-closed-item-top">
                        <p>Количество в клубе участников ограниченно</p>
                    </div>
                    <div class="club5-closed-item-bottom">
                        <p>Наша задача установить конект с каждой из вас. Мы помогаем составить индивидуальный план
                            развития и поддерживаем участниц на протяжении всего обучения </p>
                    </div>
                </div>
                <div class="club5-closed-item careerum-flex-fsfs">
                    <div class="club5-closed-item-top">
                        <p>Окна входа в клуб открываются вместе со стартом Интенсивов <span>на 3 дня</span></p>
                        <p class="club5-closed-item-label">Ближайшее окно: 24 июня</p>
                    </div>
                    <div class="club5-closed-item-bottom">
                        <p>Индивидуальные карьерные консультации и экспертное сопровождение </p>
                    </div>
                </div>
                <div class="club5-closed-item careerum-flex-fsfs">
                    <div class="club5-closed-item-top">
                        <p>Оставь заявку в лист ожидания </p>
                    </div>
                    <div class="club5-closed-item-bottom">
                        <p>Сейчас все места в Careerum.Club заняты. Оставь заявку в лист ожидания, если у нас
                            освободится место, то мы сразу предложим тебе присоединиться</p>
                    </div>
                </div>
            </div>
            <div class="club5-closed-link">
                <a href="#buy" class="btn-color-main-bright-orange">Записаться в лист ожидания</a>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club5-question', {
        label: 'Club 5 question (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club5-question main-wrapper">
        <div class="careerum-container-responsive-wide careerum-flex-fsst">
            <div class="club5-question-left">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748692315234-pNJQt-Fram.png"
                    class="hidden-tablet-mobile" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748692390369-vhL4E-Imag.png"
                    class="hidden-desc-mobile" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748692393418-uT6el-Imag.png"
                    class="hidden-desc-tablet" alt="img">
            </div>
            <div class="club5-question-right position-relative careerum-flex-fsfs">
                <p class="club5-question-header position-relative z-20">Не знаешь, какой трек нужен тебе прямо сейчас?
                </p>
                <p class="club5-question-text position-relative z-20">Обратись к карьерному эксперту Светлане и вы
                    вместе составите твой
                    маршрут</p>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748692439179-y05Jy-Grou.svg"
                    class="hidden-tablet-mobile position-absolute z-10" alt="img">
                <a href="#tg" class="btn-color-main-black-light">Задать вопрос эксперту в Telegram</a>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club5-help-buy', {
        label: 'Club 5 help-buy (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club5-help-buy main-wrapper">
        <div class="careerum-container-responsive-wide position-relative">
            <h2 class="position-relative z-20 hidden-mobile">Поможем оплатить<br>
                подписку через работодателя</h2>
            <h2 class="position-relative z-20 hidden-desc-tablet">Поможем оплатить
                подписку через работодателя</h2>
            <p>Мы подготовили шаблон письма для вашего руководителя, в котором описали все плюшки подписки Сareerum
                и добавили специальные условия, если ты захочешь позвать коллег :)</p>
            <p class="position-absolute z-20">
                20% скидка для команд
                от 3 человек
            </p>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748417583292-7lMJt-Vect.svg"
                class="hidden-tablet-mobile position-absolute z-10" alt="img">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748439521583-YB1jO-Vect.svg"
                class="hidden-desc-mobile position-absolute z-10" alt="img">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748521783891-hRNq7-Vect.svg"
                class="hidden-desc-tablet position-absolute z-10" alt="img">
            <div class="careerum-flex-fsfs club5-help-buy-links">
                <a href="#" class="btn-color-main-white hidden-tablet-mobile">Забрать шаблон письма для руководителя
                </a>
                <a href="#" class="btn-color-main-white hidden-desc">Забрать шаблон письма</a>
                <a href="#" class="btn-color-main-white">Оплатить через руководителя</a>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club5-woman', {
        label: 'Club 5 woman (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club5-woman main-wrapper hidden-mobile">
        <div class="careerum-container-responsive-wide position-relative">
            <div class="club5-woman-img-container">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748350745207-6H7Ij-Grou.svg"
                    class="hidden-tablet-mobile" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748427602748-8rS2M-Grou.svg"
                    class="hidden-desc-mobile position-relative" alt="img">
            </div>
            <div class="club5-woman-text-items position-absolute">
                <p class="position-absolute">Живая, а не продуктивная</p>
                <p class="position-absolute">Знает свои возможности</p>
                <p class="position-absolute">На своем месте</p>
                <p class="position-absolute">Видит смысл в работе</p>
                <p class="position-absolute">Знает свои границы</p>
                <p class="position-absolute">Доверяет себе</p>
                <p class="position-absolute">Яркая</p>
                <p class="position-absolute">Амбициозная</p>
                <p class="position-absolute">Деятельная</p>
                <p class="position-absolute">Уверенная</p>
            </div>
            <div class="club5-woman-card-items position-absolute">
                <div class="club5-woman-card-item position-absolute">
                    <p>Careerum Woman</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748351224669-oCmkb-Cont.svg"
                        class="hidden-tablet-mobile position-absolute" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748428072259-IxYJg-Cont.svg"
                        class="hidden-desc-mobile position-absolute" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/"
                        class="hidden-desc-tablet position-absolute" alt="img">
                </div>
                <div class="club5-woman-card-item position-absolute">
                    <p>Glow&Growth</p>
                    <p>On</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748352788440-l5AUh-Cont.svg"
                        class="hidden-tablet-mobile position-absolute" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748428251795-UoLsM-Cont.svg"
                        class="hidden-desc-mobile position-absolute" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/"
                        class="hidden-desc-tablet position-absolute" alt="img">
                </div>
                <div class="club5-woman-card-item person position-absolute careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748351778347-qhckZ-Imag.png"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748428545781-c3Gig-Imag.png"
                        class="hidden-desc-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/" class="hidden-desc-tablet"
                        alt="img">
                    <div>
                        <p class="club5-woman-card-item-person-name">Анна</p>
                        <p class="club5-woman-card-item-person-descr">UX-designer, посетила 28 стран</p>
                    </div>
                </div>
                <div class="club5-woman-card-item person position-absolute careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748351778188-ayhzd-Imag.png"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748428546029-VJt7C-Imag.png"
                        class="hidden-desc-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/" class="hidden-desc-tablet"
                        alt="img">
                    <div>
                        <p class="club5-woman-card-item-person-name">Юлия</p>
                        <p class="club5-woman-card-item-person-descr">Руководит IT командой и ведет экспертный блог</p>
                    </div>
                </div>
                <div class="club5-woman-card-item person position-absolute careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748351777875-f6dpd-Imag.png"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748428546145-ieEEO-Imag.png"
                        class="hidden-desc-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/" class="hidden-desc-tablet"
                        alt="img">
                    <div>
                        <p class="club5-woman-card-item-person-name">Мила</p>
                        <p class="club5-woman-card-item-person-descr">Маркетолог, ходит с дочкой на балет</p>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club5-opportunities', {
        label: 'Club 5 opportunities (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club5-opportunities main-wrapper">
        <div class="careerum-container-responsive-wide">
            <h2>Возможности комьюнити</h2>
            <div class="club5-opportunities-items careerum-flex-sbst">
                <div class="club5-opportunities-item position-relative">
                    <p>Собрать информацию из первых уст сотрудников компании, в которую хотите попасть</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748356915425-QkwZf-Vect.svg"
                        class="hidden-tablet-mobile position-absolute" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748432097030-gAAPB-Vect.svg"
                        class="hidden-desc position-absolute" alt="img">
                </div>
                <div class="club5-opportunities-item position-relative">
                    <p>Найти рефералов, чтобы получить рекомендации в компанию на выбранную позицию</p>
                </div>
                <div class="club5-opportunities-item position-relative">
                    <p class="position-absolute">Поддержка</p>
                    <p class="position-absolute">Нетворкинг</p>
                    <p class="position-absolute">Комьюнити</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748356915142-mD2D1-Grou.svg"
                        class="hidden-tablet-mobile position-absolute" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748432067729-pUaNH-Grou.svg"
                        class="hidden-desc position-absolute" alt="img">
                </div>
                <div class="club5-opportunities-item position-relative">
                    <p class="hidden-desc">Расширить нетворкинг <br />со специалистами разного уровня: от junior
                        до<br>C-level</p>
                    <p class="hidden-tablet-mobile">Расширить нетворкинг <br />со специалистами разного уровня:
                        от junior до C-level</p>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club5-program', {
        label: 'Club 5 program (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club5-program main-wrapper">
        <div class="careerum-container-responsive-wide">
            <h2>Годовая программа развития карьеры на <span>2025 год</span></h2>
            <p>В рамках подписки ты сможешь участвовать в интенсивах и прокачивать один из карьерных навыков</p>
            <div class="club5-program-items careerum-flex-sbst">
                <div class="club5-program-item wide position-relative">
                    <p class="club5-program-item-label">Старт 22 июля</p>
                    <div class="club5-program-item-header careerum-flex-fsfs"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748363968024-cgPU4-Fram.svg"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748436024397-vzP5w-Fram.svg"
                            class="hidden-desc" alt="img">
                        <p>Wellness-курс </p>
                    </div>
                    <p class="club5-program-item-subheader">Практики велнесса для карьеры: отдыхаем без чувства вины</p>
                    <p class="club5-program-item-text">Практики заземленности, чтобы работать меньше, прорабатываем
                        границы, реалистичность к стрессу</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748364331454-vTy0M-Vect.svg"
                        class="hidden-tablet-mobile position-absolute" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748436098704-EuWIB-Vect.svg"
                        class="hidden-desc-mobile position-absolute" alt="img">
                </div>
                <div class="club5-program-item">
                    <p class="club5-program-item-label">Старт 26 августа</p>
                    <div class="club5-program-item-header careerum-flex-fsfs"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748363967914-piC1l-Fram.svg"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748436024294-g37fu-Fram.svg"
                            class="hidden-desc" alt="img">
                        <p>Портфельная карьера</p>
                    </div>
                    <p class="club5-program-item-subheader">Корпорация, фриланс, предпринимательство – "портфельная"
                        карьера</p>
                    <p class="club5-program-item-text">Как создать сильное портфолио, упаковываться для рынка, чтобы
                        вырасти в деньгах и клиентах</p>
                </div>
                <div class="club5-program-item">
                    <p class="club5-program-item-label">Старт 23 сентября</p>
                    <div class="club5-program-item-header careerum-flex-fsfs"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748363967800-0YgKq-Fram.svg"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748436024187-2Tzxh-Fram.svg"
                            class="hidden-desc" alt="img">
                        <p>Карьерная ракета</p>
                    </div>
                    <p class="club5-program-item-subheader">Лаборатория софт-скиллов будущего для работы каждый день</p>
                    <p class="club5-program-item-text">Как эффективно проходить отборы в компании, управлять карьерой
                        как проектом, составлять план развития, расти через цели</p>
                </div>
                <div class="club5-program-item">
                    <p class="club5-program-item-label">Старт 21 октября</p>
                    <div class="club5-program-item-header careerum-flex-fsfs"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748363967672-tMb20-Fram.svg"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748436024070-SXC5s-Fram.svg"
                            class="hidden-desc" alt="img">
                        <p>Power Talk </p>
                    </div>
                    <p class="club5-program-item-subheader">Прорыв в карьере через коммуникации</p>
                    <p class="club5-program-item-text">Как эффективно общаться, продавать идеи и влиять на людей</p>
                </div>
                <div class="club5-program-item medium">
                    <p class="club5-program-item-label">Старт 20 ноября</p>
                    <div class="club5-program-item-header careerum-flex-fsfs"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748363967555-4VmKN-Fram.svg"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748436023797-7ONkC-Fram.svg"
                            class="hidden-desc" alt="img">
                        <p>Big Boss </p>
                    </div>
                    <p class="club5-program-item-subheader">Лидерство в предпринимательстве и корпорациях</p>
                    <p class="club5-program-item-text">Как быть лидером, руководителем, вести за собой людей</p>
                </div>
                <div class="club5-program-item medium">
                    <p class="club5-program-item-label">Старт 22 декабря</p>
                    <div class="club5-program-item-header careerum-flex-fsfs"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748363967555-4VmKN-Fram.svg"
                            class="hidden-tablet-mobile" alt="img"> <img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748436023797-7ONkC-Fram.svg"
                            class="hidden-desc" alt="img">
                        <p>Work&Mom</p>
                    </div>
                    <p class="club5-program-item-subheader">Материнство, отношения и карьера</p>
                    <p class="club5-program-item-text">Как это все совмещать и жить в ненадрывах и балансе</p>
                </div>
            </div>
            <div class="club5-program-link">
                <a href="#buy" class="btn-color-main-bright-orange">Записаться в лист ожидания</a>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-case3-main', {
        label: 'Cases main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-case3-main main-wrapper">
            <div class="careerum-container-responsive">
                <div class="case3-main-wrapper careerum-flex-sbst">
                    <div class="case3-main-left position-relative careerum-flex-fsfs">
                        <p class="case3-main-label">март, 2023</p>
                        <h1>Оффер в новой сфере с релокацией всего за 3 месяца</h1>
                        <div class="position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1750232171532-P1zBL-Mask.png" class="hidden-tablet-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1750234517447-w8Wft-Mask.png" class="hidden-desc" alt="img">
                            <a href="#" class="position-absolute">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1750231902536-KZIYS-Fram.svg" class="hidden-tablet-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1750234519042-DTVZL-Fram.svg" class="hidden-desc" alt="img">
                            </a>
                            <p class="case3-main-name">Арина Кунашко, frontend-разработчик, DIGINETICA, Испания</p>
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1750232531615-5IMLV-ÑÐ¾.svg" class="hidden-tablet-mobile position-absolute z-10" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1750234518926-Lcz0c-ÑÐ¾.svg" class="hidden-desc-mobile position-absolute z-10" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1750236473494-swQzi-ÑÐ¾.svg" class="hidden-desc-tablet position-absolute z-10" alt="img">
                    </div>
                    <div class="case3-main-right">
                        <div>
                            <div class="case3-main-subheader careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1750231920954-Uz72o-Ligh.svg" class="hidden-tablet-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1750234518682-CS3IN-Ligh.svg" class="hidden-desc" alt="img">
                                <p>До Careerum</p>
                            </div>
                            <ul>
                                <li>Поиск работы в новой нише</li>
                                <li>Нет опыта на рабочих проектах</li>
                                <li>Необходимость релокации в Испанию</li>
                                <li>Сжатые сроки поиска</li>
                                <li>Высокая конкуренция на junior и middle позициях</li>
                            </ul>
                        </div>
                        <div class="orange">
                            <div class="case3-main-subheader careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1750231931423-YdQ6I-Star.svg" class="hidden-tablet-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1750234518807-felnH-Star.svg" class="hidden-desc" alt="img">
                                <p>Результат</p>
                            </div>
                            <ul>
                                <li>Написала продающее резюме</li>
                                <li>Построила стратегию поиска работы</li>
                                <li>Научилась правильно преподносить себя на интервью</li>
                                <li>Прокачала навык поиска работы</li>
                                <li>Поставила перед собой новые цели: прокачать навыки и повысить доход
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-case3-content', {
        label: 'Cases content (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-case3-content main-wrapper">
            <div class="careerum-container-responsive">
                <div class="case3-content-label">
                    <p>До Careerum</p>
                </div>
                <div class="case3-content-text">
                    <p>Короткая вводная часть о герое кейса и контексте, с которым он обратился в Карьерум. Это не нужно сокращать, наоборот нужно написать короткий сторитейл. Если смена сферы, то кем работал до и на что хочет сменить.</p>
                </div>
                <div class="case3-content-qoute">
                    <p>“Мне казалось, что я, кандидат без профильного образования и опыта, не смогу получить оффер из-за большой конкуренции”</p>
                </div>
                <div class="case3-content-tales-small careerum-flex-sbfs">
                    <div>
                        <p>160 откликов</p>
                    </div>
                    <div>
                        <p>1,5 месяца</p>
                    </div>
                    <div class="orange">
                        <p>0 приглашений</p>
                    </div>
                </div>
                <div class="case3-content-tales careerum-flex-sbst">
                    <div class="position-relative">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1750231942888-D1xUq-Vect.svg" class="hidden-tablet-mobile position-absolute z-10" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1750235943845-kUvVM-Vect.svg" class="hidden-desc-mobile position-absolute z-10" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1750237031120-CfYUD-Vect.svg" class="hidden-desc-tablet position-absolute z-10" alt="img">
                        <p class="position-relative z-20">Непонимание, что делать</p>
                    </div>
                    <div>
                        <p>Стресс, страх, снижение самооценки, демотивация
                        </p>
                    </div>
                    <div>
                        <p>Ощущение, что найти работу невозможно</p>
                    </div>
                </div>
                <div class="case3-content-item">
                    <p class="case3-content-header">Доработала резюме с карьерным экспертом</p>
                    <p class="case3-content-item__subheader">Задача эксперта: помочь упаковать текущий опыт клиента так, чтобы специалист мог претендовать на позиции в новой сфере </p>
                    <ul>
                        <li class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1750231965358-p6mwz-Chec.svg" class="hidden-tablet-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1750234518539-rKIGp-Chec.svg" class="hidden-desc" alt="img">
                            <p>Детализированы навыки и опыт: подробно описаны технологии, библиотеки и фреймворки, а также задачи, которые решала Арина
                            </p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1750231965358-p6mwz-Chec.svg" class="hidden-tablet-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1750234518539-rKIGp-Chec.svg" class="hidden-desc" alt="img">
                            <p>Добавлен акцент на профессиональное развитие: указали конкретные курсы и даты их прохождения
                            </p>
                        </li>
                    </ul>
                </div>
                <p class="case3-content-header">Общий срок поиска работы  с Careerum — 3 месяца</p>
                <p class="case3-content-subheader">Через две недели, после второго пройденного интервью получила оффер, который подошел по всем условиям</p>
                <div class="case3-content-tales-small careerum-flex-sbfs">
                    <div>
                        <p>160 откликов</p>
                    </div>
                    <div>
                        <p>1,5 месяца</p>
                    </div>
                    <div class="orange">
                        <p>0 приглашений</p>
                    </div>
                </div>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-seo-main', {
        label: 'SEO main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-seo-main main-wrapper">
        <div class="careerum-container-responsive-wide careerum-flex-sbfs">
            <div class="seo-main-left">
                <div class="seo-main-labels careerum-flex-fsc">
                    <div class="seo-main-label careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751270320689-v8z2N-Cale.svg"
                            class="hidden-tablet-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751270328103-Oh0o2-Cale.svg"
                            class="hidden-desc-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751270331292-DlKSN-Cale.svg"
                            class="hidden-desc-tablet" alt="img">
                        <p>Старт: 22 июля</p>
                    </div>
                    <div class="seo-main-label careerum-flex-fsc">
                        <p>4 недели</p>
                    </div>
                    <div class="seo-main-label white careerum-flex-fsc">
                        <p>Программа</p>
                    </div>
                    <div class="seo-main-label blue careerum-flex-fsc">
                        <p>В подписке Сareerum</p>
                    </div>
                </div>
                <h1>СЕО своей карьеры</h1>
                <p>Новые пути для развития и заработка в современном мире</p>
                <a href="#program" class="btn-color-main-bright-orange hidden-mobile">Посмотреть программу</a>
            </div>
            <div class="seo-main-right">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751271055995-CQvTL-Grou.svg"
                    class="hidden-tablet-mobile" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751270422236-9QzzI-Grou.png"
                    class="hidden-desc-mobile" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1775028452649-UrUl3-Grou.svg"
                    class="hidden-desc-tablet" alt="img">
                <a href="#program" class="btn-color-main-bright-orange hidden-desc-tablet">Посмотреть программу</a>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-seo-who', {
        label: 'SEO who (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-seo-who main-wrapper seo-who2">
        <div class="careerum-container-responsive-wide">
            <h2>Этот курс для тех, кто:</h2>
            <div class="seo-who-wrapper careerum-flex-sbst">
                <div class="seo-who-item">
                    <p class="seo-who-item-label">01</p>
                    <p class="seo-who-item-text">Хочет <span>выйти из найма,</span> но не понимает, с чего начать</p>
                </div>
                <div class="seo-who-item">
                    <p class="seo-who-item-label position-relative z-10">02</p>
                    <p class="seo-who-item-text position-relative z-10">Чувствует себя в <span>профессиональном
                            тупике</span> или кризисе</p>
                    <img src="https://cdn.careerum.com/1775024263336-z4SlP-Grou.svg"
                        class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="eager">
                    <img src="https://cdn.careerum.com/1775026279706-dMJP0-Grou.svg"
                        class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                </div>
                <div class="seo-who-item">
                    <p class="seo-who-item-label">03</p>
                    <p class="seo-who-item-text">Готов <span>перестроить карьеру</span> на своих условиях: креативно,
                        гибко, с опорой
                        на собственную экспертизу</p>
                </div>
                <div class="seo-who-item">
                    <p class="seo-who-item-label position-relative z-10">04</p>
                    <p class="seo-who-item-text position-relative z-10">Хочет <span>повысить личную
                            устойчивость/доходы</span> за счёт консалтинга, фриланса
                        или side-проектов</p>
                    <img src="https://cdn.careerum.com/1775024271873-SJDwG-Vect.svg"
                        class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="eager">
                    <img src="https://cdn.careerum.com/1775026279668-Y9PxS-Grou.svg"
                        class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                </div>
                <div class="seo-who-item">
                    <p class="seo-who-item-label">05</p>
                    <p class="seo-who-item-text">Думает о будущих изменениях — и хочет <span>не бояться перемен,</span>
                        а монетизировать их</p>
                </div>
                <div class="seo-who-item">
                    <p class="seo-who-item-label position-relative z-10">06</p>
                    <p class="seo-who-item-text position-relative z-10">Хочет выйти из найма, но не понимает, с чего
                        начать</p>
                    <img src="https://cdn.careerum.com/1775024278472-Vwjto-Grou.svg"
                        class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="eager">
                    <img src="https://cdn.careerum.com/1775026279602-leBJ1-Grou.svg"
                        class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                    <img src="https://cdn.careerum.com/1775028601756-8Wn7M-Fram.svg" class="hidden-desc-tablet position-absolute z-1" alt="img"
                        loading="lazy">
                </div>
            </div>
            <a href="#program" class="btn-color-main-bright-orange">Посмотреть программу</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-seo-you', {
        label: 'SEO you (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-seo-you main-wrapper">
        <div class="careerum-container-responsive-wide">
            <div class="seo-you-header position-relative">
                <h2>Это про вас?</h2>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751271536667-PHRRQ-Vect.svg"
                    class="hidden-mobile position-absolute" alt="img">
            </div>
            <div class="seo-you-wrapper careerum-flex-sbst">
                <div class="seo-you-item careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751271949646-jutGU-Icon.svg"
                        class="hidden-tablet" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751271959191-ueh9Z-Icon.svg"
                        class="hidden-desc-mobile" alt="img">
                    <p>Текущая работа больше не радует и не развивает, но уходить «в никуда» страшно</p>
                </div>
                <div class="seo-you-item careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751271949646-jutGU-Icon.svg"
                        class="hidden-tablet" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751271959191-ueh9Z-Icon.svg"
                        class="hidden-desc-mobile" alt="img">
                    <p>Вам надоело ставить чужие цели и выполнять чужие KPI</p>
                </div>
                <div class="seo-you-item careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751271949646-jutGU-Icon.svg"
                        class="hidden-tablet" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751271959191-ueh9Z-Icon.svg"
                        class="hidden-desc-mobile" alt="img">
                    <p>В найме нет перспектив — горизонтальный рост не поощряют, вертикальный недостижим</p>
                </div>
                <div class="seo-you-item careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751271949646-jutGU-Icon.svg"
                        class="hidden-tablet" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751271959191-ueh9Z-Icon.svg"
                        class="hidden-desc-mobile" alt="img">
                    <p>Рынок и технологии меняются так быстро, что высок риск остаться «не у дел»</p>
                </div>
                <div class="seo-you-item careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751271949646-jutGU-Icon.svg"
                        class="hidden-tablet" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751271959191-ueh9Z-Icon.svg"
                        class="hidden-desc-mobile" alt="img">
                    <p>Хочется подстраховать себя доходом на фрилансе, но сложно понять, с чего начать</p>
                </div>
                <div class="seo-you-item careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751271949646-jutGU-Icon.svg"
                        class="hidden-tablet" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751271959191-ueh9Z-Icon.svg"
                        class="hidden-desc-mobile" alt="img">
                    <p>Боитесь, что одна зарплата уже не гарант дохода и спокойствия</p>
                </div>
            </div>
            <p class="seo-you-text position-relative z-10">Значит, пришло время построить <span>свою карьерную стратегию</span> и овладеть
                гибкими форматами
                заработка!</p>
            <img src="https://cdn.careerum.com/1775026679534-hAEZ3-Grou.svg" class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
            <img src="https://cdn.careerum.com/1775028716642-JuF9e-Elli.svg" class="hidden-desc-tablet position-absolute z-1" alt="img" loading="lazy">
        </div>
    </div>`
    });
    
    blockManager.add('careerum-seo-results', {
        label: 'SEO results (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-seo-results main-wrapper seo-results2">
        <div class="careerum-container-responsive-wide">
            <h2>Результаты</h2>
            <div class="seo-results-wrapper careerum-flex-fsst">
                <div class="seo-results-items">
                    <div class="seo-results-item position-relative blue">
                        <p class="position-relative z-20">Разберётесь, какие форматы современной карьеры реально
                            работают и приносят доход</p>
                        <img src="https://cdn.careerum.com/1775024786283-AxNlF-Grou.svg"
                            class="hidden-tablet-mobile position-absolute z-10" alt="img">
                        <img src="https://cdn.careerum.com/1775026929639-YvkA9-Grou.svg"
                            class="hidden-desc-mobile position-absolute z-10" alt="img">
                        <img src="https://cdn.careerum.com/1775028787835-lVTOV-Grou.svg"
                            class="hidden-desc-tablet position-absolute z-10" alt="img">
                    </div>
                    <div class="seo-results-item careerum-flex-fsfs">
                        <img src="https://cdn.careerum.com/1775024549812-igtqo-Fram.svg" class="hidden-tablet-mobile"
                            alt="img" loading="eager">
                        <img src="https://cdn.careerum.com/1775026900512-sHzCs-Fram.svg" class="hidden-desc-mobile" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1775028969068-dxCCQ-Fram.svg" class="hidden-desc-tablet" alt="img" loading="lazy">
                        <p>Получите впервые чёткую карту возможностей: <span>реальные сценарии</span> и подводные камни
                            каждого пути
                        </p>
                    </div>
                </div>
                <div class="seo-results-items">
                    <div class="seo-results-item careerum-flex-fsfs">
                        <img src="https://cdn.careerum.com/1775024549925-eFb9U-Fram.svg" class="hidden-tablet-mobile"
                            alt="img" loading="eager">
                        <img src="https://cdn.careerum.com/1775026900679-EjPhT-Fram.svg" class="hidden-desc-mobile" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1775028969150-QsH25-Fram.svg" class="hidden-desc-tablet" alt="img" loading="lazy">
                        <p>Пройдёте <span>карьерный чекап</span>, чтобы понять: какая траектория развития вам подходит
                        </p>
                    </div>
                    <div class="seo-results-item careerum-flex-fsfs">
                        <img src="https://cdn.careerum.com/1775024549857-c3yDW-Fram.svg" class="hidden-tablet-mobile"
                            alt="img" loading="eager">
                        <img src="https://cdn.careerum.com/1775026900874-zIE4Z-Fram.svg" class="hidden-desc-mobile" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1775028969194-przKX-Fram.svg" class="hidden-desc-tablet" alt="img" loading="lazy">
                        <p>Сформулируете <span>гипотезы</span> o своём дальнейшем развитии и <span>первые шаги</span>
                            к новому уровню свободы</p>
                    </div>
                    <div class="seo-results-item careerum-flex-fsfs">
                        <img src="https://cdn.careerum.com/1775024549741-i9HsX-Fram.svg" class="hidden-tablet-mobile"
                            alt="img" loading="eager">
                        <img src="https://cdn.careerum.com/1775026900944-YrmO3-Fram.svg" class="hidden-desc-mobile" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1775028969234-nyy3k-Fram.svg" class="hidden-desc-tablet" alt="img" loading="lazy">
                        <p>Проработаете <span>форматы монетизации</span></p>
                    </div>
                </div>
            </div>
            <a href="#program" class="btn-color-main-bright-orange">Посмотреть программу</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-seo-tales', {
        label: 'SEO tales (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-seo-tales main-wrapper">
        <div class="careerum-container-responsive-wide">
            <div class="seo-tales-wrapper careerum-flex-fsfs">
                <div class="seo-tales-item">
                    <div class="seo-tales-img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751272634787-0i23p-Fram.svg"
                            class="hidden-tablet-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751272791528-kbxrx-Fram.svg"
                            class="hidden-desc-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751355371534-Mf9xR-Fram.svg"
                            class="hidden-desc-tablet" alt="img">
                    </div>
                    <div class="seo-tales-orange-light_orange careerum-flex-cc">
                        <p>Экспертиза</p>
                    </div>
                </div>
                <div class="seo-tales-item">
                    <div class="seo-tales-light_blue-blue careerum-flex-cc">
                        <p>Монетизация</p>
                    </div>
                    <div class="seo-tales-img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751272634672-kysMV-Fram.svg"
                            class="hidden-tablet-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751272791410-kYdVO-Fram.svg"
                            class="hidden-desc-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751355371906-7mlwS-Fram.svg"
                            class="hidden-desc-tablet" alt="img">
                    </div>
                </div>
                <div class="seo-tales-item">
                    <div class="seo-tales-img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751272634490-vcSzn-Fram.svg"
                            class="hidden-tablet-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751272791293-Ldi3l-Fram.svg"
                            class="hidden-desc-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751355371653-fj2i8-Fram.svg"
                            class="hidden-desc-tablet" alt="img">
                    </div>
                    <div class="seo-tales-light_blue-orange careerum-flex-cc">
                        <p>Уверенность</p>
                    </div>
                </div>
                <div class="seo-tales-item">
                    <div class="seo-tales-light_orange-orange careerum-flex-cc">
                        <p>Автономия</p>
                    </div>
                    <div class="seo-tales-img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751272634383-cpP6q-Fram.svg"
                            class="hidden-tablet-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751272791172-xVuTb-Fram.svg"
                            class="hidden-desc-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751355372093-gV8qZ-Fram.svg"
                            class="hidden-desc-tablet" alt="img">
                    </div>
                </div>
                <div class="seo-tales-item">
                    <div class="seo-tales-img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751272634268-o3oHY-Fram.svg"
                            class="hidden-tablet-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751272791036-9EiJY-Fram.svg"
                            class="hidden-desc-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751355372239-WR87o-Fram.svg"
                            class="hidden-desc-tablet" alt="img">
                    </div>
                    <div class="seo-tales-white-blue careerum-flex-cc">
                        <p>Карьера</p>
                    </div>
                </div>
                <div class="seo-tales-item">
                    <div class="seo-tales-white-orange careerum-flex-cc">
                        <p>Стратегия</p>
                    </div>
                    <div class="seo-tales-img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751272634002-0Lemo-Fram.svg"
                            class="hidden-tablet-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751272790749-zy6jt-Fram.svg"
                            class="hidden-desc-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751355371758-eihes-Fram.svg"
                            class="hidden-desc-tablet" alt="img">
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-seo-about', {
        label: 'SEO about (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-seo-about main-wrapper seo-about2">
        <div class="careerum-container-responsive-wide">
            <h2>Мир больше не делится только на:</h2>
            <div class="seo-about-top careerum-flex-sbfs">
                <div class="seo-about-top-left position-relative">
                    <p>Начальников и исполнителей</p>
                </div>
                <div class="seo-about-top-right  position-relative">
                    <p>Предпринимателей и специалистов в найме</p>
                </div>
            </div>
            <div class="seo-about-bottom careerum-flex-sbst">
                <div class="seo-about-bottom-left careerum-flex-sbst">
                    <div class="seo-about-bottom-item blue position-relative">
                        <p class="position-relative z-10">На программе развенчиваем мифы</p>
                        <p class="position-relative z-10">О традиционной карьере и помогаем выбрать свой путь —
                            с примерами, кейсами и пошаговыми
                            инструментами</p>
                        <img src="https://cdn.careerum.com/1775025485197-8oA2u-Grou.svg"
                            class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1775027488334-SXneX-Grou.svg" class="hidden-desc-mobile position-absolute z-1" alt="img"
                            loading="lazy">
                        <img src="https://cdn.careerum.com/1775027532982-BuRQx-Grou.svg" class="hidden-desc-tablet position-absolute z-1" alt="img"
                            loading="lazy">
                    </div>
                    <div class="seo-about-bottom-item">
                        <img src="https://cdn.careerum.com/1775025059733-2x7lZ-Fram.svg" class="hidden-tablet-mobile"
                            alt="img">
                        <img src="https://cdn.careerum.com/1775027578483-zR3av-Fram.svg" class="hidden-desc-mobile"
                            alt="img">
                        <img src="https://cdn.careerum.com/1775029370392-VCIRK-Fram.svg" class="hidden-desc-tablet"
                            alt="img">
                        <p>Уйти из корпорации — <span>не значит</span> «умирать на фрилансе»</p>
                    </div>
                    <div class="seo-about-bottom-item">
                        <img src="https://cdn.careerum.com/1775025059795-PWoWh-Fram.svg" class="hidden-tablet-mobile"
                            alt="img">
                        <img src="https://cdn.careerum.com/1775027578533-PoUcQ-Fram.svg" class="hidden-desc-mobile"
                            alt="img">
                        <img src="https://cdn.careerum.com/1775029370486-enWVG-Fram.svg" class="hidden-desc-tablet"
                            alt="img">
                        <p class="hidden-tablet">Вертикальный рост <span>не обязателен</span> — есть горизонтальные
                            и гибридные
                            карьеры</p>
                        <p class="hidden-desc-mobile">Вертикальный рост <span>не обязателен</span> — есть горизонталь
                            ные и гибридные
                            карьеры</p>
                    </div>
                    <div class="seo-about-bottom-item">
                        <img src="https://cdn.careerum.com/1775025059827-Pg2T0-Fram.svg" class="hidden-tablet-mobile"
                            alt="img">
                        <img src="https://cdn.careerum.com/1775027578571-t0omL-Fram.svg" class="hidden-desc-mobile"
                            alt="img">
                        <img src="https://cdn.careerum.com/1775029370527-530t8-Fram.svg" class="hidden-desc-tablet"
                            alt="img">
                        <p>Одна профессия на всю жизнь? <span>Уже давно не так!</span></p>
                    </div>
                    <div class="seo-about-bottom-item">
                        <img src="https://cdn.careerum.com/1775025059861-q5WHr-Fram.svg" class="hidden-tablet-mobile"
                            alt="img">
                        <img src="https://cdn.careerum.com/1775027578607-xzBhz-Fram.svg" class="hidden-desc-mobile"
                            alt="img">
                        <img src="https://cdn.careerum.com/1775029370565-DiYru-Fram.svg" class="hidden-desc-tablet"
                            alt="img">
                        <p>Гиг-экономика, стартапы, кросс-командные форматы и slash-карьеры дают <span>новые
                                возможности</span>
                            профессионалам любого возраста</p>
                    </div>
                </div>
            </div>
            <a href="#program" class="btn-color-main-bright-orange">Посмотреть программу</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-seo-form', {
        label: 'SEO form (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-seo-form block1 main-wrapper" data-offer-rub="340" data-offer-eur="341" data-link-rub="1 900 ₽"
        data-link-eur="19 €">
        <div class="careerum-container-responsive-wide">
            <div class="seo-form-switcher careerum-flex-fec position-relative z-20">
                <div class="seo-form-curr careerum-flex-fsst">
                    <ul class="careerum-flex-fsfs rub">
                        <li data-currency="eur">EUR</li>
                        <li data-currency="rub" class="active">RUB</li>
                    </ul>
                    <div class="seo-form-notif careerum-flex-cc">
                        <div class="seo-form-notif-icon"> <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                alt=""> </div>
                        <div class="seo-form-notif-content">
                            <p>Оплата в российских рублях возможна только картой
                                российского банка. В&nbsp;евро — картой
                                зарубежного банка</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="seo-form-wrapper careerum-flex-sbfs position-relative z-10">
                <div class="seo-form-left position-relative z-20">
                    <div class="seo-form-labels careerum-flex-fsfs">
                        <p>Старт 22 июля</p>
                        <p>Живой курс с Ольгой Лермонтовой</p>
                    </div>
                    <h2>СЕО своей карьеры</h2>
                    <p class="seo-form-subheader">Новые пути для развития и заработка в современном мире</p>
                    <p class="seo-form-list-header">Что входит в курс:</p>
                    <ul>
                        <li class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751279475940-7rk6l-Soft.svg"
                                class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751356944437-BocQ6-Soft.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>Тест</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751279475940-7rk6l-Soft.svg"
                                class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751356944437-BocQ6-Soft.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>2 живых эфира от Ольги Лермонтовой (формат: лекции + ответы на вопросы)</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751279475940-7rk6l-Soft.svg"
                                class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751356944437-BocQ6-Soft.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>Канал информации в Telegram</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751279475940-7rk6l-Soft.svg"
                                class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751356944437-BocQ6-Soft.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>Чат для общения в Telegram</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751279475940-7rk6l-Soft.svg"
                                class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751356944437-BocQ6-Soft.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>Рабочие материалы</p>
                        </li>
                    </ul>
                </div>
                <div class="seo-form-right position-relative z-20">
                    <div class="careerum-registration-form-club40">
                        <form class="deva-form" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                            <div class="careerum-club40-form-name"> <input type="text" name="name" value="" required
                                    placeholder="Имя">
                                <p class="careerum-club40-form-warn">Поле не заполнено</p>
                            </div>
                            <div class="careerum-club40-form-email"> <input type="text" name="email" value="" required
                                    placeholder="Почта">
                                <p class="careerum-club40-form-warn">Поле не заполнено</p>
                            </div>
                            <div class="careerum-club40-form-phone"> <input type="tel" value="" name="tel" required
                                    class="itl-input">
                                <p class="careerum-club40-form-warn">Поле не заполнено</p>
                            </div>
                            <div class="careerum-club40-form-agree"> <label> <input type="checkbox" name="agree">
                                    <div> <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                            fill="none">
                                            <path
                                                d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                        </svg> </div>
                                </label>
                                <p>Я принимаю условия <a href="/ru-intl/legal/offer">Оферты</a> и даю согласие
                                    на обработку персональных данных в соответствии с <a
                                        href="/ru-ru/legal/privacy">Политикой конфиденциальности</a>. </p>
                            </div>
                            <a href="#" class="submit-btn btn-color-main-bright-orange careerum-flex-cc" disabled>
                                Оплатить участие 1000 ₽ </a>
                            <input type="hidden" hidden name="offerID" value="" autocomplete="off">
                        </form>
                    </div>
                </div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751279824246-BCzX3-ÑÐ¾.svg"
                    class="hidden-tablet-mobile position-absolute z-10" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751279833758-TWhWa-ÑÐ¾.svg"
                    class="hidden-desc-mobile position-absolute z-10" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751371045841-X4B9l-ÑÐ¾.svg"
                    class="hidden-desc-tablet position-absolute z-10" alt="img">
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-seo-author', {
        label: 'SEO author (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-seo-author main-wrapper">
        <div class="careerum-container-responsive-wide">
            <h2>Автор и спикер курса</h2>
            <div class="seo-author-wrapper careerum-flex-sbst">
                <div class="seo-author-photo">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751280098173-0IAa5-Fram.png"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751280105332-2f5KW-Fram.png"
                        class="hidden-desc-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751280112780-DUfzT-Fram.png"
                        class="hidden-desc-tablet" alt="img">
                </div>
                <div class="seo-author-info position-relative">
                    <p class="seo-author-name position-relative z-20">Ольга Лермонтова</p>
                    <p class="seo-author-description position-relative z-20">Путь: от филолога-репетитора
                        до международного стратега и предпринимателя</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751280341150-unujQ-ÑÐ¾.svg"
                        class="hidden-tablet-mobile position-absolute z-10" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751280344917-RhqxM-ÑÐ¾.svg"
                        class="hidden-desc-mobile position-absolute z-10" alt="img">
                </div>
                <div class="seo-author-list">
                    <ul>
                        <li class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751280673516-dk4Uw-MapP.svg"
                                class="hidden-tablet-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751280804472-2dwqr-MapP.svg"
                                class="hidden-desc-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751280957310-QvjMX-MapP.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>Старт: преподаватель английского и итальянского</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751280673400-mDbrc-Path.svg"
                                class="hidden-tablet-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751280804697-FwDeZ-Path.svg"
                                class="hidden-desc-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751280957555-YYtab-Path.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>Переход в бизнес: B2B-продажи в Adobe, McAfee</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751280673268-sF8z5-Bag .svg"
                                class="hidden-tablet-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751280804116-MpQTF-Bag..svg"
                                class="hidden-desc-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751280956887-s5e5x-Bag..svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>Стратегия & масштаб: Microsoft — развитие продаж на 12 рынках</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751280672903-K5nUM-Lock.svg"
                                class="hidden-tablet-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751280804363-msCkE-Lock.svg"
                                class="hidden-desc-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751280957190-1C3Js-Lock.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>Digital и глобальный онлайн: Google (UK&I) — стратегия цифровых продуктов</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751280672743-IXARZ-MapT.svg"
                                class="hidden-tablet-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751280804585-xBGK8-MapT.svg"
                                class="hidden-desc-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751280957436-2JCiP-MapT.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>TravelTech и новые индустрии: Travelport, развитие продаж и стратегия на 20+ рынков.</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751280672503-K6OEC-Rock.svg"
                                class="hidden-tablet-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751280804799-NVQKK-Rock.svg"
                                class="hidden-desc-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751280957668-YTh3R-Rock.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>Собственный бизнес: Founder & CEO Careerum — международная платформа карьерного развития
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="careerum-container-responsive-wide">
            <h2>Автор и спикер программы</h2>
            <div class="seo-author-wrapper careerum-flex-sbst">
                <div class="seo-author-photo">
                    <img src="https://cdn.careerum.com/1775025793433-j0nwa-Fram.png" class="hidden-tablet-mobile"
                        alt="img">
                    <img src="https://cdn.careerum.com/1775027801625-SFUS1-Fram.png" class="hidden-desc-mobile"
                        alt="img">
                    <img src="https://cdn.careerum.com/1775029631208-0q6jA-Fram.png" class="hidden-desc-tablet"
                        alt="img">
                </div>
                <div class="seo-author-info position-relative">
                    <p class="seo-author-description position-relative z-20">Путь: от филолога-репетитора
                        до международного стратега и предпринимателя</p>
                    <ul>
                        <li class="careerum-flex-fsfs">
                            <img src="https://cdn.careerum.com/1751280673516-dk4Uw-MapP.svg"
                                class="hidden-tablet-mobile" alt="img">
                            <img src="https://cdn.careerum.com/1751280804472-2dwqr-MapP.svg" class="hidden-desc-mobile"
                                alt="img">
                            <img src="https://cdn.careerum.com/1751280957310-QvjMX-MapP.svg" class="hidden-desc-tablet"
                                alt="img">
                            <p>Старт: преподаватель английского и итальянского</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://cdn.careerum.com/1751280673400-mDbrc-Path.svg"
                                class="hidden-tablet-mobile" alt="img">
                            <img src="https://cdn.careerum.com/1751280804697-FwDeZ-Path.svg" class="hidden-desc-mobile"
                                alt="img">
                            <img src="https://cdn.careerum.com/1751280957555-YYtab-Path.svg" class="hidden-desc-tablet"
                                alt="img">
                            <p>Переход в бизнес: B2B-продажи в Adobe, McAfee</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://cdn.careerum.com/1751280673268-sF8z5-Bag .svg"
                                class="hidden-tablet-mobile" alt="img">
                            <img src="https://cdn.careerum.com/1751280804116-MpQTF-Bag..svg" class="hidden-desc-mobile"
                                alt="img">
                            <img src="https://cdn.careerum.com/1751280956887-s5e5x-Bag..svg" class="hidden-desc-tablet"
                                alt="img">
                            <p>Стратегия & масштаб: Microsoft — развитие продаж на 12 рынках</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://cdn.careerum.com/1751280672903-K5nUM-Lock.svg"
                                class="hidden-tablet-mobile" alt="img">
                            <img src="https://cdn.careerum.com/1751280804363-msCkE-Lock.svg" class="hidden-desc-mobile"
                                alt="img">
                            <img src="https://cdn.careerum.com/1751280957190-1C3Js-Lock.svg" class="hidden-desc-tablet"
                                alt="img">
                            <p>Digital и глобальный онлайн: Google (UK&I) — стратегия цифровых продуктов</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://cdn.careerum.com/1751280672743-IXARZ-MapT.svg"
                                class="hidden-tablet-mobile" alt="img">
                            <img src="https://cdn.careerum.com/1751280804585-xBGK8-MapT.svg" class="hidden-desc-mobile"
                                alt="img">
                            <img src="https://cdn.careerum.com/1751280957436-2JCiP-MapT.svg" class="hidden-desc-tablet"
                                alt="img">
                            <p>TravelTech и новые индустрии: Travelport, развитие продаж и стратегия на 20+ рынков.</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://cdn.careerum.com/1751280672503-K6OEC-Rock.svg"
                                class="hidden-tablet-mobile" alt="img">
                            <img src="https://cdn.careerum.com/1751280804799-NVQKK-Rock.svg" class="hidden-desc-mobile"
                                alt="img">
                            <img src="https://cdn.careerum.com/1751280957668-YTh3R-Rock.svg" class="hidden-desc-tablet"
                                alt="img">
                            <p>Собственный бизнес: Founder & CEO Careerum — международная платформа карьерного развития
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-seo-program', {
        label: 'SEO program (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-seo-program main-wrapper">
        <div class="careerum-container-responsive-wide">
            <div class="seo-program-header careerum-flex-fsc">
                <h2>Программа</h2>
                <p class="seo-program-start">Старт 22 июля</p>
            </div>
            <div class="seo-program-top careerum-flex-sbst">
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751281444578-uWzU6-Vide.svg"
                        class="hidden-tablet" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751281466438-lzlD2-Vide.svg"
                        class="hidden-desc-mobile" alt="img">
                    <p>2 живых эфира с Ольгой Лермонтовой</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751281444294-t8wCt-Test.svg"
                        class="hidden-tablet" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751281466313-Q3PKI-Test.svg"
                        class="hidden-desc-mobile" alt="img">
                    <p>Карьерный чекап</p>
                </div>
            </div>
            <div class="seo-program-item">
                <p class="seo-program-item-label">Модуль 01</p>
                <p class="seo-program-item-header">КАРЬЕРНАЯ НАВИГАЦИЯ БУДУЩЕГО</p>
                <div class="seo-program-item-content">
                    <p>Рассмотрим, какой тип развития и монетизации подходит именно вам:</p>
                    <ul>
                        <li>Корпорации</li>
                        <li>Малый и средний бизнес</li>
                        <li>Стартапы</li>
                        <li>Slash-карьера: новые гибридные роли и как совмещать найм и фриланс</li>
                        <li>Предпринимательство/side-проекты</li>
                        <li>Экспертный фриланс</li>
                    </ul>
                </div>
                <div class="seo-program-item-content">
                    <p>Тест-практикум: какой тип развития и монетизации подходит именно вам </p>
                </div>
            </div>
            <div class="seo-program-item">
                <p class="seo-program-item-label">Модуль 02</p>
                <p class="seo-program-item-header">МОНЕТИЗАЦИЯ И ФИНАНСОВАЯ СВОБОДА</p>
                <div class="seo-program-item-content">
                    <p>Как подстелить «финансовую подушку», чтобы спокойно менять формат работы</p>
                </div>
                <div class="seo-program-item-content">
                    <p>Все современные способы монетизации экспертизы: почасовые ставки, продуктовые модели, роялти,
                        консалтинг и др.</p>
                </div>
                <div class="seo-program-item-content">
                    <p>Юридические, операционные, жизненные лайфхаки: как не «потеряться между форматами»</p>
                </div>
            </div>
            <a href="#buy" class="btn-color-main-bright-orange">Купить курс</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-seo-cases', {
        label: 'SEO cases (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-seo-cases main-wrapper">
        <div class="careerum-container-responsive-wide">
            <h2>Кейсы участников Careerum</h2>
            <div class="seo-cases-wrapper">
                <div class="seo-cases-items">
                    <div class="seo-cases-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751283067505-YCZTq-Fram.png"
                            alt="img">
                        <div>
                            <p class="seo-cases-item-name">Кирилл Азаренко</p>
                            <p class="seo-cases-item-position">Лид продукта, Россия</p>
                            <div class="seo-cases-item-line"></div>
                            <p class="seo-cases-item-about">Перешёл из семейного бизнеса в найм, чтобы найти работy
                                по любви
                            </p>
                            <div class="seo-cases-item-result careerum-flex-fsc"> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751283511678-vO34H-Chec.svg"
                                    alt="">
                                <p>Результат с Careerum: </p>
                            </div>
                            <ul>
                                <li>Сменил вектор и вырос до руководящей должности</li>
                                <li>Увеличил доход в 4 раза</li>
                                <li>Стал амбассадором Careerum, проводит нетворк-встречи клуба</li>
                            </ul>
                        </div>
                    </div>
                    <div class="seo-cases-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751283067227-VqzAV-Fram.png"
                            alt="img">
                        <div>
                            <p class="seo-cases-item-name">Александра Анцупова</p>
                            <p class="seo-cases-item-position">Crew Coordinator and Analyst, Латвия</p>
                            <div class="seo-cases-item-line"></div>
                            <p class="seo-cases-item-about">Меняла сферы деятельности, нигде не могла почyвствовать себя
                                на своём месте
                            </p>
                            <div class="seo-cases-item-result careerum-flex-fsc"> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751283511678-vO34H-Chec.svg"
                                    alt="">
                                <p>Результат с Careerum: </p>
                            </div>
                            <ul>
                                <li>Собрала весь свой опыт в сильное резюме мyльтиспециалиста</li>
                                <li>Полностью сменила индустрию и выросла в зарплате</li>
                                <li>Осознала свои ценности и потребности в работе</li>
                            </ul>
                        </div>
                    </div>
                    <div class="seo-cases-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751283066523-OmCSs-Fram.png"
                            alt="img">
                        <div>
                            <p class="seo-cases-item-name">Наталья Рябова</p>
                            <p class="seo-cases-item-position">Global L&D Manager, Германия</p>
                            <div class="seo-cases-item-line"></div>
                            <p class="seo-cases-item-about">Совмещала проекты, накопила опыт и устроилась в Германии
                                без немецкого</p>
                            <div class="seo-cases-item-result careerum-flex-fsc"> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751283511678-vO34H-Chec.svg"
                                    alt="">
                                <p>Результат с Careerum: </p>
                            </div>
                            <ul>
                                <li>Выросла в зарплате на 70%</li>
                                <li>Полyчила оффер через 2 недели после собеседования</li>
                                <li>Сформировалось ощущение «я на своём месте»</li>
                            </ul>
                        </div>
                    </div>
                    <div class="seo-cases-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751283066138-E9XVD-Fram.png"
                            alt="img">
                        <div>
                            <p class="seo-cases-item-name">Дмитрий Иванов</p>
                            <p class="seo-cases-item-position">Chief Operating Officer, ОАЭ</p>
                            <div class="seo-cases-item-line"></div>
                            <p class="seo-cases-item-about">Работал в найме, перешёл в свой консалтинговый проект,
                                диверсифицировал доход</p>
                            <div class="seo-cases-item-result careerum-flex-fsc"> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751283511678-vO34H-Chec.svg"
                                    alt="">
                                <p>Результат с Careerum: </p>
                            </div>
                            <ul>
                                <li>Появилось ощyщение финансовой yверенности</li>
                                <li>Сократилась тревога остаться невостребованным специалистом</li>
                                <li>Стало легче решаться на перемены и амбициозные шаги</li>
                            </ul>
                        </div>
                    </div>
                    <div class="seo-cases-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751283065397-0ayJ0-Fram.png"
                            alt="img">
                        <div>
                            <p class="seo-cases-item-name">Елизавета Коряковская</p>
                            <p class="seo-cases-item-position">MD & Board-Certified Cardiologist, Голландия
                            </p>
                            <div class="seo-cases-item-line"></div>
                            <p class="seo-cases-item-about">Строит портфельную карьеру, совмещая околомедицинские
                                проекты
                            </p>
                            <div class="seo-cases-item-result careerum-flex-fsc"> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751283511678-vO34H-Chec.svg"
                                    alt="">
                                <p>Результат с Careerum: </p>
                            </div>
                            <ul>
                                <li>Релоцировалась в Голландию</li>
                                <li>Выросла в доходе благодаря совмещению проектов</li>
                                <li>Расширила экспертизy и стала yвереннее в себе как в специалисте</li>
                            </ul>
                        </div>
                    </div>
                    <div class="seo-cases-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751283065828-z2Wz9-Fram.png"
                            alt="img">
                        <div>
                            <p class="seo-cases-item-name">Мария Санкова</p>
                            <p class="seo-cases-item-position">Business Development Manager, ОАЭ </p>
                            <div class="seo-cases-item-line"></div>
                            <p class="seo-cases-item-about">Попробовала себя в мyзыке, логистике, бизнесе, не видела
                                себя
                                ни в одном направлении</p>
                            <div class="seo-cases-item-result careerum-flex-fsc"> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751283511678-vO34H-Chec.svg"
                                    alt="">
                                <p>Результат с Careerum: </p>
                            </div>
                            <ul>
                                <li>Сформировала четкyю карьернyю цель</li>
                                <li>Поняла, какая карьера «её» по‑настоящемy</li>
                                <li>Использовала прошлый опыт, чтобы полyчить текyщyю роль и релоцироваться в ОАЭ</li>
                            </ul>
                        </div>
                    </div>
                    <div class="seo-cases-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751283064958-tNuNc-Fram.png"
                            alt="img">
                        <div>
                            <p class="seo-cases-item-name">Ольга Дробышева</p>
                            <p class="seo-cases-item-position">Специалист по маркетингy, Россия</p>
                            <div class="seo-cases-item-line"></div>
                            <p class="seo-cases-item-about">Пробовала себя в 7 разных ролях, но всегда появлялось
                                ощущение,
                                что выросла из них
                            </p>
                            <div class="seo-cases-item-result careerum-flex-fsc"> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751283511678-vO34H-Chec.svg"
                                    alt="">
                                <p>Результат с Careerum: </p>
                            </div>
                            <ul>
                                <li>Наша сферy, где по‑настоящемy интересно и можно применить весь опыт</li>
                                <li>Выросла в зарплате на 50%</li>
                                <li>Появилось ощyщение самореализованности</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <a href="#buy" class="btn-color-main-bright-orange">Купить курс</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club40-who', {
        label: 'Club 4 who (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club40-who main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>С нами построить карьеру мечты может каждый</h2>
                    <p>Помогаем специалистам любого возраста из любых отраслей и стран</p>
                    <div class="club40-who-wrapper careerum-flex-cc">
                        <div class="club40-who-item">
                            <p>Менеджеры</p>
                        </div>
                        <div class="club40-who-item">
                            <p>Инженеры</p>
                        </div>
                        <div class="club40-who-item">
                            <p>Дизайнеры</p>
                        </div>
                        <div class="club40-who-item blue">
                            <p>Маркетологи</p>
                        </div>
                        <div class="club40-who-item">
                            <p>Бухгалтеры</p>
                        </div>
                        <div class="club40-who-item blue">
                            <p>Медработники</p>
                        </div>
                        <div class="club40-who-item">
                            <p>Айтишники</p>
                        </div>
                        <div class="club40-who-item">
                            <p>С-lеvеl</p>
                        </div>
                        <div class="club40-who-item">
                            <p>Джyны</p>
                        </div>
                        <div class="club40-who-item">
                            <p>Выгоревшие</p>
                        </div>
                        <div class="club40-who-item blue">
                            <p>Запyтавшиеся в карьере</p>
                        </div>
                    </div>
                    <div class="club40-who-wrapper careerum-flex-cc">
                        <div class="club40-who-item">
                            <p>Менеджеры</p>
                        </div>
                        <div class="club40-who-item">
                            <p>С-lеvеl</p>
                        </div>
                        <div class="club40-who-item blue">
                            <p>Инженеры</p>
                        </div>
                        <div class="club40-who-item">
                            <p>Дизайнеры</p>
                        </div>
                        <div class="club40-who-item">
                            <p>Маркетологи</p>
                        </div>
                        <div class="club40-who-item">
                            <p>Джyны</p>
                        </div>
                        <div class="club40-who-item blue">
                            <p>Запyтавшиеся в карьере</p>
                        </div>
                        <div class="club40-who-item">
                            <p>Айтишники</p>
                        </div>
                        <div class="club40-who-item">
                            <p>Медработники</p>
                        </div>
                        <div class="club40-who-item">
                            <p>Бухгалтеры</p>
                        </div>
                        <div class="club40-who-item">
                            <p>Выгоревшие</p>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-club40-programs', {
        label: 'Club 4 programs (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club40-programs main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>В подписке Careerum доступны 8 карьерных программ:</h2>
                    <div class="club40-programs-wrapper careerum-flex-sbst">
                        <div class="club40-programs-item">
                            <div class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751881408659-i5T5N-Rock.svg"
                                    class="hidden-tablet" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751897397874-wxglb-Rock.svg" class="hidden-desc-mobile"
                                    alt="img">
                                <p>Карьерная ракета: как расти внутри компании </p>
                            </div>
                            <ul>
                                <li>Жизнь после оффера: успешный онбординг</li>
                                <li>Цели как в Google: как расти и быть эффективнее</li>
                                <li>Карьера как проект: управляй карьерой без стресса и с PDP</li>
                                <li>Пробей зарплатный потолок</li>
                                <li>Нетворкинг</li>
                            </ul>
                        </div>
                        <div class="club40-programs-item">
                            <div class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751881408538-zCxjM-Star.svg"
                                    class="hidden-tablet" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751897398118-MGSHL-Star.svg" class="hidden-desc-mobile"
                                    alt="img">
                                <p>Звездный кандидат: как найти работу мечты </p>
                            </div>
                            <ul>
                                <li>Стратегия и 150 площадок поиска</li>
                                <li>Резюме + валидатор резюме СV-Hеlpеr + LinkedIn</li>
                                <li>Интервью</li>
                                <li>Переговоры по офферу</li>
                            </ul>
                        </div>
                        <div class="club40-programs-item">
                            <div class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751881408420-NGHr0-Arro.svg"
                                    class="hidden-tablet" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751897397053-lNodf-Arro.svg" class="hidden-desc-mobile"
                                    alt="img">
                                <p>Выход из карьерного кризиса и перезагрузка </p>
                            </div>
                            <ul>
                                <li>Real Me</li>
                                <li>Портфельная / нелинейная / slash-карьера / предпринимательское мышление</li>
                                <li>Новые горизонты </li>
                                <li>Антикризис</li>
                            </ul>
                        </div>
                        <div class="club40-programs-item">
                            <div class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751881408293-8zjdh-Scal.svg"
                                    class="hidden-tablet" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751897397986-zT9zV-Scal.svg" class="hidden-desc-mobile"
                                    alt="img">
                                <p>Life work balance: карьера без стресса</p>
                            </div>
                            <ul>
                                <li>Самооценка</li>
                                <li>Границы</li>
                                <li>Невыгорание</li>
                            </ul>
                        </div>
                        <div class="club40-programs-item">
                            <div class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751881408161-4o08s-Flas.svg"
                                    class="hidden-tablet" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751897397347-HH8vu-Flas.svg" class="hidden-desc-mobile"
                                    alt="img">
                                <p>Careerum Lab: навыки будущего </p>
                            </div>
                            <ul>
                                <li>Эмоциональный интеллект</li>
                                <li>Удаленка</li>
                                <li>Карьера и финансы</li>
                                <li>Публичные выступления</li>
                                <li>Data-driven, zoom out, use your head</li>
                            </ul>
                        </div>
                        <div class="club40-programs-item">
                            <div class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751881408027-csAaf-Hand.svg"
                                    class="hidden-tablet" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751897397472-a2ml8-Hand.svg" class="hidden-desc-mobile"
                                    alt="img">
                                <p>Big Boss: как быть успешным руководителем </p>
                            </div>
                            <ul>
                                <li>Самооценка</li>
                                <li>Границы</li>
                                <li>Невыгорание</li>
                            </ul>
                        </div>
                        <div class="club40-programs-item wide">
                            <div class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751881407717-i4oUf-Mega.svg"
                                    class="hidden-tablet" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751897397761-FD7P6-Mega.svg" class="hidden-desc-mobile"
                                    alt="img">
                                <p>Power Talk: коммуникации для прорыва в карьере</p>
                            </div>
                            <ul>
                                <li>Международная карьера</li>
                                <li>Уроки географии</li>
                                <li>Зарубежное образование</li>
                            </ul>
                        </div>
                        <div class="club40-programs-item wide">
                            <div class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751881532663-OMGyk-MapP.svg"
                                    class="hidden-tablet" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751897397651-DA5ze-MapP.svg" class="hidden-desc-mobile"
                                    alt="img">
                                <p>Старт в Careerum </p>
                            </div>
                            <ul class="slim">
                                <li>Дебанк карьерных мифов</li>
                                <li>Определение вашей карьерной стадии</li>
                                <li>Аудит текущего статуса</li>
                                <li>Создание вашей кастомной траектории обучения</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-club40-form2', {
        label: 'Club 4 form2 (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club40-form2 main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="club40-form2-wrapper careerum-flex-sbfs">
                        <div class="club40-form2-left position-relative">
                            <h2 class="position-relative z-20">Пройдите тест и получите вашу индивидуальную программу развития
                                карьеры</h2>
                            <p class="position-relative z-20">Это бесплатно!</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751883286476-FVwbZ-Vect.svg"
                                class="hidden-tablet-mobile position-absolute z-10" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751883276153-SObe3-Vect.svg"
                                class="hidden-desc-mobile position-absolute z-10" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751883296331-GduPE-Vect.svg"
                                class="hidden-desc-tablet position-absolute z-10" alt="img">
                        </div>
                        <div class="club40-form2-right">
                            <div class="careerum-registration-form-club40">
                                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                    data-gjs-type="deva-registration-form">
                                    <div class="careerum-club40-form-name">
                                        <input type="text" name="name" value="" required placeholder="Имя">
                                        <p class="careerum-club40-form-warn">Неверное имя</p>
                                    </div>
                                    <div class="careerum-club40-form-email">
                                        <input type="text" name="email" value="" required placeholder="Почта">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                    </div>
                                    <div class="careerum-club40-form-phone">
                                        <input type="tel" value="" name="tel" required class="itl-input">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                    </div>
                                    <div class="careerum-club40-form-agree">
                                        <label>
                                            <input type="checkbox" name="agree">
                                            <div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                    fill="none">
                                                    <path
                                                        d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                        stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </label>
                                        <p>Я даю согласие на обработку своих персональных данных в соответствии с <a
                                                href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                                    </div>
                                    <a href="#" class="submit-btn btn-color-main-bright-orange" disabled>Пройти тест</a>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-club40-author2', {
        label: 'Club 4 author2 (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club40-author2 main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="club40-author2-header position-relative">
                        <p class="position-relative z-10">
                            <span>Мир обновился,</span> а ваша карьерная стратегия — нет!
                        </p>
                        <img src="https://cdn.careerum.com/1774351600370-ivgmA-Grou.svg"
                            class="hidden-tablet-mobile position-absolute" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1774361201080-eWevZ-Grou.svg"
                            class="hidden-desc-mobile position-absolute" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1774362998539-LR2Do-Grou.svg"
                            class="hidden-desc-tablet position-absolute" alt="img" loading="lazy">
                    </div>
                    <h2>Основательница и автор методологии Careerum</h2>
                    <div class="club40-author2-wrapper careerum-flex-sbst">
                        <div class="club40-author2-left">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751883990101-FdJox-Fram.png"
                                class="hidden-tablet-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751898694150-FuOBC-Imag.png" class="hidden-desc-mobile"
                                alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751903884181-oXitW-Imag.png" class="hidden-desc-tablet"
                                alt="img">
                        </div>
                        <div class="club40-author2-right">
                            <p class="club40-author2-name">Ольга Лермонтова</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751884348694-1DDGj-Soft.svg"
                                        class="hidden-mobile" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751884352612-hET3j-Soft.svg"
                                        class="hidden-desc-tablet" alt="img">
                                    <p><span>15+ лет управленческой карьеры</span> в Google, Microsoft, Adobe, Intel
                                        на 25 рынках (Европа, СНГ, Ближний Восток, Африка).</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751884348694-1DDGj-Soft.svg"
                                        class="hidden-mobile" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751884352612-hET3j-Soft.svg"
                                        class="hidden-desc-tablet" alt="img">
                                    <p><span>MBA от INSEAD,</span> магистратура по психологии в Harvard University.
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751884348694-1DDGj-Soft.svg"
                                        class="hidden-mobile" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751884352612-hET3j-Soft.svg"
                                        class="hidden-desc-tablet" alt="img">
                                    <p><span>Карьерный коуч и стратег</span> с портфелем из 13 000 клиентов из 60 стран.
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751884348694-1DDGj-Soft.svg"
                                        class="hidden-mobile" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751884352612-hET3j-Soft.svg"
                                        class="hidden-desc-tablet" alt="img">
                                    <p><span>Состоялась в разных форматах:</span> как сотрудник, эксперт-фрилансер
                                        и предприниматель.</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751884348694-1DDGj-Soft.svg"
                                        class="hidden-mobile" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751884352612-hET3j-Soft.svg"
                                        class="hidden-desc-tablet" alt="img">
                                    <p><span>Перепридумывала свою карьеру 7 раз:</span> из репетитора по языкам — в продажи
                                        и маркетинг — потом в стратегию — потом в свой бизнес.
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751884348694-1DDGj-Soft.svg"
                                        class="hidden-mobile" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751884352612-hET3j-Soft.svg"
                                        class="hidden-desc-tablet" alt="img">
                                    <p><span>Автор бестселлера</span> МИФ «Работа по любви».</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-club40-experts', {
        label: 'Club 4 experts (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club40-experts main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Авторы курсов — ведущие карьерные эксперты и стратеги</h2>
                    <div class="club40-experts-wrapper noselect careerum-flex-fsst">
                        <div class="club40-experts-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751886594810-OyWeK-phot.png" class="hidden-tablet-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751899044239-xzjDU-phot.png" class="hidden-desc" alt="img">
                            <p class="club40-experts-name">Михаил Ромашов</p>
                            <p class="club40-experts-position">Product Owner SberCIB</p>
                            <ul>
                                <li>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751885806207-f6tns-Chec.svg" alt="">
                                    <p>5+лет опыта</p>
                                </li>
                                <li>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751885806207-f6tns-Chec.svg" alt="">
                                    <p>Помог 500+ клиентам научиться грамотно выстраивать коммуникации</p>
                                </li>
                                <li>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751885806207-f6tns-Chec.svg" alt="">
                                    <p>Работал с компаниями Skolkovo, Mars, Sber</p>
                                </li>
                            </ul>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751885808676-5JzRt-Loca.svg" alt="">
                                <p>Россия</p>
                            </div>
                        </div>
                        <div class="club40-experts-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751886595232-e6Xbj-phot.png" class="hidden-tablet-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751899044562-5b40n-phot.png" class="hidden-desc" alt="img">
                            <p class="club40-experts-name">Елена Резанова</p>
                            <p class="club40-experts-position">карьерный стратег</p>
                            <ul>
                                <li>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751885806207-f6tns-Chec.svg" alt="">
                                    <p>9+ лет опыта</p>
                                </li>
                                <li>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751885806207-f6tns-Chec.svg" alt="">
                                    <p>Помогает посмотреть на карьеру целостно и соотнести ее с целями бизнеса</p>
                                </li>
                                <li>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751885806207-f6tns-Chec.svg" alt="">
                                    <p>Автор книг-бестселлеров «Никогда-нибудь» и «Это норм!»</p>
                                </li>
                            </ul>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751885808676-5JzRt-Loca.svg" alt="">
                                <p>Монако </p>
                            </div>
                        </div>
                        <div class="club40-experts-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751886595440-aD0Oq-phot.png" class="hidden-tablet-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751899044695-EYDLK-phot.png" class="hidden-desc" alt="img">
                            <p class="club40-experts-name">Sophie Vurpillot</p>
                            <p class="club40-experts-position">рекрутер и коуч</p>
                            <ul>
                                <li>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751885806207-f6tns-Chec.svg" alt="">
                                    <p>10+ лет опыта</p>
                                </li>
                                <li>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751885806207-f6tns-Chec.svg" alt="">
                                    <p>Помогла специалистам из 20+ стран раскрыть потенциал</p>
                                </li>
                                <li>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751885806207-f6tns-Chec.svg" alt="">
                                    <p>Сотрудничала с университетами Европы, США и Латинской Америки</p>
                                </li>
                            </ul>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751885808676-5JzRt-Loca.svg" alt="">
                                <p>Испания</p>
                            </div>
                        </div>
                        <div class="club40-experts-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751886595666-VoTLk-phot.png" class="hidden-tablet-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751899044804-5Cp0h-phot.png" class="hidden-desc" alt="img">
                            <p class="club40-experts-name">Анна Бабич</p>
                            <p class="club40-experts-position">психолог</p>
                            <ul>
                                <li>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751885806207-f6tns-Chec.svg" alt="">
                                    <p>Терапевт в сфере АСТ и эмоционально-фокусированной терапии</p>
                                </li>
                                <li>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751885806207-f6tns-Chec.svg" alt="">
                                    <p>Автор книги-бестселлера «Внутренняя опора»</p>
                                </li>
                                <li>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751885806207-f6tns-Chec.svg" alt="">
                                    <p>Спикер конференций: Psychologies, TeamLead, CodeFest</p>
                                </li>
                            </ul>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751885808676-5JzRt-Loca.svg" alt="">
                                <p>Россия</p>
                            </div>
                        </div>
                        <div class="club40-experts-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751886596007-TP3H5-phot.png" class="hidden-tablet-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751899044919-uA7sq-phot.png" class="hidden-desc" alt="img">
                            <p class="club40-experts-name">Montse Lorente</p>
                            <p class="club40-experts-position">рекрутер и коуч</p>
                            <ul>
                                <li>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751885806207-f6tns-Chec.svg" alt="">
                                    <p>10+ лет опыта</p>
                                </li>
                                <li>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751885806207-f6tns-Chec.svg" alt="">
                                    <p>Помогла специалистам из 20+ стран раскрыть потенциал</p>
                                </li>
                                <li>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751885806207-f6tns-Chec.svg" alt="">
                                    <p>Сотрудничала с университетами Европы, США и Латинской Америки.</p>
                                </li>
                            </ul>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751885808676-5JzRt-Loca.svg" alt="">
                                <p>Перу</p>
                            </div>
                        </div>
                        <div class="club40-experts-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751886596469-S3CmV-phot.png" class="hidden-tablet-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751899045047-USgl9-phot.png" class="hidden-desc" alt="img">
                            <p class="club40-experts-name">Санжар Ибрагимов</p>
                            <p class="club40-experts-position">ментор</p>
                            <ul>
                                <li>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751885806207-f6tns-Chec.svg" alt="">
                                    <p>Опыт в консалтинге в McKinsey & Company, PwC, World Bank Group</p>
                                </li>
                                <li>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751885806207-f6tns-Chec.svg" alt="">
                                    <p>MBA в швейцарской бизнес-школе IMD</p>
                                </li>
                                <li>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751885806207-f6tns-Chec.svg" alt="">
                                    <p>Ментор в IMD International и Aalto Business School</p>
                                </li>
                            </ul>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751885808676-5JzRt-Loca.svg" alt="">
                                <p>Финляндия</p>
                            </div>
                        </div>
                    </div>
                    <a href="#buy" class="btn-color-main-dark-orange">Выбрать тариф</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-club40-career_consult', {
        label: 'Club 4 career_consult (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club40-career_consult main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="club40-career_consult-main-wrapper">
                        <div class="club40-career_consult-top careerum-flex-sbfs">
                            <div class="club40-career_consult-left">
                                <p class="club40-career_consult-label">Карьерные консультации</p>
                                <h2>Команда карьерных коучей и экспертов с международной сертификацией</h2>
                                <div class="club40-career_consult-numbers-top hidden-desc">
                                    <div class="careerum-flex-fsc">
                                        <p class="club40-career_consult-number">3800+</p>
                                        <p class="club40-career_consult-text">часов проведённых сессий</p>
                                    </div>
                                    <div class="careerum-flex-fsc">
                                        <p class="club40-career_consult-number">9,5/10</p>
                                        <p class="club40-career_consult-text">средняя оценка карьерных экспертов</p>
                                    </div>
                                </div>
                            </div>
                            <div class="club40-career_consult-right">
                                <div class="club40-career_consult-numbers hidden-tablet-mobile">
                                    <p class="club40-career_consult-number">3 800+</p>
                                    <p class="club40-career_consult-text">часов проведённых сессий</p>
                                    <p class="club40-career_consult-number">9,5/10</p>
                                    <p class="club40-career_consult-text">средняя оценка карьерных экспертов</p>
                                </div>
                                <div class="club40-career_consult-item-top hidden-desc">
                                    <div>
                                        <p>Помогут достичь вашей цели:</p>
                                        <ul>
                                            <li>усилить резюме и LinkedIn-профиль</li>
                                            <li>потренировать собеседование</li>
                                            <li>поставить карьерную цель</li>
                                            <li>подготовиться к переговорам по офферу</li>
                                            <li>определить направление для развития</li>
                                            <li>понять свои ценности, мотиваторы и желания</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="club40-career_consult-wrapper noselect">
                            <div class="club40-career_consult-item first">
                                <div>
                                    <p>Помогут достичь вашей цели:</p>
                                    <ul>
                                        <li>усилить резюме и LinkedIn-профиль</li>
                                        <li>потренировать собеседование</li>
                                        <li>поставить карьерную цель</li>
                                        <li>подготовиться к переговорам по офферу</li>
                                        <li>определить направление для развития</li>
                                        <li>понять свои ценности, мотиваторы и желания</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="club40-career_consult-item">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751890362314-vHWA8-Fram.png" class="hidden-tablet-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751901045754-jjAA1-Spea.png" class="hidden-desc" alt="img">
                                <p class="club40-career_consult-name">Николай Пулин</p>
                                <p class="club40-career_consult-position">Эксперт по коммуникации</p>
                                <ul>
                                    <li>6+ лет в HR, 2+ года в карьерном консyльтировании</li>
                                    <li>200+ консyльтаций для специалистов РФ и Европы</li>
                                    <li>Клиенты из IT, digital, ЕdTеch, промышленности, нефтегаза и дрyгих отраслей</li>
                                </ul>
                            </div>
                            <div class="club40-career_consult-item">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751890362872-KaLZL-Fram.png" class="hidden-tablet-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751901046987-T58ic-Spea.png" class="hidden-desc" alt="img">
                                <p class="club40-career_consult-name">Софи Бессон</p>
                                <p class="club40-career_consult-position">Карьерный эксперт, Израиль</p>
                                <ul>
                                    <li>6+ в HR и карьерном консультировании</li>
                                    <li>Помогла 700+ клиентам составить резюме и найти работу в Европе, США и Канаде</li>
                                    <li>Работала с сотрудниками Disney, Intel, Microsoft</li>
                                </ul>
                            </div>
                            <div class="club40-career_consult-item">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751890363176-JQJVi-Fram.png" class="hidden-tablet-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751901049066-Aw2AA-Spea.png" class="hidden-desc" alt="img">
                                <p class="club40-career_consult-name">Олеся Спиридонова</p>
                                <p class="club40-career_consult-position">Коуч практик ФПКиН, психолог-консультант, Россия</p>
                                <ul>
                                    <li>16+ лет в коучинге и инженерной отрасли</li>
                                    <li>Помогла 100+ клиентам найти свой путь в жизни и карьере</li>
                                    <li>Работала с сотрудниками компаний различных отраслей, включая IT, финансы, маркетинг, EdTech и др.</li>
                                </ul>
                            </div>
                            <div class="club40-career_consult-item">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751890363522-x7nHG-Fram.png" class="hidden-tablet-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751901050183-4KIyX-Spea.png" class="hidden-desc" alt="img">
                                <p class="club40-career_consult-name">Майя Бурякина</p>
                                <p class="club40-career_consult-position">Коуч ACC ICF, США/Россия</p>
                                <ul>
                                    <li>10+ лет в подборе, адаптации и развитии персонала</li>
                                    <li>Провела 150+ консультаций на тему поиска работы и построения карьеры</li>
                                    <li>Ex-руководитель HR-направления в международной FMCG-компании с 2 500+ сотрудников</li>
                                </ul>
                            </div>
                            <div class="club40-career_consult-item">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751890365260-WuJ7l-Fram.png" class="hidden-tablet-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751901053298-2JI8T-Spea.png" class="hidden-desc" alt="img">
                                <p class="club40-career_consult-name">Мария Пудалова</p>
                                <p class="club40-career_consult-position">Карьерный эксперт, Германия</p>
                                <ul>
                                    <li>7+ лет в PR и стратегии выстраивания бренда</li>
                                    <li>Помогла 400+ клиентам улучшить CV и найти работу в Европе и США</li>
                                    <li>Работала с сотрудниками Deloitte, BBDO, Microsoft</li>
                                </ul>
                            </div>
                            <div class="club40-career_consult-item">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751890367197-UKezd-Fram.png" class="hidden-tablet-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751901055636-mXz8T-Spea.png" class="hidden-desc" alt="img">
                                <p class="club40-career_consult-name">Виктория Албаутова</p>
                                <p class="club40-career_consult-position">Коуч ICU, Турция</p>
                                <ul>
                                    <li>8+ лет в коучинге и маркетинге</li>
                                    <li>Помогла 150+ клиентам построить выигрышные стратегии и бренды</li>
                                    <li>Работала с компаниями Beiesdorf, Philips, Johnson&Johnson, Novartis</li>
                                </ul>
                            </div>
                            <div class="club40-career_consult-item">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751890368483-JdWle-Fram.png" class="hidden-tablet-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751901057771-FOS2q-Spea.png" class="hidden-desc" alt="img">
                                <p class="club40-career_consult-name">Елена Добринская</p>
                                <p class="club40-career_consult-position">PCC ICF, ОАЭ</p>
                                <ul>
                                    <li>10+ лет в коучинге и финансах</li>
                                    <li>Помогла 1700+ клиентам обрести уверенность и подготовиться к собеседованиям</li>
                                    <li>Работала с сотрудниками Sony, Ernst&Young, Deloitte</li>
                                </ul>
                            </div>
                            <div class="club40-career_consult-item">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751890369217-Vkuxj-Fram.png" class="hidden-tablet-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751901059541-a1sXM-Spea.png" class="hidden-desc" alt="img">
                                <p class="club40-career_consult-name">Елена Эльзенбах</p>
                                <p class="club40-career_consult-position">Коуч ICF, Россия</p>
                                <ul>
                                    <li>11+ лет опыта в коучинге, НКО и EdTech</li>
                                    <li>Помогла 1300+ клиентам из РФ, Европы и СНГ получить оффер через укрепление самооценки</li>
                                    <li>Работала с сотрудниками Lamoda, Яндекс, Mail, InDriver</li>
                                </ul>
                            </div>
                            <div class="club40-career_consult-item">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751890371911-1rEWT-Fram.png" class="hidden-tablet-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751901060757-TJe4t-Spea.png" class="hidden-desc" alt="img">
                                <p class="club40-career_consult-name">Светлана Шуйская</p>
                                <p class="club40-career_consult-position">Коуч ICF, Россия</p>
                                <ul>
                                    <li>18+ лет в коучинге и закупках</li>
                                    <li>Помогла 300+ клиентам вырасти в доходе, составить стратегию, начать своё дело</li>
                                    <li>Работала с сотрудниками Metro Cash&Carry, Yandex, Avito</li>
                                </ul>
                            </div>
                            <div class="club40-career_consult-item">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751890374277-IH6fF-Fram.png" class="hidden-tablet-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751901061584-BYwbo-Spea.png" class="hidden-desc" alt="img">
                                <p class="club40-career_consult-name">Марина Веденичева</p>
                                <p class="club40-career_consult-position">Коуч PCC ICF, Великобритания</p>
                                <ul>
                                    <li>18+ лет в HR и карьерном коучинге</li>
                                    <li>Помогла 2000+ клиентам усилить лидерские качества и получить повышение</li>
                                    <li>Работала с сотрудниками Mars, Shell, Ernst & Young</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <a href="#buy" class="btn-color-main-dark-orange">Выбрать тариф</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-club40-process', {
        label: 'Club 4 process (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club40-process main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Как проходит обучение в Сareerum:</h2>
                    <div class="club40-process-wrapper careerum-flex-sbst">
                        <div class="club40-process-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751893958561-qlgkm-Edit.svg" alt="img">
                            <p>Ваш индивидуальный трек</p>
                            <ul>
                                <li>На старте определяем вашу карьерную стадию</li>
                                <li>Формируем вашу индивидуальную программу развития</li>
                            </ul>
                        </div>
                        <div class="club40-process-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751893958670-VkyqS-Prof.svg" alt="img">
                            <p>Тематическая программа месяца</p>
                            <ul>
                                <li>Каждый месяц в Careerum мы посвящаем новой карьерной теме, по которой проводим практикумы и эфиры</li>
                            </ul>
                        </div>
                        <div class="club40-process-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751893958276-9BuoE-Docu.svg" alt="img">
                            <p>Карьерные консультации </p>
                            <ul>
                                <li>Для более глубокой проработки вашего запроса вы можете обратиться к нашим карьерным коучам и экспертам</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-club40-coming_soon', {
        label: 'Club 4 coming_soon (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club40-coming_soon main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Ближайшая программа</h2>
                    <div class="club40-coming_soon-wrapper careerum-flex-sbst">
                        <div class="club40-coming_soon-item">
                            <p class="club40-coming_soon-item-label">Август</p>
                            <p class="club40-coming_soon-item-header">Как работать не работая</p>
                            <p class="club40-coming_soon-item-speaker">
                                <span>Спикер:</span> Ольга Лермонтова
                            </p>
                            <p class="club40-coming_soon-item-text">Что будет:</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751884348694-1DDGj-Soft.svg"
                                        class="hidden-tablet-mobile" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751884352612-hET3j-Soft.svg"
                                        class="hidden-desc" alt="img">
                                    <p>Живой эфир 2 часа</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751884348694-1DDGj-Soft.svg"
                                        class="hidden-tablet-mobile" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751884352612-hET3j-Soft.svg"
                                        class="hidden-desc" alt="img">
                                    <p>Лекция + промты + ответы на вопросы</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751884348694-1DDGj-Soft.svg"
                                        class="hidden-tablet-mobile" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751884352612-hET3j-Soft.svg"
                                        class="hidden-desc" alt="img">
                                    <p>Доп живые эфиры: Внедрение ИИ в работе, Поиск работы, Разборы резюме (ру, ин)</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-coming_soon-item">
                            <p class="club40-coming_soon-item-label">Сентябрь</p>
                            <p class="club40-coming_soon-item-header">Как правильно увольняться</p>
                            <p class="club40-coming_soon-item-speaker"><span>Спикеры:</span> Ольга Лермонтова, Михаил Ромашов</p>
                            <p class="club40-coming_soon-item-text">Что будет:</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751884348694-1DDGj-Soft.svg"
                                        class="hidden-tablet-mobile" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751884352612-hET3j-Soft.svg"
                                        class="hidden-desc" alt="img">
                                    <p>Живой эфир 2 часа</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751884348694-1DDGj-Soft.svg"
                                        class="hidden-tablet-mobile" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751884352612-hET3j-Soft.svg"
                                        class="hidden-desc" alt="img">
                                    <p>Лекция + ответы на вопросы</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751884348694-1DDGj-Soft.svg"
                                        class="hidden-tablet-mobile" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751884352612-hET3j-Soft.svg"
                                        class="hidden-desc" alt="img">
                                    <p>Доп живые эфиры: Репетируем увольнение, Формулируем достижения для резюме, Бизнес игра</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-club40-form3', {
        label: 'Club 4 form3 (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club40-form3 main-wrapper" data-offer-rub="340" data-offer-eur="341" data-link-rub="1 900 ₽"
                data-link-eur="79 € <s>99 €</s>">
                <div class="careerum-container-responsive">
                    <div class="club40-form-switcher careerum-flex-fec position-relative z-20">
                        <div class="club40-form-curr careerum-flex-fsst">
                            <ul class="careerum-flex-fsfs rub">
                                <li data-currency="eur">EUR</li>
                                <li data-currency="rub" class="active">RUB</li>
                            </ul>
                            <div class="club40-form-notif careerum-flex-cc">
                                <div class="club40-form-notif-icon"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                        alt=""> </div>
                                <div class="club40-form-notif-content">
                                    <p>Оплата в российских рублях возможна только картой
                                        российского банка. В&nbsp;евро — картой
                                        зарубежного банка</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="club40-form-wrapper careerum-flex-sbfs position-relative z-10">
                        <div class="club40-form-left position-relative z-20">
                            <div class="club40-form-labels careerum-flex-fsfs">
                                <p>Курс</p>
                            </div>
                            <h2>Продающее резюме</h2>
                            <p class="club40-form-subheader">Создайте за неделю резюме, которое заметят рекрутеры</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751896716275-aJtzk-Grou.png" class="hidden-tablet-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1751902378216-9YPEX-Grou.png" class="hidden-desc-mobile" alt="img">
                        </div>
                        <div class="club40-form-right position-relative z-20">
                            <div class="careerum-registration-form-club40">
                                <form class="deva-form" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                    <div class="careerum-club40-form-name"> <input type="text" name="name" value="" required
                                            placeholder="Имя">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                    </div>
                                    <div class="careerum-club40-form-email"> <input type="text" name="email" value="" required
                                            placeholder="Почта">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                    </div>
                                    <div class="careerum-club40-form-phone"> <input type="tel" value="" name="tel" required
                                            class="itl-input">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                    </div>
                                    <div class="careerum-club40-form-agree"> <label> <input type="checkbox" name="agree">
                                            <div> <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                    fill="none">
                                                    <path
                                                        d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                        stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                </svg> </div>
                                        </label>
                                        <p>Я принимаю условия <a href="/ru-intl/legal/offer">Оферты</a> и даю согласие
                                            на обработку персональных данных в соответствии с <a
                                                href="/ru-ru/legal/privacy">Политикой конфиденциальности</a>. </p>
                                    </div>
                                    <div class="club40-form-switcher careerum-flex-fsc position-relative z-20">
                                        <div class="club40-form-curr careerum-flex-fsst">
                                            <ul class="careerum-flex-fsfs rub">
                                                <li data-currency="eur">EUR</li>
                                                <li data-currency="rub" class="active">RUB</li>
                                            </ul>
                                            <div class="club40-form-notif careerum-flex-cc">
                                                <div class="club40-form-notif-icon"> <img
                                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                                        alt=""> </div>
                                                <div class="club40-form-notif-content">
                                                    <p>Оплата в российских рублях возможна только картой
                                                        российского банка. В&nbsp;евро — картой
                                                        зарубежного банка</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <a href="#" class="submit-btn btn-color-main-bright-orange careerum-flex-cc" disabled>
                                        Оплатить</a>
                                    <input type="hidden" hidden name="offerID" value="" autocomplete="off">
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-awake-main', {
        label: 'Awake main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-awake-main main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <div class="awake-main-bg position-relative z-10">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743043990-RB5ro-Star.svg"
                    class="hidden-tablet-mobile position-absolute" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743045862-QU63s-Star.svg"
                    class="hidden-desc-mobile position-absolute" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752910668234-HrPvy-Star.svg"
                    class="hidden-desc-tablet position-absolute" alt="img">
            </div>
            <h1 class="position-relative z-20">Что<br> нового<br> в <span class="position-relative">Careerum</span></h1>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743081212-CoWIE-Grou.svg"
                class="hidden-tablet-mobile position-absolute z-20" alt="img">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743129167-dRI9A-Grou.svg"
                class="hidden-desc-mobile position-absolute z-20" alt="img">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743131067-s0jdL-Grou.svg"
                class="hidden-desc-tablet position-absolute z-20" alt="img">
            <div class="awake-main-wrapper careerum-flex-fsfs position-relative z-20">
                <div class="awake-main-left">
                    <p class="awake-main-header">Пока вас не было с нами, Careerum стал:</p>
                    <p class="awake-main-text hidden-mobile"><span>Пора вернуться</span> и начать новый этап вашего профессионального
                        роста!</p>
                </div>
                <div class="position-relative awake-main-right">
                    <div class="position-absolute awake-main-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743559882-DIxwA-Icon.svg"
                            class="hidden-tablet-mobile position-relative" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752825828375-rE1X4-Icon.svg"
                            class="hidden-desc-mobile position-relative" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752910204128-ETh3c-Icon.svg"
                            class="hidden-desc-tablet position-relative" alt="img">
                        <div class="careerum-flex-cc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743559352-vNxBO-Ligh.svg"
                                class="hidden-tablet-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752825828495-QcYmg-Ligh.svg" class="hidden-desc"
                                alt="img">
                            <p>Полезнее</p>
                        </div>
                    </div>
                    <div class="position-absolute awake-main-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743559629-98nlQ-Icon.svg"
                            class="hidden-tablet-mobile position-relative" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752825828148-etPg7-Icon.svg"
                            class="hidden-desc-mobile position-relative" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752910203884-jK1VL-Icon.svg"
                            class="hidden-desc-tablet position-relative" alt="img">
                        <div class="careerum-flex-cc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743628715-Raa8y-Icon.svg"
                                class="hidden-tablet-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752825828037-9vKUa-Icon.svg" class="hidden-desc"
                                alt="img">
                            <p>Cильнее</p>
                        </div>
                    </div>
                    <div class="position-absolute awake-main-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743559751-OlcD5-Icon.svg"
                            class="hidden-tablet-mobile position-relative" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752825828265-t8U8z-Icon.svg"
                            class="hidden-desc-mobile position-relative" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752910204013-DzgkZ-Icon.svg"
                            class="hidden-desc-tablet position-relative" alt="img">
                        <div class="careerum-flex-cc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743627999-9LvAe-Magi.svg"
                                class="hidden-tablet-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752825828859-2etH8-Magi.svg" class="hidden-desc"
                                alt="img">
                            <p>Технологичнее </p>
                        </div>
                    </div>
                </div>
                <p class="awake-main-text hidden-desc-tablet"><span>Пора вернуться</span> и начать новый этап вашего профессионального
                    роста!</p>
            </div>
            <a href="#buy" class="btn-color-main-bright-orange position-relative z-20">Вернуться в Careerum</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-awake-schedule', {
        label: 'Awake schedule (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-awake-schedule main-wrapper">
        <div class="careerum-container-responsive">
            <h2>
                Расписание клуба на 3 месяца
            </h2>
            <div class="awake-schedule-nav">
                <ul class="careerum-flex-fsfs noselect">
                    <li data-number="1" class="active">Август</li>
                    <li data-number="2">Сентябрь</li>
                    <li data-number="3">Октябрь</li>
                    <li data-number="4">Ноябрь</li>
                </ul>
            </div>
            <div class="awake-schedule-wrapper" data-number="1">
                <div class="awake-schedule-slider">
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>5 августа 19:00 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">«СамоОценка» —завершающий эфир интенсива</p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>Почему талантливые женщины обесценивают сами себя</li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикеры:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743793428-R4J4f-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005080-6BLKw-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Ольга Лермонтова</p>
                                    <p class="awake-schedule-item-speakers-position">Основательница Careerum</p>
                                </div>
                            </div>
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743791962-REiQe-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005407-tQ1J0-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Майя Бурякина</p>
                                    <p class="awake-schedule-item-speakers-position">Коуч ACC ICF, США/Россия</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>6 августа 19:00 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">«СЕО своей карьеры» </p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>Портфельная карьера как инструмент</li>
                            <li>Ошибки в создании портфельной карьеры</li>
                            <li>Форматы монетизации</li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикер:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743793428-R4J4f-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005080-6BLKw-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Ольга Лермонтова</p>
                                    <p class="awake-schedule-item-speakers-position">Основательница Careerum</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>7 августа 19:00 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">«Real mе» — завершающий эфир интенсива</p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>Составите стратегическую карту дальнейших действий по вашим карьерным гипотезам.</li>
                            <li>По итогу встречу у вас будет: сформулированная цель, создан ресурсный план,
                                запланированы дальнейшие действия </li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикер:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743792348-IOXla-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005681-9GLWf-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Софи Бессон</p>
                                    <p class="awake-schedule-item-speakers-position">Карьерный эксперт</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>12 августа 19:00 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">Как продвигать личный бренд профессионалам</p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>Зачем нужен личный бренд профессионалам в 2025 году?</li>
                            <li>Где может быть представлен личный бренд профессионала</li>
                            <li>Как «о себе» писать на разных платформах</li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикеры:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743792516-uO5k9-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744006008-TKe0o-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Мария Пудалова</p>
                                    <p class="awake-schedule-item-speakers-position">Карьерный эксперт</p>
                                </div>
                            </div>
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743792348-IOXla-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005681-9GLWf-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Софи Бессон</p>
                                    <p class="awake-schedule-item-speakers-position">Карьерный эксперт</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>17 августа 12:00 - 13:30 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">Еnglish Spеaking Club</p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>На встрече вы прокачаете свой speaking и расширите нетворк. Встреча подходит для уровня
                                B1-B2.</li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикер:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743792734-G1EgK-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744006369-cjdCF-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Ольга Колобкова</p>
                                    <p class="awake-schedule-item-speakers-position">Руководитель Kolobkova School и
                                        амбассадор Careerum</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>19 августа 19:00 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">Q&A сессия с карьерным коучем и экспертом</p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>QA-сессия — это онлайн-эфир, на котором карьерный эксперт в паре с коучем будут отвечать
                                на ваши вопросы в прямом эфире</li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикеры:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743792348-IOXla-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005681-9GLWf-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Софи Бессон</p>
                                    <p class="awake-schedule-item-speakers-position">Карьерный эксперт</p>
                                </div>
                            </div>
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743792905-P05wT-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744006650-225R6-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Олеся Спиридонова</p>
                                    <p class="awake-schedule-item-speakers-position">Коуч практик ФПКиН,
                                        психолог-консультант</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>20 августа 19:00 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">Разбор кейсов и создание следующего карьерного шага</p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>Эфир для участников курса "СЕО своей карьеры", прошедших 2 предыдущих модуля. На эфире
                                можно будет разобрать свой кейс и составить план дальнейшего карьерного развития</li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикер:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743793428-R4J4f-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005080-6BLKw-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Ольга Лермонтова</p>
                                    <p class="awake-schedule-item-speakers-position">Основательница Careerum</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>28 августа 19:00 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">ИИ в помощь, а не в конкуренты</p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>Что делать, если вы боитесь потерять работу из-за ИИ</li>
                            <li>Как интегрировать ИИ в свою карьеру и сделать вторым мозгом</li>
                            <li>Куда и как добавить свои навыки по работе с ИИ в резюме</li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикер:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743792348-IOXla-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005681-9GLWf-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Софи Бессон</p>
                                    <p class="awake-schedule-item-speakers-position">Карьерный эксперт</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>31 августа 12:00 - 13:30 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">Нетворкинговая встреча</p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>Эта встреча — пространство для обретения поддержки и активации вашего потенциала. Вы
                                сможете расширить свою сеть контактов.</li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикеры:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743793091-yxprW-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744006900-ps5q1-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Елена Шеховцова</p>
                                    <p class="awake-schedule-item-speakers-position">Амбассадор Careerum</p>
                                </div>
                            </div>
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743793247-OiJE7-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744007108-Uwk7W-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Кирилл Азаренко</p>
                                    <p class="awake-schedule-item-speakers-position">Амбассадор Careerum</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="awake-schedule-slider-nav careerum-flex-fec">
                    <div class="awake-schedule-nav-prev careerum-flex-cc ">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white"
                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="awake-schedule-nav-next careerum-flex-cc">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white"
                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>
            </div>
            <div class="awake-schedule-wrapper" data-number="2">
                <div class="awake-schedule-slider">
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>5 сентября 19:00 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">«СамоОценка» —завершающий эфир интенсива</p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>Почему талантливые женщины обесценивают сами себя</li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикеры:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743793428-R4J4f-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005080-6BLKw-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Ольга Лермонтова</p>
                                    <p class="awake-schedule-item-speakers-position">Основательница Careerum</p>
                                </div>
                            </div>
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743791962-REiQe-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005407-tQ1J0-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Майя Бурякина</p>
                                    <p class="awake-schedule-item-speakers-position">Коуч ACC ICF, США/Россия</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>6 сентября 19:00 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">«СЕО своей карьеры» </p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>Портфельная карьера как инструмент</li>
                            <li>Ошибки в создании портфельной карьеры</li>
                            <li>Форматы монетизации</li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикер:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743793428-R4J4f-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005080-6BLKw-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Ольга Лермонтова</p>
                                    <p class="awake-schedule-item-speakers-position">Основательница Careerum</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>7 сентября 19:00 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">«Real mе» — завершающий эфир интенсива</p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>Составите стратегическую карту дальнейших действий по вашим карьерным гипотезам.</li>
                            <li>По итогу встречу у вас будет: сформулированная цель, создан ресурсный план,
                                запланированы дальнейшие действия </li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикер:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743792348-IOXla-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005681-9GLWf-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Софи Бессон</p>
                                    <p class="awake-schedule-item-speakers-position">Карьерный эксперт</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>12 сентября 19:00 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">Как продвигать личный бренд профессионалам</p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>Зачем нужен личный бренд профессионалам в 2025 году?</li>
                            <li>Где может быть представлен личный бренд профессионала</li>
                            <li>Как «о себе» писать на разных платформах</li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикеры:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743792516-uO5k9-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744006008-TKe0o-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Мария Пудалова</p>
                                    <p class="awake-schedule-item-speakers-position">Карьерный эксперт</p>
                                </div>
                            </div>
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743792348-IOXla-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005681-9GLWf-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Софи Бессон</p>
                                    <p class="awake-schedule-item-speakers-position">Карьерный эксперт</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>17 сентября 12:00 - 13:30 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">Еnglish Spеaking Club</p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>На встрече вы прокачаете свой speaking и расширите нетворк. Встреча подходит для уровня
                                B1-B2.</li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикер:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743792734-G1EgK-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744006369-cjdCF-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Ольга Колобкова</p>
                                    <p class="awake-schedule-item-speakers-position">Руководитель Kolobkova School и
                                        амбассадор Careerum</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>19 сентября 19:00 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">Q&A сессия с карьерным коучем и экспертом</p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>QA-сессия — это онлайн-эфир, на котором карьерный эксперт в паре с коучем будут отвечать
                                на ваши вопросы в прямом эфире</li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикеры:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743792348-IOXla-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005681-9GLWf-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Софи Бессон</p>
                                    <p class="awake-schedule-item-speakers-position">Карьерный эксперт</p>
                                </div>
                            </div>
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743792905-P05wT-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744006650-225R6-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Олеся Спиридонова</p>
                                    <p class="awake-schedule-item-speakers-position">Коуч практик ФПКиН,
                                        психолог-консультант</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>20 сентября 19:00 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">Разбор кейсов и создание следующего карьерного шага</p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>Эфир для участников курса "СЕО своей карьеры", прошедших 2 предыдущих модуля. На эфире
                                можно будет разобрать свой кейс и составить план дальнейшего карьерного развития</li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикер:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743793428-R4J4f-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005080-6BLKw-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Ольга Лермонтова</p>
                                    <p class="awake-schedule-item-speakers-position">Основательница Careerum</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>28 сентября 19:00 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">ИИ в помощь, а не в конкуренты</p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>Что делать, если вы боитесь потерять работу из-за ИИ</li>
                            <li>Как интегрировать ИИ в свою карьеру и сделать вторым мозгом</li>
                            <li>Куда и как добавить свои навыки по работе с ИИ в резюме</li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикер:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743792348-IOXla-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005681-9GLWf-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Софи Бессон</p>
                                    <p class="awake-schedule-item-speakers-position">Карьерный эксперт</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>31 сентября 12:00 - 13:30 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">Нетворкинговая встреча</p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>Эта встреча — пространство для обретения поддержки и активации вашего потенциала. Вы
                                сможете расширить свою сеть контактов.</li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикеры:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743793091-yxprW-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744006900-ps5q1-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Елена Шеховцова</p>
                                    <p class="awake-schedule-item-speakers-position">Амбассадор Careerum</p>
                                </div>
                            </div>
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743793247-OiJE7-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744007108-Uwk7W-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Кирилл Азаренко</p>
                                    <p class="awake-schedule-item-speakers-position">Амбассадор Careerum</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="awake-schedule-slider-nav careerum-flex-fec">
                    <div class="awake-schedule-nav-prev careerum-flex-cc ">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white"
                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="awake-schedule-nav-next careerum-flex-cc">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white"
                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>
            </div>
            <div class="awake-schedule-wrapper" data-number="3">
                <div class="awake-schedule-slider">
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>5 октября 19:00 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">«СамоОценка» —завершающий эфир интенсива</p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>Почему талантливые женщины обесценивают сами себя</li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикеры:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743793428-R4J4f-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005080-6BLKw-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Ольга Лермонтова</p>
                                    <p class="awake-schedule-item-speakers-position">Основательница Careerum</p>
                                </div>
                            </div>
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743791962-REiQe-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005407-tQ1J0-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Майя Бурякина</p>
                                    <p class="awake-schedule-item-speakers-position">Коуч ACC ICF, США/Россия</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>6 октября 19:00 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">«СЕО своей карьеры» </p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>Портфельная карьера как инструмент</li>
                            <li>Ошибки в создании портфельной карьеры</li>
                            <li>Форматы монетизации</li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикер:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743793428-R4J4f-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005080-6BLKw-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Ольга Лермонтова</p>
                                    <p class="awake-schedule-item-speakers-position">Основательница Careerum</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>7 октября 19:00 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">«Real mе» — завершающий эфир интенсива</p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>Составите стратегическую карту дальнейших действий по вашим карьерным гипотезам.</li>
                            <li>По итогу встречу у вас будет: сформулированная цель, создан ресурсный план,
                                запланированы дальнейшие действия </li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикер:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743792348-IOXla-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005681-9GLWf-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Софи Бессон</p>
                                    <p class="awake-schedule-item-speakers-position">Карьерный эксперт</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>12 октября 19:00 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">Как продвигать личный бренд профессионалам</p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>Зачем нужен личный бренд профессионалам в 2025 году?</li>
                            <li>Где может быть представлен личный бренд профессионала</li>
                            <li>Как «о себе» писать на разных платформах</li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикеры:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743792516-uO5k9-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744006008-TKe0o-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Мария Пудалова</p>
                                    <p class="awake-schedule-item-speakers-position">Карьерный эксперт</p>
                                </div>
                            </div>
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743792348-IOXla-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005681-9GLWf-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Софи Бессон</p>
                                    <p class="awake-schedule-item-speakers-position">Карьерный эксперт</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>17 октября 12:00 - 13:30 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">Еnglish Spеaking Club</p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>На встрече вы прокачаете свой speaking и расширите нетворк. Встреча подходит для уровня
                                B1-B2.</li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикер:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743792734-G1EgK-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744006369-cjdCF-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Ольга Колобкова</p>
                                    <p class="awake-schedule-item-speakers-position">Руководитель Kolobkova School и
                                        амбассадор Careerum</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>19 октября 19:00 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">Q&A сессия с карьерным коучем и экспертом</p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>QA-сессия — это онлайн-эфир, на котором карьерный эксперт в паре с коучем будут отвечать
                                на ваши вопросы в прямом эфире</li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикеры:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743792348-IOXla-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005681-9GLWf-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Софи Бессон</p>
                                    <p class="awake-schedule-item-speakers-position">Карьерный эксперт</p>
                                </div>
                            </div>
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743792905-P05wT-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744006650-225R6-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Олеся Спиридонова</p>
                                    <p class="awake-schedule-item-speakers-position">Коуч практик ФПКиН,
                                        психолог-консультант</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>20 октября 19:00 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">Разбор кейсов и создание следующего карьерного шага</p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>Эфир для участников курса "СЕО своей карьеры", прошедших 2 предыдущих модуля. На эфире
                                можно будет разобрать свой кейс и составить план дальнейшего карьерного развития</li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикер:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743793428-R4J4f-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005080-6BLKw-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Ольга Лермонтова</p>
                                    <p class="awake-schedule-item-speakers-position">Основательница Careerum</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>28 октября 19:00 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">ИИ в помощь, а не в конкуренты</p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>Что делать, если вы боитесь потерять работу из-за ИИ</li>
                            <li>Как интегрировать ИИ в свою карьеру и сделать вторым мозгом</li>
                            <li>Куда и как добавить свои навыки по работе с ИИ в резюме</li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикер:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743792348-IOXla-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005681-9GLWf-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Софи Бессон</p>
                                    <p class="awake-schedule-item-speakers-position">Карьерный эксперт</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>31 октября 12:00 - 13:30 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">Нетворкинговая встреча</p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>Эта встреча — пространство для обретения поддержки и активации вашего потенциала. Вы
                                сможете расширить свою сеть контактов.</li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикеры:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743793091-yxprW-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744006900-ps5q1-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Елена Шеховцова</p>
                                    <p class="awake-schedule-item-speakers-position">Амбассадор Careerum</p>
                                </div>
                            </div>
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743793247-OiJE7-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744007108-Uwk7W-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Кирилл Азаренко</p>
                                    <p class="awake-schedule-item-speakers-position">Амбассадор Careerum</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            <div class="awake-schedule-wrapper" data-number="4">
                <div class="awake-schedule-slider">
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>5 октября 19:00 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">«СамоОценка» —завершающий эфир интенсива</p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>Почему талантливые женщины обесценивают сами себя</li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикеры:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743793428-R4J4f-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005080-6BLKw-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Ольга Лермонтова</p>
                                    <p class="awake-schedule-item-speakers-position">Основательница Careerum</p>
                                </div>
                            </div>
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743791962-REiQe-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005407-tQ1J0-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Майя Бурякина</p>
                                    <p class="awake-schedule-item-speakers-position">Коуч ACC ICF, США/Россия</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>6 октября 19:00 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">«СЕО своей карьеры» </p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>Портфельная карьера как инструмент</li>
                            <li>Ошибки в создании портфельной карьеры</li>
                            <li>Форматы монетизации</li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикер:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743793428-R4J4f-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005080-6BLKw-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Ольга Лермонтова</p>
                                    <p class="awake-schedule-item-speakers-position">Основательница Careerum</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>7 октября 19:00 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">«Real mе» — завершающий эфир интенсива</p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>Составите стратегическую карту дальнейших действий по вашим карьерным гипотезам.</li>
                            <li>По итогу встречу у вас будет: сформулированная цель, создан ресурсный план,
                                запланированы дальнейшие действия </li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикер:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743792348-IOXla-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005681-9GLWf-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Софи Бессон</p>
                                    <p class="awake-schedule-item-speakers-position">Карьерный эксперт</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>12 октября 19:00 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">Как продвигать личный бренд профессионалам</p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>Зачем нужен личный бренд профессионалам в 2025 году?</li>
                            <li>Где может быть представлен личный бренд профессионала</li>
                            <li>Как «о себе» писать на разных платформах</li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикеры:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743792516-uO5k9-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744006008-TKe0o-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Мария Пудалова</p>
                                    <p class="awake-schedule-item-speakers-position">Карьерный эксперт</p>
                                </div>
                            </div>
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743792348-IOXla-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005681-9GLWf-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Софи Бессон</p>
                                    <p class="awake-schedule-item-speakers-position">Карьерный эксперт</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>17 октября 12:00 - 13:30 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">Еnglish Spеaking Club</p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>На встрече вы прокачаете свой speaking и расширите нетворк. Встреча подходит для уровня
                                B1-B2.</li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикер:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743792734-G1EgK-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744006369-cjdCF-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Ольга Колобкова</p>
                                    <p class="awake-schedule-item-speakers-position">Руководитель Kolobkova School и
                                        амбассадор Careerum</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>19 октября 19:00 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">Q&A сессия с карьерным коучем и экспертом</p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>QA-сессия — это онлайн-эфир, на котором карьерный эксперт в паре с коучем будут отвечать
                                на ваши вопросы в прямом эфире</li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикеры:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743792348-IOXla-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005681-9GLWf-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Софи Бессон</p>
                                    <p class="awake-schedule-item-speakers-position">Карьерный эксперт</p>
                                </div>
                            </div>
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743792905-P05wT-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744006650-225R6-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Олеся Спиридонова</p>
                                    <p class="awake-schedule-item-speakers-position">Коуч практик ФПКиН,
                                        психолог-консультант</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>20 октября 19:00 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">Разбор кейсов и создание следующего карьерного шага</p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>Эфир для участников курса "СЕО своей карьеры", прошедших 2 предыдущих модуля. На эфире
                                можно будет разобрать свой кейс и составить план дальнейшего карьерного развития</li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикер:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743793428-R4J4f-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005080-6BLKw-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Ольга Лермонтова</p>
                                    <p class="awake-schedule-item-speakers-position">Основательница Careerum</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>28 октября 19:00 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">ИИ в помощь, а не в конкуренты</p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>Что делать, если вы боитесь потерять работу из-за ИИ</li>
                            <li>Как интегрировать ИИ в свою карьеру и сделать вторым мозгом</li>
                            <li>Куда и как добавить свои навыки по работе с ИИ в резюме</li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикер:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743792348-IOXla-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005681-9GLWf-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Софи Бессон</p>
                                    <p class="awake-schedule-item-speakers-position">Карьерный эксперт</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-schedule-item">
                        <div class="awake-schedule-item-labels careerum-flex-fsfs">
                            <p>Эфир</p>
                            <p>31 октября 12:00 - 13:30 мск</p>
                        </div>
                        <p class="awake-schedule-item-header">Нетворкинговая встреча</p>
                        <p class="awake-schedule-item-text">Что узнаете:</p>
                        <ul>
                            <li>Эта встреча — пространство для обретения поддержки и активации вашего потенциала. Вы
                                сможете расширить свою сеть контактов.</li>
                        </ul>
                        <p class="awake-schedule-item-text">Спикеры:</p>
                        <div class="awake-schedule-item-speakers">
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743793091-yxprW-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744006900-ps5q1-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Елена Шеховцова</p>
                                    <p class="awake-schedule-item-speakers-position">Амбассадор Careerum</p>
                                </div>
                            </div>
                            <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743793247-OiJE7-Spea.png"
                                    class="hidden-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744007108-Uwk7W-Spea.png"
                                    class="hidden-desc-tablet" alt="img">
                                <div>
                                    <p class="awake-schedule-item-speakers-name">Кирилл Азаренко</p>
                                    <p class="awake-schedule-item-speakers-position">Амбассадор Careerum</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="awake-schedule-slider-nav careerum-flex-fec">
                    <div class="awake-schedule-nav-prev careerum-flex-cc ">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white"
                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="awake-schedule-nav-next careerum-flex-cc">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white"
                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>
            </div>
            <a href="#buy" class="btn-color-main-bright-orange">Вернуться в Careerum</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-awake-telegram', {
        label: 'Awake telegram (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-awake-telegram main-wrapper">
        <div class="careerum-container-responsive">
            <h2>Careerum.Club — теперь в Telegram!</h2>
            <div class="awake-telegram-wrapper careerum-flex-sbst">
                <div class="awake-telegram-item">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752782103985-ep58B-Cont.png"
                            class="hidden-tablet-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744343169-sABHC-Cont.png"
                            class="hidden-desc-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752911506518-pUuAN-Cont.png"
                            class="hidden-desc-tablet" alt="img">
                    </div>
                    <p class="awake-telegram-item-header">Нетворк-активности каждую неделю</p>
                    <p class="awake-telegram-item-text">Встречи #light_network и другие события для вашего карьерного
                        роста — всё в календаре клуба</p>
                </div>
                <div class="awake-telegram-item">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744220682-7niFf-Cont.png"
                            class="hidden-tablet-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744343654-YLGFK-Cont.png"
                            class="hidden-desc-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744724877-9DsIH-Cont.png"
                            class="hidden-desc-tablet" alt="img">
                    </div>
                    <p class="awake-telegram-item-header">Coffee Buddy для знакомств</p>
                    <p class="awake-telegram-item-text">Coffee Buddy-бот организует встречи «один на один» среди
                        клубовцев, чтобы вы могли неформально познакомиться и обменяться инсайтами</p>
                </div>
                <div class="awake-telegram-item">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744221791-dQxrh-Cont.png"
                            class="hidden-tablet-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744343939-ZeLg6-Cont.png"
                            class="hidden-desc-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744726416-Ce6FB-Cont.png"
                            class="hidden-desc-tablet" alt="img">
                    </div>
                    <p class="awake-telegram-item-header">Учимся вместе</p>
                    <p class="awake-telegram-item-text">Проходите курсы в мини-командах — «тройках». Так обучение
                        становится живым и поддерживающим</p>
                </div>
                <div class="awake-telegram-item">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744222244-PTR1y-Cont.png"
                            class="hidden-tablet-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744344154-kATy3-Cont.png"
                            class="hidden-desc-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744727054-QPMrV-Cont.png"
                            class="hidden-desc-tablet" alt="img">
                    </div>
                    <p class="awake-telegram-item-header">Английский разговорный клуб</p>
                    <p class="awake-telegram-item-text">Тренируйте профессиональный английский бесплатно</p>
                </div>
            </div>
            <a href="#buy" class="btn-color-main-bright-orange">Вернуться в Careerum</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-awake-new_programms', {
        label: 'Awake new_programms (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-awake-new_programms main-wrapper">
        <div class="careerum-container-responsive">
            <h2>Мы обновили программы и запустили новые</h2>
            <div class="careerum-awake-labels">
                <div class="careerum-awake-label-white careerum-flex-fsc position-relative z-20">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744980825-ikXcw-Upda.svg"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744983967-uOfoq-Upda.svg"
                        class="hidden-desc-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744987313-zuntf-Upda.svg"
                        class="hidden-desc-tablet" alt="img">
                    <p>Обновили в марте 2025</p>
                </div>
                <div class="careerum-awake-label-blue careerum-flex-fsc position-relative z-10">
                    <p>Звездный кандидат</p>
                </div>
            </div>
            <p class="awake-new_programms-text">Программа, которая идёт в ногу с рынком и реально помогает получать
                офферы</p>
            <div class="awake-new_programms-wrapper">
                <div class="awake-new_programms-item">
                    <p class="awake-new_programms-item-header">Модуль про LinkedIn</p>
                    <p class="awake-new_programms-item-text">Полностью обновлён: реально работающие стратегии для поиска
                        работы и личного продвижения на этой платформе</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744965472-Y0Cvb-Grou.svg"
                        class="hidden-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752912061048-1H1im-Grou.png" class="hidden-desc-tablet"
                        alt="img">
                </div>
                <div class="awake-new_programms-item">
                    <p class="awake-new_programms-item-header">Great Deal: как получить оффер мечты</p>
                    <p class="awake-new_programms-item-text">Модуль усилен материалами по переговорам и продажи себя —
                        теперь на примерах реальных успешных кейсов наших выпускников</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744964959-uluNR-Grou.svg"
                        class="hidden-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752912061480-9DAQt-Grou.png" class="hidden-desc-tablet"
                        alt="img">
                </div>
                <div class="awake-new_programms-item">
                    <p class="awake-new_programms-item-header">Уникальный новый модуль «Как нанимают в…»:</p>
                    <p class="awake-new_programms-item-text">Эксперты из ведущих компаний рассказывают о том, как
                        проходит отбор</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744964355-ygIMT-Grou.png"
                        class="hidden-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752912061632-JUuV4-Grou.png" class="hidden-desc-tablet"
                        alt="img">
                </div>
                <div class="awake-new_programms-item">
                    <p class="awake-new_programms-item-header">12 новых шаблонов резюме:</p>
                    <p class="awake-new_programms-item-text">Полностью соответствуют тенденциям 2025 года</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744963863-3WAMc-Grou.png"
                        class="hidden-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752912061993-wQCXq-Grou.png" class="hidden-desc-tablet"
                        alt="img">
                </div>
            </div>
            <div class="awake-new_programms-slider-nav careerum-flex-fec">
                <div class="awake-new_programms-nav-prev careerum-flex-cc ">
                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="awake-new_programms-nav-next careerum-flex-cc">
                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
            </div>
            <div class="careerum-awake-reviews_video">
                <h3>Отзывы о курсе</h3>
                <div class="awake-reviews-wrapper careerum-flex-fsst">
                    <div class="awake-reviews-item" data-video-id="1102196636">
                        <div class="awake-reviews-item-wrapper position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752762633965-gNJ95-Revi.png"
                                alt="img" class="awake-reviews-item-img position-relative z-10">
                            <div class="awake-reviews-item-video position-absolute z-20"></div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752763535440-GC2wo-Revi.svg"
                                alt="" class="awake-reviews-item-play position-absolute z-30">
                        </div>
                        <div class="awake-reviews-item-info">
                            <p class="awake-reviews-item-info-name">Екатерина</p>
                        </div>
                    </div>
                    <div class="awake-reviews-item" data-video-id="1102196747">
                        <div class="awake-reviews-item-img position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752762634995-nbdko-Revi.png"
                                alt="img" class="awake-reviews-item-img position-relative z-10">
                            <div class="awake-reviews-item-video position-absolute z-20"></div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752763535440-GC2wo-Revi.svg"
                                alt="" class="awake-reviews-item-play position-absolute z-30">
                        </div>
                        <div class="awake-reviews-item-info">
                            <p class="awake-reviews-item-info-name">Анна</p>
                        </div>
                    </div>
                    <div class="awake-reviews-item" data-video-id="1102196799">
                        <div class="awake-reviews-item-img position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752762634413-FNekJ-Revi.png"
                                alt="img" class="awake-reviews-item-img position-relative z-10">
                            <div class="awake-reviews-item-video position-absolute z-20"></div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752763535440-GC2wo-Revi.svg"
                                alt="" class="awake-reviews-item-play position-absolute z-30">
                        </div>
                        <div class="awake-reviews-item-info">
                            <p class="awake-reviews-item-info-name">Марина</p>
                        </div>
                    </div>
                </div>
                <div class="awake-reviews-slider-nav careerum-flex-fec">
                    <div class="awake-reviews-nav-prev careerum-flex-cc ">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white"
                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="awake-reviews-nav-next careerum-flex-cc">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white"
                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>
            </div>
            <a href="#buy" class="btn-color-main-bright-orange">Вернуться в Careerum</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-awake-lesson', {
        label: 'Awake lesson (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-awake-lesson main-wrapper">
        <div class="careerum-container-responsive">
            <div class="careerum-awake-labels">
                <div class="careerum-awake-label-white careerum-flex-fsc position-relative z-20">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744980825-ikXcw-Upda.svg"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744983967-uOfoq-Upda.svg"
                        class="hidden-desc-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744987313-zuntf-Upda.svg"
                        class="hidden-desc-tablet" alt="img">
                    <p>Обновили в марте 2025</p>
                </div>
                <div class="careerum-awake-label-blue careerum-flex-fsc position-relative z-10 hidden-mobile">
                    <p>Международная карьера и релокация</p>
                </div>
                <div class="careerum-awake-label-blue careerum-flex-fsc position-relative z-10 hidden-desc-tablet large">
                    <p>Международная карьера и релокация</p>
                </div>
            </div>
            <div class="awake-lesson-wrapper careerum-flex-sbfs">
                <div class="awake-lesson-left">
                    <h2>Обновлённый урок</h2>
                    <p>«Культурные отличия: что учесть при поиске работы»</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752745161470-1O0zT-Vect.svg"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752745163208-11LIc-Vect.svg"
                        class="hidden-desc-mobile" alt="img">
                </div>
                <div class="awake-lesson-right position-relative z-20">
                    <div class="position-relative awake-lesson-item-orange">
                        <p>Инсайты о поиске работы за границей </p>
                    </div>
                    <div class="position-relative awake-lesson-item-yellow z-10">
                        <p class="position-relative z-20">Как культурные различия влияют <span>на поиск работы,</span> общение с работодателями и
                            построение карьеры</p>
                    </div>
                    <div class="position-relative awake-lesson-item-blue z-20">
                        <p class="position-relative z-20">Какие нюансы действительно имеют значение, как избегать <span>«подводных камней»</span></p>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752914809473-8Iu1g-Illu.svg"
                        class="hidden-desc-tablet position-absolute z-30" alt="img">
                </div>
            </div>
            <a href="#buy" class="btn-color-main-bright-orange">Вернуться в Careerum</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-awake-programms', {
        label: 'Awake programms (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-awake-programms main-wrapper">
        <div class="careerum-container-responsive">
            <h2>Программы с <span>Ольгой Лермонтовой</span></h2>
            <div class="careerum-awake-labels">
                <div class="careerum-awake-label-white careerum-flex-fsc position-relative z-20">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744980825-ikXcw-Upda.svg"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744983967-uOfoq-Upda.svg"
                        class="hidden-desc-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744987313-zuntf-Upda.svg"
                        class="hidden-desc-tablet" alt="img">
                    <p>Новая программа, март 2025</p>
                </div>
                <div class="careerum-awake-label-blue careerum-flex-fsc position-relative z-10 large">
                    <p>Power Talk — прорыв в карьере через коммуникации</p>
                </div>
            </div>
            <p class="awake-programms-text">Для тех, у кого карьера зависит от умения эффективно общаться, продавать
                идеи и влиять на людей</p>
            <p class="awake-programms-header">3 топ-спикера:</p>
            <div class="awake-programms-wrapper careerum-flex-fsst">
                <div class="awake-programms-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752745270815-2Wmzc-Cont.png"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752745345644-qel8l-Cont.png"
                        class="hidden-desc-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752745470019-KX5Ap-Cont.png"
                        class="hidden-desc-tablet" alt="img">
                    <div>
                        <p class="awake-programms-item-header">Ольга Лермонтова</p>
                        <p class="awake-programms-item-text">Основательница Careerum</p>
                    </div>
                </div>
                <div class="awake-programms-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752745272242-cSu07-Cont.png"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752745346626-RTnHK-Cont.png"
                        class="hidden-desc-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752745470475-Y33hK-Cont.png"
                        class="hidden-desc-tablet" alt="img">
                    <div>
                        <p class="awake-programms-item-header">Михаил Ромашов </p>
                        <p class="awake-programms-item-text">Product Owner SberCIB </p>
                    </div>
                </div>
                <div class="awake-programms-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752745273341-K6dXH-Imag.png"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752745347185-Iclkh-Imag.png"
                        class="hidden-desc-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752745470723-TAIY9-Imag.png"
                        class="hidden-desc-tablet" alt="img">
                    <div>
                        <p class="awake-programms-item-header">Мила Плющ </p>
                        <p class="awake-programms-item-text">CMO International Ads Яндекс</p>
                    </div>
                </div>
            </div>
            <div class="careerum-awake-reviews_video">
                <h3>Отзывы</h3>
                <div class="awake-reviews-wrapper not-slick">
                    <div class="awake-reviews-item" data-video-id="1102197042">
                        <div class="awake-reviews-item-wrapper position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752765960753-9cqlI-Revi.png"
                                alt="img" class="awake-reviews-item-img position-relative z-10">
                            <div class="awake-reviews-item-video position-absolute z-20"></div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752763535440-GC2wo-Revi.svg"
                                alt="" class="awake-reviews-item-play position-absolute z-30">
                        </div>
                        <div class="awake-reviews-item-info">
                            <p class="awake-reviews-item-info-name">Екатерина</p>
                        </div>
                    </div>
                    <div class="awake-reviews-item" data-video-id="1102197007">
                        <div class="awake-reviews-item-wrapper position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752765961532-4ODQ7-Revi.png"
                                alt="img" class="awake-reviews-item-img position-relative z-10">
                            <div class="awake-reviews-item-video position-absolute z-20"></div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752763535440-GC2wo-Revi.svg"
                                alt="" class="awake-reviews-item-play position-absolute z-30">
                        </div>
                        <div class="awake-reviews-item-info">
                            <p class="awake-reviews-item-info-name">Марина</p>
                        </div>
                    </div>
                </div>
                <div class="awake-reviews-slider-nav careerum-flex-fec">
                    <div class="awake-reviews-nav-prev careerum-flex-cc ">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white"
                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="awake-reviews-nav-next careerum-flex-cc">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white"
                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>
            </div>
            <a href="#buy" class="btn-color-main-bright-orange">Вернуться в Careerum</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-awake-master', {
        label: 'Awake master (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-awake-master main-wrapper">
        <div class="careerum-container-responsive">
            <div class="careerum-awake-labels">
                <div class="careerum-awake-label-white careerum-flex-fsc position-relative z-20">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744980825-ikXcw-Upda.svg"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744983967-uOfoq-Upda.svg"
                        class="hidden-desc-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744987313-zuntf-Upda.svg"
                        class="hidden-desc-tablet" alt="img">
                    <p>Новый мастер-класс, март 2025</p>
                </div>
                <div class="careerum-awake-label-blue careerum-flex-fsc position-relative z-10 large">
                    <p>«Карьерная перезагрузка 2026: Тренды, сценарии развития, навыки будущего»</p>
                </div>
            </div>
            <div class="awake-master-wrapper careerum-flex-sbst">
                <div class="awake-master-left position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752745614192-3HshG-Cont.png"
                        class="hidden-tablet-mobile position-relative z-10" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752830533986-YPE6x-Cont.png"
                        class="hidden-desc-mobile position-relative z-10" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752916118535-96ZyW-Cont.png"
                        class="hidden-desc-tablet position-relative z-10" alt="img">
                    <div class="awake-master-header position-absolute z-20 careerum-flex-cc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752745658819-Qf9e6-Fire.svg"
                            class="hidden-tablet-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752830602463-hruQP-Fire.svg" class="hidden-desc-mobile"
                            alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752916210368-L02dR-Fire.svg" class="hidden-desc-tablet"
                            alt="img">
                        <p>Мастер-класс</p>
                    </div>
                    <div class="awake-master-text position-absolute z-30">
                        <p>от Ольги Лермонтовой</p>
                    </div>
                </div>
                <div class="awake-master-right">
                    <ul>
                        <li class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752745613830-oovp7-Cloc.svg"
                                class="hidden-tablet-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752830602095-N7JfC-Cloc.svg"
                                class="hidden-desc-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752916118364-opruO-Cloc.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>Какие профессии и навыки <span>будут востребованы</span> завтра?</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752745613718-Pdvs7-Rock.svg"
                                class="hidden-tablet-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752830602583-odACb-Rock.svg"
                                class="hidden-desc-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752916118783-DapA8-Rock.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>Какие сценарии карьерного роста <span>реально работают</span> в новых условиях?</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752745613461-eih8p-Comp.svg"
                                class="hidden-tablet-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752830602353-Aa496-Comp.svg"
                                class="hidden-desc-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752916118659-8W7io-Comp.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>Как <span>не потерять актуальность</span> и уверенно адаптироваться к переменам?</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="careerum-awake-reviews_text">
                <h3>Отзывы о мастер-классе</h3>
                <div class="awake-reviews-wrapper">
                    <div class="awake-reviews-item">
                        <div class="awake-reviews-item-top careerum-flex-fsc">
                            <p class="awake-reviews-item-top-name">Оксана</p>
                            <p class="awake-reviews-item-top-date">21.06.25 14:26</p>
                        </div>
                        <div class="awake-reviews-item-stars">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752740451363-GmXdM-Rati.svg"
                                alt="">
                        </div>
                        <p class="awake-reviews-item-text">Вебинар глубокий, нравится подача Ольги безоценочная,
                            незапугивающая, предлагает варианты и решения уже в процессе презентации</p>
                    </div>
                    <div class="awake-reviews-item">
                        <div class="awake-reviews-item-top careerum-flex-fsc">
                            <p class="awake-reviews-item-top-name">Анна</p>
                            <p class="awake-reviews-item-top-date">21.06.25 14:46</p>
                        </div>
                        <div class="awake-reviews-item-stars">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752740451363-GmXdM-Rati.svg"
                                alt="">
                        </div>
                        <p class="awake-reviews-item-text">Пожалуй самые сильные и информативные курсы, которые
                            я видела. Спасибо огромное за качество!</p>
                    </div>
                    <div class="awake-reviews-item">
                        <div class="awake-reviews-item-top careerum-flex-fsc">
                            <p class="awake-reviews-item-top-name">Мария Шмакова</p>
                            <p class="awake-reviews-item-top-date">21.06.25 14:53</p>
                        </div>
                        <div class="awake-reviews-item-stars">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752740451363-GmXdM-Rati.svg"
                                alt="">
                        </div>
                        <p class="awake-reviews-item-text">Подтверждаю! Мне 22 и взяла максимум пользы от Ольги, и жалею
                            что не знала на самом старте</p>
                    </div>
                    <div class="awake-reviews-item">
                        <div class="awake-reviews-item-top careerum-flex-fsc">
                            <p class="awake-reviews-item-top-name">Юлия</p>
                            <p class="awake-reviews-item-top-date">21.06.25 14:05</p>
                        </div>
                        <div class="awake-reviews-item-stars">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752740451363-GmXdM-Rati.svg"
                                alt="">
                        </div>
                        <p class="awake-reviews-item-text">Очень нравится системность, структурность, взгляд сверху
                            и вообще заставляет задуматься о вещах, которые в текущей жизни не в фокусе</p>
                    </div>
                    <div class="awake-reviews-item">
                        <div class="awake-reviews-item-top careerum-flex-fsc">
                            <p class="awake-reviews-item-top-name">Екатерина</p>
                            <p class="awake-reviews-item-top-date">21.06.25 14:25</p>
                        </div>
                        <div class="awake-reviews-item-stars">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752740451363-GmXdM-Rati.svg"
                                alt="">
                        </div>
                        <p class="awake-reviews-item-text">Я считаю, что нужно с записью выпустить pdf сборник золотых
                            цитат спикера! «не тётя с горы решает, а вы» – ❤️</p>
                    </div>
                </div>
                <div class="awake-reviews-slider-nav careerum-flex-fec">
                    <div class="awake-reviews-nav-prev careerum-flex-cc ">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white"
                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="awake-reviews-nav-next careerum-flex-cc">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white"
                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>
            </div>
            <a href="#buy" class="btn-color-main-bright-orange">Вернуться в Careerum</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-awake-course', {
        label: 'Awake course (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-awake-course main-wrapper">
        <div class="careerum-container-responsive">
            <div class="careerum-awake-labels">
                <div class="careerum-awake-label-white careerum-flex-fsc position-relative z-20">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744980825-ikXcw-Upda.svg"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744983967-uOfoq-Upda.svg"
                        class="hidden-desc-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744987313-zuntf-Upda.svg"
                        class="hidden-desc-tablet" alt="img">
                    <p>Идет набор на курс</p>
                </div>
                <div class="careerum-awake-label-blue careerum-flex-fsc position-relative z-10">
                    <p>СEO своей карьеры</p>
                </div>
            </div>
            <p class="awake-course-text">Разберётесь, какие форматы современной карьеры <span>реально работают
                    и приносят доход</span></p>
            <div class="awake-course-wrapper careerum-flex-sbst">
                <div class="awake-course-left position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752745760806-IIDKo-Cont.png"
                        class="hidden-tablet-mobile position-relative z-10" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752831263279-NASfN-Cont.png"
                        class="hidden-desc-mobile position-relative z-10" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752916910356-nCtRH-Imag.png"
                        class="hidden-desc-tablet position-relative z-10" alt="img">
                    <div class="awake-course-header position-absolute z-20 careerum-flex-cc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752745658819-Qf9e6-Fire.svg"
                            class="hidden-tablet-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752830602463-hruQP-Fire.svg" class="hidden-desc-mobile"
                            alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752916210368-L02dR-Fire.svg" class="hidden-desc-tablet"
                            alt="img">
                        <p>Живой курс</p>
                    </div>
                    <div class="awake-course-text position-absolute z-30">
                        <p>от Ольги Лермонтовой</p>
                    </div>
                </div>
                <div class="awake-course-right position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752745821336-vU8kh-Grou.svg"
                        class="hidden-tablet-mobile position-absolute z-10" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752831358160-EvKo2-Grou.svg"
                        class="hidden-desc-mobile position-absolute z-10" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752916943642-ng4Bs-Grou.svg"
                        class="hidden-desc-tablet" alt="img">
                    <div class="awake-course-items position-relative z-20">
                        <p class="orange"> Получите впервые чёткую карту возможностей: реальные сценарии и подводные
                            камни каждого пути</p>
                        <p>Малый или средний бизнес</p>
                        <p>Корпорации</p>
                        <p>Гибридные роли</p>
                        <p>Фриланс</p>
                        <p>Предпринимательство</p>
                        <p>Найм</p>
                        <p>Стартапы</p>
                        <p>Side-проекты</p>
                    </div>
                </div>
            </div>
            <a href="#buy" class="btn-color-main-bright-orange">Вернуться в Careerum</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-awake-updates', {
        label: 'Awake updates (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-awake-updates main-wrapper">
        <div class="careerum-container-responsive">
            <div class="careerum-awake-labels">
                <div class="careerum-awake-label-white careerum-flex-fsc position-relative z-20">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744980825-ikXcw-Upda.svg"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744983967-uOfoq-Upda.svg"
                        class="hidden-desc-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744987313-zuntf-Upda.svg"
                        class="hidden-desc-tablet" alt="img">
                    <p>Полностью обновили в январе 2024</p>
                </div>
                <div class="careerum-awake-label-blue careerum-flex-fsc position-relative z-10">
                    <p>Real me 2.0</p>
                </div>
            </div>
            <p class="awake-updates-main-text">Не сжигать мосты, а <span>пересобрать</span> весь ваш опыт в новое и
                классное</p>
            <div class="awake-updates-wrapper careerum-flex-sbfs">
                <div class="awake-updates-left">
                    <h2>Усовершенствовали программу</h2>
                    <p class="awake-updates-text hidden-mobile">Чтобы вам было легче и быстрее находить свои „Хочу, «Могу», «Надо»
                        и переупаковывать карьерную стратегию на основе этих ориентиров</p>
                    <p class="awake-updates-text hidden-desc-tablet">Чтобы вам было легче и быстрее находить свои</p>
                </div>
                <div class="awake-updates-right">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752745872655-idKPx-Grou.svg"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752832251985-gzyUX-Fram.svg" class="hidden-desc-mobile"
                        alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752919818637-MEO7W-Fram.svg" class="hidden-desc-tablet"
                        alt="img">
                        <p class="awake-updates-text hidden-desc-tablet">И переупаковывать карьерную стратегию на основе этих ориентиров</p>
                </div>
            </div>
            <div class="careerum-awake-reviews_text">
                <h3>Отзывы о программе</h3>
                <div class="awake-reviews-wrapper">
                    <div class="awake-reviews-item">
                        <div class="awake-reviews-item-top careerum-flex-fsc">
                            <p class="awake-reviews-item-top-name">Ольга</p>
                            <p class="awake-reviews-item-top-date">13:05</p>
                        </div>
                        <div class="awake-reviews-item-stars">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752740451363-GmXdM-Rati.svg"
                                alt="">
                        </div>
                        <p class="awake-reviews-item-text">Благодаря практике, я почувствовала что не одна в своих
                            сомнениях. И с собой заберу уверенное желание пройти этот курс</p>
                    </div>
                    <div class="awake-reviews-item">
                        <div class="awake-reviews-item-top careerum-flex-fsc">
                            <p class="awake-reviews-item-top-name">Ksu Tuu</p>
                            <p class="awake-reviews-item-top-date">13:53</p>
                        </div>
                        <div class="awake-reviews-item-stars">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752740451363-GmXdM-Rati.svg"
                                alt="">
                        </div>
                        <p class="awake-reviews-item-text">Забираю с собой чувство что талант можно использовать по
                            разному и в разных сферах и его развивать. </p>
                    </div>
                    <div class="awake-reviews-item">
                        <div class="awake-reviews-item-top careerum-flex-fsc">
                            <p class="awake-reviews-item-top-name">Анастасия</p>
                            <p class="awake-reviews-item-top-date">13:56</p>
                        </div>
                        <div class="awake-reviews-item-stars">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752740451363-GmXdM-Rati.svg"
                                alt="">
                        </div>
                        <p class="awake-reviews-item-text">Очень круто было посмотреть на опыт другого человека, а так
                            же через какие-то его таланты записать и выделить для себя то6 что хотелось бы развивать</p>
                    </div>
                    <div class="awake-reviews-item">
                        <div class="awake-reviews-item-top careerum-flex-fsc">
                            <p class="awake-reviews-item-top-name">Джамиля</p>
                            <p class="awake-reviews-item-top-date">13:05</p>
                        </div>
                        <div class="awake-reviews-item-stars">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752740451363-GmXdM-Rati.svg"
                                alt="">
                        </div>
                        <p class="awake-reviews-item-text">Забираю с собой позитивный заряд и уверенность, что я на
                            правильном пути</p>
                    </div>
                </div>
                <div class="awake-reviews-slider-nav careerum-flex-fec">
                    <div class="awake-reviews-nav-prev careerum-flex-cc ">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white"
                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="awake-reviews-nav-next careerum-flex-cc">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white"
                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>
            </div>
            <a href="#buy" class="btn-color-main-bright-orange">Вернуться в Careerum</a>
            <div class="careerum-awake-labels">
                <div class="careerum-awake-label-white careerum-flex-fsc position-relative z-20">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744980825-ikXcw-Upda.svg"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744983967-uOfoq-Upda.svg"
                        class="hidden-desc-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744987313-zuntf-Upda.svg"
                        class="hidden-desc-tablet" alt="img">
                    <p>Обновили в январе 2023</p>
                </div>
                <div class="careerum-awake-label-blue careerum-flex-fsc position-relative z-10">
                    <p>Антикризис</p>
                </div>
            </div>
            <div class="awake-updates-wrapper careerum-flex-sbfs">
                <div class="awake-updates-left">
                    <h2>В новой версии программы вы найдёте фишки, чтобы оставаться на волне
                    </h2>
                    <p class="awake-updates-text">Что поможет успешно адаптироваться даже в условиях турбулентности</p>
                </div>
                <div class="awake-updates-right">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752745927804-anW3o-Fram.png"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752832332175-8XD46-Fram.png" class="hidden-desc-mobile"
                        alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752920512612-abRY3-Fram.png" class="hidden-desc-tablet"
                        alt="img">
                </div>
            </div>
            <a href="#buy" class="btn-color-main-bright-orange">Вернуться в Careerum</a>
            <div class="careerum-awake-labels">
                <div class="careerum-awake-label-white careerum-flex-fsc position-relative z-20">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744980825-ikXcw-Upda.svg"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744983967-uOfoq-Upda.svg"
                        class="hidden-desc-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744987313-zuntf-Upda.svg"
                        class="hidden-desc-tablet" alt="img">
                    <p>Обновили в мае 2025</p>
                </div>
                <div class="careerum-awake-label-blue careerum-flex-fsc position-relative z-10">
                    <p>Самооценка и Деньги</p>
                </div>
            </div>
            <div class="awake-updates-wrapper2 careerum-flex-sbst">
                <div class="awake-updates-item careerum-flex-sbst">
                    <div class="awake-updates-item-left">
                        <p class="awake-updates-header">Добавили модуль с Ольгой </p>
                        <p class="awake-updates-text">О том, как женщинам в мужском профессиональном мире быть
                            услышанной</p>
                    </div>
                    <div class="awake-updates-item-right">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752745969813-8Zu0V-Cont.png"
                            class="hidden-tablet-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752832596846-MXw7U-Cont.png" class="hidden-desc-mobile"
                            alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752923111009-92CVk-Imag.png" class="hidden-desc-tablet position-relative"
                            alt="img">
                    </div>
                </div>
                <div class="awake-updates-item careerum-flex-sbst">
                    <div class="awake-updates-item-left">
                        <p class="awake-updates-header">Фидбек прошлых потоков</p>
                        <p class="awake-updates-text">Учли обратную связь клубовцев, прошедших старый курс. Добавили
                            кейсы-примеры клиентов</p>
                    </div>
                    <div class="awake-updates-item-right">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752745970400-peces-Cont.png"
                            class="hidden-tablet-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752832597487-hj2Jf-Cont.png" class="hidden-desc-mobile"
                            alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752925271453-JcVMn-Less.png" class="hidden-desc-tablet position-relative"
                            alt="img">
                    </div>
                </div>
            </div>
            <div class="careerum-awake-reviews_text">
                <h3>Отзывы о программе</h3>
                <div class="awake-reviews-wrapper">
                    <div class="awake-reviews-item">
                        <div class="awake-reviews-item-top careerum-flex-fsc">
                            <p class="awake-reviews-item-top-name">Оксана</p>
                            <p class="awake-reviews-item-top-date">12:59</p>
                        </div>
                        <div class="awake-reviews-item-stars">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752740451363-GmXdM-Rati.svg"
                                alt="">
                        </div>
                        <p class="awake-reviews-item-text">Спасибо, я получила много новых инсайтов о своей мотивации и страхах. И вообще каждый раз на эфирах Ольги получаю ответы на вопросы, наличие которых у себя не подозревала</p>
                    </div>
                    <div class="awake-reviews-item">
                        <div class="awake-reviews-item-top careerum-flex-fsc">
                            <p class="awake-reviews-item-top-name">Александра</p>
                            <p class="awake-reviews-item-top-date">13:10</p>
                        </div>
                        <div class="awake-reviews-item-stars">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752740451363-GmXdM-Rati.svg"
                                alt="">
                        </div>
                        <p class="awake-reviews-item-text">Это очень полезно! Так намного проще разбивать все эти “сложные” ситуации</p>
                    </div>
                    <div class="awake-reviews-item">
                        <div class="awake-reviews-item-top careerum-flex-fsc">
                            <p class="awake-reviews-item-top-name">Елена</p>
                            <p class="awake-reviews-item-top-date">13:20</p>
                        </div>
                        <div class="awake-reviews-item-stars">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752740451363-GmXdM-Rati.svg"
                                alt="">
                        </div>
                        <p class="awake-reviews-item-text">Мне кажется, эту практику нужно повторять периодически с хорошо знакомыми или близкими коллегами. Для того, чтобы искренне поверить и принять свои достижения, сильные стороны</p>
                    </div>
                </div>
                <div class="awake-reviews-slider-nav careerum-flex-fec">
                    <div class="awake-reviews-nav-prev careerum-flex-cc ">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white"
                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="awake-reviews-nav-next careerum-flex-cc">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white"
                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>
            </div>
            <a href="#buy" class="btn-color-main-bright-orange">Вернуться в Careerum</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-awake-lab', {
        label: 'Awake lab (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-awake-lab main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <div class="awake-lab-bg position-relative z-10">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752769114532-djQ9l-Grou.png"
                    class="hidden-tablet-mobile position-absolute z-10" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746049979-nvZvY-Grou.svg"
                    class="hidden-desc-mobile position-absolute z-10" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746072197-YLgtB-Grou.svg"
                    class="hidden-desc-tablet position-absolute z-10" alt="img">
            </div>
            <h2 class="position-relative z-20">Открыли <span>Careerum.Lab</span> — AI-инструменты для вашей карьеры</h2>
            <p class="awake-lab-text position-relative z-20">Получите конкурентное преимущество в поиске работе и развитии карьеры с помощью технологий:</p>
            <div class="awake-lab-wrapper position-relative z-20 careerum-flex-sbst">
                <div class="awake-lab-item careerum-flex-sbfs">
                    <div class="awake-lab-item-left">
                        <p class="awake-lab-item-header">AI-сервис проверки резюме</p>
                        <p class="awake-lab-item-text">За 5 минут узнайте, чего не хватает в вашем резюме для идеального
                            отклика на вакансию</p>
                    </div>
                    <div class="awake-lab-item-right">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746125133-FkUCh-Cont.png"
                            class="hidden-tablet-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752833166166-oGNso-Cont.png" class="hidden-desc-mobile"
                            alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752925702664-I7mFW-Cont.png" class="hidden-desc-tablet"
                            alt="img">
                    </div>
                </div>
                <div class="awake-lab-item careerum-flex-sbfs position-relative">
                    <div class="awake-lab-item-left">
                        <p class="awake-lab-item-header">Career Navigator</p>
                        <p class="awake-lab-item-text">Формирует индивидуальную программу под ваши цели — найдите
                            оптимальные направления развития на основе данных рынка и вашего опыта</p>
                    </div>
                    <div class="awake-lab-item-right">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746124285-4qNYo-Cont.png"
                            class="hidden-tablet-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752833166543-gQ7oD-Cont.png" class="hidden-desc-mobile"
                            alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752925702299-6lGOI-Cont.png" class="hidden-desc-tablet"
                            alt="img">
                    </div>
                    <div class="awake-lab-item-bottom position-absolute hidden-mobile">
                        <p>Используйте эти инструменты <span>бесплатно</span> в рамках подписки</p>
                    </div>
                </div>
            </div>
            <div class="awake-lab-item-bottom position-relative hidden-desc-tablet">
                <p>Используйте эти инструменты <span>бесплатно</span> в рамках подписки</p>
            </div>
            <a href="#buy" class="btn-color-main-bright-orange">Вернуться в Careerum</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-awake-platform', {
        label: 'Awake platform (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-awake-platform main-wrapper">
        <div class="careerum-container-responsive">
            <h2>Образовательная платформа Careerum — теперь своя!</h2>
            <p class="awake-platform-text">Мы переехали с GetCourse на собственную платформу learn.careerum.com — это
                значит, что теперь у вас:</p>
            <div class="awake-platform-wrapper">
                <div class="awake-platform-item">
                    <p class="awake-platform-item-header position-relative z-10">Личный кабинет</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752770291179-g5B66-Cont.png"
                        class="hidden-mobile position-relative z-10" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752926508801-tfLw9-Cont.png"
                        class="hidden-desc-tablet position-relative z-10" alt="img">
                    <p class="awake-platform-item-label position-absolute z-20">Для учёта успехов
                        и управления подпиской</p>
                </div>
                <div class="awake-platform-item">
                    <p class="awake-platform-item-header position-relative z-10">Быстрая навигация</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752770292583-34Grf-Cont.png"
                        class="hidden-mobile position-relative z-10" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752926509451-BdINw-Cont.png"
                        class="hidden-desc-tablet position-relative z-10" alt="img">
                    <p class="awake-platform-item-label position-absolute z-20">Между курсами и уроками</p>
                </div>
                <div class="awake-platform-item">
                    <p class="awake-platform-item-header position-relative z-10">Календарь ивентов</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752770290731-QBCyG-Cont.png"
                        class="hidden-mobile position-relative z-10" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752926512160-mTcyY-Cont.png"
                        class="hidden-desc-tablet position-relative z-10" alt="img">
                    <p class="awake-platform-item-label position-absolute z-20">Расписание активностей и эфиров клуба на
                        3 месяца</p>
                </div>
                <div class="awake-platform-item">
                    <p class="awake-platform-item-header position-relative z-10">Career Navigator</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752770290129-uOVYT-Cont.png"
                        class="hidden-mobile position-relative z-10" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752926510305-1uwEy-Cont.png"
                        class="hidden-desc-tablet position-relative z-10" alt="img">
                    <p class="awake-platform-item-label position-absolute z-20">Индивидуальная программа под ваши цели
                    </p>
                </div>
            </div>
            <div class="awake-platform-slider-nav careerum-flex-fec">
                <div class="awake-platform-nav-prev careerum-flex-cc ">
                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="awake-platform-nav-next careerum-flex-cc">
                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
            </div>
            <a href="#buy" class="btn-color-main-bright-orange">Вернуться в Careerum</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-awake-pay', {
        label: 'Awake pay (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-awake-pay main-wrapper">
        <div class="careerum-container-responsive">
            <h2>Оплата и управление подпиской стали удобнее:</h2>
            <div class="awake-pay-wrapper careerum-flex-sbst">
                <div class="awake-pay-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746395305-NqD84-Icon.svg"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752835422963-nb4Zf-Icon.svg" class="hidden-desc-mobile"
                        alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752927185932-wETNq-Icon.svg" class="hidden-desc-tablet"
                        alt="img">
                    <p>Возможность оформить и продлить подписку с рассрочкой на <span>3, 6 или 12 месяцев</span>
                        в рублях и евро</p>
                </div>
                <div class="awake-pay-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746395193-r9zAt-Icon.svg"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752835423464-bVrPv-Icon.svg" class="hidden-desc-mobile"
                        alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752927186240-qr6Vz-Icon.svg" class="hidden-desc-tablet"
                        alt="img">
                    <p>Увеличенные <span>скидки</span> от 3 месяцев</p>
                </div>
                <div class="awake-pay-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746394899-9F8nI-Icon.svg"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752835423588-vEsmQ-Icon.svg" class="hidden-desc-mobile"
                        alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752927186355-hf8wS-Icon.svg" class="hidden-desc-tablet"
                        alt="img">
                    <p>Покупка <span>дополнительных сессий</span> с экспертами в личном кабинете</p>
                </div>
            </div>
            <a href="#buy" class="btn-color-main-bright-orange">Вернуться в Careerum</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-awake-mobile', {
        label: 'Awake mobile (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-awake-mobile main-wrapper">
        <div class="careerum-container-responsive">
            <div class="awake-mobile-bg position-relative z-10">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752772044019-xPDgN-Fram.svg"
                    class="hidden-tablet-mobile position-absolute" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752835553069-eWjWR-Fram.svg"
                    class="hidden-desc-mobile position-absolute" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752927391120-APTYD-Fram.svg"
                    class="hidden-desc-tablet position-absolute" alt="img">
            </div>
            <div class="awake-mobile-wrapper">
                <h2 class="position-relative z-20">Релиз мобильного приложения</h2>
                <div class="careerum-flex-fsc position-relative z-20">
                    <p>Cовсем скоро доступно в: </p>
                    <div class="careerum-flex-fsc">
                        <div class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746875959-Wy5Sj-AppS.svg"
                                class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752927597715-a8gwT-AppS.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>Apple Store</p>
                        </div>
                        <div class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746875711-jP80Q-Goog.svg"
                                class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752927597219-JGzlD-Goog.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>Google Play</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-awake-couches', {
        label: 'Awake couches (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-awake-couches main-wrapper">
        <div class="careerum-container-responsive">
            <h2>Наша команда карьерных экспертов и коучей <span>пополнилась</span> новыми лицами</h2>
            <div class="awake-couches-top careerum-flex-fsfs">
                <div class="awake-couches-top-left">
                    <div class="awake-couches-top-right-wrapper hidden-desc-tablet">
                        <div>
                            <p class="awake-couches-top-right-header careerum-flex-cc">3 800+</p>
                            <p class="awake-couches-top-right-text">часов проведённых сессий</p>
                        </div>
                        <div>
                            <p class="awake-couches-top-right-header careerum-flex-cc">9,5/10</p>
                            <p class="awake-couches-top-right-text">средняя оценка карьерных<br> экспертов</p>
                        </div>
                    </div>
                    <p class="awake-couches-top-left-header">Помогут достичь вашей цели: </p>
                    <ul>
                        <li class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746922107-o7d5i-Link.svg"
                                class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752928344203-mYT4Q-Link.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>Усилить резюме и LinkedIn-профиль</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746921754-njqoR-Chat.svg"
                                class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752928343697-RahCb-Chat.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>Потренировать собеседование</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746922343-RovnH-Targ.svg"
                                class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752928344431-mJthk-Targ.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>Поставить карьерную цель</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746921867-vO3K3-Chat.svg"
                                class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752928343960-eS8IV-Chat.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>Подготовиться к переговорам по офферу</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746921991-PflyV-Comp.svg"
                                class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752928344081-KycAw-Comp.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>Определить направление для развития</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746922227-JkNVG-Spar.svg"
                                class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752928344322-nFfeU-Spar.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>Понять свои ценности, мотиваторы и желания</p>
                        </li>
                    </ul>
                </div>
                <div class="awake-couches-top-right hidden-mobile">
                    <div class="awake-couches-top-right-wrapper">
                        <div>
                            <p class="awake-couches-top-right-header">3 800+</p>
                            <p class="awake-couches-top-right-text">часов проведённых сессий</p>
                        </div>
                        <div>
                            <p class="awake-couches-top-right-header">9,5/10</p>
                            <p class="awake-couches-top-right-text">средняя оценка карьерных экспертов</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="awake-couches-wrapper">
                <div class="awake-couches-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746617188-gBD3O-Fram.png"
                        class="hidden-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746742157-30J0a-Spea.png"
                        class="hidden-desc-tablet" alt="img">
                    <p class="awake-couches-item-name">Николай Пулин</p>
                    <p class="awake-couches-item-position">Эксперт по коммуникации</p>
                    <ul>
                        <li>6+ лет в HR, 2+ года в карьерном консyльтировании</li>
                        <li>200+ консyльтаций для специалистов РФ и Европы</li>
                        <li>Клиенты из IT, digital, ЕdTеch, промышленности, нефтегаза и дрyгих отраслей</li>
                    </ul>
                </div>
                <div class="awake-couches-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746617685-3DDAU-Fram.png"
                        class="hidden-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746742544-LFRzV-Spea.png"
                        class="hidden-desc-tablet" alt="img">
                    <p class="awake-couches-item-name">Софи Бессон</p>
                    <p class="awake-couches-item-position">Карьерный эксперт, Израиль</p>
                    <ul>
                        <li>6+ в HR и карьерном консультировании</li>
                        <li>Помогла 700+ клиентам составить резюме и найти работу в Европе, СШАи Канаде</li>
                        <li>Работала с сотрудниками Disney, Intel, Microsoft</li>
                    </ul>
                </div>
                <div class="awake-couches-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746618185-KErUh-Fram.png"
                        class="hidden-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746742868-gDdJB-Spea.png"
                        class="hidden-desc-tablet" alt="img">
                    <p class="awake-couches-item-name">Олеся Спиридонова</p>
                    <p class="awake-couches-item-position">Коуч практик ФПКиН, психолог-консультант, Россия</p>
                    <ul>
                        <li>16+ лет в коучинге и инженерной отрасли</li>
                        <li>Помогла 100+ клиентам найти свой путь в жизни и карьере</li>
                        <li>Работала с сотрудниками компаний различных отраслей, включая IT, финансы, маркетинг,
                            EdTech и др.</li>
                    </ul>
                </div>
                <div class="awake-couches-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746618898-9cdVR-Fram.png"
                        class="hidden-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746743241-y0qDT-Spea.png"
                        class="hidden-desc-tablet" alt="img">
                    <p class="awake-couches-item-name">Майя Бурякина</p>
                    <p class="awake-couches-item-position">Коуч ACC ICF, США/Россия</p>
                    <ul>
                        <li>10+ лет в подборе, адаптации и развитии персонала</li>
                        <li>Провела 150+ консультаций на тему поиска работы и построения карьеры</li>
                        <li>Ex-руководитель HR-направления в международной FMCG-компании с 2 500+ сотрудников</li>
                    </ul>
                </div>
                <div class="awake-couches-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746620303-07ol9-Fram.png"
                        class="hidden-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746743649-FteMH-Spea.png"
                        class="hidden-desc-tablet" alt="img">
                    <p class="awake-couches-item-name">Мария Пудалова</p>
                    <p class="awake-couches-item-position">Карьерный эксперт, Германия</p>
                    <ul>
                        <li>7+ лет в PR и стратегии выстраивания бренда</li>
                        <li>Помогла 400+ клиентам улучшить CV и найти работу в Европе и США</li>
                        <li>Работала с сотрудниками Deloitte, BBDO, Microsoft</li>
                    </ul>
                </div>
                <div class="awake-couches-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746621620-UjHbY-Fram.png"
                        class="hidden-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746744022-xsYRn-Spea.png"
                        class="hidden-desc-tablet" alt="img">
                    <p class="awake-couches-item-name">Виктория Албаутова</p>
                    <p class="awake-couches-item-position">Коуч ICU, Турция</p>
                    <ul>
                        <li>8+ лет в коучинге и маркетинге</li>
                        <li>Помогла 150+ клиентам построить выигрышные стратегии и бренды</li>
                        <li>Работала с компаниями Beiesdorf, Philips, Johnson&Johnson, Novartis</li>
                    </ul>
                </div>
                <div class="awake-couches-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746622594-AF5DY-Fram.png"
                        class="hidden-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746744392-5ItSU-Spea.png"
                        class="hidden-desc-tablet" alt="img">
                    <p class="awake-couches-item-name">Елена Добринская</p>
                    <p class="awake-couches-item-position">PCC ICF, ОАЭ</p>
                    <ul>
                        <li>10+ лет в коучинге и финансах</li>
                        <li>Помогла 1700+ клиентам обрести уверенность и подготовиться к собеседованиям</li>
                        <li>Работала с сотрудниками Sony, Ernst&Young, Deloitte</li>
                    </ul>
                </div>
                <div class="awake-couches-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746623197-MhXAb-Fram.png"
                        class="hidden-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746744774-Cn87H-Spea.png"
                        class="hidden-desc-tablet" alt="img">
                    <p class="awake-couches-item-name">Елена Эльзенбах</p>
                    <p class="awake-couches-item-position">Коуч ICF, Россия</p>
                    <ul>
                        <li>11+ лет опыта в коучинге, НКО и EdTech</li>
                        <li>Помогла 1300+ клиентам из РФ, Европы и СНГ получить оффер через укрепление самооценки</li>
                        <li>Работала с сотрудниками Lamoda, Яндекс, Mail, InDriver</li>
                    </ul>
                </div>
                <div class="awake-couches-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746623778-a9zi8-Fram.png"
                        class="hidden-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746745261-j9iy9-Spea.png"
                        class="hidden-desc-tablet" alt="img">
                    <p class="awake-couches-item-name">Светлана Шуйская</p>
                    <p class="awake-couches-item-position">Коуч ICF, Россия</p>
                    <ul>
                        <li>18+ лет в коучинге и закупках</li>
                        <li>Помогла 300+ клиентам вырасти в доходе, составить стратегию, начать своё дело</li>
                        <li>Работала с сотрудниками Metro Cash&Carry, Yandex, Avito</li>
                    </ul>
                </div>
                <div class="awake-couches-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746624422-3lHzi-Fram.png"
                        class="hidden-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746745795-FRwMU-Spea.png"
                        class="hidden-desc-tablet" alt="img">
                    <p class="awake-couches-item-name">Марина Веденичева</p>
                    <p class="awake-couches-item-position">Коуч PCC ICF, Великобритания</p>
                    <ul>
                        <li>18+ лет в HR и карьерном коучинге</li>
                        <li>Помогла 2000+ клиентам усилить лидерские качества и получить повышение</li>
                        <li>Работала с сотрудниками Mars, Shell, Ernst & Young</li>
                    </ul>
                </div>
            </div>
            <div class="awake-couches-slider-nav careerum-flex-fec">
                <div class="awake-couches-nav-prev careerum-flex-cc ">
                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="awake-couches-nav-next careerum-flex-cc">
                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
            </div>
            <a href="#buy" class="btn-color-main-bright-orange">Вернуться в Careerum</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-awake-tariffs', {
        label: 'Awake tariffs (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-awake-tariffs main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="awake-tariffs-top">
                        <h2 class="inline-block">Лист ожидания</h2>
                        <p class="awake-tariffs-text">Сейчас Careerum закрыт. Запишитесь в лист ожидания, и мы сообщим вам о
                            ближайшем окне входа </p>
                    </div>
                    <div class="realme0726-banner position-relative">
                        <p class="realme0726-banner__header position-relative z-10">Цены повышаются</p>
                        <div class="realme0726-banner__label careerum-flex-fsc position-relative z-10">
                            <img src="https://cdn.careerum.com/1783499010476-052TU-Cale.svg" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1783499674272-hmYHm-Cale.svg" class="hidden-desc-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1783499759629-lYdL3-Cale.svg" class="hidden-desc-tablet" alt="img" loading="lazy">
                            <p>Старт 28 июля</p>
                        </div>
                        <img src="https://cdn.careerum.com/1783499078998-WGKyp-Grou.svg"
                            class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1783499674201-UMZ8Z-Grou.svg" class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1783499759698-Q4aqj-Grou.svg" class="hidden-desc-tablet position-absolute z-1" alt="img"
                            loading="lazy">
                    </div>
                    <div class="awake-tariffs-switchers careerum-flex-sbfs">
                        <div class="awake-tariffs-period-wrapper">
                            <div class="awake-tariffs-period careerum-flex-fsst">
                                <ul class="careerum-flex-fsfs">
                                    <li data-period="1">
                                        <p class="hidden-mobile">1 месяц</p>
                                        <p class="hidden-desc-tablet">1 меc</p>
                                    </li>
                                    <li data-period="3" class="active">
                                        <p class="hidden-mobile">3 месяца</p>
                                        <p class="hidden-desc-tablet">3 меc</p>
                                    </li>
                                    <li data-period="6">
                                        <p class="hidden-mobile">6 месяцев</p>
                                        <p class="hidden-desc-tablet">6 мес</p>
                                    </li>
                                    <li data-period="12">
                                        <p class="hidden-mobile">12 месяцев</p>
                                        <p class="hidden-desc-tablet">12 мес</p>
                                    </li>
                                </ul>
                                <div class="awake-tariffs-notif careerum-flex-cc">
                                    <div class="awake-tariffs-notif-icon"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                            alt=""> </div>
                                    <div class="awake-tariffs-notif-content">
                                        <p>1 месяц подписки предоставляет 30 дней доступа к платформе</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="awake-tariffs-curr careerum-flex-fsst">
                            <ul class="careerum-flex-fsfs">
                                <li data-currency="eur">EUR</li>
                                <li data-currency="rub" class="active">RUB</li>
                            </ul>
                            <div class="awake-tariffs-notif careerum-flex-cc">
                                <div class="awake-tariffs-notif-icon"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                        alt=""> </div>
                                <div class="awake-tariffs-notif-content">
                                    <p>Оплата в российских рублях возможна только картой российского банка. В&nbsp;евро — картой
                                        зарубежного банка</p>
                                </div>
                            </div>
                        </div>
                        <div class="awake-tariffs-curr-mobile">
                            <div class="awake-tariffs__swicher-block">
                                <div class="awake-tariffs__swicher-top">
                                    <p class="awake-tariffs__swicher-header">Посмотреть
                                        цены в
                                        <span>RUB</span>
                                    </p><svg xmlns="http://www.w3.org/2000/svg" width="24"
                                        height="24" viewBox="0 0 24 24" fill="none" class="awake-tariffs__swicher-arrow">
                                        <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black">
                                        </path>
                                    </svg>
                                </div>
                                <div class="awake-tariffs__swicher-bottom">
                                    <ul>
                                        <li data-currency="rub">
                                            RUB
                                        </li>
                                        <li data-currency="eur" class="active">
                                            EUR
                                        </li>
                                    </ul>
                                    <p>
                                        Обратите внимание,<br> что оплата в российских
                                        рублях
                                        возможна только<br> с карты
                                        российского банка. Оплата в евро — с карты зарубежного банка
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-tariffs-items-wrapper">
                        <div class="awake-tariffs-items careerum-flex-cst">
                            <div class="awake-tariffs-item careerum-flex-fsfs hidden-9-12" data-price-1m-rub="12 900 ₽"
                                data-oldprice-1m-rub="" data-discount-1m-rub=" %" data-price-3m-rub="8&nbsp;900 ₽"
                                data-fullprice-3m-rub="26&nbsp;700 ₽" data-oldprice-3m-rub="38 700 ₽"
                                data-discount-3m-rub="-31%" data-price-6m-rub="" data-oldprice-6m-rub=""
                                data-discount-6m-rub=" %" data-fullprice-6m-rub="" data-price-12m-rub=""
                                data-fullprice-12m-rub="" data-discount-12m-rub=" %" data-oldprice-12m-rub=""
                                data-price-1m-eur="149 €" data-oldprice-1m-eur="" data-discount-1m-eur=" %"
                                data-price-3m-eur="89 €" data-fullprice-3m-eur="267 €" data-oldprice-3m-eur="447 €"
                                data-discount-3m-eur="–39%" data-price-6m-eur="" data-fullprice-6m-eur=""
                                data-oldprice-6m-eur="" data-discount-6m-eur=" %" data-price-12m-eur=""
                                data-fullprice-12m-eur="" data-oldprice-12m-eur="" data-discount-12m-eur=" %"
                                data-offer-1m-rub="27" data-offer-3m-rub="94" data-offer-6m-rub="" data-offer-12m-rub=""
                                data-offer-1m-eur="48" data-offer-3m-eur="97" data-offer-6m-eur="" data-offer-12m-eur="">
                                <div class="awake-tariffs-item-header yellow">
                                    <div class="awake-tariffs-item-header-label careerum-flex-fsc white">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432322102-BgJzk-Hand.svg"
                                            alt="img">
                                        <p>Базовый</p>
                                    </div>
                                    <p class="awake-tariffs-item-header hidden-mobile">Библиотека<br>курсов</p>
                                    <p class="awake-tariffs-item-header hidden-desc-tablet">Библиотека курсов</p>
                                </div>
                                <div class="awake-tariffs-item-content">
                                    <ul>
                                        <li class="careerum-flex-fsfs">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>35 программ под любую карьерную задачу</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>12 шаблонов резюме RU и EN</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>AI-сервис проверки резюме</p>
                                        </li>
                                        <li class="careerum-flex-fsfs disabled">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321524-Xduv4-XCir.svg"
                                                alt="">
                                            <p>Онлайн-эфиры на актуальные темы</p>
                                        </li>
                                        <li class="careerum-flex-fsfs disabled">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321524-Xduv4-XCir.svg"
                                                alt="">
                                            <p>Доступ в карьерный клуб</p>
                                        </li>
                                        <li class="careerum-flex-fsfs disabled">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321524-Xduv4-XCir.svg"
                                                alt="">
                                            <p>Поддержка  карьерных экспертов в чате клуба</p>
                                        </li>
                                        <li class="careerum-flex-fsfs disabled">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321524-Xduv4-XCir.svg"
                                                alt="">
                                            <p>2 личные консультации с карьерными экспертами в месяц</p>
                                        </li>
                                    </ul>
                                </div>
                                <div class="awake-tariffs-item-footer">
                                    <div class="awake-tariffs-item-discount hidden-m1">
                                        <p class="awake-tariffs-item-discount"></p>
                                        <p class="awake-tariffs-item-oldprice"></p>
                                    </div>
                                    <div class="awake-tariffs-item-price careerum-flex-fsfs">
                                        <p class="awake-tariffs-item-fullprice-amount">12 900 ₽</p>
                                        <p class="awake-tariffs-item-price-separator">/</p>
                                        <div>
                                            <p class="awake-tariffs-item-price-amount"></p>
                                            <p class="awake-tariffs-item-price-text">цена месяца</p>
                                        </div>
                                    </div>
                                    <div class="awake-tariffs-item-rassr">
                                        <p>Доступно в рассрочку</p>
                                    </div>
                                    <div class="awake-tariffs-item-link"> <a href="#tariff-single-waitlist"
                                            class="btn-color-main-bright-orange">Записаться в лист ожидания</a> </div>
                                </div>
                            </div>
                            <div class="awake-tariffs-item careerum-flex-fsfs selected" data-price-1m-rub="14 900 ₽"
                                data-oldprice-1m-rub="" data-discount-1m-rub=" %" data-price-3m-rub="13 300 ₽"
                                data-fullprice-3m-rub="39&nbsp;900 ₽" data-oldprice-3m-rub="44 700 ₽"
                                data-discount-3m-rub="-11%" data-price-6m-rub="11&nbsp;650 ₽"
                                data-fullprice-6m-rub="69&nbsp;900 ₽" data-oldprice-6m-rub="89 400 ₽"
                                data-discount-6m-rub="-22%" data-price-12m-rub="9&nbsp;075 ₽"
                                data-fullprice-12m-rub="108&nbsp;900 ₽" data-oldprice-12m-rub="178 800 ₽"
                                data-discount-12m-rub="-39%" data-price-1m-eur="199 €" data-oldprice-1m-eur=""
                                data-discount-1m-eur=" %" data-price-3m-eur="170 €" data-fullprice-3m-eur="510 €"
                                data-oldprice-3m-eur="597 €" data-discount-3m-eur="-15%" data-price-6m-eur="130 €"
                                data-fullprice-6m-eur="780 €" data-oldprice-6m-eur="1 194 €" data-discount-6m-eur="-35%"
                                data-price-12m-eur="100 €" data-fullprice-12m-eur="1 200 €" data-oldprice-12m-eur="2 388 €"
                                data-discount-12m-eur="-50%" data-offer-1m-rub="28" data-offer-3m-rub="29"
                                data-offer-6m-rub="30" data-offer-12m-rub="31" data-offer-1m-eur="49" data-offer-3m-eur="50"
                                data-offer-6m-eur="51" data-offer-12m-eur="52">
                                <div class="awake-tariffs-item-header blue">
                                    <div class="awake-tariffs-item-header-label careerum-flex-fsc blue">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321987-1A2dc-Fire.svg"
                                            alt="img">
                                        <p>Оптимальный</p>
                                    </div>
                                    <p class="awake-tariffs-item-header">С поддержкой экспертов</p>
                                </div>
                                <div class="awake-tariffs-item-content">
                                    <ul>
                                        <li class="careerum-flex-fsfs">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>35 программ под любую карьерную задачу</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>12 шаблонов резюме RU и EN</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>AI-сервис проверки резюме</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>Онлайн-эфиры на актуальные темы</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>Доступ в карьерный клуб</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>Поддержка  карьерных экспертов в чате клуба</p>
                                        </li>
                                        <li class="careerum-flex-fsfs disabled">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321524-Xduv4-XCir.svg"
                                                alt="">
                                            <p>2 личные консультации с карьерными экспертами в месяц</p>
                                        </li>
                                    </ul>
                                </div>
                                <div class="awake-tariffs-item-footer">
                                    <div class="awake-tariffs-item-discount hidden-m1">
                                        <p class="awake-tariffs-item-discount"></p>
                                        <p class="awake-tariffs-item-oldprice"></p>
                                    </div>
                                    <div class="awake-tariffs-item-price careerum-flex-fsfs">
                                        <p class="awake-tariffs-item-fullprice-amount">12 900 ₽</p>
                                        <p class="awake-tariffs-item-price-separator">/</p>
                                        <div>
                                            <p class="awake-tariffs-item-price-amount"></p>
                                            <p class="awake-tariffs-item-price-text">цена месяца</p>
                                        </div>
                                    </div>
                                    <div class="awake-tariffs-item-rassr">
                                        <p>Доступно в рассрочку</p>
                                    </div>
                                    <div class="awake-tariffs-item-link">
                                        <a href="#tariff-support-waitlist" class="btn-color-main-bright-orange">Записаться в лист
                                            ожидания</a>
                                    </div>
                                </div>
                            </div>
                            <div class="awake-tariffs-item careerum-flex-fsfs" data-price-1m-rub="33&nbsp;900 ₽"
                                data-oldprice-1m-rub="" data-discount-1m-rub=" %" data-price-3m-rub="29&nbsp;967 ₽"
                                data-fullprice-3m-rub="89&nbsp;900 ₽" data-oldprice-3m-rub="101 700 ₽"
                                data-discount-3m-rub="-12%" data-price-6m-rub="26&nbsp;650 ₽"
                                data-fullprice-6m-rub="159&nbsp;900 ₽" data-oldprice-6m-rub="203 400 ₽"
                                data-discount-6m-rub="-21%" data-price-12m-rub="20&nbsp;908 ₽"
                                data-fullprice-12m-rub="250&nbsp;900 ₽" data-oldprice-12m-rub="406 800 ₽"
                                data-discount-12m-rub="-38%" data-price-1m-eur="360 €" data-oldprice-1m-eur=""
                                data-discount-1m-eur=" %" data-price-3m-eur="310 €" data-fullprice-3m-eur="930 €"
                                data-oldprice-3m-eur="1 080 €" data-discount-3m-eur="-14%" data-price-6m-eur="250 €"
                                data-fullprice-6m-eur="1 500 €" data-oldprice-6m-eur="2 160 €" data-discount-6m-eur="-31%"
                                data-price-12m-eur="230 €" data-fullprice-12m-eur="2 760 €" data-oldprice-12m-eur="4 320 €"
                                data-discount-12m-eur="-36%" data-offer-1m-rub="32" data-offer-3m-rub="100"
                                data-offer-6m-rub="101" data-offer-12m-rub="102" data-offer-1m-eur="53" data-offer-3m-eur="103"
                                data-offer-6m-eur="104" data-offer-12m-eur="105">
                                <div class="awake-tariffs-item-header dark">
                                    <div class="awake-tariffs-item-header-label careerum-flex-fsc white">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321867-adLt2-Meda.svg"
                                            alt="img">
                                        <p>Premium</p>
                                    </div>
                                    <p class="awake-tariffs-item-header">Индивидуальное сопровождение</p>
                                </div>
                                <div class="awake-tariffs-item-content">
                                    <ul>
                                        <li class="careerum-flex-fsfs">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>35 программ под любую карьерную задачу</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>12 шаблонов резюме RU и EN</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>AI-сервис проверки резюме</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>Онлайн-эфиры на актуальные темы</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>Доступ в карьерный клуб</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>Поддержка  карьерных экспертов в чате клуба</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>2 личные консультации с карьерными экспертами в месяц<br>
                                                  · персональный разбор резюме<br>
                                                  · персональный разбор Linkedin <br>
                                                  · тренировочные собеседования или любой другой ваш карьерный запрос
                                            </p>
                                        </li>
                                    </ul>
                                </div>
                                <div class="awake-tariffs-item-footer">
                                    <div class="awake-tariffs-item-discount hidden-m1">
                                        <p class="awake-tariffs-item-discount"></p>
                                        <p class="awake-tariffs-item-oldprice"></p>
                                    </div>
                                    <div class="awake-tariffs-item-price careerum-flex-fsfs">
                                        <p class="awake-tariffs-item-fullprice-amount">12 900 ₽</p>
                                        <p class="awake-tariffs-item-price-separator">/</p>
                                        <div>
                                            <p class="awake-tariffs-item-price-amount"></p>
                                            <p class="awake-tariffs-item-price-text">цена месяца</p>
                                        </div>
                                    </div>
                                    <div class="awake-tariffs-item-rassr">
                                        <p>Доступно в рассрочку</p>
                                    </div>
                                    <div class="awake-tariffs-item-link"> <a href="#tariff-individual-waitlist"
                                            class="btn-color-main-bright-orange">Записаться в лист ожидания</a> </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-club50-main', {
        label: 'Club 50 main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club50-main main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <div class="club50-main-bg position-relative z-10">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753813961456-nqmjL-Star.svg"
                    class="hidden-tablet-mobile position-absolute" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743045862-QU63s-Star.svg"
                    class="hidden-desc-mobile position-absolute" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753950333515-ngKmT-Star.svg"
                    class="hidden-desc-tablet position-absolute" alt="img">
            </div>
            <h1 class="position-relative z-20">Careerum</h1>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753803713681-nSBor-Grou.svg"
                class="hidden-tablet-mobile position-absolute z-20" alt="img">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753803748659-a7J8v-Grou.svg"
                class="hidden-desc-mobile position-absolute z-20" alt="img">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753803750716-HjOoL-Grou.svg"
                class="hidden-desc-tablet position-absolute z-20" alt="img">
            <p class="club50-main-text">Решим любую карьерную задачу</p>
            <div class="club50-main-wrapper wrapper-desc careerum-flex-fsc position-relative z-20">
                <div>
                    <p>Сменить сферу</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753814407246-tz1Pb-Fram.svg"
                        alt="img">
                </div>
                <div>
                    <p>Карьерная стратегия</p>
                </div>
                <div>
                    <p>Вырасти в зарплате</p>
                </div>
                <div>
                    <p>Новая должность</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753814406968-n6CL9-Fram.svg"
                        alt="img">
                </div>
                <div>
                    <p>Обрести смысл в работе</p>
                </div>
                <div>
                    <p>Оффер с релокацией</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753814407366-HutLE-Fram.svg"
                        alt="img">
                </div>
                <div>
                    <p>Найти работу</p>
                </div>
                <div>
                    <p>Победить выгорание</p>
                </div>
            </div>
            <div class="club50-main-wrapper wrapper-tablet careerum-flex-fsc position-relative z-20">
                <div>
                    <p>Сменить сферу</p>
                </div>
                <div>
                    <p>Карьерная стратегия</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753885896726-KmMUE-Fram.svg"
                        alt="">
                </div>
                <div></div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753885896836-YdX0s-Fram.svg"
                        alt="">
                </div>
                <div>
                    <p>Новая должность</p>
                </div>
                <div>
                    <p>Победить выгорание</p>
                </div>
                <div>
                    <p>Вырасти в зарплате</p>
                </div>
                <div>
                    <p>Обрести смысл в работе</p>
                </div>
                <div>
                    <p>Оффер с релокацией</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753885896478-4HpxZ-Fram.svg"
                        alt="">
                </div>
                <div>
                    <p>Найти работу</p>
                </div>
                <div></div>
            </div>
            <div class="club50-main-wrapper wrapper-mobile careerum-flex-fsc position-relative z-20">
                <div>
                    <p>Найти работу</p>
                </div>
                <div>
                    <p>Сменить сферу</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753893603438-LDFw2-Fram.svg"
                        alt="img">
                </div>
                <div>
                    <p>Вырасти в зарплате</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753893603320-FjhFW-Fram.svg"
                        alt="img">
                </div>
                <div>
                    <p>Новая должность</p>
                </div>
                <div>
                    <p>Обрести смысл в работе</p>
                </div>
                <div>
                    <p>Победить выгорание</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753893603096-Y4oHQ-Fram.svg"
                        alt="img">
                </div>
                <div>
                    <p>Оффер с релокацией</p>
                </div>
                <div>
                    <p>Карьерная стратегия</p>
                </div>
            </div>
            <a href="#buy" class="btn-color-main-bright-orange position-relative z-20">Записаться в лист ожидания</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club50-main_sept', {
        label: 'Club 50 main sept (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club50-main_sept main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <h1 class="position-relative z-20">Careerum</h1>
                    <p class="club50-main-subheader position-relative z-30">клуб и платформа карьерного развития</p>
                    <div class="club50-main-label position-relative z-30">
                        <p>Тушим пожары<br> 
                            поиска работы</p>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1756226024986-qGIoM-Fram.png"
                        class="hidden-tablet-mobile position-absolute z-10" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1756226027817-GI0vC-Fram.png"
                        class="hidden-desc-mobile position-absolute z-10" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1756226030114-dlBdM-Grou.png"
                        class="hidden-desc-tablet position-absolute z-10" alt="img">
                    <p class="club50-main-text position-relative z-30">И решим любую карьерную задачу:</p>
                    <div class="club50-main-wrapper careerum-flex-fsc position-relative z-20">
                        <p>Найти работу</p>
                        <p>Обрести смысл в работе</p>
                        <p>Оффер с релокацией</p>
                        <p>Сменить сферу</p>
                        <p>Победить выгорание</p>
                        <p>Новая должность</p>
                        <p>Карьерная стратегия</p>
                        <p>Вырасти в зарплате</p>
                    </div>
                    <a href="#buy" class="btn-color-main-bright-orange position-relative z-20">Записаться в лист ожидания</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-club50-what', {
        label: 'Club 50 what (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club50-what main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <h2>Что такое Careerum</h2>
            <p class="club50-what-text">Мы работаем в формате карьерного клуба по подписке, в который входит:</p>
            <div class="club50-what-wrapper careerum-flex-sbst position-relative">
                <div class="club50-what-item white position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753816300925-rhkhQ-Elli.svg"
                        class="hidden-tablet-mobile position-absolute z-10 club50-what-item-top" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753887150146-wwzC0-Elli.svg"
                        class="hidden-desc-mobile position-absolute z-10 club50-what-item-top" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753894305538-5pFwq-Elli.svg"
                        class="hidden-desc-tablet position-absolute z-10 club50-what-item-top" alt="img">
                    <p class="club50-what-item-header position-relative z-20">Образовательный контент</p>
                    <p class="club50-what-item-text">Курсы и эфиры от поиска работы до роста в доходе</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753815035296-Gmc6U-Grou.png"
                        class="hidden-tablet-mobile club50-what-item-bottom" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753887420560-iWIu1-Grou.png"
                        class="hidden-desc-mobile club50-what-item-bottom" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753894224859-CRoCb-Grou.png"
                        class="hidden-desc-tablet club50-what-item-bottom" alt="img">
                </div>
                <div class="club50-what-item blue position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753816300815-ad53v-Elli.svg"
                        class="hidden-tablet-mobile position-absolute z-10 club50-what-item-top" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753887150400-fbpYp-Elli.svg"
                        class="hidden-desc-mobile position-absolute z-10 club50-what-item-top" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753894305419-aIo1q-Elli.svg"
                        class="hidden-desc-tablet position-absolute z-10 club50-what-item-top" alt="img">
                    <p class="club50-what-item-header position-relative z-20">Карьерные консультации</p>
                    <p class="club50-what-item-text">Быстрое достижение целей с поддержкой практиков, которые знают
                        потребности рынка</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753815034718-ZBbIM-Fram.png"
                        class="hidden-tablet-mobile club50-what-item-bottom" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753887420441-SEw0K-Fram.png"
                        class="hidden-desc-mobile club50-what-item-bottom" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753894225173-BWa0s-Fram.png"
                        class="hidden-desc-tablet club50-what-item-bottom" alt="img">
                </div>
                <div class="club50-what-item orange position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753816300543-AZBPi-Elli.svg"
                        class="hidden-tablet-mobile position-absolute z-10 club50-what-item-top" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753887150522-ipak7-Elli.svg"
                        class="hidden-desc-mobile position-absolute z-10 club50-what-item-top" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753894305309-AZhdW-Elli.svg"
                        class="hidden-desc-tablet position-absolute z-10 club50-what-item-top" alt="img">
                    <p class="club50-what-item-header position-relative z-20">Поддерживающее сообщество</p>
                    <p class="club50-what-item-text">Открытые к общению участники, которые готовы делиться своим личным
                        опытом</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753815035179-ilqPl-Grou.png"
                        class="hidden-tablet-mobile club50-what-item-bottom" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753887420198-0Sbn3-Grou.png"
                        class="hidden-desc-mobile club50-what-item-bottom" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753894225357-yRMrS-Grou.png"
                        class="hidden-desc-tablet club50-what-item-bottom" alt="img">
                </div>
                <div class="club50-what-item-img position-absolute hidden-tablet">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753814950964-z4Ibf-Grou.svg"
                        class="hidden-tablet-mobile position-absolute" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753894265609-tigrF-Grou.svg"
                        class="hidden-desc-tablet position-absolute" alt="img">
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club50-clients', {
        label: 'Club 50 clients (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club50-clients main-wrapper">
        <div class="careerum-container-responsive">
            <h2 class="careerum-club40-header">Наши клиенты построили карьеру в ведущих компаниях</h2>
            <div class="club50-clients-image hidden-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753883213525-fhjzf-Ð»Ð¾.png"
                    class="hidden-tablet-mobile" alt="logos">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753888574974-w7I33-Ð»Ð¾.png"
                    class="hidden-desc-mobile" alt="logos">
            </div>
            <div class="club50-clients-image hidden-desc-tablet position-relative">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753905709941-9kkGu-Prop.png" class="" alt="">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753905710511-Zacts-Prop.png" class="" alt="">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753905710364-DDQsK-Prop.png" class="" alt="">
            </div>
            <div class="club50-clients-tales careerum-flex-sbst">
                <div class="club50-clients-tale light">
                    <div class="careerum-flex-fsfs">
                        <p class="club50-clients-tale-header">6 000+</p>
                        <p class="club50-clients-tale-label position-relative">Офферов</p>
                    </div>
                    <p class="club50-clients-tale-text">Получили наши клиенты по всему миру </p>
                </div>
                <div class="club50-clients-tale medium">
                    <div class="careerum-flex-fsfs">
                        <p class="club50-clients-tale-header">1,5+ раза</p>
                        <p class="club50-clients-tale-label position-relative">Рост ЗП</p>
                    </div>
                    <p class="club50-clients-tale-text">Средний рост зарплаты с Careerum</p>
                </div>
                <div class="club50-clients-tale dark">
                    <div class="careerum-flex-fsfs">
                        <p class="club50-clients-tale-header">14 000+</p>
                        <p class="club50-clients-tale-label position-relative">Успешных кейсов</p>
                    </div>
                    <p class="club50-clients-tale-text">Профессионалов по всему миру уже построили карьеру по методу
                        Careerum </p>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('club50-clients2', {
        label: 'Club 50 clients 2 (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club50-clients main-wrapper club50-clients2">
                <div class="careerum-container-responsive">
                    <h2 class="careerum-club40-header">Наши клиенты построили карьеру
                        в ведущих компаниях России и мира</h2>
                    <div class="club50-clients-image hidden-mobile">
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753883213525-fhjzf-Ð»Ð¾.png"
                            alt="logos" class="hidden-tablet-mobile" />
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753888574974-w7I33-Ð»Ð¾.png"
                            alt="logos" class="hidden-desc-mobile" />
                    </div>
                    <div
                        class="club50-clients-image hidden-desc-tablet position-relative">
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753905709941-9kkGu-Prop.png" alt=""
                            id="idxbrl" />
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753905710511-Zacts-Prop.png" alt=""
                            id="ixyse1" />
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753905710364-DDQsK-Prop.png" alt=""
                            id="izqcxr" />
                    </div>
                    <div class="club50-clients-tales careerum-flex-sbst">
                        <div class="club50-clients-tale light">
                            <div class="careerum-flex-fsfs">
                                <p class="club50-clients-tale-header">6 000+</p>
                                <p class="club50-clients-tale-label position-relative">
                                    Офферов</p>
                            </div>
                            <p class="club50-clients-tale-text">Получили наши клиенты
                                по всему миру </p>
                        </div>
                        <div class="club50-clients-tale medium">
                            <div class="careerum-flex-fsfs">
                                <p class="club50-clients-tale-header">1,5+ раза</p>
                                <p class="club50-clients-tale-label position-relative">
                                    Рост ЗП</p>
                            </div>
                            <p class="club50-clients-tale-text">Средний рост зарплаты
                                клубовцев</p>
                        </div>
                        <div class="club50-clients-tale medium-dark">
                            <div class="careerum-flex-fsfs">
                                <p class="club50-clients-tale-header">130+</p>
                                <p class="club50-clients-tale-label position-relative">
                                    Релокаций</p>
                            </div>
                            <p class="club50-clients-tale-text">Даже в кризисы</p>
                        </div>
                        <div class="club50-clients-tale dark">
                            <div class="careerum-flex-fsfs">
                                <p class="club50-clients-tale-header">450%</p>
                                <p class="club50-clients-tale-label position-relative">
                                    Рекорд</p>
                            </div>
                            <p class="club50-clients-tale-text">Повышения зарплаты вместе
                                с Careerum </p>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-club50-for-you', {
        label: 'Club 50 for-you (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club50-for-you main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <h2>Careerum для вас, если:</h2>
            <div class="club50-for-you-wrapper noselect">
                <div class="club50-for-you-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753819034681-hUKJI-Smil.svg"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753889270910-gL6yI-Smil.svg"
                        class="hidden-desc" alt="img">
                    <p class="club50-for-you-item-header position-relative">Не расту в карьере</p>
                    <p class="club50-for-you-item-text">У меня куча опыта, но сомнения мешают расти в карьере</p>
                </div>
                <div class="club50-for-you-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753819034557-HaKzT-Hour.svg"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753889270809-KnkVq-Hour.svg"
                        class="hidden-desc" alt="img">
                    <div class="careerum-flex-fsst">
                        <p class="club50-for-you-item-header position-relative z-20">Ищу работу</p>
                        <p class="club50-for-you-item-header position-relative z-10">больше 3х месяцев</p>
                    </div>
                    <p class="club50-for-you-item-text">Но откликов мало, а вакансии не радуют</p>
                </div>
                <div class="club50-for-you-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753819034317-2IYX5-Coin.svg"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753889270570-e6zhp-Coin.svg"
                        class="hidden-desc" alt="img">
                    <p class="club50-for-you-item-header position-relative">Боюсь обсуждать деньги </p>
                    <p class="club50-for-you-item-text">И предлагать свои условия в работе</p>
                </div>
                <div class="club50-for-you-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753819034090-dUYx1-Char.svg"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753889270206-Iul1R-Char.svg"
                        class="hidden-desc" alt="img">
                    <p class="club50-for-you-item-text">Справляюсь с задачами и перевыполняю KPI, но</p>
                    <p class="club50-for-you-item-header position-relative">Меня не повышают </p>
                </div>
                <div class="club50-for-you-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753819034557-HaKzT-Hour.svg"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753889270697-XETnS-Hour.svg"
                        class="hidden-desc" alt="img">
                    <div class="careerum-flex-fsst">
                        <p class="club50-for-you-item-header position-relative z-20">Ищу работу</p>
                        <p class="club50-for-you-item-header position-relative z-10">после декрета </p>
                    </div>
                    <p class="club50-for-you-item-text">Сложно найти работу после долгого перерыва / декрета /
                        саббатикала</p>
                </div>
                <div class="club50-for-you-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753819034205-DhJw6-Circ.svg"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753889270460-I4tsC-Circ.svg"
                        class="hidden-desc" alt="img">
                    <div class="careerum-flex-fsst">
                        <p class="club50-for-you-item-header position-relative z-20">Не понимаю свои </p>
                        <p class="club50-for-you-item-header position-relative z-10">сильные стороны</p>
                    </div>
                    <p class="club50-for-you-item-text">И не знаю, куда расти и развиваться</p>
                </div>
                <div class="club50-for-you-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753819034793-3jah9-Smil.svg"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753889271019-8EBDs-Smil.svg"
                        class="hidden-desc" alt="img">
                    <p class="club50-for-you-item-header position-relative">Набираю горy проектов </p>
                    <p class="club50-for-you-item-text">Чтобы руководитель заметил мои результаты</p>
                </div>
                <div class="club50-for-you-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753819033711-RZtW7-Arro.svg"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753889375248-ktzSw-Arro.svg"
                        class="hidden-desc" alt="img">
                    <div class="careerum-flex-fsst">
                        <p class="club50-for-you-item-header position-relative z-20">Меняю компанию</p>
                        <p class="club50-for-you-item-header position-relative z-10">каждый год </p>
                    </div>
                    <p class="club50-for-you-item-text">Надеясь, что на  новом месте будет лучше</p>
                </div>
                <div class="club50-for-you-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753819033980-3dTfw-Batt.svg"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753889374983-xotxr-Batt.svg"
                        class="hidden-desc" alt="img">
                    <p class="club50-for-you-item-header position-relative">Регулярно выгораю</p>
                    <p class="club50-for-you-item-text">Меняю работy раз в год или  чаще, ухожy в творческий отпуск</p>
                </div>
            </div>
            <div class="club50-for-you-nav careerum-flex-fec">
                <div class="club50-for-you-nav-prev careerum-flex-cc ">
                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="club50-for-you-nav-next careerum-flex-cc">
                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club50-cases', {
        label: 'Club 50 cases (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-seo-cases careerum-club50-cases main-wrapper club50-cases2 levelup-cases">
                <div class="careerum-container-responsive">
                    <h2>Результаты наших клиентов</h2>
                    <p class="club50-cases-subheader">До / После </p>
                    <div class="seo-cases-wrapper">
                        <div class="seo-cases-items">
                            <div class="seo-cases-item">
                                <div>
                                    <img loading=""
                                        src="https://storage.yandexcloud.net/cdn.careerum.com/1773146635464-nmDjs-Fram.png"
                                        alt="img" class="hidden-mobile">
                                    <img loading=""
                                        src="https://storage.yandexcloud.net/cdn.careerum.com/1773146801533-KenW1-Fram.png"
                                        alt="img" class="hidden-desc-tablet">
                                    <p class="seo-cases-item-name">Сергей Михайлов
                                    </p>
                                    <p class="seo-cases-item-position">Technical Transfer Lead,
                                        Австрия</p>
                                    <a href="#" target="_blank" class="seo-cases-item-ln careerum-flex-fsc disabled">
                                        <img loading="" src="
                                            https://fra1.digitaloceanspaces.com/devabackenduploads/1753821559141-onfXW-Link.svg"
                                            alt="">
                                        <p>Профиль в LinkedIn</p>
                                    </a>
                                    <div class="seo-cases-item-line"></div>
                                    <p class="seo-cases-item-before">До: </p>
                                    <ul class="seo-cases-item-before-list">
                                        <li>Искал роль  проджект-менеджера  в международной
                                            компании</li>
                                        <li>Хотел переехать в Западную Европу</li>
                                    </ul>
                                    <p class="seo-cases-item-after">Результат с Careerum:&nbsp;
                                    </p>
                                    <ul>
                                        <li class="bold">Получил оффер</li>
                                        <li>Релоцировался в Австрию</li>
                                        <li>Рост дохода в 3 раза</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="seo-cases-item">
                                <div>
                                    <img loading=""
                                        src="https://storage.yandexcloud.net/cdn.careerum.com/1773146635751-0nKvn-mobi.png"
                                        alt="img" class="hidden-mobile">
                                    <img loading=""
                                        src="https://storage.yandexcloud.net/cdn.careerum.com/1773146801871-lEHbl-mobi.png"
                                        alt="img" class="hidden-desc-tablet">
                                    <p class="seo-cases-item-name">Мария Воробьёва
                                    </p>
                                    <p class="seo-cases-item-position">Креативный продюсер,
                                        Сербия  </p>
                                    <a href="https://www.linkedin.com/in/maryarty/" target="_blank"
                                        class="seo-cases-item-ln careerum-flex-fsc">
                                        <img loading="" src="
                                            https://fra1.digitaloceanspaces.com/devabackenduploads/1753821559141-onfXW-Link.svg"
                                            alt="">
                                        <p>Профиль в LinkedIn</p>
                                    </a>
                                    <div class="seo-cases-item-line"></div>
                                    <p class="seo-cases-item-before">До: </p>
                                    <ul class="seo-cases-item-before-list">
                                        <li>10 лет в маркетинге</li>
                                        <li>Выгорела, потеряла ориентиры и веру в себя</li>
                                        <li>Работа не вдохновляла,  а опыт казался бессмысленным
                                        </li>
                                    </ul>
                                    <p class="seo-cases-item-after">Результат с Careerum:&nbsp;
                                    </p>
                                    <ul>
                                        <li class="bold">Получила 2 оффера</li>
                                        <li>Получила работу в Сербии</li>
                                        <li>Рост дохода на 20%</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="seo-cases-item">
                                <div>
                                    <img loading=""
                                        src="https://storage.yandexcloud.net/cdn.careerum.com/1773146635546-dnKGF-Fram.png"
                                        alt="img" class="hidden-mobile">
                                    <img loading=""
                                        src="https://storage.yandexcloud.net/cdn.careerum.com/1773146801629-Qj9Ei-Fram.png"
                                        alt="img" class="hidden-desc-tablet">
                                    <p class="seo-cases-item-name">Сергей Бухаров
                                    </p>
                                    <p class="seo-cases-item-position">Supply Chain Analyst,
                                        Нидерланды
                                    <div data-gjs-type="default"><span data-gjs-type="default"><br data-gjs-type="default"></span>
                                    </div>
                                    </p>
                                    <a href="#" target="_blank" class="seo-cases-item-ln careerum-flex-fsc disabled">
                                        <img loading="" src="
                                            https://fra1.digitaloceanspaces.com/devabackenduploads/1753821559141-onfXW-Link.svg"
                                            alt="">
                                        <p>Профиль в LinkedIn</p>
                                    </a>
                                    <div class="seo-cases-item-line"></div>
                                    <p class="seo-cases-item-before">До: </p>
                                    <ul class="seo-cases-item-before-list">
                                        <li>Уволился весной 2022 года, так как не смог договориться
                                            о релокации</li>
                                        <li>Переехал из России  в Грузию</li>
                                    </ul>
                                    <p class="seo-cases-item-after">Результат с Careerum:&nbsp;
                                    </p>
                                    <ul>
                                        <li class="bold">Оффер от Mars&nbsp;</li>
                                        <li>Компания сопроводила релокацию в Нидерланды</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="seo-cases-item">
                                <div>
                                    <img loading=""
                                        src="https://storage.yandexcloud.net/cdn.careerum.com/1773146635592-CYzTq-Fram.png"
                                        alt="img" class="hidden-mobile">
                                    <img loading=""
                                        src="https://storage.yandexcloud.net/cdn.careerum.com/1773146801676-5hnWW-Fram.png"
                                        alt="img" class="hidden-desc-tablet">
                                    <p class="seo-cases-item-name">Людмила Киселёва
                                    </p>
                                    <p class="seo-cases-item-position">Recruiter ll, США</p>
                                    <a href="https://www.linkedin.com/in/lusy-kiseleva/" target="_blank"
                                        class="seo-cases-item-ln careerum-flex-fsc">
                                        <img loading="" src="
                                            https://fra1.digitaloceanspaces.com/devabackenduploads/1753821559141-onfXW-Link.svg"
                                            alt="">
                                        <p>Профиль в LinkedIn</p>
                                    </a>
                                    <div class="seo-cases-item-line"></div>
                                    <p class="seo-cases-item-before">До: </p>
                                    <ul class="seo-cases-item-before-list">
                                        <li>Переехала в США,  работала ассистентом</li>
                                        <li>Хотела начать карьеру  в корпорации</li>
                                    </ul>
                                    <p class="seo-cases-item-after">Результат с Careerum:&nbsp;
                                    </p>
                                    <ul>
                                        <li class="bold">Оффер ассистента  в Microsoft&nbsp;</li>
                                        <li>Через год стала рекрутером в Transocean</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="seo-cases-item">
                                <div>
                                    <img loading=""
                                        src="https://storage.yandexcloud.net/cdn.careerum.com/1773146635786-mnQDA-mobi.png"
                                        alt="img" class="hidden-mobile">
                                    <img loading=""
                                        src="https://storage.yandexcloud.net/cdn.careerum.com/1773146801916-m7Ak0-mobi.png"
                                        alt="img" class="hidden-desc-tablet">
                                    <p class="seo-cases-item-name">Полина Климашевская
                                    </p>
                                    <p class="seo-cases-item-position">Маркетолог, Германия  </p>
                                    <a href="https://www.linkedin.com/in/polina-klimashevskaia/" target="_blank"
                                        class="seo-cases-item-ln careerum-flex-fsc">
                                        <img loading="" src="
                                            https://fra1.digitaloceanspaces.com/devabackenduploads/1753821559141-onfXW-Link.svg"
                                            alt="">
                                        <p>Профиль в LinkedIn</p>
                                    </a>
                                    <div class="seo-cases-item-line"></div>
                                    <p class="seo-cases-item-before">До: </p>
                                    <ul class="seo-cases-item-before-list">
                                        <li>Выгорание, год не могла начать поиск работы из-за
                                            стресса</li>
                                        <li>Не понимала своей ценности как специалиста</li>
                                    </ul>
                                    <p class="seo-cases-item-after">Результат с Careerum:&nbsp;
                                    </p>
                                    <ul>
                                        <li class="bold">Оффер в стартапе</li>
                                        <li>10 000 € к годовому доходу</li>
                                        <li>100% домашний офис</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="seo-cases-item">
                                <div>
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753883585439-jSyD6-Fram.png"
                                        alt="img" class="hidden-mobile">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753907316829-EKeIp-Fram.png"
                                        alt="img" class="hidden-desc-tablet">
                                    <p class="seo-cases-item-name">Олег Федоткин
                                    </p>
                                    <p class="seo-cases-item-position">Head of
                                        Department, Германия</p>
                                    <a href="https://www.linkedin.com/in/olegfedotkin/" target="_blank"
                                        class="seo-cases-item-ln careerum-flex-fsc">
                                        <img loading="" src="
                                            https://fra1.digitaloceanspaces.com/devabackenduploads/1753821559141-onfXW-Link.svg"
                                            alt="">
                                        <p>Профиль в LinkedIn</p>
                                    </a>
                                    <div class="seo-cases-item-line"></div>
                                    <p class="seo-cases-item-before">До: </p>
                                    <ul class="seo-cases-item-before-list">
                                        <li>Не мог самостоятельно найти работу в Германии</li>
                                        <li>Не хотел возвращаться  в Москву после окончания
                                            контракта c Henkel</li>
                                    </ul>
                                    <p class="seo-cases-item-after">Результат с Careerum:&nbsp;
                                    </p>
                                    <ul>
                                        <li class="bold">Оффер на head-позицию&nbsp;</li>
                                        <li>Рост зарплаты на 30%</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="seo-cases-item">
                                <div>
                                    <img loading=""
                                        src="https://storage.yandexcloud.net/cdn.careerum.com/1773146635824-Y6PA7-mobi.png"
                                        alt="img" class="hidden-mobile">
                                    <img loading=""
                                        src="https://storage.yandexcloud.net/cdn.careerum.com/1773146801961-LfTjU-mobi.png"
                                        alt="img" class="hidden-desc-tablet">
                                    <p class="seo-cases-item-name">Екатерина Семусева
                                    </p>
                                    <p class="seo-cases-item-position">Старший тестировщик
                                        1С, Москва </p>
                                    <a href="#" target="_blank" class="seo-cases-item-ln careerum-flex-fsc disabled">
                                        <img loading="" src="
                                            https://fra1.digitaloceanspaces.com/devabackenduploads/1753821559141-onfXW-Link.svg"
                                            alt="">
                                        <p>Профиль в LinkedIn</p>
                                    </a>
                                    <div class="seo-cases-item-line"></div>
                                    <p class="seo-cases-item-before">До: </p>
                                    <ul class="seo-cases-item-before-list">
                                        <li>15 лет опыта, руководящая роль</li>
                                        <li>Токсичный коллектив  и обесценивание себя</li>
                                        <li>Паника при мысли о поиске работы</li>
                                    </ul>
                                    <p class="seo-cases-item-after">Результат с Careerum:&nbsp;
                                    </p>
                                    <ul>
                                        <li class="bold">Оффер в Sber за 2 недели</li>
                                        <li>Ощущение контроля над карьерой</li>
                                        <li>Зарплата выше рынка</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="seo-cases-item">
                                <div>
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753986343695-glxpY-desk.png"
                                        alt="img" class="hidden-mobile">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753986343984-SoQME-mobi.png"
                                        alt="img" class="hidden-desc-tablet">
                                    <p class="seo-cases-item-name">Анастасия Шубихина
                                    </p>
                                    <p class="seo-cases-item-position">Бизнес-аналитик, Россия</p>
                                    <a href="#" target="_blank" class="seo-cases-item-ln careerum-flex-fsc disabled">
                                        <img loading="" src="
                                            https://fra1.digitaloceanspaces.com/devabackenduploads/1753821559141-onfXW-Link.svg"
                                            alt="">
                                        <p>Профиль в LinkedIn</p>
                                    </a>
                                    <div class="seo-cases-item-line"></div>
                                    <p class="seo-cases-item-before">До: </p>
                                    <ul class="seo-cases-item-before-list">
                                        <li>Высокая экспертиза и желание сменить сферу</li>
                                        <li>Боялась потерять в деньгах и статусе</li>
                                        <li>Не было опыта и стратегии поиска</li>
                                    </ul>
                                    <p class="seo-cases-item-after">Результат с Careerum:&nbsp;
                                    </p>
                                    <ul>
                                        <li class="bold">Оффер в IT</li>
                                        <li>Рост дохода в 2 раза</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="seo-cases-item">
                                <div>
                                    <img loading=""
                                        src="https://storage.yandexcloud.net/cdn.careerum.com/1773146635635-1bIGT-Fram.png"
                                        alt="img" class="hidden-mobile">
                                    <img loading=""
                                        src="https://storage.yandexcloud.net/cdn.careerum.com/1773146801722-Er9lH-Fram.png"
                                        alt="img" class="hidden-desc-tablet">
                                    <p class="seo-cases-item-name">Александра Пинчукова
                                    </p>
                                    <p class="seo-cases-item-position">Менеджер бизнес-процессов,
                                        Германия</p>
                                    <a href="#" target="_blank" class="seo-cases-item-ln careerum-flex-fsc disabled">
                                        <img loading="" src="
                                            https://fra1.digitaloceanspaces.com/devabackenduploads/1753821559141-onfXW-Link.svg"
                                            alt="">
                                        <p>Профиль в LinkedIn</p>
                                    </a>
                                    <div class="seo-cases-item-line"></div>
                                    <p class="seo-cases-item-before">До: </p>
                                    <ul class="seo-cases-item-before-list">
                                        <li>Работала главным бухгалтером</li>
                                        <li>Хотела найти работу  в Германии и переехать</li>
                                    </ul>
                                    <p class="seo-cases-item-after">Результат с Careerum:&nbsp;
                                    </p>
                                    <ul>
                                        <li class="bold">Оффер в штаб-квартиру Puma&nbsp;</li>
                                        <li>Релокация в Германию</li>
                                        <li>Оффер за 3 месяца поиска</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="seo-cases-item">
                                <div>
                                    <img loading=""
                                        src="https://storage.yandexcloud.net/cdn.careerum.com/1773146635670-EgoLM-Fram.png"
                                        alt="img" class="hidden-mobile">
                                    <img loading=""
                                        src="https://storage.yandexcloud.net/cdn.careerum.com/1773146801776-cH1KC-Fram.png"
                                        alt="img" class="hidden-desc-tablet">
                                    <p class="seo-cases-item-name">Тая Штоль
                                    </p>
                                    <p class="seo-cases-item-position">UX/UI-дизайнер, Испания</p>
                                    <a href="https://www.linkedin.com/in/dr-taja-stoll/" target="_blank" class="seo-cases-item-ln careerum-flex-fsc">
                                        <img loading="" src="
                                            https://fra1.digitaloceanspaces.com/devabackenduploads/1753821559141-onfXW-Link.svg"
                                            alt="">
                                        <p>Профиль в LinkedIn</p>
                                    </a>
                                    <div class="seo-cases-item-line"></div>
                                    <p class="seo-cases-item-before">До: </p>
                                    <ul class="seo-cases-item-before-list">
                                        <li>Потеряла всех клиентов  из России в феврале 2022 года
                                        </li>
                                        <li>Хотела в найм, но опыт  был только во фрилансе</li>
                                    </ul>
                                    <p class="seo-cases-item-after">Результат с Careerum:&nbsp;
                                    </p>
                                    <ul>
                                        <li class="bold">Оффер в немецкую компанию&nbsp; &nbsp;
                                        </li>
                                        <li>Рост дохода в 6 раз</li>
                                        <li>Получила соцпакет</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="seo-cases-item">
                                <div>
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753986308406-cRA8k-desk.png"
                                        alt="img" class="hidden-mobile">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753986308867-OrHL2-mobi.png"
                                        alt="img" class="hidden-desc-tablet">
                                    <p class="seo-cases-item-name">Наталья Рябова
                                    </p>
                                    <p class="seo-cases-item-position">Learning &amp; Development
                                        Manager в DFE Pharma, Германия</p>
                                    <a href="https://www.linkedin.com/in/nataliaryabova/" target="_blank"
                                        class="seo-cases-item-ln careerum-flex-fsc">
                                        <img loading="" src="
                                            https://fra1.digitaloceanspaces.com/devabackenduploads/1753821559141-onfXW-Link.svg"
                                            alt="">
                                        <p>Профиль в LinkedIn</p>
                                    </a>
                                    <div class="seo-cases-item-line"></div>
                                    <p class="seo-cases-item-before">До: </p>
                                    <ul class="seo-cases-item-before-list">
                                        <li>4 месяца самостоятельного поиска в Германии</li>
                                        <li>Офферов не было, до интервью не доходила</li>
                                    </ul>
                                    <p class="seo-cases-item-after">Результат с Careerum:&nbsp;
                                    </p>
                                    <ul>
                                        <li class="bold">Оффер через 2 недели после интервью</li>
                                        <li>Рост дохода на 70%</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="seo-cases-item">
                                <div>
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753883585304-5KOSN-Fram.png"
                                        alt="img" class="hidden-mobile">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753907316689-b5hPA-Fram.png"
                                        alt="img" class="hidden-desc-tablet">
                                    <p class="seo-cases-item-name">Евгения
                                        Вольхина</p>
                                    <p class="seo-cases-item-position">Project
                                        Manager, Германия </p>
                                    <a href="#" class="seo-cases-item-ln careerum-flex-fsc disabled">
                                        <img loading="" src="
                                            https://fra1.digitaloceanspaces.com/devabackenduploads/1753821559141-onfXW-Link.svg"
                                            alt="">
                                        <p>Профиль в LinkedIn</p>
                                    </a>
                                    <div class="seo-cases-item-line"></div>
                                    <p class="seo-cases-item-before">До: </p>
                                    <ul class="seo-cases-item-before-list">
                                        <li>Работала консультантом-методологом  в Екатеринбурге
                                        </li>
                                        <li>Хотела сменить сферу и релоцироваться в Германию&nbsp;
                                        </li>
                                    </ul>
                                    <p class="seo-cases-item-after">Результат с Careerum:&nbsp;
                                    </p>
                                    <ul>
                                        <li class="bold">Оффер в Big4 в Москве&nbsp;</li>
                                        <li class="bold">Оффер в Германию</li>
                                        <li>Рост зарплаты на 40%</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="seo-cases-item">
                                <div>
                                    <img loading=""
                                        src="https://storage.yandexcloud.net/cdn.careerum.com/1773146635711-AgWxk-Fram.png"
                                        alt="img" class="hidden-mobile">
                                    <img loading=""
                                        src="https://storage.yandexcloud.net/cdn.careerum.com/1773146801822-cmWoQ-Fram.png"
                                        alt="img" class="hidden-desc-tablet">
                                    <p class="seo-cases-item-name">Карина Пысина
                                    </p>
                                    <p class="seo-cases-item-position">Бизнес-аналитик, Россия</p>
                                    <a href="https://www.linkedin.com/mwlite/in/karina-pysina-919342110" target="_blank"
                                        class="seo-cases-item-ln careerum-flex-fsc">
                                        <img loading="" src="
                                            https://fra1.digitaloceanspaces.com/devabackenduploads/1753821559141-onfXW-Link.svg"
                                            alt="">
                                        <p>Профиль в LinkedIn</p>
                                    </a>
                                    <div class="seo-cases-item-line"></div>
                                    <p class="seo-cases-item-before">До: </p>
                                    <ul class="seo-cases-item-before-list">
                                        <li>Пыталась перейти в бизнес-анализ из клиентского отдела
                                        </li>
                                        <li>Не смогла и уволилась вникуда</li>
                                    </ul>
                                    <p class="seo-cases-item-after">Результат с Careerum:&nbsp;
                                    </p>
                                    <ul>
                                        <li class="bold">Оффер бизнес-аналитика&nbsp;&nbsp;</li>
                                        <li>Зарплата на 100% выше</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="seo-cases-item">
                                <div>
                                    <img loading=""
                                        src="https://storage.yandexcloud.net/cdn.careerum.com/1773146635861-sDIxK-mobi.png"
                                        alt="img" class="hidden-mobile">
                                    <img loading=""
                                        src="https://storage.yandexcloud.net/cdn.careerum.com/1773146802008-JEx77-mobi.png"
                                        alt="img" class="hidden-desc-tablet">
                                    <p class="seo-cases-item-name">Анна Штендер
                                    </p>
                                    <p class="seo-cases-item-position">Bid and Proposal Manager,
                                        Германия</p>
                                    <a href="#" target="_blank"
                                        class="seo-cases-item-ln careerum-flex-fsc disabled">
                                        <img loading="" src="
                                            https://fra1.digitaloceanspaces.com/devabackenduploads/1753821559141-onfXW-Link.svg"
                                            alt="">
                                        <p>Профиль в LinkedIn</p>
                                    </a>
                                    <div class="seo-cases-item-line"></div>
                                    <p class="seo-cases-item-before">До: </p>
                                    <ul class="seo-cases-item-before-list">
                                        <li>10 лет перерыва в карьере</li>
                                        <li>Релокация</li>
                                        <li>Не могла выйти на новый рынок Германии</li>
                                    </ul>
                                    <p class="seo-cases-item-after">Результат с Careerum:&nbsp;
                                    </p>
                                    <ul>
                                        <li class="bold">Оффер в немецкой компании</li>
                                        <li>Адаптировала RU-опыт  под немецкий рынок</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-flex-fec seo-cases-nav">
                            <div aria-disabled="true" class="careerum-flex-cc seo-cases-nav-prev slick-arrow slick-disabled"><svg
                                    data-gjs-type="svg"" width=" 18"height="16" viewBox="0 0 18 16" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path data-gjs-type="svg-in""
                                        d=" M2.19055 8.13997L15.8105 8.13997"stroke="white" stroke-width="2.64201"
                                        stroke-linecap="round" stroke-linejoin="round">
                                    </path>
                                    <path data-gjs-type="svg-in""
                                        d=" M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258"stroke="white" stroke-width="2.64201"
                                        stroke-linecap="round" stroke-linejoin="round"></path>
                                </svg></div>
                            <div aria-disabled="false" class="careerum-flex-cc seo-cases-nav-next slick-arrow"><svg
                                    data-gjs-type="svg""
                                    width=" 18"height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path data-gjs-type="svg-in""
                                        d=" M15.8095 8.14128L2.18945 8.14128"stroke="white" stroke-width="2.64201"
                                        stroke-linecap="round" stroke-linejoin="round">
                                    </path>
                                    <path data-gjs-type="svg-in""
                                        d=" M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887"stroke="white" stroke-width="2.64201"
                                        stroke-linecap="round" stroke-linejoin="round"></path>
                                </svg></div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-club50-library', {
        label: 'Club 50 library (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club50-library main-wrapper club0326-library">
        <div class="careerum-container-responsive">
            <div class="club50-library-top">
                <h2 id="i6oi57f">Подберем образовательный трек под вашу цель внутри нашей платформы</h2>
            </div>
            <div class="club50-library-filter">
                <div class="club50-library-filter-wrapper">
                    <ul class="careerum-flex-fsc noselect">
                        <li data-filter="all" class="active club-50-filter-item">
                            Все</li>
                        <li id="iz0ntz">Поиск работы</li>
                        <li id="ihe6j12">Карьерный рост</li>
                        <li id="i6071p">Ясность и план</li>
                        <li id="ixhxo9g">Релокация</li>
                        <li>Выгорание</li>
                        <li id="iqshb6p">Самооценка</li>
                        <li>Коммуникации</li>
                    </ul>
                </div>
            </div>
            <div class="club50-library-wrapper noselect">
                <div data-filter="Ясность и план,Выгорание" class="club50-library-item light-blue">
                    <div class="club50-library-item-bg position-relative">
                        <div class="careerum-flex-fsc position-relative z-20">
                            <p class="club50-library-item-label">Ясность и план
                            </p>
                            <p class="club50-library-item-label">Выгорание</p>
                        </div>
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753855168802-1VRfF-Grou.svg"
                            alt="img" class="position-absolute" />
                    </div>
                    <div class="club50-library-item-content position-relative">
                        <div class="club50-library-item-content-front">
                            <p class="club50-library-item-header">Real me.
                                Перезагрузка</p>
                            <p class="club50-library-item-text">Программа по
                                проработке стратегии выхода из карьерного
                                кризиса и плана перехода к новой деятельности</p>
                            <div class="club50-library-item-result careerum-flex-fsc">
                                <img loading=""
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753857621330-Gtb5o-Chec.svg"
                                    alt="" />
                                <p>Результат:</p>
                            </div>
                            <p class="club50-library-item-result-text">Найдете
                                новый вектор развития и начнете движение
                                к
                                осмысленной и приносящей удовлетворение работе</p>
                            <div class="club50-library-item-button">
                                <p>Узнать подробнее</p>
                            </div>
                        </div>
                        <div class="club50-library-item-content-back">
                            <p class="club50-library-item-header">Что входит в
                                программу «Выход из карьерного кризиса и
                                перезагрузка»:</p>
                            <p class="club50-library-item-subheader">Запись
                                мастер-класса:</p>
                            <ul>
                                <li>2026: Тренды, сценарии развития, навыки
                                    будущего» </li>
                            </ul>
                            <div class="club50-library-item-divider"></div>
                            <p class="club50-library-item-subheader">Курсы:</p>
                            <ul>
                                <li>Real Me</li>
                                <li>
                                    Портфельная / нелинейная / <br />слеш-карьера
                                </li>
                                <li>Новые горизонты: Самоопределение и смена
                                    специализации </li>
                                <li>Антикризис</li>
                                <li>Карьерные истории</li>
                                <li>Митап «Истории клубовцев, у которых
                                    получилось»</li>
                            </ul>
                            <div class="club50-library-item-button">
                                <p>Вернуться назад</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div data-filter="Карьерный рост" id="irqwzlv" class="club50-library-item light-blue">
                    <div class="club50-library-item-bg position-relative">
                        <div class="careerum-flex-fsc position-relative z-20">
                            <p class="club50-library-item-label">Карьерный рост
                            </p>
                            <p class="club50-library-item-label hidden">Выгорание
                            </p>
                        </div>
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753855168802-1VRfF-Grou.svg"
                            alt="img" class="position-absolute" />
                    </div>
                    <div class="club50-library-item-content position-relative">
                        <div class="club50-library-item-content-front">
                            <p class="club50-library-item-header">Level Up</p>
                            <p class="club50-library-item-text">Программа
                                профессиональной трансформации и управления карьерой </p>
                            <div class="club50-library-item-result careerum-flex-fsc">
                                <img loading=""
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753857621330-Gtb5o-Chec.svg"
                                    alt="" />
                                <p>Результат:</p>
                            </div>
                            <p class="club50-library-item-result-text">Выберите
                                комфортный и эффектиный вектор карьерного роста и начнете движение к своему повышению
                            </p>
                            <div class="club50-library-item-button">
                                <p id="iifcwmh">Узнать подробнее</p>
                            </div>
                        </div>
                        <div class="club50-library-item-content-back">
                            <p class="club50-library-item-header">Что входит в
                                программу  «Level Up»:</p>
                            <p class="club50-library-item-subheader hidden">Запись
                                мастер-класса:</p>
                            <ul id="ivf11pl" class="hidden">
                                <li id="i77nel3">2026: Тренды, сценарии развития,
                                    навыки будущего» </li>
                            </ul>
                            <div class="club50-library-item-divider hidden"></div>
                            <p class="club50-library-item-subheader hidden">Курсы:
                            </p>
                            <ul>
                                <li id="ibwezkw">Карьерная стратегия</li>
                                <li id="i3ncnzx">23 видеолекции по 15-20 минут
                                </li>
                                <li id="ifio0il">Персональный AI-ассистент </li>
                                <li id="ibmj0b5">Доступ в карьерный клуб</li>
                            </ul>
                            <div class="club50-library-item-button">
                                <p>Вернуться назад</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div data-filter="Карьерный рост" id="ie3v93d" class="club50-library-item blue">
                    <div class="club50-library-item-bg position-relative">
                        <div class="careerum-flex-fsc position-relative z-20">
                            <p class="club50-library-item-label">Карьерный рост
                            </p>
                        </div>
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753855169031-AwA6w-Grou.svg"
                            alt="img" class="position-absolute" />
                    </div>
                    <div class="club50-library-item-content position-relative">
                        <div class="club50-library-item-content-front">
                            <p class="club50-library-item-header">Карьера в эпоху
                                AI</p>
                            <p class="club50-library-item-text">Программа по
                                пересборке профессиональной роли, которая превратит вас из исполнителя в стратега</p>
                            <div class="club50-library-item-result careerum-flex-fsc">
                                <img loading=""
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753857621330-Gtb5o-Chec.svg"
                                    alt="" />
                                <p>Результат:</p>
                            </div>
                            <p class="club50-library-item-result-text">Вы станете
                                специалистом, который управляет процессамии через AI, –
                                с влиянием и сильной позицией на рынке</p>
                            <div class="club50-library-item-button">
                                <p>Узнать подробнее</p>
                            </div>
                        </div>
                        <div class="club50-library-item-content-back">
                            <p class="club50-library-item-header">Что входит в
                                программу  «Карьера в эпоху AI»:</p>
                            <p class="club50-library-item-subheader hidden">
                                Вебинары:</p>
                            <ul id="ixh3deg" class="hidden">
                                <li id="iwrehjo">Менталитет продавца </li>
                                <li>Цепляющее сопроводительное письмо </li>
                            </ul>
                            <div class="club50-library-item-divider hidden"></div>
                            <p class="club50-library-item-subheader hidden">Курсы:
                            </p>
                            <ul>
                                <li id="i197sxg">4 мастермайнда </li>
                                <li id="iutst42">«Тревожный чемоданчик карьериста
                                    2026»: пакет всех промптов программы </li>
                                <li id="ixvuoyq">AI-сервис проверки резюме </li>
                                <li id="i0t3hti">Доступ в карьерный клуб </li>
                            </ul>
                            <div class="club50-library-item-button">
                                <p>Вернуться назад</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div data-filter="Поиск работы" class="club50-library-item blue">
                    <div class="club50-library-item-bg position-relative">
                        <div class="careerum-flex-fsc position-relative z-20">
                            <p class="club50-library-item-label">Поиск работы</p>
                        </div>
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753855169031-AwA6w-Grou.svg"
                            alt="img" class="position-absolute" />
                    </div>
                    <div class="club50-library-item-content position-relative">
                        <div class="club50-library-item-content-front">
                            <p class="club50-library-item-header">Звездный
                                кандидат</p>
                            <p class="club50-library-item-text">Программа по
                                развитию навыков и инструментов для
                                эффективного поиска работы, чтобы получить желаемый оффер на выгодных условиях</p>
                            <div class="club50-library-item-result careerum-flex-fsc">
                                <img loading=""
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753857621330-Gtb5o-Chec.svg"
                                    alt="" />
                                <p>Результат:</p>
                            </div>
                            <p class="club50-library-item-result-text">Получите
                                оффер, соответствующий амбициям и
                                ценностям,
                                с достойной оплатой</p>
                            <div class="club50-library-item-button">
                                <p>Узнать подробнее</p>
                            </div>
                        </div>
                        <div class="club50-library-item-content-back">
                            <p class="club50-library-item-header">Что входит в
                                программу «Звёздный кандидат»:</p>
                            <p class="club50-library-item-subheader">Вебинары:</p>
                            <ul>
                                <li>Менталитет продавца </li>
                                <li>Цепляющее сопроводительное письмо </li>
                            </ul>
                            <div class="club50-library-item-divider"></div>
                            <p class="club50-library-item-subheader">Курсы:</p>
                            <ul>
                                <li>Продающее резюме </li>
                                <li>Умная стратегия поиска работы </li>
                                <li>LinkedIn Pro: как стать звездой для рекрутеров
                                </li>
                                <li>Эффективное интервью </li>
                                <li>Great Deal: как получить оффер мечты</li>
                            </ul>
                            <div class="club50-library-item-button">
                                <p>Вернуться назад</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div data-filter="Карьерный рост,Коммуникации" class="club50-library-item blue">
                    <div class="club50-library-item-bg position-relative">
                        <div class="careerum-flex-fsc position-relative z-20">
                            <p class="club50-library-item-label">Карьерный рост
                            </p>
                            <p class="club50-library-item-label">Коммуникации</p>
                        </div>
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753855168695-8WGeb-Vect.svg"
                            alt="img" class="position-absolute" />
                    </div>
                    <div class="club50-library-item-content position-relative">
                        <div class="club50-library-item-content-front">
                            <p class="club50-library-item-header">Карьерная ракета
                            </p>
                            <p class="club50-library-item-text">Программа для
                                ускорения карьерного и зарплатного
                                роста
                                внутри компании через эффективное планирование, самопрезентацию и нетворкинг</p>
                            <div class="club50-library-item-result careerum-flex-fsc">
                                <img loading=""
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753857621330-Gtb5o-Chec.svg"
                                    alt="" />
                                <p>Результат:</p>
                            </div>
                            <p class="club50-library-item-result-text">Системно
                                построите карьеру в текущей
                                организации,
                                добиваясь повышения и признания</p>
                            <div class="club50-library-item-button">
                                <p>Узнать подробнее</p>
                            </div>
                        </div>
                        <div class="club50-library-item-content-back">
                            <p class="club50-library-item-header">Что входит в
                                программу «Карьерная ракета: как расти
                                внутри компании»:</p>
                            <p class="club50-library-item-subheader">Курсы:</p>
                            <ul>
                                <li>Жизнь после оффера: успешный онбординг</li>
                                <li>Цели как в Google: как расти и быть
                                    эффективной </li>
                                <li>Карьера как проект: управляй карьерой без
                                    стресса и с PDP</li>
                                <li>Пробей зарплатный потолок</li>
                                <li>Секреты нетворкинга</li>
                                <li>Как правильно увольняться</li>
                                <li>Open mindset</li>
                                <li>Митап «Понимание культурного кода»</li>
                            </ul>
                            <div class="club50-library-item-button">
                                <p>Вернуться назад</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div data-filter="Релокация,Поиск работы" class="club50-library-item light-blue">
                    <div class="club50-library-item-bg position-relative">
                        <div class="careerum-flex-fsc position-relative z-20">
                            <p class="club50-library-item-label">Релокация</p>
                            <p class="club50-library-item-label">Поиск работы</p>
                        </div>
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753855168578-fKjxX-Grou.svg"
                            alt="img" class="position-absolute fix3" />
                    </div>
                    <div class="club50-library-item-content position-relative">
                        <div class="club50-library-item-content-front">
                            <p class="club50-library-item-header">Go Global</p>
                            <p class="club50-library-item-text">Программа для
                                разработки стратегии и планирования
                                практических шагов для поиска работы и релокации за границу</p>
                            <div class="club50-library-item-result careerum-flex-fsc">
                                <img loading=""
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753857621330-Gtb5o-Chec.svg"
                                    alt="" />
                                <p>Результат:</p>
                            </div>
                            <p class="club50-library-item-result-text">Построите
                                международную карьеру или успешно
                                релоцируетесь с оффером</p>
                            <div class="club50-library-item-button">
                                <p>Узнать подробнее</p>
                            </div>
                        </div>
                        <div class="club50-library-item-content-back">
                            <p class="club50-library-item-header">Что входит в
                                программу «Go Global»:</p>
                            <p class="club50-library-item-subheader">Вебинар:</p>
                            <ul>
                                <li>Секреты и подводные камни виз талантов: США,
                                    Франция, Великобритания</li>
                            </ul>
                            <div class="club50-library-item-divider"></div>
                            <p class="club50-library-item-subheader">Курсы:</p>
                            <ul>
                                <li>Международная карьера</li>
                                <li id="i0dvm1s">Уроки географии: истории
                                    участников клуба о релокации и адаптации к новой стране
                                    и её культуре</li>
                                <li>Зарубежное образование: демистификация и MBA
                                </li>
                            </ul>
                            <div class="club50-library-item-button">
                                <p>Вернуться назад</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div data-filter="Коммуникации,Карьерный рост" class="club50-library-item blue">
                    <div class="club50-library-item-bg position-relative">
                        <div class="careerum-flex-fsc position-relative z-20">
                            <p class="club50-library-item-label">Коммуникации</p>
                            <p class="club50-library-item-label">Карьерный рост
                            </p>
                        </div>
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753855168919-1xAxz-Vect.svg"
                            alt="img" class="position-absolute fix2" />
                    </div>
                    <div class="club50-library-item-content position-relative">
                        <div class="club50-library-item-content-front">
                            <p class="club50-library-item-header">Power Talk</p>
                            <p class="club50-library-item-text">Программа по
                                развитию навыков эффективной коммуникации,
                                ведения переговоров, в том числе о зарплате, отстаивании границ и убеждений</p>
                            <div class="club50-library-item-result careerum-flex-fsc">
                                <img loading=""
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753857621330-Gtb5o-Chec.svg"
                                    alt="" />
                                <p>Результат:</p>
                            </div>
                            <p class="club50-library-item-result-text">Добьетесь
                                своих целей на работе через уверенное и
                                экологичное общение</p>
                            <div class="club50-library-item-button">
                                <p>Узнать подробнее</p>
                            </div>
                        </div>
                        <div class="club50-library-item-content-back">
                            <p class="club50-library-item-header">Что входит в
                                программу «Power Talk»:</p>
                            <p class="club50-library-item-subheader">Курсы:</p>
                            <ul>
                                <li>EcoTalk. Здоровое общение и личные границы на
                                    работе</li>
                                <li>Эффективное управление конфликтами и
                                    переговоры</li>
                                <li>Как «продавать» свои идеи руководителю и
                                    команде</li>
                                <li>Формула повышения в зарплате и должности</li>
                                <li>Техники переговоров BATNA и ZOPA</li>
                            </ul>
                            <div class="club50-library-item-button">
                                <p>Вернуться назад</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div data-filter="Выгорание,Самооценка" class="club50-library-item light-blue">
                    <div class="club50-library-item-bg position-relative">
                        <div class="careerum-flex-fsc position-relative z-20">
                            <p class="club50-library-item-label">Выгорание</p>
                            <p class="club50-library-item-label">Самооценка</p>
                        </div>
                        <img loading=""
                            src="https://storage.yandexcloud.net/cdn.careerum.com/1773403334062-hcBEQ-Vect.svg"
                            alt="img" class="position-absolute fix1" />
                    </div>
                    <div class="club50-library-item-content position-relative">
                        <div class="club50-library-item-content-front">
                            <p class="club50-library-item-header">Life work
                                balance</p>
                            <p class="club50-library-item-text">Программа для
                                восстановления ресурса,
                                развития навыков
                                управления стрессом, выстраивания личных границ, повышения и развития адекватной
                                профессиональной самооценки</p>
                            <div class="club50-library-item-result careerum-flex-fsc">
                                <img loading=""
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753857621330-Gtb5o-Chec.svg"
                                    alt="" />
                                <p>Результат:</p>
                            </div>
                            <p class="club50-library-item-result-text">Создадите
                                устойчивую систему
                                life-work balance для
                                продуктивной работы без выгорания и с удовольствием. Избавитесь от синдрома
                                самозванца</p>
                            <div class="club50-library-item-button">
                                <p>Узнать подробнее</p>
                            </div>
                        </div>
                        <div class="club50-library-item-content-back">
                            <p class="club50-library-item-header">Что входит в
                                программу «Life work balance»:</p>
                            <p class="club50-library-item-subheader">Курсы:</p>
                            <ul>
                                <li>Самооценка и Деньги</li>
                                <li>Карьера без стресса: методы предотвращения
                                    стресса и выгорания</li>
                                <li>Женская самооценка: мифы и архетипы </li>
                            </ul>
                            <div class="club50-library-item-button">
                                <p>Вернуться назад</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div data-filter="Карьерный рост,Коммуникации" class="club50-library-item blue">
                    <div class="club50-library-item-bg position-relative">
                        <div class="careerum-flex-fsc position-relative z-20">
                            <p class="club50-library-item-label">Карьерный рост
                            </p>
                            <p class="club50-library-item-label">Коммуникации</p>
                        </div>
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753856609217-ez8p7-Grou.svg"
                            alt="img" class="position-absolute" />
                    </div>
                    <div class="club50-library-item-content position-relative">
                        <div class="club50-library-item-content-front">
                            <p class="club50-library-item-header">Big Boss</p>
                            <p class="club50-library-item-text">Программа по
                                развитию навыков
                                эффективного управления
                                командой, понимание бизнес-целей и способности вести команду к результатам</p>
                            <div class="club50-library-item-result careerum-flex-fsc">
                                <img loading=""
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753857621330-Gtb5o-Chec.svg"
                                    alt="" />
                                <p>Результат:</p>
                            </div>
                            <p class="club50-library-item-result-text">Станете
                                компетентным и уверенным
                                руководителем,
                                развивающим свою команду и достигающим успеха</p>
                            <div class="club50-library-item-button">
                                <p>Узнать подробнее</p>
                            </div>
                        </div>
                        <div class="club50-library-item-content-back">
                            <p class="club50-library-item-header">Что входит в
                                программу «Big Boss»:</p>
                            <p class="club50-library-item-subheader">Курсы:</p>
                            <ul>
                                <li>Big Boss: быть, а не казаться </li>
                                <li id="if9e32">
                                    Dream Team: как вывести командную работу на новый уровень<br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                </li>
                            </ul>
                            <div class="club50-library-item-button">
                                <p>Вернуться назад</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="club50-library-nav careerum-flex-fec">
                <div aria-disabled="true" class="careerum-flex-cc club50-library-nav-prev">
                    <svg width=" 18" height=" 16" viewBox=" 0 0 18 16" fill=" none" xmlns=" http://www.w3.org/2000/svg">
                        <path d=" M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round">
                        </path>
                        <path d=" M8.46289 14.3859L2.18956 8.13924L8.46289
                                1.89258" stroke=" white" stroke-width=" 2.64201" stroke-linecap=" round"
                            stroke-linejoin=" round"></path>
                    </svg>
                </div>
                <div hide-by-geo=" unset" aria-disabled=" false" class=" careerum-flex-cc club50-library-nav-next">
                    <svg width=" 18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d=" M15.8095 8.14128L2.18945 8.14128" stroke=" white" stroke-width=" 2.64201"
                            stroke-linecap=" round" stroke-linejoin=" round">
                        </path>
                        <path d=" M9.53711 1.89534L15.8104 8.14201L9.53711
                            14.3887" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                            stroke-linejoin="round"></path>
                    </svg>
                </div>
            </div>
            <div id="ixsr3yg" class="club50-library-button">
                <a onclick="" href="#buy" class="btn-color-main-black">Заполнить анкету в Careerum  </a>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club50-reviews', {
        label: 'Club 50 reviews (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-awake-reviews_video careerum-club50-reviews main-wrapper">
        <div class="careerum-container-responsive">
            <h3>Отзывы участников</h3>
            <div class="awake-reviews-wrapper careerum-flex-fsst">
                <div class="awake-reviews-item" data-video-id="1102196636">
                    <div class="awake-reviews-item-wrapper position-relative">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752762633965-gNJ95-Revi.png"
                            alt="img" class="awake-reviews-item-img position-relative z-10">
                        <div class="awake-reviews-item-video position-absolute z-20"></div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752763535440-GC2wo-Revi.svg"
                            alt="" class="awake-reviews-item-play position-absolute z-30">
                    </div>
                    <div class="awake-reviews-item-info">
                        <p class="awake-reviews-item-info-tag">#Звездный кандидат</p>
                        <p class="awake-reviews-item-info-name">Екатерина</p>
                        <p class="awake-reviews-item-info-position">Юрист-международник</p>
                    </div>
                </div>
                <div class="awake-reviews-item" data-video-id="1102196747">
                    <div class="awake-reviews-item-img position-relative">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752762634995-nbdko-Revi.png"
                            alt="img" class="awake-reviews-item-img position-relative z-10">
                        <div class="awake-reviews-item-video position-absolute z-20"></div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752763535440-GC2wo-Revi.svg"
                            alt="" class="awake-reviews-item-play position-absolute z-30">
                    </div>
                    <div class="awake-reviews-item-info">
                        <p class="awake-reviews-item-info-tag">#Звездный кандидат</p>
                        <p class="awake-reviews-item-info-name">Анна</p>
                        <p class="awake-reviews-item-info-position">Account manager</p>
                    </div>
                </div>
                <div class="awake-reviews-item" data-video-id="1102196799">
                    <div class="awake-reviews-item-img position-relative">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752762634413-FNekJ-Revi.png"
                            alt="img" class="awake-reviews-item-img position-relative z-10">
                        <div class="awake-reviews-item-video position-absolute z-20"></div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752763535440-GC2wo-Revi.svg"
                            alt="" class="awake-reviews-item-play position-absolute z-30">
                    </div>
                    <div class="awake-reviews-item-info">
                        <p class="awake-reviews-item-info-tag">#Звездный кандидат</p>
                        <p class="awake-reviews-item-info-name">Марина</p>
                        <p class="awake-reviews-item-info-position">Ученый исследователь в области
                            инновационных
                            технологий</p>
                    </div>
                </div>
                <div class="awake-reviews-item" data-video-id="1102196799">
                    <div class="awake-reviews-item-img position-relative">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752765960753-9cqlI-Revi.png"
                            alt="img" class="awake-reviews-item-img position-relative z-10">
                        <div class="awake-reviews-item-video position-absolute z-20"></div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752763535440-GC2wo-Revi.svg"
                            alt="" class="awake-reviews-item-play position-absolute z-30">
                    </div>
                    <div class="awake-reviews-item-info">
                        <p class="awake-reviews-item-info-tag">#Power Talk</p>
                        <p class="awake-reviews-item-info-name">Екатерина</p>
                        <p class="awake-reviews-item-info-position">Бренд-менеджер</p>
                    </div>
                </div>
                <div class="awake-reviews-item" data-video-id="1102196799">
                    <div class="awake-reviews-item-img position-relative">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752765961532-4ODQ7-Revi.png"
                            alt="img" class="awake-reviews-item-img position-relative z-10">
                        <div class="awake-reviews-item-video position-absolute z-20"></div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752763535440-GC2wo-Revi.svg"
                            alt="" class="awake-reviews-item-play position-absolute z-30">
                    </div>
                    <div class="awake-reviews-item-info">
                        <p class="awake-reviews-item-info-tag">#Power Talk</p>
                        <p class="awake-reviews-item-info-name">Марина</p>
                        <p class="awake-reviews-item-info-position">Frontend-разработчик</p>
                    </div>
                </div>
            </div>
            <div class="awake-reviews-slider-nav careerum-flex-fec">
                <div class="awake-reviews-nav-prev careerum-flex-cc ">
                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="awake-reviews-nav-next careerum-flex-cc">
                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
            </div>
            <a href="#buy" class="btn-color-main-bright-orange position-relative z-20">Записаться в
                лист ожидания</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club50-form', {
        label: 'Club 50 form (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club50-form main-wrapper">
        <div class="careerum-container-responsive careerum-flex-sbst">
            <div class="club50-form-left">
                <h2>Не определились с выбором курса?</h2>
                <p><span class="orange">Пройдите тест</span> и получите <span class="blue">индивидуальную
                        программу,</span> адаптированную под ваши карьерные цели</p>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753865519795-dJTNy-Cont.svg"
                    class="hidden-tablet-mobile" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753891527123-1yTwi-Cont.svg"
                    class="hidden-desc-mobile" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753908319327-TReT1-Cont.svg"
                    class="hidden-desc-tablet" alt="img">
            </div>
            <div class="club50-form-right">
                <div class="careerum-registration-form-club40">
                    <form class="deva-form" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                        <div class="careerum-club40-form-name">
                            <input type="text" name="name" value="" required placeholder="Имя">
                            <p class="careerum-club40-form-warn">Поле не заполнено</p>
                        </div>
                        <div class="careerum-club40-form-telegram">
                            <input type="text" name="telegram" value="" required placeholder="Telegram">
                            <p class="careerum-club40-form-warn">Поле не заполнено</p>
                        </div>
                        <div class="careerum-club40-form-email">
                            <input type="text" name="email" value="" required placeholder="Почта">
                            <p class="careerum-club40-form-warn">Поле не заполнено</p>
                        </div>
                        <div class="careerum-club40-form-phone">
                            <input type="tel" value="" name="tel" required class="itl-input">
                            <p class="careerum-club40-form-warn">Поле не заполнено</p>
                        </div>
                        <div class="careerum-club40-form-agree">
                            <label>
                                <input type="checkbox" name="agree">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                        fill="none">
                                        <path
                                            d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                            stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                    </svg>
                                </div>
                            </label>
                            <p>Я принимаю условия <a href="#">Оферты</a> и даю согласие на обработку
                                персональных
                                данных
                                в соответствии с <a href="#">Политикой конфиденциальности</a>.</p>
                        </div>
                        <a href="#" class="submit-btn btn-color-main-white-black" disabled>Подобрать
                            программу</a>
                        <input type="hidden" hidden name="offerID" value="">
                    </form>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club50-scanner', {
        label: 'Club 50 scanner (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club50-scanner main-wrapper">
        <div class="careerum-container-responsive careerum-flex-sbst">
            <div class="club50-scanner-left careerum-flex-fsfs position-relative z-20">
                <h2>Резюме Сканер</h2>
                <p>За 1 минуту узнайте, чего не хватает в вашем резюме для идеального отклика на вакансию</p>
                <a href="#" class="btn-color-main-white-black hidden-tablet-mobile">Попробовать</a>
            </div>
            <div class="club50-scanner-right position-relative z-10">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753867237214-qNCI5-Cont.svg"
                    class="hidden-tablet-mobile" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753892233946-8v2jN-Cont.svg" class="hidden-desc-mobile" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753940052422-6XYqa-Cont.png" class="hidden-desc-tablet position-absolute" alt="img">
            </div>
            <a href="#" class="btn-color-main-white-black hidden-desc-tablet">Попробовать</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club50-couches', {
        label: 'Club 50 couches (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-awake-couches careerum-club50-couches main-wrapper">
        <div class="careerum-container-responsive">
            <h2>Карьерные консультации</h2>
            <div class="awake-couches-banner position-relative">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755711692282-ZANNa-Grou.svg"
                    class="hidden-tablet-mobile position-absolute" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755786852606-KOk7s-Grou.svg"
                    class="hidden-desc-mobile position-absolute" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755794882046-1LmBB-Grou.svg"
                    class="hidden-desc-tablet position-absolute" alt="img">
                <p class="awake-couches-banner-text">На тарифе </p>
                <p class="awake-couches-banner-header">«Индивидуальное сопровождение»</p>
            </div>
            <div class="awake-couches-top careerum-flex-sbst">
                <div class="awake-couches-top-left">
                    <p class="awake-couches-top-left-header">Помогут достичь вашей цели: </p>
                    <ul>
                        <li class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746922107-o7d5i-Link.svg"
                                class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752928344203-mYT4Q-Link.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>Составить резюме </p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746921754-njqoR-Chat.svg"
                                class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752928343697-RahCb-Chat.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>Потренировать собеседование</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746922343-RovnH-Targ.svg"
                                class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752928344431-mJthk-Targ.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>Поставить карьерную цель</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746921867-vO3K3-Chat.svg"
                                class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752928343960-eS8IV-Chat.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>Подготовиться к переговорам по офферу</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746921991-PflyV-Comp.svg"
                                class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752928344081-KycAw-Comp.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>Определить направление для развития</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746922227-JkNVG-Spar.svg"
                                class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752928344322-nFfeU-Spar.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>Понять свои ценности, мотиваторы и желания</p>
                        </li>
                    </ul>
                </div>
                <div class="awake-couches-top-right careerum-flex-fsfs">
                    <div>
                        <div class="careerum-flex-fsfs">
                            <p class="awake-couches-top-right-header">3 800+</p>
                            <p class="awake-couches-top-right-label">Часов</p>
                        </div>
                        <p class="awake-couches-top-right-text">Проведенных сессий</p>
                    </div>
                    <div>
                        <div class="careerum-flex-fsfs">
                            <p class="awake-couches-top-right-header">9,5/10</p>
                            <p class="awake-couches-top-right-label">Баллов</p>
                        </div>
                        <p class="awake-couches-top-right-text">Средняя оценка экспертов</p>
                    </div>
                </div>
            </div>
            <div class="awake-couches-wrapper">
                <div class="awake-couches-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746617188-gBD3O-Fram.png"
                        class="hidden-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746742157-30J0a-Spea.png"
                        class="hidden-desc-tablet" alt="img">
                    <p class="awake-couches-item-name">Николай Пулин</p>
                    <p class="awake-couches-item-position">Эксперт по коммуникации</p>
                    <ul>
                        <li>6+ лет в HR, 2+ года в карьерном консyльтировании</li>
                        <li>200+ консyльтаций для специалистов РФ и Европы</li>
                        <li>Клиенты из IT, digital, ЕdTеch, промышленности, нефтегаза и дрyгих
                            отраслей</li>
                    </ul>
                </div>
                <div class="awake-couches-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746617685-3DDAU-Fram.png"
                        class="hidden-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746742544-LFRzV-Spea.png"
                        class="hidden-desc-tablet" alt="img">
                    <p class="awake-couches-item-name">Софи Бессон</p>
                    <p class="awake-couches-item-position">Карьерный эксперт, Израиль</p>
                    <ul>
                        <li>6+ в HR и карьерном консультировании</li>
                        <li>Помогла 700+ клиентам составить резюме и найти работу в Европе,
                            СШАи Канаде</li>
                        <li>Работала с сотрудниками Disney, Intel, Microsoft</li>
                    </ul>
                </div>
                <div class="awake-couches-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746618185-KErUh-Fram.png"
                        class="hidden-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746742868-gDdJB-Spea.png"
                        class="hidden-desc-tablet" alt="img">
                    <p class="awake-couches-item-name">Олеся Спиридонова</p>
                    <p class="awake-couches-item-position">Коуч практик ФПКиН, психолог-консультант,
                        Россия</p>
                    <ul>
                        <li>16+ лет в коучинге и инженерной отрасли</li>
                        <li>Помогла 100+ клиентам найти свой путь в жизни и карьере</li>
                        <li>Работала с сотрудниками компаний различных отраслей, включая IT,
                            финансы, маркетинг,
                            EdTech и др.</li>
                    </ul>
                </div>
                <div class="awake-couches-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746618898-9cdVR-Fram.png"
                        class="hidden-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746743241-y0qDT-Spea.png"
                        class="hidden-desc-tablet" alt="img">
                    <p class="awake-couches-item-name">Майя Бурякина</p>
                    <p class="awake-couches-item-position">Коуч ACC ICF, США/Россия</p>
                    <ul>
                        <li>10+ лет в подборе, адаптации и развитии персонала</li>
                        <li>Провела 150+ консультаций на тему поиска работы и построения карьеры
                        </li>
                        <li>Ex-руководитель HR-направления в международной FMCG-компании с 2 500+
                            сотрудников</li>
                    </ul>
                </div>
                <div class="awake-couches-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746620303-07ol9-Fram.png"
                        class="hidden-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746743649-FteMH-Spea.png"
                        class="hidden-desc-tablet" alt="img">
                    <p class="awake-couches-item-name">Мария Пудалова</p>
                    <p class="awake-couches-item-position">Карьерный эксперт, Германия</p>
                    <ul>
                        <li>7+ лет в PR и стратегии выстраивания бренда</li>
                        <li>Помогла 400+ клиентам улучшить CV и найти работу в Европе и США</li>
                        <li>Работала с сотрудниками Deloitte, BBDO, Microsoft</li>
                    </ul>
                </div>
                <div class="awake-couches-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746621620-UjHbY-Fram.png"
                        class="hidden-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746744022-xsYRn-Spea.png"
                        class="hidden-desc-tablet" alt="img">
                    <p class="awake-couches-item-name">Виктория Албаутова</p>
                    <p class="awake-couches-item-position">Коуч ICU, Турция</p>
                    <ul>
                        <li>8+ лет в коучинге и маркетинге</li>
                        <li>Помогла 150+ клиентам построить выигрышные стратегии и бренды</li>
                        <li>Работала с компаниями Beiesdorf, Philips, Johnson&Johnson, Novartis</li>
                    </ul>
                </div>
                <div class="awake-couches-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746622594-AF5DY-Fram.png"
                        class="hidden-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746744392-5ItSU-Spea.png"
                        class="hidden-desc-tablet" alt="img">
                    <p class="awake-couches-item-name">Елена Добринская</p>
                    <p class="awake-couches-item-position">PCC ICF, ОАЭ</p>
                    <ul>
                        <li>10+ лет в коучинге и финансах</li>
                        <li>Помогла 1700+ клиентам обрести уверенность и подготовиться
                            к собеседованиям</li>
                        <li>Работала с сотрудниками Sony, Ernst&Young, Deloitte</li>
                    </ul>
                </div>
                <div class="awake-couches-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746623197-MhXAb-Fram.png"
                        class="hidden-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746744774-Cn87H-Spea.png"
                        class="hidden-desc-tablet" alt="img">
                    <p class="awake-couches-item-name">Елена Эльзенбах</p>
                    <p class="awake-couches-item-position">Коуч ICF, Россия</p>
                    <ul>
                        <li>11+ лет опыта в коучинге, НКО и EdTech</li>
                        <li>Помогла 1300+ клиентам из РФ, Европы и СНГ получить оффер
                            через укрепление самооценки</li>
                        <li>Работала с сотрудниками Lamoda, Яндекс, Mail, InDriver</li>
                    </ul>
                </div>
                <div class="awake-couches-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746623778-a9zi8-Fram.png"
                        class="hidden-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746745261-j9iy9-Spea.png"
                        class="hidden-desc-tablet" alt="img">
                    <p class="awake-couches-item-name">Светлана Шуйская</p>
                    <p class="awake-couches-item-position">Коуч ICF, Россия</p>
                    <ul>
                        <li>18+ лет в коучинге и закупках</li>
                        <li>Помогла 300+ клиентам вырасти в доходе, составить стратегию, начать своё
                            дело</li>
                        <li>Работала с сотрудниками Metro Cash&Carry, Yandex, Avito</li>
                    </ul>
                </div>
                <div class="awake-couches-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746624422-3lHzi-Fram.png"
                        class="hidden-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746745795-FRwMU-Spea.png"
                        class="hidden-desc-tablet" alt="img">
                    <p class="awake-couches-item-name">Марина Веденичева</p>
                    <p class="awake-couches-item-position">Коуч PCC ICF, Великобритания</p>
                    <ul>
                        <li>18+ лет в HR и карьерном коучинге</li>
                        <li>Помогла 2000+ клиентам усилить лидерские качества и получить повышение
                        </li>
                        <li>Работала с сотрудниками Mars, Shell, Ernst & Young</li>
                    </ul>
                </div>
            </div>
            <div class="awake-couches-slider-nav careerum-flex-fec">
                <div class="awake-couches-nav-prev careerum-flex-cc ">
                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="awake-couches-nav-next careerum-flex-cc">
                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
            </div>
            <a href="#buy" class="btn-color-main-bright-orange">Записаться в лист ожидания</a>
        </div>
    </div>`
    });
    
    blockManager.add('club50-couches2', {
        label: 'Club 50 couches 2 (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-awake-couches careerum-club50-couches main-wrapper club50-couches2">
                <div class="careerum-container-responsive">
                    <div class="global-couches-top careerum-flex-sbst">
                        <div class="global-couches-top-left position-relative">
                            <div class="global-couches-top-left-content position-relative z-10">
                                <img src="https://cdn.careerum.com/1787202826919-XZ2yC-Fram.png" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1787206136629-NFZSZ-Fram.png" class="hidden-desc-mobile" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1787221536736-BE93b-Fram.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                                <p class="global-couches-header">
                                    С вами будет работать команда <span>карьерных экспертов</span>
                                </p>
                            </div>
                            <img src="https://cdn.careerum.com/1787203228967-5LBBC-Chat.png"
                                class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1787206155886-0gXQq-Chat.png" class="hidden-desc-mobile position-absolute z-1" alt="img"
                                loading="lazy">
                            <img src="https://cdn.careerum.com/1787222251420-bxt1D-Chat.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                                loading="lazy">
                        </div>
                        <div class="global-couches-top-right">
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1787203633051-ipv5a-Chec.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1787222282196-vetlS-Chec.svg" class="hidden-desc-tablet" alt="img" loading="lazy">
                                    <p>Знают, что реально работает, а что — нет. <span>4500+ проведенных сессий</span></p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1787203633078-zRsPF-Eye..svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1787222282226-TP6nO-Eye..svg" class="hidden-desc-tablet" alt="img" loading="lazy">
                                    <p>Видят сотни кейсов переходов, увольнений и офферов </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1787203632995-1CYqQ-Chat.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1787222282154-xWRY9-Chat.svg" class="hidden-desc-tablet" alt="img" loading="lazy">
                                    <p>Могут сказать правду, даже если она неудобная</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1787203633110-ALWao-Gear.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1787222282263-qBEGe-Gear.svg" class="hidden-desc-tablet" alt="img" loading="lazy">
                                    <p>Понимают рынок изнутри</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="club0526-couches-top position-relative">
                        <div class="position-relative z-10">
                            <img src="https://cdn.careerum.com/1780391841805-4wstC-Fram.png" class="hidden-mobile" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780393781815-CvvZ1-Fram.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                            <h2>С вами будет работать команда карьерных экспертов</h2>
                        </div>
                        <img src="https://cdn.careerum.com/1780391841676-Mlygk-Vect.svg" class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1780393427001-5IjGP-Vect.svg" class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1780393445464-4DarR-Vect.svg" class="hidden-desc-tablet position-absolute z-1" alt="img" loading="lazy">
                    </div>
                    <div class="club0526-couches-bottom">
                        <ul class="careerum-flex-sbfs">
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1780392344972-5H0Pn-Chec.svg" class="hidden-mobile" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1780393930766-1U38L-Chec.svg" class="hidden-desc-tablet" alt="img" loading="lazy">
                                <p>Знают, что реально работает, а что — нет. 4500+ проведенных сессий</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1780392345000-jMVkD-Eye..svg" class="hidden-mobile" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1780393930801-raPI6-Eye..svg" class="hidden-desc-tablet" alt="img" loading="lazy">
                                <p>Видят сотни кейсов переходов, увольнений и офферов </p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1780392344898-uZu3P-Chat.svg" class="hidden-mobile" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1780393930643-E4jay-Chat.svg" class="hidden-desc-tablet" alt="img" loading="lazy">
                                <p>Могут сказать правду, даже если она неудобная</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1780392345024-Gv3jN-Gear.svg" class="hidden-mobile" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1780393930832-OlLq4-Gear.svg" class="hidden-desc-tablet" alt="img" loading="lazy">
                                <p>Понимают рынок изнутри</p>
                            </li>
                        </ul>
                    </div>
                    <div class="ai042026-couches-header">
                        <h2>На сессиях с карьерными экспертами:</h2>
                        <p>Упакуете новый навык AI в ваш профессиональный профиль</p>
                    </div>
                    <div class="ai042026-couches-list careerum-flex-sbst">
                        <div class="ai042026-couches-list-item careerum-flex-fsfs">
                            <img src="https://cdn.careerum.com/1776868869787-uUxXu-Vect.svg" class="hidden-tablet-mobile"
                                alt="img" loading="eager">
                            <img src="https://cdn.careerum.com/1776868899187-tEAJ4-Vect.svg" class="hidden-desc" alt="img"
                                loading="eager">
                            <p class="bold">Разберёте, как превратить навык AI в рост дохода, влияния и усиления позиции
                                в текущей компании</p>
                        </div>
                        <div class="ai042026-couches-list-item careerum-flex-fsfs">
                            <img src="https://cdn.careerum.com/1776868869787-uUxXu-Vect.svg" class="hidden-tablet-mobile"
                                alt="img" loading="eager">
                            <img src="https://cdn.careerum.com/1776868899187-tEAJ4-Vect.svg" class="hidden-desc" alt="img"
                                loading="eager">
                            <p>Упакуете новый навык в резюме, LinkedIn и самопрезентацию</p>
                        </div>
                        <div class="ai042026-couches-list-item careerum-flex-fsfs">
                            <img src="https://cdn.careerum.com/1776868869787-uUxXu-Vect.svg" class="hidden-tablet-mobile"
                                alt="img" loading="eager">
                            <img src="https://cdn.careerum.com/1776868899187-tEAJ4-Vect.svg" class="hidden-desc" alt="img"
                                loading="eager">
                            <p>Определите, какие карьерные возможности открывает навык AI вам на рынке и составите пошаговый
                                план реализации</p>
                        </div>
                        <div class="ai042026-couches-list-item careerum-flex-fsfs">
                            <img src="https://cdn.careerum.com/1776868869787-uUxXu-Vect.svg" class="hidden-tablet-mobile"
                                alt="img" loading="eager">
                            <img src="https://cdn.careerum.com/1776868899187-tEAJ4-Vect.svg" class="hidden-desc" alt="img"
                                loading="eager">
                            <p>Получите 2–3 карьерные гипотезы и план реализации приоритетной</p>
                        </div>
                    </div>
                    <p class="club0326-main-text">Рынки, с которыми мы работаем:</p>
                    <div class="careerum-flex-fsc club0326-main-regions">
                        <p>РФ</p>
                        <p>СНГ</p>
                        <p>ЕС</p>
                        <p>DACH</p>
                        <p>США</p>
                        <p>ОАЭ</p>
                        <p>JАРАС</p>
                        <p>MENA</p>
                        <p>LATAM</p>
                        <p>UK&I</p>
                        <p>BALTICS</p>
                    </div>
                    <h2 id="idctd6i">Поддержка карьерных стратегов</h2>
                    <div class="awake-couches-banner position-relative hidden">
                        <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755711692282-ZANNa-Grou.svg"
                            alt="img" class="hidden-tablet-mobile position-absolute">
                        <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755786852606-KOk7s-Grou.svg"
                            alt="img" class="hidden-desc-mobile position-absolute">
                        <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755794882046-1LmBB-Grou.svg"
                            alt="img" class="hidden-desc-tablet position-absolute">
                        <p class="awake-couches-banner-text">На&nbsp;тарифе </p>
                        <p class="awake-couches-banner-header">«Индивидуальное сопровождение»
                        </p>
                    </div>
                    <div class="club0326-couches-top">
                        <ul class="careerum-flex-sbfs">
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1773304635539-j244w-Chec.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1773313701481-96TA2-Chec.svg" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1773304639172-SMfLj-Chec.svg" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                                <p>Работаем строго по методологии</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1773304635539-j244w-Chec.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1773313701481-96TA2-Chec.svg" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1773304639172-SMfLj-Chec.svg" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                                <p>4500+ проведенных сессий</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1773304635539-j244w-Chec.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1773313701481-96TA2-Chec.svg" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1773304639172-SMfLj-Chec.svg" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                                <p>9.7 средняя оценка экспертов Careerum</p>
                            </li>
                        </ul>
                    </div>
                    <div class="awake-couches-top careerum-flex-sbst">
                        <div class="awake-couches-top-left">
                            <p class="awake-couches-top-left-header">Эксперты помогут:</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755802120132-Sai1q-Chec.svg"
                                        alt="img" class="hidden-mobile">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755805724844-SN27e-Chec.svg"
                                        alt="img" class="hidden-desc-tablet">
                                    <p>Составить резюме </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755802120132-Sai1q-Chec.svg"
                                        alt="img" class="hidden-mobile">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755805724844-SN27e-Chec.svg"
                                        alt="img" class="hidden-desc-tablet">
                                    <p>Потренировать собеседование</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755802120132-Sai1q-Chec.svg"
                                        alt="img" class="hidden-mobile">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755805724844-SN27e-Chec.svg"
                                        alt="img" class="hidden-desc-tablet">
                                    <p>Поставить карьерную цель</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755802120132-Sai1q-Chec.svg"
                                        alt="img" class="hidden-mobile">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755805724844-SN27e-Chec.svg"
                                        alt="img" class="hidden-desc-tablet">
                                    <p>Подготовиться к&nbsp;переговорам по&nbsp;офферу</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755802120132-Sai1q-Chec.svg"
                                        alt="img" class="hidden-mobile">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755805724844-SN27e-Chec.svg"
                                        alt="img" class="hidden-desc-tablet">
                                    <p>Определить направление для&nbsp;развития</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755802120132-Sai1q-Chec.svg"
                                        alt="img" class="hidden-mobile">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755805724844-SN27e-Chec.svg"
                                        alt="img" class="hidden-desc-tablet">
                                    <p>Понять свои ценности, мотиваторы и&nbsp;желания</p>
                                </li>
                            </ul>
                        </div>
                        <div class="awake-couches-top-right careerum-flex-fsfs">
                            <p id="iiri7xv" class="awake-couches-top-right-text">Эксперты
                                Careerum работают со всеми <span draggable="true" data-highlightable="1">индустриями, рынками и
                                    странами:</span></p>
                            <img loading=""
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755802292816-QByMD-Grou.svg" alt="img"
                                id="i9xk1z8" class="hidden-tablet-mobile">
                            <img loading=""
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755804928257-pHmRm-Grou.svg" alt="img"
                                id="i3c89xn" class="hidden-desc-mobile">
                            <img loading=""
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755802292816-QByMD-Grou.svg" alt="img"
                                id="if0frgb" class="hidden-desc-tablet">
                        </div>
                    </div>
                    <div class="awake-couches-top2 careerum-flex-sbst">
                        <div class="awake-couches-top2-left">
                            <div>
                                <img src="https://cdn.careerum.com/1770871155902-wWdUr-Gene.png" class="hidden-tablet-mobile" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770871199271-6u0Tt-Gene.png" class="hidden-desc-mobile" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770871241548-kdo9e-Gene.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                                <p>Сертифицированные карьерные эксперты и коучи</p>
                            </div>
                            <div>
                                <img src="https://cdn.careerum.com/1770871155979-GwSbc-Gene.png" class="hidden-tablet-mobile" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770871201370-a38mK-Gene.png" class="hidden-desc-mobile" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770871241481-MOVDm-Gene.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                                <p>Глубокая структурная работа с экспертами на личных консультациях и в группах</p>
                            </div>
                        </div>
                        <div class="awake-couches-top2-right careerum-flex-fsfs">
                            <p class="awake-couches-top-right-text">
                                Опыт работы <span>на рынках:</span>
                            </p>
                            <img loading="" src="https://cdn.careerum.com/1770870979307-n3Ez0-Grou.svg" alt="img"
                                class="hidden-tablet-mobile" />
                            <img loading="" src="https://cdn.careerum.com/1770872284311-zDPbl-Grou.svg" alt="img"
                                class="hidden-desc-mobile" />
                            <img loading="" src="https://cdn.careerum.com/1770870984018-SniR0-Grou.svg" alt="img"
                                class="hidden-desc-tablet" />
                        </div>
                    </div>
                    <div class="awake-couches-wrapper">
                                <div class="awake-couches-item">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746617188-gBD3O-Fram.png"
                                        alt="img" class="hidden-mobile">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746742157-30J0a-Spea.png"
                                        alt="img" class="hidden-desc-tablet">
                                    <p class="awake-couches-item-name">Николай Пулин</p>
                                    <p class="awake-couches-item-position">Карьерный эксперт,
                                        Германия</p>
                                    <ul>
                                        <li>6+ лет&nbsp;в&nbsp;HR, 2+ года в&nbsp;карьерном
                                            консyльтировании</li>
                                        <li>200+ консyльтаций для&nbsp;специалистов
                                            РФ&nbsp;и&nbsp;Европы</li>
                                        <li id="iyshvuf">Клиенты из IT, digital, ЕdTеch,
                                            нефтегаза промышленности&nbsp;</li>
                                    </ul>
                                </div>
                                <div class="awake-couches-item ">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746618185-KErUh-Fram.png"
                                        alt="img" class="hidden-mobile">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746742868-gDdJB-Spea.png"
                                        alt="img" class="hidden-desc-tablet">
                                    <p class="awake-couches-item-name">Олеся Спиридонова</p>
                                    <p class="awake-couches-item-position">Коуч практик ФПКиН,
                                        психолог-консультант,
                                        Россия</p>
                                    <ul>
                                        <li>16+ лет&nbsp;в&nbsp;коучинге и&nbsp;инженерной
                                            отрасли</li>
                                        <li>Помогла 100+ клиентам найти свой путь в&nbsp;жизни
                                            и&nbsp;карьере</li>
                                        <li id="i8on0vn">Клиенты из IT, финансы, маркетинг,
                                            EdTech и др.</li>
                                    </ul>
                                </div>
                                <div class="awake-couches-item">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762174337640-4VWN2-Fram.png"
                                        alt="img" class="hidden-mobile">
                                    <img loading=""
                                        src="https://storage.yandexcloud.net/cdn.careerum.com/1767602476170-KOox5-1762.png"
                                        alt="img" class="hidden-desc-tablet">
                                    <p class="awake-couches-item-name">Дарья Абхинав</p>
                                    <p class="awake-couches-item-position">Карьерный
                                        консультант и коуч ICF, Польша</p>
                                    <ul>
                                        <li id="ist5ezk">13 лет опыта в подборе персонала
                                            внутри Huawei, Metro Cash and Carry и во внешнем консалтинге для многих международных
                                            и&nbsp;российских корпораций и Tech стартапов</li>
                                        <li id="im4t0rx">8 лет практики карьерного
                                            консультирования для клиентов по всему миру
                                        </li>
                                        <li id="ieq522b">Член Ассоциации Карьерных
                                            Консультантов. Спикер по теме карьеры для студентов МГИМО и&nbsp;МГУ</li>
                                    </ul>
                                </div>
                                <div class="awake-couches-item">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746618898-9cdVR-Fram.png"
                                        alt="img" class="hidden-mobile">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746743241-y0qDT-Spea.png"
                                        alt="img" class="hidden-desc-tablet">
                                    <p class="awake-couches-item-name">Майя Бурякина</p>
                                    <p class="awake-couches-item-position">Коуч ACC ICF,
                                        США/Россия</p>
                                    <ul>
                                        <li>10+ лет&nbsp;в&nbsp;подборе, адаптации
                                            и&nbsp;развитии персонала</li>
                                        <li id="ir7zcvl">370 часов индивидуальной работы с
                                            клиентами
                                        </li>
                                        <li id="i0yx4fm">Ex-руководитель HR-направления
                                            в&nbsp;международной FMCG-компании с&nbsp;2&nbsp;500+
                                            сотрудников</li>
                                    </ul>
                                </div>
                                <div class="awake-couches-item">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746622594-AF5DY-Fram.png"
                                        alt="img" class="hidden-mobile">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746744392-5ItSU-Spea.png"
                                        alt="img" class="hidden-desc-tablet">
                                    <p class="awake-couches-item-name">Елена Добринская</p>
                                    <p class="awake-couches-item-position">Коуч PCC ICF, ОАЭ
                                    </p>
                                    <ul>
                                        <li>10+ лет&nbsp;в&nbsp;коучинге и&nbsp;финансах</li>
                                        <li>Помогла 1700+ клиентам обрести уверенность
                                            и&nbsp;подготовиться
                                            к&nbsp;собеседованиям</li>
                                        <li id="iue3qen">Клиенты из Sony, Ernst&amp;Young,
                                            Deloitte</li>
                                    </ul>
                                </div>
                                <div class="awake-couches-item">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746621620-UjHbY-Fram.png"
                                        alt="img" class="hidden-mobile">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746744022-xsYRn-Spea.png"
                                        alt="img" class="hidden-desc-tablet">
                                    <p class="awake-couches-item-name">Виктория Албаутова</p>
                                    <p class="awake-couches-item-position">Коуч ICU, Турция
                                    </p>
                                    <ul>
                                        <li>8+ лет&nbsp;в&nbsp;коучинге и&nbsp;маркетинге</li>
                                        <li>Помогла 150+ клиентам построить выигрышные
                                            стратегии и&nbsp;бренды</li>
                                        <li id="irmpz53">Клиенты из Beiesdorf, Philips,
                                            Johnson&amp;Johnson, Novartis</li>
                                    </ul>
                                </div>
                                <div id="i0t3y5h" class="awake-couches-item">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746620303-07ol9-Fram.png"
                                        alt="img" class="hidden-mobile">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746743649-FteMH-Spea.png"
                                        alt="img" class="hidden-desc-tablet">
                                    <p class="awake-couches-item-name">Мария Пудалова</p>
                                    <p class="awake-couches-item-position">Карьерный эксперт,
                                        Германия</p>
                                    <ul>
                                        <li>7+ лет&nbsp;в&nbsp;PR и&nbsp;стратегии
                                            выстраивания бренда</li>
                                        <li>Помогла 400+ клиентам улучшить CV и&nbsp;найти
                                            работу в&nbsp;Европе и&nbsp;США</li>
                                        <li id="ifup5wc">Клиенты из Deloitte, BBDO, Microsoft
                                        </li>
                                    </ul>
                                </div>
                                <div class="awake-couches-item">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746623197-MhXAb-Fram.png"
                                        alt="img" class="hidden-mobile">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746744774-Cn87H-Spea.png"
                                        alt="img" class="hidden-desc-tablet">
                                    <p class="awake-couches-item-name">Елена Эльзенбах</p>
                                    <p class="awake-couches-item-position">Коуч ICF, Россия
                                    </p>
                                    <ul>
                                        <li>11+ лет&nbsp;опыта в&nbsp;коучинге,
                                            НКО&nbsp;и&nbsp;EdTech</li>
                                        <li>Помогла 1300+ клиентам из&nbsp;РФ, Европы
                                            и&nbsp;СНГ&nbsp;получить оффер
                                            через&nbsp;укрепление самооценки</li>
                                        <li id="in4fnke">Клиенты из Lamoda, Яндекс, Mail,
                                            InDriver</li>
                                    </ul>
                                </div>
                                <div class="awake-couches-item">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746623778-a9zi8-Fram.png"
                                        alt="img" class="hidden-mobile">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746745261-j9iy9-Spea.png"
                                        alt="img" class="hidden-desc-tablet">
                                    <p class="awake-couches-item-name">Светлана Шуйская</p>
                                    <p class="awake-couches-item-position">Коуч ICF, Россия
                                    </p>
                                    <ul>
                                        <li>18+ лет&nbsp;в&nbsp;коучинге и&nbsp;закупках</li>
                                        <li>Помогла 300+ клиентам вырасти в&nbsp;доходе,
                                            составить стратегию, начать своё
                                            дело</li>
                                        <li id="ih4k41h">Клиенты из Metro Cash&amp;Carry,
                                            Yandex, Avito</li>
                                    </ul>
                                </div>
                                <div class="awake-couches-item">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753948745412-Cjzwx-Spea.png"
                                        alt="img" class="hidden-mobile">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753948745412-Cjzwx-Spea.png"
                                        alt="img" class="hidden-desc-tablet">
                                    <p class="awake-couches-item-name">Надежда Община</p>
                                    <p class="awake-couches-item-position">Карьерный эксперт,
                                        Португалия</p>
                                    <ul>
                                        <li id="imx5ppg">9+ лет в маркетинге
                                            и&nbsp;консультировании</li>
                                        <li id="ifdau7b">Помогла 550+ клиентам из&nbsp;США,
                                            Европы и СНГ найти работу и сменить карьеру</li>
                                        <li id="iszc66g">Клиенты из Airbus, Hubspot, Google,
                                            Farfetch</li>
                                    </ul>
                                </div>
                                <div class="awake-couches-item">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746624422-3lHzi-Fram.png"
                                        alt="img" class="hidden-mobile">

                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746745795-FRwMU-Spea.png"
                                        alt="img" class="hidden-desc-tablet">
                                    <p class="awake-couches-item-name">Марина Веденичева</p>
                                    <p class="awake-couches-item-position">Коуч PCC ICF,
                                        Великобритания</p>
                                    <ul>
                                        <li>18+ лет&nbsp;в&nbsp;HR и&nbsp;карьерном коучинге
                                        </li>
                                        <li>Помогла 2000+ клиентам усилить лидерские качества
                                            и&nbsp;получить повышение
                                        </li>
                                        <li id="i35vgag">Клиенты из Mars, Shell, Ernst &amp;
                                            Young</li>
                                    </ul>
                                </div>
                    </div>
                    <div class="awake-couches-slider-nav careerum-flex-fec">
                        <div class="awake-couches-nav-prev careerum-flex-cc">
                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </div>
                        <div class="awake-couches-nav-next careerum-flex-cc">
                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </div>
                    </div><a onclick="" href="#buy" class="btn-color-main-bright-orange hidden">Записаться в лист ожидания</a>
                </div>
                <div class="careerum-container-responsive">
                    <h2 id="idctd6i" class="hidden">С вами будет работать команда
                        карьерных стратегов</h2>
                    <div class="club0526-couches-top position-relative">
                        <div class="position-relative z-10 wide">
                            <img loading="lazy" src="https://cdn.careerum.com/1780391841805-4wstC-Fram.png" alt="img"
                                class="hidden-mobile" />
                            <img loading="lazy" src="https://cdn.careerum.com/1780393781815-CvvZ1-Fram.png" alt="img"
                                class="hidden-desc-tablet" />
                            <h2 id="i5uptd7">Наши карьерные эксперты помогут вам в достижении карьерных целей</h2>
                        </div>
                        <img loading="lazy" src="https://cdn.careerum.com/1780391841676-Mlygk-Vect.svg" alt="img"
                            class="hidden-tablet-mobile position-absolute z-1" />
                        <img loading="lazy" src="https://cdn.careerum.com/1780393427001-5IjGP-Vect.svg" alt="img"
                            class="hidden-desc-mobile position-absolute z-1" />
                        <img loading="lazy" src="https://cdn.careerum.com/1780393445464-4DarR-Vect.svg" alt="img"
                            class="hidden-desc-tablet position-absolute z-1" />
                    </div>
                    <div class="club0526-couches-bottom">
                        <ul class="careerum-flex-sbfs">
                            <li class="careerum-flex-fsfs">
                                <img loading="lazy" src="https://cdn.careerum.com/1780392344972-5H0Pn-Chec.svg" alt="img"
                                    class="hidden-mobile" />
                                <img loading="lazy" src="https://cdn.careerum.com/1780393930766-1U38L-Chec.svg" alt="img"
                                    class="hidden-desc-tablet" />
                                <p>Знают, что реально работает, а что — нет. 4500+
                                    проведенных сессий</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img loading="lazy" src="https://cdn.careerum.com/1780392345000-jMVkD-Eye..svg" alt="img"
                                    class="hidden-mobile" />
                                <img loading="lazy" src="https://cdn.careerum.com/1780393930801-raPI6-Eye..svg" alt="img"
                                    class="hidden-desc-tablet" />
                                <p>Видят сотни кейсов переходов, увольнений и офферов </p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img loading="lazy" src="https://cdn.careerum.com/1780392344898-uZu3P-Chat.svg" alt="img"
                                    class="hidden-mobile" />
                                <img loading="lazy" src="https://cdn.careerum.com/1780393930643-E4jay-Chat.svg" alt="img"
                                    class="hidden-desc-tablet" />
                                <p>Могут сказать правду, даже если она неудобная</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img loading="lazy" src="https://cdn.careerum.com/1780392345024-Gv3jN-Gear.svg" alt="img"
                                    class="hidden-mobile" />
                                <img loading="lazy" src="https://cdn.careerum.com/1780393930832-OlLq4-Gear.svg" alt="img"
                                    class="hidden-desc-tablet" />
                                <p>Понимают рынок изнутри</p>
                            </li>
                        </ul>
                    </div>
                    <p class="club0326-main-text">Рынки, с которыми мы работаем:</p>
                    <div class="careerum-flex-fsc club0326-main-regions">
                        <p>РФ</p>
                        <p>СНГ</p>
                        <p>ЕС</p>
                        <p>DACH</p>
                        <p>США</p>
                        <p>ОАЭ</p>
                        <p>JАРАС</p>
                        <p>MENA</p>
                        <p>LATAM</p>
                        <p>UK &amp;I</p>
                        <p>BALTICS</p>
                    </div>
                    <div class="awake-couches-banner position-relative hidden">
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755711692282-ZANNa-Grou.svg" alt="img"
                            class="hidden-tablet-mobile position-absolute" />
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755786852606-KOk7s-Grou.svg" alt="img"
                            class="hidden-desc-mobile position-absolute" />
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755794882046-1LmBB-Grou.svg" alt="img"
                            class="hidden-desc-tablet position-absolute" />
                        <p class="awake-couches-banner-text">На тарифе </p>
                        <p class="awake-couches-banner-header">«Индивидуальное
                            сопровождение»</p>
                    </div>
                    <div class="club0326-couches-top hidden">
                        <ul class="careerum-flex-sbfs">
                            <li class="careerum-flex-fsfs">
                                <img loading="lazy" src="https://cdn.careerum.com/1773304635539-j244w-Chec.svg" alt="img"
                                    class="hidden-tablet-mobile" />
                                <img loading="lazy" src="https://cdn.careerum.com/1773313701481-96TA2-Chec.svg" alt="img"
                                    class="hidden-desc-mobile" />
                                <img loading="lazy" src="https://cdn.careerum.com/1773304639172-SMfLj-Chec.svg" alt="img"
                                    class="hidden-desc-tablet" />
                                <p>Работаем строго по методологии</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img loading="lazy" src="https://cdn.careerum.com/1773304635539-j244w-Chec.svg" alt="img"
                                    class="hidden-tablet-mobile" />
                                <img loading="lazy" src="https://cdn.careerum.com/1773313701481-96TA2-Chec.svg" alt="img"
                                    class="hidden-desc-mobile" />
                                <img loading="lazy" src="https://cdn.careerum.com/1773304639172-SMfLj-Chec.svg" alt="img"
                                    class="hidden-desc-tablet" />
                                <p>4500+ проведенных сессий</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img loading="lazy" src="https://cdn.careerum.com/1773304635539-j244w-Chec.svg" alt="img"
                                    class="hidden-tablet-mobile" />
                                <img loading="lazy" src="https://cdn.careerum.com/1773313701481-96TA2-Chec.svg" alt="img"
                                    class="hidden-desc-mobile" />
                                <img loading="lazy" src="https://cdn.careerum.com/1773304639172-SMfLj-Chec.svg" alt="img"
                                    class="hidden-desc-tablet" />
                                <p>9.7 средняя оценка экспертов Careerum</p>
                            </li>
                        </ul>
                    </div>
                    <div class="awake-couches-wrapper">
                        <div class="awake-couches-item wide">
                            <img loading=""
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746617188-gBD3O-Fram.png"
                                alt="img" class="hidden-mobile" />
                            <img loading=""
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746742157-30J0a-Spea.png"
                                alt="img" class="hidden-desc-tablet" />
                            <p class="awake-couches-item-name">Николай Пулин</p>
                            <p class="awake-couches-item-position">Карьерный эксперт,
                                Германия</p>
                            <ul>
                                <li id="i6kglu2">6+ лет в HR, 3+ года в карьерном
                                    консyльтировании</li>
                                <li id="i3zd5yz">400+ консyльтаций для специалистов РФ и
                                    международного рынка</li>
                                <li id="iyshvuf">Клиенты из Apple, Amazon, Microsoft,
                                    Miro, Mars, Яндекс, Авито, Сбер и другие крупные бренды </li>
                            </ul>
                        </div>
                        <div class="awake-couches-item wide">
                            <img loading=""
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746618185-KErUh-Fram.png"
                                alt="img" class="hidden-mobile" />
                            <img loading=""
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746742868-gDdJB-Spea.png"
                                alt="img" class="hidden-desc-tablet" />
                            <p class="awake-couches-item-name">Олеся Спиридонова</p>
                            <p class="awake-couches-item-position">Коуч практик ФПКиН,
                                психолог-консультант,
                                Россия</p>
                            <ul>
                                <li>16+ лет в коучинге и инженерной отрасли</li>
                                <li id="if5e79l">Провела 400+ консультаций на тему
                                    карьерного развития. Соавтор и разработчик профессиональных стандартов.</li>
                                <li id="i8on0vn">Клиенты из IT, финансы, маркетинг, EdTech
                                    и др.</li>
                            </ul>
                        </div>
                        <div class="awake-couches-item wide">
                            <img loading=""
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746618898-9cdVR-Fram.png"
                                alt="img" class="hidden-mobile" />
                            <img loading=""
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746743241-y0qDT-Spea.png"
                                alt="img" class="hidden-desc-tablet" />
                            <p class="awake-couches-item-name">Майя Бурякина</p>
                            <p class="awake-couches-item-position">Коуч ACC ICF,
                                США/Россия</p>
                            <ul>
                                <li id="izwryxb">11+ лет в подборе, адаптации и развитии
                                    персонала</li>
                                <li id="ir7zcvl">400+ часов индивидуальной работы с
                                    клиентами
                                </li>
                                <li id="i0yx4fm">Ex-руководитель HR-направления
                                    в международной FMCG-компании с 2500+
                                    сотрудников</li>
                            </ul>
                        </div>
                        <div class="awake-couches-item wide">
                            <img loading=""
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746621620-UjHbY-Fram.png"
                                alt="img" class="hidden-mobile" />
                            <img loading=""
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746744022-xsYRn-Spea.png"
                                alt="img" class="hidden-desc-tablet" />
                            <p class="awake-couches-item-name">Виктория Албаутова</p>
                            <p class="awake-couches-item-position">Коуч ICU, Турция</p>
                            <ul>
                                <li id="iyezn2g">18+ лет в коучинге и маркетинге</li>
                                <li id="ixdolwv">Помогла 500+ клиентам построить
                                    выигрышные стратегии и бренды</li>
                                <li id="irmpz53">Клиенты из P &amp;G, PepsiCo, Philips,
                                    Johnson &amp;Johnson, Novartis</li>
                            </ul>
                        </div>
                        <div class="awake-couches-item wide">
                            <img loading=""
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746622594-AF5DY-Fram.png"
                                alt="img" class="hidden-mobile" />
                            <img loading=""
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746744392-5ItSU-Spea.png"
                                alt="img" class="hidden-desc-tablet" />
                            <p class="awake-couches-item-name">Елена Добринская</p>
                            <p class="awake-couches-item-position">Коуч PCC ICF, ОАЭ</p>
                            <ul id="ivixklf">
                                <li id="imug8dl">7+ лет в финансах (Deloitte, TELE2) и 4+
                                    года в карьерном коучинге</li>
                                <li id="icn51i1">Помогла 1700+ клиентам достичь своих
                                    личных и карьерных целей</li>
                                <li id="iue3qen">Клиенты из Ernst &amp;Young, Deloitte,
                                    Sony, Gazpromneft</li>
                            </ul>
                        </div>
                        <div class="awake-couches-item wide">
                            <img loading=""
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746623197-MhXAb-Fram.png"
                                alt="img" class="hidden-mobile" />
                            <img loading=""
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746744774-Cn87H-Spea.png"
                                alt="img" class="hidden-desc-tablet" />
                            <p class="awake-couches-item-name">Елена Эльзенбах</p>
                            <p class="awake-couches-item-position">Коуч ICF, Вьетнам</p>
                            <ul>
                                <li id="iw63pa5">13+ лет опыта в коучинге, НКО и EdTech
                                </li>
                                <li id="i21e5jf">750+ часов личной и групповой работы с
                                    клиентами</li>
                                <li id="in4fnke">Клиенты из Тинькофф, Яндекс, VK, Mail,
                                    Lamoda, РЖД, Альфа банк, Сбер, Мегафон</li>
                            </ul>
                        </div>
                        <div class="awake-couches-item wide">
                            <img loading=""
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746623778-a9zi8-Fram.png"
                                alt="img" class="hidden-mobile" />
                            <img loading=""
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746745261-j9iy9-Spea.png"
                                alt="img" class="hidden-desc-tablet" />
                            <p class="awake-couches-item-name">Светлана Шуйская</p>
                            <p class="awake-couches-item-position">Коуч ICF, психолог
                                направления КПТ, Россия</p>
                            <ul>
                                <li>18+ лет в коучинге и закупках</li>
                                <li id="icquwhd">Помогла 500+ клиентам выстроить
                                    стратегию, вырасти в доходе, перейти на новый уровень профессиональной и личностной
                                    реализации</li>
                                <li id="ih4k41h">Клиенты из Google, Yandex, Сбер, Toyota,
                                    METRO, Cash &amp;Carry, Mars</li>
                            </ul>
                        </div>
                        <div class="awake-couches-item wide">
                            <img loading=""
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746624422-3lHzi-Fram.png"
                                alt="img" class="hidden-mobile" />
                            <img loading=""
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746745795-FRwMU-Spea.png"
                                alt="img" class="hidden-desc-tablet" />
                            <p class="awake-couches-item-name">Марина Веденичева</p>
                            <p class="awake-couches-item-position">Коуч PCC ICF,
                                Великобритания</p>
                            <ul>
                                <li>18+ лет в HR и карьерном коучинге</li>
                                <li id="i1go35b">Помогла 2000+ клиентам усилить лидерские
                                    качества и получить повышение
                                </li>
                                <li id="i35vgag">Клиенты из Mars, Shell, Ernst &amp; Young
                                </li>
                            </ul>
                        </div>
                        <div class="awake-couches-item wide">
                            <img loading="" src="https://storage.yandexcloud.net/cdn.careerum.com/1775729352680-E3Uuh-Fram.png"
                                alt="img" class="hidden-mobile" />
                            <img loading="" src="https://storage.yandexcloud.net/cdn.careerum.com/1775729352680-E3Uuh-Fram.png"
                                alt="img" class="hidden-desc-tablet" />
                            <p class="awake-couches-item-name">Дарья Абхинав</p>
                            <p class="awake-couches-item-position">Карьерный консультант и
                                коуч ICF, Польша</p>
                            <ul>
                                <li id="iwx2mmg">13 лет опыта в подборе персонала, во
                                    внешнем консалтинге для международных и российских корпораций</li>
                                <li id="ipm657j">8 лет практики карьерного
                                    консультирования для клиентов по всему миру
                                </li>
                                <li id="i1ae0jf">Клиенты из Huawei, Metro Cash and Carry
                                </li>
                            </ul>
                        </div>
                        <div class="awake-couches-item wide">
                            <img loading="" src="https://storage.yandexcloud.net/cdn.careerum.com/1775729352633-lLVyF-Fram.png"
                                alt="img" class="hidden-mobile" />
                            <img loading="" src="https://storage.yandexcloud.net/cdn.careerum.com/1775729352633-lLVyF-Fram.png"
                                alt="img" class="hidden-desc-tablet" />
                            <p class="awake-couches-item-name">Надежда Община</p>
                            <p class="awake-couches-item-position">Карьерный эксперт,
                                Португалия</p>
                            <ul>
                                <li id="id1tplj">9+ лет в маркетинге и консультировании
                                </li>
                                <li id="isarap2">Помогла 550+ клиентам из США, Европы и
                                    СНГ найти работу и сменить карьеру
                                </li>
                                <li id="igt66lh">
                                    Работала с<div>сотрудниками Airbus, Hubspot, Google,
                                        Farfetch</div>
                                </li>
                            </ul>
                        </div>
                        <div class="awake-couches-item wide">
                            <img loading="" src="https://storage.yandexcloud.net/cdn.careerum.com/1775729352581-8SA1V-Fram.png"
                                alt="img" class="hidden-mobile" />
                            <img loading="" src="https://storage.yandexcloud.net/cdn.careerum.com/1775729352581-8SA1V-Fram.png"
                                alt="img" class="hidden-desc-tablet" />
                            <p class="awake-couches-item-name">Ольга Пешкова</p>
                            <p class="awake-couches-item-position">Карьерный консультант,
                                Болгария</p>
                            <ul>
                                <li id="ivxp8fu">
                                    8+ лет опыта в рекрутменте <br />(in-house и
                                    агентство)
                                </li>
                                <li id="ip9zo7c">Действующий рекрутер
                                </li>
                                <li id="i3r6w4i">Спикер о карьере в Европе на разных
                                    площадках</li>
                            </ul>
                        </div>
                        <div class="awake-couches-item wide">
                            <img loading="" src="https://storage.yandexcloud.net/cdn.careerum.com/1775729352439-poHZE-Fram.png"
                                alt="img" class="hidden-mobile" />
                            <img loading="" src="https://storage.yandexcloud.net/cdn.careerum.com/1775729352439-poHZE-Fram.png"
                                alt="img" class="hidden-desc-tablet" />
                            <p class="awake-couches-item-name">Ксения Колганова</p>
                            <p class="awake-couches-item-position">Карьерный консультант,
                                Болгария</p>
                            <ul>
                                <li id="i2isizv">20+ лет опыта в HR и рекрутменте</li>
                                <li id="i117x93">Многолетний опыт закрытия C-level
                                    вакансий
                                </li>
                                <li id="izrxtpr">Клиенты из Яндекс, Сбер, ВК, Amazon,
                                    финансовый сектор ОАЭ</li>
                            </ul>
                        </div>
                        <div id="iedygvc" class="awake-couches-item wide">
                            <img loading=""
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762174337640-4VWN2-Fram.png"
                                alt="img" class="hidden-mobile" />
                            <img loading="" src="https://storage.yandexcloud.net/cdn.careerum.com/1767602476170-KOox5-1762.png"
                                alt="img" class="hidden-desc-tablet" />
                            <p class="awake-couches-item-name">Дарья Абхинав</p>
                            <p class="awake-couches-item-position">Карьерный консультант и
                                коуч ICF, Польша</p>
                            <ul>
                                <li id="ist5ezk">13 лет опыта в подборе персонала внутри
                                    Huawei, Metro Cash and Carry и во внешнем консалтинге для многих международных и российских
                                    корпораций и Tech стартапов</li>
                                <li id="im4t0rx">8 лет практики карьерного
                                    консультирования для клиентов по всему миру
                                </li>
                                <li id="ieq522b">Член Ассоциации Карьерных Консультантов.
                                    Спикер по теме карьеры для студентов МГИМО и МГУ</li>
                            </ul>
                        </div>
                    </div>
                    <div class="careerum-flex-fec awake-couches-slider-nav">
                        <div aria-disabled="true" class="careerum-flex-cc awake-couches-nav-prev">
                            <svg width=" 18" height=" 16" viewBox=" 0 0 18 16" fill=" none" xmlns=" http://www.w3.org/2000/svg">
                                <path d=" M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round">
                                </path>
                                <path d=" M8.46289 14.3859L2.18956 8.13924L8.46289
                                        1.89258" stroke=" white" stroke-width=" 2.64201" stroke-linecap=" round"
                                    stroke-linejoin=" round">
                                </path>
                            </svg>
                        </div>
                        <div hide-by-geo=" unset" aria-disabled=" false" class=" careerum-flex-cc awake-couches-nav-next">
                            <svg width=" 18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d=" M15.8095 8.14128L2.18945 8.14128" stroke=" white" stroke-width=" 2.64201"
                                    stroke-linecap=" round" stroke-linejoin=" round">
                                </path>
                                <path d=" M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white"
                                    stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round">
                                </path>
                            </svg>
                        </div>
                    </div>
                    <a onclick="" href="#buy" class="btn-color-main-black sdsdsd">Заполнить анкету в
                        Careerum  </a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-club50-tariffs', {
        label: 'Club 50 tariffs (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div data-timer="" custom-link-anchor="buy" class="careerum-awake-tariffs careerum-club50-tariffs main-wrapper club0326-tariffs careerum-levelup-tariffs">
                <div class="careerum-container-responsive">
                    <div class="awake-tariffs-top">
                        <h2 class="inline-block">Как попасть в Careerum?</h2>
                        <h2 class="inline-block">Как попасть в <span>Careerum?</span></h2>
                        <p id="itcg3za" class="club0326-tariffs-text">
                            Вход в клуб возможен только через диагностику карьерного кейса.<br/>
                            Мы рассматриваем <b>50 заявок в месяц </b>
                        </p>
                    </div>
                    <div class="awake-tariffs-switchers careerum-flex-sbfs">
                        <div class="awake-tariffs-period-wrapper">
                            <div class="awake-tariffs-period careerum-flex-fsst">
                                <ul class="careerum-flex-fsfs not-m1">
                                    <li data-period="1">
                                        <p class="hidden-mobile">1 месяц</p>
                                        <p class="hidden-desc-tablet">1 меc</p>
                                    </li>
                                    <li data-period="3" class="active">
                                        <p class="hidden-mobile">3 месяца</p>
                                        <p class="hidden-desc-tablet">3 меc</p>
                                    </li>
                                    <li data-period="6">
                                        <p class="hidden-mobile">6 месяцев</p>
                                        <p class="hidden-desc-tablet">6 мес</p>
                                    </li>
                                    <li data-period="12">
                                        <p class="hidden-mobile">12 месяцев</p>
                                        <p class="hidden-desc-tablet">12 мес</p>
                                    </li>
                                </ul>
                                <div class="awake-tariffs-notif careerum-flex-cc">
                                    <div class="awake-tariffs-notif-icon">
                                        <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg" alt=""/>
                                    </div>
                                    <div class="awake-tariffs-notif-content">
                                        <p>1 месяц подписки предоставляет 30 дней доступа к платформе</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="awake-tariffs-curr careerum-flex-fsst">
                            <ul class="careerum-flex-fsfs">
                                <li data-currency="eur">EUR</li>
                                <li data-currency="rub" class="active">RUB</li>
                            </ul>
                            <div class="awake-tariffs-notif careerum-flex-cc">
                                <div class="awake-tariffs-notif-icon">
                                    <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg" alt=""/>
                                </div>
                                <div class="awake-tariffs-notif-content">
                                    <p>Оплата в российских рублях возможна только картой российского банка.
                                            В евро — картой
                                            зарубежного банка</p>
                                </div>
                            </div>
                        </div>
                        <div class="awake-tariffs-curr-mobile">
                            <div class="awake-tariffs__swicher-block">
                                <div class="awake-tariffs__swicher-top">
                                    <p class="awake-tariffs__swicher-header">
                                        Посмотреть
                                            цены в
                                            <span>RUB</span>
                                    </p>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="awake-tariffs__swicher-arrow">
                                        <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black"></path>
                                    </svg>
                                </div>
                                <div class="awake-tariffs__swicher-bottom">
                                    <ul>
                                        <li data-currency="rub">RUB
                                            </li>
                                        <li data-currency="eur" class="active">EUR
                                            </li>
                                    </ul>
                                    <p>
                                        Обратите внимание,<br/>
                                        что оплата в российских
                                            рублях
                                            возможна только<br/>с карты
                                            российского банка. Оплата в евро — с карты зарубежного банка
                                        
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="levelup-tariffs-bottom position-relative z-1">
                        <img loading="lazy" src="https://cdn.careerum.com/1770290624643-Ure4F-Grou.svg" alt="img" class="hidden-tablet-mobile position-absolute z-1"/>
                        <img loading="lazy" src="https://cdn.careerum.com/1770292590407-9aSjH-Grou.svg" alt="img" class="hidden-desc-mobile position-absolute z-1"/>
                        <img loading="lazy" src="https://cdn.careerum.com/1770300210002-bGAyJ-Grou.svg" alt="img" class="hidden-desc-tablet position-absolute z-1"/>
                        <div class="levelup-tariffs-bottom-wrapper careerum-flex-sbc position-relative z-10">
                            <div class="levelup-tariffs-bottom-text">
                                <p>6 личных консультаций </p>
                                <p>с карьерными экспертами</p>
                                <p>При покупке тарифа «Индивидуальное сопровождение» на 3 месяца</p>
                            </div>
                            <div class="levelup-tariffs-bottom-img">
                                <img loading="lazy" src="https://cdn.careerum.com/1770290593483-tgXd1-Grou.png" alt="img" class="hidden-tablet-mobile"/>
                                <img loading="lazy" src="https://cdn.careerum.com/1770292559690-AtfKf-Grou.png" alt="img" class="hidden-desc-mobile"/>
                                <img loading="lazy" src="https://cdn.careerum.com/1770300179775-V9as8-Grou.png" alt="img" class="hidden-desc-tablet"/>
                            </div>
                        </div>
                    </div>
                    <div class="awake-tariffs-items-wrapper elements-2">
                        <div class="awake-tariffs-items careerum-flex-cst">
                            <div data-price="" data-price-1m-rub="8 900 ₽" data-oldprice-1m-rub="12 900 ₽" data-discount-1m-rub="-31%" data-price-3m-rub="8 900 ₽" data-fullprice-3m-rub="26 700 ₽" data-oldprice-3m-rub="38 700 ₽" data-discount-3m-rub="-31%" data-price-6m-rub="8 900 ₽" data-oldprice-6m-rub="" data-discount-6m-rub="" data-fullprice-6m-rub="53 400 ₽" data-price-12m-rub="6 900 ₽" data-fullprice-12m-rub="82 800 ₽" data-discount-12m-rub="–22%" data-oldprice-12m-rub="106 800 ₽" data-price-1m-eur="89 €" data-oldprice-1m-eur="149 €" data-discount-1m-eur="–39%" data-price-3m-eur="89 €" data-fullprice-3m-eur="267 €" data-oldprice-3m-eur="447 €" data-discount-3m-eur="–39%" data-price-6m-eur="89 €" data-fullprice-6m-eur="534 €" data-oldprice-6m-eur="" data-discount-6m-eur=" %" data-price-12m-eur="69 €" data-fullprice-12m-eur="828 €" data-oldprice-12m-eur="1 068 €" data-discount-12m-eur="–22%" data-offer-1m-rub="27" data-offer-3m-rub="94" data-offer-6m-rub="95" data-offer-12m-rub="96" data-offer-1m-eur="48" data-offer-3m-eur="97" data-offer-6m-eur="98" data-offer-12m-eur="99" id="i2th66z" class="awake-tariffs-item careerum-flex-fsfs hidden">
                                <div class="awake-tariffs-item-header yellow">
                                    <div class="careerum-flex-fsc awake-tariffs-item-header-wrapper">
                                        <div class="awake-tariffs-item-header-label careerum-flex-fsc white">
                                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432322102-BgJzk-Hand.svg" alt="img"/>
                                            <p>Базовый</p>
                                        </div>
                                        <div class="awake-tariffs-item-header-places careerum-flex-fsc hidden">
                                            <p id="iveg60e">Доступно мест: неограниченно</p>
                                        </div>
                                    </div>
                                    <p class="awake-tariffs-item-header hidden-mobile">Самостоятельный без клуба
                                        </p>
                                    <div class="awake-tariffs-item-header-places careerum-flex-fsc hidden">
                                        <p id="i70j1li">Доступно мест: неограниченно</p>
                                    </div>
                                    <p class="awake-tariffs-item-header hidden-desc-tablet">Самостоятельный без клуба</p>
                                </div>
                                <div class="awake-tariffs-item-content">
                                    <ul>
                                        <li class="careerum-flex-fsfs">
                                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg" alt=""/>
                                            <p id="i7z91s">Образовательные курсы по вашей задаче на платформе</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg" alt=""/>
                                            <p id="i93qoe">12 шаблонов резюме RU и EN</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg" alt=""/>
                                            <p id="ibyf5w">AI-сервис проверки резюме</p>
                                        </li>
                                        <li class="careerum-flex-fsfs disabled">
                                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321524-Xduv4-XCir.svg" alt=""/>
                                            <p id="iyaw34">Доступ в карьерный клуб</p>
                                        </li>
                                        <li class="careerum-flex-fsfs disabled">
                                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321524-Xduv4-XCir.svg" alt=""/>
                                            <p id="iqaytdg">Экспертные онлайн-эфиры клуба</p>
                                        </li>
                                        <li class="careerum-flex-fsfs disabled">
                                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321524-Xduv4-XCir.svg" alt=""/>
                                            <p id="ije3lf">Фидбэк от карьерных стратегов на онлайн-эфирах: разборы кейсов, позиций, рынков, отраслей, рисков при переходе</p>
                                        </li>
                                        <li class="careerum-flex-fsfs disabled">
                                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321524-Xduv4-XCir.svg" alt=""/>
                                            <p id="ipz6hc">Поддержка экспертов в чате </p>
                                        </li>
                                        <li class="careerum-flex-fsfs disabled">
                                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321524-Xduv4-XCir.svg" alt=""/>
                                            <p id="ie71os">2 личные консультации с карьерными экспертами в месяц</p>
                                        </li>
                                    </ul>
                                </div>
                                <div class="awake-tariffs-item-footer">
                                    <div class="awake-tariffs-item-discount hidden-m1 hidden-m3 hidden-m6">
                                        <p class="awake-tariffs-item-discount"></p>
                                        <p class="awake-tariffs-item-oldprice"></p>
                                    </div>
                                    <div class="awake-tariffs-item-price careerum-flex-fsfs">
                                        <p class="awake-tariffs-item-fullprice-amount">12 900 ₽</p>
                                        <p class="awake-tariffs-item-price-separator">/</p>
                                        <div>
                                            <p class="awake-tariffs-item-price-amount"></p>
                                            <p class="awake-tariffs-item-price-text">цена месяца</p>
                                        </div>
                                    </div>
                                    <div class="awake-tariffs-item-rassr careerum-flex-fsc hidden-m1">
                                        <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753885469183-Cyal7-Cred.svg" alt="img"/>
                                        <p>Доступно в рассрочку</p>
                                    </div>
                                    <div class="awake-tariffs-item-link">
                                        <a onclick="" href="https://school.careerum.ru/anketa2026" target="_blank" class="btn-color-main-bright-orange no-change no-popup getparams">Заполнить анкету в Сareerum</a>
                                    </div>
                                </div>
                            </div>
                            <div data-price="" data-price-1m-rub="14 900 ₽" data-oldprice-1m-rub="" data-discount-1m-rub=" %" data-price-3m-rub="14 000 ₽" data-fullprice-3m-rub="42 000 ₽" data-oldprice-3m-rub="44 700 ₽" data-discount-3m-rub="-6%" data-price-6m-rub="13 000 ₽" data-fullprice-6m-rub="78 000 ₽" data-oldprice-6m-rub="89 400 ₽" data-discount-6m-rub="-13%" data-price-12m-rub="10 000 ₽" data-fullprice-12m-rub="120 000 ₽" data-oldprice-12m-rub="178 800 ₽" data-discount-12m-rub="-33%" data-price-1m-eur="199 €" data-oldprice-1m-eur="" data-discount-1m-eur=" %" data-price-3m-eur="180 €" data-fullprice-3m-eur="540 €" data-oldprice-3m-eur="597 €" data-discount-3m-eur="-10%" data-price-6m-eur="150 €" data-fullprice-6m-eur="900 €" data-oldprice-6m-eur="1 194 €" data-discount-6m-eur="-25%" data-price-12m-eur="110 €" data-fullprice-12m-eur="1 320 €" data-oldprice-12m-eur="2 388 €" data-discount-12m-eur="-45%" data-offer-1m-rub="28" data-offer-3m-rub="29" data-offer-6m-rub="30" data-offer-12m-rub="31" data-offer-1m-eur="49" data-offer-3m-eur="50" data-offer-6m-eur="51" data-offer-12m-eur="52" class="awake-tariffs-item careerum-flex-fsfs selected">
                                <div class="awake-tariffs-item-header blue">
                                    <div class="careerum-flex-fsc awake-tariffs-item-header-wrapper">
                                        <div class="awake-tariffs-item-header-label careerum-flex-fsc blue">
                                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321987-1A2dc-Fire.svg" alt="img"/>
                                            <p id="if6k6r">Групповой формат</p>
                                        </div>
                                        <div id="we34434543" class="awake-tariffs-item-header-places careerum-flex-fsc hidden-mobile hidden">
                                            <p id="izzaui1">Доступно мест: 50</p>
                                        </div>
                                    </div>
                                    <div class="awake-tariffs-item-header-places careerum-flex-fsc hidden">
                                        <p id="im6eoc">Доступно мест: 50</p>
                                    </div>
                                    <p class="awake-tariffs-item-header">С поддержкой экспертов</p>
                                </div>
                                <div class="awake-tariffs-item-content">
                                    <ul id="i0bftjk">
                                        <li class="careerum-flex-fsfs">
                                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg" alt=""/>
                                            <p id="ig8huz">Разработка карьерной стратегии под ваши цели</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg" alt=""/>
                                            <p id="ih4kyv6">Образовательный трек по вашей задаче 
            на платформе </p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg" alt=""/>
                                            <p id="ibe0t48">Фидбэк от карьерных стратегов на онлайн-эфирах: разборы кейсов, позиций, рынков, отраслей, рисков при переходе</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg" alt=""/>
                                            <p id="ilnalff">Поддержка экспертов в чате </p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg" alt=""/>
                                            <p id="i5d0e9f">Доступ в карьерный клуб</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg" alt=""/>
                                            <p id="ilgrri">Экспертные онлайн-эфиры клуба</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg" alt=""/>
                                            <p id="igyn7u8">6 шаблонов резюме RU и EN</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg" alt=""/>
                                            <p id="ivdl8jk">AI-сервис проверки резюме</p>
                                        </li>
                                        <li class="careerum-flex-fsfs disabled">
                                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321524-Xduv4-XCir.svg" alt=""/>
                                            <p id="in8jjp">2 личные консультации с карьерными экспертами в месяц</p>
                                        </li>
                                    </ul>
                                </div>
                                <div class="awake-tariffs-item-footer">
                                    <div class="awake-tariffs-item-discount hidden-m1">
                                        <p class="awake-tariffs-item-discount"></p>
                                        <p class="awake-tariffs-item-oldprice"></p>
                                    </div>
                                    <div class="awake-tariffs-item-price careerum-flex-fsfs">
                                        <p class="awake-tariffs-item-fullprice-amount">12 900 ₽</p>
                                        <p class="awake-tariffs-item-price-separator">/</p>
                                        <div>
                                            <p class="awake-tariffs-item-price-amount"></p>
                                            <p class="awake-tariffs-item-price-text">цена месяца</p>
                                        </div>
                                    </div>
                                    <div class="awake-tariffs-item-rassr careerum-flex-fsc hidden-m1">
                                        <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753885469183-Cyal7-Cred.svg" alt="img"/>
                                        <p id="i73qlr">Доступно в рассрочку</p>
                                    </div>
                                    <div class="awake-tariffs-item-link">
                                        <a onclick="" href="https://school.careerum.ru/anketa_club" target="_blank" class="no-change no-popup getparams btn-color-main-black">Заполнить анкету в Сareerum</a>
                                    </div>
                                </div>
                            </div>
                            <div data-price="" data-price-1m-rub="33 900 ₽" data-oldprice-1m-rub="" data-discount-1m-rub=" %" data-price-3m-rub="33 000 ₽" data-fullprice-3m-rub="99 000 ₽" data-oldprice-3m-rub="101 700 ₽" data-discount-3m-rub="-3%" data-price-6m-rub="29 000 ₽" data-fullprice-6m-rub="174 000 ₽" data-oldprice-6m-rub="203 400 ₽" data-discount-6m-rub="-14%" data-price-12m-rub="22 000 ₽" data-fullprice-12m-rub="264 000 ₽" data-oldprice-12m-rub="406 800 ₽" data-discount-12m-rub="-35%" data-price-1m-eur="360 €" data-oldprice-1m-eur="" data-discount-1m-eur=" %" data-price-3m-eur="330 €" data-fullprice-3m-eur="990 €" data-oldprice-3m-eur="1 080 €" data-discount-3m-eur="-8%" data-price-6m-eur="290 €" data-fullprice-6m-eur="1 740 €" data-oldprice-6m-eur="2 160 €" data-discount-6m-eur="-19%" data-price-12m-eur="245 €" data-fullprice-12m-eur="2 940 €" data-oldprice-12m-eur="4 320 €" data-discount-12m-eur="-32%" data-offer-1m-rub="32" data-offer-3m-rub="100" data-offer-6m-rub="101" data-offer-12m-rub="102" data-offer-1m-eur="53" data-offer-3m-eur="103" data-offer-6m-eur="104" data-offer-12m-eur="105" class="awake-tariffs-item careerum-flex-fsfs">
                                <div id="iczbjnn" class="awake-tariffs-item-header dark">
                                    <div id="ixklgyb" class="careerum-flex-fsc awake-tariffs-item-header-wrapper">
                                        <div class="awake-tariffs-item-header-label careerum-flex-fsc white">
                                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321867-adLt2-Meda.svg" alt="img"/>
                                            <p id="ipqink">Личная работа с экспертом</p>
                                        </div>
                                        <div id="iuylvnx" class="awake-tariffs-item-header-places careerum-flex-fsc white hidden-mobile hidden">
                                            <p id="isxdkni">Доступно мест: 20</p>
                                        </div>
                                    </div>
                                    <div id="isxbwxc" class="awake-tariffs-item-header-places careerum-flex-fsc white hidden">
                                        <p id="ia0w82">Доступно мест: 20</p>
                                    </div>
                                    <p class="awake-tariffs-item-header">Индивидуальное сопровождение</p>
                                </div>
                                <div class="awake-tariffs-item-content">
                                    <ul id="ibwoxqe">
                                        <li class="careerum-flex-fsfs">
                                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg" alt=""/>
                                            <div id="iy7rlcx">
                                                <p id="io5nige">2 личные консультации с карьерными экспертами в месяц:
                                                </p>
                                                <ul id="i9pffw6">
                                                    <li data-period="1" id="i8ydmf">
                                                        <p id="ikbowlq">Разработка стратегии</p>
                                                    </li>
                                                    <li data-period="1" id="isc5jpc">
                                                        <p id="iy5yglu">Персональный разбор резюме</p>
                                                    </li>
                                                    <li data-period="1" id="ivem9l9">
                                                        <p id="iych3ow">Персональный разбор Linkedin </p>
                                                    </li>
                                                    <li data-period="1" id="iqdfnjw">
                                                        <p id="ip82mmf">Тренировочные собеседования или любой другой ваш карьерный запрос</p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg" alt=""/>
                                            <p id="ij9pqa8">Образовательный трек по вашей задаче 
            на платформе </p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg" alt=""/>
                                            <p id="itajai">Фидбэк от карьерных стратегов на онлайн-эфирах: разборы кейсов, позиций, рынков, отраслей, рисков при переходе </p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg" alt=""/>
                                            <p id="iu240c">Поддержка экспертов в чате</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg" alt=""/>
                                            <p id="id4adww">Доступ в карьерный клуб</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg" alt=""/>
                                            <p id="ipkvpq">Экспертные онлайн-эфиры клуба</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg" alt=""/>
                                            <p id="i6vlfhi">6 шаблонов резюме RU и EN</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg" alt=""/>
                                            <p id="i5fxzs7">AI-сервис проверки резюме</p>
                                        </li>
                                    </ul>
                                </div>
                                <div class="awake-tariffs-item-footer">
                                    <div class="awake-tariffs-item-discount hidden-m1">
                                        <p class="awake-tariffs-item-discount"></p>
                                        <p class="awake-tariffs-item-oldprice"></p>
                                    </div>
                                    <div class="awake-tariffs-item-price careerum-flex-fsfs">
                                        <p class="awake-tariffs-item-fullprice-amount">12 900 ₽</p>
                                        <p class="awake-tariffs-item-price-separator">/</p>
                                        <div>
                                            <p class="awake-tariffs-item-price-amount"></p>
                                            <p class="awake-tariffs-item-price-text">цена месяца</p>
                                        </div>
                                    </div>
                                    <div class="awake-tariffs-item-rassr careerum-flex-fsc hidden-m1">
                                        <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753885469183-Cyal7-Cred.svg" alt="img"/>
                                        <p>Доступно в рассрочку</p>
                                    </div>
                                    <div class="awake-tariffs-item-notif hidden">
                                        <p>Места закончились</p>
                                        <p>Оставьте заявку в лист ожидания, если у нас освободится место, то наши карьерные консультанты свяжутся с вами</p>
                                    </div>
                                    <div class="awake-tariffs-item-link">
                                        <a onclick="" href="https://school.careerum.ru/anketa_club" target="_blank" class="no-change no-popup getparams btn-color-main-black">Заполнить анкету в Сareerum</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <a onclick="" href="https://school.careerum.ru/anketa2026" target="_blank" class="btn-color-main-black getparams hidden">Заполнить анкету</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-validator2-main', {
        label: 'Validator 2 main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-validator2-main main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <div class="validator-main-header">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754325123211-YEPWM-Fram.svg"
                    class="hidden-tablet-mobile" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754325133231-bHChL-Head.svg"
                    class="hidden-desc-mobile" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754325140840-ZZ2xi-Grou.svg"
                    class="hidden-desc-tablet" alt="img">
            </div>
            <div class="validator-main-wrapper careerum-flex-sbst">
                <div class="validator-main-left position-relative">
                    <div class="validator-main-bg position-relative z-10">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754325753753-tSdXF-Grou.svg"
                            class="hidden-tablet-mobile position-absolute" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754332564908-V6vPN-Grou.svg"
                            class="hidden-desc-mobile position-absolute" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754334979368-RIA0x-Grou.svg"
                            class="hidden-desc-tablet position-absolute" alt="img">
                    </div>
                    <div class="validator-main-content position-relative z-20">
                        <div class="validator-main-labels">
                            <p class="validator-main-label">AI-сервис</p>
                        </div>
                        <h1 class="position-relative">Резюме <span class="position-absolute">сканер</span></h1>
                        <p class="validator-main-text"><span>Прокачайте</span> свое резюме</p>
                        <a href="#form" class="btn-color-main-dark-orange hidden-mobile">Оплатить 5 проверок</a>
                    </div>
                </div>
                <div class="validator-main-right">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754325445641-PqLyH-Fram.png"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754325447259-q1ksf-Fram.png"
                        class="hidden-desc-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754334913805-AxOpc-Fram.png"
                        class="hidden-desc-tablet" alt="img">
                </div>
            </div>
            <a href="#form" class="btn-color-main-dark-orange hidden-desc-tablet">Оплатить 5 проверок</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-validator2-how', {
        label: 'Validator 2 how (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-validator2-how main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <h2>Как это работает</h2>
            <div class="validator-how-wrapper position-relative">
                <div class="validator-how-items">
                    <div class="validator-how-item">
                        <p class="validator-how-item-step">Шаг 1/8</p>
                        <div class="validator-how-item-text careerum-flex-cfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754327435821-SI034-Uplo.svg"
                                class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754336313384-JOBaE-Uplo.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>Загрузите файл</p>
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754334498786-hv5Do-Fram.png"
                            class="hidden-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754336581487-HVV0s-Fram.png"
                            class="hidden-desc-tablet" alt="img">
                    </div>
                    <div class="validator-how-item">
                        <p class="validator-how-item-step">Шаг 2/8</p>
                        <div class="validator-how-item-text careerum-flex-cfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754327434935-aYuw0-Clip.svg"
                                class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754336312287-ljI2j-Clip.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>Получите анализ резюме<br> по 5 параметрам</p>
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754334499498-1x3JK-Fram.png"
                            class="hidden-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754336582197-fRlOv-Fram.png"
                            class="hidden-desc-tablet" alt="img">
                    </div>
                    <div class="validator-how-item">
                        <p class="validator-how-item-step">Шаг 3/8</p>
                        <div class="validator-how-item-text careerum-flex-cfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754327435602-ROixR-Star.svg"
                                class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754336313154-Xbqri-Star.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>Общая оценка качества резюме</p>
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754334499743-NXMWh-Fram.png"
                            class="hidden-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754336582444-V2ugW-Fram.png"
                            class="hidden-desc-tablet" alt="img">
                    </div>
                    <div class="validator-how-item">
                        <p class="validator-how-item-step">Шаг 4/8</p>
                        <div class="validator-how-item-text careerum-flex-cfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754327435720-tjCBu-Targ.svg"
                                class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754336313268-rMWG8-Targ.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>Ваши сильные стороны<br> и возможности</p>
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754334499976-hicrE-Fram.png"
                            class="hidden-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754336582787-9oOHw-Fram.png"
                            class="hidden-desc-tablet" alt="img">
                    </div>
                    <div class="validator-how-item">
                        <p class="validator-how-item-step">Шаг 5/8</p>
                        <div class="validator-how-item-text careerum-flex-cfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754327435159-o5pqU-File.svg"
                                class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754336312668-DEbT0-File.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>Ошибки в презентации опыта</p>
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754334500218-IY3cG-Fram.png"
                            class="hidden-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754336583026-i5Qec-Fram.png"
                            class="hidden-desc-tablet" alt="img">
                    </div>
                    <div class="validator-how-item">
                        <p class="validator-how-item-step">Шаг 6/8</p>
                        <div class="validator-how-item-text careerum-flex-cfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754327435490-8SfpF-Spin.svg"
                                class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754336313022-SQorG-Spin.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>Скрининг резюме<br> под вакансию</p>
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754334500541-eMCKG-Fram.png"
                            class="hidden-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754336583254-QrEhb-Fram.png"
                            class="hidden-desc-tablet" alt="img">
                    </div>
                    <div class="validator-how-item">
                        <p class="validator-how-item-step">Шаг 7/8</p>
                        <div class="validator-how-item-text careerum-flex-cfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754327435380-W0lwu-Plug.svg"
                                class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754336312902-EzwAl-Plug.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>Соответствие желаемой вакансии</p>
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754334500785-RcGT1-Fram.png"
                            class="hidden-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754336583855-z8NCH-Fram.png"
                            class="hidden-desc-tablet" alt="img">
                    </div>
                    <div class="validator-how-item">
                        <p class="validator-how-item-step">Шаг 8/8</p>
                        <div class="validator-how-item-text careerum-flex-cfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754327435271-zVZpj-List.svg"
                                class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754336312782-CIIro-List.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p>Результаты скрининга<br> и рекомендации</p>
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754334501058-ETSv1-Fram.png"
                            class="hidden-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1754336584215-gPqYV-Fram.png"
                            class="hidden-desc-tablet" alt="img">
                    </div>
                </div>
                <div class="validator-how-nav position-absolute careerum-flex-cc">
                    <div class="validator-how-nav-prev careerum-flex-cc">
                        <svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 22L11.6 13.0857L2 2.8" stroke="white" stroke-width="3.84" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="validator-how-nav-next careerum-flex-cc">
                        <svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 22L11.6 13.0857L2 2.8" stroke="white" stroke-width="3.84" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-validator2-form', {
        label: 'Validator 2 form (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-validator2-form main-wrapper" data-offer-rub="11" data-offer-eur="22">
        <div class="careerum-container-responsive position-relative">
            <h2>Оплатить 5 проверок резюме</h2>
            <div class="validator-form-wrapper">
                <div class="careerum-registration-form-club40">
                    <form class="deva-form careerum-flex-fsfs" name="devaRegistrationForm"
                        data-gjs-type="deva-registration-form">
                        <div class="careerum-club40-form-name">
                            <input type="text" name="name" value="" required placeholder="Имя">
                            <p class="careerum-club40-form-warn">Поле не заполнено</p>
                        </div>
                        <div class="careerum-club40-form-email">
                            <input type="text" name="email" value="" required placeholder="Почта">
                            <p class="careerum-club40-form-warn">Поле не заполнено</p>
                        </div>
                        <div class="careerum-club40-form-phone">
                            <input type="tel" value="" name="tel" required class="itl-input">
                            <p class="careerum-club40-form-warn">Поле не заполнено</p>
                        </div>
                        <div class="careerum-flex-fsfs form-buttons">
                            <div class="form-button-second rub">
                                <p>500 ₽</p>
                            </div>
                            <a href="#" class="submit-btn btn-color-main-bright-orange button-sent hidden"
                                disabled>500 ₽</a>
                            <div class="form-button-second eur">
                                <p>5 €</p>
                            </div>
                            <div class="careerum-club40-form-agree">
                                <label>
                                    <input type="checkbox" name="agree">
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                            fill="none">
                                            <path
                                                d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                        </svg>
                                    </div>
                                </label>
                                <p>Я принимаю условия <a href="/ru-intl/legal/offer">Оферты</a> и даю согласие
                                    на обработку персональных данных
                                    в соответствии с <a href="/ru-ru/legal/privacy">Политикой конфиденциальности</a></p>
                            </div>
                        </div>
                        <input type="hidden" hidden name="offerID" value="" autocomplete="off">
                    </form>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-lead2-form', {
        label: 'Lead 2 form (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-lead2-form main-wrapper beige-bg" >
                <div class="careerum-container-responsive position-relative">
                    <div class="careerum-form-lead position-relative">
                        <h2>Как обойти 99% кандидатов
                            на собеседовании?</h2>
                        <p>Типы собеседований: что будут проверять, какие вопросы зададут и чего хотят добиться HR</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1668598134770.svg" alt=""
                            class="position-absolute hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1668598181401.svg" alt=""
                            class="position-absolute hidden-desc-mobile">
                        <div class="lead-form-wrapper">
                            <div class="careerum-registration-form-club40">
                                <form class="deva-form getcourse-email-signup careerum-flex-fsfs" name="devaRegistrationForm"
                                    data-gjs-type="deva-registration-form">
                                    <div class="careerum-club40-form-name">
                                        <input type="text" name="name" value="" required placeholder="Имя">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                    </div>
                                    <div class="careerum-club40-form-email">
                                        <input type="text" name="email" value="" required placeholder="Почта">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                    </div>
                                    <div class="careerum-club40-form-telegram">
                                        <input type="text" value="" name="telegram" required placeholder="Telegram">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                    </div>
                                    <div class="careerum-club40-form-phone">
                                        <input type="tel" value="" name="tel" required class="itl-input">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                    </div>
                                    <div class="careerum-flex-fsfs form-buttons">
                                        <a href="#" class="submit-btn btn-color-main-bright-orange button-sent"
                                            disabled>Получить гайд</a>
                                        <div class="careerum-club40-form-agree">
                                            <label>
                                                <input type="checkbox" name="agree">
                                                <div>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8"
                                                        viewBox="0 0 8 8" fill="none">
                                                        <path
                                                            d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                            stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                    </svg>
                                                </div>
                                            </label>
                                            <p>Я даю согласие
                                                на обработку персональных данных
                                                в соответствии с <a href="/ru-ru/legal/privacy">Политикой конфиденциальности</a>
                                            </p>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="careerum-form-success-lead">
                        <div class="position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1668598146404.svg" alt=""
                                class="careerum-form-success-lead-heart position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1668598155559.svg" alt=""
                                class="careerum-form-success-lead-highlight position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1668598191411.svg" alt=""
                                class="careerum-form-success-lead-heart position-absolute hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1668598202783.svg" alt=""
                                class="careerum-form-success-lead-highlight position-absolute hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1668598233783.svg" alt=""
                                class="careerum-form-success-lead-heart position-absolute hidden-desc-tablet">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1668598243347.svg" alt=""
                                class="careerum-form-success-lead-highlight position-absolute hidden-desc-tablet">
                            <h2>Спасибо!&nbsp;<br>Гайд пришлем<div>на почту</div>
                            </h2>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-pack-form', {
        label: 'Big pack form (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-pack-form main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <div class="pack-form-bg position-relative">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755151083288-dlg7K-Grou.svg" class="hidden-tablet-mobile position-absolute" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755151092912-kE3EA-Grou.svg" class="hidden-desc-mobile position-absolute" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755151100558-uL6bR-Grou.svg" class="hidden-desc-tablet position-absolute" alt="img">
            </div>
            <div class="pack-form-logo">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755150910701-cyn93-logo.svg" class="hidden-tablet-mobile" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755150918402-sy6tj-logo.svg" class="hidden-desc" alt="img">
            </div>
            <div class="careerum-form-lead position-relative form-sent">
                <div class="pack-form-top">
                    <div class="pack-form-top-title careerum-flex-sbfs">
                        <div class="pack-form-top-title-left position-relative z-20">
                            <h1 class="position-relative">
                                <span class="position-relative">Big Pack</span> <br>
                                <span class="position-relative">от Ольги Лермонтовой</span></h1>
                            <div class="position-relative">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755154805451-fZtSL-Vect.svg" class="hidden-tablet-mobile position-absolute" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755154805088-Wfpge-Vect.svg" class="hidden-desc-mobile position-absolute" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755154804818-qN1nq-Vect.svg" class="hidden-desc-tablet position-absolute" alt="img">
                                <p>Как избежать <span>факапов</span>  
                                    при поиске работы</p>
                            </div>
                        </div>
                        <div class="pack-form-top-title-right position-relative z-10">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755153451595-FmU2X-Grou.svg" class="hidden-tablet-mobile position-absolute z-10" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755232491104-xWBua-Grou.svg" class="hidden-desc-mobile position-absolute z-10" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755239466236-Z4pfg-Grou.png" class="hidden-desc-tablet position-absolute z-10" alt="img">
                            <div class="position-relative z-20">
                                <p><span>Big Pack — это 7 писем с лайфхаками, чек-листами и таблицами,</span> чтобы вы не наделали критических ошибок при поиске работы в новом сезоне</p>
                            </div>
                        </div>
                        <div class="lead-form-wrapper position-relative z-20">
                            <p class="lead-form-title">
                                Заполните форму, чтобы получать письма
                            </p>
                            <div class="careerum-registration-form-club40">
                                <form class="deva-form getcourse-email-signup careerum-flex-fsfs" name="devaRegistrationForm"
                                    data-gjs-type="deva-registration-form">
                                    <div class="careerum-club40-form-name">
                                        <input type="text" name="name" value="" required placeholder="Имя">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                    </div>
                                    <div class="careerum-club40-form-telegram">
                                        <input type="text" value="" name="telegram" required placeholder="Telegram">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                    </div>
                                    <div class="careerum-club40-form-email">
                                        <input type="text" name="email" value="" required placeholder="Почта">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                    </div>
                                    <div class="careerum-club40-form-phone">
                                        <input type="tel" value="" name="tel" required class="itl-input">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                    </div>
                                    <div class="form-buttons">
                                        <a href="#" class="submit-btn btn-color-main-bright-orange button-sent"
                                            disabled>Получать письма</a>
                                        <div class="careerum-club40-form-agree">
                                            <label>
                                                <input type="checkbox" name="agree">
                                                <div>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8"
                                                        viewBox="0 0 8 8" fill="none">
                                                        <path
                                                            d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                            stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                    </svg>
                                                </div>
                                            </label>
                                            <p>Я даю согласие
                                                на обработку персональных данных
                                                в соответствии с <a href="/ru-ru/legal/privacy">Политикой конфиденциальности</a>
                                            </p>
                                        </div>
                                    </div>
                                    <input type="hidden" hidden name="offerID" value="" autocomplete="off">
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pack-form-center">
                    <div class="careerum-flex-sbfs pack-form-center-top">
                        <div class="pack-form-center-top-left careerum-flex-fsfs">
                            <div class="pack-form-item item-1 position-relative">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755153175214-skXGI-Fram.png" class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755233371087-UUCzg-Fram.png" class="hidden-desc-mobile position-absolute z-10" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755239655980-MBJn2-Fram.png" class="hidden-desc-tablet position-absolute z-10" alt="img">
                                <div class="pack-form-item-number careerum-flex-fsfs position-relative z-20">
                                    <p>1</p>
                                    <p>письмо</p>
                                </div>
                                <p class="pack-form-item-header position-relative z-20">Как искать вакансии, которые не разочаруют</p>
                                <p class="pack-form-item-text position-relative z-20">Не надо откликаться на все подряд – научитесь искать то, что вам понравится</p>
                            </div>
                            <a href="#form" class="btn-color-main-dark-orange">Хочу избежать факапов!</a>
                            <div  class="pack-form-item item-8 position-relative hidden-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755153176104-ezmlV-Grou.png" class="hidden-tablet-mobile position-absolute" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755233401277-IfS46-Grou.svg" class="hidden-desc-mobile position-absolute" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/" class="hidden-desc-tablet position-absolute" alt="img">
                            </div>
                            <div class="pack-form-item item-5 position-relative hidden-desc-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755233372225-8HGr6-Fram.png" class="hidden-desc-mobile position-absolute z-10" alt="img">
                                <div class="pack-form-item-number careerum-flex-fsfs position-relative z-20">
                                    <p>5</p>
                                    <p>письмо</p>
                                </div>
                                <p class="pack-form-item-label position-relative z-20">Секрет, которым редко делятся</p>
                                <p class="pack-form-item-header position-relative z-20">Как сделать тестовое, чтобы «прощупать» компанию и обойти конкурентов</p>
                            </div>
                        </div>
                        <div class="pack-form-center-top-right careerum-flex-fsfs">
                            <div class="pack-form-item item-2 position-relative">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755153342642-dW0j7-Fram.png" class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755233371395-mi1rb-Fram.png" class="hidden-desc-mobile position-absolute z-10" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755239653403-faesI-Fram.png" class="hidden-desc-tablet position-absolute z-10" alt="img">
                                <div class="pack-form-item-number careerum-flex-fsfs position-relative z-20">
                                    <p>2</p>
                                    <p>письмо</p>
                                </div>
                                <p class="pack-form-item-label position-relative z-20">Письмо с трекером вакансий</p>
                                <p class="pack-form-item-header position-relative z-20">«Боже, куда я откликался!»</p>
                                <p class="pack-form-item-text position-relative z-20">Сможете отслеживать, куда вы отправили резюме и что вам ответили</p>
                            </div>
                            <div class="careerum-flex-sbfs">
                                <div class="pack-form-item item-3 position-relative">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755153176219-lhDcY-Grou.png" class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755233372517-URMRm-Grou.png" class="hidden-desc-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755239653229-ComqF-Grou.png" class="hidden-desc-tablet position-absolute z-10" alt="img">
                                    <div class="pack-form-item-number careerum-flex-fsfs position-relative z-20">
                                        <p>3</p>
                                        <p>письмо</p>
                                    </div>
                                    <p class="pack-form-item-header position-relative z-20">Письмо про ошибки, которые помешают вам найти работу в 2025–2026 году</p>
                                </div>
                                <div class="pack-form-item item-4 position-relative">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755153175718-h1imR-Fram.png" class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755233371726-d7xOf-Fram.png" class="hidden-desc-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755239653067-rICq1-Fram.png" class="hidden-desc-tablet position-absolute z-10" alt="img">
                                    <div class="pack-form-item-number careerum-flex-fsfs position-relative z-20">
                                        <p>4</p>
                                        <p>письмо</p>
                                    </div>
                                    <p class="pack-form-item-header position-relative z-20">Инсайды от рекрутеров: что отталкивает рекрутеров и почему вам могут не сделать оффер</p>
                                </div>
                            </div>
                            <div class="pack-form-item item-5 position-relative hidden-tablet">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755153175469-aLtrp-Fram.png" class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755239652615-oLWz0-Grou.png" class="hidden-desc-tablet position-absolute z-10" alt="img">
                                <div class="pack-form-item-number careerum-flex-fsfs position-relative z-20">
                                    <p>5</p>
                                    <p>письмо</p>
                                </div>
                                <p class="pack-form-item-label position-relative z-20">Секрет, которым редко делятся</p>
                                <p class="pack-form-item-header position-relative z-20">Как сделать тестовое, чтобы «прощупать» компанию и обойти конкурентов</p>
                            </div>
                            <div class="pack-form-item item-6 position-relative hidden-desc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755153175826-tes3V-Fram.png" class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755233371847-Mo8Cc-Fram.png" class="hidden-desc-mobile position-absolute z-10" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755239652491-PgZHq-Fram.png" class="hidden-desc-tablet position-absolute z-10" alt="img">
                                <div class="pack-form-item-number careerum-flex-fsfs position-relative z-20">
                                    <p>6</p>
                                    <p>письмо</p>
                                </div>
                                <p class="pack-form-item-label position-relative z-20">Самый короткий путь до оффера</p>
                                <p class="pack-form-item-header position-relative z-20">90% кандидатов не используют этот ресурс</p>
                            </div>
                        </div>
                    </div>
                    <div class="careerum-flex-sbfs pack-form-center-bottom">
                        <div class="pack-form-item item-6 position-relative hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755153175826-tes3V-Fram.png" class="hidden-tablet-mobile position-absolute z-10" alt="img">
                            <div class="pack-form-item-number careerum-flex-fsfs position-relative z-20">
                                <p>6</p>
                                <p>письмо</p>
                            </div>
                            <p class="pack-form-item-label position-relative z-20">Самый короткий путь до оффера</p>
                            <p class="pack-form-item-header position-relative z-20">90% кандидатов не используют этот ресурс</p>
                        </div>
                        <div class="pack-form-item item-7 position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755153176332-P0al3-Grou.png" class="hidden-tablet-mobile position-absolute z-10" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755233372642-1tgtF-Grou.png" class="hidden-desc-mobile position-absolute z-10" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755239651943-Fike4-Fram.png" class="hidden-desc-tablet position-absolute z-10" alt="img">
                            <div class="pack-form-item-number careerum-flex-fsfs position-relative z-20">
                                <p>7</p>
                                <p>письмо</p>
                            </div>
                            <p class="pack-form-item-header position-relative z-20">Как работодатели сталкерят вас при найме: <span class="position-absolute">соцсети</span><span class="position-absolute">&</span><span class="position-absolute">рекомендации</span></p>
                        </div>
                    </div>
                </div>
                <div class="pack-form-bottom careerum-flex-sbfs">
                    <div>
                        <h2>Заберите Big Pack от Ольги Лермонтовой</h2>
                        <p class="hidden-tablet">Чтобы в новом сезоне <span class="position-relative">увидеть оффер</span> вместо фейспалма от рекрутера</p>
                        <p class="hidden-desc-mobile">Чтобы в новом сезоне <span class="position-relative">увидеть оффер</span></p>
                        <p class="hidden-desc-mobile">вместо фейспалма от рекрутера</p>
                    </div>
                    <div class="lead-form-wrapper">
                        <div class="careerum-registration-form-club40">
                            <form class="deva-form getcourse-email-signup careerum-flex-fsfs" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-telegram">
                                    <input type="text" value="" name="telegram" required placeholder="Telegram">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="form-buttons">
                                    <a href="#" class="submit-btn btn-color-main-bright-orange button-sent"
                                        disabled>Получать письма</a>
                                    <div class="careerum-club40-form-agree">
                                        <label>
                                            <input type="checkbox" name="agree">
                                            <div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8"
                                                    viewBox="0 0 8 8" fill="none">
                                                    <path
                                                        d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                        stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </label>
                                        <p>Я даю согласие
                                            на обработку персональных данных
                                            в соответствии с <a href="/ru-ru/legal/privacy">Политикой конфиденциальности</a>
                                        </p>
                                    </div>
                                </div>
                                <input type="hidden" hidden name="offerID" value="" autocomplete="off">
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="careerum-form-success-lead">
                <div class="position-relative">
                    <h2>Отлично, я уже собрала ваш бокс:</h2>
                    <p>первое письмо прилетит с минуты на минуту</p>
                    <div class="pack-form-author careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755161627709-tADEj-Fram.png" class="hidden-tablet-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755161641403-IpCBR-Fram.png" class="hidden-desc" alt="img">
                        <div class="position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755161515325-Zi5fV-Vect.svg" class="hidden-tablet-mobile position-absolute" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755161517026-pWdhS-Vect.svg" class="hidden-desc-mobile position-absolute" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755161518933-3GSJS-Vect.svg" class="hidden-desc-tablet position-absolute" alt="img">
                            <p class="pack-form-name">Ольга Лермонтова</p>
                            <p class="pack-form-position">СЕО Careerum</p>
                        </div>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755162039620-fOzGa-Grou.svg" class="hidden-tablet-mobile position-relative success-bg" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755161465170-u3ozF-Grou.svg" class="hidden-desc-mobile position-relative success-bg" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755161473124-2WTI6-Grou.svg" class="hidden-desc-tablet position-relative success-bg" alt="img">
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club50-banner', {
        label: 'Club 50 banner (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club50-banner main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755694901437-orJUt-Grou.svg"
                        class="hidden-tablet-mobile position-absolute z-10" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755747514829-NrCmB-Grou.svg"
                        class="hidden-desc-mobile position-absolute z-10" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755790432039-yqusr-Grou.svg"
                        class="hidden-desc-tablet position-absolute z-10" alt="img">
                    <h2 class="position-relative z-20">Что будет доступно</h2>
                    <p class="position-relative z-20">в подписке</p>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-club50-schedule2', {
        label: 'Club 50 schedule2 (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div custom-link-anchor="events" class="careerum-club50-schedule2 main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="club50-schedule2-top">
                        <h2>Расписание онлайн-эфиров</h2>
                        <h2 class="hidden">
                            Расписание онлайн-эфиров <span>2026</span>
                        </h2>
                    </div>
                    <div class="club50-schedule2-bottom">
                        <div class="club50-schedule2-wrapper active">
                            <div class="club50-schedule2-title careerum-flex-sbfs">
                                <div class="club50-schedule2-title-left">
                                    <p class="club50-schedule2-mounth">Сентябрь</p>
                                    <p class="club50-schedule2-header hidden">Карьерная стратегия</p>
                                </div>
                                <div class="club50-schedule2-title-right careerum-flex-cc">
                                    <svg width="46" height="46" viewBox="0 0 46 46" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" class="hidden-tablet-mobile">
                                        <path d="M11.7151 34.5715L34.5723 11.7144" stroke="#191C20"
                                            stroke-width="2.85714" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M16.0008 11.7142H34.5723V30.2856" stroke="#191C20"
                                            stroke-width="2.85714" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                    <svg width="38" height="38" viewBox="0 0 38 38" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" class="hidden-desc-mobile">
                                        <path d="M9.9721 28.4097L28.2578 10.124" stroke="#191C20"
                                            stroke-width="2.28571" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M13.4007 10.1238H28.2578V24.981" stroke="#191C20"
                                            stroke-width="2.28571" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" class="hidden-desc-tablet">
                                        <path d="M8.38105 23.5981L23.6191 8.36005" stroke="#191C20"
                                            stroke-width="1.90476" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M11.2382 8.36026H23.6191V20.7412" stroke="#191C20"
                                            stroke-width="1.90476" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                </div>
                            </div>
                            <div class="club50-schedule2-slider">
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p >Эфир</p>
                                        <p >3 сентября, 19:30 мск</p>
                                    </div>
                                    <p class="awake-schedule-item-header">Real Me, Практикум 3</p>
                                    <p class="awake-schedule-item-text hidden">Что узнаете:</p>
                                    <ul class="hidden">
                                        <li>Почему талантливые женщины обесценивают сами себя</li>
                                    </ul>
                                    <p class="awake-schedule-item-text">Спикеры:</p>
                                    <div class="awake-schedule-item-speakers">
                                        <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                            <img loading=""
                                                src="https://storage.yandexcloud.net/cdn.careerum.com/1773142636660-mEaMF-Spea.png"
                                                alt="img" class="hidden-mobile" />
                                            <img loading=""
                                                src="https://storage.yandexcloud.net/cdn.careerum.com/1773142946175-SXJTe-Spea.png"
                                                alt="img" class="hidden-desc-tablet" />
                                            <div>
                                                <p class="awake-schedule-item-speakers-name">Олеся Спиридонова</p>
                                                <p class="awake-schedule-item-speakers-position">Коуч-практик</p>
                                            </div>
                                        </div>
                                        <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                            <img loading=""
                                                src="https://storage.yandexcloud.net/cdn.careerum.com/1773142636776-ISqrm-Spea.png"
                                                alt="img" class="hidden-mobile" />
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744006900-ps5q1-Spea.png"
                                                alt="img" class="hidden-desc-tablet" />
                                            <div>
                                                <p class="awake-schedule-item-speakers-name">Светлана Шуйская</p>
                                                <p class="awake-schedule-item-speakers-position">Коуч-практик</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p >Эфир</p>
                                        <p >9 сентября, 19:30 мск</p>
                                    </div>
                                    <p class="awake-schedule-item-header">Онлайн коворкинг</p>
                                    <p class="awake-schedule-item-text hidden">Что узнаете:</p>
                                    <ul class="hidden">
                                        <li >Почему талантливые женщины обесценивают сами себя</li>
                                    </ul>
                                    <p class="awake-schedule-item-text">Спикер:</p>
                                    <div class="awake-schedule-item-speakers">
                                        <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                            <img loading=""
                                                src="https://storage.yandexcloud.net/cdn.careerum.com/1770624842035-uXjXP-Spea.png"
                                                alt="img" class="hidden-mobile" />
                                            <img loading=""
                                                src="https://storage.yandexcloud.net/cdn.careerum.com/1770624841764-6eKnS-mobi.png"
                                                alt="img" class="hidden-desc-tablet" />
                                            <div>
                                                <p class="awake-schedule-item-speakers-name">Майя Бурякина</p>
                                                <p class="awake-schedule-item-speakers-position">Коуч ACC ICF,
                                                    США/Россия</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p >Эфир</p>
                                        <p >17 сентября, 19:30 мск</p>
                                    </div>
                                    <p class="awake-schedule-item-header">Real Me, Практикум 4</p>
                                    <p class="awake-schedule-item-text hidden">Что узнаете:</p>
                                    <ul class="hidden">
                                        <li >Почему талантливые женщины обесценивают сами себя</li>
                                    </ul>
                                    <p class="awake-schedule-item-text">Спикер:</p>
                                    <div class="awake-schedule-item-speakers">
                                        <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                            <img loading=""
                                                src="https://storage.yandexcloud.net/cdn.careerum.com/1770624842035-uXjXP-Spea.png"
                                                alt="img" class="hidden-mobile" />
                                            <img loading=""
                                                src="https://storage.yandexcloud.net/cdn.careerum.com/1770624841764-6eKnS-mobi.png"
                                                alt="img" class="hidden-desc-tablet" />
                                            <div>
                                                <p class="awake-schedule-item-speakers-name">Майя Бурякина</p>
                                                <p class="awake-schedule-item-speakers-position">Коуч ACC ICF,
                                                    США/Россия</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p >Онлайн-встреча</p>
                                        <p >27 сентября, 12:00 мск</p>
                                    </div>
                                    <p class="awake-schedule-item-header">Еnglish Spеaking Club</p>
                                    <p class="awake-schedule-item-text">Что узнаете:</p>
                                    <ul>
                                        <li >На встрече вы прокачаете свой speaking и расширите
                                            нетворк. Встреча подходит для уровня B1-B2</li>
                                    </ul>
                                    <p class="awake-schedule-item-text">Спикер:</p>
                                    <div class="awake-schedule-item-speakers">
                                        <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743792734-G1EgK-Spea.png"
                                                alt="img" class="hidden-mobile" />
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744006369-cjdCF-Spea.png"
                                                alt="img" class="hidden-desc-tablet" />
                                            <div>
                                                <p class="awake-schedule-item-speakers-name">Ольга Колобкова</p>
                                                <p class="awake-schedule-item-speakers-position">Руководитель
                                                    Kolobkova School и
                                                    амбассадор Careerum</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p >Эфир</p>
                                        <p >29 сентября, 19:00 мск </p>
                                    </div>
                                    <p class="awake-schedule-item-header">Книжный клуб </p>
                                    <p class="awake-schedule-item-text">Спикер:</p>
                                    <div class="awake-schedule-item-speakers">
                                        <div class="careerum-flex-fsc awake-schedule-item-speaker hidden">
                                            <img loading=""
                                                src="https://storage.yandexcloud.net/cdn.careerum.com/1768550440145-FVPVa-Spea.png"
                                                alt="img" class="hidden-mobile" />
                                            <img loading=""
                                                src="https://storage.yandexcloud.net/cdn.careerum.com/1768550440145-FVPVa-Spea.png"
                                                alt="img" class="hidden-desc-tablet" />
                                            <div>
                                                <p class="awake-schedule-item-speakers-name">Анна Прохорова</p>
                                                <p class="awake-schedule-item-speakers-position">Врач-невролог
                                                    высшей категории, cертифицированный нейрокоуч</p>
                                            </div>
                                        </div>
                                        <div class="careerum-flex-fsc awake-schedule-item-speaker hidden">
                                            <img loading=""
                                                src="https://storage.yandexcloud.net/cdn.careerum.com/1773142636776-ISqrm-Spea.png"
                                                alt="img" class="hidden-mobile" />
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744006900-ps5q1-Spea.png"
                                                alt="img" class="hidden-desc-tablet" />
                                            <div>
                                                <p class="awake-schedule-item-speakers-name">Светлана Шуйская</p>
                                                <p class="awake-schedule-item-speakers-position">Карьерный коуч
                                                    ICF</p>
                                            </div>
                                        </div>
                                        <div class="careerum-flex-fsc awake-schedule-item-speaker hidden">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753947490109-jxjDE-Spea.png"
                                                alt="img" class="hidden-mobile" />
                                            <img loading=""
                                                src="https://storage.yandexcloud.net/cdn.careerum.com/1768551934450-aa5jz-Spea.png"
                                                alt="img" class="hidden-desc-tablet" />
                                            <div>
                                                <p class="awake-schedule-item-speakers-name">Николай Пулин </p>
                                                <p class="awake-schedule-item-speakers-position">Карьерный эксперт
                                                </p>
                                            </div>
                                        </div>
                                        <div class="careerum-flex-fsc awake-schedule-item-speaker hidden">
                                            <img loading=""
                                                src="https://storage.yandexcloud.net/cdn.careerum.com/1773142636888-rUEKU-Spea.png"
                                                alt="img" class="hidden-mobile" />
                                            <img loading=""
                                                src="https://storage.yandexcloud.net/cdn.careerum.com/1773142946108-iRUAh-Spea.png"
                                                alt="img" class="hidden-desc-tablet" />
                                            <div>
                                                <p class="awake-schedule-item-speakers-name">Екатерина Савина</p>
                                                <p class="awake-schedule-item-speakers-position">Коуч ICF</p>
                                            </div>
                                        </div>
                                        <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                            <img loading=""
                                                src="https://storage.yandexcloud.net/cdn.careerum.com/1773142636660-mEaMF-Spea.png"
                                                alt="img" class="hidden-mobile" />
                                            <img loading=""
                                                src="https://storage.yandexcloud.net/cdn.careerum.com/1773142946175-SXJTe-Spea.png"
                                                alt="img" class="hidden-desc-tablet" />
                                            <div>
                                                <p class="awake-schedule-item-speakers-name">Олеся Спиридонова</p>
                                                <p class="awake-schedule-item-speakers-position">Коуч-практик</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="club50-schedule2-slider-nav careerum-flex-fec">
                                <div class="club50-schedule2-nav-prev careerum-flex-cc">
                                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white"
                                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white"
                                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                </div>
                                <div class="club50-schedule2-nav-next careerum-flex-cc">
                                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white"
                                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white"
                                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div class="club50-schedule2-wrapper">
                            <div class="club50-schedule2-title careerum-flex-sbfs">
                                <div class="club50-schedule2-title-left">
                                    <p class="club50-schedule2-mounth">Октябрь
                                    </p>
                                    <p class="club50-schedule2-header hidden">Личный бренд и AI в карьере</p>
                                </div>
                                <div class="club50-schedule2-title-right careerum-flex-cc">
                                    <svg width="46" height="46" viewBox="0 0 46 46" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" class="hidden-tablet-mobile">
                                        <path d="M11.7151 34.5715L34.5723 11.7144" stroke="#191C20"
                                            stroke-width="2.85714" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M16.0008 11.7142H34.5723V30.2856" stroke="#191C20"
                                            stroke-width="2.85714" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                    <svg width="38" height="38" viewBox="0 0 38 38" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" class="hidden-desc-mobile">
                                        <path d="M9.9721 28.4097L28.2578 10.124" stroke="#191C20"
                                            stroke-width="2.28571" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M13.4007 10.1238H28.2578V24.981" stroke="#191C20"
                                            stroke-width="2.28571" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" class="hidden-desc-tablet">
                                        <path d="M8.38105 23.5981L23.6191 8.36005" stroke="#191C20"
                                            stroke-width="1.90476" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M11.2382 8.36026H23.6191V20.7412" stroke="#191C20"
                                            stroke-width="1.90476" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                </div>
                            </div>
                            <div class="club50-schedule2-slider">
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p >Эфир</p>
                                        <p >1 октября, 19:30 мск</p>
                                    </div>
                                    <p class="awake-schedule-item-header">Real Me, Практикум 5</p>
                                    <p class="awake-schedule-item-text">Спикер:</p>
                                    <div class="awake-schedule-item-speakers">
                                        <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743791962-REiQe-Spea.png"
                                                alt="img" class="hidden-mobile" />
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005407-tQ1J0-Spea.png"
                                                alt="img" class="hidden-desc-tablet" />
                                            <div>
                                                <p class="awake-schedule-item-speakers-name">Майя Бурякина</p>
                                                <p class="awake-schedule-item-speakers-position">Коуч ACC ICF,
                                                    США/Россия</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p >Эфир</p>
                                        <p >
                                            <a onclick="" href="" class="link"></a>
                                            5 октября, 20:00 мск
                                        </p>
                                    </div>
                                    <p class="awake-schedule-item-header">
                                        От желания к<span> </span>
                                        результату
                                    </p>
                                    <p class="awake-schedule-item-text">Спикер:</p>
                                    <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                        <img loading=""
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743791962-REiQe-Spea.png"
                                            alt="img" class="hidden-mobile" />
                                        <img loading=""
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005407-tQ1J0-Spea.png"
                                            alt="img" class="hidden-desc-tablet" />
                                        <div>
                                            <p class="awake-schedule-item-speakers-name">Майя Бурякина</p>
                                            <p class="awake-schedule-item-speakers-position">Коуч ACC ICF,
                                                США/Россия</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p >Эфир</p>
                                        <p >
                                            <a onclick="" href="" class="link"></a>
                                            7 октября, 19:30 мск
                                        </p>
                                    </div>
                                    <p class="awake-schedule-item-header">
                                        Личный бренд: как стать экспертом, которого знают, рекомендуют и<span
                                        > </span>
                                        зовут на лучшие роли
                                    </p>
                                    <p class="awake-schedule-item-text">Спикер:</p>
                                    <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                        <img loading=""
                                            src="https://storage.yandexcloud.net/cdn.careerum.com/1790539811095-wJPA6-Spea.png"
                                            alt="img" class="hidden-mobile" />
                                        <img loading=""
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005407-tQ1J0-Spea.png"
                                            alt="img" class="hidden-desc-tablet" />
                                        <div>
                                            <p class="awake-schedule-item-speakers-name">Ольга Пешкова</p>
                                            <p class="awake-schedule-item-speakers-position">Карьерный консультант
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p >Эфир</p>
                                        <p >
                                            <a onclick="" href="" class="link"></a>
                                            12 октября, 20:00 мск
                                        </p>
                                    </div>
                                    <p class="awake-schedule-item-header">Онлайн коворкинг </p>
                                    <p class="awake-schedule-item-text">Спикер:</p>
                                    <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                        <img loading=""
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743791962-REiQe-Spea.png"
                                            alt="img" class="hidden-mobile" />
                                        <img loading=""
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005407-tQ1J0-Spea.png"
                                            alt="img" class="hidden-desc-tablet" />
                                        <div>
                                            <p class="awake-schedule-item-speakers-name">Майя Бурякина</p>
                                            <p class="awake-schedule-item-speakers-position">Коуч ACC ICF,
                                                США/Россия</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p >Эфир</p>
                                        <p >
                                            <a onclick="" href="" class="link"></a>
                                            15 октября, 19:30 мск
                                        </p>
                                    </div>
                                    <p class="awake-schedule-item-header">Real Me, Практикум 6 </p>
                                    <p class="awake-schedule-item-text">Спикер:</p>
                                    <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                        <img loading=""
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743791962-REiQe-Spea.png"
                                            alt="img" class="hidden-mobile" />
                                        <img loading=""
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005407-tQ1J0-Spea.png"
                                            alt="img" class="hidden-desc-tablet" />
                                        <div>
                                            <p class="awake-schedule-item-speakers-name">Майя Бурякина</p>
                                            <p class="awake-schedule-item-speakers-position">Коуч ACC ICF,
                                                США/Россия</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p >Онлайн-встреча</p>
                                        <p >
                                            <a onclick="" href="" class="link"></a>
                                            20 октября, 19:00 мск
                                        </p>
                                    </div>
                                    <p class="awake-schedule-item-header">
                                        Митап: «Как пробиться
                                        к<span> </span>
                                        рекрутерам через 500 откликов», рынок РФ
                                    </p>
                                </div>
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p >Онлайн-встреча</p>
                                        <p >
                                            <a onclick="" href="" class="link"></a>
                                            22 октября, 19:00 мск
                                        </p>
                                    </div>
                                    <p class="awake-schedule-item-header">
                                        Митап: «Как пробиться к<span> </span>
                                        рекрутерам через 500 откликов», международный рынок
                                    </p>
                                </div>
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p >Эфир</p>
                                        <p >
                                            <a onclick="" href="" class="link"></a>
                                            26 октября, 19:30 мск
                                        </p>
                                    </div>
                                    <p class="awake-schedule-item-header">
                                        Вводный эфир «Карьера в<span> </span>
                                        эпоху ИИ»
                                    </p>
                                    <p class="awake-schedule-item-text">Спикер:</p>
                                    <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                        <img loading=""
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743791962-REiQe-Spea.png"
                                            alt="img" class="hidden-mobile" />
                                        <img loading=""
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005407-tQ1J0-Spea.png"
                                            alt="img" class="hidden-desc-tablet" />
                                        <div>
                                            <p class="awake-schedule-item-speakers-name">Майя Бурякина</p>
                                            <p class="awake-schedule-item-speakers-position">Коуч ACC ICF,
                                                США/Россия</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p >Эфир</p>
                                        <p >
                                            <a onclick="" href="" class="link"></a>
                                            29 октября, 20:00 мск
                                        </p>
                                    </div>
                                    <p class="awake-schedule-item-header">Книжный клуб </p>
                                    <p class="awake-schedule-item-text">Спикер:</p>
                                    <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                        <img loading=""
                                            src="https://storage.yandexcloud.net/cdn.careerum.com/1773142636660-mEaMF-Spea.png"
                                            alt="img" class="hidden-mobile" />
                                        <img loading=""
                                            src="https://storage.yandexcloud.net/cdn.careerum.com/1773142946175-SXJTe-Spea.png"
                                            alt="img" class="hidden-desc-tablet" />
                                        <div>
                                            <p class="awake-schedule-item-speakers-name">Олеся Спиридонова</p>
                                            <p class="awake-schedule-item-speakers-position">Коуч-практик</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="club50-schedule2-slider-nav careerum-flex-fec">
                                <div class="club50-schedule2-nav-prev careerum-flex-cc">
                                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white"
                                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white"
                                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                </div>
                                <div class="club50-schedule2-nav-next careerum-flex-cc">
                                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white"
                                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white"
                                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div class="club50-schedule2-wrapper">
                            <div class="club50-schedule2-title careerum-flex-sbfs">
                                <div class="club50-schedule2-title-left">
                                    <p class="club50-schedule2-mounth">Ноябрь
                                    </p>
                                </div>
                                <div class="club50-schedule2-title-right careerum-flex-cc">
                                    <svg width="46" height="46" viewBox="0 0 46 46" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" class="hidden-tablet-mobile">
                                        <path d="M11.7151 34.5715L34.5723 11.7144" stroke="#191C20"
                                            stroke-width="2.85714" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M16.0008 11.7142H34.5723V30.2856" stroke="#191C20"
                                            stroke-width="2.85714" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                    <svg width="38" height="38" viewBox="0 0 38 38" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" class="hidden-desc-mobile">
                                        <path d="M9.9721 28.4097L28.2578 10.124" stroke="#191C20"
                                            stroke-width="2.28571" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M13.4007 10.1238H28.2578V24.981" stroke="#191C20"
                                            stroke-width="2.28571" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" class="hidden-desc-tablet">
                                        <path d="M8.38105 23.5981L23.6191 8.36005" stroke="#191C20"
                                            stroke-width="1.90476" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M11.2382 8.36026H23.6191V20.7412" stroke="#191C20"
                                            stroke-width="1.90476" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                </div>
                            </div>
                            <div class="club50-schedule2-slider">
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p >Эфир</p>
                                        <p >
                                            <a onclick="" href="" class="link"></a>
                                            2 ноября, 20:00 мск
                                        </p>
                                    </div>
                                    <p class="awake-schedule-item-header">
                                        От желания к<span> </span>
                                        результату
                                    </p>
                                    <p class="awake-schedule-item-text">Спикер:</p>
                                    <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                        <img loading=""
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743791962-REiQe-Spea.png"
                                            alt="img" class="hidden-mobile" />
                                        <img loading=""
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005407-tQ1J0-Spea.png"
                                            alt="img" class="hidden-desc-tablet" />
                                        <div>
                                            <p class="awake-schedule-item-speakers-name">Майя Бурякина</p>
                                            <p class="awake-schedule-item-speakers-position">Коуч ACC ICF,
                                                США/Россия</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p >Эфир</p>
                                        <p >10 ноября, 19:00 мск </p>
                                    </div>
                                    <p class="awake-schedule-item-header">
                                        Прожарка резюме. Рынок<span> </span>
                                        РФ
                                    </p>
                                    <p class="awake-schedule-item-text">Спикер:</p>
                                    <div class="awake-schedule-item-speakers">
                                        <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                            <img loading=""
                                                src="https://storage.yandexcloud.net/cdn.careerum.com/1790539811095-wJPA6-Spea.png"
                                                alt="img" class="hidden-mobile" />
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005407-tQ1J0-Spea.png"
                                                alt="img" class="hidden-desc-tablet" />
                                            <div>
                                                <p class="awake-schedule-item-speakers-name">Ольга Пешкова</p>
                                                <p class="awake-schedule-item-speakers-position">Карьерный
                                                    консультант</p>
                                            </div>
                                        </div>
                                        <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753947490109-jxjDE-Spea.png"
                                                alt="img" class="hidden-mobile" />
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744006008-TKe0o-Spea.png"
                                                alt="img" class="hidden-desc-tablet" />
                                            <div>
                                                <p class="awake-schedule-item-speakers-name">Николай Пулин </p>
                                                <p class="awake-schedule-item-speakers-position">Карьерный эксперт
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p >Эфир</p>
                                        <p >11 ноября, 19:00 мск </p>
                                    </div>
                                    <p class="awake-schedule-item-header">Прожарка резюме / LinkedIn.
                                        Международный рынок</p>
                                    <p class="awake-schedule-item-text">Спикер:</p>
                                    <div class="awake-schedule-item-speakers">
                                        <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                            <img loading=""
                                                src="https://storage.yandexcloud.net/cdn.careerum.com/1790539811095-wJPA6-Spea.png"
                                                alt="img" class="hidden-mobile" />
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005407-tQ1J0-Spea.png"
                                                alt="img" class="hidden-desc-tablet" />
                                            <div>
                                                <p class="awake-schedule-item-speakers-name">Ольга Пешкова</p>
                                                <p class="awake-schedule-item-speakers-position">Карьерный
                                                    консультант</p>
                                            </div>
                                        </div>
                                        <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753947490109-jxjDE-Spea.png"
                                                alt="img" class="hidden-mobile" />
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744006008-TKe0o-Spea.png"
                                                alt="img" class="hidden-desc-tablet" />
                                            <div>
                                                <p class="awake-schedule-item-speakers-name">Николай Пулин </p>
                                                <p class="awake-schedule-item-speakers-position">Карьерный эксперт
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p >Эфир</p>
                                        <p >
                                            <a onclick="" href="" class="link"></a>
                                            12 ноября, 20:00 мск
                                        </p>
                                    </div>
                                    <p class="awake-schedule-item-header">Онлайн коворкинг </p>
                                    <p class="awake-schedule-item-text">Спикер:</p>
                                    <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                        <img loading=""
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743791962-REiQe-Spea.png"
                                            alt="img" class="hidden-mobile" />
                                        <img loading=""
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005407-tQ1J0-Spea.png"
                                            alt="img" class="hidden-desc-tablet" />
                                        <div>
                                            <p class="awake-schedule-item-speakers-name">Майя Бурякина</p>
                                            <p class="awake-schedule-item-speakers-position">Коуч ACC ICF,
                                                США/Россия</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p >Онлайн-встреча</p>
                                        <p >18 ноября, 19:00 мск </p>
                                    </div>
                                    <p class="awake-schedule-item-header">Crash-Test Job Interview
                                        на английском</p>
                                    <ul ></ul>
                                    <p class="awake-schedule-item-text">Спикер:</p>
                                    <div class="awake-schedule-item-speakers">
                                        <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                            <img loading=""
                                                src="https://storage.yandexcloud.net/cdn.careerum.com/1790539811095-wJPA6-Spea.png"
                                                alt="img" class="hidden-mobile" />
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005407-tQ1J0-Spea.png"
                                                alt="img" class="hidden-desc-tablet" />
                                            <div>
                                                <p class="awake-schedule-item-speakers-name">Ольга Пешкова</p>
                                                <p class="awake-schedule-item-speakers-position">Карьерный
                                                    консультант</p>
                                            </div>
                                        </div>
                                        <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753947490109-jxjDE-Spea.png"
                                                alt="img" class="hidden-mobile" />
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744006008-TKe0o-Spea.png"
                                                alt="img" class="hidden-desc-tablet" />
                                            <div>
                                                <p class="awake-schedule-item-speakers-name">Николай Пулин </p>
                                                <p class="awake-schedule-item-speakers-position">Карьерный эксперт
                                                </p>
                                            </div>
                                        </div>
                                        <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743792734-G1EgK-Spea.png"
                                                alt="img" class="hidden-mobile" />
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744006369-cjdCF-Spea.png"
                                                alt="img" class="hidden-desc-tablet" />
                                            <div>
                                                <p class="awake-schedule-item-speakers-name">Ольга Колобкова</p>
                                                <p class="awake-schedule-item-speakers-position">Руководитель
                                                    Kolobkova School и
                                                    амбассадор Careerum</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p >Онлайн-встреча</p>
                                        <p >22 ноября, 19:00 мск </p>
                                    </div>
                                    <p class="awake-schedule-item-header">Crash-Test Job Interview
                                        на русском</p>
                                    <ul ></ul>
                                    <p class="awake-schedule-item-text">Спикер:</p>
                                    <div class="awake-schedule-item-speakers">
                                        <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                            <img loading=""
                                                src="https://storage.yandexcloud.net/cdn.careerum.com/1790539811095-wJPA6-Spea.png"
                                                alt="img" class="hidden-mobile" />
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005407-tQ1J0-Spea.png"
                                                alt="img" class="hidden-desc-tablet" />
                                            <div>
                                                <p class="awake-schedule-item-speakers-name">Ольга Пешкова</p>
                                                <p class="awake-schedule-item-speakers-position">Карьерный
                                                    консультант</p>
                                            </div>
                                        </div>
                                        <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753947490109-jxjDE-Spea.png"
                                                alt="img" class="hidden-mobile" />
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744006008-TKe0o-Spea.png"
                                                alt="img" class="hidden-desc-tablet" />
                                            <div>
                                                <p class="awake-schedule-item-speakers-name">Николай Пулин </p>
                                                <p class="awake-schedule-item-speakers-position">Карьерный эксперт
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p >Эфир</p>
                                        <p >30 ноября, 19:30 мск </p>
                                    </div>
                                    <p class="awake-schedule-item-header">
                                        Q &amp;A сессия «Карьера в<span> </span>
                                        эпоху AI»
                                    </p>
                                    <p class="awake-schedule-item-text">Спикер:</p>
                                    <div class="awake-schedule-item-speakers">
                                        <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743791962-REiQe-Spea.png"
                                                alt="img" class="hidden-mobile" />
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005407-tQ1J0-Spea.png"
                                                alt="img" class="hidden-desc-tablet" />
                                            <div>
                                                <p class="awake-schedule-item-speakers-name">Майя Бурякина</p>
                                                <p class="awake-schedule-item-speakers-position">Коуч ACC ICF,
                                                    США/Россия</p>
                                            </div>
                                        </div>
                                        <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                            <img loading=""
                                                src="https://storage.yandexcloud.net/cdn.careerum.com/1790540478385-4DPTZ-Spea.png"
                                                alt="img" class="hidden-mobile" />
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744006008-TKe0o-Spea.png"
                                                alt="img" class="hidden-desc-tablet" />
                                            <div>
                                                <p class="awake-schedule-item-speakers-name">Иннокентий Солнцев
                                                </p>
                                                <p class="awake-schedule-item-speakers-position">Co-founder и CTO
                                                careerum</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="club50-schedule2-slider-nav careerum-flex-fec">
                                <div class="club50-schedule2-nav-prev careerum-flex-cc">
                                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white"
                                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white"
                                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                </div>
                                <div class="club50-schedule2-nav-next careerum-flex-cc">
                                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white"
                                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white"
                                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div class="club50-schedule2-wrapper">
                            <div class="club50-schedule2-title careerum-flex-sbfs">
                                <div class="club50-schedule2-title-left">
                                    <p class="club50-schedule2-mounth">Декабрь
                                    </p>
                                </div>
                                <div class="club50-schedule2-title-right careerum-flex-cc">
                                    <svg width="46" height="46" viewBox="0 0 46 46" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" class="hidden-tablet-mobile">
                                        <path d="M11.7151 34.5715L34.5723 11.7144" stroke="#191C20"
                                            stroke-width="2.85714" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M16.0008 11.7142H34.5723V30.2856" stroke="#191C20"
                                            stroke-width="2.85714" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                    <svg width="38" height="38" viewBox="0 0 38 38" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" class="hidden-desc-mobile">
                                        <path d="M9.9721 28.4097L28.2578 10.124" stroke="#191C20"
                                            stroke-width="2.28571" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M13.4007 10.1238H28.2578V24.981" stroke="#191C20"
                                            stroke-width="2.28571" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" class="hidden-desc-tablet">
                                        <path d="M8.38105 23.5981L23.6191 8.36005" stroke="#191C20"
                                            stroke-width="1.90476" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M11.2382 8.36026H23.6191V20.7412" stroke="#191C20"
                                            stroke-width="1.90476" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                </div>
                            </div>
                            <div class="club50-schedule2-slider">
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p >Эфир</p>
                                        <p >21 декабря, 21:00 мск </p>
                                    </div>
                                    <p class="awake-schedule-item-header">Careerum Ёлка </p>
                                    <p class="awake-schedule-item-text hidden">Спикер:</p>
                                    <div class="awake-schedule-item-speakers hidden">
                                        <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743793428-R4J4f-Spea.png"
                                                alt="img" class="hidden-mobile" />
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005080-6BLKw-Spea.png"
                                                alt="img" class="hidden-desc-tablet" />
                                            <div>
                                                <p class="awake-schedule-item-speakers-name">Ольга Лермонтова</p>
                                                <p class="awake-schedule-item-speakers-position">Основательница
                                                careerum</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p >Эфир</p>
                                        <p >28 декбря, 19:00 мск </p>
                                    </div>
                                    <p class="awake-schedule-item-header">Книжный клуб</p>
                                    <p class="awake-schedule-item-text hidden">Что узнаете:</p>
                                    <ul class="hidden">
                                        <li >Эта встреча — пространство для обретения поддержки
                                            и активации вашего потенциала.
                                            Вы сможете расширить свою сеть контактов</li>
                                    </ul>
                                    <p class="awake-schedule-item-text">Спикер:</p>
                                    <div class="awake-schedule-item-speakers">
                                        <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                            <img loading=""
                                                src="https://storage.yandexcloud.net/cdn.careerum.com/1773142636660-mEaMF-Spea.png"
                                                alt="img" class="hidden-mobile" />
                                            <img loading=""
                                                src="https://storage.yandexcloud.net/cdn.careerum.com/1773142946175-SXJTe-Spea.png"
                                                alt="img" class="hidden-desc-tablet" />
                                            <div>
                                                <p class="awake-schedule-item-speakers-name">Олеся Спиридонова</p>
                                                <p class="awake-schedule-item-speakers-position">Коуч-практик</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="club50-schedule2-slider-nav careerum-flex-fec">
                                <div class="club50-schedule2-nav-prev careerum-flex-cc">
                                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white"
                                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white"
                                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                </div>
                                <div class="club50-schedule2-nav-next careerum-flex-cc">
                                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white"
                                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white"
                                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div class="club50-schedule2-wrapper">
                            <div class="club50-schedule2-title careerum-flex-sbfs">
                                <div class="club50-schedule2-title-left">
                                    <p class="club50-schedule2-mounth">
                                        Ноябрь
                                    </p>
                                    <p class="club50-schedule2-header">Кризис середины карьеры</p>
                                </div>
                                <div
                                class="club50-schedule2-title-right careerum-flex-cc opacity-50 pointer-none">
                                    <svg width="46" height="46" viewBox="0 0 46 46" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" class="hidden-tablet-mobile">
                                        <path d="M11.7151 34.5715L34.5723 11.7144" stroke="#191C20"
                                            stroke-width="2.85714" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M16.0008 11.7142H34.5723V30.2856" stroke="#191C20"
                                            stroke-width="2.85714" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                    <svg width="38" height="38" viewBox="0 0 38 38" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" class="hidden-desc-mobile">
                                        <path d="M9.9721 28.4097L28.2578 10.124" stroke="#191C20"
                                            stroke-width="2.28571" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M13.4007 10.1238H28.2578V24.981" stroke="#191C20"
                                            stroke-width="2.28571" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" class="hidden-desc-tablet">
                                        <path d="M8.38105 23.5981L23.6191 8.36005" stroke="#191C20"
                                            stroke-width="1.90476" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M11.2382 8.36026H23.6191V20.7412" stroke="#191C20"
                                            stroke-width="1.90476" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                </div>
                            </div>
                            <div class="club50-schedule2-slider">
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p>Эфир</p>
                                        <p>7 октября 19:00 мск </p>
                                    </div>
                                    <p class="awake-schedule-item-header">Лекция по Leadership
                                        от Ольги Лермонтовой </p>
                                    <p class="awake-schedule-item-text">Что узнаете:</p>
                                    <ul>
                                        <li>Что такое лидерство в 2025 году </li>
                                        <li>Как проявлять лидерские качества, даже не будучи руководителем</li>
                                        <li>Почему soft skills — основа карьерного роста</li>
                                    </ul>
                                    <p class="awake-schedule-item-text">Спикер:</p>
                                    <div class="awake-schedule-item-speakers">
                                        <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743793428-R4J4f-Spea.png"
                                                alt="img" class="hidden-mobile" />
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005080-6BLKw-Spea.png"
                                                alt="img" class="hidden-desc-tablet" />
                                            <div>
                                                <p class="awake-schedule-item-speakers-name">Ольга Лермонтова</p>
                                                <p class="awake-schedule-item-speakers-position">Основательница
                                                careerum</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p>Эфир</p>
                                        <p>12 октября 12:00 мск </p>
                                    </div>
                                    <p class="awake-schedule-item-header">Еnglish Spеaking Club </p>
                                    <p class="awake-schedule-item-text">Что узнаете:</p>
                                    <ul>
                                        <li>На встрече вы прокачаете разговорный английский и расширите нетворк.
                                            Встреча подходит для уровня B1-B2</li>
                                    </ul>
                                    <p class="awake-schedule-item-text">Спикер:</p>
                                    <div class="awake-schedule-item-speakers">
                                        <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743792734-G1EgK-Spea.png"
                                                alt="img" class="hidden-mobile" />
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744006369-cjdCF-Spea.png"
                                                alt="img" class="hidden-desc-tablet" />
                                            <div>
                                                <p class="awake-schedule-item-speakers-name">Ольга Колобкова</p>
                                                <p class="awake-schedule-item-speakers-position">Руководитель
                                                    Kolobkova School и
                                                    амбассадор Careerum</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p>Эфир</p>
                                        <p>14 октября 19:00 мск </p>
                                    </div>
                                    <p class="awake-schedule-item-header">Поиск и формулирование достижений</p>
                                    <p class="awake-schedule-item-text">Что узнаете:</p>
                                    <ul>
                                        <li>Как превратить опыт в сильные достижения</li>
                                        <li>Что важно работодателю и менеджеру</li>
                                        <li>Готовые формулировки
                                            для резюме, интервью
                                            и performance review </li>
                                    </ul>
                                    <p class="awake-schedule-item-text jgj">
                                        Спикеры: <b>Эксперты Careerum</b>
                                    </p>
                                </div>
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p>Эфир</p>
                                        <p>21 октября 19:00 мск </p>
                                    </div>
                                    <p class="awake-schedule-item-header">Эффективные коммуникации</p>
                                    <p class="awake-schedule-item-text">Что узнаете:</p>
                                    <ul>
                                        <li>Как говорить с коллегами, чтобы быть услышанным</li>
                                        <li>Как давать и получать обратную связь</li>
                                        <li>Типичные примеры рабочих коммуникаций</li>
                                    </ul>
                                    <p class="awake-schedule-item-text">Спикеры:</p>
                                    <div class="awake-schedule-item-speakers">
                                        <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753985535278-iLeDB-Spea.png"
                                                alt="img" class="hidden-mobile" />
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744006369-cjdCF-Spea.png"
                                                alt="img" class="hidden-desc-tablet" />
                                            <div>
                                                <p class="awake-schedule-item-speakers-name">Михаил Ромашов </p>
                                                <p class="awake-schedule-item-speakers-position">Тренер по
                                                    коммуникациям
                                                    и soft skills</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p>Эфир</p>
                                        <p>26 октября 12:00 мск </p>
                                    </div>
                                    <p class="awake-schedule-item-header">Нетворкинговая встреча</p>
                                    <p class="awake-schedule-item-text">Что узнаете:</p>
                                    <ul>
                                        <li>Эта встреча — пространство для обретения поддержки
                                            и активации вашего потенциала.
                                            Вы сможете расширить свою сеть контактов</li>
                                    </ul>
                                    <p class="awake-schedule-item-text">Спикер:</p>
                                    <div class="awake-schedule-item-speakers">
                                        <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743793091-yxprW-Spea.png"
                                                alt="img" class="hidden-mobile" />
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744006900-ps5q1-Spea.png"
                                                alt="img" class="hidden-desc-tablet" />
                                            <div>
                                                <p class="awake-schedule-item-speakers-name">Елена Шеховцова</p>
                                                <p class="awake-schedule-item-speakers-position">Амбассадор
                                                careerum</p>
                                            </div>
                                        </div>
                                        <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743793247-OiJE7-Spea.png"
                                                alt="img" class="hidden-mobile" />
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744007108-Uwk7W-Spea.png"
                                                alt="img" class="hidden-desc-tablet" />
                                            <div>
                                                <p class="awake-schedule-item-speakers-name">Кирилл Азаренко</p>
                                                <p class="awake-schedule-item-speakers-position">Амбассадор
                                                careerum</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p>Эфир</p>
                                        <p>30 октября 19:00 мск </p>
                                    </div>
                                    <p class="awake-schedule-item-header">Практикум по Leadership</p>
                                    <p class="awake-schedule-item-text">Что узнаете:</p>
                                    <ul>
                                        <li>Прокачаете ключевые лидерские навыки через практические задания</li>
                                        <li>Научитесь управлять собой
                                            и влиянием на других</li>
                                        <li>Получите обратную связь
                                            от карьерных экспертов</li>
                                    </ul>
                                    <p class="awake-schedule-item-text jgj">
                                        Спикеры: <b>Эксперты Careerum</b>
                                    </p>
                                </div>
                            </div>
                            <div class="club50-schedule2-slider-nav careerum-flex-fec">
                                <div class="club50-schedule2-nav-prev careerum-flex-cc">
                                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white"
                                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white"
                                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                </div>
                                <div class="club50-schedule2-nav-next careerum-flex-cc">
                                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white"
                                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white"
                                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div class="club50-schedule2-wrapper">
                            <div class="club50-schedule2-title careerum-flex-sbfs">
                                <div class="club50-schedule2-title-left">
                                    <p class="club50-schedule2-mounth">
                                        Декабрь
                                    </p>
                                    <p class="club50-schedule2-header">В 2026 с планом, который сработает</p>
                                </div>
                                <div
                                class="club50-schedule2-title-right careerum-flex-cc pointer-none opacity-50">
                                    <svg width="46" height="46" viewBox="0 0 46 46" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" class="hidden-tablet-mobile">
                                        <path d="M11.7151 34.5715L34.5723 11.7144" stroke="#191C20"
                                            stroke-width="2.85714" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M16.0008 11.7142H34.5723V30.2856" stroke="#191C20"
                                            stroke-width="2.85714" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                    <svg width="38" height="38" viewBox="0 0 38 38" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" class="hidden-desc-mobile">
                                        <path d="M9.9721 28.4097L28.2578 10.124" stroke="#191C20"
                                            stroke-width="2.28571" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M13.4007 10.1238H28.2578V24.981" stroke="#191C20"
                                            stroke-width="2.28571" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" class="hidden-desc-tablet">
                                        <path d="M8.38105 23.5981L23.6191 8.36005" stroke="#191C20"
                                            stroke-width="1.90476" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M11.2382 8.36026H23.6191V20.7412" stroke="#191C20"
                                            stroke-width="1.90476" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                </div>
                            </div>
                            <div class="club50-schedule2-slider">
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p>Эфир</p>
                                        <p >7 октября 19:00 мск </p>
                                    </div>
                                    <p class="awake-schedule-item-header">Лекция по Leadership
                                        от Ольги Лермонтовой </p>
                                    <p class="awake-schedule-item-text">Что узнаете:</p>
                                    <ul>
                                        <li >Что такое лидерство в 2025 году </li>
                                        <li >Как проявлять лидерские качества, даже не будучи
                                            руководителем</li>
                                        <li >Почему soft skills — основа карьерного роста</li>
                                    </ul>
                                    <p class="awake-schedule-item-text">Спикер:</p>
                                    <div class="awake-schedule-item-speakers">
                                        <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743793428-R4J4f-Spea.png"
                                                alt="img" class="hidden-mobile" />
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744005080-6BLKw-Spea.png"
                                                alt="img" class="hidden-desc-tablet" />
                                            <div>
                                                <p class="awake-schedule-item-speakers-name">Ольга Лермонтова</p>
                                                <p class="awake-schedule-item-speakers-position">Основательница
                                                careerum</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p>Эфир</p>
                                        <p >12 октября 12:00 мск </p>
                                    </div>
                                    <p class="awake-schedule-item-header">Еnglish Spеaking Club </p>
                                    <p class="awake-schedule-item-text">Что узнаете:</p>
                                    <ul>
                                        <li >На встрече вы прокачаете разговорный английский и
                                            расширите нетворк. Встреча подходит для уровня B1-B2</li>
                                    </ul>
                                    <p class="awake-schedule-item-text">Спикер:</p>
                                    <div class="awake-schedule-item-speakers">
                                        <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743792734-G1EgK-Spea.png"
                                                alt="img" class="hidden-mobile" />
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744006369-cjdCF-Spea.png"
                                                alt="img" class="hidden-desc-tablet" />
                                            <div>
                                                <p class="awake-schedule-item-speakers-name">Ольга Колобкова</p>
                                                <p class="awake-schedule-item-speakers-position">Руководитель
                                                    Kolobkova School и
                                                    амбассадор Careerum</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p>Эфир</p>
                                        <p >14 октября 19:00 мск </p>
                                    </div>
                                    <p class="awake-schedule-item-header">Поиск и формулирование достижений</p>
                                    <p class="awake-schedule-item-text">Что узнаете:</p>
                                    <ul>
                                        <li >Как превратить опыт в сильные достижения</li>
                                        <li >Что важно работодателю и менеджеру</li>
                                        <li >Готовые формулировки
                                            для резюме, интервью
                                            и performance review </li>
                                    </ul>
                                    <p class="awake-schedule-item-text jgj">
                                        Спикеры: <b>Эксперты Careerum</b>
                                    </p>
                                </div>
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p>Эфир</p>
                                        <p >21 октября 19:00 мск </p>
                                    </div>
                                    <p class="awake-schedule-item-header">Эффективные коммуникации</p>
                                    <p class="awake-schedule-item-text">Что узнаете:</p>
                                    <ul>
                                        <li >Как говорить с коллегами, чтобы быть услышанным</li>
                                        <li >Как давать и получать обратную связь</li>
                                        <li >Типичные примеры рабочих коммуникаций</li>
                                    </ul>
                                    <p class="awake-schedule-item-text">Спикеры:</p>
                                    <div class="awake-schedule-item-speakers">
                                        <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753985535278-iLeDB-Spea.png"
                                                alt="img" class="hidden-mobile" />
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744006369-cjdCF-Spea.png"
                                                alt="img" class="hidden-desc-tablet" />
                                            <div>
                                                <p class="awake-schedule-item-speakers-name">Михаил Ромашов </p>
                                                <p class="awake-schedule-item-speakers-position">Тренер по
                                                    коммуникациям
                                                    и soft skills</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p>Эфир</p>
                                        <p >26 октября 12:00 мск </p>
                                    </div>
                                    <p class="awake-schedule-item-header">Нетворкинговая встреча</p>
                                    <p class="awake-schedule-item-text">Что узнаете:</p>
                                    <ul>
                                        <li >Эта встреча — пространство для обретения поддержки
                                            и активации вашего потенциала.
                                            Вы сможете расширить свою сеть контактов</li>
                                    </ul>
                                    <p class="awake-schedule-item-text">Спикер:</p>
                                    <div class="awake-schedule-item-speakers">
                                        <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743793091-yxprW-Spea.png"
                                                alt="img" class="hidden-mobile" />
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744006900-ps5q1-Spea.png"
                                                alt="img" class="hidden-desc-tablet" />
                                            <div>
                                                <p class="awake-schedule-item-speakers-name">Елена Шеховцова</p>
                                                <p class="awake-schedule-item-speakers-position">Амбассадор
                                                careerum</p>
                                            </div>
                                        </div>
                                        <div class="careerum-flex-fsc awake-schedule-item-speaker">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752743793247-OiJE7-Spea.png"
                                                alt="img" class="hidden-mobile" />
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744007108-Uwk7W-Spea.png"
                                                alt="img" class="hidden-desc-tablet" />
                                            <div>
                                                <p class="awake-schedule-item-speakers-name">Кирилл Азаренко</p>
                                                <p class="awake-schedule-item-speakers-position">Амбассадор
                                                careerum</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="awake-schedule-item">
                                    <div class="awake-schedule-item-labels careerum-flex-fsfs">
                                        <p>Эфир</p>
                                        <p>30 октября 19:00 мск </p>
                                    </div>
                                    <p class="awake-schedule-item-header">Практикум по Leadership</p>
                                    <p class="awake-schedule-item-text">Что узнаете:</p>
                                    <ul>
                                        <li>Прокачаете ключевые лидерские навыки через практические задания</li>
                                        <li>Научитесь управлять собой
                                            и влиянием на других</li>
                                        <li>Получите обратную связь
                                            от карьерных экспертов</li>
                                    </ul>
                                    <p class="awake-schedule-item-text jgj">
                                        Спикеры: <b>Эксперты Careerum</b>
                                    </p>
                                </div>
                            </div>
                            <div class="club50-schedule2-slider-nav careerum-flex-fec">
                                <div class="club50-schedule2-nav-prev careerum-flex-cc">
                                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white"
                                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white"
                                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                </div>
                                <div class="club50-schedule2-nav-next careerum-flex-cc">
                                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white"
                                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white"
                                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-club50-platform', {
        label: 'Club 50 platform (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club50-platform main-wrapper">
        <div class="careerum-container-responsive">
            <h2>Образовательная платформа в вашем телефоне</h2>
            <div class="club50-platform-wrapper">
                <div class="club50-platform-item form">
                    <p class="club50-platform-item-header">Карьерный навигатор</p>
                    <p class="club50-platform-item-text"><span>Пройдите тест</span> и получите индивидуальную программу,
                        адаптированную под ваши карьерные
                        цели</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755705367488-GPX0r-Cont.png"
                        class="hidden-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755791969676-slH3Q-Cont.png" class="hidden-desc-tablet"
                        alt="img">
                    <div class="careerum-registration-form-club40">
                        <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                            data-gjs-type="deva-registration-form">
                            <div class="careerum-club40-form-name">
                                <input type="text" name="name" value="" required placeholder="Имя">
                                <p class="careerum-club40-form-warn">Поле не заполнено</p>
                            </div>
                            <div class="careerum-club40-form-telegram">
                                <input type="text" name="telegram" value="" required placeholder="Telegram">
                                <p class="careerum-club40-form-warn">Поле не заполнено</p>
                            </div>
                            <div class="careerum-club40-form-email">
                                <input type="text" name="email" value="" required placeholder="Почта">
                                <p class="careerum-club40-form-warn">Поле не заполнено</p>
                            </div>
                            <div class="careerum-club40-form-phone">
                                <input type="tel" value="" name="tel" required class="itl-input">
                                <p class="careerum-club40-form-warn">Поле не заполнено</p>
                            </div>
                            <div class="careerum-club40-form-agree">
                                <label>
                                    <input type="checkbox" name="agree">
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                            fill="none">
                                            <path
                                                d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                        </svg>
                                    </div>
                                </label>
                                <p>Я даю согласие на обработку
                                    персональных
                                    данных
                                    в соответствии с <a href="#">Политикой конфиденциальности</a>.</p>
                            </div>
                            <a href="#" class="submit-btn btn-color-main-dark-orange" disabled>Подобрать
                                программу</a>
                            <input type="hidden" hidden name="offerID" value="">
                        </form>
                    </div>
                </div>
                <div class="club50-platform-item img">
                    <p class="club50-platform-item-header">
                        Личный кабинет
                    </p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755706057175-YCbr1-Cont.png"
                        class="hidden-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755791970097-a7obk-Cont.png" class="hidden-desc-tablet"
                        alt="img">
                </div>
                <div class="club50-platform-item img">
                    <p class="club50-platform-item-header">
                        Быстрая навигация
                    </p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755706058275-DBBL2-Cont.png"
                        class="hidden-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755791970606-CBCXt-Cont.png" class="hidden-desc-tablet"
                        alt="img">
                </div>
                <div class="club50-platform-item img">
                    <p class="club50-platform-item-header">
                        Календарь ивентов
                    </p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755706057822-pX9Ge-Cont.png"
                        class="hidden-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755791972177-u1jE3-Cont.png" class="hidden-desc-tablet"
                        alt="img">
                </div>
            </div>
            <div class="club50-platform-slider-nav careerum-flex-fec">
                <div class="club50-platform-nav-prev careerum-flex-cc ">
                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="club50-platform-nav-next careerum-flex-cc">
                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club50-community', {
        label: 'Club 50 community (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club50-community main-wrapper">
        <div class="careerum-container-responsive">
            <h2>Поддерживающее сообщество</h2>
            <p>Русскоязычные профессионалы от junior до C-level</p>
            <div class="club0526-community-header position-relative">
                <h2 class="position-relative z-10">Закрытое профессиональное комьюнити</h2>
                <p class="position-relative z-10">Зрелые русскоязычные специалисты из 60+ стран: middle, senior, руководители</p>
                <img src="https://cdn.careerum.com/1780392824466-0agUJ-Fram.svg" class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                <img src="https://cdn.careerum.com/1780392826562-fGU7w-Fram.svg" class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                <img src="https://cdn.careerum.com/1780392828179-b32tY-Grou.svg" class="hidden-desc-tablet position-absolute z-1" alt="img" loading="lazy">
            </div>
            <div class="club50-community-wrapper">
                <div class="club50-community-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755708085899-pBiIe-Fram.png"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755786690232-xixTG-Fram.png"
                        class="hidden-desc-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755792851462-cuW9i-Fram.png" class="hidden-desc-tablet"
                        alt="img">
                    <p class="club50-community-item-header">Найдите классных коллег из своей сферы и страны</p>
                    <p class="club50-community-item-text">Знакомьтесь с людьми из нужных вам сфер, стран, компаний и
                        получайте поддержку клубовцев на карьерном пути</p>
                </div>
                <div class="club50-community-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755708084014-3r512-Cont.png"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755786429607-THbdE-Cont.png"
                        class="hidden-desc-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755792661346-iUnb0-Cont.png" class="hidden-desc-tablet"
                        alt="img">
                    <p class="club50-community-item-header">Ищите работу через нетворкинг</p>
                    <ul>
                        <li>Соберите информацию из первых уст о компании, в которую хотите попасть</li>
                        <li>Получить реферальные рекомендации на выбранные вакансии </li>
                    </ul>
                </div>
                <div class="club50-community-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755708084398-v8ZfC-Cont.png"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755786430353-oAZSB-Cont.png"
                        class="hidden-desc-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755792662182-SBFA4-Cont.png" class="hidden-desc-tablet"
                        alt="img">
                    <p class="club50-community-item-header">Разбирайте свои кейсы с карьерными экспертами</p>
                    <ul>
                        <li>Задавайте вопросы экспертам в чате, делитесь ситуациями на работе</li>
                        <li>Прорабатывайте ваш запрос на видеосессиях </li>
                        <li>Достигайте своих целей, благодаря глубокой и системной работе на консультациях</li>
                    </ul>
                </div>
                <div class="club50-community-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755708084652-Yhpom-Cont.png"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755786430905-yVecE-Cont.png"
                        class="hidden-desc-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755792662643-qoVRw-Cont.png" class="hidden-desc-tablet"
                        alt="img">
                    <p class="club50-community-item-header">Тренируйте английский для работы</p>
                    <p class="club50-community-item-text">Оттачивайте профессиональный английский бесплатно в кругу
                        единомышленников</p>
                </div>
                <div class="club50-community-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755708084984-XL390-Cont.png"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755786431434-W0sDF-Cont.png"
                        class="hidden-desc-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755792663730-9Hxmt-Cont.png" class="hidden-desc-tablet"
                        alt="img">
                    <p class="club50-community-item-header">Расширяйте карьерные связи</p>
                    <ul>
                        <li>Знакомьтесь в клубовцами на онлайн-встречах #light_network </li>
                        <li>Обменивайтесь инсайтами на встречах Coffee Buddy «один на один»</li>
                    </ul>
                </div>
                <div class="club50-community-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755708085188-lFTtS-Cont.png"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755786431755-7iehj-Cont.png"
                        class="hidden-desc-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755792664141-iThg2-Cont.png" class="hidden-desc-tablet"
                        alt="img">
                    <p class="club50-community-item-header">Учитесь с единомышленниками</p>
                    <p class="club50-community-item-text">Проходите обучающие курсы не в одиночку, а в «тройке» —
                        мини-команде. Так веселее и эффективнее: поддержка, обмен опытом и мотивация на каждом шаге!</p>
                </div>
                <div class="club50-community-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755708085392-JXprT-Cont.png"
                        class="hidden-tablet-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755786431955-qTtq0-Cont.png"
                        class="hidden-desc-mobile" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755792664435-gRRi9-Cont.png" class="hidden-desc-tablet"
                        alt="img">
                    <p class="club50-community-item-header">Встречайтесь оффлайн по всему миру</p>
                    <p class="club50-community-item-text">Заряжайтесь карьерным вдохновением на живых встречах клуба с
                        участниками и экспертами</p>
                </div>
            </div>
            <div class="club50-community-slider-nav careerum-flex-fec">
                <div class="club50-community-nav-prev careerum-flex-cc ">
                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="club50-community-nav-next careerum-flex-cc">
                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
            </div>
            <a href="#buy" class="btn-color-main-bright-orange position-relative z-20">Записаться в лист ожидания</a>
        </div>
            <div class="careerum-container-responsive">
                <div class="club0526-community-header position-relative">
                    <h2 class="position-relative z-10">Careerum — это профессиональное
                        комьюнити</h2>
                    <p class="position-relative z-10">Зрелые русскоязычные специалисты
                        из 60+ стран: middle, senior, руководители</p>
                    <img loading="lazy" src="https://cdn.careerum.com/1780392824466-0agUJ-Fram.svg" alt="img"
                        class="hidden-tablet-mobile position-absolute z-1" />
                    <img loading="lazy" src="https://cdn.careerum.com/1780392826562-fGU7w-Fram.svg" alt="img"
                        class="hidden-desc-mobile position-absolute z-1" />
                    <img loading="lazy" src="https://cdn.careerum.com/1780392828179-b32tY-Grou.svg" alt="img"
                        class="hidden-desc-tablet position-absolute z-1" />
                </div>
                <div class="club50-community-wrapper">
                    <div class="club50-community-item">
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755708085899-pBiIe-Fram.png"
                            alt="img" class="hidden-tablet-mobile" />
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755786690232-xixTG-Fram.png"
                            alt="img" class="hidden-desc-mobile" />
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755792851462-cuW9i-Fram.png"
                            alt="img" class="hidden-desc-tablet" />
                        <p class="club50-community-item-header">Найдите классных
                            коллег из своей сферы и страны</p>
                        <p class="club50-community-item-text">Знакомьтесь с людьми из
                            нужных вам сфер, стран, компаний и
                            получайте поддержку клубовцев на карьерном пути</p>
                    </div>
                    <div class="club50-community-item">
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755708084014-3r512-Cont.png"
                            alt="img" class="hidden-tablet-mobile" />
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755786429607-THbdE-Cont.png"
                            alt="img" class="hidden-desc-mobile" />
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755792661346-iUnb0-Cont.png"
                            alt="img" class="hidden-desc-tablet" />
                        <p class="club50-community-item-header">Ищите работу через
                            нетворкинг</p>
                        <ul>
                            <li id="ixy8yfr">Соберите информацию из первых уст о
                                компании, в которую хотите попасть</li>
                            <li id="ir16vrh">Получить реферальные рекомендации на
                                выбранные вакансии </li>
                        </ul>
                    </div>
                    <div class="club50-community-item">
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755708084398-v8ZfC-Cont.png"
                            alt="img" class="hidden-tablet-mobile" />
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755786430353-oAZSB-Cont.png"
                            alt="img" class="hidden-desc-mobile" />
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755792662182-SBFA4-Cont.png"
                            alt="img" class="hidden-desc-tablet" />
                        <p class="club50-community-item-header">Разбирайте свои кейсы
                            с карьерными экспертами</p>
                        <ul>
                            <li>Задавайте вопросы экспертам в чате, делитесь
                                ситуациями на работе</li>
                            <li>Прорабатывайте ваш запрос на видеосессиях </li>
                            <li>Достигайте своих целей, благодаря глубокой и системной
                                работе на консультациях</li>
                        </ul>
                    </div>
                    <div class="club50-community-item">
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755708084652-Yhpom-Cont.png"
                            alt="img" class="hidden-tablet-mobile" />
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755786430905-yVecE-Cont.png"
                            alt="img" class="hidden-desc-mobile" />
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755792662643-qoVRw-Cont.png"
                            alt="img" class="hidden-desc-tablet" />
                        <p class="club50-community-item-header">Тренируйте английский
                            для работы</p>
                        <p class="club50-community-item-text">Оттачивайте
                            профессиональный английский бесплатно в кругу
                            единомышленников</p>
                    </div>
                    <div class="club50-community-item">
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755708084984-XL390-Cont.png"
                            alt="img" class="hidden-tablet-mobile" />
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755786431434-W0sDF-Cont.png"
                            alt="img" class="hidden-desc-mobile" />
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755792663730-9Hxmt-Cont.png"
                            alt="img" class="hidden-desc-tablet" />
                        <p class="club50-community-item-header">Расширяйте карьерные
                            связи</p>
                        <ul>
                            <li>Знакомьтесь в клубовцами на онлайн-встречах
                                #light_network </li>
                            <li>Обменивайтесь инсайтами на встречах Coffee Buddy «один
                                на один»</li>
                        </ul>
                    </div>
                    <div class="club50-community-item">
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755708085188-lFTtS-Cont.png"
                            alt="img" class="hidden-tablet-mobile" />
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755786431755-7iehj-Cont.png"
                            alt="img" class="hidden-desc-mobile" />
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755792664141-iThg2-Cont.png"
                            alt="img" class="hidden-desc-tablet" />
                        <p class="club50-community-item-header">Учитесь
                            с единомышленниками</p>
                        <p class="club50-community-item-text">Проходите обучающие
                            курсы не в одиночку, а в «тройке» —
                            мини-команде. Так веселее и эффективнее: поддержка, обмен опытом и мотивация на каждом шаге!</p>
                    </div>
                    <div class="club50-community-item">
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755708085392-JXprT-Cont.png"
                            alt="img" class="hidden-tablet-mobile" />
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755786431955-qTtq0-Cont.png"
                            alt="img" class="hidden-desc-mobile" />
                        <img loading=""
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755792664435-gRRi9-Cont.png"
                            alt="img" class="hidden-desc-tablet" />
                        <p class="club50-community-item-header">Встречайтесь оффлайн
                            по всему миру</p>
                        <p class="club50-community-item-text">Заряжайтесь карьерным
                            вдохновением на живых встречах клуба с
                            участниками и экспертами</p>
                    </div>
                </div>
                <div class="careerum-flex-fec club50-community-slider-nav">
                    <div aria-disabled="true" class="careerum-flex-cc club50-community-nav-prev">
                        <svg width=" 18" height=" 16" viewBox=" 0 0 18 16" fill=" none" xmlns=" http://www.w3.org/2000/svg">
                            <path d=" M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round">
                            </path>
                            <path d=" M8.46289 14.3859L2.18956 8.13924L8.46289
                                    1.89258" stroke=" white" stroke-width=" 2.64201" stroke-linecap=" round"
                                stroke-linejoin=" round">
                            </path>
                        </svg>
                    </div>
                    <div hide-by-geo=" unset" aria-disabled=" false" class=" careerum-flex-cc club50-community-nav-next">
                        <svg width=" 18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d=" M15.8095 8.14128L2.18945 8.14128" stroke=" white" stroke-width=" 2.64201"
                                stroke-linecap=" round" stroke-linejoin=" round">
                            </path>
                            <path d=" M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white"
                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round">
                            </path>
                        </svg>
                    </div>
                </div>
                <a onclick="" href="#buy" class="position-relative z-20 btn-color-main-black sdfg">Заполнить анкету в
                    Careerum </a>
            </div>
    </div>`
    });
    
    blockManager.add('careerum-club50-scanner2', {
        label: 'Club 50 scanner2 (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club50-scanner2 main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <div class="club50-scanner-wrapper position-relative z-20">
                <p class="club50-scanner-label">AI-сервис </p>
                <h2>Резюме <span>сканер</span></h2>
                <p class="club50-scanner-text">За 1 минуту узнайте, чего не хватает в вашем резюме для идеального
                    отклика на вакансию</p>
                <a href="#" class="btn-color-main-bright-orange">Попробовать</a>
            </div>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755714374461-g5wV4-Grou.png"
                class="hidden-tablet-mobile position-absolute z-10" alt="img">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755787445149-g9NXb-Fram.png"
                class="hidden-desc-mobile" alt="img">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755795727884-5Umga-Fram.png"
                class="hidden-desc-tablet" alt="img">
            <a href="#" class="btn-color-main-bright-orange">Попробовать</a>
        </div>
    </div>`
    });

    blockManager.add('careerum-club50-pay', {
        label: 'Club 50 pay (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div id="i5ricny" class="careerum-awake-pay main-wrapper realme50-pay club50-pay2 club0326-pay">
                <div class="careerum-container-responsive">
                    <h2 id="ir20vqm">Мы работаем в формате подписки </h2>
                    <div class="awake-pay-wrapper careerum-flex-sbst">
                        <div class="awake-pay-item wide">
                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746394899-9F8nI-Icon.svg" alt="img" class="hidden-tablet-mobile"/>
                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752835423588-vEsmQ-Icon.svg" alt="img" class="hidden-desc-mobile"/>
                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752927186355-hf8wS-Icon.svg" alt="img" class="hidden-desc-tablet"/>
                            <p id="iel2fut">
                                <span draggable="true">Чем дольше подписка, тем дешевле: </span>
                                мы поддерживаем регулярное и системное развитие карьеры. 
            Это наша философия!
                            </p>
                        </div>
                        <div class="awake-pay-item">
                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755802546412-qtSIZ-Calc.svg" alt="img" class="hidden-tablet-mobile"/>
                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755804858534-T0J0V-Calc.svg" alt="img" class="hidden-desc-mobile"/>
                            <img loading="" src="https://storage.yandexcloud.net/cdn.careerum.com/1768552000838-8gy1l-Calc.svg" alt="img" class="hidden-desc-tablet"/>
                            <p id="ibenthn">
                                <span draggable="true">Самый выгодный вариант: </span>
                                единый платеж 
            на 3, 6 или 12 месяцев. 
            На годовой подписке 
            вы сэкономите до 39%
                            </p>
                        </div>
                        <div class="awake-pay-item">
                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746395305-NqD84-Icon.svg" alt="img" class="hidden-tablet-mobile"/>
                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752835422963-nb4Zf-Icon.svg" alt="img" class="hidden-desc-mobile"/>
                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752927185932-wETNq-Icon.svg" alt="img" class="hidden-desc-tablet"/>
                            <p id="i2glqpw">
                                <span draggable="true" data-highlightable="1" id="ifsd5yf">В рассрочку:</span>
                                действует на тарифы от 3 месяцев в рублях и евро
                            </p>
                        </div>
                        <div class="awake-pay-item">
                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746395193-r9zAt-Icon.svg" alt="img" class="hidden-tablet-mobile"/>
                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752835423464-bVrPv-Icon.svg" alt="img" class="hidden-desc-mobile"/>
                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752927186240-qr6Vz-Icon.svg" alt="img" class="hidden-desc-tablet"/>
                            <p id="ib0u0wz">
                                <span draggable="true" data-highlightable="1">Если важно снизить размер платежа в месяц:</span>
                                вам подойдет помесячная оплата
                            </p>
                        </div>
                        <div class="awake-pay-item">
                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755802559738-KpyHx-Curr.svg" alt="img" class="hidden-tablet-mobile"/>
                            <img loading="" src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755804865386-sMhGh-Curr.svg" alt="img" class="hidden-desc-mobile"/>
                            <img loading="" src="https://storage.yandexcloud.net/cdn.careerum.com/1773404171952-FZxvP-Curr.svg" alt="img" class="hidden-desc-tablet"/>
                            <p id="icry2yr">
                                Можно оплатить в <span draggable="true" data-highlightable="1">₽ и €</span>
                            </p>
                        </div>
                    </div>
                    <div class="careerum-flex-fec awake-pay-slider-nav hidden">
                        <div class="careerum-flex-cc awake-pay-nav-prev">
                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg" id="i8npupv">
                                <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </div>
                        <div class="careerum-flex-cc awake-pay-nav-next">
                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </div>
                    </div>
                    <a onclick="" href="#buy" class="btn-color-main-bright-orange hidden">Записаться в лист ожидания</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-club50-faq', {
        label: 'Club 50 faq (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club50-faq main-wrapper">
        <div class="careerum-container-responsive careerum-flex-sbfs">
            <div class="club50-faq-left">
                <h2>Популярные вопросы
                </h2>
            </div>
            <div class="club50-faq-right">
                <div>
                    <div class="club50-faq-header">
                        <p>В чем разница между тарифами?</p>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 9.99609H19" stroke="#827F7C" stroke-width="2" stroke-linecap="round" />
                            <path d="M10.0039 1L10.0039 19" stroke="#827F7C" stroke-width="2" stroke-linecap="round" />
                        </svg>
                    </div>
                    <div class="club50-faq-content">
                        <p>
                            Наполнение подписки зависит от выбранного вами тарифного плана.
                        </p>
                        <p>
                            <span>Тариф «Библиотека курсов»:</span><br>
                            Доступ только к образовательной платформе с программами под любую карьерную задачу: поиск
                            работы, повышение, релокация, смена отрасли. Программы на платформе закрывают абсолютно
                            все карьерные вопросы для профессионалов.
                        </p>
                        <p>
                            <span>Тариф «С поддержкой экспертов»:</span><br>
                            Доступ к образовательной платформе.<br>
                            Доступ к клубу — закрытому сообществу профессионалов из 60+ стран.<br>
                            Участие в групповых онлайн-эфирах и интенсивах.<br>
                            Поддержка коучей и экспертов в групповом чате и эфирах.
                        </p>
                        <p>
                            <span>Тариф «Индивидуальное сопровождение»:</span><br>
                            Индивидуальное сопровождение карьерного коуча и эксперта: 2 индивидуальные видеосессии
                            в месяц продолжительностью 50 мин.<br>
                            Доступ к образовательной платформе.<br>
                            Доступ к закрытому сообществу Careerum.<br>
                            Участие в групповых онлайн-эфирах и интенсивах.
                        </p>
                    </div>
                </div>
                <div>
                    <div class="club50-faq-header">
                        <p>Как понять, какой тариф мне подойдет?</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="12" viewBox="0 0 22 12" fill="none">
                            <path d="M1 1L11 11L21 1" stroke="#827F7C" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round"></path>
                        </svg>
                    </div>
                    <div class="club50-faq-content">
                        <p>
                            При выборе тарифа мы советуем опираться на ваши цели.
                        </p>
                        <p>

                            Тариф «Библиотека курсов»<br>
                            Для тех, кто хочет самостоятельно проработать свой карьерный запрос с помощью наших
                            программ.<br>
                            Тариф включает только доступ к образовательной платформе и не предусматривает обратную связь
                            от карьерных экспертов и коучей.
                        </p>
                        <p>
                            Тариф «С поддержкой экспертов»<br>
                            Для тех, кому важна обратная связь и нетворкинг в профессиональном комьюнити.<br>
                            Вы получаете поддержку сообщества, коучей и экспертов в закрытом сообществе Careerum,
                            а также возможность задавать вопросы и разбирать свои кейсы с карьерными экспертами
                            на QA-эфирах.
                        </p>
                        <p>
                            Тариф «Индивидуальное сопровождение»<br>
                            Для тех, кто хочет глубоко и точечно проработать свой карьерный запрос. <br>
                            В дополнение ко всем
                            опциям тарифов «Библиотека курсов» и «С поддержкой экспертов» вы получаете индивидуальное
                            сопровождение персонального карьерного коуча и эксперта на онлайн-сессиях и в личном чате
                            с экспертами.
                        </p>
                        <p>
                            Для каждого из тарифов доступна подписка на 1 месяц (30 дней), 3 месяца (90 дней), 6 месяцев
                            (180 дней) и 12 месяцев (365 дней). Чем длиннее период подписки, тем выгоднее стоимость.
                        </p>
                    </div>
                </div>
                <div>
                    <div class="club50-faq-header">
                        <p>Как выбрать длительность подписки?</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="12" viewBox="0 0 22 12" fill="none">
                            <path d="M1 1L11 11L21 1" stroke="#827F7C" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round"></path>
                        </svg>
                    </div>
                    <div class="club50-faq-content">
                        <p>
                            <span>1 месяц — SOS-режим, когда горит.</span><br>
                            За это время вы сможете:
                        <ul>
                            <li>
                                закрыть одну задачу: усилить резюме/Linkedin/сопроводительное письмо/потренировать
                                собеседование
                            </li>
                            <li>
                                справиться с шоком от внезапного увольнения и сформировать план действий
                            </li>
                            <li>
                                качественно пройти одну конкретную программу в подписке
                            </li>
                            <li>
                                получить две личные консультации экспертов (только на тарифе «Индивидуальное
                                сопровождение»)
                            </li>
                            <li>
                                подготовить новое резюме с экспертом (на тарифах «С поддержкой экспертов» и
                                «Индивидуальное сопровождение»)
                            </li>
                        </ul>
                        </p>
                        <p>
                            <span>3 месяца — из хаоса к понятным результатам.</span><br>
                            За это время вы сможете:
                        <ul>
                            <li>
                                упаковать себя под поиск работы 
                            </li>
                            <li>
                                получить оффер в своей локации 
                            </li>
                            <li>
                                упаковать себя под смену сферы
                            </li>
                            <li>
                                получить повышение
                            </li>
                            <li>
                                понять, куда двигаться дальше в карьере
                            </li>
                            <li>
                                выйти из первой и второй стадии выгорания 
                            </li>
                            <li>
                                поставить карьерные цели и сформировать стратегию
                            </li>
                        </ul>
                        </p>
                        <p>
                            <span>6 месяцев — пробить стеклянный потолок в карьере.</span><br>
                            За это время вы сможете:
                        <ul>
                            <li>
                                получить оффер в любой локации
                            </li>
                            <li>
                                победить синдром самозванца
                            </li>
                            <li>
                                увеличить доход
                            </li>
                            <li>
                                протестировать новые форматы карьеры
                            </li>
                            <li>
                                прокачать профессиональную коммуникацию
                            </li>
                            <li>
                                выстроить качественный нетворкинг по всему миру
                            </li>
                            <li>
                                получить руководящую позицию
                            </li>
                        </ul>
                        </p>
                        <p>
                            <span>12 месяцев — развитие карьеры как системы</span><br>
                            Помимо решения срочных задач в работе, вы сможете идти к долгосрочным целям без откатов.<br>
                            В дополнение к результатам 6 месяцев, вы сможете внедрить карьерное развитие как систему и
                            прокачать карьерные навыки, чтобы идти вперед.<br>
                            Ведь карьера как чистка зубов — ей нужно заниматься постоянно, чтобы результаты через год
                            вас впечатлили!
                        </p>
                    </div>
                </div>
                <div>
                    <div class="club50-faq-header">
                        <p>Как я буду получать обратную связь от карьерных экспертов и коучей на разных тарифах?</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="12" viewBox="0 0 22 12" fill="none">
                            <path d="M1 1L11 11L21 1" stroke="#827F7C" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round"></path>
                        </svg>
                    </div>
                    <div class="club50-faq-content">
                        <p>
                            Вы можете получить экспертную обратную связь только на тарифах «С поддержкой экспертов»
                            и «Индивидуальное сопровождение».
                        </p>
                        <p>
                            Вот как это работает в общем пространстве — чатах клуба
                            и эфирах.
                            Взаимодействие с экспертами через эфиры:
                            Тематические эфиры на карьерные темы, где можно послушать лекцию эксперта и задать вопросы
                            по теме.
                            Q&A сессии — Zoom-встречи с экспертами с разборами ваших кейсов и ответами на вопросы.
                            Ответы на вопросы в чате клуба в разных ветках.
                        </p>
                        <p>
                            С сентября 2025 мы внедряем новый формат анонимных вопросов, поскольку понимаем,
                            что некоторые темы могут быть очень чувствительны. Мы будем собирать анонимные вопросы
                            в анкету, а эксперты ответят на них в чате клуба в разных форматах (текст/видео/аудио).
                            Вот как работает экспертная поддержка на карьерных консультациях на тарифе «Индивидуальное
                            сопровождение».<br>
                            Создаём чат: клиент + коуч + эксперт, в котором вы можете задавать вопросы экспертам. Обычно
                            мы отвечаем на экспертные вопросы в течение 48 часов.<br>
                            Вы заполняете анкету, после чего на установочной сессии с коучем (30 минут, дополнительно
                            к основным двум сессиям), выявляем ваши цели, задачи и мотивации.<br>
                            Затем мы прикрепляем к вам коуча и эксперта на весь срок подписки. В течение месяца
                            у вас есть две встречи со специалистами. Вы сами выбираете приоритетного специалиста
                            для работы — коуча или карьерного эксперта.<br>
                            Роль коуча в процессе: ведёт вас на протяжении всего срока нахождения в Careerum, помогает
                            верифицировать цели.
                        </p>
                    </div>
                </div>
                <div>
                    <div class="club50-faq-header">
                        <p>С какими рынками, профессиями индустриями работают эксперты при поиске работы? Как выбрать
                            эксперта под свой запрос?</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="12" viewBox="0 0 22 12" fill="none">
                            <path d="M1 1L11 11L21 1" stroke="#827F7C" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round"></path>
                        </svg>
                    </div>
                    <div class="club50-faq-content">
                        <p>
                            Эксперты Careerum работают со всеми индустриями, рынками и странами:
                            РФ/ЕС/США/Великобритания/MENA/APAC, релокация, удалёнка, переход в руководящие роли, смена
                            функции и отрасли.
                        </p>
                        <p>
                            Важное исключение: академическая индустрия — единственная специфическая область, в которой
                            у нас нет экспертизы.
                        </p>
                        <p>
                            Показатели, на которые мы смотрим вместе с вами
                        </p>
                        <p>
                            Конверсия: просмотр → отклик → интервью → финал → оффер.<br>
                            Количество целевых интро/рефералов в неделю и качество воронки поиска.<br>
                            Рост компенсации и улучшение условий (гибрид/удалёнка, бонусы, RSU и т.д.).<br>
                            Снижение времени выхода на оффер за счёт точной упаковки и стратегии.
                        </p>
                        <p>
                            <span>Чего мы не делаем</span>
                        </p>
                        <p>
                            Не даём «универсальные шаблоны» без вашего контекста.<br>
                            Не пишем резюме за вас.<br>
                            Не откликаемся за вас.<br>
                            Не обещаем оффер «за 7 дней».
                        </p>
                        <p>
                            Мы ускоряем путь и повышаем шансы на оффер, а результат рождается из ваших действий
                            при нашей экспертной поддержке. Careerum — это про измеримые карьерные результаты
                            и устойчивую траекторию. Мы даём опору, ясность и скорость в поиске работы.
                        </p>
                    </div>
                </div>
                <div>
                    <div class="club50-faq-header">
                        <p>Чем отличается карьерный коуч от карьерного эксперта?</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="12" viewBox="0 0 22 12" fill="none">
                            <path d="M1 1L11 11L21 1" stroke="#827F7C" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round"></path>
                        </svg>
                    </div>
                    <div class="club50-faq-content">
                        <p>
                            Самый частый вопрос: в чем разница между карьерным коучем и карьерным экспертом — и к кому
                            идти именно вам?
                        </p>
                        <p>
                            Коротко: коуч помогает выбрать направление и снять внутренние блоки (“куда
                            и зачем“), эксперт приводит к измеримым результатам в карьере (“как и чем“). Ниже —
                            подробно, с примерами и нашими цифрами.
                        </p>
                        <p>
                            Что делает карьерный коуч
                            Помогает прояснить карьерные цели, ценности, мотивацию и критерии «хорошей работы» именно
                            для вас.
                            Выводит из выгорания 1–2 стадии, возвращает энергию и фокус.
                            Переводит «хочу» в работе в достижимый план, укрепляет уверенность и дисциплину.
                            Инструменты: коучинговые модели (GROW и др.), вопросы, рефлексия, упражнения
                            на ценности/сильные стороны.
                            Результат: ясность направления, приоритеты, план без саботажа сроков, устойчивость
                            в изменениях.
                            Что делает карьерный эксперт
                            Даёт практику рынка и пошаговую тактику: как упаковать опыт, где искать, как выйти
                            на интервью/оффер.
                            Делает аудит и апгрейд резюме, LinkedIn, портфолио; строит стратегию откликов и нетворкинга.
                            Готовит к интервью и переговорам по офферу: сценарии ответов, сторителлинг, кейсы, цифры,
                            возражения.
                            Инструменты: best practices ATS, hiring POV, матрица достижений, карта компаний, письма
                            интро/рефералы, negotiation playbook.
                            Результат: рост конверсий отклики → интервью → оффер, сильные артефакты, повышение
                            компенсации.
                        </p>
                        <p>
                            Кому и когда нужен коуч vs эксперт.<br>
                            Идите к коучу, если:<br>
                            Нет ясности «куда дальше».<br>
                            Сомневаетесь в выборе сферы/роли/локации.<br>
                            Выгорание, страхи и прокрастинация мешают действовать.<br>
                            Хочется устойчивости и системы.
                        </p>
                        <p>
                            Идите к эксперту, если:<br>
                            «Горит»: нужен оффер/повышение.<br>
                            Планируете или находитесь в процессе релокации или смены сферы.<br>
                            Нужно резюме/LinkedIn/портфолио под рынок.<br>
                            Хотите подготовиться к собеседованию и переговорам.
                        </p>
                        <p>
                            Идеальная связка: коуч формирует
                            траекторию, эксперт ускоряет исполнение. При срочной задаче начинайте с эксперта,
                            при отсутствии ясности — с коуча.
                        </p>
                    </div>
                </div>
                <div>
                    <div class="club50-faq-header">
                        <p>Что произойдет после оплаты?</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="12" viewBox="0 0 22 12" fill="none">
                            <path d="M1 1L11 11L21 1" stroke="#827F7C" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round"></path>
                        </svg>
                    </div>
                    <div class="club50-faq-content">
                        <p>
                            Мы начнём заботливо погружать вас в мир Careerum.
                        </p>
                        <p>
                            После оплаты мы обработаем ваш платёж в течение нескольких минут и отправим подробное письмо
                            с инструкциями на почту, указанную при оплате.<br>
                            Шаг 1. Вам нужно заполнить анкету участника, которая позволит нашей команде познакомиться
                            с вашими карьерными запросами.<br>
                            Шаг 2. Вы получите доступ к обучающей платформе и всем программам.<br>
                            Шаг 3. Мы подключим вас к онбординговому боту в Telegram, который будет вашим навигатором
                            по подписке.<br>
                            Шаг 4. На тарифах «С поддержкой экспертов» и «Индивидуальное сопровождение» участники
                            присоединяются к закрытому чату клуба и регистрируются в системе coffee buddy,
                            чтобы развивать полезные профессиональные связи.<br>
                            Шаг 5. Вы проходите карьерный навигатор, и мы формируем для вас обучающий план.<br>
                            Шаг 6. На тарифах «С поддержкой экспертов» и «Индивидуальное сопровождение» вы начинаете
                            участвовать в живых тематических эфирах клуба и нетворкинг-встречах.<br>
                            На всех тарифах в процессе погружения и обучения в Careerum можно обратиться к нашим
                            кураторам из команды заботы Виолетте и Ане:)
                        </p>
                        <p>
                            Просто напишите на <a href="mailto:hello@careerum.com"
                                target="_blank">hello@careerum.com</a> в любое время. Мы на связи ежедневно
                            с 10.00 до 19.00 мск.
                        </p>
                    </div>
                </div>
                <div>
                    <div class="club50-faq-header">
                        <p>Доступ ко всем материалам откроется сразу?</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="12" viewBox="0 0 22 12" fill="none">
                            <path d="M1 1L11 11L21 1" stroke="#827F7C" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round"></path>
                        </svg>
                    </div>
                    <div class="club50-faq-content">
                        <p>
                            После оплаты подписки вы сразу получите доступ ко всем обучающим программам Careerum. Доступ
                            придёт на почту, которую вы указали при оплате.
                        </p>
                    </div>
                </div>
                <div>
                    <div class="club50-faq-header">
                        <p>Если я передумаю, могу ли я вернуть деньги за подписку?</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="12" viewBox="0 0 22 12" fill="none">
                            <path d="M1 1L11 11L21 1" stroke="#827F7C" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round"></path>
                        </svg>
                    </div>
                    <div class="club50-faq-content">
                        <p>
                            Вы можете вернуть деньги за подписку, написав на почту hello@careerum.com. Это нужно сделать
                            в течение 7 календарных дней с момента оплаты. Тогда мы вернём вам полную сумму.
                        </p>
                        <p>
                            Если со дня оплаты прошло больше 7 календарных дней, мы вернём вам часть суммы,
                            пропорциональную оказанным услугам. Каждый раз она рассчитывается индивидуально. Подробнее
                            о возвратах можно узнать в разделе «Политика возвратов».
                        </p>
                    </div>
                </div>
                <div>
                    <div class="club50-faq-header">
                        <p>Смогу ли я поменять программу во время подписки?</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="12" viewBox="0 0 22 12" fill="none">
                            <path d="M1 1L11 11L21 1" stroke="#827F7C" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round"></path>
                        </svg>
                    </div>
                    <div class="club50-faq-content">
                        <p>
                            Да. В течение действия вашей подписки вам доступны абсолютно все программы на платформе.
                        </p>
                        <p>
                            Вы можете комбинировать программы, курсы и уроки так, как это актуально именно для вас.
                            Вы можете менять программы и смотреть несколько курсов параллельно. Чтобы сформировать
                            для себя актуальный трек обучения, пройдите тест в Карьерном навигаторе Careerum.
                        </p>
                    </div>
                </div>
                <div>
                    <div class="club50-faq-header">
                        <p>Как выглядит карьерная платформа Careerum внутри?</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="12" viewBox="0 0 22 12" fill="none">
                            <path d="M1 1L11 11L21 1" stroke="#827F7C" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round"></path>
                        </svg>
                    </div>
                    <div class="club50-faq-content">
                        <p>
                            У нас собственная обучающая платформа, где вам доступны:
                        </p>
                        <ul>
                            <li>7 программ</li>
                        </ul>
                        <p>
                            — Звёздный кандидат: вы пройдете путь от поиска работы к офферу мечты. <br>
                            — Power Talk: освоите навыки эффективной коммуникации и ведения переговоров (в том числе о
                            зарплате), научитесь отстаивать границы и убеждения.<br>
                            — Выход из карьерного кризиса и перезагрузка: разработаете стратегию выхода из карьерного
                            кризиса/тупика и план перехода к новой деятельности, в том числе портфельной карьере.<br>
                            — Карьерная ракета: как расти внутри компании: ускорите карьерный и зарплатный рост внутри
                            компании через эффективное планирование, самопрезентацию и нетворкинг.<br>
                            — Go Global: разработаете стратегию поиска работы и релокации за границу и спланируете
                            практические шаги.<br>
                            — Life work balance: карьера без стресса: восстановите внутренний ресурс, научитесь
                            управлять стрессом и выстраивать границы. <br>
                            — Big Boss: как быть успешным руководителем: научитесь эффективно управлять командой и вести
                            ее к результатам.
                        </p>
                         
                        <ul>
                            <li>Личный кабинет, где вы можете отслеживать прогресс обучения и управлять подпиской.</li>
                            <li>Раздел «Избранное», в который вы можете собирать актуальные для вас материалы.</li>
                            <li>
                                Расписание живых эфиров (на тарифах «С поддержкой экспертов» и «Индивидуальное
                                сопровождение»).
                            </li>
                            <li>Карьерный навигатор, который поможет:</li>
                        </ul>
                        <p>
                            — определить ваши карьерные цели на текущий момент <br>
                            — выбрать подходящую  программу для старта<br>
                            — выстроить свою образовательную траекторию, исходя из срочности цели и времени, которое вы
                            готовы тратить на обучение.
                        </p>

                        <ul>
                            <li>Резюме-сканер — AI-сервис, который:</li>
                        </ul>
                        <p>
                            — проанализирует ваше резюме
                            — выявит слабые стороны в структуре и подаче
                            — даст рекомендации по улучшению
                            — поможет кастомизировать резюме под конкретную вакансию.
                        </p>

                        <p><a href="https://careerum.com/ru-ru/promo/validator"
                                target="_blank">https://careerum.com/ru-ru/promo/validator</a> </p>

                        <p>На тарифах «С поддержкой экспертов» и «Индивидуальное сопровождение» вы также получаете:</p>

                        <ul>
                            <li>
                                Доступ к карьерному клубу. 
                            </li>
                            <li>
                                Живые эфиры с экспертами и коучами Careerum.
                            </li>
                            <li>
                                Нетворкинг в чате и в формате coffee buddy. 
                            </li>
                            <li>
                                Обратную связь от экспертов
                            </li>
                        </ul>
                    </div>
                </div>
                <div>
                    <div class="club50-faq-header">
                        <p>Если у меня возник вопрос, к кому я могу обратиться?</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="12" viewBox="0 0 22 12" fill="none">
                            <path d="M1 1L11 11L21 1" stroke="#827F7C" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round"></path>
                        </svg>
                    </div>
                    <div class="club50-faq-content">
                        <p>
                            Если на любом из этапов у вас возникнут вопросы, наша команда заботы будет рада помочь.
                            Просто напишите на <a href="mailto:hello@careerum.com"
                                target="_blank">hello@careerum.com</a> в любое время. Мы на связи ежедневно с 10.00 до
                            19.00 МСК.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-club50-popup-question', {
        label: 'Club 50 popup questions (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-popup careerum-club50-popup-question" id="popup">
                <div class="popup__close-button-wrapper careerum-flex-cc">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                        class="close-switch hidden-tablet-mobile">
                        <g clip-path="url(#clip0_10220_30209)">
                            <path d="M21.5957 21.2718L2.41172 2.16602" stroke="#636463" stroke-width="4" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M2.39951 21.278L21.6035 2.15625" stroke="#636463" stroke-width="4" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="clip0_10220_30209">
                                <rect width="24" height="24" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="close-switch hidden-desc">
                        <g clip-path="url(#clip0_10683_5644)">
                            <path d="M10.7969 10.6359L1.20488 1.08301" stroke="white" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M1.19878 10.639L10.8008 1.07812" stroke="white" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="clip0_10683_5644">
                                <rect width="12" height="12" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <div class="club50-popup-question-content">
                    <h2>Лист ожидания в Careerum</h2>
                    <p class="club50-popup-question-text">Сейчас клуб закрыт. Заполните короткую анкету, мы внесем вас в лист
                        ожидания и раньше всех сообщим об открытии клуба </p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1756551941519-0vSEW-Vect.svg"
                        class="hidden-tablet-mobile club50-popup-question-img" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1756551949472-dChSy-Vect.svg"
                        class="hidden-desc-mobile club50-popup-question-img" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1756551955699-ttvxP-Vect.svg"
                        class="hidden-desc-tablet club50-popup-question-img" alt="img">
                    <div class="careerum-flex-sbfs club50-popup-question-wrapper">
                        <div class="club50-popup-question-left">
                            <p class="club50-popup-question-subheader">Ваша ближайшая<br> карьерная цель</p>
                            <div class="club50-popup-question-inputs">
                                <label class="noselect">
                                    <input type="radio" hidden name="q1" value="Найти новую работу" checked>
                                    <p>Найти новую работу</p>
                                </label>
                                <label class="noselect">
                                    <input type="radio" hidden name="q1"
                                        value="Получить повышение в зарплате и должности на текущей работе">
                                    <p>Получить повышение в зарплате и должности на текущей работе</p>
                                </label>
                                <label class="noselect">
                                    <input type="radio" hidden name="q1" value="Понять, в какой сфере мне развиваться">
                                    <p>Понять, в какой сфере мне развиваться</p>
                                </label>
                                <label class="noselect">
                                    <input type="radio" hidden name="q1"
                                        value="Строить карьеру более быстро, легко и осознанно">
                                    <p>Строить карьеру более быстро, легко и осознанно</p>
                                </label>
                            </div>
                            <p class="club50-popup-question-subheader">Покупали ли вы какой-либо из наших продуктов?</p>
                            <div class="club50-popup-question-inputs careerum-flex-fsfs">
                                <label class="noselect">
                                    <input type="radio" hidden name="q2" value="Да" checked>
                                    <p>Да</p>
                                </label>
                                <label class="noselect">
                                    <input type="radio" hidden name="q2" value="Нет">
                                    <p>Нет</p>
                                </label>
                            </div>
                        </div>
                        <div class="club50-popup-question-right">
                            <div class="careerum-registration-form-club40">
                                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                    data-gjs-type="deva-registration-form">
                                    <div class="careerum-club40-form-name">
                                        <input type="text" name="name" value="" required placeholder="Имя">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                    </div>
                                    <div class="careerum-club40-form-telegram">
                                        <input type="text" name="telegram" value="" required placeholder="Telegram">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                    </div>
                                    <div class="careerum-club40-form-email">
                                        <input type="text" name="email" value="" required placeholder="Почта">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                    </div>
                                    <div class="careerum-club40-form-phone">
                                        <input type="tel" value="" name="tel" required class="itl-input">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                    </div>
                                    <div class="careerum-club40-form-agree">
                                        <label>
                                            <input type="checkbox" name="agree" autocomplete="off">
                                            <div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                    fill="none">
                                                    <path
                                                        d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                        stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </label>
                                        <p>Я даю согласие на обработку
                                            персональных
                                            данных
                                            в соответствии с <a href="#">Политикой конфиденциальности</a>.</p>
                                    </div>
                                    <a href="#" class="submit-btn btn-color-main-dark-orange" disabled>Записаться в лист
                                        ожидания</a>
                                    <input type="hidden" hidden name="additional_data" value="" autocomplete="off">
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-pack2-form', {
        label: 'Big pack form 2 (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-pack2-form main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <div class="pack-form-logo">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757407229179-x7R97-logo.svg"
                            class="hidden-tablet-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755150918402-sy6tj-logo.svg"
                            class="hidden-desc" alt="img">
                    </div>
                    <div class="careerum-form-lead position-relative">
                        <div class="pack-form-top">
                            <div class="pack-form-top-title careerum-flex-sbfs">
                                <div class="pack-form-top-title__item position-relative z-10">
                                    <p class="position-relative pack-form__label">
                                        <span class="position-relative z-20">Power Talk </span> <br>
                                        <span class="position-relative z-10">Big Pack #2</span>
                                    </p>
                                    <h1>Несносные боссы и сложные коллеги</h1>
                                    <p class="pack-form__subheader">Как с ними общаться?</p>
                                </div>
                                <div class="pack-form-top-title__item card position-relative z-20">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757406865022-yZn1V-Grou.png"
                                        class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757431222494-of0n4-Grou.png"
                                        class="hidden-desc-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757436031429-PsC8v-Grou.png"
                                        class="hidden-desc-tablet position-absolute z-10" alt="img">
                                    <div class="position-relative z-20">
                                        <p>Big Pack #2</p>
                                        <p>10 писем с лайфхаками и рекомендации от экспертов по профессиональной коммуникации
                                        </p>
                                        <p><span>Поможем вам вырасти,<br> а не заруинить карьеру</span></p>
                                        <p><span>Поможем вам вырасти, а не заруинить карьеру</span></p>
                                    </div>
                                </div>
                                <a href="#form" class="btn-color-main-bright-orange position-relative z-30">Получать письма</a>
                                <div class="pack-form-top-title__item position-relative z-20">
                                    <div class="lead-form-wrapper position-relative z-20">
                                        <p class="lead-form__title">
                                            Заполните форму, чтобы получать письма
                                        </p>
                                        <div class="careerum-registration-form-club40">
                                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                                data-gjs-type="deva-registration-form">
                                                <div class="careerum-club40-form-name">
                                                    <input type="text" name="name" value="" required placeholder="Имя">
                                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                                </div>
                                                <div class="careerum-club40-form-telegram">
                                                    <input type="text" value="" name="telegram" required placeholder="Telegram">
                                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                                </div>
                                                <div class="careerum-club40-form-email">
                                                    <input type="text" name="email" value="" required placeholder="Почта">
                                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                                </div>
                                                <div class="careerum-club40-form-phone">
                                                    <input type="tel" value="" name="tel" required class="itl-input">
                                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                                </div>
                                                <div class="careerum-club40-form-agree">
                                                    <label>
                                                        <input type="checkbox" name="agree">
                                                        <div>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8"
                                                                viewBox="0 0 8 8" fill="none">
                                                                <path
                                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                            </svg>
                                                        </div>
                                                    </label>
                                                    <p>Я даю согласие
                                                        на обработку персональных данных
                                                        в соответствии с <a href="/ru-ru/legal/privacy">Политикой
                                                            конфиденциальности</a>
                                                    </p>
                                                </div>
                                                <a href="#" class="submit-btn btn-color-main-bright-orange button-sent"
                                                    disabled>Получать письма</a>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="pack-form-center">
                            <div class="careerum-flex-sbfs">
                                <div>
                                    <div class="pack-form-center__item letter-1">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757424844410-SpRpJ-Grou.png" class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757432219071-GI3Pd-Grou.png" class="hidden-desc-mobile position-absolute z-10" alt="img">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757436875800-hJlA3-Grou.png" class="hidden-desc-tablet position-absolute z-10" alt="img">
                                        <div class="pack-form-center__item__number careerum-flex-fsfs position-relative z-20">
                                            <p>1</p>
                                            <p>письмо</p>
                                        </div>
                                        <p class="pack-form-center__item__header position-relative z-20">Как давать и получать обратную связь?</p>
                                        <p class="pack-form-center__item__text position-relative z-20">Не стоит переживать – это можно сделать красиво и экологично</p>
                                    </div>
                                    <div class="pack-form-center__item letter-2 hidden-mobile">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757424844540-9hXZa-Grou.png" class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757432219221-qkbOA-Grou.png" class="hidden-desc-mobile position-absolute z-10" alt="img">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757436875545-PiHTR-Grou.png" class="hidden-desc-tablet position-absolute z-10" alt="img">
                                        <div class="pack-form-center__item__number careerum-flex-fsfs position-relative z-20">
                                            <p>2</p>
                                            <p>письмо</p>
                                        </div>
                                        <p class="pack-form-center__item__header position-relative z-20">Как продать свою идею сложному руководителю</p>
                                    </div>
                                </div>
                                <div class="pack-form-center__item badge">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757424902828-eDHSv-Fram.png" class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757431990264-9PUZP-Fram.png" class="hidden-desc-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757436875121-eKDgn-Fram.png" class="hidden-desc-tablet position-absolute z-10" alt="img">
                                    <p class="pack-form-center__item__label position-relative z-20">Подарок для читателей Big Pack</p>
                                    <p class="pack-form-center__item__header position-relative z-20">Бесплатный эфир бизнес-тренера и спикера Careerum </p>
                                    <p class="pack-form-center__item__text position-relative z-20">«Конфликты: найти и обезвредить»</p>
                                </div>
                                <div class="pack-form-center__item letter-2 hidden-desc-tablet">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757424844540-9hXZa-Grou.png" class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757432219221-qkbOA-Grou.png" class="hidden-desc-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757436875545-PiHTR-Grou.png" class="hidden-desc-tablet position-absolute z-10" alt="img">
                                    <div class="pack-form-center__item__number careerum-flex-fsfs position-relative z-20">
                                        <p>2</p>
                                        <p>письмо</p>
                                    </div>
                                    <p class="pack-form-center__item__header position-relative z-20">Как продать свою идею сложному руководителю</p>
                                </div>
                            </div>
                            <div class="careerum-flex-sbfs">
                                <div class="pack-form-center__item letter-3">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757424844677-sTrT8-Grou.png" class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757432219341-BRSCy-Grou.png" class="hidden-desc-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757436875925-HzqWb-Grou.png" class="hidden-desc-tablet position-absolute z-10" alt="img">
                                    <div class="pack-form-center__item__number careerum-flex-fsfs position-relative z-20">
                                        <p>3</p>
                                        <p>письмо</p>
                                    </div>
                                    <p class="pack-form-center__item__header position-relative z-20">Вас услышат!</p>
                                    <p class="pack-form-center__item__text position-relative z-20">Как быть лидером и руководить командой</p>
                                </div>
                                <div class="pack-form-center__item letter-4">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757424844015-w7s8Y-Fram.png" class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757432218822-I2KDI-Grou.png" class="hidden-desc-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757436875681-eiv3j-Grou.png" class="hidden-desc-tablet position-absolute z-10" alt="img">
                                    <div class="pack-form-center__item__number careerum-flex-fsfs position-relative z-20">
                                        <p>4</p>
                                        <p>письмо</p>
                                    </div>
                                    <p class="pack-form-center__item__header position-relative z-20">Будьте эгоистом и это окупится</p>
                                    <p class="pack-form-center__item__text position-relative z-20">Как экологично продвигать себя и свои идеи</p>
                                </div>
                                <div class="pack-form-center__item letter-5">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757424844147-M2hpv-Fram.png" class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757432218642-PtLQT-Fram.png" class="hidden-desc-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757437932737-dFFKD-Grou.png" class="hidden-desc-tablet position-absolute z-10" alt="img">
                                    <div class="pack-form-center__item__number careerum-flex-fsfs position-relative z-20">
                                        <p>5</p>
                                        <p>письмо</p>
                                    </div>
                                    <p class="pack-form-center__item__label position-relative z-20">Не делайте так никогда</p>
                                    <p class="pack-form-center__item__header position-relative z-20">Самые неприятные ошибки в деловой переписке</p>
                                </div>
                            </div>
                            <div class="pack-form-center__btn hidden-tablet-mobile">
                                <a href="#form" class="btn-color-main-bright-orange">Хочу стать мастером коммуникаций</a>
                            </div>
                            <div class="careerum-flex-sbfs">
                                <div class="pack-form-center__item letter-6">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757424843652-latHF-Fram.png" class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757432218297-RC9cs-Fram.png" class="hidden-desc-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757436874849-ize7K-Fram.png" class="hidden-desc-tablet position-absolute z-10" alt="img">
                                    <div class="pack-form-center__item__number careerum-flex-fsfs position-relative z-20">
                                        <p>6</p>
                                        <p>письмо</p>
                                    </div>
                                    <p class="pack-form-center__item__header position-relative z-20">Закрой за мной дверь, я ухожу!</p>
                                    <p class="pack-form-center__item__text position-relative z-20">Как правильно увольняться</p>
                                </div>
                                <div class="pack-form-center__item letter-7">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757424844832-qMIpS-Grou.png" class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757432219471-kMt8T-Grou.png" class="hidden-desc-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757436876301-6cnrE-Grou.png" class="hidden-desc-tablet position-absolute z-10" alt="img">
                                    <div class="pack-form-center__item__number careerum-flex-fsfs position-relative z-20">
                                        <p>7</p>
                                        <p>письмо</p>
                                    </div>
                                    <p class="pack-form-center__item__header position-relative z-20">Как профессионально реагировать на критику</p>
                                </div>
                            </div>
                            <div class="careerum-flex-sbfs">
                                <div class="pack-form-center__item letter">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757428001492-reUhU-Grou.png" class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757432218945-rWFiT-Grou.png" class="hidden-desc-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757436875409-7tq3a-Grou.png" class="hidden-desc-tablet position-absolute z-10" alt="img">
                                    <div class="position-relative z-20">
                                        <p>Бонус</p>
                                        <p>+3 секретных письма</p>
                                        <p>После которых<br> вы станете мастером коммуникаций</p>
                                    </div>
                                </div>
                                <div class="pack-form-center__item promo">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757427516517-u8nze-Grou.svg" class="hidden-tablet-mobile position-absolute z-20" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757432224974-8c2K6-Grou.svg" class="hidden-desc-mobile position-absolute z-20" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757436849595-W837z-Grou.svg" class="hidden-desc-tablet position-absolute z-20" alt="img">
                                    <p class="pack-form-center__item__header--promo position-relative z-10">Вам доступен<br> «Big Pack #1»</p>
                                    <p class="pack-form-center__item__text--promo position-relative z-10">Как избежать <span>факапов</span>  
                                        при поиске работы</p>
                                    <a href="#" class="btn-color-main-bright-orange position-relative z-30">Забрать 7 писем</a>
                                </div>
                            </div>
                        </div>
                        <div class="pack-form-bottom">
                            <div class="position-relative">
                                <h2>Заберите Big Pack от Ольги Лермонтовой</h2>
                                <p>Чтобы в новом сезоне получить все профиты от профессиональной коммуникации</p>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757436849467-iQEcG-Grou.svg" class="hidden-desc-tablet position-absolute" alt="">
                            </div>
                            <div class="lead-form-wrapper">
                                <div class="careerum-registration-form-club40">
                                    <form class="deva-form getcourse-email-signup careerum-flex-fsfs"
                                        name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                        <div class="careerum-club40-form-name">
                                            <input type="text" name="name" value="" required placeholder="Имя">
                                            <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                        </div>
                                        <div class="careerum-club40-form-telegram">
                                            <input type="text" value="" name="telegram" required placeholder="Telegram">
                                            <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                        </div>
                                        <div class="careerum-club40-form-email">
                                            <input type="text" name="email" value="" required placeholder="Почта">
                                            <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                        </div>
                                        <div class="careerum-club40-form-phone">
                                            <input type="tel" value="" name="tel" required class="itl-input">
                                            <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                        </div>
                                        <div class="form-buttons">
                                            <a href="#" class="submit-btn btn-color-main-bright-orange button-sent"
                                                disabled>Получать письма</a>
                                            <div class="careerum-club40-form-agree">
                                                <label>
                                                    <input type="checkbox" name="agree">
                                                    <div>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8"
                                                            viewBox="0 0 8 8" fill="none">
                                                            <path
                                                                d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                                stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                        </svg>
                                                    </div>
                                                </label>
                                                <p>Я даю согласие
                                                    на обработку персональных данных
                                                    в соответствии с <a href="/ru-ru/legal/privacy">Политикой
                                                        конфиденциальности</a>
                                                </p>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="careerum-form-success-lead">
                        <div class="position-relative">
                            <h2>Отлично, я уже собрала ваш бокс:</h2>
                            <p>первое письмо прилетит с минуты на минуту</p>
                            <div class="pack-form-author careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757429328445-UFQMt-Grou.png"
                                    class="hidden-tablet-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757435599540-0ek93-Grou.png"
                                    class="hidden-desc" alt="img">
                                <div class="position-relative">
                                    <p class="pack-form-name">Ольга Лермонтова</p>
                                    <p class="pack-form-position">СЕО Careerum</p>
                                </div>
                            </div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757429755500-LVMxu-Grou.svg"
                                class="hidden-tablet-mobile position-relative success-bg" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757435774509-bDwzf-Grou.svg"
                                class="hidden-desc-mobile position-relative success-bg" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757436849118-3252C-Grou.svg"
                                class="hidden-desc-tablet position-relative success-bg" alt="img">
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-club5-banner-top', {
        label: 'Club 5 banner top (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club5-banner-top main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="club5-banner__wrapper position-relative">
                        <div class="club5-banner__bg position-absolute z-10">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757503371694-qByTP-Grou.svg"
                                class="hidden-tablet-mobile position-absolute" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757503394369-EUTem-Star.svg"
                                class="hidden-desc-mobile position-absolute" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757503403403-yy0W2-Star.svg"
                                class="hidden-desc-tablet position-absolute" alt="img">
                        </div>
                        <div class="club5-banner__content careerum-flex-sbfs position-relative z-20">
                            <div class="club5-banner__left">
                                <div class="club5-banner__labels careerum-flex-fsfs">
                                    <p>Power Talk</p>
                                    <p>Big Pack #2</p>
                                </div>
                                <p class="club5-banner__title">Несносные боссы и сложные коллеги: <span>Как с ними общаться?</span></p>
                            </div>
                            <div class="club5-banner__right">
                                <a href="/ru-ru/promo/big-pack2" class="btn-color-main-bright-orange" target="_blank">Читать письма</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('club5-banner-top2', {
        label: 'Club 5 banner top timer (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club5-banner-top club5-banner-top2 careerum-club5-banner-top-timer main-wrapper"
                data-timer="no" data-redirect="no" data-url="" data-static="yes" data-offset=""
                data-timer-end="09/25/2025 00:00 GMT+0300">
                <div class="careerum-container-responsive">
                    <div class="club5-banner__wrapper position-relative">
                        <div class="club5-banner__bg position-absolute z-10">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1758530764034-8AQHV-Grou.png"
                                class="hidden-tablet-mobile position-absolute" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1758544977699-k9er4-Grou.png"
                                class="hidden-desc-mobile position-absolute" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1758272444127-UnHgO-Grou.png"
                                class="hidden-desc-tablet position-absolute" alt="img">
                        </div>
                        <div class="club5-banner__content careerum-flex-fsfs position-relative z-20">
                            <div class="club5-banner__left">
                                <p class="club5-banner__title2">Запись лекции с Михаилом Ромашовым</p>
                                <p class="club5-banner__title">Конфликты: найти и обезвредить
                                    4 навыка для сложных разговоров</p>
                            </div>
                            <div class="club5-banner__timer">
                                <p>До 00:00 25 сентября</p>
                                <div class="careerum-flex-sbfs">
                                    <div class="club5-banner__timer-item">
                                        <p class="timer-day-number">0</p>
                                        <p class="timer-day-text">ДНЕЙ</p>
                                    </div>
                                    <div class="club5-banner__timer-item">
                                        <p class="timer-hour-number">0</p>
                                        <p class="timer-hour-text">ЧАСОВ</p>
                                    </div>
                                    <div class="club5-banner__timer-item">
                                        <p class="timer-min-number">0</p>
                                        <p class="timer-min-text">МИНУТ</p>
                                    </div>
                                </div>
                            </div>
                            <div class="club5-banner__right">
                                <a href="/ru-ru/promo/big-pack2" class="btn-color-main-white" target="_blank">Посмотреть</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-intens5-form', {
        label: 'Intensive 5 form (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-intens5-form main-wrapper">
                <div class="careerum-container-responsive careerum-flex-sbst">
                    <div class="intens5-form__left position-relative">
                        <h2>Задать вопрос кураторам</h2>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1758527604147-zDIZ1-Grou.svg"
                            class="hidden-desc-mobile position-absolute" alt="img">
                    </div>
                    <div class="intens5-form__right">
                        <div class="careerum-registration-form-club40">
                            <form class="deva-form getcourse-email-signup careerum-flex-fsfs" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-telegram">
                                    <input type="text" name="telegram" value="" required placeholder="Telegram">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-buttons careerum-flex-fsfs">
                                    <div class="careerum-club40-form-agree">
                                        <label>
                                            <input type="checkbox" name="agree" autocomplete="off">
                                            <div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                    fill="none">
                                                    <path
                                                        d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                        stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </label>
                                        <p>Я даю согласие на обработку
                                            персональных
                                            данных
                                            в соответствии с <a href="#">Политикой конфиденциальности</a>.</p>
                                    </div>
                                    <a href="#" class="submit-btn btn-color-main-white" disabled>Задать вопрос</a>
                                </div>
                                <input type="hidden" hidden name="additional_data" value="" autocomplete="off">
                            </form>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('club5-banner-top3', {
        label: 'Club 5 banner top3 (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club5-banner-top club5-banner-top3 main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="club5-banner__wrapper position-relative">
                        <div class="club5-banner__bg position-absolute z-10">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1758709464982-mJZgj-Grou.png"
                                class="hidden-tablet-mobile position-absolute" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1758709508418-fDD3b-Grou.png"
                                class="hidden-desc-mobile position-absolute" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1758709510139-s6pS6-Grou.png"
                                class="hidden-desc-tablet position-absolute" alt="img">
                        </div>
                        <div class="club5-banner__content careerum-flex-fsc position-relative z-20">
                            <div class="club5-banner__left">
                                <p class="club5-banner__title2">Октябрь в клубе</p>
                                <p class="club5-banner__title">Как работать со сложными людьми?</p>
                                <p class="club5-banner__label">Старт интенсива Power Talk</p>
                            </div>
                            <div class="club5-banner__right">
                                <a href="/ru-ru/promo/big-pack2" class="btn-color-main-white" target="_blank">Узнать подробнее</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-pack3-form', {
        label: 'Big pack form 3 (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-pack2-form careerum-pack3-form main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <div class="pack-form-logo">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757407229179-x7R97-logo.svg"
                            class="hidden-tablet-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755150918402-sy6tj-logo.svg"
                            class="hidden-desc" alt="img">
                    </div>
                    <div class="careerum-form-lead position-relative form-sent">
                        <div class="pack-form-top">
                            <div class="pack-form-top-title careerum-flex-sbfs">
                                <div class="pack-form-top-title__item position-relative z-10">
                                    <p class="position-relative pack-form__label">
                                        <span class="position-relative z-10">Карьерные кризисы</span> <br>
                                        <span class="position-relative z-20">Big Pack #3</span>
                                    </p>
                                    <h1>Game over?</h1>
                                    <p class="pack-form__subheader">Как пережить карьерный кризис</p>
                                </div>
                                <div class="pack-form-top-title__item card position-relative z-20">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759342340801-NvmvU-Grou.png"
                                        class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759345924742-8rUpC-Grou.png"
                                        class="hidden-desc-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759348091717-2MITM-Grou.png"
                                        class="hidden-desc-tablet position-absolute z-10" alt="img">
                                    <div class="position-relative z-20">
                                        <p>Big Pack #3</p>
                                        <p>10 писем с лайфхаками и рекомендациями <br>от карьерных экспертов
                                        </p>
                                        <p><span>Поможем вам выйти из карьерного кризиса</span></p>
                                    </div>
                                </div>
                                <a href="#form" class="btn-color-main-bright-orange position-relative z-30">Получать письма</a>
                                <div class="pack-form-top-title__item position-relative z-20">
                                    <div class="lead-form-wrapper position-relative z-20">
                                        <p class="lead-form__title">
                                            Заполните форму, чтобы получать письма
                                        </p>
                                        <div class="careerum-registration-form-club40">
                                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                                data-gjs-type="deva-registration-form">
                                                <div class="careerum-club40-form-name">
                                                    <input type="text" name="name" value="" required placeholder="Имя">
                                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                                </div>
                                                <div class="careerum-club40-form-telegram">
                                                    <input type="text" value="" name="telegram" required placeholder="Telegram">
                                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                                </div>
                                                <div class="careerum-club40-form-email">
                                                    <input type="text" name="email" value="" required placeholder="Почта">
                                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                                </div>
                                                <div class="careerum-club40-form-phone">
                                                    <input type="tel" value="" name="tel" required class="itl-input">
                                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                                </div>
                                                <div class="careerum-club40-form-agree">
                                                    <label>
                                                        <input type="checkbox" name="agree">
                                                        <div>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8"
                                                                viewBox="0 0 8 8" fill="none">
                                                                <path
                                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                            </svg>
                                                        </div>
                                                    </label>
                                                    <p>Я даю согласие
                                                        на обработку персональных данных
                                                        в соответствии с <a href="/ru-ru/legal/privacy">Политикой
                                                            конфиденциальности</a>
                                                    </p>
                                                </div>
                                                <a href="#" class="submit-btn btn-color-main-bright-orange button-sent"
                                                    disabled>Получать письма</a>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="pack-form-center">
                            <div class="careerum-flex-sbfs">
                                <div>
                                    <div class="pack-form-center__item letter-1">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759342764984-aauH3-Grou.png" class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759345925349-ZT81G-Grou.png" class="hidden-desc-mobile position-absolute z-10" alt="img">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759348092300-FFMQc-Grou.png" class="hidden-desc-tablet position-absolute z-10" alt="img">
                                        <div class="pack-form-center__item__number careerum-flex-fsfs position-relative z-20">
                                            <p>1</p>
                                            <p>письмо</p>
                                        </div>
                                        <p class="pack-form-center__item__header position-relative z-20">Прокрастинация: найти и обезвредить</p>
                                        <p class="pack-form-center__item__text position-relative z-20">Как расшевелить себя</p>
                                    </div>
                                    <div class="pack-form-center__item letter-2 hidden-mobile">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759342764543-s6nRQ-Grou.png" class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759345924964-1MQeX-Grou.png" class="hidden-desc-mobile position-absolute z-10" alt="img">
                                        <div class="pack-form-center__item__number careerum-flex-fsfs position-relative z-20">
                                            <p>2</p>
                                            <p>письмо</p>
                                        </div>
                                        <p class="pack-form-center__item__header position-relative z-20">Я плыву в никуда: как перестроить маршрут</p>
                                    </div>
                                </div>
                                <div class="pack-form-center__item badge">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759342765389-JJqD6-Grou.png" class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759345925468-buiwx-Grou.png" class="hidden-desc-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759348091010-gAoD4-Grou.png" class="hidden-desc-tablet position-absolute z-10" alt="img">
                                    <p class="pack-form-center__item__label position-relative z-20">Подарок для читателей Big Pack</p>
                                    <p class="pack-form-center__item__label position-relative z-20">Подарок для читателей</p>
                                    <p class="pack-form-center__item__header position-relative z-20">Ранний доступ к покупке мастер-класса Ольги Лермонтовой</p>
                                    <p class="pack-form-center__item__text position-relative z-20">«Кризис середины карьеры»</p>
                                </div>
                                <div class="pack-form-center__item letter-2 hidden-desc-tablet">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759348091954-trMGj-Grou.png" class="position-absolute z-10" alt="img">
                                    <div class="pack-form-center__item__number careerum-flex-fsfs position-relative z-20">
                                        <p>2</p>
                                        <p>письмо</p>
                                    </div>
                                    <p class="pack-form-center__item__header position-relative z-20">Я плыву в никуда: как перестроить маршрут</p>
                                </div>
                            </div>
                            <div class="careerum-flex-sbfs">
                                <div class="pack-form-center__item letter-3">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759342765109-EbWCi-Grou.png" class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759345925086-d9Hcb-Grou.png" class="hidden-desc-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759348092464-XbROi-Grou.png" class="hidden-desc-tablet position-absolute z-10" alt="img">
                                    <div class="pack-form-center__item__number careerum-flex-fsfs position-relative z-20">
                                        <p>3</p>
                                        <p>письмо</p>
                                    </div>
                                    <p class="pack-form-center__item__header position-relative z-20">10 фатальных карьерных ошибок</p>
                                </div>
                                <div class="pack-form-center__item letter-4">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759342764728-Nw4hS-Grou.png" class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759345924612-gDne1-Grou.png" class="hidden-desc-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759348092906-36SBi-Grou.png" class="hidden-desc-tablet position-absolute z-10" alt="img">
                                    <div class="pack-form-center__item__number careerum-flex-fsfs position-relative z-20">
                                        <p>4</p>
                                        <p>письмо</p>
                                    </div>
                                    <p class="pack-form-center__item__header position-relative z-20">Как стать кандидатом на повышение</p>
                                    <p class="pack-form-center__item__text position-relative z-20">И наконец-то вырасти!</p>
                                </div>
                                <div class="pack-form-center__item letter-5">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759342764853-SpWXX-Grou.png" class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759345924246-kH6Df-Fram.png" class="hidden-desc-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759348092153-8X5I6-Grou.png" class="hidden-desc-tablet position-absolute z-10" alt="img">
                                    <div class="pack-form-center__item__number careerum-flex-fsfs position-relative z-20">
                                        <p>5</p>
                                        <p>письмо</p>
                                    </div>
                                    <p class="pack-form-center__item__header position-relative z-20">Как понять, что вам пора увольняться</p>
                                </div>
                            </div>
                            <div class="pack-form-center__btn hidden-tablet-mobile">
                                <a href="#form" class="btn-color-main-bright-orange">Хочу выплыть из кризиса</a>
                            </div>
                            <div class="careerum-flex-sbfs">
                                <div class="pack-form-center__item letter-6">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759342763553-l7rcP-Fram.png" class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759345925734-HrhaS-Grou.png" class="hidden-desc-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759348092679-CNgLh-Grou.png" class="hidden-desc-tablet position-absolute z-10" alt="img">
                                    <div class="pack-form-center__item__number careerum-flex-fsfs position-relative z-20">
                                        <p>6</p>
                                        <p>письмо</p>
                                    </div>
                                    <p class="pack-form-center__item__header position-relative z-20">Как вернуться<br> в карьеру из декрета</p>
                                </div>
                                <div class="pack-form-center__item letter-7">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759342765251-m8zYC-Grou.png" class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759345925896-ScK6z-Grou.png" class="hidden-desc-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759348093035-dWorE-Grou.png" class="hidden-desc-tablet position-absolute z-10" alt="img">
                                    <div class="pack-form-center__item__number careerum-flex-fsfs position-relative z-20">
                                        <p>7</p>
                                        <p>письмо</p>
                                    </div>
                                    <p class="pack-form-center__item__header position-relative z-20">Что делать, если я ничего не хочу. Либо хочу всё сразу</p>
                                </div>
                            </div>
                            <div class="careerum-flex-sbfs">
                                <div class="pack-form-center__item letter">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759342765641-nHdbJ-Grou.png" class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759345926070-PjFYJ-Grou.png" class="hidden-desc-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759348093328-bhxP9-Grou.png" class="hidden-desc-tablet position-absolute z-10" alt="img">
                                    <div class="position-relative z-20">
                                        <p>Бонус</p>
                                        <p>+3 секретных письма</p>
                                        <p>После которых вы переживете любой кризис</p>
                                    </div>
                                </div>
                                <div class="lead-form-wrapper">
                                    <p>Заберите Big Pack от Ольги Лермонтовой</p>
                                    <p>Чтобы в новом сезоне получить все профиты от профессиональной коммуникации</p>
                                    <div class="careerum-registration-form-club40">
                                        <form class="deva-form getcourse-email-signup"
                                            name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                            <div class="careerum-club40-form-name">
                                                <input type="text" name="name" value="" required placeholder="Имя">
                                                <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                            </div>
                                            <div class="careerum-club40-form-telegram">
                                                <input type="text" value="" name="telegram" required placeholder="Telegram">
                                                <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                            </div>
                                            <div class="careerum-club40-form-email">
                                                <input type="text" name="email" value="" required placeholder="Почта">
                                                <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                            </div>
                                            <div class="careerum-club40-form-phone">
                                                <input type="tel" value="" name="tel" required class="itl-input">
                                                <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                            </div>
                                            <div class="form-buttons">
                                                <div class="careerum-club40-form-agree">
                                                    <label>
                                                        <input type="checkbox" name="agree">
                                                        <div>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8"
                                                                viewBox="0 0 8 8" fill="none">
                                                                <path
                                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                            </svg>
                                                        </div>
                                                    </label>
                                                    <p>Я даю согласие
                                                        на обработку персональных данных
                                                        в соответствии с <a href="/ru-ru/legal/privacy">Политикой
                                                            конфиденциальности</a>
                                                    </p>
                                                </div>
                                                <a href="#" class="submit-btn btn-color-main-bright-orange button-sent"
                                                    disabled>Получать письма</a>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="careerum-form-success-lead">
                        <div class="position-relative">
                            <h2>Отлично, я уже собрала ваш бокс:</h2>
                            <p>первое письмо прилетит с минуты на минуту</p>
                            <div class="pack-form-author careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757429328445-UFQMt-Grou.png"
                                    class="hidden-tablet-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757435599540-0ek93-Grou.png"
                                    class="hidden-desc" alt="img">
                                <div class="position-relative">
                                    <p class="pack-form-name">Ольга Лермонтова</p>
                                    <p class="pack-form-position">СЕО Careerum</p>
                                </div>
                            </div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759345120933-r1YXh-Grou.svg"
                                class="hidden-tablet-mobile position-relative success-bg" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759347485045-vrPhS-Grou.svg"
                                class="hidden-desc-mobile position-relative success-bg" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759348247794-sscir-Grou.svg"
                                class="hidden-desc-tablet position-relative success-bg" alt="img">
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-club50-club', {
        label: 'Club 50 club (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club50-club main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Мне кажется, что Careerum — это комьюнити успешных карьеристов. А я просто работаю, можно ли мне в клуб?
                    </h2>
                    <div class="club50-club-content position-relative">
                        <p class="cub50-club-header hidden-tablet">Мы <span>не привилегированный</span> клуб для успешных карьеристов</p>
                        <p class="cub50-club-header hidden-desc-mobile">Мы <span>не привилегированный </span><br> клуб для успешных карьеристов</p>
                        <p class="cub50-club-label">Но здесь вы почувствуете себя именно так!</p>
                        <p class="cub50-club-text">Вы разрешите себе больше/лучше, вернёте амбиции и интерес к работе</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759517993037-bW0vN-Grou.png" class="hidden-tablet-mobile position-absolute" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759517997831-HugT0-Grou.png" class="hidden-desc-mobile position-absolute" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759517995493-czqBi-Grou.png" class="hidden-desc-tablet position-absolute" alt="img">
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-birthday-main', {
        label: 'Birthday main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-birthday-main main-wrapper position-relative">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759758628593-asvbL-Gene.png"
                    class="hidden-tablet-mobile position-absolute right" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759758630697-pRDfm-Gene.png"
                    class="hidden-desc-mobile position-absolute right" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759758633891-5grfr-Gene.png"
                    class="hidden-desc-tablet position-absolute right" alt="img">
                <div class="careerum-container-responsive position-relative">
                    <div class="birthday-main-logo">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1757407229179-x7R97-logo.svg"
                            class="hidden-tablet-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1755150918402-sy6tj-logo.svg"
                            class="hidden-desc" alt="img">
                    </div>
                    <div class="birthday-main-wrapper">
                        <div class="birthday-main-bg position-relative z-10">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759751942922-O8FQL-Backg.webp"
                                class="hidden-tablet-mobile position-absolute bg" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759759009658-2ckYY-backg.webp"
                                class="hidden-desc-mobile position-absolute bg" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759736516876-WqfWj-backg.webp"
                                class="hidden-desc-tablet position-absolute bg" alt="img">
                        </div>
                        <div class="birthday-main-content position-relative z-20">
                            <div class="birthday-main-labels">
                                <p class="position-relative z-10">Telegram-подкаст</p>
                                <p class="position-relative z-20">от Ольги Лермонтовой </p>
                            </div>
                            <h1>Как офигеть</h1>
                            <p class="birthday-main-text">и взять от жизни все! </p>
                            <a href="#form" class="btn-color-main-bright-orange">Слушать подкаст</a>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-birthday-why', {
        label: 'Birthday why (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-birthday-why main-wrapper position-relative z-10">
                <div class="careerum-container-responsive position-relative">
                    <h2 class="position-relative z-30">Вам точно нужно это послушать, если:</h2>
                    <div class="birthday-why-bg position-relative z-10">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759759966852-ML2of-Frame.webp"
                            class="hidden-tablet-mobile position-absolute" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759760580929-3JtSZ-Frame.webp"
                            class="hidden-desc-mobile position-absolute" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759760919969-sueyM-49587.webp"
                            class="hidden-desc-tablet position-absolute" alt="img">
                    </div>
                    <div class="birthday-why-content position-relative z-20 careerum-flex-sbst">
                        <div class="birthday-why-item">
                            <p>Вам не досталась волшебная лампа с джинном</p>
                        </div>
                        <div class="birthday-why-item">
                            <p>Ваш папа не султан</p>
                        </div>
                        <div class="birthday-why-item">
                            <p>Вы всю жизнь были как истинная восточная принцесса — умницей и скромницей</p>
                        </div>
                        <div class="birthday-why-item">
                            <p>И вам кажется,<br> что уже поздно что-то менять!</p>
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759759464242-A8LoY-Grou.png"
                            class="hidden-tablet-mobile position-absolute" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759760470233-UaTWT-Grou.png"
                            class="hidden-desc-mobile position-absolute" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759761376589-vQHwD-Grou.png"
                            class="hidden-desc-tablet position-absolute" alt="img">
                    </div>
                </div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759760027975-y7vMm-d120.png"
                    class="hidden-tablet-mobile position-absolute z-20" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759760581345-NAzha-d120.png"
                    class="hidden-desc-mobile position-absolute z-20" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759761689771-tzA3W-Grou.png"
                    class="hidden-desc-tablet position-absolute z-40" alt="img">
                <div class="position-absolute z-30 bottom-shadow"></div>
            </div>`
    });
    
    blockManager.add('careerum-birthday-form', {
        label: 'Birthday form (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-birthday-form main-wrapper position-relative z-20">
                <div class="careerum-container-responsive position-relative careerum-flex-sbfs">
                    <div class="birthday-form-left position-relative z-20">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759736175804-1CRPu-Fram.png"
                            class="hidden-tablet-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759737681761-8LHL6-Grou.png"
                            class="hidden-desc-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759738409557-hSJiJ-Grou.png"
                            class="hidden-desc-tablet" alt="img">
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759738173386-y1oDt-Gene.png"
                        class="hidden-desc-tablet position-absolute z-10" alt="img">
                    <div class="birthday-form-right position-relative z-20">
                        <h2>Заполните форму, чтобы получить доступ</h2>
                        <div class="careerum-registration-form-club40">
                            <form class="deva-form getcourse-email-signup addCountry" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-telegram">
                                    <input type="text" value="" name="telegram" required placeholder="Telegram">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я даю согласие
                                        на обработку персональных данных
                                        в соответствии с <a href="/ru-ru/legal/privacy">Политикой
                                            конфиденциальности</a>
                                    </p>
                                </div>
                                <a href="#" class="submit-btn btn-color-main-bright-orange button-sent" disabled>Слушать
                                    подкаст</a>
                            </form>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-veb50-main', {
        label: 'Veb 50 main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-veb50-main main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="veb50-main-bg position-relative z-10">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759904819291-2Qyuw-Grou.png"
                            class="hidden-tablet-mobile position-absolute" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759904831047-y5agB-Grou.png"
                            class="hidden-desc-mobile position-absolute" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759903074254-q6uys-Grou.png"
                            class="hidden-desc-tablet position-absolute" alt="img">
                    </div>
                    <div class="veb50-main-content position-relative z-20">
                        <div class="veb50-main-labels careerum-flex-fsfs">
                            <div class="veb50-main-label white careerum-flex-cc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759903216867-V623J-Cale.svg"
                                    class="hidden-tablet-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759903240902-AOeBt-Cale.svg"
                                    class="hidden-desc-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759903270018-0GIZR-Cale.svg"
                                    class="hidden-desc-tablet" alt="img">
                                <p>2 ноября, 12:00 мск </p>
                            </div>
                            <div class="veb50-main-label white careerum-flex-cc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759920318952-HCTww-Cloc.svg" class="hidden-tablet-mobile"
                                    alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759919971173-kUZjW-Cloc.svg" class="hidden-desc-mobile"
                                    alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759919977017-uZdHW-Cloc.svg" class="hidden-desc-tablet"
                                    alt="img">
                                <p>2 часа</p>
                            </div>
                            <div class="veb50-main-label blue">
                                <p>Мастер-класс Ольги Лермонтовой</p>
                            </div>
                        </div>
                        <h1>Кризис середины карьеры</h1>
                        <div class="veb50-main-items careerum-flex-sbst">
                            <div class="veb50-main-item careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759903320984-9dWOB-Note.svg"
                                    class="hidden-tablet-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759903384696-8q6kZ-Note.svg"
                                    class="hidden-desc-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759903442780-3uMMq-Note.svg"
                                    class="hidden-desc-tablet" alt="img">
                                <p><span>Разберётесь в причинах</span> вашего карьерного кризиса</p>
                            </div>
                            <div class="veb50-main-item careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759903321339-DbXqU-Wren.svg"
                                    class="hidden-tablet-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759903385065-VWK3v-Wren.svg"
                                    class="hidden-desc-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759903443350-dqgC0-Wren.svg"
                                    class="hidden-desc-tablet" alt="img">
                                <p><span>Получите инструменты</span>, как выйти из тупика без радикальных решений и потраченных
                                    нервов</p>
                            </div>
                            <div class="veb50-main-item careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759903321114-iGzWo-Tren.svg"
                                    class="hidden-tablet-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759903384945-9rADD-Tren.svg"
                                    class="hidden-desc-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759903443238-m2CBE-Tren.svg"
                                    class="hidden-desc-tablet" alt="img">
                                <p><span>Сформируете личную стратегию:</span> куда двигаться дальше, чтобы вернуть себе драйв,
                                    кайф и перспективы</p>
                            </div>
                        </div>
                        <a href="#buy" class="btn-color-main-dark-orange">Купить билет на мастер-класс</a>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-veb50-form', {
        label: 'Veb 50 form (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-veb50-form main-wrapper" data-offer-rub="376" data-offer-eur="377" data-price-rub="1 900 ₽" data-price-eur="19 €" data-old_price-rub="4 990 ₽" data-old_price-eur="49 €">
                <div class="careerum-container-responsive">
                    <div class="veb50-form-bg position-relative z-10">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759920404562-f3VgR-Grou.svg" class="hidden-tablet-mobile position-absolute" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759921750209-l9lLd-Grou.svg" class="hidden-desc-mobile position-absolute" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759934854455-G5ZGH-Subt.svg" class="hidden-desc-tablet position-absolute" alt="img">
                    </div>
                    <div class="veb50-form-wrapper careerum-flex-sbfs position-relative z-20">
                        <div class="veb50-form-left">
                            <div class="veb50-form-left-labels careerum-flex-fsfs">
                                <div class="veb50-form-left-label careerum-flex-fsc white position-relative z-10">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759903240902-AOeBt-Cale.svg" class="hidden-mobile"
                                        alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759903270018-0GIZR-Cale.svg" class="hidden-desc-tablet"
                                        alt="img">
                                    <p>2 ноября, 12:00 мск</p>
                                </div>
                                <div class="veb50-form-left-label blue position-relative z-20">
                                    <p>Мастер-класс Ольги Лермонтовой</p>
                                </div>
                            </div>
                            <h2>Кризис середины карьеры</h2>
                        </div>
                        <div class="veb50-form-right">
                            <div class="veb50-form-switcher careerum-flex-fec">
                                <div class="veb50-form-curr careerum-flex-fsst">
                                    <ul class="careerum-flex-fsfs rub">
                                        <li data-currency="eur">EUR</li>
                                        <li data-currency="rub" class="active">RUB</li>
                                    </ul>
                                    <div class="veb50-form-notif careerum-flex-cc">
                                        <div class="veb50-form-notif-icon"> <img
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                                alt=""> </div>
                                        <div class="veb50-form-notif-content">
                                            <p>Оплата в российских рублях возможна только картой российского банка. В&nbsp;евро — картой
                                                зарубежного банка</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="careerum-registration-form-club40">
                                <form class="deva-form addCountry" name="devaRegistrationForm"
                                    data-gjs-type="deva-registration-form">
                                    <div class="careerum-club40-form-name">
                                        <input type="text" name="name" value="" required placeholder="Имя">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                    </div>
                                    <div class="careerum-club40-form-telegram">
                                        <input type="text" value="" name="telegram" required placeholder="Telegram">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                    </div>
                                    <div class="careerum-club40-form-email">
                                        <input type="text" name="email" value="" required placeholder="Почта">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                    </div>
                                    <div class="careerum-club40-form-phone">
                                        <input type="tel" value="" name="tel" required class="itl-input">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                    </div>
                                    <div class="careerum-club40-form-agree">
                                        <label>
                                            <input type="checkbox" name="agree">
                                            <div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                    fill="none">
                                                    <path
                                                        d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                        stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </label>
                                        <p>Я даю согласие
                                            на обработку персональных данных
                                            в соответствии с <a href="/ru-ru/legal/privacy">Политикой
                                                конфиденциальности</a>
                                        </p>
                                    </div>
                                    <div class="careerum-club40-form-price careerum-flex-fsc">
                                        <p class="price"></p>
                                        <p class="old-price"></p>
                                    </div>
                                    <div class="veb50-mobile-curr-wrapper position-relative z-20">
                                        <div class="veb50-tariffs__swicher-block">
                                            <div class="veb50-tariffs__swicher-top">
                                                <p class="veb50-tariffs__swicher-header">Посмотреть
                                                    цены в
                                                    <span>EUR</span>
                                                </p><svg xmlns="http://www.w3.org/2000/svg" width="24"
                                                    height="24" viewBox="0 0 24 24" fill="none" class="veb50-tariffs__swicher-arrow">
                                                    <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black">
                                                    </path>
                                                </svg>
                                            </div>
                                            <div class="veb50-tariffs__swicher-bottom">
                                                <ul>
                                                    <li data-currency="rub" class="active">
                                                        RUB
                                                    </li>
                                                    <li data-currency="eur">
                                                        EUR
                                                    </li>
                                                </ul>
                                                <p>
                                                    Обратите внимание,<br> что оплата в российских
                                                    рублях
                                                    возможна только<br> с карты
                                                    российского банка. Оплата в евро — с карты зарубежного банка
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <a href="#" class="submit-btn btn-color-main-dark-orange button-sent" disabled>Купить билет на
                                        мастер-класс</a>
                                    <input type="hidden" hidden name="offerID" value="">
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-veb50-reviews', {
        label: 'Veb 50 reviews (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-veb50-reviews main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Отзывы о мастер-классе</h2>
                    <div class="veb50-reviews-slider">
                        <div class="veb50-reviews-slider-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759914762452-HZHNd-Fram.png" class="hidden-tablet-mobile"
                                alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759919821007-PMeJt-Fram.png" class="hidden-desc-mobile"
                                alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759934413603-wnh0n-Fram.png" class="hidden-desc-tablet"
                                alt="img">
                        </div>
                        <div class="veb50-reviews-slider-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759914762950-dqWvr-Fram.png" class="hidden-tablet-mobile"
                                alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759919821500-nykyc-Fram.png" class="hidden-desc-mobile"
                                alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759934414276-Rd6Sw-Fram.png" class="hidden-desc-tablet"
                                alt="img">
                        </div>
                        <div class="veb50-reviews-slider-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759914763184-SK7TL-Fram.png" class="hidden-tablet-mobile"
                                alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759919821646-08jtk-Fram.png" class="hidden-desc-mobile"
                                alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759934414418-rtZXL-Fram.png" class="hidden-desc-tablet"
                                alt="img">
                        </div>
                        <div class="veb50-reviews-slider-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759914763434-z5NDL-Fram.png" class="hidden-tablet-mobile"
                                alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759919821773-UpYHq-Fram.png" class="hidden-desc-mobile"
                                alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759934414579-QiYuO-Fram.png" class="hidden-desc-tablet"
                                alt="img">
                        </div>
                        <div class="veb50-reviews-slider-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759914763594-3YUpf-Fram.png" class="hidden-tablet-mobile"
                                alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759919821888-CDKJs-Fram.png" class="hidden-desc-mobile"
                                alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759934414741-Ir8a2-Fram.png" class="hidden-desc-tablet"
                                alt="img">
                        </div>
                        <div class="veb50-reviews-slider-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759914763736-z36g6-Fram.png" class="hidden-tablet-mobile"
                                alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759919822025-HLneT-Fram.png" class="hidden-desc-mobile"
                                alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759934414891-nU2mB-Fram.png" class="hidden-desc-tablet"
                                alt="img">
                        </div>
                    </div>
                    <div class="veb50-reviews-slider-nav careerum-flex-fec">
                        <div class="veb50-reviews-nav-prev careerum-flex-cc ">
                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="veb50-reviews-nav-next careerum-flex-cc">
                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-veb50-who', {
        label: 'Veb 50 who (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-veb50-who main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Для кого этот мастер-класс</h2>
                    <div class="veb50-who-wrapper careerum-flex-sbst">
                        <div class="veb50-who-item careerum-flex-fsfs position-relative z-10">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759999431108-taWtG-Smil.svg" class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760000256688-u741X-Smil.svg" class="hidden-desc-tablet" alt="img">
                            <p>Думали, что если много-много работать, будет много денег и признания. А оказалось — только много-много работы</p>
                        </div>
                        <div class="veb50-who-item careerum-flex-fsfs position-relative z-20">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759999471435-VLmuv-XCir.svg" class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760000257227-uLtPG-XCir.svg" class="hidden-desc-tablet" alt="img">
                            <p>Уже ненавидите свою работу, но страшно решиться на перемены и облажаться. Кажется, что потеряете всё и придётся начать с нуля</p>
                        </div>
                        <div class="veb50-who-item careerum-flex-fsfs position-relative z-10">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759999430981-zLTQc-Thum.svg" class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760000256968-TuaGN-Thum.svg" class="hidden-desc-tablet" alt="img">
                            <p>Упорно работали и выросли. А там наверху не обнаружили ни счастья, ни драйва, только лишь выгорание и потерю смысла</p>
                        </div>
                        <div class="veb50-who-item careerum-flex-fsfs position-relative z-20">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759999431108-taWtG-Smil.svg" class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760000256688-u741X-Smil.svg" class="hidden-desc-tablet" alt="img">
                            <p>Работаете в международной компании, как мечтали, но уткнулись в стеклянный потолок и не знаете, как его разбить </p>
                        </div>
                        <div class="veb50-who-item careerum-flex-fsfs position-relative z-30">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759999471435-VLmuv-XCir.svg" class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760000257227-uLtPG-XCir.svg" class="hidden-desc-tablet" alt="img">
                            <p>Решились на переезд за границу, но оказались один на один с новым рынком труда и растерялись</p>
                        </div>
                        <div class="veb50-who-item careerum-flex-fsfs position-relative z-40">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1759999430833-hDnOC-Warn.svg" class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760000257097-dIfF2-Warn.svg" class="hidden-desc-tablet" alt="img">
                            <p>Проработали 10+ лет в одной компании, а теперь нужно менять работу — и вы растеряны: с чего начинать и что делать</p>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-realme50-main', {
        label: 'RealMe main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club5-main main-wrapper careerum-realme50-main">
                <div class="careerum-container-responsive">
                    <div class="club5-main-top position-relative">
                        <div class="position-relative z-10 club5-main-labels careerum-flex-fsfs">
                            <p class="club5-main-label black">Интенсив</p>
                            <p class="club5-main-label pink">В подписке Careerum</p>
                        </div>
                        <h1 class="position-relative z-20">Real me 2.0</h1>
                        <p class="position-relative z-20">Перезагрузка</p>
                        <p class="position-relative z-20">Курс поможет перезапустить карьеру в 30+ на чистовик</p>
                    </div>
                    <div class="club5-main-center careerum-flex-sbst">
                        <div class="club5-main-left">
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760349555180-Sglnb-Soft.svg"
                                        class="hidden-tablet-mobile" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760349556966-9wv4F-Soft.svg"
                                        class="hidden-desc" alt="img">
                                    <p>Понять, куда двигаться дальше в карьере</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760349555180-Sglnb-Soft.svg"
                                        class="hidden-tablet-mobile" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760349556966-9wv4F-Soft.svg"
                                        class="hidden-desc" alt="img">
                                    <p>Перепридумать себя на меняющемся рынке</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760349555180-Sglnb-Soft.svg"
                                        class="hidden-tablet-mobile" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760349556966-9wv4F-Soft.svg"
                                        class="hidden-desc" alt="img">
                                    <p>Найти новый вектор самореализации, не обнуляя накопленный опыт</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club5-main-right">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760349825592-2xCxe-Bott.png"
                                class="hidden-tablet-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760349897893-InoaQ-Grou.png"
                                class="hidden-desc-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760349897409-s6Cxf-Bott.png"
                                class="hidden-desc-tablet" alt="img">
                        </div>
                    </div>
                    <div class="club5-main-link">
                        <a href="#program" class="btn-color-main-bright-orange">Посмотреть
                            программу</a>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-realme50-experience', {
        label: 'RealMe experience (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club5-experience careerum-realme50-experience main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <p class="club5-experience-top">У вас за плечами реальный опыт,
                        пройденные взлёты и&nbsp;падения. Карьера
                        <span>вроде бы</span> есть. Но вы&nbsp;стоите на распутье:
                    </p>
                    <div class="club5-experience-center careerum-flex-fsfs position-relative z-10">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760351060171-kQAv0-Prof.png" alt="">
                        <p>Хочется нового этапа, но какого – не понятно. Понятно только то, что по-старому уже не хочется? </p>
                    </div>
                    <p class="club5-experience-bottom position-relative z-30">Страшно
                        ошибиться и выбрать не то</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760351212487-eI13E-Vect.svg" alt=""
                        class="bottom-text-bg position-absolute z-20 hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760351213329-YWfuB-Grou.svg" alt=""
                        class="center-text-bg position-absolute z-20 hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760446639177-bIUuI-Vect.svg" alt=""
                        class="bottom-text-bg position-absolute z-20 hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760446637457-uFNPs-Grou.svg" alt=""
                        class="center-text-bg position-absolute z-20 hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760450978222-oQuSx-Grou.svg" alt=""
                        class="center-text-bg position-absolute z-20 hidden-desc-tablet">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760450977659-zKtHD-Vect.svg" alt=""
                        class="bottom-text-bg position-absolute z-20 hidden-desc-tablet">
                </div>
            </div>`
    });
    
    blockManager.add('careerum-realme50-myths', {
        label: 'RealMe myths (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club5-myths main-wrapper careerum-realme50-myths">
                <div class="careerum-container-responsive">
                    <div class="club5-myths-header-container position-relative">
                        <h2>Курс для вас, если:</h2>
                    </div>
                    <div class="club5-myths-slider">
                        <div class="club5-myths-item">
                            <div class="club5-myths-item-top">
                                <p class="club5-myths-item-title">вы в кризисе середины карьеры: вроде чего‑то добились,
                                    но что дальше — непонятно</p>
                                <p class="club5-myths-item-label2">После Real ME</p>
                                <p class="club5-myths-item-text2">Пройдете кризис мягко и сформулируете новый образ
                                    себя-профессионала в изменчивом мире работы</p>
                            </div>
                            <div class="club5-myths-item-bottom">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760351857794-q1WMA-Fram.png"
                                    class="hidden-tablet-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760447406360-mxX8L-Imag.png" class="hidden-desc-mobile"
                                    alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760451321734-NXY3u-Imag.png" class="hidden-desc-tablet"
                                    alt="img">
                            </div>
                        </div>
                        <div class="club5-myths-item">
                            <div class="club5-myths-item-top">
                                <p class="club5-myths-item-title">Надоело работать с идиотами и кажется, что любая компания —
                                    это болото</p>
                                <p class="club5-myths-item-label2">После Real ME</p>
                                <p class="club5-myths-item-text2">Выберите работу на пересечении ваших ценностей, талантов и
                                    потребности рынка</p>
                            </div>
                            <div class="club5-myths-item-bottom">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760351859437-ZqRsS-Fram.png"
                                    class="hidden-tablet-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760447405469-sAR1Z-Imag.png" class="hidden-desc-mobile"
                                    alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760451316614-TKkSg-Imag.png" class="hidden-desc-tablet"
                                    alt="img">
                            </div>
                        </div>
                        <div class="club5-myths-item">
                            <div class="club5-myths-item-top">
                                <p class="club5-myths-item-title">вы сейчас в переломном моменте и выбираете между несколькими
                                    карьерными сценариями</p>
                                <p class="club5-myths-item-label2">После Real ME</p>
                                <p class="club5-myths-item-text2">Выберете то, что реально ваше, без прессинга чужих ожиданий
                                </p>
                            </div>
                            <div class="club5-myths-item-bottom">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760351858567-7IXzG-Fram.png"
                                    class="hidden-tablet-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760447405738-yoLkY-Imag.png" class="hidden-desc-mobile"
                                    alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760451317325-D8Qw8-Imag.png" class="hidden-desc-tablet"
                                    alt="img">
                            </div>
                        </div>
                        <div class="club5-myths-item">
                            <div class="club5-myths-item-top">
                                <p class="club5-myths-item-title">Хотите поменять сферу работы, но боитесь ошибиться — вдруг
                                    выберете не то</p>
                                <p class="club5-myths-item-label2">После Real ME</p>
                                <p class="club5-myths-item-text2">Соберёте новый вектор развития, который станет опорой
                                    даже на изменчивом рынке труда</p>
                            </div>
                            <div class="club5-myths-item-bottom">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760351859807-47hIg-Fram.png"
                                    class="hidden-tablet-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760447406627-GiXkr-Imag.png" class="hidden-desc-mobile"
                                    alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760451323823-CIurI-Imag.png" class="hidden-desc-tablet"
                                    alt="img">
                            </div>
                        </div>
                        <div class="club5-myths-item">
                            <div class="club5-myths-item-top">
                                <p class="club5-myths-item-title">меняете работу каждые 2–3 года, разочаровываетесь и выгораете
                                    на каждой</p>
                                <p class="club5-myths-item-label2">После Real ME</p>
                                <p class="club5-myths-item-text2">Выявите свои личные карьерные опоры, которые не разрушат
                                    кризисы и войны</p>
                            </div>
                            <div class="club5-myths-item-bottom">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760351859019-ZGLSV-Fram.png"
                                    class="hidden-tablet-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760447406080-ddrj2-Imag.png" class="hidden-desc-mobile"
                                    alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760451319819-5ghsx-Imag.png" class="hidden-desc-tablet"
                                    alt="img">
                            </div>
                        </div>
                    </div>
                    <div class="club5-myths-slider-nav careerum-flex-fec">
                        <div class="club5-myths-nav-prev careerum-flex-cc ">
                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="club5-myths-nav-next careerum-flex-cc">
                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>
                    <div class="club5-myths-link">
                        <a href="#buy" class="btn-color-main-bright-orange">Записаться
                            в лист ожидания</a>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-realme50-career', {
        label: 'RealMe career (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club5-career main-wrapper careerum-realme50-career">
                <div class="careerum-container-responsive">
                    <h2>Ваша карьера:</h2>
                    <div class="club5-career-top position-relative">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748347401887-dyomU-Grou.svg" alt=""
                            class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748426057709-9INSl-Grou.svg" alt=""
                            class="hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748512306858-PcJEF-Grou.svg" alt=""
                            class="hidden-desc-tablet">
                        <div class="position-relative">
                            <div class="club5-career-top-item position-absolute careerum-flex-cc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748684276278-qm2gQ-Fram.svg"
                                    alt="" class="hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748684327525-XYLyt-Icon.svg"
                                    alt="" class="hidden-desc-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748684329032-yRaKe-Icon.svg"
                                    alt="" class="hidden-desc-tablet">
                                <p>Не гонка</p>
                            </div>
                            <div class="club5-career-top-item position-absolute careerum-flex-cc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748347853508-d65FU-Icon.svg"
                                    alt="" class="hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748426232672-9NUWV-Icon.svg"
                                    alt="" class="hidden-desc-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748512407514-IRlBP-Icon.svg"
                                    alt="" class="hidden-desc-tablet">
                                <p>Не чужие ожидания</p>
                            </div>
                            <div class="club5-career-top-item position-absolute careerum-flex-cc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748347853272-6J7k6-Icon.svg"
                                    alt="" class="hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748426232464-Vc2A6-Icon.svg"
                                    alt="" class="hidden-desc-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1748512407265-JlKOK-Icon.svg"
                                    alt="" class="hidden-desc-tablet">
                                <p>Не лестница</p>
                            </div>
                        </div>
                    </div>
                    <div class="club5-career-center position-relative">
                        <p>В Careerum мы учим строить карьеру на <span class="violet">внутренней опоре</span>, с уважением к своим ценностям, <span class="yellow">целям</span>, в своем ритме и балансе</p>
                    </div>
                    <div class="club5-career-bottom careerum-flex-sbst">
                        <div class="club5-career-bottom-left position-relative">
                            <div class="position-absolute">
                                <p class="club5-career-bottom-item-text position-absolute">Бренд</p>
                                <p class="club5-career-bottom-item-text position-absolute">Статус</p>
                                <p class="club5-career-bottom-item-text position-absolute">Престиж</p>
                                <p class="club5-career-bottom-item-text position-absolute">Деньги</p>
                                <p class="club5-career-bottom-item-text position-absolute">Крутую роль</p>
                                <p class="club5-career-bottom-item-text position-absolute">Выше, быстрее, сильнее</p>
                            </div>
                            <p class="club5-career-bottom-item-header">Вы думаете, что
                                хотите:</p><img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760353844702-Fp2yP-Grou.svg" alt=""
                                class="hidden-tablet-mobile position-absolute"><img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760353846992-yCneE-Grou.svg" alt=""
                                class="hidden-desc-mobile position-absolute"><img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760353848799-ASLCq-Grou.svg" alt=""
                                class="hidden-desc-tablet position-absolute z-10">
                        </div>
                        <div class="club5-career-bottom-right position-relative z-20">
                            <p class="club5-career-bottom-item-header">А на самом деле
                                ищете:</p>
                            <div class="position-absolute">
                                <p class="club5-career-bottom-item-text position-absolute">Баланс</p>
                                <p class="club5-career-bottom-item-text position-absolute">Цели</p>
                                <p class="club5-career-bottom-item-text position-absolute">Огонь</p>
                                <p class="club5-career-bottom-item-text position-absolute">Легкость</p>
                                <p class="club5-career-bottom-item-text position-absolute">Интерес</p>
                                <p class="club5-career-bottom-item-text position-absolute">Смыслы</p>
                                <p class="club5-career-bottom-item-text position-absolute">Деньги</p>
                                <p class="club5-career-bottom-item-text position-absolute">Признание</p>
                            </div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760354686583-8FWpD-Grou.svg"
                                alt="" class="hidden-tablet-mobile position-absolute">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760354688021-GoAQZ-Grou.svg"
                                alt="" class="hidden-desc-mobile position-absolute">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760354690108-8u0bD-Grou.svg"
                                alt="" class="hidden-desc-tablet position-absolute">
                        </div>
                    </div>
                    <a href="#buy" class="btn-color-main-bright-orange hidden-tablet-mobile">Записаться
                        в лист ожидания</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-realme50-calendar', {
        label: 'RealMe calendar (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club5-calendar main-wrapper careerum-realme50-calendar">
                <div class="careerum-container-responsive">
                    <div class="club5-calendar-intensive position-relative">
                        <div class="club5-calendar-intensive-top careerum-flex-fsc">
                            <p class="club5-calendar-intensive-type">Интенсив</p>
                            <p class="club5-calendar-intensive-orange">В подписке Careerum</p>
                        </div>
                        <p class="club5-calendar-intensive-header">Программа интенсива</p>
                        <p class="club5-calendar-intensive-text">Видеоуроки и живые практикумы с профессиональными коучами,
                            карьерными экспертами и профориентологами Careerum</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760356403403-LWFwf-Fram.svg" alt="img"
                            class="hidden-tablet-mobile position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760356345493-pJM2O-Puzz.svg" alt="img"
                            class="hidden-desc-mobile position-absolute">
                    </div>
                    <div class="club5-calendar-items-2">
                        <div class="club5-calendar-item2 active">
                            <div class="club5-calendar-item2-top careerum-flex-sbfs">
                                <div>
                                    <p class="club5-calendar-item2-label">Модуль 1</p>
                                    <p class="club5-calendar-item2-header">Определяем свою карьерную точку «А»</p>
                                </div>
                                <div class="careerum-flex-cc">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760356855022-smtiq-Grou.svg"
                                        class="hidden-tablet-mobile" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760356857182-KJ1d3-Grou.svg"
                                        class="hidden-desc-mobile" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760356859200-MnwGp-Grou.svg"
                                        class="hidden-desc-tablet" alt="img">
                                </div>
                            </div>
                            <div class="club5-calendar-item2-top">
                                <ul>
                                    <li>Вы определите свою карьерную точку «А» и цель на курс</li>
                                    <li>Узнаете свою текущую карьерную стадию и наметите следующий карьерный шаг</li>
                                    <li>Разберётесь с негативными установками, которые мешают расти / менять карьеру</li>
                                </ul>
                            </div>
                        </div>
                        <div class="club5-calendar-item2">
                            <div class="club5-calendar-item2-top careerum-flex-sbfs">
                                <div>
                                    <p class="club5-calendar-item2-label">Модуль 2</p>
                                    <p class="club5-calendar-item2-header">Ваши «Могу». Определяем навыки, опыт
                                        и знания и формируем в единую систему</p>
                                </div>
                                <div class="careerum-flex-cc">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760356855022-smtiq-Grou.svg"
                                        class="hidden-tablet-mobile" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760356857182-KJ1d3-Grou.svg"
                                        class="hidden-desc-mobile" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760356859200-MnwGp-Grou.svg"
                                        class="hidden-desc-tablet" alt="img">
                                </div>
                            </div>
                            <div class="club5-calendar-item2-top">
                                <ul>
                                    <li>Вы определите ваши навыки, опыт и знания и сформируете из них единую систему</li>
                                    <li>Присвоите себе свои таланты и сильные стороны</li>
                                    <li>Увидите, какие виды деятельности вас заряжают, а какие, наоборот, высасывают энергию
                                    </li>
                                    <li>Проведёте ревизию текущей, предыдущих и возможных будущих деятельностей на соответствие
                                        вашим «могу»</li>
                                </ul>
                            </div>
                        </div>
                        <div class="club5-calendar-item2">
                            <div class="club5-calendar-item2-top careerum-flex-sbfs">
                                <div>
                                    <p class="club5-calendar-item2-label">Модуль 3</p>
                                    <p class="club5-calendar-item2-header">Ваши «Хочу». Формулируем ваши фундаментальные
                                        потребности в работе</p>
                                </div>
                                <div class="careerum-flex-cc">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760356855022-smtiq-Grou.svg"
                                        class="hidden-tablet-mobile" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760356857182-KJ1d3-Grou.svg"
                                        class="hidden-desc-mobile" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760356859200-MnwGp-Grou.svg"
                                        class="hidden-desc-tablet" alt="img">
                                </div>
                            </div>
                            <div class="club5-calendar-item2-top">
                                <ul>
                                    <li>Вы узнаете, какие у вас есть глубинные профессиональные ценности а работе</li>
                                    <li>Вы найдёте и определите свои мотиваторы и интересы, чтобы работа заряжала</li>
                                    <li>Проведёте ревизию текущей, предыдущих и возможных будущих деятельностей на соответствие
                                        вашим «хочу»</li>
                                </ul>
                            </div>
                        </div>
                        <div class="club5-calendar-item2">
                            <div class="club5-calendar-item2-top careerum-flex-sbfs">
                                <div>
                                    <p class="club5-calendar-item2-label">Модуль 4</p>
                                    <p class="club5-calendar-item2-header">Ваши «Надо». Проводим анализ рынка и определяем
                                        возможные пути развития</p>
                                </div>
                                <div class="careerum-flex-cc">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760356855022-smtiq-Grou.svg"
                                        class="hidden-tablet-mobile" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760356857182-KJ1d3-Grou.svg"
                                        class="hidden-desc-mobile" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760356859200-MnwGp-Grou.svg"
                                        class="hidden-desc-tablet" alt="img">
                                </div>
                            </div>
                            <div class="club5-calendar-item2-top">
                                <ul>
                                    <li>Вы научитесь анализировать релевантные вам отрасли, профессии, компании</li>
                                    <li>Проведёте ревизию всех факторов рынка для вашей будущей деятельности</li>
                                    <li>Найдёте опции достойной монетизации новой деятельности</li>
                                </ul>
                            </div>
                        </div>
                        <div class="club5-calendar-item2">
                            <div class="club5-calendar-item2-top careerum-flex-sbfs">
                                <div>
                                    <p class="club5-calendar-item2-label">Модуль 5</p>
                                    <p class="club5-calendar-item2-header">Создаём сильные карьерные гипотезы на основе ваших
                                        «могу», «хочу» и «надо»</p>
                                </div>
                                <div class="careerum-flex-cc">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760356855022-smtiq-Grou.svg"
                                        class="hidden-tablet-mobile" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760356857182-KJ1d3-Grou.svg"
                                        class="hidden-desc-mobile" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760356859200-MnwGp-Grou.svg"
                                        class="hidden-desc-tablet" alt="img">
                                </div>
                            </div>
                            <div class="club5-calendar-item2-top">
                                <ul>
                                    <li>И идём воплощать их в жизнь!</li>
                                    <li>Проведёте ревизию всех факторов рынка для вашей будущей деятельности</li>
                                    <li>Вы научитесь делать осознанные карьерные выборы на долгие годы и получите уверенность
                                        в себе и в принятии решений</li>
                                </ul>
                            </div>
                        </div>
                        <div class="club5-calendar-item2">
                            <div class="club5-calendar-item2-top careerum-flex-sbfs">
                                <div>
                                    <p class="club5-calendar-item2-label">Модуль 6</p>
                                    <p class="club5-calendar-item2-header">Практика и выход в жизнь с новой карьерной стратегией
                                    </p>
                                </div>
                                <div class="careerum-flex-cc">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760356855022-smtiq-Grou.svg"
                                        class="hidden-tablet-mobile" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760356857182-KJ1d3-Grou.svg"
                                        class="hidden-desc-mobile" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760356859200-MnwGp-Grou.svg"
                                        class="hidden-desc-tablet" alt="img">
                                </div>
                            </div>
                            <div class="club5-calendar-item2-top">
                                <ul>
                                    <li>Вы протестируете свои карьерные гипотезы, сформулированные на курсе</li>
                                    <li>Вернётесь с вопросами к нашим карьерным экспертам</li>
                                    <li>Доработаете свои гипотезы на основе реального опыта и ответов экспертов</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="club5-calendar-link">
                        <a href="#buy" class="btn-color-main-bright-orange">Записаться в лист ожидания</a>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-realme50-results', {
        label: 'RealMe results (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-realme50-results main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="realme50-results-header position-relative">
                        <h2>Результаты после Real Me</h2>
                        <p class="position-absolute">До / После</p>
                    </div>
                    <div class="realme50-results-slider">
                        <div class="realme50-results-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760362705468-uZUEL-mobi.png"
                                class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760362838989-jFnaG-mobi.png"
                                class="hidden-desc-tablet" alt="img">
                            <p class="realme50-results-name">Николай Ковров</p>
                            <p class="realme50-results-position">Product Manager, Россия</p>
                            <a href="https://www.linkedin.com/in/nikolay-kovrov-2ba617160/" target="_blank" class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760361892331-DADwE-Link.svg"
                                    alt="">
                                <p>Профиль в LinkedIn</p>
                            </a>
                            <div class="realme50-results-divider"></div>
                            <p class="realme50-results-subheader orange">До:</p>
                            <p class="realme50-results-text">Не смог реализовать себя в индустрии спорта. Работал в стартапах,
                                Яндексе и Инвитро, но столкнулся с переработками, выгоранием и потерей смыслов</p>
                            <p class="realme50-results-subheader black">Результат с Careerum:</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760361977091-VHB0T-Care.svg"
                                        alt="">
                                    <p>Получил предложение на позицию продакт-менеджера от крупного российского банка</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760361977091-VHB0T-Care.svg"
                                        alt="">
                                    <p>Вырос в доходе в 3 раза</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760361977091-VHB0T-Care.svg"
                                        alt="">
                                    <p>Открыл новые карьерные перспективы</p>
                                </li>
                            </ul>
                        </div>
                        <div class="realme50-results-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760362705891-Dquw2-mobi.png"
                                class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760362839402-fD1qj-mobi.png"
                                class="hidden-desc-tablet" alt="img">
                            <p class="realme50-results-name">Александра Анцупова</p>
                            <p class="realme50-results-position">Crew Coordinator and Analyst, Латвия</p>
                            <a href="https://www.linkedin.com/in/aleksandra-ancupova-2b1b571a8/" target="_blank" class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760361892331-DADwE-Link.svg"
                                    alt="">
                                <p>Профиль в LinkedIn</p>
                            </a>
                            <div class="realme50-results-divider"></div>
                            <p class="realme50-results-subheader orange">До:</p>
                            <p class="realme50-results-text">Работала менеджером по продажам, затем проджект-менеджером,
                                но чувствовала себя не на своём месте. Функционал оказался ей неинтересен и не соответствовал
                                её ценностям</p>
                            <p class="realme50-results-subheader black">Результат с Careerum:</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760361977091-VHB0T-Care.svg"
                                        alt="">
                                    <p>Научилась составлять продающее резюме и формулировать достижения</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760361977091-VHB0T-Care.svg"
                                        alt="">
                                    <p>Получила оффер после первого отклика</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760361977091-VHB0T-Care.svg"
                                        alt="">
                                    <p>Сменила индустрию и профессию</p>
                                </li>
                            </ul>
                        </div>
                        <div class="realme50-results-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760362706230-vxazQ-mobi.png"
                                class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760362839700-4nli0-mobi.png"
                                class="hidden-desc-tablet" alt="img">
                            <p class="realme50-results-name">Мария Кузнецова</p>
                            <p class="realme50-results-position">Специалист в области маркетинга, Таиланд</p>
                            <a href="https://www.linkedin.com/in/kuznetsovamary/" target="_blank" class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760361892331-DADwE-Link.svg"
                                    alt="">
                                <p>Профиль в LinkedIn</p>
                            </a>
                            <div class="realme50-results-divider"></div>
                            <p class="realme50-results-subheader orange">До:</p>
                            <p class="realme50-results-text">Работа не нравилась — Мария хотела перейти в сферу маркетинга и PR.
                                Не хотела всё начинать с нуля, а других способов перехода в новую сферу она не видела</p>
                            <p class="realme50-results-subheader black">Результат с Careerum:</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760361977091-VHB0T-Care.svg"
                                        alt="">
                                    <p>Получила 2 оффера, начала карьеру в маркетинге</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760361977091-VHB0T-Care.svg"
                                        alt="">
                                    <p>Поняла свои карьерные перспективы</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760361977091-VHB0T-Care.svg"
                                        alt="">
                                    <p>Научилась искать работу за рубежом</p>
                                </li>
                            </ul>
                        </div>
                        <div class="realme50-results-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760362706620-EkdbR-mobi.png"
                                class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760362840080-uhHK5-mobi.png"
                                class="hidden-desc-tablet" alt="img">
                            <p class="realme50-results-name">Ольга Дробышева</p>
                            <p class="realme50-results-position">Специалист продуктового маркетинга, Москва</p>
                            <a href="https://www.linkedin.com/in/olga-drobysheva-a954a89b/" target="_blank" class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760361892331-DADwE-Link.svg"
                                    alt="">
                                <p>Профиль в LinkedIn</p>
                            </a>
                            <div class="realme50-results-divider"></div>
                            <p class="realme50-results-subheader orange">До:</p>
                            <p class="realme50-results-text">Руководила стратегическими кросс-функциональными проектами
                                в ритейл-компании. Сама работа нравилась, но хотелось большего масштаба. Но не понимала,
                                чего конкретно она хочет и куда двигаться дальше</p>
                            <p class="realme50-results-subheader black">Результат с Careerum:</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760361977091-VHB0T-Care.svg"
                                        alt="">
                                    <p>Поняла, каких именно изменений хочет</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760361977091-VHB0T-Care.svg"
                                        alt="">
                                    <p>Получила свой идеальный оффер</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760361977091-VHB0T-Care.svg"
                                        alt="">
                                    <p>Выросла в доходе на 50%</p>
                                </li>
                            </ul>
                        </div>
                        <div class="realme50-results-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760362707169-izuwN-mobi.png"
                                class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760362840429-Kdsji-mobi.png"
                                class="hidden-desc-tablet" alt="img">
                            <p class="realme50-results-name">Полина Меркулова</p>
                            <p class="realme50-results-position">Change Analyst, Великобритания</p>
                            <a href="https://www.linkedin.com/in/polinamerkulova/" target="_blank" class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760361892331-DADwE-Link.svg"
                                    alt="">
                                <p>Профиль в LinkedIn</p>
                            </a>
                            <div class="realme50-results-divider"></div>
                            <p class="realme50-results-subheader orange">До:</p>
                            <p class="realme50-results-text">Не устраивали постоянные переработки, недостаточный доход
                                и отсутствие социальных гарантий. низкая самооценка из-за высоких академических требований
                                и непонимание, как сменить сферу</p>
                            <p class="realme50-results-subheader black">Результат с Careerum:</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760361977091-VHB0T-Care.svg"
                                        alt="">
                                    <p>Работа в новой сфере</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760361977091-VHB0T-Care.svg"
                                        alt="">
                                    <p>Постоянный контракт + бонусы</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760361977091-VHB0T-Care.svg"
                                        alt="">
                                    <p>Рост зарплаты в 4 раза</p>
                                </li>
                            </ul>
                        </div>
                        <div class="realme50-results-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760362708108-DJaY4-mobi.png"
                                class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760362840858-s0z7a-mobi.png"
                                class="hidden-desc-tablet" alt="img">
                            <p class="realme50-results-name">Виктория Сагина</p>
                            <p class="realme50-results-position">Planning Specialist, Россия</p>
                            <a href="https://www.linkedin.com/in/vsagina/" target="_blank" class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760361892331-DADwE-Link.svg"
                                    alt="">
                                <p>Профиль в LinkedIn</p>
                            </a>
                            <div class="realme50-results-divider"></div>
                            <p class="realme50-results-subheader orange">До:</p>
                            <p class="realme50-results-text">Хотела сменить работу, сомневалась в своих силах, не знала,
                                как найти компанию с подходящими ценностями</p>
                            <p class="realme50-results-subheader black">Результат с Careerum:</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760361977091-VHB0T-Care.svg"
                                        alt="">
                                    <p>Научилась позиционировать свою экспертизу</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760361977091-VHB0T-Care.svg"
                                        alt="">
                                    <p>Научилась вести переговоры по офферу</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760361977091-VHB0T-Care.svg"
                                        alt="">
                                    <p>Оффер и рост зарплаты на 50%</p>
                                </li>
                            </ul>
                        </div>
                        <div class="realme50-results-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760362708571-xS2IX-mobi.png"
                                class="hidden-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760362841504-gyy6V-mobi.png"
                                class="hidden-desc-tablet" alt="img">
                            <p class="realme50-results-name">Екатерина Минаева</p>
                            <p class="realme50-results-position">Head of Sustainability, Латвия</p>
                            <a href="" target="_blank" class="careerum-flex-fsc disabled">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760361892331-DADwE-Link.svg"
                                    alt="">
                                <p>Профиль в LinkedIn</p>
                            </a>
                            <div class="realme50-results-divider"></div>
                            <p class="realme50-results-subheader orange">До:</p>
                            <p class="realme50-results-text">Была успешным руководителем отдела взыскания и управляла командой
                                из 150+ человек в 7 странах, но работа не совпадала с её ценностями</p>
                            <p class="realme50-results-subheader black">Результат с Careerum:</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760361977091-VHB0T-Care.svg"
                                        alt="">
                                    <p>Любимая работа, совпадение по ценностям с руководством</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760361977091-VHB0T-Care.svg"
                                        alt="">
                                    <p>Рост заработной платы на 60%</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760361977091-VHB0T-Care.svg"
                                        alt="">
                                    <p>Понимание своих карьерных планов и перспектив</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="realme50-results-slider-nav careerum-flex-fec">
                        <div class="realme50-results-nav-prev careerum-flex-cc ">
                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="realme50-results-nav-next careerum-flex-cc">
                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-realme50-reviews', {
        label: 'RealMe reviews (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-realme50-reviews main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Отзывы об интенсиве</h2>
                    <div class="realme50-reviews-slider">
                        <div class="realme50-reviews-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760363869108-vND9I-phot.png"
                                class="hidden-tablet-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760449611052-XCGpJ-phot.png" class="hidden-desc-mobile"
                                alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760453385406-pH0PO-phot.png" class="hidden-desc-tablet"
                                alt="img">
                        </div>
                        <div class="realme50-reviews-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760363864859-AduyE-Fram.png"
                                class="hidden-tablet-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760449602920-Clft7-Fram.png" class="hidden-desc-mobile"
                                alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760453372480-2zKjB-Fram.png" class="hidden-desc-tablet"
                                alt="img">
                        </div>
                        <div class="realme50-reviews-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760363867204-X6iq0-phot.png"
                                class="hidden-tablet-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760449608967-tqH9l-phot.png" class="hidden-desc-mobile"
                                alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760453383214-1GWF8-phot.png" class="hidden-desc-tablet"
                                alt="img">
                        </div>
                        <div class="realme50-reviews-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760363865419-PeN5j-Fram.png"
                                class="hidden-tablet-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760449603946-dTBLr-Fram.png" class="hidden-desc-mobile"
                                alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760453375331-V86L2-Fram.png" class="hidden-desc-tablet"
                                alt="img">
                        </div>
                        <div class="realme50-reviews-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760363870619-jWrlW-phot.png"
                                class="hidden-tablet-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760449613375-ifrjJ-phot.png" class="hidden-desc-mobile"
                                alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760453388867-BwZUD-phot.png" class="hidden-desc-tablet"
                                alt="img">
                        </div>
                        <div class="realme50-reviews-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760363865693-Btk5m-Fram.png"
                                class="hidden-tablet-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760449605620-O5PIk-Fram.png" class="hidden-desc-mobile"
                                alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760453377428-vl5rn-Fram.png" class="hidden-desc-tablet"
                                alt="img">
                        </div>
                        <div class="realme50-reviews-item">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760363866042-c5QHr-phot.png"
                                class="hidden-tablet-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760449607235-ayM3k-phot.png" class="hidden-desc-mobile"
                                alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760453379355-J2Cko-phot.png" class="hidden-desc-tablet"
                                alt="img">
                        </div>
                    </div>
                    <div class="realme50-reviews-slider-nav careerum-flex-fec">
                        <div class="realme50-reviews-nav-prev careerum-flex-cc ">
                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="realme50-reviews-nav-next careerum-flex-cc">
                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    
    blockManager.add('careerum-club50-about-subscription', {
        label: 'Club 50 about subscription (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club50-about-subscription main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="club50-about-subscription-header">
                        <h2>Еще о подписке</h2>
                    </div>
                    <div class="club50-about-subscription-wrapper">
                        <div class="club50-about-subscription-items careerum-flex-fsfs">
                            <a href="#pop1">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762755398719-7v4Qt-Grou.svg"
                                    class="hidden-tablet-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762755832495-TM63r-Grou.svg"
                                    class="hidden-desc-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762756095495-Z6Qk8-Grou.svg"
                                    class="hidden-desc-tablet" alt="img">
                                <p>В чем разница<br> между тарифами?</p>
                            </a>
                            <a href="#pop2">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762755398580-Wjndx-Grou.svg"
                                    class="hidden-tablet-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762755832383-rNI3m-Grou.svg"
                                    class="hidden-desc-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762756095389-93hTw-Grou.svg"
                                    class="hidden-desc-tablet" alt="img">
                                <p>Какой тариф<br> мне подойдет?</p>
                            </a>
                            <a href="#pop3">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762755398433-uCaXe-Grou.svg"
                                    class="hidden-tablet-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762755832279-VKtqj-Grou.svg"
                                    class="hidden-desc-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762756095276-bLYqw-Grou.svg"
                                    class="hidden-desc-tablet" alt="img">
                                <p>Как выбрать длительность подписки?</p>
                            </a>
                            <a href="#pop4">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762755398151-MG11J-Grou.svg"
                                    class="hidden-tablet-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762755832050-UQRPs-Grou.svg"
                                    class="hidden-desc-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762756094986-hrKWI-Grou.svg"
                                    class="hidden-desc-tablet" alt="img">
                                <p>Что произойдет после оплаты?</p>
                            </a>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('popup-faq-v1', {
        label: 'Club 50 about popup 1 (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-popup careerum-club50-popup-faq popup-faq-v1" id="pop1">
        <div class="popup__close-button-wrapper careerum-flex-cc">
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                class="close-switch hidden-tablet-mobile">
                <path d="M1.28516 1.28516L19.2816 19.2769" stroke="white" stroke-width="2.57143"
                    stroke-linecap="round" />
                <path d="M19.2852 1.29395L1.28876 19.2857" stroke="white" stroke-width="2.57143"
                    stroke-linecap="round" />
            </svg>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
                class="close-switch hidden-desc">
                <path d="M1 1L14.9972 14.9936" stroke="#191C20" stroke-width="2" stroke-linecap="round" />
                <path d="M15 1.00635L1.0028 14.9999" stroke="#191C20" stroke-width="2" stroke-linecap="round" />
            </svg>
        </div>
        <div class="club50-popup-faq-content position-relative z-10">
            <div class="club50-popup-faq-progress-container position-absolute z-20"></div>
            <div class="club50-popup-faq-content-items position-relative z-10 slider-autoplay">
                <div class="club50-popup-faq-content-item yellow position-relative z-10">
                    <h2>В чем разница между тарифами?</h2>
                    <p class="club50-popup-faq-content-label">«Библиотека курсов»</p>
                    <p class="club50-popup-faq-content-text">Доступ только к образовательной платформе с программами
                        под любую карьерную задачу:</p>
                    <ul>
                        <li>Поиск работы</li>
                        <li>Повышение</li>
                        <li>Релокация</li>
                        <li>Смена отрасли</li>
                    </ul>
                    <p class="club50-popup-faq-content-text">Программы на платформе закрывают абсолютно все карьерные
                        вопросы для профессионалов.</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762759085737-0tfQa-Grou.svg"
                        class="hidden-tablet-mobile position-absolute" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762786248268-pqv7L-Grou.svg"
                        class="hidden-desc-mobile position-absolute" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762791114176-185LK-Grou.svg"
                        class="hidden-desc-tablet position-absolute" alt="img">
                </div>
                <div class="club50-popup-faq-content-item blue position-relative z-10">
                    <h2>В чем разница между тарифами?</h2>
                    <p class="club50-popup-faq-content-label">«С поддержкой экспертов»</p>
                    <ul>
                        <li>Доступ к образовательной платформе</li>
                        <li>Доступ к клубу — закрытому сообществу профессионалов из 60+ стран.</li>
                        <li>Участие в групповых онлайн-эфирах и интенсивах</li>
                        <li>Поддержка коучей и экспертов в групповом чате и эфирах.</li>
                    </ul>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762773788710-MUAZT-Grou.svg"
                        class="hidden-tablet-mobile position-absolute" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762786248154-LdXZ4-Grou.svg"
                        class="hidden-desc-mobile position-absolute" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762791114065-jW0mq-Grou.svg"
                        class="hidden-desc-tablet position-absolute" alt="img">
                </div>
                <div class="club50-popup-faq-content-item dark position-relative z-10">
                    <h2>В чем разница между тарифами?</h2>
                    <p class="club50-popup-faq-content-label">«Индивидуальное сопровождение»</p>
                    <ul>
                        <li>Индивидуальное сопровождение карьерного коуча и эксперта: 2 индивидуальные видеосессии
                            в месяц продолжительностью 50 мин</li>
                        <li>Доступ к образовательной платформе.</li>
                        <li>Доступ к закрытому сообществу Careerum.</li>
                        <li>Участие в групповых онлайн-эфирах и интенсивах.</li>
                    </ul>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762773791105-fxF2K-Grou.svg"
                        class="hidden-tablet-mobile position-absolute" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762786247910-et2o4-Grou.svg"
                        class="hidden-desc-mobile position-absolute" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762791113766-5HbYT-Grou.svg"
                        class="hidden-desc-tablet position-absolute" alt="img">
                </div>
            </div>
            <div class="club50-popup-faq-content-arrows position-absolute z-20">
                <div class="club50-popup-faq-content-arrows-prev careerum-flex-cc position-absolute">
                    <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg"
                        class="hidden-mobile">
                        <path d="M1.32031 7.32129L15.3203 7.32129" stroke="#C2C2C2" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M7.32031 1.32129L1.32031 7.32129L7.32031 13.3213" stroke="#C2C2C2"
                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <svg width="20" height="35" viewBox="0 0 20 35" fill="none" xmlns="http://www.w3.org/2000/svg"
                        class="hidden-desc-tablet">
                        <path d="M17.5 2L2 17.5L17.5 33" stroke="#25282C" stroke-opacity="0.6" stroke-width="4"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="club50-popup-faq-content-arrows-next careerum-flex-cc position-absolute">
                    <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg"
                        class="hidden-mobile">
                        <path d="M15.3203 7.32129L1.32031 7.32129" stroke="#C2C2C2" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M9.32031 1.32129L15.3203 7.32129L9.32031 13.3213" stroke="#C2C2C2"
                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <svg width="20" height="35" viewBox="0 0 20 35" fill="none" xmlns="http://www.w3.org/2000/svg"
                        class="hidden-desc-tablet">
                        <path d="M2 2L17.5 17.5L2 33" stroke="#25282C" stroke-opacity="0.6" stroke-width="4"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('popup-faq-v2', {
        label: 'Club 50 about popup 2 (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-popup careerum-club50-popup-faq popup-faq-v2" id="pop2">
        <div class="popup__close-button-wrapper careerum-flex-cc">
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                class="close-switch hidden-tablet-mobile">
                <path d="M1.28516 1.28516L19.2816 19.2769" stroke="white" stroke-width="2.57143"
                    stroke-linecap="round" />
                <path d="M19.2852 1.29395L1.28876 19.2857" stroke="white" stroke-width="2.57143"
                    stroke-linecap="round" />
            </svg>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
                class="close-switch hidden-desc">
                <path d="M1 1L14.9972 14.9936" stroke="#191C20" stroke-width="2" stroke-linecap="round" />
                <path d="M15 1.00635L1.0028 14.9999" stroke="#191C20" stroke-width="2" stroke-linecap="round" />
            </svg>
        </div>
        <div class="club50-popup-faq-content position-relative z-10">
            <div class="club50-popup-faq-progress-container position-absolute z-20 disabled-progress"></div>
            <div class="club50-popup-faq-content-items position-relative z-10 disabled-slider">
                <div class="club50-popup-faq-content-item white position-relative z-10">
                    <h2>Какой тариф мне подойдет?</h2>
                    <p class="club50-popup-faq-content-label2 yellow">Тариф «Библиотека курсов»</p>
                    <p class="club50-popup-faq-content-text2">Для тех, кто хочет самостоятельно проработать свой
                        карьерный запрос с помощью наших программ. Тариф включает только доступ к образовательной
                        платформе и не предусматривает обратную связь от карьерных экспертов и коучей.</p>
                    <div class="club50-popup-faq-content-divider"></div>
                    <p class="club50-popup-faq-content-label2 blue">Тариф «С поддержкой экспертов»</p>
                    <p class="club50-popup-faq-content-text2">Для тех, кому важна обратная связь и нетворкинг
                        в профессиональном комьюнити. Вы получаете поддержку сообщества, коучей и экспертов в закрытом
                        сообществе Careerum, а также возможность задавать вопросы и разбирать свои кейсы с карьерными
                        экспертами на QA-эфирах.</p>
                    <div class="club50-popup-faq-content-divider"></div>
                    <p class="club50-popup-faq-content-label2 dark">Тариф «Индивидуальное сопровождение»</p>
                    <p class="club50-popup-faq-content-text2">Для тех, кто хочет глубоко и точечно проработать свой
                        карьерный запрос. В дополнение ко всем опциям тарифов «Библиотека курсов» и «С поддержкой
                        экспертов» вы получаете индивидуальное сопровождение персонального карьерного коуча и эксперта
                        на онлайн-сессиях и в личном чате с экспертами</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762780532614-nyD5s-Vect.svg"
                        class="hidden-tablet-mobile position-absolute z-0" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762786330995-SJf9n-Vect.svg"
                        class="hidden-desc position-absolute z-0" alt="img">
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('popup-faq-v3', {
        label: 'Club 50 about popup 3 (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-popup careerum-club50-popup-faq popup-faq-v3" id="pop3">
        <div class="popup__close-button-wrapper careerum-flex-cc">
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                class="close-switch hidden-tablet-mobile">
                <path d="M1.28516 1.28516L19.2816 19.2769" stroke="white" stroke-width="2.57143"
                    stroke-linecap="round" />
                <path d="M19.2852 1.29395L1.28876 19.2857" stroke="white" stroke-width="2.57143"
                    stroke-linecap="round" />
            </svg>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
                class="close-switch hidden-desc">
                <path d="M1 1L14.9972 14.9936" stroke="white" stroke-width="2" stroke-linecap="round" />
                <path d="M15 1.00635L1.0028 14.9999" stroke="white" stroke-width="2" stroke-linecap="round" />
            </svg>
        </div>
        <div class="club50-popup-faq-content dark position-relative z-10">
            <div class="club50-popup-faq-progress-container light position-absolute z-20"></div>
            <div class="club50-popup-faq-content-items position-relative z-10 slider-autoplay">
                <div class="club50-popup-faq-content-item black position-relative z-10">
                    <h2>Как выбрать длительность подписки?</h2>
                    <p class="club50-popup-faq-content-label">1 месяц</p>
                    <p class="club50-popup-faq-content-subheader1">SOS-режим, когда горит</p>
                    <p class="club50-popup-faq-content-subheader2">За это время вы сможете:</p>
                    <ul>
                        <li>Закрыть одну задачу: Усилить резюме, Прокачать Linkedin, Составить сопроводительное письмо,
                            Потренировать собеседование</li>
                        <li>Справиться с шоком от внезапного увольнения и сформировать план действий</li>
                        <li>Качественно пройти одну конкретную программу в подписке</li>
                        <li>Получить две личные консультации экспертов (только на тарифе «Индивидуальное сопровождение»)
                        </li>
                        <li>Подготовить новое резюме с экспертом (на тарифах «С поддержкой экспертов» и «Индивидуальное
                            сопровождение»)</li>
                    </ul>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762781489620-W7wDP-Vect.svg"
                        class="hidden-tablet-mobile position-absolute" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762781489620-W7wDP-Vect.svg"
                        class="hidden-desc-mobile position-absolute" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762793055882-luXxH-Vect.svg"
                        class="hidden-desc-tablet position-absolute" alt="img">
                </div>
                <div class="club50-popup-faq-content-item black position-relative z-10">
                    <h2>Как выбрать длительность подписки?</h2>
                    <p class="club50-popup-faq-content-label">3 месяца</p>
                    <p class="club50-popup-faq-content-subheader1">Из хаоса к понятным результатам</p>
                    <p class="club50-popup-faq-content-subheader2">За это время вы сможете:</p>
                    <ul>
                        <li>Упаковать себя под поиск работы </li>
                        <li>Получить оффер в своей локации </li>
                        <li>Упаковать себя под смену сферы</li>
                        <li>Получить повышение</li>
                        <li>Понять, куда двигаться дальше в карьере</li>
                        <li>Выйти из первой и второй стадии выгорания </li>
                        <li>Поставить карьерные цели и сформировать стратегию</li>
                    </ul>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762781492360-c4qOn-Vect.svg"
                        class="hidden-tablet-mobile position-absolute" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762781492360-c4qOn-Vect.svg"
                        class="hidden-desc-mobile position-absolute" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762793055763-tH6UT-Vect.svg"
                        class="hidden-desc-tablet position-absolute" alt="img">
                </div>
                <div class="club50-popup-faq-content-item black position-relative z-10">
                    <h2>Как выбрать длительность подписки?</h2>
                    <p class="club50-popup-faq-content-label">6 месяцев</p>
                    <p class="club50-popup-faq-content-subheader1">Пробить стеклянный потолок в карьере</p>
                    <p class="club50-popup-faq-content-subheader2">За это время вы сможете:</p>
                    <ul>
                        <li>Получить оффер в любой локации</li>
                        <li>Победить синдром самозванца</li>
                        <li>Увеличить доход</li>
                        <li>Протестировать новые форматы карьеры</li>
                        <li>Прокачать профессиональную коммуникацию</li>
                        <li>Выстроить качественный нетворкинг по всему миру</li>
                        <li>Получить руководящую позицию</li>
                    </ul>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762781494241-46mA8-Vect.svg"
                        class="hidden-tablet-mobile position-absolute" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762781494241-46mA8-Vect.svg"
                        class="hidden-desc-mobile position-absolute" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762793055639-jrtKS-Vect.svg"
                        class="hidden-desc-tablet position-absolute" alt="img">
                </div>
                <div class="club50-popup-faq-content-item black position-relative z-10">
                    <h2>Как выбрать длительность подписки?</h2>
                    <p class="club50-popup-faq-content-label">12 месяцев</p>
                    <p class="club50-popup-faq-content-subheader1">Развитие карьеры как системы</p>
                    <p class="club50-popup-faq-content-text bold">Помимо решения срочных задач в работе, вы сможете идти
                        к долгосрочным целям без откатов.</p>
                    <p class="club50-popup-faq-content-text">В дополнение к результатам 6 месяцев, вы сможете внедрить
                        карьерное развитие как систему и прокачать карьерные навыки, чтобы идти вперед</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762781496252-CyEls-Grou.svg"
                        class="hidden-tablet-mobile position-absolute" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762781496252-CyEls-Grou.svg"
                        class="hidden-desc-mobile position-absolute" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1762793055288-FhOXQ-Grou.svg"
                        class="hidden-desc-tablet position-absolute left" alt="img">
                </div>
            </div>
            <div class="club50-popup-faq-content-arrows position-absolute z-20">
                <div class="club50-popup-faq-content-arrows-prev careerum-flex-cc position-absolute">
                    <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg"
                        class="hidden-mobile">
                        <path d="M1.32031 7.32129L15.3203 7.32129" stroke="#C2C2C2" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M7.32031 1.32129L1.32031 7.32129L7.32031 13.3213" stroke="#C2C2C2"
                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <svg width="20" height="35" viewBox="0 0 20 35" fill="none" xmlns="http://www.w3.org/2000/svg"
                        class="hidden-desc-tablet">
                        <path d="M17.5 2L2 17.5L17.5 33" stroke="white" stroke-opacity="0.6" stroke-width="4"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="club50-popup-faq-content-arrows-next careerum-flex-cc position-absolute">
                    <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg"
                        class="hidden-mobile">
                        <path d="M15.3203 7.32129L1.32031 7.32129" stroke="#C2C2C2" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M9.32031 1.32129L15.3203 7.32129L9.32031 13.3213" stroke="#C2C2C2"
                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <svg width="20" height="35" viewBox="0 0 20 35" fill="none" xmlns="http://www.w3.org/2000/svg"
                        class="hidden-desc-tablet">
                        <path d="M2 2L17.5 17.5L2 33" stroke="white" stroke-opacity="0.6" stroke-width="4"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('popup-faq-v4', {
        label: 'Club 50 about popup 4 (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-popup careerum-club50-popup-faq popup-faq-v4" id="pop4">
        <div class="popup__close-button-wrapper careerum-flex-cc">
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                class="close-switch hidden-tablet-mobile">
                <path d="M1.28516 1.28516L19.2816 19.2769" stroke="white" stroke-width="2.57143"
                    stroke-linecap="round" />
                <path d="M19.2852 1.29395L1.28876 19.2857" stroke="white" stroke-width="2.57143"
                    stroke-linecap="round" />
            </svg>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
                class="close-switch hidden-desc">
                <path d="M1 1L14.9972 14.9936" stroke="#191C20" stroke-width="2" stroke-linecap="round" />
                <path d="M15 1.00635L1.0028 14.9999" stroke="#191C20" stroke-width="2" stroke-linecap="round" />
            </svg>
        </div>
        <div class="club50-popup-faq-content white position-relative z-10">
            <div class="club50-popup-faq-progress-container position-absolute z-20"></div>
            <div class="club50-popup-faq-content-items position-relative z-10 slider-autoplay">
                <div class="club50-popup-faq-content-item white position-relative z-10">
                    <h2>Что произойдет после оплаты?</h2>
                    <p class="club50-popup-faq-content-subheader3">После оплаты мы обработаем ваш платёж в течение
                        нескольких минут и отправим подробное письмо с инструкциями на почту, указанную при оплате.</p>
                    <ul class="club50-popup-faq-content-list-dotted">
                        <li>
                            <p class="club50-popup-faq-content-list-label">Шаг 1</p>
                            <p class="club50-popup-faq-content-list-text">Вам нужно заполнить анкету участника, которая
                                позволит нашей команде познакомиться с вашими карьерными запросами.</p>
                        </li>
                        <li>
                            <p class="club50-popup-faq-content-list-label">Шаг 2</p>
                            <p class="club50-popup-faq-content-list-text">Вы получите доступ к обучающей платформе
                                и всем программам.</p>
                        </li>
                        <li>
                            <p class="club50-popup-faq-content-list-label">Шаг 3</p>
                            <p class="club50-popup-faq-content-list-text">Мы подключим вас к онбординговому боту
                                в Telegram, который будет вашим навигатором по подписке.</p>
                        </li>
                        <li>
                            <p class="club50-popup-faq-content-list-label">Шаг 4</p>
                            <p class="club50-popup-faq-content-list-text">На тарифах «С поддержкой экспертов»
                                и «Индивидуальное сопровождение» участники присоединяются к закрытому чату клуба
                                и регистрируются в системе coffee buddy, чтобы развивать полезные профессиональные
                                связи.</p>
                        </li>
                    </ul>
                </div>
                <div class="club50-popup-faq-content-item white position-relative z-10">
                    <h2>Что произойдет после оплаты?</h2>
                    <p class="club50-popup-faq-content-subheader3">После оплаты мы обработаем ваш платёж в течение
                        нескольких минут и отправим подробное письмо с инструкциями на почту, указанную при оплате.</p>
                    <ul class="club50-popup-faq-content-list-dotted">
                        <li>
                            <p class="club50-popup-faq-content-list-label">Шаг 5</p>
                            <p class="club50-popup-faq-content-list-text">Вы проходите карьерный навигатор, и мы формируем для вас обучающий план</p>
                        </li>
                        <li>
                            <p class="club50-popup-faq-content-list-label">Шаг 6</p>
                            <p class="club50-popup-faq-content-list-text">На тарифах «С поддержкой экспертов» и «Индивидуальное сопровождение» вы начинаете участвовать в живых тематических эфирах клуба и нетворкинг-встречах</p>
                        </li>
                    </ul>
                    <p class="club50-popup-faq-content-text">На всех тарифах в процессе погружения и обучения в Careerum
                        можно обратиться к нашим кураторам из команды заботы Виолетте и Ане :)</p>
                    <p class="club50-popup-faq-content-text">Просто напишите на hello@careerum.com в любое время.
                        Мы на связи ежедневно с 10.00 до 19.00 мск.</p>
                </div>
            </div>
            <div class="club50-popup-faq-content-arrows position-absolute z-20">
                <div class="club50-popup-faq-content-arrows-prev careerum-flex-cc position-absolute">
                    <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg"
                        class="hidden-mobile">
                        <path d="M1.32031 7.32129L15.3203 7.32129" stroke="#C2C2C2" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M7.32031 1.32129L1.32031 7.32129L7.32031 13.3213" stroke="#C2C2C2"
                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <svg width="20" height="35" viewBox="0 0 20 35" fill="none" xmlns="http://www.w3.org/2000/svg"
                        class="hidden-desc-tablet">
                        <path d="M17.5 2L2 17.5L17.5 33" stroke="#25282C" stroke-opacity="0.6" stroke-width="4"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="club50-popup-faq-content-arrows-next careerum-flex-cc position-absolute">
                    <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg"
                        class="hidden-mobile">
                        <path d="M15.3203 7.32129L1.32031 7.32129" stroke="#C2C2C2" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M9.32031 1.32129L15.3203 7.32129L9.32031 13.3213" stroke="#C2C2C2"
                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <svg width="20" height="35" viewBox="0 0 20 35" fill="none" xmlns="http://www.w3.org/2000/svg"
                        class="hidden-desc-tablet">
                        <path d="M2 2L17.5 17.5L2 33" stroke="#25282C" stroke-opacity="0.6" stroke-width="4"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-blackfriday2-main', {
        label: 'Blackfriday 2 main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-blackfriday2-main main-wrapper position-relative">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763540831355-6sLHD-Grou.png"
                    class="position-absolute normal" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763471622439-zcBfl-img_.png"
                    class="position-absolute wide" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763561752661-0VBq5-img_.png"
                    class="hidden-desc-mobile position-absolute" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763620468500-gHhMc-Grou.png"
                    class="hidden-desc-tablet position-absolute" alt="img">
                <div class="careerum-container-responsive position-relative">
                    <div class="blackfriday2-main-logo">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763472731467-II8Cc-logo.svg"
                            class="hidden-tablet-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763472757707-IuRKf-logo.svg"
                            class="hidden-desc" alt="img">
                    </div>
                    <div class="blackfriday2-main-wrapper position-relative">
                        <p class="blackfriday2-main-subheader">Вы попали в</p>
                        <div class="blackfriday2-main-header-imgs position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763637159954-Os1CL-Fram.svg"
                                class="hidden-tablet-mobile blackfriday2-main-header position-absolute" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763637162544-oghBg-Fram.svg"
                                class="hidden-tablet-mobile blackfriday2-main-header2 position-absolute" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763637544287-0MDl4-Fram.svg"
                                class="hidden-desc-mobile blackfriday2-main-header position-absolute" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763637563733-9NGae-Fram.svg"
                                class="hidden-desc-mobile blackfriday2-main-header2 position-absolute" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763637821962-szcQ2-Fram.svg"
                                class="hidden-desc-tablet blackfriday2-main-header position-absolute" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763637821251-Vvtn2-Fram.svg"
                                    class="hidden-desc-tablet blackfriday2-main-header2 position-absolute" alt="img">
                        </div>
                        <p class="blackfriday2-main-subheader">вашей работы</p>
                        <p class="blackfriday2-main-subheader">Туда, где живут ваши карьерные монстры</p>
                        <p class="blackfriday2-main-subheader2">Они тихо шепчут:</p>
                        <div class="blackfriday2-main-items careerum-flex-cfs">
                            <div class="blackfriday2-main-item">
                                <p>Сделай идеально или умри</p>
                            </div>
                            <div class="blackfriday2-main-item position-relative">
                                <p>Тебе просто повезло — не обольщайся</p>
                            </div>
                            <div class="blackfriday2-main-item">
                                <p>Без тебя всё развалится</p>
                            </div>
                            <div class="blackfriday2-main-item hidden-desc">
                                <p>Ещё чуть-чуть доработай — и тогда ты заслужишь отдых</p>
                            </div>
                            <div class="blackfriday2-main-item">
                                <p>Ты просто хорошо притворяешься</p>
                            </div>
                            <div class="blackfriday2-main-item hidden-tablet-mobile">
                                <p>Ещё чуть-чуть доработай — и тогда ты заслужишь отдых</p>
                            </div>
                            <div class="blackfriday2-main-item position-relative">
                                <p>Зачем менять работу? Тут хоть всё знакомо</p>
                            </div>
                        </div>
                        <a href="#form" class="btn-color-red">Сразиться с монстрами</a>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-blackfriday2-content', {
        label: 'Blackfriday 2 content (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-blackfriday2-content main-wrapper position-relative">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763554378897-0jHrg-Grou.png"
                    class="position-absolute wide" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763556703489-1jnek-Grou.png"
                    class="position-absolute normal" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763563911135-2iOO3-Grou.png"
                    class="hidden-desc-mobile position-absolute" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763619984780-pnDh2-Grou.png"
                    class="hidden-desc-tablet position-absolute" alt="img">
                <div class="blackfriday2-content-date">
                    <p>24 ноября – 2 декабря</p>
                </div>
                <div class="careerum-container-responsive position-relative">
                    <div class="blackfriday2-content-header">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763637367118-iuMXm-BLAC.svg"
                            class="hidden-tablet-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763637609337-zdONr-BLAC.svg"
                            class="hidden-desc-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763637866839-anuby-BLAC.svg"
                            class="hidden-desc-tablet" alt="img">
                        <p class="blackfriday2-content-subheader">В эту чёрную пятницу мы боремся с карьерной тьмой...</p>
                    </div>
                    <div class="blackfriday2-content-center">
                        <p class="blackfriday2-content-subheader2">Победи своего монстра</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763542065360-jX0JX-Gene.png"
                            class="hidden-tablet-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763542099279-IJjAb-Gene.png"
                            class="hidden-desc-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763618948530-UuZ5U-Gene.png"
                            class="hidden-desc-tablet" alt="img">
                    </div>
                    <div class="blackfriday2-content-block">
                        <p>Они кормятся вашим стрессом, сомнениями, перфекционизмом, не дают расти и любить свою работу</p>
                        <p>Победите своих монстров и вытащите себя с изнанки карьеры</p>
                    </div>
                    <div class="blackfriday2-content-slider-wrapper">
                        <h2>Найдите своего монстра</h2>
                        <div class="blackfriday2-content-slider">
                            <div class="blackfriday2-content-item position-relative">
                                <div class="blackfriday2-content-item-front position-absolute">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763551590692-8ARq2-Gene.png"
                                        class="position-absolute z-10 bg" alt="img">
                                    <p class="position-relative z-40 blackfriday2-content-item-header">Зеркальный Паразит</p>
                                    <div class="blackfriday2-content-item-front-top position-absolute z-20"></div>
                                    <div class="blackfriday2-content-item-front-bottom position-absolute z-20"></div>
                                    <button class="position-absolute z-30">Чем питается?</button>
                                </div>
                                <div class="blackfriday2-content-item-back">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763549918686-TpPLh-Grou.png"
                                        class="position-absolute z-10 bg" alt="img">
                                    <p class="position-relative z-40 blackfriday2-content-item-header">Зеркальный Паразит</p>
                                    <p class="position-relative z-30 blackfriday2-content-item-text">Искажает отражение — вместо
                                        профессионала показывает
                                        человека с одними ошибками</p>
                                    <button class="position-absolute z-20">Скрыть</button>
                                </div>
                            </div>
                            <div class="blackfriday2-content-item position-relative">
                                <div class="blackfriday2-content-item-front position-absolute">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763551588757-KWOXq-Fram.png"
                                        class="position-absolute z-10 bg" alt="img">
                                    <p class="position-relative z-40 blackfriday2-content-item-header">Коварный Шалтай-болтай
                                    </p>
                                    <div class="blackfriday2-content-item-front-top position-absolute z-20"></div>
                                    <div class="blackfriday2-content-item-front-bottom position-absolute z-20"></div>
                                    <button class="position-absolute z-30">Чем питается?</button>
                                </div>
                                <div class="blackfriday2-content-item-back">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763549918686-TpPLh-Grou.png"
                                        class="position-absolute z-10 bg" alt="img">
                                    <p class="position-relative z-40 blackfriday2-content-item-header">Коварный Шалтай-болтай
                                    </p>
                                    <p class="position-relative z-30 blackfriday2-content-item-text">Не дает найти баланс:
                                        раскачивает эмоции от ледяного
                                        спокойствия до неконтролируемой ярости/тревожности, токсичности</p>
                                    <button class="position-absolute z-20">Скрыть</button>
                                </div>
                            </div>
                            <div class="blackfriday2-content-item position-relative">
                                <div class="blackfriday2-content-item-front position-absolute">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763551589238-G2NKW-Fram.png"
                                        class="position-absolute z-10 bg" alt="img">
                                    <p class="position-relative z-40 blackfriday2-content-item-header">Безликий Последователь
                                    </p>
                                    <div class="blackfriday2-content-item-front-top position-absolute z-20"></div>
                                    <div class="blackfriday2-content-item-front-bottom position-absolute z-20"></div>
                                    <button class="position-absolute z-30">Чем питается?</button>
                                </div>
                                <div class="blackfriday2-content-item-back">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763549918686-TpPLh-Grou.png"
                                        class="position-absolute z-10 bg" alt="img">
                                    <p class="position-relative z-40 blackfriday2-content-item-header">Безликий Последователь
                                    </p>
                                    <p class="position-relative z-30 blackfriday2-content-item-text">Заставляет отказаться
                                        от собственного пути и слепо
                                        копировать чужие карьерные треки</p>
                                    <button class="position-absolute z-20">Скрыть</button>
                                </div>
                            </div>
                            <div class="blackfriday2-content-item position-relative">
                                <div class="blackfriday2-content-item-front position-absolute">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763551589377-IYbuW-Fram.png"
                                        class="position-absolute z-10 bg" alt="img">
                                    <p class="position-relative z-40 blackfriday2-content-item-header">Болотник рутинный</p>
                                    <div class="blackfriday2-content-item-front-top position-absolute z-20"></div>
                                    <div class="blackfriday2-content-item-front-bottom position-absolute z-20"></div>
                                    <button class="position-absolute z-30">Чем питается?</button>
                                </div>
                                <div class="blackfriday2-content-item-back">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763549918686-TpPLh-Grou.png"
                                        class="position-absolute z-10 bg" alt="img">
                                    <p class="position-relative z-40 blackfriday2-content-item-header">Болотник рутинный</p>
                                    <p class="position-relative z-30 blackfriday2-content-item-text">Затягивает в трясину
                                        однообразных задач, где нет места для
                                        стратегии и роста</p>
                                    <button class="position-absolute z-20">Скрыть</button>
                                </div>
                            </div>
                            <div class="blackfriday2-content-item position-relative">
                                <div class="blackfriday2-content-item-front position-absolute">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763551589515-4gBTY-Fram.png"
                                        class="position-absolute z-10 bg" alt="img">
                                    <p class="position-relative z-40 blackfriday2-content-item-header">Миражник целеполагания
                                    </p>
                                    <div class="blackfriday2-content-item-front-top position-absolute z-20"></div>
                                    <div class="blackfriday2-content-item-front-bottom position-absolute z-20"></div>
                                    <button class="position-absolute z-30">Чем питается?</button>
                                </div>
                                <div class="blackfriday2-content-item-back">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763549918686-TpPLh-Grou.png"
                                        class="position-absolute z-10 bg" alt="img">
                                    <p class="position-relative z-40 blackfriday2-content-item-header">Миражник целеполагания
                                    </p>
                                    <p class="position-relative z-30 blackfriday2-content-item-text">Показывает амбициозные,
                                        но недостижимые цели, приводящие
                                        к разочарованию</p>
                                    <button class="position-absolute z-20">Скрыть</button>
                                </div>
                            </div>
                            <div class="blackfriday2-content-item position-relative">
                                <div class="blackfriday2-content-item-front position-absolute">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763551589650-R47t3-Fram.png"
                                        class="position-absolute z-10 bg" alt="img">
                                    <p class="position-relative z-40 blackfriday2-content-item-header">Сирена Перфекционизма</p>
                                    <div class="blackfriday2-content-item-front-top position-absolute z-20"></div>
                                    <div class="blackfriday2-content-item-front-bottom position-absolute z-20"></div>
                                    <button class="position-absolute z-30">Чем питается?</button>
                                </div>
                                <div class="blackfriday2-content-item-back">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763549918686-TpPLh-Grou.png"
                                        class="position-absolute z-10 bg" alt="img">
                                    <p class="position-relative z-40 blackfriday2-content-item-header">Сирена Перфекциониз-ма
                                    </p>
                                    <p class="position-relative z-30 blackfriday2-content-item-text">Манит обещанием идеального
                                        результата, не давая вовремя
                                        закончить работу</p>
                                    <button class="position-absolute z-20">Скрыть</button>
                                </div>
                            </div>
                            <div class="blackfriday2-content-item position-relative">
                                <div class="blackfriday2-content-item-front position-absolute">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763551589777-XAqJg-Fram.png"
                                        class="position-absolute z-10 bg" alt="img">
                                    <p class="position-relative z-40 blackfriday2-content-item-header">Ткач Изоляции</p>
                                    <div class="blackfriday2-content-item-front-top position-absolute z-20"></div>
                                    <div class="blackfriday2-content-item-front-bottom position-absolute z-20"></div>
                                    <button class="position-absolute z-30">Чем питается?</button>
                                </div>
                                <div class="blackfriday2-content-item-back">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763549918686-TpPLh-Grou.png"
                                        class="position-absolute z-10 bg" alt="img">
                                    <p class="position-relative z-40 blackfriday2-content-item-header">Ткач Изоляции</p>
                                    <p class="position-relative z-30 blackfriday2-content-item-text">Плетёт сеть вежливых,
                                        но формальных связей — в ней не
                                        рождается сотрудничество и доверие</p>
                                    <button class="position-absolute z-20">Скрыть</button>
                                </div>
                            </div>
                            <div class="blackfriday2-content-item position-relative">
                                <div class="blackfriday2-content-item-front position-absolute">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763551589920-uSpx9-Fram.png"
                                        class="position-absolute z-10 bg" alt="img">
                                    <p class="position-relative z-40 blackfriday2-content-item-header">Архивариус Забытых Связей
                                    </p>
                                    <div class="blackfriday2-content-item-front-top position-absolute z-20"></div>
                                    <div class="blackfriday2-content-item-front-bottom position-absolute z-20"></div>
                                    <button class="position-absolute z-30">Чем питается?</button>
                                </div>
                                <div class="blackfriday2-content-item-back">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763549918686-TpPLh-Grou.png"
                                        class="position-absolute z-10 bg" alt="img">
                                    <p class="position-relative z-40 blackfriday2-content-item-header">Архивариус Забытых Связей
                                    </p>
                                    <p class="position-relative z-30 blackfriday2-content-item-text">Бережно складывает имена и
                                        визитки в архив, где связи
                                        пылятся без отклика и продолжения</p>
                                    <button class="position-absolute z-20">Скрыть</button>
                                </div>
                            </div>
                            <div class="blackfriday2-content-item position-relative">
                                <div class="blackfriday2-content-item-front position-absolute">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763551590042-0OHdK-Fram.png"
                                        class="position-absolute z-10 bg" alt="img">
                                    <p class="position-relative z-40 blackfriday2-content-item-header">Выжигатель Ресурса </p>
                                    <div class="blackfriday2-content-item-front-top position-absolute z-20"></div>
                                    <div class="blackfriday2-content-item-front-bottom position-absolute z-20"></div>
                                    <button class="position-absolute z-30">Чем питается?</button>
                                </div>
                                <div class="blackfriday2-content-item-back">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763549918686-TpPLh-Grou.png"
                                        class="position-absolute z-10 bg" alt="img">
                                    <p class="position-relative z-40 blackfriday2-content-item-header">Выжигатель Ресурса </p>
                                    <p class="position-relative z-30 blackfriday2-content-item-text">Монстр, который
                                        подталкивает работать на износ, пока
                                        от энергии не останется лишь пепел</p>
                                    <button class="position-absolute z-20">Скрыть</button>
                                </div>
                            </div>
                            <div class="blackfriday2-content-item position-relative">
                                <div class="blackfriday2-content-item-front position-absolute">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763551590170-kWC3U-Fram.png"
                                        class="position-absolute z-10 bg" alt="img">
                                    <p class="position-relative z-40 blackfriday2-content-item-header">Чупакабра Обязательств
                                    </p>
                                    <div class="blackfriday2-content-item-front-top position-absolute z-20"></div>
                                    <div class="blackfriday2-content-item-front-bottom position-absolute z-20"></div>
                                    <button class="position-absolute z-30">Чем питается?</button>
                                </div>
                                <div class="blackfriday2-content-item-back">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763549918686-TpPLh-Grou.png"
                                        class="position-absolute z-10 bg" alt="img">
                                    <p class="position-relative z-40 blackfriday2-content-item-header">Чупакабра Обязательств
                                    </p>
                                    <p class="position-relative z-30 blackfriday2-content-item-text">Заменяет истинное «хочу»
                                        на бесконечное «надо», высасывая
                                        всю радость из работы</p>
                                    <button class="position-absolute z-20">Скрыть</button>
                                </div>
                            </div>
                            <div class="blackfriday2-content-item position-relative">
                                <div class="blackfriday2-content-item-front position-absolute">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763551590293-lBQyw-Fram.png"
                                        class="position-absolute z-10 bg" alt="img">
                                    <p class="position-relative z-40 blackfriday2-content-item-header">Властитель
                                        Неопределенности</p>
                                    <div class="blackfriday2-content-item-front-top position-absolute z-20"></div>
                                    <div class="blackfriday2-content-item-front-bottom position-absolute z-20"></div>
                                    <button class="position-absolute z-30">Чем питается?</button>
                                </div>
                                <div class="blackfriday2-content-item-back">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763549918686-TpPLh-Grou.png"
                                        class="position-absolute z-10 bg" alt="img">
                                    <p class="position-relative z-40 blackfriday2-content-item-header">Властитель
                                        Неопределеннос-ти</p>
                                    <p class="position-relative z-30 blackfriday2-content-item-text">Замораживает волю
                                        и способность действовать, когда старые
                                        планы рушатся</p>
                                    <button class="position-absolute z-20">Скрыть</button>
                                </div>
                            </div>
                            <div class="blackfriday2-content-item position-relative">
                                <div class="blackfriday2-content-item-front position-absolute">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763551590415-MKm69-Fram.png"
                                        class="position-absolute z-10 bg" alt="img">
                                    <p class="position-relative z-40 blackfriday2-content-item-header">Призрак Нестабильности
                                    </p>
                                    <div class="blackfriday2-content-item-front-top position-absolute z-20"></div>
                                    <div class="blackfriday2-content-item-front-bottom position-absolute z-20"></div>
                                    <button class="position-absolute z-30">Чем питается?</button>
                                </div>
                                <div class="blackfriday2-content-item-back">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763549918686-TpPLh-Grou.png"
                                        class="position-absolute z-10 bg" alt="img">
                                    <p class="position-relative z-40 blackfriday2-content-item-header">Призрак Нестабильности
                                    </p>
                                    <p class="position-relative z-30 blackfriday2-content-item-text">Пугает потерей
                                        единственного источника дохода и мешает
                                        пробовать фриланс или параллельные проекты</p>
                                    <button class="position-absolute z-20">Скрыть</button>
                                </div>
                            </div>
                            <div class="blackfriday2-content-item position-relative">
                                <div class="blackfriday2-content-item-front position-absolute">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763551590549-KRvNY-Fram.png"
                                        class="position-absolute z-10 bg" alt="img">
                                    <p class="position-relative z-40 blackfriday2-content-item-header">Демон Микроменеджмента
                                    </p>
                                    <div class="blackfriday2-content-item-front-top position-absolute z-20"></div>
                                    <div class="blackfriday2-content-item-front-bottom position-absolute z-20"></div>
                                    <button class="position-absolute z-30">Чем питается?</button>
                                </div>
                                <div class="blackfriday2-content-item-back">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763549918686-TpPLh-Grou.png"
                                        class="position-absolute z-10 bg" alt="img">
                                    <p class="position-relative z-40 blackfriday2-content-item-header">Демон Микроменеджмен-та
                                    </p>
                                    <p class="position-relative z-30 blackfriday2-content-item-text">Убийца инициативы
                                        и самостоятельности команды.
                                        Контролирует каждый шаг, чтобы ничего не упустить</p>
                                    <button class="position-absolute z-20">Скрыть</button>
                                </div>
                            </div>
                            <div class="blackfriday2-content-item position-relative">
                                <div class="blackfriday2-content-item-front position-absolute">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763551590834-jshmY-Gene.png"
                                        class="position-absolute z-10 bg" alt="img">
                                    <p class="position-relative z-40 blackfriday2-content-item-header">Призрак Отказа</p>
                                    <div class="blackfriday2-content-item-front-top position-absolute z-20"></div>
                                    <div class="blackfriday2-content-item-front-bottom position-absolute z-20"></div>
                                    <button class="position-absolute z-30">Чем питается?</button>
                                </div>
                                <div class="blackfriday2-content-item-back">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763549918686-TpPLh-Grou.png"
                                        class="position-absolute z-10 bg" alt="img">
                                    <p class="position-relative z-40 blackfriday2-content-item-header">Призрак Отказа</p>
                                    <p class="position-relative z-30 blackfriday2-content-item-text">Питается страхом неудач
                                        и заставляет прекращать поиски
                                        работы после первых же неудач</p>
                                    <button class="position-absolute z-20">Скрыть</button>
                                </div>
                            </div>
                            <div class="blackfriday2-content-item position-relative">
                                <div class="blackfriday2-content-item-front position-absolute">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763551590971-INB3n-Gene.png"
                                        class="position-absolute z-10 bg" alt="img">
                                    <p class="position-relative z-40 blackfriday2-content-item-header">Тёмный лжец изнанки</p>
                                    <div class="blackfriday2-content-item-front-top position-absolute z-20"></div>
                                    <div class="blackfriday2-content-item-front-bottom position-absolute z-20"></div>
                                    <button class="position-absolute z-30">Чем питается?</button>
                                </div>
                                <div class="blackfriday2-content-item-back">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763549918686-TpPLh-Grou.png"
                                        class="position-absolute z-10 bg" alt="img">
                                    <p class="position-relative z-40 blackfriday2-content-item-header">Тёмный лжец изнанки</p>
                                    <p class="position-relative z-30 blackfriday2-content-item-text">Убеждает, что говорить
                                        о своих достижениях — это
                                        хвастовство и нескромность</p>
                                    <button class="position-absolute z-20">Скрыть</button>
                                </div>
                            </div>
                        </div>
                        <div class="blackfriday2-content-slider-nav careerum-flex-fec">
                            <div class="blackfriday2-content-slider-nav-prev careerum-flex-cc">
                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_279_992)">
                                        <foreignObject x="-18.1166" y="-18.1166" width="76.2332" height="76.2332">
                                            <div xmlns="http://www.w3.org/1999/xhtml"
                                                style="backdrop-filter:blur(9.06px);clip-path:url(#bgblur_1_279_992_clip_path);height:100%;width:100%">
                                            </div>
                                        </foreignObject>
                                        <rect data-figma-bg-blur-radius="18.1166" y="40" width="40" height="40"
                                            transform="rotate(-90 0 40)" fill="white" />
                                        <path d="M13 20L27 20" stroke="#202024" stroke-width="2.64201" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M19 26L13 20L19 14" stroke="#202024" stroke-width="2.64201"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </g>
                                    <defs>
                                        <clipPath id="bgblur_1_279_992_clip_path" transform="translate(18.1166 18.1166)">
                                            <rect y="40" width="40" height="40" transform="rotate(-90 0 40)" />
                                        </clipPath>
                                        <clipPath id="clip0_279_992">
                                            <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)"
                                                fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <div class="blackfriday2-content-slider-nav-next careerum-flex-cc">
                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_279_996)">
                                        <foreignObject x="-18.1166" y="-18.1166" width="76.2332" height="76.2332">
                                            <div xmlns="http://www.w3.org/1999/xhtml"
                                                style="backdrop-filter:blur(9.06px);clip-path:url(#bgblur_1_279_996_clip_path);height:100%;width:100%">
                                            </div>
                                        </foreignObject>
                                        <rect data-figma-bg-blur-radius="18.1166" x="40" y="1.74846e-06" width="40" height="40"
                                            transform="rotate(90 40 1.74846e-06)" fill="white" />
                                        <path d="M27 20L13 20" stroke="#202024" stroke-width="2.64201" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M21 14L27 20L21 26" stroke="#202024" stroke-width="2.64201"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </g>
                                    <defs>
                                        <clipPath id="bgblur_1_279_996_clip_path" transform="translate(18.1166 18.1166)">
                                            <rect x="40" y="1.74846e-06" width="40" height="40"
                                                transform="rotate(90 40 1.74846e-06)" />
                                        </clipPath>
                                        <clipPath id="clip0_279_996">
                                            <rect x="40" y="1.74846e-06" width="40" height="40" rx="20"
                                                transform="rotate(90 40 1.74846e-06)" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-blackfriday2-form', {
        label: 'Blackfriday 2 form (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-blackfriday2-form main-wrapper position-relative">
                <div class="careerum-container-responsive position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763554691863-PzhaM-Gene.png"
                        class="hidden-tablet-mobile position-absolute z-10" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763563732093-BL1EI-Gene.png"
                        class="hidden-desc-mobile position-absolute z-10" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1763620090014-QaXJN-Gene.png"
                        class="hidden-desc-tablet position-absolute z-10" alt="img">
                    <div class="blackfriday2-form-content position-relative z-20">
                        <h2>Кто ты, воин?</h2>
                        <div class="blackfriday2-form-content-wrapper">
                            <div class="careerum-registration-form-club40">
                                <form class="deva-form getcourse-email-signup addCountry careerum-flex-sbfs"
                                    name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                    <div class="careerum-club40-form-name">
                                        <input type="text" name="name" value="" required placeholder="Имя">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                    </div>
                                    <div class="careerum-club40-form-telegram">
                                        <input type="text" value="" name="telegram" required placeholder="Telegram">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                    </div>
                                    <div class="careerum-club40-form-email">
                                        <input type="text" name="email" value="" required placeholder="Почта">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                    </div>
                                    <div class="careerum-club40-form-phone">
                                        <input type="tel" value="" name="tel" required class="itl-input">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                    </div>
                                    <div class="careerum-club40-form-latest careerum-flex-fsfs">
                                        <div class="careerum-club40-form-agree">
                                            <label>
                                                <input type="checkbox" name="agree">
                                                <div>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8"
                                                        viewBox="0 0 8 8" fill="none">
                                                        <path
                                                            d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                            stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                    </svg>
                                                </div>
                                            </label>
                                            <p>Я даю согласие
                                                на обработку персональных данных
                                                в соответствии с <a href="/ru-ru/legal/privacy">Политикой
                                                    конфиденциальности</a>
                                            </p>
                                        </div>
                                        <a href="#" class="submit-btn btn-color-red button-sent" disabled>Вступить в бой</a>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-bfsale-main', {
        label: 'Blackfriday sale main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-bfsale-main main-wrapper position-relative">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764066485896-3rdCv-Fram.png"
                    class="position-absolute hidden-tablet-mobile" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764067128474-g3zW9-Fram.png"
                    class="hidden-desc-mobile position-absolute" alt="img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764067139532-5z0MA-Fram.png"
                    class="hidden-desc-tablet position-absolute" alt="img">
                <div class="careerum-container-responsive position-relative">
                    <div class="bfsale-main-logo">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764066067250-06388-Fram.svg"
                            class="hidden-mobile" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764066079151-lqi68-Grou.svg"
                            class="hidden-desc-tablet" alt="img">
                    </div>
                    <div class="bfsale-main-wrapper position-relative careerum-flex-sbfs">
                        <div class="bfsale-main-left position-relative z-20">
                            <h1 class="hidden">BLACK FRIDAY</h1>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764067230448-RgBIV-BLAC.svg"
                                class="hidden-tablet-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764067239490-pFFgJ-BLAC.svg"
                                class="hidden-desc-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764067248935-8BI2t-BLAC.svg"
                                class="hidden-desc-tablet" alt="img">
                            <p class="bfsale-main-text">В эту чёрную пятницу мы боремся с карьерной тьмой...</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764066653071-TS4oo-Grou.png"
                                class="hidden-desc-tablet bottom" alt="img">
                            <p class="bfsale-main-subheader">Но ваша карьера — не тьма! <br>А лаборатория развития карьерных
                                навыков
                            </p>
                            <a href="#buy" class="btn-color-red">Прокачать навыки</a>
                        </div>
                        <div class="bfsale-main-right position-relative z-10">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764066519549-QLyZO-Grou.png"
                                class="hidden-tablet-mobile position-absolute" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764066704452-9Jp32-Grou.png"
                                class="hidden-desc-mobile position-absolute" alt="img">
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-bfsale-map', {
        label: 'Blackfriday sale map (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-bfsale-map main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <div class="bfsale-map-wrapper careerum-flex-sbfs">
                        <div class="bfsale-map-left position-relative">
                            <h2 class="position-relative z-20">Карта карьерных навыков</h2>
                            <p class="position-relative z-20">Карьерные навыки делают вас тем, кто управляет своей карьерой</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764069146852-PcPrw-Grou.svg"
                                class="hidden-tablet-mobile position-absolute z-10" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764102505583-ZILuK-Grou.svg"
                                class="hidden-desc-mobile position-absolute z-10" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764148142347-wRfo4-Grou.png"
                                class="hidden-desc-tablet position-absolute z-10" alt="img">
                        </div>
                        <div class="bfsale-map-right position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764069325700-4dViK-Grou.png"
                                class="hidden-tablet-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764102505425-b8yoD-Fram.png"
                                class="hidden-desc-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764148142685-2WHiC-Fram.png"
                                class="hidden-desc-tablet" alt="img">
                        </div>
                    </div>
                    <div class="bfsale-map-slider-wrapper">
                        <div class="bfsale-map-slider-nav">
                            <ul class="careerum-flex-fsfs">
                                <li data-number="1" class="active">Карьерная стратегия</li>
                                <li data-number="2">Рост и самореализация</li>
                                <li data-number="3">Внутренняя устойчивость</li>
                                <li data-number="4">Влияние и взаимодействие</li>
                            </ul>
                        </div>
                        <div class="bfsale-map-slider-items" data-number="1">
                            <div class="bfsale-map-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764069000855-ao69O-Comp.svg"
                                        class="" alt="img">
                                    <p class="bfsale-map-slider-item-header">Самоопределение</p>
                                    <p class="bfsale-map-slider-item-text">Навык определять, что вы по-настоящему хотите
                                        создавать
                                        своим трудом, кому и какую это приносит ценность</p>
                                </div>
                            </div>
                            <div class="bfsale-map-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764074093937-g3IAq-Path.svg"
                                        alt="img">
                                    <p class="bfsale-map-slider-item-header">Карьерное планирование</p>
                                    <p class="bfsale-map-slider-item-text">Навык определять действия, которые помогают двигаться
                                        к выбранным точкам роста</p>
                                </div>
                            </div>
                            <div class="bfsale-map-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764069002850-yZevP-Ligh.svg"
                                        alt="img">
                                    <p class="bfsale-map-slider-item-header">Управление мотивацией</p>
                                    <p class="bfsale-map-slider-item-text">Навык понимать, что вас вдохновляет, и поддерживать
                                        свои
                                        источники мотивации так, чтобы они не иссякали</p>
                                </div>
                            </div>
                            <div class="bfsale-map-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764068999456-HQPX1-Arro.svg"
                                        alt="img">
                                    <p class="bfsale-map-slider-item-header">Адаптивность к кризисам</p>
                                    <p class="bfsale-map-slider-item-text">Навык опираться на свои внутренние и внешние ресурсы
                                        и
                                        сохранять гибкость в ситуациях неожиданных трудностей</p>
                                </div>
                            </div>
                            <div class="bfsale-map-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764069004800-MmWxl-Suit.svg"
                                        alt="img">
                                    <p class="bfsale-map-slider-item-header">Построение портфельной карьеры</p>
                                    <p class="bfsale-map-slider-item-text">Навык выбирать и добавлять новые профессиональные
                                        направления без потери баланса, усиливая устойчивость и рост вашей карьеры</p>
                                </div>
                            </div>
                        </div>
                        <div class="bfsale-map-slider-items" data-number="2">
                            <div class="bfsale-map-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764069005090-gMO7R-Targ.svg"
                                        alt="img">
                                    <p class="bfsale-map-slider-item-header">Умение ставить цели</p>
                                    <p class="bfsale-map-slider-item-text">Навык формулировать конкретные, значимые и достижимые
                                        цели, опираясь на их личный смысл</p>
                                </div>
                            </div>
                            <div class="bfsale-map-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764069000700-ilQQU-Chec.svg"
                                        alt="img">
                                    <p class="bfsale-map-slider-item-header">Умение достигать результаты</p>
                                    <p class="bfsale-map-slider-item-text">Навык заранее устранять барьеры, мешающие доводить
                                        начатое до конца, прогнозировать риски, и стабильно выходить на нужный результат</p>
                                </div>
                            </div>
                            <div class="bfsale-map-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764069003616-RO3B8-Meda.svg
                                    " alt="img">
                                    <p class="bfsale-map-slider-item-header">Умение искать и презентовать достижения</p>
                                    <p class="bfsale-map-slider-item-text">Навык доносить свой реальный вклад и результаты ясно,
                                        структурировано и убедительно</p>
                                </div>
                            </div>
                            <div class="bfsale-map-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764069005305-vRXAh-Tren.svg"
                                        alt="img">
                                    <p class="bfsale-map-slider-item-header">Умение продавать себя</p>
                                    <p class="bfsale-map-slider-item-text">Навык видеть свою ценность глазами заказчиков,
                                        работодателей и партнёров — и уметь её аргументированно показать</p>
                                </div>
                            </div>
                            <div class="bfsale-map-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764068999456-HQPX1-Arro.svg"
                                        alt="img">
                                    <p class="bfsale-map-slider-item-header">Навык смены работы</p>
                                    <p class="bfsale-map-slider-item-text">Навык создания стратегии поиска, написания резюме
                                        и сопроводительных писем, управления воронкой поиска работы, прохождения собеседований,
                                        переговорам по офферу</p>
                                </div>
                            </div>
                        </div>
                        <div class="bfsale-map-slider-items" data-number="3">
                            <div class="bfsale-map-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764069004534-LjwQi-Shie.svg"
                                        alt="img">
                                    <p class="bfsale-map-slider-item-header">Уверенность и внутренняя опора</p>
                                    <p class="bfsale-map-slider-item-text">Навык сохранять чувство собственной ценности даже
                                        при критике, давлении или сложных ситуациях</p>
                                </div>
                            </div>
                            <div class="bfsale-map-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764069001613-Et92C-Hear.svg"
                                        alt="img">
                                    <p class="bfsale-map-slider-item-header">Эмоциональная устойчивость</p>
                                    <p class="bfsale-map-slider-item-text">Навык осознавать свои эмоции и управлять ими так,
                                        чтобы
                                        они не мешали ясности и эффективности в работе</p>
                                </div>
                            </div>
                            <div class="bfsale-map-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764068999935-gjRN7-Batt.svg"
                                        alt="img">
                                    <p class="bfsale-map-slider-item-header">Управление энергией</p>
                                    <p class="bfsale-map-slider-item-text">Навык замечать свои основные энергетические утечки и
                                        заранее заботиться о ресурсе, чтобы работать устойчиво и без перегрузов</p>
                                </div>
                            </div>
                        </div>
                        <div class="bfsale-map-slider-items" data-number="4">
                            <div class="bfsale-map-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764069000356-gutJp-Chat.svg"
                                        alt="img">
                                    <p class="bfsale-map-slider-item-header">Бизнес коммуникация и влияние</p>
                                    <p class="bfsale-map-slider-item-text">Навык адаптировать свой стиль общения так, чтобы
                                        разные
                                        люди понимали вас точно и слышали ваш смысл</p>
                                </div>
                            </div>
                            <div class="bfsale-map-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764069006046-xLiSa-User.svg"
                                        alt="img">
                                    <p class="bfsale-map-slider-item-header">Построение отношений</p>
                                    <p class="bfsale-map-slider-item-text">Навык создавать с окружающими больше доверия,
                                        сотрудничества и взаимной поддержки</p>
                                </div>
                            </div>
                            <div class="bfsale-map-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764069001240-8kaYJ-Crow.svg"
                                        alt="img">
                                    <p class="bfsale-map-slider-item-header">Лидерство</p>
                                    <p class="bfsale-map-slider-item-text">Навык формировать ясность и инициативу в команде,
                                        вдохновляя людей двигаться к общему результату</p>
                                </div>
                            </div>
                            <div class="bfsale-map-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764069004356-TiNj0-Shar.svg"
                                        alt="img">
                                    <p class="bfsale-map-slider-item-header">Нетворкинг</p>
                                    <p class="bfsale-map-slider-item-text">Навык приносить ценность своему профессиональному
                                        сообществу так, чтобы сеть контактов работала выгодно для всех</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-bfsale-labs', {
        label: 'Blackfriday sale labs (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-bfsale-labs main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <div class="bfsale-labs-wrapper careerum-flex-sbfs">
                        <div class="bfsale-labs-left">
                            <p class="bfsale-labs-header">Мы создали <span>четыре лаборатории</span>, каждая из которых
                                прокачивает одну зону карьерных навыков</p>
                        </div>
                        <div class="bfsale-labs-right">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764074818543-ooiz0-Fram.png"
                                class="hidden-tablet-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764103631665-DZx0n-Fram.png"
                                class="hidden-desc-mobile" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764148969978-dsdTS-Fram.png"
                                class="hidden-desc-tablet" alt="img">
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-bfsale-labs-about', {
        label: 'Blackfriday sale about labs (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-bfsale-labs-about main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <h2>Что внутри каждой</h2>
                    <div class="bfsale-labs-about-slider">
                        <div class="bfsale-labs-about-item position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764077072608-LpgzK-Grou.png"
                                class="hidden-tablet-mobile position-absolute bg" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764103884106-JMeVS-Grou.png"
                                class="hidden-desc position-absolute bg" alt="img">
                            <div class="position-relative z-20">
                                <p class="bfsale-labs-about-item-label">Подкаст-курс </p>
                                <p class="bfsale-labs-about-item-header">Короткие аудио-уроки по 5 минут, которые мягко включают
                                    вас
                                    в развитие</p>
                                <p class="bfsale-labs-about-item-text">Один подкаст — один навык: с инсайтами и через реальные
                                    рабочие ситуации</p>
                                <p class="bfsale-labs-about-item-text">Практики, которые меняют мышление и делают вас сильнее
                                </p>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764077199242-GfS6N-Fram.png"
                                    class="hidden-tablet-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764103998753-X2q7a-Fram.png"
                                    class="hidden-desc" alt="img">
                            </div>
                        </div>
                        <div class="bfsale-labs-about-item position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764077075610-rhn9r-Grou.png"
                                class="hidden-tablet-mobile position-absolute bg" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764103897751-ehvbq-Grou.png"
                                class="hidden-desc position-absolute bg" alt="img">
                            <div class="position-relative z-20">
                                <p class="bfsale-labs-about-item-label">Карьерные навыки</p>
                                <p class="bfsale-labs-about-item-header">Фундамент, на котором стоит ваша карьера</p>
                                <p class="bfsale-labs-about-item-subheader">Результат развития навыков:</p>
                                <ul>
                                    <li>Профессиональные решения становятся осознаннее</li>
                                    <li>Коммуникации — чище</li>
                                    <li>Энергия — стабильнее</li>
                                    <li>Цели — точнее</li>
                                </ul>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764077198057-W4NC3-Fram.png"
                                    class="hidden-tablet-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764103999363-6Y5SN-Fram.png"
                                    class="hidden-desc" alt="img">
                            </div>
                        </div>
                        <div class="bfsale-labs-about-item position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764077079083-fR5Bk-Grou.png"
                                class="hidden-tablet-mobile position-absolute bg" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764103909355-XwCIn-Grou.png"
                                class="hidden-desc position-absolute bg" alt="img">
                            <div class="position-relative z-20">
                                <p class="bfsale-labs-about-item-label">Диагностика навыков</p>
                                <p class="bfsale-labs-about-item-header">Вы получите личный профиль навыков и конкретные шаги
                                    развития</p>
                                <p class="bfsale-labs-about-item-subheader">Оцените:</p>
                                <ul>
                                    <li>Сильные стороны</li>
                                    <li>Нестабильные зоны</li>
                                    <li>Рекомендации для роста</li>
                                </ul>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764077195629-n1VWs-Grou.png"
                                    class="hidden-tablet-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764103999478-kBqeY-Grou.png"
                                    class="hidden-desc" alt="img">
                            </div>
                        </div>
                        <div class="bfsale-labs-about-item position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764077082663-sTxPl-Grou.png"
                                class="hidden-tablet-mobile position-absolute bg" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764103911263-nMtpd-Grou.png"
                                class="hidden-desc position-absolute bg" alt="img">
                            <div class="position-relative z-20">
                                <p class="bfsale-labs-about-item-label">Карта навыков</p>
                                <p class="bfsale-labs-about-item-header">Путеводитель по развитию профессиональной устойчивости
                                </p>
                                <p class="bfsale-labs-about-item-subheader">Помогает быстро понять:</p>
                                <ul>
                                    <li>Какие навыки существуют и за что они отвечают</li>
                                    <li>Как они связаны между собой</li>
                                    <li>На что влияет каждый навык в карьере</li>
                                </ul>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764077194645-fXVsm-Fram.png"
                                    class="hidden-tablet-mobile" alt="img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764103999587-y9BIX-Fram.png"
                                    class="hidden-desc" alt="img">
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-bfsale-description', {
        label: 'Blackfriday sale description (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-bfsale-description main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <div class="bfsale-description-header position-relative">
                        <h2 class="position-relative z-20">Лаборатории</h2>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764078195739-MpXII-Grou.png"
                            class="hidden-tablet-mobile position-absolute z-10" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764104499337-LBXw8-Grou.png"
                            class="hidden-desc-mobile position-absolute z-10" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764149430531-lkuOV-Grou.png"
                            class="hidden-desc-tablet position-absolute z-10" alt="img">
                    </div>
                    <div class="bfsale-description-switcher position-relative z-20">
                        <ul class="careerum-flex-fsfs">
                            <li data-currency="eur">EUR</li>
                            <li class="active" data-currency="rub">RUB</li>
                        </ul>
                        <div class="bfsale-description-switcher-mobile">
                            <div class="bfsale-tariffs__swicher-block">
                                <div class="bfsale-tariffs__swicher-top">
                                    <p class="bfsale-tariffs__swicher-header">Посмотреть
                                        цены в
                                        <span>EUR</span>
                                    </p>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" class="bfsale-tariffs__swicher-arrow">
                                        <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black">
                                        </path>
                                    </svg>
                                </div>
                                <div class="bfsale-tariffs__swicher-bottom">
                                    <ul>
                                        <li data-currency="rub" class="active">
                                            RUB
                                        </li>
                                        <li data-currency="eur" class="">
                                            EUR
                                        </li>
                                    </ul>
                                    <p>
                                        Обратите внимание,<br> что оплата в российских
                                        рублях
                                        возможна только<br> с карты
                                        российского банка. Оплата в евро — с карты зарубежного банка
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bfsale-description-wrapper careerum-flex-sbfs position-relative z-10">
                        <div class="bfsale-description-item blue position-relative" data-price-rub="5 900 ₽"
                            data-price-eur="59 €" data-oldprice-rub="14 900 ₽" data-oldprice-eur="149 €"
                            data-popup-rub="#popup1r" data-popup-eur="#popiup1e">
                            <div>
                                <div class="bfsale-description-item-header position-relative">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764079762353-MJIr1-Grou.png"
                                        class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764106798112-xDeQN-Grou.png"
                                        class="hidden-desc-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764151120405-FgwpL-Grou.png"
                                        class="hidden-desc-tablet position-absolute z-10" alt="img">
                                    <div class="bfsale-description-item-label careerum-flex-fsc position-relative z-20">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764078882262-Uzl3p-Flas.svg"
                                            alt="img">
                                        <p>LAB 1</p>
                                    </div>
                                    <p class="bfsale-description-item-header position-relative z-20">Core Energy</p>
                                    <p class="bfsale-description-item-descr position-relative z-20">Уверенность, энергия,
                                        внутренняя опора</p>
                                </div>
                                <div class="bfsale-description-item-content position-relative z-20 careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764084355252-4KFdU-Fram.png"
                                        class="hidden-tablet-mobile position-absolute z-10 active" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764080485180-u3ybw-Fram.png"
                                        class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764105314861-HTfUM-Fram.png"
                                        class="hidden-desc-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764150556354-OXnkn-Fram.png"
                                        class="hidden-desc-mobile position-absolute z-10 active" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764150799049-HjVOx-Fram.png"
                                        class="hidden-desc-tablet position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764150798689-cRvjG-Fram.png"
                                        class="hidden-desc-tablet position-absolute z-10 active" alt="img">
                                    <div
                                        class="bfsale-description-item-content-wrapper position-relative z-20 careerum-flex-fsfs">
                                        <p class="bfsale-description-item-text">
                                            В этой лаборатории вы узнаете о навыках, которые отвечают за ощущение контроля
                                            над карьерой, вашу внутреннюю опору, энергию и мотивацию. Оцените, насколько у вас
                                            эти навыки прокачены и сформируете план развития
                                        </p>
                                        <div class="bfsale-description-item-content-group careerum-flex-fsc">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764081894435-iKocy-Micr.svg"
                                                alt="img">
                                            <p>Подкаcт-курс 50 минут (Доступ навсегда) </p>
                                        </div>
                                        <div class="bfsale-description-item-content-group careerum-flex-fsc">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764081894129-FYUjY-Acti.svg"
                                                alt="img">
                                            <p>Диагностика навыков (Доступ до конца 2025)</p>
                                        </div>
                                        <div class="bfsale-description-item-content-group careerum-flex-fsc">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764081894558-Ku92R-Path.svg"
                                                alt="img">
                                            <p>Карта навыков</p>
                                        </div>
                                        <div class="bfsale-description-item-content-switcher careerum-flex-fsc">
                                            <p>Навыки:</p>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764080919943-it39v-Care.svg"
                                                alt="img">
                                        </div>
                                        <div class="bfsale-description-item-content-skills">
                                            <p class="bfsale-description-item-content-skills-header">1. Уверенность и внутренняя
                                                опора</p>
                                            <p class="bfsale-description-item-content-skills-text">Навык сохранять чувство
                                                собственной ценности даже при критике, давлении или сложных ситуациях</p>
                                            <p class="bfsale-description-item-content-skills-header">2. Эмоциональная
                                                устойчивость</p>
                                            <p class="bfsale-description-item-content-skills-text">Навык осознавать свои эмоции
                                                и управлять ими так, чтобы они не мешали ясности и эффективности в работе</p>
                                            <p class="bfsale-description-item-content-skills-header">3. Управление энергией</p>
                                            <p class="bfsale-description-item-content-skills-text">Навык замечать свои основные
                                                энергетические утечки и заранее заботиться о ресурсе, чтобы работать устойчиво
                                                и без перегрузов</p>
                                        </div>
                                        <div class="bfsale-description-item-content-buy">
                                            <div class="careerum-flex-fsc">
                                                <p class="bfsale-description-item-content-buy-price">5 900 ₽</p>
                                                <p class="bfsale-description-item-content-buy-old-price">14 900 ₽</p>
                                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764082950553-OFSNU-Fram.png"
                                                    alt="img">
                                            </div>
                                            <a href="#popup1" class="btn-color-red">Купить</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bfsale-description-item red position-relative" data-price-rub="5 900 ₽"
                            data-price-eur="59 €" data-oldprice-rub="14 900 ₽" data-oldprice-eur="149 €"
                            data-popup-rub="#popup1r" data-popup-eur="#popiup1e">
                            <div>
                                <div class="bfsale-description-item-header position-relative">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764084766226-xtVcm-Grou.png"
                                        class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764106798502-X7Hcp-Grou.png"
                                        class="hidden-desc-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764151486272-zOQh9-Grou.png"
                                        class="hidden-desc-tablet position-absolute z-10" alt="img">
                                    <div class="bfsale-description-item-label careerum-flex-fsc position-relative z-20">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764078882262-Uzl3p-Flas.svg"
                                            alt="img">
                                        <p>LAB 2</p>
                                    </div>
                                    <p class="bfsale-description-item-header position-relative z-20">Career GPS</p>
                                    <p class="bfsale-description-item-descr position-relative z-20">Самоопределение в карьере и
                                        стратегия</p>
                                </div>
                                <div class="bfsale-description-item-content position-relative z-20 careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764085221869-Onuas-Fram.png"
                                        class="hidden-tablet-mobile position-absolute z-10 active" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764084941792-D6bTD-Fram.png"
                                        class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764106666038-vBBVc-Fram.png"
                                        class="hidden-desc-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764106667854-MVntL-Fram.png"
                                        class="hidden-desc-mobile position-absolute z-10 active" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764152366627-A3Jnv-Fram.png"
                                        class="hidden-desc-tablet position-absolute z-10 active" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764151587283-yxTIJ-Fram.png"
                                        class="hidden-desc-tablet position-absolute z-10 " alt="img">
                                    <div
                                        class="bfsale-description-item-content-wrapper position-relative z-20 careerum-flex-fsfs">
                                        <p class="bfsale-description-item-text">
                                            В этой лаборатории вы узнаете и оцените свои навыки формирования ясной карьерной
                                            стратегии. Поймете, какие навыки отвечают за принятие решений, чтобы двигаться
                                            вперед
                                        </p>
                                        <div class="bfsale-description-item-content-group careerum-flex-fsc">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764081894435-iKocy-Micr.svg"
                                                alt="img">
                                            <p>Подкаcт-курс 50 минут (Доступ навсегда) </p>
                                        </div>
                                        <div class="bfsale-description-item-content-group careerum-flex-fsc">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764081894129-FYUjY-Acti.svg"
                                                alt="img">
                                            <p>Диагностика навыков (Доступ до конца 2025)</p>
                                        </div>
                                        <div class="bfsale-description-item-content-group careerum-flex-fsc">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764081894558-Ku92R-Path.svg"
                                                alt="img">
                                            <p>Карта навыков</p>
                                        </div>
                                        <div class="bfsale-description-item-content-switcher careerum-flex-fsc">
                                            <p>Навыки:</p>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764080919943-it39v-Care.svg"
                                                alt="img">
                                        </div>
                                        <div class="bfsale-description-item-content-skills">
                                            <p class="bfsale-description-item-content-skills-header">1. Самоопределение</p>
                                            <p class="bfsale-description-item-content-skills-text">Навык определять,
                                                что вы по‑настоящему хотите создавать своим трудом, кому и какую это приносит
                                                ценность</p>
                                            <p class="bfsale-description-item-content-skills-header">2. Карьерное планирование
                                            </p>
                                            <p class="bfsale-description-item-content-skills-text">Навык определять действия,
                                                которые помогают двигаться к выбранным точкам роста</p>
                                            <p class="bfsale-description-item-content-skills-header">3. Управление мотивацией
                                            </p>
                                            <p class="bfsale-description-item-content-skills-text">Навык понимать,
                                                что вас вдохновляет, и поддерживать свои источники мотивации так,
                                                чтобы они не иссякали</p>
                                            <p class="bfsale-description-item-content-skills-header">4. Адаптивность к кризисам
                                            </p>
                                            <p class="bfsale-description-item-content-skills-text">Навык опираться на свои
                                                внутренние и внешние ресурсы и сохранять гибкость в ситуациях неожиданных
                                                трудностей</p>
                                            <p class="bfsale-description-item-content-skills-header">5. Построение портфельной
                                                карьеры</p>
                                            <p class="bfsale-description-item-content-skills-text">Навык выбирать и добавлять
                                                новые профессиональные направления без потери баланса, усиливая устойчивость
                                                и рост вашей карьеры</p>
                                        </div>
                                        <div class="bfsale-description-item-content-buy">
                                            <div class="careerum-flex-fsc">
                                                <p class="bfsale-description-item-content-buy-price">5 900 ₽</p>
                                                <p class="bfsale-description-item-content-buy-old-price">14 900 ₽</p>
                                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764082950553-OFSNU-Fram.png"
                                                    alt="img">
                                            </div>
                                            <a href="#popup2" class="btn-color-red">Купить</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bfsale-description-item blue position-relative" data-price-rub="5 900 ₽"
                            data-price-eur="59 €" data-oldprice-rub="14 900 ₽" data-oldprice-eur="149 €"
                            data-popup-rub="#popup1r" data-popup-eur="#popiup1e">
                            <div>
                                <div class="bfsale-description-item-header position-relative">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764085487263-A9WUe-Grou.png"
                                        class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764107001732-ZDbKk-Grou.png"
                                        class="hidden-desc-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764152229789-A4zw8-Grou.png"
                                        class="hidden-desc-tablet position-absolute z-10" alt="img">
                                    <div class="bfsale-description-item-label careerum-flex-fsc position-relative z-20">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764078882262-Uzl3p-Flas.svg"
                                            alt="img">
                                        <p>LAB 3</p>
                                    </div>
                                    <p class="bfsale-description-item-header position-relative z-20">Influence Power</p>
                                    <p class="bfsale-description-item-descr position-relative z-20">Коммуникации, лидерство,
                                        влияние</p>
                                </div>
                                <div class="bfsale-description-item-content position-relative z-20 careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764086764297-H4XwL-Fram.png"
                                        class="hidden-tablet-mobile position-absolute z-10 active" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764080485180-u3ybw-Fram.png"
                                        class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764105314861-HTfUM-Fram.png"
                                        class="hidden-desc-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764141522540-4B4pj-Fram.png"
                                        class="hidden-desc-mobile position-absolute z-10 active" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764151807197-5J8D4-Fram.png"
                                        class="hidden-desc-tablet position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764151806866-H0bMk-Fram.png"
                                        class="hidden-desc-tablet position-absolute z-10 active" alt="img">
                                    <div
                                        class="bfsale-description-item-content-wrapper position-relative z-20 careerum-flex-fsfs">
                                        <p class="bfsale-description-item-text">
                                            В этой лаборатории вы узнаете о навыках, которые отвечают за влияние, доверие
                                            и профессиональную проявленность в команде, на встречах и в переговорах. Оцените,
                                            насколько они развиты у вас сейчас, и поймёте, что помогает говорить так, чтобы вас
                                            слышали, влиять без давления и проявляться как лидер
                                        </p>
                                        <div class="bfsale-description-item-content-group careerum-flex-fsc">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764081894435-iKocy-Micr.svg"
                                                alt="img">
                                            <p>Подкаcт-курс 50 минут (Доступ навсегда) </p>
                                        </div>
                                        <div class="bfsale-description-item-content-group careerum-flex-fsc">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764081894129-FYUjY-Acti.svg"
                                                alt="img">
                                            <p>Диагностика навыков (Доступ до конца 2025)</p>
                                        </div>
                                        <div class="bfsale-description-item-content-group careerum-flex-fsc">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764081894558-Ku92R-Path.svg"
                                                alt="img">
                                            <p>Карта навыков</p>
                                        </div>
                                        <div class="bfsale-description-item-content-switcher careerum-flex-fsc">
                                            <p>Навыки:</p>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764080919943-it39v-Care.svg"
                                                alt="img">
                                        </div>
                                        <div class="bfsale-description-item-content-skills">
                                            <p class="bfsale-description-item-content-skills-header">1. Профессиональная
                                                коммуникация и влияние</p>
                                            <p class="bfsale-description-item-content-skills-text">Навык адаптировать свой стиль
                                                общения так, чтобы разные люди понимали вас точно и прислушивались к вашему
                                                мнению</p>
                                            <p class="bfsale-description-item-content-skills-header">2. Построение отношений</p>
                                            <p class="bfsale-description-item-content-skills-text">Навык создавать с окружающими
                                                больше доверия, сотрудничества и взаимной поддержки</p>
                                            <p class="bfsale-description-item-content-skills-header">3. Лидерство</p>
                                            <p class="bfsale-description-item-content-skills-text">Навык формировать ясность и
                                                инициативу в команде, вдохновляя людей двигаться к общему результату</p>
                                            <p class="bfsale-description-item-content-skills-header">4. Нетворкинг</p>
                                            <p class="bfsale-description-item-content-skills-text">Навык приносить ценность
                                                своему профессиональному сообществу так, чтобы сеть контактов работала выгодно
                                                для всех</p>
                                        </div>
                                        <div class="bfsale-description-item-content-buy">
                                            <div class="careerum-flex-fsc">
                                                <p class="bfsale-description-item-content-buy-price">5 900 ₽</p>
                                                <p class="bfsale-description-item-content-buy-old-price">14 900 ₽</p>
                                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764082950553-OFSNU-Fram.png"
                                                    alt="img">
                                            </div>
                                            <a href="#popup1" class="btn-color-red">Купить</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bfsale-description-item red position-relative" data-price-rub="5 900 ₽"
                            data-price-eur="59 €" data-oldprice-rub="14 900 ₽" data-oldprice-eur="149 €"
                            data-popup-rub="#popup1r" data-popup-eur="#popiup1e">
                            <div>
                                <div class="bfsale-description-item-header position-relative">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764087780580-2cYpO-Grou.png"
                                        class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764107002070-oyr0M-Grou.png"
                                        class="hidden-desc-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764151807319-FCSGt-Grou.png"
                                        class="hidden-desc-tablet position-absolute z-10" alt="img">
                                    <div class="bfsale-description-item-label careerum-flex-fsc position-relative z-20">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764078882262-Uzl3p-Flas.svg"
                                            alt="img">
                                        <p>LAB 4</p>
                                    </div>
                                    <p class="bfsale-description-item-header position-relative z-20">Next Step</p>
                                    <p class="bfsale-description-item-descr position-relative z-20">Смена работы, продажа своей
                                        ценности и карьерный рост</p>
                                </div>
                                <div class="bfsale-description-item-content position-relative z-20 careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764086763883-uwvDz-Fram.png"
                                        class="hidden-tablet-mobile position-absolute z-10 active" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764084941792-D6bTD-Fram.png"
                                        class="hidden-tablet-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764106666038-vBBVc-Fram.png"
                                        class="hidden-desc-mobile position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764141522139-7ZHd4-Fram.png"
                                        class="hidden-desc-mobile position-absolute z-10 active" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764152442244-vljYp-Fram.png"
                                        class="hidden-desc-tablet position-absolute z-10" alt="img">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764152441817-kYuGw-Fram.png"
                                        class="hidden-desc-tablet position-absolute z-10 active" alt="img">
                                    <div
                                        class="bfsale-description-item-content-wrapper position-relative z-20 careerum-flex-fsfs">
                                        <p class="bfsale-description-item-text">
                                            В этой лаборатории вы узнаете о навыках, которые помогают видеть и формулировать
                                            свою профессиональную ценность и смело продавать себя на рынке. Оцените, насколько
                                            уверенно вы говорите о своих достижениях сегодня, и поймёте, какие навыки нужно
                                            развивать для движение вперёд — к новой роли, уровню и доходу
                                        </p>
                                        <div class="bfsale-description-item-content-group careerum-flex-fsc">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764081894435-iKocy-Micr.svg"
                                                alt="img">
                                            <p>Подкаcт-курс 50 минут (Доступ навсегда) </p>
                                        </div>
                                        <div class="bfsale-description-item-content-group careerum-flex-fsc">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764081894129-FYUjY-Acti.svg"
                                                alt="img">
                                            <p>Диагностика навыков (Доступ до конца 2025)</p>
                                        </div>
                                        <div class="bfsale-description-item-content-group careerum-flex-fsc">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764081894558-Ku92R-Path.svg"
                                                alt="img">
                                            <p>Карта навыков</p>
                                        </div>
                                        <div class="bfsale-description-item-content-switcher careerum-flex-fsc">
                                            <p>Навыки:</p>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764080919943-it39v-Care.svg"
                                                alt="img">
                                        </div>
                                        <div class="bfsale-description-item-content-skills">
                                            <p class="bfsale-description-item-content-skills-header">1. Умение ставить цели</p>
                                            <p class="bfsale-description-item-content-skills-text">Навык формулировать
                                                конкретные, значимые и достижимые цели, опираясь на их личный смысл</p>
                                            <p class="bfsale-description-item-content-skills-header">2. Умение достигать
                                                результаты</p>
                                            <p class="bfsale-description-item-content-skills-text">Навык заранее устранять
                                                барьеры, мешающие доводить начатое до конца, прогнозировать риски, и стабильно
                                                выходить на нужный результат</p>
                                            <p class="bfsale-description-item-content-skills-header">3. Умение искать и
                                                презентовать достижения</p>
                                            <p class="bfsale-description-item-content-skills-text">Навык доносить свой реальный
                                                вклад и результаты ясно, структурировано и убедительно</p>
                                            <p class="bfsale-description-item-content-skills-header">4. Умение продавать себя
                                            </p>
                                            <p class="bfsale-description-item-content-skills-text">Навык видеть свою ценность
                                                глазами заказчиков, работодателей и партнёров — и уметь её аргументированно
                                                показать</p>
                                            <p class="bfsale-description-item-content-skills-header">5. Навык смены работы</p>
                                            <p class="bfsale-description-item-content-skills-text">Навык создания стратегии
                                                поиска, написания резюме и сопроводительных писем, управления воронкой поиска
                                                работы, прохождения собеседований, переговоров по офферу</p>
                                        </div>
                                        <div class="bfsale-description-item-content-buy">
                                            <div class="careerum-flex-fsc">
                                                <p class="bfsale-description-item-content-buy-price">5 900 ₽</p>
                                                <p class="bfsale-description-item-content-buy-old-price">14 900 ₽</p>
                                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764082950553-OFSNU-Fram.png"
                                                    alt="img">
                                            </div>
                                            <a href="#popup1" class="btn-color-red">Купить</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bfsale-description-bottom position-relative z-20" data-price-rub="14 900 ₽"
                        data-price-eur="149 €" data-oldprice-rub="59 600 ₽" data-oldprice-eur="569 €" data-popup-rub="#popup1r"
                        data-popup-eur="#popiup1e">
                        <div class="bfsale-description-bottom-wrapper careerum-flex-sbfs position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764089857459-F9yK3-Grou.png"
                                class="hidden-tablet-mobile position-absolute z-10" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764141719789-dalkG-Grou.png"
                                class="hidden-desc-mobile position-absolute z-10" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764152972332-wddXY-Grou.png"
                                class="hidden-desc-tablet position-absolute z-10" alt="img">
                            <div class="bfsale-description-bottom-left">
                                <p class="bfsale-description-bottom-header">Купить все лаборатории</p>
                                <div class="bfsale-description-bottom-group careerum-flex-fsc hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764088485842-hJPEP-Lock.svg"
                                        alt="img">
                                    <p>Доступ к подкаст-курсам навсегда</p>
                                </div>
                                <div class="bfsale-description-bottom-group careerum-flex-fsc hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764088485842-hJPEP-Lock.svg"
                                        alt="img">
                                    <p>Доступ к диагностике до конца 2025</p>
                                </div>
                                <div class="bfsale-description-bottom-buy hidden-tablet-mobile">
                                    <div class="careerum-flex-fsc">
                                        <p class="bfsale-description-bottom-buy-price">14 900 ₽</p>
                                        <p class="bfsale-description-bottom-buy-old-price">59 600 ₽</p>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764091418415-un41i-Fram.png"
                                            alt="img">
                                    </div>
                                    <a href="#popup1" class="btn-color-red">Купить</a>
                                </div>
                            </div>
                            <div class="bfsale-description-bottom-right">
                                <div class="bfsale-description-bottom-item position-relative">
                                    <div class="bfsale-description-bottom-item-label careerum-flex-fsfs">
                                        <p>LAB 1</p>
                                        <p>Core Energy</p>
                                    </div>
                                    <p class="bfsale-description-bottom-item-header">Уверенность, энергия, внутренняя опора</p>
                                </div>
                                <div class="bfsale-description-bottom-line careerum-flex-fsc">
                                    <div class="hidden-desc"></div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764089531924-rQWhQ-Fram.svg"
                                        alt="img" class="hidden-desc">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764089721586-7gavF-Fram.svg"
                                        alt="img" class="hidden-tablet-mobile">
                                    <div></div>
                                </div>
                                <div class="bfsale-description-bottom-item position-relative">
                                    <div class="bfsale-description-bottom-item-label careerum-flex-fsfs">
                                        <p>LAB 2</p>
                                        <p>Career GPS</p>
                                    </div>
                                    <p class="bfsale-description-bottom-item-header hidden-desc">Самоопределение<br> в карьере и
                                        стратегия</p>
                                    <p class="bfsale-description-bottom-item-header hidden-tablet-mobile">Самоопределение в
                                        карьере и стратегия</p>
                                </div>
                                <div class="bfsale-description-bottom-line careerum-flex-fsc">
                                    <div class="hidden-desc"></div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764089531924-rQWhQ-Fram.svg"
                                        alt="img" class="hidden-desc">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764089721586-7gavF-Fram.svg"
                                        alt="img" class="hidden-tablet-mobile">
                                    <div></div>
                                </div>
                                <div class="bfsale-description-bottom-item position-relative">
                                    <div class="bfsale-description-bottom-item-label careerum-flex-fsfs">
                                        <p>LAB 3</p>
                                        <p>Influence Power</p>
                                    </div>
                                    <p class="bfsale-description-bottom-item-header">Коммуникации, лидерство, влияние</p>
                                </div>
                                <div class="bfsale-description-bottom-line careerum-flex-fsc">
                                    <div class="hidden-desc"></div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764089531924-rQWhQ-Fram.svg"
                                        alt="img" class="hidden-desc">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764089721586-7gavF-Fram.svg"
                                        alt="img" class="hidden-tablet-mobile">
                                    <div></div>
                                </div>
                                <div class="bfsale-description-bottom-item position-relative">
                                    <div class="bfsale-description-bottom-item-label careerum-flex-fsfs">
                                        <p>LAB 4</p>
                                        <p>Next Step</p>
                                    </div>
                                    <p class="bfsale-description-bottom-item-header">Смена работы, продажа своей ценности
                                        и карьерный рост</p>
                                </div>
                                <div class="bfsale-description-bottom-group careerum-flex-fsc hidden-desc">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764088485842-hJPEP-Lock.svg"
                                        alt="img">
                                    <p>Доступ к подкаст-курсам навсегда</p>
                                </div>
                                <div class="bfsale-description-bottom-group careerum-flex-fsc hidden-desc">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764088485842-hJPEP-Lock.svg"
                                        alt="img">
                                    <p>Доступ к диагностике до конца 2025</p>
                                </div>
                                <div class="bfsale-description-bottom-buy hidden-desc">
                                    <div class="careerum-flex-fsc">
                                        <p class="bfsale-description-bottom-buy-price">14 900 ₽</p>
                                        <p class="bfsale-description-bottom-buy-old-price">59 600 ₽</p>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764091418415-un41i-Fram.png"
                                            alt="img">
                                    </div>
                                    <a href="#popup1" class="btn-color-red">Купить</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764143007187-IlJPO-Grou.png"
                        class="hidden-tablet-mobile position-absolute z-10" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764143021173-pgto3-Grou.png"
                        class="hidden-desc-mobile position-absolute z-10" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764143041451-MqJYM-Grou.png"
                        class="hidden-desc-tablet position-absolute z-10" alt="img">
                </div>
            </div>`
    });
    
    blockManager.add('careerum-bfsale-tariffs', {
        label: 'Blackfriday sale tariffs (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-bfsale-tariffs main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <div class="bfsale-tariffs-header position-relative">
                        <h2>Бустеры навыков</h2>
                        <p>2 лабы со скидкой 67% </p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764090732346-C43Is-Grou.png"
                            class="hidden-tablet-mobile position-absolute" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764143748899-qYlZy-Grou.png"
                            class="hidden-desc-mobile position-absolute" alt="img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764153311245-9xR9r-Grou.png"
                            class="hidden-desc-tablet position-absolute" alt="img">
                    </div>
                    <div class="bfsale-tariffs-switcher position-relative z-30">
                        <ul class="careerum-flex-fsfs">
                            <li data-currency="eur">EUR</li>
                            <li class="active" data-currency="rub">RUB</li>
                        </ul>
                        <div class="bfsale-tariffs-switcher-mobile">
                            <div class="bfsale-tariffs__swicher-block">
                                <div class="bfsale-tariffs__swicher-top">
                                    <p class="bfsale-tariffs__swicher-header">Посмотреть
                                        цены в
                                        <span>EUR</span>
                                    </p>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" class="bfsale-tariffs__swicher-arrow">
                                        <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black">
                                        </path>
                                    </svg>
                                </div>
                                <div class="bfsale-tariffs__swicher-bottom">
                                    <ul>
                                        <li data-currency="rub" class="active">
                                            RUB
                                        </li>
                                        <li data-currency="eur" class="">
                                            EUR
                                        </li>
                                    </ul>
                                    <p>
                                        Обратите внимание,<br> что оплата в российских
                                        рублях
                                        возможна только<br> с карты
                                        российского банка. Оплата в евро — с карты зарубежного банка
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bfsale-tariffs-wrapper careerum-flex-sbfs position-relative z-20">
                        <div class="bfsale-tariffs-item position-relative" data-price-rub="9 900 ₽" data-price-eur="99 €"
                            data-oldprice-rub="29 800 ₽" data-oldprice-eur="298 €" data-popup-rub="#popup21r"
                            data-popup-eur="#popiup21e">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764091088207-uQu7p-Fram.png"
                                class="hidden-tablet-mobile position-absolute z-10" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764144171602-mHdCd-Fram.png"
                                class="hidden-desc-mobile position-absolute z-10" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764153592017-d67om-Fram.png"
                                class="hidden-desc-tablet position-absolute z-10" alt="img">
                            <div class="bfsale-tariffs-item-content position-relative z-20">
                                <div class="bfsale-tariffs-item-top">
                                    <div class="bfsale-tariffs-item-header-wrapper">
                                        <p class="bfsale-tariffs-item-header">Бустер 
                                            уверенности</p>
                                    </div>
                                    <p class="bfsale-tariffs-item-subheader">Core Energy</p>
                                    <p class="bfsale-tariffs-item-descr">Уверенность, энергия, внутренняя опора</p>
                                    <div class="bfsale-tariffs-item-divider"></div>
                                    <p class="bfsale-tariffs-item-subheader">Influence Power</p>
                                    <p class="bfsale-tariffs-item-descr">Коммуникации, лидерство, влияние</p>
                                </div>
                                <div class="bfsale-tariffs-group careerum-flex-fsc">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764094183690-iA5UH-Lock.png"
                                        alt="img">
                                    <p>Доступ к подкаст-курсам навсегда</p>
                                </div>
                                <div class="bfsale-tariffs-group careerum-flex-fsc">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764094183690-iA5UH-Lock.png"
                                        alt="img">
                                    <p>Доступ к диагностике до конца 2025</p>
                                </div>
                                <div class="bfsale-tariffs-buy">
                                    <div class="careerum-flex-cc">
                                        <p class="bfsale-tariffs-buy-price">9 900 ₽</p>
                                        <p class="bfsale-tariffs-buy-old-price">29 800 ₽</p>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764091561414-8zXKv-Fram.png"
                                            alt="img">
                                    </div>
                                    <a href="#popup1" class="btn-color-red">Купить</a>
                                </div>
                            </div>
                        </div>
                        <div class="bfsale-tariffs-item position-relative" data-price-rub="9 900 ₽" data-price-eur="99 €"
                            data-oldprice-rub="29 800 ₽" data-oldprice-eur="298 €" data-popup-rub="#popup22r"
                            data-popup-eur="#popiup22e">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764091087736-UReYN-Fram.png"
                                class="hidden-tablet-mobile position-absolute z-10" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764144171083-W72Ex-Fram.png"
                                class="hidden-desc-mobile position-absolute z-10" alt="img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764153592426-bvrun-Fram.png"
                                class="hidden-desc-tablet position-absolute z-10" alt="img">
                            <div class="bfsale-tariffs-item-content position-relative z-20">
                                <div class="bfsale-tariffs-item-top">
                                    <div class="bfsale-tariffs-item-header-wrapper">
                                        <p class="bfsale-tariffs-item-header">Бустер карьерной стратегии</p>
                                    </div>
                                    <p class="bfsale-tariffs-item-subheader"> Career GPS</p>
                                    <p class="bfsale-tariffs-item-descr">Самоопределение<br> в карьере и стратегия</p>
                                    <div class="bfsale-tariffs-item-divider"></div>
                                    <p class="bfsale-tariffs-item-subheader">Next Step</p>
                                    <p class="bfsale-tariffs-item-descr">Смена работы, продажа своей ценности и карьерный рост
                                    </p>
                                </div>
                                <div class="bfsale-tariffs-group careerum-flex-fsc">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764094183690-iA5UH-Lock.png"
                                        alt="img">
                                    <p>Доступ к подкаст-курсам навсегда</p>
                                </div>
                                <div class="bfsale-tariffs-group careerum-flex-fsc">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764094183690-iA5UH-Lock.png"
                                        alt="img">
                                    <p>Доступ к диагностике до конца 2025</p>
                                </div>
                                <div class="bfsale-tariffs-buy">
                                    <div class="careerum-flex-cc">
                                        <p class="bfsale-tariffs-buy-price">9 900 ₽</p>
                                        <p class="bfsale-tariffs-buy-old-price">29 800 ₽</p>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764091561414-8zXKv-Fram.png"
                                            alt="img">
                                    </div>
                                    <a href="#popup1" class="btn-color-red">Купить</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764143340732-Q81C2-Grou.png"
                        class="hidden-tablet-mobile position-absolute z-10" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764143363250-CCYDg-Grou.png"
                        class="hidden-desc-mobile position-absolute z-10" alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764143390664-mBUSz-Grou.png"
                        class="hidden-desc-tablet position-absolute z-10" alt="img">
                </div>
            </div>`
    });
    
    blockManager.add('careerum-bfsale-popup', {
        label: 'Blackfriday sale popup (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-popup careerum-bfsale-popup">
                <div class="popup__close-button-wrapper careerum-flex-cc close-switch">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"
                        class="close-switch">
                        <path d="M10.5977 10.5588L1.00566 1.00586" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M0.999561 10.5609L10.6016 1" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="bfsale-popup-content careerum-flex-sbst">
                    <div class="bfsale-popup-content-left careerum-flex-fsfs">
                        <p class="bfsale-popup-content-header">1 лаборатория</p>
                        <div class="bfsale-popup-content-labels careerum-flex-fsc">
                            <div class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764094924791-Hus5M-Flas.svg"
                                    alt="img">
                                <p>LAB 1</p>
                            </div>
                            <p>Core Energy</p>
                        </div>
                        <p class="bfsale-popup-content-subheader">Уверенность, энергия, внутренняя опора</p>
                        <div class="bfsale-popup-buy">
                            <div class="careerum-flex-fsc">
                                <p class="bfsale-popup-buy-price">9 900 ₽</p>
                                <p class="bfsale-popup-buy-old-price">29 800 ₽</p>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764091561414-8zXKv-Fram.png"
                                    alt="img">
                            </div>
                            <a href="#popup1" class="close-switch">Купить только эту лабу</a>
                        </div>
                    </div>
                    <div class="bfsale-popup-content-right careerum-flex-fsfs">
                        <p class="bfsale-popup-content-header">Набор из 2 лабораторий</p>
                        <div class="bfsale-popup-content-labels careerum-flex-fsc">
                            <div class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764094924791-Hus5M-Flas.svg"
                                    alt="img">
                                <p>LAB 1</p>
                            </div>
                            <p>Core Energy</p>
                        </div>
                        <p class="bfsale-popup-content-subheader">Уверенность, энергия, внутренняя опора</p>
                        <div class="bfsale-popup-content-labels careerum-flex-fsc">
                            <div class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764094924791-Hus5M-Flas.svg"
                                    alt="img">
                                <p>LAB 3</p>
                            </div>
                            <p>Influence Power</p>
                        </div>
                        <p class="bfsale-popup-content-subheader last">Коммуникации, лидерство, влияние</p>
                        <div class="bfsale-popup-buy">
                            <div class="careerum-flex-fsc">
                                <p class="bfsale-popup-buy-price">9 900 ₽</p>
                                <p class="bfsale-popup-buy-old-price">29 800 ₽</p>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764091561414-8zXKv-Fram.png"
                                    alt="img">
                            </div>
                            <a href="#popup1" class="btn-color-red close-switch">Купить 2 лабы</a>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-bfsale-popup-pay', {
        label: 'Blackfriday sale popup (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-popup careerum-bfsale-popup-pay">
                <div class="popup__close-button-wrapper careerum-flex-cc close-switch">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="">
                        <path d="M10.5977 10.5588L1.00566 1.00586" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M0.999561 10.5609L10.6016 1" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="bfsale-popup-pay-content careerum-flex-sbst">
                    <div class="bfsale-popup-pay-content-left position-relative">
                        <p class="bfsale-popup-pay-content-header">1 лаборатория</p>
                        <div class="bfsale-popup-pay-content-labels careerum-flex-fsc">
                            <div class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764094924791-Hus5M-Flas.svg"
                                    alt="img">
                                <p>LAB 1</p>
                            </div>
                            <p>Core Energy</p>
                        </div>
                        <p class="bfsale-popup-pay-content-subheader">Уверенность, энергия, внутренняя опора</p>
                        <div class="bfsale-popup-pay-content-labels careerum-flex-fsc">
                            <div class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764094924791-Hus5M-Flas.svg"
                                    alt="img">
                                <p>LAB 1</p>
                            </div>
                            <p>Core Energy</p>
                        </div>
                        <p class="bfsale-popup-pay-content-subheader">Уверенность, энергия, внутренняя опора</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764163606068-EV9XY-Unio.svg"
                            class="hidden-tablet-mobile position-absolute z-10" alt="img">
                    </div>
                    <div class="bfsale-popup-pay-content-right">
                        <div class="careerum-registration-form-club40 position-relative z-20">
                            <form class="deva-form addCountry" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-telegram">
                                    <input type="text" value="" name="telegram" required placeholder="Telegram">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я даю согласие
                                        на обработку персональных данных
                                        в соответствии с <a href="/ru-ru/legal/privacy">Политикой
                                            конфиденциальности</a>
                                    </p>
                                </div>
                                <div class="careerum-club40-form-amount">
                                    <div class="careerum-flex-fsc">
                                        <p class="bfsale-popup-buy-price">5 900 ₽</p>
                                        <p class="bfsale-popup-buy-old-price">14 900 ₽</p>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764091561414-8zXKv-Fram.png"
                                            alt="img">
                                    </div>
                                </div>
                                <a href="#" class="submit-btn btn-color-red button-sent" disabled>Выбрать способ оплаты</a>
                            </form>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-advent2-main', {
        label: 'Advent2 main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-advent2-main main-wrapper position-relative">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764660013163-ss71m-Grou.png"
                    class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764749445708-Jhvti-Grou.png"
                    class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764831367476-5gHRc-Grou.png"
                    class="hidden-desc-tablet position-absolute z-1" alt="img" loading="lazy">
                <div class="careerum-container-responsive position-relative z-10">
                    <div class="advent2-main-logo">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764661495014-svyAb-logo.svg"
                            class="hidden-tablet-mobile" alt="img" loading="lazy">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764661513873-hjrgL-logo.svg"
                            class="hidden-desc" alt="img" loading="lazy">
                    </div>
                    <div class="advent2-main-labels careerum-flex-fsfs">
                        <div class="advent2-main-label careerum-flex-cc">
                            <p>Адвент</p>
                        </div>
                        <div class="advent2-main-label careerum-flex-cc">
                            <p>8-31 декабря</p>
                        </div>
                        <div class="advent2-main-label careerum-flex-cc hidden-mobile">
                            <p>Адвент доступен только участникам<br>
                                листа ожидания клуба Careerum</p>
                        </div>
                    </div>
                    <div class="advent2-main-wrapper position-relative">
                        <h1>Сказки</h1>
                        <p class="advent2-main-header">О (не)волшебных навыках</p>
                        <p class="advent2-main-text">18 писем со сказками — разбираем один карьерный навык в каждой. Покажем
                            силу навыков и как они меняют в вашу карьеру. Каждая сказка — инсайт, который можно сразу
                            применять</p>
                        <p class="advent2-main-subheader">Станьте той, кто управляет своей карьерой</p>
                        <div class="advent2-main-text-block hidden-desc-tablet position-relative z-1">
                            <p>Адвент доступен только участникам
                                листа ожидания клуба Careerum</p>
                        </div>
                        <a href="#form" class="btn-color-dark-green position-relative z-10">Лист ожидания Careerum</a>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-advent2-slider', {
        label: 'Advent2 slider (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-advent2-slider gradient main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Сказки о внутренней устойчивости</h2>
                    <div class="advent2-slider noselect">
                        <div class="advent2-slider-item carerum-flex-fsfs">
                            <div class="advent2-slider-item-front position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764668497573-R6lAP-Grou.png" class="hidden-tablet-mobile position-absolute z-1"
                                    alt="img" loading="lazy">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764748512108-3LZP0-Grou.png" class="hidden-desc position-absolute z-1"
                                    alt="img" loading="lazy">
                                <div class="advent2-slider-item-header careerum-flex-fsfe fs27 position-relative z-10">
                                    <p>1</p>
                                    <p>сказка</p>
                                    <p>Пеппи Длинный чулок</p>
                                </div>
                                <p class="advent2-slider-item-subheader position-relative z-10">Которая была сильнее лошади
                                    и слабее собственных сомнений
                                </p>
                                <button class="position-relative z-10">Спойлер сказки</button>
                            </div>
                            <div class="advent2-slider-item-back position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764745134933-1MEKP-Fram.png"
                                    alt="img" loading="lazy" class="position-absolute z-1">
                                <div class="advent2-slider-item-header careerum-flex-fsfe fs27">
                                    <p>1</p>
                                    <p>сказка</p>
                                    <p>Пеппи Длинный чулок</p>
                                </div>
                                <p class="advent2-slider-item-label position-relative z-10">Внутренняя опора</p>
                                <p class="advent2-slider-item-subheader2 position-relative z-10">Хозяйка виллы «Курица»</p>
                                <p class="advent2-slider-item-text position-relative z-10">Внешне дерзкая, но нет стабильного
                                    ощущения своей
                                    ценности, компенсирует напором, бунтарством и токсичностью</p>
                                <button class="position-relative z-10">Вернуться</button>
                            </div>
                        </div>
                        <div class="advent2-slider-item carerum-flex-fsfs">
                            <div class="advent2-slider-item-front position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764827907228-FYUbh-Grou.png" class="hidden-tablet-mobile position-absolute z-1"
                                    alt="img" loading="lazy">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764827906724-7syFp-Grou.png" class="hidden-desc position-absolute z-1"
                                    alt="img" loading="lazy">
                                <div class="advent2-slider-item-header careerum-flex-fsfe position-relative z-10">
                                    <p>2</p>
                                    <p>сказка</p>
                                    <p>Золушка</p>
                                </div>
                                <p class="advent2-slider-item-subheader position-relative z-10">Золушка, которая не верила,
                                    что достойна выйти из подвала</p>
                                <button class="position-relative z-10">Спойлер сказки</button>
                            </div>
                            <div class="advent2-slider-item-back position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764744964549-GCwck-Grou.png"
                                    alt="img" loading="lazy" class="position-absolute z-1">
                                <div class="advent2-slider-item-header careerum-flex-fsfe">
                                    <p>2</p>
                                    <p>сказка</p>
                                    <p>Золушка</p>
                                </div>
                                <p class="advent2-slider-item-label position-relative z-10">Уверенность</p>
                                <p class="advent2-slider-item-subheader2 position-relative z-10">Домработница </p>
                                <p class="advent2-slider-item-text position-relative z-10">Заниженная самооценка, полная
                                    зависимость от оценки семьи, не верит в ценность своего труда</p>
                                <button class="position-relative z-10">Вернуться</button>
                            </div>
                        </div>
                        <div class="advent2-slider-item carerum-flex-fsfs">
                            <div class="advent2-slider-item-front position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764746340206-eSgbN-Grou.png" class="hidden-tablet-mobile position-absolute z-1"
                                    alt="img" loading="lazy">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764748513018-CX16H-Grou.png" class="hidden-desc position-absolute z-1"
                                    alt="img" loading="lazy">
                                <div class="advent2-slider-item-header careerum-flex-fsfe position-relative z-10">
                                    <p>3</p>
                                    <p>сказка</p>
                                    <p>Мальвина</p>
                                </div>
                                <p class="advent2-slider-item-subheader position-relative z-10">И семь истерик: хроники менторки
                                    без тормозов
                                </p>
                                <button class="position-relative z-10">Спойлер сказки</button>
                            </div>
                            <div class="advent2-slider-item-back position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764745134933-1MEKP-Fram.png"
                                    alt="img" loading="lazy" class="position-absolute z-1">
                                <div class="advent2-slider-item-header careerum-flex-fsfe">
                                    <p>3</p>
                                    <p>сказка</p>
                                    <p>Мальвина</p>
                                </div>
                                <p class="advent2-slider-item-label position-relative z-10">Эмоциональная устойчивость</p>
                                <p class="advent2-slider-item-subheader2 position-relative z-10">Работает менторкой у Буратино
                                    и Пьеро</p>
                                <p class="advent2-slider-item-text position-relative z-10">Проседает навык эмоциональной
                                    устойчивости. При любой критике взрывается, обижается, драматизирует. Эмоции управляют ею, а
                                    не наоборот</p>
                                <button class="position-relative z-10">Вернуться</button>
                            </div>
                        </div>
                        <div class="advent2-slider-item carerum-flex-fsfs">
                            <div class="advent2-slider-item-front position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764746340453-y73NQ-Grou.png" class="hidden-tablet-mobile position-absolute z-1"
                                    alt="img" loading="lazy">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764748514340-mEeVq-Grou.png" class="hidden-desc position-absolute z-1"
                                    alt="img" loading="lazy">
                                <div class="advent2-slider-item-header careerum-flex-fsfe fs36 position-relative z-10">
                                    <p>4</p>
                                    <p>сказка</p>
                                    <p>Мэри Поппинс</p>
                                </div>
                                <p class="advent2-slider-item-subheader position-relative z-10">Гувернантка без выходных:
                                    инструкция по тихому выгоранию</p>
                                <button class="position-relative z-10">Спойлер сказки</button>
                            </div>
                            <div class="advent2-slider-item-back position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764744964549-GCwck-Grou.png"
                                    alt="img" loading="lazy" class="position-absolute z-1">
                                <div class="advent2-slider-item-header careerum-flex-fsfe fs36">
                                    <p>4</p>
                                    <p>сказка</p>
                                    <p>Мэри Поппинс</p>
                                </div>
                                <p class="advent2-slider-item-label position-relative z-10">Управление энергией </p>
                                <p class="advent2-slider-item-subheader2 position-relative z-10">Гувернантка</p>
                                <p class="advent2-slider-item-text position-relative z-10">Всегда «в образе», никогда
                                    не отдыхает, живёт на сверхресурсах</p>
                                <button class="position-relative z-10">Вернуться</button>
                            </div>
                        </div>
                        <div class="advent2-slider-item carerum-flex-fsfs">
                            <div class="advent2-slider-item-front position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764828088293-Hz6Ws-Grou.png" class="hidden-tablet-mobile position-absolute z-1"
                                    alt="img" loading="lazy">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764828090167-KfhBZ-Grou.png" class="hidden-desc position-absolute z-1"
                                    alt="img" loading="lazy">
                                <div class="advent2-slider-item-header careerum-flex-fsfe position-relative z-10">
                                    <p>5</p>
                                    <p>сказка</p>
                                    <p>Мулан</p>
                                </div>
                                <p class="advent2-slider-item-subheader position-relative z-10">Как Мулан меняла роли,
                                    но так и не выбирала свою</p>
                                <button class="position-relative z-10">Спойлер сказки</button>
                            </div>
                            <div class="advent2-slider-item-back position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764745134933-1MEKP-Fram.png"
                                    alt="img" loading="lazy" class="position-absolute z-1">
                                <div class="advent2-slider-item-header careerum-flex-fsfe">
                                    <p>5</p>
                                    <p>сказка</p>
                                    <p>Мулан</p>
                                </div>
                                <p class="advent2-slider-item-label position-relative z-10">Самоопределение</p>
                                <p class="advent2-slider-item-subheader2 position-relative z-10">Солдатка поневоле,
                                    дочь-заменитель, герой «по обязанности»</p>
                                <p class="advent2-slider-item-text position-relative z-10">Всё время подменяет свои желания
                                    чужими ожиданиями: семьи, армии, традиций. Живёт в постоянном режиме «надо», а не «хочу»</p>
                                <button class="position-relative z-10">Вернуться</button>
                            </div>
                        </div>
                        <div class="advent2-slider-item carerum-flex-fsfs">
                            <div class="advent2-slider-item-front position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764746341186-yINOK-Grou.png" class="hidden-tablet-mobile position-absolute z-1"
                                    alt="img" loading="lazy">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764748515751-X6b5I-Grou.png" class="hidden-desc position-absolute z-1"
                                    alt="img" loading="lazy">
                                <div class="advent2-slider-item-header careerum-flex-fsfe position-relative z-10">
                                    <p>6</p>
                                    <p>сказка</p>
                                    <p>Гретель</p>
                                </div>
                                <p class="advent2-slider-item-subheader position-relative z-10">Гретель, которая снова пошла
                                    в лес без плана</p>
                                <button class="position-relative z-10">Спойлер сказки</button>
                            </div>
                            <div class="advent2-slider-item-back position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764744964549-GCwck-Grou.png"
                                    alt="img" loading="lazy" class="position-absolute z-1">
                                <div class="advent2-slider-item-header careerum-flex-fsfe">
                                    <p>6</p>
                                    <p>сказка</p>
                                    <p>Гретель</p>
                                </div>
                                <p class="advent2-slider-item-label position-relative z-10">Карьерное планирование</p>
                                <p class="advent2-slider-item-subheader2 position-relative z-10">Работает старшей сестрой,
                                    отвечает за выживание</p>
                                <p class="advent2-slider-item-text position-relative z-10">Проседает: всё — реактивно; делает
                                    только то, что происходит прямо сейчас</p>
                                <button class="position-relative z-10">Вернуться</button>
                            </div>
                        </div>
                        <div class="advent2-slider-item carerum-flex-fsfs">
                            <div class="advent2-slider-item-front position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764746341717-rd7SR-Grou.png" class="hidden-tablet-mobile position-absolute z-1"
                                    alt="img" loading="lazy">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764748516349-mM82M-Grou.png" class="hidden-desc position-absolute z-1"
                                    alt="img" loading="lazy">
                                <div class="advent2-slider-item-header careerum-flex-fsfe position-relative z-10">
                                    <p>7</p>
                                    <p>сказка</p>
                                    <p>Шапокляк</p>
                                </div>
                                <p class="advent2-slider-item-subheader position-relative z-10">История фрилансерки, для которой
                                    «не хочу» стало профессией</p>
                                <button class="position-relative z-10">Спойлер сказки</button>
                            </div>
                            <div class="advent2-slider-item-back position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764745134933-1MEKP-Fram.png"
                                    alt="img" loading="lazy" class="position-absolute z-1">
                                <div class="advent2-slider-item-header careerum-flex-fsfe">
                                    <p>7</p>
                                    <p>сказка</p>
                                    <p>Шапокляк</p>
                                </div>
                                <p class="advent2-slider-item-label position-relative z-10">Управление мотивацией</p>
                                <p class="advent2-slider-item-subheader2 position-relative z-10">Фрилансерка-вредительница</p>
                                <p class="advent2-slider-item-text position-relative z-10">Делает только то, что “прикололо”,
                                    мотивации нет, цели нет. Энергия уходит в хаос и мелкие диверсии. Делает всё “против”, но не
                                    понимает — ради чего</p>
                                <button class="position-relative z-10">Вернуться</button>
                            </div>
                        </div>
                        <div class="advent2-slider-item carerum-flex-fsfs">
                            <div class="advent2-slider-item-front position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764748516771-dV3cb-Grou.png" class="hidden-tablet-mobile position-absolute z-1"
                                    alt="img" loading="lazy">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764746339656-20wyT-Fram.png" class="hidden-desc position-absolute z-1"
                                    alt="img" loading="lazy">
                                <div class="advent2-slider-item-header careerum-flex-fsfe position-relative z-10">
                                    <p>8</p>
                                    <p>сказка</p>
                                    <p>Герда</p>
                                </div>
                                <p class="advent2-slider-item-subheader position-relative z-10">Как смелая девочка терялась
                                    каждый раз, когда нужно было действовать</p>
                                <button class="position-relative z-10">Спойлер сказки</button>
                            </div>
                            <div class="advent2-slider-item-back position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764744964549-GCwck-Grou.png"
                                    alt="img" loading="lazy" class="position-absolute z-1">
                                <div class="advent2-slider-item-header careerum-flex-fsfe">
                                    <p>8</p>
                                    <p>сказка</p>
                                    <p>Герда</p>
                                </div>
                                <p class="advent2-slider-item-label position-relative z-10">Адаптивность к кризисам</p>
                                <p class="advent2-slider-item-subheader2 position-relative z-10">Спасательница в суровых
                                    условиях Севера</p>
                                <p class="advent2-slider-item-text position-relative z-10">В моменты кризиса зависает,
                                    застывает, теряет способность действовать</p>
                                <button class="position-relative z-10">Вернуться</button>
                            </div>
                        </div>
                        <div class="advent2-slider-item carerum-flex-fsfs">
                            <div class="advent2-slider-item-front position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764828210215-5IGk5-Grou.png" class="hidden-tablet-mobile position-absolute z-1"
                                    alt="img" loading="lazy">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764828213621-OrR1i-Grou.png" class="hidden-desc position-absolute z-1"
                                    alt="img" loading="lazy">
                                <div class="advent2-slider-item-header careerum-flex-fsfe fs36 position-relative z-10">
                                    <p>9</p>
                                    <p>сказка</p>
                                    <p>Баба Яга</p>
                                </div>
                                <p class="advent2-slider-item-subheader position-relative z-10">300 лет в избушке: инструкция по
                                    карьерному застою от Бабы Яги</p>
                                <button class="position-relative z-10">Спойлер сказки</button>
                            </div>
                            <div class="advent2-slider-item-back position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764745134933-1MEKP-Fram.png"
                                    alt="img" loading="lazy" class="position-absolute z-1">
                                <div class="advent2-slider-item-header careerum-flex-fsfe fs36">
                                    <p>9</p>
                                    <p>сказка</p>
                                    <p>Баба Яга</p>
                                </div>
                                <p class="advent2-slider-item-label position-relative z-10">Портфельная карьера</p>
                                <p class="advent2-slider-item-subheader2 position-relative z-10">Потомственная ведьма, лекарка,
                                    охранницы границ миров</p>
                                <p class="advent2-slider-item-text position-relative z-10">Занимается всем понемногу,
                                    но не соединяет роли. Навык есть, системности нет. Сидит в одной избушке 300 лет — классика
                                    застоя</p>
                                <button class="position-relative z-10">Вернуться</button>
                            </div>
                        </div>
                        <div class="advent2-slider-item carerum-flex-fsfs">
                            <div class="advent2-slider-item-front position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764746344657-WiwoV-Grou.png" class="hidden-tablet-mobile position-absolute z-1"
                                    alt="img" loading="lazy">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764748518228-oslzZ-Grou.png" class="hidden-desc position-absolute z-1"
                                    alt="img" loading="lazy">
                                <div class="advent2-slider-item-header careerum-flex-fsfe fs36 position-relative z-10">
                                    <p>10</p>
                                    <p>сказка</p>
                                    <p>Фрекен Бок</p>
                                </div>
                                <p class="advent2-slider-item-subheader position-relative z-10">И искусство говорить так, чтобы
                                    все сопротивлялись</p>
                                <button class="position-relative z-10">Спойлер сказки</button>
                            </div>
                            <div class="advent2-slider-item-back position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764744964549-GCwck-Grou.png"
                                    alt="img" loading="lazy" class="position-absolute z-1">
                                <div class="advent2-slider-item-header careerum-flex-fsfe fs36">
                                    <p>10</p>
                                    <p>сказка</p>
                                    <p>Фрекен Бок</p>
                                </div>
                                <p class="advent2-slider-item-label position-relative z-10">Профессиональная коммуникация и
                                    влияние </p>
                                <p class="advent2-slider-item-subheader2 position-relative z-10">Гувернантка </p>
                                <p class="advent2-slider-item-text position-relative z-10">Говорит сверху-вниз, требует, давит,
                                    не умеет адаптировать стиль общения — полная противоположность Influence Power</p>
                                <button class="position-relative z-10">Вернуться</button>
                            </div>
                        </div>
                        <div class="advent2-slider-item carerum-flex-fsfs">
                            <div class="advent2-slider-item-front position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764828579117-CBWWI-Grou.png" class="hidden-tablet-mobile position-absolute z-1"
                                    alt="img" loading="lazy">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764828575916-IkheM-Grou.png" class="hidden-desc position-absolute z-1"
                                    alt="img" loading="lazy">
                                <div class="advent2-slider-item-header careerum-flex-fsfe fs28 position-relative z-10">
                                    <p>11</p>
                                    <p>сказка</p>
                                    <p>Малифисента</p>
                                </div>
                                <p class="advent2-slider-item-subheader position-relative z-10">Как Малефисента защищала свои
                                    границы так яростно, что перестала видеть тех, кто пришёл с добром</p>
                                <button class="position-relative z-10">Спойлер сказки</button>
                            </div>
                            <div class="advent2-slider-item-back position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764745134933-1MEKP-Fram.png"
                                    alt="img" loading="lazy" class="position-absolute z-1">
                                <div class="advent2-slider-item-header careerum-flex-fsfe fs28">
                                    <p>11</p>
                                    <p>сказка</p>
                                    <p>Малифисента</p>
                                </div>
                                <p class="advent2-slider-item-label position-relative z-10">Отношения</p>
                                <p class="advent2-slider-item-subheader2 position-relative z-10">Руководительница экосистемы
                                    лесного королевства</p>
                                <p class="advent2-slider-item-text position-relative z-10">Мастерски держит дистанцию: мгновенно
                                    отсекает угрозы, читает намерения и умеет ставить мощные границы — но ровно так же она
                                    отсеивает и тех, кто мог бы стать союзником</p>
                                <button class="position-relative z-10">Вернуться</button>
                            </div>
                        </div>
                        <div class="advent2-slider-item carerum-flex-fsfs">
                            <div class="advent2-slider-item-front position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764828603662-y8Lpx-Grou.png" class="hidden-tablet-mobile position-absolute z-1"
                                    alt="img" loading="lazy">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764748520473-tC4vi-Grou.png" class="hidden-desc position-absolute z-1"
                                    alt="img" loading="lazy">
                                <div class="advent2-slider-item-header careerum-flex-fsfe fs28 position-relative z-10">
                                    <p>12</p>
                                    <p>сказка</p>
                                    <p>Королева Червей</p>
                                </div>
                                <p class="advent2-slider-item-subheader position-relative z-10">Инструкция по разрушению команды
                                    за 3 крика</p>
                                <button class="position-relative z-10">Спойлер сказки</button>
                            </div>
                            <div class="advent2-slider-item-back position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764744964549-GCwck-Grou.png"
                                    alt="img" loading="lazy" class="position-absolute z-1">
                                <div class="advent2-slider-item-header careerum-flex-fsfe fs28">
                                    <p>12</p>
                                    <p>сказка</p>
                                    <p>Королева Червей</p>
                                </div>
                                <p class="advent2-slider-item-label position-relative z-10">Лидерство</p>
                                <p class="advent2-slider-item-subheader2 position-relative z-10">СЕО королевства</p>
                                <p class="advent2-slider-item-text position-relative z-10">Орёт, наказывает, ломает команду —
                                    абсолютный антипод зрелого лидерства</p>
                                <button class="position-relative z-10">Вернуться</button>
                            </div>
                        </div>
                        <div class="advent2-slider-item carerum-flex-fsfs">
                            <div class="advent2-slider-item-front position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764746348963-8kBYL-Grou.png" class="hidden-tablet-mobile position-absolute z-1"
                                    alt="img" loading="lazy">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764748521007-zONWI-Grou.png" class="hidden-desc position-absolute z-1"
                                    alt="img" loading="lazy">
                                <div class="advent2-slider-item-header careerum-flex-fsfe fs28 position-relative z-10">
                                    <p>13</p>
                                    <p>сказка</p>
                                    <p>Фея Крестная</p>
                                </div>
                                <p class="advent2-slider-item-subheader position-relative z-10">История коуча, у которой не было
                                    ни одного повторного клиента</p>
                                <button class="position-relative z-10">Спойлер сказки</button>
                            </div>
                            <div class="advent2-slider-item-back position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764745134933-1MEKP-Fram.png"
                                    alt="img" loading="lazy" class="position-absolute z-1">
                                <div class="advent2-slider-item-header careerum-flex-fsfe fs28">
                                    <p>13</p>
                                    <p>сказка</p>
                                    <p>Фея Крестная</p>
                                </div>
                                <p class="advent2-slider-item-label position-relative z-10">Нетворкинг</p>
                                <p class="advent2-slider-item-subheader2 position-relative z-10">Коуч по жизненным
                                    кризисам/стилистка/маг/астролог/таролог</p>
                                <p class="advent2-slider-item-text position-relative z-10">Появляется и исчезает, контакты
                                    не поддерживает, сеть не развивает — никакой системной работы с людьми. Нетворкинг =
                                    точечные акции, а не отношения</p>
                                <button class="position-relative z-10">Вернуться</button>
                            </div>
                        </div>
                        <div class="advent2-slider-item carerum-flex-fsfs">
                            <div class="advent2-slider-item-front position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764828817416-0BdfI-Grou.png" class="hidden-tablet-mobile position-absolute z-1"
                                    alt="img" loading="lazy">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764828579117-CBWWI-Grou.png" class="hidden-desc position-absolute z-1"
                                    alt="img" loading="lazy">
                                <div class="advent2-slider-item-header careerum-flex-fsfe fs44 position-relative z-10">
                                    <p>14</p>
                                    <p>сказка</p>
                                    <p>Забава</p>
                                </div>
                                <p class="advent2-slider-item-subheader position-relative z-10">История девушки, которая хотела
                                    всё и сразу — и поэтому не начинала ничего</p>
                                <button class="position-relative z-10">Спойлер сказки</button>
                            </div>
                            <div class="advent2-slider-item-back position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764744964549-GCwck-Grou.png"
                                    alt="img" loading="lazy" class="position-absolute z-1">
                                <div class="advent2-slider-item-header careerum-flex-fsfe fs44">
                                    <p>14</p>
                                    <p>сказка</p>
                                    <p>Забава</p>
                                </div>
                                <p class="advent2-slider-item-label position-relative z-10">Умение ставить карьерные цели</p>
                                <p class="advent2-slider-item-subheader2 position-relative z-10">Нэпо-бейби с бесконечным
                                    доступом к возможностям королевства</p>
                                <p class="advent2-slider-item-text position-relative z-10">Человек, который может стать кем
                                    угодно, но не знает, чего хочет</p>
                                <button class="position-relative z-10">Вернуться</button>
                            </div>
                        </div>
                        <div class="advent2-slider-item carerum-flex-fsfs">
                            <div class="advent2-slider-item-front position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764746351240-CpK2b-Grou.png" class="hidden-tablet-mobile position-absolute z-1"
                                    alt="img" loading="lazy">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764748523359-vY7Ym-Grou.png" class="hidden-desc position-absolute z-1"
                                    alt="img" loading="lazy">
                                <div class="advent2-slider-item-header careerum-flex-fsfe position-relative z-10">
                                    <p>15</p>
                                    <p>сказка</p>
                                    <p>Маша</p>
                                </div>
                                <p class="advent2-slider-item-subheader position-relative z-10">И тысяча незаконченных дел</p>
                                <button class="position-relative z-10">Спойлер сказки</button>
                            </div>
                            <div class="advent2-slider-item-back position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764745134933-1MEKP-Fram.png"
                                    alt="img" loading="lazy" class="position-absolute z-1">
                                <div class="advent2-slider-item-header careerum-flex-fsfe">
                                    <p>15</p>
                                    <p>сказка</p>
                                    <p>Маша</p>
                                </div>
                                <p class="advent2-slider-item-label position-relative z-10">Умение достигать результатов</p>
                                <p class="advent2-slider-item-subheader2 position-relative z-10">Постоянно начинает много дел —
                                    ничего не заканчивает</p>
                                <p class="advent2-slider-item-text position-relative z-10"></p>
                                <button class="position-relative z-10">Вернуться</button>
                            </div>
                        </div>
                        <div class="advent2-slider-item carerum-flex-fsfs">
                            <div class="advent2-slider-item-front position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764746352878-XE4qH-Grou.png" class="hidden-tablet-mobile position-absolute z-1"
                                    alt="img" loading="lazy">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764748524583-RO0yd-Grou.png" class="hidden-desc position-absolute z-1"
                                    alt="img" loading="lazy">
                                <div class="advent2-slider-item-header careerum-flex-fsfe position-relative z-10">
                                    <p>16</p>
                                    <p>сказка</p>
                                    <p>Белль</p>
                                </div>
                                <p class="advent2-slider-item-subheader position-relative z-10">Которая «тащила на себе» весь
                                    замок и считала это ничего особенного</p>
                                <button class="position-relative z-10">Спойлер сказки</button>
                            </div>
                            <div class="advent2-slider-item-back position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764744964549-GCwck-Grou.png"
                                    alt="img" loading="lazy" class="position-absolute z-1">
                                <div class="advent2-slider-item-header careerum-flex-fsfe">
                                    <p>16</p>
                                    <p>сказка</p>
                                    <p>Белль</p>
                                </div>
                                <p class="advent2-slider-item-label position-relative z-10">Умение искать и презентовать
                                    достижения</p>
                                <p class="advent2-slider-item-subheader2 position-relative z-10">Все на ней держится — но она не
                                    считает это достижениями</p>
                                <p class="advent2-slider-item-text position-relative z-10"></p>
                                <button class="position-relative z-10">Вернуться</button>
                            </div>
                        </div>
                        <div class="advent2-slider-item carerum-flex-fsfs">
                            <div class="advent2-slider-item-front position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764829008815-EMusI-Grou.png" class="hidden-tablet-mobile position-absolute z-1"
                                    alt="img" loading="lazy">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764829011853-woXoi-Grou.png" class="hidden-desc position-absolute z-1"
                                    alt="img" loading="lazy">
                                <div class="advent2-slider-item-header careerum-flex-fsfe fs44 position-relative z-10">
                                    <p>17</p>
                                    <p>сказка</p>
                                    <p>Снегурочка</p>
                                </div>
                                <p class="advent2-slider-item-subheader position-relative z-10">Как сменить работу, если
                                    ты вечная фриланс-сотрудница</p>
                                <button class="position-relative z-10">Спойлер сказки</button>
                            </div>
                            <div class="advent2-slider-item-back position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764745134933-1MEKP-Fram.png"
                                    alt="img" loading="lazy" class="position-absolute z-1">
                                <div class="advent2-slider-item-header careerum-flex-fsfe fs44">
                                    <p>17</p>
                                    <p>сказка</p>
                                    <p>Снегурочка</p>
                                </div>
                                <p class="advent2-slider-item-label position-relative z-10">Навык смена работы</p>
                                <p class="advent2-slider-item-subheader2 position-relative z-10">Ивент-менеджерка</p>
                                <p class="advent2-slider-item-text position-relative z-10">Сезонно на проектах, не понимает,
                                    куда двигаться дальше</p>
                                <button class="position-relative z-10">Вернуться</button>
                            </div>
                        </div>
                        <div class="advent2-slider-item carerum-flex-fsfs">
                            <div class="advent2-slider-item-front position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764746354573-izmm9-Grou.png" class="hidden-tablet-mobile position-absolute z-1"
                                    alt="img" loading="lazy">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764748526046-Knh07-Grou.png" class="hidden-desc position-absolute z-1"
                                    alt="img" loading="lazy">
                                <div class="advent2-slider-item-header careerum-flex-fsfe fs36 position-relative z-10">
                                    <p>18</p>
                                    <p>сказка</p>
                                    <p>Лиса Алиса</p>
                                </div>
                                <p class="advent2-slider-item-subheader position-relative z-10">Когда харизма работает против
                                    тебя: кейс Лисы Алисы</p>
                                <button class="position-relative z-10">Спойлер сказки</button>
                            </div>
                            <div class="advent2-slider-item-back position-absolute careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764744964549-GCwck-Grou.png"
                                    alt="img" loading="lazy" class="position-absolute z-1">
                                <div class="advent2-slider-item-header careerum-flex-fsfe fs36">
                                    <p>18</p>
                                    <p>сказка</p>
                                    <p>Лиса Алиса</p>
                                </div>
                                <p class="advent2-slider-item-label position-relative z-10">Умение продавать себя</p>
                                <p class="advent2-slider-item-subheader2 position-relative z-10">Профессиональная
                                    переговорщица-аферистка</p>
                                <p class="advent2-slider-item-text position-relative z-10">Продаёт себя слишком уверенно —
                                    манипулятивный антипод здоровой самопрезентации</p>
                                <button class="position-relative z-10">Вернуться</button>
                            </div>
                        </div>
                    </div>
                    <div class="advent2-slider-nav careerum-flex-fec noselect">
                        <div class="advent2-slider-nav-prev careerum-flex-cc">
                            <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.32129 7.32104L15.3213 7.32104" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M7.32129 13.321L1.32129 7.32104L7.32129 1.32104" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="advent2-slider-nav-next careerum-flex-cc">
                            <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.3213 7.32105L1.32129 7.32104" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.32129 1.32104L15.3213 7.32105L9.32129 13.321" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>
                    <a href="#form" class="btn-color-dark-green">Лист ожидания Careerum</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-advent2-bonuses', {
        label: 'Advent2 bonuses (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-advent2-bonuses main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764669364663-KNDC6-Grou.png"
                        class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764669366129-mqF9X-Grou.png"
                        class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764669368022-5DJqY-Grou.png"
                        class="hidden-desc-tablet position-absolute z-1" alt="img" loading="lazy">
                    <div class="advent2-bonuses-wrapper position-relative z-10">
                        <h2>Сказочные бонусы</h2>
                        <p class="advent2-bonuses-subheader">На подписку в Careerum</p>
                        <p class="advent2-bonuses-text">Всех участников адвента ждёт новогоднее чудо от Careerum. Магия
                            новогодних скидок, которая откроется только тем, кто заглянет внутрь</p>
                        <a href="#form" class="btn-color-dark-green">Лист ожидания Careerum</a>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-advent2-map', {
        label: 'Advent2 map (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-advent2-map main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764670765348-DTtu4-Grou.png"
                        class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764670763020-fp7Z2-Grou.png"
                        class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1764670761233-KjiVw-Grou.png"
                        class="hidden-desc-tablet position-absolute z-1" alt="img" loading="lazy">
                    <div class="advent2-map-wrapper position-relative z-10">
                        <h2>Карта карьерных навыков в подарок</h2>
                        <p class="advent2-map-subheader">Путеводитель по развитию профессиональной устойчивости</p>
                        <p class="advent2-map-text">Помогает быстро понять:</p>
                        <ul>
                            <li class="position-relative">Какие навыки существуют и за что они отвечают</li>
                            <li class="position-relative">Как они связаны между собой</li>
                            <li class="position-relative">На что влияет каждый навык в карьере</li>
                        </ul>
                        <a href="#form" class="btn-color-dark-green">Лист ожидания Careerum</a>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-advent2-support', {
        label: 'Advent2 support (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-advent2-support main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1765347701504-HvIiE-Grou.png"
                        class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1765348203469-7lf9P-Grou.png"
                        class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1765348754263-VFAZG-Grou.png"
                        class="hidden-desc-tablet position-absolute z-1" alt="img" loading="lazy">
                    <div class="advent2-support-wrapper position-relative z-10">
                        <h2>Вы весь год поддерживали других</h2>
                        <p class="advent2-support-text">Разруливали кучу проблем. Стояли грудью за свою команду. Тащили всякое
                            невыносимое</p>
                        <p class="advent2-support-text">И мы решили ПОЗАБОТИТЬСЯ О ВАС</p>
                        <div>
                            <p>Эти 18 писем — наша поддержка, если вам её пока никто не дал</p>
                        </div>
                        <a href="#form" class="btn-color-dark-green">Лист ожидания Careerum</a>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-advent2-form', {
        label: 'Advent2 form (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-advent2-form main-wrapper">
                <div class="careerum-container-responsive careerum-flex-fsfs">
                    <h2>Заполните форму и наша служба заботы свяжется с вами, чтобы подключить адвент</h2>
                    <div class="careerum-registration-form-club40">
                        <form class="deva-form getcourse-email-signup addCountry careerum-flex-sbfs" name="devaRegistrationForm"
                            data-gjs-type="deva-registration-form">
                            <div class="careerum-club40-form-name">
                                <input type="text" name="name" value="" required placeholder="Имя">
                                <p class="careerum-club40-form-warn">Поле не заполнено</p>
                            </div>
                            <div class="careerum-club40-form-telegram">
                                <input type="text" value="" name="telegram" required placeholder="Telegram">
                                <p class="careerum-club40-form-warn">Поле не заполнено</p>
                            </div>
                            <div class="careerum-club40-form-email">
                                <input type="text" name="email" value="" required placeholder="Почта">
                                <p class="careerum-club40-form-warn">Поле не заполнено</p>
                            </div>
                            <div class="careerum-club40-form-phone">
                                <input type="tel" value="" name="tel" required class="itl-input">
                                <p class="careerum-club40-form-warn">Поле не заполнено</p>
                            </div>
                            <div class="careerum-club40-form-latest careerum-flex-fsfs">
                                <div class="careerum-club40-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я даю согласие
                                        на обработку персональных данных
                                        в соответствии с <a href="/ru-ru/legal/privacy">Политикой
                                            конфиденциальности</a>
                                    </p>
                                </div>
                                <a href="#" class="submit-btn btn-color-dark-green button-sent" disabled>Лист ожидания Careerum</a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-advent-popup', {
        label: 'Advent popup thanks (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-popup careerum-advent-popup" id="thanks">
                <div class="popup__close-button-wrapper careerum-flex-cc">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"
                        class="close-switch">
                        <path d="M10.5977 10.5588L1.00566 1.00586" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M0.999561 10.5609L10.6016 1" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="advent-popup-content position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1765278962689-Yelfh-Grou.png" class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1765278960316-FjUEJ-Grou.png" class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1765278955238-B4oeA-Grou.png" class="hidden-desc-tablet position-absolute z-1" alt="img" loading="lazy">
                    <h2 class="position-relative z-10">Спасибо!</h2>
                    <p class="position-relative z-10">Отправили адвент вам на почту</p>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-case4-main', {
        label: 'Case 4 (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-case4-main main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="case4-main-header">
                        <div class="case4-main-info position-relative carerum-flex-fsfs">
                            <p class="case4-main-info__date">сентябрь, 2025</p>
                            <h1 class="position-relative z-10">Как выйти на международный рынок спустя 10 лет перерыва в карьере
                            </h1>
                            <div class="case4-main-info__photo position-relative z-10 careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1768205794646-q1j7j-Mask.png" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1768206332390-BxJMf-Mask.png" class="hidden-desc" alt="img"
                                    loading="lazy">
                                <div class="case4-main-info__photo__about">
                                    <div class="case4-main-info__name">
                                        <p>Анна Штендер</p>
                                    </div>
                                    <div class="careerum-flex-fsc case4-main-info__position">
                                        <img src="https://cdn.careerum.com/1768202278947-jVbzM-Bag..svg"
                                            class="hidden-tablet-mobile" alt="img" loading="eager">
                                        <p class="hidden-tablet-mobile">Bid and Proposal Manager</p>
                                        <p class="hidden-desc">Bid and Proposal Manager, Германия</p>
                                    </div>
                                    <div class="careerum-flex-fsc case4-main-info__country">
                                        <img src="https://cdn.careerum.com/1768202278892-k04YC-MapP.svg"
                                            class="hidden-tablet-mobile" alt="img" loading="eager">
                                        <p>Германия</p>
                                    </div>
                                </div>
                                <a href="#" class="position-absolute z-10">
                                    <img src="https://cdn.careerum.com/1768202278892-k04YC-MapP.svg"
                                            class="hidden-tablet-mobile" alt="img" loading="eager">
                                    <svg width="66" height="66" viewBox="0 0 66 66" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <rect width="66" height="66" rx="33" fill="#00BAFF" />
                                        <path
                                            d="M35.5332 27.6051C36.6761 26.1339 38.0986 25.2098 39.9102 25.0275C43.6186 24.6627 46.5002 26.3102 47.4668 30.1827C47.6978 31.1007 47.8072 32.0734 47.8194 33.0217C47.862 36.2802 47.8255 39.5387 47.8498 42.8033C47.8559 43.3626 47.6857 43.5267 47.1324 43.5146C45.5822 43.4781 44.0259 43.5024 42.4757 43.5024C41.6793 43.5024 41.6732 43.5024 41.6732 42.7243C41.6732 39.7697 41.6793 36.8213 41.6672 33.8667C41.6672 33.35 41.6368 32.8333 41.5395 32.3287C41.3267 31.1554 40.7674 30.2252 39.5212 29.9395C38.1594 29.6356 37.0287 30.055 36.1897 31.1858C35.6851 31.8606 35.5392 32.6448 35.5392 33.4655C35.5332 36.5538 35.5392 39.6421 35.5392 42.7243C35.5392 42.9492 35.5392 43.1802 35.5392 43.4416C35.3447 43.4659 35.1988 43.5024 35.0529 43.5024C33.3629 43.5085 31.6789 43.4903 29.9889 43.5146C29.539 43.5206 29.4478 43.3504 29.4539 42.9431C29.466 37.2894 29.466 31.6296 29.4539 25.9758C29.4539 25.5077 29.618 25.374 30.0496 25.3801C31.6789 25.3922 33.3081 25.3983 34.9374 25.3801C35.4237 25.374 35.5757 25.5564 35.5453 26.0184C35.5088 26.5351 35.5332 27.0701 35.5332 27.6051Z"
                                            fill="white" />
                                        <path
                                            d="M26.3106 34.4749C26.3106 37.2349 26.2985 39.9949 26.3228 42.761C26.3289 43.3324 26.1769 43.527 25.5811 43.5087C23.9883 43.4662 22.3956 43.4783 20.8089 43.5026C20.3225 43.5087 20.1341 43.3932 20.1341 42.8704C20.1523 37.2531 20.1523 31.6359 20.1341 26.0125C20.1341 25.4958 20.3286 25.356 20.8089 25.3621C22.4199 25.3803 24.0309 25.3864 25.6419 25.3621C26.189 25.3499 26.3228 25.5687 26.3167 26.0794C26.2985 28.8759 26.3106 31.6784 26.3106 34.4749Z"
                                            fill="white" />
                                        <path
                                            d="M26.6695 19.9517C26.6695 21.7633 25.2104 23.1068 23.2225 23.119C21.2832 23.1312 19.7999 21.7451 19.7999 19.9213C19.7999 18.0854 21.3015 16.7114 23.2894 16.7297C25.2591 16.7418 26.6695 18.0854 26.6695 19.9517Z"
                                            fill="white" />
                                    </svg>
                                </a>
                            </div>
                            <img src="https://cdn.careerum.com/1768205695114-xRXGN-ÑÐ¾.svg"
                                class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1765952573787-ttSfB-ÑÐ¾.svg"
                                class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1765869491256-XWBx1-ÑÐ¾.svg"
                                class="hidden-desc-tablet position-absolute z-1" alt="img" loading="lazy">
                            <div class="case4-main-info__line hidden-tablet-mobile"></div>
                        </div>
                        <div class="case4-main-results careerum-flex-fsfs">
                            <div class="case4-main-results__item mh">
                                <div class="case4-main-results__item__label careerum-flex-fsc">
                                    <img src="https://cdn.careerum.com/1765870271041-hnZ9D-Ligh.svg" alt="img" loading="eager">
                                    <p>До</p>
                                </div>
                                <ul>
                                    <li>10 лет перерыва в карьере</li>
                                    <li>Потеря профессиональной уверенности</li>
                                    <li>Не знала, с чего начать поиск работы</li>
                                    <li>Не понимала, как адаптировать опыт под рынок Германии</li>
                                </ul>
                            </div>
                            <div class="case4-main-results__item">
                                <div class="case4-main-results__item__label blue careerum-flex-fsc">
                                    <img src="https://cdn.careerum.com/1765870270758-xE9rG-Star.svg" alt="img" loading="eager">
                                    <p>Результат с Careerum</p>
                                </div>
                                <ul>
                                    <li>Вернула уверенность и опору</li>
                                    <li>Поняла, как позиционировать себя на рынке</li>
                                    <li>Освоила стратегию поиска и коммуникации</li>
                                    <li>Получила работу в международной компании</li>
                                    <li>Увидела реальные перспективы для роста</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="case4-main-content">
                        <h2>Я хочу вернуться на работу, но не понимаю, как?</h2>
                        <div class="case4-main-content__img">
                            <img src="https://cdn.careerum.com/1768202798220-RoArd-Fram.png" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1768206392617-oQ9J3-Fram.png" class="hidden-desc-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1768210137649-D9pqm-Fram.png" class="hidden-desc-tablet"
                                alt="img" loading="lazy">
                        </div>
                        <p class="case4-main-content__text">Меня зовут Анна Штендер, и это моя история, как я вышла
                            на международный рынок спустя 10 лет перерыва в карьере.</p>
                        <p class="case4-main-content__text">Я 10 лет занималась финансовым учётом и контроллингом. До переезда
                            в Германию я руководила финансовым департаментом международной компании в России — строила карьеру,
                            принимала решения, работала, формировала и развивала команду.</p>
                        <p class="case4-main-content__text"><span>После переезда и рождения детей моя жизнь изменилась.</span>
                            Я открыла портретную студию — это было ближе к семье, спокойнее, гибче. Думала, ненадолго,
                            но эта пауза растянулась на десять лет.</p>
                        <div class="case4-main-content__quote">
                            <img src="https://cdn.careerum.com/1765871212658-cZuXd-â .svg" class="" alt="img" loading="lazy">
                            <p>Однажды я проснулась с острым ощущением: мне не хватает работы, стабильности и прежнего уровня
                                дохода</p>
                        </div>
                        <p class="case4-main-content__text">Я хочу вернуться — но не понимаю, как: 10 лет в финансовом учете,
                            руководящая роль, сильное образование — всё это утратило вес. Так в моей жизни появился Careerum.
                        </p>
                        <p class="case4-main-content__text">Мои знания в области российского бухгалтерского и налогового учёта
                            не подходили для новой страны. Я была уверена, что должна что‑то менять, но не знала, с чего начать.
                        </p>
                        <h2 class="mt60">Первые шаги при поддержке Careerum</h2>
                        <p class="case4-main-content__text">Careerum покорил меня с первых дней — <span>разнообразием
                                инструментов, точностью рекомендаций и ощущением, что платформа подстраивается именно
                                под мой запрос.</span> Сначала я сосредоточилась на самостоятельной работе.</p>
                        <p class="case4-main-content__text">Я изучила курсы по созданию резюме, по подготовке к интервью —
                            <span>и впервые за долгое время почувствовала уверенность.</span>
                        </p>
                        <p class="case4-main-content__text">И когда позже я общалась, например, с рекрутерами Adidas произошло
                            удивительное: <span>они задавали ровно те же вопросы, которые мы разбирали на курсе.</span></p>
                        <p class="case4-main-content__text">Я знала, что говорить. Я не терялась. Я была готова.</p>
                        <div class="case4-main-content__quote">
                            <img src="https://cdn.careerum.com/1765871212658-cZuXd-â .svg" class="" alt="img" loading="lazy">
                            <p>Я поняла, что не нужно начинать с нуля. Я смогла увидеть ценность своего опыта и признать свои
                                достижения</p>
                        </div>
                        <p class="case4-main-content__text"><span>Но я хотела не просто освежить знания.</span> Мне нужно было
                            вдохновение — реальные истории людей, которые, как и я, ищут себя в новой стране, строят карьеру
                            с нуля, преодолевают страх и двигаются вперёд. Поэтому особенно ценным для меня оказалось сообщество
                            карьерумцев. Я познакомилась с участницей клуба, которая тоже живёт в Германии и тоже строит карьеру
                            после переезда. Мы встретились лично — и этот разговор стал настоящей опорой.</p>
                        <p class="case4-main-content__text">Мы сравнивали свои истории, делились страхами, анализировали,
                            что применили из рекомендаций Careerum и какие получили результаты. Для меня это была не просто
                            встреча — это было напоминание, что <span>я не одна на этом пути.</span></p>
                        <p class="case4-main-content__text">И я очень благодарна ей за поддержку. А Careerum — за то,
                            что создаёт пространство, где такие встречи становятся возможными.</p>
                        <div class="case4-main-content__block position-relative mt60">
                            <div class="case4-main-content__block__wrapper position-relative z-10">
                                <p class="case4-main-content__block__header">
                                    Получите <span>аудиоразбор</span> вашей карьерной ситуации с экспертом
                                </p>
                                <p class="case4-main-content__block__subheader">Чтобы получить разбор, необходимо заполнить
                                    небольшую анкету</p>
                                <p class="case4-main-content__block__text">Для нас важна ваша мотивация — поэтому мы будем
                                    изучать внимательно опыт и запрос каждого кандидата</p>
                                <p class="case4-main-content__block__label">30 бесплатных мест в месяц</p>
                            </div>
                            <a href="#" class="case4-main-content__button hidden-mobile">Заполнить анкету</a>
                            <img src="https://cdn.careerum.com/1768203711950-7QpRt-Grou.svg"
                                class="hidden-tablet-mobile position-absolute z-1 br" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1768209346797-FSau9-Grou.svg"
                                class="hidden-desc-mobile position-absolute z-1 br" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1768210405045-J0NmC-Grou.svg"
                                class="hidden-desc-tablet position-absolute z-1 br" alt="img" loading="lazy">
                        </div>
                        <a href="#" class="case4-main-content__button hdden-desc-tablet">Заполнить анкету</a>
                        <h2 class="mt60">Работая с карьерным коучем, я впервые по‑настоящему приняла свой опыт</h2>
                        <p class="case4-main-content__text">Я решила, что для следующего шага в поиске работы лучше всего
                            мне поможет моего тариф с сопровождением экспертов. И не ошиблась! <span>Именно работа с коучем
                                стала тем поворотным моментом, который изменил моё отношение к себе и к своей карьере.</span>
                        </p>
                        <p class="case4-main-content__text">Работая с карьерным коучем, я впервые по‑настоящему приняла свой
                            опыт. Я перестала смотреть на десять лет паузы как на провал.</p>
                        <p class="case4-main-content__text">Самой глубокой частью работы стало то, что мы с Яной прорабатывали
                            то, что тормозило меня сильнее всего: чувство вины — за смену сферы и за долгий профессиональный
                            перерыв. Это действительно было похоже на терапию. До разговора с ней я даже не осознавала,
                            насколько эта вина влияет на мою уверенность, на ответы на интервью, на позиционирование.</p>
                        <p class="case4-main-content__text">После этих встреч <span>я впервые позволила себе считать свой путь
                                не ошибкой, а естественной частью большого профессионального движения.</span></p>
                        <p class="case4-main-content__text">Ещё один важный результат — я научилась грамотно и уверенно
                            рассказывать о своих soft skills. Не общими словами, а так, чтобы они точно отвечали требованиям
                            конкретной вакансии. То, что раньше я не считала «чем‑то особенным», стало моим конкурентным
                            преимуществом.</p>
                        <div class="case4-main-content__block table position-relative">
                            <div class="case4-main-content__block__table__wrapper position-relative z-10">
                                <div class="case4-main-content__block__row careerum-flex-fsfs">
                                    <p class="case4-main-content__block__table__header">Работа с коучем</p>
                                    <p class="case4-main-content__block__table__text">Новый взгляд на свой опыт без чувства вины
                                    </p>
                                </div>
                                <div class="case4-main-content__block__row careerum-flex-fsfs">
                                    <p class="case4-main-content__block__table__header">Курс по самооценке</p>
                                    <p class="case4-main-content__block__table__text">Появилась уверенность в себе</p>
                                </div>
                                <div class="case4-main-content__block__row careerum-flex-fsfs">
                                    <p class="case4-main-content__block__table__header">Звёздный кандидат</p>
                                    <p class="case4-main-content__block__table__text">Продающее резюме</p>
                                </div>
                                <div class="case4-main-content__block__row careerum-flex-fsfs">
                                    <p class="case4-main-content__block__table__header">Поддержка сообщества</p>
                                    <p class="case4-main-content__block__table__text">Чувство, что не одна на своём пути</p>
                                </div>
                            </div>
                            <img src="https://cdn.careerum.com/1765872624303-LqKT0-Vect.svg"
                                class="hidden-tablet-mobile position-absolute z-1 br" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1765954268181-bq4Nz-Vect.svg"
                                class="hidden-desc-mobile position-absolute z-1 br" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1765957741465-TQerH-Vect.svg"
                                class="hidden-desc-tablet position-absolute z-1 br" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1765872624047-8s290-Vect.svg"
                                class="hidden-tablet-mobile position-absolute z-1 tl" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1765954268314-ewJw5-Vect.svg"
                                class="hidden-desc-mobile position-absolute z-1 tl" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1765957741693-Wef3n-Vect.svg"
                                class="hidden-desc-tablet position-absolute z-1 tl" alt="img" loading="lazy">
                        </div>
                        <a href="#" class="case4-main-content__button">Заполнить анкету</a>
                        <h2 class="mt60">Careerum дал мне фундамент для возвращения в профессию</h2>
                        <p class="case4-main-content__text">Я оформила резюме, создала свой первый в жизни профиль в LinkedIn —
                            и именно он сыграл ключевую роль в поиске моей первой работы после паузы.</p>
                        <div class="case4-main-content__img">
                            <img src="https://cdn.careerum.com/1768204022055-5mIiX-Fram.png" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1765953883367-1YXKg-Fram.png" class="hidden-desc-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1768210463024-XrhiQ-Fram.png" class="hidden-desc-tablet"
                                alt="img" loading="lazy">
                        </div>
                        <p class="case4-main-content__text">Следующим шагом стала воронка откликов. Я применила рекомендацию
                            Careerum: уделять 20% времени самым желанным позициям и 80% — массовым откликам, где важна скорость,
                            а не идеальная кастомизация.</p>
                        <div class="case4-main-content__quote">
                            <img src="https://cdn.careerum.com/1765871212658-cZuXd-â .svg" class="" alt="img" loading="lazy">
                            <p>Для меня это сработало на сто процентов. Свою первую работу после десятилетней паузы я нашла
                                именно среди тех самых восьмидесяти процентов — на позицию, на которую не делала идеальную
                                кастомизацию резюме и не писала сопроводительное письмо с особой тщательностью</p>
                        </div>
                        <p class="case4-main-content__text">Большую роль сыграла и работа с карьерным экспертом Софи Бессон.
                            Мы вместе адаптировали резюме под конкретные вакансии, оттачивали формулировки, разрабатывали логику
                            откликов. Эти правки помогли мне уверенно входить в диалоги с работодателями и точнее
                            позиционировать свой опыт.</p>
                        <p class="case4-main-content__text">Когда фундамент был готов, всё сложилось довольно быстро.
                            <span>И я получила тот самый отклик, который изменил мой путь.<span>
                        </p>
                        <p class="case4-main-content__text">Так я вышла на свою первую работу после 10 лет перерыва —
                            в небольшую консалтинговую фирму, работающую с международными клиентами. Это был контракт
                            на ограниченный срок, но для меня он стал настоящим перезапуском карьеры.</p>
                        <p class="case4-main-content__text"><span>Я снова почувствовала себя профессионалом.</span>
                            Этот контракт дал мне
                            возможность безопасно адаптироваться, набрать скорость и вернуть уверенность.</p>
                        <h2 class="mt60">Как я вышла на международный рынок</h2>
                        <div class="case4-main-content__img">
                            <img src="https://cdn.careerum.com/1768204285247-W2zGO-Fram.png" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1765953883694-wAt22-Fram.png" class="hidden-desc-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1765954003367-JF3ZB-Fram.png" class="hidden-desc-tablet"
                                alt="img" loading="lazy">
                        </div>
                        <p class="case4-main-content__text">Когда мой контракт закончился и я начала новый поиск в 2025 году,
                            я снова вернулась в Careerum. Теперь у меня была цель — выйти на позицию в крупной международной
                            компании. Я чувствовала, что готова к следующему уровню, но мне нужно было укрепить внутреннюю
                            опору.</p>
                        <p class="case4-main-content__text">Я прошла курс Анны Бабич по самооценке — и он стал для меня важным
                            шагом. Он помог мне посмотреть на свой опыт по‑новому: не как на «историю с паузой», а как на зрелую
                            профессиональную траекторию, где каждый этап имеет ценность.</p>
                        <p class="case4-main-content__text">И именно это изменило моё поведение на интервью.</p>
                        <div class="case4-main-content__quote">
                            <img src="https://cdn.careerum.com/1765871212658-cZuXd-â .svg" class="" alt="img" loading="lazy">
                            <p>Приняв и осознав ценность своего опыта, я вышла на новый уровень общения с нанимающими
                                менеджерами: интервью превратились в диалоги, где мы обменивались своими профессиональными
                                взглядами и опытом</p>
                        </div>
                        <p class="case4-main-content__text">Я стала говорить увереннее, спокойнее, структурированнее —
                            и почувствовала, что <span>работодатели начали видеть во мне равного партнёра, а не кандидата
                                после перерыва.</span></p>
                        <p class="case4-main-content__text">И уже через месяц я получила оффер от крупной международной
                            компании. Сегодня я занимаюсь финансовым контроллингом — в компании, в которую всегда стремилась
                            попасть.</p>
                        <div class="case4-main-content__block revert-bg tales position-relative mt60">
                            <div class="case4-main-content__block__wrapper position-relative z-10">
                                <p class="case4-main-content__block__header">
                                    Какие программы Careerum подойдут вам в похожей ситуации?
                                </p>
                                <img src="https://cdn.careerum.com/1765876215957-TOjj2-Vect.svg"
                                    class="hidden-tablet-mobile position-absolute header" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1768209454482-32cFn-Vect.svg"
                                    class="hidden-desc-mobile position-absolute header" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1765876217546-VzvEr-Vect.svg"
                                    class="hidden-desc-tablet position-absolute header" alt="img" loading="lazy">
                            </div>
                            <div class="case4-main-content__block__tales__wrapper position-relative z-10 careerum-flex-sbst">
                                <div class="case4-main-content__block__tale blue position-relative careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1765878669512-sW6Uj-Grou.svg" class=" position-absolute"
                                        alt="img" loading="lazy">
                                    <div class="position-relative z-10">
                                        <p>Звёздный кандидат</p>
                                        <p>Программа по развитию навыков и инструментов для эффективного поиска работы,
                                            чтобы получить желаемый оффер на выгодных условиях</p>
                                    </div>
                                </div>
                                <div class="case4-main-content__block__tale light position-relative careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1765878669265-9ostd-Grou.svg" class=" position-absolute"
                                        alt="img" loading="lazy">
                                    <div class="position-relative z-10">
                                        <p>Go Global</p>
                                        <p>Программа для разработки стратегии и планирования практических шагов для поиска
                                            работы и релокации за границу</p>
                                    </div>
                                </div>
                                <div class="case4-main-content__block__tale2">
                                    <p>Попасть в Careerum можно только через анкету кандидата</p>
                                </div>
                                <img src="https://cdn.careerum.com/1768210768726-z5ZIE-Fram.svg"
                                    class=" position-absolute hidden-desc-tablet" alt="img" loading="lazy">
                                <a href="#" class="case4-main-content__button hidden-mobile">Заполнить анкету</a>
                            </div>
                        </div>
                        <a href="#" class="case4-main-content__button hidden-desc-tablet">Заполнить анкету</a>
                        <div class="case4-main-content__block light position-relative mt60">
                            <p class="case4-main-content__block__header dark hidden-mobile">История Анны — про то, что перерыв
                                не определяет будущее</p>
                            <p class="case4-main-content__block__header dark hidden-desc-tablet">История Анны — <br>про то, что
                                перерыв не определяет будущее</p>
                            <img src="https://cdn.careerum.com/1765879197892-ZN6jB-Grou.svg"
                                class="hidden-tablet-mobile position-absolute" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1765956391638-8S45P-Grou.svg"
                                class="hidden-desc-mobile position-absolute " alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1765958281986-LF3ti-Grou.svg"
                                class="hidden-desc-tablet position-absolute" alt="img" loading="lazy">
                        </div>
                        <p class="case4-main-content__text">10 лет вне профессии — это не финал. Это пауза, после которой можно
                            вернуться в ещё более сильную позицию, если использовать правильные инструменты и иметь
                            профессиональную поддержку.</p>
                        <p class="case4-main-content__text">Если вам кажется, что ваш путь оборвался — знайте, вам просто
                            не хватает инструментов и поддержки. И вы можете найти их, как это сделала Анна. Приходите
                            в Careerum — вы сможете обрести ясность, уверенность, навыки самопрезентации и профессиональное
                            сообщество.</p>
                        <p class="case4-main-content__text"><span>Если вам кажется,</span> что ваш путь оборвался — знайте, <span>вам просто
                            не хватает инструментов и поддержки.</span> И вы можете найти их, как это сделала Анна. Приходите
                            в Careerum — <span>вы сможете обрести ясность, уверенность, навыки самопрезентации и профессиональное
                            сообщество.</span></p>
                        <p class="case4-main-content__text"><span>Если вам кажется,</span> что ваш путь оборвался — знайте, вам просто
                            не хватает инструментов и поддержки. И вы можете найти их, как это сделала Анна. Приходите
                            в Careerum — <span>вы сможете обрести ясность, уверенность, навыки самопрезентации и профессиональное
                            сообщество.</span></p>
                        <div class="case4-main-content__block revert-bg position-relative mt60">
                            <div class="case4-main-content__block__wrapper2 position-relative z-10">
                                <p class="case4-main-content__block__header">
                                    Перезапустите карьеру после паузы
                                </p>
                                <p class="case4-main-content__block__subheader thin">
                                    И вернитесь в профессию сильнее, чем раньше
                                </p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1768205083359-PkV1v-Spar.svg" alt="img"
                                            loading="lazy">
                                        <p>Уверенность после долгого перерыва</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1768205083315-7KumJ-Iden.svg" alt="img"
                                            loading="lazy">
                                        <p>Чёткое позиционирование на новом рынке</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1768205083261-sNYsp-Clip.svg" alt="img"
                                            loading="lazy">
                                        <p>Пошаговая стратегия поиска работы</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1768205083142-KOhTC-Glob.svg" alt="img"
                                            loading="lazy">
                                        <p>Возвращение в международную компанию</p>
                                    </li>
                                </ul>
                                <p class="case4-main-content__block__label white hidden-desc-tablet">Попасть в Careerum можно
                                    только через анкету кандидата</p>
                            </div>
                            <a href="#" class="case4-main-content__button hidden-mobile">Заполнить анкету</a>
                            <img src="https://cdn.careerum.com/1768205224685-EGTfi-Grou.svg"
                                class="hidden-tablet-mobile position-absolute z-1 b20r" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1768209648613-bl4wX-Grou.svg"
                                class="hidden-desc-mobile position-absolute z-1 t20r" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1765958567120-Putf7-Grou.svg"
                                class="hidden-desc-tablet position-absolute z-1 tl" alt="img" loading="lazy">
                        </div>
                        <a href="#" class="case4-main-content__button hidden-desc-tablet">Заполнить анкету</a>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-club50-system', {
        label: 'Club 50 system (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club50-system main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Система карьерной транформации Careerum</h2>
                    <div class="club50-system-wrapper noselect">
                        <div class="club50-system-item">
                            <div class="careerum-flex-fsc">
                                <img loading="" src="https://cdn.careerum.com/1767099750422-3UFzD-User.svg" alt="img" class="hidden-tablet-mobile"/>
                                <img loading="" src="https://cdn.careerum.com/1767102261310-EU0WL-User.svg" alt="img" class="hidden-desc"/>
                                <p class="club50-system-item-label position-relative z-20">Шаг 1</p>
                            </div>
                            <p class="club50-system-item-text">Проведёте аудит накопленного опыта за годы карьеры</p>
                        </div>
                        <div class="club50-system-item">
                            <div class="careerum-flex-fsc">
                                <img loading="" src="https://cdn.careerum.com/1767099749864-PDGbK-Char.svg" alt="img" class="hidden-tablet-mobile"/>
                                <img loading="" src="https://cdn.careerum.com/1767102260985-oSL2S-Char.svg" alt="img" class="hidden-desc"/>
                                <p class="club50-system-item-label position-relative z-20">Шаг 2</p>
                            </div>
                            <p class="club50-system-item-text">Определите следующий шаг на локальном или глобальном рынке: рост внутри компании, смена траектории или поиск новой работы</p>
                        </div>
                        <div class="club50-system-item">
                            <div class="careerum-flex-fsc">
                                <img loading="" src="https://cdn.careerum.com/1767099750161-1t0H3-List.svg" alt="img" class="hidden-tablet-mobile"/>
                                <img loading="" src="https://cdn.careerum.com/1767102261097-QXWKS-List.svg" alt="img" class="hidden-desc"/>
                                <p class="club50-system-item-label position-relative z-20">Шаг 3</p>
                            </div>
                            <p class="club50-system-item-text">Создадите карьерную стратегию роста на 5 лет вперед на основе своих профессиональных ценностей, талантов и сильных сторон</p>
                        </div>
                        <div class="club50-system-item">
                            <div class="careerum-flex-fsc">
                                <img loading="" src="https://cdn.careerum.com/1767099750320-iyjKC-Tren.svg" alt="img" class="hidden-tablet-mobile"/>
                                <img loading="" src="https://cdn.careerum.com/1767102261229-su3uT-Tren.svg" alt="img" class="hidden-desc"/>
                                <p class="club50-system-item-label position-relative z-20">Шаг 4</p>
                            </div>
                            <p class="club50-system-item-text">Научитесь определять потребности рынка, руководителя и том-менеджмента компании.</p>
                        </div>
                        <div class="club50-system-item">
                            <div class="careerum-flex-fsc">
                                <img loading="" src="https://cdn.careerum.com/1767099750215-lw4Lw-Note.svg" alt="img" class="hidden-tablet-mobile"/>
                                <img loading="" src="https://cdn.careerum.com/1767102261143-pnXPa-Note.svg" alt="img" class="hidden-desc"/>
                                <p class="club50-system-item-label position-relative z-20">Шаг 5</p>
                            </div>
                            <p class="club50-system-item-text">Переупакуете свой опыт под следующий шаг: сильное резюме, Linkedin-профиль, 100% готовность к прохождению интервью любой сложности</p>
                        </div>
                        <div class="club50-system-item">
                            <div class="careerum-flex-fsc">
                                <img loading="" src="https://cdn.careerum.com/1767099750369-yh12Q-Trop.svg" alt="img" class="hidden-tablet-mobile"/>
                                <img loading="" src="https://cdn.careerum.com/1767102261271-LV7ms-Trop.svg" alt="img" class="hidden-desc"/>
                                <p class="club50-system-item-label position-relative z-20">Шаг 6</p>
                            </div>
                            <p class="club50-system-item-text">Вернете себе ощущение профессиональной ценности, избавитесь от синдрома самозванца</p>
                        </div>
                        <div class="club50-system-item">
                            <div class="careerum-flex-fsc">
                                <img loading="" src="https://cdn.careerum.com/ё1767099750278-JnM20-Star.svg" alt="img" class="hidden-tablet-mobile"/>
                                <img loading="" src="https://cdn.careerum.com/1767102261187-JRgOh-Star.svg" alt="img" class="hidden-desc"/>
                                <p class="club50-system-item-label position-relative z-20">Шаг 7</p>
                            </div>
                            <p class="club50-system-item-text">Найдете не просто «новую работу», а новый профессиональный уровень, который соответствует вашему опыту, ценностям и потенциалу</p>
                        </div>
                    </div>
                    <div class="club50-system-nav careerum-flex-fec">
                        <div class="club50-system-nav-prev careerum-flex-cc">
                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </div>
                        <div class="club50-system-nav-next careerum-flex-cc">
                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white" stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-club50-banner2', {
        label: 'Club 5 banner 2 (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club50-banner2 main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="club50-banner-bg position-relative z-1">
                        <img src="https://cdn.careerum.com/1769580488171-5wgtW-Grou.svg" class="hidden-tablet-mobile position-absolute" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1769580510703-7wWwE-Grou.svg" class="hidden-desc-mobile position-absolute" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1769580573974-Adi3m-Grou.svg" class="hidden-desc-tablet position-absolute" alt="img" loading="lazy">
                    </div>
                    <div class="club50-banner-content position-relative z-10">
                        <div class="club50-banner-content-top careerum-flex-fsc">
                            <div class="club50-banner-label blue careerum-flex-fsc">
                                <p>В подписке Careerum</p>
                            </div>
                            <div class="club50-banner-label careerum-flex-fsc img">
                                <img src="https://cdn.careerum.com/1769580602301-iiii3-Cale.svg" alt="img" loading="eager" class="hidden-tablet-mobile">
                                <img src="https://cdn.careerum.com/1769582457259-lgLIN-Cale.svg" alt="img" loading="eager" class="hidden-desc-mobile">
                                <img src="https://cdn.careerum.com/1769583332048-CLllS-Cale.svg" alt="img" loading="eager" class="hidden-desc-tablet">
                                <p>19 февраля – 7 мая</p>
                            </div>
                            <div class="club50-banner-label careerum-flex-fsc">
                                <p>3 месяца</p>
                            </div>
                        </div>
                        <div class="club50-banner-content-center">
                            <div class="club50-banner-header careerum-flex-fsc position-relative">
                                <h2>LEVEL <span>UP</span></h2>
                                <img src="https://cdn.careerum.com/1769580622915-c520R-Grou.svg" class="hidden-tablet-mobile" alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1769580642787-bmbLr-Grou.svg" class="hidden-desc-mobile" alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1769580670103-TVUvj-Grou.svg" class="hidden-desc-tablet position-absolute" alt="img" loading="eager">
                            </div>
                            <p class="club50-banner-subheader">Программа профессиональной трансформации и управления карьерой для зрелых специалистов и руководителей</p>
                        </div>
                        <div class="club50-banner-content-button">
                            <a href="" class="btn-color-main-black">Узнать подробности</a>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('club5-banner-top4', {
        label: 'Club 5 banner top 4 (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club5-banner-top club5-banner-top4 main-wrapper"
            data-timer="no" data-redirect="no" data-url="" data-static="yes" data-offset=""
            data-timer-end="02/19/2026 00:00 GMT+0300">
                <div class="careerum-container-responsive">
                    <div class="club5-banner__wrapper position-relative">
                        <div class="club5-banner__bg position-absolute z-10">
                            <img src="https://cdn.careerum.com/1769578887628-9yuP5-Grou.svg"
                                class="hidden-tablet-mobile position-absolute" alt="img">
                            <img src="https://cdn.careerum.com/1769578890004-xYgNz-Grou.svg"
                                class="hidden-desc-mobile position-absolute" alt="img">
                            <img src="https://cdn.careerum.com/1769578894359-f5Jrf-Grou.svg"
                                class="hidden-desc-tablet position-absolute" alt="img">
                        </div>
                        <div class="club5-banner__content careerum-flex-sbc position-relative z-20">
                            <div class="club5-banner__left">
                                <p class="club5-banner__label">Старт 19 февраля </p>
                                <p class="club5-banner__title">Набор на новый курс Level Up</p>
                                <p class="club5-banner__text">Начните управлять своей карьерой и создайте осознанную стратегию</p>
                            </div>
                            <div class="club5-banner__timer">
                                <div class="careerum-flex-sbst">
                                    <div class="club5-banner__timer-item">
                                        <p class="timer-day-number">0</p>
                                        <p class="timer-day-text">ДНЕЙ</p>
                                    </div>
                                    <div class="club5-banner__timer-item">
                                        <p class="timer-hour-number">0</p>
                                        <p class="timer-hour-text">ЧАСОВ</p>
                                    </div>
                                    <div class="club5-banner__timer-item">
                                        <p class="timer-min-number">0</p>
                                        <p class="timer-min-text">МИНУТ</p>
                                    </div>
                                </div>
                            </div>
                            <div class="club5-banner__right careerum-flex-fec">
                                <a href="/ru-ru/promo/big-pack2" class="btn-color-main-white" target="_blank">Узнать подробнее</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-levelup-main', {
        label: 'LevelUp main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-levelup-main main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <div class="levelup-main-bg position-absolute z-1">
                        <img src="https://cdn.careerum.com/1770205925984-mKmgP-Grou.svg"
                            class="hidden-tablet-mobile position-absolute round z-1" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1770205944796-WsVRV-Grou.svg"
                            class="hidden-desc-mobile position-absolute round z-1" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1770293284658-Rzd3m-Grou.svg"
                            class="hidden-desc-tablet position-absolute round z-1" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1770269576827-CWX2l-Sect.png"
                            class="hidden-tablet-mobile overlay position-absolute z-10" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1770271534921-yG1AR-Sect.png"
                            class="hidden-desc-mobile overlay position-absolute z-10" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1770293395772-I159t-Sect.png"
                            class="hidden-desc-tablet overlay position-absolute z-10" alt="img" loading="lazy">
                        <div class="levelup-main-bg-gradient position-absolute z-20"></div>
                    </div>
                    <div class="levelup-main-wrapper position-relative z-10">
                        <div class="levelup-main-label careerum-flex-fsc">
                            <img src="https://cdn.careerum.com/1770201911423-DAmNV-Cale.svg" class="hidden-tablet" alt="img"
                                loading="lazy">
                            <img src="https://cdn.careerum.com/1770202010588-npNTY-Cale.svg" class="hidden-desc-mobile"
                                alt="img" loading="lazy">
                            <p>19 февраля – 31 апреля</p>
                        </div>
                        <p class="levelup-main-description hidden-desc-tablet">Программа профессиональной трансформации и
                            управления карьерой </p>
                        <div class="levelup-main-header position-relative careerum-flex-fsfs">
                            <h1>LEVEL <span>UP</span></h1>
                            <img src="https://cdn.careerum.com/1770201911333-CWMYR-Grou.svg" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1770202010531-7NE6m-Grou.svg" class="hidden-desc-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1770202058987-GHDCu-Grou.svg"
                                class="hidden-desc-tablet position-absolute z-1" alt="img" loading="lazy">
                        </div>
                        <p class="levelup-main-description hidden-mobile">Программа профессиональной трансформации и управления
                            карьерой для
                            зрелых специалистов и руководителей</p>
                        <p class="levelup-main-subheader">Вы создадите:</p>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1770201911234-trUO9-Soft.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770202010450-hGxBc-Soft.svg" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770293890944-TJSZM-Soft.png" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                                <p>Сильный профессиональный профиль: резюме, Linkedin, портфолио </p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1770201911234-trUO9-Soft.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770202010450-hGxBc-Soft.svg" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770293890944-TJSZM-Soft.png" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                                <p>Карьерную стратегию роста на 1–5 лет</p>
                            </li>
                        </ul>
                        <a href="#" class="btn-color-main-black">Посмотреть программу</a>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-levelup-foryou', {
        label: 'LevelUp foryou (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-levelup-foryou main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Стоит участвовать, если:</h2>
                    <div class="levelup-foryou-wrapper">
                        <div class="careerum-flex-sbst">
                            <div class="levelup-foryou-item left">
                                <img src="https://cdn.careerum.com/1770202149475-gYmCb-Fram.png" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770202233049-cOyQI-Fram.png" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770202309771-HbqFF-Fram.png" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                            </div>
                            <div class="levelup-foryou-item right">
                                <div class="levelup-foryou-subitem">
                                    <p class="levelup-foryou-subitem-header">Вы не понимаете, куда двигаться, несмотря на свой
                                        опыт</p>
                                    <p class="levelup-foryou-subitem-text">Вы многое умеете, но не понимаете, как это собрать
                                        в конкретную стратегию роста</p>
                                </div>
                                <div class="levelup-foryou-subitem">
                                    <p class="levelup-foryou-subitem-header">Достигли потолка</p>
                                    <p class="levelup-foryou-subitem-text">Не понимаете какие ещё есть варианты карьерного
                                        развития в вашем случае, давно не двигаетесь, возможно, думаете в сторону ухода из найма
                                    </p>
                                </div>
                                <div class="levelup-foryou-subitem">
                                    <p class="levelup-foryou-subitem-header">Вы боитесь сделать следующий карьерный
                                        шаг неправильно</p>
                                    <p class="levelup-foryou-subitem-text">Страшно потерять время, деньги, статус, актуальность
                                        на рынке труда</p>
                                </div>
                            </div>
                        </div>
                        <div class="careerum-flex-sbst">
                            <div class="levelup-foryou-item left">
                                <div class="levelup-foryou-subitem">
                                    <p class="levelup-foryou-subitem-header">AI-трансформация мира тревожит вас: ваши
                                        hard-скиллы заменяемы</p>
                                    <p class="levelup-foryou-subitem-text">Не знаете, как при конкуренции с ИИ упаковать свой
                                        опыт, показать и продать его текущему работодателю или на открытом рынке</p>
                                </div>
                            </div>
                            <div class="levelup-foryou-item right">
                                <img src="https://cdn.careerum.com/1770202149264-2tKpR-Fram.png" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770202232993-lk3g9-Fram.png" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770202309446-kHyWR-Fram.png" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                            </div>
                        </div>
                        <div class="careerum-flex-sbst">
                            <div class="levelup-foryou-item left">
                                <img src="https://cdn.careerum.com/1770202149396-3hR5f-Fram.png" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770202232878-EbtZT-Fram.png" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770294587865-TdYea-Fram.png" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                            </div>
                            <div class="levelup-foryou-item right">
                                <div class="levelup-foryou-subitem">
                                    <p class="levelup-foryou-subitem-header">Ответственность растёт, а влияние и деньги — нет
                                    </p>
                                    <p class="levelup-foryou-subitem-text">Каждый раз вам прибавляют нагрузку, но формально
                                        это не учитывается</p>
                                </div>
                                <div class="levelup-foryou-subitem">
                                    <p class="levelup-foryou-subitem-header">Вы много лет в одной компании</p>
                                    <p class="levelup-foryou-subitem-text">И теперь страшно выходить на внешний рынок: кажется,
                                        что вы профессиональны только здесь</p>
                                </div>
                                <div class="levelup-foryou-subitem">
                                    <p class="levelup-foryou-subitem-header">Корпоративная культура/токсичная команда давит</p>
                                    <p class="levelup-foryou-subitem-text">Ценности подменяются лозунгами, обратная связь
                                        становится непрямой, а развитие уступает место режиму выживания</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-levelup-author', {
        label: 'LevelUp author (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-levelup-author main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Автор программы и методологии</h2>
                    <div class="levelup-author-wrapper">
                        <div class="levelup-author-header hidden-mobile">
                            <p class="levelup-author-name">Ольга Лермонтова</p>
                            <p class="levelup-author-position">Основательница Careerum</p>
                        </div>
                        <div class="levelup-author-content careerum-flex-sbst">
                            <div class="levelup-author-image">
                                <img src="https://cdn.careerum.com/1770202406033-jstJS-Fram.png" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770202407765-o4eSb-Fram.png" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770202409986-hQXPt-Imag.png" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                            </div>
                            <div class="levelup-author-text">
                                <div class="hidden-desc-tablet">
                                    <p class="levelup-author-name">Ольга Лермонтова</p>
                                    <p class="levelup-author-position">Основательница Careerum</p>
                                    <p class="levelup-author-text-header">15+ лет управленческой карьеры с постоянным ростом
                                    </p>
                                    <p class="levelup-author-text-text">В Google, Microsoft, Adobe, Intel на 25 рынках с
                                        постоянным ростом должности и дохода</p>
                                    <a href="#pop4" class="btn-color-main-white">Подробнее об эксперте</a>
                                </div>
                                <ul class="hidden-mobile">
                                    <li>
                                        <p class="levelup-author-text-header">15+ лет управленческой карьеры </p>
                                        <p class="levelup-author-text-text">В Google, Microsoft, Adobe, Intel на 25 рынках с
                                            постоянным ростом должности и дохода</p>
                                    </li>
                                    <li>
                                        <p class="levelup-author-text-header">MBA от INSEAD </p>
                                        <p class="levelup-author-text-text">Магистратура по психологии в Harvard University</p>
                                    </li>
                                    <li>
                                        <p class="levelup-author-text-header">Карьерный коуч и стратег</p>
                                        <p class="levelup-author-text-text">С портфелем 13 000 клиентов из 60 стран</p>
                                    </li>
                                    <li>
                                        <p class="levelup-author-text-header">Состоялась в разных форматах:</p>
                                        <p class="levelup-author-text-text">Как сотрудник, эксперт-фрилансер и предприниматель
                                        </p>
                                    </li>
                                    <li>
                                        <p class="levelup-author-text-header">Перепридумывала свою карьеру 7 раз: </p>
                                        <p class="levelup-author-text-text">Из репетитора по языкам — в продажи и маркетинг —
                                            потом в стратегию — потом в свой бизнес</p>
                                    </li>
                                    <li>
                                        <p class="levelup-author-text-header">Автор бестселлера </p>
                                        <p class="levelup-author-text-text">МИФ «Работа по любви»</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-levelup-newformats', {
        label: 'LevelUp newformats (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-levelup-newformats main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Как пройдет обучение</h2>
                    <div class="levelup-newformats-wrapper">
                        <div class="levelup-newformats-top careerum-flex-sbfs">
                            <div class="levelup-newformats-top-img">
                                <img src="https://cdn.careerum.com/1770202537851-7j4Ja-Fram.png" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770202857731-pVqMx-Fram.png" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770203037796-Js6Ot-Fram.png" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                            </div>
                            <div class="levelup-newformats-top-text">
                                <p class="levelup-newformats-top-header">2 потока</p>
                                <p class="levelup-newformats-top-text">Российский и международный рынки</p>
                            </div>
                        </div>
                        <div class="levelup-newformats-steps careerum-flex-sbst">
                            <div class="levelup-newformats-step">
                                <p class="levelup-newformats-step-label">Шаг 1</p>
                                <p class="levelup-newformats-step-header">Проведёте аудит накопленного опыта за годы карьеры:
                                </p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1770202583377-Dy7sL-Soft.svg"
                                            class="hidden-tablet-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770202858044-XxKCF-Soft.svg"
                                            class="hidden-desc-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770203038176-9H0nG-Soft.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                        <p>Присвоите себе результаты</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1770202583377-Dy7sL-Soft.svg"
                                            class="hidden-tablet-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770202858044-XxKCF-Soft.svg"
                                            class="hidden-desc-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770203038176-9H0nG-Soft.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                        <p>Поймёте свою рыночную стоимость</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="levelup-newformats-step">
                                <p class="levelup-newformats-step-label">Шаг 2</p>
                                <p class="levelup-newformats-step-header">Определите следующий шаг:</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1770202583377-Dy7sL-Soft.svg"
                                            class="hidden-tablet-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770202858044-XxKCF-Soft.svg"
                                            class="hidden-desc-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770203038176-9H0nG-Soft.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                        <p>Рост внутри компании / поиск новой работы / выход в портфельную карьеру
                                            или горизонтальный / вертикальный/ диагональный рост</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1770202583377-Dy7sL-Soft.svg"
                                            class="hidden-tablet-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770202858044-XxKCF-Soft.svg"
                                            class="hidden-desc-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770203038176-9H0nG-Soft.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                        <p>Смена сферы или рост в своей профессии на локальном или глобальном рынке</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="levelup-newformats-step">
                                <p class="levelup-newformats-step-label">Шаг 3</p>
                                <p class="levelup-newformats-step-header">Создадите карьерную стратегию роста
                                    на 1/3/5 лет на основе:</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1770202583377-Dy7sL-Soft.svg"
                                            class="hidden-tablet-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770202858044-XxKCF-Soft.svg"
                                            class="hidden-desc-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770203038176-9H0nG-Soft.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                        <p>Своих профессиональных ценностей, талантов</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1770202583377-Dy7sL-Soft.svg"
                                            class="hidden-tablet-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770202858044-XxKCF-Soft.svg"
                                            class="hidden-desc-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770203038176-9H0nG-Soft.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                        <p>Активов, сильных сторон, навыков</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1770202583377-Dy7sL-Soft.svg"
                                            class="hidden-tablet-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770202858044-XxKCF-Soft.svg"
                                            class="hidden-desc-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770203038176-9H0nG-Soft.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                        <p>Сильного позиционирования, соответствия потребностям актуального рынка труда</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1770202583377-Dy7sL-Soft.svg"
                                            class="hidden-tablet-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770202858044-XxKCF-Soft.svg"
                                            class="hidden-desc-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770203038176-9H0nG-Soft.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                        <p>Ответа на вопрос: «В какой индустрии и роли я хочу быть глобально?»</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="levelup-newformats-step">
                                <p class="levelup-newformats-step-label">Шаг 4</p>
                                <p class="levelup-newformats-step-header">Проведёте анализ рынка:</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1770202583377-Dy7sL-Soft.svg"
                                            class="hidden-tablet-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770202858044-XxKCF-Soft.svg"
                                            class="hidden-desc-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770203038176-9H0nG-Soft.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                        <p>Научитесь определять бизнес-потребности рынка, руководителя и топ-менеджмента</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1770202583377-Dy7sL-Soft.svg"
                                            class="hidden-tablet-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770202858044-XxKCF-Soft.svg"
                                            class="hidden-desc-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770203038176-9H0nG-Soft.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                        <p>Поймёте, нужно ли вам  доп.обучение и какое именно для дальнейшего профессионального
                                            развития</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1770202583377-Dy7sL-Soft.svg"
                                            class="hidden-tablet-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770202858044-XxKCF-Soft.svg"
                                            class="hidden-desc-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770203038176-9H0nG-Soft.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                        <p>Какие конкретные роли есть сейчас на рынке/в компании, чтобы реализовать свою
                                            стратегию</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="levelup-newformats-step hidden-desc-tablet">
                                <p class="levelup-newformats-step-label">Шаг 5</p>
                                <p class="levelup-newformats-step-header">Упакуете свой опыт по новую карьерную стратегию</p>
                            </div>
                        </div>
                        <div class="levelup-newformats-banner position-relative">
                            <div class="levelup-newformats-banner-top position-relative">
                                <img src="https://cdn.careerum.com/1770202537903-W6vTA-Fram.png"
                                    class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770202857899-Ri6sF-Fram.png"
                                    class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770203037945-3CFy3-Fram.png"
                                    class="hidden-desc-tablet position-absolute z-1" alt="img" loading="lazy">
                                <p class="levelup-newformats-banner-header position-relative z-10">Результат — ваш <span>сильный
                                        профессиональный профиль</span></p>
                            </div>
                            <div class="levelup-newformats-banner-bottom careerum-flex-sbfs">
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1770202583377-Dy7sL-Soft.svg"
                                            class="hidden-tablet-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770202858044-XxKCF-Soft.svg"
                                            class="hidden-desc-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770203038176-9H0nG-Soft.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                        <p>Продающее резюме</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1770202583377-Dy7sL-Soft.svg"
                                            class="hidden-tablet-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770202858044-XxKCF-Soft.svg"
                                            class="hidden-desc-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770203038176-9H0nG-Soft.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                        <p>Мощный Linkedin-профиль</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1770202583377-Dy7sL-Soft.svg"
                                            class="hidden-tablet-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770202858044-XxKCF-Soft.svg"
                                            class="hidden-desc-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770203038176-9H0nG-Soft.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                        <p>Сопроводительные письма</p>
                                    </li>
                                </ul>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1770202583377-Dy7sL-Soft.svg"
                                            class="hidden-tablet-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770202858044-XxKCF-Soft.svg"
                                            class="hidden-desc-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770203038176-9H0nG-Soft.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                        <p>Портфолио</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1770202583377-Dy7sL-Soft.svg"
                                            class="hidden-tablet-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770202858044-XxKCF-Soft.svg"
                                            class="hidden-desc-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770203038176-9H0nG-Soft.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                        <p>Файл с перечнем всех ваших навыков, талантов и опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1770202583377-Dy7sL-Soft.svg"
                                            class="hidden-tablet-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770202858044-XxKCF-Soft.svg"
                                            class="hidden-desc-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770203038176-9H0nG-Soft.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                        <p>Карьерная стратегия на 1-5 лет</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="levelup-newformats-steps careerum-flex-sbst">
                            <div class="levelup-newformats-step hidden-mobile">
                                <p class="levelup-newformats-step-label">Шаг 5</p>
                                <p class="levelup-newformats-step-header">Упакуете свой опыт по новую карьерную стратегию</p>
                            </div>
                            <div class="levelup-newformats-step">
                                <p class="levelup-newformats-step-label">Шаг 6</p>
                                <p class="levelup-newformats-step-header">Найдёте не просто «новую работу»</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1770202583377-Dy7sL-Soft.svg"
                                            class="hidden-tablet-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770202858044-XxKCF-Soft.svg"
                                            class="hidden-desc-mobile" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770203038176-9H0nG-Soft.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                        <p>А новый профессиональный уровень, который соответствует вашему опыту, ценностям
                                            и потенциалу</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="levelup-newformats-banner-flex careerum-flex-sbfs">
                            <div>
                                <p class="levelup-newformats-banner-flex-header hidden-desc-tablet">Сертификат о прохождении</p>
                                <img src="https://cdn.careerum.com/1770202537747-chZhP-Fram.png" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770202857984-VDGGE-Fram.png" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770203038059-L9LmN-Fram.png" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                            </div>
                            <div>
                                <p class="levelup-newformats-banner-flex-header hidden-mobile">Сертификат о прохождении</p>
                                <p class="levelup-newformats-banner-flex-text">Подтверждение, что вы: </p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1770202699120-I1ACX-Chec.svg" class="hidden-mobile"
                                            alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770203038128-tASJk-Chec.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                        <p>Стратегически развиваетесь</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1770202699120-I1ACX-Chec.svg" class="hidden-mobile"
                                            alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770203038128-tASJk-Chec.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                        <p>Управляете своим карьерным ростом</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1770202699120-I1ACX-Chec.svg" class="hidden-mobile"
                                            alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770203038128-tASJk-Chec.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                        <p>Владеете международными стандартами самопрезентации и переговорами о деньгах</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1770202699120-I1ACX-Chec.svg" class="hidden-mobile"
                                            alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770203038128-tASJk-Chec.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                        <p>Инвестируете в развитие (green flag для рекрутеров и профессионального рынка, как
                                            показатель ценности и зрелости кандидата)</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <a href="#" class="btn-color-main-black">Посмотреть программу</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-levelup-program', {
        label: 'LevelUp program (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-levelup-program main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Программа — два трека:</h2>
                    <div class="levelup-program-wrapper">
                        <div class="levelup-program-top careerum-flex-fsc">
                            <p class="position-relative z-1">Повышение внутри компании</p>
                            <div class="position-relative z-10">
                                <img src="https://cdn.careerum.com/1770203151873-CSdbU-Fram.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770203465995-HYreE-Fram.svg" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770203650972-2noiY-Fram.svg" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                            </div>
                            <p class="position-relative z-1">Рост через новую работу</p>
                        </div>
                        <div class="levelup-program-banner">
                            <div class="levelup-program-banner-top position-relative">
                                <img src="https://cdn.careerum.com/1770203255088-oOAXK-Fram.png"
                                    class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770273225363-Y4GiK-Fram.png"
                                    class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770296937993-SzzMk-Fram.png"
                                    class="hidden-desc-tablet position-absolute z-1" alt="img" loading="lazy">
                                <p class="levelup-program-banner-top-header position-relative z-10">Мы интегрировали в программу
                                    нейросети: </p>
                                <ul class="careerum-flex-fsfs position-relative z-10">
                                    <li>ChatGPT</li>
                                    <li>Claude</li>
                                    <li>Perplexity</li>
                                </ul>
                            </div>
                            <div class="levelup-program-banner-bottom">
                                <p class="levelup-program-banner-bottom-header">Он ускорит создание вашей карьерной стратегии
                                </p>
                                <div class="levelup-program-banner-bottom-wrapper careerum-flex-fsfs">
                                    <div class="levelup-program-banner-bottom-items">
                                        <div class="levelup-program-banner-bottom-item careerum-flex-fsfs">
                                            <p class="levelup-program-banner-bottom-item-number">( 1 )</p>
                                            <div>
                                                <p class="levelup-program-banner-bottom-item-header">Аналитика рынка</p>
                                                <p class="levelup-program-banner-bottom-item-text">Точный анализ зарплатных
                                                    вилок и спроса по вашей роли, уровню и локации — без догадок и «ощущений»
                                                </p>
                                            </div>
                                        </div>
                                        <div class="levelup-program-banner-bottom-item careerum-flex-fsfs">
                                            <p class="levelup-program-banner-bottom-item-number">( 2 )</p>
                                            <div>
                                                <p class="levelup-program-banner-bottom-item-header">Карьерные сценарии</p>
                                                <p class="levelup-program-banner-bottom-item-text">15 релевантных вариантов
                                                    развития карьеры на основе ваших навыков и рынка — включая неочевидные, но
                                                    перспективные для вашей траектории</p>
                                            </div>
                                        </div>
                                        <div class="levelup-program-banner-bottom-item careerum-flex-fsfs">
                                            <p class="levelup-program-banner-bottom-item-number">( 3 )</p>
                                            <div>
                                                <p class="levelup-program-banner-bottom-item-header">Умная упаковка под офферы
                                                </p>
                                                <p class="levelup-program-banner-bottom-item-text">Резюме и сопроводительные
                                                    письма,
                                                    адаптированные под вакансии и ATS-фильтры, чтобы рынок видел вашу реальную
                                                    ценность</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="levelup-program-banner-bottom-bonus">
                                        <div class="levelup-program-banner-bottom-bonus-top careerum-flex-fsc">
                                            <img src="https://cdn.careerum.com/1770297790095-KQ7uc-12.p.png"
                                                class="hidden-mobile" alt="img" loading="lazy">
                                            <img src="https://cdn.careerum.com/1770297843368-b2YoO-(1)..png"
                                                class="hidden-desc-tablet" alt="img" loading="lazy">
                                            <p>Бонус</p>
                                        </div>
                                        <div class="levelup-program-banner-bottom-bonus-bottom">
                                            <p>Библиотека карьерных промптов для стратегии, переговоров и самопрезентации.
                                                Остаётся с вами навсегда!</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="levelup-program-header position-relative">
                            <img src="https://cdn.careerum.com/1770203255409-kAYA7-Elli.svg"
                                class="hidden-tablet-mobile position-absolute z-1 tr" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1770270756811-Z5B8y-Rect.png"
                                class="hidden-tablet-mobile position-absolute z-10" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1770203484986-fZjZo-Elli.svg"
                                class="hidden-desc-mobile position-absolute z-1 tr" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1770274089665-6qCyF-Rect.png"
                                class="hidden-desc-mobile position-absolute z-10" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1770204004415-ooliz-Elli.svg"
                                class="hidden-desc-tablet position-absolute z-1 tr" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1770298088144-6DH5v-Sect.png"
                                class="hidden-desc-tablet position-absolute z-10" alt="img" loading="lazy">
                            <div class="position-relative z-20">
                                <p class="levelup-program-header-label">Блок 1</p>
                                <p class="levelup-program-header-header">Аудит активов и профессиональная
                                    идентичность</p>
                                <p class="levelup-program-header-text">Цель блока — ответить на вопросы
                                    «Кто я сейчас?» и «Сколько я стою?», отделить факты от эмоций и проработать психологические
                                    барьеры: перфекционизм, синдром самозванца и внутреннего критика</p>
                            </div>
                        </div>
                        <div class="levelup-program-items">
                            <div class="levelup-program-item careerum-flex-sbfs">
                                <div class="levelup-program-item-content">
                                    <p class="levelup-program-item-content-label">Неделя 1</p>
                                    <p class="levelup-program-item-content-header">Как увидеть свою реальную ценность</p>
                                    <p class="levelup-program-item-content-text">Научитесь управлять внутренним критиком
                                        и опираться на реальные достижения, а также найдёте смыслы в работе, которые станут
                                        вашим фундаментом</p>
                                </div>
                                <div class="levelup-program-item-switcher">
                                    <img src="https://cdn.careerum.com/1770203542874-P746M-Week.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1770203587144-50aer-Week.svg" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                            </div>
                            <div class="levelup-program-item careerum-flex-sbfs">
                                <div class="levelup-program-item-content">
                                    <p class="levelup-program-item-content-label">Неделя 2</p>
                                    <p class="levelup-program-item-content-header">Инвентаризация hard & soft skills</p>
                                    <p class="levelup-program-item-content-text">Соберёте базу навыков, знаний и кейсов
                                        (“мастер-файл“), научитесь доказывать экспертность не общими фразами, а конкретными
                                        историями по методу STAR и убедитесь в своём опыте, даже если раньше казалось,
                                        что вам нечего предложить рынку</p>
                                </div>
                                <div class="levelup-program-item-switcher">
                                    <img src="https://cdn.careerum.com/1770203542874-P746M-Week.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1770203587144-50aer-Week.svg" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                            </div>
                            <div class="levelup-program-item careerum-flex-sbfs">
                                <div class="levelup-program-item-content">
                                    <p class="levelup-program-item-content-label">Неделя 3</p>
                                    <p class="levelup-program-item-content-header">Код уникальности: чем вы отличаетесь
                                        от других</p>
                                    <p class="levelup-program-item-content-text">Научитесь отключать «самозванца», который
                                        обесценивает ваши успехи, и замените изматывающий перфекционизм на стратегию реального
                                        роста</p>
                                </div>
                                <div class="levelup-program-item-switcher">
                                    <img src="https://cdn.careerum.com/1770203542874-P746M-Week.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1770203587144-50aer-Week.svg" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                            </div>
                            <div class="levelup-program-item careerum-flex-sbfs">
                                <div class="levelup-program-item-content">
                                    <p class="levelup-program-item-content-label">Неделя 4</p>
                                    <p class="levelup-program-item-content-header">Отвечаем на вопрос «Ради чего я работаю?»</p>
                                    <p class="levelup-program-item-content-text">Поймёте, что вам нужно на самом деле: свобода,
                                        экспертность, управление или стабильность, и получите чёткое понимание: «Что меня
                                        мотивирует в работе и почему»</p>
                                </div>
                                <div class="levelup-program-item-switcher">
                                    <img src="https://cdn.careerum.com/1770203542874-P746M-Week.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1770203587144-50aer-Week.svg" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                            </div>
                        </div>
                        <div class="levelup-program-button">
                            <a href="#" class="btn-color-main-black">
                                Заполнить анкету участника
                            </a>
                        </div>
                        <div class="levelup-program-header light-blue position-relative">
                            <img src="https://cdn.careerum.com/1770203255366-XmHXP-Elli.svg"
                                class="hidden-tablet-mobile position-absolute z-1 tl" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1770270962474-yFKvU-Rect.png"
                                class="hidden-tablet-mobile position-absolute z-10" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1770203485052-aZUkS-Elli.svg"
                                class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1770274468810-twbyH-Rect.png"
                                class="hidden-desc-mobile position-absolute z-10" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1770204004367-u5mWx-Elli.svg"
                                class="hidden-desc-tablet position-absolute z-1" alt="img" loading="lazy">
                            <div class="position-relative z-10">
                                <p class="levelup-program-header-label">Блок 2</p>
                                <p class="levelup-program-header-header">Стратегия и гипотезы</p>
                                <p class="levelup-program-header-text">Результат блока — выйдете
                                    из тактического мышления и сформируете ясную карьерную стратегию на 1/3/5 лет, опираясь
                                    на рынок, а не на сомнения</p>
                            </div>
                        </div>
                        <div class="levelup-program-items">
                            <div class="levelup-program-item careerum-flex-sbfs">
                                <div class="levelup-program-item-content">
                                    <p class="levelup-program-item-content-label">Неделя 5</p>
                                    <p class="levelup-program-item-content-header">Создание карьерного плана</p>
                                    <p class="levelup-program-item-content-text">Поймёте, где и кем хотите работать, определите
                                        свою «Большую Цель», ради которой стоит вставать по утрам, а также сузите воронку
                                        поиска: от «кем я стану, когда вырасту» до конкретной сферы/роли</p>
                                </div>
                                <div class="levelup-program-item-switcher">
                                    <img src="https://cdn.careerum.com/1770203542874-P746M-Week.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1770203587144-50aer-Week.svg" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                            </div>
                            <div class="levelup-program-item careerum-flex-sbfs">
                                <div class="levelup-program-item-content">
                                    <p class="levelup-program-item-content-label">Неделя 6</p>
                                    <p class="levelup-program-item-content-header">Практика: создание карьерных гипотез</p>
                                    <p class="levelup-program-item-content-text">Начнёте активно взаимодействовать
                                        с ИИ-инструментами, создадите и протестируете карьерные гипотезы для реализации
                                        карьерного вектора, а также выберете 3 наиболее подходящих варианта</p>
                                </div>
                                <div class="levelup-program-item-switcher">
                                    <img src="https://cdn.careerum.com/1770203542874-P746M-Week.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1770203587144-50aer-Week.svg" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                            </div>
                            <div class="levelup-program-item careerum-flex-sbfs">
                                <div class="levelup-program-item-content">
                                    <p class="levelup-program-item-content-label">Неделя 7</p>
                                    <p class="levelup-program-item-content-header">Практика: проверка карьерных гипотез на рынке
                                        труда</p>
                                    <p class="levelup-program-item-content-text">Протестируете выбранные роли о рынок и живых
                                        людей, сэкономите месяцы жизни, отсеяв красивые, но нежизнеспособные фантазии,
                                        и оставите только подходящие варианты</p>
                                </div>
                                <div class="levelup-program-item-switcher">
                                    <img src="https://cdn.careerum.com/1770203542874-P746M-Week.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1770203587144-50aer-Week.svg" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                            </div>
                            <div class="levelup-program-item careerum-flex-sbfs">
                                <div class="levelup-program-item-content">
                                    <p class="levelup-program-item-content-label">Неделя 8</p>
                                    <p class="levelup-program-item-content-header">Выстраивание стратегии видимости и управления
                                        карьерой</p>
                                    <p class="levelup-program-item-content-text">Научитесь доносить свою ценность на языке
                                        бизнеса, инициировать разговор о повышении или оффере без дрожи в коленях, а также
                                        получите готовые скрипты переговоров, которые напрямую влияют на авторитет и доход</p>
                                </div>
                                <div class="levelup-program-item-switcher">
                                    <img src="https://cdn.careerum.com/1770203542874-P746M-Week.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1770203587144-50aer-Week.svg" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                            </div>
                        </div>
                        <div class="levelup-program-button">
                            <a href="#" class="btn-color-main-black">
                                Заполнить анкету участника
                            </a>
                        </div>
                        <div class="levelup-program-header position-relative">
                            <img src="https://cdn.careerum.com/1770203255314-nglno-Grou.svg"
                                class="hidden-tablet-mobile position-absolute z-1 tr" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1770271123214-6TTmO-Rect.png"
                                class="hidden-tablet-mobile position-absolute z-10" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1770203485108-7i5rw-Grou.svg"
                                class="hidden-desc-mobile position-absolute z-1 tr" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1770274391667-hvRl1-Rect.png"
                                class="hidden-desc-mobile position-absolute z-10" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1770204004265-LdXc6-Grou.svg"
                                class="hidden-desc-tablet position-absolute z-1 tr" alt="img" loading="lazy">
                            <div class="position-relative z-20">
                                <p class="levelup-program-header-label">Блок 3</p>
                                <p class="levelup-program-header-header">Упаковка профессионального опыта</p>
                                <p class="levelup-program-header-text">Результат недели — готовый тактический
                                    план выхода на рынок труда с чёткими целями, управляемыми рисками и продающим резюме</p>
                            </div>
                        </div>
                        <div class="levelup-program-items">
                            <div class="levelup-program-item careerum-flex-sbfs">
                                <div class="levelup-program-item-content">
                                    <p class="levelup-program-item-content-label">Неделя 9</p>
                                    <p class="levelup-program-item-content-header">Создание сильного резюме</p>
                                    <p class="levelup-program-item-content-text">Перестанете воспринимать резюме
                                        как автобиографию и начинаете относиться к нему как к коммерческому предложению,
                                        оцифруете свои результаты (даже если кажется, что их нет) и упаковываете их в сильные
                                        формулировки</p>
                                </div>
                                <div class="levelup-program-item-switcher">
                                    <img src="https://cdn.careerum.com/1770203542874-P746M-Week.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1770203587144-50aer-Week.svg" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                            </div>
                            <div class="levelup-program-item careerum-flex-sbfs">
                                <div class="levelup-program-item-content">
                                    <p class="levelup-program-item-content-label">Неделя 10</p>
                                    <p class="levelup-program-item-content-header">Кастомизация резюме и создание
                                        сопроводительного письма</p>
                                    <p class="levelup-program-item-content-text">Начнёте активно взаимодействовать
                                        с ИИ-инструментами, создадите и протестируете карьерные гипотезы для реализации
                                        карьерного вектора, а также выберете 3 наиболее подходящих варианта</p>
                                </div>
                                <div class="levelup-program-item-switcher">
                                    <img src="https://cdn.careerum.com/1770203542874-P746M-Week.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1770203587144-50aer-Week.svg" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                            </div>
                            <div class="levelup-program-item careerum-flex-sbfs">
                                <div class="levelup-program-item-content">
                                    <p class="levelup-program-item-content-label">Неделя 11</p>
                                    <p class="levelup-program-item-content-header">Выход на рынок: прожарка резюме / LinkedIn
                                        профилей</p>
                                    <p class="levelup-program-item-content-text">Упакуете свой профессиональный опыт так,
                                        как это нужно работодателю, и полностью подготовитесь к выходу на внешний или внутренний
                                        рынок</p>
                                </div>
                                <div class="levelup-program-item-switcher">
                                    <img src="https://cdn.careerum.com/1770203542874-P746M-Week.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1770203587144-50aer-Week.svg" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                            </div>
                        </div>
                        <div class="levelup-program-button">
                            <a href="#" class="btn-color-main-black">
                                Заполнить анкету участника
                            </a>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-levelup-format', {
        label: 'LevelUp format (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-levelup-format main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Формат</h2>
                    <div class="levelup-format-wrapper">
                        <div class="levelup-format-top position-relative">
                            <img src="https://cdn.careerum.com/1770204208768-AV0GU-Gene.png"
                                class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1770204746429-952v6-Gene.png"
                                class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1770298789010-qLxSj-Gene.png"
                                class="hidden-desc-tablet position-absolute z-1" alt="img" loading="lazy">
                            <div class="levelup-format-top-label white careerum-flex-fsfs">
                                <div class="levelup-format-top-label-text careerum-flex-cc">
                                    <p>С группой</p>
                                </div>
                                <div class="levelup-format-top-label-img careerum-flex-cc">
                                    <img src="https://cdn.careerum.com/1770204267109-Hlcmt-User.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1770204634350-DNYvV-User.svg" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                            </div>
                            <div class="levelup-format-top-label blue careerum-flex-fsfs">
                                <div class="levelup-format-top-label-img careerum-flex-cc">
                                    <img src="https://cdn.careerum.com/1770204267029-V54c5-User.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1770204634263-VzFxX-User.svg" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                                <div class="levelup-format-top-label-text careerum-flex-cc">
                                    <p>Индивидуально</p>
                                </div>
                            </div>
                        </div>
                        <div class="levelup-format-slider noselect">
                            <div class="levelup-format-slider-item position-relative">
                                <img src="https://cdn.careerum.com/1770204208699-xG8QU-Fram.png"
                                    class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770204732048-Q5ncn-Fram.png"
                                    class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770299251470-UvfaI-Fram.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                                    loading="lazy">
                                <p class="levelup-format-slider-item-header position-relative z-10">Живые групповые практикумы
                                    с карьерными экспертами
                                </p>
                                <ul class="position-relative z-10">
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1770203038128-tASJk-Chec.svg" class="hidden-mobile"
                                            alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770204471975-sXZCr-Chec.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                        <p>5 групповых практикумов</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1770203038128-tASJk-Chec.svg" class="hidden-mobile"
                                            alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770204471975-sXZCr-Chec.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                        <p>Прожарка резюме и LinkedIn на русском и английском языках</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1770203038128-tASJk-Chec.svg" class="hidden-mobile"
                                            alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770204471975-sXZCr-Chec.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                        <p>3 групповых разбора кейсов</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1770203038128-tASJk-Chec.svg" class="hidden-mobile"
                                            alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770204471975-sXZCr-Chec.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                        <p>2 потока RU и EU рынок</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="levelup-format-slider-item position-relative">
                                <img src="https://cdn.careerum.com/1770204208642-9ijVl-Fram.png"
                                    class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770204732185-46eXr-Fram.png"
                                    class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770299251656-Lzm5h-Fram.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                                    loading="lazy">
                                <p class="levelup-format-slider-item-header position-relative z-10">Обратная связь и поддержка
                                </p>
                                <ul class="position-relative z-10">
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1770203038128-tASJk-Chec.svg" class="hidden-mobile"
                                            alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770204471975-sXZCr-Chec.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                        <p>Фидбэк от карьерных экспертов на всех практических эфирах</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1770203038128-tASJk-Chec.svg" class="hidden-mobile"
                                            alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770204471975-sXZCr-Chec.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                        <p>Ответы на вопросы в чате 5 рабочих дней</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1770203038128-tASJk-Chec.svg" class="hidden-mobile"
                                            alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770204471975-sXZCr-Chec.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                        <p>Личный чат с экспертом и коучем на Индивидуальном тарифе</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="levelup-format-slider-item position-relative">
                                <img src="https://cdn.careerum.com/1770204208203-tWln4-Fram.png"
                                    class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770204732259-LkXXt-Fram.png"
                                    class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770299251805-PdT6b-Fram.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                                    loading="lazy">
                                <p class="levelup-format-slider-item-header position-relative z-10">23 видеолекции в записи
                                    по 15–20 минут каждая</p>
                                <ul class="position-relative z-10">
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1770203038128-tASJk-Chec.svg" class="hidden-mobile"
                                            alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770204471975-sXZCr-Chec.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                        <p>В том числе 3 новых урока от Ольги Лермонтовой на тему «Как расти и развиваться
                                            в текущей компании»</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="levelup-format-slider-item position-relative">
                                <img src="https://cdn.careerum.com/1770204208343-yOhS9-Fram.png"
                                    class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770204732319-yTvi5-Fram.png"
                                    class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770299251889-pNN90-Fram.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                                    loading="lazy">
                                <p class="levelup-format-slider-item-header position-relative z-10">Домашние задания</p>
                                <ul class="position-relative z-10">
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1770203038128-tASJk-Chec.svg" class="hidden-mobile"
                                            alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770204471975-sXZCr-Chec.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                        <p>С проверкой от экспертов</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="levelup-format-slider-item position-relative">
                                <img src="https://cdn.careerum.com/1770204208417-BIZo1-Fram.png"
                                    class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770204732392-TWlwr-Fram.png"
                                    class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770299251946-rF8l7-Fram.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                                    loading="lazy">
                                <p class="levelup-format-slider-item-header position-relative z-10">11 аудиоподкастов‑ настроек
                                </p>
                                <ul class="position-relative z-10">
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1770203038128-tASJk-Chec.svg" class="hidden-mobile"
                                            alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770204471975-sXZCr-Chec.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                        <p>От экспертов каждый понедельник</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="levelup-format-slider-item position-relative">
                                <img src="https://cdn.careerum.com/1770204208488-uu6Ku-Fram.png"
                                    class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770204732534-EGmVn-Fram.png"
                                    class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770299252007-k9GRP-Fram.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                                    loading="lazy">
                                <p class="levelup-format-slider-item-header position-relative z-10">Работа в тройках</p>
                                <ul class="position-relative z-10">
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1770203038128-tASJk-Chec.svg" class="hidden-mobile"
                                            alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770204471975-sXZCr-Chec.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                        <p>Командный формат проработки заданий программы: вы сможете валидировать свои идеи,
                                            получить взгляд со стороны и поддержку от напарников</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="levelup-format-slider-item position-relative">
                                <img src="https://cdn.careerum.com/1770204208561-FRvG8-Fram.png"
                                    class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770204732454-2if5c-Fram.png"
                                    class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770299252058-sjyAs-Fram.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                                    loading="lazy">
                                <p class="levelup-format-slider-item-header position-relative z-10">Рабочая тетрадь</p>
                                <ul class="position-relative z-10">
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1770203038128-tASJk-Chec.svg" class="hidden-mobile"
                                            alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1770204471975-sXZCr-Chec.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                        <p>Командный формат проработки заданий программы: вы сможете валидировать свои идеи,
                                            получить взгляд со стороны и поддержку от напарников</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="levelup-format-slider-nav careerum-flex-fec noselect">
                            <div class="levelup-format-slider-nav-prev">
                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_414_3976)">
                                        <foreignObject x="-18.1166" y="-18.1166" width="76.2332" height="76.2332">
                                            <div xmlns="http://www.w3.org/1999/xhtml"
                                                style="backdrop-filter:blur(9.06px);clip-path:url(#bgblur_1_414_3976_clip_path);height:100%;width:100%">
                                            </div>
                                        </foreignObject>
                                        <rect data-figma-bg-blur-radius="18.1166" y="40" width="40" height="40"
                                            transform="rotate(-90 0 40)" fill="#191C20" />
                                        <path d="M13 20L27 20" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M19 26L13 20L19 14" stroke="white" stroke-width="2.64201"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </g>
                                    <defs>
                                        <clipPath transform="translate(18.1166 18.1166)">
                                            <rect y="40" width="40" height="40" transform="rotate(-90 0 40)" />
                                        </clipPath>
                                        <clipPath>
                                            <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)"
                                                fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <div class="levelup-format-slider-nav-next">
                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_414_3980)">
                                        <foreignObject x="-18.1166" y="-18.1166" width="76.2332" height="76.2332">
                                            <div xmlns="http://www.w3.org/1999/xhtml"
                                                style="backdrop-filter:blur(9.06px);clip-path:url(#bgblur_1_414_3980_clip_path);height:100%;width:100%">
                                            </div>
                                        </foreignObject>
                                        <rect data-figma-bg-blur-radius="18.1166" x="40" y="1.74846e-06" width="40" height="40"
                                            transform="rotate(90 40 1.74846e-06)" fill="#191C20" />
                                        <path d="M27 20L13 20" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M21 14L27 20L21 26" stroke="white" stroke-width="2.64201"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </g>
                                    <defs>
                                        <clipPath transform="translate(18.1166 18.1166)">
                                            <rect x="40" y="1.74846e-06" width="40" height="40"
                                                transform="rotate(90 40 1.74846e-06)" />
                                        </clipPath>
                                        <clipPath>
                                            <rect x="40" y="1.74846e-06" width="40" height="40" rx="20"
                                                transform="rotate(90 40 1.74846e-06)" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-levelup-schedule', {
        label: 'LevelUp schedule (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-levelup-schedule main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Расписание практических эфиров</h2>
                    <div class="levelup-schedule-slider noselect">
                        <div class="levelup-schedule-slider-item">
                            <div class="levelup-schedule-slider-item-labels careerum-flex-fsc">
                                <div class="levelup-schedule-slider-item-label blue careerum-flex-cc">
                                    <p>5 марта</p>
                                </div>
                                <div class="levelup-schedule-slider-item-label white careerum-flex-cc">
                                    <img src="https://cdn.careerum.com/1770212009713-DgqMZ-Vide.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1770212021164-hehbm-Vide.svg" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                            </div>
                            <p class="levelup-schedule-slider-item-subheader">Групповой практикум № 1</p>
                            <p class="levelup-schedule-slider-item-header">Как найти и присвоить свои суперсилы для мастер-файла
                            </p>
                            <p class="levelup-schedule-slider-item-text">Что сделаете:</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1770204905749-kMztj-Soft.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1770204882485-L0GrS-Soft.svg" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                    <p>Заполните раздел «Таланты» и «Достижения» в Мастер-файле, отделив факты от голоса
                                        Внутреннего Критика, и получите внешнее подтверждение своей ценности от группы
                                        и эксперта</p>
                                </li>
                            </ul>
                        </div>
                        <div class="levelup-schedule-slider-item">
                            <div class="levelup-schedule-slider-item-labels careerum-flex-fsc">
                                <div class="levelup-schedule-slider-item-label blue careerum-flex-cc">
                                    <p>19 марта</p>
                                </div>
                                <div class="levelup-schedule-slider-item-label white careerum-flex-cc">
                                    <img src="https://cdn.careerum.com/1770212009713-DgqMZ-Vide.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1770212021164-hehbm-Vide.svg" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                            </div>
                            <p class="levelup-schedule-slider-item-subheader">Групповые разборы кейсов</p>
                            <p class="levelup-schedule-slider-item-header">Q&A сессия по блоку 1</p>
                        </div>
                        <div class="levelup-schedule-slider-item">
                            <div class="levelup-schedule-slider-item-labels careerum-flex-fsc">
                                <div class="levelup-schedule-slider-item-label blue careerum-flex-cc">
                                    <p>24 марта</p>
                                </div>
                                <div class="levelup-schedule-slider-item-label white careerum-flex-cc">
                                    <img src="https://cdn.careerum.com/1770212009713-DgqMZ-Vide.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1770212021164-hehbm-Vide.svg" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                            </div>
                            <p class="levelup-schedule-slider-item-subheader">Групповой практикум № 2</p>
                            <p class="levelup-schedule-slider-item-header">Валидация карьерных гипотез для рынка РФ</p>
                            <p class="levelup-schedule-slider-item-text">Что сделаете:</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1770204905749-kMztj-Soft.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1770204882485-L0GrS-Soft.svg" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                    <p>Детальный анализ, проверка и отсев карьерных гипотез, в результате чего выявление
                                        топ 3 перспективных и желаемых карьерных роли.</p>
                                </li>
                            </ul>
                        </div>
                        <div class="levelup-schedule-slider-item">
                            <div class="levelup-schedule-slider-item-labels careerum-flex-fsc">
                                <div class="levelup-schedule-slider-item-label blue careerum-flex-cc">
                                    <p>26 марта</p>
                                </div>
                                <div class="levelup-schedule-slider-item-label white careerum-flex-cc">
                                    <img src="https://cdn.careerum.com/1770212009713-DgqMZ-Vide.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1770212021164-hehbm-Vide.svg" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                            </div>
                            <p class="levelup-schedule-slider-item-subheader">Групповой практикум № 3</p>
                            <p class="levelup-schedule-slider-item-header">Валидация карьерных гипотез для Global рынка</p>
                            <p class="levelup-schedule-slider-item-text">Что сделаете:</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1770204905749-kMztj-Soft.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1770204882485-L0GrS-Soft.svg" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                    <p>Детальный анализ, проверка и отсев карьерных гипотез, в результате чего выявление
                                        топ 3 перспективных и желаемых карьерных роли.</p>
                                </li>
                            </ul>
                        </div>
                        <div class="levelup-schedule-slider-item">
                            <div class="levelup-schedule-slider-item-labels careerum-flex-fsc">
                                <div class="levelup-schedule-slider-item-label blue careerum-flex-cc">
                                    <p>9 апреля</p>
                                </div>
                                <div class="levelup-schedule-slider-item-label white careerum-flex-cc">
                                    <img src="https://cdn.careerum.com/1770212009713-DgqMZ-Vide.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1770212021164-hehbm-Vide.svg" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                            </div>
                            <p class="levelup-schedule-slider-item-subheader">Групповые разборы кейсов</p>
                            <p class="levelup-schedule-slider-item-header">Q&A по блоку 2</p>
                        </div>
                        <div class="levelup-schedule-slider-item">
                            <div class="levelup-schedule-slider-item-labels careerum-flex-fsc">
                                <div class="levelup-schedule-slider-item-label blue careerum-flex-cc">
                                    <p>21 апреля</p>
                                </div>
                                <div class="levelup-schedule-slider-item-label white careerum-flex-cc">
                                    <img src="https://cdn.careerum.com/1770212009713-DgqMZ-Vide.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1770212021164-hehbm-Vide.svg" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                            </div>
                            <p class="levelup-schedule-slider-item-subheader">Групповой практикум № 4</p>
                            <p class="levelup-schedule-slider-item-header">«Прожарка» резюме для рынка РФ</p>
                            <p class="levelup-schedule-slider-item-text">Что сделаете:</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1770204905749-kMztj-Soft.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1770204882485-L0GrS-Soft.svg" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                    <p>Проведёте краш-тест вашего резюме/ LinkedIn профиля глазами рекрутера, чтобы устранить
                                        критические ошибки и повысить конверсию из отклика в приглашение на интервью</p>
                                </li>
                            </ul>
                        </div>
                        <div class="levelup-schedule-slider-item">
                            <div class="levelup-schedule-slider-item-labels careerum-flex-fsc">
                                <div class="levelup-schedule-slider-item-label blue careerum-flex-cc">
                                    <p>23 апреля</p>
                                </div>
                                <div class="levelup-schedule-slider-item-label white careerum-flex-cc">
                                    <img src="https://cdn.careerum.com/1770212009713-DgqMZ-Vide.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1770212021164-hehbm-Vide.svg" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                            </div>
                            <p class="levelup-schedule-slider-item-subheader">Групповой практикум № 5</p>
                            <p class="levelup-schedule-slider-item-header">«Прожарка» резюме и LinkedIn для Global рынка</p>
                            <p class="levelup-schedule-slider-item-text">Что сделаете:</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1770204905749-kMztj-Soft.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1770204882485-L0GrS-Soft.svg" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                    <p>Проведёте краш-тест вашего резюме/ LinkedIn профиля глазами рекрутера, чтобы устранить
                                        критические ошибки и повысить конверсию из отклика в приглашение на интервью</p>
                                </li>
                            </ul>
                        </div>
                        <div class="levelup-schedule-slider-item">
                            <div class="levelup-schedule-slider-item-labels careerum-flex-fsc">
                                <div class="levelup-schedule-slider-item-label blue careerum-flex-cc">
                                    <p>30 апреля</p>
                                </div>
                                <div class="levelup-schedule-slider-item-label white careerum-flex-cc">
                                    <img src="https://cdn.careerum.com/1770212009713-DgqMZ-Vide.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1770212021164-hehbm-Vide.svg" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                            </div>
                            <p class="levelup-schedule-slider-item-subheader">Групповые разборы кейсов</p>
                            <p class="levelup-schedule-slider-item-header">Q&A по блоку 3</p>
                        </div>
                    </div>
                    <div class="levelup-schedule-slider-nav careerum-flex-fec noselect">
                        <div class="levelup-schedule-slider-nav-prev">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_414_3976)">
                                    <foreignObject x="-18.1166" y="-18.1166" width="76.2332" height="76.2332">
                                        <div xmlns="http://www.w3.org/1999/xhtml"
                                            style="backdrop-filter:blur(9.06px);clip-path:url(#bgblur_1_414_3976_clip_path);height:100%;width:100%">
                                        </div>
                                    </foreignObject>
                                    <rect data-figma-bg-blur-radius="18.1166" y="40" width="40" height="40"
                                        transform="rotate(-90 0 40)" fill="#191C20" />
                                    <path d="M13 20L27 20" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M19 26L13 20L19 14" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath transform="translate(18.1166 18.1166)">
                                        <rect y="40" width="40" height="40" transform="rotate(-90 0 40)" />
                                    </clipPath>
                                    <clipPath>
                                        <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="levelup-schedule-slider-nav-next">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_414_3980)">
                                    <foreignObject x="-18.1166" y="-18.1166" width="76.2332" height="76.2332">
                                        <div xmlns="http://www.w3.org/1999/xhtml"
                                            style="backdrop-filter:blur(9.06px);clip-path:url(#bgblur_1_414_3980_clip_path);height:100%;width:100%">
                                        </div>
                                    </foreignObject>
                                    <rect data-figma-bg-blur-radius="18.1166" x="40" y="1.74846e-06" width="40" height="40"
                                        transform="rotate(90 40 1.74846e-06)" fill="#191C20" />
                                    <path d="M27 20L13 20" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M21 14L27 20L21 26" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath transform="translate(18.1166 18.1166)">
                                        <rect x="40" y="1.74846e-06" width="40" height="40"
                                            transform="rotate(90 40 1.74846e-06)" />
                                    </clipPath>
                                    <clipPath>
                                        <rect x="40" y="1.74846e-06" width="40" height="40" rx="20"
                                            transform="rotate(90 40 1.74846e-06)" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-levelup-pay', {
        label: 'LevelUp pay (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-levelup-pay main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Приобрести участие в программе с выгодой? </h2>
                    <div class="levelup-pay-slider noselect">
                        <div class="levelup-pay-slider-item">
                            <img loading="" src="https://cdn.careerum.com/1752746394899-9F8nI-Icon.svg" alt="img"
                                class="hidden-tablet-mobile" />
                            <img loading="" src="https://cdn.careerum.com/1752835423588-vEsmQ-Icon.svg" alt="img"
                                class="hidden-desc-tablet" />
                            <img loading="" src="https://cdn.careerum.com/1770291447327-PWStp-Icon.svg" alt="img"
                                class="hidden-desc-mobile" />
                            <p class="levelup-pay-item-title">Программа входит в подписку Careerum</p>
                            <p class="levelup-pay-item-text">Программа длится 3 месяца с 19 февраля по 31 апреля и входит в
                                подписку Careerum. Отдельно купить программу невозможно</p>
                        </div>
                        <div class="levelup-pay-slider-item">
                            <img loading="" src="https://cdn.careerum.com/1755802546412-qtSIZ-Calc.svg" alt="img"
                                class="hidden-tablet-mobile" />
                            <img loading="" src="https://cdn.careerum.com/1755804858534-T0J0V-Calc.svg" alt="img"
                                class="hidden-desc-tablet" />
                            <img loading="" src="https://cdn.careerum.com/1770291447029-zPzUG-Calc.svg" alt="img"
                                class="hidden-desc-mobile" />
                            <p class="levelup-pay-item-title">Самый выгодный вариант участия:</p>
                            <p class="levelup-pay-item-text">Единый платеж на 3, 6 или 12 месяцев. После окончания синхронного
                                обучения на программе, вы можете продолжить работу с экспертами и прохождение других обучающих
                                материалов на платформе</p>
                        </div>
                        <div class="levelup-pay-slider-item">
                            <img loading="" src="https://cdn.careerum.com/1752746395193-r9zAt-Icon.svg" alt="img"
                                class="hidden-tablet-mobile" />
                            <img loading="" src="https://cdn.careerum.com/1752835423464-bVrPv-Icon.svg" alt="img"
                                class="hidden-desc-tablet" />
                            <img loading="" src="https://cdn.careerum.com/1770291447214-eFkFN-Icon.svg" alt="img"
                                class="hidden-desc-mobile" />
                            <p class="levelup-pay-item-title">Если важно снизить размер платежа в месяц</p>
                            <p class="levelup-pay-item-text">Вам подойдет помесячная оплата. Чтобы участвовать в программе Level
                                UP, вам нужно будет каждый месяц продлевать подписку</p>
                        </div>
                        <div class="levelup-pay-slider-item">
                            <img loading="" src="https://cdn.careerum.com/1752746395305-NqD84-Icon.svg" alt="img"
                                class="hidden-tablet-mobile" />
                            <img loading="" src="https://cdn.careerum.com/1752835422963-nb4Zf-Icon.svg" alt="img"
                                class="hidden-desc-tablet" />
                            <img loading="" src="https://cdn.careerum.com/1770291447282-OLLt6-Icon.svg" alt="img"
                                class="hidden-desc-mobile" />
                            <p class="levelup-pay-item-title">Рассрочка</p>
                            <p class="levelup-pay-item-text">Действует на тарифы от 3 месяцев в рублях и евро</p>
                        </div>
                        <div class="levelup-pay-slider-item">
                            <img loading="" src="https://cdn.careerum.com/1752746394899-9F8nI-Icon.svg" alt="img"
                                class="hidden-tablet-mobile" />
                            <img loading="" src="https://cdn.careerum.com/1752835423588-vEsmQ-Icon.svg" alt="img"
                                class="hidden-desc-tablet" />
                            <img loading="" src="https://cdn.careerum.com/1770291447327-PWStp-Icon.svg" alt="img"
                                class="hidden-desc-mobile" />
                            <p class="levelup-pay-item-title">Чем дольше подписка, тем дешевле </p>
                            <p class="levelup-pay-item-text">Мы поддерживаем регулярное и системное развитие карьеры. Это наша
                                философия!</p>
                        </div>
                        <div class="levelup-pay-slider-item">
                            <img loading="" src="https://cdn.careerum.com/1755802559738-KpyHx-Curr.svg" alt="img"
                                class="hidden-tablet-mobile" />
                            <img loading="" src="https://cdn.careerum.com/1770291447130-Klpub-Curr.svg" alt="img"
                                class="hidden-desc-mobile" />
                            <img loading="" src="https://cdn.careerum.com/1770304312036-2OT8K-Curr.svg" alt="img"
                                class="hidden-desc-tablet" />
                            <p class="levelup-pay-item-title">Можно оплатить в ₽ и €</p>
                        </div>
                    </div>
                    <div class="levelup-pay-slider-nav careerum-flex-fec noselect">
                        <div class="levelup-pay-slider-nav-prev">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_414_3976)">
                                    <foreignObject x="-18.1166" y="-18.1166" width="76.2332" height="76.2332">
                                        <div xmlns="http://www.w3.org/1999/xhtml"
                                            style="backdrop-filter:blur(9.06px);clip-path:url(#bgblur_1_414_3976_clip_path);height:100%;width:100%">
                                        </div>
                                    </foreignObject>
                                    <rect data-figma-bg-blur-radius="18.1166" y="40" width="40" height="40"
                                        transform="rotate(-90 0 40)" fill="#191C20" />
                                    <path d="M13 20L27 20" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M19 26L13 20L19 14" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath transform="translate(18.1166 18.1166)">
                                        <rect y="40" width="40" height="40" transform="rotate(-90 0 40)" />
                                    </clipPath>
                                    <clipPath>
                                        <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="levelup-pay-slider-nav-next">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_414_3980)">
                                    <foreignObject x="-18.1166" y="-18.1166" width="76.2332" height="76.2332">
                                        <div xmlns="http://www.w3.org/1999/xhtml"
                                            style="backdrop-filter:blur(9.06px);clip-path:url(#bgblur_1_414_3980_clip_path);height:100%;width:100%">
                                        </div>
                                    </foreignObject>
                                    <rect data-figma-bg-blur-radius="18.1166" x="40" y="1.74846e-06" width="40" height="40"
                                        transform="rotate(90 40 1.74846e-06)" fill="#191C20" />
                                    <path d="M27 20L13 20" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M21 14L27 20L21 26" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath transform="translate(18.1166 18.1166)">
                                        <rect x="40" y="1.74846e-06" width="40" height="40"
                                            transform="rotate(90 40 1.74846e-06)" />
                                    </clipPath>
                                    <clipPath>
                                        <rect x="40" y="1.74846e-06" width="40" height="40" rx="20"
                                            transform="rotate(90 40 1.74846e-06)" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-levelup-author-popup', {
        label: 'LevelUp author popup (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-popup careerum-levelup-author-popup" id="pop4">
                <div class="popup__close-button-wrapper careerum-flex-cc">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
                        class="close-switch">
                        <path d="M1 1L14.9972 14.9936" stroke="#191C20" stroke-width="2" stroke-linecap="round" />
                        <path d="M15 1.00635L1.0028 14.9999" stroke="#191C20" stroke-width="2" stroke-linecap="round" />
                    </svg>
                </div>
                <div class="levelup-author-popup-content white position-relative z-10">
                    <ul>
                        <li>
                            <p class="levelup-author-title">MBA от INSEAD </p>
                            <p class="levelup-author-text">Магистратура по психологии в Harvard University</p>
                        </li>
                        <li>
                            <p class="levelup-author-title">Карьерный коуч и стратег</p>
                            <p class="levelup-author-text">С портфелем 13 000 клиентов из 60 стран</p>
                        </li>
                        <li>
                            <p class="levelup-author-title">Состоялась в разных форматах:</p>
                            <p class="levelup-author-text">Как сотрудник, эксперт-фрилансер и предприниматель</p>
                        </li>
                        <li>
                            <p class="levelup-author-title">Перепридумывала свою карьеру 7 раз: </p>
                            <p class="levelup-author-text">Из репетитора по языкам — в продажи и маркетинг — потом в стратегию — потом в свой бизнес</p>
                        </li>
                        <li>
                            <p class="levelup-author-title">Автор бестселлера </p>
                            <p class="levelup-author-text">МИФ «Работа по любви»</p>
                        </li>
                    </ul>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-levelup-banner', {
        label: 'LevelUp banner (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-levelup-banner main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="levelup-banner-bg position-relative z-1">
                        <img src="https://cdn.careerum.com/1771246874860-oaDPG-Grou.png"
                            class="hidden-tablet-mobile position-absolute" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1771247284848-NcP8k-Grou.png"
                            class="hidden-desc-mobile position-absolute" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1771247374561-bxOV4-Grou.png"
                            class="hidden-desc-tablet position-absolute" alt="img" loading="lazy">
                    </div>
                    <div class="levelup-banner-wrapper position-relative z-10 careerum-flex-sbfs">
                        <div class="levelup-banner-left">
                            <div class="levelup-banner-labels careerum-flex-fsfs">
                                <div class="levelup-banner-label blue">
                                    <p>18 февраля, 20:00 мск</p>
                                </div>
                                <div class="levelup-banner-label">
                                    <p>Всего 500 мест</p>
                                </div>
                            </div>
                            <h2>Разбор карьерных кейсов с Ольгой Лермонтовой в ZOOM</h2>
                            <p>Карьера зашла в тупик? Подскажем, где спрятан ваш рост!</p>
                            <a href="#" class="btn-color-main-black hidden-mobile">Зарегистрироваться</a>
                        </div>
                        <div class="levelup-banner-right">
                            <img src="https://cdn.careerum.com/1771246986411-fxiJa-Grou.png" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1771247314028-LynJe-Grou.png" class="hidden-desc-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1771247341343-2QvKj-Grou.png" class="hidden-desc-tablet"
                                alt="img" loading="lazy">
                        </div>
                        <a href="#" class="btn-color-main-black hidden-desc-tablet">Зарегистрироваться</a>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-candidate-main', {
        label: 'Candidate main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-candidate-main main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <div class="candidate-main-bg position-absolute z-1">
                        <img src="https://cdn.careerum.com/1772785558997-cPxjS-Fram.svg"
                            class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1772785579955-xnw6O-Fram.svg"
                            class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1772785606324-Z6hUl-Fram.svg"
                            class="hidden-desc-tablet position-absolute z-1" alt="img" loading="lazy">
                    </div>
                    <div class="candidate-main-wrapper position-relative z-10">
                        <div class="candidate-main-label-wrapper careerum-flex-fsfs">
                            <div class="candidate-main-label careerum-flex-fsc">
                                <img src="https://cdn.careerum.com/1772785487007-tlknE-Cale.svg" class="hidden-tablet" alt="img"
                                    loading="lazy">
                                <img src="https://cdn.careerum.com/1772785512982-FxJvo-Cale.svg" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <p>Старт: в любое время</p>
                            </div>
                        </div>
                        <h1>Звездный кандидат</h1>
                        <p class="candidate-main-description"><span>Программа по системному поиску работы,</span>
                            после которой
                            не вы бегаете за вакансиями — <span>а работодатели конкурируют за вас</span></p>
                        <p class="candidate-main-subheader">Результаты:</p>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1770201911234-trUO9-Soft.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770202010450-hGxBc-Soft.svg" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770293890944-TJSZM-Soft.png" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                                <p><span>Стратегия поиска работы, заточенная под вашу цель:</span> роль, рынок, уровень дохода
                                </p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1770201911234-trUO9-Soft.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770202010450-hGxBc-Soft.svg" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770293890944-TJSZM-Soft.png" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                                <p><span>Сильный профессиональный профиль:</span> резюме, Linkedin, сопроводительные письма</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1770201911234-trUO9-Soft.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770202010450-hGxBc-Soft.svg" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1770293890944-TJSZM-Soft.png" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                                <p><span>Навык вести собеседования и переговоры</span> так, чтобы выбирали ВЫ, а не вас</p>
                            </li>
                        </ul>
                        <a href="#" class="btn-color-main-black">Посмотреть программу</a>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-candidate-foryou', {
        label: 'Candidate foryou (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-candidate-foryou main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Стоит участвовать, если:</h2>
                    <div class="candidate-foryou-wrapper">
                        <div class="candidate-foryou-header orange position-relative">
                            <p class="position-relative z-10">У вас горит поиск работы</p>
                            <img src="https://cdn.careerum.com/1772789796947-0Lcbk-Grou.svg"
                                class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1772793319048-6ivG3-Grou.svg" class="hidden-desc-mobile position-absolute z-1" alt="img"
                                loading="lazy">
                            <img src="https://cdn.careerum.com/1772795159807-TenCA-Grou.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                                loading="lazy">
                        </div>
                        <div class="candidate-foryou-items row careerum-flex-sbst">
                            <div class="candidate-foryou-item">
                                <p class="candidate-foryou-item-header">Давно без работы. Подушка кончается/оффера нет/виза
                                    под угрозой</p>
                                <p class="candidate-foryou-item-text">Поиск из паники почти всегда ведёт в роль ниже уровня,
                                    в слабую компанию или в новую точку выгорания.<br><br>На программе:<br>— выстроите
                                    антикризисную стратегию<br>— приоритизируете роли<br>— усилите
                                    позиционирование<br>— ускорите воронку откликов<br>— дойдёте до оффера без отката в карьере
                                </p>
                            </div>
                            <div class="candidate-foryou-item">
                                <p class="candidate-foryou-item-header">Рынок стал жёстче</p>
                                <p class="candidate-foryou-item-text">Массовые сокращения, снижение зарплат, минимальные бюджеты
                                    на найм, AI-фильтры, закрытые реферальные круги. Вам не кажется — рынок действительно стал
                                    жёстче.<br><br>На программе:<br>— определите свою целевую роль<br>— адаптируете резюме
                                    под вакансии<br>— перейдёте от массовых откликов к целевым действиям<br>— настроите LinkedIn
                                    под алгоритмы рекрутеров<br>— сформулируете аргументацию по уровню и вилке</p>
                            </div>
                            <div class="candidate-foryou-item">
                                <p class="candidate-foryou-item-header">Сократили. Увольнение как будто обнулило ваш опыт</p>
                                <p class="candidate-foryou-item-text">Если опыт не упакован — вы выглядите как «сокращённый
                                    сотрудник», а не как кандидат следующего уровня.<br><br>На программе:<br>— зафиксируете
                                    измеримые результаты и масштаб влияния<br>— пересоберете позиционирование под уровень выше,
                                    а не «как было»<br>— сформулируете историю увольнения без оправданий и потери статуса</p>
                            </div>
                        </div>
                        <div class="candidate-foryou-header blue position-relative">
                            <p class="position-relative z-10">Не умеете упаковывать и продавать свой опыт</p>
                            <img src="https://cdn.careerum.com/1772789522901-fesp6-Grou.svg"
                                class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1772793347207-25M4F-Grou.png" class="hidden-desc-mobile position-absolute z-1" alt="img"
                                loading="lazy">
                            <img src="https://cdn.careerum.com/1772795177846-7vdGy-Grou.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                                loading="lazy">
                        </div>
                        <div class="candidate-foryou-items careerum-flex-sbst">
                            <div class="candidate-foryou-item">
                                <p class="candidate-foryou-item-header">Сильный опыт, но резюме не передаёт и 20% того,
                                    что вы реально сделали</p>
                                <p class="candidate-foryou-item-text">Рекрутер смотрит резюме 6–8 секунд. Если в нём нет цифр
                                    и уровня задач — ваш опыт обесценивается автоматически.<br><br>На программе:<br>— переведёте
                                    обязанности в измеримые результаты<br>— зафиксируете масштаб:
                                    бюджет/команда/рынок/влияние<br>— cформируете чёткое value proposition под конкретную
                                    роль<br>— соберёте резюме, LinkedIn и интервью в одну стратегию, чтобы рынок видел не список
                                    функций, а уровень ответственности и влияния</p>
                            </div>
                            <div class="candidate-foryou-item">
                                <p class="candidate-foryou-item-header">Слишком разноплановый опыт? Считаете это минусом</p>
                                <p class="candidate-foryou-item-text">Если опыт описан как набор разных ролей — он выглядит
                                    размытым, а работодатель покупает решение конкретной
                                    задачи.<br><br>На программе:<br>— сгруппируете опыт вокруг одной логики, а не хронологии.
                                    Чтобы ваш профиль выглядел не «я делал(а) всё», а «я решаю задачи этого уровня»<br>— уберёте
                                    лишнее, усилите релевантное<br>— сформируете понятное предложение для работодателя.</p>
                            </div>
                            <div class="candidate-foryou-item">
                                <p class="candidate-foryou-item-header">У вас ничего не работает. Отклики уходят — в ответ
                                    тишина</p>
                                <p class="candidate-foryou-item-text">Резюме не проходит первичный скрининг. Отклики
                                    отправляются без чёткой роли. Вилка не совпадает с уровнем позиции. Аргументация на интервью
                                    размыта.<br><br>На программе:<br>— найдёте, где именно ломается ваш поиск: позиционирование,
                                    роль, вилка, аргументация, презентация опыта<br>— перестроите поиск так, чтобы отклики
                                    превращались в интервью, а интервью — в офферы</p>
                            </div>
                            <div class="candidate-foryou-item">
                                <p class="candidate-foryou-item-header">Систематически «продаёте» себя дешевле, а потом
                                    работаете с ощущением «стою дороже в 1,5–2 раза»</p>
                                <p class="candidate-foryou-item-text">Проблема не в «жадности работодателей». Проблема
                                    в отсутствии стратегии переговоров.<br><br>На программе:<br>— определите рыночный диапазон
                                    вашей роли<br>— зафиксируете минимально приемлемую планку<br>— выстроите аргументацию
                                    по уровню и вкладу<br>— отработаете сценарии переговоров до оффера<br>— научитесь проводить
                                    переговоры по офферу на ваших условиях и получать повышение зарплаты в 2 раза</p>
                            </div>
                        </div>
                        <div class="candidate-foryou-header light position-relative">
                            <p class="position-relative z-10">Вы ищете работу на международном рынке</p>
                            <img src="https://cdn.careerum.com/1772789556364-pyeXG-Grou.png"
                                class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1772793358651-3ujEQ-Grou.png" class="hidden-desc-mobile position-absolute z-1" alt="img"
                                loading="lazy">
                            <img src="https://cdn.careerum.com/1772795188252-UKkqJ-Grou.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                                loading="lazy">
                        </div>
                        <div class="candidate-foryou-items row careerum-flex-sbst">
                            <div class="candidate-foryou-item">
                                <p class="candidate-foryou-item-header">Вы начали строить карьеру за рубежом, и ваши
                                    10‑15 лет RU-экспертизы как будто обесценились</p>
                                <p class="candidate-foryou-item-text">На программе:<br>— вернёте профессиональную идентичность<br>— переведёте ваш опыт на язык нового рынка<br>— научитесь выходить на нанимающих менеджеров напрямую, минуя AI-фильтры, которые вас отсеивают</p>
                            </div>
                            <div class="candidate-foryou-item">
                                <p class="candidate-foryou-item-header">Вам нужна экспертиза поиска на конкретном рынке</p>
                                <p class="candidate-foryou-item-text">53% наших клиентов работают на международном рынке
                                    и получили офферы в 60+ странах. Наши эксперты работают с рынками: ЕС, США, Канада,
                                    Великобритания, ОАЭ, МENA, LATAM, APAC</p>
                            </div>
                            <div class="candidate-foryou-item">
                                <p class="candidate-foryou-item-header">Вы готовитесь к релокации</p>
                                <p class="candidate-foryou-item-text">Поиск в новой стране — это не просто перевод резюме
                                    на английский. Меняются: требования к формату CV и объёму, логика описания достижений,
                                    ожидания по вилке и грейду, отношение к визовому статусу, роль рефералов и локального
                                    нетворкинга.<br><br>
                                    Если не учесть это заранее, поиск затягивается на месяцы.<br><br>
                                    На программе:<br>— адаптируете резюме, сопроводительные и LinkedIn под конкретный
                                    рынок<br>— зафиксируете реалистичную роль и диапазон зарплаты - оцените визовые ограничения
                                    и стратегию входа — выстроите план выхода на локальных работодателей</p>
                            </div>
                        </div>
                        <div class="candidate-foryou-header violet position-relative">
                            <p class="position-relative z-10">Страшно искать работу</p>
                            <img src="https://cdn.careerum.com/1772789613815-tLaeb-Grou.svg"
                                class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1772793368514-borAy-Grou.png" class="hidden-desc-mobile position-absolute z-1" alt="img"
                                loading="lazy">
                            <img src="https://cdn.careerum.com/1772795198529-ugp8D-Grou.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                                loading="lazy">
                        </div>
                        <div class="candidate-foryou-items row careerum-flex-sbst">
                            <div class="candidate-foryou-item">
                                <p class="candidate-foryou-item-header">У вас нет времени и вы в стрессе от поиска</p>
                                <p class="candidate-foryou-item-text">Хаотичный поиск отнимает часы: скроллинг вакансий,
                                    спонтанные отклики, переписывание резюме под каждую позицию. При этом нет системныи
                                    нет понимания, что именно даёт результат. Стресс возникает не из-за объёма задач, а из-за
                                    отсутствия структуры.<br><br>На программе:<br>— выстроите системную воронку
                                    поиска<br>— определите приоритетные каналы, а не «всё сразу»<br>— запланируете 3–4 часа
                                    в неделю на конкретные действия</p>
                            </div>
                            <div class="candidate-foryou-item">
                                <p class="candidate-foryou-item-header">AI-трансформация мира тревожит: ваши hard-скиллы
                                    заменяемы</p>
                                <p class="candidate-foryou-item-text">Если ваш профиль описан как набор инструментов —
                                    он конкурирует с ИИ.Если как уровень мышления и ответственности — он выходит за пределы
                                    автоматизации.<br><br>На программе:<br>— переведете hard-скиллы в уровень задач
                                    и решений<br>— усилите управленческую и стратегическую компоненту профиля<br>— сформируете
                                    позиционирование «выше функции»<br>— определите, какие навыки усиливать, чтобы не выпадать
                                    из рынка</p>
                            </div>
                            <div class="candidate-foryou-item">
                                <p class="candidate-foryou-item-header">Сомневаетесь в себе после декрета / длительной паузы
                                    и финансово зависите от партнёра</p>
                                <p class="candidate-foryou-item-text"> Рынок оценивает не факт перерыва, а то, как вы его
                                    объясняете и чем закрываете.<br><br>На программе:<br>— сформулируете объяснение перерыва
                                    без оправданий<br>— поймёте, какие навыки и ответственность
                                    у вас сохранились<br>— определите реалистичную роль входа (без отката
                                    на 2–3 грейда)<br>— пересоберете резюме и под текущие требования рынка</p>
                            </div>
                        </div>
                        <div class="candidate-foryou-header orange position-relative">
                            <p class="position-relative z-10">Вы боитесь, что уже поздно<br> что-то менять</p>
                            <img src="https://cdn.careerum.com/1772789676852-7kqeP-Grou.svg"
                                class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1772793381088-RkChf-Grou.png" class="hidden-desc-mobile position-absolute z-1" alt="img"
                                loading="lazy">
                            <img src="https://cdn.careerum.com/1772795207749-GGWvl-Grou.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                                loading="lazy">
                        </div>
                        <div class="candidate-foryou-items careerum-flex-sbst">
                            <div class="candidate-foryou-item">
                                <p class="candidate-foryou-item-header">Вам 40+ / 45+ — может, уже поздно?</p>
                                <p class="candidate-foryou-item-text">Если профиль описан как «20 лет стажа» —
                                    это воспринимается как кандидат без фокуса. Если профиль собран вокруг конкретной экспертизы
                                    и масштаба решений — возраст становится вашим активом.<br><br>На программе:<br>— уберете
                                    из позиционирования «длинный стаж» как главный аргумент<br>— зафиксируете нишевую экспертизу
                                    и уровень ответственности<br>— адаптируете стратегию поиска под зрелый грейд,
                                    а не middle-рынок</p>
                            </div>
                            <div class="candidate-foryou-item">
                                <p class="candidate-foryou-item-header">10 лет в одной компании и не знаете, как начать поиск
                                    новой работы</p>
                                <p class="candidate-foryou-item-text">Ваше резюме отражает внутреннюю карьеру, а не конкурентный
                                    профиль, а рынок изменился:<br>— другие форматы CV<br>— другая логика интервью<br>— жёстче
                                    конкуренция и фильтры.<br><br>На программе:<br>— проведёте внешнюю оценку вашего уровня
                                    и рыночной позиции<br>— пересоберете резюме под открытый рынок, а не под внутренний
                                    рост<br>— сформулируете чёткую целевую роль<br>— создадите аргументацию, понятную рекрутеру
                                    за первые 30 секунд</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-club0326-main', {
        label: 'Club 0326 main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club0326-main main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <div class="club0326-main-header position-relative z-20">
                        <h1 class="position-relative z-10">Careerum</h1>
                        <p class="club0326-main-subheader position-absolute z-20">Клуб и платформа карьерного развития</p>
                    </div>
                    <p class="club0326-main-text">Помогаем зрелым специалистам и руководителям выстроить карьерную стратегию</p>
                    <div class="careerum-flex-fsst club0326-main-tales">
                        <div class="club0326-main-tale">
                            <p class="club0326-main-tale-header">Рост, повышение</p>
                            <p class="club0326-main-tale-text">Хотите вырасти в роли и доходе</p>
                        </div>
                        <div class="club0326-main-tale">
                            <p class="club0326-main-tale-header">Оффер</p>
                            <p class="club0326-main-tale-text">Сложности с поиском работы</p>
                        </div>
                        <div class="club0326-main-tale">
                            <p class="club0326-main-tale-header">Ясность и план</p>
                            <p class="club0326-main-tale-text">Не знаете, какая работа вам нужна</p>
                        </div>
                        <div class="club0326-main-tale">
                            <p class="club0326-main-tale-header">Релокация</p>
                            <p class="club0326-main-tale-text">Планируете выходить на международку</p>
                        </div>
                    </div>
                    <p class="club0326-main-text">Рынки, с которыми мы работаем:</p>
                    <div class="careerum-flex-fsc club0326-main-regions">
                        <p>РФ</p>
                        <p>СНГ</p>
                        <p>ЕС</p>
                        <p>DACH</p>
                        <p>США</p>
                        <p>ОАЭ</p>
                        <p>JАРАС</p>
                        <p>MENA</p>
                        <p>LATAM</p>
                        <p>КАНАДА</p>
                        <p>UK&I</p>
                        <p>BALTICS</p>
                    </div>
                    <a href="#buy" class="btn-color-main-black getparams">Заполнить анкету в Careerum</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-club0326-strategies', {
        label: 'Club 0326 strategies (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club0326-strategies main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="club0326-strategies-header position-relative">
                        <h2 class="position-relative z-10">10 стратегий</h2>
                        <p class="position-relative z-10">Которые вы сможете реализовать с нами</p>
                        <img src="https://cdn.careerum.com/1773393841687-Gk9kU-Gene.png"
                            class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1773393864169-QJxDE-Gene.png"
                            class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1773393707810-0JHvc-Gene.png"
                            class="hidden-desc-tablet position-absolute z-1" alt="img" loading="lazy">
                    </div>
                    <div class="club0326-strategies-list careerum-flex-sbfs">
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1773304635539-j244w-Chec.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1773304637482-Op28h-Chec.svg" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1773304639172-SMfLj-Chec.svg" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                                <p>Поиск работы с ростом зарплаты</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1773304635539-j244w-Chec.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1773304637482-Op28h-Chec.svg" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1773304639172-SMfLj-Chec.svg" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                                <p>Поиск работы в новой стране</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1773304635539-j244w-Chec.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1773304637482-Op28h-Chec.svg" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1773304639172-SMfLj-Chec.svg" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                                <p>Выход на международный рынок</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1773304635539-j244w-Chec.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1773304637482-Op28h-Chec.svg" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1773304639172-SMfLj-Chec.svg" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                                <p>Рост в руководящую/новую роль</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1773304635539-j244w-Chec.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1773304637482-Op28h-Chec.svg" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1773304639172-SMfLj-Chec.svg" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                                <p>Переход в новую сферу без потери дохода</p>
                            </li>
                        </ul>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1773304635539-j244w-Chec.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1773304637482-Op28h-Chec.svg" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1773304639172-SMfLj-Chec.svg" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                                <p>Адаптация карьеры к эпохе AI</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1773304635539-j244w-Chec.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1773304637482-Op28h-Chec.svg" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1773304639172-SMfLj-Chec.svg" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                                <p>Выход из найма и создание портфельной карьеры</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1773304635539-j244w-Chec.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1773304637482-Op28h-Chec.svg" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1773304639172-SMfLj-Chec.svg" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                                <p>Выход из токсичной рабочей среды и выгорания</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1773304635539-j244w-Chec.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1773304637482-Op28h-Chec.svg" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1773304639172-SMfLj-Chec.svg" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                                <p>Пересборка разнородного опыта в сильный проф.профиль</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1773304635539-j244w-Chec.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1773304637482-Op28h-Chec.svg" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1773304639172-SMfLj-Chec.svg" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                                <p>Возращение в карьеру после перерыва в работе или декрета</p>
                            </li>
                        </ul>
                    </div>
                    <div class="club0326-strategies-tales careerum-flex-sbst">
                        <div class="club0326-strategies-tale light">
                            <div class="careerum-flex-fsfs position-relative">
                                <p class="club0326-strategies-tale-header">6 000+</p>
                                <p class="club0326-strategies-tale-label position-relative">
                                    Офферов</p>
                            </div>
                            <p class="club0326-strategies-tale-text">Получили наши клиенты
                                по всему миру </p>
                        </div>
                        <div class="club0326-strategies-tale medium">
                            <div class="careerum-flex-fsfs position-relative">
                                <p class="club0326-strategies-tale-header">1,5+ раза</p>
                                <p class="club0326-strategies-tale-label position-relative">Средний рост ЗП</p>
                            </div>
                            <p class="club0326-strategies-tale-text">Средний рост зарплаты с Careerum</p>
                        </div>
                        <div class="club0326-strategies-tale medium-dark">
                            <div class="careerum-flex-fsfs position-relative">
                                <p class="club0326-strategies-tale-header">230 +</p>
                                <p class="club0326-strategies-tale-label position-relative">
                                    Релокаций</p>
                            </div>
                            <p class="club0326-strategies-tale-text">Даже в кризисы</p>
                        </div>
                        <div class="club0326-strategies-tale dark">
                            <div class="careerum-flex-fsfs position-relative">
                                <p class="club0326-strategies-tale-header">450%</p>
                                <p class="club0326-strategies-tale-label position-relative">
                                    Рекорд повышения</p>
                            </div>
                            <p class="club0326-strategies-tale-text">Повышения зарплаты вместе<br>
                                с Careerum </p>
                        </div>
                    </div>
                    <a href="#buy" class="btn-color-main-black getparams">Хочу разбор стратегии</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-club0326-system', {
        label: 'Club 0326 system (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club0326-system main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="club0326-system-header position-relative">
                        <h2 class="position-relative z-10">Система вашей карьерной трансформации</h2>
                        <img src="https://cdn.careerum.com/1773394085572-hD7mj-Grou.svg"
                            class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1773395659007-U0Tbp-Grou.svg"
                            class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1773396078793-ylFDf-Grou.svg"
                            class="hidden-desc-tablet position-absolute z-1" alt="img" loading="lazy">
                    </div>
                    <div class="club0326-system-bottom">
                        <div class="club0326-system-bottom-items-wrapper careerum-flex-sbfs">
                            <div class="club0326-system-bottom-items">
                                <div class="club0326-system-bottom-item careerum-flex-fsfs">
                                    <p class="club0326-system-bottom-item-number">(
                                        1 )</p>
                                    <div>
                                        <p class="club0326-system-bottom-item-header">Аудит опыта</p>
                                        <p class="club0326-system-bottom-item-text">Проведёте аудит накопленного опыта за годы
                                            карьеры</p>
                                    </div>
                                </div>
                                <div class="club0326-system-bottom-item careerum-flex-fsfs">
                                    <p class="club0326-system-bottom-item-number">(
                                        2 )</p>
                                    <div>
                                        <p class="club0326-system-bottom-item-header">Карьерная цель</p>
                                        <p class="club0326-system-bottom-item-text">Определите следующий шаг на локальном или
                                            глобальном рынке: рост внутри компании, смена траектории или поиск новой работы</p>
                                    </div>
                                </div>
                                <div class="club0326-system-bottom-item careerum-flex-fsfs">
                                    <p class="club0326-system-bottom-item-number">(
                                        3 )</p>
                                    <div>
                                        <p class="club0326-system-bottom-item-header">Сильный профиль профессионала</p>
                                        <p class="club0326-system-bottom-item-text">Переупакуете свой опыт под следующий шаг:
                                            сильное резюме, Linkedin-профиль, 100% готовность к прохождению интервью любой
                                            сложности</p>
                                    </div>
                                </div>
                            </div>
                            <div class="club0326-system-bottom-items">
                                <div class="club0326-system-bottom-item careerum-flex-fsfs">
                                    <p class="club0326-system-bottom-item-number">(
                                        4 )</p>
                                    <div>
                                        <p class="club0326-system-bottom-item-header">Понимание рынка</p>
                                        <p class="club0326-system-bottom-item-text">Научитесь определять потребности рынка,
                                            руководителя и топ-менеджмента компании</p>
                                    </div>
                                </div>
                                <div class="club0326-system-bottom-item careerum-flex-fsfs">
                                    <p class="club0326-system-bottom-item-number">(
                                        5 )</p>
                                    <div>
                                        <p class="club0326-system-bottom-item-header">Работа с профессиональной самооценкой</p>
                                        <p class="club0326-system-bottom-item-text">Вернете себе ощущение профессиональной
                                            ценности, избавитесь от синдрома самозванца</p>
                                    </div>
                                </div>
                                <div class="club0326-system-bottom-item careerum-flex-fsfs">
                                    <p class="club0326-system-bottom-item-number">(
                                        6 )</p>
                                    <div>
                                        <p class="club0326-system-bottom-item-header">Карьерная стратегия</p>
                                        <p class="club0326-system-bottom-item-text">Создадите карьерную стратегию на основе
                                            своих целей, опыта, профессиональных ценностей, талантов и сильных сторон</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="club0326-system-bottom-bonus">
                            <div class="club0326-system-bottom-bonus-top careerum-flex-fsc position-relative z-10">
                                <img loading="lazy" src="https://cdn.careerum.com/1770297790095-KQ7uc-12.p.png" alt="img"
                                    class="hidden-mobile">
                                <img loading="lazy" src="https://cdn.careerum.com/1770297843368-b2YoO-(1)..png" alt="img"
                                    class="hidden-desc-tablet">
                                <p>Оффер</p>
                            </div>
                            <div class="club0326-system-bottom-bonus-bottom position-relative z-1">
                                <p>Найдете не просто «новую работу», а новый профессиональный уровень, который
                                    соответствует вашему опыту, ценностям и потенциалу</p>
                            </div>
                        </div>
                    </div>
                    <a href="#buy" class="btn-color-main-black getparams">Хочу разбор стратегии</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-club0326-club', {
        label: 'Club 0326 club (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club0326-club main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <div class="club0326-club-header position-relative">
                        <h2 class="position-relative z-10"><span>Careerum</span> — это закрытый клуб для профессионалов </h2>
                        <p class="club0326-club-text position-relative z-10">Попасть к нам можно только через анкету и
                            диагностику вашего карьерного
                            кейса</p>
                        <img src="https://cdn.careerum.com/1773394581868-9IRyh-Grou.png"
                            class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1773395831132-qpXL0-Grou.png"
                            class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1773318415107-hWBPd-Grou.svg"
                            class="hidden-desc-tablet position-absolute z-1" alt="img" loading="lazy">
                    </div>
                    <div class="club0326-club-header2 position-relative">
                        <h2 class="position-relative z-10 hidden-mobile">Попасть в Careerum можно только <span class="position-relative z-10">через анкету и диагностику</span> вашего карьерного кейса</h2>
                        <h2 class="position-relative z-10 hidden-desc-tablet">Попасть в Careerum можно <span class="position-relative z-10">только через анкету</span> и <span class="position-relative z-10">диагностику</span> вашего карьерного кейса</h2>
                        <img src="https://cdn.careerum.com/1780389142046-cBRzR-Fram.png"
                            class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1780389143353-eubwF-Fram.png"
                            class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1780389144988-bL1Ew-Grou.png"
                            class="hidden-desc-tablet position-absolute z-1" alt="img" loading="lazy">
                    </div>
                    <div class="club0326-club-bottom">
                        <p class="club0326-club-subheader">Как мы принимаем решение по каждой анкете:</p>
                        <ul class="careerum-flex-sbfs">
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1773307481862-tH9FX-Chec.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1773307483468-VnsUY-Chec.svg" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1773316970454-ShO1S-Chec.svg" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                                <p><span>Мэтч по экспертизе:</span> лежит ли ваш запрос в зоне нашей компетенции и уверены ли
                                    мы, что сможем дать вам результат</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1773307481862-tH9FX-Chec.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1773307483468-VnsUY-Chec.svg" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1773316970454-ShO1S-Chec.svg" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                                <p><span>Готовность к изменениям:</span> нам важно, чтобы вы были готовы внедрять стратегию
                                    и действовать, а не просто наблюдать</p>
                            </li>
                        </ul>
                        <a href="#buy" class="btn-color-main-black getparams">Анкета на диагностику </a>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-club0326-selection', {
        label: 'Club 0326 selection (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club0326-selection main-wrapper">
                <div class="careerum-container-responsive">
                    <div class=" careerum-flex-sbst">
                        <div class="club0326-selection-left position-relative">
                            <h2>Если вы прошли отбор в клуб!</h2>
                            <img src="https://cdn.careerum.com/1773308282565-IJTHF-Grou.png"
                                class="hidden-tablet-mobile position-absolute" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1773313000321-b4aCf-Grou.png"
                                class="hidden-desc-mobile position-absolute" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1773317292987-gdRN9-Grou.png"
                                class="hidden-desc-tablet position-absolute" alt="img" loading="lazy">
                        </div>
                        <div class="club0326-selection-right">
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1773307483468-VnsUY-Chec.svg"
                                        class="hidden-tablet-mobile" alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1773307485241-6AZPB-Chec.svg" class="hidden-desc"
                                        alt="img" loading="lazy">
                                    <p>Вы получаете приглашение в клуб. На принятие решения у вас будет 24 часа</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1773307483468-VnsUY-Chec.svg"
                                        class="hidden-tablet-mobile" alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1773307485241-6AZPB-Chec.svg" class="hidden-desc"
                                        alt="img" loading="lazy">
                                    <p>Ставим цели на работу в клубе</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1773307483468-VnsUY-Chec.svg"
                                        class="hidden-tablet-mobile" alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1773307485241-6AZPB-Chec.svg" class="hidden-desc"
                                        alt="img" loading="lazy">
                                    <p>Формируем для вас персональный образовательный трек на платформе</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1773307483468-VnsUY-Chec.svg"
                                        class="hidden-tablet-mobile" alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1773307485241-6AZPB-Chec.svg" class="hidden-desc"
                                        alt="img" loading="lazy">
                                    <p>Назначаем установочную сессию с карьерным экспертом</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1773307483468-VnsUY-Chec.svg"
                                        class="hidden-tablet-mobile" alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1773307485241-6AZPB-Chec.svg" class="hidden-desc"
                                        alt="img" loading="lazy">
                                    <p>Получаете доступ в закрытое профессиональное комьюнити</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <a href="#buy" class="btn-color-main-black getparams">Анкета на диагностику </a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-veb0326-main', {
        label: 'Veb 0326 main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-veb0326-main main-wrapper">
                <div class="careerum-container-responsive careerum-flex-sbfs">
                    <div class="veb0326-main-left">
                        <div class="veb0326-main-labels careerum-flex-fsfs">
                            <div class="veb0326-main-label blue careerum-flex-cc">
                                <p>Лекция Ольги Лермонтовой</p>
                            </div>
                        </div>
                        <h1>Карьерная перезагрузка <span>2026</span></h1>
                        <p class="veb0326-main-subheader">Как выжить в новом мире работы и не попасть под каток изменений?</p>
                        <a href="#buy" class="btn-color-main-black">Зарегистрироваться</a>
                    </div>
                    <div class="veb0326-main-right">
                        <img src="https://cdn.careerum.com/1774349638995-FPI5d-Fram.png" class="hidden-tablet-mobile" alt="img"
                            loading="eager">
                        <img src="https://cdn.careerum.com/1774360349203-TIX6E-Fram.png" class="hidden-desc-mobile" alt="eager"
                            loading="lazy">
                        <img src="https://cdn.careerum.com/1774362211765-xqYM2-Fram.png" class="hidden-desc-tablet" alt="eager"
                            loading="lazy">
                        <a href="#buy" class="btn-color-main-black">Зарегистрироваться</a>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-veb0326-who', {
        label: 'Veb 0326 who (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-veb0326-who main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>
                        Для кого эта лекция?
                    </h2>
                    <div class="veb0326-who-tales careerum-flex-sbst">
                        <div class="veb0326-who-tale">
                            <p class="veb0326-who-tale-number">[1]</p>
                            <p class="veb0326-who-tale-header">Вам страшно стать ненужным в эпоху AI</p>
                            <p class="veb0326-who-tale-text">ИИ уже переписывает роли в бухгалтерии, HR, маркетинге, логистике.
                                И главный вопросе не «заменит  ли?», а «когда?»</p>
                        </div>
                        <div class="veb0326-who-tale">
                            <p class="veb0326-who-tale-number">[2]</p>
                            <p class="veb0326-who-tale-header">Вы застряли в кризисе</p>
                            <p class="veb0326-who-tale-text">Есть достижения, опыт, хорошая роль, но непонятно, что будет дальше
                                в горизонте 3–5 лет</p>
                        </div>
                        <div class="veb0326-who-tale">
                            <p class="veb0326-who-tale-number">[3]</p>
                            <p class="veb0326-who-tale-header">Вы выгорели, но не от нагрузки</p>
                            <p class="veb0326-who-tale-text">А от отсутствия признания, несовпадения ценностей или потери смысла
                            </p>
                        </div>
                        <div class="veb0326-who-tale">
                            <p class="veb0326-who-tale-number">[4]</p>
                            <p class="veb0326-who-tale-header">Вы чувствуете, что пора сменить сферу</p>
                            <p class="veb0326-who-tale-text">Но боитесь выбрать не то или просесть в доходе. Выбираете
                                между карьерными сценариями, и каждый кажется рискованным</p>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-veb0326-who', {
        label: 'Veb 0326 who (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: ``
    });
    
    blockManager.add('careerum-veb0326-bonus', {
        label: 'Veb 0326 bonus (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-veb0326-bonus main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="veb0326-bonus-bg position-relative">
                        <img src="https://cdn.careerum.com/1774351156211-4KsCY-Grou.png"
                            class="hidden-tablet-mobile position-absolute" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1774361057815-zLWqQ-Grou.png"
                            class="hidden-desc-mobile position-absolute" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1774362951681-BrKKD-Grou.png"
                            class="hidden-desc-tablet position-absolute" alt="img" loading="lazy">
                    </div>
                    <div class="veb0326-bonus-content">
                        <h2>
                            <span>Бонус</span> сразу после регистрации на лекцию
                        </h2>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-veb0326-gift', {
        label: 'Veb 0326 gift (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-veb0326-gift main-wrapper">
                <div class="careerum-container-responsive careerum-flex-sbfs">
                    <div class="veb0326-gift-bg position-relative z-1">
                        <img loading="eager" src="https://cdn.careerum.com/1779177373521-ti415-Grou.png" alt="img"
                            class="hidden-tablet-mobile position-absolute" />
                        <img loading="lazy" src="https://cdn.careerum.com/1779178708041-pJrIT-Grou.png" alt="img"
                            class="hidden-desc-mobile position-absolute" />
                        <img loading="lazy" src="https://cdn.careerum.com/1779180078123-YKrnc-Grou.png" alt="img"
                            class="hidden-desc-tablet position-absolute" />
                    </div>
                    <div class="veb0326-gift-content position-relative z-10">
                        <h2 class="position-relative z-10"><span>ПОДАРОК</span> всем, кто будет на мастер-классе до конца</h2>
                        <img src="https://cdn.careerum.com/1779177395748-kQmWD-Vect.svg" class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1779178645065-eAYzi-Vect.svg" class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1779179719362-dB2JS-Vect.svg" class="hidden-desc-tablet position-absolute z-1" alt="img" loading="lazy">
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-veb0326-program', {
        label: 'Veb 0326 program (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-veb0326-program main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Программа мастер-класса</h2>
                    <div class="veb0326-program-tales careerum-flex-sbst">
                        <div class="veb0326-program-tale position-relative">
                            <div class="veb0326-program-tale-labels careerum-flex-fsfs">
                                <div class="veb0326-program-tale-label"><p>Блок 1</p></div>
                                <div class="veb0326-program-tale-label position-relative"><p>30 минут</p></div>
                            </div>
                            <p class="veb0326-program-tale-header">Теория</p>
                            <p class="veb0326-program-tale-text">Аналитика рынка труда 2026. Разберём 3 тренда: AI, глобальные сокращения, нелинейные карьеры</p>
                        </div>
                        <div class="veb0326-program-tale position-relative">
                            <div class="veb0326-program-tale-labels careerum-flex-fsfs">
                                <div class="veb0326-program-tale-label"><p>Блок 2</p></div>
                                <div class="veb0326-program-tale-label position-relative"><p>20 минут</p></div>
                            </div>
                            <p class="veb0326-program-tale-header">Практика</p>
                            <p class="veb0326-program-tale-text">С чего начать карьерную перезагрузку? Проведёте аудит: ваша точка 0, сколько вы теряете в деньгах и времени, как понять, куда двигаться дальше</p>
                        </div>
                        <div class="veb0326-program-tale position-relative">
                            <div class="veb0326-program-tale-labels careerum-flex-fsfs">
                                <div class="veb0326-program-tale-label"><p>Блок 3</p></div>
                                <div class="veb0326-program-tale-label position-relative"><p>20 минут</p></div>
                            </div>
                            <p class="veb0326-program-tale-header">Инструменты</p>
                            <p class="veb0326-program-tale-text">Как пройти карьерную перезагрузку без потерь? Пошаговый план реализации  выбранной стратегии</p>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-veb0326-promises', {
        label: 'Veb 0326 promises (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-veb0326-promises main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="veb0326-promises-top position-relative">
                        <img src="https://cdn.careerum.com/1774358512932-saeP9-Vect.svg"
                            class="hidden-tablet-mobile position-absolute" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1774361459061-M4fVD-Vect.svg"
                            class="hidden-desc-mobile position-absolute" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1774363342280-9cSlz-Vect.svg"
                            class="hidden-desc-tablet position-absolute" alt="img" loading="lazy">
                        <h2 class="position-relative">Рынок перегрет обещаниями вроде: </h2>
                        <p class="veb0326-promises-subheader">«Найдите работу мечты за 2 недели»</p>
                        <p class="veb0326-promises-text">Это звучит токсично и лживо, и вы 100% это чувствуете</p>
                    </div>
                    <div class="veb0326-promises-bottom">
                        <p class="veb0326-promises-bottom-header">Моя лекция — она про другое</p>
                        <ul class="careerum-flex-sbfs">
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1774358459681-5Ud1o-Chec.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1774361535192-D1lqb-Chec.svg" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1774363522229-zz4uk-Chec.svg" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                                <p>Я расскажу, как <span>заново собрать свою карьерную устойчивость</span> и позицию в мире,
                                    который меняется быстрее, чем мы успели это понять</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1774358459681-5Ud1o-Chec.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1774361535192-D1lqb-Chec.svg" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1774363522229-zz4uk-Chec.svg" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                                <p>Не <i>«как искать работу»</i>, это вам расскажут без меня, а <span>как оставаться нужным на
                                        любом
                                        рынке</span> — через глубокое понимание трендов, своих сильных сторон и новых правил
                                    игры</p>
                            </li>
                        </ul>
                        <a href="#buy" class="btn-color-main-black">Я жду вас на лекции!</a>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-veb0326-after', {
        label: 'Veb 0326 after (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-veb0326-after main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>После лекции у вас появятся <span>ясность и план,</span> что делать дальше:</h2>
                    <div class="veb0326-after-tales careerum-flex-sbst">
                        <div class="veb0326-after-tale">
                            <img src="https://cdn.careerum.com/1774359048183-T0V1q-Char.svg" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1774361726106-QRaMz-Char.svg" class="hidden-desc-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1774363710524-j3vQX-Char.svg" class="hidden-desc-tablet" alt="img" loading="lazy">
                            <p class="veb0326-after-tale-header">Тренды и перспективы: как меняется карьерный мир</p>
                            <p class="veb0326-after-tale-text">Новые карьерные реалии, которые уже меняют правила:
                                нестабильность траекторий, AI в каждой индустрии, конец «одной карьеры на всю жизнь»</p>
                        </div>
                        <div class="veb0326-after-tale">
                            <img src="https://cdn.careerum.com/1774359048140-CeoB6-Comp.svg" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1774361726067-XqlPH-Comp.svg" class="hidden-desc-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1774363710483-QPyrD-Comp.svg" class="hidden-desc-tablet" alt="img" loading="lazy">
                            <p class="veb0326-after-tale-header">Возможные сценарии развития + реальные кейсы</p>
                            <ul>
                                <li class="careerum-flex-sbfs">
                                    <p>( 1 )</p>
                                    <p>Как зрелые профессионалы пересобирают карьеру: меняют сферу, пересобирают резюме, учатся
                                        торговаться за условия, находят новые форматы работы</p>
                                </li>
                                <li class="careerum-flex-sbfs">
                                    <p>( 2 )</p>
                                    <p>Разбор реальных историй участников Careerum</p>
                                </li>
                            </ul>
                        </div>
                        <div class="veb0326-after-tale">
                            <img src="https://cdn.careerum.com/1774359048040-oOaHV-Spar.svg" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1774361725976-JShia-Spar.svg" class="hidden-desc-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1774363710413-WIdUL-Spar.svg" class="hidden-desc-tablet" alt="img" loading="lazy">
                            <p class="veb0326-after-tale-header">Мета-навыки будущего</p>
                            <ul>
                                <li class="careerum-flex-sbfs">
                                    <p>( 1 )</p>
                                    <p>Что прокачивать уже сейчас, чтобы оставаться востребованным в эпоху AI</p>
                                </li>
                                <li class="careerum-flex-sbfs">
                                    <p>( 2 )</p>
                                    <p>77% работодателей ставят софт и метаскилы выше хард-скилов</p>
                                </li>
                                <li class="careerum-flex-sbfs">
                                    <p>( 3 )</p>
                                    <p>Узнаете, какие именно умения невозможно заменить AI в ближайшие годы, и как их развивать,
                                        чтобы не остаться за бортом карьеры</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-consult0326-main', {
        label: 'Consultation 0326 main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-consult0326-main main-wrapper">
                <div class="careerum-container-responsive careerum-flex-sbfs">
                    <div class="consult0326-logo position-relative z-10">
                        <img src="https://cdn.careerum.com/1774861002605-Ns8Wr-logo.svg" class="hidden-tablet-mobile" alt="img"
                            loading="lazy">
                        <img src="https://cdn.careerum.com/1774861004720-ZOaOa-logo.svg" class="hidden-desc" alt="img"
                            loading="lazy">
                    </div>
                    <div class="consult0326-left position-relative z-10">
                        <h1>Индивидуальные консультации<br> <span>Ольги Лермонтовой</span></h1>
                        <p>Персональная поддержка вашего карьерного развития от основательницы и CEO Careerum</p>
                        <a href="#buy" class="btn-color-main-white hidden-mobile">Подать заявку на работу</a>
                    </div>
                    <div class="consult0326-right position-relative z-1">
                        <img src="https://cdn.careerum.com/1774860721662-I3ZKI-Fram.png"
                            class="hidden-tablet-mobile position-absolute" alt="img" loading="eager">
                        <img src="https://cdn.careerum.com/1774872932754-CLNUX-Fram.png" class="hidden-desc-mobile position-absolute" alt="img"
                            loading="lazy">
                        <img src="https://cdn.careerum.com/1774872836621-bxJQq-Grou.png" class="hidden-desc-tablet position-relative z-1" alt="img"
                            loading="lazy">
                        <a href="#buy" class="btn-color-main-white hidden-desc-tablet position-relative z-10">Подать заявку на работу</a>
                    </div>
                    <div class="consult0326-tales">
                        <h2>Опыт работы и образование на Топ-уровне:</h2>
                        <div class="careerum-flex-sbfs consult0326-tales-wrapper">
                            <div class="consult0326-tales-item">
                                <img src="https://cdn.careerum.com/1774869644633-0mTZF-Fram.png" class="hidden-tablet-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1774870830824-nBUwu-Fram.png" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1774873568194-oUUI1-Fram.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                            </div>
                            <div class="consult0326-tales-item">
                                <img src="https://cdn.careerum.com/1774869644702-Pw4oQ-Fram.png" class="hidden-tablet-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1774870830898-TZG1l-Fram.png" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1774873568300-gENUk-Fram.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                            </div>
                            <div class="consult0326-tales-item">
                                <img src="https://cdn.careerum.com/1774869644750-5tcih-Fram.png" class="hidden-tablet-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1774870830937-o0Czp-Fram.png" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1774873568342-KTS4Z-Fram.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                            </div>
                            <div class="consult0326-tales-item">
                                <img src="https://cdn.careerum.com/1774869644798-tGYwj-Fram.png" class="hidden-tablet-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1774870830975-eP3Q6-Fram.png" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1774873568382-f4RcK-Fram.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                            </div>
                            <div class="consult0326-tales-item">
                                <img src="https://cdn.careerum.com/1774869644846-D4GYy-Fram.png" class="hidden-tablet-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1774870831027-eGsKL-Fram.png" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1774873568426-gY5iz-Fram.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-consult0326-why', {
        label: 'Consultation 0326 why (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-consult0326-why main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>ПОЧЕМУ Я:</h2>
                    <div class="consult0326-why-wrapper careerum-flex-sbfs">
                        <div class="consult0326-why-left">
                            <img src="https://cdn.careerum.com/1774864692687-BJ0G8-Fram.png" class="hidden-tablet-mobile wide"
                                alt="img" loading="eager">
                            <img src="https://cdn.careerum.com/1774870913899-GHEzs-Fram.png" class="hidden-desc-mobile wide"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1774873789749-Xn94u-Grou.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                        </div>
                        <div class="consult0326-why-right position-relative">
                            <ul>
                                <li class="position-relative">15 лет в корпоративной стратегии (Google, Microsoft, Travelport)
                                    на рынках Европы, США и Азии</li>
                                <li class="position-relative">Founder & CEO образовательной платформы с выручкой >€1M и 14,000+
                                    клиентов</li>
                                <li class="position-relative">Степень MBA в INSEAD</li>
                                <li class="position-relative">Кандидат в магистры психологии (Harvard Extension School)</li>
                            </ul>
                            <div class="consult0326-why-qoute position-relative z-10">
                                <p>Я понимаю бизнес-процессы на уровне цифр и стратегий корпораций. И я понимаю людей на уровне
                                    глубинной психологии. Я помогаю фаундерам и C-level руководителям соединить эти два мира,
                                    чтобы расти в доходе и масштабе, не теряя себя</p>
                            </div>
                            <img src="https://cdn.careerum.com/1774865030732-BWLiM-Elli.svg"
                                class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1774871240729-e0mCt-Elli.svg"
                                class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1774874061063-S1xAw-Elli.svg" class="hidden-desc-tablet position-absolute z-1" alt="img"
                                loading="lazy">
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-consult0326-format', {
        label: 'Consultation 0326 format (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-consult0326-format main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>ФОРМАТ РАБОТЫ</h2>
                    <div class="consult0326-format-wrapper">
                        <div class="consult0326-format-item left careerum-flex-sbst">
                            <div class="consult0326-format-item-content position-relative">
                                <p class="consult0326-format-item-number">01</p>
                                <p class="consult0326-format-item-title">Заявка</p>
                                <p class="consult0326-format-item-text">Заполняете бриф. Я беру в работу только те запросы, где
                                    могу дать 10x ROI</p>
                            </div>
                            <div class="consult0326-format-item-empty"></div>
                        </div>
                        <div class="consult0326-format-item careerum-flex-sbst">
                            <div class="position-relative consult0326-format-item-empty"></div>
                            <div class="consult0326-format-item-content">
                                <p class="consult0326-format-item-number">02</p>
                                <p class="consult0326-format-item-title">Подготовка</p>
                                <p class="consult0326-format-item-text">Я изучаю ваш профиль, бизнес-модель или CV до нашей
                                    встречи</p>
                            </div>
                        </div>
                        <div class="consult0326-format-item left careerum-flex-sbst">
                            <div class="consult0326-format-item-content position-relative">
                                <p class="consult0326-format-item-number">03</p>
                                <p class="consult0326-format-item-title">Deep Dive</p>
                                <p class="consult0326-format-item-text">2.5 часа интенсивной стратегической работы в Zoom</p>
                            </div>
                            <div class="consult0326-format-item-empty"></div>
                        </div>
                        <div class="consult0326-format-item careerum-flex-sbst">
                            <div class="position-relative consult0326-format-item-empty"></div>
                            <div class="consult0326-format-item-content">
                                <p class="consult0326-format-item-number">04</p>
                                <p class="consult0326-format-item-title">Action Plan</p>
                                <p class="consult0326-format-item-text">Вы получаете резюме сессии, запись и чёткий вектор
                                    действий</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-consult0326-tariffs', {
        label: 'Consultation 0326 tariffs (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-consult0326-tariffs main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="consult0326-tariffs-header">
                        <h2>Услуги</h2>
                    </div>
                    <div class="consult0326-tariffs-wrapper">
                        <div class="consult0326-tariffs-slider careerum-flex-sbst">
                            <div class="consult0326-tariffs-item careerum-flex-fsfs">
                                <div class="consult0326-tariffs-item-top">
                                    <p class="consult0326-tariffs-item-label">ДЛЯ ТОП-МЕНЕДЖЕРОВ</p>
                                    <p class="consult0326-tariffs-item-title">Executive Career Strategy</p>
                                    <p class="consult0326-tariffs-item-text">Аудит вашей карьеры как бизнес-актива. Для тех,
                                        кто упёрся в «стеклянный потолок», потерял драйв или готовится к переходу на глобальный
                                        C–Level.</p>
                                    <ul>
                                        <li class="position-relative">Оценка рыночной стоимости</li>
                                        <li class="position-relative">Снятие блоков и синдрома самозванца</li>
                                        <li class="position-relative">Сценарии: Stay, Grow or Go Global</li>
                                    </ul>
                                </div>
                                <div class="consult0326-tariffs-item-bottom">
                                    <div class="careerum-flex-sbc">
                                        <p class="consult0326-tariffs-item-price">1 500 €</p>
                                        <p class="consult0326-tariffs-item-descr">2.5 ЧАСА (DEEP DIVE)</p>
                                    </div>
                                    <a href="#popup1" class="btn-color-main-white">Купить</a>
                                </div>
                            </div>
                            <div class="consult0326-tariffs-item careerum-flex-fsfs">
                                <div class="consult0326-tariffs-item-top">
                                    <p class="consult0326-tariffs-item-label">ДЛЯ ПРЕДПРИНИМАТЕЛЕЙ</p>
                                    <p class="consult0326-tariffs-item-title">Founder Alignment</p>
                                    <p class="consult0326-tariffs-item-text">Синхронизация личных целей и бизнеса. Для владельцев,
                                        которые стали заложниками своей компании и ищут выход из операционки в стратегию</p>
                                    <ul>
                                        <li class="position-relative">Founder-Market Fit</li>
                                        <li class="position-relative">Психологические блоки масштабирования</li>
                                        <li class="position-relative">Личная стратегия выхода или роста</li>
                                    </ul>
                                </div>
                                <div class="consult0326-tariffs-item-bottom">
                                    <div class="careerum-flex-sbc">
                                        <p class="consult0326-tariffs-item-price">2 000 €</p>
                                        <p class="consult0326-tariffs-item-descr">2.5 ЧАСА (DEEP DIVE)</p>
                                    </div>
                                    <a href="#popup2" class="btn-color-main-white">Купить</a>
                                </div>
                            </div>
                            <div class="consult0326-tariffs-item careerum-flex-fsfs">
                                <div class="consult0326-tariffs-item-top">
                                    <p class="consult0326-tariffs-item-label">ДЛЯ СТАРТАПОВ (PRE-SEED / SEED)</p>
                                    <p class="consult0326-tariffs-item-title">Startup Crash Test</p>
                                    <p class="consult0326-tariffs-item-text">Проверка бизнес-модели и упаковка для инвесторов
                                        глазами стратега из Big Tech</p>
                                    <ul>
                                        <li class="position-relative">Pitch Deck & Storytelling</li>
                                        <li class="position-relative">Reality check юнит-экономики</li>
                                        <li class="position-relative">Market Entry Strategy</li>
                                    </ul>
                                </div>
                                <div class="consult0326-tariffs-item-bottom">
                                    <div class="careerum-flex-sbc">
                                        <p class="consult0326-tariffs-item-price">1 500 €</p>
                                        <p class="consult0326-tariffs-item-descr">2.5 ЧАСА (DEEP DIVE)</p>
                                    </div>
                                    <a href="#popup3" class="btn-color-main-white">Купить</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="consult0326-tariffs-bottom">
                        <p class="consult0326-tariffs-bottom-header">Executive Sparring Partner</p>
                        <p class="consult0326-tariffs-bottom-text">Долгосрочное сопровождение (3–6 месяцев). Психологическая и
                            стратегическая опора для первых лиц. «Венди Роудс» для вашего бизнеса</p>
                        <p class="consult0326-tariffs-bottom-text light">Доступно только после прохождения разовой
                            стратегической сессии</p>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-consult0326-faq', {
        label: 'Consultation 0326 faq (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-consult0326-faq main-wrapper">
                <div class="careerum-container-responsive careerum-flex-sbfs">
                    <div class="consult0326-faq-left">
                        <h2>FAQ</h2>
                    </div>
                    <div class="consult0326-faq-right">
                        <div class="consult0326-faq-item">
                            <div class="consult0326-faq-item-top careerum-flex-sbfs">
                                <div>
                                    <p>Почему нет пакетов из 10 сессий?</p>
                                </div>
                                <div class="consult0326-faq-item-switcher">
                                    <img src="https://cdn.careerum.com/1774868005395-LGMRd-Vect.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1774868026941-ywSY8-Vect.svg" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                            </div>
                            <div class="consult0326-faq-item-bottom">
                                <p>Моим клиентам не нужно «просто поговорить». Им нужна ясность и решение, которое экономит
                                    месяцы времени. 2.5 часа интенсивного аудита дают больше, чем полгода обычного коучинга.</p>
                            </div>
                        </div>
                        <div class="consult0326-faq-item">
                            <div class="consult0326-faq-item-top careerum-flex-sbfs">
                                <div>
                                    <p>Как происходит оплата?</p>
                                </div>
                                <div class="consult0326-faq-item-switcher">
                                    <img src="https://cdn.careerum.com/1774868005395-LGMRd-Vect.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1774868026941-ywSY8-Vect.svg" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                            </div>
                            <div class="consult0326-faq-item-bottom">
                                <p>Оплата производится по инвойсу на эстонское юрлицо (Careerum OÜ) после утверждения вашей
                                    заявки.</p>
                            </div>
                        </div>
                        <div class="consult0326-faq-item">
                            <div class="consult0326-faq-item-top careerum-flex-sbfs">
                                <div>
                                    <p>Можно ли получить совет по конкретной бизнес-ситуации?</p>
                                </div>
                                <div class="consult0326-faq-item-switcher">
                                    <img src="https://cdn.careerum.com/1774868005395-LGMRd-Vect.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1774868026941-ywSY8-Vect.svg" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                            </div>
                            <div class="consult0326-faq-item-bottom">
                                <p>Да, сессии абсолютно прикладные. Мы разбираем ваши реальные цифры, конфликты в борде или
                                    карьерные офферы.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-club0426-main', {
        label: 'Club 0426 main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club0426-main main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <div class="club0426-main-header-wrapper position-relative z-20 careerum-flex-sbfs">
                        <div class="club0426-main-left">
                            <h1 class="position-relative z-1">Careerum</h1>
                            <p class="club0426-main-subheader position-relative z-10">Клуб и платформа карьерного развития</p>
                            <p class="club0426-main-text">Помогаем профессионалам <span>вырасти в карьере</span>, когда старые
                                инструменты перестают работать</p>
                        </div>
                        <div class="club0426-main-right">
                            <img src="https://cdn.careerum.com/1775032938719-DeHwu-Fram.png" class="hidden-tablet-mobile"
                                alt="img" loading="eager">
                            <img src="https://cdn.careerum.com/1775032940691-Xs0ip-Fram.png" class="hidden-desc-mobile"
                                alt="img" loading="eager">
                            <img src="https://cdn.careerum.com/1775032942635-pZg5m-Grou.png" class="hidden-desc-tablet"
                                alt="img" loading="eager">
                        </div>
                    </div>
                    <p class="club0426-main-text2">Чтобы расти в карьере, теперь нужен<br> не просто поиск работы, а <span>новая карьерная стратегия:</span></p>
                    <div class="careerum-flex-fsst club0426-main-tales">
                        <div class="club0426-main-tale">
                            <p class="club0426-main-tale-header">Рост, повышение</p>
                            <p class="club0426-main-tale-text">Если вы уперлись в потолок, а старые способы расти в деньгах больше не работают</p>
                        </div>
                        <div class="club0426-main-tale">
                            <p class="club0426-main-tale-header">Оффер</p>
                            <p class="club0426-main-tale-text">Если поиск затянулся, и вам нужна работающая стратегия, а не бездумная рассылка резюме</p>
                        </div>
                        <div class="club0426-main-tale">
                            <p class="club0426-main-tale-header">Ясность и план</p>
                            <p class="club0426-main-tale-text">Если ваша роль теряет смысл (или её забирает AI), и пора пересобрать свою карьеру, не потеряв доход</p>
                        </div>
                        <div class="club0426-main-tale">
                            <p class="club0426-main-tale-header">Релокация</p>
                            <p class="club0426-main-tale-text">Если вы хотите сократить карьерные риски и строить карьеру за рубежом</p>
                        </div>
                    </div>
                    <a href="#buy" class="btn-color-main-black getparams">Заполнить анкету в Careerum</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-ai042026-main', {
        label: 'AI 0426 main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-ai042026-main main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="ai042026-main-logo">
                        <img src="https://cdn.careerum.com/1775160324669-Fp67q-logo.svg" class="hidden-tablet-mobile" alt="img"
                            loading="eager">
                        <img src="https://cdn.careerum.com/1775160327008-ccvqZ-logo.svg" class="hidden-desc" alt="img"
                            loading="eager">
                    </div>
                    <div class="ai042026-main-top careerum-flex-sbfs">
                        <div class="ai042026-main-top-left position-relative z-10">
                            <div class="ai042026-main-labels careerum-flex-fsfs">
                                <div class="ai042026-main-label violet">
                                    <p>Старт: 13 мая</p>
                                </div>
                                <div class="ai042026-main-label black">
                                    <p>Интенсив</p>
                                </div>
                                <div class="ai042026-main-label black">
                                    <p>Теория + Живые эфиры + практика</p>
                                </div>
                            </div>
                            <h1>Карьера в эпоху <span>AI</span></h1>
                            <p class="ai042026-subheader">От исполнителя к стратегу</p>
                            <ul class="ai042026-models-wrapper careerum-flex-fsfs">
                                <li class="position-relative">Claude</li>
                                <li class="position-relative">ChatGPT 5</li>
                                <li class="position-relative">DeepSeek</li>
                                <li class="position-relative">Perplexity</li>
                                <li class="position-relative">Grok</li>
                            </ul>
                            <a href="https://school.careerum.ru/anketa_ai" target="_blank"
                                class="btn-color-main-black hidden-mobile getparams">Заполнить анкету</a>
                        </div>
                        <div class="ai042026-main-top-right position-relative z-1 hero__image-wrap">
                            <img src="https://cdn.careerum.com/1776858555572-GKxdt-Fram.png"
                                class="hidden-tablet-mobile position-absolute hero__image1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1776858556964-ii5H3-Fram.png"
                                class="hidden-desc-mobile position-absolute" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1776858558876-acKRB-Fram.png"
                                class="hidden-desc-tablet position-absolute" alt="img" loading="lazy">
                        </div>
                        <a href="https://school.careerum.ru/anketa_ai" target="_blank"
                            class="btn-color-main-black hidden-desc-tablet getparams">Заполнить анкету</a>
                    </div>
                    <div class="ai042026-main-bottom">
                        <div class="ai042026-main-banner position-relative">
                            <p class="position-relative z-10 hidden-mobile">Новая система мышления, работы и пересборка профессиональной роли,
                                которая <span>сделает вас
                                    дороже рынка</span></p>
                            <p class="position-relative z-10 hidden-desc-tablet">Новая система мышления, работы и пересборка профессиональной роли,
                                которая <span>сделает вас
                                    дороже</span><br> <span>рынка</span></p>
                            <img src="https://cdn.careerum.com/1776859423601-97Ain-Ð¡Ð½.png"
                                class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1775161630362-pYYiD-Ð¡Ð½.png"
                                class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1776892740895-MKgmD-Ð¡Ð½.png"
                                class="hidden-desc-tablet position-absolute z-1" alt="img" loading="lazy">
                        </div>
                        <ul class="careerum-flex-sbst">
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1775161786754-YfhD1-Soft.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1775161790656-1USUd-Soft.svg" class="hidden-desc" alt="img"
                                    loading="lazy">
                                <div>
                                    <p>Из человека, который «делает руками»</p>
                                    <p>В специалиста, который <span>управляет процессами через AI</span> </p>
                                </div>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1775161786754-YfhD1-Soft.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1775161790656-1USUd-Soft.svg" class="hidden-desc" alt="img"
                                    loading="lazy">
                                <div>
                                    <p>Из «незаметного исполнителя»</p>
                                    <p>В специалиста <span>с влиянием</span> и сильной позицией </p>
                                </div>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1775161786754-YfhD1-Soft.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1775161790656-1USUd-Soft.svg" class="hidden-desc" alt="img"
                                    loading="lazy">
                                <div>
                                    <p>Из хаотичного пользователя нейросетей</p>
                                    <p>В системного <span>профессионала</span> с собственной карьерной стратегией</p>
                                </div>
                            </li>
                        </ul>
                        <a href="https://school.careerum.ru/anketa_ai" target="_blank"
                            class="btn-color-main-black getparams">Заполнить
                            анкету</a>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-ai042026-authors', {
        label: 'AI 0426 authors (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-ai042026-authors main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Авторы и спикеры</h2>
                    <div class="ai042026-authors-wrapper careerum-flex-sbst">
                        <div class="ai042026-authors-item">
                            <img src="https://cdn.careerum.com/1776085322275-PrabF-Fram.png" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1776085753824-FvA1N-Fram.png" class="hidden-desc-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1776085913114-cavey-Fram.png" class="hidden-desc-tablet"
                                alt="img" loading="lazy">
                            <p class="ai042026-authors-item-name">Иннокентий Солнцев</p>
                            <p class="ai042026-authors-item-position">Co-founder и CTO Careerum</p>
                            <p class="ai042026-authors-item-text">Соавтор программы, отвечает за внедрение AI и автоматизацию
                                процессов в Careerum. <span>Ведет технические блоки программы и практические мастермайнды</span>
                            </p>
                        </div>
                        <div class="ai042026-authors-item">
                            <img src="https://cdn.careerum.com/1776085322203-NvZnT-Fram.png" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1776085753964-MyF99-Fram.png" class="hidden-desc-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1776085912959-vSe3M-Fram.png" class="hidden-desc-tablet"
                                alt="img" loading="lazy">
                            <p class="ai042026-authors-item-name">Ольга Лермонтова</p>
                            <p class="ai042026-authors-item-position">Основательница и СЕО Careerum</p>
                            <p class="ai042026-authors-item-text">Соавтор программы, карьерный стратег. <span>Ведет карьерные
                                    и бизнес-блоки программы</span></p>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-ai042026-banner', {
        label: 'AI 0426 banner (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-ai042026-banner main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <h2 class="position-relative z-10 gradient">Ваш опыт уже стоит больше</h2>
                    <p class="position-relative z-10 ai042026-banner-text">Вы просто не умеете его масштабировать через AI</p>
                    <img src="https://cdn.careerum.com/1776860913154-7JQwm-Gene.png"
                        class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                    <img src="https://cdn.careerum.com/1776890093257-Ydc5Z-Gene.png" class="hidden-desc-mobile position-absolute z-1" alt="img"
                        loading="lazy">
                    <img src="https://cdn.careerum.com/1776893164819-ZF04B-Gene.png" class="hidden-desc-tablet position-absolute z-1 bottom" alt="img"
                        loading="lazy">
                </div>
                <div class="careerum-container-responsive position-relative">
                    <h2 class="position-relative z-10">AI не заменит вас</h2>
                    <p class="position-relative z-10 ai042026-banner-text mt12">Но вас точно заменит тот, кто уже научился управлять AI</p>
                    <img src="https://cdn.careerum.com/1776860913154-7JQwm-Gene.png"
                        class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                    <img src="https://cdn.careerum.com/1776890336320-mLUVC-Gene.png" class="hidden-desc-mobile position-absolute z-1" alt="img"
                        loading="lazy">
                    <img src="https://cdn.careerum.com/1776893363335-4C9yh-Gene.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                        loading="lazy">
                </div>
                <div class="careerum-container-responsive position-relative">
                    <h2 class="position-relative z-10 thin">Станьте <span class="bg">сильнее,</span> чем 98% профессионалов на
                        рынке <span class="gradient">с помощью AI</span></h2>
                    <img src="https://cdn.careerum.com/1776861732776-bY2sh-Fram.svg"
                        class="hidden-tablet-mobile position-absolute z-1 bottom" alt="img" loading="lazy">
                    <img src="https://cdn.careerum.com/1776890465530-Z9Woj-Fram.svg" class="hidden-desc-mobile position-absolute z-1 bottom" alt="img"
                        loading="lazy">
                    <img src="https://cdn.careerum.com/" class="hidden-desc-tablet position-absolute z-1" alt="img"
                        loading="lazy">
                </div>
                <div class="careerum-container-responsive position-relative wide">
                    <h2 class="position-relative z-10">Доступен на платформе<br> <span class="bg wide">только до 31 июля</span>
                    </h2>
                    <p class="position-relative z-10 ai042026-banner-text mt12">Рынок очень быстро меняется, материалы потребуют обновления</p>
                    <p class="position-relative z-10 ai042026-banner-text mt12">Мы <span>не планируем повторять</span> запуск AI-интенсива в этом году</p>
                </div>
                <div class="careerum-container-responsive position-relative wide">
                    <h2 class="position-relative z-10">Сегодня платят не за то, сколько вы делаете</h2>
                    <p class="position-relative z-10 ai042026-banner-text mt12 fs18">А за то, насколько вы ускоряете результат через AI и мыслите
                        бизнес-процессами</p>
                    <img src="https://cdn.careerum.com/1776866939838-wEox8-Ð¡Ð½.png"
                        class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                    <img src="https://cdn.careerum.com/1776891341637-0kO1b-Ð¡Ð½.png" class="hidden-desc-mobile position-absolute z-1" alt="img"
                        loading="lazy">
                    <img src="https://cdn.careerum.com/1776895027028-W8QIt-Ð¡Ð½.png" class="hidden-desc-tablet position-absolute z-1 bottom" alt="img"
                        loading="lazy">
                </div>
                <div class="careerum-container-responsive position-relative">
                    <p class="ai042026-banner-label">Бонус</p>
                    <h2 class="position-relative z-10">Тревожный чемоданчик<br> карьериста 2026</h2>
                    <p class="position-relative z-10 ai042026-banner-text mt12">Пакет всех промптов программы</p>
                    <img src="https://cdn.careerum.com/1776889555705-bxJJV-Grou.png"
                        class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                    <img src="https://cdn.careerum.com/1776892346469-NGSg1-Grou.png" class="hidden-desc-mobile position-absolute z-1" alt="img"
                        loading="lazy">
                    <img src="https://cdn.careerum.com/1776896781105-4d5re-Grou.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                        loading="lazy">
                </div>
            </div>`
    });
    
    blockManager.add('careerum-ai042026-why', {
        label: 'AI 0426 why (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-ai042026-why main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <h2>Программа для вас, если:</h2>
                    <div class="ai042026-why-wrapper careerum-flex-sbst">
                        <div class="ai042026-why-item">
                            <img src="https://cdn.careerum.com/1776861208218-vnSn6-Grad.svg" alt="img">
                            <p class="ai042026-why-item-header">Вы сильный специалист, но не понимаете, как подступиться
                                к нейросетям</p>
                            <p class="ai042026-why-item-text">Чувствуете, что если не перестроитесь, то начнёте проигрывать
                                коллегам и рынку</p>
                        </div>
                        <div class="ai042026-why-item">
                            <img src="https://cdn.careerum.com/1776861208380-jKVAk-Lapt.svg" alt="img">
                            <p class="ai042026-why-item-header">Хотите получить системное обучение и навыки по нейросетям</p>
                            <p class="ai042026-why-item-text">которые позволят иметь больше влияния в компании и стоить дороже
                                на рынке</p>
                        </div>
                        <div class="ai042026-why-item">
                            <img src="https://cdn.careerum.com/1776861208450-4TSDM-Robo.svg" alt="img">
                            <p class="ai042026-why-item-header">Тонете в операционке</p>
                            <p class="ai042026-why-item-text">хотите наконец‑то делегировать рутину ИИ</p>
                        </div>
                        <div class="ai042026-why-item">
                            <img src="https://cdn.careerum.com/1776861208418-iyglq-Meda.svg" alt="img">
                            <p class="ai042026-why-item-header">Хотите научиться мыслить бизнес-процессами и стать AI-лидером
                            </p>
                            <p class="ai042026-why-item-text">начать решать более стратегические задачи и отвечать за внедрение
                                AI у себя в команде</p>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-ai042026-program', {
        label: 'AI 0426 program (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-ai042026-program main-wrapper violet">
                <div class="careerum-container-responsive position-relative">
                    <h2>Программа</h2>
                    <div class="ai042026-program-wrapper">
                        <div class="ai042026-program-item">
                            <div class="ai042026-program-item-header">
                                <div class="ai042026-program-item-labels careerum-flex-fsfs">
                                    <p>Неделя 1</p>
                                    <p>Спикер: Иннокентий</p>
                                </div>
                                <p class="ai042026-program-item-title">Модуль 1. Снятие страха перед AI, базовые инструменты,
                                    безопасность</p>
                            </div>
                            <div class="ai042026-program-item-results">
                                <p class="ai042026-program-item-result-title">Результат модуля:</p>
                                <ul>
                                    <li>Преодолеете страх перед новыми технологиями</li>
                                    <li>Подключите нужные для ваших задач нейросети</li>
                                    <li>Освоите базовые принципы общения с AI</li>
                                    <li>Освоите правила безопасности (NDA)</li>
                                    <li>Готовы переходить к решению более сложных карьерных задач с AI</li>
                                </ul>
                            </div>
                            <div class="ai042026-program-item-lessons">
                                <div class="ai042026-program-item-lesson">
                                    <div class="ai042026-program-item-lesson-title careerum-flex-fsc">
                                        <div class="ai042026-program-item-lesson-title-number">
                                            <p>01</p>
                                        </div>
                                        <p>Базовые возможности AI</p>
                                    </div>
                                    <div class="ai042026-program-item-lesson-content">
                                        <p>Снимаем страх перед технологиями. Разбираем простым языком, что такое AI сегодня,
                                            какие рутинные задачи он уже умеет забирать на себя и почему для работы
                                            с ним не нужно быть программистом. Делаем обзор самых доступных текстовых
                                            нейросетей, которые работают без сложных настроек и VPN</p>
                                    </div>
                                </div>
                                <div class="ai042026-program-item-lesson">
                                    <div class="ai042026-program-item-lesson-title careerum-flex-fsc">
                                        <div class="ai042026-program-item-lesson-title-number">
                                            <p>02</p>
                                        </div>
                                        <p>Юридический Firewall: безопасность и NDA</p>
                                    </div>
                                    <div class="ai042026-program-item-lesson-content">
                                        <p>Разбираем правила безопасности: что категорически нельзя отдавать нейросетям
                                            (коммерческая тайна, персональные данные) в реалиях РФ и Global-рынка. Вы освоите
                                            правило «обезличивания» контекста перед загрузкой рабочих документов в AI</p>
                                    </div>
                                </div>
                                <div class="ai042026-program-item-lesson">
                                    <div class="ai042026-program-item-lesson-title careerum-flex-fsc">
                                        <div class="ai042026-program-item-lesson-title-number">
                                            <p>03</p>
                                        </div>
                                        <p>Почему AI не волшебная таблетка</p>
                                    </div>
                                    <div class="ai042026-program-item-lesson-content">
                                        <p>Управление ожиданиями и разрушение мифа о том, что нужно написать один «идеальный»
                                            запрос. Мы закрепляем правило: AI — это рабочий инструмент, который нужно
                                            использовать итеративно, не игнорируя, но и не копируя первый ответ вслепую.
                                            Вы научитесь выстраивать диалог с машиной шаг за шагом, докручивая результаты</p>
                                    </div>
                                </div>
                                <div class="ai042026-program-item-lesson">
                                    <div class="ai042026-program-item-lesson-title careerum-flex-fsc">
                                        <div class="ai042026-program-item-lesson-title-number">
                                            <p>04</p>
                                        </div>
                                        <p>AI для продвинутых</p>
                                    </div>
                                    <div class="ai042026-program-item-lesson-content">
                                        <p>Теоретический хардкор для тех, кто уже активно пользуется нейросетями и хочет выйти
                                            на новый уровень. Разбираем продвинутые темы: что такое системные промпты и как они
                                            меняют логику ответов AI, в чем архитектурная разница между моделями</p>
                                    </div>
                                </div>
                            </div>
                            <div class="ai042026-program-item-button">
                                <p>Подробнее об уроках</p>
                                <p>Свернуть</p>
                            </div>
                        </div>
                        <div class="ai042026-program-item">
                            <div class="ai042026-program-item-header">
                                <div class="ai042026-program-item-labels careerum-flex-fsfs">
                                    <p>Неделя 2</p>
                                    <p>Спикер: Ольга</p>
                                </div>
                                <p class="ai042026-program-item-title">Модуль 2. Аудит своих задач, концепция «Я-корпорация»,
                                    мышление бизнес-процессами</p>
                            </div>
                            <div class="ai042026-program-item-results">
                                <p class="ai042026-program-item-result-title">Результат модуля:</p>
                                <ul>
                                    <li>Перестанете мыслить категориями линейного исполнителя</li>
                                    <li>Разработаете архитектуру своего рабочего конвейера</li>
                                    <li>Научитесь формулировать задачи к AI через бизнес-цели</li>
                                    <li>Оцифруете массив данных своей текущей рабочей рутины</li>
                                </ul>
                            </div>
                            <div class="ai042026-program-item-lessons">
                                <div class="ai042026-program-item-lesson">
                                    <div class="ai042026-program-item-lesson-title careerum-flex-fsc">
                                        <div class="ai042026-program-item-lesson-title-number">
                                            <p>05</p>
                                        </div>
                                        <p>Смена парадигмы: мышление бизнес-процессами и концепция «Я-корпорация»</p>
                                    </div>
                                    <div class="ai042026-program-item-lesson-content">
                                        <p>В этом уроке мы закладываем фундамент: переход от позиции «я — лишь звено в цепи»
                                            к концепции «Я-корпорация». Вы узнаете, как мыслить о себе в рамках рынка,
                                            предоставляя работодателю качественный сервис. Мы разбираем, как перестать делать
                                            задачи руками по привычке и начать смотреть на работу сверху. Вы научитесь
                                            анализировать, как устроен весь бизнес-процесс, чтобы оптимизировать его с помощью
                                            AI на уровне достижения результатов, а не просто выполнения отдельной задачи</p>
                                    </div>
                                </div>
                                <div class="ai042026-program-item-lesson">
                                    <div class="ai042026-program-item-lesson-title careerum-flex-fsc">
                                        <div class="ai042026-program-item-lesson-title-number">
                                            <p>06</p>
                                        </div>
                                        <p>Как ставить AI задачи на языке бизнес-целей</p>
                                    </div>
                                    <div class="ai042026-program-item-lesson-content">
                                        <p>Учимся отходить от базовых команд к запросам уровня бизнес-цели. Вы получите
                                            фреймворк для правильной постановки задач AI: как делегировать процесс машине
                                            так же, как вы делегировали бы его живому эксперту или ассистенту</p>
                                    </div>
                                </div>
                                <div class="ai042026-program-item-lesson">
                                    <div class="ai042026-program-item-lesson-title careerum-flex-fsc">
                                        <div class="ai042026-program-item-lesson-title-number">
                                            <p>07</p>
                                        </div>
                                        <p>AI-оцифровка рабочих задач</p>
                                    </div>
                                    <div class="ai042026-program-item-lesson-content">
                                        <p>Вы узнаете, как выгрузить в AI объём текущих задач (и видимых проектов, и невидимой
                                            сверхнагрузки). Нейросеть поможет собрать это всё вместе в ясную картину, проведёт
                                            аудит и беспристрастно разделит ваши задачи по уровням сложности. AI покажет
                                            ваш фактический масштаб и превратит этот массив данных в железобетонную фактуру
                                            по стандарту Careerum: «активное действие + метрика + релевантность»</p>
                                    </div>
                                </div>
                            </div>
                            <div class="ai042026-program-item-button">
                                <p>Подробнее об уроках</p>
                                <p>Свернуть</p>
                            </div>
                        </div>
                        <div class="ai042026-program-item">
                            <div class="ai042026-program-item-header">
                                <div class="ai042026-program-item-labels careerum-flex-fsfs">
                                    <p>Неделя 3</p>
                                    <p>Спикер: Иннокентий</p>
                                </div>
                                <p class="ai042026-program-item-title">Модуль 3. Делегирование рутины AI, экономия до 3 часов
                                    в день</p>
                            </div>
                            <div class="ai042026-program-item-results">
                                <p class="ai042026-program-item-result-title">Результат модуля:</p>
                                <ul>
                                    <li>Делегируете рутину AI и освободите до 3-х часов в день</li>
                                    <li>Создадите собственные AI-фреймворки для оценки рабочих проектов по ключевым критериям
                                    </li>
                                    <li>Научитесь фильтровать информационный шум и генерировать готовые драфты управленческих
                                        решений</li>
                                </ul>
                            </div>
                            <div class="ai042026-program-item-lessons">
                                <div class="ai042026-program-item-lesson">
                                    <div class="ai042026-program-item-lesson-title careerum-flex-fsc">
                                        <div class="ai042026-program-item-lesson-title-number">
                                            <p>08</p>
                                        </div>
                                        <p>AI для синтеза информации</p>
                                    </div>
                                    <div class="ai042026-program-item-lesson-content">
                                        <p>Учимся работать с огромными массивами данных. Как использовать AI для мгновенного
                                            резюмирования длинных отчётов, встреч (по транскриптам) и объёмной переписки,
                                            экономя до 3-х часов в день на чтении. AI становится вашим аналитиком, вытаскивающим
                                            только самую суть</p>
                                    </div>
                                </div>
                                <div class="ai042026-program-item-lesson">
                                    <div class="ai042026-program-item-lesson-title careerum-flex-fsc">
                                        <div class="ai042026-program-item-lesson-title-number">
                                            <p>09</p>
                                        </div>
                                        <p>AI для быстрого принятия решений (Decision Support System)</p>
                                    </div>
                                    <div class="ai042026-program-item-lesson-content">
                                        <p>Переходим от исполнения к управлению рисками. Создание AI-фреймворков для мгновенной
                                            оценки проектов по ключевым критериям (ROI, риски, ресурсы) и генерация драфтов
                                            решений</p>
                                    </div>
                                </div>
                                <div class="ai042026-program-item-lesson">
                                    <div class="ai042026-program-item-lesson-title careerum-flex-fsc">
                                        <div class="ai042026-program-item-lesson-title-number">
                                            <p>10</p>
                                        </div>
                                        <p>Уровень Executive: автоматизация входящего рабочего потока</p>
                                    </div>
                                    <div class="ai042026-program-item-lesson-content">
                                        <p>Автоматизация и приоритизация задач и email, создание «капсул времени» и фильтрация
                                            информационного шума. Настраиваем систему так, чтобы вы фокусировались только
                                            на задачах с высокой важностью</p>
                                    </div>
                                </div>
                            </div>
                            <div class="ai042026-program-item-button">
                                <p>Подробнее об уроках</p>
                                <p>Свернуть</p>
                            </div>
                        </div>
                        <div class="ai042026-program-item">
                            <div class="ai042026-program-item-header">
                                <div class="ai042026-program-item-labels careerum-flex-fsfs">
                                    <p>Неделя 4</p>
                                </div>
                                <p class="ai042026-program-item-title">Модуль 4. Практика и мастермайнды без теории</p>
                            </div>
                            <div class="ai042026-program-item-results">
                                <p class="ai042026-program-item-result-title">Результат модуля:</p>
                                <p class="ai042026-program-item-result-text">Середина обучения, где уже накопилось много
                                    практиктики и вопросов, которые вы будете разбирать вместе с экспертами курса:</p>
                                <ul>
                                    <li>Внедрите AI-инструменты в работу</li>
                                    <li>Разберете ваши кейсы с экспертами</li>
                                </ul>
                            </div>
                        </div>
                        <div class="ai042026-program-item">
                            <div class="ai042026-program-item-header">
                                <div class="ai042026-program-item-labels careerum-flex-fsfs">
                                    <p>Неделя 5</p>
                                    <p>Спикер: Ольга</p>
                                </div>
                                <p class="ai042026-program-item-title">Модуль 5. AI как спарринг-партнёр для переговоров
                                    с руководством</p>
                            </div>
                            <div class="ai042026-program-item-results">
                                <p class="ai042026-program-item-result-title">Результат модуля:</p>
                                <ul>
                                    <li>Выстроите непробиваемую аргументацию для диалога с руководством (например, о повышении
                                        дохода или отказе от задач без доплаты), безопасно загружая сложную рабочую переписку
                                        в AI</li>
                                    <li>Внедрите личного AI-ассистента. Теперь ваша рутинная работа еженедельно превращается
                                        в структурированные статус-отчёты, которые говорят о вас на языке бизнес-ценности
                                        и повышают ваше влияние</li>
                                </ul>
                            </div>
                            <div class="ai042026-program-item-lessons">
                                <div class="ai042026-program-item-lesson">
                                    <div class="ai042026-program-item-lesson-title careerum-flex-fsc">
                                        <div class="ai042026-program-item-lesson-title-number">
                                            <p>11</p>
                                        </div>
                                        <p>AI-ассистент для управления видимостью</p>
                                    </div>
                                    <div class="ai042026-program-item-lesson-content">
                                        <p>Разрушаем миф о том, что качественную работу заметят автоматически. Мы закрепляем
                                            правило Careerum: регулярная коммуникация результатов руководству — это обязательный
                                            навык специалиста высокого уровня. Учимся говорить о своей работе не через процесс
                                            (“я сделал“), а через ценность и влияние на бизнес. Вы создадите и настроите личного
                                            AI-ассистента, который будет еженедельно собирать ваши рутинные успехи
                                            и автоматически превращать их в структурированный, сильный status update
                                            для руководства, стейкхолдеров или смежных команд</p>
                                    </div>
                                </div>
                                <div class="ai042026-program-item-lesson">
                                    <div class="ai042026-program-item-lesson-title careerum-flex-fsc">
                                        <div class="ai042026-program-item-lesson-title-number">
                                            <p>12</p>
                                        </div>
                                        <p>Симуляция сложных переговоров со стейкхолдерами с помощью AI-спарринг партнёра</p>
                                    </div>
                                    <div class="ai042026-program-item-lesson-content">
                                        <p>Учимся безопасно загружать сложную рабочую переписку в AI, чтобы он выступил вашим
                                            спарринг-партнёром. Нейросеть поможет перевести ваши эмоции в факты, выстроить
                                            непробиваемую аргументацию (на основе вашей оцифрованной ценности из прошлого
                                            модуля) и подготовить стратегию диалога с боссом, используя дипломатичные фреймворки
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="ai042026-program-item-button">
                                <p>Подробнее об уроках</p>
                                <p>Свернуть</p>
                            </div>
                        </div>
                        <div class="ai042026-program-item">
                            <div class="ai042026-program-item-header">
                                <div class="ai042026-program-item-labels careerum-flex-fsfs">
                                    <p>Неделя 6</p>
                                    <p>Спикер: Ольга</p>
                                </div>
                                <p class="ai042026-program-item-title">Модуль 6. AI-лидерство, масштабирование на команду</p>
                            </div>
                            <div class="ai042026-program-item-results">
                                <p class="ai042026-program-item-result-title">Результат модуля:</p>
                                <ul>
                                    <li>Совершите переход от линейного исполнителя к системному стратегу</li>
                                    <li>Научитесь интегрировать AI в бизнес-процессы компании</li>
                                    <li>Перестроите работу команды</li>
                                    <li>Прокачаете AI-насмотренность, которая сделает вашу Я-корпорацию неуязвимой для кризисов
                                        и гарантирует, что ваша ценность на рынке будет расти быстрее конкурентов</li>
                                </ul>
                            </div>
                            <div class="ai042026-program-item-lessons">
                                <div class="ai042026-program-item-lesson">
                                    <div class="ai042026-program-item-lesson-title careerum-flex-fsc">
                                        <div class="ai042026-program-item-lesson-title-number">
                                            <p>13</p>
                                        </div>
                                        <p>От «сильного исполнителя» к стратегу</p>
                                    </div>
                                    <div class="ai042026-program-item-lesson-content">
                                        <p>Разбираем, как специалисту перестроиться, чтобы не отвалиться от рынка. Фокус
                                            на умение делегировать процессы AI и управлять результатами его работы. Демонстрация
                                            разницы между простым чатом и сложными агентами для автоматизации командных задач
                                        </p>
                                    </div>
                                </div>
                                <div class="ai042026-program-item-lesson">
                                    <div class="ai042026-program-item-lesson-title careerum-flex-fsc">
                                        <div class="ai042026-program-item-lesson-title-number">
                                            <p>14</p>
                                        </div>
                                        <p>AI-лидерство как рычаг влияния</p>
                                    </div>
                                    <div class="ai042026-program-item-lesson-content">
                                        <p>Как инициировать AI-оптимизацию в своей и смежных командах, даже если вы пока
                                            не руководитель. Учимся использовать AI-насмотренность для расширения полномочий,
                                            выхода из операционки и обоснования своего перехода на управленческий уровень</p>
                                    </div>
                                </div>
                                <div class="ai042026-program-item-lesson">
                                    <div class="ai042026-program-item-lesson-title careerum-flex-fsc">
                                        <div class="ai042026-program-item-lesson-title-number">
                                            <p>15</p>
                                        </div>
                                        <p>Защита от «коробки под мостом»</p>
                                    </div>
                                    <div class="ai042026-program-item-lesson-content">
                                        <p>Закрепление концепции Я-корпорация. Как сделать AI-насмотренность регулярной рабочей
                                            привычкой, чтобы всегда оставаться востребованным, дорогим специалистом,
                                            чья профессиональная ценность растёт быстрее рынка</p>
                                    </div>
                                </div>
                            </div>
                            <div class="ai042026-program-item-button">
                                <p>Подробнее об уроках</p>
                                <p>Свернуть</p>
                            </div>
                        </div>
                        <div class="ai042026-program-item">
                            <div class="ai042026-program-item-header">
                                <div class="ai042026-program-item-labels careerum-flex-fsfs">
                                    <p>Неделя 7</p>
                                    <p>Спикер: Ольга</p>
                                </div>
                                <p class="ai042026-program-item-title">Модуль 7. Прогнозирование трендов, микрообучение, защита
                                    от устаревания</p>
                            </div>
                            <div class="ai042026-program-item-results">
                                <p class="ai042026-program-item-result-title">Результат модуля:</p>
                                <ul>
                                    <li>Соберете своего личного карьерного AI-прогнозиста и ментора</li>
                                    <li>Поймете, какие навыки будут востребованы в вашей индустрии завтра</li>
                                    <li>Научитесь использовать AI для личного микрообучения каждый день</li>
                                </ul>
                            </div>
                            <div class="ai042026-program-item-lessons">
                                <div class="ai042026-program-item-lesson">
                                    <div class="ai042026-program-item-lesson-title careerum-flex-fsc">
                                        <div class="ai042026-program-item-lesson-title-number">
                                            <p>16</p>
                                        </div>
                                        <p>AI-сканер рынка: прогнозирование восстребованных навыков</p>
                                    </div>
                                    <div class="ai042026-program-item-lesson-content">
                                        <p>Использование AI для анализа глобальных трендов, разбора будущих вакансий и выявления
                                            «затухающих» компетенций в вашей нише</p>
                                    </div>
                                </div>
                                <div class="ai042026-program-item-lesson">
                                    <div class="ai042026-program-item-lesson-title careerum-flex-fsc">
                                        <div class="ai042026-program-item-lesson-title-number">
                                            <p>17</p>
                                        </div>
                                        <p>AI-тьютор: учиться меньше, стоить дороже</p>
                                    </div>
                                    <div class="ai042026-program-item-lesson-content">
                                        <p>Вы создадите личного AI-ассистента, который поможет точечно закрывать пробелы
                                            в навыках (Micro-skilling) всего за 15 минут в день. Вы перестанете учиться
                                            «на всякий случай» и начнёте изучать только то, что напрямую капитализируется
                                            и растит вашу ценность и цену на рынке</p>
                                    </div>
                                </div>
                                <div class="ai042026-program-item-lesson">
                                    <div class="ai042026-program-item-lesson-title careerum-flex-fsc">
                                        <div class="ai042026-program-item-lesson-title-number">
                                            <p>18</p>
                                        </div>
                                        <p>Подготовка к гибридным ролям будущего</p>
                                    </div>
                                    <div class="ai042026-program-item-lesson-content">
                                        <p>Рынок уходит от стандартных профессий к гибридным ролям на стыке функций.
                                            Вы научитесь использовать ИИ, чтобы симулировать рабочие задачи завтрашнего
                                            дня и безопасно тестировать свои навыки</p>
                                    </div>
                                </div>
                            </div>
                            <div class="ai042026-program-item-button">
                                <p>Подробнее об уроках</p>
                                <p>Свернуть</p>
                            </div>
                        </div>
                        <div class="ai042026-program-item">
                            <div class="ai042026-program-item-header">
                                <div class="ai042026-program-item-labels careerum-flex-fsfs">
                                    <p>Неделя 8</p>
                                    <p>Спикер: Ольга</p>
                                </div>
                                <p class="ai042026-program-item-title">Модуль 8. Практика, мастермайнд, выпускной</p>
                            </div>
                            <div class="ai042026-program-item-lessons">
                                <div class="ai042026-program-item-lesson">
                                    <div class="ai042026-program-item-lesson-title careerum-flex-fsc">
                                        <div class="ai042026-program-item-lesson-title-number">
                                            <p>19</p>
                                        </div>
                                        <p>Подведение итогов обучения на мастермайнде</p>
                                    </div>
                                </div>
                                <div class="ai042026-program-item-lesson">
                                    <div class="ai042026-program-item-lesson-title careerum-flex-fsc">
                                        <div class="ai042026-program-item-lesson-title-number">
                                            <p>20</p>
                                        </div>
                                        <p>Живой эфир «Выпускной»</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <a href="https://school.careerum.ru/anketa_ai" target="_blank"
                        class="btn-color-main-black getparams">Заполнить
                        анкету</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-ai042026-format', {
        label: 'AI 0426 format (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-ai042026-format main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <div class="ai042026-format-header careerum-flex-fsfs">
                        <h2>Формат</h2>
                        <p>8 недель</p>
                    </div>
                    <div class="ai042026-format-slider noselect">
                        <div class="ai042026-format-item">
                            <img src="https://cdn.careerum.com/1776865974107-3Sd4O-Cloc.svg" alt="">
                            <p class="ai042026-format-item-title">Нагрузка в неделю</p>
                            <p class="ai042026-format-item-text">В среднем 4–5 часов в неделю. Из них 2 недели будут без новой
                                теории, для закрепления на практике)</p>
                        </div>
                        <div class="ai042026-format-item">
                            <img src="https://cdn.careerum.com/1776865974031-RDHp5-Chat.svg" alt="">
                            <p class="ai042026-format-item-title">Поддержка экспертов</p>
                            <ul>
                                <li>В чате интенсива 5 дней в неделю</li>
                                <li>Фидбек и разбор кейсов на мастермайндах</li>
                            </ul>
                        </div>
                        <div class="ai042026-format-item">
                            <img src="https://cdn.careerum.com/1776865974174-abiZJ-Grad.svg" alt="">
                            <p class="ai042026-format-item-title">Практика</p>
                            <p class="ai042026-format-item-text">4 живых практических мастермайнда</p>
                        </div>
                        <div class="ai042026-format-item">
                            <img src="https://cdn.careerum.com/1776865974265-mC6y8-Suit.svg" alt="">
                            <p class="ai042026-format-item-title">Тревожный чемоданчик карьериста</p>
                            <p class="ai042026-format-item-text">Пакет всех промптов программы</p>
                        </div>
                        <div class="ai042026-format-item">
                            <img src="https://cdn.careerum.com/1776865974294-TcLkI-User.svg" alt="">
                            <p class="ai042026-format-item-title">Личное сопровождение</p>
                            <p class="ai042026-format-item-text">От карьерного эксперта на тарифе Индивидуальное сопровождение
                            </p>
                        </div>
                        <div class="ai042026-format-item">
                            <img src="https://cdn.careerum.com/1776865974233-Yx6j0-Hand.svg" alt="">
                            <p class="ai042026-format-item-title">Buddy-поддержка</p>
                            <p class="ai042026-format-item-text">Мотивация и менторство в тройках с другими участниками
                                по принципу «равный равному»</p>
                        </div>
                        <div class="ai042026-format-item">
                            <img src="https://cdn.careerum.com/1776865974203-gAzqD-Hand.svg" alt="">
                            <p class="ai042026-format-item-title">Комьюнити, нетворкинг</p>
                            <ul>
                                <li>Доступ в закрытое профессиональное сообщество Careerum</li>
                                <li>4 нетворк-встречи в месяц онлайн</li>
                            </ul>
                        </div>
                        <div class="ai042026-format-item">
                            <img src="https://cdn.careerum.com/1776865974141-mIRJk-Coff.svg" alt="">
                            <p class="ai042026-format-item-title">Coffee Buddy</p>
                            <p class="ai042026-format-item-text">Еженедельные онлайн-встречи c участниками интенсива</p>
                        </div>
                    </div>
                    <div class="ai042026-format-nav careerum-flex-fec">
                        <div class="ai042026-format-nav-prev">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_310_1010)">
                                    <foreignObject x="-18.1166" y="-18.1166" width="76.2332" height="76.2332">
                                        <div xmlns="http://www.w3.org/1999/xhtml"
                                            style="backdrop-filter:blur(9.06px);clip-path:url(#bgblur_1_310_1010_clip_path);height:100%;width:100%">
                                        </div>
                                    </foreignObject>
                                    <rect data-figma-bg-blur-radius="18.1166" y="40" width="40" height="40"
                                        transform="rotate(-90 0 40)" fill="#191C20" />
                                    <path d="M13 20L27 20" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M19 26L13 20L19 14" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="bgblur_1_310_1010_clip_path" transform="translate(18.1166 18.1166)">
                                        <rect y="40" width="40" height="40" transform="rotate(-90 0 40)" />
                                    </clipPath>
                                    <clipPath id="clip0_310_1010">
                                        <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="ai042026-format-nav-next">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_310_1014)">
                                    <foreignObject x="-18.1166" y="-18.1166" width="76.2332" height="76.2332">
                                        <div xmlns="http://www.w3.org/1999/xhtml"
                                            style="backdrop-filter:blur(9.06px);clip-path:url(#bgblur_1_310_1014_clip_path);height:100%;width:100%">
                                        </div>
                                    </foreignObject>
                                    <rect data-figma-bg-blur-radius="18.1166" x="40" y="1.74846e-06" width="40" height="40"
                                        transform="rotate(90 40 1.74846e-06)" fill="#191C20" />
                                    <path d="M27 20L13 20" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M21 14L27 20L21 26" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="bgblur_1_310_1014_clip_path" transform="translate(18.1166 18.1166)">
                                        <rect x="40" y="1.74846e-06" width="40" height="40"
                                            transform="rotate(90 40 1.74846e-06)" />
                                    </clipPath>
                                    <clipPath id="clip0_310_1014">
                                        <rect x="40" y="1.74846e-06" width="40" height="40" rx="20"
                                            transform="rotate(90 40 1.74846e-06)" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-ai042026-result', {
        label: 'AI 0426 result (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-ai042026-result main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <h2>Результаты программы для участников:</h2>
                    <div class="ai042026-result-slider noselect">
                        <div class="ai042026-result-item">
                            <p class="ai042026-result-item-title position-relative z-1">Настроите доступ к ключевым нейросетям
                            </p>
                            <p class="ai042026-result-item-text position-relative z-1">Получите знания правил безопасности,
                                позволяющее легально использовать AI даже в строгих корпорациях</p>
                            <div class="ai042026-result-item-img position-relative z-10">
                                <img src="https://cdn.careerum.com/1776867487283-2UHGU-Fram.png"
                                    class="hidden-tablet-mobile position-absolute" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1776891594258-6V3cC-Fram.png" class="hidden-desc-mobile position-absolute" alt="img"
                                    loading="lazy">
                                <img src="https://cdn.careerum.com/1776895286735-Yux5m-Fram.png" class="hidden-desc-tablet position-absolute" alt="img"
                                    loading="lazy">
                            </div>
                        </div>
                        <div class="ai042026-result-item">
                            <p class="ai042026-result-item-title position-relative z-1">Делегируете AI работу с отчётами</p>
                            <p class="ai042026-result-item-text position-relative z-1">С длинными тредами переписки и анализом
                                встреч</p>
                            <div class="ai042026-result-item-img position-relative z-10">
                                <img src="https://cdn.careerum.com/1776867487366-TZMsp-Fram.png"
                                    class="hidden-tablet-mobile position-absolute" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1776891594333-bm26h-Fram.png" class="hidden-desc-mobile position-absolute" alt="img"
                                    loading="lazy">
                                <img src="https://cdn.careerum.com/1776895286833-yFNbQ-Fram.png" class="hidden-desc-tablet position-absolute" alt="img"
                                    loading="lazy">
                            </div>
                        </div>
                        <div class="ai042026-result-item">
                            <p class="ai042026-result-item-title position-relative z-1">Настроите AI-фреймворки</p>
                            <p class="ai042026-result-item-text position-relative z-1">Которые просчитывают риски, окупаемость
                                и ресурсы для любого проекта</p>
                            <div class="ai042026-result-item-img position-relative z-10">
                                <img src="https://cdn.careerum.com/1776867487424-yQYXw-Fram.png"
                                    class="hidden-tablet-mobile position-absolute" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1776891594370-s0SJt-Fram.png" class="hidden-desc-mobile position-absolute" alt="img"
                                    loading="lazy">
                                <img src="https://cdn.careerum.com/1776895286833-yFNbQ-Fram.png" class="hidden-desc-tablet position-absolute" alt="img"
                                    loading="lazy">
                            </div>
                        </div>
                        <div class="ai042026-result-item">
                            <p class="ai042026-result-item-title position-relative z-1">AI будет приоритизировать вашу почту
                                и чаты</p>
                            <p class="ai042026-result-item-text position-relative z-1">Фокусируя ваше внимание только на задачах
                                с высокой бизнес-важностью</p>
                            <div class="ai042026-result-item-img position-relative z-10">
                                <img src="https://cdn.careerum.com/1776867487471-9kpux-Fram.png"
                                    class="hidden-tablet-mobile position-absolute" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1776891594406-OfXO0-Fram.png" class="hidden-desc-mobile position-absolute" alt="img"
                                    loading="lazy">
                                <img src="https://cdn.careerum.com/1776895286900-pCOpU-Fram.png" class="hidden-desc-tablet position-absolute" alt="img"
                                    loading="lazy">
                            </div>
                        </div>
                        <div class="ai042026-result-item">
                            <p class="ai042026-result-item-title position-relative z-1">AI-ассистент</p>
                            <p class="ai042026-result-item-text position-relative z-1">Который еженедельно упаковывает ваши
                                рутинные действия в отчёты о «бизнес-ценности» для руководства и стейкхолдеров</p>
                            <div class="ai042026-result-item-img position-relative z-10">
                                <img src="https://cdn.careerum.com/1776867487511-drP5l-Fram.png"
                                    class="hidden-tablet-mobile position-absolute" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1776891594441-HrgNp-Fram.png" class="hidden-desc-mobile position-absolute" alt="img"
                                    loading="lazy">
                                <img src="https://cdn.careerum.com/1776895286933-KiEFw-Fram.png" class="hidden-desc-tablet position-absolute" alt="img"
                                    loading="lazy">
                            </div>
                        </div>
                        <div class="ai042026-result-item">
                            <p class="ai042026-result-item-title position-relative z-1">Научитесь прогонять сценарии диалогов
                            </p>
                            <p class="ai042026-result-item-text position-relative z-1">Через AI-спарринг партнёра,
                                чтобы переводить эмоции в факты и получать аргументы для повышения дохода или защиты границ</p>
                            <div class="ai042026-result-item-img position-relative z-10">
                                <img src="https://cdn.careerum.com/1776867487568-pYJXd-Fram.png"
                                    class="hidden-tablet-mobile position-absolute" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1776891594475-dYqpf-Fram.png" class="hidden-desc-mobile position-absolute" alt="img"
                                    loading="lazy">
                                <img src="https://cdn.careerum.com/1776895286973-5AuFm-Fram.png" class="hidden-desc-tablet position-absolute" alt="img"
                                    loading="lazy">
                            </div>
                        </div>
                        <div class="ai042026-result-item">
                            <p class="ai042026-result-item-title position-relative z-1">Сформируете пошаговый план внедрения AI
                            </p>
                            <p class="ai042026-result-item-text position-relative z-1">Что позволит вам занять позицию стратега
                                и эксперта, даже если сейчас вы формально не руководитель</p>
                            <div class="ai042026-result-item-img position-relative z-10">
                                <img src="https://cdn.careerum.com/1776867487611-t3vWA-Fram.png"
                                    class="hidden-tablet-mobile position-absolute" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1776891594509-DNGa2-Fram.png" class="hidden-desc-mobile position-absolute" alt="img"
                                    loading="lazy">
                                <img src="https://cdn.careerum.com/1776895286973-5AuFm-Fram.png" class="hidden-desc-tablet position-absolute" alt="img"
                                    loading="lazy">
                            </div>
                        </div>
                        <div class="ai042026-result-item">
                            <p class="ai042026-result-item-title position-relative z-1">Сформируете реестр ваших реальных
                                компетенций</p>
                            <p class="ai042026-result-item-text position-relative z-1">Переведённый в метрики и факты
                                по стандартам топового рынка</p>
                            <div class="ai042026-result-item-img position-relative z-10">
                                <img src="https://cdn.careerum.com/1776867487656-ZaIdd-Fram.png"
                                    class="hidden-tablet-mobile position-absolute" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1776891594543-Hyzg9-Fram.png" class="hidden-desc-mobile position-absolute" alt="img"
                                    loading="lazy">
                                <img src="https://cdn.careerum.com/1776895286973-5AuFm-Fram.png" class="hidden-desc-tablet position-absolute" alt="img"
                                    loading="lazy">
                            </div>
                        </div>
                        <div class="ai042026-result-item">
                            <p class="ai042026-result-item-title position-relative z-1">Создадите систему</p>
                            <p class="ai042026-result-item-text position-relative z-1">Которая сканирует тренды вашей индустрии,
                                находит «слепые зоны» в ваших навыках и составляет план микро-обучения, чтобы ваша цена на рынке
                                росла быстрее конкурентов</p>
                            <div class="ai042026-result-item-img position-relative z-10">
                                <img src="https://cdn.careerum.com/1776867487698-0Aq58-Fram.png"
                                    class="hidden-tablet-mobile position-absolute" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1776891594577-HKFlF-Fram.png" class="hidden-desc-mobile position-absolute" alt="img"
                                    loading="lazy">
                                <img src="https://cdn.careerum.com/1776895287077-DiSAr-Fram.png" class="hidden-desc-tablet position-absolute" alt="img"
                                    loading="lazy">
                            </div>
                        </div>
                    </div>
                    <div class="ai042026-result-nav careerum-flex-fec">
                        <div class="ai042026-result-nav-prev">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_310_1010)">
                                    <foreignObject x="-18.1166" y="-18.1166" width="76.2332" height="76.2332">
                                        <div xmlns="http://www.w3.org/1999/xhtml"
                                            style="backdrop-filter:blur(9.06px);clip-path:url(#bgblur_1_310_1010_clip_path);height:100%;width:100%">
                                        </div>
                                    </foreignObject>
                                    <rect data-figma-bg-blur-radius="18.1166" y="40" width="40" height="40"
                                        transform="rotate(-90 0 40)" fill="#191C20" />
                                    <path d="M13 20L27 20" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M19 26L13 20L19 14" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="bgblur_1_310_1010_clip_path" transform="translate(18.1166 18.1166)">
                                        <rect y="40" width="40" height="40" transform="rotate(-90 0 40)" />
                                    </clipPath>
                                    <clipPath id="clip0_310_1010">
                                        <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="ai042026-result-nav-next">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_310_1014)">
                                    <foreignObject x="-18.1166" y="-18.1166" width="76.2332" height="76.2332">
                                        <div xmlns="http://www.w3.org/1999/xhtml"
                                            style="backdrop-filter:blur(9.06px);clip-path:url(#bgblur_1_310_1014_clip_path);height:100%;width:100%">
                                        </div>
                                    </foreignObject>
                                    <rect data-figma-bg-blur-radius="18.1166" x="40" y="1.74846e-06" width="40" height="40"
                                        transform="rotate(90 40 1.74846e-06)" fill="#191C20" />
                                    <path d="M27 20L13 20" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M21 14L27 20L21 26" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="bgblur_1_310_1014_clip_path" transform="translate(18.1166 18.1166)">
                                        <rect x="40" y="1.74846e-06" width="40" height="40"
                                            transform="rotate(90 40 1.74846e-06)" />
                                    </clipPath>
                                    <clipPath id="clip0_310_1014">
                                        <rect x="40" y="1.74846e-06" width="40" height="40" rx="20"
                                            transform="rotate(90 40 1.74846e-06)" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </div>
                    <a href="https://school.careerum.ru/anketa_ai" target="_blank"
                        class="btn-color-main-black getparams">Заполнить
                        анкету</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-ai042026-pay', {
        label: 'AI 0426 pay (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-ai042026-pay main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Приобрести участие в программе с выгодой?</h2>
                    <div class="ai042026-pay-slider noselect">
                        <div class="ai042026-pay-item ">
                            <img src="https://cdn.careerum.com/1776888890489-2mcFk-Icon.svg" class="hidden-tablet-mobile" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1776892185945-GDfrc-Icon.svg" class="hidden-desc" alt="img" loading="lazy">
                            <p class="ai042026-pay-item-title">Программа входит в подписку Careerum</p>
                            <p class="ai042026-pay-item-text">Программа длится 3 месяца с 19 февраля по 31 апреля и входит в подписку Careerum. Отдельно купить программу невозможно</p>
                        </div>
                        <div class="ai042026-pay-item">
                            <img src="https://cdn.careerum.com/1776888890396-YbDut-Calc.svg" class="hidden-tablet-mobile" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1776892185833-EMYBt-Calc.svg" class="hidden-desc" alt="img" loading="lazy">
                            <p class="ai042026-pay-item-title">Самый выгодный вариант участия:</p>
                            <p class="ai042026-pay-item-text">Единый платеж на 3, 6 или 12 месяцев. После окончания синхронного обучения на программе, вы можете продолжить работу с экспертами и прохождение других обучающих материалов на платформе</p>
                        </div>
                        <div class="ai042026-pay-item">
                            <img src="https://cdn.careerum.com/1776888890519-enGKk-Icon.svg" class="hidden-tablet-mobile" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1776892185977-wWVc8-Icon.svg" class="hidden-desc" alt="img" loading="lazy">
                            <p class="ai042026-pay-item-title">Рассрочка, если важно снизить размер платежа в месяц</p>
                            <p class="ai042026-pay-item-text">Действует на тарифы от 3 месяцев в рублях и евро.</p>
                        </div>
                        <div class="ai042026-pay-item">
                            <img src="https://cdn.careerum.com/1776888890551-upsz2-Icon.svg" class="hidden-tablet-mobile" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1776892186011-HRGa4-Icon.svg" class="hidden-desc" alt="img" loading="lazy">
                            <p class="ai042026-pay-item-title">Чем дольше подписка, тем дешевле </p>
                            <p class="ai042026-pay-item-text">Мы поддерживаем регулярное и системное развитие карьеры. Это наша философия!</p>
                        </div>
                        <div class="ai042026-pay-item">
                            <img src="https://cdn.careerum.com/1776888890460-fvKEt-Curr.svg" class="hidden-tablet-mobile" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1776892185909-aMgCz-Curr.svg" class="hidden-desc" alt="img" loading="lazy">
                            <p class="ai042026-pay-item-title">Можно оплатить в ₽ и € </p>
                        </div>
                    </div>
                    <div class="ai042026-pay-nav careerum-flex-fec">
                        <div class="ai042026-pay-nav-prev">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_310_1010)">
                                    <foreignObject x="-18.1166" y="-18.1166" width="76.2332" height="76.2332">
                                        <div xmlns="http://www.w3.org/1999/xhtml"
                                            style="backdrop-filter:blur(9.06px);clip-path:url(#bgblur_1_310_1010_clip_path);height:100%;width:100%">
                                        </div>
                                    </foreignObject>
                                    <rect data-figma-bg-blur-radius="18.1166" y="40" width="40" height="40"
                                        transform="rotate(-90 0 40)" fill="#191C20" />
                                    <path d="M13 20L27 20" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M19 26L13 20L19 14" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="bgblur_1_310_1010_clip_path" transform="translate(18.1166 18.1166)">
                                        <rect y="40" width="40" height="40" transform="rotate(-90 0 40)" />
                                    </clipPath>
                                    <clipPath id="clip0_310_1010">
                                        <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="ai042026-pay-nav-next">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_310_1014)">
                                    <foreignObject x="-18.1166" y="-18.1166" width="76.2332" height="76.2332">
                                        <div xmlns="http://www.w3.org/1999/xhtml"
                                            style="backdrop-filter:blur(9.06px);clip-path:url(#bgblur_1_310_1014_clip_path);height:100%;width:100%">
                                        </div>
                                    </foreignObject>
                                    <rect data-figma-bg-blur-radius="18.1166" x="40" y="1.74846e-06" width="40" height="40"
                                        transform="rotate(90 40 1.74846e-06)" fill="#191C20" />
                                    <path d="M27 20L13 20" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M21 14L27 20L21 26" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="bgblur_1_310_1014_clip_path" transform="translate(18.1166 18.1166)">
                                        <rect x="40" y="1.74846e-06" width="40" height="40"
                                            transform="rotate(90 40 1.74846e-06)" />
                                    </clipPath>
                                    <clipPath id="clip0_310_1014">
                                        <rect x="40" y="1.74846e-06" width="40" height="40" rx="20"
                                            transform="rotate(90 40 1.74846e-06)" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-ai042026-reviews', {
        label: 'AI 0426 reviews (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-ai042026-reviews main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <h2>Отзывы участников</h2>
                    <div class="ai042026-reviews-slider noselect">
                        <div class="ai042026-reviews-item">
                            <p class="ai042026-reviews-item-header">Анонимно</p>
                            <p class="ai042026-reviews-item-text">До выполнения упражнения мне казалось, что я в основном
                                занималась операционными задачами: собирала информацию, отправляла письма и координировала
                                людей. Когда ИИ перевёл ситуацию на язык бизнеса, я увидела, что фактически выполняла роль
                                связующего звена между HQ и китайской командой, управляла неопределённостью и предотвращала риск
                                срыва международного проекта. Это помогло мне по‑новому посмотреть на свой вклад и увидеть
                                в своей работе больше стратегической ценности, а не только исполнение процессов.</p>
                        </div>
                        <div class="ai042026-reviews-item">
                            <p class="ai042026-reviews-item-header">Анна</p>
                            <p class="ai042026-reviews-item-text">OMG Innokentiy, You've created a monster! 🥵😆 (в хорошем
                                смысле!). Мозг так не работал несколько лет! Я тут боюсь как бы работу не прогулять, зависнув
                                с проектом, по которому делаю домашку!</p>
                        </div>
                        <div class="ai042026-reviews-item">
                            <p class="ai042026-reviews-item-header">Анонимно</p>
                            <p class="ai042026-reviews-item-text">Главный инсайт — провожу для себя переоценку того что можно
                                считать рутинной задачей. Эти задачи я просто считала для себя рабочими, но времени они точно
                                занимали немало. Будет теперь бот мне помогать с быстрыми ответами на запросы цен в зависимости
                                от скоупа проекта)</p>
                        </div>
                        <div class="ai042026-reviews-item">
                            <p class="ai042026-reviews-item-header">Анонимно</p>
                            <p class="ai042026-reviews-item-text">Инсайт: и вопросы от ИИ и сформированные им гипотезы были 100%
                                попаданием в цель. И брифинг и выводы экспертного уровня, причём мотивы поведений были классно
                                разделены по логике. 2 года назад, на такой брейнсторм собирались директора и придумывали
                                продающие и смягчающие нарративы в течение недель. А Claude за 1 час учёл и логику
                                и человеческий фактор. Причём он подсветил мне насколько раньше моя позиция была слабой
                                и почему. И я раньше понимала почему, но не получалось донести это до Топ-менеджмента
                                в правильных тезисах и настоять на своём. А с таким анализом — все как на ладони и неоспоримо.
                                🔥</p>
                        </div>
                        <div class="ai042026-reviews-item">
                            <p class="ai042026-reviews-item-header">Инна C.</p>
                            <p class="ai042026-reviews-item-text">Этот курс очень практичный, сразу получаю реальные результаты.
                                И это только первая неделя. Спасибо вам!</p>
                        </div>
                        <div class="ai042026-reviews-item">
                            <p class="ai042026-reviews-item-header">Анонимно</p>
                            <p class="ai042026-reviews-item-text">Я в восторге от второго модуля! Чувствую что нужно будет
                                ещё раз посмотреть уже после выполнения задания; хоть я и уже и пересматривала некоторые места,
                                всё равно ощущение что я не до конца впитала смысл. Домашку делать конечно лень, но я буду себя
                                уговаривать — верю в процесс.</p>
                        </div>
                        <div class="ai042026-reviews-item">
                            <p class="ai042026-reviews-item-header">Ольга</p>
                            <p class="ai042026-reviews-item-text">ИИ предложил довольно простое решение, с которого можно начать
                                менять ситуацию с постоянными ошибками в аналитике. Но главное не это. Открылись глаза на то,
                                что у меня в принципе не правильно выстроена коммуникация с командой, они не пытаются
                                самостоятельно найти и исправить ошибки и скидывают это на меня, при этом я осознала свои
                                недработки — нет чётких инструкций, чек-листов и критических точек для самоповерки. Что я вообще
                                жду от команды? В общем, уже есть план по изменениям, нужно потратить время на подготовку
                                инструкций. Спасибо за это задание!</p>
                        </div>
                        <div class="ai042026-reviews-item">
                            <p class="ai042026-reviews-item-header">Саша С.</p>
                            <p class="ai042026-reviews-item-text">Смотрю уроки второй недели, просто полный взрыв мозга
                                с головой. Плотность полезной, свежей и применимой инфо зашкаливает 🔥🔥🔥</p>
                        </div>
                        <div class="ai042026-reviews-item">
                            <p class="ai042026-reviews-item-header">Инна С.</p>
                            <p class="ai042026-reviews-item-text">Восхищаюсь курсом! Вчера выполнила часть домашки
                                для 1:1 с начальником через Copilot, превратив оперативную задачу в стратегическую. Сегодня
                                провайдер внезапно спросил мою начальницу о этой задаче. Написала и радовалась, как начальнице
                                повезло с такой подчинённой! 😄 Начальница выдохнула и поблагодарила!</p>
                        </div>
                        <div class="ai042026-reviews-item">
                            <p class="ai042026-reviews-item-header">Марина Р.</p>
                            <p class="ai042026-reviews-item-text">Посмотрела 1 урок 2 модуля и в восторге! Как он точно отразил
                                что произошло у меня на работе))
                                Я на прошлой неделе упомянула что обучаюсь на курсе по внедрению AI в бизнес процессы… и вуаля.
                                От руководителя прилетает задачка найти инструмент для автоматизации сбора информации))</p>
                        </div>
                        <div class="ai042026-reviews-item">
                            <p class="ai042026-reviews-item-header">Анонимно</p>
                            <p class="ai042026-reviews-item-text">Приятно удивило качество ответов на запросы, выходящие далеко
                                за рамки стандартного фирменного рисерча в сети. Очень неожиданные глубокие вопросы, максимально
                                ёмкая и содержательная обратная связь и прекрасные предложения по следующим шагам, действительно
                                привязанным к первоначальной задаче. Создаётся ощущение, что есть‑таки цель у основателей
                                довести до результата и завершить общение, ты не падаешь в кроличью нору бесконечных ветвей
                                диалога, приводящих туда, куда ты собственно и не собиралась…</p>
                        </div>
                        <div class="ai042026-reviews-item">
                            <p class="ai042026-reviews-item-header">Анонимно</p>
                            <p class="ai042026-reviews-item-text">Работала с DeepSeek. Помог по шагам структурировать задачу,
                                я в процессе общения с ним, но уже довольна, пропал страх пустого экрана, действительно!) Рада
                                тому, что задания открываются постепенно. Есть ощущение распределённой нагрузки и возможности
                                поразмыслить над каждым заданием пару дней. Спасибо🙌</p>
                        </div>
                        <div class="ai042026-reviews-item">
                            <p class="ai042026-reviews-item-header">Инна C.</p>
                            <p class="ai042026-reviews-item-text">Хочу поделиться результатом выполнения домашек на примере
                                подготовки презентации с Copilot: сегодня её одобрила мой менеджер и даже не просила ничего
                                дополнительно править. Это успех! 🎉</p>
                        </div>
                        <div class="ai042026-reviews-item">
                            <p class="ai042026-reviews-item-header">Инна C.</p>
                            <p class="ai042026-reviews-item-text">Я вдохновилась результатами участников курса и решила
                                переделать ДЗ1 с чатом GPT. Результат великолепный. В теории он может все делать. Интересно
                                проверить качество на практике 🙂</p>
                        </div>
                        <div class="ai042026-reviews-item">
                            <p class="ai042026-reviews-item-header">Анна</p>
                            <p class="ai042026-reviews-item-text">Решала личную задачу с DeepSeek. Впечатлена этим режимом —
                                не перегружает информацией, сразу даёт квалифицированную гипотезу. Перестраивается в зависимости
                                от моего ответа. Мега полезный способ 🔥</p>
                        </div>
                        <div class="ai042026-reviews-item">
                            <p class="ai042026-reviews-item-header">Анонимно</p>
                            <p class="ai042026-reviews-item-text">Использовала ГПТ. Очень классно и структурно ему удалось
                                нащупать проблему — мне нра)) Если в процессе стратегии и уточнения все выглядело очевидно,
                                то тут он прямо ходил по мозолям. Действительно было ощущение эксперта. Очень нравится
                                структурность и возможность именно упаковать мысли и подумать о него. Тем более, что задача
                                в целом известная и изученная, своего опыта не хватает — его добивает ЛЛМ:)</p>
                        </div>
                        <div class="ai042026-reviews-item">
                            <p class="ai042026-reviews-item-header">Анонимно</p>
                            <p class="ai042026-reviews-item-text">Приятно удивило качество ответов на запросы, выходящие
                                Не привычный для меня формат общения с нейронкой, мне очень зашёл. Пришла с запросом
                                как перестроить процессы 1–1 с подчинёнными. Вопросы задавал очень простые, кажется что можно
                                углубиться, но даже текущий итог мне очень понравился.</p>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-ai042026-linkedin', {
        label: 'AI 0426 linkedin (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-ai042026-linkedin main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <h2>Что пишут участники на Linkedin:</h2>
                    <div class="ai042026-linkedin-slider noselect">
                        <div class="ai042026-linkedin-item careerum-flex-fsfs">
                            <div class="ai042026-linkedin-item-top">
                                <img src="https://cdn.careerum.com/1787657284087-UPYSx-Ð¡Ð½.png" class="hidden-mobile" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1787657958846-sMAl7-Ð¡Ð½.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                            </div>
                            <div class="ai042026-linkedin-item-bottom">
                                <a href="https://www.linkedin.com/feed/update/urn:li:activity:7488260310760595457/" target="_blank">Перейти на Linkedin</a>
                            </div>
                        </div>
                        <div class="ai042026-linkedin-item careerum-flex-fsfs">
                            <div class="ai042026-linkedin-item-top">
                                <img src="https://cdn.careerum.com/1787657284175-PgxNd-Ð¡Ð½.png" class="hidden-mobile" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1787657958927-HykUV-Ð¡Ð½.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                            </div>
                            <div class="ai042026-linkedin-item-bottom">
                                <a href="https://www.linkedin.com/posts/olga-kuzmich_futureofwork-aitools-automation-share-7488556291200655362-Rd9H/" target="_blank">Перейти на Linkedin</a>
                            </div>
                        </div>
                        <div class="ai042026-linkedin-item careerum-flex-fsfs">
                            <div class="ai042026-linkedin-item-top">
                                <img src="https://cdn.careerum.com/1787657284218-YlldC-Ð¡Ð½.png" class="hidden-mobile" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1787657958970-2ucNU-Ð¡Ð½.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                            </div>
                            <div class="ai042026-linkedin-item-bottom">
                                <a href="https://www.linkedin.com/feed/update/urn:li:activity:7488226209818988545/" target="_blank">Перейти на Linkedin</a>
                            </div>
                        </div>
                        <div class="ai042026-linkedin-item careerum-flex-fsfs">
                            <div class="ai042026-linkedin-item-top">
                                <img src="https://cdn.careerum.com/1787657284251-rlF5X-Ð¡Ð½.png" class="hidden-mobile" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1787657959002-O5tyb-Ð¡Ð½.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                            </div>
                            <div class="ai042026-linkedin-item-bottom">
                                <a href="https://www.linkedin.com/feed/update/urn:li:activity:7491175835295543296/" target="_blank">Перейти на Linkedin</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-pack4-form', {
        label: 'Big Pack 4 (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-pack2-form careerum-pack3-form careerum-pack4-form main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <div class="pack-form-logo">
                        <img src="https://cdn.careerum.com/1757407229179-x7R97-logo.svg" class="hidden-tablet-mobile" alt="img"
                            loading="eager">
                        <img src="https://cdn.careerum.com/1755150918402-sy6tj-logo.svg" class="hidden-desc" alt="img"
                            loading="eager">
                    </div>
                    <div class="careerum-form-lead position-relative">
                        <div class="pack-form-top">
                            <div class="pack-form-top-title careerum-flex-sbfs">
                                <div class="pack-form-top-title__item position-relative z-10">
                                    <p class="position-relative pack-form__label">
                                        <span class="position-relative z-10">Карьера в эпоху AI</span> <br>
                                        <span class="position-relative z-20">Big Pack #4</span>
                                    </p>
                                    <h1>Игра на вылет</h1>
                                    <p class="pack-form__subheader">Кто следующий: стажёр, AI или вы?</p>
                                </div>
                                <div class="pack-form-top-title__item card position-relative z-20">
                                    <img src="https://cdn.careerum.com/1776402317951-uDaya-Grou.png"
                                        class="hidden-tablet-mobile position-absolute z-10" alt="img" loading="eager">
                                    <img src="https://cdn.careerum.com/1776405522116-nShma-Grou.png"
                                        class="hidden-desc-mobile position-absolute z-10" alt="img" loading="eager">
                                    <img src="https://cdn.careerum.com/1776408738610-CGm8r-Grou.png"
                                        class="hidden-desc-tablet position-absolute z-10" alt="img" loading="eager">
                                    <div class="position-relative z-20">
                                        <p>Big Pack #4</p>
                                        <p>10 писем с лайфхаками и рекомендациями от основателей Careerum</p>
                                        <p><span>Как внедрить AI, пока не стало слишком поздно </span></p>
                                    </div>
                                </div>
                                <a href="#form" class="btn-color-main-black position-relative z-30">Получать письма</a>
                                <div class="pack-form-top-title__item position-relative z-20">
                                    <div class="lead-form-wrapper position-relative z-20">
                                        <p class="lead-form__title">
                                            Заполните форму, чтобы получать письма
                                        </p>
                                        <div class="careerum-registration-form-club40">
                                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                                data-gjs-type="deva-registration-form">
                                                <div class="careerum-club40-form-name">
                                                    <input type="text" name="name" value="" required placeholder="Имя">
                                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                                </div>
                                                <div class="careerum-club40-form-telegram">
                                                    <input type="text" value="" name="telegram" required placeholder="Telegram">
                                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                                </div>
                                                <div class="careerum-club40-form-email">
                                                    <input type="text" name="email" value="" required placeholder="Почта">
                                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                                </div>
                                                <div class="careerum-club40-form-phone">
                                                    <input type="tel" value="" name="tel" required class="itl-input">
                                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                                </div>
                                                <div class="careerum-club40-form-agree">
                                                    <label>
                                                        <input type="checkbox" name="agree">
                                                        <div>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8"
                                                                viewBox="0 0 8 8" fill="none">
                                                                <path
                                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                            </svg>
                                                        </div>
                                                    </label>
                                                    <p>Я даю согласие
                                                        на обработку персональных данных
                                                        в соответствии с <a href="/ru-ru/legal/privacy">Политикой
                                                            конфиденциальности</a>
                                                    </p>
                                                </div>
                                                <a href="#" class="submit-btn btn-color-main-bright-orange button-sent"
                                                    disabled>Получать письма</a>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="pack-form-center">
                            <div class="careerum-flex-sbfs">
                                <div>
                                    <div class="pack-form-center__item letter-1">
                                        <img src="https://cdn.careerum.com/1776402530738-oYXRq-Grou.png"
                                            class="hidden-tablet-mobile position-absolute z-10" alt="img" loading="eager">
                                        <img src="https://cdn.careerum.com/1776405522219-hjchm-Grou.png"
                                            class="hidden-desc-mobile position-absolute z-10" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1776408738708-uflb3-Over.png"
                                            class="hidden-desc-tablet position-absolute z-10" alt="img" loading="lazy">
                                        <div class="pack-form-center__item__number careerum-flex-fsfs position-relative z-20">
                                            <p>1</p>
                                            <p>письмо</p>
                                        </div>
                                        <p class="pack-form-center__item__header position-relative z-20">Вас не уволят.<br> Всё
                                            будет ещё хуже...</p>
                                        <p class="pack-form-center__item__text position-relative z-20">Письмо-тест на уязвимость
                                            перед AI</p>
                                    </div>
                                    <div class="pack-form-center__item letter-2 hidden-mobile">
                                        <img src="https://cdn.careerum.com/1776403226769-tVwwT-Grou.png"
                                            class="hidden-tablet-mobile position-absolute z-10" alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1776405522185-E11pT-Grou.png"
                                            class="hidden-desc-mobile position-absolute z-10" alt="img" loading="lazy">
                                        <div class="pack-form-center__item__number careerum-flex-fsfs position-relative z-20">
                                            <p>2</p>
                                            <p>письмо</p>
                                        </div>
                                        <p class="pack-form-center__item__header position-relative z-20">У вас есть подчинённый, которому вы ни разу не дали задачу</p>
                                        <p class="pack-form-center__item__text position-relative z-20">Разбираемся, что вы
                                            упускаете и в чем ваш профессиональный промах</p>
                                    </div>
                                </div>
                                <div class="pack-form-center__item badge">
                                    <img src="https://cdn.careerum.com/1776403226801-0tV7L-Gene.png"
                                        class="hidden-tablet-mobile position-absolute z-10" alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1776405521984-pnk2s-Gene.png"
                                        class="hidden-desc-mobile position-absolute z-10" alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1776408738506-HeS48-Gene.png"
                                        class="hidden-desc-tablet position-absolute z-10" alt="img" loading="lazy">
                                    <p class="pack-form-center__item__label position-relative z-20">ПРОЙДИТЕ ТЕСТ</p>
                                    <p class="pack-form-center__item__label position-relative z-20">ПРОЙДИТЕ ТЕСТ</p>
                                    <p class="pack-form-center__item__header position-relative z-20">Как скоро AI заменит вашу
                                        роль? </p>
                                    <p class="pack-form-center__item__text position-relative z-20">Узнаете свой индекс карьерной
                                        уязвимости и что делать, чтобы его укрепить</p>
                                </div>
                                <div class="pack-form-center__item letter-2 hidden-desc-tablet">
                                    <img src="https://cdn.careerum.com/1776408738316-ZUL0K-Foot.png"
                                        class="position-absolute z-10" alt="img" loading="lazy">
                                    <div class="pack-form-center__item__number careerum-flex-fsfs position-relative z-20">
                                        <p>2</p>
                                        <p>письмо</p>
                                    </div>
                                    <p class="pack-form-center__item__header position-relative z-20">У вас есть подчинённый, которому вы ни разу не дали задачу</p>
                                    <p class="pack-form-center__item__text position-relative z-20">Разбираемся, что вы упускаете
                                        и в чем ваш профессиональный промах</p>
                                </div>
                            </div>
                            <div class="careerum-flex-sbfs">
                                <div class="pack-form-center__item letter-3">
                                    <img src="https://cdn.careerum.com/1776403226733-6rEqV-Grou.png"
                                        class="hidden-tablet-mobile position-absolute z-10" alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1776405522255-5HAmG-Grou.png"
                                        class="hidden-desc-mobile position-absolute z-10" alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1776408738428-XvNiG-Foot.png"
                                        class="hidden-desc-tablet position-absolute z-10" alt="img" loading="lazy">
                                    <div class="pack-form-center__item__number careerum-flex-fsfs position-relative z-20">
                                        <p>3</p>
                                        <p>письмо</p>
                                    </div>
                                    <p class="pack-form-center__item__header position-relative z-20">Сколько чужой работы вы
                                        делаете каждый день?</p>
                                    <p class="pack-form-center__item__text position-relative z-20">Анализируем ваш календарь и делаем интересные открытия</p>
                                </div>
                                <div class="pack-form-center__item letter-4">
                                    <img src="https://cdn.careerum.com/1776403226673-8Y35P-Grou.png"
                                        class="hidden-tablet-mobile position-absolute z-10" alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1776405522085-RUqS8-Grou.png"
                                        class="hidden-desc-mobile position-absolute z-10" alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1776408738813-AzWB4-Sect.png"
                                        class="hidden-desc-tablet position-absolute z-10" alt="img" loading="lazy">
                                    <div class="pack-form-center__item__number careerum-flex-fsfs position-relative z-20">
                                        <p>4</p>
                                        <p>письмо</p>
                                    </div>
                                    <p class="pack-form-center__item__header position-relative z-20">Почему лучшие специалисты застревают, а средние растут?</p>
                                    <p class="pack-form-center__item__text position-relative z-20">Как выглядит ваша рабочая неделя глазами руководителя. Спойлер: никак</p>
                                </div>
                                <div class="pack-form-center__item letter-5">
                                    <img src="https://cdn.careerum.com/1776403226700-dzI7C-Over.png"
                                        class="hidden-tablet-mobile position-absolute z-10" alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1776405522351-0WaYR-Over.png"
                                        class="hidden-desc-mobile position-absolute z-10" alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1776408738742-eIWS2-Over.png"
                                        class="hidden-desc-tablet position-absolute z-10" alt="img" loading="lazy">
                                    <div class="pack-form-center__item__number careerum-flex-fsfs position-relative z-20">
                                        <p>5</p>
                                        <p>письмо</p>
                                    </div>
                                    <p class="pack-form-center__item__header position-relative z-20">Как подготовиться к встрече, от которой зависит ваше будущее?</p>
                                </div>
                            </div>
                            <div class="pack-form-center__btn hidden-tablet-mobile">
                                <a href="#form" class="btn-color-main-black">Хочу внедрить AI</a>
                            </div>
                            <div class="careerum-flex-sbfs">
                                <div class="pack-form-center__item letter-6">
                                    <img src="https://cdn.careerum.com/1776403226646-ntIKE-Form.png"
                                        class="hidden-tablet-mobile position-absolute z-10" alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1776405521929-tTupz-Form.png"
                                        class="hidden-desc-mobile position-absolute z-10" alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1776408738472-f0JOD-Form.png"
                                        class="hidden-desc-tablet position-absolute z-10" alt="img" loading="lazy">
                                    <div class="pack-form-center__item__number careerum-flex-fsfs position-relative z-20">
                                        <p>6</p>
                                        <p>письмо</p>
                                    </div>
                                    <p class="pack-form-center__item__header position-relative z-20">Два сценария 2026–2027 годов</p>
                                    <p class="pack-form-center__item__text position-relative z-20 hidden-tablet-mobile">Вы станете исполнителем чужой<br> AI-стратегии или автором своей?</p>
                                    <p class="pack-form-center__item__text position-relative z-20 hidden-desc">Вы станете исполнителем чужой AI-стратегии или автором своей?</p>
                                </div>
                                <div class="pack-form-center__item letter-7">
                                    <img src="https://cdn.careerum.com/1776403226603-wfJqU-Grou.png"
                                        class="hidden-tablet-mobile position-absolute z-10" alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1776405522288-HRY3t-Grou.png"
                                        class="hidden-desc-mobile position-absolute z-10" alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1776408738775-Kryv8-Quot.png"
                                        class="hidden-desc-tablet position-absolute z-10" alt="img" loading="lazy">
                                    <div class="pack-form-center__item__number careerum-flex-fsfs position-relative z-20">
                                        <p>7</p>
                                        <p>письмо</p>
                                    </div>
                                    <p class="pack-form-center__item__header position-relative z-20">Ваше резюме устаревает быстрее, чем вы его обновляете</p>
                                    <p class="pack-form-center__item__text position-relative z-20">То, за что вам платят сегодня, уже появилось в вакансиях стажёров</p>
                                    <p class="pack-form-center__item__text position-relative z-20">Как это увидеть вовремя?</p>
                                </div>
                            </div>
                            <div class="careerum-flex-sbfs pack-form-bottom">
                                <div class="pack-form-center__item letter">
                                    <img src="https://cdn.careerum.com/1776403226521-L7THz-Grou.png"
                                        class="hidden-tablet-mobile position-absolute z-10" alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1776405522320-kBIBi-Grou.png"
                                        class="hidden-desc-mobile position-absolute z-10" alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1776408738673-9M8lw-Grou.png"
                                        class="hidden-desc-tablet position-absolute z-10" alt="img" loading="lazy">
                                    <div class="position-relative z-20">
                                        <p>Бонус</p>
                                        <p>+3 секретных письма</p>
                                        <p>После которых вы перестанете бояться AI и начнёте расти за его счёт</p>
                                    </div>
                                </div>
                                <div class="lead-form-wrapper">
                                    <p>Заберите Big Pack от Ольги Лермонтовой и Иннокентия Солнцева</p>
                                    <p>Чтобы остаться незаменимым и востребованным экспертом на рынке, где AI способен заменить вас за 15% от вашей зарплаты</p>
                                    <div class="careerum-registration-form-club40">
                                        <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                            data-gjs-type="deva-registration-form">
                                            <div class="careerum-club40-form-name">
                                                <input type="text" name="name" value="" required placeholder="Имя">
                                                <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                            </div>
                                            <div class="careerum-club40-form-telegram">
                                                <input type="text" value="" name="telegram" required placeholder="Telegram">
                                                <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                            </div>
                                            <div class="careerum-club40-form-email">
                                                <input type="text" name="email" value="" required placeholder="Почта">
                                                <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                            </div>
                                            <div class="careerum-club40-form-phone">
                                                <input type="tel" value="" name="tel" required class="itl-input">
                                                <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                            </div>
                                            <div class="form-buttons">
                                                <div class="careerum-club40-form-agree">
                                                    <label>
                                                        <input type="checkbox" name="agree">
                                                        <div>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8"
                                                                viewBox="0 0 8 8" fill="none">
                                                                <path
                                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                            </svg>
                                                        </div>
                                                    </label>
                                                    <p>Я даю согласие
                                                        на обработку персональных данных
                                                        в соответствии с <a href="/ru-ru/legal/privacy">Политикой
                                                            конфиденциальности</a>
                                                    </p>
                                                </div>
                                                <a href="#" class="submit-btn btn-color-main-bright-orange button-sent"
                                                    disabled>Получать письма</a>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="careerum-form-success-lead">
                        <div class="position-relative">
                            <h2>Отлично, я уже собрала ваш бокс:</h2>
                            <p>первое письмо прилетит с минуты на минуту</p>
                            <div class="pack-form-author careerum-flex-fsc">
                                <img src="https://cdn.careerum.com/1776405113706-6yaY3-Grou.png" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1776407126056-KSrtE-Grou.png" class="hidden-desc" alt="img"
                                    loading="lazy">
                                <div class="position-relative">
                                    <p class="pack-form-name">Ольга Лермонтова</p>
                                    <p class="pack-form-position">СЕО Careerum</p>
                                </div>
                            </div>
                            <img src="https://cdn.careerum.com/1776758125810-maawq-Grou.svg"
                                class="hidden-tablet-mobile position-relative success-bg" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1776407150989-W5P3B-Grou.svg"
                                class="hidden-desc-mobile position-relative success-bg" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1776407205586-l0R8P-Grou.svg"
                                class="hidden-desc-tablet position-relative success-bg" alt="img" loading="lazy">
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-bigpack-banner', {
        label: 'Big Pack banner (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-bigpack-banner main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <h2 class="position-relative z-10">Карьерная перезагрузка <span>2026</span></h2>
                    <p class="position-relative z-10">Инструкция в 7 письмах</p>
                    <a href="https://careerum.link/siIuZ" target="_blank"
                        class="position-relative z-10 btn-color-main-bright-orange getparams">Читать письма</a>
                    <img src="https://cdn.careerum.com/1777896228780-QfOpJ-Grou.svg"
                        class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                    <img src="https://cdn.careerum.com/1777896259308-PbOcj-Grou.svg"
                        class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                    <img src="https://cdn.careerum.com/1777896285074-etPrY-Fram.svg"
                        class="hidden-desc-tablet position-absolute z-1" alt="img" loading="lazy">
                </div>
            </div>`
    });
    
    blockManager.add('bigpack-banner-top', {
        label: 'Big Pack banner top (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div data-timer="no" data-redirect="no" data-url="" data-static="yes" data-offset=""
                data-timer-end="02/19/2026 00:00 GMT+0300" id="i22kzbd"
                class="careerum-club5-banner-top bigpack-banner-top main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="club5-banner__wrapper position-relative">
                        <div class="club5-banner__bg position-absolute z-10">
                            <img loading="" src="https://cdn.careerum.com/1777897238782-VFyvo-Grou.svg" alt="img"
                                class="hidden-tablet-mobile position-absolute">
                        </div>
                        <div class="club5-banner__content careerum-flex-sbc position-relative z-20">
                            <div class="club5-banner__left">
                                <p class="club5-banner__label hidden">6 мая в 20:00 по мск </p>
                                <p class="club5-banner__title"><span>Карьерная перезагрузка:</span> как выжить в новом мире работы и не попасть под каток изменений?</p>
                                <p class="club5-banner__text">Инструкция в 7 письмах</p>
                            </div>
                            <div class="club5-banner__right careerum-flex-fec">
                                <a onclick="" href="https://careerum.link/siIuZ" target="_blank"
                                    class="btn-color-main-bright-orange getparams">Читать письма</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-pack5-main', {
        label: 'Big Pack 5 main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-pack5-main main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="pack5-form-logo">
                        <img src="https://cdn.careerum.com/1757407229179-x7R97-logo.svg" class="hidden-tablet-mobile" alt="img"
                            loading="eager">
                        <img src="https://cdn.careerum.com/1755150918402-sy6tj-logo.svg" class="hidden-desc" alt="img"
                            loading="eager">
                    </div>
                    <div class="careerum-flex-sbfs pack5-content">
                        <div class="pack5-content-left position-relative z-10">
                            <div class="pack5-content-labels careerum-flex-fsfs">
                                <div class="pack5-content-label">
                                    <p>Тренажёр по коммуникациям</p>
                                </div>
                                <div class="pack5-content-label pink">
                                    <p>Бесплатно</p>
                                </div>
                                <div class="pack5-content-label pink">
                                    <p>10 дней практики</p>
                                </div>
                            </div>
                            <h1>Научитесь сильной коммуникации с руководителем и командой</h1>
                        </div>
                        <div class="pack5-content-right position-relative z-1">
                            <img src="https://cdn.careerum.com/1778763410988-Pffvq-Grou.png"
                                class="hidden-tablet-mobile position-absolute" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1778763412535-jlex3-Grou.png"
                                class="hidden-desc-mobile position-absolute" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1778763414230-I34Kk-Grou.png"
                                class="hidden-desc-tablet position-absolute" alt="img" loading="lazy">
                        </div>
                    </div>
                    <a href="#form" class="btn-color-main-bright-orange position-relative z-10">Прокачать навык коммуникации</a>
                </div>
            </div>`
    });
    
    blockManager.add('pack5-format', {
        label: 'Big Pack 5 format (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-consult0326-format main-wrapper pack5-format">
                <div class="careerum-container-responsive">
                    <h2>Программа тренажёра</h2>
                    <div class="consult0326-format-wrapper">
                        <div class="consult0326-format-item left careerum-flex-sbst">
                            <div class="consult0326-format-item-content position-relative">
                                <p class="consult0326-format-item-number">01</p>
                                <p class="consult0326-format-item-title">Тест на стиль коммуникации</p>
                                <p class="consult0326-format-item-text">Как вас воспринимают коллеги?</p>
                            </div>
                            <div class="consult0326-format-item-empty"></div>
                        </div>
                        <div class="consult0326-format-item careerum-flex-sbst">
                            <div class="position-relative consult0326-format-item-empty"></div>
                            <div class="consult0326-format-item-content">
                                <p class="consult0326-format-item-number">02</p>
                                <p class="consult0326-format-item-title">Видеоуроки от Ольги Лермонтовой</p>
                                <p class="consult0326-format-item-text">Какие проблемы есть у вашего стиля и как их исправить
                                </p>
                            </div>
                        </div>
                        <div class="consult0326-format-item left careerum-flex-sbst">
                            <div class="consult0326-format-item-content position-relative">
                                <p class="consult0326-format-item-number">03</p>
                                <p class="consult0326-format-item-title">Моделируем ситуации на работе</p>
                                <p class="consult0326-format-item-text">Разбор типичных ситуаций по вашему стилю коммуникации
                                </p>
                            </div>
                            <div class="consult0326-format-item-empty"></div>
                        </div>
                        <div class="consult0326-format-item careerum-flex-sbst last-mobile">
                            <div class="position-relative consult0326-format-item-empty"></div>
                            <div class="consult0326-format-item-content">
                                <p class="consult0326-format-item-number">04</p>
                                <p class="consult0326-format-item-title">Практические упражнения</p>
                                <p class="consult0326-format-item-text">3 секретных приёма для прорыва в карьере через сильную
                                    коммуникацию</p>
                            </div>
                        </div>
                        <div class="consult0326-format-item left careerum-flex-sbst">
                            <div class="consult0326-format-item-content position-relative">
                                <p class="consult0326-format-item-number">05</p>
                                <p class="consult0326-format-item-title">Разбор вашего кейса</p>
                                <p class="consult0326-format-item-text">Персонально с карьерными консультантами клуба Careerum
                                </p>
                            </div>
                            <div class="consult0326-format-item-empty position-relative"></div>
                        </div>
                    </div>
                    <a href="#form" class="btn-color-main-bright-orange">Тренажёр по коммуникациям</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-pack5-form', {
        label: 'Big Pack 5 form (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-pack5-form main-wrapper last">
                <div class="careerum-container-responsive careerum-flex-sbfs">
                    <div class="pack5-form-header">
                        <h2>Пройдите весь тренажёр за 10 дней в Telegram</h2>
                        <p>Чтобы в новом сезоне провести переговоры с самым сложным боссом и забрать своё повышение!</p>
                    </div>
                    <div class="pack5-form-wrapper">
                        <div class="careerum-registration-form-club40">
                            <form class="deva-form getcourse-email-signup careerum-flex-fsfs" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-telegram">
                                    <input type="text" value="" name="telegram" required placeholder="Telegram">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="form-buttons">
                                    <a href="#" class="submit-btn btn-color-main-bright-orange button-sent" disabled>Начать
                                        тренировку</a>
                                    <div class="careerum-club40-form-agree">
                                        <label>
                                            <input type="checkbox" name="agree">
                                            <div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                    fill="none">
                                                    <path
                                                        d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                        stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </label>
                                        <p>Я даю согласие
                                            на обработку персональных данных
                                            в соответствии с <a href="/ru-ru/legal/privacy">Политикой
                                                конфиденциальности</a>
                                        </p>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-pack5-item', {
        label: 'Big Pack 5 item (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-pack5-item main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="pack5-item-top">
                        <p class="pack5-item-top-number">01</p>
                        <p class="pack5-item-top-label">Тест на стиль коммуникации</p>
                        <h2>Узнаёте своего персонажа?</h2>
                        <p class="pack5-item-top-text">4 стиля коммуникаторов в команде</p>
                    </div>
                    <div class="pack5-item-tales careerum-flex-sbst">
                        <div class="pack5-item-tale position-relative">
                            <p class="pack5-item-tale-header position-relative z-10">«Надо просто хорошо работать, и тогда это
                                увидит босс»</p>
                            <p class="pack5-item-tale-text position-relative z-10">Это невидимка и ему сложно презентовать свои
                                успехи</p>
                            <img src="https://cdn.careerum.com/1778767714010-uPeZ2-Grou.png"
                                class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1778769586432-nlyaB-Grou.png" class="hidden-desc-mobile position-absolute z-1" alt="img"
                                loading="lazy">
                            <img src="https://cdn.careerum.com/1778829526443-RODwH-Grou.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                                loading="lazy">
                        </div>
                        <div class="pack5-item-tale position-relative">
                            <p class="pack5-item-tale-header position-relative z-10">«Вы совсем рехнулись! Есть нормальные
                                идеи?»</p>
                            <p class="pack5-item-tale-text position-relative z-10">Это агрессивный эксперт и от него порой
                                шарахается даже руководитель</p>
                            <img src="https://cdn.careerum.com/1778767713935-auDZR-Grou.png"
                                class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1778769586338-lXzwE-Grou.png" class="hidden-desc-mobile position-absolute z-1" alt="img"
                                loading="lazy">
                            <img src="https://cdn.careerum.com/1778829526368-5vGnz-Grou.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                                loading="lazy">
                        </div>
                        <div class="pack5-item-tale position-relative">
                            <p class="pack5-item-tale-header position-relative z-10">«Да, вчера я взяла эту задачу. Но сегодня у
                                меня уже нет на неё ресурса. Сорри...»</p>
                            <p class="pack5-item-tale-text position-relative z-10">Это ситуативный игрок и команда часто не
                                может на него положиться</p>
                            <img src="https://cdn.careerum.com/1778767714049-j0O3X-Grou.png"
                                class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1778769586481-wZXpp-Grou.png" class="hidden-desc-mobile position-absolute z-1" alt="img"
                                loading="lazy">
                            <img src="https://cdn.careerum.com/1778829526406-YSAD6-Grou.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                                loading="lazy">
                        </div>
                        <div class="pack5-item-tale position-relative">
                            <p class="pack5-item-tale-header position-relative z-10">«Ребята, давайте жить дружно!»</p>
                            <p class="pack5-item-tale-text position-relative z-10">Это стратегический коммуникатор и он всеми
                                силами избегает конфликтов, теряя деньги</p>
                            <img src="https://cdn.careerum.com/1778767714090-E10wO-Grou.png"
                                class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1778769586524-wTSJC-Grou.png" class="hidden-desc-mobile position-absolute z-1" alt="img"
                                loading="lazy">
                            <img src="https://cdn.careerum.com/1778829526482-5etqu-Grou.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                                loading="lazy">
                        </div>
                    </div>
                    <div class="pack5-item-bottom position-relative">
                        <p class="pack5-item-bottom-header position-relative z-10 hidden-tablet">Каждый из них хочет повышения, <span
                                class="right">но ни один</span> <span class="left">не получит</span></p>
                        <p class="pack5-item-bottom-header position-relative z-10 hidden-desc-mobile">Каждый из них хочет повышения,<br> <span
                                class="left">но ни один не получит</span></p>
                        <p class="pack5-item-bottom-text position-relative z-10">Потому что они НЕ УМЕЮТ использовать
                            коммуникации для прорыва в карьере</p>
                        <p class="pack5-item-bottom-text position-relative z-10">А вы научитесь за 10 дней!</p>
                        <img src="https://cdn.careerum.com/1778766555607-eriNb-whit.png"
                            class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1778769687391-api9E-whit.png" class="hidden-desc-mobile position-absolute z-1" alt="img"
                            loading="lazy">
                        <img src="https://cdn.careerum.com/1778829526522-G5TYu-whit.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                            loading="lazy">
                    </div>
                    <a href="#form" class="btn-color-main-bright-orange">Узнать свой стиль </a>
                </div>
                <div class="careerum-container-responsive">
                    <div class="pack5-item-wrapper careerum-flex-sbst">
                        <div class="pack5-item-top position-relative">
                            <p class="pack5-item-top-number position-relative z-10">02</p>
                            <p class="pack5-item-top-label position-relative z-10">Уроки от Ольги Лермонтовой</p>
                            <h2>Инструкции к вашему стилю коммуникации</h2>
                            <p class="pack5-item-top-text position-relative z-10">Что делать, чтобы вас слушали и слышали, а вы — росли в карьере</p>
                            <img src="https://cdn.careerum.com/1778829789505-573Dc-Gene.png" class="hidden-desc-tablet position-absolute z-1" alt="img" loading="lazy">
                        </div>
                        <div class="pack5-item-bottom">
                            <img src="https://cdn.careerum.com/1778766993453-VeOWn-Fram.png" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1778826849585-GmH4j-Fram.png" class="hidden-desc-mobile" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1778829526127-10JD1-Fram.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                        </div>
                    </div>
                    <a href="#form" class="btn-color-main-bright-orange">Запустить тренажёр</a>
                </div>
                <div class="careerum-container-responsive">
                    <div class="pack5-item-wrapper careerum-flex-sbst">
                        <div class="pack5-item-top">
                            <p class="pack5-item-top-number">03</p>
                            <h2>Разбираем кейсы и ситуации на работе</h2>
                            <p class="pack5-item-top-text">Копаем до самой сути: чтобы вы научились управлять руководителем
                                благодаря навыку коммуникации </p>
                        </div>
                        <div class="pack5-item-bottom">
                            <img src="https://cdn.careerum.com/1778766993603-OKgfG-Fram.png" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1778826849653-DFxff-Fram.png" class="hidden-desc-mobile" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1778829526223-PPY1Z-Fram.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                        </div>
                    </div>
                    <a href="#form" class="btn-color-main-bright-orange">Щёлкать такие кейсы, как орешки</a>
                </div>
                <div class="careerum-container-responsive">
                    <div class="pack5-item-wrapper careerum-flex-sbst">
                        <div class="pack5-item-top">
                            <p class="pack5-item-top-number">04</p>
                            <h2>Секретные приёмы для каждого стиля</h2>
                            <p class="pack5-item-top-text">Простые техники, которые вы сможете применить уже во время
                                прохождения тренажёра и увидеть результаты!</p>
                        </div>
                        <div class="pack5-item-bottom">
                            <img src="https://cdn.careerum.com/1778766993343-zFeDF-Fram.png" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1778826849473-ERXFy-Fram.png" class="hidden-desc-mobile" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1778829526037-jPlxr-Fram.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                        </div>
                    </div>
                    <a href="#form" class="btn-color-main-bright-orange">Узнать все приёмы</a>
                </div>
                <div class="careerum-container-responsive">
                    <div class="pack5-item-wrapper careerum-flex-sbst">
                        <div class="pack5-item-top">
                            <p class="pack5-item-top-number">05</p>
                            <h2>Разбор вашего кейса</h2>
                            <p class="pack5-item-top-text">С карьерным консультантом клуба Careerum: это будет очень ценно!</p>
                        </div>
                        <div class="pack5-item-bottom">
                            <img src="https://cdn.careerum.com/1778766993530-ynp2S-Fram.png" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1778826849700-zraXy-Fram.png" class="hidden-desc-mobile" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1778829526269-WTgqD-Fram.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-gambit-main', {
        label: 'Careerum Gambit Main',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-gambit-main main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <h1 class="position-relative z-10">THE GAMBIT</h1>
                    <p class="gambit-main-subheader position-relative z-10">Играй в карьере по своим правилам</p>
                    <a href="#popup" class="btn-color-main-red">Подписаться на рассылку</a>
                    <img src="https://cdn.careerum.com/1780309828971-INRXw-1b29.png"
                        class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                    <img src="https://cdn.careerum.com/1780309831518-gvyDY-1b29.png"
                        class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                    <img src="https://cdn.careerum.com/1780309833763-Qe7GV-1b29.png"
                        class="hidden-desc-tablet position-absolute z-1" alt="img" loading="lazy">
                </div>
            </div>`
    });
    
    blockManager.add('careerum-gambit-news', {
        label: 'Careerum Gambit news',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-gambit-news main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Лучшие статьи недели</h2>
                    <div class="gambit-news-items careerum-flex-sbst">
                        <a class="gambit-news-item position-relative" href="#" target="_blank">
                            <div class="gambit-news-item-label position-relative z-10">
                                <p>THE MOVE</p>
                            </div>
                            <p class="gambit-news-item-title position-relative z-10">Как просчитать следующий шаг </p>
                            <p class="gambit-news-item-text position-relative z-10">И не разрушить свою карьеру</p>
                            <img src="https://cdn.careerum.com/1780311421691-bNGuD-1503.png"
                                class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780311423281-qkIEJ-1503.png"
                                class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780318616805-9tnxf-1503.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                                loading="lazy">
                        </a>
                        <a class="gambit-news-item position-relative" href="#" target="_blank">
                            <div class="gambit-news-item-label position-relative z-10">
                                <p>THE TRAP</p>
                            </div>
                            <p class="gambit-news-item-title position-relative z-10">На грани Ctrl+Z</p>
                            <p class="gambit-news-item-text position-relative z-10">Почему работа всё чаще ощущается как точка
                                кипения</p>
                            <img src="https://cdn.careerum.com/1780311421691-bNGuD-1503.png"
                                class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780311423281-qkIEJ-1503.png"
                                class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780318616759-4xOYH-5e7e.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                                loading="lazy">
                        </a>
                        <a class="gambit-news-item position-relative" href="#" target="_blank">
                            <div class="gambit-news-item-label position-relative z-10">
                                <p>THE SIGN</p>
                            </div>
                            <p class="gambit-news-item-title position-relative z-10">Под давлением</p>
                            <p class="gambit-news-item-text position-relative z-10">Что происходит, когда работа начинает стоить
                                слишком дорого</p>
                            <img src="https://cdn.careerum.com/1780311421691-bNGuD-1503.png"
                                class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780311423281-qkIEJ-1503.png"
                                class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780318704031-vH0MA-Grou.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                                loading="lazy">
                        </a>
                        <a class="gambit-news-item position-relative" href="#" target="_blank">
                            <div class="gambit-news-item-label position-relative z-10">
                                <p>THE MOVE</p>
                            </div>
                            <p class="gambit-news-item-title position-relative z-10">Как просчитать следующий шаг </p>
                            <p class="gambit-news-item-text position-relative z-10">И не разрушить свою карьеру</p>
                            <img src="https://cdn.careerum.com/1780311421691-bNGuD-1503.png"
                                class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780311423281-qkIEJ-1503.png"
                                class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780318616805-9tnxf-1503.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                                loading="lazy">
                        </a>
                        <a class="gambit-news-item position-relative" href="#" target="_blank">
                            <div class="gambit-news-item-label position-relative z-10">
                                <p>THE MOVE</p>
                            </div>
                            <p class="gambit-news-item-title position-relative z-10">Как просчитать следующий шаг </p>
                            <p class="gambit-news-item-text position-relative z-10">И не разрушить свою карьеру</p>
                            <img src="https://cdn.careerum.com/1780311421691-bNGuD-1503.png"
                                class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780311423281-qkIEJ-1503.png"
                                class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780318616805-9tnxf-1503.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                                loading="lazy">
                        </a>
                        <a class="gambit-news-item position-relative" href="#" target="_blank">
                            <div class="gambit-news-item-label">
                                <p>THE MOVE</p>
                            </div>
                            <p class="gambit-news-item-title">Как просчитать следующий шаг </p>
                            <p class="gambit-news-item-text">И не разрушить свою карьеру</p>
                            <img src="https://cdn.careerum.com/1780311421691-bNGuD-1503.png"
                                class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780311423281-qkIEJ-1503.png"
                                class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780318616805-9tnxf-1503.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                                loading="lazy">
                        </a>
                    </div>
                    <div class="gambit-news-button">
                        <a href="#" class="btn-color-main-red switcher">Больше статей</a>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-gambit-team', {
        label: 'Careerum Gambit team',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-gambit-team main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Команда</h2>
                    <div class="gambit-team-items careerum-flex-fsst">
                        <div class="gambit-team-item">
                            <img src="https://cdn.careerum.com/1780314782007-UZvBL-Fram.png" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780314782007-UZvBL-Fram.png" class="hidden-desc-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780314782007-UZvBL-Fram.png" class="hidden-desc-tablet"
                                alt="img" loading="lazy">
                            <p class="gambit-team-item-name">Настя Березина</p>
                            <p class="gambit-team-item-position">Главный редактор, авторка</p>
                        </div>
                        <div class="gambit-team-item">
                            <img src="https://cdn.careerum.com/1780314782007-UZvBL-Fram.png" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780314782007-UZvBL-Fram.png" class="hidden-desc-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780314782007-UZvBL-Fram.png" class="hidden-desc-tablet"
                                alt="img" loading="lazy">
                            <p class="gambit-team-item-name">Вика Барабошина</p>
                            <p class="gambit-team-item-position">Выпускающий редактор, авторка</p>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-gambit-popular', {
        label: 'Careerum Gambit popular',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-gambit-popular main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Популярные статьи</h2>
                    <div class="gambit-popular-slider">
                        <a class="gambit-popular-item position-relative" href="#" target="_blank">
                            <div class="gambit-popular-item-label position-relative z-10">
                                <p>THE MOVE</p>
                            </div>
                            <p class="gambit-popular-item-title position-relative z-10">Как просчитать следующий шаг </p>
                            <p class="gambit-popular-item-text position-relative z-10">И не разрушить свою карьеру</p>
                            <img src="https://cdn.careerum.com/1780311421691-bNGuD-1503.png"
                                class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780311423281-qkIEJ-1503.png"
                                class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780319120474-WONkf-5f57.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                                loading="lazy">
                        </a>
                        <a class="gambit-popular-item position-relative" href="#" target="_blank">
                            <div class="gambit-popular-item-label position-relative z-10">
                                <p>THE MOVE</p>
                            </div>
                            <p class="gambit-popular-item-title position-relative z-10">Как просчитать следующий шаг </p>
                            <p class="gambit-popular-item-text position-relative z-10">И не разрушить свою карьеру</p>
                            <img src="https://cdn.careerum.com/1780311421691-bNGuD-1503.png"
                                class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780311423281-qkIEJ-1503.png"
                                class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780319120423-wpMrY-5e7e.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                                loading="lazy">
                        </a>
                        <a class="gambit-popular-item position-relative" href="#" target="_blank">
                            <div class="gambit-popular-item-label position-relative z-10">
                                <p>THE MOVE</p>
                            </div>
                            <p class="gambit-popular-item-title position-relative z-10">Как просчитать следующий шаг </p>
                            <p class="gambit-popular-item-text position-relative z-10">И не разрушить свою карьеру</p>
                            <img src="https://cdn.careerum.com/1780311421691-bNGuD-1503.png"
                                class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780311423281-qkIEJ-1503.png"
                                class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780319120293-ZRTly-Grou.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                                loading="lazy">
                        </a>
                        <a class="gambit-popular-item position-relative" href="#" target="_blank">
                            <div class="gambit-popular-item-label position-relative z-10">
                                <p>THE MOVE</p>
                            </div>
                            <p class="gambit-popular-item-title position-relative z-10">Как просчитать следующий шаг </p>
                            <p class="gambit-popular-item-text position-relative z-10">И не разрушить свою карьеру</p>
                            <img src="https://cdn.careerum.com/1780311421691-bNGuD-1503.png"
                                class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780311423281-qkIEJ-1503.png"
                                class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780319120293-ZRTly-Grou.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                                loading="lazy">
                        </a>
                    </div>
                    <div class="gambit-popular-slider-nav careerum-flex-fec">
                        <div class="gambit-popular-nav-prev">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_647_4046)">
                                    <foreignObject x="-18.1166" y="-18.1166" width="76.2332" height="76.2332">
                                        <div xmlns="http://www.w3.org/1999/xhtml"
                                            style="backdrop-filter:blur(9.06px);clip-path:url(#bgblur_1_647_4046_clip_path);height:100%;width:100%">
                                        </div>
                                    </foreignObject>
                                    <rect data-figma-bg-blur-radius="18.1166" y="40" width="40" height="40"
                                        transform="rotate(-90 0 40)" fill="white" />
                                    <path d="M13 20L27 20" stroke="#2B2B2B" stroke-width="2.64201" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M19 26L13 20L19 14" stroke="#2B2B2B" stroke-width="2.64201" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="bgblur_1_647_4046_clip_path" transform="translate(18.1166 18.1166)">
                                        <rect y="40" width="40" height="40" transform="rotate(-90 0 40)" />
                                    </clipPath>
                                    <clipPath id="clip0_647_4046">
                                        <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="gambit-popular-nav-next">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_647_4050)">
                                    <foreignObject x="-18.1166" y="-18.1166" width="76.2332" height="76.2332">
                                        <div xmlns="http://www.w3.org/1999/xhtml"
                                            style="backdrop-filter:blur(9.06px);clip-path:url(#bgblur_1_647_4050_clip_path);height:100%;width:100%">
                                        </div>
                                    </foreignObject>
                                    <rect data-figma-bg-blur-radius="18.1166" x="40" y="1.74846e-06" width="40" height="40"
                                        transform="rotate(90 40 1.74846e-06)" fill="white" />
                                    <path d="M27 20L13 20" stroke="#2B2B2B" stroke-width="2.64201" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M21 14L27 20L21 26" stroke="#2B2B2B" stroke-width="2.64201" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="bgblur_1_647_4050_clip_path" transform="translate(18.1166 18.1166)">
                                        <rect x="40" y="1.74846e-06" width="40" height="40"
                                            transform="rotate(90 40 1.74846e-06)" />
                                    </clipPath>
                                    <clipPath id="clip0_647_4050">
                                        <rect x="40" y="1.74846e-06" width="40" height="40" rx="20"
                                            transform="rotate(90 40 1.74846e-06)" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-gambit-subscribe', {
        label: 'Careerum Gambit subscribe',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-gambit-subscribe main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Подпишитесь на еженедельный дайджест</h2>
                    <div class="gambit-subscribe-wrapper position-relative">
                        <p class="gambit-subscribe-title position-relative z-10">THE GAMBIT</p>
                        <ul class="position-relative z-10">
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1780313561597-NnAh6-Chec.svg" alt="">
                                <p>Подборка лучших статей</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1780313561597-NnAh6-Chec.svg" alt="">
                                <p>Не пропустите важное</p>
                            </li>
                        </ul>
                        <a href="#popup" class="btn-color-main-red position-relative z-10">Подписаться на рассылку</a>
                        <img src="https://cdn.careerum.com/1780313629250-fnKXO-Fram.png"
                            class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1780316677380-DMuf8-Fram.png"
                            class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1780319358007-W7cqY-Fram.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                            loading="lazy">
                    </div>
                    <a href="#popup" class="btn-color-main-red position-relative z-10">Подписаться на рассылку</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-gambit-popup', {
        label: 'Careerum Gambit popup',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-popup careerum-gambit-popup" id="popup">
                <div class="popup__close-button-wrapper careerum-flex-cc close-switch">
                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 1L1 12" stroke="white" stroke-width="2" stroke-linecap="round" />
                        <path d="M12 12L1 1" stroke="white" stroke-width="2" stroke-linecap="round" />
                    </svg>
                </div>
                <div class="gambit-popup-content position-relative z-10">
                    <p class="gambit-popup-title">Заполните форму, чтобы подписаться на рассылку</p>
                    <div class="careerum-registration-form-club40">
                        <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                            data-gjs-type="deva-registration-form">
                            <div class="careerum-club40-form-name">
                                <input type="text" name="name" value="" required placeholder="Имя">
                                <p class="careerum-club40-form-warn">Поле не заполнено</p>
                            </div>
                            <div class="careerum-club40-form-email">
                                <input type="text" name="email" value="" required placeholder="Почта">
                                <p class="careerum-club40-form-warn">Поле не заполнено</p>
                            </div>
                            <div class="careerum-club40-form-phone">
                                <input type="tel" value="" name="tel" required class="itl-input">
                                <p class="careerum-club40-form-warn">Поле не заполнено</p>
                            </div>
                            <div class="careerum-club40-form-agree">
                                <label>
                                    <input type="checkbox" name="agree">
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                            fill="none">
                                            <path
                                                d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                        </svg>
                                    </div>
                                </label>
                                <p>Я даю согласие
                                    на обработку персональных данных
                                    в соответствии с <a href="/ru-ru/legal/privacy">Политикой
                                        конфиденциальности</a>
                                </p>
                            </div>
                            <a href="#" class="submit-btn btn-color-main-red button-sent" disabled>Отправить</a>
                        </form>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-gambit-breadcrumbs', {
        label: 'Careerum Gambit breadcrumbs',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-gambit-breadcrumbs main-wrapper">
                <div class="careerum-container-responsive">
                    <a href="/ru-ru/the-gambit" class="careerum-flex-fsc">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="24" height="24" fill="white" />
                            <path d="M18 4.80005L6 12.925L18 19.8" stroke="#B2B2B2" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        <p>Блог Gambit by Careerum</p>
                    </a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-gambit-intro', {
        label: 'Careerum Gambit intro',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-gambit-intro main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <div class="gambit-intro-labels position-relative z-10 careerum-flex-sbc">
                        <div class="gambit-intro-label">
                            <p>THE MOVE</p>
                        </div>
                        <div class="gambit-intro-date">
                            <p>28 мая 2026</p>
                        </div>
                    </div>
                    <h1 class="position-relative z-10">Как просчитать следующий шаг</h1>
                    <p class="gambit-intro-subheader position-relative z-10">И не разрушить свою карьеру</p>
                    <img src="https://cdn.careerum.com/1780325333685-h8Ny8-1503.png"
                        class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                    <img src="https://cdn.careerum.com/1780325335573-VTCLn-1503.png"
                        class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                    <img src="https://cdn.careerum.com/1780325337494-8vLl0-1503.png"
                        class="hidden-desc-tablet position-absolute z-1" alt="img" loading="lazy">
                </div>
            </div>`
    });
    
    blockManager.add('careerum-gambit-content', {
        label: 'Careerum Gambit content',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-gambit-content main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <h2>Не принимайте решения из усталости</h2>
                    <p class="gambit-content-text">Самые опасные карьерные решения редко принимаются из вдохновения. Чаще —
                        из выгорания, раздражения или желания «сбежать». Уволиться после тяжёлой недели, резко сменить сферу
                        после одного конфликта или согласиться на первую попавшуюся вакансию — это не стратегия, а реакция.</p>
                    <p class="gambit-content-text">Перед любым большим шагом важно отделить эмоции от фактов. Проблема
                        действительно в профессии или в конкретной компании? Вы устали от работы или просто давно не отдыхали?
                        Иногда человеку нужен отпуск, а не новая карьера.</p>
                    <div class="gambit-content-quote">
                        <p class="position-relative z-1">Холодная оценка ситуации помогает не разрушить то, что строилось годами
                        </p>
                    </div>
                    <p class="gambit-content-text">Важно учитывать:</p>
                    <ul>
                        <li class="position-relative">
                            <p class="gambit-content-text">Чему вас научит новая роль;</p>
                        </li>
                        <li class="position-relative">
                            <p class="gambit-content-text">Какие связи и опыт она даст;</p>
                        </li>
                        <li class="position-relative">
                            <p class="gambit-content-text">Будет ли эта работа усиливать ваше резюме через 2–3 года;</p>
                        </li>
                        <li class="position-relative">
                            <p class="gambit-content-text">Насколько она совпадает с вашим образом жизни.</p>
                        </li>
                    </ul>
                    <p class="gambit-content-text">Карьерный рост — это не всегда движение быстрее. Иногда это движение точнее.</p>
                    <div class="gambit-content-button">
                        <a href="#" class="btn-color-main-red">Перейти</a>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-club0526-main', {
        label: 'Careerum club0526 main',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club0526-main main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="club0526-main-wrapper careerum-flex-sbfs">
                        <div class="club0526-main-left">
                            <h1>Careerum</h1>
                            <p class="club0526-main-subheader">Клуб и платформа карьерного развития</p>
                            <p class="club0526-main-text">Помогаем профессионалам <span>вырасти в карьере</span>, когда старые
                                инструменты перестают работать</p>
                        </div>
                        <div class="club0526-main-right">
                            <img src="https://cdn.careerum.com/1780377383552-sJNvZ-Bott.png" class="hidden-tablet-mobile"
                                alt="img" loading="eager">
                            <img src="https://cdn.careerum.com/1780377385820-bck6m-Bott.png" class="hidden-desc-mobile"
                                alt="img" loading="eager">
                            <img src="https://cdn.careerum.com/1780377389360-npvQV-Bott.png" class="hidden-desc-tablet"
                                alt="img" loading="eager">
                        </div>
                    </div>
                    <a href="#buy" class="btn-color-main-black">Заполнить анкету в Careerum</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-club0526-why', {
        label: 'Careerum club0526 why',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club0526-why main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Вам точно к нам, если ваш карьерный кризис выглядит так:</h2>
                    <div class="club0526-why-slider">
                        <div class="club0526-why-item">
                            <div class="club0526-why-item__top">
                                <p class="club0526-why-item__number">01</p>
                                <p class="club0526-why-item__text">Мне страшно остаться без плана, если завтра всё снова
                                    изменится</p>
                            </div>
                            <div>
                                <img src="https://cdn.careerum.com/1780380068706-EGsWK-Fram.png" class="hidden-tablet-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1780380231064-Ji6hf-Fram.png" class="hidden-desc-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1780380372845-bKFFO-Imag.png" class="hidden-desc-tablet"
                                    alt="img" loading="eager">
                            </div>
                        </div>
                        <div class="club0526-why-item">
                            <div class="club0526-why-item__top">
                                <p class="club0526-why-item__number">02</p>
                                <p class="club0526-why-item__text">Мне страшно остаться без плана, если завтра всё снова
                                    изменится</p>
                            </div>
                            <div>
                                <img src="https://cdn.careerum.com/1780380069026-0xUdu-Fram.png" class="hidden-tablet-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1780380231337-m98oO-Fram.png" class="hidden-desc-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1780380372522-x38du-Imag.png" class="hidden-desc-tablet"
                                    alt="img" loading="eager">
                            </div>
                        </div>
                        <div class="club0526-why-item">
                            <div class="club0526-why-item__top">
                                <p class="club0526-why-item__number">03</p>
                                <p class="club0526-why-item__text">Текущая работа выжимает, но страшно уходить</p>
                            </div>
                            <div>
                                <img src="https://cdn.careerum.com/1780380068820-56spf-Fram.png" class="hidden-tablet-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1780380231150-FYUUB-Fram.png" class="hidden-desc-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1780380372601-khTkr-Imag.png" class="hidden-desc-tablet"
                                    alt="img" loading="eager">
                            </div>
                        </div>
                        <div class="club0526-why-item">
                            <div class="club0526-why-item__top">
                                <p class="club0526-why-item__number">04</p>
                                <p class="club0526-why-item__text">AI не заменил меня напрямую, но в компании сокращения и
                                    рабочих мест стало меньше</p>
                            </div>
                            <div>
                                <img src="https://cdn.careerum.com/1780380069066-aXUnT-Fram.png" class="hidden-tablet-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1780380231379-T2I3i-Fram.png" class="hidden-desc-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1780380372881-pfhiV-Imag.png" class="hidden-desc-tablet"
                                    alt="img" loading="eager">
                            </div>
                        </div>
                        <div class="club0526-why-item">
                            <div class="club0526-why-item__top">
                                <p class="club0526-why-item__number">05</p>
                                <p class="club0526-why-item__text">Давно пытаюсь попасть в стабильную компанию с сильным брендом
                                </p>
                            </div>
                            <div>
                                <img src="https://cdn.careerum.com/1780380068896-LApEx-Fram.png" class="hidden-tablet-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1780380231204-6E4eP-Fram.png" class="hidden-desc-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1780380372648-k2sy8-Imag.png" class="hidden-desc-tablet"
                                    alt="img" loading="eager">
                            </div>
                        </div>
                        <div class="club0526-why-item">
                            <div class="club0526-why-item__top">
                                <p class="club0526-why-item__number">06</p>
                                <p class="club0526-why-item__text">Я зрелый специалист, но не понимаю, куда расти дальше</p>
                            </div>
                            <div>
                                <img src="https://cdn.careerum.com/1780380069105-2szqP-Fram.png" class="hidden-tablet-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1780380231425-b1Q16-Fram.png" class="hidden-desc-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1780380372689-B8L1k-Imag.png" class="hidden-desc-tablet"
                                    alt="img" loading="eager">
                            </div>
                        </div>
                        <div class="club0526-why-item">
                            <div class="club0526-why-item__top">
                                <p class="club0526-why-item__number">07</p>
                                <p class="club0526-why-item__text">Я сильный профессионал, но мне не дают повышение: не видят,
                                    задвигают</p>
                            </div>
                            <div>
                                <img src="https://cdn.careerum.com/1780380069146-e9svl-Fram.png" class="hidden-tablet-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1780380231558-p3Z6N-Fram.png" class="hidden-desc-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1780380372921-pszBi-Imag.png" class="hidden-desc-tablet"
                                    alt="img" loading="eager">
                            </div>
                        </div>
                        <div class="club0526-why-item">
                            <div class="club0526-why-item__top">
                                <p class="club0526-why-item__number">08</p>
                                <p class="club0526-why-item__text">Откликаюсь, но вакансий мало и интервью нет</p>
                            </div>
                            <div>
                                <img src="https://cdn.careerum.com/1780380068941-yav46-Fram.png" class="hidden-tablet-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1780380231250-mu4Dq-Fram.png" class="hidden-desc-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1780380372727-bymN4-Imag.png" class="hidden-desc-tablet"
                                    alt="img" loading="eager">
                            </div>
                        </div>
                        <div class="club0526-why-item">
                            <div class="club0526-why-item__top">
                                <p class="club0526-why-item__number">09</p>
                                <p class="club0526-why-item__text">Хочу выйти на международный рынок, но не знаю правил игры</p>
                            </div>
                            <div>
                                <img src="https://cdn.careerum.com/1780380069186-rLi3x-Fram.png" class="hidden-tablet-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1780380231607-uNgnV-Fram.png" class="hidden-desc-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1780380372767-WLiKo-Imag.png" class="hidden-desc-tablet"
                                    alt="img" loading="eager">
                            </div>
                        </div>
                        <div class="club0526-why-item">
                            <div class="club0526-why-item__top">
                                <p class="club0526-why-item__number">10</p>
                                <p class="club0526-why-item__text">Я выгорела, но не понимаю: менять работу, роль или всю
                                    траекторию</p>
                            </div>
                            <div>
                                <img src="https://cdn.careerum.com/1780380069237-yZapj-Fram.png" class="hidden-tablet-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1780380231649-KJEF0-Fram.png" class="hidden-desc-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1780380372960-MqBOF-Imag.png" class="hidden-desc-tablet"
                                    alt="img" loading="eager">
                            </div>
                        </div>
                        <div class="club0526-why-item">
                            <div class="club0526-why-item__top">
                                <p class="club0526-why-item__number">11</p>
                                <p class="club0526-why-item__text">Впервые за годы задаёт себе вопрос: «а чего я хочу на самом
                                    деле?»</p>
                            </div>
                            <div>
                                <img src="https://cdn.careerum.com/1780380068984-xU3Tv-Fram.png" class="hidden-tablet-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1780380231299-tHMlR-Fram.png" class="hidden-desc-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1780380372811-Y36Ow-Imag.png" class="hidden-desc-tablet"
                                    alt="img" loading="eager">
                            </div>
                        </div>
                    </div>
                    <div class="club0526-why-slider-nav careerum-flex-fec">
                        <div class="club0526-why-slider-nav-prev">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_14446_27267)">
                                    <foreignObject x="-18.1166" y="-18.1166" width="76.2332" height="76.2332">
                                        <div xmlns="http://www.w3.org/1999/xhtml"
                                            style="backdrop-filter:blur(9.06px);clip-path:url(#bgblur_1_14446_27267_clip_path);height:100%;width:100%">
                                        </div>
                                    </foreignObject>
                                    <rect data-figma-bg-blur-radius="18.1166" y="40" width="40" height="40"
                                        transform="rotate(-90 0 40)" fill="black" />
                                    <path d="M13 20L27 20" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M19 26L13 20L19 14" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="bgblur_1_14446_27267_clip_path" transform="translate(18.1166 18.1166)">
                                        <rect y="40" width="40" height="40" transform="rotate(-90 0 40)" />
                                    </clipPath>
                                    <clipPath id="clip0_14446_27267">
                                        <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="club0526-why-slider-nav-next">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_14446_27271)">
                                    <foreignObject x="-18.1166" y="-18.1166" width="76.2332" height="76.2332">
                                        <div xmlns="http://www.w3.org/1999/xhtml"
                                            style="backdrop-filter:blur(9.06px);clip-path:url(#bgblur_1_14446_27271_clip_path);height:100%;width:100%">
                                        </div>
                                    </foreignObject>
                                    <rect data-figma-bg-blur-radius="18.1166" x="40" y="1.74846e-06" width="40" height="40"
                                        transform="rotate(90 40 1.74846e-06)" fill="black" />
                                    <path d="M27 20L13 20" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M21 14L27 20L21 26" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="bgblur_1_14446_27271_clip_path" transform="translate(18.1166 18.1166)">
                                        <rect x="40" y="1.74846e-06" width="40" height="40"
                                            transform="rotate(90 40 1.74846e-06)" />
                                    </clipPath>
                                    <clipPath id="clip0_14446_27271">
                                        <rect x="40" y="1.74846e-06" width="40" height="40" rx="20"
                                            transform="rotate(90 40 1.74846e-06)" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-club0526-banner', {
        label: 'Careerum club0526 banner',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club0526-banner main-wrapper">
                <div class="careerum-container-responsive careerum-flex-sbfs">
                    <div class="club0526-banner-left position-relative z-10">
                        <h2 class="position-relative z-10">Причины, почему люди застревают в карьере:</h2>
                        <p class="club0526-banner-subheader position-relative z-10">Именно это даёт Careerum</p>
                        <img src="https://cdn.careerum.com/1780384032332-uSwmm-Vect.svg" class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1780384042020-ZuVdx-Vect.svg" class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1780384051090-fsJvP-Vect.svg" class="hidden-desc-tablet position-absolute z-1" alt="img" loading="lazy">
                    </div>
                    <div class="club0526-banner-right position-relative z-1">
                        <img src="https://cdn.careerum.com/1780385297493-I6zv1-Fram.svg" class="hidden-tablet-mobile position-absolute" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1780383983962-SWI40-Fram.png" class="hidden-desc-mobile position-absolute" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1780383994558-5OldH-Fram.png" class="hidden-desc-tablet position-absolute" alt="img" loading="lazy">
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-club0526-banner2', {
        label: 'Careerum club0526 banner2',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club0526-banner2 main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <h2 class="position-relative z-10">В Careerum вы больше не один на один с карьерой:</h2>
                    <img src="https://cdn.careerum.com/1780393156066-Ee80d-Grou.png" class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                    <img src="https://cdn.careerum.com/1780393157224-AzSm0-Grou.png" class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                    <img src="https://cdn.careerum.com/1780393159429-ZDfAW-Grou.png" class="hidden-desc-tablet position-absolute z-1" alt="img" loading="lazy">
                </div>
            </div>`
    });
    
    blockManager.add('careerum-club0526-example', {
        label: 'Careerum club0526 example',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club0526-example main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Пример карьерной стратегии</h2>
                    <div class="club0526-example-slider">
                        <div class="club0526-example-item">
                            <img src="https://cdn.careerum.com/1780391078058-r3OL1-Fram.png" class="hidden-tablet-mobile" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780391501472-t1DNn-Fram.png" class="hidden-desc-mobile" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780391626890-OinIm-Fram.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                        </div>
                        <div class="club0526-example-item">
                            <img src="https://cdn.careerum.com/1780391078189-4fG2z-Fram.png" class="hidden-tablet-mobile" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780391501587-ySMKx-Fram.png" class="hidden-desc-mobile" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780391626995-wvbo7-Fram.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                        </div>
                        <div class="club0526-example-item">
                            <img src="https://cdn.careerum.com/1780391078241-ToMsQ-Fram.png" class="hidden-tablet-mobile" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780391501625-3Tl1i-Fram.png" class="hidden-desc-mobile" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780391627052-iMAeS-Fram.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                        </div>
                        <div class="club0526-example-item">
                            <img src="https://cdn.careerum.com/1780391078286-CdYMy-Fram.png" class="hidden-tablet-mobile" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780391501660-x1Bna-Fram.png" class="hidden-desc-mobile" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780391627091-68la9-Fram.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                        </div>
                        <div class="club0526-example-item">
                            <img src="https://cdn.careerum.com/1780391078348-AtTxf-Fram.png" class="hidden-tablet-mobile" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780391501696-BdbYK-Fram.png" class="hidden-desc-mobile" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780391627130-OoRDL-Fram.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                        </div>
                        <div class="club0526-example-item">
                            <img src="https://cdn.careerum.com/1780391078397-v5bve-Fram.png" class="hidden-tablet-mobile" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780391501737-Nhf2T-Fram.png" class="hidden-desc-mobile" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1780391627174-vXyyk-Fram.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                        </div>
                    </div>
                    <div class="club0526-example-slider-nav careerum-flex-fec">
                        <div class="club0526-example-slider-nav-prev">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_14446_27267)">
                                    <foreignObject x="-18.1166" y="-18.1166" width="76.2332" height="76.2332">
                                        <div xmlns="http://www.w3.org/1999/xhtml"
                                            style="backdrop-filter:blur(9.06px);clip-path:url(#bgblur_1_14446_27267_clip_path);height:100%;width:100%">
                                        </div>
                                    </foreignObject>
                                    <rect data-figma-bg-blur-radius="18.1166" y="40" width="40" height="40"
                                        transform="rotate(-90 0 40)" fill="black" />
                                    <path d="M13 20L27 20" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M19 26L13 20L19 14" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="bgblur_1_14446_27267_clip_path" transform="translate(18.1166 18.1166)">
                                        <rect y="40" width="40" height="40" transform="rotate(-90 0 40)" />
                                    </clipPath>
                                    <clipPath id="clip0_14446_27267">
                                        <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="club0526-example-slider-nav-next">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_14446_27271)">
                                    <foreignObject x="-18.1166" y="-18.1166" width="76.2332" height="76.2332">
                                        <div xmlns="http://www.w3.org/1999/xhtml"
                                            style="backdrop-filter:blur(9.06px);clip-path:url(#bgblur_1_14446_27271_clip_path);height:100%;width:100%">
                                        </div>
                                    </foreignObject>
                                    <rect data-figma-bg-blur-radius="18.1166" x="40" y="1.74846e-06" width="40" height="40"
                                        transform="rotate(90 40 1.74846e-06)" fill="black" />
                                    <path d="M27 20L13 20" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M21 14L27 20L21 26" stroke="white" stroke-width="2.64201" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="bgblur_1_14446_27271_clip_path" transform="translate(18.1166 18.1166)">
                                        <rect x="40" y="1.74846e-06" width="40" height="40"
                                            transform="rotate(90 40 1.74846e-06)" />
                                    </clipPath>
                                    <clipPath id="clip0_14446_27271">
                                        <rect x="40" y="1.74846e-06" width="40" height="40" rx="20"
                                            transform="rotate(90 40 1.74846e-06)" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('realme-banner-top', {
        label: 'Careerum realme0626 banner top',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div data-timer="no" data-redirect="no" data-url="" data-static="yes" data-offset=""
                data-timer-end="06/30/2026 00:00 GMT+0300" class="careerum-club5-banner-top club5-banner-top2 realme-banner-top main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="club5-banner__wrapper position-relative">
                        <div class="club5-banner__content careerum-flex-sbc position-relative z-20">
                            <div class="club5-banner__left">
                                <p class="club5-banner__title">Бонусы только до 30 июня для списка предзаписи</p>
                            </div>
                            <div class="club5-banner__timer careerum-flex-sbc">
                                <div class="club5-banner__timer-item">
                                    <p class="timer-day-number">00</p>
                                    <p class="timer-day-text"></p>
                                </div>
                                <div class="club5-banner__timer-item">
                                    <p class="timer-hour-number">00</p>
                                    <p class="timer-hour-text"></p>
                                </div>
                                <div class="club5-banner__timer-item">
                                    <p class="timer-min-number">00</p>
                                    <p class="timer-min-text"></p>
                                </div>
                            </div>
                            <div class="club5-banner__right careerum-flex-fec">
                                <a onclick="" href="https://careerum.link/siIuZ" target="_blank"
                                    class="btn-color-main-bright-orange getparams">Подробнее</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-levelup0726-main', {
        label: 'Careerum levelup0726 main',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-levelup0726-main main-wrapper">
                <div class="careerum-container-responsive careerum-flex-sbfs">
                    <div class="levelup0726-main-left">
                        <div class="levelup0726-main-labels careerum-flex-fsfs">
                            <div class="levelup0726-main-label careerum-flex-cc">
                                <p>Мастер-класс Ольги Лермонтовой</p>
                            </div>
                            <div class="levelup0726-main-label blue careerum-flex-cc">
                                <p>Для зрелых профессионалов</p>
                            </div>
                        </div>
                        <h1>Level Up</h1>
                        <p class="levelup0726-main-subheader">Как зарабатывать на 80% больше во второй половине карьеры?</p>
                        <a href="#buy" class="btn-color-main-black">Зарегистрироваться</a>
                    </div>
                    <div class="levelup0726-main-right">
                        <img src="https://cdn.careerum.com/1782902554943-67eiy-Fram.png" class="hidden-tablet-mobile" alt="img"
                            loading="eager">
                        <img src="https://cdn.careerum.com/1782902556295-DQUlc-Fram.png" class="hidden-desc-mobile" alt="eager"
                            loading="lazy">
                        <img src="https://cdn.careerum.com/1782921575671-7rCLF-Fram.png" class="hidden-desc-tablet" alt="eager"
                            loading="lazy">
                        <a href="#buy" class="btn-color-main-black">Зарегистрироваться</a>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-realme0726-compas', {
        label: 'Careerum realme0726 compas',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club5-calendar main-wrapper careerum-realme50-calendar careerum-realme0726-compas">
                <div class="careerum-container-responsive">
                    <div class="club5-calendar-intensive position-relative">
                        <div class="club5-calendar-intensive-top careerum-flex-fsc position-relative z-10">
                            <img src="https://cdn.careerum.com/1782934748873-4tFvP-Fire.svg" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1782934748848-yqR7E-Fire.svg" class="hidden-desc-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1782934755378-EHNfo-Fire.svg" class="hidden-desc-tablet"
                                alt="img" loading="lazy">
                            <p>Бонусный артефакт</p>
                        </div>
                        <p class="club5-calendar-intensive-header position-relative z-10">Карьерный компас</p>
                        <img src="https://cdn.careerum.com/1782935343112-59Yz4-Grou.png" class="hidden-tablet-mobile position-absolute z-1" alt="img"
                            loading="lazy">
                        <img src="https://cdn.careerum.com/1782935344674-EmCHu-Grou.png" class="hidden-desc-mobile position-absolute z-1" alt="img"
                            loading="lazy">
                        <img src="https://cdn.careerum.com/1782935351607-EPJjX-Grou.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                            loading="lazy">
                    </div>
                    <div class="club5-calendar-items-2">
                        <div class="club5-calendar-item2">
                            <div class="club5-calendar-item2-top careerum-flex-sbfs">
                                <div>
                                    <p class="club5-calendar-item2-label">Раздел 1</p>
                                    <p class="club5-calendar-item2-header">Мои внутренние опоры </p>
                                </div>
                                <div class="careerum-flex-cc">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760356855022-smtiq-Grou.svg"
                                        alt="img" class="hidden-tablet-mobile">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760356857182-KJ1d3-Grou.svg"
                                        alt="img" class="hidden-desc-mobile">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760356859200-MnwGp-Grou.svg"
                                        alt="img" class="hidden-desc-tablet">
                                </div>
                            </div>
                            <div class="realme0726-compas-item2-top">
                                <div class="club5-calendar-item2-top-content">
                                    <p class="club5-calendar-items-2-header">Топ-5 Суперсил</p>
                                    <ul>
                                        <li>Ключевые таланты, твердые навыки (hard skills) и кросс-функциональные навыки (soft skills), подтвержденные историями по методу STAR</li>
                                    </ul>
                                </div>
                                <div class="club5-calendar-item2-top-content">
                                    <p class="club5-calendar-items-2-header">Мой карьерный якорь и Топ-3 индивидуальные ценности</p>
                                    <ul>
                                        <li>Глобальная потребность и ее личная формулировка</li>
                                    </ul>
                                </div>
                                <div class="club5-calendar-item2-top-content">
                                    <p class="club5-calendar-items-2-header">Энергетический баланс</p>
                                    <ul>
                                        <li>Топ-3 мотиватора. Задачи, дающие энергию и Топ-3 демотиватора/Red Flags – задачи, забирающие ресурс, которых должно быть не более 20%</li>
                                    </ul>
                                </div>
                                <div class="club5-calendar-item2-top-content">
                                    <p class="club5-calendar-items-2-header">Идеальная рабочая среда</p>
                                    <ul>
                                        <li>3-5 критически важных факторов, без которых работа по любви невозможна</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="club5-calendar-item2">
                            <div class="club5-calendar-item2-top careerum-flex-sbfs">
                                <div>
                                    <p class="club5-calendar-item2-label">Раздел 2</p>
                                    <p class="club5-calendar-item2-header">Карта рынка и гипотезы </p>
                                </div>
                                <div class="careerum-flex-cc">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760356855022-smtiq-Grou.svg"
                                        alt="img" class="hidden-tablet-mobile">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760356857182-KJ1d3-Grou.svg"
                                        alt="img" class="hidden-desc-mobile">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760356859200-MnwGp-Grou.svg"
                                        alt="img" class="hidden-desc-tablet">
                                </div>
                            </div>
                            <div class="realme0726-compas-item2-top">
                                <div class="club5-calendar-item2-top-content">
                                    <p class="club5-calendar-items-2-header">Топ-3 целевые отрасли / подотрасли</p>
                                    <ul>
                                        <li>Результаты широкого поиска и построения майнд-карт</li>
                                    </ul>
                                </div>
                                <div class="club5-calendar-item2-top-content">
                                    <p class="club5-calendar-items-2-header">Шорт-лист карьерных гипотез</p>
                                    <ul>
                                        <li>3 сформулированные гипотезы развития</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="club5-calendar-item2">
                            <div class="club5-calendar-item2-top careerum-flex-sbfs">
                                <div>
                                    <p class="club5-calendar-item2-label">Раздел 3</p>
                                    <p class="club5-calendar-item2-header">Матрица выбора</p>
                                </div>
                                <div class="careerum-flex-cc">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760356855022-smtiq-Grou.svg"
                                        alt="img" class="hidden-tablet-mobile">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760356857182-KJ1d3-Grou.svg"
                                        alt="img" class="hidden-desc-mobile">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760356859200-MnwGp-Grou.svg"
                                        alt="img" class="hidden-desc-tablet">
                                </div>
                            </div>
                            <div class="realme0726-compas-item2-top">
                                <div class="club5-calendar-item2-top-content">
                                    <p class="club5-calendar-items-2-header">Таблица валидации</p>
                                    <ul>
                                        <li>Участник переносит свои гипотезы в таблицу и оценивает их от 1 до 10 по критериям из Раздела 1 (соответствие талантам, ценностям, факторам среды)</li>
                                    </ul>
                                </div>
                                <div class="club5-calendar-item2-top-content">
                                    <p class="club5-calendar-items-2-header">Выбранная гипотеза-лидер</p>
                                    <ul>
                                        <li>Роль, набравшая максимальное количество баллов, которая становится фокусом для тестирования</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="club5-calendar-item2">
                            <div class="club5-calendar-item2-top careerum-flex-sbfs">
                                <div>
                                    <p class="club5-calendar-item2-label">Раздел 4</p>
                                    <p class="club5-calendar-item2-header">Тестирование гипотезы</p>
                                </div>
                                <div class="careerum-flex-cc">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760356855022-smtiq-Grou.svg"
                                        alt="img" class="hidden-tablet-mobile">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760356857182-KJ1d3-Grou.svg"
                                        alt="img" class="hidden-desc-mobile">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1760356859200-MnwGp-Grou.svg"
                                        alt="img" class="hidden-desc-tablet">
                                </div>
                            </div>
                            <div class="realme0726-compas-item2-top">
                                <div class="club5-calendar-item2-top-content">
                                    <p class="club5-calendar-items-2-header">Подготовка к нетворкингу</p>
                                    <ul>
                                        <li>3 качественных, открытых вопроса для представителей выбранной профессии</li>
                                    </ul>
                                </div>
                                <div class="club5-calendar-item2-top-content">
                                    <p class="club5-calendar-items-2-header">План тестирования гипотезы на ближайший месяц</p>
                                    <ul>
                                        <li>Выбор 1-2 форматов тестирования. Это может быть просьба о стажировке внутри своей компании, поиск волонтерского/freelance проекта на Upwork, или внедрение элементов новой роли в текущие задачи</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="club5-calendar-link"><a onclick="" href="#buy" class="btn-color-main-bright-orange">Заполнить
                            анкету предзаписи</a>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-levelup0726-form', {
        label: 'Careerum levelup0726 form',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-levelup0726-form main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="levelup0726-form-bg position-relative z-10">
                        <img src="https://cdn.careerum.com/1783086842453-v4cqK-Fram.png"
                            class="hidden-tablet-mobile position-absolute" alt="img">
                        <img src="https://cdn.careerum.com/1783089848528-yP2Pn-Fram.png"
                            class="hidden-desc-mobile position-absolute" alt="img">
                        <img src="https://cdn.careerum.com/1783090682844-Toelc-Fram.png"
                            class="hidden-desc-tablet position-absolute" alt="img">
                    </div>
                    <div class="levelup0726-form-wrapper careerum-flex-sbfs position-relative z-20">
                        <div class="levelup0726-form-left">
                            <div class="levelup0726-form-left-labels careerum-flex-fsfs">
                                <div class="levelup0726-form-left-label white position-relative z-10">
                                    <p>Бесплатный мастер-класс</p>
                                </div>
                                <div class="levelup0726-form-left-label blue position-relative z-20">
                                    <p>От Ольги Лермонтовой</p>
                                </div>
                            </div>
                            <h2>Level Up: как зарабатывать на 80% больше во второй половине карьеры?</h2>
                        </div>
                        <div class="levelup0726-form-right">
                            <div class="careerum-registration-form-club40">
                                <form class="deva-form addCountry" name="devaRegistrationForm"
                                    data-gjs-type="deva-registration-form">
                                    <div class="careerum-club40-form-name">
                                        <input type="text" name="name" value="" required placeholder="Имя">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                    </div>
                                    <div class="careerum-club40-form-telegram">
                                        <input type="text" value="" name="telegram" required placeholder="Telegram">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                    </div>
                                    <div class="careerum-club40-form-email">
                                        <input type="text" name="email" value="" required placeholder="Почта">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                    </div>
                                    <div class="careerum-club40-form-phone">
                                        <input type="tel" value="" name="tel" required class="itl-input">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                    </div>
                                    <div class="careerum-club40-form-agree">
                                        <label>
                                            <input type="checkbox" name="agree">
                                            <div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                    fill="none">
                                                    <path
                                                        d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                        stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </label>
                                        <p>Я даю согласие
                                            на обработку персональных данных
                                            в соответствии с <a href="/ru-ru/legal/privacy">Политикой
                                                конфиденциальности</a>
                                        </p>
                                    </div>
                                    <a href="#" class="submit-btn btn-color-main-black button-sent"
                                        disabled>Зарегистрироваться</a>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('levelup0726-author', {
        label: 'Careerum levelup0726 author',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club40-author2 main-wrapper club50-author transparent-bg veb0326-author levelup0726-author">
                <div class="careerum-container-responsive">
                    <div class="club40-author2-header position-relative">
                        <p class="position-relative z-10"><span>Мир обновился,</span> а ваша карьерная стратегия — нет!
                        </p>
                        <img loading="eager" src="https://cdn.careerum.com/1774351600370-ivgmA-Grou.svg" alt="img"
                            class="hidden-tablet-mobile position-absolute">
                        <img loading="lazy" src="https://cdn.careerum.com/1774361201080-eWevZ-Grou.svg" alt="img"
                            class="hidden-desc-mobile position-absolute">
                        <img loading="lazy" src="https://cdn.careerum.com/1774362998539-LR2Do-Grou.svg" alt="img"
                            class="hidden-desc-tablet position-absolute">
                    </div>
                    <div class="club40-author2-wrapper careerum-flex-sbst">
                        <div class="club40-author2-left position-relative">
                            <img loading="eager"
                                src="https://storage.yandexcloud.net/cdn.careerum.com/1774430144575-fTM6a-Fram.png" alt="img"
                                class="hidden-tablet-mobile">
                            <img loading="" src="https://storage.yandexcloud.net/cdn.careerum.com/1774430112993-Oarur-Imag.png"
                                alt="img" class="hidden-desc-mobile">
                            <img loading="" src="https://storage.yandexcloud.net/cdn.careerum.com/1774429936942-MgcPy-Grou.png"
                                alt="img" class="hidden-desc-tablet">
                            <p class="club40-author2-name position-absolute">Ольга
                                Лермонтова</p>
                        </div>
                        <div class="club40-author2-right">
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img loading="" src="https://cdn.careerum.com/1751884348694-1DDGj-Soft.svg" alt="img"
                                        class="hidden-mobile">
                                    <img loading="" src="https://cdn.careerum.com/1751884352612-hET3j-Soft.svg" alt="img"
                                        class="hidden-desc-tablet">
                                    <p id="ibakht">Профессии меняются быстрее, чем мы
                                        успеваем к ним адаптироваться&nbsp;</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img loading="" src="https://cdn.careerum.com/1751884348694-1DDGj-Soft.svg" alt="img"
                                        class="hidden-mobile">
                                    <img loading="" src="https://cdn.careerum.com/1751884352612-hET3j-Soft.svg" alt="img"
                                        class="hidden-desc-tablet">
                                    <p id="il27cv">AI забирает высокооплачиваемые
                                        роли&nbsp;</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img loading="" src="https://cdn.careerum.com/1751884348694-1DDGj-Soft.svg" alt="img"
                                        class="hidden-mobile">
                                    <img loading="" src="https://cdn.careerum.com/1751884352612-hET3j-Soft.svg" alt="img"
                                        class="hidden-desc-tablet">
                                    <p id="ig5yf3">8/10 работодателей уже требуют навыки,
                                        которым не учат ни в одном вузе</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img loading="" src="https://cdn.careerum.com/1751884348694-1DDGj-Soft.svg" alt="img"
                                        class="hidden-mobile">
                                    <img loading="" src="https://cdn.careerum.com/1751884352612-hET3j-Soft.svg" alt="img"
                                        class="hidden-desc-tablet">
                                    <p id="ipa86ql"><span  >Это не моя страшилка,
                                            это новая реальность карьерного мира</span></p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img loading="" src="https://cdn.careerum.com/1751884348694-1DDGj-Soft.svg" alt="img"
                                        class="hidden-mobile">
                                    <img loading="" src="https://cdn.careerum.com/1751884352612-hET3j-Soft.svg" alt="img"
                                        class="hidden-desc-tablet">
                                    <p id="iftxbrj">И в ней нужна карьерная перезагрузка
                                        и&nbsp;пересборка</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="case4-main-content__quote careerum-flex-fsfs">
                        <img loading="lazy" src="https://cdn.careerum.com/1765871212658-cZuXd-â .svg" alt="img">
                        <p><span>Самые компетентные,</span> надёжные и выкладывающиеся профессионалы <span>застревают в карьере
                                чаще других.</span> Именно потому что они такие. На мастер-классе я покажу, почему
                            так происходит — с данными, кейсами и конкретным выходом из всех карьерных ловушек зрелых профи.</p>
                    </div>
                    <a href="#buy" class="btn-color-main-bright-orange position-relative z-20 hidden">Купить
                        запись</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-career0726-main', {
        label: 'Careerum career0726 main',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-career0726-main main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="career0726-main-logo">
                        <img src="https://cdn.careerum.com/1784535908312-fAp42-Fram.svg" class="hidden-tablet-mobile" alt="img"
                            loading="eager">
                        <img src="https://cdn.careerum.com/1784537565737-hy3GJ-Fram.svg" class="hidden-desc-mobile" alt="img"
                            loading="eager">
                        <img src="https://cdn.careerum.com/1784537587603-KvueJ-Fram.svg" class="hidden-desc-tablet" alt="img"
                            loading="eager">
                    </div>
                    <div class="career0726-main-wrapper careerum-flex-sbfs">
                        <div class="career0726-main-left">
                            <div class="career0726-main-labels careerum-flex-fsfs">
                                <div class="career0726-main-label careerum-flex-cc">
                                    <p>25 июля в 11:00 сет | 12:00 мск</p>
                                </div>
                            </div>
                            <h1>Вернуть себе карьеру</h1>
                            <p class="career0726-main-subheader">Почему зрелые профессионалы перестают чувствовать карьеру своей
                                — и как это изменить, не обязательно  начиная заново</p>
                        </div>
                        <div class="career0726-main-right">
                            <div class="career0726-main-author careerum-flex-fsc">
                                <img src="https://cdn.careerum.com/1784533241355-kNWXF-Fram.png" class="hidden-tablet-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1784533243251-lUMHZ-Fram.png" class="hidden-desc-mobile"
                                    alt="eager" loading="lazy">
                                <img src="https://cdn.careerum.com/1784533244778-rNY7x-Fram.png" class="hidden-desc-tablet"
                                    alt="eager" loading="lazy">
                                <p><span>Ольга Лермонтова</span><br> ALM candidate по психологии, Harvard Extension School
                                    Основательница Careerum</p>
                            </div>
                            <p class="career0726-main-description">Авторская лекция по мотивам магистерской работы и 14 000+
                                карьерных кейсов" вместо установочной лекции и вот этого всего</p>
                        </div>
                    </div>
                    <a href="#buy" class="btn-color-main-white-red">Зарегистрироваться</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-career0726-author', {
        label: 'Careerum career0726 author',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-career0726-author main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="career0726-author-wrapper careerum-flex-sbst">
                        <div class="career0726-author-left">
                            <img src="https://cdn.careerum.com/1784558624367-5Ddho-Fram.png" class="hidden-tablet-mobile"
                                alt="img" loading="eager">
                            <img src="https://cdn.careerum.com/1784558625770-xhXY9-Imag.png" class="hidden-desc-mobile"
                                alt="eager" loading="lazy">
                            <img src="https://cdn.careerum.com/1784558627470-T8hZ1-Fram.png" class="hidden-desc-tablet"
                                alt="eager" loading="lazy">
                        </div>
                        <div class="career0726-author-right">
                            <p class="career0726-author-header">Я двадцать лет строила карьеру в больших компаниях, потом свою,
                                и перепридумывала себя семь раз.</p>
                            <p class="career0726-author-text">Каждый раз замечала одно и то же — и у себя, так у женщин вокруг:
                                в какой‑то момент карьера, в которую всё вложено, перестаёт ощущаться своей. Достижений
                                хватает — а ощущение такое, будто переросла то, кем была.</p>
                            <p class="career0726-author-text">Долго казалось, что это что‑то личное. Пока за годы работы
                                с тысячами женщин не увидела, что это закономерность. Резюме, вакансии, «найди своё призвание» —
                                всё это работает с симптомом, а не с тем, что за ним.</p>
                            <p class="career0726-author-text">Поэтому пошла учиться в Гарвард — разобраться, как это устроено.
                                Эта лекция — про то, что я поняла.</p>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-career0726-what', {
        label: 'Careerum career0726 what',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-career0726-what main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Что мы разберем на лекции:</h2>
                    <ul>
                        <li>Чем больше вложено в текущую карьеру, тем труднее решиться её менять</li>
                        <li>После 35 карьерная активность снижается не из-за угасания амбиций, а из-за нехватки стратегии и ясности</li>
                        <li>Чем сильнее потребность выбрать «правильно», тем реже женщина решается на карьерный эксперимент</li>
                        <li>Женщины чаще меняют карьеру под давлением обстоятельств, чем по собственной инициативе — даже когда работа давно не приносит удовлетворения</li>
                        <li>Наличие карьерной стратегии определяет реальные действия сильнее, чем уверенность в себе</li>
                    </ul>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-career0726-about', {
        label: 'Careerum career0726 about',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-career0726-about main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Об Ольге Лермонтовой:</h2>
                    <ul>
                        <li class="careerum-flex-fsfs">
                            <img src="https://cdn.careerum.com/1784533167508-SNZaZ-Soft.svg" alt="img" loading="eager">
                            <div>
                                <p class="career0726-about-header">Основательница международной карьерной платформы
                                    Careerum</p>
                                <p class="career0726-about-text">14000+ клиентов из 60+ стран построили с ее помощью
                                    карьеру в топовых мировых компаниях</p>
                            </div>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://cdn.careerum.com/1784533167508-SNZaZ-Soft.svg" alt="img" loading="eager">
                            <div>
                                <p class="career0726-about-header">Harvard Extension School</p>
                                <p class="career0726-about-text">магистратура по психологии (ALM)</p>
                            </div>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://cdn.careerum.com/1784533167508-SNZaZ-Soft.svg" alt="img" loading="eager">
                            <div>
                                <p class="career0726-about-header">15+ лет управленческой карьеры</p>
                                <p class="career0726-about-text">в Google, Microsoft, Adobe, Intel на 25 рынках
                                    (Европа,
                                    СНГ, Ближний Восток, Африка)</p>
                            </div>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://cdn.careerum.com/1784533167508-SNZaZ-Soft.svg" alt="img" loading="eager">
                            <div>
                                <p class="career0726-about-header">MBA, INSEAD</p>
                                <p class="career0726-about-text">топ-3 бизнес-школа мира</p>
                            </div>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://cdn.careerum.com/1784533167508-SNZaZ-Soft.svg" alt="img" loading="eager">
                            <div>
                                <p class="career0726-about-header">Состоялась в разных форматах:</p>
                                <p class="career0726-about-text">как сотрудник, эксперт-фрилансер и предприниматель</p>
                            </div>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://cdn.careerum.com/1784533167508-SNZaZ-Soft.svg" alt="img" loading="eager">
                            <div>
                                <p class="career0726-about-header">Перепридумывала свою карьеру 7 раз:</p>
                                <p class="career0726-about-text">из репетитора по языкам — в продажи и маркетинг —
                                    потом
                                    в стратегию — потом в свой бизнес</p>
                            </div>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <img src="https://cdn.careerum.com/1784533167508-SNZaZ-Soft.svg" alt="img" loading="eager">
                            <div>
                                <p class="career0726-about-header">Автор бестселлера </p>
                                <p class="career0726-about-text">МИФ «Работа по любви»</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-career0726-tariffs', {
        label: 'Careerum career0726 tariffs',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-career0726-tariffs main-wrapper careerum-awake-tariffs">
                <div class="careerum-container-responsive">
                    <div class="career0726-tariffs-header careerum-flex-sbfs">
                        <h2>Участие</h2>
                        <div class="awake-tariffs-curr careerum-flex-fsst">
                            <ul class="careerum-flex-fsfs rub">
                                <li data-currency="eur">EUR</li>
                                <li data-currency="rub" class="active">RUB</li>
                            </ul>
                            <div class="awake-tariffs-notif careerum-flex-cc">
                                <div class="awake-tariffs-notif-icon">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                        alt="">
                                </div>
                                <div class="awake-tariffs-notif-content">
                                    <p>Оплата в российских рублях возможна только картой
                                        российского банка.
                                        В евро — картой
                                        зарубежного банка</p>
                                </div>
                            </div>
                        </div>
                        <div class="awake-tariffs-curr-mobile careerum-flex-fefs">
                            <div class="awake-tariffs__swicher-block">
                                <div class="awake-tariffs__swicher-top">
                                    <p class="awake-tariffs__swicher-header"><span class="revert">RUB</span></p>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" class="awake-tariffs__swicher-arrow">
                                        <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black">
                                        </path>
                                    </svg>
                                </div>
                                <div class="awake-tariffs__swicher-bottom">
                                    <ul>
                                        <li data-currency="rub" class="active">RUB</li>
                                        <li data-currency="eur" class="">EUR</li>
                                    </ul>
                                    <p>
                                        Обратите внимание,<br> что оплата в российских
                                        рублях
                                        возможна только<br> с карты
                                        российского банка. Оплата в евро — с карты зарубежного банка
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="career0726-tariffs-wrapper careerum-flex-sbst">
                        <div class="awake-tariffs-item careerum-flex-fsfs">
                            <p class="career0726-tariffs-item-header">Онлайн-участие в лекции</p>
                            <ul>
                                <li>Участие в лекции</li>
                                <li class="disabled">PDF лекции</li>
                                <li class="disabled">Запись лекции</li>
                            </ul>
                            <a href="#" class="no-change no-popup getparams btn-color-main-black" target="_blank">Регистрация</a>
                        </div>
                        <div class="awake-tariffs-item careerum-flex-fsfs" data-price-1m-rub="2 900 ₽" data-price-1m-eur="290 €">
                            <p class="career0726-tariffs-item-header">Онлайн-участие + запись</p>
                            <ul>
                                <li>Участие в лекции</li>
                                <li>PDF лекции</li>
                                <li>Запись лекции</li>
                            </ul>
                            <div class="career0726-tariffs-item-price">
                                <p class="career0726-tariffs-item-fullprice-amount">2 900 ₽</p>
                            </div>
                            <a href="#1" class="btn-color-main-black">Выбрать билет</a>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-reviews0726-main', {
        label: 'Careerum reviews0726 main',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-reviews0726-main main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="reviews0726-main-logo">
                        <img src="https://cdn.careerum.com/1784752416559-P6rDq-logo.svg" class="hidden-tablet-mobile" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1784874080139-P51pz-logo.svg" class="hidden-desc" alt="img" loading="lazy">
                    </div>
                    <h1>Отзывы о карьерном клубе Careerum</h1>
                    <div class="reviews0726-main-label careerum-flex-fsc">
                        <p class="reviews0726-main-rating">4.6</p>
                        <img src="https://cdn.careerum.com/1784732331114-4Vool-Fram.svg" class="hidden-mobile" alt="img"
                            loading="lazy">
                        <img src="https://cdn.careerum.com/1784732341127-hq0PY-Fram.svg" class="hidden-desc-tablet" alt="img"
                            loading="lazy">
                        <p class="reviews0726-main-reviews">128 отзывов</p>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-reviews0726-about', {
        label: 'Careerum reviews0726 about',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-reviews0726-about main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>О клубе</h2>
                    <div class="reviews0726-about-content careerum-flex-sbfs">
                        <div class="reviews0726-about-left">
                            <p>Карьерный клуб Careerum — подписка на закрытое сообщество русскоязычных специалистов в 60+
                                странах: чаты по профессиям и странам, эфиры экспертов с ICF-сертификацией, карьерные треки
                                и тренировочные собеседования.</p>
                            <p>Участники хвалят нетворкинг и поддержку; Главная претензия — цена и то, что пользу нужно забирать
                                самому.</p>
                            <p>Средняя оценка <span>4.6 / 5</span> по 128 отзывам</p>
                        </div>
                        <div class="reviews0726-about-right">
                            <div class="reviews0726-about-rating">
                                <p class="reviews0726-about-number">4.6</p>
                                <img src="https://cdn.careerum.com/1784732331114-4Vool-Fram.svg" class="hidden-mobile" alt="img"
                                    loading="lazy">
                                <img src="https://cdn.careerum.com/1784732341127-hq0PY-Fram.svg" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                                <p class="reviews0726-about-text">Сводная оценка клуба</p>
                            </div>
                            <div class="reviews0726-about-description careerum-flex-sbfs">
                                <div class="reviews0726-about-item">
                                    <p class="reviews0726-about-item-header">128</p>
                                    <p class="reviews0726-about-item-text">Отзывов</p>
                                </div>
                                <div class="reviews0726-about-item">
                                    <p class="reviews0726-about-item-header">86%</p>
                                    <p class="reviews0726-about-item-text">Рекомендуют</p>
                                </div>
                                <div class="reviews0726-about-item">
                                    <p class="reviews0726-about-item-header">июль’26</p>
                                    <p class="reviews0726-about-item-text">Обновлено</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-reviews0726-rating', {
        label: 'Careerum reviews0726 rating',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-reviews0726-rating main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="reviews0726-rating-top">
                        <h2>4.6</h2>
                        <img src="https://cdn.careerum.com/1784732331114-4Vool-Fram.svg" class="hidden-mobile" alt="img"
                            loading="lazy">
                        <img src="https://cdn.careerum.com/1784732341127-hq0PY-Fram.svg" class="hidden-desc-tablet" alt="img"
                            loading="lazy">
                        <p class="reviews0726-rating-text">Сводная оценка Карьерного Клуба</p>
                    </div>
                    <div class="reviews0726-rating-bottom careerum-flex-sbfs">
                        <div class="reviews0726-rating-item">
                            <p class="reviews0726-rating-item-header">128</p>
                            <p class="reviews0726-rating-item-text">Отзывов</p>
                        </div>
                        <div class="reviews0726-rating-item">
                            <p class="reviews0726-rating-item-header">93%</p>
                            <p class="reviews0726-rating-item-text">Рекомендуют</p>
                        </div>
                        <div class="reviews0726-rating-item">
                            <p class="reviews0726-rating-item-header">июль’26</p>
                            <p class="reviews0726-rating-item-text">Обновлено</p>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-reviews0726-pros', {
        label: 'Careerum reviews0726 pros',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-reviews0726-pros main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Плюсы и минусы — честно</h2>
                    <div class="reviews0726-pros-content careerum-flex-sbst">
                        <div class="reviews0726-pros-left">
                            <p class="reviews0726-pros-header green">За что хвалят:</p>
                            <ul>
                                <li>Нетворкинг и интро в компании изнутри</li>
                                <li>Эксперты с ICF, сильные эфиры</li>
                                <li>Разнообразие материалов и треков</li>
                                <li>Поддержка комьюнити, вакансии от участников</li>
                            </ul>
                        </div>
                        <div class="reviews0726-pros-right">
                            <p class="reviews0726-pros-header red">За что кртитикуют:</p>
                            <ul>
                                <li>Цена выше разовой консультации</li>
                                <li>Пользу надо забирать самому — не «под ключ»</li>
                                <li>Автопродление подписки</li>
                                <li>Часть контента — не под каждый уровень</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-reviews0726-reviews', {
        label: 'Careerum reviews0726 reviews',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-reviews0726-reviews main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Что говорят участники</h2>
                    <div class="reviews0726-reviews-content careerum-flex-sbst">
                        <div class="reviews0726-reviews-item item2 careerum-flex-fsfs">
                            <p class="reviews0726-reviews-item-header">Карьерный клуб</p>
                            <div class="reviews0726-reviews-item-top careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1784732492132-lhJvD-Fram.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1784748501207-gkL4d-Fram.svg" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1784750410935-W2k6T-Fram.svg" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                                <div>
                                    <p class="reviews0726-reviews-item-name">Марина К.</p>
                                    <div class="reviews0726-reviews-item-description careerum-flex-fsfs">
                                        <p>Продакт</p>
                                        <p>Берлин</p>
                                        <p>Оффер</p>
                                    </div>
                                    <div class="reviews0726-reviews-item-rating careerum-flex-fsc">
                                        <p>4.8</p>
                                        <img src="https://cdn.careerum.com/1784732492322-lfE3c-Fram.svg" class="hidden-mobile"
                                            alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1784732550291-tUBbQ-Fram.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                    </div>
                                </div>
                            </div>
                            <div class="reviews0726-reviews-item-bottom">
                                <p class="reviews0726-reviews-item-text">«Пришла за структурой поиска, осталась за комьюнити.
                                    Через чат продактов получила интро в компанию — оффер за 3 месяца. Эфиры по резюме под
                                    международный рынок реально изменили отклики.»</p>
                            </div>
                            <div class="reviews0726-reviews-item-date careerum-flex-fsfs">
                                <a href="#" target="_blank">Все отзывы о Карьерном Клубе [128]</a>
                            </div>
                        </div>
                        <div class="reviews0726-reviews-item careerum-flex-fsfs">
                            <div class="reviews0726-reviews-item-top careerum-flex-fsc">
                                <img src="https://cdn.careerum.com/1784732492221-JZDwH-Fram.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1784748501274-GSZ9p-Fram.svg" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1784750411369-V1poY-Fram.svg" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                                <div>
                                    <p class="reviews0726-reviews-item-name">Дмитрий Р.</p>
                                    <div class="reviews0726-reviews-item-description careerum-flex-fsfs">
                                        <p>Senior-аналитик</p>
                                        <p>Нидерланды</p>
                                    </div>
                                    <div class="reviews0726-reviews-item-rating careerum-flex-fsc">
                                        <p>4.2</p>
                                        <img src="https://cdn.careerum.com/1784732492322-lfE3c-Fram.svg" class="hidden-mobile"
                                            alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1784732550291-tUBbQ-Fram.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                    </div>
                                </div>
                            </div>
                            <div class="reviews0726-reviews-item-bottom">
                                <p class="reviews0726-reviews-item-text">«Клуб полезный, но это не сервис «сделают за вас». Цену
                                    чувствуешь, и пользу надо забирать: ходить на эфиры, писать в чаты. Кто активен — окупает».
                                </p>
                            </div>
                            <div class="reviews0726-reviews-item-date careerum-flex-fsfs">
                                <p>Февраль 2026</p>
                                <p>В клубе 5 месяцев</p>
                            </div>
                        </div>
                        <div class="reviews0726-reviews-item careerum-flex-fsfs">
                            <div class="reviews0726-reviews-item-top careerum-flex-fsc">
                                <img src="https://cdn.careerum.com/1784732492256-EaJSn-Fram.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1784748501303-DbdtT-Fram.svg" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1784750411443-qo8CW-Fram.svg" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                                <div>
                                    <p class="reviews0726-reviews-item-name">Ольга В.</p>
                                    <div class="reviews0726-reviews-item-description careerum-flex-fsfs">
                                        <p>HR-директор</p>
                                        <p>ОАЭ</p>
                                        <p>Релокация</p>
                                    </div>
                                    <div class="reviews0726-reviews-item-rating careerum-flex-fsc">
                                        <p>4.8</p>
                                        <img src="https://cdn.careerum.com/1784732492322-lfE3c-Fram.svg" class="hidden-mobile"
                                            alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1784732550291-tUBbQ-Fram.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                    </div>
                                </div>
                            </div>
                            <div class="reviews0726-reviews-item-bottom">
                                <p class="reviews0726-reviews-item-text">«Переехала в Дубай по офферу, который нашла через
                                    нетворкинг клуба. Отдельно ценно — тренировочные собеседования с обратной связью перед
                                    реальными интервью.»</p>
                            </div>
                            <div class="reviews0726-reviews-item-date careerum-flex-fsfs">
                                <p>Январь 2026</p>
                                <p>В клубе 11 месяцев</p>
                            </div>
                        </div>
                        <div class="reviews0726-reviews-item careerum-flex-fsfs">
                            <div class="reviews0726-reviews-item-top careerum-flex-fsc">
                                <img src="https://cdn.careerum.com/1784732492291-Y1Wql-Fram.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1784748501332-X3TG4-Fram.svg" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1784750411481-xkKMv-Fram.svg" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                                <div>
                                    <p class="reviews0726-reviews-item-name">Анна С.</p>
                                    <div class="reviews0726-reviews-item-description careerum-flex-fsfs">
                                        <p>Маркетолог</p>
                                        <p>Кипр</p>
                                    </div>
                                    <div class="reviews0726-reviews-item-rating careerum-flex-fsc">
                                        <p>4.5</p>
                                        <img src="https://cdn.careerum.com/1784732492322-lfE3c-Fram.svg" class="hidden-mobile"
                                            alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1784732550291-tUBbQ-Fram.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                    </div>
                                </div>
                            </div>
                            <div class="reviews0726-reviews-item-bottom">
                                <p class="reviews0726-reviews-item-text">«Не заметила автопродление — списалась подписка на
                                    новый период. Написала в саппорт, разобрались и вернули. Осадок был, но по контенту клуб
                                    норм.»</p>
                            </div>
                            <div class="reviews0726-reviews-item-date careerum-flex-fsfs">
                                <p>Январь 2026</p>
                                <p>В клубе 11 месяцев</p>
                            </div>
                        </div>
                        <div class="reviews0726-reviews-item careerum-flex-fsfs">
                            <div class="reviews0726-reviews-item-top careerum-flex-fsc">
                                <img src="https://cdn.careerum.com/1784732492291-Y1Wql-Fram.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1784748501332-X3TG4-Fram.svg" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/" class="hidden-desc-tablet" alt="img" loading="lazy">
                                <div>
                                    <p class="reviews0726-reviews-item-name">Анна С.</p>
                                    <div class="reviews0726-reviews-item-description careerum-flex-fsfs">
                                        <p>Маркетолог</p>
                                        <p>Кипр</p>
                                    </div>
                                    <div class="reviews0726-reviews-item-rating careerum-flex-fsc">
                                        <p>4.5</p>
                                        <img src="https://cdn.careerum.com/1784732492322-lfE3c-Fram.svg" class="hidden-mobile"
                                            alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1784732550291-tUBbQ-Fram.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                    </div>
                                </div>
                            </div>
                            <div class="reviews0726-reviews-item-bottom">
                                <p class="reviews0726-reviews-item-text">«Не заметила автопродление — списалась подписка на
                                    новый период. Написала в саппорт, разобрались и вернули. Осадок был, но по контенту клуб
                                    норм.»</p>
                            </div>
                            <div class="reviews0726-reviews-item-date careerum-flex-fsfs">
                                <p>Январь 2026</p>
                                <p>В клубе 11 месяцев</p>
                            </div>
                        </div>
                        <div class="reviews0726-reviews-item careerum-flex-fsfs">
                            <div class="reviews0726-reviews-item-top careerum-flex-fsc">
                                <img src="https://cdn.careerum.com/1784732492291-Y1Wql-Fram.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1784748501332-X3TG4-Fram.svg" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/" class="hidden-desc-tablet" alt="img" loading="lazy">
                                <div>
                                    <p class="reviews0726-reviews-item-name">Анна С.</p>
                                    <div class="reviews0726-reviews-item-description careerum-flex-fsfs">
                                        <p>Маркетолог</p>
                                        <p>Кипр</p>
                                    </div>
                                    <div class="reviews0726-reviews-item-rating careerum-flex-fsc">
                                        <p>4.5</p>
                                        <img src="https://cdn.careerum.com/1784732492322-lfE3c-Fram.svg" class="hidden-mobile"
                                            alt="img" loading="lazy">
                                        <img src="https://cdn.careerum.com/1784732550291-tUBbQ-Fram.svg"
                                            class="hidden-desc-tablet" alt="img" loading="lazy">
                                    </div>
                                </div>
                            </div>
                            <div class="reviews0726-reviews-item-bottom">
                                <p class="reviews0726-reviews-item-text">«Не заметила автопродление — списалась подписка на
                                    новый период. Написала в саппорт, разобрались и вернули. Осадок был, но по контенту клуб
                                    норм.»</p>
                            </div>
                            <div class="reviews0726-reviews-item-date careerum-flex-fsfs">
                                <p>Январь 2026</p>
                                <p>В клубе 11 месяцев</p>
                            </div>
                        </div>
                    </div>
                    <div class="reviews0726-reviews-button-wrapper">
                        <div class="reviews0726-reviews-button">
                            <p>Показать все 128 отзывов</p>
                            <p>Скрыть</p>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-reviews0726-subscription', {
        label: 'Careerum reviews0726 subscription',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-reviews0726-subscription main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Что входит в подписку</h2>
                    <div class="reviews0726-subscription-content careerum-flex-sbst">
                        <ul>
                            <li>Закрытые чаты по профессиям / странам / целям</li>
                            <li>Эфиры экспертов (ICF)</li>
                            <li>Карьерные треки </li>
                        </ul>
                        <ul>
                            <li>Тренировочные собеседования</li>
                            <li>Вакансии от участников</li>
                        </ul>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-reviews0726-faq', {
        label: 'Careerum reviews0726 faq',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-reviews0726-faq main-wrapper">
                <div class="careerum-container-responsive careerum-flex-sbfs">
                    <div class="reviews0726-faq-header">
                        <h2>Частые вопросы</h2>
                    </div>
                    <div class="reviews0726-faq-content noselect">
                        <div class="reviews0726-faq-item">
                            <div class="reviews0726-faq-item-header careerum-flex-sbfs">
                                <p>Стоит ли покупать подписку на клуб Careerum?</p>
                                <img src="https://cdn.careerum.com/1784736325088-W9P60-Fram.svg" alt="img" loading="lazy">
                            </div>
                            <div class="reviews0726-faq-item-text">
                                <p>Подходит, если нужна регулярная среда, нетворкинг и доступ к экспертам, и вы готовы
                                    участвовать. Менее полезен, если ждёте, что работу найдут за вас. Многие окупают подписку
                                    одним оффером или ростом ЗП.</p>
                            </div>
                        </div>
                        <div class="reviews0726-faq-item">
                            <div class="reviews0726-faq-item-header careerum-flex-sbfs">
                                <p>Чем клуб отличается от индивидуального сопровождения?</p>
                                <img src="https://cdn.careerum.com/1784736325088-W9P60-Fram.svg" alt="img" loading="lazy">
                            </div>
                            <div class="reviews0726-faq-item-text">
                                <p>Клуб — среда и регулярность по подписке (комьюнити, эфиры, треки). Сопровождение —
                                    персональный эксперт и план под вашу ситуацию. Для сложных переходов чаще берут
                                    сопровождение, для системного развития — клуб; можно совмещать.</p>
                            </div>
                        </div>
                        <div class="reviews0726-faq-item">
                            <div class="reviews0726-faq-item-header careerum-flex-sbfs">
                                <p>Правда ли, что деньги списываются автоматически?</p>
                                <img src="https://cdn.careerum.com/1784736325088-W9P60-Fram.svg" alt="img" loading="lazy">
                            </div>
                            <div class="reviews0726-faq-item-text">
                                <p>Подписка продлевается автоматически; отключить автопродление и отменить можно в личном
                                    кабинете. Если списание прошло по ошибке — саппорт разбирает и возвращает</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-reviews0726-join', {
        label: 'Careerum reviews0726 join',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-reviews0726-join main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="reviews0726-join-top">
                        <h2>Узнать про клуб и заполнить анкету</h2>
                        <div class="reviews0726-join-top-content careerum-flex-cc">
                            <p>Отбор по анкете</p>
                            <p>Подберём формат под вашу цель</p>
                        </div>
                        <a href="#" class="btn-color-main-red2">Заполнить анкету</a>
                    </div>
                    <div class="reviews0726-join-bottom">
                        <p>Внешние профили:</p>
                        <div class="reviews0726-join-bottom-links careerum-flex-cc">
                            <a href="#">Otzovik</a>
                            <div class="reviews0726-join-bottom-links-divider"></div>
                            <a href="#">T-Bank</a>
                            <div class="reviews0726-join-bottom-links-divider"></div>
                            <a href="#">DreamJob</a>
                            <div class="reviews0726-join-bottom-links-divider hidden-mobile"></div>
                            <a href="#">App Store</a>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-reviews0726-results', {
        label: 'Careerum reviews0726 results',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-reviews0726-results main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Результаты в цифрах</h2>
                    <div class="reviews0726-results-content careerum-flex-sbst">
                        <div class="reviews0726-results-item">
                            <p class="reviews0726-results-number">6000+</p>
                            <p class="reviews0726-results-text">Офферов</p>
                        </div>
                        <div class="reviews0726-results-item">
                            <p class="reviews0726-results-number">230+</p>
                            <p class="reviews0726-results-text">Релокаций</p>
                        </div>
                        <div class="reviews0726-results-item">
                            <p class="reviews0726-results-number">1.5×</p>
                            <p class="reviews0726-results-text">Рост зарплаты</p>
                        </div>
                        <div class="reviews0726-results-item">
                            <p class="reviews0726-results-number">90+</p>
                            <p class="reviews0726-results-text">Реальных кейсов с именами</p>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-global-main', {
        label: 'Careerum goglobal main',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-global-main main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="global-main-content careerum-flex-sbst">
                        <div class="global-main-left position-relative z-10">
                            <div class="global-main-labels careerum-flex-fsfs">
                                <div class="global-main-label red">
                                    <p>Старт 29 сентября</p>
                                </div>
                                <div class="global-main-label">
                                    <p>3 месяца</p>
                                </div>
                            </div>
                            <h1>Go Global</h1>
                            <p class="global-main-text">Постройте международную карьеру без обнуления своего опыта</p>
                        </div>
                        <div class="global-main-right position-relative z-1">
                            <img src="https://cdn.careerum.com/1786018769562-SRGy5-Fram.png"
                                class="hidden-tablet-mobile position-absolute" alt="img" loading="eager">
                            <img src="https://cdn.careerum.com/1786018767319-zGd4M-Fram.png"
                                class="hidden-desc-mobile position-absolute" alt="img" loading="eager">
                            <img src="https://cdn.careerum.com/1786018765252-JzDmx-Chat.png"
                                class="hidden-desc-tablet position-absolute" alt="img" loading="eager">
                        </div>
                    </div>
                    <a href="#" class="btn-color-main-red3 position-relative z-10">Посмотреть программу</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-global-who', {
        label: 'Careerum goglobal who',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-global-who main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Для кого эта программа:</h2>
                    <div class="global-who-content careerum-flex-sbst">
                        <div class="global-who-item">
                            <p class="global-who-item-number">01</p>
                            <p class="global-who-item-title"><span>Хотите выйти</span> на международный рынок</p>
                            <p class="global-who-item-text">Из локальной компании в международную. Через релокацию, удалёнку
                                или переход, но не понимаете, с чего начать.</p>
                        </div>
                        <div class="global-who-item">
                            <p class="global-who-item-number">02</p>
                            <p class="global-who-item-title"><span>Переехали,</span> но пока не на целевой рынок</p>
                            <p class="global-who-item-text">Вы в условной Грузии, Сербии, Турции или ОАЭ. Работаете
                                на российских клиентов. Уехали, чтобы двигаться дальше, но карьера стоит на мест</p>
                        </div>
                        <div class="global-who-item">
                            <p class="global-who-item-number">03</p>
                            <p class="global-who-item-title hidden-tablet">Уже на международном рынке, но <span>упёрлись в потолок</span></p>
                            <p class="global-who-item-title hidden-desc-mobile">Уже на междуна-родном рынке, но <span>упёрлись в потолок</span></p>
                            <p class="global-who-item-text">Работаете в международной компании не первый год. Делаете отличную
                                работу, но не растёте, и не понимаете, почему</p>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-global-why', {
        label: 'Careerum goglobal why',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-global-why main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Какие задачи вы сможете решить на программе:</h2>
                    <div class="global-why-top">
                        <div class="global-why-top-row careerum-flex-cc">
                            <div class="global-why-top-item blue img">
                                <img src="https://cdn.careerum.com/1786018894382-zxnue-Glob.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1786018939211-amagV-Glob.svg" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1786018977630-7Y2jF-Glob.svg" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                            </div>
                            <div class="global-why-top-item light">
                                <p>Релокация</p>
                            </div>
                            <div class="global-why-top-item italic">
                                <p>Старт</p>
                            </div>
                        </div>
                        <div class="global-why-top-row careerum-flex-cc">
                            <div class="global-why-top-item white italic">
                                <p>Рост</p>
                            </div>
                            <div class="global-why-top-item blue">
                                <p>Позиционирование</p>
                            </div>
                            <div class="global-why-top-item light img">
                                <img src="https://cdn.careerum.com/1786018894321-qYNvV-Suit.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1786018937542-7NZvv-Suit.svg" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1786018977597-ZAei9-Suit.svg" class="hidden-desc-tablet"
                                    alt="img" loading="lazy">
                            </div>
                        </div>
                    </div>
                    <div class="global-why-tales careerum-flex-sbst">
                        <div class="global-why-tale position-relative">
                            <img src="https://cdn.careerum.com/1786019020669-roRxs-Glob.svg" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1786019075566-pFoA0-Glob.svg" class="hidden-desc" alt="img"
                                loading="lazy">
                            <p class="global-why-tale-title">Выйти на международный рынок:</p>
                            <ul>
                                <li>
                                    <p>Понять, какие роли на международном рынке соответствуют вашему опыту</p>
                                </li>
                                <li>
                                    <p>Упаковать карьерный капитал так, чтобы его приняли западные работодатели</p>
                                </li>
                            </ul>
                        </div>
                        <div class="global-why-tale position-relative">
                            <img src="https://cdn.careerum.com/1786019020699-LzRpC-MapP.svg" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1786019075596-tPxEA-MapP.svg" class="hidden-desc" alt="img"
                                loading="lazy">
                            <p class="global-why-tale-title">Переехать из «временной страны» на целевой рынок:</p>
                            <ul>
                                <li>
                                    <p>Перестать застревать в русскоязычных проектах</p>
                                </li>
                                <li>
                                    <p>Начать строить карьеру на рынке, на котором вы на самом деле хотите развиваться</p>
                                </li>
                                <li>
                                    <p>Собрать стратегию перехода в международную компанию из любой точки мира</p>
                                </li>
                            </ul>
                        </div>
                        <div class="global-why-tale position-relative">
                            <img src="https://cdn.careerum.com/1786019020725-Z8pKB-Tren.svg" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1786019075878-yv9gQ-Tren.svg" class="hidden-desc" alt="img"
                                loading="lazy">
                            <p class="global-why-tale-title">Рост внутри международной компании:</p>
                            <ul>
                                <li>
                                    <p>Разобраться, как устроены повышения и карьерные решения в вашей компании и географии —
                                        и начать в них участвовать</p>
                                </li>
                                <li>
                                    <p>Перестать быть «невидимым профессионалом» и научиться показывать свою ценность так,
                                        как это делают те, кто растёт</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-global-author', {
        label: 'Careerum goglobal author',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-global-author main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>AВТОР ПРОГРАММЫ</h2>
                    <div class="global-author-content careerum-flex-sbst">
                        <div class="global-author-left">
                            <img src="https://cdn.careerum.com/1786020572273-4Smdb-Fram.png" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1786020572230-kslIV-Fram.png" class="hidden-desc-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1786020572121-CITVy-Fram.png" class="hidden-desc-tablet"
                                alt="img" loading="lazy">
                        </div>
                        <div class="global-author-right">
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1786020651915-wSqQw-Soft.svg"
                                        class="hidden-tablet-mobile" alt="img" loading="eager">
                                    <img src="https://cdn.careerum.com/1786020654054-q0TId-Soft.svg" class="hidden-desc-mobile"
                                        alt="img" loading="eager">
                                    <img src="https://cdn.careerum.com/1786020655611-o1d9H-Soft.svg" class="hidden-desc-tablet"
                                        alt="img" loading="eager">
                                    <div>
                                        <p class="global-author-item-title">Основательница Careerum — платформы, где клиенты
                                            строят международные карьеры уже 8 лет</p>
                                        <p class="global-author-item-text">14 000+ профессионалов из 60+ стран вышли на
                                            международный рынок и получили офферы в топовых компаниях</p>
                                    </div>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1786020651915-wSqQw-Soft.svg"
                                        class="hidden-tablet-mobile" alt="img" loading="eager">
                                    <img src="https://cdn.careerum.com/1786020654054-q0TId-Soft.svg" class="hidden-desc-mobile"
                                        alt="img" loading="eager">
                                    <img src="https://cdn.careerum.com/1786020655611-o1d9H-Soft.svg" class="hidden-desc-tablet"
                                        alt="img" loading="eager">
                                    <div>
                                        <p class="global-author-item-title">15+ лет собственной международной карьеры: от стартовых позиций до руководящих</p>
                                        <p class="global-author-item-text">Google, Microsoft, Adobe, Intel. 25 рынков. Европа,
                                            Ближний Восток, Африка, карьера на двух языках — английский и итальянский</p>
                                    </div>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1786020651915-wSqQw-Soft.svg"
                                        class="hidden-tablet-mobile" alt="img" loading="eager">
                                    <img src="https://cdn.careerum.com/1786020654054-q0TId-Soft.svg" class="hidden-desc-mobile"
                                        alt="img" loading="eager">
                                    <img src="https://cdn.careerum.com/1786020655611-o1d9H-Soft.svg" class="hidden-desc-tablet"
                                        alt="img" loading="eager">
                                    <div>
                                        <p class="global-author-item-title">Строила карьеру в странах, где её никто не знал и не
                                            ждал</p>
                                        <p class="global-author-item-text">Заходила на новые рынки с нуля, адаптировалась к
                                            чужим корпоративным культурам, росла без «своих» связей — и выстроила из этого
                                            систему, которая сейчас работает для других в Careerum</p>
                                    </div>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1786020651915-wSqQw-Soft.svg"
                                        class="hidden-tablet-mobile" alt="img" loading="eager">
                                    <img src="https://cdn.careerum.com/1786020654054-q0TId-Soft.svg" class="hidden-desc-mobile"
                                        alt="img" loading="eager">
                                    <img src="https://cdn.careerum.com/1786020655611-o1d9H-Soft.svg" class="hidden-desc-tablet"
                                        alt="img" loading="eager">
                                    <div>
                                        <p class="global-author-item-title">Эксперт в том, о чём остальные молчат: что
                                            происходит после оффера</p>
                                        <p class="global-author-item-text">Как пройти адаптацию, как стать cultural fit в чужой ментальности, как расти в среде, где совсем другие правила игры</p>
                                    </div>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1786020651915-wSqQw-Soft.svg"
                                        class="hidden-tablet-mobile" alt="img" loading="eager">
                                    <img src="https://cdn.careerum.com/1786020654054-q0TId-Soft.svg" class="hidden-desc-mobile"
                                        alt="img" loading="eager">
                                    <img src="https://cdn.careerum.com/1786020655611-o1d9H-Soft.svg" class="hidden-desc-tablet"
                                        alt="img" loading="eager">
                                    <div>
                                        <p class="global-author-item-title">Harvard Extension School</p>
                                        <p class="global-author-item-text">Магистратура по психологии (ALM) — исследует, как
                                            люди принимают карьерные решения в условиях неопределённости</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-global-how', {
        label: 'Careerum goglobal how',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-global-how main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Как устроена программа:</h2>
                    <div class="global-how-content">
                        <div class="global-how-item careerum-flex-cst left">
                            <div class="global-how-item-content">
                                <p class="global-how-item-number">01</p>
                                <p class="global-how-item-title">Разбираемся в правилах международного рынка</p>
                                <p class="global-how-item-text">Почему здесь работают совсем другие принципы</p>
                            </div>
                            <div></div>
                        </div>
                        <div class="global-how-item careerum-flex-cst right">
                            <div></div>
                            <div class="global-how-item-content">
                                <p class="global-how-item-number">02</p>
                                <p class="global-how-item-title">Оцифровываем карьерный капитал</p>
                                <p class="global-how-item-text">Учимся видеть и упаковывать свои реальные достижения</p>
                            </div>
                        </div>
                        <div class="global-how-item careerum-flex-cst left">
                            <div class="global-how-item-content">
                                <p class="global-how-item-number">03</p>
                                <p class="global-how-item-title">Формируем новую профессиональную идентичность</p>
                                <p class="global-how-item-text">Определяем роли, в которых ваш опыт будет максимально ценен</p>
                            </div>
                            <div></div>
                        </div>
                        <div class="global-how-item careerum-flex-cst right">
                            <div></div>
                            <div class="global-how-item-content">
                                <p class="global-how-item-number">04</p>
                                <p class="global-how-item-title">Выбираем рынок</p>
                                <p class="global-how-item-text">Не «Европа вообще», а конкретные страны и компании</p>
                            </div>
                        </div>
                        <div class="global-how-item careerum-flex-cst left">
                            <div class="global-how-item-content">
                                <p class="global-how-item-number">05</p>
                                <p class="global-how-item-title">Строим международное позиционирование</p>
                                <p class="global-how-item-text">Резюме, LinkedIn, Elevator Pitch, Карьерный нарратив</p>
                            </div>
                            <div></div>
                        </div>
                        <div class="global-how-item careerum-flex-cst right">
                            <div></div>
                            <div class="global-how-item-content">
                                <p class="global-how-item-number">06</p>
                                <p class="global-how-item-title">Запускаем системный поиск</p>
                                <p class="global-how-item-text">Без хаотичных откликов и с понятной стратегией</p>
                            </div>
                        </div>
                        <div class="global-how-item careerum-flex-cst left">
                            <div class="global-how-item-content">
                                <p class="global-how-item-number">07</p>
                                <p class="global-how-item-title">Учимся строить международный нетворкинг</p>
                                <p class="global-how-item-text">Чтобы вакансии находили вас тоже</p>
                            </div>
                            <div></div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-global-structure', {
        label: 'Careerum goglobal structure',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-global-structure main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>программа:</h2>
                    <div class="global-structure-content">
                        <div class="global-structure-block">
                            <p class="global-structure-block-number">БЛОК 1.</p>
                            <p class="global-structure-block-header">АУДИТ АКТИВОВ И САМООЦЕНКА</p>
                        </div>
                        <div class="global-structure-item">
                            <div class="global-structure-item-top careerum-flex-sbfs">
                                <div class="global-structure-item-header">
                                    <div class="global-structure-item-label">
                                        <p>Неделя 1–4</p>
                                    </div>
                                    <p class="global-structure-item-title">Синдром самозванца и преодоление «русской ментальности»</p>
                                </div>
                                <div class="global-structure-item-switcher">
                                    <img src="https://cdn.careerum.com/1786020810081-dKdym-Icon.svg"
                                        class="hidden-tablet-mobile" alt="img" loading="eager">
                                    <img src="https://cdn.careerum.com/1786020817663-aFYUK-Icon.svg" class="hidden-desc-mobile"
                                        alt="img" loading="eager">
                                    <img src="https://cdn.careerum.com/1786020826087-thgSQ-Icon.svg" class="hidden-desc-tablet"
                                        alt="img" loading="eager">
                                </div>
                            </div>
                            <div class="global-structure-item-bottom">
                                <p class="global-structure-item-text">Уроки:</p>
                                <ul>
                                    <li>Главные карьерные ошибки специалистов из СНГ на Западе</li>
                                    <li>Внутренний Профессионал vs Критик-самозванец за рубежом</li>
                                    <li>Смыслы и профессиональная устойчивость</li>
                                </ul>
                            </div>
                        </div>
                        <div class="global-structure-item">
                            <div class="global-structure-item-top careerum-flex-sbfs">
                                <div class="global-structure-item-header">
                                    <div class="global-structure-item-label">
                                        <p>Неделя 2</p>
                                    </div>
                                    <p class="global-structure-item-title">Инвентаризация капитала по методу STAR и упаковка масштаба</p>
                                </div>
                                <div class="global-structure-item-switcher">
                                    <img src="https://cdn.careerum.com/1786020810081-dKdym-Icon.svg"
                                        class="hidden-tablet-mobile" alt="img" loading="eager">
                                    <img src="https://cdn.careerum.com/1786020817663-aFYUK-Icon.svg" class="hidden-desc-mobile"
                                        alt="img" loading="eager">
                                    <img src="https://cdn.careerum.com/1786020826087-thgSQ-Icon.svg" class="hidden-desc-tablet"
                                        alt="img" loading="eager">
                                </div>
                            </div>
                            <div class="global-structure-item-bottom">
                                <p class="global-structure-item-text">Уроки:</p>
                                <ul>
                                    <li>Метод STAR для глобального рынка</li>
                                    <li>Психология присвоения ресурсов</li>
                                    <li>ИИ-диагностика карьерного капитала</li>
                                </ul>
                            </div>
                        </div>
                        <div class="global-structure-item">
                            <div class="global-structure-item-top careerum-flex-sbfs">
                                <div class="global-structure-item-header">
                                    <div class="global-structure-item-label">
                                        <p>Неделя 3</p>
                                    </div>
                                    <p class="global-structure-item-title">Ваш код уникальности, западный левелинг (Leveling) и культурный код</p>
                                </div>
                                <div class="global-structure-item-switcher">
                                    <img src="https://cdn.careerum.com/1786020810081-dKdym-Icon.svg"
                                        class="hidden-tablet-mobile" alt="img" loading="eager">
                                    <img src="https://cdn.careerum.com/1786020817663-aFYUK-Icon.svg" class="hidden-desc-mobile"
                                        alt="img" loading="eager">
                                    <img src="https://cdn.careerum.com/1786020826087-thgSQ-Icon.svg" class="hidden-desc-tablet"
                                        alt="img" loading="eager">
                                </div>
                            </div>
                            <div class="global-structure-item-bottom">
                                <p class="global-structure-item-text">Уроки:</p>
                                <ul>
                                    <li>Перфекционизм и синдром отличника за рубежом</li>
                                    <li>Таланты и суперсилы (ваш код уникальности)</li>
                                    <li>Специфика зрелых рынков и левелинг</li>
                                    <li>8 шкал культурных различий по Эрин Майер</li>
                                </ul>
                            </div>
                        </div>
                        <div class="global-structure-item">
                            <div class="global-structure-item-top careerum-flex-sbfs">
                                <div class="global-structure-item-header">
                                    <div class="global-structure-item-label">
                                        <p>Неделя 4</p>
                                    </div>
                                    <p class="global-structure-item-title">Формула «Сколько я стою за рубежом?»</p>
                                </div>
                                <div class="global-structure-item-switcher">
                                    <img src="https://cdn.careerum.com/1786020810081-dKdym-Icon.svg"
                                        class="hidden-tablet-mobile" alt="img" loading="eager">
                                    <img src="https://cdn.careerum.com/1786020817663-aFYUK-Icon.svg" class="hidden-desc-mobile"
                                        alt="img" loading="eager">
                                    <img src="https://cdn.careerum.com/1786020826087-thgSQ-Icon.svg" class="hidden-desc-tablet"
                                        alt="img" loading="eager">
                                </div>
                            </div>
                            <div class="global-structure-item-bottom">
                                <p class="global-structure-item-text">Урок:</p>
                                <ul>
                                    <li>Карьерные ценности</li>
                                </ul>
                            </div>
                        </div>
                        <div class="global-structure-block">
                            <p class="global-structure-block-number">БЛОК 2.</p>
                            <p class="global-structure-block-header">КАРЬЕРНАЯ СТРАТЕГИЯ, ХАБЫ И ВНУТРЕННИЙ НЕТВОРКИНГ</p>
                        </div>
                        <div class="global-structure-item">
                            <div class="global-structure-item-top careerum-flex-sbfs">
                                <div class="global-structure-item-header">
                                    <div class="global-structure-item-label">
                                        <p>Неделя 5</p>
                                    </div>
                                    <p class="global-structure-item-title">География возможностей и аудит текущей локации</p>
                                </div>
                                <div class="global-structure-item-switcher">
                                    <img src="https://cdn.careerum.com/1786020810081-dKdym-Icon.svg"
                                        class="hidden-tablet-mobile" alt="img" loading="eager">
                                    <img src="https://cdn.careerum.com/1786020817663-aFYUK-Icon.svg" class="hidden-desc-mobile"
                                        alt="img" loading="eager">
                                    <img src="https://cdn.careerum.com/1786020826087-thgSQ-Icon.svg" class="hidden-desc-tablet"
                                        alt="img" loading="eager">
                                </div>
                            </div>
                            <div class="global-structure-item-bottom">
                                <p class="global-structure-item-text">Уроки:</p>
                                <ul>
                                    <li>Карта возможностей и профессиональные хабы</li>
                                    <li>Архитектура глобальных корпораций</li>
                                    <li>Аудит текущей страны и офиса</li>
                                </ul>
                            </div>
                        </div>
                        <div class="global-structure-item">
                            <div class="global-structure-item-top careerum-flex-sbfs">
                                <div class="global-structure-item-header">
                                    <div class="global-structure-item-label">
                                        <p>Неделя 6–7</p>
                                    </div>
                                    <p class="global-structure-item-title">Проектирование карьерных гипотез</p>
                                </div>
                                <div class="global-structure-item-switcher">
                                    <img src="https://cdn.careerum.com/1786020810081-dKdym-Icon.svg"
                                        class="hidden-tablet-mobile" alt="img" loading="eager">
                                    <img src="https://cdn.careerum.com/1786020817663-aFYUK-Icon.svg" class="hidden-desc-mobile"
                                        alt="img" loading="eager">
                                    <img src="https://cdn.careerum.com/1786020826087-thgSQ-Icon.svg" class="hidden-desc-tablet"
                                        alt="img" loading="eager">
                                </div>
                            </div>
                            <div class="global-structure-item-bottom">
                                <p class="global-structure-item-text">Уроки и практикум:</p>
                                <ul>
                                    <li>Международный вектор и Helicopter View</li>
                                    <li>Построение карьерных гипотез</li>
                                    <li>Декомпозиция целей и управление рисками</li>
                                    <li><span>Практикум недели:</span> Большая практическая работа по заполнению «Карты гипотез» в рабочей тетради с ИИ-валидацией пробелов в навыках</li>
                                </ul>
                            </div>
                        </div>
                        <div class="global-structure-item">
                            <div class="global-structure-item-top careerum-flex-sbfs">
                                <div class="global-structure-item-header">
                                    <div class="global-structure-item-label">
                                        <p>Неделя 8</p>
                                    </div>
                                    <p class="global-structure-item-title">Культура Self-Advocacy и международный нетворкинг</p>
                                </div>
                                <div class="global-structure-item-switcher">
                                    <img src="https://cdn.careerum.com/1786020810081-dKdym-Icon.svg"
                                        class="hidden-tablet-mobile" alt="img" loading="eager">
                                    <img src="https://cdn.careerum.com/1786020817663-aFYUK-Icon.svg" class="hidden-desc-mobile"
                                        alt="img" loading="eager">
                                    <img src="https://cdn.careerum.com/1786020826087-thgSQ-Icon.svg" class="hidden-desc-tablet"
                                        alt="img" loading="eager">
                                </div>
                            </div>
                            <div class="global-structure-item-bottom">
                                <p class="global-structure-item-text">Уроки:</p>
                                <ul>
                                    <li>Анатомия международного нетворкинга на равных</li>
                                    <li>Шпаргалка нетворкера: Скрипты первого контакта и сценарии созвонов</li>
                                    <li>Культура Self-Advocacy как обязанность, а не хвастовство</li>
                                    <li>Конструктор видимости: Шаблоны отчётов и Brag Folder</li>
                                </ul>
                            </div>
                        </div>
                        <div class="global-structure-block">
                            <p class="global-structure-block-number">БЛОК 3.</p>
                            <p class="global-structure-block-header">УПАКОВКА</p>
                        </div>
                        <div class="global-structure-item">
                            <div class="global-structure-item-top careerum-flex-sbfs">
                                <div class="global-structure-item-header">
                                    <div class="global-structure-item-label">
                                        <p>Неделя 9–11</p>
                                    </div>
                                    <p class="global-structure-item-title">Упаковка резюме и LinkedIn</p>
                                </div>
                                <div class="global-structure-item-switcher">
                                    <img src="https://cdn.careerum.com/1786020810081-dKdym-Icon.svg"
                                        class="hidden-tablet-mobile" alt="img" loading="eager">
                                    <img src="https://cdn.careerum.com/1786020817663-aFYUK-Icon.svg" class="hidden-desc-mobile"
                                        alt="img" loading="eager">
                                    <img src="https://cdn.careerum.com/1786020826087-thgSQ-Icon.svg" class="hidden-desc-tablet"
                                        alt="img" loading="eager">
                                </div>
                            </div>
                            <div class="global-structure-item-bottom">
                                <p class="global-structure-item-text">Живые эфиры:</p>
                                <ul>
                                    <li>Эфир по поиску работы на международном рынке</li>
                                    <li>Прожарка резюме, LinkedIn</li>
                                </ul>
                            </div>
                        </div>
                        <div class="global-structure-item">
                            <div class="global-structure-item-top careerum-flex-sbfs">
                                <div class="global-structure-item-header">
                                    <div class="global-structure-item-label">
                                        <p>Неделя 12</p>
                                    </div>
                                    <p class="global-structure-item-title">Карьерная карта на 90 дней</p>
                                </div>
                                <div class="global-structure-item-switcher">
                                    <img src="https://cdn.careerum.com/1786020810081-dKdym-Icon.svg"
                                        class="hidden-tablet-mobile" alt="img" loading="eager">
                                    <img src="https://cdn.careerum.com/1786020817663-aFYUK-Icon.svg" class="hidden-desc-mobile"
                                        alt="img" loading="eager">
                                    <img src="https://cdn.careerum.com/1786020826087-thgSQ-Icon.svg" class="hidden-desc-tablet"
                                        alt="img" loading="eager">
                                </div>
                            </div>
                            <div class="global-structure-item-bottom">
                                <p class="global-structure-item-text">Практическое задание:</p>
                                <ul>
                                    <li>Сборка всех наработок (цели, гипотезы, промо-нарратив, brag folder, план нетворкинга) в единый Международный карьерный план действий на следующие 90 дней</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-global-tariffs', {
        label: 'Careerum goglobal tariffs',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div custom-link-anchor="buy" 
                class="careerum-awake-tariffs careerum-club50-tariffs main-wrapper careerum-global-tariffs">
                <div class="careerum-container-responsive">
                    <div class="awake-tariffs-top">
                        <h2 class="inline-block">Тарифы</h2>
                    </div>
                    <div class="global-tariffs-top">
                        <p class="global-tariffs-top__title">Early birds</p>
                        <p class="global-tariffs-top__text">Успейте забронировать место по лучшей цене:</p>
                        <div class="global-tariffs-top__items careerum-flex-fsfs">
                            <div class="global-tariffs-top__item">
                                <p>С 10 по 20 августа: <span>49 900 ₽ / 490 €</span></p>
                            </div>
                            <div class="global-tariffs-top__item">
                                <p>С 21 по 31 августа: <span>59 900 ₽ / 590 €</span></p>
                            </div>
                            <div class="global-tariffs-top__item">
                                <p>С 1 сентября: <span>69 900 ₽ / 690 €</span></p>
                            </div>
                        </div>
                    </div>
                    <div class="global-tariffs-top v2">
                        <p class="global-tariffs-top__title">Early birds</p>
                        <p class="global-tariffs-top__text">Успейте забронировать место на тариф <span>«Global Level Up + подписка в клуб»</span><br> по лучшей цене:</p>
                        <div class="global-tariffs-top__items careerum-flex-fsfs">
                            <div class="global-tariffs-top__item hidden">
                                <p class="global-tariffs-top-label">С 1 сентября:</p>
                                <p>Групповой: <span>42 000 ₽ / 540 €</span></p>
                                <p>Индивидульаный: <span>99 000 ₽ / 990 €</span></p>
                            </div>
                            <div class="global-tariffs-top__item">
                                <p class="global-tariffs-top-label">С 1 сентября:</p>
                                <p>Групповой: <span>42 000 ₽ / 540 €</span></p>
                                <p>Индивидульаный: <span>99 000 ₽ / 990 €</span></p>
                            </div>
                            <div class="global-tariffs-top__item">
                                <p class="global-tariffs-top-label">С 23 сентября:</p>
                                <p>Групповой: <span>44 700 ₽ / 597 €</span></p>
                                <p>Индивидульаный: <span>101 700 ₽ / 1080 €</span></p>
                            </div>
                        </div>
                    </div>
                    <div class="awake-tariffs-switchers careerum-flex-sbfs">
                        <div class="awake-tariffs-period-wrapper hidden">
                            <div class="awake-tariffs-period careerum-flex-fsst">
                                <ul class="careerum-flex-fsfs not-m1 m3">
                                    <li data-period="1"  class="hidden">
                                        <p class="hidden-mobile">1 месяц</p>
                                        <p class="hidden-desc-tablet">1 меc</p>
                                    </li>
                                    <li data-period="3" class="active">
                                        <p class="hidden-mobile">3 месяца</p>
                                        <p class="hidden-desc-tablet">3 меcяца</p>
                                    </li>
                                    <li data-period="6"  class="hidden">
                                        <p class="hidden-mobile">6 месяцев</p>
                                        <p class="hidden-desc-tablet">6 мес</p>
                                    </li>
                                    <li data-period="12"  class="hidden">
                                        <p class="hidden-mobile">12 месяцев</p>
                                        <p class="hidden-desc-tablet">12 мес</p>
                                    </li>
                                </ul>
                                <div class="awake-tariffs-notif careerum-flex-cc">
                                    <div class="awake-tariffs-notif-icon"><img loading=""
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                            alt=""></div>
                                    <div class="awake-tariffs-notif-content">
                                        <p>1 месяц подписки предоставляет 30 дней доступа
                                            к платформе</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="global-tariffs-type-wrapper">
                            <ul class="careerum-flex-fsc">
                                <li class="active" data-type="group">Групповой</li>
                                <li data-type="ind">Индивидуальный</li>
                            </ul>
                        </div>
                        <div class="awake-tariffs-curr careerum-flex-fsst">
                            <ul class="careerum-flex-fsfs rub">
                                <li data-currency="eur">EUR</li>
                                <li data-currency="rub" class="active">RUB</li>
                            </ul>
                            <div class="awake-tariffs-notif careerum-flex-cc">
                                <div class="awake-tariffs-notif-icon"><img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                        alt=""></div>
                                <div class="awake-tariffs-notif-content">
                                    <p>Оплата в российских рублях возможна только картой
                                        российского банка.
                                        В&nbsp;евро — картой
                                        зарубежного банка</p>
                                </div>
                            </div>
                        </div>
                        <div class="awake-tariffs-curr-mobile">
                            <div class="awake-tariffs__swicher-block">
                                <div class="awake-tariffs__swicher-top">
                                    <p class="awake-tariffs__swicher-header">
                                        Посмотреть
                                        цены в
                                        <span>EUR</span>
                                    </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" class="awake-tariffs__swicher-arrow">
                                        <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black">
                                        </path>
                                    </svg>
                                </div>
                                <div class="awake-tariffs__swicher-bottom">
                                    <ul>
                                        <li data-currency="rub" class="active">RUB
                                        </li>
                                        <li data-currency="eur" class="">EUR
                                        </li>
                                    </ul>
                                    <p>
                                        Обратите внимание,<br>
                                        что оплата в российских
                                        рублях
                                        возможна только<br>с карты
                                        российского банка. Оплата в евро — с карты зарубежного банка

                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-tariffs-items-wrapper elements-2" data-type="group">
                        <div class="awake-tariffs-items careerum-flex-cst">
                            <div data-price="" data-price-1m-rub="14 900 ₽" data-oldprice-1m-rub="" data-discount-1m-rub=" %"
                                data-price-3m-rub="14 967 ₽" data-fullprice-3m-rub="44 900 ₽" data-oldprice-3m-rub="69 900 ₽"
                                data-discount-3m-rub="-36%" data-price-6m-rub="13 000 ₽" data-fullprice-6m-rub="78&nbsp;000 ₽"
                                data-oldprice-6m-rub="89 400 ₽" data-discount-6m-rub="-13%" data-price-12m-rub="10 000 ₽"
                                data-fullprice-12m-rub="120 000 ₽" data-oldprice-12m-rub="178 800 ₽"
                                data-discount-12m-rub="-33%" data-price-1m-eur="199 €" data-oldprice-1m-eur=""
                                data-discount-1m-eur=" %" data-price-3m-eur="193 €" data-fullprice-3m-eur="580 €"
                                data-oldprice-3m-eur="790 €" data-discount-3m-eur="-27%" data-price-6m-eur="150 €"
                                data-fullprice-6m-eur="900 €" data-oldprice-6m-eur="1 194 €" data-discount-6m-eur="-25%"
                                data-price-12m-eur="110 €" data-fullprice-12m-eur="1 320 €" data-oldprice-12m-eur="2 388 €"
                                data-discount-12m-eur="-45%" data-offer-1m-rub="28" data-offer-3m-rub="29"
                                data-offer-6m-rub="30" data-offer-12m-rub="31" data-offer-1m-eur="49" data-offer-3m-eur="50"
                                data-offer-6m-eur="51" data-offer-12m-eur="52"
                                class="awake-tariffs-item careerum-flex-fsfs">
                                <div class="awake-tariffs-item-header light-b">
                                    <div class="careerum-flex-fsc awake-tariffs-item-header-wrapper">
                                        <div class="awake-tariffs-item-header-label careerum-flex-fsc blue">
                                            <p >Без подписки в клуб</p>
                                        </div>
                                        <div class="awake-tariffs-item-header-label careerum-flex-fsc blue-tr">
                                            <p >3 месяца</p>
                                        </div>
                                    </div>
                                    <p class="awake-tariffs-item-header">Программа Go Global</p>
                                </div>
                                <div class="awake-tariffs-item-content">
                                    <ul >
                                        <li class="careerum-flex-fsfs disabled">
                                            <img loading=""
                                                src="https://cdn.careerum.com/1786104699267-KtinR-XCir.svg"
                                                alt="">
                                            <div >
                                                <p class="bold">Индивидуальная работа</p>
                                                <ul >
                                                    <li data-period="1" >
                                                        <p >6 личных консультации с карьерным экспертом/карьерным коучем</p>
                                                    </li>
                                                    <li data-period="1" >
                                                        <p >Личный чат поддержки</p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li class="careerum-flex-fsfs disabled">
                                            <img loading=""
                                                src="https://cdn.careerum.com/1786104699267-KtinR-XCir.svg"
                                                alt="">
                                            <div >
                                                <p class="bold">Доступ в карьерный клуб</p>
                                                <ul >
                                                    <li data-period="1" >
                                                        <p >8 обучающих программ </p>
                                                    </li>
                                                    <li data-period="1" >
                                                        <p >Экспертные онлайн-эфиры клуба</p>
                                                    </li>
                                                    <li data-period="1" >
                                                        <p >Нетворкинг</p>
                                                    </li>
                                                    <li data-period="1" >
                                                        <p >Еженедельный кофе-бадди</p>
                                                    </li>
                                                    <li data-period="1" >
                                                        <p >6 шаблонов резюме RU и EN и примеры заполнений</p>
                                                    </li>
                                                    <li data-period="1" >
                                                        <p >AI-сервис проверки резюме</p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>Доступ к программе c 29.09.2026 до конца срока подписки</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>Видеолекции + материалы программы</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>8 еженедельных групповых коворкинг-практик по 90 минут </p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>2 эфира с экспертами «Прожарки» (резюме, LinkedIn, Elevator Pitch)</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>2 эфира с экспертами по поиску работы на международном рынке</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>Работа в тройках</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>Домашние задания</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>Фидбэк от карьерных экспертов на всех живых эфирах</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>Ответы на вопросы в чате 5 рабочих дней</p>
                                        </li>
                                    </ul>
                                </div>
                                <div class="awake-tariffs-item-footer">
                                    <div class="awake-tariffs-item-discount hidden-m1">
                                        <p class="awake-tariffs-item-discount">-36%</p>
                                        <p class="awake-tariffs-item-oldprice">69 900 ₽
                                        </p>
                                    </div>
                                    <div class="awake-tariffs-item-price careerum-flex-fsfs">
                                        <p class="awake-tariffs-item-fullprice-amount">44
                                            900 ₽</p>
                                        <p class="awake-tariffs-item-price-separato hidden">/
                                        </p>
                                        <div class="hidden">
                                            <p class="awake-tariffs-item-price-amount">14
                                                967 ₽</p>
                                            <p class="awake-tariffs-item-price-text">цена
                                                месяца</p>
                                        </div>
                                    </div>
                                    <div class="awake-tariffs-item-rassr careerum-flex-fsc hidden-m1">
                                        <img loading=""
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753885469183-Cyal7-Cred.svg"
                                            alt="img">
                                        <p >Доступно в рассрочку</p>
                                    </div>
                                    <div class="awake-tariffs-item-link">
                                        <a onclick="" href="https://school.careerum.ru/anketa_goglobal" target="_blank"
                                            class="no-change no-popup getparams btn-color-main-red3">Заполнить анкету</a>
                                    </div>
                                </div>
                            </div>
                            <div data-price="" data-price-1m-rub="33&nbsp;900 ₽" data-oldprice-1m-rub=""
                                data-discount-1m-rub=" %" data-price-3m-rub="33 000 ₽" data-fullprice-3m-rub="99 000 ₽"
                                data-oldprice-3m-rub="129 900 ₽" data-discount-3m-rub="-23%" data-price-6m-rub="29 000 ₽"
                                data-fullprice-6m-rub="174 000 ₽" data-oldprice-6m-rub="203 400 ₽" data-discount-6m-rub="-14%"
                                data-price-12m-rub="22 000 ₽" data-fullprice-12m-rub="264 000 ₽"
                                data-oldprice-12m-rub="406 800 ₽" data-discount-12m-rub="-35%" data-price-1m-eur="360 €"
                                data-oldprice-1m-eur="" data-discount-1m-eur=" %" data-price-3m-eur="330 €"
                                data-fullprice-3m-eur="990 €" data-oldprice-3m-eur="1 460 €" data-discount-3m-eur="-33%"
                                data-price-6m-eur="290 €" data-fullprice-6m-eur="1 740 €" data-oldprice-6m-eur="2 160 €"
                                data-discount-6m-eur="-19%" data-price-12m-eur="245 €" data-fullprice-12m-eur="2 940 €"
                                data-oldprice-12m-eur="4 320 €" data-discount-12m-eur="-32%" data-offer-1m-rub="32"
                                data-offer-3m-rub="100" data-offer-6m-rub="101" data-offer-12m-rub="102" data-offer-1m-eur="53"
                                data-offer-3m-eur="103" data-offer-6m-eur="104" data-offer-12m-eur="105"
                                class="awake-tariffs-item careerum-flex-fsfs">
                                <div  class="awake-tariffs-item-header blue">
                                    <div  class="careerum-flex-fsc awake-tariffs-item-header-wrapper">
                                        <div class="awake-tariffs-item-header-label careerum-flex-fsc white shadow">
                                            <p >С подпиской в клуб</p>
                                        </div>
                                        <div class="awake-tariffs-item-header-label careerum-flex-fsc white-tr">
                                            <p >3 месяца</p>
                                        </div>
                                    </div>
                                    <p class="awake-tariffs-item-header">Программа Go Global + подписка в клуб</p>
                                </div>
                                <div class="awake-tariffs-item-content">
                                    <ul >
                                        <li class="careerum-flex-fsfs disabled">
                                            <img loading=""
                                                src="https://cdn.careerum.com/1786104699267-KtinR-XCir.svg"
                                                alt="">
                                            <div >
                                                <p class="bold">Индивидуальная работа</p>
                                                <ul >
                                                    <li data-period="1" >
                                                        <p >6 личных консультации с карьерным экспертом/карьерным коучем</p>
                                                    </li>
                                                    <li data-period="1" >
                                                        <p >Личный чат поддержки</p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <div >
                                                <p class="bold">Доступ в карьерный клуб</p>
                                                <ul >
                                                    <li data-period="1" >
                                                        <p >8 обучающих программ </p>
                                                    </li>
                                                    <li data-period="1" >
                                                        <p >Экспертные онлайн-эфиры клуба</p>
                                                    </li>
                                                    <li data-period="1" >
                                                        <p >Нетворкинг</p>
                                                    </li>
                                                    <li data-period="1" >
                                                        <p >Еженедельный кофе-бадди</p>
                                                    </li>
                                                    <li data-period="1" >
                                                        <p >6 шаблонов резюме RU и EN и примеры заполнений</p>
                                                    </li>
                                                    <li data-period="1" >
                                                        <p >AI-сервис проверки резюме</p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>Доступ к программе c 29.09.2026 до конца срока подписки</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>Видеолекции + материалы программы</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>8 еженедельных групповых коворкинг-практик по 90 минут </p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>2 эфира с экспертами «Прожарки» (резюме, LinkedIn, Elevator Pitch)</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>2 эфира с экспертами по поиску работы на международном рынке</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>Работа в тройках</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>Домашние задания</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>Фидбэк от карьерных экспертов на всех живых эфирах</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>Ответы на вопросы в чате 5 рабочих дней</p>
                                        </li>
                                    </ul>
                                </div>
                                <div class="awake-tariffs-item-footer">
                                    <div class="awake-tariffs-item-discount hidden-m1">
                                        <p class="awake-tariffs-item-discount">-23%</p>
                                        <p class="awake-tariffs-item-oldprice">129 900 ₽
                                        </p>
                                    </div>
                                    <div class="awake-tariffs-item-price careerum-flex-fsfs">
                                        <p class="awake-tariffs-item-fullprice-amount">99
                                            000 ₽</p>
                                        <p class="awake-tariffs-item-price-separator">/
                                        </p>
                                        <div>
                                            <p class="awake-tariffs-item-price-amount">33
                                                000 ₽</p>
                                            <p class="awake-tariffs-item-price-text">цена
                                                месяца</p>
                                        </div>
                                    </div>
                                    <div class="awake-tariffs-item-rassr careerum-flex-fsc hidden-m1"><img loading=""
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753885469183-Cyal7-Cred.svg"
                                            alt="img">
                                        <p>Доступно в рассрочку</p>
                                    </div>
                                    <div class="awake-tariffs-item-notif hidden">
                                        <p>Места закончились</p>
                                        <p>Оставьте заявку в лист ожидания, если у нас
                                            освободится место, то&nbsp;наши карьерные консультанты свяжутся с вами</p>
                                    </div>
                                    <div class="awake-tariffs-item-link">
                                        <a onclick="" href="https://school.careerum.ru/anketa_goglobal" target="_blank"
                                            class="no-change no-popup getparams btn-color-main-red3">Заполнить анкету</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-tariffs-items-wrapper elements-2" data-type="ind">
                        <div class="awake-tariffs-items careerum-flex-cst">
                            <div data-price="" data-price-1m-rub="14 900 ₽" data-oldprice-1m-rub="" data-discount-1m-rub=" %"
                                data-price-3m-rub="14 967 ₽" data-fullprice-3m-rub="44 900 ₽" data-oldprice-3m-rub="69 900 ₽"
                                data-discount-3m-rub="-36%" data-price-6m-rub="13 000 ₽" data-fullprice-6m-rub="78&nbsp;000 ₽"
                                data-oldprice-6m-rub="89 400 ₽" data-discount-6m-rub="-13%" data-price-12m-rub="10 000 ₽"
                                data-fullprice-12m-rub="120 000 ₽" data-oldprice-12m-rub="178 800 ₽"
                                data-discount-12m-rub="-33%" data-price-1m-eur="199 €" data-oldprice-1m-eur=""
                                data-discount-1m-eur=" %" data-price-3m-eur="193 €" data-fullprice-3m-eur="580 €"
                                data-oldprice-3m-eur="790 €" data-discount-3m-eur="-27%" data-price-6m-eur="150 €"
                                data-fullprice-6m-eur="900 €" data-oldprice-6m-eur="1 194 €" data-discount-6m-eur="-25%"
                                data-price-12m-eur="110 €" data-fullprice-12m-eur="1 320 €" data-oldprice-12m-eur="2 388 €"
                                data-discount-12m-eur="-45%" data-offer-1m-rub="28" data-offer-3m-rub="29"
                                data-offer-6m-rub="30" data-offer-12m-rub="31" data-offer-1m-eur="49" data-offer-3m-eur="50"
                                data-offer-6m-eur="51" data-offer-12m-eur="52"
                                class="awake-tariffs-item careerum-flex-fsfs">
                                <div class="awake-tariffs-item-header light-r">
                                    <div class="careerum-flex-fsc awake-tariffs-item-header-wrapper">
                                        <div class="awake-tariffs-item-header-label careerum-flex-fsc white">
                                            <p >Без подписки в клуб</p>
                                        </div>
                                        <div class="awake-tariffs-item-header-label careerum-flex-fsc white-tr">
                                            <p >3 месяца</p>
                                        </div>
                                    </div>
                                    <p class="awake-tariffs-item-header">Программа Go Global</p>
                                </div>
                                <div class="awake-tariffs-item-content">
                                    <ul >
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <div >
                                                <p class="bold">Индивидуальная работа</p>
                                                <ul >
                                                    <li data-period="1" >
                                                        <p >6 личных консультации с карьерным экспертом/карьерным коучем</p>
                                                    </li>
                                                    <li data-period="1" >
                                                        <p >Личный чат поддержки</p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>Доступ к программе c 29.09.2026 до конца срока подписки</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>Видеолекции + материалы программы</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>8 еженедельных групповых коворкинг-практик по 90 минут </p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>2 эфира с экспертами «Прожарки» (резюме, LinkedIn, Elevator Pitch)</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>2 эфира с экспертами по поиску работы на международном рынке</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>Работа в тройках</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>Домашние задания</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>Фидбэк от карьерных экспертов на всех живых эфирах</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>Ответы на вопросы в чате 5 рабочих дней</p>
                                        </li>
                                        <li class="careerum-flex-fsfs disabled">
                                            <img loading=""
                                                src="https://cdn.careerum.com/1786104699267-KtinR-XCir.svg"
                                                alt="">
                                            <div >
                                                <p class="bold">Доступ в карьерный клуб</p>
                                                <ul >
                                                    <li data-period="1" >
                                                        <p >8 обучающих программ </p>
                                                    </li>
                                                    <li data-period="1" >
                                                        <p >Экспертные онлайн-эфиры клуба</p>
                                                    </li>
                                                    <li data-period="1" >
                                                        <p >Нетворкинг</p>
                                                    </li>
                                                    <li data-period="1" >
                                                        <p >Еженедельный кофе-бадди</p>
                                                    </li>
                                                    <li data-period="1" >
                                                        <p >6 шаблонов резюме RU и EN и примеры заполнений</p>
                                                    </li>
                                                    <li data-period="1" >
                                                        <p >AI-сервис проверки резюме</p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div class="awake-tariffs-item-footer">
                                    <div class="awake-tariffs-item-discount hidden-m1">
                                        <p class="awake-tariffs-item-discount">-36%</p>
                                        <p class="awake-tariffs-item-oldprice">69 900 ₽
                                        </p>
                                    </div>
                                    <div class="awake-tariffs-item-price careerum-flex-fsfs">
                                        <p class="awake-tariffs-item-fullprice-amount">44
                                            900 ₽</p>
                                        <p class="awake-tariffs-item-price-separato hidden">/
                                        </p>
                                        <div class="hidden">
                                            <p class="awake-tariffs-item-price-amount">14
                                                967 ₽</p>
                                            <p class="awake-tariffs-item-price-text">цена
                                                месяца</p>
                                        </div>
                                    </div>
                                    <div class="awake-tariffs-item-rassr careerum-flex-fsc hidden-m1">
                                        <img loading=""
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753885469183-Cyal7-Cred.svg"
                                            alt="img">
                                        <p >Доступно в рассрочку</p>
                                    </div>
                                    <div class="awake-tariffs-item-link">
                                        <a onclick="" href="https://school.careerum.ru/anketa_goglobal" target="_blank"
                                            class="no-change no-popup getparams btn-color-main-red3">Заполнить анкету</a>
                                    </div>
                                </div>
                            </div>
                            <div data-price="" data-price-1m-rub="33&nbsp;900 ₽" data-oldprice-1m-rub=""
                                data-discount-1m-rub=" %" data-price-3m-rub="33 000 ₽" data-fullprice-3m-rub="99 000 ₽"
                                data-oldprice-3m-rub="129 900 ₽" data-discount-3m-rub="-23%" data-price-6m-rub="29 000 ₽"
                                data-fullprice-6m-rub="174 000 ₽" data-oldprice-6m-rub="203 400 ₽" data-discount-6m-rub="-14%"
                                data-price-12m-rub="22 000 ₽" data-fullprice-12m-rub="264 000 ₽"
                                data-oldprice-12m-rub="406 800 ₽" data-discount-12m-rub="-35%" data-price-1m-eur="360 €"
                                data-oldprice-1m-eur="" data-discount-1m-eur=" %" data-price-3m-eur="330 €"
                                data-fullprice-3m-eur="990 €" data-oldprice-3m-eur="1 460 €" data-discount-3m-eur="-33%"
                                data-price-6m-eur="290 €" data-fullprice-6m-eur="1 740 €" data-oldprice-6m-eur="2 160 €"
                                data-discount-6m-eur="-19%" data-price-12m-eur="245 €" data-fullprice-12m-eur="2 940 €"
                                data-oldprice-12m-eur="4 320 €" data-discount-12m-eur="-32%" data-offer-1m-rub="32"
                                data-offer-3m-rub="100" data-offer-6m-rub="101" data-offer-12m-rub="102" data-offer-1m-eur="53"
                                data-offer-3m-eur="103" data-offer-6m-eur="104" data-offer-12m-eur="105"
                                class="awake-tariffs-item careerum-flex-fsfs">
                                <div  class="awake-tariffs-item-header red">
                                    <div  class="careerum-flex-fsc awake-tariffs-item-header-wrapper">
                                        <div class="awake-tariffs-item-header-label careerum-flex-fsc white shadow">
                                            <p >С подпиской в клуб</p>
                                        </div>
                                        <div class="awake-tariffs-item-header-label careerum-flex-fsc white-tr">
                                            <p >3 месяца</p>
                                        </div>
                                    </div>
                                    <p class="awake-tariffs-item-header">Программа Go Global + подписка в клуб</p>
                                </div>
                                <div class="awake-tariffs-item-content">
                                    <ul >
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <div >
                                                <p class="bold">Индивидуальная работа</p>
                                                <ul >
                                                    <li data-period="1" >
                                                        <p >6 личных консультации с карьерным экспертом/карьерным коучем</p>
                                                    </li>
                                                    <li data-period="1" >
                                                        <p >Личный чат поддержки</p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <div >
                                                <p class="bold">Доступ в карьерный клуб</p>
                                                <ul >
                                                    <li data-period="1" >
                                                        <p >8 обучающих программ </p>
                                                    </li>
                                                    <li data-period="1" >
                                                        <p >Экспертные онлайн-эфиры клуба</p>
                                                    </li>
                                                    <li data-period="1" >
                                                        <p >Нетворкинг</p>
                                                    </li>
                                                    <li data-period="1" >
                                                        <p >Еженедельный кофе-бадди</p>
                                                    </li>
                                                    <li data-period="1" >
                                                        <p >6 шаблонов резюме RU и EN и примеры заполнений</p>
                                                    </li>
                                                    <li data-period="1" >
                                                        <p >AI-сервис проверки резюме</p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>Доступ к программе c 29.09.2026 до конца срока подписки</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>Видеолекции + материалы программы</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>8 еженедельных групповых коворкинг-практик по 90 минут </p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>2 эфира с экспертами «Прожарки» (резюме, LinkedIn, Elevator Pitch)</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>2 эфира с экспертами по поиску работы на международном рынке</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>Работа в тройках</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>Домашние задания</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>Фидбэк от карьерных экспертов на всех живых эфирах</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>Ответы на вопросы в чате 5 рабочих дней</p>
                                        </li>
                                    </ul>
                                </div>
                                <div class="awake-tariffs-item-footer">
                                    <div class="awake-tariffs-item-discount hidden-m1">
                                        <p class="awake-tariffs-item-discount">-23%</p>
                                        <p class="awake-tariffs-item-oldprice">129 900 ₽
                                        </p>
                                    </div>
                                    <div class="awake-tariffs-item-price careerum-flex-fsfs">
                                        <p class="awake-tariffs-item-fullprice-amount">99
                                            000 ₽</p>
                                        <p class="awake-tariffs-item-price-separator">/
                                        </p>
                                        <div>
                                            <p class="awake-tariffs-item-price-amount">33
                                                000 ₽</p>
                                            <p class="awake-tariffs-item-price-text">цена
                                                месяца</p>
                                        </div>
                                    </div>
                                    <div class="awake-tariffs-item-rassr careerum-flex-fsc hidden-m1"><img loading=""
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753885469183-Cyal7-Cred.svg"
                                            alt="img">
                                        <p>Доступно в рассрочку</p>
                                    </div>
                                    <div class="awake-tariffs-item-notif hidden">
                                        <p>Места закончились</p>
                                        <p>Оставьте заявку в лист ожидания, если у нас
                                            освободится место, то&nbsp;наши карьерные консультанты свяжутся с вами</p>
                                    </div>
                                    <div class="awake-tariffs-item-link">
                                        <a onclick="" href="https://school.careerum.ru/anketa_goglobal" target="_blank"
                                            class="no-change no-popup getparams btn-color-main-red3">Заполнить анкету</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-global-format', {
        label: 'Careerum goglobal format',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-global-format main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>ФОРМАТЫ:</h2>
                    <div class="global-format-top">
                        <div class="global-format-top-row careerum-flex-fsfs">
                            <div class="global-format-top-text">
                                <p>С группой</p>
                            </div>
                            <div class="global-format-top-img careerum-flex-cc">
                                <img src="https://cdn.careerum.com/1786426495853-6b5G0-User.svg" class="hidden-mobile" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1786429948481-OsZLs-User.svg" class="hidden-desc-tablet" alt="img" loading="lazy">
                            </div>
                        </div>
                        <div class="global-format-top-row careerum-flex-fsfs">
                            <div class="global-format-top-img red careerum-flex-cc">
                                <img src="https://cdn.careerum.com/1786426495776-ZUsSE-User.svg" class="hidden-mobile" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1786429948406-tuo5P-User.svg" class="hidden-desc-tablet" alt="img" loading="lazy">
                            </div>
                            <div class="global-format-top-text red">
                                <p>Индивидуально</p>
                            </div>
                        </div>
                    </div>
                    <div class="global-format-slider noselect">
                        <div class="global-format-item">
                            <img src="https://cdn.careerum.com/1786427695567-yEquu-Fire.svg" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1786429342035-WXoms-Fire.svg" class="hidden-desc" alt="img"
                                loading="lazy">
                            <p class="global-format-item-title">Живые экспертные эфиры</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1786426704040-2cvg4-Chec.svg" alt="img" loading="lazy">
                                    <p>2 эфира Прожарки с карьерными экспертами Резюме, LinkedIn, Elevator Pitch</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1786426704040-2cvg4-Chec.svg" alt="img" loading="lazy">
                                    <p>2 эфира с экспертами по поиску работы на международном рынке</p>
                                </li>
                            </ul>
                        </div>
                        <div class="global-format-item">
                            <img src="https://cdn.careerum.com/1786427695503-v4kn5-Chat.svg" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1786429341978-eQgde-Chat.svg" class="hidden-desc" alt="img"
                                loading="lazy">
                            <p class="global-format-item-title">Практика</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1786426704040-2cvg4-Chec.svg" alt="img" loading="lazy">
                                    <p>8 коворкинг-практик каждую неделю по 90 минут</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1786426704040-2cvg4-Chec.svg" alt="img" loading="lazy">
                                    <p>Домашние задания (с проверкой от экспертов на «Индивидуальном тарифе»)</p>
                                </li>
                            </ul>
                        </div>
                        <div class="global-format-item">
                            <img src="https://cdn.careerum.com/1786427695536-1QU3m-Chat.svg" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1786429342005-0YbMb-Chat.svg" class="hidden-desc" alt="img"
                                loading="lazy">
                            <p class="global-format-item-title">Обратная связь и поддержка</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1786426704040-2cvg4-Chec.svg" alt="img" loading="lazy">
                                    <p>Фидбэк от карьерных экспертов на всех живых эфирах</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1786426704040-2cvg4-Chec.svg" alt="img" loading="lazy">
                                    <p>Ответы на вопросы в чате 5 рабочих дней</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1786426704040-2cvg4-Chec.svg" alt="img" loading="lazy">
                                    <p>Личный чат поддержки с экспертами</p>
                                </li>
                            </ul>
                        </div>
                        <div class="global-format-item">
                            <img src="https://cdn.careerum.com/1786427695599-ha2im-Fram.svg" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1786429342065-bir5t-Fram.svg" class="hidden-desc" alt="img"
                                loading="lazy">
                            <p class="global-format-item-title">Работа в тройках</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1786426704040-2cvg4-Chec.svg" alt="img" loading="lazy">
                                    <p>Командный формат проработки заданий программы: вы сможете валидировать свои идеи, получить взгляд со стороны и поддержку от сокурсников</p>
                                </li>
                            </ul>
                        </div>
                        <div class="global-format-item">
                            <img src="https://cdn.careerum.com/1786427695387-XspgC-Book.svg" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1786429341690-qyzfv-Book.svg" class="hidden-desc" alt="img"
                                loading="lazy">
                            <p class="global-format-item-title">Домашние задания</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1786426704040-2cvg4-Chec.svg" alt="img" loading="lazy">
                                    <p>Видеолекции + материалы программы</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1786426704040-2cvg4-Chec.svg" alt="img" loading="lazy">
                                    <p>С проверкой от экспертов на Индивидуальном тарифе</p>
                                </li>
                            </ul>
                        </div>
                        <div class="global-format-item">
                            <img src="https://cdn.careerum.com/1786427695633-FET6K-Hand.svg" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1786429342094-YKSbr-Hand.svg" class="hidden-desc" alt="img"
                                loading="lazy">
                            <p class="global-format-item-title">Индивидуальная работа с экспертами и коучами</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1786426704040-2cvg4-Chec.svg" alt="img" loading="lazy">
                                    <p>Только на тарифе «Индивидуальное сопровождение»</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1786426704040-2cvg4-Chec.svg" alt="img" loading="lazy">
                                    <p>Онбординг-встреча с коучем (30 мин)</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1786426704040-2cvg4-Chec.svg" alt="img" loading="lazy">
                                    <p>6 личных консультации с карьерным экспертом/карьерным коучем (50 минут)</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1786426704040-2cvg4-Chec.svg" alt="img" loading="lazy">
                                    <p>Личный чат поддержки с экспертами</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1786426704040-2cvg4-Chec.svg" alt="img" loading="lazy">
                                    <p>Проверка домашних заданий карьерным экспертом и коучем</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-global-banner', {
        label: 'Careerum goglobal banner',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-global-main main-wrapper careerum-global-banner">
                <div class="careerum-container-responsive">
                    <div class="global-main-content careerum-flex-sbst">
                        <div class="global-main-left position-relative z-10">
                            <div class="global-main-labels careerum-flex-fsfs">
                                <div class="global-main-label red">
                                    <p>Старт 29 сентября</p>
                                </div>
                                <div class="global-main-label">
                                    <p>3 месяца</p>
                                </div>
                            </div>
                            <h1>Go Global</h1>
                            <p class="global-main-text">Постройте международную карьеру без обнуления своего опыта</p>
                            <p class="global-main-label2">Раняя цена <span>до 20 августа</span></p>
                        </div>
                        <div class="global-main-right position-relative z-1">
                            <img src="https://cdn.careerum.com/1786536211752-TcCX9-Fram.png"
                                class="hidden-tablet-mobile position-absolute" alt="img" loading="eager">
                            <img src="https://cdn.careerum.com/1786536225180-YDgQG-Fram.png"
                                class="hidden-desc-mobile position-absolute" alt="img" loading="eager">
                            <img src="https://cdn.careerum.com/1786517570504-SSIwF-Fram.png"
                                class="hidden-desc-tablet position-absolute" alt="img" loading="eager">
                        </div>
                    </div>
                    <a href="ru-ru/go-global" class="btn-color-main-red3 position-relative z-10 getparams">Посмотреть программу</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-global-banner-top', {
        label: 'Careerum goglobal banner-top',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div data-timer="no" data-redirect="no" data-url="" data-static="yes" data-offset=""
                data-timer-end="09/29/2026 00:00 GMT+0300" id="i22kzbd"
                class="careerum-club5-banner-top club5-banner-top4 main-wrapper careerum-global-banner-top">
                <div class="careerum-container-responsive">
                    <div class="club5-banner__wrapper position-relative">
                        <div class="club5-banner__bg position-absolute z-10">
                            <img loading="" src="https://cdn.careerum.com/1786513869822-t0nwG-Chat.png" alt="img"
                                class="hidden-tablet-mobile position-absolute">
                            <img loading="" src="https://cdn.careerum.com/1786514401406-7SKMB-Chat.png" alt="img"
                                class="hidden-desc-mobile position-absolute">
                        </div>
                        <div class="club5-banner__content careerum-flex-sbc position-relative z-20">
                            <div class="club5-banner__left">
                                <p class="club5-banner__label">Старт 29 сентября</p>
                                <p class="club5-banner__title">Набор на программу Go Global</p>
                                <p class="club5-banner__text">Постройте международную карьеру без обнуления своего опыта</p>
                            </div>
                            <div class="club5-banner__timer">
                                <div class="careerum-flex-sbst">
                                    <div class="club5-banner__timer-item">
                                        <p class="timer-day-number">00</p>
                                        <p class="timer-day-text">дней</p>
                                    </div>
                                    <div class="club5-banner__timer-item">
                                        <p class="timer-hour-number">00</p>
                                        <p class="timer-hour-text">часов</p>
                                    </div>
                                    <div class="club5-banner__timer-item">
                                        <p class="timer-min-number">00</p>
                                        <p class="timer-min-text">минут</p>
                                    </div>
                                </div>
                            </div>
                            <div class="club5-banner__right careerum-flex-fec">
                                <a onclick="" href="ru-ru/go-global" target="_blank"
                                    class="btn-color-main-red3 getparams">Узнать подробнее</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-global-main2', {
        label: 'Careerum goglobal main2',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-global-main main-wrapper careerum-global-main2">
                <div class="careerum-container-responsive">
                    <div class="global-main-content careerum-flex-sbst">
                        <div class="global-main-left position-relative z-10">
                            <div class="global-main-labels careerum-flex-fsfs">
                                <div class="global-main-label red">
                                    <p>Старт 29 сентября</p>
                                </div>
                                <div class="global-main-label">
                                    <p>3 месяца</p>
                                </div>
                            </div>
                            <h1>Global<br> Level Up</h1>
                            <p class="global-main-text">Стратегия роста в деньгах и должности на международном рынке:</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1787148693708-kbLez-Soft.svg" class="hidden-mobile"
                                        alt="img" loading="eager">
                                    <img src="https://cdn.careerum.com/1787148695409-vZ28X-Soft.svg" class="hidden-desc-tablet"
                                        alt="img" loading="eager">
                                    <p>Рост внутри команды</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1787148693708-kbLez-Soft.svg" class="hidden-mobile"
                                        alt="img" loading="eager">
                                    <img src="https://cdn.careerum.com/1787148695409-vZ28X-Soft.svg" class="hidden-desc-tablet"
                                        alt="img" loading="eager">
                                    <p>Рост внутри компании</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1787148693708-kbLez-Soft.svg" class="hidden-mobile"
                                        alt="img" loading="eager">
                                    <img src="https://cdn.careerum.com/1787148695409-vZ28X-Soft.svg" class="hidden-desc-tablet"
                                        alt="img" loading="eager">
                                    <p>Рост через поиск новой работы</p>
                                </li>
                            </ul>
                            <div class="global-main-regions careerum-flex-fsfs">
                                <p>ЕС</p>
                                <p>DACH</p>
                                <p>США</p>
                                <p>ОАЭ</p>
                                <p>JAPAC</p>
                                <p>MENA</p>
                                <p>LATAM</p>
                                <p>UK&I</p>
                                <p>BALTICS</p>
                            </div>
                        </div>
                        <div class="global-main-right position-relative z-1">
                            <p class="global-main-clients z-10 position-absolute">На кейсах 14 000+ клиентов</p>
                            <p class="global-main-countries z-10 position-absolute">60+ стран</p>
                            <img src="https://cdn.careerum.com/1787149129434-7pq4G-Fram.png"
                                class="hidden-tablet-mobile position-absolute" alt="img" loading="eager">
                            <img src="https://cdn.careerum.com/1787204879372-AdHrq-Fram.png"
                                class="hidden-desc-mobile position-absolute" alt="img" loading="eager">
                            <img src="https://cdn.careerum.com/1787207504766-iE9SC-Grou.png"
                                class="hidden-desc-tablet" alt="img" loading="eager">
                        </div>
                    </div>
                    <a href="#" class="btn-color-main-red3 position-relative z-10">Посмотреть программу</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-global-why2', {
        label: 'Careerum goglobal why2',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-global-why2 v2 main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Стоит участвовать, если:</h2>
                    <div class="global-why2-switchers">
                        <ul class="careerum-flex-fsfs noselect">
                            <li class="active" data-type="up">Повышение</li>
                            <li data-type="search">Поиск работы</li>
                        </ul>
                    </div>
                    <div class="global-why2-content careerum-flex-sbfs">
                        <div class="global-why2-left">
                            <img src="https://cdn.careerum.com/1787149770660-eIUA5-Fram.png" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1787205177439-EMIbH-Fram.png" class="hidden-desc-mobile" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1787207791776-Jv3zw-Fram.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                        </div>
                        <div class="global-why2-right">
                            <div class="global-why2-items" data-type="up">
                                <div class="global-why2-item">
                                    <p class="global-why2-header">Вы не понимаете, куда двигаться дальше, несмотря на свой опыт</p>
                                    <p class="global-why2-text">Вы многое умеете, но не понимаете, как это собрать в конкретную стратегию роста на международном рынке</p>
                                </div>
                                <div class="global-why2-item">
                                    <p class="global-why2-header">Не понимаете, как устроена политика в компаниях</p>
                                    <p class="global-why2-text">Вы не знаете, как правильно повышать «свою видимость», чтобы это считалось культурно приемлемым для западной среды</p>
                                </div>
                                <div class="global-why2-item">
                                    <p class="global-why2-header">В ВАШЕЙ КОМПАНИИ Headcount freeze</p>
                                    <p class="global-why2-text">Вам кажется, что рост невозможен из-за внутренних политик, headcount freeze, отсутствия прав на промо</p>
                                </div>
                                <div class="global-why2-item">
                                    <p class="global-why2-header">Устали от Бесконечных реоргов и сокращений</p>
                                    <p class="global-why2-text">Менеджеры меняются часто, и с каждым новым вам приходится заново доказывать свою ценность</p>
                                </div>
                                <div class="global-why2-item">
                                    <p class="global-why2-header">Много МИКРОменеджмента в компании</p>
                                    <p class="global-why2-text">Решения о вашем карьерном росте принимают люди, которые вас лично не знают</p>
                                </div>
                                <div class="global-why2-item">
                                    <p class="global-why2-header">в вашей компанде Manager’s favorite сильнее meritocracy</p>
                                    <p class="global-why2-text">Ваш менеджер делает ставку на local talent — вас держит «в тени» без выхода на P&L или стратегию</p>
                                </div>
                                <div class="global-why2-item">
                                    <p class="global-why2-header">ваша инициатива никому не нужна</p>
                                    <p class="global-why2-text">Любые инициативы в компании воспринимаются как «too pushy», если вы не из локальной культуры. При этом более молодые и напористые local-коллеги растут</p>
                                </div>
                                <div class="global-why2-item">
                                    <p class="global-why2-header">вас ценят как исполнителя, но не видят лидера</p>
                                    <p class="global-why2-text">Вы отвечаете за кросс-функциональные задачи, но не получаете ни промоушена, ни полномочий</p>
                                </div>
                                <div class="global-why2-item">
                                    <p class="global-why2-header">Достигли потолка</p>
                                    <p class="global-why2-text">Вы достигли высокого уровня, но не вижу своего следующего шага в международной системе</p>
                                </div>
                                <div class="global-why2-item">
                                    <p class="global-why2-header">не понимаете, какие навыки нужно докачать</p>
                                    <p class="global-why2-text">Чтобы перепрыгнуть на новый уровень в карьере</p>
                                </div>
                                <div class="global-why2-item">
                                    <p class="global-why2-header">ваша Ответственность растёт, а влияние и деньги — нет</p>
                                    <p class="global-why2-text">Каждый раз вам прибавляют нагрузку, но формально это не учитывается. Вы буквально забываете о себе, вас не замечают, вы не умеете себя продавать</p>
                                </div>
                                <div class="global-why2-item">
                                    <p class="global-why2-header">AI-трансформация мира тревожит вас: ваши hard-скиллы заменяемы</p>
                                    <p class="global-why2-text">Не знаете, как при конкуренции с ИИ упаковать свой опыт, показать и продать его текущему работодателю или на открытом рынке</p>
                                </div>
                            </div>
                            <div class="global-why2-items" data-type="search">
                                <div class="global-why2-item">
                                    <p class="global-why2-header">ВЫ умеЕТЕ искать работу, но ВАШИ инструменты нужно перекалибровать под следующий уровень / новый рынок</p>
                                </div>
                                <div class="global-why2-item">
                                    <p class="global-why2-header">Не понимаЕТЕ, на какую роль теперь продавать себя НА МЕЖДУНАРОДНОМ РЫНКЕ</p>
                                </div>
                                <div class="global-why2-item">
                                    <p class="global-why2-header">Не понимаЕТЕ, на каком рынке/в какой географии У ВАС ЕСТЬ реальные шансы И ГДЕ ОНИ выше</p>
                                </div>
                                <div class="global-why2-item">
                                    <p class="global-why2-header">Старое позиционирование перестало работать после смены роли или уровня</p>
                                </div>
                                <div class="global-why2-item">
                                    <p class="global-why2-header">ПРОХОДИТЕ интервью, но не понимаЕТЕ, почему они не превращаются в оффер</p>
                                </div>
                                <div class="global-why2-item">
                                    <p class="global-why2-header">AI и изменениЯ профессий делают выбор следующего карьерного шага ещё менее очевидным</p>
                                </div>
                                <div class="global-why2-item">
                                    <p class="global-why2-header">У ВАС много ЗНАНИЙ, но нет системы принятия карьерных решений</p>
                                </div>
                                <div class="global-why2-item">
                                    <p class="global-why2-header">ВЫ давно не искалИ работу и не понимаЕТЕ, как устроен сегодняшний рынок</p>
                                </div>
                                <div class="global-why2-item">
                                    <p class="global-why2-header">понимаЕТЕ, что СОВСЕМ скоро ВАМ понадобится поиск РАБОТЫ</p>
                                </div>
                                <div class="global-why2-item">
                                    <p class="global-why2-header">виДИТЕ много карьерных решений и программ, но не понимаЕТЕ, какИЕ ПОДХОДЯТ именно ВАМ</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-global-learn', {
        label: 'Careerum goglobal learn',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-global-learn main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Как пройдёт обучение</h2>
                    <div class="global-learn-top position-relative">
                        <p class="global-learn-top-header position-relative z-10">Подходит для:</p>
                        <div class="global-learn-top-labels position-relative z-10 careerum-flex-fsfs">
                            <div class="global-learn-top-label red">
                                <p>Роста внутри компании</p>
                            </div>
                            <div class="global-learn-top-label">
                                <p>Поиска новой работы</p>
                            </div>
                        </div>
                        <img src="https://cdn.careerum.com/1787150731834-g4cgB-Chat.png"
                            class="hidden-tablet-mobile position-absolute z-10" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1787205330040-hmLkz-Chat.png" class="hidden-desc-mobile position-absolute z-10" alt="img"
                            loading="lazy">
                        <img src="https://cdn.careerum.com/1787208368358-3jLsF-Chat.png" class="hidden-desc-tablet position-absolute z-10" alt="img"
                            loading="lazy">
                    </div>
                    <div class="global-learn-tales careerum-flex-sbst">
                        <div class="global-learn-tale">
                            <p class="global-learn-tale-label">Шаг 1</p>
                            <p class="global-learn-tale-header">Проведёте аудит накопленного опыта за годы карьеры:</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1787148695409-vZ28X-Soft.svg" alt="img" loading="eager">
                                    <p>Присвоите себе результаты</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1787148695409-vZ28X-Soft.svg" alt="img" loading="eager">
                                    <p>Поймёте свою рыночную стоимость</p>
                                </li>
                            </ul>
                        </div>
                        <div class="global-learn-tale">
                            <p class="global-learn-tale-label">Шаг 2</p>
                            <p class="global-learn-tale-header">Определите следующий шаг:</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1787148695409-vZ28X-Soft.svg" alt="img" loading="eager">
                                    <p>Рост внутри компании / поиск новой работы / выход в портфельную карьеру
                                        или горизонтальный / вертикальный/ диагональный рост</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1787148695409-vZ28X-Soft.svg" alt="img" loading="eager">
                                    <p>Смена сферы или рост в своей профессии</p>
                                </li>
                            </ul>
                        </div>
                        <div class="global-learn-tale">
                            <p class="global-learn-tale-label">Шаг 3</p>
                            <p class="global-learn-tale-header">Создадите карьерную стратегию роста на 1/3/5 лет на основе:</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1787148695409-vZ28X-Soft.svg" alt="img" loading="eager">
                                    <p>Своих профессиональных ценностей, талантов</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1787148695409-vZ28X-Soft.svg" alt="img" loading="eager">
                                    <p>Активов, сильных сторон, навыков</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1787148695409-vZ28X-Soft.svg" alt="img" loading="eager">
                                    <p>Сильного позиционирования, соответствия потребностям актуального рынка труда</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1787148695409-vZ28X-Soft.svg" alt="img" loading="eager">
                                    <p>Ответа на вопрос: «В какой индустрии и роли я хочу быть глобально?»</p>
                                </li>
                            </ul>
                        </div>
                        <div class="global-learn-tale">
                            <p class="global-learn-tale-label">Шаг 4</p>
                            <p class="global-learn-tale-header">Проведёте анализ рынка:</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1787148695409-vZ28X-Soft.svg" alt="img" loading="eager">
                                    <p>Научитесь определять бизнес-потребности рынка, руководителя и топ-менеджмента</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1787148695409-vZ28X-Soft.svg" alt="img" loading="eager">
                                    <p>Поймёте, нужно ли вам доп. обучение и какое именно для дальнейшего профессионального
                                        развития</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1787148695409-vZ28X-Soft.svg" alt="img" loading="eager">
                                    <p>Какие конкретные роли есть сейчас на рынке/в компании, чтобы реализовать свою стратегию
                                    </p>
                                </li>
                            </ul>
                        </div>
                        <div class="global-learn-tale">
                            <p class="global-learn-tale-label">Шаг 5</p>
                            <p class="global-learn-tale-header">Упакуете свой опыт про новую карьерную стратегию</p>
                        </div>
                        <div class="global-learn-tale">
                            <p class="global-learn-tale-label">Шаг 6</p>
                            <p class="global-learn-tale-header">Найдёте не просто «новую работу»</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1787148695409-vZ28X-Soft.svg" alt="img" loading="eager">
                                    <p>А новый профессиональный уровень, который соответствует вашему опыту, ценностям
                                        и потенциалу</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-global-result', {
        label: 'Careerum goglobal result',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-global-result main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="global-result-top position-relative">
                        <div class="global-result-top-content position-relative z-10">
                            <h2>Результат</h2>
                            <p class="global-result-text">Cильная стратегия роста<br>на международном рынке</p>
                        </div>
                        <img src="https://cdn.careerum.com/1787205712695-C7XUh-Grou.png"
                            class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1787205554836-3P00e-Grou.png" class="hidden-desc-mobile position-absolute z-1" alt="img"
                            loading="lazy">
                        <img src="https://cdn.careerum.com/1787208839298-LiLzw-Grou.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                            loading="lazy">
                    </div>
                    <div class="global-result-list careerum-flex-sbfs">
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1787156637873-RtO7I-Soft.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1787156669830-cYmBb-Soft.svg" class="hidden-desc" alt="img"
                                    loading="eager">
                                <p>Карьерная стратегия роста на международном рынке</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1787156637873-RtO7I-Soft.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1787156669830-cYmBb-Soft.svg" class="hidden-desc" alt="img"
                                    loading="eager">
                                <p>Список ролей, на которые вы можете претендовать</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1787156637873-RtO7I-Soft.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1787156669830-cYmBb-Soft.svg" class="hidden-desc" alt="img"
                                    loading="eager">
                                <p>Продающее резюме</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1787156637873-RtO7I-Soft.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1787156669830-cYmBb-Soft.svg" class="hidden-desc" alt="img"
                                    loading="eager">
                                <p>Мощный Linkedin-профиль</p>
                            </li>
                        </ul>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1787156637873-RtO7I-Soft.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1787156669830-cYmBb-Soft.svg" class="hidden-desc" alt="img"
                                    loading="eager">
                                <p>Скрипты переговоров с менеджерами о повышении</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1787156637873-RtO7I-Soft.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1787156669830-cYmBb-Soft.svg" class="hidden-desc" alt="img"
                                    loading="eager">
                                <p>Сопроводительные письма</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1787156637873-RtO7I-Soft.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1787156669830-cYmBb-Soft.svg" class="hidden-desc" alt="img"
                                    loading="eager">
                                <p>Портфолио</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1787156637873-RtO7I-Soft.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="eager">
                                <img src="https://cdn.careerum.com/1787156669830-cYmBb-Soft.svg" class="hidden-desc" alt="img"
                                    loading="eager">
                                <p>Файл с перечнем всех ваших навыков, талантов и опыта</p>
                            </li>
                        </ul>
                    </div>
                    <a href="#" class="btn-color-main-red3 position-relative z-10">Заполнить анкету</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-global-reviews', {
        label: 'Careerum goglobal reviews',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-global-reviews main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Отзывы клиентов</h2>
                    <div class="global-reviews-slider">
                        <div class="global-reviews-item">
                            <img src="https://cdn.careerum.com/1787203005290-UyihS-Ð¡Ð½.png" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1787206026065-3iWFT-Ð¡Ð½.png" class="hidden-desc-mobile" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1787221364486-bJ58b-Fram.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                        </div>
                        <div class="global-reviews-item">
                            <img src="https://cdn.careerum.com/1787203005406-4MTQq-Ð¡Ð½.png" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1787206026181-FAoyw-Ð¡Ð½.png" class="hidden-desc-mobile" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1787221364617-r6bnH-Fram.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                        </div>
                        <div class="global-reviews-item">
                            <img src="https://cdn.careerum.com/1787203005442-vJZkf-Ð¡Ð½.png" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1787206026210-QpL4r-Ð¡Ð½.png" class="hidden-desc-mobile" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1787221364656-9ZnMe-Fram.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                        </div>
                        <div class="global-reviews-item">
                            <img src="https://cdn.careerum.com/1787203005474-0Po34-Ð¡Ð½.png" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1787206026242-xrJz4-Ð¡Ð½.png" class="hidden-desc-mobile" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1787221364696-3JTay-Fram.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                        </div>
                    </div>
                    <div class="careerum-flex-fec global-reviews-nav">
                        <div class="careerum-flex-cc global-reviews-nav-prev">
                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </div>
                        <div class="careerum-flex-cc global-reviews-nav-next">
                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-globalmk-main', {
        label: 'Careerum globalmk main',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-globalmk-main main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="globalmk-main-wrapper careerum-flex-sbfs">
                        <div class="globalmk-main-left position-relative z-10">
                            <div class="globalmk-main-labels careerum-flex-fsfs">
                                <div class="globalmk-main-label">
                                    <p>Лекция Ольги Лермонтовой</p>
                                </div>
                                <div class="globalmk-main-label red">
                                    <p>Начало: 17:00 мск</p>
                                </div>
                            </div>
                            <h1>Go Global 2027</h1>
                            <p class="globalmk-main-description">Скрытые правила и главные ошибки международной карьеры</p>
                        </div>
                        <div class="globalmk-main-right position-relative z-1">
                            <img src="https://cdn.careerum.com/1787687003305-ed0We-Fram.png"
                                class="hidden-tablet-mobile position-absolute" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1787687004601-at7nh-Fram.png"
                                class="hidden-desc-mobile position-absolute" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1787687005903-Fy0Aj-Fram.png" class="hidden-desc-tablet"
                                alt="img" loading="lazy">
                        </div>
                    </div>
                    <a href="#form" class="btn-color-main-red3 position-relative z-10">Зарегистрироваться</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-globalmk-who', {
        label: 'Careerum globalmk who',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-globalmk-who main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Для кого эта лекция:</h2>
                    <div class="globalmk-who-items">
                        <div class="globalmk-who-item">
                            <p class="globalmk-who-item-title hidden-tablet-mobile">Вы только задумались о международной карьере
                            </p>
                            <div class="globalmk-who-item-content careerum-flex-sbst position-relative">
                                <div class="globalmk-who-item-left">
                                    <p class="globalmk-who-item-title hidden-desc-mobile">Вы только задумались о международной
                                        карьере</p>
                                    <img src="https://cdn.careerum.com/1787687119895-roYs5-Fram.png"
                                        class="hidden-tablet-mobile" alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1787693214707-VdGej-Fram.png" class="hidden-desc-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1787726171243-aqoJ1-Fram.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                                    <p class="globalmk-who-item-title hidden-desc-tablet">Вы только задумались о международной
                                        карьере</p>
                                    <ul>
                                        <li>Пока не понимаете, с чего начать путь</li>
                                        <li>Боитесь, что вас там никто не ждёт и придётся потерять в роли и деньгах</li>
                                        <li>Не уверены в своих шансах и силах</li>
                                        <li>Сравниваете страны для переезда</li>
                                    </ul>
                                </div>
                                <div class="globalmk-who-item-right position-relative">
                                    <div class="globalmk-who-item-right-top careerum-flex-fsfs position-relative z-1">
                                        <div class="globalmk-who-item-photo">
                                            <img src="https://cdn.careerum.com/1787687119733-jQmEK-Fram.png"
                                                class="hidden-tablet-mobile" alt="img" loading="lazy">
                                            <img src="https://cdn.careerum.com/1787693214482-khL8E-Fram.png"
                                                class="hidden-desc-mobile" alt="img" loading="lazy">
                                            <img src="https://cdn.careerum.com/1787726171079-rp9qt-Fram.png" class="hidden-desc-tablet" alt="img"
                                                loading="lazy">
                                        </div>
                                        <div class="globalmk-who-item-about">
                                            <p class="globalmk-who-item-name">Александра Пинчукова</p>
                                            <p class="globalmk-who-item-position">Менеджер бизнес-процессов, Германия</p>
                                        </div>
                                    </div>
                                    <div class="globalmk-who-item-right-bottom position-relative z-1">
                                        <div class="globalmk-who-item-before-wrapper">
                                            <p class="globalmk-who-item-before">До:</p>
                                            <ul class="globalmk-who-item-before-list">
                                                <li>Работала главным бухгалтером в РФ</li>
                                                <li>Хотела найти работу в Германии и переехать</li>
                                            </ul>
                                        </div>
                                        <div class="globalmk-who-item-separator"></div>
                                        <div class="globalmk-who-item-after-wrapper">
                                            <p class="globalmk-who-item-after">Результат с Careerum:</p>
                                            <ul class="globalmk-who-item-after-list">
                                                <li>Оффер в штаб-квартиру Puma</li>
                                                <li>Релокация в Германию</li>
                                                <li>3 месяца поиска</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="globalmk-who-item-label position-absolute z-10">
                                        <p>200+ похожих кейсов в Careerum</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="globalmk-who-item">
                            <p class="globalmk-who-item-title hidden-tablet-mobile">Вроде переехали, но только «физически» — карьерно
                                вы всё ещё на старом рынке</p>
                            <div class="globalmk-who-item-content careerum-flex-sbst position-relative">
                                <div class="globalmk-who-item-left">
                                    <p class="globalmk-who-item-title hidden-desc-mobile">Вроде переехали, но только «физически» — карьерно
                                        вы всё ещё на старом рынке</p>
                                    <img src="https://cdn.careerum.com/1787687119929-xwatE-Fram.png"
                                        class="hidden-tablet-mobile" alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1787693214751-z25ME-Fram.png" class="hidden-desc-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1787726171277-gRaUF-Fram.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                                    <p class="globalmk-who-item-title hidden-desc-tablet">Вроде переехали, но только «физически» — карьерно
                                        вы всё ещё на старом рынке</p>
                                    <ul>
                                        <li>Уехали из РФ/СНГ во «временную страну», но хотите переехать в целевую</li>
                                        <li>Живёте за границей, но всё ещё работаете на российский рынок, а хотите
                                            на местный/глобальный</li>
                                        <li>Все связи и контакты остались дома</li>
                                        <li>Не понимаете, как сделать следующий карьерный шаг</li>
                                    </ul>
                                </div>
                                <div class="globalmk-who-item-right position-relative">
                                    <div class="globalmk-who-item-right-top careerum-flex-fsfs  position-relative z-1">
                                        <div class="globalmk-who-item-photo">
                                            <img src="https://cdn.careerum.com/1787687119826-GXNxX-Fram.png"
                                                class="hidden-tablet-mobile" alt="img" loading="lazy">
                                            <img src="https://cdn.careerum.com/1787693214618-g7NrP-Fram.png"
                                                class="hidden-desc-mobile" alt="img" loading="lazy">
                                            <img src="https://cdn.careerum.com/1787726171185-zKjMN-Fram.png" class="hidden-desc-tablet" alt="img"
                                                loading="lazy">
                                        </div>
                                        <div class="globalmk-who-item-about">
                                            <p class="globalmk-who-item-name">Полина Осташева</p>
                                            <p class="globalmk-who-item-position">Product Manager, Болгария</p>
                                        </div>
                                    </div>
                                    <div class="globalmk-who-item-right-bottom  position-relative z-1">
                                        <div class="globalmk-who-item-before-wrapper">
                                            <p class="globalmk-who-item-before">До:</p>
                                            <ul class="globalmk-who-item-before-list">
                                                <li>6 лет в IT после перехода из ивентов</li>
                                                <li>Опыт в Яндексе, Магните, МТС</li>
                                                <li>Переезд в Болгарию</li>
                                                <li>Удалённая работа на российский рынок</li>
                                                <li>Поиск работы в новой стране</li>
                                            </ul>
                                        </div>
                                        <div class="globalmk-who-item-separator"></div>
                                        <div class="globalmk-who-item-after-wrapper">
                                            <p class="globalmk-who-item-after">Результат с Careerum:</p>
                                            <ul class="globalmk-who-item-after-list">
                                                <li>Оффер Product Manager в Софии за два месяца</li>
                                                <li>Международная компания с HQ в Лондоне</li>
                                                <li>Выбор компании по ценностям, а не только по зарплате</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="globalmk-who-item-label position-absolute z-10">
                                        <p>350+ похожих кейсов в Careerum</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="globalmk-who-item">
                            <p class="globalmk-who-item-title">Уже работаете в стране, куда хотелось переехать, но не растёте
                                дальше</p>
                            <div class="globalmk-who-item-content careerum-flex-sbst position-relative">
                                <div class="globalmk-who-item-left">
                                    <img src="https://cdn.careerum.com/1787687119966-51ubE-Fram.png"
                                        class="hidden-tablet-mobile" alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1787693214786-4NqqB-Fram.png" class="hidden-desc-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1787726171310-2VnEh-Fram.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                                    <ul>
                                        <li>Чувствуете себя «недо» по сравнению с местными сотрудниками</li>
                                        <li>Испытываете трудности в коммуникации и переговорах</li>
                                        <li>Готовы расти, но вас не повышают</li>
                                    </ul>
                                </div>
                                <div class="globalmk-who-item-right position-relative">
                                    <div class="globalmk-who-item-right-top careerum-flex-fsfs position-relative z-1">
                                        <div class="globalmk-who-item-photo">
                                            <img src="https://cdn.careerum.com/1787687119862-Cul43-Fram.png"
                                                class="hidden-tablet-mobile" alt="img" loading="lazy">
                                            <img src="https://cdn.careerum.com/1787693214662-Z7yDg-Fram.png"
                                                class="hidden-desc-mobile" alt="img" loading="lazy">
                                            <img src="https://cdn.careerum.com/1787726171214-inwPW-Fram.png" class="hidden-desc-tablet" alt="img"
                                                loading="lazy">
                                        </div>
                                        <div class="globalmk-who-item-about">
                                            <p class="globalmk-who-item-name">Олександр Балєв</p>
                                            <p class="globalmk-who-item-position">Engineering Manager, Германия</p>
                                        </div>
                                    </div>
                                    <div class="globalmk-who-item-right-bottom position-relative z-1">
                                        <div class="globalmk-who-item-before-wrapper">
                                            <p class="globalmk-who-item-before">До:</p>
                                            <ul class="globalmk-who-item-before-list">
                                                <li>3 года в IT и 5 лет руководства командами</li>
                                                <li>Совмещал родительский отпуск с поиском новой работы</li>
                                                <li>Легко проходил первые этапы интервью, но получал отказы в финале</li>
                                                <li>Испытывал трудности с коммуникацией и самопрезентацией на интервью</li>
                                            </ul>
                                        </div>
                                        <div class="globalmk-who-item-separator"></div>
                                        <div class="globalmk-who-item-after-wrapper">
                                            <p class="globalmk-who-item-after">Результат с Careerum:</p>
                                            <ul class="globalmk-who-item-after-list">
                                                <li>Убедительные и структурированные ответы на интервью</li>
                                                <li>Блестяще прошёл лидерское собеседование</li>
                                                <li>Почувствовал уверенность в себе</li>
                                                <li>Получил оффер на 30% выше предыдущего после месяца в клубе</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="globalmk-who-item-label position-absolute z-10">
                                        <p>150+ похожих кейсов в Careerum</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-globalmk-program', {
        label: 'Careerum globalmk program',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-globalmk-program main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Программа лекции:</h2>
                    <div class="globalmk-program-top">
                        <div class="globalmk-program-row careerum-flex-cst">
                            <div class="globalmk-program-top-img careerum-flex-cc">
                                <img src="https://cdn.careerum.com/1787690713171-JmWc0-Glob.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1787693342517-Jli5V-Glob.svg" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1787726953690-hjWLL-Glob.svg" class="hidden-desc-tablet" alt="img" loading="lazy">
                            </div>
                            <div class="globalmk-program-top-text blue">
                                <p>Международный рынок </p>
                            </div>
                        </div>
                        <div class="globalmk-program-row careerum-flex-cst">
                            <div class="globalmk-program-top-text white">
                                <p class="italic">Найм</p>
                            </div>
                            <div class="globalmk-program-top-text">
                                <p class="italic">2027</p>
                            </div>
                            <div class="globalmk-program-top-text blue">
                                <p>Ошибки</p>
                            </div>
                            <div class="globalmk-program-top-img careerum-flex-cc">
                                <img src="https://cdn.careerum.com/1787690713084-Lvgik-Suit.svg" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1787693342443-82YZX-Suit.svg" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1787726953616-ioylR-Suit.svg" class="hidden-desc-tablet" alt="img" loading="lazy">
                            </div>
                        </div>
                    </div>
                    <div class="globalmk-program-tales careerum-flex-sbst">
                        <div class="globalmk-program-tale">
                            <div class="globalmk-program-tale-label careerum-flex-fsfs">
                                <p>Блок 1</p>
                                <p>Тренды</p>
                            </div>
                            <p class="globalmk-program-tale-title">международный рынок труда 2027</p>
                            <p class="globalmk-program-tale-text">Скрытые правила: как устроен рынок на самом деле, какие тренды
                                в найме существуют, как эффективнее всего развивать глобальную карьеру сейчас</p>
                        </div>
                        <div class="globalmk-program-tale">
                            <div class="globalmk-program-tale-label careerum-flex-fsfs">
                                <p>Блок 2</p>
                                <p>Разборы</p>
                            </div>
                            <p class="globalmk-program-tale-title">5 ошибок международной карьеры</p>
                            <p class="globalmk-program-tale-text">Покажу 5 классических ошибок для каждой стадии глобальной
                                карьеры. Дам первые шаги, чтобы их исправить</p>
                        </div>
                        <div class="globalmk-program-tale">
                            <div class="globalmk-program-tale-label careerum-flex-fsfs">
                                <p>Блок 3</p>
                                <p>Инструменты</p>
                            </div>
                            <p class="globalmk-program-tale-title">Методология Go Global</p>
                            <p class="globalmk-program-tale-text">Покажу пошаговую методологию Careerum — как мы помогаем
                                клиентам построить международную карьеру</p>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-globalmk-form', {
        label: 'Careerum globalmk form',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-globalmk-form main-wrapper">
                <div class="careerum-container-responsive careerum-flex-sbfs position-relative">
                    <div class="globalmk-form-left position-relative z-10">
                        <div class="globalmk-form-labels careerum-flex-fsfs">
                            <div class="globalmk-form-label">
                                <p>Лекция Ольги Лермонтовой</p>
                            </div>
                            <div class="globalmk-form-label red">
                                <p>Начало: 17:00 мск</p>
                            </div>
                        </div>
                        <h2>Go Global 2027</h2>
                        <p class="globalmk-form-description">Скрытые правила и главные ошибки международной карьеры</p>
                    </div>
                    <div class="globalmk-form-right position-relative z-10">
                        <div class="careerum-registration-form-club40">
                            <form class="deva-form getcourse-email-signup addCountry" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-telegram">
                                    <input type="text" name="telegram" value="" required placeholder="Telegram">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я даю согласие
                                        на обработку персональных данных
                                        в соответствии с <a href="/ru-ru/legal/privacy">Политикой
                                            конфиденциальности</a>
                                    </p>
                                </div>
                                <a href="#" class="submit-btn btn-color-main-red button-sent" disabled>Зарегистрироваться</a>
                            </form>
                        </div>
                    </div>
                    <img src="https://cdn.careerum.com/1787691215061-wInxR-Chat.png"
                        class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                    <img src="https://cdn.careerum.com/1787693428105-2LMEs-Chat.png"
                        class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                    <img src="https://cdn.careerum.com/1787727473437-ji2Pd-Chat.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                        loading="lazy">
                </div>
            </div>`
    });
    
    blockManager.add('careerum-globalmk-author', {
        label: 'Careerum globalmk author',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-globalmk-author main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Почему мне можно доверять в вопросах международной карьеры?</h2>
                    <div class="globalmk-author-content careerum-flex-sbfs">
                        <div class="globalmk-author-left">
                            <img src="https://cdn.careerum.com/1787691922539-xCou1-Fram.png" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1787693381885-ljPc9-Fram.png" class="hidden-desc-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1787727599930-jz03H-Fram.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                        </div>
                        <div class="globalmk-author-right">
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1787691875554-SSwCu-Soft.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1787691877303-WlOFQ-Soft.svg" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                    <p>За 15+ лет в маркетинге и продажах я прошла Microsoft, Google, Adobe, Travelport</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1787691875554-SSwCu-Soft.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1787691877303-WlOFQ-Soft.svg" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                    <p>Работала на 25+ рынках Европы и Африки</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1787691875554-SSwCu-Soft.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1787691877303-WlOFQ-Soft.svg" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                    <p>Получила MBA в INSEAD, топ-3 бизнес-школ мира</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1787691875554-SSwCu-Soft.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1787691877303-WlOFQ-Soft.svg" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                    <p>Прямо сейчас исследую карьерные переходы в Harvard Extension School</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://cdn.careerum.com/1787691875554-SSwCu-Soft.svg" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1787691877303-WlOFQ-Soft.svg" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                    <p>В 2019 я основала Careerum — и с тех пор помогла построить карьеру 14 000 людям
                                        из 61 страны</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="globalmk-author-quote careerum-flex-fsfs">
                        <img src="https://cdn.careerum.com/1787692236886-yKYI4-qweq.svg" class="hidden-tablet-mobile" alt="img"
                            loading="lazy">
                        <img src="https://cdn.careerum.com/1787693409250-T8YEj-asda.svg" class="hidden-desc-mobile" alt="img"
                            loading="lazy">
                        <img src="https://cdn.careerum.com/1787727727632-1ENim-asda.svg" class="hidden-desc-tablet" alt="img" loading="lazy">
                        <p>Я вижу одни и те же ошибки на международном рынке снова и снова — и <span>знаю, как их обойти,</span>
                            потому что сама их совершала. И знаю решения</p>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-globalmk-reviews', {
        label: 'Careerum globalmk reviews',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-globalmk-reviews main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Отзывы о моих лекциях:</h2>
                    <div class="globalmk-reviews-slider">
                        <div class="globalmk-reviews-item">
                            <img src="https://cdn.careerum.com/1787692985452-eOoyL-Fram.png" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1787692705331-N607S-Fram.png" class="hidden-desc-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1787727938302-ATTuu-Fram.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                        </div>
                        <div class="globalmk-reviews-item">
                            <img src="https://cdn.careerum.com/1787692985590-z78HE-Fram.png" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1787692705425-Eddmv-Fram.png" class="hidden-desc-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1787727938383-gUTGZ-Fram.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                        </div>
                        <div class="globalmk-reviews-item">
                            <img src="https://cdn.careerum.com/1787692985638-eZurn-Fram.png" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1787692705482-8IyIX-Fram.png" class="hidden-desc-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1787727938416-cdPGz-Fram.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                        </div>
                        <div class="globalmk-reviews-item">
                            <img src="https://cdn.careerum.com/1787692985687-nW6vg-Fram.png" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1787692705555-mZtRa-Fram.png" class="hidden-desc-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1787727938458-MbUJY-Fram.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                        </div>
                        <div class="globalmk-reviews-item">
                            <img src="https://cdn.careerum.com/1787692985736-R5Opd-Fram.png" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1787692705610-XgJuU-Fram.png" class="hidden-desc-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1787727938498-8exWz-Fram.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                        </div>
                        <div class="globalmk-reviews-item">
                            <img src="https://cdn.careerum.com/1787692985784-qF2Bm-Fram.png" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1787692705657-LpItM-Fram.png" class="hidden-desc-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1787727938535-X8DB3-Fram.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-media-kit-nav', {
        label: 'Careerum MeidaKit nav',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-media-kit-nav" aria-label="Разделы">
                <div class="careerum-media-kit-wrap">
                <a class="media-kit-nav__name" href="#top">Ольга Лермонтова</a>
                <div class="media-kit-nav__links">
                    <a href="#topics">Темы</a>
                    <a href="#media">Эфиры</a>
                    <a href="#value">Для вас</a>
                    <a href="#bio">Биография</a>
                    <a href="#photos">Фото</a>
                </div>
                <a class="media-kit-btn btn--primary" href="#contact">Пригласить</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-media-kit-hero', {
        label: 'Careerum MeidaKit hero',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-media-kit-hero">
                <div class="careerum-media-kit-wrap media-kit-hero__inner">
                <div>
                    <p class="media-kit-hero__kicker">Медиа-кит спикера для подкастов, СМИ и PR-агентств</p>
                    <h1 class="media-kit-hero__name"><span>Ольга</span><span>Лермонтова</span></h1>
                    <p class="media-kit-hero__role">Мост между наукой и практикой карьеры. 14&nbsp;000 клиентских кейсов из 61
                    страны и академическая рамка психологии. Говорит о карьере не мотивационно, а механистически.</p>
                    <p class="media-kit-hero__creds">Основательница Careerum. 15 лет в Microsoft, Google, Adobe и Travelport. MBA
                    INSEAD, ICF, ALM candidate по психологии в Harvard Extension School. Автор бестселлера «Работа по любви».</p>
                    <div class="media-kit-hero__actions">
                    <a class="media-kit-btn btn--primary" href="#contact">Пригласить в эфир</a>
                    <a class="media-kit-btn btn--outline" href="#topics">Темы для выпуска</a>
                    </div>
                </div>
                <div class="media-kit-hero__photo">
                    <img src="https://cdn.careerum.com/1790759545516-dP9eR-ÐÐµ.jpg"
                    alt="Ольга Лермонтова в тёмно-синем пиджаке и голубой рубашке">
                </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-media-kit-audience', {
        label: 'Careerum MeidaKit audience',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-media-kit-audience" aria-labelledby="media-kit-aud-title">
                <div class="careerum-media-kit-wrap">
                <h2 id="media-kit-aud-title" class="media-kit-sec__title" style="font-size:1.25rem;margin-bottom:1rem">Аудитория
                </h2>
                <div class="media-kit-aud">
                    <div class="media-kit-aud__card media-kit-aud__card--accent">
                    <span class="media-kit-aud__num">2 млн+</span>
                    <span class="media-kit-aud__label">Охват в месяц</span>
                    <span class="media-kit-aud__meta">по всем площадкам</span>
                    </div>
                    <a class="media-kit-aud__card" href="https://www.instagram.com/lermontova.career/" target="_blank"
                    rel="noopener">
                    <span class="media-kit-aud__num">268&nbsp;000 <small>подписчиков</small></span>
                    <span class="media-kit-aud__label">Instagram</span>
                    <span class="media-kit-aud__meta">@lermontova.career</span>
                    </a>
                    <a class="media-kit-aud__card" href="https://www.youtube.com/@Careerum" target="_blank" rel="noopener">
                    <span class="media-kit-aud__num">49&nbsp;000 <small>подписчиков</small></span>
                    <span class="media-kit-aud__label">YouTube</span>
                    <span class="media-kit-aud__meta">Careerum</span>
                    </a>
                    <a class="media-kit-aud__card" href="https://t.me/dreamcatchme" target="_blank" rel="noopener">
                    <span class="media-kit-aud__num">26&nbsp;000 <small>подписчиков</small></span>
                    <span class="media-kit-aud__label">Telegram</span>
                    <span class="media-kit-aud__meta">«Нагуглила карьеру»</span>
                    </a>
                </div>
                <div class="media-kit-portrait">
                    <h2>Кто эти люди</h2>
                    <div>
                    <p class="media-kit-portrait__who">Женщины 30–55 лет: senior-специалисты, руководители, фаундеры, HR и
                        консультантки.</p>
                    <p class="media-kit-portrait__geo">Европа (Франция, Германия, Польша, Кипр, Великобритания, Италия и другие),
                        США, Канада, ОАЭ, Россия и страны СНГ.</p>
                    </div>
                </div>
                <div class="media-kit-press-row" aria-label="Где выходили материалы">
                    <span>Публикации и эфиры</span>
                    <b>Forbes Woman</b>
                    <b>РБК Тренды</b>
                    <b>Сноб</b>
                    <b>Marie Claire</b>
                    <b>Т—Ж</b>
                    <b>Лайфхакер</b>
                    <b>vc.ru</b>
                    <b>Forbes Education</b>
                </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-media-kit-topics', {
        label: 'Careerum MeidaKit topics',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-media-kit-block careerum-media-kit-topics">
                <div class="careerum-media-kit-wrap careerum-media-kit-sec">
                <div>
                    <h2 class="media-kit-sec__title">Темы для выпуска</h2>
                    <p class="media-kit-sec__note">Разговор на 60–90 минут по любой из тем.</p>
                </div>
                <div>
                    <ul class="media-kit-tgrid">
                    <li><span class="media-kit-tag">Идентичность</span>
                        <h3>Почему нельзя «выбрать» карьеру, сидя в кресле</h3>
                        <p>Новая идентичность собирается только через пробы, а не через тесты и списки ценностей.</p>
                    </li>
                    <li><span class="media-kit-tag">Карьера после 40</span>
                        <h3>Загадка двух женщин</h3>
                        <p>Почему одинаковый опыт даёт разный результат после 40 и почему дело в среде, а не в возрасте.</p>
                    </li>
                    <li><span class="media-kit-tag">Данные WEF и ILO</span>
                        <h3>Карьеру больше нельзя построить один раз</h3>
                        <p>Цикличность карьеры и роль ИИ — аналитически, без алармизма.</p>
                    </li>
                    <li><span class="media-kit-tag">Без увольнения</span>
                        <h3>Реставрация вместо революции</h3>
                        <p>Как вернуть авторство над карьерой, не уходя с работы.</p>
                    </li>
                    <li><span class="media-kit-tag">Личная история</span>
                        <h3>Семь карьерных поворотов</h3>
                        <p>От репетитора до CEO международной платформы, и зачем успешный CEO в 40+ вернулся учиться.</p>
                    </li>
                    <li><span class="media-kit-tag">Метаанализ 90 исследований</span>
                        <h3>Карьерная субъектность — измеримый конструкт</h3>
                        <p>Схема «Понять → Выбрать → Действовать» и что говорит наука.</p>
                    </li>
                    </ul>
                </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-media-kit-media', {
        label: 'Careerum MeidaKit media',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-media-kit-block careerum-media-kit-media">
                <div class="careerum-media-kit-wrap careerum-media-kit-sec">
                <div>
                    <h2 class="media-kit-sec__title">Где Ольгу уже слышали</h2>
                    <p class="media-kit-sec__note">12 подкастов и 11 статей. Нажмите на категорию, чтобы раскрыть список.</p>
                </div>
                <div>
                    <div class="media-kit-hits">
                    <a class="media-kit-hit" href="https://www.youtube.com/watch?v=vqGmRpV-tAw" target="_blank" rel="noopener">
                        <span class="media-kit-hit__num">340 тыс. <small>просмотров</small></span><span class="media-kit-hit__show">Подкаст
                        Соколовского</span>
                        <span class="media-kit-hit__title">«Как быть востребованным в эпоху ИИ»</span>
                    </a>
                    <a class="media-kit-hit" href="https://www.youtube.com/watch?v=lDTjKRWoWTE" target="_blank" rel="noopener">
                        <span class="media-kit-hit__num">102 тыс. <small>просмотров</small></span><span class="media-kit-hit__show">Роман
                        Тарасенко</span>
                        <span class="media-kit-hit__title">«Работа по любви. Миф или реальность?»</span>
                    </a>
                    <a class="media-kit-hit" href="https://www.youtube.com/watch?v=7D8VXRjhRD8" target="_blank" rel="noopener">
                        <span class="media-kit-hit__num">Поединок</span><span class="media-kit-hit__show">Игорь Манн</span>
                        <span class="media-kit-hit__title">Существует ли карьера по любви?</span>
                    </a>
                    </div>
                    <div class="media-kit-cats">
                    <details class="media-kit-cat" open>
                        <summary>
                        <h3>Подкасты<span class="media-kit-count">12</span></h3><span class="media-kit-toggle"
                            aria-hidden="true"></span>
                        </summary>
                        <ul class="media-kit-items">
                        <li><span class="media-kit-kind">Forbes Education</span>
                            <div><a
                                href="https://stroki.mts.ru/podcast/episode/komu-ya-nuzhen-kakiye-navyki-trebuyutsya-dlya-karery-mechty-i-kak-ikh-razvivat-282331"
                                target="_blank" rel="noopener">«Кому я нужен? Какие навыки требуются для карьеры мечты и как их
                                развивать»</a></div>
                        </li>
                        <li><span class="media-kit-kind">План Б, Т—Ж</span>
                            <div><a href="https://zvuk.com/episode/119566806" target="_blank" rel="noopener">Как провести ревизию
                                своих навыков и конвертировать их на международную аудиторию</a></div>
                        </li>
                        <li><span class="media-kit-kind">Поиск работы в IT и переезд в США</span>
                            <div><a
                                href="https://podcasts.apple.com/us/podcast/%D0%BF%D0%BE%D0%B8%D1%81%D0%BA-%D1%80%D0%B0%D0%B1%D0%BE%D1%82%D1%8B-%D0%B2-it-%D0%B8-%D0%BF%D0%B5%D1%80%D0%B5%D0%B5%D0%B7%D0%B4-%D0%B2-%D1%81%D1%88%D0%B0/id1501864022"
                                target="_blank" rel="noopener">«Как находят работу те, кто находит, в 2026 году»</a>
                            <p>Ведущая Анна Наумова</p>
                            </div>
                        </li>
                        <li><span class="media-kit-kind">Это непросто, «Либо/Либо»</span>
                            <div><span class="plain">Как сейчас искать работу за границей</span></div>
                        </li>
                        </ul>
                        <details class="media-kit-more" style="padding:0 1.5rem 1.2rem">
                        <summary>Ещё 5 выпусков</summary>
                        <ul class="media-kit-items">
                            <li><span class="media-kit-kind">Несладкий бизнес</span>
                            <div><a href="https://notsweetbusiness.mave.digital/ep-104" target="_blank" rel="noopener">«Как найти
                                работу за рубежом?»</a>
                                <p>Ведущие Цыплухина и Береснева</p>
                            </div>
                            </li>
                            <li><span class="media-kit-kind">Не учи меня жить</span>
                            <div><span class="plain">Как строить карьеру по своим правилам, с опорой на метанавыки и
                                ценности</span>
                                <p>Ведущая Алена Борьессон</p>
                            </div>
                            </li>
                            <li><span class="media-kit-kind">Дороже денег</span>
                            <div><a href="https://dorogedeneg.mave.digital/ep-5" target="_blank" rel="noopener">«Как найти работу
                                по душе и достичь успеха в карьере?»</a>
                                <p>Ведущая Ксения Падерина</p>
                            </div>
                            </li>
                            <li><span class="media-kit-kind">Вог не смог</span>
                            <div><a href="https://open.spotify.com/episode/7dQ6jsPFP4I30CGOIoVvcR" target="_blank"
                                rel="noopener">«Из тётки в женщину»: что сначала — худеть или переодеваться?</a>
                                <p>Лайфстайл</p>
                            </div>
                            </li>
                            <li><span class="media-kit-kind">Дом, в котором</span>
                            <div><a href="https://open.spotify.com/episode/0WQA5GjyvZlTWI1vpw3Dsn" target="_blank"
                                rel="noopener">Покупка и ремонт дома в Италии</a>
                                <p>Лайфстайл</p>
                            </div>
                            </li>
                        </ul>
                        </details>
                    </details>
                    <details class="media-kit-cat">
                        <summary>
                        <h3>Статьи и колонки<span class="media-kit-count">11</span></h3><span class="media-kit-toggle"
                            aria-hidden="true"></span>
                        </summary>
                        <ul class="media-kit-items">
                        <li><span class="media-kit-kind">Forbes Woman</span>
                            <div><a
                                href="https://www.forbes.ru/forbes-woman/567667-horosaa-bor-ba-pocemu-zensinam-vazno-ucit-sa-zdorovoj-konkurencii-i-rabote-v-komande"
                                target="_blank" rel="noopener">«Здоровая конкуренция: как женщинам совмещать амбиции и командную
                                работу»</a></div>
                        </li>
                        <li><span class="media-kit-kind">РБК Тренды</span>
                            <div><a href="https://trends.rbc.ru/trends/education/634d656e9a7947cbc0844bea" target="_blank"
                                rel="noopener">Как строить карьеру в VUCA-мире</a></div>
                        </li>
                        <li><span class="media-kit-kind">РБК Тренды</span>
                            <div><a href="https://trends.rbc.ru/trends/innovation/669526ef9a7947258b4a6fd1" target="_blank"
                                rel="noopener">Эволюция бизнеса: чем плохи красные и хороши бирюзовые компании</a></div>
                        </li>
                        <li><span class="media-kit-kind">Сноб</span>
                            <div><a href="https://snob.ru/news/187473/" target="_blank" rel="noopener">5 внутренних установок,
                                которые препятствуют карьерному росту</a></div>
                        </li>
                        </ul>
                        <details class="media-kit-more" style="padding:0 1.5rem 1.2rem">
                        <summary>Ещё 7 статей</summary>
                        <ul class="media-kit-items">
                            <li><span class="media-kit-kind">Сноб</span>
                            <div><a href="https://snob.ru/news/206890/" target="_blank" rel="noopener">Как обсуждать зарплату на
                                собеседовании и не стесняться говорить о деньгах</a></div>
                            </li>
                            <li><span class="media-kit-kind">Т-Бизнес</span>
                            <div><a href="https://secrets.tbank.ru/lichnyj-opyt/olga-lermontova-biznes-ne-lekarstvo-ot-problem-2/"
                                target="_blank" rel="noopener">«Бизнес — это не лекарство от всех проблем»</a></div>
                            </li>
                            <li><span class="media-kit-kind">Marie Claire</span>
                            <div><a
                                href="https://www.marieclaire.ru/karera/poshagovyi-plan-kak-postroit-uspeshnuyu-kareru-bystro/"
                                target="_blank" rel="noopener">Пошаговый план: как построить успешную карьеру быстро</a></div>
                            </li>
                            <li><span class="media-kit-kind">Лайфхакер</span>
                            <div><a href="https://lifehacker.ru/gendernoe-neravenstvo-na-rabote/" target="_blank" rel="noopener">О
                                гендерных стереотипах и неравенстве на работе</a></div>
                            </li>
                            <li><span class="media-kit-kind">vc.ru</span>
                            <div><a href="https://vc.ru/flood/26329-foreign-work" target="_blank" rel="noopener">Насыщенность
                                рынка и медленный карьерный рост: к чему готовиться при переезде на работу в Европу</a></div>
                            </li>
                            <li><span class="media-kit-kind">vc.ru</span>
                            <div><a
                                href="https://vc.ru/hr/223684-dotyanutsya-do-microsoft-kak-poluchit-offer-v-top-kompaniyu-rekomendacii-karernogo-koucha-olgi-lermontovoi"
                                target="_blank" rel="noopener">«Дотянуться до Microsoft. Как получить оффер в топ-компанию»</a>
                            </div>
                            </li>
                            <li><span class="media-kit-kind">vc.ru</span>
                            <div><a href="https://vc.ru/promo/373022-rynok-truda-v-krizise-a-kak-v-nem-iskat-svoyu-pervuyu-rabotu"
                                target="_blank" rel="noopener">«Рынок труда в кризисе. А как в нём искать свою первую работу?»</a>
                            </div>
                            </li>
                        </ul>
                        </details>
                    </details>
                    <details class="media-kit-cat">
                        <summary>
                        <h3>Свои проекты<span class="media-kit-count">3</span></h3><span class="media-kit-toggle"
                            aria-hidden="true"></span>
                        </summary>
                        <ul class="media-kit-items">
                        <li><span class="media-kit-kind">Подкаст, ведущая</span>
                            <div><a
                                href="https://podcasts.apple.com/us/podcast/%D0%BD%D0%B0-%D1%81%D0%B2%D0%BE%D0%B5%D0%BC-%D0%BC%D0%B5%D1%81%D1%82%D0%B5/id1701617043"
                                target="_blank" rel="noopener">«На своём месте»</a>
                            <p>Лучший брендовый подкаст 2024 года по версии Яндекс Музыки</p>
                            </div>
                        </li>
                        <li><span class="media-kit-kind">Подкаст, ведущая</span>
                            <div><a
                                href="https://podcasts.apple.com/us/podcast/%D0%BC%D1%8B-%D0%B2%D0%B0%D0%BC-%D0%BF%D0%B5%D1%80%D0%B5%D0%B7%D0%B2%D0%BE%D0%BD%D0%B8%D0%BC/id1576372228"
                                target="_blank" rel="noopener">«Мы вам перезвоним»</a></div>
                        </li>
                        <li><span class="media-kit-kind">Книга, МИФ</span>
                            <div><a
                                href="https://litres.com/book/olga-lermontova-3161/rabota-po-lubvi-kak-postroit-uspeshnuu-kareru-i-prevr-66654646/"
                                target="_blank" rel="noopener">«Работа по любви»</a>
                            <p>Бестселлер издательства МИФ</p>
                            </div>
                        </li>
                        </ul>
                    </details>
                    </div>
                </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-media-kit-value', {
        label: 'Careerum MeidaKit value',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-media-kit-block careerum-media-kit-value">
                <div class="careerum-media-kit-wrap careerum-media-kit-sec">
                <div class="media-kit-sec__side">
                    <h2 class="media-kit-sec__title">Что вы получаете</h2>
                    <p class="media-kit-sec__note">Для подкаста, издания, конференции или бренда.</p>
                    <img src="https://cdn.careerum.com/1790759653313-hVenm-ÐÐµ.jpg"
                    alt="Ольга Лермонтова у микрофона на записи подкаста" loading="lazy">
                </div>
                <ul class="media-kit-value">
                    <li>
                    <h3>Опытная ведущая по ту сторону микрофона</h3>
                    <p>Два собственных подкаста, один из них — лучший брендовый подкаст 2024 года по версии Яндекс Музыки.</p>
                    </li>
                    <li>
                    <h3>Разговор на 60–90 минут</h3>
                    <p>Глубоко по любой из тем, с цифрами, исследованиями и живыми кейсами.</p>
                    </li>
                    <li>
                    <h3>Освещение в соцсетях</h3>
                    <p>Аудитория Ольги — 340&nbsp;000+ подписчиков и 2 млн+ охвата в месяц.</p>
                    </li>
                    <li>
                    <h3>Бонус для аудитории</h3>
                    <p>Полезный материал или специальное предложение от Careerum. Формат согласуем с командой заранее.</p>
                    </li>
                    <li>
                    <h3>Проверенный интерес аудитории</h3>
                    <p>340 тыс. просмотров у выпуска с Соколовским и 102 тыс. у выпуска с Тарасенко.</p>
                    </li>
                    <li>
                    <h3>Материалы для анонса</h3>
                    <p>Фото, биография и подводка на этой странице, готовые к копированию.</p>
                    </li>
                </ul>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-media-kit-bio', {
        label: 'Careerum MeidaKit bio',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-media-kit-block careerum-media-kit-bio">
                <div class="careerum-media-kit-wrap careerum-media-kit-sec">
                <div>
                    <h2 class="media-kit-sec__title">Биография</h2>
                    <p class="media-kit-sec__note">Три версии для анонса. Выберите длину и скопируйте.</p>
                </div>
                <div>
                    <p class="media-kit-lead">15 лет в международных корпорациях, затем собственная платформа и исследование
                    карьерных переходов.</p>
                    <dl class="media-kit-facts">
                    <div>
                        <dt>Careerum</dt>
                        <dd>Основана в 2019 году. 14&nbsp;000 клиентов из 61 страны, команда 20 человек, выручка более $1M в год
                        </dd>
                    </div>
                    <div>
                        <dt>Корпоративный опыт</dt>
                        <dd>15 лет в маркетинге, продажах и стратегии Microsoft, Google, Adobe Systems и Travelport на 25+ рынках
                        Европы и Африки</dd>
                    </div>
                    <div>
                        <dt>Образование</dt>
                        <dd>MBA INSEAD (Сингапур); ALM candidate по психологии, Harvard Extension School; коучинговая сертификация
                        ICF</dd>
                    </div>
                    <div>
                        <dt>Книга</dt>
                        <dd>Бестселлер «Работа по любви», издательство МИФ</dd>
                    </div>
                    <div>
                        <dt>Подкасты</dt>
                        <dd>Ведущая «Мы вам перезвоним» и «На своём месте» (лучший брендовый подкаст 2024 по версии Яндекс Музыки)
                        </dd>
                    </div>
                    </dl>
                    <div class="media-kit-tabs">
                    <div class="media-kit-tabs__head" role="tablist" aria-label="Длина биографии">
                        <button class="media-kit-tab" role="tab" aria-selected="true" aria-controls="bio-short" id="t-short">Одна
                        строка</button>
                        <button class="media-kit-tab" role="tab" aria-selected="false" aria-controls="bio-intro" id="t-intro"
                        tabindex="-1">Подводка ведущего</button>
                        <button class="media-kit-tab" role="tab" aria-selected="false" aria-controls="bio-full" id="t-full"
                        tabindex="-1">Полная</button>
                    </div>
                    <div class="media-kit-bio" role="tabpanel" id="bio-short" aria-labelledby="t-short">
                        <p>Ольга Лермонтова — карьерный стратег, основательница платформы Careerum (14&nbsp;000 клиентов из 61
                        страны), ex-Microsoft и Google, MBA INSEAD.</p>
                    </div>
                    <div class="media-kit-bio" role="tabpanel" id="bio-intro" aria-labelledby="t-intro" hidden>
                        <p>Сегодня у нас в гостях Ольга Лермонтова — основательница платформы карьерного развития Careerum, через
                        которую прошли 14&nbsp;000 клиентов из 61 страны. 15 лет Ольга работала в маркетинге, продажах и стратегии
                        Microsoft, Google и Adobe на 25+ рынках Европы и Африки, окончила MBA в INSEAD, а сейчас исследует
                        карьерные переходы в Harvard Extension School. Она автор бестселлера «Работа по любви» и ведущая подкастов
                        «Мы вам перезвоним» и «На своём месте».</p>
                    </div>
                    <div class="media-kit-bio" role="tabpanel" id="bio-full" aria-labelledby="t-full" hidden>
                        <p>Ольга Лермонтова — карьерный стратег, основательница и CEO Careerum, платформы карьерного развития для
                        русскоязычных профессионалов. С 2019 года платформа помогла 14&nbsp;000 клиентов из 61 страны; в команде
                        20 человек, выручка превышает $1M в год.</p>
                        <p>До Careerum Ольга 15 лет работала в маркетинге, продажах и стратегии Microsoft, Google, Adobe Systems и
                        Travelport на 25+ рынках Европы и Африки. Окончила MBA INSEAD в Сингапуре, имеет коучинговую сертификацию
                        ICF и учится в Harvard Extension School (ALM по психологии), где исследует карьерные переходы.</p>
                        <p>Ольга — автор бестселлера «Работа по любви» (МИФ) и ведущая подкастов «Мы вам перезвоним» и «На своём
                        месте», который Яндекс Музыка назвала лучшим брендовым подкастом 2024 года. Её подход — мост между наукой
                        и практикой: о карьере она говорит не мотивационно, а механистически.</p>
                    </div>
                    <button class="media-kit-copy" type="button" id="copyBtn">Скопировать текст</button>
                    </div>
                </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-media-kit-photos', {
        label: 'Careerum MeidaKit photos',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-media-kit-block careerum-media-kit-photos">
                <div class="careerum-media-kit-wrap">
                <div class="careerum-media-kit-sec" style="margin-bottom:1.75rem">
                    <div>
                    <h2 class="media-kit-sec__title">Фото для публикаций</h2>
                    </div>
                    <p class="media-kit-sec__note" style="max-width:52ch;margin:0;align-self:end">Для анонсов, обложек выпусков и
                    статей. Можно использовать с указанием имени.</p>
                </div>
                <div class="media-kit-gallery">
                    <figure class="media-kit-shot">
                    <img src="https://cdn.careerum.com/1790759727095-JhsDS-ÐÐµ.jpg"
                        alt="Портрет в тёмно-синем пиджаке за столом"><button class="dl" data-name="lermontova-portrait-1.jpg"
                        hidden>Скачать</button>
                    </figure>
                    <figure class="media-kit-shot"><img src="https://cdn.careerum.com/1790759727043-Tppid-ÐÐµ.jpg"
                        alt="У микрофона на записи подкаста"><button class="dl" data-name="lermontova-podcast.jpg"
                        hidden>Скачать</button></figure>
                    <figure class="media-kit-shot"><img src="https://cdn.careerum.com/1790759727003-lTKZy-ÐÐµ.jpg"
                        alt="Крупный портрет в белой рубашке"><button class="dl" data-name="lermontova-portrait-2.jpg"
                        hidden>Скачать</button></figure>
                    <figure class="media-kit-shot"><img src="https://cdn.careerum.com/1790759726915-9ORdT-ÐÐµ.jpg"
                        alt="В полный рост в библиотеке"><button class="dl" data-name="lermontova-library.jpg"
                        hidden>Скачать</button></figure>
                    <figure class="media-kit-shot"><img src="https://cdn.careerum.com/1790759787517-4uFDn-ÐÐµ.jpg"
                        alt="В бордовом атласном костюме"><button class="dl" data-name="lermontova-burgundy.jpg"
                        hidden>Скачать</button></figure>
                    <figure class="media-kit-shot"><img src="https://cdn.careerum.com/1790759787473-Mzyrs-ÐÐµ.jpg"
                        alt="В голубой рубашке в кресле"><button class="dl" data-name="lermontova-armchair.jpg"
                        hidden>Скачать</button></figure>
                    <figure class="media-kit-shot"><img src="https://cdn.careerum.com/1790759787376-m9Lmq-ÐÐµ.jpg"
                        alt="В белой рубашке и пиджаке в интерьере"><button class="dl" data-name="lermontova-interior.jpg"
                        hidden>Скачать</button></figure>
                </div>
                <p class="media-kit-gallery__note">Оригиналы в полном разрешении отправим по запросу на hello@careerum.com.</p>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-media-kit-contact', {
        label: 'Careerum MeidaKit contact',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-media-kit-block careerum-media-kit-contact">
                <div class="careerum-media-kit-wrap">
                <div class="careerum-media-kit-sec">
                    <div>
                    <h2 class="media-kit-sec__title">Условия и детали</h2>
                    </div>
                    <ul class="media-kit-terms">
                    <li>
                        <h3>Форматы</h3>
                        <p>Гостья подкаста, интервью, экспертный комментарий, колонка, панельная дискуссия, вебинар, выступление на
                        конференции.</p>
                    </li>
                    <li>
                        <h3>Языки</h3>
                        <p>Русский и английский.</p>
                    </li>
                    <li>
                        <h3>Запись</h3>
                        <p>Онлайн из Италии (центральноевропейское время), офлайн по договорённости.</p>
                    </li>
                    <li>
                        <h3>Условия участия</h3>
                        <p>Согласуем индивидуально, в зависимости от формата и площадки.</p>
                    </li>
                    </ul>
                </div>

                <div class="media-kit-contact__card careerum-media-kit-sec">
                    <div>
                    <h2 class="media-kit-sec__title">Пригласить Ольгу</h2>
                    <p class="media-kit-sec__note">Напишите тему, формат, дату и аудиторию вашего проекта.</p>
                    <a class="mail"
                        href="mailto:hello@careerum.com?subject=%D0%9F%D1%80%D0%B8%D0%B3%D0%BB%D0%B0%D1%88%D0%B5%D0%BD%D0%B8%D0%B5%20%D0%B4%D0%BB%D1%8F%20%D0%9E%D0%BB%D1%8C%D0%B3%D0%B8%20%D0%9B%D0%B5%D1%80%D0%BC%D0%BE%D0%BD%D1%82%D0%BE%D0%B2%D0%BE%D0%B9">hello@careerum.com</a>
                    </div>
                    <ul class="media-kit-contact__list">
                    <li><span>Telegram для связи</span><a href="https://t.me/belyok" target="_blank"
                        rel="noopener">t.me/belyok</a></li>
                    <li><span>Instagram</span><a href="https://www.instagram.com/lermontova.career/" target="_blank"
                        rel="noopener">@lermontova.career</a></li>
                    <li><span>LinkedIn</span><a href="https://www.linkedin.com/in/lermontova" target="_blank"
                        rel="noopener">linkedin.com/in/lermontova</a></li>
                    <li><span>YouTube</span><a href="https://www.youtube.com/@Careerum" target="_blank"
                        rel="noopener">Careerum</a></li>
                    <li><span>Сайт</span><a href="https://careerum.com/ru-ru/promo/olga-lermontova" target="_blank"
                        rel="noopener">careerum.com</a></li>
                    </ul>
                </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-media-kit-footer', {
        label: 'Careerum MeidaKit footer',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-media-kit-footer">
                <div class="careerum-media-kit-wrap">
                <span>© 2026 Ольга Лермонтова, Careerum</span>
                <a href="#top">Наверх</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-reviews2-main', {
        label: 'Careerum reviews2 main',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-reviews2-main main-wrapper position-relative">
                <div class="careerum-container-responsive careerum-flex-fsfs">
                    <div class="reviews2-main-left">
                        <h2>«Превратить хаотичный поиск в чёткую стратегию с опорой на то, <span>что важно тебе»</span></h2>
                        <p class="reviews2-main-subheader">История участницы · Анна Есипова, Account Manager, Лиссабон</p>
                        <p class="reviews2-main-text">…Анна пришла в клуб с хаотичным поиском и неуверенностью. Вместе
                            с карьерным экспертом она выстроила стратегию, переупаковала резюме и общение с рекрутерами —
                            и теперь регулярно получает офферы и осознанно их оценивает…</p>
                    </div>
                    <div class="reviews2-main-right">
                        <div class="careerum-flex-sbfs">
                            <div>
                                <img src="https://cdn.careerum.com/1791465148354-YpoLP-Fram.png" alt="img" loading="eager">
                            </div>
                            <div>
                                <img src="https://cdn.careerum.com/1791465148431-NTCTc-Fram.png" alt="img" loading="eager">
                            </div>
                            <div>
                                <img src="https://cdn.careerum.com/1791465148536-lMNSa-Fram.png" alt="img" loading="eager">
                            </div>
                            <div>
                                <img src="https://cdn.careerum.com/1791465148506-N1Zs2-Fram.png" alt="img" loading="eager">
                            </div>
                            <div>
                                <img src="https://cdn.careerum.com/1791465148463-O1n31-Fram.png" alt="img" loading="eager">
                            </div>
                            <div>
                                <img src="https://cdn.careerum.com/1791465148578-zlRKK-Fram.png" alt="img" loading="eager">
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-reviews2-neuro', {
        label: 'Careerum reviews2 neuro',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-reviews2-neuro main-wrapper">
                <div class="careerum-container-responsive careerum-flex-sbfs">
                    <div class="reviews2-neuro-left">
                        <h2>Не верьте нам на слово — спросите нейросеть</h2>
                        <p class="reviews2-neuro-subheader">ИИ ответит по открытым источникам: что такое Careerum, кому подходит клуб и какие результаты у участников.</p>
                    </div>
                    <div class="reviews2-neuro-right">
                        <a href="#" class="careerum-flex-cc" target="_blank">
                            <img src="https://cdn.careerum.com/1791465233909-3acYF-Chat.svg" alt="">
                            <p>ChatGPT</p>
                        </a>
                        <a href="#" class="careerum-flex-cc" target="_blank">
                            <img src="https://cdn.careerum.com/1791465234051-XqEO6-Perp.svg" alt="">
                            <p>Perplexity</p>
                        </a>
                        <a href="#" class="careerum-flex-cc" target="_blank">
                            <img src="https://cdn.careerum.com/1791465233979-QFAyQ-icon.svg" alt="">
                            <p>DeepSeek</p>
                        </a>
                        <a href="#" class="careerum-flex-cc" target="_blank">
                            <img src="https://cdn.careerum.com/1791465234015-STK1s-icon.svg" alt="">
                            <p>Grok</p>
                        </a>
                        <a href="#" class="careerum-flex-cc" target="_blank">
                            <img src="https://cdn.careerum.com/1791465234087-pMUfq-Ð¡Ð½.svg" alt="">
                            <p>Алиса · Яндекс</p>
                        </a>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-alumni-main', {
        label: 'Careerum alumni main',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-alumni-main main-wrapper position-relative">
                <img src="https://cdn.careerum.com/1791792602706-UGbWJ-Grou.svg"
                    class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                <img src="https://cdn.careerum.com/1791792604492-8sA7y-Grou.svg"
                    class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                <img src="https://cdn.careerum.com/1791792642266-YJpLh-Grou.svg"
                    class="hidden-desc-tablet position-absolute z-1" alt="img" loading="lazy">
                <div class="careerum-container-responsive position-relative z-10">
                    <img src="https://cdn.careerum.com/1791792790524-ePvbw-Fram.png" class="alumni-main-header-img" alt="img"
                        loading="eager">
                    <h1>Alumni</h1>
                    <p class="alumni-main-subheader position-relative">Careerum</p>
                    <p class="alumni-main-text">После Careerum жизнь идёт дальше, <span>связи остаются!</span></p>
                    <p class="alumni-main-slider-header">Оставайтесь с нами в своём ритме:</p>
                    <div class="alumni-main-slider careerum-slick-slider-wrapper noselect position-relative"
                        data-slider-init="3" data-slider-1300="1" data-slider-768="1">
                        <div class="alumni-main-slider-item-label careerum-flex-cc position-absolute z-10">
                            <img src="https://cdn.careerum.com/1791810764511-bMEWr-Gift.svg" alt="">
                            <p>Бесплатно</p>
                        </div>
                        <div class="slider-elements position-relative z-1">
                            <div class="alumni-main-slider-item careerum-flex-fsc">
                                <p class="alumni-main-slider-item-header">Важное о рынке работы</p>
                                <p class="alumni-main-slider-item-text">Раз в месяц собираем все изменения и держим руку на
                                    пульсе</p>
                                <div class="alumni-main-slider-item-img">
                                    <img src="https://cdn.careerum.com/1791793788096-Fomxi-Fram.png"
                                        class="hidden-tablet-mobile" alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1791793694871-hp0mg-Fram.png" class="hidden-desc-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1791831378668-WCceP-Fram.png" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                            </div>
                            <div class="alumni-main-slider-item careerum-flex-fsc">
                                <p class="alumni-main-slider-item-header">Прямые эфиры</p>
                                <p class="alumni-main-slider-item-text">Один клубный эфир в месяц для выпускников for free</p>
                                <div class="alumni-main-slider-item-img">
                                    <img src="https://cdn.careerum.com/1791793788146-qSckd-Fram.png"
                                        class="hidden-tablet-mobile bottom" alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1791793694931-gfxrN-Fram.png"
                                        class="hidden-desc-mobile bottom" alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1791831378810-kGmGd-Fram.png" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                            </div>
                            <div class="alumni-main-slider-item careerum-flex-fsc position-relative">
                                <p class="alumni-main-slider-item-header">Подкасты</p>
                                <p class="alumni-main-slider-item-text">Подкасты от экспертов Careerum </p>
                                <div class="alumni-main-slider-item-img top">
                                    <img src="https://cdn.careerum.com/1791793788330-sM3dv-Fram.png"
                                        class="hidden-tablet-mobile" alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1791793695124-Glewm-Fram.png" class="hidden-desc-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1791831379446-IHQWg-Fram.png" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                            </div>
                            <div class="alumni-main-slider-item careerum-flex-fsc">
                                <p class="alumni-main-slider-item-header">Coffee-buddy</p>
                                <p class="alumni-main-slider-item-text">Coffee-buddy для знакомств </p>
                                <div class="alumni-main-slider-item-img">
                                    <img src="https://cdn.careerum.com/1791793788209-u9PQV-Fram.png"
                                        class="hidden-tablet-mobile" alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1791793694997-2jYEq-Fram.png" class="hidden-desc-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1791831379087-cdqNE-Fram.png" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                            </div>
                            <div class="alumni-main-slider-item careerum-flex-fsc">
                                <p class="alumni-main-slider-item-header">Задать вопрос эксперту</p>
                                <p class="alumni-main-slider-item-text hidden">Задать вопрос эксперту</p>
                                <div class="alumni-main-slider-item-img">
                                    <img src="https://cdn.careerum.com/1791793788013-xt0Qf-Cont.png"
                                        class="hidden-tablet-mobile" alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1791793694522-X7n5u-Cont.png" class="hidden-desc-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1791831378054-5KOLs-Cont.png" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                            </div>
                            <div class="alumni-main-slider-item careerum-flex-fsc">
                                <p class="alumni-main-slider-item-header bottom">Careerum Елка</p>
                                <div class="alumni-main-slider-item-img bottom">
                                    <img src="https://cdn.careerum.com/1791793788274-Nl5LD-Fram.png"
                                        class="hidden-tablet-mobile" alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1791793695060-2SzRY-Fram.png" class="hidden-desc-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1791831379182-dIzVd-Fram.png"
                                        class="hidden-desc-tablet bottom" alt="img" loading="lazy">
                                </div>
                            </div>
                            <div class="alumni-main-slider-item careerum-flex-fsc dark position-relative">
                                <p class="alumni-main-slider-item-header">Особые условия для возвращения</p>
                                <p class="alumni-main-slider-item-text">А еще можно пригласить друга — и получить бонус себе
                                    и
                                    ему:)</p>
                                <img src="https://cdn.careerum.com/1791793870867-5rbDM-Grou.svg"
                                    class="hidden-mobile position-absolute z-1" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1791831619282-toQBq-Grou.svg"
                                    class="hidden-desc-tablet position-absolute z-1" alt="img" loading="lazy">
                                <a href="#" class="alumni-main-slider-item-link-white position-relative z-10">Вернуться без
                                    лишних шагов</a>
                                <a href="#" class="alumni-main-slider-item-link-dark position-relative z-10">Уточнить
                                    детали</a>
                            </div>
                        </div>
                        <div class="slider-nav">
                        </div>
                    </div>
                    <a href="#buy" class="btn-color-black label position-relative">Вступить в Alumni в Telegram</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-alumni-header', {
        label: 'Careerum alumni header',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-alumni-header main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Расписание Careerum до конца года</h2>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-alumni-schedule', {
        label: 'Careerum alumni schedule',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-awake-mobile careerum-alumni-schedule main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="awake-mobile-bg position-relative z-10">
                        <img loading="" src="https://cdn.careerum.com/1792405552231-nRid0-Fram.svg" alt="img"
                            class="hidden-tablet-mobile position-absolute">
                        <img loading="" src="https://cdn.careerum.com/1791828704457-1XZgl-Fram.svg" alt="img"
                            class="hidden-desc-mobile position-absolute">
                        <img loading="" src="https://cdn.careerum.com/1792421377325-vHPmi-Fram.svg" alt="img"
                            class="hidden-desc-tablet position-absolute">
                    </div>
                    <div class="awake-mobile-wrapper thin">
                        <h2 class="position-relative z-20">Впереди ещё много лет профессиональной жизни. И вы вправе хотеть от неё большего!</h2>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-alumni-author', {
        label: 'Careerum alumni author',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-alumni-author main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="careerum-awake-labels">
                        <div class="careerum-awake-label-white careerum-flex-fsc position-relative z-20">
                            <img loading=""
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744980825-ikXcw-Upda.svg"
                                alt="img" class="hidden-tablet-mobile">
                            <img loading=""
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744983967-uOfoq-Upda.svg"
                                alt="img" class="hidden-desc-mobile">
                            <img loading=""
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744987313-zuntf-Upda.svg"
                                alt="img" class="hidden-desc-tablet">
                            <p>3 мастер-класса:</p>
                        </div>
                        <div class="careerum-awake-label-blue careerum-flex-fsc position-relative z-10">
                            <p>Мастер-классы Ольги Лермонтовой</p>
                        </div>
                    </div>
                    <div class="alumni-author-content careerum-flex-sbfs">
                        <div class="alumni-author-left position-relative">
                            <img src="https://cdn.careerum.com/1791811982086-uLlm3-Cont.png"
                                class="hidden-tablet-mobile position-relative z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1791828938436-9pwp9-Cont.png"
                                class="hidden-desc-mobile position-relative z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1791832565142-QDFRB-Cont.png"
                                class="hidden-desc-tablet position-relative z-1" alt="img" loading="lazy">
                            <div class="careerum-flex-cc position-absolute z-10 alumni-author-label">
                                <img src="https://cdn.careerum.com/1791812124632-ds4az-Fire.svg" alt="img" loading="eager">
                                <p>Ольга в клубе</p>
                            </div>
                        </div>
                        <div class="alumni-author-right">
                            <p class="alumni-author-slider-header">Ваше мнение о МК Ольги:</p>
                            <div class="alumni-author-slider careerum-slick-slider-wrapper noselect" data-slider-init="2"
                                data-slider-1300="2" data-slider-768="1">
                                <div class="slider-elements">
                                    <div class="alumni-author-slider-item">
                                        <div class="careerum-flex-fsfe">
                                            <p class="alumni-author-slider-item-name">Екатерина</p>
                                            <p class="alumni-author-slider-item-date">21.06.25 14:25</p>
                                        </div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752740451363-GmXdM-Rati.svg"
                                            alt="">
                                        <p class="alumni-author-slider-item-text">Я считаю, что нужно с записью выпустить pdf
                                            сборник золотых цитат спикера! «не тётя с горы решает, а вы» – ❤️</p>
                                    </div>
                                    <div class="alumni-author-slider-item">
                                        <div class="careerum-flex-fsfe">
                                            <p class="alumni-author-slider-item-name">Оксана</p>
                                            <p class="alumni-author-slider-item-date">21.06.25 14:26</p>
                                        </div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752740451363-GmXdM-Rati.svg"
                                            alt="">
                                        <p class="alumni-author-slider-item-text">Вебинар глубокий, нравится подача Ольги
                                            безоценочная, незапугивающая, предлагает варианты и решения уже в процессе
                                            презентации</p>
                                    </div>
                                    <div class="alumni-author-slider-item">
                                        <div class="careerum-flex-fsfe">
                                            <p class="alumni-author-slider-item-name">Анна</p>
                                            <p class="alumni-author-slider-item-date">21.06.25 14:46</p>
                                        </div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752740451363-GmXdM-Rati.svg"
                                            alt="">
                                        <p class="alumni-author-slider-item-text">Пожалуй самые сильные и информативные курсы,
                                            которые я видела. Спасибо огромное за качество!</p>
                                    </div>
                                    <div class="alumni-author-slider-item">
                                        <div class="careerum-flex-fsfe">
                                            <p class="alumni-author-slider-item-name">Мария</p>
                                            <p class="alumni-author-slider-item-date">21.06.25 14:53</p>
                                        </div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752740451363-GmXdM-Rati.svg"
                                            alt="">
                                        <p class="alumni-author-slider-item-text">Подтверждаю! Мне 22 и взяла максимум пользы
                                            от Ольги, и жалею что не знала на самом старте</p>
                                    </div>
                                    <div class="alumni-author-slider-item">
                                        <div class="careerum-flex-fsfe">
                                            <p class="alumni-author-slider-item-name">Юлия</p>
                                            <p class="alumni-author-slider-item-date">21.06.25 14:05</p>
                                        </div>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752740451363-GmXdM-Rati.svg"
                                            alt="">
                                        <p class="alumni-author-slider-item-text">Очень нравится системность, структурность,
                                            взгляд сверху и вообще заставляет задуматься о вещах, которые в текущей жизни
                                            не в фокусе</p>
                                    </div>
                                </div>
                                <div class="slider-nav careerum-flex-fec">
                                    <div class="slick-nav-prev careerum-flex-cc">
                                        <svg width="17" height="15" viewBox="0 0 17 15" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1.32031 7.32104L15.3203 7.32104" stroke="white" stroke-width="2.64201"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M7.32031 13.321L1.32031 7.32104L7.32031 1.32104" stroke="white"
                                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                    <div class="slick-nav-next careerum-flex-cc">
                                        <svg width="17" height="15" viewBox="0 0 17 15" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15.3203 7.32105L1.32031 7.32104" stroke="white" stroke-width="2.64201"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M9.32031 1.32104L15.3203 7.32105L9.32031 13.321" stroke="white"
                                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="alumni-author-bottom">
                            <div class="alumni-author-bottom-slider careerum-slick-slider-wrapper noselect" data-slider-init="3"
                                data-slider-1300="2" data-slider-768="1">
                                <div class="slider-elements">
                                    <div class="alumni-author-bottom-item">
                                        <p class="alumni-author-bottom-item-date">29 октября</p>
                                        <p class="alumni-author-bottom-item-type">Professional longevity</p>
                                        <p class="alumni-author-bottom-item-header">Поколение без пенсии</p>
                                        <p class="alumni-author-bottom-item-text">Как построить жизнь, в которой работа до 80 —
                                            выбор, а не необходимость</p>
                                        <div class="alumni-author-bottom-item-img position-relative">
                                            <img src="https://cdn.careerum.com/1792404902696-Fqrsp-Fram.png"
                                                class="hidden-mobile position-absolute" alt="img" loading="lazy">
                                            <img src="https://cdn.careerum.com/1792421209714-S8Ouw-Fram.png"
                                                class="hidden-desc-tablet position-absolute" alt="img" loading="lazy">
                                        </div>
                                    </div>
                                    <div class="alumni-author-bottom-item">
                                        <p class="alumni-author-bottom-item-date">19 ноября</p>
                                        <p class="alumni-author-bottom-item-type">Professional longevity</p>
                                        <p class="alumni-author-bottom-item-header">Чем выше уровень, тем меньше ролей</p>
                                        <p class="alumni-author-bottom-item-text">Как вернуть себе свободу и новые возможности
                                        </p>
                                        <div class="alumni-author-bottom-item-img position-relative">
                                            <img src="https://cdn.careerum.com/1792404902908-JFrFc-Fram.png"
                                                class="hidden-mobile position-absolute top" alt="img" loading="lazy">
                                            <img src="https://cdn.careerum.com/1792421209975-FbFNK-Fram.png"
                                                class="hidden-desc-tablet position-absolute top" alt="img" loading="lazy">
                                        </div>
                                    </div>
                                    <div class="alumni-author-bottom-item">
                                        <p class="alumni-author-bottom-item-date">5 января</p>
                                        <p class="alumni-author-bottom-item-type">Professional longevity</p>
                                        <p class="alumni-author-bottom-item-header">Чем выше уровень, тем меньше ролей</p>
                                        <p class="alumni-author-bottom-item-text">Как вернуть себе свободу и новые возможности
                                        </p>
                                        <div class="alumni-author-bottom-item-img position-relative">
                                            <img src="https://cdn.careerum.com/1792404902879-CilTf-Fram.png"
                                                class="hidden-mobile position-absolute" alt="img" loading="lazy">
                                            <img src="https://cdn.careerum.com/1792421209933-lKZB6-Fram.png"
                                                class="hidden-desc-tablet position-absolute" alt="img" loading="lazy">
                                        </div>
                                    </div>
                                    <div class="alumni-author-bottom-item">
                                        <p class="alumni-author-bottom-item-date">21 декабря</p>
                                        <p class="alumni-author-bottom-item-type">Эфир</p>
                                        <p class="alumni-author-bottom-item-header">Careerum Ёлка</p>
                                        <div class="alumni-author-bottom-item-img position-relative">
                                            <img src="https://cdn.careerum.com/1792404902821-EQm4R-Fram.png"
                                                class="hidden-mobile position-absolute" alt="img" loading="lazy">
                                            <img src="https://cdn.careerum.com/1792421209884-pmsCm-Fram.png"
                                                class="hidden-desc-tablet position-absolute" alt="img" loading="lazy">
                                        </div>
                                    </div>
                                </div>
                                <div class="slider-nav careerum-flex-fec">
                                    <div class="slick-nav-prev careerum-flex-cc">
                                        <svg width="17" height="15" viewBox="0 0 17 15" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1.32031 7.32104L15.3203 7.32104" stroke="white" stroke-width="2.64201"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M7.32031 13.321L1.32031 7.32104L7.32031 1.32104" stroke="white"
                                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                    <div class="slick-nav-next careerum-flex-cc">
                                        <svg width="17" height="15" viewBox="0 0 17 15" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15.3203 7.32105L1.32031 7.32104" stroke="white" stroke-width="2.64201"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M9.32031 1.32104L15.3203 7.32105L9.32031 13.321" stroke="white"
                                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <a href="#buy" class="btn-color-black label position-relative">Присоединиться к Careerum</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-alumni-master', {
        label: 'Careerum alumni master',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-alumni-master main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="careerum-awake-labels">
                        <div class="careerum-awake-label-white careerum-flex-fsc position-relative z-20">
                            <img loading=""
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744980825-ikXcw-Upda.svg"
                                alt="img" class="hidden-tablet-mobile">
                            <img loading=""
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744983967-uOfoq-Upda.svg"
                                alt="img" class="hidden-desc-mobile">
                            <img loading=""
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744987313-zuntf-Upda.svg"
                                alt="img" class="hidden-desc-tablet">
                            <p>Эфиры клуба:</p>
                        </div>
                        <div class="careerum-awake-label-blue careerum-flex-fsc position-relative z-10">
                            <p>О профессиональном долголетии спикеры <br>и амбассадоры клуба</p>
                        </div>
                    </div>
                    <div class="alumni-master-content">
                        <p class="alumni-master-header">Ваш опыт даёт вам право на новые главы. Менять роли, пробовать своё,
                            увлекаться большим проектом или освобождать больше времени для жизни. Пересматривать то, что
                            когда-то подходило, потому что вы сами стали другой</p>
                        <div class="alumni-master-slider careerum-slick-slider-wrapper noselect" data-slider-init="3"
                            data-slider-1300="2" data-slider-768="1">
                            <div class="slider-elements">
                                <div class="alumni-master-slider-item item2">
                                    <p class="alumni-master-slider-item-label">11 ноября</p>
                                    <p class="alumni-master-slider-item-label blue">Professional longevity</p>
                                    <p class="alumni-master-slider-item-header">Работа будущего</p>
                                    <p class="alumni-master-slider-item-text2">Почему интерес, окружение и личные ценности
                                        становятся важнее карьерной лестницы?</p>
                                    <img src="https://cdn.careerum.com/1792406218579-zUsZO-Fram.png" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1792421656888-lzl22-Fram.png" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                                <div class="alumni-master-slider-item item2">
                                    <p class="alumni-master-slider-item-label">25 ноября</p>
                                    <p class="alumni-master-slider-item-label blue">Professional longevity</p>
                                    <p class="alumni-master-slider-item-header">Портфельная карьера</p>
                                    <p class="alumni-master-slider-item-text2">Через кейс амбассадора клуба</p>
                                    <img src="https://cdn.careerum.com/1792406218704-RaypW-Fram.png" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1792421656953-zxp0f-Fram.png" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                                <div class="alumni-master-slider-item item2">
                                    <p class="alumni-master-slider-item-label">9 декабря</p>
                                    <p class="alumni-master-slider-item-label blue">Professional longevity</p>
                                    <p class="alumni-master-slider-item-header">Как Создавать проекты не из амбиций,
                                        а из любопытства и свободы быть собой</p>
                                    <img src="https://cdn.careerum.com/1792406218704-RaypW-Fram.png" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1792421656953-zxp0f-Fram.png" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                            </div>
                            <div class="slider-nav careerum-flex-fec">
                                <div class="slick-nav-prev careerum-flex-cc">
                                    <svg width="17" height="15" viewBox="0 0 17 15" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.32031 7.32104L15.3203 7.32104" stroke="white" stroke-width="2.64201"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M7.32031 13.321L1.32031 7.32104L7.32031 1.32104" stroke="white"
                                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <div class="slick-nav-next careerum-flex-cc">
                                    <svg width="17" height="15" viewBox="0 0 17 15" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M15.3203 7.32105L1.32031 7.32104" stroke="white" stroke-width="2.64201"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M9.32031 1.32104L15.3203 7.32105L9.32031 13.321" stroke="white"
                                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <a href="#buy" class="btn-color-black label position-relative">Присоединиться к Careerum</a>
                </div>
                <div class="careerum-container-responsive">
                    <div class="careerum-awake-labels">
                        <div class="careerum-awake-label-white careerum-flex-fsc position-relative z-20">
                            <img loading=""
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744980825-ikXcw-Upda.svg"
                                alt="img" class="hidden-tablet-mobile">
                            <img loading=""
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744983967-uOfoq-Upda.svg"
                                alt="img" class="hidden-desc-mobile">
                            <img loading=""
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744987313-zuntf-Upda.svg"
                                alt="img" class="hidden-desc-tablet">
                            <p>Сезон найма и поиска работы в клубе</p>
                        </div>
                        <div class="careerum-awake-label-blue careerum-flex-fsc position-relative z-10">
                            <p>Поиск работы РФ – и международка</p>
                        </div>
                    </div>
                    <div class="alumni-master-content">
                        <p class="alumni-master-header">Наши мастер-классы реально помогают получить <span>оффер!</span></p>
                        <div class="alumni-master-slider careerum-slick-slider-wrapper noselect" data-slider-init="3"
                            data-slider-1300="2" data-slider-768="1">
                            <div class="slider-elements">
                                <div class="alumni-master-slider-item">
                                    <p class="alumni-master-slider-item-label">20 октября – рынок РФ</p>
                                    <p class="alumni-master-slider-item-label">22 октября – международный рынок</p>
                                    <p class="alumni-master-slider-item-header">Митап по рынку РФ «Как пробиться к
                                        рекрутерам через 500 откликов?»</p>
                                    <img src="https://cdn.careerum.com/1791823824164-bPy1f-Fram.png" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1791833707740-yuVwa-Fram.png" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                                <div class="alumni-master-slider-item">
                                    <p class="alumni-master-slider-item-label">10 ноября – рынок РФ</p>
                                    <p class="alumni-master-slider-item-label">11 ноября – международный рынок</p>
                                    <p class="alumni-master-slider-item-header">Прожарки резюме. РФ рынок</p>
                                    <p class="alumni-master-slider-item-text">Наши эксперты разбирают ваши CV в прямом эфире
                                        и дают рекомендации</p>
                                    <img src="https://cdn.careerum.com/1791823840856-e7kmn-Fram.png" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1791833707865-uR3LC-Fram.png" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                                <div class="alumni-master-slider-item">
                                    <p class="alumni-master-slider-item-label">10 ноября – рынок РФ</p>
                                    <p class="alumni-master-slider-item-label">22 ноября – международный рынок</p>
                                    <p class="alumni-master-slider-item-header">Краш-тест джоб интервью</p>
                                    <img src="https://cdn.careerum.com/1791823833844-egkwx-Fram.png" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1791833707824-vNLuI-Fram.png" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                                <div class="alumni-master-slider-item">
                                    <p class="alumni-master-slider-item-label">12 ноября </p>
                                    <p class="alumni-master-slider-item-header">Онлайн-коворкинг</p>
                                    <p class="alumni-master-slider-item-text">Каждый участник приходит со своей задачей и
                                        работает над ней:</p>
                                    <ul class="alumni-master-slider-item-list">
                                        <li>Улучшает резюме</li>
                                        <li>Делает аутричи в Линкедине</li>
                                        <li>Выполняем вместе домашнее задание </li>
                                        <li>Рядом с вами эксперт, который помогает и отвечает на вопросы.</li>
                                    </ul>
                                    <img src="https://cdn.careerum.com/1791823824056-DDLmk-Fram.png" class="hidden-mobile"
                                        alt="img" loading="lazy">
                                    <img src="https://cdn.careerum.com/1791833707645-fDau9-Fram.png" class="hidden-desc-tablet"
                                        alt="img" loading="lazy">
                                </div>
                            </div>
                            <div class="slider-nav careerum-flex-fec">
                                <div class="slick-nav-prev careerum-flex-cc">
                                    <svg width="17" height="15" viewBox="0 0 17 15" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.32031 7.32104L15.3203 7.32104" stroke="white" stroke-width="2.64201"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M7.32031 13.321L1.32031 7.32104L7.32031 1.32104" stroke="white"
                                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <div class="slick-nav-next careerum-flex-cc">
                                    <svg width="17" height="15" viewBox="0 0 17 15" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M15.3203 7.32105L1.32031 7.32104" stroke="white" stroke-width="2.64201"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M9.32031 1.32104L15.3203 7.32105L9.32031 13.321" stroke="white"
                                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <a href="#buy" class="btn-color-black label position-relative">Вернуться за 9 900 ₽ в месяц</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-alumni-ai', {
        label: 'Careerum alumni ai',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-ai042026-main careerum-alumni-ai main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="careerum-awake-labels">
                        <div class="careerum-awake-label-white careerum-flex-fsc position-relative z-20">
                            <img loading=""
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744980825-ikXcw-Upda.svg"
                                alt="img" class="hidden-tablet-mobile">
                            <img loading=""
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744983967-uOfoq-Upda.svg"
                                alt="img" class="hidden-desc-mobile">
                            <img loading=""
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752744987313-zuntf-Upda.svg"
                                alt="img" class="hidden-desc-tablet">
                            <p>Новый курс, май 2026</p>
                        </div>
                    </div>
                    <div class="ai042026-main-top careerum-flex-sbfs">
                        <div class="ai042026-main-top-left position-relative z-10">
                            <h2>Карьера в эпоху <span>AI</span></h2>
                            <p class="ai042026-subheader">От исполнителя к стратегу</p>
                            <ul class="ai042026-models-wrapper careerum-flex-fsfs">
                                <li class="position-relative">Claude</li>
                                <li class="position-relative">ChatGPT 5</li>
                                <li class="position-relative">DeepSeek</li>
                                <li class="position-relative">Perplexity</li>
                                <li class="position-relative">Grok</li>
                            </ul>
                        </div>
                        <div class="ai042026-main-top-right position-relative z-1 hero__image-wrap">
                            <img loading="eager" src="https://cdn.careerum.com/1776858555572-GKxdt-Fram.png" alt="img"
                                class="hidden-tablet-mobile position-absolute hero__image1">
                            <img loading="eager" src="https://cdn.careerum.com/1776858556964-ii5H3-Fram.png" alt="img"
                                class="hidden-desc-mobile position-absolute">
                            <img loading="eager" src="https://cdn.careerum.com/1776858558876-acKRB-Fram.png" alt="img"
                                class="hidden-desc-tablet position-absolute">
                        </div>
                    </div>
                    <div class="ai042026-main-bottom">
                        <div class="ai042026-main-banner position-relative">
                            <p class="position-relative z-10 hidden-mobile">Новая система
                                мышления, работы и пересборка профессиональной роли,
                                которая <span>сделает вас
                                    дороже рынка</span></p>
                            <p class="position-relative z-10 hidden-desc-tablet">Новая
                                система мышления, работы и пересборка профессиональной роли,
                                которая <span>сделает вас
                                    дороже</span><br> <span>рынка</span></p>
                            <img loading="lazy" src="https://cdn.careerum.com/1776859423601-97Ain-Ð¡Ð½.png" alt="img"
                                class="hidden-tablet-mobile position-absolute z-1">
                            <img loading="lazy" src="https://cdn.careerum.com/1775161630362-pYYiD-Ð¡Ð½.png" alt="img"
                                class="hidden-desc-mobile position-absolute z-1">
                            <img loading="lazy"
                                src="https://storage.yandexcloud.net/cdn.careerum.com/1776929430726-c3bdb-Ð¡Ð½.png" alt="img"
                                class="hidden-desc-tablet position-absolute z-1">
                        </div>
                        <ul class="careerum-flex-sbst">
                            <li class="careerum-flex-fsfs">
                                <img loading="lazy" src="https://cdn.careerum.com/1775161786754-YfhD1-Soft.svg" alt="img"
                                    class="hidden-tablet-mobile">
                                <img loading="lazy" src="https://cdn.careerum.com/1775161790656-1USUd-Soft.svg" alt="img"
                                    class="hidden-desc">
                                <div>
                                    <p>Из человека, который «делает руками»</p>
                                    <p>В специалиста, который <span>управляет процессами через AI</span> </p>
                                </div>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img loading="lazy" src="https://cdn.careerum.com/1775161786754-YfhD1-Soft.svg" alt="img"
                                    class="hidden-tablet-mobile">
                                <img loading="lazy" src="https://cdn.careerum.com/1775161790656-1USUd-Soft.svg" alt="img"
                                    class="hidden-desc">
                                <div>
                                    <p>Из «незаметного исполнителя»</p>
                                    <p>В специалиста <span>с влиянием</span> и сильной позицией </p>
                                </div>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img loading="lazy" src="https://cdn.careerum.com/1775161786754-YfhD1-Soft.svg" alt="img"
                                    class="hidden-tablet-mobile">
                                <img loading="lazy" src="https://cdn.careerum.com/1775161790656-1USUd-Soft.svg" alt="img"
                                    class="hidden-desc">
                                <div>
                                    <p>Из хаотичного пользователя нейросетей</p>
                                    <p>В системного <span>профессионала</span> с собственной карьерной стратегией</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-alumni-reviews', {
        label: 'Careerum alumni reviews',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-awake-updates careerum-alumni-reviews main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="careerum-awake-reviews_text">
                        <h2>Результаты выпускников:</h2>
                        <div class="awake-reviews-wrapper">
                            <div class="awake-reviews-item">
                                <div class="awake-reviews-item-top careerum-flex-fsc">
                                    <p class="awake-reviews-item-top-name">Анна</p>
                                </div>
                                <div class="awake-reviews-item-stars">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752740451363-GmXdM-Rati.svg"
                                        alt="" />
                                </div>
                                <p class="awake-reviews-item-text">OMG Innokentiy, You've created a monster!!! 🥵😆 (в хорошем
                                    смысле!). Мозг так не работал несколько лет! Я тут боюсь как бы работу не прогулять,
                                    зависнув с проектом, по которому делаю домашку! </p>
                            </div>
                            <div class="awake-reviews-item">
                                <div class="awake-reviews-item-top careerum-flex-fsc">
                                    <p class="awake-reviews-item-top-name">Инна C.</p>
                                </div>
                                <div class="awake-reviews-item-stars">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752740451363-GmXdM-Rati.svg"
                                        alt="" />
                                </div>
                                <p class="awake-reviews-item-text">Этот курс очень практичный, сразу получаю реальные
                                    результаты. И это только первая неделя. Спасибо Вам!</p>
                            </div>
                            <div class="awake-reviews-item">
                                <div class="awake-reviews-item-top careerum-flex-fsc">
                                    <p class="awake-reviews-item-top-name">Инна C.</p>
                                </div>
                                <div class="awake-reviews-item-stars">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752740451363-GmXdM-Rati.svg"
                                        alt="" />
                                </div>
                                <p class="awake-reviews-item-text">Восхищаюсь курсом! Вчера выполнила часть домашки для 1:1 с
                                    начальником через Copilot, превратив оперативную задачу в стратегическую. Сегодня провайдер
                                    внезапно спросил мою начальницу о этой задаче. Написала и радовалась, как начальнице повезло
                                    с такой подчиненной! 😄 Начальница выдохнула и поблагодарила!</p>
                            </div>
                            <div class="awake-reviews-item">
                                <div class="awake-reviews-item-top careerum-flex-fsc">
                                    <p class="awake-reviews-item-top-name">Саша С.</p>
                                </div>
                                <div class="awake-reviews-item-stars">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752740451363-GmXdM-Rati.svg"
                                        alt="" />
                                </div>
                                <p class="awake-reviews-item-text">Смотрю уроки второй недели, просто полный взрыв мозга с
                                    головой. Плотность полезной, свежей и применимой инфо зашкаливает 🔥🔥🔥</p>
                            </div>
                            <div class="awake-reviews-item">
                                <div class="awake-reviews-item-top careerum-flex-fsc">
                                    <p class="awake-reviews-item-top-name">Анонимно</p>
                                </div>
                                <div class="awake-reviews-item-stars">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752740451363-GmXdM-Rati.svg"
                                        alt="" />
                                </div>
                                <p class="awake-reviews-item-text">Я в восторге от второго модуля! Чувствую что нужно будет ещё
                                    раз посмотреть уже после выполнения задания; хоть я и уже и пересматривала некоторые места,
                                    всё равно ощущение что я не до конца впитала смысл. Домашку делать конечно лень, но я буду
                                    себя уговаривать — верю в процесс.</p>
                            </div>
                            <div class="awake-reviews-item">
                                <div class="awake-reviews-item-top careerum-flex-fsc">
                                    <p class="awake-reviews-item-top-name">Инна C.</p>
                                </div>
                                <div class="awake-reviews-item-stars">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752740451363-GmXdM-Rati.svg"
                                        alt="" />
                                </div>
                                <p class="awake-reviews-item-text">Я вдохновилась результатами участников курса и решила
                                    переделать ДЗ1 с чатом GPT. Результат великолепный. В теории он может все делать. Интересно
                                    проверить качество на практике 🙂</p>
                            </div>
                            <div class="awake-reviews-item">
                                <div class="awake-reviews-item-top careerum-flex-fsc">
                                    <p class="awake-reviews-item-top-name">Анонимно</p>
                                </div>
                                <div class="awake-reviews-item-stars">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752740451363-GmXdM-Rati.svg"
                                        alt="" />
                                </div>
                                <p class="awake-reviews-item-text">Главный инсайт — провожу для себя переоценку того что можно
                                    считать рутинной задачей. Эти задачи я просто считала для себя рабочими, но времени они
                                    точно занимали немало. Будет теперь бот мне помогать с быстрыми ответами на запросы цен в
                                    зависимости от скоупа проекта)</p>
                            </div>
                            <div class="awake-reviews-item">
                                <div class="awake-reviews-item-top careerum-flex-fsc">
                                    <p class="awake-reviews-item-top-name">Анонимно</p>
                                </div>
                                <div class="awake-reviews-item-stars">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752740451363-GmXdM-Rati.svg"
                                        alt="" />
                                </div>
                                <p class="awake-reviews-item-text">Когда ИИ перевел ситуацию на язык бизнеса, я увидела, что
                                    фактически выполняла роль связующего звена между HQ и китайской командой, управляла
                                    неопределенностью и предотвращала риск срыва международного проекта. Это помогло мне
                                    по-новому посмотреть на свой вклад.</p>
                            </div>
                            <div class="awake-reviews-item">
                                <div class="awake-reviews-item-top careerum-flex-fsc">
                                    <p class="awake-reviews-item-top-name">Анонимно</p>
                                </div>
                                <div class="awake-reviews-item-stars">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752740451363-GmXdM-Rati.svg"
                                        alt="" />
                                </div>
                                <p class="awake-reviews-item-text">Claude подсветил мне насколько раньше моя позиция была слабой
                                    и почему. И я раньше понимала почему, но не получалось донести это до Топ-менеджмента в
                                    правильных тезисах и настоять на своем. А с таким анализом — все как на ладони и неоспоримо.
                                    🔥</p>
                            </div>
                            <div class="awake-reviews-item">
                                <div class="awake-reviews-item-top careerum-flex-fsc">
                                    <p class="awake-reviews-item-top-name">Ольга</p>
                                </div>
                                <div class="awake-reviews-item-stars">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752740451363-GmXdM-Rati.svg"
                                        alt="" />
                                </div>
                                <p class="awake-reviews-item-text">Открылись глаза на то, что у меня в принципе не правильно
                                    выстроена коммуникация с командой, они не пытаются самостоятельно найти и исправить ошибки и
                                    скидывают это на меня, при этом я осознала свои недработки — нет четких инструкций,
                                    чек-листов и критических точек для самоповерки.</p>
                            </div>
                            <div class="awake-reviews-item">
                                <div class="awake-reviews-item-top careerum-flex-fsc">
                                    <p class="awake-reviews-item-top-name">Марина Р.</p>
                                </div>
                                <div class="awake-reviews-item-stars">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752740451363-GmXdM-Rati.svg"
                                        alt="" />
                                </div>
                                <p class="awake-reviews-item-text">Посмотрела 1 урок 2 модуля и в восторге! Как он точно отразил
                                    что произошло у меня на работе)) Я на прошлой неделе упомянула что обучаюсь на курсе по
                                    внедрению AI в бизнес процессы... и вуаля. От руководителя прилетает задачка найти
                                    инструмент для автоматизации сбора информации))</p>
                            </div>
                            <div class="awake-reviews-item">
                                <div class="awake-reviews-item-top careerum-flex-fsc">
                                    <p class="awake-reviews-item-top-name">Анонимно</p>
                                </div>
                                <div class="awake-reviews-item-stars">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752740451363-GmXdM-Rati.svg"
                                        alt="" />
                                </div>
                                <p class="awake-reviews-item-text">Приятно удивило качество ответов на запросы, выходящие далеко
                                    за рамки стандартного фирменного рисерча в сети. Очень неожиданные глубокие вопросы,
                                    максимально емкая и содержательная обратная связь и прекрасные предложения по следующим
                                    шагам, действительно привязанным к первоначальной задаче. </p>
                            </div>
                            <div class="awake-reviews-item">
                                <div class="awake-reviews-item-top careerum-flex-fsc">
                                    <p class="awake-reviews-item-top-name">Анонимно</p>
                                </div>
                                <div class="awake-reviews-item-stars">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752740451363-GmXdM-Rati.svg"
                                        alt="" />
                                </div>
                                <p class="awake-reviews-item-text">Работала с DeepSeek. Помог по шагам структурировать задачу, я
                                    в процессе общения с ним, но уже довольна, пропал страх пустого экрана, действительно!) Рада
                                    тому, что задания открываются постепенно. Есть ощущение распределенной нагрузки и
                                    возможности поразмыслить над каждым заданием пару дней. Спасибо🙌</p>
                            </div>
                            <div class="awake-reviews-item">
                                <div class="awake-reviews-item-top careerum-flex-fsc">
                                    <p class="awake-reviews-item-top-name">Инна C.</p>
                                </div>
                                <div class="awake-reviews-item-stars">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752740451363-GmXdM-Rati.svg"
                                        alt="" />
                                </div>
                                <p class="awake-reviews-item-text">Хочу поделиться результатом выполнения домашек на примере
                                    подготовки презентации с Copilot: сегодня ее одобрила мой менеджер и даже не просила ничего
                                    дополнительно править. Это успех! 🎉</p>
                            </div>
                            <div class="awake-reviews-item">
                                <div class="awake-reviews-item-top careerum-flex-fsc">
                                    <p class="awake-reviews-item-top-name">Анна</p>
                                </div>
                                <div class="awake-reviews-item-stars">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752740451363-GmXdM-Rati.svg"
                                        alt="" />
                                </div>
                                <p class="awake-reviews-item-text">Решала личную задачу с DeepSeek. Впечатлена этим режимом — не
                                    перегружает информацией, сразу даёт квалифицированную гипотезу. Перестраивается в
                                    зависимости от моего ответа. Мега полезный способ 🔥</p>
                            </div>
                            <div class="awake-reviews-item">
                                <div class="awake-reviews-item-top careerum-flex-fsc">
                                    <p class="awake-reviews-item-top-name">Анонимно</p>
                                </div>
                                <div class="awake-reviews-item-stars">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752740451363-GmXdM-Rati.svg"
                                        alt="" />
                                </div>
                                <p class="awake-reviews-item-text">Использовала ГПТ. Очень классно и структурно ему удалось
                                    нащупать проблему — мне нра)) Если в процессе стратегии и уточнения все выглядело очевидно,
                                    то тут он прямо ходил по мозолям. Действительно было ощущение эксперта. Очень нравится
                                    структурность и возможность именно упаковать мысли и подумать об него. </p>
                            </div>
                        </div>
                        <div class="awake-reviews-slider-nav careerum-flex-fec">
                            <div class="awake-reviews-nav-prev careerum-flex-cc">
                                <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                                        stroke-linecap="round" stroke-linejoin="round">
                                    </path>
                                    <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white"
                                        stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                                </svg>
                            </div>
                            <div class="awake-reviews-nav-next careerum-flex-cc">
                                <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201"
                                        stroke-linecap="round" stroke-linejoin="round">
                                    </path>
                                    <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white"
                                        stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round"></path>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <a onclick="" href="#buy" class="btn-color-black">Вернуться за 9 900 ₽ в месяц</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-alumni-tariffs', {
        label: 'Careerum alumni tariffs',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div data-timer="" custom-link-anchor="buy"
                class="careerum-awake-tariffs careerum-club50-tariffs main-wrapper club0326-tariffs careerum-alumni-tariffs">
                <div class="careerum-container-responsive">
                    <div class="awake-tariffs-top">
                        <h2 class="inline-block">Тариф</h2>
                    </div>
                    <div class="awake-tariffs-switchers careerum-flex-sbfs">
                        <div class="awake-tariffs-period-wrapper">
                            <div class="awake-tariffs-period careerum-flex-fsst">
                                <ul class="careerum-flex-fsfs not-m1 m1">
                                    <li data-period="1" id="ikpkr5o" class="active">
                                        <p class="hidden-mobile">1 месяц</p>
                                        <p class="hidden-desc-tablet">1 меc</p>
                                    </li>
                                    <li data-period="3" class="hidden">
                                        <p class="hidden-mobile">3 месяца</p>
                                        <p class="hidden-desc-tablet">3 меc</p>
                                    </li>
                                    <li data-period="6" class="hidden">
                                        <p class="hidden-mobile">6 месяцев</p>
                                        <p class="hidden-desc-tablet">6 мес</p>
                                    </li>
                                    <li data-period="12" class="hidden">
                                        <p class="hidden-mobile">12 месяцев</p>
                                        <p class="hidden-desc-tablet">12 мес</p>
                                    </li>
                                </ul>
                                <div class="awake-tariffs-notif careerum-flex-cc">
                                    <div class="awake-tariffs-notif-icon"> <img loading=""
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                            alt=""> </div>
                                    <div class="awake-tariffs-notif-content">
                                        <p>1 месяц подписки предоставляет 30 дней доступа
                                            к платформе</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="awake-tariffs-curr careerum-flex-fsst">
                            <ul class="careerum-flex-fsfs rub">
                                <li data-currency="eur">EUR</li>
                                <li data-currency="rub" class="active">RUB</li>
                            </ul>
                            <div class="awake-tariffs-notif careerum-flex-cc">
                                <div class="awake-tariffs-notif-icon"> <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                        alt=""> </div>
                                <div class="awake-tariffs-notif-content">
                                    <p>Оплата в российских рублях возможна только картой
                                        российского банка.
                                        В евро — картой
                                        зарубежного банка</p>
                                </div>
                            </div>
                        </div>
                        <div class="awake-tariffs-curr-mobile">
                            <div class="awake-tariffs__swicher-block">
                                <div class="awake-tariffs__swicher-top">
                                    <p class="awake-tariffs__swicher-header">Посмотреть
                                        цены в
                                        <span>EUR</span>
                                    </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" class="awake-tariffs__swicher-arrow">
                                        <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black">
                                        </path>
                                    </svg>
                                </div>
                                <div class="awake-tariffs__swicher-bottom">
                                    <ul>
                                        <li data-currency="rub" class="active">
                                            RUB
                                        </li>
                                        <li data-currency="eur" class="">
                                            EUR
                                        </li>
                                    </ul>
                                    <p>
                                        Обратите внимание,<br> что оплата в российских
                                        рублях
                                        возможна только<br> с карты
                                        российского банка. Оплата в евро — с карты зарубежного банка
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="levelup-tariffs-bottom position-relative z-1 hidden">
                        <img loading="lazy" src="https://cdn.careerum.com/1770290624643-Ure4F-Grou.svg" alt="img"
                            class="hidden-tablet-mobile position-absolute z-1">
                        <img loading="lazy" src="https://cdn.careerum.com/1770292590407-9aSjH-Grou.svg" alt="img"
                            class="hidden-desc-mobile position-absolute z-1">
                        <img loading="lazy" src="https://cdn.careerum.com/1770300210002-bGAyJ-Grou.svg" alt="img"
                            class="hidden-desc-tablet position-absolute z-1">
                        <div class="levelup-tariffs-bottom-wrapper careerum-flex-sbc position-relative z-10">
                            <div class="levelup-tariffs-bottom-text">
                                <p>6 личных консультаций </p>
                                <p>с карьерными экспертами</p>
                                <p>При покупке тарифа «Индивидуальное сопровождение» на 3
                                    месяца</p>
                            </div>
                            <div class="levelup-tariffs-bottom-img"><img loading="lazy"
                                    src="https://cdn.careerum.com/1770290593483-tgXd1-Grou.png" alt="img"
                                    class="hidden-tablet-mobile"><img loading="lazy"
                                    src="https://cdn.careerum.com/1770292559690-AtfKf-Grou.png" alt="img"
                                    class="hidden-desc-mobile"><img loading="lazy"
                                    src="https://cdn.careerum.com/1770300179775-V9as8-Grou.png" alt="img"
                                    class="hidden-desc-tablet"></div>
                        </div>
                    </div>
                    <div class="awake-tariffs-items-wrapper elements-2">
                        <div class="awake-tariffs-items careerum-flex-fsst">
                            <div data-price="" data-price-1m-rub="50 000 ₽" data-oldprice-1m-rub="12 900 ₽"
                                data-discount-1m-rub="-31%" data-price-3m-rub="8 900 ₽" data-fullprice-3m-rub="26 700 ₽"
                                data-oldprice-3m-rub="38 700 ₽" data-discount-3m-rub="-31%" data-price-6m-rub="8 900 ₽"
                                data-oldprice-6m-rub="" data-discount-6m-rub="" data-fullprice-6m-rub="53 400 ₽"
                                data-price-12m-rub="6 900 ₽" data-fullprice-12m-rub="82 800 ₽" data-discount-12m-rub="–22%"
                                data-oldprice-12m-rub="106 800 ₽" data-price-1m-eur="500 €" data-oldprice-1m-eur="149 €"
                                data-discount-1m-eur="–39%" data-price-3m-eur="89 €" data-fullprice-3m-eur="267 €"
                                data-oldprice-3m-eur="447 €" data-discount-3m-eur="–39%" data-price-6m-eur="89 €"
                                data-fullprice-6m-eur="534 €" data-oldprice-6m-eur="" data-discount-6m-eur=" %"
                                data-price-12m-eur="69 €" data-fullprice-12m-eur="828 €" data-oldprice-12m-eur="1 068 €"
                                data-discount-12m-eur="–22%" data-offer-1m-rub="27" data-offer-3m-rub="94"
                                data-offer-6m-rub="95" data-offer-12m-rub="96" data-offer-1m-eur="48" data-offer-3m-eur="97"
                                data-offer-6m-eur="98" data-offer-12m-eur="99" id="i2th66z"
                                class="awake-tariffs-item careerum-flex-fsfs hidden m1">
                                <div class="awake-tariffs-item-header blue">
                                    <div class="careerum-flex-fsc awake-tariffs-item-header-wrapper">
                                        <div class="awake-tariffs-item-header-label careerum-flex-fsc blue"><img
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321987-1A2dc-Fire.svg"
                                                alt="img" id="ikakmgf">
                                            <p id="i16jue7">Без подписки</p>
                                        </div>
                                        <div class="awake-tariffs-item-header-places careerum-flex-fsc hidden">
                                            <p id="iveg60e">Доступно мест: неограниченно
                                            </p>
                                        </div>
                                    </div>
                                    <p class="awake-tariffs-item-header hidden-mobile">
                                        Стратегическая сессия
                                    </p>
                                    <div class="awake-tariffs-item-header-places careerum-flex-fsc hidden">
                                        <p id="i70j1li">Доступно мест: неограниченно</p>
                                    </div>
                                    <p class="awake-tariffs-item-header hidden-desc-tablet">Стратегическая сессия</p>
                                </div>
                                <div class="awake-tariffs-item-content">
                                    <ul>
                                        <li class="careerum-flex-fsfs"><img
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p id="i7z91s">Онлайн-встреча 2 часа</p>
                                        </li>
                                        <li class="careerum-flex-fsfs"><img
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p id="i93qoe">Разборы вашего запроса</p>
                                        </li>
                                        <li class="careerum-flex-fsfs"><img
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p id="ievhjrk">Запись встречи</p>
                                        </li>
                                        <li class="careerum-flex-fsfs"><img
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p id="iuhl77g">Документ с карьерной
                                                стратегией и пошаговым планом действий</p>
                                        </li>
                                        <li class="careerum-flex-fsfs disabled hidden">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321524-Xduv4-XCir.svg"
                                                alt="">
                                            <p id="ie71os">2 личные консультации с
                                                карьерными экспертами в месяц</p>
                                        </li>
                                    </ul>
                                </div>
                                <div class="awake-tariffs-item-footer">
                                    <div class="awake-tariffs-item-discount hidden-m1 hidden-m3 hidden-m6">
                                        <p class="awake-tariffs-item-discount"></p>
                                        <p class="awake-tariffs-item-oldprice"></p>
                                    </div>
                                    <div class="awake-tariffs-item-price careerum-flex-fsfs">
                                        <p class="awake-tariffs-item-fullprice-amount">50
                                            000 ₽</p>
                                        <p class="awake-tariffs-item-price-separator">/
                                        </p>
                                        <div>
                                            <p class="awake-tariffs-item-price-amount">
                                            </p>
                                            <p class="awake-tariffs-item-price-text">цена
                                                месяца</p>
                                        </div>
                                    </div>
                                    <div class="awake-tariffs-item-rassr careerum-flex-fsc hidden-m1"><img loading=""
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753885469183-Cyal7-Cred.svg"
                                            alt="img">
                                        <p>Доступно в рассрочку</p>
                                    </div>
                                    <div class="awake-tariffs-item-link"> <a onclick=""
                                            href="https://school.careerum.ru/anketa_strat" target="_blank"
                                            class="no-change no-popup getparams btn-color-main-black">Заполнить
                                            анкету на сессию</a> </div>
                                </div>
                            </div>
                            <div data-price="" data-price-1m-rub="14 900 ₽" data-oldprice-1m-rub="" data-discount-1m-rub=" %"
                                data-price-3m-rub="14 000 ₽" data-fullprice-3m-rub="42 000 ₽" data-oldprice-3m-rub="44 700 ₽"
                                data-discount-3m-rub="-6%" data-price-6m-rub="13 000 ₽" data-fullprice-6m-rub="78 000 ₽"
                                data-oldprice-6m-rub="89 400 ₽" data-discount-6m-rub="-13%" data-price-12m-rub="10 000 ₽"
                                data-fullprice-12m-rub="120 000 ₽" data-oldprice-12m-rub="178 800 ₽"
                                data-discount-12m-rub="-33%" data-price-1m-eur="199 €" data-oldprice-1m-eur=""
                                data-discount-1m-eur=" %" data-price-3m-eur="180 €" data-fullprice-3m-eur="540 €"
                                data-oldprice-3m-eur="597 €" data-discount-3m-eur="-10%" data-price-6m-eur="150 €"
                                data-fullprice-6m-eur="900 €" data-oldprice-6m-eur="1 194 €" data-discount-6m-eur="-25%"
                                data-price-12m-eur="110 €" data-fullprice-12m-eur="1 320 €" data-oldprice-12m-eur="2 388 €"
                                data-discount-12m-eur="-45%" data-offer-1m-rub="28" data-offer-3m-rub="29"
                                data-offer-6m-rub="30" data-offer-12m-rub="31" data-offer-1m-eur="49" data-offer-3m-eur="50"
                                data-offer-6m-eur="51" data-offer-12m-eur="52"
                                class="awake-tariffs-item careerum-flex-fsfs selected m1">
                                <div class="awake-tariffs-item-header blue">
                                    <div class="careerum-flex-fsc awake-tariffs-item-header-wrapper">
                                        <div class="awake-tariffs-item-header-label careerum-flex-fsc blue">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321987-1A2dc-Fire.svg"
                                                alt="img" id="ircs4fi">
                                            <p id="if6k6r">Групповой формат</p>
                                        </div>
                                        <div id="we34434543"
                                            class="awake-tariffs-item-header-places careerum-flex-fsc hidden-mobile hidden">
                                            <p id="izzaui1">Доступно мест: 50</p>
                                        </div>
                                    </div>
                                    <div class="awake-tariffs-item-header-places careerum-flex-fsc hidden">
                                        <p id="im6eoc">Доступно мест: 50</p>
                                    </div>
                                    <p class="awake-tariffs-item-header">С поддержкой
                                        экспертов</p>
                                </div>
                                <div class="awake-tariffs-item-content">
                                    <div id="i3hvtcf" class="awake-tariffs-item-content-img hidden">
                                        <img loading="lazy"
                                            src="https://storage.yandexcloud.net/cdn.careerum.com/1790679978943-TDoDy-Fram.png"
                                            alt="img" class="hidden-tablet-mobile z-1">
                                        <img loading="lazy"
                                            src="https://storage.yandexcloud.net/cdn.careerum.com/1790679980725-ZXlak-Fram.png"
                                            alt="img" class="hidden-desc-mobile z-1">
                                        <img loading="lazy"
                                            src="https://storage.yandexcloud.net/cdn.careerum.com/1790679982503-QzfAY-Fram.png"
                                            alt="img" class="hidden-desc-tablet z-1">
                                    </div>
                                    <ul id="i0bftjk">
                                        <li class="careerum-flex-fsfs">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p id="ig8huz">Образовательный трек по вашей
                                                задаче на платформе&nbsp;</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p id="ibe0t48">Фидбэк от карьерных стратегов
                                                на онлайн-эфирах: разборы кейсов, позиций, рынков, отраслей, рисков при переходе
                                            </p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p id="ilnalff">Поддержка экспертов в чате
                                            </p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p id="i5d0e9f">Доступ в карьерный клуб</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p id="ilgrri">Экспертные онлайн-эфиры клуба
                                            </p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p id="igyn7u8">6 шаблонов резюме RU и EN</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p id="ivdl8jk">AI-сервис проверки резюме</p>
                                        </li>
                                        <li class="careerum-flex-fsfs disabled">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321524-Xduv4-XCir.svg"
                                                alt="">
                                            <p id="in8jjp">2 личные консультации с
                                                карьерными экспертами в месяц</p>
                                        </li>
                                    </ul>
                                </div>
                                <div class="awake-tariffs-item-footer">
                                    <div class="awake-tariffs-item-discount hidden-m1">
                                        <p class="awake-tariffs-item-discount"></p>
                                        <p class="awake-tariffs-item-oldprice"></p>
                                    </div>
                                    <div class="awake-tariffs-item-price careerum-flex-fsc">
                                        <p class="awake-tariffs-item-fullprice-amount old">14
                                            900 ₽</p>
                                        <p class="awake-tariffs-item-price-separator">/
                                        </p>
                                        <div>
                                            <p class="awake-tariffs-item-price-amount2">9 900 ₽
                                            </p>
                                            <p class="awake-tariffs-item-price-text hidden">цена
                                                месяца</p>
                                        </div>
                                    </div>
                                    <div class="awake-tariffs-item-rassr careerum-flex-fsc hidden-m1"><img loading=""
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753885469183-Cyal7-Cred.svg"
                                            alt="img">
                                        <p id="i73qlr">Доступно в рассрочку</p>
                                    </div>
                                    <div class="awake-tariffs-item-link"><a onclick=""
                                            href="https://school.careerum.ru/anketa_club" target="_blank"
                                            class="btn-color-main-black no-change no-popup getparams">Вернуться</a></div>
                                </div>
                            </div>
                            <div data-price="" data-price-1m-rub="33 900 ₽" data-oldprice-1m-rub="" data-discount-1m-rub=" %"
                                data-price-3m-rub="33 000 ₽" data-fullprice-3m-rub="99 000 ₽" data-oldprice-3m-rub="101 700 ₽"
                                data-discount-3m-rub="-3%" data-price-6m-rub="29 000 ₽" data-fullprice-6m-rub="174 000 ₽"
                                data-oldprice-6m-rub="203 400 ₽" data-discount-6m-rub="-14%" data-price-12m-rub="22 000 ₽"
                                data-fullprice-12m-rub="264 000 ₽" data-oldprice-12m-rub="406 800 ₽"
                                data-discount-12m-rub="-35%" data-price-1m-eur="360 €" data-oldprice-1m-eur=""
                                data-discount-1m-eur=" %" data-price-3m-eur="330 €" data-fullprice-3m-eur="990 €"
                                data-oldprice-3m-eur="1 080 €" data-discount-3m-eur="-8%" data-price-6m-eur="290 €"
                                data-fullprice-6m-eur="1 740 €" data-oldprice-6m-eur="2 160 €" data-discount-6m-eur="-19%"
                                data-price-12m-eur="245 €" data-fullprice-12m-eur="2 940 €" data-oldprice-12m-eur="4 320 €"
                                data-discount-12m-eur="-32%" data-offer-1m-rub="32" data-offer-3m-rub="100"
                                data-offer-6m-rub="101" data-offer-12m-rub="102" data-offer-1m-eur="53" data-offer-3m-eur="103"
                                data-offer-6m-eur="104" data-offer-12m-eur="105"
                                class="awake-tariffs-item careerum-flex-fsfs hidden">
                                <div id="iczbjnn" class="awake-tariffs-item-header dark">
                                    <div id="ixklgyb" class="careerum-flex-fsc awake-tariffs-item-header-wrapper">
                                        <div class="awake-tariffs-item-header-label careerum-flex-fsc white"><img
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321867-adLt2-Meda.svg"
                                                alt="img">
                                            <p id="ipqink">Личная работа с экспертом</p>
                                        </div>
                                        <div id="iuylvnx"
                                            class="awake-tariffs-item-header-places careerum-flex-fsc white hidden-mobile hidden">
                                            <p id="isxdkni">Доступно мест: 20</p>
                                        </div>
                                    </div>
                                    <div id="isxbwxc" class="awake-tariffs-item-header-places careerum-flex-fsc white hidden">
                                        <p id="ia0w82">Доступно мест: 20</p>
                                    </div>
                                    <p class="awake-tariffs-item-header">Индивидуальное
                                        сопровождение</p>
                                </div>
                                <div class="awake-tariffs-item-content">
                                    <div class="awake-tariffs-item-content-img hidden">
                                        <img loading="lazy"
                                            src="https://storage.yandexcloud.net/cdn.careerum.com/1790595171402-gGb72-Fram.png"
                                            alt="img" class="hidden-tablet-mobile z-1"><img loading="lazy"
                                            src="https://storage.yandexcloud.net/cdn.careerum.com/1790595206955-HXkrq-Fram.png"
                                            alt="img" class="hidden-desc-mobile z-1"><img loading="lazy"
                                            src="https://storage.yandexcloud.net/cdn.careerum.com/1790595241408-r1yBJ-Fram.png"
                                            alt="img" class="hidden-desc-tablet z-1">
                                    </div>
                                    <ul id="ibwoxqe">
                                        <li class="careerum-flex-fsfs">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <div id="iy7rlcx">
                                                <p id="io5nige">2 личные консультации с
                                                    карьерными экспертами в месяц:
                                                </p>
                                                <ul id="i9pffw6">
                                                    <li data-period="1" id="i8ydmf">
                                                        <p id="ikbowlq">Онбординговая
                                                            сессия на 30 минут с коучем для формирование целей на работу с
                                                            экспертом</p>
                                                    </li>
                                                    <li data-period="1" id="i9grlge">
                                                        <p id="ij7ubcn">Разработка
                                                            стратегии</p>
                                                    </li>
                                                    <li data-period="1" id="isc5jpc">
                                                        <p id="iy5yglu">Персональный
                                                            разбор резюме</p>
                                                    </li>
                                                    <li data-period="1" id="ivem9l9">
                                                        <p id="iych3ow">Персональный
                                                            разбор Linkedin </p>
                                                    </li>
                                                    <li data-period="1" id="iqdfnjw">
                                                        <p id="ip82mmf">Тренировочные
                                                            собеседования или любой другой ваш карьерный запрос</p>
                                                    </li>
                                                    <li data-period="1" id="i3aovnm">
                                                        <p id="i729ouc">Личный чат с
                                                            экспертом и коучем</p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p id="ij9pqa8">Образовательный трек по вашей
                                                задаче на платформе </p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p id="itajai">Фидбэк от карьерных стратегов
                                                на онлайн-эфирах: разборы кейсов, позиций, рынков, отраслей, рисков при переходе
                                            </p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p id="iu240c">Поддержка экспертов в общем
                                                чате: ответы на вопросы, разборы кейсов в анонимном формате</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p id="id4adww">Доступ в карьерный клуб</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p id="ipkvpq">Экспертные онлайн-эфиры клуба
                                            </p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p id="i6vlfhi">6 шаблонов резюме RU и EN</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p id="i5fxzs7">AI-сервис проверки резюме</p>
                                        </li>
                                    </ul>
                                </div>
                                <div class="awake-tariffs-item-footer">
                                    <div class="awake-tariffs-item-discount hidden-m1">
                                        <p class="awake-tariffs-item-discount"></p>
                                        <p class="awake-tariffs-item-oldprice"></p>
                                    </div>
                                    <div class="awake-tariffs-item-price careerum-flex-fsfs">
                                        <p class="awake-tariffs-item-fullprice-amount">33
                                            900 ₽</p>
                                        <p class="awake-tariffs-item-price-separator">/
                                        </p>
                                        <div>
                                            <p class="awake-tariffs-item-price-amount">
                                            </p>
                                            <p class="awake-tariffs-item-price-text">цена
                                                месяца</p>
                                        </div>
                                    </div>
                                    <div class="awake-tariffs-item-rassr careerum-flex-fsc hidden-m1"><img loading=""
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753885469183-Cyal7-Cred.svg"
                                            alt="img">
                                        <p>Доступно в рассрочку</p>
                                    </div>
                                    <div class="awake-tariffs-item-notif hidden">
                                        <p>Места закончились</p>
                                        <p>Оставьте заявку в лист ожидания, если у нас
                                            освободится место, то наши карьерные консультанты свяжутся с вами</p>
                                    </div>
                                    <div class="awake-tariffs-item-link">
                                        <a onclick="" href="https://school.careerum.ru/anketa_club" target="_blank"
                                            class="no-change no-popup getparams btn-color-main-black">Вернуться</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-alumni-main2', {
        label: 'Careerum alumni main2',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-alumni-main2 main-wrapper position-relative">
                <img src="https://cdn.careerum.com/1792400646956-gGj7W-Fram.svg" class="hidden-mobile position-absolute z-1"
                    alt="img" loading="lazy">
                <img src="https://cdn.careerum.com/1792424088622-3mP54-Fram.svg" class="hidden-desc-tablet position-absolute z-1" alt="img" loading="lazy">
                <div class="careerum-container-responsive position-relative z-10 careerum-flex-sbfs">
                    <div class="alumni-main-left position-relative z-10">
                        <div class="alumni-main-labels">
                            <p>3 месяца в клубе Careerum</p>
                            <p class="border">с хедлайнером Ольгой Лермонтовой</p>
                        </div>
                        <div class="alumni-main-header position-relative">
                            <h1 class="position-relative z-10">Professional <span>Longevity</span></h1>
                            <img src="https://cdn.careerum.com/1792401186485-7OD7B-Grou.png"
                                class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1792415672482-qJAco-Grou.svg"
                                class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1792419983693-Qfj0K-Grou.svg"
                                class="hidden-desc-tablet position-absolute z-1" alt="img" loading="lazy">
                        </div>
                        <p class="alumni-main-subheader">Большое профессиональное будущее — на ваших условиях</p>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1792402128055-8z7tm-Soft.svg" alt="">
                                <p>Оставайтесь востребованной — и через 20 лет</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1792402128055-8z7tm-Soft.svg" alt="">
                                <p>Хорошо зарабатывайте, сохраняя силы на жизнь</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1792402128055-8z7tm-Soft.svg" alt="">
                                <p>Верните себе интерес к тому, что делаете каждый день</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1792402128055-8z7tm-Soft.svg" alt="">
                                <p>Меняйте роли, сохраняя ценность всего, что уже умеете</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://cdn.careerum.com/1792402128055-8z7tm-Soft.svg" alt="">
                                <p>Выбирайте, сколько работать и ради чего</p>
                            </li>
                        </ul>
                    </div>
                    <div class="alumni-main-right position-relative z-1">
                        <img src="https://cdn.careerum.com/1792401659414-uO3CK-Fram.png"
                            class="hidden-tablet-mobile position-absolute" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1792415890330-KMEFX-Ð¡Ð¾.png"
                            class="hidden-desc-mobile position-absolute" alt="img" loading="lazy">
                        <img src="https://cdn.careerum.com/1792420318272-gG5cf-Ð¡Ð¾.png"
                            class="hidden-desc-tablet position-absolute" alt="img" loading="lazy">
                    </div>
                    <a href="#buy" class="btn-color-black position-relative">Присоединиться к Careerum</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-alumni-what', {
        label: 'Careerum alumni what',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-alumni-what main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Что будет в подписке?</h2>
                    <p class="alumni-what-subheader">Можно прийти с конкретной задачей, обсудить то, что волнует, или услышать,
                        как с похожими вопросами справляются участники комьюнити</p>
                    <div class="alumni-what-content careerum-flex-sbst">
                        <div class="alumni-what-item">
                            <img src="https://cdn.careerum.com/1792407266127-60CSS-Fram.svg" alt="">
                            <p>Все встречи по календарю</p>
                        </div>
                        <div class="alumni-what-item">
                            <img src="https://cdn.careerum.com/1792407266231-76Zxf-Fram.svg" alt="">
                            <p>Поддержка коучей и экспертов – в любой момент</p>
                        </div>
                        <div class="alumni-what-item">
                            <img src="https://cdn.careerum.com/1792407266257-VXZcz-Fram.svg" alt="">
                            <p>Образовательный трек под вашу задачу</p>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-alumni-tariffs2', {
        label: 'Careerum alumni tariffs2',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-awake-tariffs careerum-club50-tariffs main-wrapper club0326-tariffs careerum-alumni-tariffs2">
                <div class="careerum-container-responsive">
                    <div class="awake-tariffs-top">
                        <h2 class="inline-block">Тарифы</h2>
                    </div>
                    <div class="awake-tariffs-switchers careerum-flex-sbfs">
                        <div class="awake-tariffs-period-wrapper hidden">
                            <div class="awake-tariffs-period careerum-flex-fsst">
                                <ul class="careerum-flex-fsfs not-m1 m1">
                                    <li data-period="1" id="ikpkr5o" class="active">
                                        <p class="hidden-mobile">1 месяц</p>
                                        <p class="hidden-desc-tablet">1 меc</p>
                                    </li>
                                    <li data-period="3" class="hidden">
                                        <p class="hidden-mobile">3 месяца</p>
                                        <p class="hidden-desc-tablet">3 меc</p>
                                    </li>
                                    <li data-period="6" class="hidden">
                                        <p class="hidden-mobile">6 месяцев</p>
                                        <p class="hidden-desc-tablet">6 мес</p>
                                    </li>
                                    <li data-period="12" class="hidden">
                                        <p class="hidden-mobile">12 месяцев</p>
                                        <p class="hidden-desc-tablet">12 мес</p>
                                    </li>
                                </ul>
                                <div class="awake-tariffs-notif careerum-flex-cc">
                                    <div class="awake-tariffs-notif-icon"> <img loading=""
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                            alt=""> </div>
                                    <div class="awake-tariffs-notif-content">
                                        <p>1 месяц подписки предоставляет 30 дней доступа
                                            к платформе</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="awake-tariffs-curr careerum-flex-fsst">
                            <ul class="careerum-flex-fsfs rub">
                                <li data-currency="eur">EUR</li>
                                <li data-currency="rub" class="active">RUB</li>
                            </ul>
                            <div class="awake-tariffs-notif careerum-flex-cc">
                                <div class="awake-tariffs-notif-icon"> <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                        alt=""> </div>
                                <div class="awake-tariffs-notif-content">
                                    <p>Оплата в российских рублях возможна только картой
                                        российского банка.
                                        В евро — картой
                                        зарубежного банка</p>
                                </div>
                            </div>
                        </div>
                        <div class="awake-tariffs-curr-mobile">
                            <div class="awake-tariffs__swicher-block">
                                <div class="awake-tariffs__swicher-top">
                                    <p class="awake-tariffs__swicher-header">Посмотреть
                                        цены в
                                        <span>EUR</span>
                                    </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" class="awake-tariffs__swicher-arrow">
                                        <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black">
                                        </path>
                                    </svg>
                                </div>
                                <div class="awake-tariffs__swicher-bottom">
                                    <ul>
                                        <li data-currency="rub" class="active">
                                            RUB
                                        </li>
                                        <li data-currency="eur" class="">
                                            EUR
                                        </li>
                                    </ul>
                                    <p>
                                        Обратите внимание,<br> что оплата в российских
                                        рублях
                                        возможна только<br> с карты
                                        российского банка. Оплата в евро — с карты зарубежного банка
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="alumni-tariffs-top">
                        <p>С поддержкой экспертов</p>
                    </div>
                    <div class="awake-tariffs-items-wrapper">
                        <div class="awake-tariffs-items careerum-flex-fsst">
                            <div class="alumni-tariffs-item">
                                <p class="alumni-tariffs-item-header">Что входит:</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                            alt="">
                                        <p id="ig8huz">Митапы, специальные события и ноябрьские мероприятия с Ольгой Лермонтовой
                                        </p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                            alt="">
                                        <p id="ibe0t48">Карьерный клуб — профессиональное сообщество и экспертные онлайн-эфиры
                                        </p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                            alt="">
                                        <p id="ilnalff">Поддержка экспертов в чате: вопросы по вашей карьерной ситуации</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                            alt="">
                                        <p id="i5d0e9f">Обратная связь карьерных стратегов на эфирах: разборы кейсов, позиций,
                                            рынков, отраслей и рисков перехода</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                            alt="">
                                        <p id="ilgrri">Образовательный трек на платформе по вашей задаче.</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                            alt="">
                                        <p id="igyn7u8">6 шаблонов резюме RU и EN</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                            alt="">
                                        <p id="ivdl8jk">AI-сервис проверки резюме</p>
                                    </li>
                                </ul>

                            </div>
                            <div data-price="" data-price-1m-rub="14 900 ₽" data-oldprice-1m-rub="14 901 ₽"
                                data-discount-1m-rub=" %" data-price-3m-rub="14 000 ₽" data-fullprice-3m-rub="42 000 ₽"
                                data-oldprice-3m-rub="44 700 ₽" data-discount-3m-rub="-6%" data-price-6m-rub="13 000 ₽"
                                data-fullprice-6m-rub="78 000 ₽" data-oldprice-6m-rub="89 400 ₽" data-discount-6m-rub="-13%"
                                data-price-12m-rub="10 000 ₽" data-fullprice-12m-rub="120 000 ₽"
                                data-oldprice-12m-rub="178 800 ₽" data-discount-12m-rub="-33%" data-price-1m-eur="149 €"
                                data-oldprice-1m-eur="" data-discount-1m-eur=" %" data-price-3m-eur="180 €"
                                data-fullprice-3m-eur="540 €" data-oldprice-3m-eur="597 €" data-discount-3m-eur="-10%"
                                data-price-6m-eur="150 €" data-fullprice-6m-eur="900 €" data-oldprice-6m-eur="1 194 €"
                                data-discount-6m-eur="-25%" data-price-12m-eur="110 €" data-fullprice-12m-eur="1 320 €"
                                data-oldprice-12m-eur="2 388 €" data-discount-12m-eur="-45%" data-offer-1m-rub="28"
                                data-offer-3m-rub="29" data-offer-6m-rub="30" data-offer-12m-rub="31" data-offer-1m-eur="49"
                                data-offer-3m-eur="50" data-offer-6m-eur="51" data-offer-12m-eur="52"
                                class="awake-tariffs-item careerum-flex-fsfs transparent">
                                <div class="awake-tariffs-item-header">
                                    <p class="awake-tariffs-item-header">Выберите удобный срок:</p>
                                </div>
                                <div class="awake-tariffs-item-footer">
                                    <p class="alumni-tariffs-period">1 месяц</p>
                                    <div class="awake-tariffs-item-discount hidden-m1">
                                        <p class="awake-tariffs-item-discount"></p>
                                        <p class="awake-tariffs-item-oldprice"></p>
                                    </div>
                                    <div class="awake-tariffs-item-price careerum-flex-fsc">
                                        <p class="awake-tariffs-item-fullprice-amount old">14
                                            900 ₽</p>
                                        <p class="awake-tariffs-item-price-separator">/
                                        </p>
                                        <div>
                                            <p class="awake-tariffs-item-price-amount2 awake-tariffs-item-oldprice">
                                                9 900 ₽
                                            </p>
                                            <p class="awake-tariffs-item-price-text hidden">цена
                                                месяца</p>
                                        </div>
                                    </div>
                                    <div class="alumni-tariffs-content">
                                        <p class="alumni-tariffs-content-header hidden-eur">42 000 ₽ – общая цена 3 месяцев с
                                            такой
                                            подпиской</p>
                                        <p class="alumni-tariffs-content-header hidden-rub">420 € – общая цена 3 месяцев с такой
                                            подпиской</p>
                                        <p class="alumni-tariffs-content-text">* Продление возможно только при наличии свободных
                                            мест</p>
                                        <p class="alumni-tariffs-content-header2">Свободно – <span>  300  </span> 100 мест</p>
                                        <div class="alumni-tariffs-content-divider">
                                            <div></div>
                                        </div>
                                    </div>
                                    <div class="awake-tariffs-item-rassr careerum-flex-fsc hidden-m1">
                                        <img loading=""
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753885469183-Cyal7-Cred.svg"
                                            alt="img">
                                        <p id="i73qlr">Доступно в рассрочку</p>
                                    </div>
                                    <div class="awake-tariffs-item-link">
                                        <a onclick="" href="#tariff2-support" target="_blank" class="btn-color-main-black">Хочу
                                            на месяц</a>
                                    </div>
                                </div>
                            </div>
                            <div data-price="" data-price-1m-rub="29 700 ₽" data-oldprice-1m-rub="" data-discount-1m-rub="-30 %"
                                data-price-3m-rub="33 000 ₽" data-fullprice-3m-rub="99 000 ₽" data-oldprice-3m-rub="101 700 ₽"
                                data-discount-3m-rub="-3%" data-price-6m-rub="29 000 ₽" data-fullprice-6m-rub="174 000 ₽"
                                data-oldprice-6m-rub="203 400 ₽" data-discount-6m-rub="-14%" data-price-12m-rub="22 000 ₽"
                                data-fullprice-12m-rub="264 000 ₽" data-oldprice-12m-rub="406 800 ₽"
                                data-discount-12m-rub="-35%" data-price-1m-eur="360 €" data-oldprice-1m-eur=""
                                data-discount-1m-eur="-30 %" data-price-3m-eur="297 €" data-fullprice-3m-eur="990 €"
                                data-oldprice-3m-eur="1 080 €" data-discount-3m-eur="-8%" data-price-6m-eur="290 €"
                                data-fullprice-6m-eur="1 740 €" data-oldprice-6m-eur="2 160 €" data-discount-6m-eur="-19%"
                                data-price-12m-eur="245 €" data-fullprice-12m-eur="2 940 €" data-oldprice-12m-eur="4 320 €"
                                data-discount-12m-eur="-32%" data-offer-1m-rub="32" data-offer-3m-rub="100"
                                data-offer-6m-rub="101" data-offer-12m-rub="102" data-offer-1m-eur="53" data-offer-3m-eur="103"
                                data-offer-6m-eur="104" data-offer-12m-eur="105"
                                class="awake-tariffs-item careerum-flex-fsfs blue discount-1">
                                <div id="iczbjnn" class="awake-tariffs-item-header">
                                    <div id="ixklgyb" class="careerum-flex-cc awake-tariffs-item-header-wrapper">
                                        <div class="awake-tariffs-item-header-label careerum-flex-cc ">
                                            <img src="https://cdn.careerum.com/1792412878132-kQkH6-Fire.svg" alt="img">
                                            <p id="ipqink">Выгоднее</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="awake-tariffs-item-footer">
                                    <p class="alumni-tariffs-period">3 месяца</p>
                                    <div class="awake-tariffs-item-discount hidden">
                                        <p class="awake-tariffs-item-discount"></p>
                                        <p class="awake-tariffs-item-oldprice"></p>
                                    </div>
                                    <div class="awake-tariffs-item-price careerum-flex-fsfs position-relative">
                                        <p class="awake-tariffs-item-price-amount">33
                                            900 ₽</p>
                                        <p class="awake-tariffs-item-discount position-absolute"></p>
                                        <p class="awake-tariffs-item-price-separator">/
                                        </p>
                                        <div>
                                            <p class="awake-tariffs-item-price-amount">
                                            </p>
                                            <p class="awake-tariffs-item-price-text">цена
                                                месяца</p>
                                        </div>
                                    </div>
                                    <div class="alumni-tariffs-content">
                                        <p class="alumni-tariffs-content-header hidden-rub">Одним платежом вместо <span>420 €
                                            </span>
                                        </p>
                                        <p class="alumni-tariffs-content-header hidden-eur">Одним платежом вместо <span>42 000 ₽
                                            </span>
                                        </p>
                                        <div class="careerum-flex-fsfs">
                                            <img src="https://cdn.careerum.com/1792413779147-YzfHK-Fram.svg" alt="">
                                            <p>Место закреплено за вами до конца срока подписки!</p>
                                        </div>
                                    </div>
                                    <div class="awake-tariffs-item-rassr careerum-flex-fsc hidden-m1">
                                        <img loading=""
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753885469183-Cyal7-Cred.svg"
                                            alt="img">
                                        <p>Доступно в рассрочку</p>
                                    </div>
                                    <div class="awake-tariffs-item-notif hidden">
                                        <p>Места закончились</p>
                                        <p>Оставьте заявку в лист ожидания, если у нас
                                            освободится место, то наши карьерные консультанты свяжутся с
                                            вами</p>
                                    </div>
                                    <div class="awake-tariffs-item-link">
                                        <a onclick="" href="#tariff2-support3" target="_blank"
                                            class="no-change btn-color-main-black">Хочу на 3 месяца</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-alumni-banner', {
        label: 'Careerum alumni banner',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-alumni-banner main-wrapper">
                <div class="careerum-container-responsive careerum-flex-sbc">
                    <div class="alumni-banner-left">
                        <h2>Хочу индивидуальную работу с экспертами</h2>
                        <img src="https://cdn.careerum.com/1792423016125-8H7pP-Fram.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                        <a onclick="" href="#" target="_blank" class="no-change btn-color-main-black">Заполнить анкету в
                            Careerum</a>
                    </div>
                    <div class="alumni-banner-right">
                        <img src="https://cdn.careerum.com/1792415222764-ilQKA-Fram.png" class="hidden-tablet-mobile" alt="img"
                            loading="lazy">
                        <img src="https://cdn.careerum.com/1792419463611-KORMv-Fram.png" class="hidden-desc-mobile" alt="img"
                            loading="lazy">
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-bigpack_career-main', {
        label: 'Careerum bigpack_career main',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-bigpack_career-main main-wrapper">
                <div class="careerum-container-responsive">
                    <div class="bigpack_career-main-logo">
                        <img src="https://cdn.careerum.com/1792561703663-JoPOk-logo.svg" class="hidden-tablet-mobile" alt="img"
                            loading="eager">
                        <img src="https://cdn.careerum.com/1792567374902-jY6Sa-logo.svg" class="hidden-desc" alt="img" loading="eager">
                    </div>
                    <div class="bigpack_career-main-wrapper position-relative z-1 careerum-flex-sbfs">
                        <div class="bigpack_career-main-left position-relative z-10">
                            <div class="bigpack_career-main-labels">
                                <p>Big Pack от Ольги Лермонтовой</p>
                            </div>
                            <div class="bigpack_career-main-left-header position-relative">
                                <h1>Карьерный биохакинг</h1>
                                <p class="position-absolute">Без БАДов и холодных ванн</p>
                            </div>
                            <p class="bigpack_career-main-subtitle">Professional Longevity</p>
                            <p class="bigpack_career-main-text">10 писем, 10 исследований, 10 практик. Чтобы сделать следующие
                                20 лет работы счастливее предыдущих</p>
                        </div>
                        <div class="bigpack_career-main-right position-relative z-1">
                            <img src="https://cdn.careerum.com/1792561703415-Az6ly-Fram.png"
                                class="hidden-tablet-mobile position-absolute" alt="img" loading="eager">
                            <img src="https://cdn.careerum.com/1792567374805-aS6GA-Fram.png" class="hidden-desc-mobile position-absolute" alt="img"
                                loading="eager">
                            <img src="https://cdn.careerum.com/1792571618049-yxiye-Fram.png" class="hidden-desc-tablet position-absolute" alt="img"
                                loading="eager">
                        </div>
                    </div>
                    <a href="#buy" class="btn-color-black position-relative z-10">Подписаться на рассылку</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-bigpack_career-who', {
        label: 'Careerum bigpack_career who',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-bigpack_career-who main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Для кого эта практика в письмах?</h2>
                    <div class="bigpack_career-who-wrapper careerum-flex-sbst">
                        <div class="bigpack_career-who-item img bg position-relative">
                            <div class="bigpack_career-who-item-wrapper position-relative">
                                <p class="bigpack_career-who-item-title position-relative z-10">«Всё умею, но ничего не хочу»
                                </p>
                                <p class="bigpack_career-who-item-text position-relative z-10">Разберём, куда девается интерес
                                    и любопытство к работе у зрелых профи</p>
                                <img src="https://cdn.careerum.com/1792561703633-rMKif-Fram.png"
                                    class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1792567374777-yZCyO-Fram.png" class="hidden-desc-mobile position-absolute z-1" alt="img"
                                    loading="lazy">
                                <img src="https://cdn.careerum.com/1792571794173-21jyL-Fram.png" class="hidden-desc-tablet position-absolute z-1" alt="img"
                                    loading="lazy">
                            </div>
                        </div>
                        <div class="bigpack_career-who-item bg1 position-relative">
                            <div class="bigpack_career-who-item-wrapper position-relative">
                                <p class="bigpack_career-who-item-title position-relative z-10">«Ещё лет двадцать — и на пенсию»
                                </p>
                                <p class="bigpack_career-who-item-text position-relative z-10">Обсудим, почему 20 лет —
                                    это не довесок к классной жизни, а время, когда можно стать счастливее в деятельности</p>
                            </div>
                        </div>
                        <div class="bigpack_career-who-item bg2 position-relative">
                            <div class="bigpack_career-who-item-wrapper position-relative">
                                <p class="bigpack_career-who-item-title position-relative z-10">«Сначала пойму, чего хочу, —
                                    потом
                                    начну»</p>
                                <p class="bigpack_career-who-item-text position-relative z-10">Объясню, почему это ловушка
                                    мозга,
                                    которая никогда не работает. И покажу, как начать действовать</p>
                            </div>
                        </div>
                        <div class="bigpack_career-who-item bg bgm position-relative">
                            <div class="bigpack_career-who-item-wrapper position-relative">
                                <p class="bigpack_career-who-item-title position-relative z-10">«Мне за сорок. Меня обгонят те,
                                    кому
                                    двадцать пять»</p>
                                <p class="bigpack_career-who-item-text position-relative z-10">Посмотрим, какая часть вашего
                                    опыта
                                    с годами только дорожает, и как её показать рынку</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-bigpack_career-letters', {
        label: 'Careerum bigpack_career letters',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-bigpack_career-letters main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Каждый день — одно исследование и одна практика</h2>
                    <div class="bigpack_career-letters-wrapper careerum-flex-sbst">
                        <div class="bigpack_career-letters-item white">
                            <div class="bigpack_career-letters-item-number careerum-flex-fsfe">
                                <p>1</p>
                                <p>письмо</p>
                            </div>
                            <p class="bigpack_career-letters-item-type blue">Тест</p>
                            <p class="bigpack_career-letters-item-title">Что работа
                                давала вам раньше и что не даёт теперь?</p>
                            <p class="bigpack_career-letters-item-text">Учёные-медики считают не только годы жизни, но и годы
                                <span>здоровой</span> жизни. С карьерой так же. Узнайте, какая часть вашего стажа по‑настоящему
                                здоровая.
                            </p>
                        </div>
                        <div class="bigpack_career-letters-item blue">
                            <div class="bigpack_career-letters-item-number careerum-flex-fsfe">
                                <p>2</p>
                                <p>письмо</p>
                            </div>
                            <p class="bigpack_career-letters-item-type white">Практика: карта карьеры</p>
                            <p class="bigpack_career-letters-item-title">До пенсии ещё 20 лет. Дотянуть или работать
                                с удовольствием?</p>
                            <p class="bigpack_career-letters-item-text">Нарисуете карту карьеры, отметите, где уже побывали,
                                и увидите, сколько лет пути у вас на самом деле впереди</p>
                        </div>
                        <div class="bigpack_career-letters-item dark">
                            <div class="bigpack_career-letters-item-number careerum-flex-fsfe">
                                <p>3</p>
                                <p>письмо</p>
                            </div>
                            <p class="bigpack_career-letters-item-type light-blue">Практика: примерочная ролей</p>
                            <p class="bigpack_career-letters-item-title">Не знаете, чего хотите? Примерьте разное!</p>
                            <p class="bigpack_career-letters-item-text">Переберёте возможные версии себя и выберете одну,
                                которую можно безопасно примерить за 2 недели</p>
                        </div>
                        <div class="bigpack_career-letters-item wide orange rotate1">
                            <div class="bigpack_career-letters-item-number careerum-flex-fsfe">
                                <p>4</p>
                                <p>письмо</p>
                            </div>
                            <p class="bigpack_career-letters-item-type white">Практика: ревизия навыков</p>
                            <p class="bigpack_career-letters-item-title">39% ваших навыков скоро изменятся. Но какие именно?</p>
                            <p class="bigpack_career-letters-item-text">Разложите опыт на «пора обновить», «дорожает с годами»
                                и «давно прокисли» — и сверите с тем, что ищет рынок</p>
                        </div>
                        <div class="bigpack_career-letters-item wide white">
                            <div class="bigpack_career-letters-item-number careerum-flex-fsfe">
                                <p>5</p>
                                <p>письмо</p>
                            </div>
                            <p class="bigpack_career-letters-item-type blue">Практика: тест «Ваш опыт как актив»</p>
                            <p class="bigpack_career-letters-item-title">Как зарабатывать хорошо не только сейчас, но и через 
                                15 лет?</p>
                            <p class="bigpack_career-letters-item-text">Узнаете, что мешает вашему доходу расти: вас не видят,
                                вы не растёте, недооцениваете себя или соглашаетесь не на те предложения?</p>
                        </div>
                        <div class="bigpack_career-letters-item blue">
                            <div class="bigpack_career-letters-item-number careerum-flex-fsfe">
                                <p>6</p>
                                <p>письмо</p>
                            </div>
                            <p class="bigpack_career-letters-item-type white">Практика: краш-тест карьеры</p>
                            <p class="bigpack_career-letters-item-title">Что будет, если ваша компания исчезнет в понедельник?
                            </p>
                            <p class="bigpack_career-letters-item-text">Уберёте главную опору и посмотрите, что останется.
                                А потом решите, какую новую опору достраивать первой</p>
                        </div>
                        <div class="bigpack_career-letters-item dark">
                            <div class="bigpack_career-letters-item-number careerum-flex-fsfe">
                                <p>7</p>
                                <p>письмо</p>
                            </div>
                            <p class="bigpack_career-letters-item-type white">Практика: проверка ресурсов</p>
                            <p class="bigpack_career-letters-item-title">Что вы унесёте с собой, если покинете текущую работу?
                            </p>
                            <p class="bigpack_career-letters-item-text">Разделите всё, что у вас есть, на то, что останется
                                в компании, и то, что уйдёт вместе с вами</p>
                        </div>
                        <div class="bigpack_career-letters-item light-blue">
                            <div class="bigpack_career-letters-item-number careerum-flex-fsfe">
                                <p>8</p>
                                <p>письмо</p>
                            </div>
                            <p class="bigpack_career-letters-item-type white-blue">Практика: карта энергии</p>
                            <p class="bigpack_career-letters-item-title">Главный триггер выгорания вовсе не количество работы.
                                А что тогда?</p>
                            <p class="bigpack_career-letters-item-text">Отметите задачи своей недели и увидите,
                                что вас заряжает, а что незаметно выкачивает из вас жизненные силы</p>
                        </div>
                        <div class="bigpack_career-letters-item wide white">
                            <div class="bigpack_career-letters-item-number careerum-flex-fsfe">
                                <p>9</p>
                                <p>письмо</p>
                            </div>
                            <p class="bigpack_career-letters-item-type blue">Практика: меню любопытства</p>
                            <p class="bigpack_career-letters-item-title">Всё умею, но почему мне ничего не хочется?</p>
                            <p class="bigpack_career-letters-item-text">Найдёте, что на работе стало пресным, и вспомните,
                                что вас до сих пор по‑настоящему цепляет</p>
                        </div>
                        <div class="bigpack_career-letters-item wide orange rotate2">
                            <div class="bigpack_career-letters-item-number careerum-flex-fsfe">
                                <p>10</p>
                                <p>письмо</p>
                            </div>
                            <p class="bigpack_career-letters-item-type white">Практика: модель профессионального долголетия</p>
                            <p class="bigpack_career-letters-item-title">Как пересобрать карьеру, не начиная с нуля?</p>
                            <p class="bigpack_career-letters-item-text">Финал серии: собираем все детали в вашу личную модель
                                профессионального долголетия</p>
                        </div>
                    </div>
                    <a href="#buy" class="btn-color-black position-relative z-10">Хочу получить все письма </a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-bigpack_career-result', {
        label: 'Careerum bigpack_career result',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-bigpack_career-result main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Через 10 дней вы поймёте:</h2>
                    <div class="bigpack_career-result-wrapper careerum-flex-sbst">
                        <div class="bigpack_career-result-item">
                            <p class="bigpack_career-result-item-number">01</p>
                            <p class="bigpack_career-result-item-title">Куда двигаться дальше</p>
                            <p class="bigpack_career-result-item-text">Что в работе ещё ваше, а что вы переросли. И почему опыт
                                после 40 — не повод бояться молодых и ИИ, а ваше преимущество</p>
                        </div>
                        <div class="bigpack_career-result-item">
                            <p class="bigpack_career-result-item-number">02</p>
                            <p class="bigpack_career-result-item-title">Сколько вы стоите</p>
                            <p class="bigpack_career-result-item-text">Где вы сами делаете себе скидку, на чём держится
                                ваш доход, кроме одной работы, и что уйдёт с вами из любой компании</p>
                        </div>
                        <div class="bigpack_career-result-item">
                            <p class="bigpack_career-result-item-number">03</p>
                            <p class="bigpack_career-result-item-title">Как вернуть интерес и любопытство</p>
                            <p class="bigpack_career-result-item-text">Куда утекают силы, почему «всё умею, но ничего
                                не хочется» лечится не отпуском — и с чего начать перемены, ничего не бросая</p>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-bigpack_career-form', {
        label: 'Careerum bigpack_career form',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-bigpack_career-form main-wrapper">
                <div class="careerum-container-responsive careerum-flex-sbst">
                    <div class="bigpack_career-form-header">
                        <h2>Следующие годы работы могут стать счастливее предыдущих</h2>
                        <p class="bigpack_career-form-header-text">Начните с простого — пройдите 10 практик, и вы увидите, что всё это реально</p>
                    </div>
                    <div class="bigpack_career-form-wrapper">
                        <div class="careerum-registration-form-club40">
                            <form class="deva-form getcourse-email-signup careerum-flex-fsfs" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-telegram">
                                    <input type="text" value="" name="telegram" required placeholder="Telegram">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                    <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="form-buttons">
                                    <a href="#" class="submit-btn btn-color-black" disabled>Получить первое письмо</a>
                                    <div class="careerum-club40-form-agree">
                                        <label>
                                            <input type="checkbox" name="agree">
                                            <div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                    fill="none">
                                                    <path
                                                        d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                        stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </label>
                                        <p>Я даю согласие
                                            на обработку персональных данных
                                            в соответствии с <a href="/ru-ru/legal/privacy">Политикой
                                                конфиденциальности</a>
                                        </p>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-alumni-thanks', {
        label: 'Careerum bigpack_career thanks',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-bigpack_career-thanks main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <div class="bigpack_career-main-logo">
                        <img src="https://cdn.careerum.com/1792561703663-JoPOk-logo.svg" class="hidden-tablet-mobile" alt="img"
                            loading="eager">
                        <img src="https://cdn.careerum.com/1792567374902-jY6Sa-logo.svg" class="hidden-desc" alt="img" loading="eager">
                    </div>
                    <h2 class="position-relative z-10">Отлично, я уже собрала ваш бокс:</h2>
                    <p class="position-relative z-10">первое письмо прилетит с минуты на минуту</p>
                    <div class="bigpack_career-thanks-author position-relative z-10 careerum-flex-fsfs">
                        <div class="bigpack_career-thanks-author-img position-relative z-1">
                            <img src="https://cdn.careerum.com/1792566866995-2AA00-Grou.png" class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1792567374669-WZ7jt-Grou.png" class="hidden-desc-mobile position-absolute z-1" alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1792574507790-qzGPN-Grou.png" class="hidden-desc-tablet position-absolute z-1" alt="img" loading="lazy">
                        </div>
                        <div class="bigpack_career-thanks-author-description position-relative z-10">
                            <p class="bigpack_career-thanks-author-name">Ольга Лермонтова</p>
                            <p class="bigpack_career-thanks-author-position">СЕО Careerum</p>
                        </div>
                    </div>
                    <img src="https://cdn.careerum.com/1792567111376-avodw-Grou.svg" class="hidden-tablet-mobile position-absolute z-1" alt="img"
                        loading="lazy">
                    <img src="https://cdn.careerum.com/1792567374598-EqOJi-Grou.svg" class="hidden-desc-mobile position-absolute z-1" alt="img"
                        loading="lazy">
                    <img src="https://cdn.careerum.com/1792574507941-kQUHh-Grou.svg" class="hidden-desc-tablet position-absolute z-1" alt="img"
                        loading="lazy">
                </div>
            </div>`
    });
    
    blockManager.add('careerum-media-kit2-nav', {
        label: 'Careerum media kit2 nav',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-media-kit2-nav" aria-label="Разделы">
            <div class="careerum-wrap">
            <a class="media-kit2-nav__name" href="#top">Ольга Лермонтова</a>
            <div class="media-kit2-nav__links">
                <a href="#topics">Темы</a>
                <a href="#reviews">Отзывы</a>
                <a href="#video">Видео</a>
                <a href="#media">Эфиры</a>
                <a href="#bio">Биография</a>
                <a href="#photos">Фото</a>
            </div>
            <a class="media-kit2-btn btn--navy btn--sm" href="#booking">Пригласить</a>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-media-kit2-hero', {
        label: 'Careerum media kit2 hero',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-media-kit2-hero">
            <div class="careerum-wrap media-kit2-hero__in">
            <div>
                <p class="media-kit2-eyebrow">Медиа-кит · обновлён в октябре 2026</p>
                <h1>Следующие сорок лет работы — <em>по своим правилам</em></h1>
                <p class="media-kit2-hero__sub">Профессиональное долголетие: как собрать рабочую жизнь вокруг себя, а не себя
                вокруг работы
                — чтобы она давала энергию, а не забирала. Гарвардские исследования, 15 000 кейсов из 61 страны мира.</p>
                <p class="media-kit2-hero__meta">Исследовательница профессионального долголетия · основательница Careerum ·
                двадцать лет в
                Microsoft, Google и Adobe · MBA INSEAD · ICF · Harvard Extension School · автор бестселлера «Работа по любви»
                </p>
                <div class="media-kit2-hero__cta">
                <a class="media-kit2-btn btn--cream" href="#booking">Пригласить в эфир</a>
                <a class="media-kit2-btn btn--ghost-light" href="#topics">Темы для выпуска</a>
                </div>
            </div>
            <div class="media-kit2-hero__photo">
                <img src="https://cdn.careerum.com/1793209295884-p3DFs-ÐÐµ.jpg" alt="Ольга Лермонтова">
            </div>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-media-kit2-marks', {
        label: 'Careerum media kit2 marks',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-media-kit2-marks">
            <div class="careerum-wrap">
            <div class="media-kit2-marks-mgrp"><span>Два десятилетия в</span>
                <div><b>Microsoft</b><b>Google</b><b>Adobe</b><b>McAfee</b><b>Travelport</b><b>Careerum</b></div>
            </div>
            <div class="media-kit2-marks-mgrp"><span>Образование</span>
                <div><b>INSEAD</b><b>Harvard Extension School</b></div>
            </div>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-media-kit2-audience', {
        label: 'Careerum media kit2 audience',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-section careerum-media-kit2-audience">
            <div class="careerum-wrap">
            <div class="careerum-sec-head">
                <p class="media-kit2-eyebrow">Аудитория</p>
                <h2>2 млн+ охвата в месяц и аудитория, которая отвечает.</h2>
            </div>
            <div class="media-kit2-aud">
                <div class="media-kit2-aud__card">
                <span class="media-kit2-aud__num">2 млн+<small>охват в месяц</small></span>
                <span class="media-kit2-aud__label">Все площадки</span>
                <span class="media-kit2-aud__meta">суммарно</span>
                </div>
                <a class="media-kit2-aud__card" href="https://www.instagram.com/lermontova.career/" target="_blank"
                rel="noopener">
                <span class="media-kit2-aud__num">266 000<small>подписчиков</small></span>
                <span class="media-kit2-aud__label">Instagram</span>
                <span class="media-kit2-aud__meta">@lermontova.career</span>
                </a>
                <a class="media-kit2-aud__card" href="https://www.youtube.com/@olgalermontova" target="_blank" rel="noopener">
                <span class="media-kit2-aud__num">49 300<small>подписчиков</small></span>
                <span class="media-kit2-aud__label">YouTube</span>
                <span class="media-kit2-aud__meta">@olgalermontova</span>
                </a>
                <a class="media-kit2-aud__card" href="https://t.me/dreamcatchme" target="_blank" rel="noopener">
                <span class="media-kit2-aud__num">27 000<small>подписчиков</small></span>
                <span class="media-kit2-aud__label">Telegram</span>
                <span class="media-kit2-aud__meta">«Нагуглила карьеру»</span>
                </a>
            </div>
            <div class="media-kit2-portrait">
                <h3>Кто эти люди</h3>
                <div>
                <p class="media-kit2-portrait__who">Женщины 30–55 лет: senior-специалисты, руководители, фаундеры, HR и
                    консультантки.
                    Аудитория, которая не ставит лайки, а спорит и пишет развёрнутые ответы.</p>
                <p class="media-kit2-portrait__geo">Европа (Франция, Германия, Польша, Кипр, Великобритания, Италия и другие),
                    США,
                    Канада, ОАЭ, Россия и страны СНГ.</p>
                </div>
            </div>
            <div class="media-kit2-datarow">
                <h3>Данные, которых нет в открытых исследованиях</h3>
                <p class="media-kit2-datarow__lead">Каждый, кто приходит в Careerum, до первого разговора своими словами
                описывает, что
                происходит с его работой. За год — 2 183 таких описания. Это не опрос: человек не выбирает готовый вариант,
                а сам формулирует, что у него не складывается. Поэтому здесь видно, какими словами рынок описывает свои
                проблемы — и как состав этих людей расходится с тем, что принято о них думать.</p>
                <div class="media-kit2-datarow__grid">
                <div><b>8%</b><span>боятся, что ИИ сделает их роль ненужной. Половина, наоборот, видит в нём возможность для
                    роста</span></div>
                <div><b>1,8%</b><span>при этом владеют ИИ продвинуто. Разрыв не в страхе, а в навыке</span></div>
                <div><b>28%</b><span>руководители и C-level; ещё каждый шестой — менеджер проектов или продукта</span></div>
                <div><b>38 / 24 / 14</b><span>на какой рынок смотрят, в процентах: Россия, Евросоюз, глобальная
                    удалёнка</span></div>
                </div>
                <p class="media-kit2-datarow__note">Декабрь 2025 — сентябрь 2026, 2 183 человека; больше четверти — из ИТ,
                дальше
                финансы, маркетинг, продажи и HR. Блок вопросов про ИИ появился в анкете позже — на него ответили 542
                человека. Ольга комментирует рынок труда своими цифрами, а не ощущениями.</p>
            </div>

            <div class="media-kit2-pressrow">
                <span>Публикации и эфиры</span>
                <b>Forbes Woman</b><b>РБК Тренды</b><b>Сноб</b><b>Marie
                Claire</b><b>Т—Ж</b><b>Лайфхакер</b><b>vc.ru</b><b>Forbes Education</b>
            </div>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-media-kit2-topics', {
        label: 'Careerum media kit2 topics',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-section careerum-media-kit2-topics">
            <div class="careerum-wrap">
            <div class="careerum-sec-head">
                <p class="media-kit2-eyebrow">Темы для выпуска</p>
                <h2>Шесть разговоров о профессиональном долголетии.</h2>
                <p>Каждый — готовый сегмент на 60–90 минут: тезис, доказательная база и живые кейсы. Выберите тему или
                назовите аудиторию — адаптируем.</p>
            </div>
            <div class="media-kit2-angles">
                <article class="media-kit2-angle angle--wide">
                <span class="media-kit2-angle__tag">Главная тема</span>
                <h3>Впереди ещё сорок лет работы. Старая формула успеха на такой дистанции не выдерживает.</h3>
                <p>Модель «учёба — работа — пенсия» рассчитана на двадцать лет активной работы. Линда Грэттон и Эндрю Скотт
                    из London Business School показали: при нынешней продолжительности жизни работать придётся вдвое дольше. А
                    правила меняет ИИ — World Economic Forum оценивает, что к 2030 году изменятся 39% ключевых навыков.
                    Профессиональное долголетие отвечает на вопрос, как пройти эту дистанцию так, чтобы работа давала энергию.
                </p>
                <ul class="media-kit2-sigpoints">
                    <li>
                    <span class="media-kit2-sigicon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M12 3v9l6 3" />
                        <circle cx="12" cy="12" r="9" />
                        </svg></span>
                    <span><b>Амбиции конечны.</b> Сорок лет подряд хотеть «ещё выше» невозможно — это топливо заканчивается
                        или приводит к выгоранию.</span>
                    </li>
                    <li>
                    <span class="media-kit2-sigicon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M4 18l6-6 4 4 6-8" />
                        <path d="M14 4h6v6" />
                        </svg></span>
                    <span><b>Любопытство бесконечно.</b> Внутренняя мотивация — единственное, что работает на длинной
                        дистанции.</span>
                    </li>
                    <li>
                    <span class="media-kit2-sigicon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M3 20h18" />
                        <path d="M6 20V11M11 20V5M16 20v-7M21 20v-4" />
                        </svg></span>
                    <span><b>ИИ переписывает роли.</b> Исполнительская часть уходит первой — и это касается тех, кто считал
                        себя в безопасности. По расчётам WEF, из каждых ста работающих 59 придётся переучиваться, и 11 из них,
                        скорее всего, не получат такой возможности.</span>
                    </li>
                    <li>
                    <span class="media-kit2-sigicon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M4 12h15" />
                        <path d="M14 7l5 5-5 5" />
                        </svg></span>
                    <span><b>Будущее не угадывают.</b> Его проектируют — из того, что у вас уже есть. Инструменты вместо
                        прогнозов.</span>
                    </li>
                </ul>
                </article>

                <article class="media-kit2-angle">
                <span class="media-kit2-angle__tag">Право на лёгкость</span>
                <h3>Если постоянно тяжело — вы ошиблись с конфигурацией, а не плохо старались.</h3>
                <p>Долголетие не строится на силе воли. Чем отличается усталость от истощения — и почему страдание больше не
                    продаётся. Gallup второй год подряд фиксирует падение: вовлечённость в работу в мире — 20%, минимум за
                    пять лет, а потери от незаинтересованности оценивают в 9% мирового ВВП.</p>
                </article>

                <article class="media-kit2-angle">
                <span class="media-kit2-angle__tag">Job crafting</span>
                <h3>Работа по любви не лежит на сайтах вакансий. Она собирается вручную.</h3>
                <p>Передоговориться о правилах можно, не увольняясь: оставить 80% того, что драйвит, и убрать 20% того, что
                    истощает. Термин job crafting ввели Эми Вжесневски и Джейн Даттон в Academy of Management Review;
                    метаанализ 122 исследований связал его прежде всего с вовлечённостью в работу — сильнее, чем с любым
                    другим рабочим показателем.</p>
                </article>

                <article class="media-kit2-angle">
                <span class="media-kit2-angle__tag">Сезоны</span>
                <h3>В сорокалетней карьере не бывает всегда лета. Пауза — не провал.</h3>
                <p>Главы интенсивности сменяются зимой: замедлиться, переучиться, уделить время семье — без вины. В опросе
                    LinkedIn среди 23 тысяч человек паузу в работе брали 62%, и при этом 61% женщин уверены, что она до сих
                    пор читается как пятно в резюме.</p>
                </article>

                <article class="media-kit2-angle">
                <span class="media-kit2-angle__tag">Профессиональная дерзость</span>
                <h3>Право быть неудобным для системы, чтобы быть удобным для себя.</h3>
                <p>Сказать «не хочу быть руководителем», «я стою вдвое больше», «мне стало скучно» — и не извиняться. По
                    данным Visier, 62% специалистов не хотят управлять людьми: отказ от вертикали перестал быть признаком
                    слабой амбиции. Плюс семь собственных поворотов Ольги — от репетитора до основательницы компании.</p>
                </article>

                <article class="media-kit2-angle">
                <span class="media-kit2-angle__tag">Изнутри корпораций</span>
                <h3>Двадцать лет в Microsoft и Google: как карьеры на самом деле застревают.</h3>
                <p>Неромантичная механика спонсорства, видимости и внутренней политики — и почему сильнейшие застревают чаще
                    других. В исследованиях Сильвии Энн Хьюлетт темпом своего продвижения довольны 70% тех, у кого внутри
                    компании есть спонсор, и 57% тех, у кого его нет. Двадцать лет изнутри: Microsoft, Adobe, McAfee, Google,
                    Travelport, 25+ рынков Европы и Африки.</p>
                </article>
            </div>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-media-kit2-reviews', {
        label: 'Careerum media kit2 reviews',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-section careerum-media-kit2-reviews">
            <div class="careerum-wrap">
            <div class="careerum-sec-head">
                <p class="media-kit2-eyebrow">Отзывы на выступления</p>
                <h2>Что пишут зрители после эфиров.</h2>
                <p>Комментарии под выпусками, дословно. Каждый можно проверить по ссылке на видео.</p>
            </div>
            <div class="media-kit2-revwrap">
                <div class="media-kit2-revtrack" id="revtrack" tabindex="0" role="region"
                aria-label="Отзывы зрителей, прокручивается вбок">
                <figure class="media-kit2-rev">
                    <blockquote>Знаком с Олей с 2008 года, были коллегами в Microsoft! Видел весь её путь, прекрасный мастер!
                    </blockquote>
                    <figcaption><b>@AlekseyKroy</b><span>Роман Тарасенко</span><span class="media-kit2-rev__likes">♥ 131</span>
                    </figcaption>
                </figure>
                <figure class="media-kit2-rev">
                    <blockquote>Ольга крутая. Я, как человек, который был в терапии и который мучился муками самоопределения,
                    хорошо понимаю, о чём она говорит и слышу её ответы.</blockquote>
                    <figcaption><b>@alisa_wow_me</b><span>Роман Тарасенко</span><span class="media-kit2-rev__likes">♥ 32</span>
                    </figcaption>
                </figure>
                <figure class="media-kit2-rev">
                    <blockquote>Отличный совет про вопрос себе «Что я сейчас хочу». Помогает снять порой ложный блок-убеждение
                    «надо / обязан». Супер-штука для гиперответственных и напряжённых от своих же мыслей нас.</blockquote>
                    <figcaption><b>@leenaloo</b><span>Роман Тарасенко</span><span class="media-kit2-rev__likes">♥ 29</span>
                    </figcaption>
                </figure>
                <figure class="media-kit2-rev">
                    <blockquote>Одни и те же наборы талантов и способностей могут дать абсолютно разные профессии.
                    </blockquote>
                    <figcaption><b>@АннаДрагунова</b><span>Роман Тарасенко</span><span class="media-kit2-rev__likes">♥ 27</span>
                    </figcaption>
                </figure>
                <figure class="media-kit2-rev">
                    <blockquote>Интересный собеседник, много пользы от озвученных инструментов. Важно замечать себя в мелочах
                    и делать маленькие шаги навстречу своему «хочу».</blockquote>
                    <figcaption><b>@IrishDn</b><span>Роман Тарасенко</span><span class="media-kit2-rev__likes">♥ 23</span>
                    </figcaption>
                </figure>
                <figure class="media-kit2-rev">
                    <blockquote>Ольга говорит о правильной похвале. Этой теме посвящена целая книга «Гибкое сознание» Кэрол
                    Дуэк, профессора психологии Стэнфорда.</blockquote>
                    <figcaption><b>@tanya7918</b><span>Роман Тарасенко</span><span class="media-kit2-rev__likes">♥ 15</span>
                    </figcaption>
                </figure>
                <figure class="media-kit2-rev">
                    <blockquote>Ооох, какие открытия я вынесла из этого видео. Очень понравилось про минимальное время между
                    мыслью и действием.</blockquote>
                    <figcaption><b>@kseniadanilova3895</b><span>Роман Тарасенко</span><span class="media-kit2-rev__likes">♥
                        11</span>
                    </figcaption>
                </figure>
                <figure class="media-kit2-rev">
                    <blockquote>Как вы божественно говорите о карьере, мне даже захотелось её построить. Так многое хочется
                    смаковать: «согреваться о другую реальность», «убиваем аппетит риска»…</blockquote>
                    <figcaption><b>@nastya2503</b><span>Роман Тарасенко</span><span class="media-kit2-rev__likes">♥ 5</span>
                    </figcaption>
                </figure>
                <figure class="media-kit2-rev">
                    <blockquote>Сейчас как раз нахожусь в моральном дне, полгода не могу устроиться на работу. Выпуск про
                    внутреннюю опору и наконец-то научиться себя замечать. Буду следовать рекомендациям.</blockquote>
                    <figcaption><b>@GoodDay-vs8zr</b><span>Роман Тарасенко</span><span class="media-kit2-rev__likes">♥ 1</span>
                    </figcaption>
                </figure>
                <figure class="media-kit2-rev">
                    <blockquote>Прекрасный ведущий и умная гостья. Почерпнула много нового для себя. Особенно про другой
                    ракурс, как на себя смотреть.</blockquote>
                    <figcaption><b>@МаринаБелова</b><span>Подкаст Соколовского</span><span class="media-kit2-rev__likes">♥
                        1</span>
                    </figcaption>
                </figure>
                <figure class="media-kit2-rev">
                    <blockquote>Ольга, спасибо, что озвучиваете эту боль о том, что в СНГ считается правильным преодолевать
                    себя( Какой же это тупизм! И ещё людей стыдят, если не получается. Как было бы прекрасно, если бы
                    продвигался нарратив развивать именно сильные стороны, а не быть киборгом-перфекционистом!</blockquote>
                    <figcaption><b>@mariagolovkina9800</b><span>Канал @olgalermontova</span><span
                        class="media-kit2-rev__likes">♥
                        20</span></figcaption>
                </figure>
                </div>
                <div class="media-kit2-revnav">
                <button class="media-kit2-revbtn" type="button" id="revPrev" aria-label="Предыдущие отзывы">←</button>
                <button class="media-kit2-revbtn" type="button" id="revNext" aria-label="Следующие отзывы">→</button>
                </div>
            </div>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-media-kit2-video', {
        label: 'Careerum media kit2 video',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-section careerum-media-kit2-video">
            <div class="careerum-wrap">
            <div class="careerum-sec-head">
                <p class="media-kit2-eyebrow">Видео</p>
                <h2>Как Ольга держится в кадре.</h2>
                <p>Полные выпуски и разборы — на <a href="https://www.youtube.com/@olgalermontova" target="_blank"
                    rel="noopener" style="color:var(--wine);font-weight:700">канале @olgalermontova</a>.</p>
            </div>
            <div class="media-kit2-videos">
                <a class="media-kit2-vid" href="https://www.youtube.com/watch?v=vqGmRpV-tAw" target="_blank" rel="noopener">
                <span class="media-kit2-vid__frame"><img class="media-kit2-vid__thumb" src="https://cdn.careerum.com/1793209295336-js8Al-ÐÐµ.jpg"
                    alt=""><span class="media-kit2-vid__play" aria-hidden="true"></span><span
                    class="media-kit2-vid__views">752 тыс.
                    просмотров</span></span>
                <span class="media-kit2-vid__cap"><b>«Как быть востребованным в эпоху ИИ»</b>Подкаст Соколовского</span>
                </a>
                <a class="media-kit2-vid" href="https://www.youtube.com/watch?v=lDTjKRWoWTE" target="_blank" rel="noopener">
                <span class="media-kit2-vid__frame"><img class="media-kit2-vid__thumb" src="https://cdn.careerum.com/1793209295389-zHkmP-ÐÐµ.jpg"
                    alt=""><span class="media-kit2-vid__play" aria-hidden="true"></span><span
                    class="media-kit2-vid__views">102 тыс.
                    просмотров</span></span>
                <span class="media-kit2-vid__cap"><b>«Работа по любви. Миф или реальность?»</b>Роман Тарасенко</span>
                </a>
                <a class="media-kit2-vid" href="https://www.youtube.com/watch?v=z1Mm4xP_zy8" target="_blank" rel="noopener">
                <span class="media-kit2-vid__frame"><img class="media-kit2-vid__thumb" src="https://cdn.careerum.com/1793209295435-OUjfu-ÐÐµ.jpg"
                    alt=""><span class="media-kit2-vid__play" aria-hidden="true"></span><span class="media-kit2-vid__views">26
                    тыс.
                    просмотров</span></span>
                <span class="media-kit2-vid__cap"><b>«Куда пропали амбиции»</b>Канал @olgalermontova</span>
                </a>
            </div>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-media-kit2-media', {
        label: 'Careerum media kit2 media',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-section careerum-media-kit2-media">
            <div class="careerum-wrap ">
            <div class="careerum-sec-head">
                <p class="media-kit2-eyebrow">Эфиры и публикации</p>
                <h2>12 подкастов, 11 статей, два своих шоу и книга-бестселлер.</h2>
            </div>
            <div class="media-kit2-proof">
                <div class="media-kit2-stat"><b>752 тыс.</b><span>просмотров у выпуска с Соколовским</span></div>
                <div class="media-kit2-stat"><b>102 тыс.</b><span>просмотров у выпуска с Романом Тарасенко</span></div>
                <div class="media-kit2-stat"><b>15 000</b><span>клиентов Careerum из 61 страны мира</span></div>
                <div class="media-kit2-stat"><b>25+</b><span>рынков в корпоративных ролях</span></div>
            </div>
            <div class="media-kit2-cats">
                <details class="media-kit2-cat" open>
                <summary>
                    <h3>Подкасты<span class="count">12</span></h3><span class="media-kit2-toggle" aria-hidden="true"></span>
                </summary>
                <ul class="media-kit2-items">
                    <li><span class="kind">Подкаст Соколовского</span>
                    <div><a href="https://www.youtube.com/watch?v=vqGmRpV-tAw" target="_blank" rel="noopener">«Как быть
                        востребованным в эпоху ИИ»</a>
                        <p>752 тыс. просмотров, 2 702 комментария</p>
                    </div>
                    </li>
                    <li><span class="kind">Роман Тарасенко</span>
                    <div><a href="https://www.youtube.com/watch?v=lDTjKRWoWTE" target="_blank" rel="noopener">«Работа по
                        любви. Миф или реальность?»</a>
                        <p>102 тыс. просмотров</p>
                    </div>
                    </li>
                    <li><span class="kind">Поединок с Игорем Манном</span>
                    <div><a href="https://www.youtube.com/watch?v=7D8VXRjhRD8" target="_blank" rel="noopener">Существует ли
                        карьера по любви?</a></div>
                    </li>
                    <li><span class="kind">Forbes Education</span>
                    <div><a
                        href="https://stroki.mts.ru/podcast/episode/komu-ya-nuzhen-kakiye-navyki-trebuyutsya-dlya-karery-mechty-i-kak-ikh-razvivat-282331"
                        target="_blank" rel="noopener">«Кому я нужен? Какие навыки требуются для карьеры мечты»</a></div>
                    </li>
                    <li><span class="kind">План Б, Т—Ж</span>
                    <div><a href="https://zvuk.com/episode/119566806" target="_blank" rel="noopener">Как провести ревизию
                        навыков и конвертировать их на международную аудиторию</a></div>
                    </li>
                    <li><span class="kind">Поиск работы в IT</span>
                    <div><a
                        href="https://podcasts.apple.com/us/podcast/%D0%BF%D0%BE%D0%B8%D1%81%D0%BA-%D1%80%D0%B0%D0%B1%D0%BE%D1%82%D1%8B-%D0%B2-it-%D0%B8-%D0%BF%D0%B5%D1%80%D0%B5%D0%B5%D0%B7%D0%B4-%D0%B2-%D1%81%D1%88%D0%B0/id1501864022"
                        target="_blank" rel="noopener">«Как находят работу те, кто находит, в 2026 году»</a>
                        <p>Ведущая Анна Наумова</p>
                    </div>
                    </li>
                    <li><span class="kind">Несладкий бизнес</span>
                    <div><a href="https://notsweetbusiness.mave.digital/ep-104" target="_blank" rel="noopener">«Как найти
                        работу за рубежом?»</a></div>
                    </li>
                    <li><span class="kind">Это непросто, «Либо/Либо»</span>
                    <div><a href="https://podcasts.apple.com/us/podcast/id1437512522?i=1000558212978" target="_blank"
                        rel="noopener">«Мы нигде никому не нужны. Действуйте сами!» Как сейчас искать работу за границей</a>
                    </div>
                    </li>
                    <li><span class="kind">Не учи меня жить</span>
                    <div><a href="https://podcasts.apple.com/us/podcast/id1478524649?i=1000718766931" target="_blank"
                        rel="noopener">Как строить карьеру по своим правилам, с опорой на метанавыки и ценности</a>
                        <p>Ведущая Алена Борьессон</p>
                    </div>
                    </li>
                    <li><span class="kind">Дороже денег</span>
                    <div><a href="https://dorogedeneg.mave.digital/ep-5" target="_blank" rel="noopener">«Как найти работу по
                        душе и достичь успеха в карьере?»</a>
                        <p>Ведущая Ксения Падерина</p>
                    </div>
                    </li>
                    <li><span class="kind">Вог не смог</span>
                    <div><a href="https://open.spotify.com/episode/7dQ6jsPFP4I30CGOIoVvcR" target="_blank" rel="noopener">«Из
                        тётки в женщину»</a>
                        <p>Лайфстайл</p>
                    </div>
                    </li>
                    <li><span class="kind">Дом, в котором</span>
                    <div><a href="https://open.spotify.com/episode/0WQA5GjyvZlTWI1vpw3Dsn" target="_blank"
                        rel="noopener">Покупка и ремонт дома в Италии</a>
                        <p>Лайфстайл</p>
                    </div>
                    </li>
                </ul>
                </details>
                <details class="media-kit2-cat">
                <summary>
                    <h3>Статьи и колонки<span class="count">11</span></h3><span class="media-kit2-toggle"
                    aria-hidden="true"></span>
                </summary>
                <ul class="media-kit2-items">
                    <li><span class="kind">Forbes Woman</span>
                    <div><a
                        href="https://www.forbes.ru/forbes-woman/567667-horosaa-bor-ba-pocemu-zensinam-vazno-ucit-sa-zdorovoj-konkurencii-i-rabote-v-komande"
                        target="_blank" rel="noopener">«Здоровая конкуренция: как женщинам совмещать амбиции и командную
                        работу»</a></div>
                    </li>
                    <li><span class="kind">РБК Тренды</span>
                    <div><a href="https://trends.rbc.ru/trends/education/634d656e9a7947cbc0844bea" target="_blank"
                        rel="noopener">Как строить карьеру в VUCA-мире</a></div>
                    </li>
                    <li><span class="kind">РБК Тренды</span>
                    <div><a href="https://trends.rbc.ru/trends/innovation/669526ef9a7947258b4a6fd1" target="_blank"
                        rel="noopener">Эволюция бизнеса: чем плохи красные и хороши бирюзовые компании</a></div>
                    </li>
                    <li><span class="kind">Сноб</span>
                    <div><a href="https://snob.ru/news/187473/" target="_blank" rel="noopener">5 внутренних установок,
                        которые препятствуют карьерному росту</a></div>
                    </li>
                    <li><span class="kind">Сноб</span>
                    <div><a href="https://snob.ru/news/206890/" target="_blank" rel="noopener">Как обсуждать зарплату на
                        собеседовании</a></div>
                    </li>
                    <li><span class="kind">Т-Бизнес</span>
                    <div><a href="https://secrets.tbank.ru/lichnyj-opyt/olga-lermontova-biznes-ne-lekarstvo-ot-problem-2/"
                        target="_blank" rel="noopener">«Бизнес — это не лекарство от всех проблем»</a></div>
                    </li>
                    <li><span class="kind">Marie Claire</span>
                    <div><a href="https://www.marieclaire.ru/karera/poshagovyi-plan-kak-postroit-uspeshnuyu-kareru-bystro/"
                        target="_blank" rel="noopener">Пошаговый план: как построить успешную карьеру быстро</a></div>
                    </li>
                    <li><span class="kind">Лайфхакер</span>
                    <div><a href="https://lifehacker.ru/gendernoe-neravenstvo-na-rabote/" target="_blank" rel="noopener">О
                        гендерных стереотипах и неравенстве на работе</a></div>
                    </li>
                    <li><span class="kind">vc.ru</span>
                    <div><a href="https://vc.ru/flood/26329-foreign-work" target="_blank" rel="noopener">К чему готовиться
                        при переезде на работу в Европу</a></div>
                    </li>
                    <li><span class="kind">vc.ru</span>
                    <div><a
                        href="https://vc.ru/hr/223684-dotyanutsya-do-microsoft-kak-poluchit-offer-v-top-kompaniyu-rekomendacii-karernogo-koucha-olgi-lermontovoi"
                        target="_blank" rel="noopener">«Дотянуться до Microsoft: как получить оффер в топ-компанию»</a>
                    </div>
                    </li>
                    <li><span class="kind">vc.ru</span>
                    <div><a href="https://vc.ru/promo/373022-rynok-truda-v-krizise-a-kak-v-nem-iskat-svoyu-pervuyu-rabotu"
                        target="_blank" rel="noopener">«Рынок труда в кризисе. Как искать первую работу?»</a></div>
                    </li>
                </ul>
                </details>
                <details class="media-kit2-cat">
                <summary>
                    <h3>Свои проекты<span class="count">3</span></h3><span class="media-kit2-toggle" aria-hidden="true"></span>
                </summary>
                <ul class="media-kit2-items">
                    <li><span class="kind">Подкаст, ведущая</span>
                    <div><a
                        href="https://podcasts.apple.com/us/podcast/%D0%BD%D0%B0-%D1%81%D0%B2%D0%BE%D0%B5%D0%BC-%D0%BC%D0%B5%D1%81%D1%82%D0%B5/id1701617043"
                        target="_blank" rel="noopener">«На своём месте»</a>
                        <p>Лучший брендовый подкаст 2024 года по версии Яндекс Музыки</p>
                    </div>
                    </li>
                    <li><span class="kind">Подкаст, ведущая</span>
                    <div><a
                        href="https://podcasts.apple.com/us/podcast/%D0%BC%D1%8B-%D0%B2%D0%B0%D0%BC-%D0%BF%D0%B5%D1%80%D0%B5%D0%B7%D0%B2%D0%BE%D0%BD%D0%B8%D0%BC/id1576372228"
                        target="_blank" rel="noopener">«Мы вам перезвоним»</a></div>
                    </li>
                    <li><span class="kind">Книга, МИФ</span>
                    <div><a
                        href="https://litres.com/book/olga-lermontova-3161/rabota-po-lubvi-kak-postroit-uspeshnuu-kareru-i-prevr-66654646/"
                        target="_blank" rel="noopener">«Работа по любви»</a>
                        <p>Бестселлер издательства МИФ</p>
                    </div>
                    </li>
                </ul>
                </details>
            </div>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-media-kit2-bio', {
        label: 'Careerum media kit2 bio',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-section careerum-media-kit2-bio">
            <div class="careerum-wrap">
            <div class="careerum-sec-head">
                <p class="media-kit2-eyebrow">Биография</p>
                <h2>От репетитора в Москве до Google — и обратно.</h2>
                <p>Три версии текста для анонса. Выберите длину и скопируйте.</p>
            </div>
            <div class="media-kit2-bio-wrap">
                <div class="media-kit2-bio-photo"><img src="https://cdn.careerum.com/1793209295471-rxe9W-ÐÐµ.jpg" alt="Портрет Ольги Лермонтовой"
                    loading="lazy"></div>
                <div>
                <ul class="media-kit2-cv">
                    <li><span>2003–2008</span>Репетитор по языкам, Москва</li>
                    <li><span>2007–2012</span>Microsoft, Adobe, McAfee — Россия и СНГ</li>
                    <li><span>2012–2013</span>MBA INSEAD, Сингапур</li>
                    <li><span>2013–2016</span>Microsoft, штаб-квартира Западной Европы — 14 стран</li>
                    <li><span>2016–2017</span>Google, EMEA HQ, Дублин</li>
                    <li><span>2017–2021</span>Travelport, EMEA — Италия</li>
                    <li><span>2018 →</span>Основательница Careerum — 15 000 клиентов из 61 страны мира</li>
                    <li><span>Май 2027</span>Магистратура по психологии, Harvard Extension School</li>
                    <li><span>2026 →</span>
                    <div>Пересобирает <a href="https://careerum.com/ru-ru/promo/pro" target="_blank"
                        rel="noopener">Careerum</a> вокруг профессионального долголетия</div>
                    </li>
                </ul>
                <div class="media-kit2-tabs">
                    <div class="media-kit2-tabs__head" role="media-kit2-tablist" aria-label="Длина биографии">
                    <button class="media-kit2-tab" role="media-kit2-tab" aria-selected="true" aria-controls="b1" id="t1">Одна
                        строка</button>
                    <button class="media-kit2-tab" role="media-kit2-tab" aria-selected="false" aria-controls="b2" id="t2"
                        tabindex="-1">Подводка
                        ведущего</button>
                    <button class="media-kit2-tab" role="media-kit2-tab" aria-selected="false" aria-controls="b3" id="t3"
                        tabindex="-1">Полная</button>
                    </div>
                    <div class="media-kit2-bio" role="media-kit2-tabpanel" id="b1" aria-labelledby="t1">
                    <p>Ольга Лермонтова — карьерный стратег и исследователь, основательница платформы карьерного развития
                        Careerum. Двадцать лет работала в Microsoft, Google и Adobe, сейчас исследует карьерные переходы в
                        Harvard Extension School.</p>
                    </div>
                    <div class="media-kit2-bio" role="media-kit2-tabpanel" id="b2" aria-labelledby="t2" hidden>
                    <p>Сегодня у нас в гостях Ольга Лермонтова. Двадцать лет она строила карьеру в Microsoft, Google и
                        Adobe, отвечала за бизнес на 25+ рынках — а потом ушла, чтобы разобраться с вопросом, который её не
                        отпускал: почему успешные люди застревают в середине карьеры и что на самом деле помогает им
                        сдвинуться. С тех пор клиентами её платформы стали 15 000 человек из 61 страны мира, а сама она пошла
                        в магистратуру по психологии в Harvard Extension School. Её главный тезис: карьеру нельзя придумать,
                        её можно только проверить действием.</p>
                    </div>
                    <div class="media-kit2-bio" role="media-kit2-tabpanel" id="b3" aria-labelledby="t3" hidden>
                    <p>Ольга Лермонтова — карьерный стратег, исследователь и предприниматель. Двадцать лет она работала в
                        международных корпорациях Microsoft, Adobe, McAfee, Google и Travelport: от маркетинга и продаж до
                        руководящих ролей, отвечая за 25+ рынков Европы и Африки и живя в пяти странах. Окончила MBA INSEAD в
                        Сингапуре, имеет коучинговую сертификацию ICF.</p>
                    <p>В 2018 году запустила Careerum — платформу карьерного развития для русскоязычных профессионалов по
                        всему миру. Сегодня у платформы 15 000 клиентов из 61 страны мира. Опыт работы с ними привёл её
                        обратно в университет: она заканчивает магистратуру по психологии в Harvard Extension School, где
                        исследует, как люди перестраивают профессиональную идентичность в середине карьеры.</p>
                    <p>Это исследование легло в основу новой концепции Careerum, которую Ольга собирает вокруг
                        профессионального долголетия. Она автор бестселлера «Работа по любви» (МИФ) и ведущая подкастов «Мы
                        вам перезвоним» и «На своём месте», признанного лучшим брендовым подкастом 2024 года по версии Яндекс
                        Музыки. Живёт в Италии, работает на русском и английском.</p>
                    </div>
                    <div class="media-kit2-bio-actions">
                    <button class="media-kit2-copy" type="button" id="MKcopyBtn">Скопировать текст</button>
                    <a class="media-kit2-btn btn--ghost btn--sm" href="https://www.linkedin.com/in/lermontova" target="_blank"
                        rel="noopener">Ольга в LinkedIn</a>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-media-kit2-photos', {
        label: 'Careerum media kit2 photos',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-section careerum-media-kit2-photos">
            <div class="careerum-wrap">
            <div class="careerum-sec-head">
                <p class="media-kit2-eyebrow">Материалы</p>
                <h2>Фото для публикаций.</h2>
                <p>Свободно используются в материалах с указанием имени. Вертикальные, горизонтальные и квадратные кадры — в
                полном наборе.</p>
            </div>
            <div class="media-kit2-gal">
                <figure><img src="https://cdn.careerum.com/1793209295503-FibBA-ÐÐµ.jpg" alt="Ольга Лермонтова в тёмно-синем жакете" loading="lazy">
                </figure>
                <figure><img src="https://cdn.careerum.com/1793209295545-iDnEg-ÐÐµ.jpg" alt="Ольга Лермонтова у микрофона" loading="lazy"></figure>
                <figure><img src="https://cdn.careerum.com/1793209295595-jR9Nf-ÐÐµ.jpg" alt="Крупный портрет в белой рубашке" loading="lazy"></figure>
                <figure><img src="https://cdn.careerum.com/1793209295642-vriW5-ÐÐµ.jpg" alt="Портрет в полный рост в библиотеке" loading="lazy"></figure>
                <figure><img src="https://cdn.careerum.com/1793209295696-9y9d1-ÐÐµ.jpg" alt="В бордовом костюме" loading="lazy"></figure>
                <figure><img src="https://cdn.careerum.com/1793209295755-A4PPZ-ÐÐµ.jpg" alt="В голубой рубашке в кресле" loading="lazy"></figure>
                <figure><img src="https://cdn.careerum.com/1793209295846-kbDjQ-ÐÐµ.jpg" alt="В белой рубашке и жакете" loading="lazy"></figure>
            </div>
            <div class="media-kit2-gal-foot">
                <a class="media-kit2-btn btn--ghost btn--sm"
                href="https://drive.google.com/drive/folders/1e1dvezfLb-SacAl1PYo-reJ5cUyZXvzy?usp=sharing" target="_blank"
                rel="noopener">Скачать полный набор</a>
                <p>Оригиналы в высоком разрешении. Логотипы Careerum — по запросу.</p>
            </div>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-media-kit2-booking', {
        label: 'Careerum media kit2 booking',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-section careerum-media-kit2-booking">
            <div class="careerum-wrap">
            <div>
                <p class="media-kit2-eyebrow">Пригласить</p>
                <h2>Назовите аудиторию — подберём тему.</h2>
                <a class="mail"
                href="mailto:hello@careerum.com?subject=%D0%9F%D1%80%D0%B8%D0%B3%D0%BB%D0%B0%D1%88%D0%B5%D0%BD%D0%B8%D0%B5%20%D0%B4%D0%BB%D1%8F%20%D0%9E%D0%BB%D1%8C%D0%B3%D0%B8%20%D0%9B%D0%B5%D1%80%D0%BC%D0%BE%D0%BD%D1%82%D0%BE%D0%B2%D0%BE%D0%B9">hello@careerum.com</a>
                <a class="media-kit2-btn btn--ghost-light" style="display:flex;width:fit-content;margin-top:30px"
                href="https://careerum.com/ru-ru/promo/pro" target="_blank" rel="noopener">Посмотреть Careerum</a>
            </div>
            <ul class="media-kit2-specs">
                <li><span>Форматы</span>Подкасты, интервью для СМИ и ТВ, экспертный комментарий, колонка, панельная дискуссия,
                выступление на конференции</li>
                <li><span>Языки</span>Русский и английский</li>
                <li><span>Запись</span>Онлайн из Италии (центральноевропейское время), студийное качество звука и картинки.
                Офлайн по Европе — по договорённости</li>
                <li><span>Бонус для аудитории</span>Полезный материал или специальное предложение от Careerum — формат
                согласуем с командой заранее</li>
                <li><span>Условия участия</span>Согласуем индивидуально, в зависимости от формата и площадки</li>
                <li><span>Telegram</span><a href="https://t.me/belyok" target="_blank" rel="noopener">t.me/belyok</a></li>
                <li><span>YouTube</span><a href="https://www.youtube.com/@olgalermontova" target="_blank"
                    rel="noopener">@olgalermontova</a></li>
                <li><span>Instagram</span><a href="https://www.instagram.com/lermontova.career/" target="_blank"
                    rel="noopener">@lermontova.career</a></li>
                <li><span>LinkedIn</span><a href="https://www.linkedin.com/in/lermontova" target="_blank"
                    rel="noopener">linkedin.com/in/lermontova</a></li>
                <li><span>Сайт</span><a href="https://careerum.com" target="_blank" rel="noopener">careerum.com</a></li>
            </ul>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-media-kit2-footer', {
        label: 'Careerum media kit2 footer',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-media-kit2-footer">
            <div class="careerum-wrap">
            <span>© 2026 Ольга Лермонтова</span>
            <a href="#top">Наверх</a>
            </div>
        </div>`
    });
    
    blockManager.add('careerum-media-kit2-nav--en', {
        label: 'Careerum media kit en nav',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-media-kit2-nav careerum-media-kit2-nav--en" role="navigation" aria-label="Sections">
                <div class="careerum-wrap">
                <a class="media-kit2-nav__name" href="#top">Olga Lermontova Pavlenko</a>
                <div class="media-kit2-nav__links">
                    <a href="#angles">Story angles</a>
                    <a href="#proof">Track record</a>
                    <a href="#bio">Bio</a>
                    <a href="#photos">Photos</a>
                </div>
                <a class="media-kit2-btn btn--navy btn--sm" href="#booking">Book Olga</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-media-kit2-hero--en', {
        label: 'Careerum media kit en hero',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-media-kit2-hero careerum-media-kit2-hero--en">
                <div class="careerum-wrap media-kit2-hero__in">
                <div>
                    <p class="media-kit2-eyebrow">Press kit · updated October 2026</p>
                    <h1>Career longevity &amp; autonomy: <em>the next 40 years of work.</em></h1>
                    <p class="media-kit2-hero__sub">20 years across 25 markets in Big Tech, 15,000+ career cases, and Harvard
                    psychology research — applied to mid-career reinvention, white-collar AI disruption, and the rise of portfolio
                    careers.</p>
                    <p class="media-kit2-hero__meta">Founder of Crafted &amp; Careerum · Ex-Google, Microsoft &amp; Adobe · INSEAD
                    MBA · Harvard Extension ALM ’27</p>
                    <div class="media-kit2-hero__cta">
                    <a class="media-kit2-btn btn--cream" href="#booking">Book Olga</a>
                    <a class="media-kit2-btn btn--ghost-light" href="#angles">Story angles</a>
                    </div>
                </div>
                <div class="media-kit2-hero__photo">
                    <img
                    src="https://cdn.careerum.com/1793641226699-Yl5UJ-ÐÐµ.jpg"
                    alt="Olga Lermontova Pavlenko">
                </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-media-kit2-marks--en', {
        label: 'Careerum media kit en marks',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-media-kit2-marks careerum-media-kit2-marks--en">
                <div class="careerum-wrap">
                <div class="media-kit2-marks-mgrp"><span>Two decades at</span>
                    <div><b>Microsoft</b><b>Google</b><b>Adobe</b><b>McAfee</b><b>Travelport</b></div>
                </div>
                <div class="media-kit2-marks-mgrp"><span>Educated at</span>
                    <div><b>INSEAD</b><b>Harvard Extension School</b></div>
                </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-media-kit2-angles--en', {
        label: 'Careerum media kit en angles',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-section careerum-media-kit2-angles careerum-media-kit2-angles--en">
                <div class="careerum-wrap">
                <div class="careerum-sec-head">
                    <p class="media-kit2-eyebrow">Story angles &middot; ready to book</p>
                    <h2>Core arguments she makes on air &mdash; and defends.</h2>
                    <p>Each angle is backed by peer-reviewed research and proprietary data from 15,000+ career cases. Pick one for
                    a focused segment, or combine two for a 60-minute deep dive.</p>
                </div>
                <div class="media-kit2-angles">
                    <article class="media-kit2-angle angle--wide">
                    <span class="media-kit2-angle__tag">Signature thesis</span>
                    <h3>Why senior professionals get stuck when the market shifts &mdash; and the one measurable capability that
                        predicts who adapts.</h3>
                    <p>Career advice was built for a ladder that no longer exists. Olga tested its playbook against the
                        evidence.</p>
                    <ul class="media-kit2-sigpoints">
                        <li>
                        <span class="media-kit2-sigicon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M9 3h6" />
                            <path d="M10 3v6l-5 9.5A1.6 1.6 0 0 0 6.4 21h11.2a1.6 1.6 0 0 0 1.4-2.5L14 9V3" />
                            <path d="M7.5 15h9" />
                            </svg></span>
                        <span><b>The evidence base.</b> 15,000 senior cases in 61 countries, set against a meta-analysis of 90
                            studies.</span>
                        </li>
                        <li>
                        <span class="media-kit2-sigicon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
                            <circle cx="12" cy="12" r="9" />
                            <path d="M9 9l6 6M15 9l-6 6" />
                            </svg></span>
                        <span><b>What fails.</b> Personality tests, &ldquo;find your passion&rdquo;, five-year plans. They keep
                            experienced people waiting.</span>
                        </li>
                        <li>
                        <span class="media-kit2-sigicon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
                            <circle cx="12" cy="12" r="9" />
                            <path d="M8 12.5l2.8 2.8L16 9.5" />
                            </svg></span>
                        <span><b>What predicts success.</b> Career agency: understand, choose, act. Trainable in weeks, not a
                            personality trait.</span>
                        </li>
                        <li>
                        <span class="media-kit2-sigicon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M4 12h15" />
                            <path d="M14 7l5 5-5 5" />
                            </svg></span>
                        <span><b>Why hosts book it.</b> Hard psychology instead of coaching clich&eacute;s, and a protocol
                            listeners can use.</span>
                        </li>
                    </ul>
                    <p class="media-kit2-angle__proof">Backed by master&rsquo;s research in organizational psychology at Harvard
                        Extension School (ALM &rsquo;27) and eight years of proprietary data from Careerum and Crafted.</p>
                    </article>

                    <article class="media-kit2-angle">
                    <span class="media-kit2-angle__num" aria-hidden="true">01</span>
                    <span class="media-kit2-angle__tag">Mid-career reinvention</span>
                    <h3>Clarity is not a prerequisite for a pivot. It is the result of running small experiments.</h3>
                    <p>Senior professionals try to think their way into the next move. Identity changes through action, not
                        reflection.</p>
                    <p class="media-kit2-angle__proof">Herminia Ibarra &middot; Robert Kegan</p>
                    </article>

                    <article class="media-kit2-angle">
                    <span class="media-kit2-angle__num" aria-hidden="true">02</span>
                    <span class="media-kit2-angle__tag">Job crafting &amp; leverage</span>
                    <h3>Before you walk away from a six-figure role, redesign the job you already have.</h3>
                    <p>Quitting is the most expensive way to fix a broken role. Job crafting renegotiates scope, autonomy and
                        political capital from the inside.</p>
                    <p class="media-kit2-angle__proof">Wrzesniewski &amp; Dutton &middot; Gallup</p>
                    </article>

                    <article class="media-kit2-angle">
                    <span class="media-kit2-angle__num" aria-hidden="true">03</span>
                    <span class="media-kit2-angle__tag">High-performer stagnation</span>
                    <h3>Why top performers hit a wall in their forties, and ambition stops working.</h3>
                    <p>Over-delivering and linear climbing build the career, then cause the stall. The shift is from external
                        achievement to self-authorship.</p>
                    <p class="media-kit2-angle__proof">Gratton &amp; Scott &middot; Christina Maslach</p>
                    </article>

                    <article class="media-kit2-angle">
                    <span class="media-kit2-angle__num" aria-hidden="true">04</span>
                    <span class="media-kit2-angle__tag">Portfolio careers &amp; autonomy</span>
                    <h3>The corporate ladder is flattening. Senior talent is building portfolio careers instead.</h3>
                    <p>62% of individual contributors say they do not want a people-management track. Olga left a 20-year
                        leadership career to build her own company.</p>
                    <p class="media-kit2-angle__proof">Visier, 1,000 US respondents, 2023</p>
                    </article>

                    <article class="media-kit2-angle">
                    <span class="media-kit2-angle__num" aria-hidden="true">05</span>
                    <span class="media-kit2-angle__tag">White-collar AI disruption</span>
                    <h3>Only 8% fear AI will replace them. Only 1.8% can use it at an advanced level.</h3>
                    <p>The threat to senior talent is not anxiety. It is the gap between using AI as a search engine and using
                        it for leverage.</p>
                    <p class="media-kit2-angle__proof">Own dataset: n&nbsp;=&nbsp;2,183 &middot; AI module n&nbsp;=&nbsp;542</p>
                    </article>

                    <article class="media-kit2-angle">
                    <span class="media-kit2-angle__num" aria-hidden="true">06</span>
                    <span class="media-kit2-angle__tag">Global mobility &amp; identity</span>
                    <h3>Relocate or lose the Big Tech badge and you keep your skills. You lose your social proof.</h3>
                    <p>Senior careers run on invisible social capital that does not cross borders. Rebuilding it is a method,
                        not luck.</p>
                    <p class="media-kit2-angle__proof">Client cases across 61 countries</p>
                    </article>
                </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-media-kit2-quotes--en', {
        label: 'Careerum media kit en quotes',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-section careerum-media-kit2-quotes careerum-media-kit2-quotes--en">
                <div class="careerum-wrap">
                <div class="careerum-sec-head">
                    <p class="media-kit2-eyebrow">How she talks</p>
                    <h2>Lines from her work that travel.</h2>
                    <p>Short enough to quote in a headline or cut into a 30-second clip. Sharp enough to start an argument in the
                    comments.</p>
                </div>
                <div class="media-kit2-qgrid">
                    <blockquote class="media-kit2-quote">“Clarity is not a prerequisite for action. It is the result of it.”
                    </blockquote>
                    <blockquote class="media-kit2-quote">“You are not lazy. You are done wanting the thing you were told to want.”
                    </blockquote>
                    <blockquote class="media-kit2-quote">“Quitting is the most expensive way to test a hypothesis.”</blockquote>
                    <blockquote class="media-kit2-quote">“A corporate title is rented status. A portfolio career is owned
                    leverage.”</blockquote>
                    <blockquote class="media-kit2-quote">“Personality tests tell you who you were five years ago. Career
                    experiments show you who you can become next.”</blockquote>
                    <blockquote class="media-kit2-quote">“AI will not replace senior professionals. It will expose the gap between
                    those who manage processes and those who drive strategy.”</blockquote>
                </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-media-kit2-proof--en', {
        label: 'Careerum media kit en proof',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-section careerum-media-kit2-proof careerum-media-kit2-proof--en">
                <div class="careerum-wrap">
                <div class="careerum-sec-head">
                    <p class="media-kit2-eyebrow">Track record</p>
                    <h2>Two decades of practice. Eight years of data. One method.</h2>
                </div>
                <div class="media-kit2-proof">
                    <div class="media-kit2-stat"><b>15,000</b><span>careers rebuilt through Careerum since 2018</span></div>
                    <div class="media-kit2-stat"><b>61</b><span>countries her clients work in</span></div>
                    <div class="media-kit2-stat"><b>25+</b><span>markets she ran in corporate roles</span></div>
                    <div class="media-kit2-stat"><b>854K</b><span>views on her two most recent podcast appearances</span></div>
                </div>
                <p class="media-kit2-proof-note">She has worked and presented in English throughout her corporate career, and
                    now hosts <a href="https://www.youtube.com/@olga.crafted" target="_blank" rel="noopener">The Crafted
                    Career</a> in English. Her Russian-language channels carry 342,000+ followers.</p>



                <div class="media-kit2-pstrip">
                    <span class="media-kit2-pstrip__lbl">Featured &amp; quoted in</span>
                    <div class="media-kit2-pstrip__list"><span>Forbes Woman</span><span>Marie Claire</span><span>Forbes
                        Education</span><span>RBC Trends</span><span>Snob</span><span>vc.ru</span></div>
                </div>
                <div class="media-kit2-track">
                    <div>
                    <h3>She has hosted, not just guested</h3>
                    <p>Two podcasts of her own. One was named Best Branded Podcast of the Year (2024) on a major streaming
                        platform. She can hold 90 minutes and land a point.</p>
                    </div>
                    <div>
                    <h3>She writes</h3>
                    <p>Author of a best-selling career book. Regular contributor to <a
                        href="https://www.forbes.ru/forbes-woman/567667-horosaa-bor-ba-pocemu-zensinam-vazno-ucit-sa-zdorovoj-konkurencii-i-rabote-v-komande"
                        target="_blank" rel="noopener">Forbes Woman</a>, Marie Claire and leading business media. English
                        bylines on request.</p>
                    </div>
                    <div>
                    <h3>On-camera presence and reach</h3>
                    <p>Long-form, data-heavy career topics hold mass attention. Her last three Russian-language appearances run
                        from 20 to 120 minutes, unscripted and on camera throughout.</p>
                    </div>
                </div>

                <div class="media-kit2-vgrid">
                    <a class="media-kit2-vcard" href="https://www.youtube.com/watch?v=vqGmRpV-tAw" target="_blank" rel="noopener">
                    <span class="media-kit2-vcard__thumb"><img
                        src="https://cdn.careerum.com/1793641227462-EdUwq-ÐÐµ.jpg"
                        alt="" loading="lazy"><span class="media-kit2-vcard__play" aria-hidden="true"></span><span
                        class="media-kit2-vcard__stat">752K views &middot; 2,702 comments</span></span>
                    <span class="media-kit2-vcard__tag">Guest interview &middot; 1.36M-subscriber podcast (RU)</span>
                    <b>Staying employable in the age of AI</b>
                    <span class="media-kit2-vcard__d">A two-hour unscripted studio conversation on white-collar AI
                        disruption.</span>
                    </a>
                    <a class="media-kit2-vcard" href="https://www.youtube.com/watch?v=lDTjKRWoWTE" target="_blank" rel="noopener">
                    <span class="media-kit2-vcard__thumb"><img
                        src="https://cdn.careerum.com/1793641226461-JyAH1-ÐÐµ.jpg"
                        alt="" loading="lazy"><span class="media-kit2-vcard__play" aria-hidden="true"></span><span
                        class="media-kit2-vcard__stat">102K views</span></span>
                    <span class="media-kit2-vcard__tag">Guest interview &middot; business podcast (RU)</span>
                    <b>Does work you love actually exist?</b>
                    <span class="media-kit2-vcard__d">A long-form debate, held across the full run without notes.</span>
                    </a>
                    <a class="media-kit2-vcard" href="https://www.youtube.com/watch?v=z1Mm4xP_zy8" target="_blank" rel="noopener">
                    <span class="media-kit2-vcard__thumb"><img
                        src="https://cdn.careerum.com/1793641226530-JxO0S-ÐÐµ.jpg"
                        alt="" loading="lazy"><span class="media-kit2-vcard__play" aria-hidden="true"></span><span
                        class="media-kit2-vcard__stat">26K views in three weeks</span></span>
                    <span class="media-kit2-vcard__tag">Her own channel &middot; 49.4K subscribers (RU)</span>
                    <b>Where ambition goes, and why it stops working</b>
                    <span class="media-kit2-vcard__d">Written and presented solo. The format the English channel is built
                        on.</span>
                    </a>
                </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-media-kit2-bio--en', {
        label: 'Careerum media kit en bio',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-section careerum-media-kit2-bio careerum-media-kit2-bio--en">
                <div class="careerum-wrap">
                <div class="careerum-sec-head">
                    <p class="media-kit2-eyebrow">Biography</p>
                    <h2>From language tutor in Moscow to Google, and out again.</h2>
                </div>
                <div class="media-kit2-bio-wrap">
                    <div class="media-kit2-bio-photo">
                    <img
                        src="https://cdn.careerum.com/1793641226609-NUNLT-ÐÐµ.jpg"
                        alt="Portrait of Olga Lermontova Pavlenko" loading="lazy">
                    </div>
                    <div>
                    <ul class="media-kit2-cv">
                        <li><span>2003–2008</span>Language tutor, Moscow</li>
                        <li><span>2007–2012</span>Microsoft, Adobe, McAfee — Russia and CIS</li>
                        <li><span>2012–2013</span>INSEAD MBA, Singapore</li>
                        <li><span>2013–2016</span>Microsoft, Western Europe HQ — 14 countries</li>
                        <li><span>2016–2017</span>Google, EMEA HQ, Dublin</li>
                        <li><span>2017–2021</span>Travelport, EMEA — based in Italy</li>
                        <li><span>2018 →</span>Founder, Careerum — 15,000 clients in 61 countries</li>
                        <li><span>May 2027</span>ALM in psychology, Harvard Extension School</li>
                        <li><span>Feb 2027</span>Founder, <a href="https://claude.ai/artifact/EGK9iM6PTn3BrQXQfVi9k5"
                            target="_blank" rel="noopener">Crafted</a> — an eight-week, evidence-based career program</li>
                    </ul>
                    <div class="media-kit2-tabs">
                        <div class="media-kit2-tabs__head" role="tablist" aria-label="Bio length">
                        <button class="media-kit2-tab" role="tab" aria-selected="true" aria-controls="b1" id="t1">One
                            line</button>
                        <button class="media-kit2-tab" role="tab" aria-selected="false" aria-controls="b2" id="t2"
                            tabindex="-1">Host introduction</button>
                        <button class="media-kit2-tab" role="tab" aria-selected="false" aria-controls="b3" id="t3"
                            tabindex="-1">Full</button>
                        </div>
                        <div class="media-kit2-bio" role="tabpanel" id="b1" aria-labelledby="t1">
                        <p>Olga Lermontova Pavlenko is a career researcher and the founder of Crafted, an evidence-based program
                            for professionals rebuilding a career mid-stream. Across a 20-year career she led businesses at
                            Microsoft, Google and Adobe, then built Careerum: 15,000 clients in 61 countries.</p>
                        </div>
                        <div class="media-kit2-bio" role="tabpanel" id="b2" aria-labelledby="t2" hidden>
                        <p>My guest today spent two decades at Microsoft, Google and Adobe, running businesses across 25 markets
                            — then left to answer the question that kept bothering her: why do so many accomplished people get
                            stuck mid-career, and what actually gets them unstuck? Olga Lermontova Pavlenko has since worked with
                            15,000 people in 61 countries, researches career transitions in psychology at Harvard Extension
                            School, and founded Crafted. Her argument: you cannot think your way into a new career. You have to
                            run experiments.</p>
                        </div>
                        <div class="media-kit2-bio" role="tabpanel" id="b3" aria-labelledby="t3" hidden>
                        <p>Olga Lermontova Pavlenko is a career researcher, practitioner and founder. Across a 20-year career
                            she built and led businesses at Microsoft, Adobe, McAfee, Google and Travelport, covering more than 25
                            markets in Europe and Africa and living in five countries. She holds an MBA from INSEAD and an ICF
                            coaching certification.</p>
                        <p>In 2018 she left corporate life to build Careerum, a career development platform that has since
                            worked with 15,000 clients across 61 countries. What she found there sent her back to school: she is
                            completing an ALM in psychology at Harvard Extension School, where she researches how people rebuild
                            professional identity in the middle of a career.</p>
                        <p>That research became Crafted, an eight-week program launching in February 2027 for professionals with
                            ten or more years of experience, built on the finding that identity changes through action rather than
                            reflection. Olga is the author of a best-selling career book and hosts two podcasts of her own, one
                            named Best Branded Podcast of the Year in 2024. She lives in Italy and works in English and Russian.
                        </p>
                        </div>
                        <div class="media-kit2-bio-actions">
                        <button class="media-kit2-copy" type="button" id="MKcopyBtn">Copy text</button>
                        <a class="media-kit2-btn btn--ghost btn--sm" href="https://www.linkedin.com/in/lermontova" target="_blank"
                            rel="noopener">Olga on LinkedIn</a>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-media-kit2-photos--en', {
        label: 'Careerum media kit en photos',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-section careerum-media-kit2-photos careerum-media-kit2-photos--en">
                <div class="careerum-wrap">
                <div class="careerum-sec-head">
                    <p class="media-kit2-eyebrow">Assets</p>
                    <h2>Press photography.</h2>
                    <p>Free to use for coverage, with a credit to Olga Lermontova Pavlenko. Vertical, horizontal and square crops
                    in the full-resolution set.</p>
                </div>
                <div class="media-kit2-gal">
                    <figure><img
                        src="https://cdn.careerum.com/1793641226699-Yl5UJ-ÐÐµ.jpg"
                        alt="Olga Lermontova Pavlenko, navy blazer, seated at a desk" loading="lazy"></figure>
                    <figure><img
                        src="https://cdn.careerum.com/1793641226770-N8HDH-ÐÐµ.jpg"
                        alt="Olga Lermontova Pavlenko at a microphone" loading="lazy"></figure>
                    <figure><img
                        src="https://cdn.careerum.com/1793641226851-MWM4I-ÐÐµ.jpg"
                        alt="Close portrait, white shirt" loading="lazy"></figure>
                    <figure><img
                        src="https://cdn.careerum.com/1793641226920-ZqTBL-ÐÐµ.jpg"
                        alt="Full-length portrait in a library" loading="lazy"></figure>
                    <figure><img
                        src="https://cdn.careerum.com/1793641227025-2If6F-ÐÐµ.jpg"
                        alt="Portrait in a burgundy suit" loading="lazy"></figure>
                    <figure><img
                        src="https://cdn.careerum.com/1793641227096-OJKIG-ÐÐµ.jpg"
                        alt="Seated portrait, light blue shirt" loading="lazy"></figure>
                    <figure><img
                        src="https://cdn.careerum.com/1793641227191-pWzng-ÐÐµ.jpg"
                        alt="Portrait in a white shirt and blazer" loading="lazy"></figure>
                </div>
                <div class="media-kit2-gal-foot">
                    <a class="media-kit2-btn btn--ghost btn--sm"
                    href="https://drive.google.com/drive/folders/1e1dvezfLb-SacAl1PYo-reJ5cUyZXvzy?usp=sharing" target="_blank"
                    rel="noopener">Download full-resolution set</a>
                    <p>Photography by Careerum. Logos and the Crafted brand kit available on request.</p>
                </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-media-kit2-booking--en', {
        label: 'Careerum media kit en booking',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-section careerum-media-kit2-booking careerum-media-kit2-booking--en">
                <div class="careerum-wrap">
                <div>
                    <p class="media-kit2-eyebrow">Booking</p>
                    <h2>Tell us the audience. We'll shape the angle.</h2>
                    <a class="mail"
                    href="mailto:hello@careerum.com?subject=Interview%20request%20for%20Olga%20Lermontova%20Pavlenko">hello@careerum.com</a>
                    <p class="media-kit2-booking__note">Media inquiries answered within 24 hours. Put URGENT in the subject line
                    for same-day deadlines.</p>
                    <a class="media-kit2-btn btn--ghost-light media-kit2-booking__programme"
                    href="https://claude.ai/artifact/EGK9iM6PTn3BrQXQfVi9k5" target="_blank" rel="noopener">See Crafted, the
                    programme she leads</a>
                </div>
                <ul class="media-kit2-specs">
                    <li><span>Formats</span>Podcasts, broadcast and print interviews, expert comment, bylined articles, panels,
                    keynotes</li>
                    <li><span>Languages</span>English and Russian</li>
                    <li><span>Recording</span>Remote from Italy (CET), studio-quality audio and video. In person across Europe by
                    arrangement</li>
                    <li><span>Lead time</span>Flexible for booked interviews, short notice included. Expert comment within 24–48
                    hours</li>
                    <li><span>LinkedIn</span><a href="https://www.linkedin.com/in/lermontova" target="_blank"
                        rel="noopener">linkedin.com/in/lermontova</a></li>
                    <li><span>Instagram</span><a href="https://www.instagram.com/olga.crafted/" target="_blank"
                        rel="noopener">@olga.crafted</a></li>
                </ul>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-media-kit2-footer--en', {
        label: 'Careerum media kit en footer',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-media-kit2-footer careerum-media-kit2-footer--en" role="contentinfo">
                <div class="careerum-wrap">
                <span>© 2026 Olga Lermontova Pavlenko</span>
                <a href="#top">Back to top</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-portfolio_career-main', {
        label: 'Careerum portfolio_career main',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-portfolio_career-main main-wrapper">
                <div class="careerum-container-responsive careerum-flex-sbst">
                    <div class="portfolio_career-main-left position-relative z-10">
                        <div class="portfolio_career-main-labels careerum-flex-fsc">
                            <p class="portfolio_career-main-label">В подписке Careerum</p>
                            <p class="portfolio_career-main-label transparent">Программа</p>
                            <p class="portfolio_career-main-label blue">Старт: 18 ноября</p>
                        </div>
                        <h1>Портфельная карьера</h1>
                        <p class="portfolio_career-main-subheader">Выберете подходящие <span>источники дохода,</span>
                            сформулируете <span>предложение для первых клиентов</span> и проверите, <span>за что вам готовы
                                платить</span></p>
                        <div class="portfolio_career-main-period careerum-flex-fsc">
                            <p class="portfolio_career-main-period__number">10</p>
                            <p class="portfolio_career-main-period__text"><span class="blue">Недель,</span> чтобы собрать свой
                                <span class="bold">портфель занятости</span>, чтобы не зависеть только от одного работодателя
                            </p>
                        </div>
                    </div>
                    <div class="portfolio_career-main-right position-relative z-1">
                        <p class="position-absolute z-10"><span>Ольга Лермонтова,</span><br> автор программы и №1
                            эксперт в России по карьерным стратегиям и переходам</p>
                        <img src="https://cdn.careerum.com/1793727477162-rjnYp-ÐÐ¾.png"
                            class="hidden-tablet-mobile position-absolute z-1" alt="img" loading="eager">
                        <img src="https://cdn.careerum.com/1793727326570-UsNOY-Hero.png"
                            class="hidden-desc-mobile position-absolute z-1" alt="img" loading="eager">
                        <img src="https://cdn.careerum.com/1793730175291-NWHGB-Fram.png"
                            class="hidden-desc-tablet position-absolute z-1" alt="img" loading="eager">
                    </div>
                    <div class="portfolio_career-buttons careerum-flex-fsfs">
                        <a href="#program" class="btn-color-main-black position-relative">
                            <p>Посмотреть программу</p>
                            <div class="portfolio_career-main-button__label careerum-flex-fsc position-absolute z-10">
                                <img src="https://cdn.careerum.com/1793696137509-vdOMz-Fire.svg" alt="img" loading="eager">
                                <p>Всего 100 мест</p>
                            </div>
                        </a>
                        <a href="#buy" class="btn-color-main-transparent">Посмотреть тарифы от 29 900 ₽</a>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-portfolio_career-reazons', {
        label: 'Careerum portfolio_career reazons',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-portfolio_career-reazons main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Узнаете себя?</h2>
                    <div class="portfolio_career-reazons-content">
                        <div class="portfolio_career-reazons-slider careerum-slick-slider-wrapper noselect">
                            <div class="slider-elements">
                                <div class="portfolio_career-reazons-item">
                                    <p class="portfolio_career-reazons-item__number">01</p>
                                    <p class="portfolio_career-reazons-item__text">Не можете позволить себе потерять текущую
                                        работу, но понимаете, что ваша работа не гарант дохода и спокойствия</p>
                                </div>
                                <div class="portfolio_career-reazons-item">
                                    <p class="portfolio_career-reazons-item__number">02</p>
                                    <p class="portfolio_career-reazons-item__text">Не знаете, как ещё можете зарабатывать своим
                                        опытом</p>
                                </div>
                                <div class="portfolio_career-reazons-item">
                                    <p class="portfolio_career-reazons-item__number">03</p>
                                    <p class="portfolio_career-reazons-item__text">Боитесь, что придётся работать ещё больше</p>
                                </div>
                                <div class="portfolio_career-reazons-item">
                                    <p class="portfolio_career-reazons-item__number">04</p>
                                    <p class="portfolio_career-reazons-item__text">Хотите выйти из найма, т.к. нет перспектив —
                                        горизонтальный рост не поощряют, вертикальный недостижим</p>
                                </div>
                                <div class="portfolio_career-reazons-item">
                                    <p class="portfolio_career-reazons-item__number">05</p>
                                    <p class="portfolio_career-reazons-item__text">Хотите подстраховать себя доходом
                                        на фрилансе, но сложно понять, с чего начать</p>
                                </div>
                                <div class="portfolio_career-reazons-item">
                                    <p class="portfolio_career-reazons-item__number">06</p>
                                    <p class="portfolio_career-reazons-item__text">Текущая работа больше не радует
                                        и не развивает, вам надоело ставить чужие цели и выполнять чужие KPI, но уходить
                                        «в никуда» страшно</p>
                                </div>
                                <div class="portfolio_career-reazons-item">
                                    <p class="portfolio_career-reazons-item__number">07</p>
                                    <p class="portfolio_career-reazons-item__text">Рынок и технологии меняются так быстро,
                                        что высок риск остаться «не у дел»</p>
                                </div>
                            </div>
                            <div class="slider-nav careerum-flex-fec">
                                <div class="slick-nav-prev careerum-flex-cc">
                                    <svg width="17" height="15" viewBox="0 0 17 15" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.32031 7.32104L15.3203 7.32104" stroke="white" stroke-width="2.64201"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M7.32031 13.321L1.32031 7.32104L7.32031 1.32104" stroke="white"
                                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <div class="slick-nav-next careerum-flex-cc">
                                    <svg width="17" height="15" viewBox="0 0 17 15" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M15.3203 7.32105L1.32031 7.32104" stroke="white" stroke-width="2.64201"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M9.32031 1.32104L15.3203 7.32105L9.32031 13.321" stroke="white"
                                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-portfolio_career-change', {
        label: 'Careerum portfolio_career change',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-portfolio_career-change main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Как изменится ваша жизнь после программы?</h2>
                    <div class="portfolio_career-change-content careerum-flex-fsst">
                        <div class="portfolio_career-change-item">
                            <div>
                                <img src="https://cdn.careerum.com/1793697901762-hIZkT-Fram.svg" alt="img" loading="lazy">
                            </div>
                            <div>
                                <p class="portfolio_career-change-item__header">Будете понимать, как зарабатывать за пределами
                                    найма
                                </p>
                                <p class="portfolio_career-change-item__text">Hа консультациях, проектах, преподавании и других
                                    форматах работы.</p>
                            </div>
                        </div>
                        <div class="portfolio_career-change-item">
                            <div><img src="https://cdn.careerum.com/1793697902067-0knSO-Fram.svg" alt="img" loading="lazy">
                            </div>
                            <div>
                                <p class="portfolio_career-change-item__header">Соберёте своё сочетание занятий</p>
                                <p class="portfolio_career-change-item__text">Выберете, что оставить в найме, а что
                                    развивать
                                    самостоятельно — под ваши интересы и желаемый доход</p>
                            </div>
                        </div>
                        <div class="portfolio_career-change-item">
                            <div><img src="https://cdn.careerum.com/1793697901942-sXrCk-Fram.svg" alt="img" loading="lazy">
                            </div>
                            <div>
                                <p class="portfolio_career-change-item__header">Получите больше свободы в решениях</p>
                                <p class="portfolio_career-change-item__text">Будете знать, какие источники дохода
                                    развивать, чтобы
                                    меньше зависеть от одного работодателя</p>
                            </div>
                        </div>
                        <div class="portfolio_career-change-item">
                            <div><img src="https://cdn.careerum.com/1793697901973-ZMDQs-Fram.svg" alt="img" loading="lazy">
                            </div>
                            <div>
                                <p class="portfolio_career-change-item__header">Спланируете работу так, чтобы оставалось
                                    время
                                    на жизнь</p>
                                <p class="portfolio_career-change-item__text">Определите, сколько часов готовы отдавать
                                    каждому
                                    занятию</p>
                            </div>
                        </div>
                        <div class="portfolio_career-change-item wide">
                            <div><img src="https://cdn.careerum.com/1793697902067-0knSO-Fram.svg" alt="img" loading="lazy">
                            </div>
                            <div>
                                <p class="portfolio_career-change-item__header">Сможете назвать цену своей работы:</p>
                                <p class="portfolio_career-change-item__text">Сформулируете, что предлагаете клиентам,
                                    за какой
                                    результат и сколько это стоит</p>
                            </div>
                        </div>
                        <div class="portfolio_career-change-item wide">
                            <div><img src="https://cdn.careerum.com/1793697902067-0knSO-Fram.svg" alt="img" loading="lazy">
                            </div>
                            <div>
                                <p class="portfolio_career-change-item__header">Увидите, за что вам готовы платить</p>
                                <p class="portfolio_career-change-item__text">Выделите навыки и опыт, которые помогают
                                    решать задачи
                                    клиентов, в том числе с использованием ИИ</p>
                            </div>
                        </div>
                        <div class="portfolio_career-change-item wide wide-tablet">
                            <div><img src="https://cdn.careerum.com/1793697902067-0knSO-Fram.svg" alt="img" loading="lazy">
                            </div>
                            <div>
                                <p class="portfolio_career-change-item__header">Поймёте, как привлекать клиентов</p>
                                <p class="portfolio_career-change-item__text">Определите, чем хотите быть известны, где
                                    рассказывать
                                    о себе и как показывать ценность своей работы</p>
                            </div>
                        </div>
                    </div>
                    <div class="portfolio_career-buttons careerum-flex-fsfs">
                        <a href="#program" class="btn-color-main-black position-relative">
                            <p>Посмотреть программу</p>
                            <div class="portfolio_career-main-button__label careerum-flex-fsc position-absolute z-10">
                                <img src="https://cdn.careerum.com/1793696137509-vdOMz-Fire.svg" alt="img" loading="eager">
                                <p>Всего 100 мест</p>
                            </div>
                        </a>
                        <a href="#buy" class="btn-color-main-transparent">Посмотреть тарифы от 29 900 ₽</a>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-portfolio_career-study', {
        label: 'Careerum portfolio_career study',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-portfolio_career-study main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Как проходит обучение</h2>
                    <p class="portfolio_career-study-subheader">Мы чередуем неделю теории и неделю практики
                        на <span>воркшопах</span>
                    </p>
                    <div class="portfolio_career-study-content">
                        <div class="portfolio_career-study-slider careerum-slick-slider-wrapper noselect">
                            <div class="slider-elements">
                                <div class="portfolio_career-study-item careerum-flex-fsfs">
                                    <p class="portfolio_career-study-item__number">01</p>
                                    <div class="portfolio_career-study-item__content">
                                        <p class="portfolio_career-study-item__header">Вся работа проходит на воркшопах
                                        </p>
                                        <p class="portfolio_career-study-item__text">Разрабатываем прямо на воркшопе
                                            часть вашей
                                            стратегии: как найти навыки для заработка, выбрать форматы занятости
                                            или сформулировать предложение клиентам. Эксперт даёт пример и разбирает
                                            подробно,
                                            как выполнять задание. Далее вы приступаете к работе, в процессе
                                            есть возможность
                                            задать вопросы</p>
                                    </div>
                                </div>
                                <div class="portfolio_career-study-item careerum-flex-fsfs">
                                    <p class="portfolio_career-study-item__number">02</p>
                                    <div class="portfolio_career-study-item__content">
                                        <p class="portfolio_career-study-item__header">Обратная связь от экспертов</p>
                                        <p class="portfolio_career-study-item__text">Эксперт разбирает примеры
                                            участников,
                                            задаёт уточняющие вопросы и помогает увидеть дополнительные способы
                                            применения
                                            навыков. Через чужие разборы вы также находите подсказки для своей стратегии
                                            развития</p>
                                    </div>
                                </div>
                                <div class="portfolio_career-study-item careerum-flex-fsfs">
                                    <p class="portfolio_career-study-item__number">03</p>
                                    <div class="portfolio_career-study-item__content">
                                        <p class="portfolio_career-study-item__header">Каждый вокшоп добавляет одну
                                            готовую
                                            часть стратегии</p>
                                        <p class="portfolio_career-study-item__text">Каждая встреча добавляет готовую
                                            часть
                                            вашего портфеля карьеры: паспорт активов, формулу портфеля, предложение
                                            клиентам
                                            или финансовый расчёт</p>
                                    </div>
                                </div>
                                <div class="portfolio_career-study-item careerum-flex-fsfs">
                                    <p class="portfolio_career-study-item__number">04</p>
                                    <div class="portfolio_career-study-item__content">
                                        <p class="portfolio_career-study-item__header">Между воркшопами двигаетесь
                                            с поддержкой
                                            бадди</p>
                                        <p class="portfolio_career-study-item__text">Обсуждаете идеи с партнёром
                                            по обучению,
                                            которого мы распределим вам на старте. Обмениваетесь обратной связью
                                            и сверяетесь
                                            с планом</p>
                                    </div>
                                </div>
                                <div class="portfolio_career-study-item careerum-flex-fsfs">
                                    <p class="portfolio_career-study-item__number">05</p>
                                    <div class="portfolio_career-study-item__content">
                                        <p class="portfolio_career-study-item__header">Проверка гипотез на практике</p>
                                        <p class="portfolio_career-study-item__text">Постепенно переходите от стратегии
                                            к проверке предложения на потенциальных клиентах</p>
                                    </div>
                                </div>
                            </div>
                            <div class="slider-nav careerum-flex-fec">
                                <div class="slick-nav-prev careerum-flex-cc">
                                    <svg width="17" height="15" viewBox="0 0 17 15" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.32031 7.32104L15.3203 7.32104" stroke="white" stroke-width="2.64201"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M7.32031 13.321L1.32031 7.32104L7.32031 1.32104" stroke="white"
                                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <div class="slick-nav-next careerum-flex-cc">
                                    <svg width="17" height="15" viewBox="0 0 17 15" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M15.3203 7.32105L1.32031 7.32104" stroke="white" stroke-width="2.64201"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M9.32031 1.32104L15.3203 7.32105L9.32031 13.321" stroke="white"
                                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div class="portfolio_career-study-banner careerum-flex-fsst">
                            <div class="portfolio_career-study-banner__left">
                                <img src="https://cdn.careerum.com/1793699969406-FK3IY-Fram.png" class="hidden-tablet-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1793728455519-y3C4Q-Fram.png" class="hidden-desc-mobile"
                                    alt="img" loading="lazy">
                                <img src="https://cdn.careerum.com/1793731482303-Jadp0-Fram.png" class="hidden-desc-tablet" alt="img" loading="lazy">
                            </div>
                            <div class="portfolio_career-study-banner__right">
                                <p class="portfolio_career-study-banner__header">Работа в группе из 5 человек
                                    с карьерным
                                    экспертом </p>
                                <p class="portfolio_career-study-banner__text">Формат минигрупп за рамками вокшопов</p>
                                <p class="portfolio_career-study-banner__text">Работа с экспертом в минигруппах поможет
                                    более
                                    детально разобрать любой ваш вопрос, т.к. эксперт постоянно на связи с вами. А
                                    размер группы
                                    позволяет более индивидуально работать именно с вашим запросом</p>
                            </div>
                        </div>
                    </div>
                    <div class="portfolio_career-buttons careerum-flex-fsfs">
                        <a href="#buy" class="btn-color-main-black position-relative wide">
                            <p>Посмотреть тарифы от 29 900 ₽</p>
                            <div class="portfolio_career-main-button__label careerum-flex-fsc position-absolute z-10">
                                <img src="https://cdn.careerum.com/1793696137509-vdOMz-Fire.svg" alt="img" loading="eager">
                                <p>Всего 100 мест</p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-portfolio_career-program', {
        label: 'Careerum portfolio_career program',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-portfolio_career-program main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Программа и расписание</h2>
                    <div class="portfolio_career-program-slider careerum-slick-slider-wrapper noselect">
                        <div class="slider-elements">
                            <div class="portfolio_career-program-item careerum-flex-fsfs">
                                <div class="portfolio_career-program-item__labels careerum-flex-fsfs">
                                    <p class="portfolio_career-program-item__label">Неделя 0</p>
                                    <p class="portfolio_career-program-item__label blue">18–22 ноября</p>
                                </div>
                                <div class="portfolio_career-program-item__content">
                                    <p class="portfolio_career-program-item__type">Теория</p>
                                    <p class="portfolio_career-program-item__header">Онбординг и распределение
                                        по группам
                                        и к экспертам</p>
                                    <ul>
                                        <li>Познакомитесь с участниками и найдёте бадди для совместного движения</li>
                                        <li>Разберётесь, как устроена программа, и познакомитесь с теми, кто тоже ищет
                                            новые
                                            способы зарабатывать на своём опыте</li>
                                        <li>Получите бадди — партнёра, с которым сможете обсуждать идеи, сверять решения
                                            и готовиться к практическим встречам</li>
                                    </ul>
                                </div>
                                <div class="portfolio_career-program-item__result">
                                    <p class="portfolio_career-program-item__subheader">Результат недели:</p>
                                    <p class="portfolio_career-program-item__text">Понятный план обучения и человек,
                                        с которым
                                        можно обсуждать свои первые шаги</p>
                                </div>
                            </div>
                            <div class="portfolio_career-program-item careerum-flex-fsfs">
                                <div class="portfolio_career-program-item__labels careerum-flex-fsfs">
                                    <p class="portfolio_career-program-item__label">Неделя 1</p>
                                    <p class="portfolio_career-program-item__label blue">23–29 ноября</p>
                                </div>
                                <div class="portfolio_career-program-item__content">
                                    <p class="portfolio_career-program-item__type">Теория</p>
                                    <p class="portfolio_career-program-item__header">Концепция «Я-корпорация»</p>
                                    <div class="portfolio_career-program-item__block">
                                        <p class="portfolio_career-program-item__subheader">Эфир-кейс </p>
                                        <p class="portfolio_career-program-item__date">25 ноября, среда,
                                            19:00 сет/20:00 мск</p>
                                        <p class="portfolio_career-program-item__block-header">Портфельная карьера</p>
                                    </div>
                                    <ul>
                                        <li>Увидите, на что можете опираться за пределами своей должности</li>
                                        <li>Посмотрите первую часть лекции «Я-корпорация»</li>
                                        <li>Начнёте рассматривать свой опыт, навыки, репутацию и связи как основу
                                            для разных
                                            источников дохода</li>
                                        <li>Разберётесь, какие профессиональные решения можете принимать самостоятельно
                                        </li>
                                    </ul>
                                </div>
                                <div class="portfolio_career-program-item__result">
                                    <p class="portfolio_career-program-item__subheader">Результат недели:</p>
                                    <p class="portfolio_career-program-item__text">Понимание, из чего складывается
                                        ваш профессиональный капитал и как он может работать за пределами одной компании
                                    </p>
                                </div>
                            </div>
                            <div class="portfolio_career-program-item careerum-flex-fsfs blue">
                                <div class="portfolio_career-program-item__labels careerum-flex-fsfs">
                                    <p class="portfolio_career-program-item__label">Неделя 2</p>
                                    <p class="portfolio_career-program-item__label blue">30 ноября — 6 декабря</p>
                                </div>
                                <div class="portfolio_career-program-item__content">
                                    <p class="portfolio_career-program-item__type">Практика</p>
                                    <p class="portfolio_career-program-item__header">Найдёте в своём опыте то, что можно
                                        предложить другим клиентам</p>
                                    <div class="portfolio_career-program-item__block">
                                        <p class="portfolio_career-program-item__subheader">Воркшоп</p>
                                        <p class="portfolio_career-program-item__date">30 ноября, понедельник,
                                            19:00 сет/20:00 мск</p>
                                        <p class="portfolio_career-program-item__block-header">Аудит активов</p>
                                    </div>
                                    <ul>
                                        <li>На практике соберёте свои сильные стороны, достижения, кейсы и полезные
                                            связи
                                            в «Паспорт активов»</li>
                                        <li>Выделите навыки, которые можете применять в разных компаниях и проектах,
                                            и сформулируете, какие задачи способны решать для заказчиков</li>
                                        <li>Обсудите выводы на первом живом эфире и бадди-созвоне</li>
                                    </ul>
                                </div>
                                <div class="portfolio_career-program-item__result">
                                    <p class="portfolio_career-program-item__subheader">Результат недели:</p>
                                    <p class="portfolio_career-program-item__text">«Паспорт активов» — список ваших
                                        компетенций
                                        с примерами результатов и первыми идеями для заработка</p>
                                </div>
                            </div>
                            <div class="portfolio_career-program-item careerum-flex-fsfs">
                                <div class="portfolio_career-program-item__labels careerum-flex-fsfs">
                                    <p class="portfolio_career-program-item__label">Неделя 3</p>
                                    <p class="portfolio_career-program-item__label blue">7–13 декабря</p>
                                </div>
                                <div class="portfolio_career-program-item__content">
                                    <p class="portfolio_career-program-item__type">Теория</p>
                                    <p class="portfolio_career-program-item__header">7 форматов карьеры</p>
                                    <ul>
                                        <li>Разберётесь, как зарабатывать в семи форматах работы</li>
                                        <li>Посмотрите вторую часть лекции и познакомитесь с разными сценариями
                                            занятости:
                                            от экспертного фриланса и собственных проектов до работы руководителем
                                            на часть
                                            времени</li>
                                        <li>Разберётесь, как устроен каждый формат, кому он подходит и как его можно
                                            сочетать
                                            с наймом</li>
                                    </ul>
                                </div>
                                <div class="portfolio_career-program-item__result">
                                    <p class="portfolio_career-program-item__subheader">Результат недели:</p>
                                    <p class="portfolio_career-program-item__text">Несколько подходящих вам сценариев,
                                        которые
                                        стоит рассмотреть для своего портфеля</p>
                                </div>
                            </div>
                            <div class="portfolio_career-program-item careerum-flex-fsfs blue">
                                <div class="portfolio_career-program-item__labels careerum-flex-fsfs">
                                    <p class="portfolio_career-program-item__label">Неделя 4</p>
                                    <p class="portfolio_career-program-item__label blue">14–20 декабря</p>
                                </div>
                                <div class="portfolio_career-program-item__content">
                                    <p class="portfolio_career-program-item__type">Практика</p>
                                    <p class="portfolio_career-program-item__header">Соберёте своё сочетание работы,
                                        дохода
                                        и свободного времени</p>
                                    <div class="portfolio_career-program-item__block">
                                        <p class="portfolio_career-program-item__subheader">Воркшоп</p>
                                        <p class="portfolio_career-program-item__date">14 декабря, понедельник,
                                            19:00 сет/20:00 мск</p>
                                        <p class="portfolio_career-program-item__block-header">Формула портфеля</p>
                                    </div>
                                    <ul>
                                        <li>Составите первую формулу портфеля: какие занятия хотите сочетать и сколько
                                            времени
                                            готовы выделять каждому</li>
                                        <li>Учтёте желаемый доход, текущую нагрузку и силы на запуск нового направления
                                        </li>
                                        <li>На втором живом эфире и встрече с бадди обсудите, насколько реалистичен
                                            ваш вариант
                                        </li>
                                    </ul>
                                </div>
                                <div class="portfolio_career-program-item__result">
                                    <p class="portfolio_career-program-item__subheader">Результат недели:</p>
                                    <p class="portfolio_career-program-item__text">Первая версия портфеля занятости
                                        и гипотезы,
                                        которые будете прорабатывать дальше</p>
                                </div>
                            </div>
                            <div class="portfolio_career-program-item careerum-flex-fsfs">
                                <div class="portfolio_career-program-item__labels careerum-flex-fsfs">
                                    <p class="portfolio_career-program-item__label">Неделя 5</p>
                                    <p class="portfolio_career-program-item__label blue">21 декабря — 3 января</p>
                                </div>
                                <div class="portfolio_career-program-item__content">
                                    <p class="portfolio_career-program-item__type">Теория</p>
                                    <p class="portfolio_career-program-item__header">Продукт и ЦА. 4 варианта
                                        бизнес-модели</p>
                                    <ul>
                                        <li>Поймёте, кому и какой результат можете продавать</li>
                                        <li>Посмотрите первую часть лекции о бизнес-модели профессионала</li>
                                        <li>Свяжете свои навыки с задачами конкретных клиентов: кому можете помочь,
                                            что изменится благодаря вашей работе и в каком формате вы сможете
                                            это предложить
                                        </li>
                                    </ul>
                                </div>
                                <div class="portfolio_career-program-item__result">
                                    <p class="portfolio_career-program-item__subheader">Результат недели:</p>
                                    <p class="portfolio_career-program-item__text">Выбранная аудитория, задача клиента
                                        и идея
                                        услуги или продукта на основе вашего опыта</p>
                                </div>
                            </div>
                            <div class="portfolio_career-program-item careerum-flex-fsfs blue">
                                <div class="portfolio_career-program-item__labels careerum-flex-fsfs">
                                    <p class="portfolio_career-program-item__label">Неделя 6</p>
                                    <p class="portfolio_career-program-item__label blue">4–10 января</p>
                                </div>
                                <div class="portfolio_career-program-item__content">
                                    <p class="portfolio_career-program-item__type">Практика</p>
                                    <p class="portfolio_career-program-item__header">Сформулируете предложение,
                                        с которым можно
                                        идти к клиентам</p>
                                    <div class="portfolio_career-program-item__block">
                                        <p class="portfolio_career-program-item__subheader">Воркшоп</p>
                                        <p class="portfolio_career-program-item__date">4 января, понедельник,
                                            19:00 сет/20:00 мск</p>
                                        <p class="portfolio_career-program-item__block-header">Драфт оффера</p>
                                    </div>
                                    <ul>
                                        <li>Подготовите первый вариант оффера: кому помогаете, какую задачу решаете,
                                            что входит
                                            в работу и какой результат получает клиент</li>
                                        <li>На третьем живом эфире и бадди-созвоне проверите, понятно ли ваше
                                            предложение
                                            человеку, который с вами ещё не знаком</li>
                                    </ul>
                                </div>
                                <div class="portfolio_career-program-item__result">
                                    <p class="portfolio_career-program-item__subheader">Результат недели:</p>
                                    <p class="portfolio_career-program-item__text">Черновик предложения
                                        для потенциальных
                                        клиентов</p>
                                </div>
                            </div>
                            <div class="portfolio_career-program-item careerum-flex-fsfs">
                                <div class="portfolio_career-program-item__labels careerum-flex-fsfs">
                                    <p class="portfolio_career-program-item__label">Неделя 7</p>
                                    <p class="portfolio_career-program-item__label blue">11–17 января</p>
                                </div>
                                <div class="portfolio_career-program-item__content">
                                    <p class="portfolio_career-program-item__type">Теория</p>
                                    <p class="portfolio_career-program-item__header">Рассчитаете цену своей работы
                                        и нужное
                                        количество заказов</p>
                                    <ul>
                                        <li>Посмотрите вторую часть лекции о монетизации</li>
                                        <li>Разберёте модели оплаты и выберете подходящую для своего предложения</li>
                                        <li>Рассчитаете, сколько времени займёт работа, какие расходы нужно учесть
                                            и сколько
                                            заказов потребуется для желаемого дохода</li>
                                    </ul>
                                </div>
                                <div class="portfolio_career-program-item__result">
                                    <p class="portfolio_career-program-item__subheader">Результат недели:</p>
                                    <p class="portfolio_career-program-item__text">Предварительная цена, модель оплаты
                                        и финансовый расчёт выбранного направления</p>
                                </div>
                            </div>
                            <div class="portfolio_career-program-item careerum-flex-fsfs blue">
                                <div class="portfolio_career-program-item__labels careerum-flex-fsfs">
                                    <p class="portfolio_career-program-item__label">Неделя 8</p>
                                    <p class="portfolio_career-program-item__label blue">18–24 января</p>
                                </div>
                                <div class="portfolio_career-program-item__content">
                                    <p class="portfolio_career-program-item__type">Практика</p>
                                    <p class="portfolio_career-program-item__header">Проверите своё предложение
                                        на потенциальных
                                        клиентах</p>
                                    <div class="portfolio_career-program-item__block">
                                        <p class="portfolio_career-program-item__subheader">Воркшоп</p>
                                        <p class="portfolio_career-program-item__date">18 января, понедельник,
                                            19:00 сет/20:00 мск</p>
                                        <p class="portfolio_career-program-item__block-header">Карточка оффера & тест
                                            гипотезы
                                        </p>
                                    </div>
                                    <ul>
                                        <li>Соберёте «Карточку оффера»: услугу, аудиторию, результат, формат и цену</li>
                                        <li>Проведёте небольшой тест спроса — например, обсудите предложение
                                            с потенциальными
                                            клиентами или предложите пилотный проект</li>
                                        <li>На четвёртом живом эфире разберёте обратную связь и решите,
                                            что скорректировать</li>
                                    </ul>
                                </div>
                                <div class="portfolio_career-program-item__result">
                                    <p class="portfolio_career-program-item__subheader">Результат недели:</p>
                                    <p class="portfolio_career-program-item__text">Готовая «Карточка оффера» и первые
                                        данные
                                        о том, насколько клиентам нужны ваше решение и предложенные условия</p>
                                </div>
                            </div>
                            <div class="portfolio_career-program-item careerum-flex-fsfs">
                                <div class="portfolio_career-program-item__labels careerum-flex-fsfs">
                                    <p class="portfolio_career-program-item__label">Неделя 9</p>
                                    <p class="portfolio_career-program-item__label blue">25–31 января</p>
                                </div>
                                <div class="portfolio_career-program-item__content">
                                    <p class="portfolio_career-program-item__type">Теория</p>
                                    <p class="portfolio_career-program-item__header">Составите план развития портфельной
                                        карьеры
                                        на 3–6 месяцев</p>
                                    <ul>
                                        <li>Объедините результаты программы в одну стратегию: ваши активы, выбранные
                                            форматы
                                            занятости, предложение клиентам и финансовые расчёты</li>
                                        <li>Определите следующие шаги, сроки и посильную нагрузку</li>
                                        <li>Подготовите презентацию стратегии и отрепетируете её с бадди</li>
                                    </ul>
                                </div>
                                <div class="portfolio_career-program-item__result">
                                    <p class="portfolio_career-program-item__subheader">Результат недели:</p>
                                    <p class="portfolio_career-program-item__text">Дорожная карта на 3–6 месяцев —
                                        что проверять, кому предлагать свои услуги и как совмещать запуск с текущей
                                        работой</p>
                                </div>
                            </div>
                            <div class="portfolio_career-program-item careerum-flex-fsfs">
                                <div class="portfolio_career-program-item__labels careerum-flex-fsfs">
                                    <p class="portfolio_career-program-item__label">Неделя 10</p>
                                    <p class="portfolio_career-program-item__label blue">1–7 февраля</p>
                                </div>
                                <div class="portfolio_career-program-item__content">
                                    <p class="portfolio_career-program-item__type">Теория</p>
                                    <p class="portfolio_career-program-item__header">Доработаете стратегию и определите
                                        первые
                                        шаги после программы</p>
                                    <ul>
                                        <li>Представите свой план на финальном живом эфире</li>
                                        <li>Получите обратную связь, уточните спорные решения и расставите приоритеты:
                                            с какого
                                            направления начать, что проверить первым и по каким результатам оценивать
                                            движение
                                        </li>
                                    </ul>
                                </div>
                                <div class="portfolio_career-program-item__result">
                                    <p class="portfolio_career-program-item__subheader">Результат недели:</p>
                                    <p class="portfolio_career-program-item__text">Доработанная стратегия портфельной
                                        карьеры
                                        с конкретными действиями, сроками и критериями проверки</p>
                                </div>
                            </div>
                        </div>
                        <div class="slider-nav careerum-flex-fec">
                            <div class="slick-nav-prev careerum-flex-cc">
                                <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.32031 7.32104L15.3203 7.32104" stroke="white" stroke-width="2.64201"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M7.32031 13.321L1.32031 7.32104L7.32031 1.32104" stroke="white"
                                        stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <div class="slick-nav-next careerum-flex-cc">
                                <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.3203 7.32105L1.32031 7.32104" stroke="white" stroke-width="2.64201"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M9.32031 1.32104L15.3203 7.32105L9.32031 13.321" stroke="white"
                                        stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="portfolio_career-buttons careerum-flex-fsfs">
                        <a href="#buy" class="btn-color-main-black position-relative wide">
                            <p>Посмотреть тарифы от 29 900 ₽</p>
                            <div class="portfolio_career-main-button__label careerum-flex-fsc position-absolute z-10">
                                <img src="https://cdn.careerum.com/1793696137509-vdOMz-Fire.svg" alt="img" loading="eager">
                                <p>Всего 100 мест</p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-portfolio_career-cases', {
        label: 'Careerum portfolio_career cases',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-portfolio_career-cases main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Кейсы наших клиентов</h2>
                    <div class="portfolio_career-cases-slider careerum-slick-slider-wrapper noselect">
                        <div class="slider-elements">
                            <div class="portfolio_career-cases-item">
                                <img src="https://cdn.careerum.com/1793723282328-5upH9-Fram.png" alt="img" loading="lazy">
                                <div class="portfolio_career-cases-item__content">
                                    <p class="portfolio_career-cases-item__name">Кирилл Азаренко</p>
                                    <p class="portfolio_career-cases-item__position">Лид продукта, Россия</p>
                                    <div class="portfolio_career-cases-item__divider"></div>
                                    <p class="portfolio_career-cases-item__header">Перешёл из семейного бизнеса в найм,
                                        чтобы найти работy по любви</p>
                                    <div class="portfolio_career-cases-item__result careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1793723179553-NeMUa-Chec.svg"
                                            alt="img" loading="lazy">
                                        <p>Результат с Careerum:</p>
                                    </div>
                                    <ul>
                                        <li>Сменил вектор и вырос до руководящей должности</li>
                                        <li>Увеличил доход в 4 раза</li>
                                        <li>Стал амбассадором Careerum, проводит нетворк-встречи клуба</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="portfolio_career-cases-item">
                                <img src="https://cdn.careerum.com/1793723282471-FU8nP-Fram.png" alt="img" loading="lazy">
                                <div class="portfolio_career-cases-item__content">
                                    <p class="portfolio_career-cases-item__name">Александра Анцупова</p>
                                    <p class="portfolio_career-cases-item__position">Crew Coordinator and Analyst,
                                        Латвия</p>
                                    <div class="portfolio_career-cases-item__divider"></div>
                                    <p class="portfolio_career-cases-item__header">Меняла сферы деятельности, нигде
                                        не могла
                                        почyвствовать себя на своём месте</p>
                                    <div class="portfolio_career-cases-item__result careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1793723179553-NeMUa-Chec.svg"
                                            alt="img" loading="lazy">
                                        <p>Результат с Careerum:</p>
                                    </div>
                                    <ul>
                                        <li>Собрала весь свой опыт в сильное резюме мyльтиспециалиста</li>
                                        <li>Полностью сменила индустрию и выросла в зарплате</li>
                                        <li>Осознала свои ценности и потребности в работе</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="portfolio_career-cases-item">
                                <img src="https://cdn.careerum.com/1793723282527-rNNbO-Fram.png" alt="img" loading="lazy">
                                <div class="portfolio_career-cases-item__content">
                                    <p class="portfolio_career-cases-item__name">Наталья Рябова</p>
                                    <p class="portfolio_career-cases-item__position">Global L&D Manager, Германия</p>
                                    <div class="portfolio_career-cases-item__divider"></div>
                                    <p class="portfolio_career-cases-item__header">Совмещала проекты, накопила опыт
                                        и устроилась
                                        в Германии без немецкого</p>
                                    <div class="portfolio_career-cases-item__result careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1793723179553-NeMUa-Chec.svg"
                                            alt="img" loading="lazy">
                                        <p>Результат с Careerum:</p>
                                    </div>
                                    <ul>
                                        <li>Выросла в зарплате на 70%</li>
                                        <li>Полyчила оффер через 2 недели после собеседования</li>
                                        <li>Сформировалось ощущение «я на своём месте»</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="portfolio_career-cases-item">
                                <img src="https://cdn.careerum.com/1793723282598-AManR-Fram.png" alt="img" loading="lazy">
                                <div class="portfolio_career-cases-item__content">
                                    <p class="portfolio_career-cases-item__name">Дмитрий Иванов</p>
                                    <p class="portfolio_career-cases-item__position">Chief Operating Officer, ОАЭ</p>
                                    <div class="portfolio_career-cases-item__divider"></div>
                                    <p class="portfolio_career-cases-item__header">Работал в найме, перешёл в свой
                                        консалтинговый проект, диверсифицировал доход</p>
                                    <div class="portfolio_career-cases-item__result careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1793723179553-NeMUa-Chec.svg"
                                            alt="img" loading="lazy">
                                        <p>Результат с Careerum:</p>
                                    </div>
                                    <ul>
                                        <li>Появилось ощyщение финансовой yверенности</li>
                                        <li>Сократилась тревога остаться невостребованным специалистом</li>
                                        <li>Стало легче решаться на перемены и амбициозные шаги</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="portfolio_career-cases-item">
                                <img src="https://cdn.careerum.com/1793723282658-6e4o4-Fram.png" alt="img" loading="lazy">
                                <div class="portfolio_career-cases-item__content">
                                    <p class="portfolio_career-cases-item__name">Елизавета Коряковская</p>
                                    <p class="portfolio_career-cases-item__position">MD & Board-Certified Cardiologist,
                                        Голландия</p>
                                    <div class="portfolio_career-cases-item__divider"></div>
                                    <p class="portfolio_career-cases-item__header">Строит портфельную карьеру, совмещая
                                        околомедицинские проекты</p>
                                    <div class="portfolio_career-cases-item__result careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1793723179553-NeMUa-Chec.svg"
                                            alt="img" loading="lazy">
                                        <p>Результат с Careerum:</p>
                                    </div>
                                    <ul>
                                        <li>Релоцировалась в Голландию</li>
                                        <li>Выросла в доходе благодаря совмещению проектов</li>
                                        <li>Расширила экспертизy и стала yвереннее в себе как в специалисте</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="portfolio_career-cases-item">
                                <img src="https://cdn.careerum.com/1793723282707-ipsoW-Fram.png" alt="img" loading="lazy">
                                <div class="portfolio_career-cases-item__content">
                                    <p class="portfolio_career-cases-item__name">Мария Санкова</p>
                                    <p class="portfolio_career-cases-item__position">Business Development Manager, ОАЭ
                                    </p>
                                    <div class="portfolio_career-cases-item__divider"></div>
                                    <p class="portfolio_career-cases-item__header">Попробовала себя в мyзыке, логистике,
                                        бизнесе, не видела себя ни в одном направлении</p>
                                    <div class="portfolio_career-cases-item__result careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1793723179553-NeMUa-Chec.svg"
                                            alt="img" loading="lazy">
                                        <p>Результат с Careerum:</p>
                                    </div>
                                    <ul>
                                        <li>Сформировала четкyю карьернyю цель</li>
                                        <li>Поняла, какая карьера «её» по‑настоящемy</li>
                                        <li>Использовала прошлый опыт, чтобы полyчить текyщyю роль и релоцироваться
                                            в ОАЭ</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="portfolio_career-cases-item">
                                <img src="https://cdn.careerum.com/1793723282789-n8CgR-Fram.png" alt="img" loading="lazy">
                                <div class="portfolio_career-cases-item__content">
                                    <p class="portfolio_career-cases-item__name">Ольга Дробышева</p>
                                    <p class="portfolio_career-cases-item__position">Специалист по маркетингy, Россия
                                    </p>
                                    <div class="portfolio_career-cases-item__divider"></div>
                                    <p class="portfolio_career-cases-item__header">Пробовала себя в 7 разных ролях,
                                        но всегда
                                        появлялось ощущение, что выросла из них</p>
                                    <div class="portfolio_career-cases-item__result careerum-flex-fsfs">
                                        <img src="https://cdn.careerum.com/1793723179553-NeMUa-Chec.svg"
                                            alt="img" loading="lazy">
                                        <p>Результат с Careerum:</p>
                                    </div>
                                    <ul>
                                        <li>Наша сферy, где по‑настоящемy интересно и можно применить весь опыт</li>
                                        <li>Выросла в зарплате на 50%</li>
                                        <li>Появилось ощyщение самореализованности</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="slider-nav careerum-flex-fec">
                            <div class="slick-nav-prev careerum-flex-cc">
                                <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.32031 7.32104L15.3203 7.32104" stroke="white" stroke-width="2.64201"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M7.32031 13.321L1.32031 7.32104L7.32031 1.32104" stroke="white"
                                        stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <div class="slick-nav-next careerum-flex-cc">
                                <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.3203 7.32105L1.32031 7.32104" stroke="white" stroke-width="2.64201"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M9.32031 1.32104L15.3203 7.32105L9.32031 13.321" stroke="white"
                                        stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="portfolio_career-buttons careerum-flex-fsfs">
                        <a href="#buy" class="btn-color-main-black position-relative wide">
                            <p>Посмотреть тарифы от 29 900 ₽</p>
                            <div class="portfolio_career-main-button__label careerum-flex-fsc position-absolute z-10">
                                <img src="https://cdn.careerum.com/1793696137509-vdOMz-Fire.svg" alt="img" loading="eager">
                                <p>Всего 100 мест</p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-portfolio_career-author', {
        label: 'Careerum portfolio_career author',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-portfolio_career-author main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Авторы и ведущие программы</h2>
                    <div class="portfolio_career-author-about careerum-flex-sbfs">
                        <div class="portfolio_career-author__left">
                            <img src="https://cdn.careerum.com/1793713557790-kGwGS-Fram.png" class="hidden-tablet-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1793713560617-G4uHz-Fram.png" class="hidden-desc-mobile"
                                alt="img" loading="lazy">
                            <img src="https://cdn.careerum.com/1793713562370-63IoI-Fram.png" class="hidden-desc-tablet"
                                alt="img" loading="lazy">
                        </div>
                        <div class="portfolio_career-author__right">
                            <p class="portfolio_career-author__name">Ольга Лермонтова</p>
                            <p class="portfolio_career-author__description">Автор программы и основательница
                                международной
                                карьерной платформы Careerum</p>
                            <a href="#author-popup" class="btn-color-main-transparent">Подробнее об эксперте</a>
                        </div>
                    </div>
                    <div class="portfolio_career-author-banner">
                        <div class="portfolio_career-author-banner__top position-relative">
                            <div class="position-relative z-10">
                                <p>С вами будет работать наша команда карьерных экспертов и коучей</p>
                            </div>
                            <img loading="lazy" src="https://cdn.careerum.com/1793714190162-33W7K-Vect.svg" alt="img"
                                class="hidden-tablet-mobile position-absolute z-1">
                            <img loading="lazy" src="https://cdn.careerum.com/1780393427001-5IjGP-Vect.svg" alt="img"
                                class="hidden-desc-mobile position-absolute z-1">
                            <img loading="lazy" src="https://cdn.careerum.com/1780393445464-4DarR-Vect.svg" alt="img"
                                class="hidden-desc-tablet position-absolute z-1">
                        </div>
                        <div class="portfolio_career-author-banner__bottom">
                            <ul class="careerum-flex-sbfs">
                                <li class="careerum-flex-fsfs">
                                    <img loading="lazy" src="https://cdn.careerum.com/1780392344972-5H0Pn-Chec.svg" alt="img"
                                        class="hidden-mobile">
                                    <img loading="lazy" src="https://cdn.careerum.com/1780393930766-1U38L-Chec.svg" alt="img"
                                        class="hidden-desc-tablet">
                                    <p>Знают, что реально работает на рынке, а что — нет. 4500+ проведенных сессий</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img loading="lazy" src="https://cdn.careerum.com/1780392345000-jMVkD-Eye..svg" alt="img"
                                        class="hidden-mobile">
                                    <img loading="lazy" src="https://cdn.careerum.com/1780393930801-raPI6-Eye..svg" alt="img"
                                        class="hidden-desc-tablet">
                                    <p>Видят сотни кейсов переходов, увольнений и офферов </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img loading="lazy" src="https://cdn.careerum.com/1780392344898-uZu3P-Chat.svg" alt="img"
                                        class="hidden-mobile">
                                    <img loading="lazy" src="https://cdn.careerum.com/1780393930643-E4jay-Chat.svg" alt="img"
                                        class="hidden-desc-tablet">
                                    <p>Могут сказать правду, даже если она неудобная</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img loading="lazy" src="https://cdn.careerum.com/1780392345024-Gv3jN-Gear.svg" alt="img"
                                        class="hidden-mobile">
                                    <img loading="lazy" src="https://cdn.careerum.com/1780393930832-OlLq4-Gear.svg" alt="img"
                                        class="hidden-desc-tablet">
                                    <p>Понимают рынок изнутри</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="portfolio_career-author-couches">
                        <p class="portfolio_career-author-couches__header">Экспертность в рынках:</p>
                        <div class="careerum-flex-fsc portfolio_career-author-couches__regions">
                            <p>РФ</p>
                            <p>СНГ</p>
                            <p>ЕС</p>
                            <p>DACH</p>
                            <p>США</p>
                            <p>ОАЭ</p>
                            <p>JАРАС</p>
                            <p>MENA</p>
                            <p>LATAM</p>
                            <p>UK&I</p>
                            <p>BALTICS</p>
                        </div>
                        <div class="portfolio_career-author-couches__slider  careerum-slick-slider-wrapper noselect">
                            <div class="slider-elements">
                                <div class="portfolio_career-author-couches__item">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746618898-9cdVR-Fram.png"
                                        alt="img" class="hidden-mobile" />
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746743241-y0qDT-Spea.png"
                                        alt="img" class="hidden-desc-tablet" />
                                    <p class="awake-couches-item-name">Майя Бурякина</p>
                                    <p class="awake-couches-item-position">Коуч ACC ICF,
                                        США/Россия</p>
                                    <ul>
                                        <li>11+ лет в подборе, адаптации и развитии
                                            персонала</li>
                                        <li>400+ часов индивидуальной работы с клиентами
                                        </li>
                                        <li>Ex-руководитель HR-направления
                                            в международной FMCG-компании с 2500+
                                            сотрудников</li>
                                    </ul>
                                </div>
                                <div class="portfolio_career-author-couches__item">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746618185-KErUh-Fram.png"
                                        alt="img" class="hidden-mobile" />
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746742868-gDdJB-Spea.png"
                                        alt="img" class="hidden-desc-tablet" />
                                    <p class="awake-couches-item-name">Олеся Спиридонова</p>
                                    <p class="awake-couches-item-position">Коуч практик ФПКиН,
                                        психолог-консультант,
                                        Россия</p>
                                    <ul>
                                        <li>16+ лет в коучинге и инженерной отрасли</li>
                                        <li>Провела 400+ консультаций на тему
                                            карьерного развития. Соавтор и разработчик профессиональных стандартов.</li>
                                        <li>Клиенты из IT, финансы, маркетинг, EdTech
                                            и др.</li>
                                    </ul>
                                </div>
                                <div class="portfolio_career-author-couches__item">
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746617188-gBD3O-Fram.png"
                                        alt="img" class="hidden-mobile" />
                                    <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1752746742157-30J0a-Spea.png"
                                        alt="img" class="hidden-desc-tablet" />
                                    <p class="awake-couches-item-name">Николай Пулин</p>
                                    <p class="awake-couches-item-position">Карьерный консультант и коуч ICF, Германия
                                    </p>
                                    <ul>
                                        <li>6+ лет в HR, 3+ года в карьерном
                                            консyльтировании</li>
                                        <li>400+ консyльтаций для специалистов РФ и международного рынка</li>
                                        <li>Клиенты из Apple, Amazon, Microsoft,
                                            Miro, Mars, Яндекс, Авито, Сбер и другие крупные бренды </li>
                                    </ul>
                                </div>
                                <div class="portfolio_career-author-couches__item">
                                    <img loading=""
                                        src="https://storage.yandexcloud.net/cdn.careerum.com/1775729352581-8SA1V-Fram.png"
                                        alt="img" class="hidden-mobile" />
                                    <img loading=""
                                        src="https://storage.yandexcloud.net/cdn.careerum.com/1775729352581-8SA1V-Fram.png"
                                        alt="img" class="hidden-desc-tablet" />
                                    <p class="awake-couches-item-name">Ольга Пешкова</p>
                                    <p class="awake-couches-item-position">Карьерный консультант,
                                        Болгария</p>
                                    <ul>
                                        <li>
                                            8+ лет опыта в рекрутменте <br />(in-house и
                                            агентство)
                                        </li>
                                        <li>Действующий рекрутер
                                        </li>
                                        <li>Спикер о карьере в Европе на разных
                                            площадках</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="slider-nav careerum-flex-fec">
                                <div class="slick-nav-prev careerum-flex-cc">
                                    <svg width="17" height="15" viewBox="0 0 17 15" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.32031 7.32104L15.3203 7.32104" stroke="white" stroke-width="2.64201"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M7.32031 13.321L1.32031 7.32104L7.32031 1.32104" stroke="white"
                                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <div class="slick-nav-next careerum-flex-cc">
                                    <svg width="17" height="15" viewBox="0 0 17 15" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M15.3203 7.32105L1.32031 7.32104" stroke="white" stroke-width="2.64201"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M9.32031 1.32104L15.3203 7.32105L9.32031 13.321" stroke="white"
                                            stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="portfolio_career-buttons careerum-flex-fsfs">
                        <a href="#buy" class="btn-color-main-black position-relative">
                            <p>Посмотреть тарифы от 29 900 ₽</p>
                            <div class="portfolio_career-main-button__label careerum-flex-fsc position-absolute z-10">
                                <img src="https://cdn.careerum.com/1793696137509-vdOMz-Fire.svg" alt="img" loading="eager">
                                <p>Всего 100 мест</p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-portfolio_career-tariffs', {
        label: 'Careerum portfolio_career tariffs',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div data-timer="" custom-link-anchor="buy"
                class="careerum-awake-tariffs careerum-club50-tariffs main-wrapper careerum-portfolio_career-tariffs">
                <div class="careerum-container-responsive">
                    <div class="awake-tariffs-top">
                        <h2 class="inline-block">Выберите тариф подписки</h2>
                        <p>Программа «Портфельная карьера» входит в подписку Careerum. Вам будут доступны
                            также все образовательные материалы на нашей платформе, доступ в профессиональное комьюнити,
                            регулярные эфиры клуба Careerum</p>
                    </div>
                    <div class="awake-tariffs-switchers careerum-flex-sbfs">
                        <div class="awake-tariffs-period-wrapper">
                            <div class="awake-tariffs-period careerum-flex-fsst">
                                <ul class="careerum-flex-fsfs not-m1 m1">
                                    <li data-period="1" class="hidden">
                                        <p class="hidden-mobile">1 месяц</p>
                                        <p class="hidden-desc-tablet">1 меc</p>
                                    </li>
                                    <li data-period="3" class="active">
                                        <p class="hidden-mobile">3 месяца</p>
                                        <p class="hidden-desc-tablet">3 месяца</p>
                                    </li>
                                    <li data-period="6" class="hidden">
                                        <p class="hidden-mobile">6 месяцев</p>
                                        <p class="hidden-desc-tablet">6 мес</p>
                                    </li>
                                    <li data-period="12" class="hidden">
                                        <p class="hidden-mobile">12 месяцев</p>
                                        <p class="hidden-desc-tablet">12 мес</p>
                                    </li>
                                </ul>
                                <div class="awake-tariffs-notif careerum-flex-cc">
                                    <div class="awake-tariffs-notif-icon"> <img loading=""
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                            alt=""> </div>
                                    <div class="awake-tariffs-notif-content">
                                        <p>1 месяц подписки предоставляет 30 дней доступа
                                            к платформе</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="awake-tariffs-curr careerum-flex-fsst">
                            <ul class="careerum-flex-fsfs rub">
                                <li data-currency="eur">EUR</li>
                                <li data-currency="rub" class="active">RUB</li>
                            </ul>
                            <div class="awake-tariffs-notif careerum-flex-cc">
                                <div class="awake-tariffs-notif-icon"> <img loading=""
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                        alt=""> </div>
                                <div class="awake-tariffs-notif-content">
                                    <p>Оплата в российских рублях возможна только картой
                                        российского банка.
                                        В евро — картой
                                        зарубежного банка</p>
                                </div>
                            </div>
                        </div>
                        <div class="awake-tariffs-curr-mobile">
                            <div class="awake-tariffs__swicher-block">
                                <div class="awake-tariffs__swicher-top">
                                    <p class="awake-tariffs__swicher-header">Посмотреть
                                        цены в
                                        <span>EUR</span>
                                    </p>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" class="awake-tariffs__swicher-arrow">
                                        <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black">
                                        </path>
                                    </svg>
                                </div>
                                <div class="awake-tariffs__swicher-bottom">
                                    <ul>
                                        <li data-currency="rub" class="active">
                                            RUB
                                        </li>
                                        <li data-currency="eur">
                                            EUR
                                        </li>
                                    </ul>
                                    <p>
                                        Обратите внимание,<br> что оплата в российских
                                        рублях
                                        возможна только<br> с карты
                                        российского банка. Оплата в евро — с карты зарубежного банка
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="awake-tariffs-items-wrapper elements-2">
                        <div class="awake-tariffs-items careerum-flex-fsst">
                            <div data-price="" data-price-1m-rub="50 000 ₽" data-oldprice-1m-rub="12 900 ₽"
                                data-discount-1m-rub="-25%" data-price-3m-rub="9 900 ₽" data-fullprice-3m-rub="29 900 ₽"
                                data-oldprice-3m-rub="39 900 ₽" data-discount-3m-rub="-25%" data-price-6m-rub="8 900 ₽"
                                data-oldprice-6m-rub="" data-discount-6m-rub="" data-fullprice-6m-rub="53 400 ₽"
                                data-price-12m-rub="6 900 ₽" data-fullprice-12m-rub="82 800 ₽" data-discount-12m-rub="–22%"
                                data-oldprice-12m-rub="106 800 ₽" data-price-1m-eur="500 €" data-oldprice-1m-eur="149 €"
                                data-discount-1m-eur="–39%" data-price-3m-eur="89 €" data-fullprice-3m-eur="267 €"
                                data-oldprice-3m-eur="447 €" data-discount-3m-eur="–39%" data-price-6m-eur="89 €"
                                data-fullprice-6m-eur="534 €" data-oldprice-6m-eur="" data-discount-6m-eur=" %"
                                data-price-12m-eur="69 €" data-fullprice-12m-eur="828 €" data-oldprice-12m-eur="1 068 €"
                                data-discount-12m-eur="–22%" data-offer-1m-rub="27" data-offer-3m-rub="94"
                                data-offer-6m-rub="95" data-offer-12m-rub="96" data-offer-1m-eur="48" data-offer-3m-eur="97"
                                data-offer-6m-eur="98" data-offer-12m-eur="99" id="i2th66z"
                                class="awake-tariffs-item careerum-flex-fsfs">
                                <div class="awake-tariffs-item-header blue">
                                    <p class="awake-tariffs-item-header">Базовый</p>
                                </div>
                                <div class="awake-tariffs-item-content">
                                    <ul>
                                        <li class="careerum-flex-fsfs"><img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p id="i7z91s">Программа «Портфельная карьера»</p>
                                        </li>
                                        <li class="careerum-flex-fsfs"><img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p id="i93qoe">Все воркшопы программы</p>
                                        </li>
                                        <li class="careerum-flex-fsfs"><img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p id="ievhjrk">Фидбек от экспертов в общем чате </p>
                                        </li>
                                        <li class="careerum-flex-fsfs"><img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p id="iuhl77g">Доступ в карьерный клуб</p>
                                        </li>
                                        <li class="careerum-flex-fsfs"><img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p id="iuhl77g">Экспертные онлайн-эфиры клуба</p>
                                        </li>
                                        <li class="careerum-flex-fsfs disabled">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321524-Xduv4-XCir.svg"
                                                alt="">
                                            <p id="ie71os">Работа в малых группах по 5 человек с карьерым экспертом</p>
                                        </li>
                                    </ul>
                                </div>
                                <div class="awake-tariffs-item-footer">
                                    <div class="awake-tariffs-item-discount hidden-m1">
                                        <p class="awake-tariffs-item-discount"></p>
                                        <p class="awake-tariffs-item-oldprice"></p>
                                    </div>
                                    <div class="awake-tariffs-item-price careerum-flex-fsfs">
                                        <p class="awake-tariffs-item-fullprice-amount">50
                                            000 ₽</p>
                                        <p class="awake-tariffs-item-price-separator">/
                                        </p>
                                        <div>
                                            <p class="awake-tariffs-item-price-amount">
                                            </p>
                                            <p class="awake-tariffs-item-price-text">цена
                                                месяца</p>
                                        </div>
                                    </div>
                                    <div class="awake-tariffs-item-rassr careerum-flex-fsc hidden-m1"><img loading=""
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753885469183-Cyal7-Cred.svg"
                                            alt="img">
                                        <p>Доступно в рассрочку</p>
                                    </div>
                                    <div class="awake-tariffs-item-link"> <a onclick=""
                                            href="https://school.careerum.ru/anketa_strat" target="_blank"
                                            class="no-change no-popup getparams btn-color-main-black">Купить</a> </div>
                                </div>
                            </div>
                            <div data-price="" data-price-1m-rub="14 900 ₽" data-oldprice-1m-rub="9 900 ₽"
                                data-discount-1m-rub=" %" data-price-3m-rub="14 000 ₽" data-fullprice-3m-rub="39 900 ₽"
                                data-oldprice-3m-rub="44 700 ₽" data-discount-3m-rub="-10%" data-price-6m-rub="14 000 ₽"
                                data-fullprice-6m-rub="78 000 ₽" data-oldprice-6m-rub="89 400 ₽" data-discount-6m-rub="-13%"
                                data-price-12m-rub="10 000 ₽" data-fullprice-12m-rub="120 000 ₽"
                                data-oldprice-12m-rub="178 800 ₽" data-discount-12m-rub="-33%" data-price-1m-eur="199 €"
                                data-oldprice-1m-eur="99 €" data-discount-1m-eur=" %" data-price-3m-eur="180 €"
                                data-fullprice-3m-eur="540 €" data-oldprice-3m-eur="597 €" data-discount-3m-eur="-10%"
                                data-price-6m-eur="150 €" data-fullprice-6m-eur="900 €" data-oldprice-6m-eur="1 194 €"
                                data-discount-6m-eur="-25%" data-price-12m-eur="110 €" data-fullprice-12m-eur="1 320 €"
                                data-oldprice-12m-eur="2 388 €" data-discount-12m-eur="-45%" data-offer-1m-rub="28"
                                data-offer-3m-rub="29" data-offer-6m-rub="30" data-offer-12m-rub="31" data-offer-1m-eur="49"
                                data-offer-3m-eur="50" data-offer-6m-eur="51" data-offer-12m-eur="52"
                                class="awake-tariffs-item careerum-flex-fsfs m1 rub">
                                <div class="awake-tariffs-item-header blue">
                                    <p class="awake-tariffs-item-header">С поддержкой
                                        экспертов</p>
                                </div>
                                <div class="awake-tariffs-item-content">
                                    <div class="awake-tariffs-item-content-img"><img loading="lazy"
                                            src="https://storage.yandexcloud.net/cdn.careerum.com/1790679978943-TDoDy-Fram.png"
                                            alt="img" class="hidden-tablet-mobile z-1"><img loading="lazy"
                                            src="https://storage.yandexcloud.net/cdn.careerum.com/1790679980725-ZXlak-Fram.png"
                                            alt="img" class="hidden-desc-mobile z-1"><img loading="lazy"
                                            src="https://storage.yandexcloud.net/cdn.careerum.com/1790679982503-QzfAY-Fram.png"
                                            alt="img" class="hidden-desc-tablet z-1"></div>
                                    <ul>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>Все, что входит в тариф «Базовый»</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>Работа в малых группах по 5 человек с карьерым экспертом</p>
                                        </li>
                                        <li class="careerum-flex-fsfs">
                                            <img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p>Презентация стратегии и фидбек от потенциальной целевой аудитории
                                            </p>
                                        </li>
                                    </ul>
                                </div>
                                <div class="awake-tariffs-item-footer">
                                    <div class="awake-tariffs-item-discount hidden-m1">
                                        <p class="awake-tariffs-item-discount"></p>
                                        <p class="awake-tariffs-item-oldprice"></p>
                                    </div>
                                    <div class="awake-tariffs-item-price careerum-flex-fsfs">
                                        <p class="awake-tariffs-item-fullprice-amount">50
                                            000 ₽</p>
                                        <p class="awake-tariffs-item-price-separator">/
                                        </p>
                                        <div>
                                            <p class="awake-tariffs-item-price-amount">
                                            </p>
                                            <p class="awake-tariffs-item-price-text">цена
                                                месяца</p>
                                        </div>
                                    </div>
                                    <div class="awake-tariffs-item-rassr careerum-flex-fsc hidden-m1"><img loading=""
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753885469183-Cyal7-Cred.svg"
                                            alt="img">
                                        <p>Доступно в рассрочку</p>
                                    </div>
                                    <div class="awake-tariffs-item-link"> <a onclick=""
                                            href="https://school.careerum.ru/anketa_strat" target="_blank"
                                            class="no-change no-popup getparams btn-color-main-black">Купить</a> </div>
                                </div>
                            </div>
                            <div data-price="" data-price-1m-rub="33 900 ₽" data-oldprice-1m-rub="" data-discount-1m-rub=" %"
                                data-price-3m-rub="33 000 ₽" data-fullprice-3m-rub="99 000 ₽" data-oldprice-3m-rub="101 700 ₽"
                                data-discount-3m-rub="-3%" data-price-6m-rub="29 000 ₽" data-fullprice-6m-rub="174 000 ₽"
                                data-oldprice-6m-rub="203 400 ₽" data-discount-6m-rub="-14%" data-price-12m-rub="22 000 ₽"
                                data-fullprice-12m-rub="264 000 ₽" data-oldprice-12m-rub="406 800 ₽"
                                data-discount-12m-rub="-35%" data-price-1m-eur="360 €" data-oldprice-1m-eur=""
                                data-discount-1m-eur=" %" data-price-3m-eur="330 €" data-fullprice-3m-eur="990 €"
                                data-oldprice-3m-eur="1 080 €" data-discount-3m-eur="-8%" data-price-6m-eur="290 €"
                                data-fullprice-6m-eur="1 740 €" data-oldprice-6m-eur="2 160 €" data-discount-6m-eur="-19%"
                                data-price-12m-eur="245 €" data-fullprice-12m-eur="2 940 €" data-oldprice-12m-eur="4 320 €"
                                data-discount-12m-eur="-32%" data-offer-1m-rub="32" data-offer-3m-rub="100"
                                data-offer-6m-rub="101" data-offer-12m-rub="102" data-offer-1m-eur="53" data-offer-3m-eur="103"
                                data-offer-6m-eur="104" data-offer-12m-eur="105"
                                class="awake-tariffs-item careerum-flex-fsfs m1 rub hidden">
                                <div id="iczbjnn" class="awake-tariffs-item-header dark">
                                    <div id="ixklgyb" class="careerum-flex-fsc awake-tariffs-item-header-wrapper">
                                        <div class="awake-tariffs-item-header-label careerum-flex-fsc white"><img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321867-adLt2-Meda.svg"
                                                alt="img">
                                            <p id="ipqink">Личная работа с экспертом</p>
                                        </div>
                                        <div id="iuylvnx"
                                            class="awake-tariffs-item-header-places careerum-flex-fsc white hidden-mobile hidden">
                                            <p id="isxdkni">Доступно мест: 20</p>
                                        </div>
                                    </div>
                                    <div id="isxbwxc" class="awake-tariffs-item-header-places careerum-flex-fsc white hidden">
                                        <p id="ia0w82">Доступно мест: 20</p>
                                    </div>
                                    <p class="awake-tariffs-item-header">Индивидуальное
                                        сопровождение</p>
                                </div>
                                <div class="awake-tariffs-item-content">
                                    <div class="awake-tariffs-item-content-img hidden">
                                        <img loading="lazy"
                                            src="https://storage.yandexcloud.net/cdn.careerum.com/1790595171402-gGb72-Fram.png"
                                            alt="img" class="hidden-tablet-mobile z-1"><img loading="lazy"
                                            src="https://storage.yandexcloud.net/cdn.careerum.com/1790595206955-HXkrq-Fram.png"
                                            alt="img" class="hidden-desc-mobile z-1"><img loading="lazy"
                                            src="https://storage.yandexcloud.net/cdn.careerum.com/1790595241408-r1yBJ-Fram.png"
                                            alt="img" class="hidden-desc-tablet z-1">
                                    </div>
                                    <ul id="ibwoxqe">
                                        <li class="careerum-flex-fsfs"><img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <div id="iy7rlcx">
                                                <p id="io5nige">2 личные консультации с
                                                    карьерными экспертами в месяц:
                                                </p>
                                                <ul id="i9pffw6">
                                                    <li data-period="1" id="i8ydmf">
                                                        <p id="ikbowlq">Онбординговая
                                                            сессия на 30 минут с коучем для формирование целей на работу
                                                            с
                                                            экспертом</p>
                                                    </li>
                                                    <li data-period="1" id="i9grlge">
                                                        <p id="ij7ubcn">Разработка
                                                            стратегии</p>
                                                    </li>
                                                    <li data-period="1" id="isc5jpc">
                                                        <p id="iy5yglu">Персональный
                                                            разбор резюме</p>
                                                    </li>
                                                    <li data-period="1" id="ivem9l9">
                                                        <p id="iych3ow">Персональный
                                                            разбор Linkedin </p>
                                                    </li>
                                                    <li data-period="1" id="iqdfnjw">
                                                        <p id="ip82mmf">Тренировочные
                                                            собеседования или любой другой ваш карьерный запрос</p>
                                                    </li>
                                                    <li data-period="1" id="i3aovnm">
                                                        <p id="i729ouc">Личный чат с
                                                            экспертом и коучем</p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li class="careerum-flex-fsfs"><img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p id="ij9pqa8">Образовательный трек по вашей
                                                задаче на платформе </p>
                                        </li>
                                        <li class="careerum-flex-fsfs"><img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p id="itajai">Фидбэк от карьерных стратегов
                                                на онлайн-эфирах: разборы кейсов, позиций, рынков, отраслей, рисков при
                                                переходе
                                            </p>
                                        </li>
                                        <li class="careerum-flex-fsfs"><img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p id="iu240c">Поддержка экспертов в общем
                                                чате: ответы на вопросы, разборы кейсов в анонимном формате</p>
                                        </li>
                                        <li class="careerum-flex-fsfs"><img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p id="id4adww">Доступ в карьерный клуб</p>
                                        </li>
                                        <li class="careerum-flex-fsfs"><img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p id="ipkvpq">Экспертные онлайн-эфиры клуба
                                            </p>
                                        </li>
                                        <li class="careerum-flex-fsfs"><img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p id="i6vlfhi">6 шаблонов резюме RU и EN</p>
                                        </li>
                                        <li class="careerum-flex-fsfs"><img loading=""
                                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753432321745-lpr9c-Chec.svg"
                                                alt="">
                                            <p id="i5fxzs7">AI-сервис проверки резюме</p>
                                        </li>
                                    </ul>
                                </div>
                                <div class="awake-tariffs-item-footer">
                                    <div class="awake-tariffs-item-discount hidden-m1">
                                        <p class="awake-tariffs-item-discount"></p>
                                        <p class="awake-tariffs-item-oldprice"></p>
                                    </div>
                                    <div class="awake-tariffs-item-price careerum-flex-fsfs">
                                        <p class="awake-tariffs-item-fullprice-amount">33
                                            900 ₽</p>
                                        <p class="awake-tariffs-item-price-separator">/
                                        </p>
                                        <div>
                                            <p class="awake-tariffs-item-price-amount">
                                            </p>
                                            <p class="awake-tariffs-item-price-text">цена
                                                месяца</p>
                                        </div>
                                    </div>
                                    <div class="awake-tariffs-item-rassr careerum-flex-fsc hidden-m1"><img loading=""
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1753885469183-Cyal7-Cred.svg"
                                            alt="img">
                                        <p>Доступно в рассрочку</p>
                                    </div>
                                    <div class="awake-tariffs-item-notif hidden">
                                        <p>Места закончились</p>
                                        <p>Оставьте заявку в лист ожидания, если у нас
                                            освободится место, то наши карьерные консультанты свяжутся с вами</p>
                                    </div>
                                    <div class="awake-tariffs-item-link"><a onclick=""
                                            href="https://school.careerum.ru/anketa_club" target="_blank"
                                            class="no-change no-popup getparams btn-color-main-black">Вернуться</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-portfolio_career-author-popup', {
        label: 'Careerum portfolio_career author popup',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-popup careerum-portfolio_career-author-popup" id="author-popup">
                <div class="popup__close-button-wrapper careerum-flex-cc">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
                        class="close-switch">
                        <path d="M1 1L14.9972 14.9936" stroke="#191C20" stroke-width="2" stroke-linecap="round" />
                        <path d="M15 1.00635L1.0028 14.9999" stroke="#191C20" stroke-width="2" stroke-linecap="round" />
                    </svg>
                </div>
                <div class="portfolio_career-popup-content white position-relative z-1">
                    <ul>
                        <li class="careerum-flex-fsfs">
                            <div>
                                <img src="https://cdn.careerum.com/1793725945601-F67DL-Soft.svg" alt="">
                            </div>
                            <div>
                                <p class="portfolio_career-author-title">Основательница международной карьерной
                                    платформы
                                    Careerum</p>
                                <p class="portfolio_career-author-text">14000+ клиентов из 60+ стран построили с ее
                                    помощью
                                    карьеру в топовых мировых компаниях</p>
                            </div>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <div>
                                <img src="https://cdn.careerum.com/1793725945601-F67DL-Soft.svg" alt="">
                            </div>
                            <div>
                                <p class="portfolio_career-author-title">Harvard Extension School</p>
                                <p class="portfolio_career-author-text">Магистратура по психологии (ALM)</p>
                            </div>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <div>
                                <img src="https://cdn.careerum.com/1793725945601-F67DL-Soft.svg" alt="">
                            </div>
                            <div>
                                <p class="portfolio_career-author-title">15+ лет управленческой карьеры</p>
                                <p class="portfolio_career-author-text">в Google, Microsoft, Adobe, Intel на 25 рынках
                                    (Европа,
                                    СНГ, Ближний Восток, Африка)</p>
                            </div>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <div>
                                <img src="https://cdn.careerum.com/1793725945601-F67DL-Soft.svg" alt="">
                            </div>
                            <div>
                                <p class="portfolio_career-author-title">MBA, INSEAD</p>
                                <p class="portfolio_career-author-text">топ-3 бизнес-школа мира</p>
                            </div>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <div>
                                <img src="https://cdn.careerum.com/1793725945601-F67DL-Soft.svg" alt="">
                            </div>
                            <div>
                                <p class="portfolio_career-author-title">Состоялась в разных форматах:</p>
                                <p class="portfolio_career-author-text">руководитель в найме, эксперт-фрилансер
                                    и предприниматель</p>
                            </div>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <div>
                                <img src="https://cdn.careerum.com/1793725945601-F67DL-Soft.svg" alt="">
                            </div>
                            <div>
                                <p class="portfolio_career-author-title">Перепридумывала свою карьеру 7 раз:</p>
                                <p class="portfolio_career-author-text">из репетитора по языкам — в продажи
                                    и маркетинг — потом
                                    в стратегию — потом в свой бизнес</p>
                            </div>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <div>
                                <img src="https://cdn.careerum.com/1793725945601-F67DL-Soft.svg" alt="">
                            </div>
                            <div>
                                <p class="portfolio_career-author-title">Автор бестселлера </p>
                                <p class="portfolio_career-author-text">МИФ «Работа по любви»</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>`
    });

}